webpackJsonp([8],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = __webpack_require__(906);
var URI = __webpack_require__(106);
var session_1 = __webpack_require__(1131);
var browserURI = URI(window.location);
var configuration = {};
browserURI.hasQuery("octopus.server", function (octopusServerURI) {
    configuration.serverEndpoint = octopusServerURI;
});
var client = new client_1.Client(configuration);
exports.client = client;
var repository = new client_1.Repository(client);
exports.repository = repository;
var session = new session_1.default();
exports.session = session;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\clientInstance.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\clientInstance.ts"); } } })();

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var store_1 = __webpack_require__(147);
var reducers_1 = __webpack_require__(501);
var reducers_2 = __webpack_require__(327);
var logger_1 = __webpack_require__(99);
var BaseComponent = (function (_super) {
    __extends(BaseComponent, _super);
    function BaseComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.unmounted = false;
        _this.provideErrorHandlingToTopLevelMethods();
        _this.addUnmountedHook();
        return _this;
    }
    // tslint:enable:unified-signatures
    BaseComponent.prototype.setState = function (m, callback) {
        if (this.unmounted) {
            return;
        }
        _super.prototype.setState.call(this, m, callback);
    };
    BaseComponent.prototype.setChildState1 = function (first, state, callback) {
        this.setState(function (prev) {
            return (_a = {},
                _a[first] = __assign({}, prev[first], state),
                _a);
            var _a;
        }, callback);
    };
    BaseComponent.prototype.setChildState2 = function (first, second, state, callback) {
        this.setState(function (prev) {
            return (_a = {},
                _a[first] = __assign({}, prev[first], (_b = {}, _b[second] = __assign({}, prev[first][second], state), _b)),
                _a);
            var _a, _b;
        }, callback);
    };
    BaseComponent.prototype.setChildState3 = function (first, second, third, state, callback) {
        this.setState(function (prev) {
            return (_a = {},
                _a[first] = __assign({}, prev[first], (_b = {}, _b[second] = __assign({}, prev[first][second], (_c = {}, _c[third] = __assign({}, prev[first][second][third], state), _c)), _b)),
                _a);
            var _a, _b, _c;
        }, callback);
    };
    BaseComponent.prototype.provideErrorHandling = function (func) {
        var name = this.findNameOf(func);
        this.provideErrorHandlingByName(name);
    };
    BaseComponent.prototype.clearError = function () {
        store_1.default.dispatch(reducers_2.clearUnhandledErrorAction());
    };
    BaseComponent.prototype.provideErrorHandlingByName = function (name) {
        var _this = this;
        var originalMethod = this[name].bind(this);
        var wrapper = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            try {
                var result = originalMethod.apply(void 0, args);
                if (result instanceof Promise) {
                    return result.catch(function (error) {
                        _this.handleError(error, name);
                    });
                }
                else {
                    return result;
                }
            }
            catch (error) {
                _this.handleError(error, name);
                throw error;
            }
        };
        this[name] = wrapper;
    };
    BaseComponent.prototype.handleError = function (error, name) {
        logger_1.default.error("Error occurred in " + name);
        logger_1.default.error(error);
        store_1.default.dispatch(reducers_1.raiseUnhandledErrorAction(error));
        throw error;
    };
    BaseComponent.prototype.addUnmountedHook = function () {
        var _this = this;
        var componentWillUnmount = this["componentWillUnmount"];
        var originalMethod = componentWillUnmount && componentWillUnmount.bind(this);
        this["componentWillUnmount"] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.unmounted = true;
                            if (!originalMethod) return [3 /*break*/, 2];
                            return [4 /*yield*/, originalMethod.apply(void 0, args)];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
    };
    BaseComponent.prototype.findNameOf = function (func) {
        var _this = this;
        return Object.getOwnPropertyNames(this).filter(function (name) { return _this[name] === func; })[0];
    };
    BaseComponent.prototype.provideErrorHandlingToTopLevelMethods = function () {
        var _this = this;
        Object.getOwnPropertyNames(Object.getPrototypeOf(this)).forEach(function (name) {
            if (BaseComponent.methodsToCapture.includes(name)) {
                _this.provideErrorHandlingByName(name);
            }
        });
    };
    BaseComponent.methodsToCapture = ["componentDidMount", "componentWillMount", "componentDidUpdate", "componentWillUnmount",
        "shouldComponentUpdate", "componentWillUpdate", "componentWillReceiveProps"];
    return BaseComponent;
}(React.Component));
exports.BaseComponent = BaseComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BaseComponent\\BaseComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BaseComponent\\BaseComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// import Form from "./Form";
var Text_1 = __webpack_require__(17);
exports.Text = Text_1.default;
var DatePicker_1 = __webpack_require__(1582);
exports.DatePicker = DatePicker_1.default;
var Select_1 = __webpack_require__(41);
exports.Select = Select_1.default;
var Checkbox_1 = __webpack_require__(118);
exports.Checkbox = Checkbox_1.default;
var StringCheckbox_1 = __webpack_require__(38);
exports.StringCheckbox = StringCheckbox_1.default;
var FileUpload_1 = __webpack_require__(783);
exports.FileUpload = FileUpload_1.default;
var FormFieldProps_1 = __webpack_require__(1600);
exports.FormFieldProps = FormFieldProps_1.default;
var ExpandableFormSection_1 = __webpack_require__(44);
exports.ExpandableFormSection = ExpandableFormSection_1.default;
var Summary_1 = __webpack_require__(70);
exports.Summary = Summary_1.default;
exports.SummaryNode = Summary_1.SummaryNode;
var ExpansionButtons_1 = __webpack_require__(426);
exports.ExpansionButtons = ExpansionButtons_1.default;
var UnstructuredFormSection_1 = __webpack_require__(444);
exports.UnstructuredFormSection = UnstructuredFormSection_1.default;
var FormSectionHeading_1 = __webpack_require__(46);
exports.FormSectionHeading = FormSectionHeading_1.default;
var RadioButtonGroup_1 = __webpack_require__(33);
exports.StringRadioButtonGroup = RadioButtonGroup_1.StringRadioButtonGroup;
exports.BooleanRadioButtonGroup = RadioButtonGroup_1.BooleanRadioButtonGroup;
var RadioButtonGroup_2 = __webpack_require__(33);
exports.RadioButtonGroup = RadioButtonGroup_2.default;
var RadioButton_1 = __webpack_require__(36);
exports.RadioButton = RadioButton_1.default;
var ErrorPanel_1 = __webpack_require__(83);
exports.ErrorPanel = ErrorPanel_1.default;
var ColorPicker_1 = __webpack_require__(752);
exports.ColorPicker = ColorPicker_1.default;
var MoreInfo_1 = __webpack_require__(294);
exports.MoreInfo = MoreInfo_1.default;
var MarkdownEditor_1 = __webpack_require__(278);
exports.MarkdownEditor = MarkdownEditor_1.default;
var LogoEditor_1 = __webpack_require__(445);
exports.LogoEditor = LogoEditor_1.default;
var Note_1 = __webpack_require__(22);
exports.Note = Note_1.default;
var FormSection_1 = __webpack_require__(664);
exports.FormSection = FormSection_1.default;
var Sensitive_1 = __webpack_require__(82);
exports.Sensitive = Sensitive_1.default;
var SensitiveFileUpload_1 = __webpack_require__(753);
exports.SensitiveFileUpload = SensitiveFileUpload_1.default;
var LogoEditor_2 = __webpack_require__(445);
exports.LogoEditorSettings = LogoEditor_2.LogoEditorSettings;
var TimePicker_1 = __webpack_require__(1614);
exports.TimePicker = TimePicker_1.default;
__export(__webpack_require__(170));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\index.ts"); } } })();

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var TextField_1 = __webpack_require__(598);
var styles = __webpack_require__(1364);
var colors_1 = __webpack_require__(32);
var LabelStrategy_1 = __webpack_require__(174);
var VariableLookup_1 = __webpack_require__(363);
var colors_2 = __webpack_require__(32);
var fontWeights_1 = __webpack_require__(76);
var UniqueSequenceGenerator_1 = __webpack_require__(364);
var TextInternal = (function (_super) {
    __extends(TextInternal, _super);
    function TextInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.getSelection = function () {
            var input = _this.textField.getInputNode();
            return { start: input.selectionStart, end: input.selectionEnd };
        };
        _this.setValueAndSelection = function (selection, value) {
            var input = _this.textField.getInputNode();
            input.value = value;
            input.selectionStart = selection.start;
            input.selectionEnd = selection.end;
            _this.callValidateAndChange(input.value);
        };
        _this.handleChange = function (event) {
            var value = event.currentTarget.value;
            _this.callValidateAndChange(value);
        };
        _this.callValidateAndChange = function (value) {
            if (_this.props.validate) {
                var result = _this.props.validate(value);
                _this.setState({ error: result });
                if (_this.props.onValidate) {
                    _this.props.onValidate(result);
                }
            }
            _this.setState({ showExternalError: false });
            _this.props.onChange(value);
        };
        _this.handleKeyPress = function (event) {
            if (_this.props.onKeyPress) {
                _this.props.onKeyPress(event);
            }
        };
        _this.handleKeyDown = function (event) {
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(event);
            }
        };
        _this.state = {
            error: null,
            showExternalError: true
        };
        _this.genericName = "name" + TextInternal.sequence.next().toString();
        return _this;
    }
    TextInternal.prototype.componentWillMount = function () {
        if (this.props.textInputRef) {
            this.props.textInputRef(this);
        }
    };
    TextInternal.prototype.componentWillUnmount = function () {
        if (this.props.textInputRef) {
            this.props.textInputRef(null);
        }
    };
    TextInternal.prototype.componentWillReceiveProps = function (nextProps) {
        var isNewExternalErrorAvailable = nextProps.error !== this.props.error;
        if (isNewExternalErrorAvailable) {
            this.setState({ showExternalError: true });
        }
    };
    TextInternal.prototype.isFocused = function () {
        return this.textField && this.textField.getInputNode() === document.activeElement;
    };
    TextInternal.prototype.select = function () {
        if (this.textField) {
            this.textField.select();
        }
    };
    TextInternal.prototype.focus = function () {
        if (this.textField) {
            this.textField.focus();
        }
    };
    TextInternal.prototype.insertAtCursor = function (value) {
        if (!this.textField) {
            return;
        }
        var input = this.textField.getInputNode();
        if (input.selectionStart || input.selectionStart === 0) {
            var startPos = input.selectionStart;
            var endPos = input.selectionEnd;
            input.value = input.value.substring(0, startPos)
                + value
                + input.value.substring(endPos, input.value.length);
            input.selectionStart = startPos + value.length;
            input.selectionEnd = startPos + value.length;
        }
        else {
            input.value += value;
        }
        this.callValidateAndChange(input.value);
    };
    TextInternal.prototype.forceHasValue = function () {
        if (this.textField) {
            return this.textField.setState({ hasValue: true });
        }
    };
    TextInternal.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, label = _a.label, validate = _a.validate, error = _a.error, onChange = _a.onChange, onClick = _a.onClick, onValidate = _a.onValidate, type = _a.type, value = _a.value, min = _a.min, max = _a.max, name = _a.name, hintText = _a.hintText, underlineShow = _a.underlineShow, warning = _a.warning, monoSpacedFont = _a.monoSpacedFont, rowsMax = _a.rowsMax, onKeyPress = _a.onKeyPress, rows = _a.rows, multiLine = _a.multiLine, applyMaxWidth = _a.applyMaxWidth, showBorder = _a.showBorder, textInputRef = _a.textInputRef, showValueAsTitleAttribute = _a.showValueAsTitleAttribute, otherProps = __rest(_a, ["id", "label", "validate", "error", "onChange", "onClick", "onValidate", "type", "value", "min", "max", "name", "hintText", "underlineShow", "warning", "monoSpacedFont", "rowsMax", "onKeyPress", "rows", "multiLine", "applyMaxWidth", "showBorder", "textInputRef", "showValueAsTitleAttribute"]);
        var err = this.state.error || (this.state.showExternalError && error);
        var errorText = err || warning;
        var val = value ? value : "";
        // Transform underlineShow to a style, so that animations work if you toggle underlineShow to true
        var underlineStyle = underlineShow || underlineShow === undefined ?
            { borderColor: colors_1.secondaryText, position: "relative", marginRight: "0.5rem" }
            :
                { visibility: "hidden" };
        // margin-top caused overflow because material-ui text field uses border-box and margins are not included in calculations in that mode.
        // This is why we've replaced margin with padding.
        // Unfortunately, text-overflow: ellipsis doesn't work in IE11 or edge, unless the input is readonly.
        // We haven't worked around this in any way yet, but some people do some nasty hacks to get it working
        // in these browsers, like: https://frontendtricksandmagic.wordpress.com/2015/03/07/how-to-make-text-overflow-ellipsis-work-for-inputs-in-ie/
        var inputStyle = { marginTop: "0px", textOverflow: "ellipsis", overflow: "hidden" };
        // margin/padding is only required when there is a label
        inputStyle.paddingTop = label && !multiLine ? "18px" : "0px";
        var hintStyle = { color: colors_1.secondaryText, fontWeight: fontWeights_1.normal, height: "24px", whiteSpace: "nowrap", width: "90%", overflow: "hidden", textOverflow: "ellipsis" };
        var widthStyle = applyMaxWidth ? { maxWidth: "100%" } : {};
        var borderStyle = showBorder ? { padding: "0.5rem", border: "0.0625rem solid", borderColor: colors_2.divider, marginBottom: "0.5rem" } : {};
        // We are not using margin so there is no need to manually position the error text.
        var errorStyle = { bottom: "0px", color: err ? colors_1.danger : colors_1.alert };
        return (React.createElement("div", { className: styles.container },
            React.createElement(TextField_1.default, __assign({ className: monoSpacedFont ? [styles.text, styles.monospacedText].join(" ") : styles.text, ref: function (textField) { return _this.textField = textField; }, id: id, autoComplete: "nope", type: type, hintText: hintText, name: name || this.genericName, hintStyle: hintStyle, value: val, title: showValueAsTitleAttribute ? val : hintText, onClick: onClick, onChange: this.handleChange, errorText: errorText, errorStyle: errorStyle, floatingLabelStyle: { color: colors_1.secondaryText, fontWeight: fontWeights_1.normal }, floatingLabelFocusStyle: errorText ? { color: err ? colors_1.danger : colors_1.alert } : { color: colors_1.primary, fontWeight: fontWeights_1.normal }, floatingLabelFixed: !!hintText, floatingLabelText: label, underlineStyle: underlineStyle, underlineFocusStyle: { borderColor: colors_1.primary, bottom: "10px" }, underlineDisabledStyle: { borderBottom: "0.0625rem solid rgb(224, 224, 224)" }, min: min, max: max, rows: multiLine ? (rows || 3) : rows, rowsMax: rowsMax, multiLine: multiLine, onKeyPress: this.handleKeyPress, onKeyDown: this.handleKeyDown, inputStyle: inputStyle, style: __assign({}, widthStyle, borderStyle) }, otherProps))));
    };
    TextInternal.sequence = new UniqueSequenceGenerator_1.UniqueSequenceGenerator();
    TextInternal.defaultProps = {
        type: "text",
        autoFocus: false,
        applyMaxWidth: false,
        showBorder: false,
        textInputRef: function (input) { }
    };
    return TextInternal;
}(React.Component));
var Text = LabelStrategy_1.default(TextInternal, function (fieldName) { return fieldName; });
exports.default = Text;
var TextWithInputRef = function (props) { return React.createElement(Text, __assign({ textInputRef: props.textInputRef }, props)); };
exports.VariableLookupText = VariableLookup_1.withVariableLookup()(TextWithInputRef);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Text\\Text.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Text\\Text.tsx"); } } })();

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Allows other parties to register 'plugins' that provide the view and edit experience for
// custom deployment actions and conventions.
//
//   var module = angular.module('myPlugin', [], function(pluginRegistry) {
//      pluginRegistry.registerDeploymentAction("Octopus.TentaclePackage", {
//        title: "Deploy a NuGet package",               // Display text for users adding the step
//        summary: "Deploys a NuGet package...",         // Help text to show
//        summaryTemplateUrl: "area/foo/bar.html",       // Template for a short summary on the process overview page
//        summaryLink: function (scope, element) {       // Angular directive-style link function
//          var action = scope.action;                   // Get the action we are rendering
//          var step = scope.step;                       // Get the step we are rendering
//          var jQueryElement = element;                 // The HTML element for the bar.html we just inserted
//        },
//        editTemplate: "area/bar/baz.html"              // Template for editing
//      });
//
//      pluginRegistry.registerFeature("Octopus.Features.CustomPackageDirectory", {
//        isEnabled: function(action, step) {  },
//        enable: function(action, step) {  },
//        disable: function(action, step) {  },
//        editTemplateUrl: "area/foo/bar.html",
//        editLink: function(scope, element) { }
//      });
//   });
Object.defineProperty(exports, "__esModule", { value: true });
var PluginRegistry = (function () {
    function PluginRegistry() {
        this.registeredActions = {};
        this.registeredFeatures = {};
    }
    PluginRegistry.prototype.registerDeploymentAction = function (registration) {
        this.registeredActions[registration.actionType] = registration;
    };
    PluginRegistry.prototype.registerFeature = function (registration) {
        this.registeredFeatures[registration.featureName] = registration;
    };
    PluginRegistry.prototype.resolve = function (container, key) {
        var result = container[key];
        //callback(result, key);
        return result;
    };
    PluginRegistry.prototype.resolveAll = function (container) {
        var _this = this;
        return Object.keys(container).map(function (key) {
            return _this.resolve(container, key);
        }).sort(function (item) { return item.priority; });
    };
    PluginRegistry.prototype.getDeploymentAction = function (actionType) {
        var registration = this.resolve(this.registeredActions, actionType);
        if (!registration) {
            throw new Error("There is no plugin registered for " + actionType + " action type.");
        }
        return registration;
    };
    PluginRegistry.prototype.getAllActions = function () {
        return this.resolveAll(this.registeredActions);
    };
    PluginRegistry.prototype.getFeature = function (featureName) {
        var feature = this.resolve(this.registeredFeatures, featureName);
        if (!feature) {
            throw new Error("There is no plugin registered for " + featureName + " feature type.");
        }
        return feature;
    };
    PluginRegistry.prototype.getAllFeatures = function () {
        return this.resolveAll(this.registeredFeatures);
    };
    PluginRegistry.prototype.hasFeaturesForAction = function (actionType) {
        var actionPlugin = this.getDeploymentAction(actionType);
        var featuresForAction = this.getAllFeatures()
            .filter(function (f) { return actionPlugin.features && actionPlugin.features.optional && actionPlugin.features.optional.includes(f.featureName); });
        return featuresForAction.length > 0;
    };
    return PluginRegistry;
}());
var pluginRegistry = new PluginRegistry();
exports.default = pluginRegistry;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\pluginRegistry.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\pluginRegistry.ts"); } } })();

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var projectRouteLinks_1 = __webpack_require__(1227);
var tenantRouteLinks_1 = __webpack_require__(762);
var libraryRouteLinks_1 = __webpack_require__(1228);
var infrastructureRouteLinks_1 = __webpack_require__(1229);
var taskRouteLinks_1 = __webpack_require__(1230);
var configurationRouteLinks_1 = __webpack_require__(1231);
var projectGroupRouteLinks_1 = __webpack_require__(1232);
var deploymentRouteLinks_1 = __webpack_require__(1233);
var userProfileRouteLinks_1 = __webpack_require__(1234);
var dashboardRouteLinks_1 = __webpack_require__(1235);
exports.parameterizedRouteLinks = function (root) { return (__assign({ root: root ? root : "/", dashboard: dashboardRouteLinks_1.default(root) }, projectRouteLinks_1.default(root), tenantRouteLinks_1.default(root), taskRouteLinks_1.default(root), projectGroupRouteLinks_1.default(root), deploymentRouteLinks_1.default(root), { currentUser: userProfileRouteLinks_1.default(root), library: libraryRouteLinks_1.default(root), infrastructure: infrastructureRouteLinks_1.default(root), configuration: configurationRouteLinks_1.default(root), styleGuide: root + "/style-guide", codeGuide: root + "/code-guide" })); };
exports.default = exports.parameterizedRouteLinks("");


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\routeLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\routeLinks.ts"); } } })();

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var formStyles = __webpack_require__(1214);
var Note = function (props) {
    var style = props.checkboxNote ? { marginLeft: "40px" } : {};
    return React.createElement("div", { className: formStyles.note, style: props.style }, props.children);
};
exports.default = Note;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Note\\Note.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Note\\Note.tsx"); } } })();

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Chip_1 = __webpack_require__(285);
var React = __webpack_require__(0);
var Avatar_1 = __webpack_require__(354);
var account_circle_1 = __webpack_require__(1462);
var storage_1 = __webpack_require__(751);
var group_1 = __webpack_require__(780);
var call_split_1 = __webpack_require__(1463);
var local_offer_1 = __webpack_require__(1464);
var colors_1 = __webpack_require__(32);
var moment = __webpack_require__(104);
var SvgIcon_1 = __webpack_require__(21);
var colors_2 = __webpack_require__(32);
var LookupResourceChip_1 = __webpack_require__(456);
var iconStyles = {
    margin: 5,
    fill: colors_2.primaryText,
    width: 14,
    height: 14
};
exports.avatarStyles = {
    width: 24,
    height: 24,
};
// We are using SVG content directly because SvgIconMaterial doesn't allow us to reference svg files directly.
// Do we even need to use material ui here? What about using a regular img tag?
var SvgExcludedEnvironmentIcon = function (props) { return React.createElement(SvgIcon_1.default, __assign({}, props, { viewBox: "0 0 200 200" }),
    React.createElement("path", { d: "M6.712773 20.366522l7.783858-8.205343 176.512813 167.445863-7.783858 8.205343zM189.39 165.21v-31.34h-33.02l33.02 31.34" }),
    React.createElement("path", { d: "M139.94 133.87H18.13v34.58H176.4zM35 159.61v-16.88h17.3v16.88zM138.58 116.99h50.81V82.41h-87.27l36.46 34.58M85.7 82.41H18.13V117h104zM35 108.14V91.26h17.3v16.88zM84.33 65.53h105.06V30.95H47.88l36.45 34.58M52.3 50.72v5.96H35.01V39.8h5.77l-9.33-8.85H18.13v34.58h49.78L52.3 50.72" })); };
var SvgProjectIcon = function (props) { return React.createElement(SvgIcon_1.default, __assign({}, props, { viewBox: "0 0 200 200" }),
    React.createElement("path", { d: "M174.33 26H25.67A14.67 14.67 0 0 0 11 40.7v14.36h178V40.7A14.67 14.67 0 0 0 174.33 26zM11 63.09v96.21A14.72 14.72 0 0 0 25.67 174h148.66A14.72 14.72 0 0 0 189 159.3V63.09zm59.12 58.42h-37v-37h37zm93.63 17H87.11a4.06 4.06 0 1 1 0-8.11h76.64a4.06 4.06 0 1 1 0 8.11zM83 111.52a4.06 4.06 0 0 1 4.06-4.06h59.31a4.06 4.06 0 1 1 0 8.11H87.11a4.06 4.06 0 0 1-4.11-4.05zm81.61-18.83h-77.5a4.06 4.06 0 0 1 0-8.11h77.56a4.06 4.06 0 1 1 0 8.11z" })); };
var SvgMachineIcon = function (props) { return React.createElement(SvgIcon_1.default, __assign({}, props, { viewBox: "0 0 200 200" }),
    React.createElement("path", { d: "M170.17 16.15H29.83A3.83 3.83 0 0 0 26 20v116.71a3.83 3.83 0 0 0 3.83 3.83h65.34v15.73a14.94 14.94 0 0 0-9.3 9.3H42a4.83 4.83 0 1 0 0 9.67h43.9a14.93 14.93 0 0 0 28.27 0H158a4.83 4.83 0 1 0 0-9.67h-43.9a15 15 0 0 0-9.3-9.3v-15.74h65.34a3.83 3.83 0 0 0 3.83-3.83V20a3.83 3.83 0 0 0-3.8-3.85z" })); };
var SvgExcludedMachineIcon = function (props) {
    return React.createElement(SvgIcon_1.default, __assign({}, props, { viewBox: "0 0 200 200", style: { fill: colors_1.white, margin: 5, height: 19.2, width: 19.2 } }),
        React.createElement("path", { d: "M174 20a3.83 3.83 0 0 0-3.83-3.83H42.09L174 126.63zM107.68 140.53h47.76l15.9 13.31 7.26-8.67L17.38 10.15l-7.26 8.67L26 32.12v104.59a3.83 3.83 0 0 0 3.83 3.83h65.34v15.73a14.94 14.94 0 0 0-9.3 9.3H42a4.83 4.83 0 1 0 0 9.67h43.9a14.93 14.93 0 0 0 28.27 0H158a4.83 4.83 0 1 0 0-9.67h-43.9a15 15 0 0 0-9.3-9.3v-15.74z" }));
};
var chipWithAvatar = function (text, SvgIcon, props, customAvatar, description, labelColor, customIconStyles, fullWidth) {
    if (fullWidth === void 0) { fullWidth = false; }
    return React.createElement(Chip_1.default, __assign({ backgroundColor: colors_1.secondaryBackground, fullWidth: fullWidth, labelColor: labelColor || colors_2.primaryText, description: description || text, avatar: React.createElement(Avatar_1.default, { style: customAvatar ? customAvatar : exports.avatarStyles, size: exports.avatarStyles.width, icon: React.createElement(SvgIcon, { style: customIconStyles || iconStyles }) }) }, props), text);
};
var ChipIcon;
(function (ChipIcon) {
    ChipIcon[ChipIcon["Project"] = 0] = "Project";
    ChipIcon[ChipIcon["Machine"] = 1] = "Machine";
    ChipIcon[ChipIcon["ExcludedMachine"] = 2] = "ExcludedMachine";
    ChipIcon[ChipIcon["Environment"] = 3] = "Environment";
    ChipIcon[ChipIcon["ExcludedEnvironment"] = 4] = "ExcludedEnvironment";
    ChipIcon[ChipIcon["Role"] = 5] = "Role";
    ChipIcon[ChipIcon["Tenant"] = 6] = "Tenant";
    ChipIcon[ChipIcon["Channel"] = 7] = "Channel";
    ChipIcon[ChipIcon["Team"] = 8] = "Team";
    ChipIcon[ChipIcon["Step"] = 9] = "Step";
    ChipIcon[ChipIcon["StepAction"] = 10] = "StepAction";
    ChipIcon[ChipIcon["ProjectGroup"] = 11] = "ProjectGroup";
    ChipIcon[ChipIcon["CommunicationStyle"] = 12] = "CommunicationStyle";
    ChipIcon[ChipIcon["EventCategory"] = 13] = "EventCategory";
    ChipIcon[ChipIcon["EventGroup"] = 14] = "EventGroup";
    ChipIcon[ChipIcon["MachineModelHealthStatus"] = 15] = "MachineModelHealthStatus";
    ChipIcon[ChipIcon["DocumentType"] = 16] = "DocumentType";
})(ChipIcon = exports.ChipIcon || (exports.ChipIcon = {}));
// NOTE:
// This is used to show the user only what they can see, it may be filtered away by permissions
function matchesToChips(set, selected, createChip) {
    return set
        .filter(function (item) { return selected.indexOf(item.Id) !== -1; })
        .map(function (item) { return createChip(item); });
}
exports.matchesToChips = matchesToChips;
function channelChipList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(ChannelChip, { channelName: x.Name, key: x.Id }); });
}
exports.channelChipList = channelChipList;
function environmentChipList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(EnvironmentChip, { environmentName: x.Name, key: x.Id }); });
}
exports.environmentChipList = environmentChipList;
// NOTE:
// We have some inconsistency in the application where on summaries we filter away what the user cannot see due to permissions
// eg environments, but if they expand the multiselect we show them missing chips
// we should aim to move to this approach in `environmentChipListIncludingMissing` and SHOW them Ids and Names
// it will require a new API (as not to break other things)
// the objective is to  drive people to Spaces for isolation instead of using the permissions system awkwardly
function environmentChipListIncludingMissing(set, selectedIds) {
    var EnvironmentLookupChipInternal = LookupResourceChip_1.LookupResourceChipComponent();
    return selectedIds.map(function (id) { return React.createElement(EnvironmentLookupChipInternal, { lookupCollection: set, key: id, lookupId: id, type: ChipIcon.Environment, chipRender: function (item) { return React.createElement(EnvironmentChip, { environmentName: item.Name }); } }); });
}
exports.environmentChipListIncludingMissing = environmentChipListIncludingMissing;
function tenantChipList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(TenantChip, { tenant: x, key: x.Id }); });
}
exports.tenantChipList = tenantChipList;
// Same applies environmentChipListIncludingMissing
// future goal to replace all the variants with this approach
function tenantChipListIncludingMissing(set, selectedIds) {
    var TenantLookupChipInternal = LookupResourceChip_1.LookupResourceChipComponent();
    return selectedIds.map(function (id) { return React.createElement(TenantLookupChipInternal, { lookupCollection: set, key: id, lookupId: id, type: ChipIcon.Tenant, chipRender: function (item) { return React.createElement(TenantChip, { tenant: item }); } }); });
}
exports.tenantChipListIncludingMissing = tenantChipListIncludingMissing;
function projectChipList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(ProjectChip, { project: x, key: x.Id }); });
}
exports.projectChipList = projectChipList;
function documentChipList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(DocumentTypeChip, { documentType: x, key: x.Id }); });
}
exports.documentChipList = documentChipList;
function eventCategoryList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(EventCategoryChip, { eventCategory: x, key: x.Id }); });
}
exports.eventCategoryList = eventCategoryList;
function eventGroupList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(EventGroupChip, { eventGroup: x, key: x.Id }); });
}
exports.eventGroupList = eventGroupList;
var MissingChip = function (props) {
    var lookupId = props.lookupId, type = props.type, rest = __rest(props, ["lookupId", "type"]);
    var text = "Missing Resource";
    // There are cases where this isn't right, but will just have 1 message to simplify
    // e.g. Variable Snapshots will show this for deleted environments, it's not an issue in that case, but good to show this.
    var description = "The " + ChipIcon[type] + " document '" + lookupId + "' referenced by this record is no longer available or "
        + "you do not have permissions to see this resource. Please check with you Octopus Administrator regarding your "
        + "permissions. If you believe the resource is missing (and this is not permissions-related), please let Octopus "
        + "support know so that we can prevent this from happening in the future.";
    var customIconStyles = __assign({}, iconStyles, { fill: colors_1.white, backgroundColor: colors_1.danger });
    var chip = function (svg) { return chipWithAvatar(text, svg, __assign({}, rest, { backgroundColor: colors_1.dangerHighlight }), __assign({}, exports.avatarStyles, { backgroundColor: colors_1.danger }), description, colors_1.danger, customIconStyles); };
    switch (type) {
        case ChipIcon.Project:
            return chip(SvgProjectIcon);
        case ChipIcon.Machine:
            return chip(SvgMachineIcon);
        case ChipIcon.ExcludedMachine:
            return chip(SvgExcludedMachineIcon);
        case ChipIcon.Environment:
            return chip(storage_1.default);
        case ChipIcon.ExcludedEnvironment:
            return chip(SvgExcludedEnvironmentIcon);
        case ChipIcon.Role:
            return chip(local_offer_1.default);
        case ChipIcon.Tenant:
            return chip(account_circle_1.default);
        case ChipIcon.Channel:
            return chip(call_split_1.default);
        case ChipIcon.Team:
            return chip(group_1.default);
        case ChipIcon.Step:
        case ChipIcon.StepAction:
        case ChipIcon.ProjectGroup:
        case ChipIcon.CommunicationStyle:
        case ChipIcon.EventCategory:
        case ChipIcon.EventGroup:
        case ChipIcon.MachineModelHealthStatus:
        case ChipIcon.DocumentType:
            return React.createElement(Chip_1.default, __assign({ backgroundColor: colors_1.dangerHighlight, labelColor: colors_1.danger, description: description }, rest), text);
        default:
            return React.createElement(Chip_1.default, __assign({ backgroundColor: colors_1.dangerHighlight, labelColor: colors_1.danger, description: description }, rest), text);
    }
};
exports.MissingChip = MissingChip;
var ProjectChip = function (props) {
    var project = props.project, rest = __rest(props, ["project"]);
    return chipWithAvatar(project.Name, SvgProjectIcon, __assign({ description: "Project: " + project.Name }, rest));
};
exports.ProjectChip = ProjectChip;
var ProjectGroupChip = function (props) {
    var projectGroup = props.projectGroup, rest = __rest(props, ["projectGroup"]);
    var description = "Project group: " + projectGroup.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), projectGroup.Name);
};
exports.ProjectGroupChip = ProjectGroupChip;
var MachineModelHealthStatusChip = function (props) {
    var healthStatus = props.healthStatus, rest = __rest(props, ["healthStatus"]);
    var description = "Machine health: " + healthStatus.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), healthStatus.Name);
};
exports.MachineModelHealthStatusChip = MachineModelHealthStatusChip;
var EndpointCommunicationStyleChip = function (props) {
    var commStyle = props.commStyle, rest = __rest(props, ["commStyle"]);
    var description = "Communications style: " + commStyle.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), commStyle.Name);
};
exports.EndpointCommunicationStyleChip = EndpointCommunicationStyleChip;
var EnvironmentChip = function (props) {
    var environmentName = props.environmentName, isExcluded = props.isExcluded, rest = __rest(props, ["environmentName", "isExcluded"]);
    return chipWithAvatar(environmentName, isExcluded ? SvgExcludedEnvironmentIcon : storage_1.default, __assign({ description: "Environment: " + environmentName }, rest, { markAsRemoved: isExcluded }));
};
exports.EnvironmentChip = EnvironmentChip;
var MachineChip = function (props) {
    var machineName = props.machineName, isExcluded = props.isExcluded, isDisable = props.isDisable, rest = __rest(props, ["machineName", "isExcluded", "isDisable"]);
    return chipWithAvatar(machineName, (isExcluded || isDisable) ? SvgExcludedMachineIcon : SvgMachineIcon, __assign({ description: "Machine: " + machineName }, rest, { markAsRemoved: isExcluded, backgroundColor: isDisable ? colors_1.disable : colors_1.secondaryBackground, labelColor: isDisable ? colors_1.danger : colors_2.primaryText }), isDisable ? __assign({}, exports.avatarStyles, { backgroundColor: colors_1.danger }) : exports.avatarStyles);
};
exports.MachineChip = MachineChip;
var TenantChip = function (props) {
    var tenant = props.tenant, rest = __rest(props, ["tenant"]);
    return chipWithAvatar(tenant.Name, account_circle_1.default, __assign({ description: "Tenant: " + tenant.Name }, rest));
};
exports.TenantChip = TenantChip;
var TeamChip = function (props) {
    var team = props.team, rest = __rest(props, ["team"]);
    return chipWithAvatar(team.Name, group_1.default, __assign({ description: "Team: " + team.Name }, rest));
};
exports.TeamChip = TeamChip;
var ChannelChip = function (props) {
    var channelName = props.channelName, rest = __rest(props, ["channelName"]);
    return chipWithAvatar(channelName, call_split_1.default, __assign({ description: "Channel: " + channelName }, rest));
};
exports.ChannelChip = ChannelChip;
var RoleChip = function (props) {
    var role = props.role, rest = __rest(props, ["role"]);
    return chipWithAvatar(role, local_offer_1.default, __assign({ description: "Role: " + role }, rest));
};
exports.RoleChip = RoleChip;
var CertificateExpiryChip = function (props) {
    var certificate = props.certificate, rest = __rest(props, ["certificate"]);
    var now = moment();
    var certificateExpiry = moment(certificate.NotAfter);
    var prefix = certificateExpiry.isAfter(now)
        ? "Expires "
        : "Expired ";
    var expiry = prefix + certificateExpiry.fromNow();
    var color = colors_1.success;
    if (certificateExpiry.isBefore(now)) {
        color = colors_1.danger;
    }
    else if (certificateExpiry.isBefore(now.add(20, "days"))) {
        color = colors_1.alert;
    }
    var description = "Certificate expiry: " + expiry;
    return React.createElement(Chip_1.default, __assign({ description: description, backgroundColor: "rgba(0,0,0,0)", bordercolor: color, labelColor: color }, rest), expiry);
};
exports.CertificateExpiryChip = CertificateExpiryChip;
var StepChip = function (props) {
    var stepName = props.stepName, suffix = props.suffix, rest = __rest(props, ["stepName", "suffix"]);
    var description = "Step: " + stepName;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest),
        stepName,
        suffix);
};
exports.StepChip = StepChip;
var UserRoleChip = function (props) {
    var userRole = props.userRole, rest = __rest(props, ["userRole"]);
    var description = "User role: " + userRole.Name;
    return React.createElement(Chip_1.default, __assign({}, rest), userRole.Name);
};
exports.UserRoleChip = UserRoleChip;
var ExternalSecurityGroupChip = function (props) {
    var group = props.group, rest = __rest(props, ["group"]);
    var text = group.DisplayIdAndName ? group.DisplayName + " (" + group.Id + ")" : group.DisplayName;
    return React.createElement(Chip_1.default, __assign({}, rest), text);
};
exports.ExternalSecurityGroupChip = ExternalSecurityGroupChip;
var ExternalSecurityGroupNameChip = function (props) {
    var groupName = props.groupName, rest = __rest(props, ["groupName"]);
    return React.createElement(Chip_1.default, __assign({ description: "Indirectly assigned via " + groupName }, rest), groupName);
};
exports.ExternalSecurityGroupNameChip = ExternalSecurityGroupNameChip;
var FilterTextChip = function (props) {
    var filterText = props.filterText, rest = __rest(props, ["filterText"]);
    return React.createElement(Chip_1.default, __assign({}, rest), filterText);
};
exports.FilterTextChip = FilterTextChip;
var EventCategoryChip = function (props) {
    var eventCategory = props.eventCategory, rest = __rest(props, ["eventCategory"]);
    var description = "Event category: " + eventCategory.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), eventCategory.Name);
};
exports.EventCategoryChip = EventCategoryChip;
var EventCategoryPreviewChip = function (props) {
    var eventCategory = props.eventCategory, rest = __rest(props, ["eventCategory"]);
    var description = "Event category: " + eventCategory.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), eventCategory.Name);
};
exports.EventCategoryPreviewChip = EventCategoryPreviewChip;
var DocumentTypeChip = function (props) {
    var documentType = props.documentType, rest = __rest(props, ["documentType"]);
    var description = "Document type: " + documentType.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), documentType.Name);
};
exports.DocumentTypeChip = DocumentTypeChip;
var EventGroupChip = function (props) {
    var eventGroup = props.eventGroup, rest = __rest(props, ["eventGroup"]);
    var description = "Event group: " + eventGroup.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), eventGroup.Name);
};
exports.EventGroupChip = EventGroupChip;
var DisabledChip = function (props) {
    return React.createElement(Chip_1.default, __assign({}, props, { bordercolor: colors_1.secondaryText, labelColor: colors_1.secondaryText, backgroundColor: "rgba(0,0,0,0)" }), "Disabled");
};
exports.DisabledChip = DisabledChip;
var DefaultOptionChip = function (props) {
    return React.createElement(Chip_1.default, __assign({}, props), "Default");
};
exports.DefaultOptionChip = DefaultOptionChip;
var LookupTenantChip = function (props) {
    var TenantLookupChipInternal = LookupResourceChip_1.LookupResourceChipComponent();
    return React.createElement(TenantLookupChipInternal, { lookupCollection: props.lookupTenants, key: props.id, lookupId: props.id, type: ChipIcon.Tenant, chipRender: function (item) { return React.createElement(TenantChip, { tenant: item }); } });
};
exports.LookupTenantChip = LookupTenantChip;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Chips\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Chips\\index.tsx"); } } })();

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(37));
__export(__webpack_require__(915));
__export(__webpack_require__(916));
__export(__webpack_require__(418));
__export(__webpack_require__(917));
__export(__webpack_require__(918));
__export(__webpack_require__(919));
__export(__webpack_require__(920));
__export(__webpack_require__(921));
__export(__webpack_require__(922));
__export(__webpack_require__(923));
__export(__webpack_require__(924));
__export(__webpack_require__(925));
__export(__webpack_require__(926));
__export(__webpack_require__(927));
__export(__webpack_require__(928));
__export(__webpack_require__(929));
__export(__webpack_require__(930));
__export(__webpack_require__(931));
__export(__webpack_require__(932));
__export(__webpack_require__(933));
__export(__webpack_require__(934));
__export(__webpack_require__(935));
__export(__webpack_require__(760));
__export(__webpack_require__(936));
__export(__webpack_require__(937));
__export(__webpack_require__(236));
__export(__webpack_require__(938));
__export(__webpack_require__(939));
__export(__webpack_require__(940));
__export(__webpack_require__(941));
__export(__webpack_require__(942));
__export(__webpack_require__(943));
__export(__webpack_require__(944));
__export(__webpack_require__(945));
__export(__webpack_require__(946));
__export(__webpack_require__(947));
__export(__webpack_require__(948));
__export(__webpack_require__(949));
__export(__webpack_require__(950));
__export(__webpack_require__(498));
__export(__webpack_require__(951));
__export(__webpack_require__(774));
__export(__webpack_require__(952));
__export(__webpack_require__(953));
__export(__webpack_require__(954));
__export(__webpack_require__(955));
__export(__webpack_require__(956));
__export(__webpack_require__(957));
__export(__webpack_require__(958));
__export(__webpack_require__(959));
__export(__webpack_require__(960));
__export(__webpack_require__(775));
__export(__webpack_require__(961));
__export(__webpack_require__(962));
__export(__webpack_require__(187));
__export(__webpack_require__(963));
__export(__webpack_require__(776));
__export(__webpack_require__(964));
__export(__webpack_require__(965));
__export(__webpack_require__(49));
__export(__webpack_require__(966));
__export(__webpack_require__(967));
__export(__webpack_require__(968));
__export(__webpack_require__(969));
__export(__webpack_require__(970));
__export(__webpack_require__(971));
__export(__webpack_require__(972));
__export(__webpack_require__(499));
__export(__webpack_require__(973));
__export(__webpack_require__(974));
__export(__webpack_require__(975));
__export(__webpack_require__(53));
__export(__webpack_require__(976));
__export(__webpack_require__(977));
__export(__webpack_require__(978));
__export(__webpack_require__(979));
__export(__webpack_require__(980));
__export(__webpack_require__(981));
__export(__webpack_require__(982));
__export(__webpack_require__(983));
__export(__webpack_require__(984));
__export(__webpack_require__(985));
__export(__webpack_require__(986));
__export(__webpack_require__(718));
__export(__webpack_require__(987));
__export(__webpack_require__(988));
__export(__webpack_require__(717));
__export(__webpack_require__(402));
__export(__webpack_require__(989));
__export(__webpack_require__(282));
__export(__webpack_require__(990));
__export(__webpack_require__(991));
__export(__webpack_require__(992));
__export(__webpack_require__(993));
__export(__webpack_require__(322));
__export(__webpack_require__(442));
__export(__webpack_require__(994));
__export(__webpack_require__(995));
__export(__webpack_require__(996));
__export(__webpack_require__(997));
__export(__webpack_require__(998));
__export(__webpack_require__(999));
__export(__webpack_require__(1000));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\index.ts"); } } })();

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(291);
var PromiseConfirmationDialog_1 = __webpack_require__(1847);
var ActionTemplateEditor_1 = __webpack_require__(1848);
var React = __webpack_require__(0);
var resources_1 = __webpack_require__(26);
var pluginRegistry_1 = __webpack_require__(18);
var lodash_1 = __webpack_require__(16);
var clientInstance_1 = __webpack_require__(10);
var FormBaseComponent_1 = __webpack_require__(399);
var FormPaperLayout_1 = __webpack_require__(168);
var Text_1 = __webpack_require__(17);
var form_1 = __webpack_require__(15);
var ActionEditor_1 = __webpack_require__(803);
var lodash_2 = __webpack_require__(16);
var FeatureEditor_1 = __webpack_require__(804);
var form_2 = __webpack_require__(15);
var Callout_1 = __webpack_require__(81);
var MultiSelect_1 = __webpack_require__(71);
var FeatureToggle_1 = __webpack_require__(417);
var FeatureToggle_2 = __webpack_require__(224);
var Checkbox_1 = __webpack_require__(118);
var Chips_1 = __webpack_require__(23);
var ParseHelper_1 = __webpack_require__(75);
var permission_1 = __webpack_require__(49);
var StartTriggerExpander_1 = __webpack_require__(699);
var RunTriggerExpander_1 = __webpack_require__(700);
var PackageRequirementExpander_1 = __webpack_require__(1868);
var OpenFeatureDialog_1 = __webpack_require__(805);
var projectsArea_1 = __webpack_require__(219);
var react_redux_1 = __webpack_require__(67);
var DeploymentProcessRoute_1 = __webpack_require__(297);
var routeLinks_1 = __webpack_require__(20);
var Environments_1 = __webpack_require__(1873);
var ExecutionPlan_1 = __webpack_require__(1874);
var TenantsExpander_1 = __webpack_require__(1875);
var getActionLogoUrl_1 = __webpack_require__(463);
var WarningFormSection_1 = __webpack_require__(122);
var InternalRedirect_1 = __webpack_require__(40);
var EnvironmentOption;
(function (EnvironmentOption) {
    EnvironmentOption["All"] = "all";
    EnvironmentOption["Include"] = "include";
    EnvironmentOption["Exclude"] = "exclude";
})(EnvironmentOption = exports.EnvironmentOption || (exports.EnvironmentOption = {}));
var RunOn;
(function (RunOn) {
    RunOn["OctopusServer"] = "OctopusServer";
    RunOn["OctopusServerForRoles"] = "OctopusServerForRoles";
    RunOn["DeploymentTarget"] = "DeploymentTarget";
})(RunOn = exports.RunOn || (exports.RunOn = {}));
var TargetRoles;
(function (TargetRoles) {
    TargetRoles[TargetRoles["Optional"] = 0] = "Optional";
    TargetRoles[TargetRoles["None"] = 1] = "None";
    TargetRoles[TargetRoles["Required"] = 2] = "Required";
})(TargetRoles = exports.TargetRoles || (exports.TargetRoles = {}));
var ActionDetailsInternal = (function (_super) {
    __extends(ActionDetailsInternal, _super);
    function ActionDetailsInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.calculateEnvironmentConditions = function () {
            var action = _this.props.action;
            var knownEnvironments = _this.props.environments.map(function (e) { return e.Id; });
            var unavailableEnvironments = lodash_1.difference(action.Environments || [], knownEnvironments);
            var unavailableExcludedEnvironments = lodash_1.difference(action.ExcludedEnvironments || [], knownEnvironments);
            var inclusiveEnvironments = lodash_1.intersection(action.Environments || [], knownEnvironments);
            var exclusiveEnvironments = lodash_1.intersection(action.ExcludedEnvironments || [], knownEnvironments);
            var hasHiddenEnvironments = unavailableExcludedEnvironments.length + unavailableExcludedEnvironments.length > 0;
            return {
                unavailable: unavailableEnvironments,
                unavailableExclusive: unavailableExcludedEnvironments,
                inclusive: inclusiveEnvironments,
                exclusive: exclusiveEnvironments,
                hasHiddenEnvironments: hasHiddenEnvironments
            };
        };
        _this.availableRunConditions = function () {
            return (_this.props.isFirstStep) ?
                [resources_1.RunCondition.Success, resources_1.RunCondition.Always, resources_1.RunCondition.Variable] :
                [resources_1.RunCondition.Success, resources_1.RunCondition.Failure, resources_1.RunCondition.Always, resources_1.RunCondition.Variable];
        };
        _this.isConditionEditable = function () {
            var action = _this.props.action;
            if (!action) {
                return true;
            }
            var step = _this.props.step;
            return (step.Actions.length === 1 && step.Actions[0] === action) || step.Actions.length === 0;
        };
        _this.doBusyForChildren = function (action) {
            // don't clear errors on child tasks since they should just
            // be loading and we don't want to clear a Save error
            // just because we load some lookup data
            return _this.doBusyTask(action, false);
        };
        _this.setActionProperties = function (properties, initialise) {
            _this.setState(function (state) {
                return (state && state.model && state.model.action) ? {
                    model: __assign({}, state.model, { action: __assign({}, state.model.action, { Properties: __assign({}, state.model.action.Properties, properties) }) })
                } : {};
            }, function () {
                if (initialise) {
                    _this.setState(function (prev) { return ({
                        cleanModel: lodash_2.cloneDeep(prev.model)
                    }); });
                }
            });
        };
        _this.setStepProperties = function (properties) {
            _this.setState(function (state) {
                return (state && state.model && state.model.step) ? {
                    model: __assign({}, state.model, { step: __assign({}, state.model.step, { Properties: __assign({}, state.model.step.Properties, properties) }) })
                } : {};
            });
        };
        _this.actionClass = function (action) {
            return action.ActionType.replace(".", "").toLowerCase();
        };
        _this.runsOnServer = function (action, executionLocation) {
            return action && executionLocation &&
                (executionLocation === resources_1.ActionExecutionLocation.AlwaysOnServer ||
                    (executionLocation === resources_1.ActionExecutionLocation.TargetOrServer && action.Properties["Octopus.Action.RunOnServer"] === "true"));
        };
        _this.findAction = function (deploymentProcess, id) {
            for (var i = 0; i < deploymentProcess.Steps.length; i++) {
                var step = deploymentProcess.Steps[i];
                for (var j = 0; j < step.Actions.length; j++) {
                    var action = step.Actions[j];
                    if (action.Id === id) {
                        return { action: action, step: step, actionIndex: j, stepIndex: i };
                    }
                }
            }
            return null;
        };
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(this.state && this.state.model)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.save(this.state.model)];
                                    case 1:
                                        result = _a.sent();
                                        this.reloadThePage(result);
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.applyChange = function (deploymentProcess) { return __awaiter(_this, void 0, void 0, function () {
            var process;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.modify(deploymentProcess)];
                    case 1:
                        process = _a.sent();
                        this.props.onProjectStepsUpdated(process.Steps ? process.Steps.length : 0);
                        return [2 /*return*/, process];
                }
            });
        }); };
        _this.state = {
            showAdvancedSettings: true,
            openTennantPreview: false,
            pageTitle: "Step",
            canRunBeforeAcquisition: props.canRunBeforeAcquisition,
        };
        return _this;
    }
    Object.defineProperty(ActionDetailsInternal.prototype, "isNew", {
        get: function () {
            return !!(this.state && this.state.model && this.state.model.action && !this.state.model.action.Id);
        },
        enumerable: true,
        configurable: true
    });
    ActionDetailsInternal.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var action, environmentOption, runsOnServer, runOn, model;
            return __generator(this, function (_a) {
                action = this.props.action;
                environmentOption = (action.Environments || []).length > 0
                    ? EnvironmentOption.Include
                    : ((action.ExcludedEnvironments || []).length > 0)
                        ? EnvironmentOption.Exclude
                        : EnvironmentOption.All;
                runsOnServer = this.runsOnServer(action, this.props.plugin.executionLocation);
                runOn = runsOnServer
                    ? (this.showRolesForServer(this.props) ? RunOn.OctopusServerForRoles : RunOn.OctopusServer)
                    : RunOn.DeploymentTarget;
                model = {
                    step: this.props.step,
                    runOn: runOn,
                    action: action,
                    environmentOption: environmentOption,
                    condition: this.calculateEnvironmentConditions()
                };
                this.setState({
                    model: model,
                    cleanModel: lodash_2.cloneDeep(model)
                });
                return [2 /*return*/];
            });
        });
    };
    ActionDetailsInternal.prototype.render = function () {
        var _this = this;
        var action = this.state.model && this.state.model.action;
        var step = this.state.model && this.state.model.step;
        var addFeatures = (this.props.hasFeatures && !this.props.actionTemplate && action)
            ? React.createElement(OpenFeatureDialog_1.default, { actionType: action.ActionType, properties: action.Properties, saveDone: function (x) {
                    return _this.setActionProperties((_a = {}, _a["Octopus.Action.EnabledFeatures"] = x, _a));
                    var _a;
                } })
            : null;
        var actionEditorAdditionalActions = {
            packageAcquisition: {
                canRunBeforeAcquisition: this.state.canRunBeforeAcquisition,
                stepPackageRequirement: this.props.step.PackageRequirement,
                onCanRunBeforeAcquisitionChanged: function (x) {
                    _this.setState({ canRunBeforeAcquisition: x });
                },
                onStepPackageRequirementChanged: function (x) {
                    _this.setStepState({ PackageRequirement: x });
                }
            },
            stepTargetRoles: this.props.step.Properties["Octopus.Action.TargetRoles"]
        };
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo });
        }
        var title = action && action.Name
            ? action.Name
            : "Step Details";
        /* mark.siedle - This is an exception to the usual ellipsis pattern because of the StepDetailsLoader. */
        var breadcrumbTitle = "Process";
        var link = routeLinks_1.default.project(this.props.project.Slug).process;
        var breadcrumbPath = link.root;
        var isNewChildStep = this.props.match.params.stepId && this.isNew;
        if (!this.props.match.params.stepId) {
            // Redirect back to step template screen instead.
            breadcrumbTitle = "Step Templates";
            breadcrumbPath = link.stepTemplates;
        }
        else if (isNewChildStep) {
            // Redirect back to parent's step template screen instead.
            breadcrumbTitle = "Step Templates";
            breadcrumbPath = link.childStepTemplates(this.props.match.params.stepId).root;
        }
        var hasManualInterventionResponsibleTeams = action && resources_1.HasManualInterventionResponsibleTeams(action);
        return React.createElement(FormPaperLayout_1.default, { title: title, titleLogo: action && React.createElement(index_1.default, { url: getActionLogoUrl_1.default(action) }), breadcrumbTitle: breadcrumbTitle, breadcrumbPath: breadcrumbPath, busy: this.state.busy, errors: this.state.errors, model: this.state.model, cleanModel: this.state.cleanModel, savePermission: {
                permission: permission_1.default.ProcessEdit,
                project: this.props.project.Id,
            }, onSaveClick: this.handleSaveClick, secondaryAction: addFeatures, saveText: "Step details updated", isNewRecord: this.isNew }, this.state.model && action && React.createElement("div", null,
            React.createElement("div", null,
                this.state.confirmReadPromise &&
                    React.createElement(PromiseConfirmationDialog_1.default, { title: "Conflict", continueButtonLabel: "Restore the step", deferred: this.state.confirmReadPromise }, "Someone else has deleted this step from the deployment process. Would you like to add the step back?"),
                this.state.cleanModel && this.state.cleanModel.action.IsDisabled && React.createElement(WarningFormSection_1.default, null,
                    React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning }, "This step is currently disabled.")),
                React.createElement(form_2.ExpandableFormSection, { isExpandedByDefault: !action.Name, errorKey: "Name", title: "Step Name", focusOnExpandAll: true, summary: action.Name
                        ? form_2.Summary.summary(action.Name)
                        : form_2.Summary.placeholder("Please enter a name for your step"), help: "A short, memorable, unique name for this step." },
                    React.createElement(Text_1.default, { value: action.Name, onChange: function (x) { return _this.setActionState({ Name: x }); }, label: "Step name", error: this.getFieldError("Name"), validate: form_1.required("Please enter a step name"), autoFocus: true })),
                React.createElement(ExecutionPlan_1.default, { projectId: this.props.project.Id, expandedByDefault: !action.Name, executionLocation: this.props.plugin.executionLocation, runOn: this.state.model.runOn, onRunOnChanged: function (runOn) {
                        _this.setModelState({ runOn: runOn });
                        _this.setActionProperties((_a = {}, _a["Octopus.Action.RunOnServer"] = runOn === RunOn.DeploymentTarget ? "false" : "true", _a));
                        var _a;
                    }, targetRoleOption: this.props.plugin.targetRoleOption, targetRoles: this.state.model.step.Properties["Octopus.Action.TargetRoles"], onTargetRolesChanged: function (roles) {
                        return _this.setStepProperties((_a = {}, _a["Octopus.Action.TargetRoles"] = ParseHelper_1.default.encodeCSV(roles), _a));
                        var _a;
                    }, targetRolesError: this.getFieldError("Octopus.Action.TargetRoles"), isChildStep: this.props.isChildStep, maxParallelism: this.state.model.step.Properties["Octopus.Action.MaxParallelism"], onMaxParallelismChanged: function (max) {
                        return _this.setStepProperties((_a = {}, _a["Octopus.Action.MaxParallelism"] = max, _a));
                        var _a;
                    }, availableRoles: this.props.availableRoles, runsOnServer: this.runsOnServer(this.state.model.action, this.props.plugin.executionLocation) }),
                !this.props.actionTemplate && React.createElement("div", null,
                    React.createElement(ActionEditor_1.default, { plugin: this.props.plugin, projectId: this.props.project.Id, isNew: this.isNew, doBusyTask: this.doBusyForChildren, properties: this.state.model.action.Properties, setProperties: function (p, i) { return _this.setActionProperties(p, i); }, additionalActions: actionEditorAdditionalActions, getFieldError: this.getFieldError, errors: this.state.errors }),
                    this.props.hasFeatures && action.Properties["Octopus.Action.EnabledFeatures"] &&
                        React.createElement(form_2.FormSectionHeading, { title: "Features" }),
                    React.createElement(FeatureEditor_1.default, { plugin: this.props.plugin, projectId: this.props.project.Id, isNew: this.isNew, doBusyTask: this.doBusyForChildren, properties: this.state.model.action.Properties, setProperties: function (p, i) { return _this.setActionProperties(p, i); }, enabledFeatures: action.Properties["Octopus.Action.EnabledFeatures"] || "", getFieldError: this.getFieldError, errors: this.state.errors })),
                this.props.actionTemplate && React.createElement(ActionTemplateEditor_1.default, { actionTemplate: this.props.actionTemplate, projectId: this.props.project.Id, process: this.props.deploymentProcess, actionId: this.props.action.Id, properties: this.state.model.action.Properties, setProperties: function (p) { return _this.setActionProperties(p); }, doBusyTask: this.doBusyForChildren }),
                React.createElement(form_2.FormSectionHeading, { title: "Conditions" }),
                React.createElement(Environments_1.default, { environmentOption: this.state.model.environmentOption, hasHiddenEnvironments: this.state.model.condition.hasHiddenEnvironments, environments: this.props.environments, inclusiveEnvironments: this.state.model.condition.inclusive, exclusiveEnvironments: this.state.model.condition.exclusive, onEnvironmentOptionChanged: function (environmentOption) { return _this.setModelState({ environmentOption: environmentOption }); }, onInclusiveEnvironmentsChanged: function (val) { return _this.setChildState2("model", "condition", { inclusive: val }); }, onExclusiveEnvironmentsChanged: function (val) { return _this.setChildState2("model", "condition", { exclusive: val }); } }),
                (action.Channels.length > 0 || this.props.channels.length > 1) && React.createElement(form_2.ExpandableFormSection, { title: "Channels", help: "Choose which channels this step applies to.", summary: this.channelsSummary(), errorKey: "channels" },
                    React.createElement(form_1.Note, null, "If nothing is selected this step will run for releases in any channel, otherwise it will only run for releases belonging to the selected channels."),
                    React.createElement(MultiSelect_1.ChannelMultiSelect, { items: this.props.channels, onChange: function (val) { return _this.setActionState({ Channels: val }); }, value: this.state.model.action.Channels })),
                React.createElement(FeatureToggle_2.default, { feature: FeatureToggle_1.Feature.MultiTenancy }, ((this.props.project.TenantedDeploymentMode !== resources_1.TenantedDeploymentMode.Untenanted) || action.TenantTags.length > 0)
                    && React.createElement(TenantsExpander_1.default, { doBusyTask: this.doBusyTask, tenantTags: action.TenantTags, tagIndex: this.props.tagIndex, onTenantTagsChange: function (tags) { return _this.setActionState({ TenantTags: tags }); } })),
                this.isConditionEditable() && step && React.createElement(RunTriggerExpander_1.default, { isFirstStep: this.props.isFirstStep, condition: this.state.model.step.Condition, onConditionChange: function (val) { return _this.setStepState({ Condition: val }); }, variableExpression: step.Properties["Octopus.Action.ConditionVariableExpression"], onVariableExpressionChange: function (x) {
                        return _this.setStepProperties((_a = {}, _a["Octopus.Action.ConditionVariableExpression"] = x, _a));
                        var _a;
                    }, projectId: this.props.project.Id }),
                this.isConditionEditable() && !this.props.isFirstStep &&
                    React.createElement(StartTriggerExpander_1.default, { startTrigger: this.state.model.step.StartTrigger, onChange: function (val) { return _this.setStepState({ StartTrigger: val }); } }),
                this.state.canRunBeforeAcquisition && step &&
                    React.createElement(PackageRequirementExpander_1.default, { packageRequirement: this.state.model.step.PackageRequirement, onChange: function (val) { return _this.setStepState({ PackageRequirement: val }); } }),
                React.createElement(form_2.ExpandableFormSection, { title: "Required", summary: this.state.model.action.IsRequired || hasManualInterventionResponsibleTeams
                        ? form_2.Summary.summary(React.createElement("span", null,
                            "This step is ",
                            React.createElement("strong", null, "required"),
                            " cannot be skipped"))
                        : form_2.Summary.summary(React.createElement("span", null,
                            "This step is ",
                            React.createElement("strong", null, "not required"),
                            " and can be skipped")), help: "Required steps cannot not be skipped when deploying a release", errorKey: "required" },
                    hasManualInterventionResponsibleTeams &&
                        React.createElement(form_1.Note, null, "Responsible teams are specified, therefore this step is always required."),
                    React.createElement(Checkbox_1.default, { value: this.state.model.action.IsRequired || hasManualInterventionResponsibleTeams, label: "Prevent this step from being skipped when deploying", disabled: hasManualInterventionResponsibleTeams, onChange: function (val) { return _this.setActionState({ IsRequired: val }); } })))));
    };
    ActionDetailsInternal.prototype.setActionState = function (state, callback) {
        this.setChildState2("model", "action", state, callback);
    };
    ActionDetailsInternal.prototype.setStepState = function (state, callback) {
        this.setChildState2("model", "step", state, callback);
    };
    ActionDetailsInternal.prototype.channelsSummary = function () {
        var _this = this;
        return this.state.model && this.state.model.action.Channels.length > 0
            ? form_2.Summary.summary(React.createElement("span", null,
                "This step will only run for releases in ",
                this.state.model.action.Channels.map(function (ch) { return _this.getChipForChannel(ch); })))
            : form_2.Summary.default("This step will run for releases in any channel");
    };
    ActionDetailsInternal.prototype.getChipForChannel = function (id) {
        var channel = this.props.channels.find(function (c) { return c.Id === id; });
        return channel ? React.createElement(Chips_1.ChannelChip, { key: channel.Id, channelName: channel.Name }) : React.createElement(Chips_1.MissingChip, { lookupId: id, type: Chips_1.ChipIcon.Channel });
    };
    ActionDetailsInternal.prototype.updateFeatures = function (action) {
        var enabledFeatureNames = (action.Properties["Octopus.Action.EnabledFeatures"] || "")
            .split(",")
            .filter(function (name) {
            return name !== "";
        });
        var enabledFeatures = enabledFeatureNames.map(function (f) {
            return pluginRegistry_1.default.getFeature(f);
        });
        var errors = {};
        enabledFeatures.forEach(function (feature) {
            if (feature.validate) {
                feature.validate(action.Properties, errors);
            }
        });
        if (Object.keys(errors).length > 0) {
            var exception = new resources_1.OctopusError(0, "There was a problem with your request.");
            exception.Errors = Object.values(errors);
            exception.Details = errors;
            throw exception;
        }
        var properties = __assign({}, action.Properties);
        pluginRegistry_1.default.getAllFeatures().forEach(function (feature) {
            if (enabledFeatureNames.indexOf(feature.featureName) === -1) {
                if (feature.disable) {
                    feature.disable(properties);
                }
            }
        });
        enabledFeatures.forEach(function (feature) {
            if (feature.preSave) {
                feature.preSave(properties);
            }
        });
        action.Properties = properties;
    };
    ActionDetailsInternal.prototype.updateEnvironments = function (action) {
        if (!this.state.model) {
            return;
        }
        action.Environments = lodash_1.uniq((this.state.model.condition.inclusive || []).concat(this.state.model.condition.unavailable));
        action.ExcludedEnvironments = lodash_1.uniq((this.state.model.condition.exclusive || []).concat(this.state.model.condition.unavailableExclusive));
        if (this.state.model.environmentOption !== EnvironmentOption.Include) {
            action.Environments.splice(0);
        }
        if (this.state.model.environmentOption !== EnvironmentOption.Exclude) {
            action.ExcludedEnvironments.splice(0);
        }
    };
    ActionDetailsInternal.prototype.reloadThePage = function (saveResult) {
        if (this.isNew) {
            var newActionId = this.findNewActionId(saveResult);
            var redirectTo = newActionId
                ? routeLinks_1.default.project(this.props.match.params.projectSlug).process.step(newActionId)
                : routeLinks_1.default.project(this.props.match.params.projectSlug).process.root;
            this.setState({ redirectTo: redirectTo });
        }
        var currentPath = this.props.location.pathname;
        var reloadKey = this.props.match.params.reloadKey;
        var path = DeploymentProcessRoute_1.DeploymentProcessRoute.nextStepReloadPath(currentPath, reloadKey);
        this.setState({ redirectTo: path });
    };
    ActionDetailsInternal.prototype.findNewActionId = function (saveResult) {
        // tslint:disable-next-line:prefer-for-of
        for (var s = 0; s < saveResult.Steps.length; s++) {
            // tslint:disable-next-line:prefer-for-of
            for (var i = 0; i < saveResult.Steps[s].Actions.length; i++) {
                if (this.state.model && this.state.model.action && saveResult.Steps[s].Actions[i].Name === this.state.model.action.Name) {
                    return saveResult.Steps[s].Actions[i].Id;
                }
            }
        }
        return null;
    };
    ActionDetailsInternal.prototype.save = function (model) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var action, step, actionIndex, deploymentProcess, s, foundAction, deferred, result, index;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        action = model.action;
                        step = model.step;
                        if (model.runOn === RunOn.OctopusServer) {
                            step.Properties["Octopus.Action.TargetRoles"] = "";
                        }
                        if (action) {
                            if (!action.Name || action.Name.length === 0) {
                                if (action.Properties["Octopus.Action.Package.PackageId"]) {
                                    action.Name = action.Properties["Octopus.Action.Package.PackageId"];
                                }
                            }
                            this.updateFeatures(action);
                            this.updateEnvironments(action);
                        }
                        actionIndex = step.Actions.findIndex(function (a) { return a.Id === action.Id; });
                        step.Actions[actionIndex] = action;
                        if (step.Actions.length === 1) {
                            // Step name should always match action name if there is only one action
                            step.Name = step.Actions[0].Name;
                        }
                        return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.get(this.props.project.DeploymentProcessId)];
                    case 1:
                        deploymentProcess = _a.sent();
                        if (this.props.match.params.actionType) {
                            if (this.props.match.params.stepId) {
                                s = lodash_1.find(deploymentProcess.Steps, function (st) { return st.Id === _this.props.match.params.stepId; });
                                if (s) {
                                    s.Actions.push(action);
                                }
                            }
                            else {
                                deploymentProcess.Steps.push(step);
                            }
                            return [2 /*return*/, this.applyChange(deploymentProcess)];
                        }
                        foundAction = this.findAction(deploymentProcess, this.props.match.params.stepId);
                        if (!!foundAction) return [3 /*break*/, 4];
                        deferred = new PromiseConfirmationDialog_1.Deferred();
                        this.setState({ confirmReadPromise: deferred });
                        return [4 /*yield*/, deferred.promise];
                    case 2:
                        result = _a.sent();
                        if (result === false) {
                            // throw an error so the user gets a clear visual indication of what we are doing.
                            throw new resources_1.OctopusError(500, "Someone else has deleted this step from the deployment process. Step not saved.");
                        }
                        index = this.props.deploymentProcess.Steps.indexOf(step);
                        deploymentProcess.Steps.splice(index, 0, step);
                        return [4 /*yield*/, this.applyChange(deploymentProcess)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        foundAction.step.Actions[foundAction.actionIndex] = action;
                        foundAction.step.Name = step.Name;
                        foundAction.step.PackageRequirement = step.PackageRequirement;
                        foundAction.step.Condition = step.Condition;
                        foundAction.step.StartTrigger = step.StartTrigger;
                        Object.keys(step.Properties).forEach(function (key) { return foundAction.step.Properties[key] = step.Properties[key]; });
                        return [4 /*yield*/, this.applyChange(deploymentProcess)];
                    case 5: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ActionDetailsInternal.prototype.showRolesForServer = function (props) {
        var hasRoles = !!props.step.Properties["Octopus.Action.TargetRoles"];
        return hasRoles || props.plugin.targetRoleOption === TargetRoles.Required;
    };
    return ActionDetailsInternal;
}(FormBaseComponent_1.default));
var mapDispatchToProps = function (dispatch) {
    return {
        onProjectStepsUpdated: function (numberOfSteps) {
            dispatch(projectsArea_1.projectStepsUpdated(numberOfSteps));
        },
    };
};
var ActionDetails = react_redux_1.connect(null, mapDispatchToProps)(ActionDetailsInternal);
exports.default = ActionDetails;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\ActionDetails.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\ActionDetails.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(16);
// Repositories provide a helpful abstraction around the Octopus Deploy API
var BasicRepository = (function () {
    function BasicRepository(collectionLinkName, client) {
        this.collectionLinkName = collectionLinkName;
        this.client = client;
    }
    BasicRepository.prototype.create = function (resource, args) {
        return this.client.create(this.client.getRootDocument().Links[this.collectionLinkName], resource, args);
    };
    BasicRepository.prototype.modify = function (resource, args) {
        return this.client.update(resource.Links.Self, resource, args);
    };
    BasicRepository.prototype.del = function (resource) {
        return this.client.del(resource.Links.Self);
    };
    BasicRepository.prototype.list = function (args) {
        return this.client.get(this.client.getRootDocument().Links[this.collectionLinkName], args);
    };
    BasicRepository.prototype.get = function (id, args) {
        var allArgs = this.extend(args || {}, { id: id });
        return this.client.get(this.client.getRootDocument().Links[this.collectionLinkName], allArgs);
    };
    BasicRepository.prototype.all = function (args) {
        if (args !== undefined && args.ids instanceof Array && args.ids.length === 0) {
            return new Promise(function (res) { res([]); });
        }
        // http.sys has a max query string of about 16k chars. Our typical max id length is 50 chars
        // so if we are doing requests by id and have more than 300, split into multiple requests
        var maxIds = 300;
        if (args !== undefined && args.ids instanceof Array && args.ids.length > maxIds) {
            return this.batchRequestsById(args, maxIds);
        }
        var allArgs = this.extend(args || {}, { id: "all" });
        return this.client.get(this.client.getRootDocument().Links[this.collectionLinkName], allArgs);
    };
    BasicRepository.prototype.allById = function (args) {
        return this.all(args).then(function (result) { return result.reduce(function (acc, resource) {
            acc[resource.Id] = resource;
            return acc;
        }, {}); });
    };
    BasicRepository.prototype.save = function (resource) {
        if (isExistingResource(resource)) {
            return this.modify(resource);
        }
        else {
            return this.create(resource);
        }
        function isExistingResource(r) {
            return !!r.Links && !!r.Id;
        }
    };
    BasicRepository.prototype.extend = function (arg1, arg2) {
        return __assign({}, arg1, arg2);
    };
    BasicRepository.prototype.batchRequestsById = function (args, batchSize) {
        var _this = this;
        var idArrays = args.ids.map(function (item, index) { return index % batchSize === 0 ? args.ids.slice(index, index + batchSize) : null; }).filter(function (item) { return !!item; });
        var promises = idArrays.map(function (ids) {
            var newArgs = __assign({}, args, { ids: ids, id: "all" });
            return _this.client.get(_this.client.getRootDocument().Links[_this.collectionLinkName], newArgs);
        });
        return Promise.all(promises).then(function (result) { return lodash_1.flatten(result); });
    };
    return BasicRepository;
}());
exports.default = BasicRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\basicRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\basicRepository.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ExternalLink = function (props) {
    var formatUrl = function (href) {
        if (href.startsWith("http")) {
            return href;
        }
        return "https://g.octopushq.com/" + href;
    };
    var onClick = function (e) {
        if (props.onClick) {
            props.onClick();
        }
        e.stopPropagation();
    };
    return React.createElement("a", { href: formatUrl(props.href), target: props.openInSelf ? "_self" : "_blank", onClick: onClick },
        props.children,
        props.showIcon && React.createElement("em", { style: { marginLeft: "0.250rem" }, className: "fa fa-external-link", "aria-hidden": "true" }));
};
ExternalLink.defaultProps = {
    showIcon: true,
    openInSelf: false
};
exports.default = ExternalLink;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\ExternalLink\\ExternalLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\ExternalLink\\ExternalLink.tsx"); } } })();

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.white = "#ffffff";
exports.primaryText = "#333333";
exports.secondaryText = "#9e9e9e";
exports.ternaryText = "#666666";
exports.primary = "#2f93e0";
exports.primaryDarkest = "#0F2535";
exports.primaryDark = "#0A67B1";
exports.primaryLight = "#74c0fb";
exports.secondaryDark = "#053B62";
exports.hover = "rgba(153, 153, 153, 0.08)";
exports.divider = "#cccccc";
exports.disabledBackground = "rgba(153, 153, 153, 0.7)";
exports.secondaryBackground = "#e0e0e0";
exports.info = "#0A67B1";
exports.success = "#53b953";
exports.danger = "#db4437";
exports.alert = "#fb8c00";
exports.disable = "#fbe1e9";
exports.dangerHighlight = "#f8e8e6";
exports.shadow40 = "rgba(0, 0, 0, 0.4)";
exports.shadow60 = "rgba(0, 0, 0, 0.6)";
exports.theme = {}; //empty on purpose


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\colors.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\colors.ts"); } } })();

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RadioButtonGroupInternal_1 = __webpack_require__(1602);
var styles = __webpack_require__(382);
var cn = __webpack_require__(19);
var InputLabel_1 = __webpack_require__(1604);
var BoundField_1 = __webpack_require__(95);
var RadioButtonGroup = (function (_super) {
    __extends(RadioButtonGroup, _super);
    function RadioButtonGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showExternalError: true
        };
        return _this;
    }
    RadioButtonGroup.prototype.componentWillReceiveProps = function (nextProps) {
        var isNewExternalErrorAvailable = nextProps.error !== this.props.error;
        if (isNewExternalErrorAvailable) {
            this.setState({ showExternalError: true });
        }
    };
    RadioButtonGroup.prototype.handleChange = function (event, value) {
        if (this.props.validate) {
            var result = this.props.validate(value);
            this.setState({ error: result });
            if (this.props.onValidate) {
                this.props.onValidate(result);
            }
        }
        this.setState({ showExternalError: false });
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };
    RadioButtonGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, value = _a.value, label = _a.label, validate = _a.validate, children = _a.children, error = _a.error, onChange = _a.onChange, onValidate = _a.onValidate, horizontal = _a.horizontal, noMargin = _a.noMargin, otherProps = __rest(_a, ["className", "value", "label", "validate", "children", "error", "onChange", "onValidate", "horizontal", "noMargin"]);
        var err = this.state.error || (this.state.showExternalError && error);
        var classes = [styles.radioButtonGroup, className];
        if (horizontal) {
            classes.push(styles.horizontal);
        }
        return (React.createElement("div", { className: cn(styles.container, (_b = {}, _b[styles.topMargin] = !noMargin, _b)) },
            React.createElement(InputLabel_1.default, { label: label }),
            React.createElement(RadioButtonGroupInternal_1.default, __assign({ className: cn(classes), name: name, onChange: function (e, v) { return _this.handleChange(e, v); }, floatingLabelText: label, valueSelected: value }, otherProps), children),
            err && React.createElement("div", { className: styles.errorText }, err)));
        var _b;
    };
    return RadioButtonGroup;
}(React.Component));
var StringRadioButtonGroup = (function (_super) {
    __extends(StringRadioButtonGroup, _super);
    function StringRadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StringRadioButtonGroup;
}(RadioButtonGroup));
exports.StringRadioButtonGroup = StringRadioButtonGroup;
var BooleanRadioButtonGroup = (function (_super) {
    __extends(BooleanRadioButtonGroup, _super);
    function BooleanRadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BooleanRadioButtonGroup;
}(RadioButtonGroup));
exports.BooleanRadioButtonGroup = BooleanRadioButtonGroup;
exports.BoundStringRadioButtonGroup = BoundField_1.withBoundField(StringRadioButtonGroup);
exports.BoundRadioButtonGroup = BoundField_1.withBoundField(RadioButtonGroup);
exports.default = RadioButtonGroup;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\RadioButton\\RadioButtonGroup.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\RadioButton\\RadioButtonGroup.tsx"); } } })();

/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var TargetList_1 = __webpack_require__(1840);
var index_1 = __webpack_require__(23);
var ParseHelper_1 = __webpack_require__(75);
var RolesList = (function (_super) {
    __extends(RolesList, _super);
    function RolesList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RolesList;
}(TargetList_1.default));
var Roles = function (props) {
    var roles = ParseHelper_1.default.parseCSV(props.rolesAsCSV);
    return React.createElement("span", null,
        roles.length === 1 ? "role" : "roles",
        " ",
        React.createElement(RolesList, { targets: roles, renderTarget: (function (role) { return React.createElement(index_1.RoleChip, { key: role, role: role }); }) }));
};
Roles.displayName = "Roles";
exports.default = Roles;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\Roles.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\Roles.tsx"); } } })();

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RadioButton_1 = __webpack_require__(578);
var colors_1 = __webpack_require__(32);
var styles = __webpack_require__(382);
var radio_button_checked_1 = __webpack_require__(580);
var RadioButton = (function (_super) {
    __extends(RadioButton, _super);
    function RadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioButton.prototype.componentDidMount = function () {
        if (this.props.autoFocus) {
            // this digs into the RadioButton implementation to set focus
            var internalSwitch = this.radioButtonImpl.refs.enhancedSwitch;
            internalSwitch.refs.checkbox.focus();
            internalSwitch.tabPressed = true;
            internalSwitch.handleFocus();
        }
    };
    RadioButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, isDefault = _a.isDefault, label = _a.label, otherProps = __rest(_a, ["isDefault", "label"]);
        var newlabel = isDefault
            ? React.createElement("span", { className: styles.isDefault }, label)
            : label;
        return React.createElement(RadioButton_1.default, __assign({ ref: function (ref) { return _this.radioButtonImpl = ref; }, label: newlabel, labelStyle: this.props.disabled ? { color: colors_1.secondaryText } : {}, checkedIcon: React.createElement(radio_button_checked_1.default, { style: { fill: colors_1.primary } }) }, otherProps));
    };
    return RadioButton;
}(React.Component));
RadioButton.defaultProps = {
    checked: false,
    isDefault: false
};
exports.default = RadioButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\RadioButton\\RadioButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\RadioButton\\RadioButton.tsx"); } } })();

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActionExecutionLocation;
(function (ActionExecutionLocation) {
    ActionExecutionLocation["AlwaysOnTarget"] = "AlwaysOnTarget";
    ActionExecutionLocation["AlwaysOnServer"] = "AlwaysOnServer";
    ActionExecutionLocation["TargetOrServer"] = "TargetOrServer";
})(ActionExecutionLocation = exports.ActionExecutionLocation || (exports.ActionExecutionLocation = {}));
exports.default = ActionExecutionLocation;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\actionExecutionLocation.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\actionExecutionLocation.ts"); } } })();

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Checkbox_1 = __webpack_require__(118);
var BoundField_1 = __webpack_require__(95);
var StringCheckbox = (function (_super) {
    __extends(StringCheckbox, _super);
    function StringCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (isChecked) {
            var trueValue = _this.props.trueValue || "True";
            var falseValue = _this.props.falseValue || "False";
            var value = isChecked ? trueValue : falseValue;
            if (_this.props.validate) {
                var validateResult = _this.props.validate(value);
                _this.props.onValidate(validateResult);
            }
            _this.props.onChange(value);
        };
        return _this;
    }
    StringCheckbox.prototype.render = function () {
        var _a = this.props, value = _a.value, onChange = _a.onChange, onValidate = _a.onValidate, validate = _a.validate, note = _a.note, otherProps = __rest(_a, ["value", "onChange", "onValidate", "validate", "note"]);
        var val = (value || "").toLowerCase() === "true";
        return React.createElement(Checkbox_1.default, __assign({ value: val, title: this.props.title, onChange: this.handleChange, note: this.props.note }, otherProps));
    };
    return StringCheckbox;
}(React.Component));
exports.default = StringCheckbox;
exports.BoundStringCheckbox = BoundField_1.withBoundField(StringCheckbox);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Checkbox\\StringCheckbox.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Checkbox\\StringCheckbox.tsx"); } } })();

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(60);
var resources_1 = __webpack_require__(26);
var moment = __webpack_require__(104);
var DataBaseComponent = (function (_super) {
    __extends(DataBaseComponent, _super);
    function DataBaseComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.refreshId = 0;
        _this.busies = [];
        _this.doBusyTask = function (action, clearCurrentErrors) {
            if (clearCurrentErrors === void 0) { clearCurrentErrors = true; }
            return _this.doBusyTaskInternal(action, clearCurrentErrors);
        };
        _this.setError = function (message, details, fieldErrors) {
            if (details === void 0) { details = []; }
            if (fieldErrors === void 0) { fieldErrors = {}; }
            _this.setState({ errors: {
                    message: message,
                    details: details,
                    fieldErrors: fieldErrors
                } });
        };
        _this.doBusyTaskInternal = function (action, clearCurrentErrors) { return __awaiter(_this, void 0, void 0, function () {
            var busy, singlePromise, e_1, errors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        // Sometimes child components will load some lookup data while a parent component
                        // is displaying an error. The child uses the parent's doBusyTask so that the busy
                        // indicator and errors display correctly. But we shouldn't clear existing errors
                        // from that child load.
                        if (clearCurrentErrors) {
                            this.setState({
                                errors: null
                            });
                        }
                        busy = action();
                        this.busies = [busy].concat(this.busies);
                        singlePromise = Promise.all(this.busies).then(function (v) { });
                        this.setState({ busy: singlePromise });
                        return [4 /*yield*/, busy];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1 instanceof resources_1.OctopusError) {
                            errors = this.mapToOctopusError(e_1);
                            this.setState({ errors: errors });
                            return [2 /*return*/, false];
                        }
                        throw e_1;
                    case 3:
                        this.busies = this.busies.filter(function (b) { return b !== busy; });
                        // we need to return null here when done
                        // because some buttons etc just check for the
                        // existance of a busy promise
                        this.setState({ busy: this.busies.length > 0 ? Promise.all(this.busies).then(function (v) { }) : null });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.provideErrorHandling(_this.doBusyTaskInternal);
        return _this;
    }
    DataBaseComponent.prototype.doRefresh = function (getData) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var get, currentRefreshId, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    get = getData();
                                    this.refreshId += 1;
                                    currentRefreshId = this.refreshId;
                                    return [4 /*yield*/, get];
                                case 1:
                                    result = _a.sent();
                                    if (currentRefreshId === this.refreshId) {
                                        this.setState(result);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    DataBaseComponent.prototype.beginRefreshLoop = function (getData, refreshInterval, lastRefresh) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var interval;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.unmounted) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 4, 5]);
                        interval = document.hidden ? refreshInterval * 12 : refreshInterval;
                        if (!(!lastRefresh || moment().diff(lastRefresh, "ms") >= interval)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.doRefresh(getData)];
                    case 2:
                        _a.sent();
                        lastRefresh = moment();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        window.setTimeout(function () { return _this.beginRefreshLoop(getData, refreshInterval, lastRefresh); }, 250);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DataBaseComponent.prototype.mapToOctopusError = function (err) {
        // we override this in subclasses so don't remove
        return createErrorsFromOctopusError(err);
    };
    return DataBaseComponent;
}(BaseComponent_1.default));
exports.DataBaseComponent = DataBaseComponent;
function createErrorsFromOctopusError(err) {
    return {
        message: err.ErrorMessage,
        details: err.Errors || [],
        detailLinks: err.ParsedHelpLinks,
        helpLink: err.HelpLink,
        helpText: err.HelpText,
        fullException: err.FullException,
        fieldErrors: {}
    };
}
exports.createErrorsFromOctopusError = createErrorsFromOctopusError;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataBaseComponent\\DataBaseComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataBaseComponent\\DataBaseComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_1 = __webpack_require__(69);
var resolvePathWithSpaceId_1 = __webpack_require__(131);
var InternalRedirect = function (props) {
    /* tslint:disable:jsx-ban-elements */
    return React.createElement(react_router_1.Redirect, { from: props.from, to: resolvePathWithSpaceId_1.resolvePathWithSpaceId(props.to, props.match.params.spaceId), push: props.push, exact: props.exact });
};
exports.default = react_router_1.withRouter(InternalRedirect);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\InternalRedirect\\InternalRedirect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\InternalRedirect\\InternalRedirect.tsx"); } } })();

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var SelectField_1 = __webpack_require__(782);
var MenuItem_1 = __webpack_require__(97);
var colors_1 = __webpack_require__(32);
var FilterSearchBox_1 = __webpack_require__(171);
var fontWeights_1 = __webpack_require__(76);
var styles = __webpack_require__(1585);
var LabelStrategy_1 = __webpack_require__(174);
var BoundField_1 = __webpack_require__(95);
var SelectInternal = (function (_super) {
    __extends(SelectInternal, _super);
    function SelectInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (_, __, value) {
            if (_this.props.validate) {
                var result = _this.props.validate(value);
                _this.setState({ error: result });
                if (_this.props.onValidate) {
                    _this.props.onValidate(result);
                }
            }
            _this.setState({
                filter: null,
                filteredItems: null,
                showExternalError: false
            });
            _this.props.onChange(value);
        };
        _this.handleFilterChanged = function (value) {
            var filteredItems = _this.props.items.filter(function (item) {
                return item.text.toLowerCase().search(value.toLowerCase()) !== -1;
            });
            _this.setState({
                filter: value,
                filteredItems: filteredItems
            });
        };
        _this.handleOnClose = function () {
            if (_this.state.filter) {
                _this.setState({
                    filter: null,
                    filteredItems: null
                });
            }
        };
        _this.state = {
            filter: null,
            filteredItems: null,
            showExternalError: true
        };
        return _this;
    }
    SelectInternal.prototype.componentWillReceiveProps = function (nextProps) {
        var isNewExternalErrorAvailable = nextProps.error !== this.props.error;
        if (isNewExternalErrorAvailable) {
            this.setState({ showExternalError: true });
        }
    };
    SelectInternal.prototype.render = function () {
        var _a = this.props, value = _a.value, label = _a.label, fixedLabel = _a.fixedLabel, items = _a.items, error = _a.error, onChange = _a.onChange, onValidate = _a.onValidate, validate = _a.validate, warning = _a.warning, hintText = _a.hintText, allowClear = _a.allowClear, allowFilter = _a.allowFilter, otherProps = __rest(_a, ["value", "label", "fixedLabel", "items", "error", "onChange", "onValidate", "validate", "warning", "hintText", "allowClear", "allowFilter"]);
        var err = this.state.error || (this.state.showExternalError && error);
        var errorText = err || warning;
        var errorStyle = { bottom: "0px", color: err ? colors_1.danger : colors_1.alert };
        return (React.createElement("div", { className: styles.container },
            React.createElement(SelectField_1.default, __assign({ className: styles.select, value: value, allowClear: allowClear, hintText: hintText, onChange: this.handleChange, errorText: errorText, errorStyle: errorStyle, floatingLabelText: label, floatingLabelStyle: { color: colors_1.secondaryText, fontWeight: fontWeights_1.normal }, floatingLabelFocusStyle: errorText ? errorStyle : { color: colors_1.primary, fontWeight: fontWeights_1.normal }, floatingLabelFixed: !!hintText, selectedMenuItemStyle: { color: colors_1.primary }, underlineFocusStyle: { borderColor: colors_1.primary }, underlineStyle: { borderColor: colors_1.secondaryText, position: "relative" }, dropDownMenuProps: { onClose: this.handleOnClose }, iconStyle: { fill: colors_1.secondaryText }, filter: allowFilter && React.createElement("div", { className: styles.filter },
                    React.createElement(FilterSearchBox_1.default, { hintText: "Find...", autoFocus: true, value: this.state.filter, onChange: this.handleFilterChanged })) }, otherProps), (this.state.filteredItems || items).map(function (item) {
                return React.createElement(MenuItem_1.default, { key: item.value, value: item.value, leftIcon: item.icon, primaryText: item.text, style: item.style });
            }))));
    };
    return SelectInternal;
}(React.Component));
var Select = LabelStrategy_1.default(SelectInternal, function (fieldName) { return "Select " + fieldName; });
exports.default = Select;
exports.BoundSelect = BoundField_1.withBoundField(Select);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Select\\Select.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Select\\Select.tsx"); } } })();

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var styles = __webpack_require__(625);
var react_router_1 = __webpack_require__(69);
var exposeComponentAsClass_1 = __webpack_require__(369);
var resolvePathWithSpaceId_1 = __webpack_require__(131);
var cn = __webpack_require__(19);
var InternalLink = function (props) {
    var onClick = function (e) {
        if (props.onClick) {
            props.onClick();
        }
        e.stopPropagation();
    };
    var style = {};
    if (props.size) {
        style.fontSize = props.size + "rem";
    }
    if (props.weight) {
        style.fontWeight = props.weight;
    }
    /* tslint:disable:jsx-ban-elements */
    return React.createElement(react_router_dom_1.Link, { className: cn(styles.internalLink, props.className), style: { fontSize: props.size + "rem" }, to: resolvePathWithSpaceId_1.resolvePathWithSpaceId(props.to, props.match.params.spaceId), target: props.openInSelf ? "_self" : "_blank", onClick: onClick }, props.children);
};
InternalLink.defaultProps = {
    openInSelf: true
};
exports.default = exposeComponentAsClass_1.exposeComponentAsClass(react_router_1.withRouter(InternalLink));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\InternalLink\\InternalLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\InternalLink\\InternalLink.tsx"); } } })();

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(139);
var CardExpandable_1 = __webpack_require__(764);
var styles = __webpack_require__(116);
var cn = __webpack_require__(19);
var FormSectionBase_1 = __webpack_require__(264);
var Expandable_1 = __webpack_require__(729);
var uiTestClasses_1 = __webpack_require__(77);
var CardFill;
(function (CardFill) {
    CardFill[CardFill["None"] = 0] = "None";
    CardFill[CardFill["FillRight"] = 1] = "FillRight";
    CardFill[CardFill["FillAll"] = 2] = "FillAll";
})(CardFill = exports.CardFill || (exports.CardFill = {}));
var ExpandableFormSectionInternal = (function (_super) {
    __extends(ExpandableFormSectionInternal, _super);
    function ExpandableFormSectionInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.focusControl = false;
        _this.ignore = false;
        // we can't just use actAsExpander on card Title because it eats the click
        // and we can't add links to the title in help text or our show more info link
        _this.handleExpand = function (e) {
            if (e.target.tagName.toLowerCase() !== "a") {
                e.preventDefault();
                _this.props.onExpandedChanged(!_this.props.isExpanded);
            }
        };
        _this.alterChild = function (child) {
            var focusOnExpand = _this.props.expandingAll === false || _this.props.focusOnExpandAll;
            if (focusOnExpand && _this.focusControl && _this.isFocusableControl(child)) {
                _this.focusControl = false;
                return React.cloneElement(child, __assign({}, child.props, { autoFocus: true }));
            }
            else {
                return child;
            }
        };
        _this.isFocusableControl = function (child) {
            return child.props && (child.props.onChange || child.props.setProperties) && !child.props.doNotAutoFocus;
        };
        _this.ignore = _this.props.isExpandedByDefault; //don't focus the first time we expand due to being expandedByDefault
        return _this;
    }
    ExpandableFormSectionInternal.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.isExpanded === false && nextProps.isExpanded === true) {
            if (this.ignore) {
                this.ignore = false;
            }
            else {
                this.focusControl = true;
            }
        }
    };
    ExpandableFormSectionInternal.prototype.render = function () {
        var summary = this.props.summary.type === "placeholder"
            ? React.createElement("span", { className: styles.cardPlaceholderSubTitle }, this.props.summary.node)
            : this.props.summary.type === "default"
                ? React.createElement("span", { className: styles.cardDefaultSubTitle }, this.props.summary.node)
                : React.createElement("span", { className: styles.cardSubTitle }, this.props.summary.node);
        var subtitle = this.props.isExpanded ? this.help(this.props.help) : summary;
        var title = this.title(this.props.title, subtitle);
        var bodyclasses = cn((_a = {},
            _a[styles.cardMedia] = true,
            _a[styles.cardMediaFillRight] = this.props.fillCardWidth === CardFill.FillRight || this.props.fillCardWidth === CardFill.FillAll,
            _a[styles.cardMediaFillAll] = this.props.fillCardWidth === CardFill.FillAll,
            _a));
        return React.createElement(Card_1.Card, { className: uiTestClasses_1.formSectionClass + " " + styles.formExpander, onExpandChange: this.props.onExpandedChanged, expanded: this.props.isExpanded },
            React.createElement(Card_1.CardTitle, { title: title, onClick: this.handleExpand, showExpandableButton: false }),
            this.body(bodyclasses, true),
            this.moreInformation());
        var _a;
    };
    ExpandableFormSectionInternal.prototype.title = function (title, subtitle) {
        return React.createElement("div", { className: styles.cardTitleContainer },
            React.createElement("span", { className: uiTestClasses_1.formSectionTitleClass + " " + styles.cardTitle }, title),
            subtitle,
            React.createElement("div", { className: styles.expandCollapse },
                React.createElement(CardExpandable_1.default, { tabIndex: this.props.isExpanded ? -1 : 0, expanded: this.props.isExpanded })));
    };
    return ExpandableFormSectionInternal;
}(FormSectionBase_1.FormSectionBase));
exports.ExpandableFormSectionInternal = ExpandableFormSectionInternal;
var ExpandableFormSection = Expandable_1.default(ExpandableFormSectionInternal);
exports.default = ExpandableFormSection;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\ExpandableFormSection.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\ExpandableFormSection.tsx"); } } })();

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var PermissionCheck = function (props) {
    var allowed = isAllowed(props);
    var alternate = props.alternate || null;
    var children = props.children || null;
    var renderChildren = function () {
        return children && typeof children === "function"
            ? children() : children;
    };
    return React.createElement("div", null, allowed ? renderChildren() : alternate);
};
function isAllowed(props) {
    var pid = props.project || (props.wildcard ? "*" : null);
    var eid = props.environment || (props.wildcard ? "*" : null);
    var gid = props.projectGroup || (props.wildcard ? "*" : null);
    var tid = props.tenant || (props.wildcard ? "*" : null);
    var permissions = (props.permission instanceof Array)
        ? props.permission
        : [props.permission];
    var checks = permissions.map(function (p) {
        return clientInstance_1.session.currentPermissions.isAuthorized({
            permission: p,
            projectId: pid,
            environmentId: eid,
            projectGroupId: gid,
            tenantId: tid
        });
    });
    return checks.some(function (x) { return x; });
}
exports.isAllowed = isAllowed;
function firstAuthorized(permissions) {
    return clientInstance_1.session.currentPermissions.firstAuthorized(permissions);
}
exports.firstAuthorized = firstAuthorized;
exports.default = PermissionCheck;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PermissionCheck\\PermissionCheck.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PermissionCheck\\PermissionCheck.tsx"); } } })();

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(116);
var FormSectionHeading = (function (_super) {
    __extends(FormSectionHeading, _super);
    function FormSectionHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormSectionHeading.prototype.render = function () {
        return React.createElement("div", { className: styles.sectionHeading },
            React.createElement("div", { className: styles.sectionHeadingTitle }, this.props.title));
    };
    return FormSectionHeading;
}(React.Component));
exports.default = FormSectionHeading;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\FormSectionHeading.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\FormSectionHeading.tsx"); } } })();

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SpecialVariables = {
    Action: {
        TargetRoles: "Octopus.Action.TargetRoles",
        Package: {
            PackageId: "Octopus.Action.Package.PackageId",
            FeedId: "Octopus.Action.Package.FeedId"
        },
        RunOnServer: "Octopus.Action.RunOnServer",
        HealthCheck: {
            Type: "Octopus.Action.HealthCheck.Type"
        },
        Email: {
            To: "Octopus.Action.Email.To",
            ToTeamIds: "Octopus.Action.Email.ToTeamIds",
            CC: "Octopus.Action.Email.CC",
            CCTeamIds: "Octopus.Action.Email.CCTeamIds",
            Bcc: "Octopus.Action.Email.Bcc",
            BccTeamIds: "Octopus.Action.Email.BccTeamIds'"
        },
        MaxParallelism: "Octopus.Action.MaxParallelism",
        Certificate: {
            Variable: "Octopus.Action.Certificate.Variable",
            StoreLocation: "Octopus.Action.Certificate.StoreLocation"
        }
    }
};
exports.default = SpecialVariables;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\specialVariables.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\specialVariables.ts"); } } })();

/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
//Enums can't be keys in a dictionary so we might need to convert this to a list of static strings
var Permission;
(function (Permission) {
    Permission["None"] = "None";
    Permission["AdministerSystem"] = "AdministerSystem";
    Permission["ProjectEdit"] = "ProjectEdit";
    Permission["ProjectView"] = "ProjectView";
    Permission["ProjectCreate"] = "ProjectCreate";
    Permission["ProjectDelete"] = "ProjectDelete";
    Permission["ProcessView"] = "ProcessView";
    Permission["ProcessEdit"] = "ProcessEdit";
    Permission["VariableEdit"] = "VariableEdit";
    Permission["VariableEditUnscoped"] = "VariableEditUnscoped";
    Permission["VariableView"] = "VariableView";
    Permission["VariableViewUnscoped"] = "VariableViewUnscoped";
    Permission["ReleaseCreate"] = "ReleaseCreate";
    Permission["ReleaseView"] = "ReleaseView";
    Permission["ReleaseEdit"] = "ReleaseEdit";
    Permission["ReleaseDelete"] = "ReleaseDelete";
    Permission["DefectReport"] = "DefectReport";
    Permission["DefectResolve"] = "DefectResolve";
    Permission["DeploymentCreate"] = "DeploymentCreate";
    Permission["DeploymentDelete"] = "DeploymentDelete";
    Permission["DeploymentView"] = "DeploymentView";
    Permission["EnvironmentView"] = "EnvironmentView";
    Permission["EnvironmentCreate"] = "EnvironmentCreate";
    Permission["EnvironmentEdit"] = "EnvironmentEdit";
    Permission["EnvironmentDelete"] = "EnvironmentDelete";
    Permission["MachineCreate"] = "MachineCreate";
    Permission["MachineEdit"] = "MachineEdit";
    Permission["MachineView"] = "MachineView";
    Permission["MachineDelete"] = "MachineDelete";
    Permission["ArtifactView"] = "ArtifactView";
    Permission["ArtifactCreate"] = "ArtifactCreate";
    Permission["ArtifactEdit"] = "ArtifactEdit";
    Permission["ArtifactDelete"] = "ArtifactDelete";
    Permission["FeedView"] = "FeedView";
    Permission["EventView"] = "EventView";
    Permission["LibraryVariableSetView"] = "LibraryVariableSetView";
    Permission["LibraryVariableSetCreate"] = "LibraryVariableSetCreate";
    Permission["LibraryVariableSetEdit"] = "LibraryVariableSetEdit";
    Permission["LibraryVariableSetDelete"] = "LibraryVariableSetDelete";
    Permission["ProjectGroupView"] = "ProjectGroupView";
    Permission["ProjectGroupCreate"] = "ProjectGroupCreate";
    Permission["ProjectGroupEdit"] = "ProjectGroupEdit";
    Permission["ProjectGroupDelete"] = "ProjectGroupDelete";
    Permission["TeamCreate"] = "TeamCreate";
    Permission["TeamView"] = "TeamView";
    Permission["TeamEdit"] = "TeamEdit";
    Permission["TeamDelete"] = "TeamDelete";
    Permission["UserView"] = "UserView";
    Permission["UserEdit"] = "UserEdit";
    Permission["UserInvite"] = "UserInvite";
    Permission["UserRoleView"] = "UserRoleView";
    Permission["UserRoleEdit"] = "UserRoleEdit";
    Permission["TaskView"] = "TaskView";
    Permission["TaskViewLog"] = "TaskViewLog";
    Permission["TaskCreate"] = "TaskCreate";
    Permission["TaskCancel"] = "TaskCancel";
    Permission["TaskEdit"] = "TaskEdit";
    Permission["InterruptionView"] = "InterruptionView";
    Permission["InterruptionSubmit"] = "InterruptionSubmit";
    Permission["InterruptionViewSubmitResponsible"] = "InterruptionViewSubmitResponsible";
    Permission["BuiltInFeedPush"] = "BuiltInFeedPush";
    Permission["BuiltInFeedAdminister"] = "BuiltInFeedAdminister";
    Permission["BuiltInFeedDownload"] = "BuiltInFeedDownload";
    Permission["ActionTemplateView"] = "ActionTemplateView";
    Permission["ActionTemplateCreate"] = "ActionTemplateCreate";
    Permission["ActionTemplateEdit"] = "ActionTemplateEdit";
    Permission["ActionTemplateDelete"] = "ActionTemplateDelete";
    Permission["LifecycleCreate"] = "LifecycleCreate";
    Permission["LifecycleView"] = "LifecycleView";
    Permission["LifecycleEdit"] = "LifecycleEdit";
    Permission["LifecycleDelete"] = "LifecycleDelete";
    Permission["AccountView"] = "AccountView";
    Permission["AccountEdit"] = "AccountEdit";
    Permission["AccountCreate"] = "AccountCreate";
    Permission["AccountDelete"] = "AccountDelete";
    Permission["AuditView"] = "AuditView";
    Permission["TenantCreate"] = "TenantCreate";
    Permission["TenantEdit"] = "TenantEdit";
    Permission["TenantView"] = "TenantView";
    Permission["TenantDelete"] = "TenantDelete";
    Permission["TagSetCreate"] = "TagSetCreate";
    Permission["TagSetEdit"] = "TagSetEdit";
    Permission["TagSetDelete"] = "TagSetDelete";
    Permission["MachinePolicyCreate"] = "MachinePolicyCreate";
    Permission["MachinePolicyView"] = "MachinePolicyView";
    Permission["MachinePolicyEdit"] = "MachinePolicyEdit";
    Permission["MachinePolicyDelete"] = "MachinePolicyDelete";
    Permission["ProxyCreate"] = "ProxyCreate";
    Permission["ProxyView"] = "ProxyView";
    Permission["ProxyEdit"] = "ProxyEdit";
    Permission["ProxyDelete"] = "ProxyDelete";
    Permission["SubscriptionCreate"] = "SubscriptionCreate";
    Permission["SubscriptionView"] = "SubscriptionView";
    Permission["SubscriptionEdit"] = "SubscriptionEdit";
    Permission["SubscriptionDelete"] = "SubscriptionDelete";
    Permission["TriggerCreate"] = "TriggerCreate";
    Permission["TriggerView"] = "TriggerView";
    Permission["TriggerEdit"] = "TriggerEdit";
    Permission["TriggerDelete"] = "TriggerDelete";
    Permission["CertificateView"] = "CertificateView";
    Permission["CertificateCreate"] = "CertificateCreate";
    Permission["CertificateEdit"] = "CertificateEdit";
    Permission["CertificateDelete"] = "CertificateDelete";
    Permission["CertificateExportPrivateKey"] = "CertificateExportPrivateKey";
    Permission["ConfigureServer"] = "ConfigureServer";
    Permission["FeedEdit"] = "FeedEdit";
})(Permission = exports.Permission || (exports.Permission = {}));
exports.default = Permission;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\permission.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\permission.ts"); } } })();

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RaisedButton_1 = __webpack_require__(217);
var FlatButton_1 = __webpack_require__(101);
var BusyFromPromise_1 = __webpack_require__(777);
var colors_1 = __webpack_require__(32);
var cn = __webpack_require__(19);
var styles = __webpack_require__(243);
var fontWeights_1 = __webpack_require__(76);
var ActionButtonType;
(function (ActionButtonType) {
    ActionButtonType[ActionButtonType["Primary"] = 0] = "Primary";
    ActionButtonType[ActionButtonType["Secondary"] = 1] = "Secondary";
    ActionButtonType[ActionButtonType["Ternary"] = 2] = "Ternary";
    ActionButtonType[ActionButtonType["Save"] = 3] = "Save";
    ActionButtonType[ActionButtonType["Delete"] = 4] = "Delete";
})(ActionButtonType = exports.ActionButtonType || (exports.ActionButtonType = {}));
var ActionButton = (function (_super) {
    __extends(ActionButton, _super);
    function ActionButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    ActionButton.prototype.onClick = function (event) {
        var _this = this;
        if (!this.props.onClick) {
            return;
        }
        if (event.preventDefault) {
            event.preventDefault();
        }
        var promise = (function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.props.onClick(event)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); })();
        this.setState({ invocation: promise });
        return promise;
    };
    ActionButton.prototype.getButton = function (busy, disabled) {
        var _this = this;
        var props = this.props;
        var otherProps = {
            tabIndex: props.tabIndex,
            className: cn(styles.globalActionButton, props.className),
        };
        var commonLabelStyle = {
            fontSize: "0.8125rem",
        };
        var labelStyle = __assign({ color: colors_1.primary, opacity: props.disabled ? 0.5 : 1, whiteSpace: "nowrap" }, commonLabelStyle, props.labelProps);
        var wrapperStyle = {
            display: "inline-block",
        };
        var label = busy && props.busyLabel ? props.busyLabel : props.label;
        var onClick = disabled ? null : function (e) { return _this.onClick(e); };
        switch (props.type) {
            case ActionButtonType.Primary:
                return React.createElement(RaisedButton_1.default, __assign({ type: "submit", label: label, title: label, disabled: disabled, icon: props.icon, backgroundColor: colors_1.secondaryDark, labelColor: colors_1.white, labelStyle: commonLabelStyle, disabledBackgroundColor: colors_1.disabledBackground, disabledLabelColor: colors_1.white, onClick: onClick, onFocus: props.onFocus, keyboardFocused: this.props.keyboardFocused }, otherProps));
            case ActionButtonType.Save:
                return React.createElement(RaisedButton_1.default, { type: "submit", keyboardFocused: this.props.keyboardFocused, label: label, title: label, disabled: disabled, disabledBackgroundColor: colors_1.disabledBackground, disabledLabelColor: colors_1.white, backgroundColor: colors_1.success, labelColor: colors_1.white, labelStyle: commonLabelStyle, onClick: onClick });
            case ActionButtonType.Delete:
                return React.createElement(RaisedButton_1.default, { type: "submit", keyboardFocused: this.props.keyboardFocused, label: label, title: label, disabled: disabled, backgroundColor: colors_1.danger, labelColor: colors_1.white, labelStyle: commonLabelStyle, onClick: onClick, disabledBackgroundColor: colors_1.disabledBackground, disabledLabelColor: colors_1.white });
            case ActionButtonType.Ternary:
                var contents = props.icon
                    ? [props.icon, label]
                    : label;
                var height = 36 / fontWeights_1.baseSizeInPx + "rem";
                return React.createElement("a", __assign({ href: "#", title: label, onClick: onClick, onFocus: props.onFocus, style: { height: height, lineHeight: height, marginLeft: "0.5rem", marginRight: "0.5rem",
                        fontSize: "0.8125rem", fontWeight: fontWeights_1.normal, textTransform: "uppercase" } }, otherProps), contents);
            // Fallthrough to Secondary
            default:
                var style = this.props.style ? this.props.style : { margin: "inherit" };
                // Div allows margin to be added
                return React.createElement(FlatButton_1.default, __assign({ label: label, title: label, labelStyle: labelStyle, style: style, icon: props.icon, disabled: disabled, onClick: onClick, onFocus: props.onFocus, keyboardFocused: this.props.keyboardFocused }, otherProps));
        }
    };
    ActionButton.prototype.render = function () {
        var _this = this;
        return React.createElement(BusyFromPromise_1.default, { promise: this.state.invocation }, function (busy) { return React.createElement(BusyFromPromise_1.default, { promise: _this.props.disabled }, function (disabled) { return _this.getButton(busy, disabled || busy); }); });
    };
    return ActionButton;
}(React.Component));
exports.ActionButton = ActionButton;
exports.default = ActionButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Button\\ActionButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Button\\ActionButton.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NavigationButton_1 = __webpack_require__(212);
exports.NavigationButton = NavigationButton_1.NavigationButton;
exports.NavigationButtonType = NavigationButton_1.NavigationButtonType;
var ActionButton_1 = __webpack_require__(50);
exports.ActionButton = ActionButton_1.ActionButton;
exports.ActionButtonType = ActionButton_1.ActionButtonType;
var CloseButton_1 = __webpack_require__(537);
exports.CloseButton = CloseButton_1.default;
var PagingControlButton_1 = __webpack_require__(1200);
exports.PagingControlButton = PagingControlButton_1.default;
var OpenDeleteDialogButton_1 = __webpack_require__(761);
exports.OpenDeleteDialogButton = OpenDeleteDialogButton_1.default;
exports.default = ActionButton_1.ActionButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Button\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Button\\index.tsx"); } } })();

/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Resource = (function () {
    function Resource() {
    }
    return Resource;
}());
exports.Resource = Resource;
exports.default = Resource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\resource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\resource.ts"); } } })();

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FeedType;
(function (FeedType) {
    FeedType["Nuget"] = "NuGet";
    FeedType["Docker"] = "Docker";
    FeedType["Maven"] = "Maven";
    FeedType["GitHub"] = "GitHub";
})(FeedType = exports.FeedType || (exports.FeedType = {}));
var BuiltInFeedId = "feeds-builtin";
exports.BuiltInFeedId = BuiltInFeedId;
var OctopusReleaseFeedId = "feeds-builtin-releases";
exports.OctopusReleaseFeedId = OctopusReleaseFeedId;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\feedResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\feedResource.ts"); } } })();

/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1369);
var FlatButton_1 = __webpack_require__(101);
var IconButton_1 = __webpack_require__(63);
var crop_original_1 = __webpack_require__(1371);
var index_1 = __webpack_require__(68);
var cn = __webpack_require__(19);
var refresh_1 = __webpack_require__(1372);
var add_1 = __webpack_require__(1373);
var search_1 = __webpack_require__(597);
var visibility_1 = __webpack_require__(1374);
var visibility_off_1 = __webpack_require__(1375);
var delete_1 = __webpack_require__(1376);
var mode_edit_1 = __webpack_require__(1377);
var clear_1 = __webpack_require__(178);
var file_upload_1 = __webpack_require__(1378);
var arrow_drop_down_1 = __webpack_require__(357);
var arrow_drop_up_1 = __webpack_require__(1379);
var colors_1 = __webpack_require__(32);
var Icon;
(function (Icon) {
    Icon[Icon["UseDefaultImage"] = 0] = "UseDefaultImage";
    Icon[Icon["EnterFullScreen"] = 1] = "EnterFullScreen";
    Icon[Icon["ExitFullScreen"] = 2] = "ExitFullScreen";
    Icon[Icon["Refresh"] = 3] = "Refresh";
    Icon[Icon["Add"] = 4] = "Add";
    Icon[Icon["Search"] = 5] = "Search";
    Icon[Icon["Show"] = 6] = "Show";
    Icon[Icon["Hide"] = 7] = "Hide";
    Icon[Icon["Edit"] = 8] = "Edit";
    Icon[Icon["Remove"] = 9] = "Remove";
    Icon[Icon["Cancel"] = 10] = "Cancel";
    Icon[Icon["ArrowDown"] = 11] = "ArrowDown";
    Icon[Icon["Upload"] = 12] = "Upload";
    Icon[Icon["ArrowUp"] = 13] = "ArrowUp";
})(Icon = exports.Icon || (exports.Icon = {}));
var IconButton = function (props) {
    if (props.icon !== null) {
        if (typeof props.icon === "string") {
            return iconButton(React.createElement("img", { className: styles.imageIcon, src: props.icon, alt: "" }), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
        }
        switch (props.icon) {
            case Icon.EnterFullScreen: return fontAwesomeIconButton("fa-expand", props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.ExitFullScreen: return fontAwesomeIconButton("fa-compress", props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.UseDefaultImage: return materialIconButton(React.createElement(crop_original_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Refresh: return materialIconButton(React.createElement(refresh_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Add: return materialIconButton(React.createElement(add_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Search: return materialIconButton(React.createElement(search_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Show: return materialIconButton(React.createElement(visibility_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Hide: return materialIconButton(React.createElement(visibility_off_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Edit: return materialIconButton(React.createElement(mode_edit_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Cancel: return materialIconButton(React.createElement(clear_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Remove: return materialIconButton(React.createElement(delete_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Upload: return materialIconButton(React.createElement(file_upload_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.ArrowDown: return materialIconButton(React.createElement(arrow_drop_down_1.default, { color: colors_1.secondaryText }), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.ArrowUp: return materialIconButton(React.createElement(arrow_drop_up_1.default, { color: colors_1.secondaryText }), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
        }
    }
    return materialIconButton(props.customIcon, props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
};
function materialIconButton(icon, onClick, toolTipContent, disabled, tabIndex, buttonRef) {
    var elem = React.createElement(IconButton_1.default, { className: styles.materialUIIcon, disabled: disabled, tabIndex: tabIndex, onClick: onClick, ref: buttonRef }, icon);
    if (!toolTipContent) {
        return elem;
    }
    return withToolTip(elem, toolTipContent);
}
function fontAwesomeIconButton(iconClassName, onClick, toolTipContent, disabled, tabIndex, buttonRef) {
    return iconButton(React.createElement("em", { className: cn("fa", iconClassName, styles.fontAwesomeIcon), "aria-hidden": "true" }), onClick, toolTipContent, disabled, tabIndex, buttonRef);
}
function iconButton(label, onClick, toolTipContent, disabled, tabIndex, buttonRef) {
    return withToolTip(React.createElement(FlatButton_1.default, { className: styles.materialUIIcon, disabled: disabled, tabIndex: tabIndex, onClick: onClick, ref: buttonRef, label: label }), toolTipContent);
}
function withToolTip(button, toolTipContent) {
    return React.createElement(index_1.default, { content: toolTipContent }, button);
}
IconButton.displayName = "IconButton";
exports.default = IconButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\IconButton\\IconButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\IconButton\\IconButton.tsx"); } } })();

/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var InternalLink_1 = __webpack_require__(213);
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var feedResource_1 = __webpack_require__(54);
var Callout_1 = __webpack_require__(81);
var Note_1 = __webpack_require__(22);
var Select_1 = __webpack_require__(41);
var ExternalLink_1 = __webpack_require__(29);
var routeLinks_1 = __webpack_require__(20);
var clientInstance_1 = __webpack_require__(10);
var AutoComplete_1 = __webpack_require__(1931);
var StringProperties = {
    "Octopus.Action.Package.FeedId": "",
    "Octopus.Action.Package.PackageId": "",
};
var PackageSelector = (function (_super) {
    __extends(PackageSelector, _super);
    function PackageSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.checkIfLooksLikeVersion = function () {
            var looksLikeVersion = false;
            var packageId = _this.props.properties["Octopus.Action.Package.PackageId"];
            if (packageId) {
                if (packageId.match(/\.[0-9]+\.?$/)) {
                    looksLikeVersion = true;
                }
            }
            _this.setState({ looksLikeVersion: looksLikeVersion });
        };
        _this.getPackageOptions = function (searchText, feed) { return __awaiter(_this, void 0, void 0, function () {
            var items, packages;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (feed === null) {
                            items = [];
                            return [2 /*return*/, {
                                    items: items,
                                    containsAllResults: true
                                }];
                        }
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.searchPackages(feed, { term: searchText, take: 11, skip: 0 })];
                    case 1:
                        packages = _a.sent();
                        return [2 /*return*/, {
                                items: packages.Items.slice(0, 10).map(function (p) { return ({ Id: p.Id, Name: p.Id }); }),
                                containsAllResults: packages.Items.length !== 11
                            }];
                }
            });
        }); };
        _this.packageChanged = function (packageId) {
            _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.PackageId"] = packageId, _a));
            _this.checkIfLooksLikeVersion();
            var _a;
        };
        _this.feedChanged = function (feedId) {
            _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.FeedId"] = feedId, _a));
            var _a;
        };
        _this.getFeedId = function (feeds) {
            if (_this.props.properties["Octopus.Action.Package.FeedId"] !== null) {
                return _this.props.properties["Octopus.Action.Package.FeedId"];
            }
            return null;
        };
        _this.defaultFeedId = function (feeds) {
            if (feeds.length === 0) {
                return null;
            }
            var buildtIn = feeds.find(function (f) { return f.Id === feedResource_1.BuiltInFeedId; });
            if (buildtIn) {
                return buildtIn.Id;
            }
            return feeds[0].Id;
        };
        _this.getSelectedFeed = function (feeds) {
            if (feeds.length === 0) {
                return null;
            }
            if (_this.props.properties["Octopus.Action.Package.FeedId"]) {
                var feedId_1 = _this.props.properties["Octopus.Action.Package.FeedId"];
                var feed = feeds.find(function (f) { return f.Id === feedId_1; });
                if (feed) {
                    return feed;
                }
            }
            return null;
        };
        var feedType = props.feedType
            ? props.feedType
            : [feedResource_1.FeedType.Nuget, feedResource_1.FeedType.GitHub];
        _this.state = {
            feedType: feedType,
            looksLikeVersion: false,
            showBuiltIn: !!props.showBuiltIn
        };
        return _this;
    }
    PackageSelector.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props) || nextProps.feeds !== this.props.feeds;
    };
    PackageSelector.prototype.componentDidMount = function () {
        if (!this.props.properties["Octopus.Action.Package.FeedId"]) {
            this.props.setProperties((_a = {}, _a["Octopus.Action.Package.FeedId"] = feedResource_1.BuiltInFeedId, _a));
        }
        var _a;
    };
    PackageSelector.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var feeds = this.props.feeds.filter(function (f) {
            return _this.state.feedType.some(function (feedType) { return feedType === f.FeedType; }) ||
                (_this.state.showBuiltIn && f.Id === "feeds-builtin");
        });
        if (feeds.length === 0) {
            return React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning, title: "Package feed required" },
                "A package feed is required before this step can be configured. Please add a feed in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.feeds }, "External feeds"),
                " area and try again.");
        }
        var defaultFeedId = this.defaultFeedId(feeds);
        var selectedFeedId = this.getFeedId(feeds);
        if (selectedFeedId === null) {
            selectedFeedId = defaultFeedId;
        }
        var selectedFeed = this.getSelectedFeed(feeds);
        return React.createElement("div", null,
            React.createElement(Select_1.BoundSelect, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: defaultFeedId, value: selectedFeedId, onChange: this.feedChanged, items: feeds.map(function (f) { return ({ value: f.Id, text: f.Name }); }), error: this.props.getFieldError("Octopus.Action.Package.FeedId"), autoFocus: this.props.autoFocus, label: "Package feed" }),
            React.createElement(Note_1.default, null,
                "Select the feed that this package will be found in or bind one dynamically. See our ",
                React.createElement(ExternalLink_1.default, { href: "DynamicPackageFeeds" }, "documentation"),
                " for more info on dynamic binding."),
            React.createElement(AutoComplete_1.BoundAutoComplete, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "", label: "Package ID", value: properties["Octopus.Action.Package.PackageId"] || "", onChange: this.packageChanged, hintText: "Enter package ID", allowAnyTextValue: true, getOptions: function (searchText) { return _this.getPackageOptions(searchText, selectedFeed); }, error: this.props.getFieldError("Octopus.Action.Package.PackageId") }),
            React.createElement(Note_1.default, null,
                "Enter the ID of the package to deploy.",
                selectedFeed && selectedFeed.FeedType === feedResource_1.FeedType.Maven && React.createElement("span", null,
                    " The format of the package ID is ",
                    React.createElement("em", null, "Group:Artifact"),
                    " for example ",
                    React.createElement("em", null, "com.google.guava:guava"),
                    " or ",
                    React.createElement("em", null, "junit:junit"),
                    ".")),
            this.state.looksLikeVersion && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information, title: "Package version not required" }, "Hey there! It looks like you might be including the package version number in this field. You shouldn't include the package version number here, just the package ID."));
    };
    return PackageSelector;
}(BaseComponent_1.BaseComponent));
exports.default = PackageSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PackageSelector\\PackageSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PackageSelector\\PackageSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1433);
var CalloutType;
(function (CalloutType) {
    CalloutType[CalloutType["Information"] = 0] = "Information";
    CalloutType[CalloutType["Success"] = 1] = "Success";
    CalloutType[CalloutType["Warning"] = 2] = "Warning";
    CalloutType[CalloutType["Danger"] = 3] = "Danger";
})(CalloutType = exports.CalloutType || (exports.CalloutType = {}));
exports.Callout = function (props) {
    var iconName = null;
    var style = styles.none;
    switch (props.type) {
        case CalloutType.Information:// blue = information
            iconName = "sticky-note-o";
            style = styles.information;
            break;
        case CalloutType.Success:// green = success
            iconName = "lightbulb-o";
            style = styles.success;
            break;
        case CalloutType.Warning:// yellow = warning
            iconName = "exclamation-circle";
            style = styles.warning;
            break;
        case CalloutType.Danger:// red = danger
            iconName = "exclamation-triangle";
            style = styles.danger;
            break;
    }
    return (React.createElement("div", { className: style },
        props.title && React.createElement("div", { className: styles.title },
            iconName &&
                React.createElement("em", { style: { marginRight: "0.250rem" }, className: "fa fa-" + iconName, "aria-hidden": "true" }),
            React.createElement("strong", null, props.title)),
        React.createElement("div", null, props.children)));
};
exports.Callout.displayName = "Callout";
exports.default = exports.Callout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Callout\\Callout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Callout\\Callout.tsx"); } } })();

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(14);
exports.default = BaseComponent_1.BaseComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BaseComponent\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BaseComponent\\index.ts"); } } })();

/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var resources_1 = __webpack_require__(26);
var index_1 = __webpack_require__(23);
var form_1 = __webpack_require__(15);
var MissingTagsList_1 = __webpack_require__(290);
var React = __webpack_require__(0);
var scriptingLanguage_1 = __webpack_require__(140);
var CommonSummaryHelper = (function () {
    function CommonSummaryHelper() {
    }
    CommonSummaryHelper.resourceSummary = function (resourceId, resources, resourceType) {
        if (resourceId) {
            var resource = resources.find(function (x) { return x.Id === resourceId; });
            return resource
                ? form_1.Summary.summary(resource.Name)
                : form_1.Summary.placeholder("Using " + resourceType + " with id: " + resourceId); // Failed to find the resource.
        }
        return form_1.Summary.placeholder("No " + resourceType);
    };
    CommonSummaryHelper.tenantDeploymentModeSummary = function (deploymentMode, tenantIds, tenantTags) {
        var hasTags = tenantTags.length > 0;
        var hasTenants = tenantIds.length > 0;
        var hasTagOrTenant = hasTags || hasTenants;
        switch (deploymentMode) {
            case resources_1.TenantedDeploymentMode.Untenanted:
                return form_1.Summary.default(React.createElement("span", null, "Only available for untenanted deployments"));
            case resources_1.TenantedDeploymentMode.TenantedOrUntenanted:
                return hasTagOrTenant
                    ? form_1.Summary.summary(React.createElement("span", null, "Available for both untenanted deployments, and deployments to the associated tenants"))
                    : form_1.Summary.summary(React.createElement("span", null,
                        React.createElement("strong", null, "Only available in untenanted deployments"),
                        " until you choose some tenants"));
            case resources_1.TenantedDeploymentMode.Tenanted:
                return hasTagOrTenant
                    ? form_1.Summary.summary(React.createElement("span", null, "Only available for deployments to the associated tenants"))
                    : form_1.Summary.summary(React.createElement("span", null,
                        React.createElement("strong", null, "Not available for any deployments"),
                        " until you choose some tenants"));
        }
        return form_1.Summary.placeholder("Unknown tenant mode: " + deploymentMode);
    };
    CommonSummaryHelper.tenantSummary = function (tenantIds, tenantTags, tenants, showMissing) {
        var tenantChips = !!showMissing ? index_1.tenantChipListIncludingMissing(tenants, tenantIds) : index_1.tenantChipList(tenants, tenantIds);
        var hasTags = tenantTags.length > 0;
        var hasTenants = tenantIds.length > 0;
        var tenantDetails = React.createElement("span", null,
            hasTenants && React.createElement("span", null, tenantChips),
            hasTags && React.createElement("span", null,
                hasTenants ? "plus any" : "Any",
                " tenants tagged with ",
                React.createElement(MissingTagsList_1.default, { tags: tenantTags })));
        var hasTagOrTenant = hasTags || hasTenants;
        return hasTagOrTenant
            ? form_1.Summary.summary(React.createElement("span", null, tenantDetails))
            : form_1.Summary.summary("No tenants have been selected");
    };
    CommonSummaryHelper.portSummary = function (port, textIfEmpty) {
        if (textIfEmpty === void 0) { textIfEmpty = null; }
        return port ? form_1.Summary.summary(port) : form_1.Summary.placeholder(textIfEmpty ? textIfEmpty : "No port");
    };
    CommonSummaryHelper.packageSummary = function (properties, feeds) {
        var summary = [];
        if (properties["Octopus.Action.Package.PackageId"]) {
            summary.push(React.createElement("span", null,
                "Package ",
                React.createElement("strong", null, properties["Octopus.Action.Package.PackageId"])));
        }
        else {
            return form_1.Summary.placeholder("Choose a package to be deployed");
        }
        if (properties["Octopus.Action.Package.FeedId"]) {
            var feed = feeds.find(function (f) { return f.Id === properties["Octopus.Action.Package.FeedId"]; });
            if (feed) {
                summary.push(React.createElement("span", null,
                    " from feed ",
                    React.createElement("strong", null, feed.Name)));
            }
        }
        if (summary.length > 0) {
            return form_1.Summary.summary(React.Children.toArray(summary));
        }
        return form_1.Summary.placeholder("Choose a package to be deployed");
    };
    CommonSummaryHelper.scriptSummary = function (scriptBody, syntax) {
        if (!scriptBody) {
            return form_1.Summary.placeholder("The script body has not been defined");
        }
        if (syntax === scriptingLanguage_1.ScriptingLanguage.FSharp) {
            return form_1.Summary.summary(React.createElement("span", null,
                "An ",
                React.createElement("strong", null, "F#"),
                " script will be run"));
        }
        else if (syntax === scriptingLanguage_1.ScriptingLanguage.CSharp) {
            return form_1.Summary.summary(React.createElement("span", null,
                "A ",
                React.createElement("strong", null, "C#"),
                " script will be run"));
        }
        return form_1.Summary.summary(React.createElement("span", null,
            "A ",
            React.createElement("strong", null, syntax),
            " script will be run"));
    };
    return CommonSummaryHelper;
}());
exports.default = CommonSummaryHelper;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\CommonSummaryHelper\\CommonSummaryHelper.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\CommonSummaryHelper\\CommonSummaryHelper.tsx"); } } })();

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function ValueInPropertiesOrErrorsHasChanged(keysObject, newProps, props) {
    return newProps.errors !== props.errors || Object.keys(keysObject).some(function (p) { return newProps.properties[p] !== props.properties[p]; });
}
exports.ValueInPropertiesOrErrorsHasChanged = ValueInPropertiesOrErrorsHasChanged;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ShouldUpdate\\ValueInPropertiesHasChanged.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ShouldUpdate\\ValueInPropertiesHasChanged.ts"); } } })();

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var permission_1 = __webpack_require__(49);
var PermissionCheck_1 = __webpack_require__(45);
var clientInstance_1 = __webpack_require__(10);
function getFeedName(id) {
    return __awaiter(this, void 0, void 0, function () {
        var feedName, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!PermissionCheck_1.isAllowed({ permission: permission_1.Permission.FeedView })) return [3 /*break*/, 2];
                    return [4 /*yield*/, clientInstance_1.repository.Feeds.get(id)];
                case 1:
                    _a = (_b.sent()).Name;
                    return [3 /*break*/, 3];
                case 2:
                    _a = "(Feed unknown: " + permission_1.Permission.FeedView + " permission required)";
                    _b.label = 3;
                case 3:
                    feedName = _a;
                    return [2 /*return*/, feedName];
            }
        });
    });
}
exports.getFeedName = getFeedName;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\getFeedName.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\getFeedName.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ToolTip_1 = __webpack_require__(215);
var ToolTip_2 = __webpack_require__(215);
exports.ToolTipPosition = ToolTip_2.ToolTipPosition;
exports.ToolTipContent = ToolTip_2.ToolTipContent;
exports.default = ToolTip_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ToolTip\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ToolTip\\index.tsx"); } } })();

/***/ }),
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Summary = (function () {
    function Summary() {
    }
    Summary.placeholder = function (node) {
        return {
            node: node,
            type: "placeholder"
        };
    };
    Summary.default = function (node) {
        return {
            node: node,
            type: "default"
        };
    };
    Summary.summary = function (node) {
        return {
            node: node,
            type: "summary"
        };
    };
    return Summary;
}());
exports.default = Summary;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\Summary.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\Summary.tsx"); } } })();

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MultiSelect_1 = __webpack_require__(108);
exports.MultiSelect = MultiSelect_1.default;
var EnvironmentMultiSelect_1 = __webpack_require__(281);
exports.EnvironmentMultiSelect = EnvironmentMultiSelect_1.default;
var EventCategoryMultiSelect_1 = __webpack_require__(1641);
exports.EventCategoryMultiSelect = EventCategoryMultiSelect_1.default;
var EventGroupMultiSelect_1 = __webpack_require__(1642);
exports.EventGroupMultiSelect = EventGroupMultiSelect_1.default;
var DocumentTypeMultiSelect_1 = __webpack_require__(1643);
exports.DocumentTypeMultiSelect = DocumentTypeMultiSelect_1.default;
var MachineMultiSelect_1 = __webpack_require__(730);
exports.MachineMultiSelect = MachineMultiSelect_1.default;
var ProjectMultiSelect_1 = __webpack_require__(459);
exports.ProjectMultiSelect = ProjectMultiSelect_1.default;
var RoleMultiSelect_1 = __webpack_require__(423);
exports.RoleMultiSelect = RoleMultiSelect_1.default;
var TeamMultiSelect_1 = __webpack_require__(289);
exports.TeamMultiSelect = TeamMultiSelect_1.default;
var TenantMultiSelect_1 = __webpack_require__(446);
exports.TenantMultiSelect = TenantMultiSelect_1.default;
var TenantTagMultiSelect_1 = __webpack_require__(295);
exports.TenantTagMultiSelect = TenantTagMultiSelect_1.default;
var UserMultiSelect_1 = __webpack_require__(787);
exports.UserMultiSelect = UserMultiSelect_1.default;
var StepMultiSelect_1 = __webpack_require__(434);
exports.StepMultiSelect = StepMultiSelect_1.default;
var ProjectGroupMultiSelect_1 = __webpack_require__(1644);
exports.ProjectGroupMultiSelect = ProjectGroupMultiSelect_1.default;
var ChannelMultiSelect_1 = __webpack_require__(745);
exports.ChannelMultiSelect = ChannelMultiSelect_1.default;
var MachineModelHealthStatusMultiSelect_1 = __webpack_require__(1645);
exports.MachineModelHealthStatusMultiSelect = MachineModelHealthStatusMultiSelect_1.default;
var EndpointCommunicationStyleMultiSelect_1 = __webpack_require__(1646);
exports.EndpointCommunicationStyleMultiSelect = EndpointCommunicationStyleMultiSelect_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\index.ts"); } } })();

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Button_1 = __webpack_require__(51);
var OpenDialogConnect_1 = __webpack_require__(266);
var PermissionCheck_1 = __webpack_require__(45);
var Dialog_1 = __webpack_require__(121);
var dialogIdGenerator_1 = __webpack_require__(265);
var styles = __webpack_require__(349);
var OpenDialogButtonInternal = (function (_super) {
    __extends(OpenDialogButtonInternal, _super);
    function OpenDialogButtonInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.uniqueId = dialogIdGenerator_1.default.next();
        return _this;
    }
    OpenDialogButtonInternal.prototype.render = function () {
        var _this = this;
        var isOpen = this.props.openDialogs[this.uniqueId];
        var disabledDueToPermission = !!this.props.permission ? !PermissionCheck_1.isAllowed(this.props.permission) : false;
        return React.createElement("div", { className: styles.buttonDialogContainer },
            React.createElement(Button_1.ActionButton, { type: this.props.type, icon: this.props.icon, label: this.props.label, disabled: disabledDueToPermission || this.props.disabled, onClick: function () { return _this.props.openDialog(_this.uniqueId); } }),
            React.createElement(Dialog_1.default, { open: isOpen, wide: this.props.wideDialog }, this.props.children));
    };
    return OpenDialogButtonInternal;
}(React.Component));
var OpenDialogButton = OpenDialogConnect_1.OpenDialogConnect.to(OpenDialogButtonInternal);
exports.default = OpenDialogButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\OpenDialogButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\OpenDialogButton.tsx"); } } })();

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ParseHelper = (function () {
    function ParseHelper() {
    }
    // Numbers
    ParseHelper.safeParseInt = function (value, defaultValue) {
        if (defaultValue === void 0) { defaultValue = 0; }
        // so we don't display NaN
        var result = parseInt(value, 10);
        return isNaN(result) ? defaultValue : result;
    };
    // Comma Seperated Values
    ParseHelper.encodeCSV = function (val) {
        return val.join(",");
    };
    ParseHelper.parseCSV = function (val) {
        if (!val || val === "") {
            return [];
        }
        return val.split(",");
    };
    return ParseHelper;
}());
exports.default = ParseHelper;
function arrayValueFromQueryString(param, canBeCommaSeparated) {
    if (canBeCommaSeparated === void 0) { canBeCommaSeparated = false; }
    //URIjs in its infinite wisdom returns array if there are more than 1 parameter instance, or string if only one
    if (Array.isArray(param)) {
        return param;
    }
    if (typeof param === "string") {
        return canBeCommaSeparated ?
            param.split(",") :
            [param];
    }
    return [];
}
exports.arrayValueFromQueryString = arrayValueFromQueryString;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ParseHelper\\ParseHelper.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ParseHelper\\ParseHelper.tsx"); } } })();

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.normal = 400;
exports.light = 300;
exports.semibold = 500;
exports.bold = 600;
exports.baseSizeInPx = 16;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\fontWeights.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\fontWeights.ts"); } } })();

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// These class names are all used by UI E2E tests to identify certain parts of the page.
// They same values are used in the UI E2E tests project in the "Selectors" class.
// So if you change something here, you will probably need to change it in that file as well, and then update the tests
exports.tagSetClass = "tag-set";
exports.deploymentPartNameClass = "deployment-part-name";
exports.packageRowClass = "package-row";
exports.releaseVersionClass = "release-version";
exports.stepCardClass = "add-step-card";
exports.dialogClass = "octopus-dialog";
exports.busyIndicatorClass = "busy-indicator";
exports.octopusErrorClass = "octopus-error";
exports.formSectionClass = "form-section-container";
exports.formSectionTitleClass = "form-section-title";
exports.formSectionBodyClass = "form-section-body";
exports.overflowMenuClass = "overflow-menu";
exports.navLinksClass = "secondary-navigation";
exports.linkMenuClassName = "links-menu-popover";
exports.tagClass = "tag-set-tag";


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\uiTestClasses.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\uiTestClasses.ts"); } } })();

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var ErrorBoundary_1 = __webpack_require__(1134);
var ReloadableRoute = (function (_super) {
    __extends(ReloadableRoute, _super);
    function ReloadableRoute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accumulate = function (acc, paramName, params) {
            return acc ? acc + "/" + params[paramName] : params[paramName];
        };
        return _this;
    }
    ReloadableRoute.prototype.render = function () {
        // We are tagging the parent route of each component with a key made out of params it depends on so redirects to the same component with different
        // params unmount it and mount it again.
        // This can also be done by responding to changes in props but this is a lot of work to do it correctly and it is very easy to forget about it.
        // Details: https://github.com/ReactTraining/react-router/issues/1982
        var key = this.getComponentKey(this.props.computedMatch);
        return React.createElement(ErrorBoundary_1.default, null,
            React.createElement(react_router_dom_1.Route, __assign({}, this.props, { key: key })));
    };
    ReloadableRoute.prototype.getComponentKey = function (match) {
        var _this = this;
        var params = match && match.params;
        return params ? Object.keys(params).reduce(function (acc, paramName) { return _this.accumulate(acc, paramName, params); }, null) : null;
    };
    return ReloadableRoute;
}(React.Component));
exports.default = ReloadableRoute;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ReloadableRoute\\ReloadableRoute.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ReloadableRoute\\ReloadableRoute.tsx"); } } })();

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Callout_1 = __webpack_require__(59);
exports.Callout = Callout_1.Callout;
exports.CalloutType = Callout_1.CalloutType;
exports.default = Callout_1.Callout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Callout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Callout\\index.tsx"); } } })();

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(16);
var Text_1 = __webpack_require__(17);
var IconButton_1 = __webpack_require__(56);
var IconButtonList_1 = __webpack_require__(109);
var InputWithActions_1 = __webpack_require__(145);
var BoundField_1 = __webpack_require__(95);
exports.ObfuscatedPlaceholder = "******";
function createInitialSensitiveState(originalValue) {
    var value = originalValue || {
        HasValue: false,
    };
    return {
        valueBeforeEditing: null,
        isEditing: !value.HasValue,
        isHidden: true,
        originalValue: lodash_1.cloneDeep(value)
    };
}
exports.createInitialSensitiveState = createInitialSensitiveState;
var StatefulSensitive = (function (_super) {
    __extends(StatefulSensitive, _super);
    function StatefulSensitive(props) {
        var _this = _super.call(this, props) || this;
        _this.state = createInitialSensitiveState(props.value);
        return _this;
    }
    StatefulSensitive.prototype.render = function () {
        var _this = this;
        return React.createElement(StatelessSensitive, __assign({ onStateChanged: function (state) { return _this.setState(state); } }, this.props, this.state));
    };
    return StatefulSensitive;
}(React.Component));
var StatelessSensitive = (function (_super) {
    __extends(StatelessSensitive, _super);
    function StatelessSensitive() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textField = null;
        _this.handleChange = function (value) {
            _this.props.onChange({
                HasValue: true,
                NewValue: value,
            });
        };
        _this.currentValue = function () {
            return _this.props.value || {
                HasValue: false,
            };
        };
        _this.enterEditMode = function () {
            var valueBeforeEditing = lodash_1.cloneDeep(_this.currentValue());
            _this.onStateChanged({ isEditing: true, valueBeforeEditing: valueBeforeEditing });
            _this.props.onChange({
                HasValue: valueBeforeEditing.HasValue,
                NewValue: ""
            });
        };
        _this.handleRemove = function (e) {
            var originalValue = {
                HasValue: false,
                NewValue: null
            };
            _this.onStateChanged({ isEditing: false, originalValue: originalValue });
            _this.props.onChange(originalValue);
        };
        _this.handleCancel = function (e) {
            _this.onStateChanged({ isEditing: false });
            _this.props.onChange(_this.props.valueBeforeEditing);
        };
        _this.toggleVisibility = function () {
            _this.onStateChanged({ isHidden: !_this.props.isHidden });
        };
        return _this;
    }
    StatelessSensitive.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isEditing && !prevProps.isEditing) {
            this.textField.focus();
        }
    };
    StatelessSensitive.prototype.select = function () {
        if (this.props.isEditing) {
            if (this.textField && !this.textField.isFocused()) {
                this.textField.select();
            }
        }
        else {
            if (this.changeButton) {
                this.changeButton.button.button.focus();
            }
        }
    };
    StatelessSensitive.prototype.render = function () {
        var _this = this;
        var currentValue = this.currentValue();
        var _a = this.props, onChange = _a.onChange, value = _a.value, valueBeforeEditing = _a.valueBeforeEditing, removeTabIndex = _a.removeTabIndex, changeSetTabIndex = _a.changeSetTabIndex, showHideTabIndex = _a.showHideTabIndex, cancelTabIndex = _a.cancelTabIndex, canRemove = _a.canRemove, originalValue = _a.originalValue, isEditing = _a.isEditing, isHidden = _a.isHidden, hintText = _a.hintText, onStateChanged = _a.onStateChanged, applyMaxWidth = _a.applyMaxWidth, otherProps = __rest(_a, ["onChange", "value", "valueBeforeEditing", "removeTabIndex", "changeSetTabIndex", "showHideTabIndex", "cancelTabIndex", "canRemove", "originalValue", "isEditing", "isHidden", "hintText", "onStateChanged", "applyMaxWidth"]);
        // isEditing is used when you don't originally have a value, otherwise its value is meaningless
        // The reason we don't use this all the time is because we don't necessarily want the field to focus
        // when isEditingDerived becomes true, for example, after you have deleted the value
        var isEditingDerived = isEditing || !originalValue.HasValue;
        var hintTextDerived = currentValue.HasValue && !isEditingDerived ? exports.ObfuscatedPlaceholder : hintText ? hintText : "";
        var newValue = currentValue.NewValue ? currentValue.NewValue : "";
        var displayValue = newValue;
        var inputStyle = applyMaxWidth ? { maxWidth: "26.5rem" } : {};
        return (React.createElement(InputWithActions_1.default, { input: React.createElement(Text_1.default, __assign({ disabled: !isEditingDerived, type: isHidden ? "password" : "text", hintText: hintTextDerived, value: displayValue, onChange: this.handleChange, applyMaxWidth: applyMaxWidth, underlineShow: this.props.underlineShow, textInputRef: function (textField) { return _this.textField = textField; } }, otherProps)), actions: React.createElement(IconButtonList_1.default, { buttons: this.buttons(isEditingDerived, currentValue) }), applyMaxWidth: applyMaxWidth }));
    };
    StatelessSensitive.prototype.onStateChanged = function (newState) {
        var previousState = {
            valueBeforeEditing: this.props.valueBeforeEditing,
            originalValue: this.props.originalValue,
            isEditing: this.props.isEditing,
            isHidden: this.props.isHidden
        };
        this.props.onStateChanged(__assign({}, previousState, newState));
    };
    StatelessSensitive.prototype.buttons = function (isEditing, currentValue) {
        var _this = this;
        var buttons = new Array();
        buttons.push(isEditing && currentValue.NewValue &&
            React.createElement(IconButton_1.default, { toolTipContent: this.props.isHidden ? "Show" : "Hide", icon: this.props.isHidden ? IconButton_1.Icon.Show : IconButton_1.Icon.Hide, tabIndex: this.props.showHideTabIndex, onClick: this.toggleVisibility }));
        buttons.push(!isEditing && this.props.originalValue.HasValue &&
            React.createElement(IconButton_1.default, { toolTipContent: currentValue.HasValue ? "Change" : "Set", buttonRef: function (changeButton) { return _this.changeButton = changeButton; }, onClick: this.enterEditMode, tabIndex: this.props.changeSetTabIndex, icon: IconButton_1.Icon.Edit }));
        buttons.push(!isEditing && currentValue.HasValue && this.props.canRemove &&
            React.createElement(IconButton_1.default, { toolTipContent: "Remove", onClick: this.handleRemove, tabIndex: this.props.removeTabIndex, icon: IconButton_1.Icon.Remove }));
        buttons.push(isEditing && this.props.originalValue.HasValue &&
            React.createElement(IconButton_1.default, { toolTipContent: "Cancel", onClick: this.handleCancel, tabIndex: this.props.cancelTabIndex, icon: IconButton_1.Icon.Cancel }));
        return buttons.filter(function (b) { return !!b; });
    };
    StatelessSensitive.defaultProps = {
        autoFocus: false,
        canRemove: true,
        applyMaxWidth: false,
    };
    return StatelessSensitive;
}(React.Component));
exports.StatelessSensitive = StatelessSensitive;
var Sensitive = StatefulSensitive;
exports.default = Sensitive;
exports.BoundSensitive = BoundField_1.withBoundField(StatefulSensitive);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sensitive\\Sensitive.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sensitive\\Sensitive.tsx"); } } })();

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1135);
var Button_1 = __webpack_require__(51);
var smoothscroll_1 = __webpack_require__(1213);
var ExternalLink_1 = __webpack_require__(29);
var Note_1 = __webpack_require__(22);
var uiTestClasses_1 = __webpack_require__(77);
var Button_2 = __webpack_require__(51);
var clientInstance_1 = __webpack_require__(10);
var ErrorPanel = (function (_super) {
    __extends(ErrorPanel, _super);
    function ErrorPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = ({
            showFullException: false,
        });
        return _this;
    }
    ErrorPanel.prototype.componentDidMount = function () {
        if (this.props.scrollToPanel) {
            smoothscroll_1.default.scrollTo(this.panel);
        }
    };
    ErrorPanel.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { ref: function (ref) { return _this.panel = ref; }, className: styles.error, style: {
                display: this.props.fullWidth ? "block" : "inline-block",
                width: this.props.fullWidth ? "100%" : "auto"
            } },
            React.createElement("div", { className: styles.titleContainer },
                React.createElement("span", { className: styles.title }, this.props.message),
                React.createElement("div", null, this.props.canClose && React.createElement(Button_1.CloseButton, { size: "1.5rem", onClose: this.props.onErrorClose }))),
            this.props.details && this.props.details.length > 0 &&
                React.createElement("ul", null, this.props.details.map(function (e, index) { return _this.detailFor(e, index); })),
            this.props.helpText && React.createElement(Note_1.default, null, this.props.helpText),
            this.props.helpLink && React.createElement(ExternalLink_1.default, { href: this.props.helpLink }, "More information..."),
            this.props.fullException &&
                React.createElement("div", null,
                    React.createElement(Button_2.ActionButton, { type: Button_2.ActionButtonType.Ternary, label: this.state.showFullException ? "hide full exception" : "show full exception", onClick: function () { return _this.setState({ showFullException: !_this.state.showFullException }); } }),
                    this.state.showFullException &&
                        React.createElement("pre", null,
                            "Octopus v",
                            clientInstance_1.client.version,
                            React.createElement("br", null),
                            React.createElement("br", null),
                            this.props.fullException)));
    };
    ErrorPanel.prototype.detailFor = function (error, index) {
        var detailLinks = this.props.detailLinks;
        var detailLink = detailLinks && detailLinks.length > index && detailLinks[index];
        return React.createElement("li", { key: index, className: uiTestClasses_1.octopusErrorClass },
            error,
            detailLink && React.createElement("div", { className: styles.detailLink },
                React.createElement(ExternalLink_1.default, { href: detailLink }, "More information...")));
    };
    ErrorPanel.defaultProps = {
        fullWidth: true,
        scrollToPanel: true
    };
    return ErrorPanel;
}(React.Component));
exports.default = ErrorPanel;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ErrorPanel\\ErrorPanel.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ErrorPanel\\ErrorPanel.tsx"); } } })();

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isBound = function (value, fallback) {
    if (fallback === void 0) { fallback = true; }
    if (value) {
        return value.includes("#{");
    }
    return fallback;
};
exports.default = isBound;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\BoundField\\isBound.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\BoundField\\isBound.ts"); } } })();

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1680);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1657);
var SectionHeadingType;
(function (SectionHeadingType) {
    SectionHeadingType[SectionHeadingType["Heading1"] = 0] = "Heading1";
    SectionHeadingType[SectionHeadingType["Heading2"] = 1] = "Heading2";
    SectionHeadingType[SectionHeadingType["Heading3"] = 2] = "Heading3";
    SectionHeadingType[SectionHeadingType["Heading4"] = 3] = "Heading4";
})(SectionHeadingType = exports.SectionHeadingType || (exports.SectionHeadingType = {}));
var Section = (function (_super) {
    __extends(Section, _super);
    function Section() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Section.prototype.render = function () {
        return (React.createElement("section", { className: cn(this.props.className, this.props.sectionHeader ? styles.section : styles.sectionNoHeader) },
            this.renderSectionHeading(),
            React.createElement("div", { className: cn(styles.sectionBody, this.props.bodyClassName) }, this.props.children)));
    };
    Section.prototype.renderSectionHeading = function () {
        if (!this.props.sectionHeader) {
            return null;
        }
        switch (this.props.headingType) {
            case SectionHeadingType.Heading1:
                return React.createElement("h1", { className: styles.sectionHeader }, this.props.sectionHeader);
            case SectionHeadingType.Heading2:
                return React.createElement("h2", { className: styles.sectionHeader }, this.props.sectionHeader);
            case SectionHeadingType.Heading3:
                return React.createElement("h3", { className: styles.sectionHeader }, this.props.sectionHeader);
            default:
                return React.createElement("h4", { className: styles.sectionHeader }, this.props.sectionHeader);
        }
    };
    return Section;
}(React.Component));
exports.Section = Section;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Section\\Section.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Section\\Section.tsx"); } } })();

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExternalLink_1 = __webpack_require__(29);
exports.default = ExternalLink_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\ExternalLink\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\ExternalLink\\index.tsx"); } } })();

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var isBound_1 = __webpack_require__(84);
var Text_1 = __webpack_require__(17);
var Text_2 = __webpack_require__(17);
var IconButton_1 = __webpack_require__(56);
var lodash_1 = __webpack_require__(16);
var React = __webpack_require__(0);
var styles = __webpack_require__(1587);
var bindIcon = __webpack_require__(1589);
var unbindIcon = __webpack_require__(1590);
// This is a placeholder until we can implement BoundField to match the new designs
exports.withBoundField = function (Comp) {
    return _a = (function (_super) {
            __extends(class_1, _super);
            function class_1(props) {
                var _this = _super.call(this, props) || this;
                // I really want to type the index signature below, but Typescript has broken support for enums in indexers.
                // I could use [index in ControlType] but that means all enum values need to be present, not just a subset.
                _this.parameterUnboundValueRanges = {
                    Checkbox: function (param, value) {
                        if (!value) {
                            return false;
                        }
                        var lower = value.toLowerCase();
                        return lower === "true" || lower === "false";
                    },
                    Select: function (param, value) {
                        var selectOptions = param["Octopus.SelectOptions"];
                        var allOptions = selectOptions ? param["Octopus.SelectOptions"].split("\n") : [];
                        return allOptions.map(function (option) { return option.split("|")[0]; }).indexOf(value) >= 0;
                    },
                    Sensitive: function (param, value) {
                        return typeof value === "undefined" || typeof value === "object";
                    }
                };
                _this.bindUnbind = function () {
                    // this is debounced as we are getting two clicks when hitting enter to
                    // activate the button and can't get to the bottom of it
                    if (_this.getIsBound()) {
                        _this.unbind();
                    }
                    else {
                        _this.bind();
                    }
                };
                _this.bind = function () {
                    var value = _this.props.value || "";
                    if (typeof (value) !== "string") {
                        _this.props.onChange("");
                    }
                    _this.setState({ isBound: true });
                    if (_this.props.onIsBoundChanged) {
                        _this.props.onIsBoundChanged(true);
                    }
                };
                _this.unbind = function () {
                    _this.setState({ isBound: false });
                    if (_this.props.onIsBoundChanged) {
                        _this.props.onIsBoundChanged(false);
                    }
                    var resetValue = _this.props.resetValue;
                    var valueResource = (typeof resetValue === "function") ? resetValue() : resetValue;
                    _this.props.onChange(valueResource);
                };
                _this.bindUnbind = lodash_1.debounce(_this.bindUnbind, 500);
                var shouldBind = _this.shouldBind(props.value, props.parameter);
                _this.state = { isBound: shouldBind };
                if (shouldBind && _this.props.onIsBoundChanged) {
                    _this.props.onIsBoundChanged(true);
                }
                return _this;
            }
            class_1.prototype.render = function () {
                var component = this.getIsBound()
                    ? this.props.variableLookup
                        ? React.createElement(Text_2.VariableLookupText, { syntax: this.props.variableLookup.syntax, projectId: this.props.variableLookup.projectId, localNames: this.props.variableLookup.localNames, label: this.props.label, value: this.props.value, onChange: this.props.onChange, multiLine: true, rows: 5, rowsMax: 5 })
                        : React.createElement(Text_1.default, { label: this.props.label, value: this.props.value, onChange: this.props.onChange, multiLine: true, rows: 5, rowsMax: 5 })
                    : React.createElement(Comp, __assign({}, this.getWrappedComponentProps()));
                return React.createElement("div", { className: styles.container },
                    component,
                    React.createElement("div", { className: styles.buttons }, this.binding()));
            };
            class_1.prototype.getWrappedComponentProps = function () {
                var _a = this.props, resetValue = _a.resetValue, parameter = _a.parameter, hideBindButton = _a.hideBindButton, desIsBound = _a.isBound, onIsBoundChanged = _a.onIsBoundChanged, variableLookup = _a.variableLookup, otherProps = __rest(_a, ["resetValue", "parameter", "hideBindButton", "isBound", "onIsBoundChanged", "variableLookup"]); // `as any` because object rest not support in generics yet, tracked by https://github.com/Microsoft/TypeScript/issues/10727
                return otherProps;
            };
            class_1.prototype.getIsBound = function () {
                return this.props.isBound || this.state.isBound;
            };
            class_1.prototype.binding = function () {
                if (this.props.hideBindButton) {
                    return null;
                }
                var text = this.getIsBound()
                    ? "Unbind"
                    : "Bind";
                var icon = this.getIsBound()
                    ? unbindIcon
                    : bindIcon;
                return React.createElement(IconButton_1.default, { onClick: this.bindUnbind, toolTipContent: text, icon: icon });
            };
            // TODO: This needs the <Clear/> unbind icon set up properly so it switches from code icon to clear icon.
            // The clear icons is used on fields to remove or reset so this felt consistent.
            class_1.prototype.shouldBind = function (value, parameter) {
                if (value && typeof (value) === "string") {
                    if (isBound_1.default(value)) {
                        return true;
                    }
                    if (parameter) {
                        var displaySettings = parameter.DisplaySettings;
                        var controlType = displaySettings["Octopus.ControlType"];
                        var isInRange = this.parameterUnboundValueRanges[controlType];
                        if (isInRange) {
                            if (!isInRange(displaySettings, value)) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            };
            class_1.prototype.boundText = function () {
                if (this.getIsBound()) {
                    return "Remove custom bindings from this field";
                }
                return "Apply custom bindings to this field";
            };
            return class_1;
        }(React.Component)),
        _a.defaultProps = {
            hideBindButton: false
        },
        _a;
    var _a;
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\BoundField\\BoundField.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\BoundField\\BoundField.tsx"); } } })();

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var LinearProgress_1 = __webpack_require__(437);
var CircularProgress_1 = __webpack_require__(542);
var colors_1 = __webpack_require__(32);
var styles = __webpack_require__(1203);
var uiTestClasses_1 = __webpack_require__(77);
var BusyIndicator = function (props) {
    if (props.inline) {
        return props.show &&
            React.createElement("span", { className: uiTestClasses_1.busyIndicatorClass + " " + styles.circularBusyIndicator },
                React.createElement(CircularProgress_1.default, { mode: "indeterminate", color: colors_1.primaryLight, size: 22, thickness: 2 }));
    }
    else {
        return props.show
            ? React.createElement("div", { className: uiTestClasses_1.busyIndicatorClass + " " + styles.busyIndicator },
                React.createElement(LinearProgress_1.default, { mode: "indeterminate", color: colors_1.primaryLight }))
            : React.createElement("div", { className: styles.busyIndicatorHiddenSpacer });
    }
};
BusyIndicator.displayName = "BusyIndicator";
exports.default = BusyIndicator;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BusyIndicator\\BusyIndicator.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BusyIndicator\\BusyIndicator.tsx"); } } })();

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Logger = (function () {
    function Logger() {
    }
    Logger.consoleWrapper = function (name) {
        if (window && window.console && window.console[name]) {
            var console_1 = window.console;
            if (console_1[name].apply) {
                /* tslint:disable */ return function () {
                    console_1[name].apply(console_1, arguments);
                };
            }
            else {
                /* tslint:disable */ return function () {
                    var message = Array.prototype.join.call(arguments, ', ');
                    console_1[name](message);
                };
            }
        }
        else {
            return function () { };
        }
    };
    Logger.log = Logger.consoleWrapper('log');
    Logger.info = Logger.consoleWrapper('info');
    Logger.warn = Logger.consoleWrapper('warn');
    Logger.error = Logger.consoleWrapper('error');
    return Logger;
}());
;
exports.default = Logger;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\logger.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\logger.ts"); } } })();

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LookupReferenceDataItemChip_1 = __webpack_require__(766);
exports.default = LookupReferenceDataItemChip_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LookupReferenceDataItemChip\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LookupReferenceDataItemChip\\index.tsx"); } } })();

/***/ }),
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ActionButton_1 = __webpack_require__(50);
var DialogLayout_1 = __webpack_require__(141);
var DialogLayoutConnect_1 = __webpack_require__(296);
var PermissionCheck_1 = __webpack_require__(45);
var FormComponent_1 = __webpack_require__(267);
var styles = __webpack_require__(244);
var SaveDialogLayoutInternal = (function (_super) {
    __extends(SaveDialogLayoutInternal, _super);
    function SaveDialogLayoutInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.onSaveClick()];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.props.close();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.submitForm = function () {
            if (!_this.isSaveButtonDisabled()) {
                _this.saveClick();
            }
        };
        return _this;
    }
    SaveDialogLayoutInternal.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, other = __rest(_a, ["children"]);
        var save = this.props.hideSave ? null : React.createElement(ActionButton_1.ActionButton, { key: "Save", type: ActionButton_1.ActionButtonType.Save, label: this.props.saveButtonLabel || "Save", busyLabel: this.props.busyButtonLabel || "Saving...", onClick: this.saveClick, disabled: this.isSaveButtonDisabled() });
        var cancel = React.createElement(ActionButton_1.ActionButton, { key: "Cancel", label: this.props.cancelButtonLabel || "Cancel", disabled: this.props.busy, onClick: function () { return _this.props.close(); } });
        return React.createElement(DialogLayout_1.DialogLayout, __assign({ actions: [cancel, save] }, other, { closeDialog: this.props.close }),
            React.createElement(FormComponent_1.default, { onFormSubmit: this.submitForm, className: styles.dialogWrapper }, children));
    };
    SaveDialogLayoutInternal.prototype.isSaveButtonDisabled = function () {
        var disabledDueToPermission = !!this.props.savePermission ? !PermissionCheck_1.isAllowed(this.props.savePermission) : false;
        return !!(this.props.saveButtonDisabled || disabledDueToPermission || this.props.busy);
    };
    SaveDialogLayoutInternal.defaultProps = {
        hideSave: false
    };
    return SaveDialogLayoutInternal;
}(React.Component));
var SaveDialogLayout = DialogLayoutConnect_1.DialogLayoutConnect.to(SaveDialogLayoutInternal);
SaveDialogLayout.displayName = "SaveDialogLayout";
exports.default = SaveDialogLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DialogLayout\\SaveDialogLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DialogLayout\\SaveDialogLayout.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ActionButton_1 = __webpack_require__(50);
var DialogLayout_1 = __webpack_require__(141);
var DialogLayoutConnect_1 = __webpack_require__(296);
var PermissionCheck_1 = __webpack_require__(45);
var FormComponent_1 = __webpack_require__(267);
var styles = __webpack_require__(244);
var OkDialogLayoutInternal = (function (_super) {
    __extends(OkDialogLayoutInternal, _super);
    function OkDialogLayoutInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.okClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.onOkClick()];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.props.close();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.submitForm = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.isDisabled()) {
                    this.okClick();
                }
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    OkDialogLayoutInternal.prototype.isDisabled = function () {
        return this.props.okButtonDisabled || this.props.busy;
    };
    OkDialogLayoutInternal.prototype.render = function () {
        var _this = this;
        var hasPermissionForOk = !!this.props.okButtonPermission ? PermissionCheck_1.isAllowed(this.props.okButtonPermission) : true;
        var _a = this.props, children = _a.children, other = __rest(_a, ["children"]);
        var ok = React.createElement(ActionButton_1.ActionButton, { key: "Ok", label: this.props.okButtonLabel || "Ok", disabled: this.isDisabled(), onClick: this.okClick, type: ActionButton_1.ActionButtonType.Primary });
        var cancel = React.createElement(ActionButton_1.ActionButton, { key: "Cancel", label: this.props.cancelButtonLabel || "Cancel", disabled: this.props.busy, onClick: function () { return _this.props.close(); } });
        var actions = [!this.props.hideCancel && cancel, hasPermissionForOk && ok].filter(function (a) { return !!a; });
        return React.createElement(DialogLayout_1.DialogLayout, __assign({ actions: actions, closeDialog: this.props.close }, other),
            React.createElement(FormComponent_1.default, { onFormSubmit: this.submitForm, className: styles.dialogWrapper }, children));
    };
    return OkDialogLayoutInternal;
}(React.Component));
var OkDialogLayout = DialogLayoutConnect_1.DialogLayoutConnect.to(OkDialogLayoutInternal);
OkDialogLayout.displayName = "OkDialogLayout";
exports.default = OkDialogLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DialogLayout\\OkDialogLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DialogLayout\\OkDialogLayout.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ToolTip_1 = __webpack_require__(68);
var Markdown_1 = __webpack_require__(136);
var DebounceValue_1 = __webpack_require__(1635);
var IconButton_1 = __webpack_require__(1636);
var Popover_1 = __webpack_require__(220);
var IconButton_2 = __webpack_require__(56);
var Text_1 = __webpack_require__(17);
var VirtualListWithKeyboard_1 = __webpack_require__(669);
var styles = __webpack_require__(1639);
var LabelStrategy_1 = __webpack_require__(174);
var DebounceText = DebounceValue_1.default(Text_1.default);
function MultiSelect() {
    var VirtualList = VirtualListWithKeyboard_1.default();
    var MultiSelectInternal = (function (_super) {
        __extends(MultiSelectInternal, _super);
        function MultiSelectInternal(props) {
            var _this = _super.call(this, props) || this;
            _this.skipOpenningOnNextFocus = false;
            _this.onTextBlur = function () {
                // We using a timout here to stop the flickering, see https://medium.com/@jessebeach/dealing-with-focus-and-blur-in-a-composite-widget-in-react-90d3c3b49a9b
                _this.timeoutId = setTimeout(function () {
                    if (_this.state.isFocused) {
                        _this.setState({
                            isFocused: false
                        });
                    }
                }, 0);
            };
            _this.onTextFocus = function () {
                clearTimeout(_this.timeoutId);
                if (!_this.state.isFocused) {
                    _this.setState({ isFocused: true });
                }
                if (!_this.skipOpenningOnNextFocus) {
                    _this.setState({
                        open: _this.props.openOnFocus !== undefined ? _this.props.openOnFocus : true
                    });
                }
                _this.skipOpenningOnNextFocus = false;
            };
            _this.focusText = function (skipOpenningOnNextFocus) {
                _this.skipOpenningOnNextFocus = skipOpenningOnNextFocus;
                if (_this.textField) {
                    _this.textField.focus();
                }
            };
            _this.onTextKeyDown = function (event, filteredList) {
                if (event.key === "ArrowDown") {
                    _this.setState({
                        open: true
                    });
                    if (_this.state.open) {
                        _this.virtualList.focus();
                    }
                    event.preventDefault();
                }
                if (event.key === "Tab") {
                    _this.onRequestClose();
                }
            };
            _this.onKeyEsc = function (event) {
                if (event.key === "Escape") {
                    _this.onRequestClose(function () { return _this.focusText(true); });
                }
            };
            _this.onSearchTextChange = function (val) {
                _this.setState({
                    open: true,
                    filter: val
                });
            };
            _this.onToggle = function () {
                _this.setState(function (prevState) { return ({
                    open: !prevState.open
                }); });
            };
            _this.onRequestClose = function (callback) {
                _this.setState({
                    filter: "",
                    open: false
                }, callback);
            };
            _this.renderChip = function (id, index) {
                var item = _this.props.items && _this.props.items.find(function (i) { return i.Id === id; });
                var element = _this.props.renderChip(item || { Id: id, Name: id }, function (event) {
                    _this.props.onChange(_this.props.value && _this.props.value.filter(function (i) { return i !== id; }));
                });
                if (!React.isValidElement(element)) {
                    return null;
                }
                return React.createElement("span", { key: id }, element);
            };
            _this.state = {
                filter: "",
                open: false,
                isFocused: false,
            };
            return _this;
        }
        MultiSelectInternal.prototype.focus = function () {
            this.focusText();
        };
        MultiSelectInternal.prototype.componentDidMount = function () {
            this.props.multiSelectRef(this);
        };
        MultiSelectInternal.prototype.componentWillUnmount = function () {
            this.props.multiSelectRef(null);
        };
        MultiSelectInternal.prototype.componentWillMount = function () {
            var uniqueId = "MultiSelect-" + Math.floor(Math.random() * 0xFFFF);
            this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, "");
        };
        MultiSelectInternal.prototype.render = function () {
            var _this = this;
            var errorTextElement = this.props.error && (React.createElement("div", { className: styles.error }, this.props.error));
            // TODO: Replace with better null checking solution, discuss with team how to handle this situation.
            var value = this.props.value ? this.props.value : [];
            var items = this.props.items ? this.props.items : [];
            var hasInput = value.length > 0 || this.state.filter.length > 0;
            var showFloatingLabel = hasInput || this.state.isFocused;
            var floatingLabelTextElement = this.props.label && (React.createElement("label", { className: styles.label, style: !showFloatingLabel ? { visibility: "hidden" } : {}, htmlFor: this.uniqueId },
                this.props.description && React.createElement(ToolTip_1.default, { content: React.createElement(Markdown_1.default, { markup: this.props.description }) }, this.props.label),
                !this.props.description && this.props.label));
            var filteredList = this.filteredList(items, value, this.state.filter);
            var newItem = null;
            if (this.state.filter.length > 0 && this.props.onNew) {
                // TODO: The case insensitive comparison here is specific to roles
                // (which is the only use of `newItem` at the moment) and probably shouldn't be hard-coded here.
                // Either toggle this behavior from a prop, or extract it from this component entirely
                var val_1 = this.state.filter.toLowerCase();
                if (items.find(function (i) { return i.Name.toLowerCase() === val_1; }) === undefined &&
                    !value.find(function (i) { return i && (i.toLowerCase() === val_1); })) {
                    newItem = { Id: "", Name: this.state.filter };
                }
            }
            if (newItem) {
                filteredList.unshift(newItem);
            }
            return React.createElement("div", null,
                floatingLabelTextElement,
                React.createElement("div", null, value.map(this.renderChip)),
                React.createElement("div", { ref: function (el) { return _this.textAnchor = el; }, className: styles.textContainer },
                    React.createElement(DebounceText, { id: this.uniqueId, textInputRef: function (textField) { return _this.textField = textField; }, hintText: this.props.label, value: this.state.filter, autoFocus: this.props.autoFocus, onKeyDown: function (e) { return _this.onTextKeyDown(e, filteredList); }, onChange: this.onSearchTextChange, onFocus: this.onTextFocus, onBlur: this.onTextBlur, onClick: function () { return _this.setState({ open: true }); } }),
                    React.createElement("div", { className: styles.iconContainer },
                        React.createElement(IconButton_1.default, { icon: IconButton_2.Icon.ArrowDown, onClick: this.onToggle, tabIndex: -1 }))),
                errorTextElement,
                React.createElement(Popover_1.default, { open: this.state.open, useLayerForClickAway: true, anchorEl: this.textAnchor, onRequestClose: function () { return _this.onRequestClose(); }, anchorOrigin: { horizontal: "left", vertical: "bottom" }, targetOrigin: { horizontal: "left", vertical: "top" } },
                    React.createElement("div", { style: { minWidth: this.textAnchor ? this.textAnchor.offsetWidth + "px" : undefined }, onKeyDown: this.onKeyEsc },
                        React.createElement(VirtualList, { multiSelectRef: function (el) { return _this.virtualList = el; }, items: filteredList, onSelected: function (id) {
                                _this.onRequestClose(function () { return _this.focusText(true); });
                                if (items.find(function (i) { return i.Id === id; })) {
                                    _this.props.onChange(value.concat(id));
                                }
                                else {
                                    _this.props.onNew(newItem.Name);
                                }
                            }, onResized: function () {
                                // When the content's size changes, we re-render so that the
                                // popover can re-position itself based on the new `VirtualList` size
                                _this.forceUpdate();
                            }, renderItem: this.props.renderItem, addNewTemplate: function () { return _this.props.addNewTemplate(newItem.Name); }, onBlur: function () { return _this.textField.focus(); } }))));
        };
        MultiSelectInternal.prototype.filteredList = function (items, value, filter) {
            var results = items.slice(); //clone array
            if (filter.length > 0) {
                var search_1 = filter.toLowerCase();
                results = items.filter(function (i) { return i.Name.toLowerCase().includes(search_1); });
            }
            results = results.filter(function (i) { return !value.includes(i.Id); }); // filter out existing selected items
            return results;
        };
        MultiSelectInternal.defaultProps = {
            addNewTemplate: function (text) { return text + " (add new)"; },
            multiSelectRef: function (multiSelect) { },
            renderItem: function (item) { return ({ primaryText: item.Name }); },
            items: [],
            value: [],
        };
        return MultiSelectInternal;
    }(React.Component));
    return LabelStrategy_1.default(MultiSelectInternal, function (fieldName) { return "Select " + fieldName; });
}
exports.default = MultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\MultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\MultiSelect.tsx"); } } })();

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1598);
var IconButtonList = function (props) {
    return React.createElement("div", { className: styles.buttonList }, props.buttons.map(function (button, index) { return !button ? null : React.cloneElement(button, __assign({}, button.props, { key: index })); }));
};
IconButtonList.displayName = "IconButtonList";
exports.default = IconButtonList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\IconButtonList\\IconButtonList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\IconButtonList\\IconButtonList.tsx"); } } })();

/***/ }),
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ConfigurationRepository = (function () {
    function ConfigurationRepository(configurationLinkName, client) {
        this.configurationLinkName = configurationLinkName;
        this.client = client;
    }
    ConfigurationRepository.prototype.get = function () {
        return this.client.get(this.client.getRootDocument().Links[this.configurationLinkName]);
    };
    ConfigurationRepository.prototype.modify = function (resource) {
        return this.client.update(resource.Links["Self"], resource);
    };
    return ConfigurationRepository;
}());
exports.default = ConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\configurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\configurationRepository.ts"); } } })();

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1601);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var BusyFromPromise_1 = __webpack_require__(176);
var BusyIndicator_1 = __webpack_require__(98);
var SectionTitle_1 = __webpack_require__(1470);
var ErrorPanel_1 = __webpack_require__(83);
var styles = __webpack_require__(1475);
var Sticky_1 = __webpack_require__(440);
var PageTitleHelper_1 = __webpack_require__(221);
exports.headerId = "paperlayoutstickyheader";
var PaperLayout = (function (_super) {
    __extends(PaperLayout, _super);
    function PaperLayout(props) {
        var _this = _super.call(this, props) || this;
        PageTitleHelper_1.default.setPageTitle(props.title, props.breadcrumbTitle);
        _this.state = {
            stickyState: 0
        };
        return _this;
    }
    PaperLayout.prototype.componentWillReceiveProps = function (nextProps) {
        // For various screen, we update the title dynamically...
        if (this.props.title !== nextProps.title) {
            PageTitleHelper_1.default.setPageTitle(nextProps.title, nextProps.breadcrumbTitle);
        }
    };
    PaperLayout.prototype.renderHeader = function () {
        var _this = this;
        if (this.props.title || this.props.sectionControl) {
            return React.createElement(Sticky_1.default, { top: "#toppanel", innerZ: 10, onStateChange: function (x) { return _this.setState({ stickyState: x.status }); } },
                React.createElement("div", { id: exports.headerId, className: styles.headerContainer },
                    this.renderBusy(),
                    React.createElement(SectionTitle_1.default, { title: this.props.title, titleLogo: this.props.titleLogo, breadcrumbTitle: this.props.breadcrumbTitle, breadcrumbPath: this.props.breadcrumbPath, sectionControl: this.props.sectionControl, className: cn(styles.title, (_a = {}, _a[styles.stickied] = this.state.stickyState === Sticky_1.StickyStatus.STATUS_FIXED, _a)), busy: this.props.busy, enableLessIntrusiveLoadingIndicator: this.props.enableLessIntrusiveLoadingIndicator })));
        }
        return this.renderBusy();
        var _a;
    };
    PaperLayout.prototype.renderBusy = function () {
        var _this = this;
        // Note: Don't show the horizontal loading bar on subsequent auto-reloads (it "blips" too quickly and annoys everybody).
        return React.createElement("div", { className: styles.busyFromPromise },
            React.createElement(BusyFromPromise_1.default, { promise: this.props.busy }, function (busy) { return React.createElement(BusyIndicator_1.default, { show: busy && !_this.props.enableLessIntrusiveLoadingIndicator }); }));
    };
    PaperLayout.prototype.renderErrors = function () {
        var errors = this.props.errors;
        if (!errors) {
            return null;
        }
        return React.createElement(ErrorPanel_1.default, { message: errors.message, details: errors.details, detailLinks: errors.detailLinks, helpText: errors.helpText, fullException: errors.fullException, helpLink: errors.helpLink });
    };
    PaperLayout.prototype.render = function () {
        return React.createElement("div", { className: cn(styles.container, this.props.className) },
            React.createElement("div", { className: cn(this.props.flatStyle ? styles.paperContentFlat : styles.paperContent, this.props.fullWidth && styles.paperFullWidth, this.props.innerClassName) },
                this.renderHeader(),
                this.renderErrors(),
                this.props.children));
    };
    return PaperLayout;
}(React.Component));
exports.default = PaperLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PaperLayout\\PaperLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PaperLayout\\PaperLayout.tsx"); } } })();

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Checkbox_1 = __webpack_require__(249);
var check_box_1 = __webpack_require__(562);
var check_box_outline_blank_1 = __webpack_require__(561);
var colors_1 = __webpack_require__(32);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1591);
var InputLabel_1 = __webpack_require__(263);
var Note_1 = __webpack_require__(22);
var Checkbox = (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (event, isChecked) {
            if (_this.props.validate) {
                var validateResult = _this.props.validate(isChecked);
                _this.props.onValidate(validateResult);
            }
            _this.props.onChange(isChecked);
        };
        return _this;
    }
    Checkbox.prototype.componentDidMount = function () {
        if (this.props.autoFocus) {
            // this digs into the Checkbox implementation to set focus
            var internalSwitch = this.checkBoxField.refs.enhancedSwitch;
            internalSwitch.refs.checkbox.focus();
            internalSwitch.tabPressed = true;
            internalSwitch.handleFocus();
        }
    };
    Checkbox.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, label = _a.label, className = _a.className, value = _a.value, noMargin = _a.noMargin, onChange = _a.onChange, hintText = _a.hintText, note = _a.note, error = _a.error, warning = _a.warning, otherProps = __rest(_a, ["title", "label", "className", "value", "noMargin", "onChange", "hintText", "note", "error", "warning"]);
        var isMessageProvided = (error && error.length > 0) || (warning && warning.length > 0);
        var message = isMessageProvided && (error || warning);
        var messageColor = isMessageProvided && (message === error ? colors_1.danger : colors_1.alert);
        return (React.createElement("div", { className: cn(className, (_b = {}, _b[styles.topMargin] = !noMargin, _b)) },
            title && React.createElement(InputLabel_1.default, { label: title }),
            React.createElement(Checkbox_1.default, __assign({ ref: function (ref) { return _this.checkBoxField = ref; }, label: label, checked: value, onCheck: this.handleChange, labelStyle: { width: "100%" }, checkedIcon: React.createElement(check_box_1.default, { style: { fill: colors_1.primary } }), uncheckedIcon: React.createElement(check_box_outline_blank_1.default, { style: { fill: colors_1.primaryText } }) }, otherProps)),
            message && React.createElement("div", { style: { color: messageColor }, className: styles.message },
                React.createElement("hr", { style: { borderColor: messageColor } }),
                message),
            React.createElement("div", { className: styles.checkboxNote },
                React.createElement(Note_1.default, { children: note }))));
        var _b;
    };
    return Checkbox;
}(React.Component));
exports.default = Checkbox;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Checkbox\\Checkbox.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Checkbox\\Checkbox.tsx"); } } })();

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var scriptingLanguage_1 = __webpack_require__(140);
var InputLabel_1 = __webpack_require__(263);
var IconButton_1 = __webpack_require__(56);
var styles = __webpack_require__(1810);
var VariableLookup_1 = __webpack_require__(363);
var CodeMirror = __webpack_require__(796);
var codeMirror = __webpack_require__(1815);
__webpack_require__(1819);
__webpack_require__(692);
__webpack_require__(1820);
__webpack_require__(1821);
__webpack_require__(1822);
__webpack_require__(395);
__webpack_require__(1823);
__webpack_require__(693);
__webpack_require__(1824);
__webpack_require__(1825);
__webpack_require__(1826);
__webpack_require__(1828);
__webpack_require__(1830);
__webpack_require__(48);
__webpack_require__(1831);
var Language;
(function (Language) {
    Language["HTML"] = "HTML";
    Language["CSS"] = "CSS";
    Language["Markdown"] = "Markdown";
    Language["DockerFile"] = "DockerFile";
    Language["INI"] = "INI";
    Language["CoffeeScript"] = "CoffeeScript";
})(Language = exports.Language || (exports.Language = {}));
var TextFormat;
(function (TextFormat) {
    TextFormat["JSON"] = "JSON";
    TextFormat["PlainText"] = "PlainText";
    TextFormat["XML"] = "XML";
    TextFormat["YAML"] = "YAML";
})(TextFormat = exports.TextFormat || (exports.TextFormat = {}));
var CodeEditor = (function (_super) {
    __extends(CodeEditor, _super);
    function CodeEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.cursorPosition = null;
        _this.onFocusChange = function (focused) {
            if (!focused) {
                _this.cursorPosition = _this.codeMirrorInstance.getCodeMirror().getCursor();
            }
        };
        _this.handleChange = function (value) {
            _this.props.onChange(value);
        };
        _this.toggleFullScreen = function () {
            var current = _this.codeMirrorInstance.getCodeMirror().getOption("fullScreen");
            var containerClassName = current ? styles.codeEditorContainer : styles.codeEditorContainerFullScreen;
            _this.setState({ containerClassName: containerClassName, isInFullScreen: !current });
            _this.codeMirrorInstance.getCodeMirror().setOption("fullScreen", !current);
        };
        _this.state = {
            containerClassName: styles.codeEditorContainer,
            isInFullScreen: false
        };
        return _this;
    }
    CodeEditor.prototype.componentDidMount = function () {
        if (this.props.autoFocus) {
            this.focus();
        }
    };
    CodeEditor.prototype.componentWillMount = function () {
        if (this.props.textInputRef) {
            this.props.textInputRef(this);
        }
    };
    CodeEditor.prototype.componentWillUnmount = function () {
        if (this.props.textInputRef) {
            this.props.textInputRef(null);
        }
        if (this.state.isInFullScreen) {
            this.toggleFullScreen();
        }
    };
    CodeEditor.prototype.render = function () {
        var _this = this;
        var options = {
            mode: this.toMode(this.props.language),
            lineNumbers: true,
            extraKeys: {},
            readOnly: this.props.readOnly
        };
        var val = this.props.value ? this.props.value : "";
        if (this.props.allowFullScreen) {
            options.extraKeys = {
                Esc: function (cm) {
                    if (cm.getOption("fullScreen")) {
                        _this.toggleFullScreen();
                    }
                }
            };
        }
        // This one override the full screen rule as user wants to handle it explicitly
        if (this.props.onEscPressed) {
            options.extraKeys = {
                Esc: function () {
                    _this.props.onEscPressed();
                },
            };
        }
        return (React.createElement("div", null,
            this.props.label && React.createElement(InputLabel_1.default, { label: this.props.label }),
            React.createElement("div", { className: this.state.containerClassName },
                this.props.allowFullScreen && this.fullScreenToggle(),
                React.createElement(CodeMirror, { ref: function (ref) { return _this.codeMirrorInstance = ref; }, preserveScrollPosition: true, value: val, onFocusChange: this.onFocusChange, onChange: this.handleChange, options: options }))));
    };
    CodeEditor.prototype.focus = function () {
        if (this.codeMirrorInstance) {
            this.codeMirrorInstance.focus();
            if (this.cursorPosition) {
                this.codeMirrorInstance.getCodeMirror().setCursor(this.cursorPosition);
            }
        }
    };
    CodeEditor.prototype.insertAtCursor = function (value) {
        this.codeMirrorInstance.getCodeMirror().replaceSelection(value, "end");
        this.cursorPosition = this.codeMirrorInstance.getCodeMirror().getCursor();
    };
    CodeEditor.prototype.toMode = function (language) {
        switch (language) {
            case scriptingLanguage_1.ScriptingLanguage.Bash: return "shell";
            case scriptingLanguage_1.ScriptingLanguage.CSharp: return "text/x-csharp";
            case scriptingLanguage_1.ScriptingLanguage.FSharp: return "text/x-fsharp";
            case TextFormat.JSON: return "application/json";
            case TextFormat.PlainText: return "null";
            case scriptingLanguage_1.ScriptingLanguage.PowerShell: return "powershell";
            case TextFormat.XML: return "text/html";
            case TextFormat.YAML: return "text/x-yaml";
            case Language.CoffeeScript: return "application/vnd.coffeescript";
            case Language.CSS: return "text/css";
            case Language.DockerFile: return "text/x-dockerfile";
            case Language.HTML: return "text/html";
            case Language.INI: return "text/x-ini";
            case Language.Markdown: return "text/x-markdown";
            default: return "null";
        }
    };
    CodeEditor.prototype.fullScreenToggle = function () {
        var isInFullScreen = this.state.isInFullScreen;
        return React.createElement("div", { className: isInFullScreen ? styles.exitFullScreen : styles.enterFullScreen },
            React.createElement("div", null,
                React.createElement(IconButton_1.default, { toolTipContent: (isInFullScreen ? "Exit" : "Enter") + " full screen", onClick: this.toggleFullScreen, icon: isInFullScreen ? IconButton_1.Icon.ExitFullScreen : IconButton_1.Icon.EnterFullScreen })));
    };
    CodeEditor.defaultProps = {
        readOnly: false
    };
    return CodeEditor;
}(React.Component));
exports.default = CodeEditor;
var CodeEditorWithInputRef = function (props) { return React.createElement(CodeEditor, __assign({ textInputRef: props.textInputRef }, props)); };
exports.VariableLookupCodeEditor = VariableLookup_1.withVariableLookup()(CodeEditorWithInputRef);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\CodeEditor\\CodeEditor.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\CodeEditor\\CodeEditor.tsx"); } } })();

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Breadcrumb_1 = __webpack_require__(641);
var PageTitleHelper_1 = __webpack_require__(221);
var InternalNavLink_1 = __webpack_require__(223);
var styles = __webpack_require__(1578);
var AreaTitle = (function (_super) {
    __extends(AreaTitle, _super);
    function AreaTitle(props) {
        var _this = _super.call(this, props) || this;
        PageTitleHelper_1.default.setPageTitle(props.title, props.breadcrumbTitle);
        return _this;
    }
    AreaTitle.prototype.render = function () {
        return React.createElement("div", { className: styles.titleBar },
            React.createElement("div", { className: styles.title },
                React.createElement(Breadcrumb_1.default, { title: this.props.breadcrumbTitle, path: this.props.breadcrumbPath, isAreaLevelBreadcrumb: true }),
                React.createElement("h1", null,
                    React.createElement(InternalNavLink_1.default, { className: styles.pageTitleLink, to: this.props.link }, this.props.title))),
            React.createElement("div", null, this.props.children));
    };
    return AreaTitle;
}(React.Component));
exports.default = AreaTitle;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\AreaTitle\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\AreaTitle\\index.tsx"); } } })();

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Dialog_1 = __webpack_require__(158);
var styles = __webpack_require__(349);
var uiTestClasses_1 = __webpack_require__(77);
var Dialog = function (props) {
    var bodyStyle = {
        padding: "0",
        color: "inherit",
        fontSize: "inherit",
        display: "flex",
        overflow: "hidden"
    };
    var contentStyle = !props.wide ? {
        width: "75%",
        maxWidth: "550px"
    } : null;
    return React.createElement(Dialog_1.default, { className: uiTestClasses_1.dialogClass, open: props.open || false, bodyStyle: bodyStyle, contentStyle: contentStyle, contentClassName: styles.materialDialogContent, autoDetectWindowHeight: true }, props.open && props.children);
};
Dialog.displayName = "Dialog";
exports.default = Dialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\Dialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\Dialog.tsx"); } } })();

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(139);
var styles = __webpack_require__(116);
var FormSectionBase_1 = __webpack_require__(264);
// like Unstructured form section with no margin so warnings fill the panel
var WarningFormSection = (function (_super) {
    __extends(WarningFormSection, _super);
    function WarningFormSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WarningFormSection.prototype.render = function () {
        return React.createElement(Card_1.Card, { className: styles.formNonExpander, expanded: true }, this.body(styles.cardMediaWarning, false));
    };
    return WarningFormSection;
}(FormSectionBase_1.FormSectionBase));
exports.default = WarningFormSection;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\WarningFormSection.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\WarningFormSection.tsx"); } } })();

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var pathToRegexp = __webpack_require__(451);
function resolvePathWithSpaceId(to, spaceId) {
    if (typeof to !== "string") {
        return __assign({}, to, { pathname: resolveStringPathWithSpaceId(to.pathname, spaceId) });
    }
    return resolveStringPathWithSpaceId(to, spaceId);
}
exports.resolvePathWithSpaceId = resolvePathWithSpaceId;
var FakeSpaceId = "Spaces-0";
function resolveStringPathWithSpaceId(path, spaceId) {
    // path contains space id parameter so it needs to be resolved even if space id is not provided
    spaceId = spaceId ? spaceId : FakeSpaceId;
    // Switch to generatePath once a new version of router is released : https://github.com/ReactTraining/react-router/issues/6024
    var link = pathToRegexp.compile(path)({ spaceId: spaceId });
    return spaceId === FakeSpaceId ? link.replace(FakeSpaceId, "").replace("//", "/") : link;
}
exports.resolveStringPathWithSpaceId = resolveStringPathWithSpaceId;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\resolvePathWithSpaceId.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\resolvePathWithSpaceId.tsx"); } } })();

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var Note_1 = __webpack_require__(22);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var feedResource_1 = __webpack_require__(54);
var StringProperties = {
    "Octopus.Action.Package.DownloadOnTentacle": "",
    "Octopus.Action.Package.FeedId": "",
    "Octopus.Action.RunOnServer": ""
};
var PackageDownloadOptions = (function (_super) {
    __extends(PackageDownloadOptions, _super);
    function PackageDownloadOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PackageDownloadOptions.prototype.shouldComponentUpdate = function (newProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, newProps, this.props);
    };
    PackageDownloadOptions.prototype.componentDidMount = function () {
        this.props.setProperties((_a = {}, _a["Octopus.Action.Package.DownloadOnTentacle"] = this.props.properties["Octopus.Action.Package.DownloadOnTentacle"] || "False", _a));
        var _a;
    };
    PackageDownloadOptions.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        if ((properties["Octopus.Action.Package.FeedId"] && properties["Octopus.Action.Package.FeedId"].toLowerCase() === feedResource_1.BuiltInFeedId) ||
            (properties["Octopus.Action.RunOnServer"] && properties["Octopus.Action.RunOnServer"].toLowerCase() === "true")) {
            return null;
        }
        return React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                localNames: this.props.localNames,
                projectId: this.props.projectId
            }, resetValue: "False", value: properties["Octopus.Action.Package.DownloadOnTentacle"], onChange: function (val) {
                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.DownloadOnTentacle"] = val, _a));
                var _a;
            } },
            React.createElement(RadioButton_1.default, { value: "False", label: "Octopus Server will download the package, then securely upload it to the Tentacles", isDefault: true }),
            React.createElement(RadioButton_1.default, { value: "True", label: "Each Tentacle will download the package directly from the remote server" }),
            React.createElement(Note_1.default, null,
                "Applies to machines running the Tentacle deployment agent only; packages deployed to other endpoint types are always downloaded by the Octopus Server. ",
                properties["Octopus.Action.RunOnServer"]));
    };
    return PackageDownloadOptions;
}(BaseComponent_1.BaseComponent));
exports.default = PackageDownloadOptions;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PackageDownloadOptions\\PackageDownloadOptions.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PackageDownloadOptions\\PackageDownloadOptions.tsx"); } } })();

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Markdown_1 = __webpack_require__(786);
exports.default = Markdown_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Markdown\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Markdown\\index.tsx"); } } })();

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(16);
var matchErrorsToFieldNames_1 = __webpack_require__(788);
var DataBaseComponent_1 = __webpack_require__(167);
// This base class is deprecated. Use `FormBaseComponent` instead which does not have an optional model
var OptionalFormBaseComponent = (function (_super) {
    __extends(OptionalFormBaseComponent, _super);
    function OptionalFormBaseComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.getFieldError = function (fieldName) {
            if (_this.state.errors && _this.state.errors.fieldErrors) {
                var found = Object.keys(_this.state.errors.fieldErrors).find(function (k) { return k.toLowerCase() === fieldName.toLowerCase(); });
                if (found) {
                    return _this.state.errors.fieldErrors[found];
                }
                var foundPartialMatch = Object.keys(_this.state.errors.fieldErrors).find(function (k) { return k.endsWith("." + fieldName); });
                if (foundPartialMatch) {
                    return _this.state.errors.fieldErrors[foundPartialMatch];
                }
            }
            return "";
        };
        return _this;
    }
    OptionalFormBaseComponent.prototype.setModel = function (model) {
        this.setState({
            model: model,
            cleanModel: lodash_1.cloneDeep(model)
        });
    };
    OptionalFormBaseComponent.prototype.setModelState = function (state, callback) {
        this.setChildState1("model", state, callback);
    };
    OptionalFormBaseComponent.prototype.mapToOctopusError = function (err) {
        var error = _super.prototype.mapToOctopusError.call(this, err);
        error.fieldErrors = matchErrorsToFieldNames_1.default(err, this.state.model);
        return error;
    };
    return OptionalFormBaseComponent;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = OptionalFormBaseComponent;
var FormBaseComponent = (function (_super) {
    __extends(FormBaseComponent, _super);
    function FormBaseComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getFieldError = function (fieldName) {
            if (_this.state.errors && _this.state.errors.fieldErrors) {
                var found = Object.keys(_this.state.errors.fieldErrors).find(function (k) { return k.toLowerCase() === fieldName.toLowerCase(); });
                if (found) {
                    return _this.state.errors.fieldErrors[found];
                }
                var foundPartialMatch = Object.keys(_this.state.errors.fieldErrors).find(function (k) { return k.endsWith("." + fieldName); });
                if (foundPartialMatch) {
                    return _this.state.errors.fieldErrors[foundPartialMatch];
                }
            }
            return "";
        };
        return _this;
    }
    FormBaseComponent.prototype.setModel = function (model) {
        this.setState({
            model: model,
            cleanModel: lodash_1.cloneDeep(model)
        });
    };
    FormBaseComponent.prototype.setModelState = function (state, callback) {
        this.setChildState1("model", state, callback);
    };
    FormBaseComponent.prototype.mapToOctopusError = function (err) {
        var error = _super.prototype.mapToOctopusError.call(this, err);
        error.fieldErrors = matchErrorsToFieldNames_1.default(err, this.state.model);
        return error;
    };
    return FormBaseComponent;
}(DataBaseComponent_1.DataBaseComponent));
exports.FormBaseComponent = FormBaseComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FormBaseComponent\\FormBaseComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FormBaseComponent\\FormBaseComponent.tsx"); } } })();

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
var tagSeperator = "/";
var getAll = function () {
    return clientInstance_1.repository.TagSets.all();
};
exports.getAll = getAll;
var getTagIndex = function () { return __awaiter(_this, void 0, void 0, function () {
    var idx, tagSets;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                idx = {};
                return [4 /*yield*/, getAll()];
            case 1:
                tagSets = _a.sent();
                tagSets.forEach(function (t) { return t.Tags.forEach(function (tag) { return idx[tag.CanonicalTagName] = tag; }); });
                return [2 /*return*/, idx];
        }
    });
}); };
exports.getTagIndex = getTagIndex;
var groupByTagSet = function (canonicalTagNames) {
    return canonicalTagNames.reduce(function (groups, ctn) {
        var tagSetId = ctn.split(tagSeperator)[0];
        (groups[tagSetId] = groups[tagSetId] || []);
        groups[tagSetId].push(ctn);
        return groups;
    }, {});
};
exports.groupByTagSet = groupByTagSet;
var flattenGroup = function (groups) {
    return Object.keys(groups).reduce(function (a, tagId) { return a.concat(groups[tagId]); }, []);
};
exports.flattenGroup = flattenGroup;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\tenantTagsets.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\tenantTagsets.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 139 */,
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ScriptingLanguage;
(function (ScriptingLanguage) {
    ScriptingLanguage["Bash"] = "Bash";
    ScriptingLanguage["CSharp"] = "CSharp";
    ScriptingLanguage["FSharp"] = "FSharp";
    ScriptingLanguage["PowerShell"] = "PowerShell";
})(ScriptingLanguage = exports.ScriptingLanguage || (exports.ScriptingLanguage = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\scriptingLanguage.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\scriptingLanguage.ts"); } } })();

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BusyIndicator_1 = __webpack_require__(98);
var BusyFromPromise_1 = __webpack_require__(176);
var ErrorPanel_1 = __webpack_require__(83);
var styles = __webpack_require__(244);
var react_event_listener_1 = __webpack_require__(55);
var lodash_1 = __webpack_require__(16);
var KeyboardHandler_1 = __webpack_require__(543);
var DialogLayout = (function (_super) {
    __extends(DialogLayout, _super);
    function DialogLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.onResize = function () {
            // ie11 flexbox doesn't work correctly if the parent element is
            // having its size set by max-height, but the parent element to this
            // is material-ui and maxHeight is how they dynamically resize dialogs
            // so rather than change that, if we're in ie11 set the contents
            // max-height.
            if (_this.topLevel) {
                var parentHeight = _this.topLevel.parentElement.style.maxHeight;
                _this.setState({ style: { maxHeight: parentHeight } });
            }
        };
        _this.onEscKeyPressed = function () {
            if (_this.props.closeDialog) {
                _this.props.closeDialog();
                return true;
            }
            return false;
        };
        _this.ie11 = typeof (Event) !== "function";
        _this.state = { style: {} };
        _this.onResizeThrottled = lodash_1.throttle(_this.onResize, 100);
        return _this;
    }
    DialogLayout.prototype.componentDidMount = function () {
        var _this = this;
        if (this.ie11) {
            window.setTimeout(function () { return _this.onResize(); }, 250);
        }
    };
    DialogLayout.prototype.render = function () {
        var _this = this;
        if (this.props.busy && (typeof this.props.busy) !== "boolean") {
            // Workaround for a bug in material-ui dialog: https://github.com/callemall/material-ui/issues/5793#issuecomment-301282845
            this.props.busy.then(function () { return setTimeout(function () {
                if (_this.ie11) {
                    var event = document.createEvent("Event");
                    event.initEvent("resize", true, true);
                    window.dispatchEvent(event);
                }
                else {
                    window.dispatchEvent(new Event("resize"));
                }
            }, 10); });
        }
        var keyboardRegistrations = [{ key: KeyboardHandler_1.Key.Esc, onKeyPressed: this.onEscKeyPressed }];
        return React.createElement("div", { className: styles.layout, ref: function (r) { return _this.topLevel = r; }, style: this.state.style },
            React.createElement(KeyboardHandler_1.default, { registrations: keyboardRegistrations, className: styles.dialogWrapper },
                this.ie11 && React.createElement(react_event_listener_1.default, { target: "window", onResize: react_event_listener_1.withOptions(this.onResize, { passive: true }) }),
                React.createElement("div", { className: this.props.headerClassName },
                    React.createElement(BusyFromPromise_1.default, { promise: this.props.busy }, function (busy) { return React.createElement(BusyIndicator_1.default, { show: busy }); }),
                    React.createElement("div", { className: styles.title },
                        this.props.titleIcon && React.createElement("div", { className: styles.titleIcon }, this.props.titleIcon),
                        this.props.title),
                    this.props.extraHeaderContent && this.props.extraHeaderContent(styles.headerContentAlignment)),
                this.props.errors &&
                    React.createElement(ErrorPanel_1.default, { message: this.props.errors.message, details: this.props.errors.details }),
                React.createElement("div", { className: styles.body }, this.props.children),
                React.createElement("div", { className: styles.actions },
                    React.createElement("div", { className: styles.secondaryActions }, this.props.additionalActions),
                    React.createElement("div", { className: styles.primaryActions }, this.props.actions))));
    };
    return DialogLayout;
}(React.Component));
exports.DialogLayout = DialogLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DialogLayout\\DialogLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DialogLayout\\DialogLayout.tsx"); } } })();

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_event_listener_1 = __webpack_require__(55);
var material_ui_1 = __webpack_require__(92);
var IconButton_1 = __webpack_require__(63);
var clear_1 = __webpack_require__(178);
var BaseComponent_1 = __webpack_require__(14);
var lodash_1 = __webpack_require__(16);
var styles = __webpack_require__(1659);
var BorderedListItem_1 = __webpack_require__(790);
var RemoveItemsList = (function (_super) {
    __extends(RemoveItemsList, _super);
    function RemoveItemsList(props) {
        var _this = _super.call(this, props) || this;
        _this.updateButtonsVisibility = _this.updateButtonsVisibility.bind(_this);
        _this.handleResize = lodash_1.throttle(_this.updateButtonsVisibility, 100);
        _this.handleScroll = lodash_1.throttle(_this.updateButtonsVisibility, 50);
        return _this;
    }
    RemoveItemsList.prototype.componentDidMount = function () {
        this.updateButtonsVisibility();
    };
    RemoveItemsList.prototype.componentWillUnmount = function () {
        this.handleResize.cancel();
        this.handleScroll.cancel();
    };
    RemoveItemsList.prototype.render = function () {
        var _this = this;
        var actions = (this.props.listActions || []).map(function (action, index) { return React.cloneElement(action, { key: index }); });
        return (React.createElement("div", null,
            React.createElement(react_event_listener_1.default, { target: "window", onResize: this.handleResize, onScroll: react_event_listener_1.withOptions(this.handleScroll, { passive: true, capture: false }) }),
            React.createElement("div", { ref: function (el) { return _this.topActionsMenu = el; }, className: styles.actionsMenu }, actions),
            this.props.data.length === 0 && React.createElement("div", { className: styles.emptyList }, this.props.empty),
            this.props.data.length !== 0 && React.createElement(material_ui_1.List, null, this.props.data.map(function (item, index) { return _this.buildItem(item, index); })),
            React.createElement("div", { ref: function (el) { return _this.bottomActionsMenu = el; }, style: { visibility: "hidden" }, className: styles.actionsMenu }, actions)));
    };
    RemoveItemsList.prototype.updateButtonsVisibility = function () {
        if (this.topActionsMenu && this.bottomActionsMenu) {
            var result = "visible";
            if (this.isElementInViewport(this.topActionsMenu)) {
                result = "hidden";
            }
            else if (!this.isElementInViewport(this.bottomActionsMenu)) {
                result = "hidden"; //so hide the bottom one so we don't show both when we come back
            }
            this.bottomActionsMenu.style.visibility = result;
        }
    };
    RemoveItemsList.prototype.isElementInViewport = function (el) {
        var rect = el.getBoundingClientRect();
        var vWidth = window.innerWidth || document.documentElement.clientWidth;
        var vHeight = window.innerHeight || document.documentElement.clientHeight;
        // Return false if it's not in the viewport
        if (rect.right < 0 ||
            rect.bottom < 0 ||
            rect.left > vWidth ||
            rect.top > vHeight) {
            return false;
        }
        return el.contains(document.elementFromPoint(rect.right - (rect.width / 2), rect.bottom - (rect.height / 2)));
    };
    RemoveItemsList.prototype.buildItem = function (item, index) {
        var _this = this;
        var clearButton = this.props.onRemoveRow ? React.createElement(IconButton_1.default, { tooltip: this.props.clearButtonToolTip, onClick: function (e) {
                e.stopPropagation();
                _this.props.onRemoveRow(item);
            } },
            React.createElement(clear_1.default, null)) : null;
        return React.createElement(BorderedListItem_1.default, { key: item.Id || index, rightIconButton: clearButton, onClick: this.props.onRowTouch ? function (e) { return _this.onTouch(item); } : null, disabled: this.props.onRowTouch ? false : true }, this.props.onRow(item, index));
    };
    RemoveItemsList.prototype.onTouch = function (item) {
        if (this.props.onRowTouch) {
            this.props.onRowTouch(item);
        }
    };
    return RemoveItemsList;
}(BaseComponent_1.BaseComponent));
exports.RemoveItemsList = RemoveItemsList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\RemoveItemsList\\RemoveItemsList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\RemoveItemsList\\RemoveItemsList.tsx"); } } })();

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Divider_1 = __webpack_require__(248);
var colors_1 = __webpack_require__(32);
exports.Divider = function (props) {
    var margin = props.fullHeight ? { marginTop: 0 } : {};
    return React.createElement(Divider_1.default, { style: __assign({ backgroundColor: colors_1.divider }, margin) });
};
exports.default = exports.Divider;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Divider\\Divider.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Divider\\Divider.tsx"); } } })();

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LookupResourceChip_1 = __webpack_require__(456);
exports.default = LookupResourceChip_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LookupResourceChip\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LookupResourceChip\\index.tsx"); } } })();

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1595);
var sizes_1 = __webpack_require__(1597);
var InputWithActions = function (props) {
    var inputStyle = props.applyMaxWidth ? { maxWidth: sizes_1.maxInputWidth } : (props.maxWidthInRem ? { maxWidth: props.maxWidthInRem + "rem" } : {});
    return React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.input, style: inputStyle }, props.input),
        React.createElement("div", { className: styles.actions }, props.actions));
};
InputWithActions.displayName = "InputWithActions";
InputWithActions.defaultProps = {
    applyMaxWidth: false
};
exports.default = InputWithActions;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\InputWithActions\\InputWithActions.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\InputWithActions\\InputWithActions.tsx"); } } })();

/***/ }),
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(96);
var redux_thunk_1 = __webpack_require__(1002);
var reducers_1 = __webpack_require__(1003);
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
var store = redux_1.createStore(reducers_1.reducers, composeEnhancers(redux_1.applyMiddleware(redux_thunk_1.default)));
exports.default = store;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\store.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\store.ts"); } } })();

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// State Type
var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["happy"] = 0] = "happy";
    NotificationType[NotificationType["info"] = 1] = "info";
    NotificationType[NotificationType["warn"] = 2] = "warn";
    NotificationType[NotificationType["error"] = 3] = "error";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
// Actions
var NotificationActions = {
    RAISE: "NotificationActions/RAISE",
    DISMISS: "NotificationActions/DISMISS"
};
// Action Creator
exports.raiseNotification = function (dispatch) { return function (notification) {
    dispatch({ type: NotificationActions.RAISE, notification: notification });
}; };
exports.dismissNotification = function (dispatch) { return function (notificationType) {
    dispatch({ type: NotificationActions.DISMISS, notificationType: notificationType });
}; };
// Reducer
exports.notificationReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case NotificationActions.RAISE:
            var notification = action.notification;
            return __assign({}, state, (_a = {}, _a[notification.id] = notification, _a));
        case NotificationActions.DISMISS:
            var newState = __assign({}, state);
            delete newState[action.notificationType];
            return newState;
    }
    return state;
    var _a;
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\notifications.redux.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\notifications.redux.ts"); } } })();

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var IconButtonList_1 = __webpack_require__(109);
var InputWithActions_1 = __webpack_require__(383);
var React = __webpack_require__(0);
var _ = __webpack_require__(16);
var resources_1 = __webpack_require__(26);
var variableResource_1 = __webpack_require__(401);
var clientInstance_1 = __webpack_require__(10);
var Select_1 = __webpack_require__(41);
var index_1 = __webpack_require__(254);
var IconButton_1 = __webpack_require__(56);
var BoundField_1 = __webpack_require__(95);
var CertificateVariableSelect = (function (_super) {
    __extends(CertificateVariableSelect, _super);
    function CertificateVariableSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (certificateVariable) {
            var value = certificateVariable === "" ? null : certificateVariable;
            if (_this.props.validate) {
                var result = _this.props.validate(value);
                _this.setState({ error: result });
                if (_this.props.onValidate) {
                    _this.props.onValidate(result);
                }
            }
            _this.props.onChange(value);
        };
        _this.goTo = function () {
            window.open("#/projects/" + _this.props.projectId + "/variables", "_blank");
        };
        _this.getCertificateVariables = function (project) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var libraryVariableSets, templates, variableSetIds, variableResults, variables;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(project.IncludedLibraryVariableSetIds.map(function (libraryVariableSetId) { return clientInstance_1.repository.LibraryVariableSets.get(libraryVariableSetId); }))];
                    case 1:
                        libraryVariableSets = _a.sent();
                        templates = _.union(project.Templates, _.flattenDeep(libraryVariableSets.map(function (lvs) { return lvs.Templates; })))
                            .filter(function (template) {
                            return !!template.DisplaySettings && template.DisplaySettings["Octopus.ControlType"] === resources_1.ControlType.Certificate;
                        });
                        variableSetIds = _.union([project.VariableSetId], libraryVariableSets.map(function (lvs) { return lvs.VariableSetId; }));
                        return [4 /*yield*/, Promise.all(variableSetIds.map(function (variableSetId) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.Variables.get(variableSetId)];
                                    case 1: return [2 /*return*/, (_a.sent()).Variables];
                                }
                            }); }); }))];
                    case 2:
                        variableResults = _a.sent();
                        variables = _.flattenDeep(variableResults)
                            .filter(function (v) { return v.Type === variableResource_1.VariableType.Certificate; });
                        return [2 /*return*/, _.chain(variables)
                                .union(templates)
                                .map(function (v) { return v.Name; })
                                .sort()
                                .uniq()
                                .value()];
                }
            });
        }); };
        _this.onRequestRefresh = function () { return __awaiter(_this, void 0, void 0, function () {
            var variables;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ refreshing: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.getCertificateVariables(this.state.project)];
                    case 2:
                        variables = _a.sent();
                        this.setState({ variables: variables });
                        return [3 /*break*/, 4];
                    case 3:
                        this.setState({ refreshing: false });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            error: null,
            refreshing: false,
            project: null,
            variables: [],
            isDataLoaded: false
        };
        return _this;
    }
    CertificateVariableSelect.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var project, variables;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                            case 1:
                                project = _a.sent();
                                return [4 /*yield*/, this.getCertificateVariables(project)];
                            case 2:
                                variables = _a.sent();
                                this.setState({ project: project, variables: variables, isDataLoaded: true });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    CertificateVariableSelect.prototype.render = function () {
        if (!this.state.isDataLoaded) {
            return React.createElement(index_1.default, { show: true, inline: true });
        }
        var _a = this.props, onChange = _a.onChange, onValidate = _a.onValidate, projectId = _a.projectId, doBusyTask = _a.doBusyTask, otherProps = __rest(_a, ["onChange", "onValidate", "projectId", "doBusyTask"]);
        return (React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.default, __assign({ label: "Select certificate variable" }, otherProps, { allowFilter: true, error: this.state.error || this.props.error, onChange: this.handleChange, items: this.state.variables.map(function (v) { return ({ value: v, text: v }); }) })), actions: React.createElement(IconButtonList_1.default, { buttons: this.getButtons() }) }));
    };
    CertificateVariableSelect.prototype.getButtons = function () {
        var buttons = [];
        if (!this.state.refreshing) {
            buttons.push(React.createElement(IconButton_1.default, { toolTipContent: "Refresh", icon: IconButton_1.Icon.Refresh, onClick: this.onRequestRefresh }));
        }
        else {
            buttons.push(React.createElement(index_1.default, { show: true, inline: true }));
        }
        buttons.push(React.createElement(IconButton_1.default, { toolTipContent: "Add", icon: IconButton_1.Icon.Add, onClick: this.goTo }));
        return buttons;
    };
    return CertificateVariableSelect;
}(React.Component));
exports.default = CertificateVariableSelect;
exports.BoundCertificateVariableSelect = BoundField_1.withBoundField(CertificateVariableSelect);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\CertificateSelect\\CertificateVariableSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\CertificateSelect\\CertificateVariableSelect.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Callout_1 = __webpack_require__(81);
var ExternalLink_1 = __webpack_require__(29);
var AzurePowerShellScriptInfo = function (props) {
    var preamble = props.actionType === "Octopus.AzurePowerShell"
        ? "As this step is running a PowerShell script"
        : "If you are running a PowerShell script as part of this step";
    return React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
        preamble,
        " ",
        React.createElement(ExternalLink_1.default, { href: "WindowsManagementFramework3Download" }, "Windows Management Framework 3"),
        " (or newer) must be installed on the ",
        React.createElement("strong", null, "Octopus Server"),
        ".");
};
exports.default = AzurePowerShellScriptInfo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azurePowerShell\\AzurePowerShellScriptInfo.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azurePowerShell\\AzurePowerShellScriptInfo.tsx"); } } })();

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DataBaseComponent_1 = __webpack_require__(39);
exports.DataBaseComponent = DataBaseComponent_1.DataBaseComponent;
exports.DataBaseComponentState = DataBaseComponent_1.DataBaseComponentState;
exports.Errors = DataBaseComponent_1.Errors;
exports.default = DataBaseComponent_1.DataBaseComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataBaseComponent\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataBaseComponent\\index.ts"); } } })();

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PaperLayout_1 = __webpack_require__(117);
var Snackbar_1 = __webpack_require__(584);
var ExpansionButtons_1 = __webpack_require__(426);
var react_router_1 = __webpack_require__(69);
var lodash_1 = __webpack_require__(16);
var ActionList_1 = __webpack_require__(765);
var PermissionCheck_1 = __webpack_require__(45);
var OverflowMenu_1 = __webpack_require__(209);
var styles = __webpack_require__(1626);
var ActionButton_1 = __webpack_require__(50);
var BaseComponent_1 = __webpack_require__(14);
var FormComponent_1 = __webpack_require__(267);
var InternalRedirect_1 = __webpack_require__(40);
var FormPaperLayout = (function (_super) {
    __extends(FormPaperLayout, _super);
    function FormPaperLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSnackbarClose = function () {
            _this.setState({
                showSnackbar: false,
            });
        };
        _this.handleMenuClick = function (link) {
            if (link.onClick) {
                link.onClick();
            }
            else {
                _this.setState({ redirect: link.url });
            }
        };
        _this.isDisableDueToPermission = function () {
            return !!_this.props.savePermission ? !PermissionCheck_1.isAllowed(_this.props.savePermission) : false;
        };
        _this.shouldBeDisabled = function () {
            return ((!_this.state.dirty || _this.props.busy) && !_this.props.disableDirtyFormChecking && !_this.props.isNewRecord);
        };
        _this.onCtrlEnterPressed = function () { return __awaiter(_this, void 0, void 0, function () {
            var disabledDueToPermission, isSaveDisable;
            return __generator(this, function (_a) {
                disabledDueToPermission = this.isDisableDueToPermission();
                isSaveDisable = disabledDueToPermission || this.shouldBeDisabled();
                if (!isSaveDisable && !this.props.disableKeyboardFormSubmission) {
                    this.save();
                }
                return [2 /*return*/];
            });
        }); };
        _this.handleSave = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, this.save()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.onSaveClick()];
                    case 1:
                        _a.sent();
                        if (!this.props.errors) {
                            if (this.props.saveText) {
                                this.setState({ showSnackbar: true });
                            }
                            ExpansionButtons_1.toggleExpandos(false);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            dirty: false,
            showSnackbar: false,
            redirect: null
        };
        return _this;
    }
    FormPaperLayout.prototype.componentWillReceiveProps = function (nextProps) {
        if (!nextProps.disableDirtyFormChecking) {
            var dirty = !lodash_1.isEqual(nextProps.model, nextProps.cleanModel);
            this.setState({ dirty: dirty });
        }
    };
    FormPaperLayout.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, model = _a.model, errors = _a.errors, rest = __rest(_a, ["children", "model", "errors"]);
        var overFlowMenu = this.props.overFlowActions && this.props.overFlowActions.length > 0
            && React.createElement(OverflowMenu_1.default, { menuItems: this.props.overFlowActions });
        var disabledDueToPermission = this.isDisableDueToPermission();
        var permissionLabel = this.getPermissionLabel();
        var label = disabledDueToPermission ? permissionLabel + " permission required" : (this.props.saveButtonLabel || "Save");
        var save = React.createElement(ActionButton_1.default, { type: ActionButton_1.ActionButtonType.Save, onClick: this.handleSave, label: label, busyLabel: this.props.saveButtonBusyLabel || "Saving", disabled: disabledDueToPermission || this.shouldBeDisabled() });
        if (this.state.redirect) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirect, push: true });
        }
        var sectionControl = this.props.hideSectionControls
            ? null
            : React.createElement(ActionList_1.default, { actions: [this.props.secondaryAction, save, overFlowMenu].filter(function (action) { return !!action; }) });
        return React.createElement(FormComponent_1.default, { onFormSubmit: this.onCtrlEnterPressed },
            React.createElement(PaperLayout_1.default, __assign({}, rest, { sectionControl: sectionControl, errors: this.props.errors }),
                React.createElement(react_router_1.Prompt, { when: this.state.dirty && !this.props.disableDirtyFormChecking, message: function (location) { return _this.getPromptMessage(location); } }),
                !this.props.hideExpandAll &&
                    React.createElement(ExpansionButtons_1.default, { errors: errors, expandAllOnMount: this.props.expandAllOnMount }),
                React.createElement("div", { className: styles.formContainer }, children),
                this.props.saveText && React.createElement(Snackbar_1.default, { open: this.state.showSnackbar, message: this.props.saveText, autoHideDuration: 3500, onRequestClose: this.handleSnackbarClose })));
    };
    FormPaperLayout.prototype.getPermissionLabel = function () {
        if (this.props.savePermission === undefined) {
            return "No";
        }
        if (Array.isArray(this.props.savePermission.permission)) {
            return this.props.savePermission.permission.join(", ");
        }
        return this.props.savePermission.permission;
    };
    FormPaperLayout.prototype.getPromptMessage = function (location) {
        // If the pathname hasn't changed, return true which will allow the transition.
        // This is so we can ignore filter changes which only modify the query string.
        if (location.pathname === this.props.location.pathname) {
            return true;
        }
        return "If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?";
    };
    FormPaperLayout.defaultProps = {
        expandAllOnMount: false,
        saveText: "Details updated"
    };
    return FormPaperLayout;
}(BaseComponent_1.BaseComponent));
exports.default = react_router_1.withRouter(FormPaperLayout);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FormPaperLayout\\FormPaperLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FormPaperLayout\\FormPaperLayout.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PaperLayout_1 = __webpack_require__(117);
exports.default = PaperLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PaperLayout\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PaperLayout\\index.ts"); } } })();

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.required = function (message) {
    return function (value) {
        if (!value || value.length < 1) {
            return message;
        }
        return "";
    };
};
exports.email = function (message) {
    return function (value) {
        if (!value || !value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            return message;
        }
        return "";
    };
};
exports.minimum = function (message, min) {
    return function (value) {
        var result = Number(value);
        if (isNaN(result)) {
            return message;
        }
        return result < min ? message : "";
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Validators.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Validators.ts"); } } })();

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var search_1 = __webpack_require__(597);
var DebounceValue_1 = __webpack_require__(173);
var Text_1 = __webpack_require__(17);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1383);
var MobileDetect = __webpack_require__(443);
var colors_1 = __webpack_require__(32);
var FilterSearchBoxInternal = (function (_super) {
    __extends(FilterSearchBoxInternal, _super);
    function FilterSearchBoxInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = null;
        _this.setRef = function (el) {
            _this.ref = el;
        };
        return _this;
    }
    FilterSearchBoxInternal.prototype.focus = function () {
        this.ref.focus();
    };
    FilterSearchBoxInternal.prototype.render = function () {
        var _this = this;
        // Disable autoFocus filtering for mobile (Android has issues and is annoying users).
        var md = new MobileDetect(window.navigator.userAgent);
        var autoFocus = md.isPhoneSized() ? false : this.props.autoFocus;
        return (React.createElement("div", { className: cn(this.props.containerClassName, styles.filterField) },
            React.createElement(search_1.default, { className: styles.searchIcon, color: this.props.iconColor ? this.props.iconColor : colors_1.secondaryText, style: this.props.iconStyle }),
            React.createElement(Text_1.default, { textInputRef: this.setRef, type: "search", hintText: this.props.hintText, value: this.props.value, onChange: function (value) { return _this.props.onChange(value); }, autoFocus: autoFocus, onKeyDown: this.props.onKeyDown, className: cn(this.props.inputClassName, this.props.fullWidth ? styles.filterTextBoxFullWidth : styles.filterTextBoxStandardWidth) })));
    };
    return FilterSearchBoxInternal;
}(React.Component));
exports.default = DebounceValue_1.default(FilterSearchBoxInternal);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FilterSearchBox\\FilterSearchBox.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FilterSearchBox\\FilterSearchBox.tsx"); } } })();

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_lazyload_1 = __webpack_require__(663);
var clientInstance_1 = __webpack_require__(10);
var lodash_1 = __webpack_require__(16);
var styles = __webpack_require__(1571);
var Logo = (function (_super) {
    __extends(Logo, _super);
    function Logo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // We need to force a recheck because LazyLoad only rechecks on scrolling, but because our screens support filtering, that bypasses the scrolling event
    Logo.prototype.componentDidUpdate = function () {
        Logo.recheckVisibility();
    };
    Logo.prototype.render = function () {
        var resolvedUrl = this.props.url.startsWith("~") || this.props.url.startsWith("/") ? clientInstance_1.client.resolve(this.props.url) : this.props.url;
        return React.createElement("div", { className: styles.logo, style: { width: this.props.size, height: this.props.size } },
            React.createElement(react_lazyload_1.default, { once: true, height: this.props.size },
                React.createElement("img", { src: resolvedUrl, style: {
                        maxWidth: this.props.size,
                        maxHeight: this.props.size
                    }, className: this.props.isDisabled ? styles.disabled : null, alt: "Logo" })));
    };
    Logo.defaultProps = {
        size: "3.1rem"
    };
    // This is static because we want it to be debounced so that when we have lots of Logos calling it we are not rechecking it for every single one
    Logo.recheckVisibility = lodash_1.debounce(function () {
        react_lazyload_1.forceCheck();
    }, 800);
    return Logo;
}(React.Component));
exports.default = Logo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Logo\\Logo.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Logo\\Logo.tsx"); } } })();

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(16);
var lodash_2 = __webpack_require__(16);
function DebounceValue(Comp) {
    return (function (_super) {
        __extends(DebounceValueInternal, _super);
        function DebounceValueInternal(props) {
            var _this = _super.call(this, props) || this;
            _this.state = {
                value: props.value
            };
            _this.onChange = lodash_2.debounce(function (value) { return _this.props.onChange(value); }, _this.props.debounceDelay ? _this.props.debounceDelay : 250);
            return _this;
        }
        DebounceValueInternal.prototype.componentWillReceiveProps = function (nextProps) {
            if (!lodash_1.isEqual(nextProps.value, this.props.value)) {
                this.setState({ value: nextProps.value });
                this.onChange.cancel();
            }
        };
        DebounceValueInternal.prototype.render = function () {
            var _this = this;
            var _a = this.props, debounceDelay = _a.debounceDelay, innerRef = _a.innerRef, otherProps = __rest(_a, ["debounceDelay", "innerRef"]); // `as any` because object rest not support in generics yet, tracked by https://github.com/Microsoft/TypeScript/issues/10727
            return React.createElement(Comp, __assign({}, otherProps, { value: this.state.value, ref: function (c) { if (innerRef) {
                    innerRef(c);
                } }, onChange: function (value) {
                    _this.setState({ value: value });
                    _this.onChange(value);
                } }));
        };
        return DebounceValueInternal;
    }(React.Component));
}
exports.default = DebounceValue;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DebounceValue\\DebounceValue.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DebounceValue\\DebounceValue.tsx"); } } })();

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var prop_types_1 = __webpack_require__(1);
function generateLabel(fieldName, labelStrategy, fallbackLabelStrategy) {
    if (labelStrategy) {
        return labelStrategy(fieldName);
    }
    return fallbackLabelStrategy(fieldName);
}
var LabelStrategyContextTypes = {
    labelStrategy: prop_types_1.func
};
/* This component is used to set a "labeling" strategy on the react context.
* This strategy is used to determine how labels for input components are generated
* This allows us to do things like say that all inputs within the filter panel
* should have labels of the form "By [fieldName]", eg "By environments".
* For components to use the label strategy to generate their label, they should use the `UseLabelStrategy` HOC*/
var SetLabelStrategy = (function (_super) {
    __extends(SetLabelStrategy, _super);
    function SetLabelStrategy(props) {
        var _this = _super.call(this, props) || this;
        // Capture the label strategy so that it can't change (not a good idea to change things on context)
        _this.labelStrategy = props.labelStrategy;
        return _this;
    }
    SetLabelStrategy.prototype.getChildContext = function () {
        var context = {
            labelStrategy: this.labelStrategy
        };
        return context;
    };
    SetLabelStrategy.prototype.render = function () {
        return React.createElement("div", null, this.props.children);
    };
    SetLabelStrategy.childContextTypes = LabelStrategyContextTypes;
    return SetLabelStrategy;
}(React.Component));
exports.SetLabelStrategy = SetLabelStrategy;
/* This clears any label strategy that might be on the context (see `SetLabelStrategy`),
* so that any descendant components won't use that label strategy
* This is useful for things like dialogs, which are usually placed at some arbitrary point
* in the component hierarchy because they have to go somewhere, and therefore don't necessarily
* want to inherit the provided label strategy.*/
var ResetLabelStrategy = (function (_super) {
    __extends(ResetLabelStrategy, _super);
    function ResetLabelStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResetLabelStrategy.prototype.getChildContext = function () {
        var context = {
            labelStrategy: undefined
        };
        return context;
    };
    ResetLabelStrategy.prototype.render = function () {
        return React.createElement("div", null, this.props.children);
    };
    ResetLabelStrategy.childContextTypes = LabelStrategyContextTypes;
    return ResetLabelStrategy;
}(React.Component));
exports.ResetLabelStrategy = ResetLabelStrategy;
/* This HOC wraps a component and makes it use the label strategy on the react context in order to generate its label
* It is mainly used by input components, like `Text` and `Select`
* In order to provide a label strategy on the context, use `SetLabelStrategy`*/
function UseLabelStrategy(Comp, fallbackLabelStrategy) {
    return _a = (function (_super) {
            __extends(UseLabelStrategyInternal, _super);
            function UseLabelStrategyInternal(props, context) {
                var _this = _super.call(this, props) || this;
                _this.labelStrategy = context.labelStrategy;
                return _this;
            }
            UseLabelStrategyInternal.prototype.render = function () {
                var _a = this.props, fieldName = _a.fieldName, label = _a.label, other = __rest(_a, ["fieldName", "label"]);
                var derivedLabel = label || (fieldName
                    ? generateLabel(fieldName, this.labelStrategy, fallbackLabelStrategy)
                    : undefined);
                return React.createElement(Comp, __assign({}, other, { label: derivedLabel }));
            };
            return UseLabelStrategyInternal;
        }(React.Component)),
        _a.contextTypes = LabelStrategyContextTypes,
        _a;
    var _a;
}
exports.default = UseLabelStrategy;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LabelStrategy\\LabelStrategy.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LabelStrategy\\LabelStrategy.tsx"); } } })();

/***/ }),
/* 175 */,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(14);
var BusyFromPromise = (function (_super) {
    __extends(BusyFromPromise, _super);
    function BusyFromPromise(props) {
        var _this = _super.call(this, props) || this;
        _this.current = null;
        _this.resetState = function (promise) {
            // don't turn off the busy indicator if a new promise is running
            // we don't worry about order of promises finishing here, callers
            // should maintain an array of "requests" and pass in Promise.all
            // on them when it updates so we only need to worry about latest.
            if (promise === _this.current) {
                _this.current = null;
                _this.setState({ busy: false });
            }
        };
        _this.determineState = function (props) {
            if (props.promise) {
                if (typeof props.promise === "boolean") {
                    _this.current = null;
                    return { busy: props.promise };
                }
                else {
                    _this.current = props.promise;
                    props.promise.then(function () { return _this.resetState(props.promise); }, function () { return _this.resetState(props.promise); });
                    return { busy: true };
                }
            }
            else {
                return { busy: false };
            }
        };
        _this.state = _this.determineState(props);
        return _this;
    }
    BusyFromPromise.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.promise !== this.props.promise) {
            this.setState(this.determineState(nextProps));
        }
    };
    BusyFromPromise.prototype.render = function () {
        return (this.props.children)(this.state.busy);
    };
    return BusyFromPromise;
}(BaseComponent_1.BaseComponent));
exports.default = BusyFromPromise;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BusyFromPromise\\BusyFromPromise.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BusyFromPromise\\BusyFromPromise.tsx"); } } })();

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(254);
var React = __webpack_require__(0);
var styles = __webpack_require__(1859);
var Select_1 = __webpack_require__(41);
var accountResource_1 = __webpack_require__(418);
var Note_1 = __webpack_require__(22);
var IconButton_1 = __webpack_require__(56);
var IconButtonList_1 = __webpack_require__(109);
var routeLinks_1 = __webpack_require__(20);
var InputWithActions_1 = __webpack_require__(145);
var AccountIcons_1 = __webpack_require__(740);
var BoundField_1 = __webpack_require__(95);
var AccountSelect = (function (_super) {
    __extends(AccountSelect, _super);
    function AccountSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (accountId) {
            var value = accountId === "" ? null : accountId;
            if (_this.props.validate) {
                var result = _this.props.validate(value);
                _this.setState({ error: result });
                if (_this.props.onValidate) {
                    _this.props.onValidate(result);
                }
            }
            _this.props.onChange(value);
        };
        _this.selectionRenderer = function (accountId) {
            var account = _this.props.items.find(function (acc) { return acc.Id === accountId; });
            if (!account) {
                return accountId;
            }
            return React.createElement("div", { className: styles.innerContainer },
                React.createElement("span", { className: styles.selectedIcon },
                    React.createElement(AccountIcons_1.AccountIcon, { accountType: account.AccountType })),
                " ",
                account.Name);
        };
        _this.goToAccounts = function () {
            window.open("#" + routeLinks_1.default.infrastructure.accounts.root, "_blank");
        };
        _this.onRequestRefresh = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ refreshing: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.props.onRequestRefresh()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.setState({ refreshing: false });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            error: null,
            refreshing: false
        };
        return _this;
    }
    AccountSelect.prototype.getItems = function () {
        var map = function (acc) { return ({ value: acc.Id, text: acc.Name, icon: React.createElement(AccountIcons_1.AccountIcon, { accountType: acc.AccountType }) }); };
        var types = (Array.isArray(this.props.type)) ? this.props.type : [this.props.type];
        return this.props.items.filter(function (a) { return types.find(function (t) { return a.AccountType === t; }); }).map(map);
    };
    AccountSelect.prototype.onlyTypeIs = function (type) {
        var types = (Array.isArray(this.props.type)) ? this.props.type : [this.props.type];
        return types.length === 1 && types[0] === type;
    };
    AccountSelect.prototype.render = function () {
        var _a = this.props, items = _a.items, onChange = _a.onChange, onValidate = _a.onValidate, onRequestRefresh = _a.onRequestRefresh, otherProps = __rest(_a, ["items", "onChange", "onValidate", "onRequestRefresh"]);
        var warning = "";
        if (this.onlyTypeIs(accountResource_1.AccountType.AzureSubscription)) {
            warning = "Only Azure management-certificate accounts may be selected.";
        }
        if (this.onlyTypeIs(accountResource_1.AccountType.AzureServicePrincipal)) {
            warning = "Only Azure service principal accounts may be selected.";
        }
        if (this.onlyTypeIs(accountResource_1.AccountType.AmazonWebServicesAccount)) {
            warning = "Only Amazon web service accounts may be selected.";
        }
        return (React.createElement("div", { className: styles.outerContainer },
            React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.default, __assign({ label: "Select account" }, otherProps, { allowFilter: true, onChange: this.handleChange, error: this.state.error || this.props.error, items: this.getItems(), selectionRenderer: this.selectionRenderer })), actions: React.createElement(IconButtonList_1.default, { buttons: this.buttons() }) }),
            warning && React.createElement(Note_1.default, null, warning)));
    };
    AccountSelect.prototype.buttons = function () {
        return [this.state.refreshing
                ? React.createElement(index_1.default, { show: true, inline: true })
                : React.createElement(IconButton_1.default, { onClick: this.onRequestRefresh, toolTipContent: "Refresh", icon: IconButton_1.Icon.Refresh }),
            React.createElement(IconButton_1.default, { toolTipContent: "Add", onClick: this.goToAccounts, icon: IconButton_1.Icon.Add })];
    };
    return AccountSelect;
}(React.Component));
exports.default = AccountSelect;
exports.BoundAccountSelect = BoundField_1.withBoundField(AccountSelect);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\AccountSelect\\AccountSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\AccountSelect\\AccountSelect.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 178 */,
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var material_ui_1 = __webpack_require__(92);
var Button_1 = __webpack_require__(51);
var BaseComponent_1 = __webpack_require__(60);
var BusyIndicator_1 = __webpack_require__(98);
var FilterSearchBox_1 = __webpack_require__(171);
var clientInstance_1 = __webpack_require__(10);
var lodash_1 = __webpack_require__(16);
var Section_1 = __webpack_require__(90);
var styles = __webpack_require__(1685);
var RequestRaceConditioner_1 = __webpack_require__(733);
var NumberedPagingBar_1 = __webpack_require__(672);
var PagingBaseComponent = (function (_super) {
    __extends(PagingBaseComponent, _super);
    function PagingBaseComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.requestRaceConditioner = new RequestRaceConditioner_1.default();
        _this.onFilter = function (_) { return true; };
        _this.onLoadMore = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var nextPageIndex, skip, requestUri, requestParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ loadingMore: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 5, 6]);
                        if (!(this.props.onLoadMore != null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.onLoadMore()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                    case 3:
                        nextPageIndex = this.state.currentPageIndex + 1;
                        this.setState({
                            currentPageIndex: nextPageIndex,
                        });
                        skip = nextPageIndex * this.state.itemsPerPage;
                        requestUri = this.state.data.Links["Template"];
                        requestParams = {
                            // Don't skip, just increase the take size.
                            take: (skip + this.state.itemsPerPage)
                        };
                        requestParams = this.addCommonRequestParameters(requestParams);
                        return [4 /*yield*/, this.requestRaceConditioner.avoidStaleResponsesForRequest(clientInstance_1.client.get(requestUri, requestParams), function (response) { return __awaiter(_this, void 0, void 0, function () {
                                var updatedItems;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.props.onNewItems) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.props.onNewItems(response.Items)];
                                        case 1:
                                            updatedItems = _a.sent();
                                            response.Items = updatedItems || [];
                                            _a.label = 2;
                                        case 2:
                                            this.setState({
                                                data: response,
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this.setState({ loadingMore: false });
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.onPageSelected = function (skip, p) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var requestUri, requestParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.state.data && this.state.data.Links)) return [3 /*break*/, 6];
                        this.setState({ loadingMore: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 5, 6]);
                        if (!(this.props.onPageSelected != null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.onPageSelected(skip, p)];
                    case 2:
                        _a.sent();
                        this.setState({
                            currentPageIndex: p,
                        });
                        return [2 /*return*/];
                    case 3:
                        requestUri = this.state.data.Links["Template"];
                        requestParams = {
                            skip: skip,
                            take: this.state.itemsPerPage,
                        };
                        requestParams = this.addCommonRequestParameters(requestParams);
                        return [4 /*yield*/, this.requestRaceConditioner.avoidStaleResponsesForRequest(clientInstance_1.client.get(requestUri, requestParams), function (response) { return __awaiter(_this, void 0, void 0, function () {
                                var updatedItems;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.props.onNewItems) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.props.onNewItems(response.Items)];
                                        case 1:
                                            updatedItems = _a.sent();
                                            response.Items = updatedItems || [];
                                            _a.label = 2;
                                        case 2:
                                            this.setState({
                                                data: response,
                                                currentPageIndex: p,
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this.setState({ loadingMore: false });
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.onSearch = function (keywordSearch) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.setState({ keywordSearch: keywordSearch, filter: keywordSearch, isSearching: true }, function () { return __awaiter(_this, void 0, void 0, function () {
                    var isShowingSearchResults;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.onPageSelected(0, 0)];
                            case 1:
                                _a.sent(); // New search should reset to page 0.
                                isShowingSearchResults = true;
                                if (!keywordSearch) {
                                    isShowingSearchResults = false;
                                }
                                this.setState({ isShowingSearchResults: isShowingSearchResults, isSearching: false });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        _this.onFilter = props.onFilter || _this.onFilter;
        _this.provideErrorHandling(_this.onLoadMore);
        _this.provideErrorHandling(_this.onPageSelected);
        _this.provideErrorHandling(_this.onSearch);
        _this.state = {
            filter: "",
            keywordSearch: "",
            isShowingSearchResults: false,
            loadingMore: true,
            isSearching: false,
            currentPageIndex: _this.props.currentPageIndex ? _this.props.currentPageIndex : 0,
            itemsPerPage: _this.props.initialData.ItemsPerPage,
        };
        return _this;
    }
    PagingBaseComponent.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var initialData, updatedItems;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.state.data != null) {
                            return [2 /*return*/];
                        }
                        initialData = this.props.initialData;
                        if (!this.props.onNewItems) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.onNewItems(initialData.Items)];
                    case 1:
                        updatedItems = _a.sent();
                        initialData.Items = updatedItems || [];
                        _a.label = 2;
                    case 2:
                        this.setState({
                            data: initialData,
                            loadingMore: false,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    PagingBaseComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.initialData !== nextProps.initialData) {
            this.setState({
                data: nextProps.initialData,
                loadingMore: false,
                currentPageIndex: this.props.currentPageIndex ? this.props.currentPageIndex : 0,
            });
        }
    };
    PagingBaseComponent.prototype.renderFilterSearchBox = function () {
        var _this = this;
        if (!this.props.filterSearchEnabled) {
            return null;
        }
        // We switch between a search box that either "filters" or "searches". ie. Filtering data in-line vs searching the API.
        var needToShowSearch = this.state.isShowingSearchResults || this.state.data.Items.length < this.state.data.TotalResults;
        var searchBoxHintText = this.props.filterHintText || (this.props.filterSearchEnabled && !needToShowSearch ? "Filter..." : "Search...");
        return React.createElement("div", { key: "filterSearch" },
            React.createElement(FilterSearchBox_1.default, { autoFocus: this.props.autoFocusOnFilterSearch, hintText: searchBoxHintText, debounceDelay: 500, onChange: function (keyword) { return _this.onFilterSearch(keyword); } }),
            this.props.filterSearchEnabled && needToShowSearch && this.props.apiSearchParams && this.props.apiSearchParams.length > 0 &&
                React.createElement(BusyIndicator_1.default, { show: this.state.isSearching, inline: true }));
    };
    PagingBaseComponent.prototype.onFilterSearch = function (keyword) {
        var needToShowSearch = this.state.isShowingSearchResults || this.state.data.Items.length < this.state.data.TotalResults;
        if (this.props.filterSearchEnabled && !needToShowSearch) {
            this.setState({ filter: keyword });
        }
        else {
            this.onSearch(keyword);
        }
    };
    PagingBaseComponent.prototype.renderFilterSearchComponents = function () {
        if (!this.props.filterSearchEnabled) {
            return null;
        }
        return this.props.showFilterWithinSection
            ? React.createElement(Section_1.Section, null, this.renderFilterSearchBox())
            : this.renderFilterSearchBox();
    };
    PagingBaseComponent.prototype.showPagingInNumberedStyle = function () {
        var _this = this;
        var data = this.state.data;
        return React.createElement(NumberedPagingBar_1.default, { totalItems: data.TotalResults, currentPageIndex: this.state.currentPageIndex, pageSize: data.ItemsPerPage, onPageSelected: function (s, p) { return _this.onPageSelected(s, p); } });
    };
    PagingBaseComponent.prototype.showPagingInLoadMoreStyle = function () {
        var _this = this;
        return (React.createElement(material_ui_1.ListItem, { onClick: function (e) { return _this.onLoadMore(); } },
            !this.state.loadingMore && React.createElement("div", { className: styles.loadMore },
                React.createElement(Button_1.ActionButton, { label: "Load more" })),
            this.state.loadingMore && React.createElement(BusyIndicator_1.default, { show: true })));
    };
    PagingBaseComponent.prototype.navigate = function (item) {
        var redirectTo = getNavigationUrl(this.props, item);
        if (!redirectTo) {
            return;
        }
        this.setState({ redirectTo: redirectTo });
    };
    PagingBaseComponent.prototype.addCommonRequestParameters = function (requestParams) {
        var _this = this;
        // If a keywordSearch has been provided, supply it for all potential apiSearchParams.
        // Eg. Some APIs have filters for both "name", "description" and "packageVersion" etc. So this lets us
        // quickly search them all for the given keyword.
        if (this.state.keywordSearch) {
            lodash_1.each(this.props.apiSearchParams, function (param) {
                requestParams[param] = _this.state.keywordSearch;
            });
        }
        // Consumers may want to supply additional request params for filters etc.
        if (this.props.additionalRequestParams) {
            this.props.additionalRequestParams.forEach(function (value, key) {
                requestParams[key] = value; // Do not encodeURIComponent here. That is the responsibility of our client's url resolving code.
            });
        }
        return requestParams;
    };
    return PagingBaseComponent;
}(BaseComponent_1.default));
exports.PagingBaseComponent = PagingBaseComponent;
function getNavigationUrl(_a, item) {
    var match = _a.match, onRowRedirectUrl = _a.onRowRedirectUrl;
    if (onRowRedirectUrl) {
        return onRowRedirectUrl(item);
    }
    else if (match && item.Id) {
        return match.url + "/" + item.Id;
    }
    return null;
}
exports.getNavigationUrl = getNavigationUrl;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PagingBaseComponent\\PagingBaseComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PagingBaseComponent\\PagingBaseComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var NamedResource = (function (_super) {
    __extends(NamedResource, _super);
    function NamedResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NamedResource;
}(resource_1.default));
exports.NamedResource = NamedResource;
var NewNamedResource = (function () {
    function NewNamedResource() {
    }
    return NewNamedResource;
}());
exports.NewNamedResource = NewNamedResource;
exports.default = NamedResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\namedResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\namedResource.ts"); } } })();

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1430);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1839);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var AccountVariableSelect_1 = __webpack_require__(696);
var form_1 = __webpack_require__(15);
var ExternalLink_1 = __webpack_require__(91);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var Text_1 = __webpack_require__(17);
var RadioButtonGroup_1 = __webpack_require__(33);
var Callout_1 = __webpack_require__(59);
var StringProperties = {
    "Octopus.Action.AwsAccount.Variable": "",
    "Octopus.Action.AwsAccount.UseInstanceRole": "",
    "Octopus.Action.Aws.AssumeRole": "",
    "Octopus.Action.Aws.AssumedRoleArn": "",
    "Octopus.Action.Aws.AssumedRoleSession": "",
    "Octopus.Action.Aws.Region": ""
};
var AllProperties = __assign({}, StringProperties);
/**
 * A component that displays the connection details for an AWS account
 */
var AwsLoginComponent = (function (_super) {
    __extends(AwsLoginComponent, _super);
    function AwsLoginComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AwsLoginComponent.prototype.shouldComponentUpdate = function (newProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(AllProperties, newProps, this.props);
    };
    AwsLoginComponent.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.AwsAccount.Variable|Octopus.Action.Aws.AssumedRoleArn|Octopus.Action.Aws.AssumedRoleSession", title: "AWS Account", help: "The AWS account details", summary: this.awsAccountSummary() },
                React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { resetValue: "False", value: this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"], onChange: function (x) {
                        _this.props.setProperties((_a = {}, _a["Octopus.Action.AwsAccount.UseInstanceRole"] = x, _a));
                        _this.props.setProperties((_b = {}, _b["Octopus.Action.AwsAccount.Variable"] = "", _b));
                        var _a, _b;
                    }, label: "Execute using the AWS service role for an EC2 instance" },
                    React.createElement(form_1.RadioButton, { value: "True", label: "Yes" }),
                    React.createElement(form_1.RadioButton, { value: "False", label: "No" })),
                this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"] === "False" && (this.props.projectId
                    ? React.createElement(AccountVariableSelect_1.BoundAccountVariableSelect, { projectId: this.props.projectId, resetValue: "", allowClear: true, doBusyTask: this.props.doBusyTask, value: this.props.properties["Octopus.Action.AwsAccount.Variable"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.AwsAccount.Variable"] = val, _a));
                            var _a;
                        } })
                    : React.createElement(Text_1.VariableLookupText, { label: "AWS Account variable", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.AwsAccount.Variable"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.AwsAccount.Variable"] = val, _a));
                            var _a;
                        } })),
                React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { resetValue: "False", value: this.props.properties["Octopus.Action.Aws.AssumeRole"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.AssumeRole"] = x, _a));
                        var _a;
                    }, label: "Assume a different AWS service role" },
                    React.createElement(form_1.RadioButton, { value: "True", label: "Yes" }),
                    React.createElement(form_1.RadioButton, { value: "False", label: "No" })),
                this.props.properties["Octopus.Action.Aws.AssumeRole"] === "True" &&
                    React.createElement("div", null,
                        React.createElement(Text_1.VariableLookupText, { label: "Assumed role ARN", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.AssumedRoleArn"], onChange: function (val) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.AssumedRoleArn"] = val, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.Aws.AssumedRoleArn") }),
                        React.createElement(Text_1.VariableLookupText, { label: "Assumed role session name", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.AssumedRoleSession"], onChange: function (val) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.AssumedRoleSession"] = val, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.Aws.AssumedRoleSession") }))),
            React.createElement(form_1.UnstructuredFormSection, null,
                React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                    "More information can be found regarding terminology for roles and assuming roles \u00A0",
                    React.createElement(ExternalLink_1.default, { href: "AwsDocsRolesTermsAndConcepts" }, "here"),
                    ".")));
    };
    AwsLoginComponent.prototype.awsAccountSummary = function () {
        var accountVariable = this.props.properties["Octopus.Action.AwsAccount.Variable"];
        var assumedRoleArn = this.props.properties["Octopus.Action.Aws.AssumedRoleArn"];
        var assumedRole = this.props.properties["Octopus.Action.Aws.AssumeRole"] === "True";
        var useInstanceRole = this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"] === "True";
        if (useInstanceRole) {
            return form_1.Summary.summary(React.createElement("span", null,
                "The AWS service role for an EC2 instance will be used ",
                assumedRole && assumedRoleArn &&
                    React.createElement("span", null,
                        " to assume the AWS service role ",
                        React.createElement("strong", null, assumedRoleArn))));
        }
        return accountVariable
            ? form_1.Summary.summary(React.createElement("span", null,
                "The AWS account ",
                React.createElement("strong", null, accountVariable),
                " will be used",
                assumedRole && assumedRoleArn && React.createElement("span", null,
                    " to assume the AWS service role ",
                    React.createElement("strong", null, assumedRoleArn))))
            : form_1.Summary.placeholder("The account variable has not been provided");
    };
    return AwsLoginComponent;
}(BaseComponent_1.BaseComponent));
exports.default = AwsLoginComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\aws\\awsLoginComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\aws\\awsLoginComponent.tsx"); } } })();

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var IconMenu_1 = __webpack_require__(569);
var IconButton_1 = __webpack_require__(63);
var MenuItem_1 = __webpack_require__(97);
var Divider_1 = __webpack_require__(143);
var more_vert_1 = __webpack_require__(1622);
var OpenDeleteDialogMenuItem_1 = __webpack_require__(784);
var PermissionCheck_1 = __webpack_require__(45);
var lodash_1 = __webpack_require__(16);
var BaseComponent_1 = __webpack_require__(14);
var OpenDialogMenuItem_1 = __webpack_require__(785);
var styles = __webpack_require__(1623);
var uiTestClasses_1 = __webpack_require__(77);
var OverflowMenuLink_1 = __webpack_require__(1625);
var OverflowMenuItemKind;
(function (OverflowMenuItemKind) {
    OverflowMenuItemKind[OverflowMenuItemKind["Delete"] = 0] = "Delete";
    OverflowMenuItemKind[OverflowMenuItemKind["Dialog"] = 1] = "Dialog";
    OverflowMenuItemKind[OverflowMenuItemKind["Generic"] = 2] = "Generic";
    OverflowMenuItemKind[OverflowMenuItemKind["Disabled"] = 3] = "Disabled";
    OverflowMenuItemKind[OverflowMenuItemKind["Navigation"] = 4] = "Navigation";
    OverflowMenuItemKind[OverflowMenuItemKind["Download"] = 5] = "Download";
    OverflowMenuItemKind[OverflowMenuItemKind["Remove"] = 6] = "Remove";
})(OverflowMenuItemKind || (OverflowMenuItemKind = {}));
function isGroup(item) {
    return Array.isArray(item);
}
function isOverflowMenuDialogItem(item) {
    return item.kind === OverflowMenuItemKind.Dialog;
}
function isOverflowMenuDeleteItem(item) {
    return item.kind === OverflowMenuItemKind.Delete;
}
function isOverflowMenuRemoveItem(item) {
    return item.kind === OverflowMenuItemKind.Remove;
}
function isOverflowMenuDownloadItem(item) {
    return item.kind === OverflowMenuItemKind.Download;
}
function isOverflowMenuNavLink(item) {
    return item.kind === OverflowMenuItemKind.Navigation;
}
function isOverflowMenuDisabledItem(item) {
    return item.kind === OverflowMenuItemKind.Disabled;
}
function isOverflowMenuGenericItem(item) {
    return item.kind === OverflowMenuItemKind.Generic;
}
var OverflowMenu = (function (_super) {
    __extends(OverflowMenu, _super);
    function OverflowMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverflowMenu.dialogItem = function (text, child, permission) {
        return { text: text, child: child, kind: OverflowMenuItemKind.Dialog, permission: permission };
    };
    OverflowMenu.removeItem = function (text, title, onClick, content, permission) {
        return { text: text, title: title, onClick: onClick, content: content, permission: permission, kind: OverflowMenuItemKind.Remove };
    };
    OverflowMenu.deleteItem = function (text, title, onClick, content, permission) {
        return { text: text, title: title, onClick: onClick, content: content, permission: permission, kind: OverflowMenuItemKind.Delete };
    };
    OverflowMenu.deleteItemDefault = function (name, onClick, permission, customMessage) {
        return {
            text: "Delete",
            title: "Are you sure you want to delete this " + name + "?",
            onClick: onClick,
            permission: permission,
            kind: OverflowMenuItemKind.Delete,
            content: React.createElement("div", null,
                React.createElement("p", null,
                    "Deleting this ",
                    name,
                    " is permanent, there is no going back."),
                customMessage && React.createElement("p", null, customMessage),
                React.createElement("p", null, "Do you wish to continue?"))
        };
    };
    OverflowMenu.navItem = function (text, path, queryString, permission) {
        return { text: text, path: path, queryString: queryString, permission: permission, kind: OverflowMenuItemKind.Navigation };
    };
    OverflowMenu.disabledItem = function (text, reason) {
        return { text: text, reason: reason, kind: OverflowMenuItemKind.Disabled };
    };
    OverflowMenu.item = function (text, onClick, permission) {
        return { text: text, onClick: onClick, permission: permission, kind: OverflowMenuItemKind.Generic };
    };
    OverflowMenu.downloadItem = function (text, filename, link) {
        return { text: text, link: link, filename: filename, kind: OverflowMenuItemKind.Download };
    };
    OverflowMenu.prototype.render = function () {
        var _this = this;
        // Permissions may cause null entries in our menuItems, so we do null checking before map.
        var result = this.props.menuItems && this.props.menuItems.filter(function (item) { return !!item; }).map(function (item, index) {
            if (isGroup(item)) {
                var results = item.map(function (groupItem) { return _this.convert(groupItem); });
                if (index < _this.props.menuItems.length - 1) {
                    results.push({ menuItem: React.createElement(Divider_1.default, { key: index }) });
                }
                return results;
            }
            return [_this.convert(item)];
        });
        var dialogs = [];
        var menuItems = lodash_1.flatten(result).filter(function (r) { return !!r; }).map(function (r) {
            if (r.dialog) {
                dialogs.push(r.dialog);
            }
            return r.menuItem;
        });
        return React.createElement("div", { onClick: this.iconMenuOnClickOverride },
            dialogs,
            menuItems && menuItems.length > 0 &&
                React.createElement(IconMenu_1.default, { iconButtonElement: React.createElement(IconButton_1.default, { className: uiTestClasses_1.overflowMenuClass + " " + styles.menuIcon, tabIndex: this.props.tabIndex, title: "Options" },
                        React.createElement(more_vert_1.default, { focusable: this.props.tabIndex === -1 ? "false" : "", tabIndex: this.props.tabIndex, color: this.props.colorOverride ? this.props.colorOverride : "initial" })), anchorOrigin: { horizontal: "right", vertical: "bottom" }, targetOrigin: { horizontal: "right", vertical: "top" } }, menuItems));
    };
    OverflowMenu.prototype.iconMenuOnClickOverride = function (e) {
        e.preventDefault();
        e.stopPropagation(); //prevent this click toggling expanders (when IconMenus are used in expanders).
    };
    OverflowMenu.prototype.convertDeleteMenuItem = function (item) {
        var dialog;
        var dialogMenuItem = React.createElement(OpenDeleteDialogMenuItem_1.default, { ref: function (d) { return dialog = d; }, label: item.text, disabled: false, dialogTitle: item.title, key: this.props.menuKey + "-" + item.text, onDeleteClick: item.onClick }, item.content);
        return {
            menuItem: React.createElement(MenuItem_1.default, { primaryText: item.text, key: this.props.menuKey + "-" + item.text, onClick: function () { return dialog.onClick(); } }),
            dialog: dialogMenuItem
        };
    };
    OverflowMenu.prototype.convert = function (item) {
        if (isOverflowMenuDialogItem(item)) {
            if (item.permission && !PermissionCheck_1.isAllowed(item.permission)) {
                return this.alternate(item.permission.alternate);
            }
            return this.convertDialogMenuItem(item);
        }
        if (isOverflowMenuDeleteItem(item)) {
            if (item.permission && !PermissionCheck_1.isAllowed(item.permission)) {
                return this.alternate(item.permission.alternate);
            }
            return this.convertDeleteMenuItem(item);
        }
        if (isOverflowMenuRemoveItem(item)) {
            if (item.permission && !PermissionCheck_1.isAllowed(item.permission)) {
                return this.alternate(item.permission.alternate);
            }
            return this.convertRemoveMenuItem(item);
        }
        if (isOverflowMenuDownloadItem(item)) {
            if (item.permission && !PermissionCheck_1.isAllowed(item.permission)) {
                return this.alternate(item.permission.alternate);
            }
            return {
                menuItem: React.createElement(MenuItem_1.default, { primaryText: item.text, key: this.props.menuKey + "-" + item.text, containerElement: React.createElement(OverflowMenuLink_1.default, { resolve: false, downloadFileName: item.filename, to: item.link }) })
            };
        }
        if (isOverflowMenuNavLink(item)) {
            if (item.permission && !PermissionCheck_1.isAllowed(item.permission)) {
                return this.alternate(item.permission.alternate);
            }
            return {
                menuItem: React.createElement(MenuItem_1.default, { primaryText: item.text, key: this.props.menuKey + "-" + item.text, containerElement: React.createElement(OverflowMenuLink_1.default, { to: { pathname: item.path, search: item.queryString } }) })
            };
        }
        if (isOverflowMenuDisabledItem(item)) {
            return {
                menuItem: React.createElement(MenuItem_1.default, { key: this.props.menuKey + "-" + item.text, disabled: true },
                    React.createElement("a", { href: "#", onClick: function (e) { return e.preventDefault(); }, className: styles.disabledItem, title: item.reason }, item.text))
            };
        }
        if (isOverflowMenuGenericItem(item)) {
            if (item.permission && !PermissionCheck_1.isAllowed(item.permission)) {
                return this.alternate(item.permission.alternate);
            }
        }
        return {
            menuItem: React.createElement(MenuItem_1.default, { primaryText: item.text, key: this.props.menuKey + "-" + item.text, onClick: item.onClick })
        };
    };
    OverflowMenu.prototype.convertRemoveMenuItem = function (item) {
        var dialog;
        var dialogMenuItem = React.createElement(OpenDeleteDialogMenuItem_1.default, { ref: function (d) { return dialog = d; }, label: item.text, disabled: false, dialogTitle: item.title, deleteButtonLabel: "Remove", deleteButtonBusyLabel: "Removing", key: this.props.menuKey + "-" + item.text, onDeleteClick: item.onClick }, item.content);
        return {
            menuItem: React.createElement(MenuItem_1.default, { primaryText: item.text, key: this.props.menuKey + "-" + item.text, onClick: function () { return dialog.onClick(); } }),
            dialog: dialogMenuItem
        };
    };
    OverflowMenu.prototype.convertDialogMenuItem = function (item) {
        var dialog;
        var dialogMenuItem = React.createElement(OpenDialogMenuItem_1.default, { ref: function (d) { return dialog = d; }, label: item.text, key: this.props.menuKey + "-" + item.text }, item.child);
        return {
            menuItem: React.createElement(MenuItem_1.default, { primaryText: item.text, key: this.props.menuKey + "-" + item.text, onClick: function () { return dialog.getWrappedInstance().onClick(); } }),
            dialog: dialogMenuItem
        };
    };
    OverflowMenu.prototype.alternate = function (alternate) {
        return alternate && { menuItem: React.createElement(MenuItem_1.default, { key: alternate, primaryText: alternate }) };
    };
    return OverflowMenu;
}(BaseComponent_1.BaseComponent));
exports.default = OverflowMenu;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Menu\\OverflowMenu.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Menu\\OverflowMenu.tsx"); } } })();

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fontoctopus.af93096ee4f17f3ce6d6363747b45e97.hashedasset.eot";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StringHelper_1 = __webpack_require__(458);
exports.default = StringHelper_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\StringHelper\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\StringHelper\\index.tsx"); } } })();

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RaisedButton_1 = __webpack_require__(217);
var FlatButton_1 = __webpack_require__(101);
var URI = __webpack_require__(106);
var colors_1 = __webpack_require__(32);
var styles = __webpack_require__(243);
var InternalRedirect_1 = __webpack_require__(40);
var NavigationButtonType;
(function (NavigationButtonType) {
    NavigationButtonType[NavigationButtonType["Primary"] = 0] = "Primary";
    NavigationButtonType[NavigationButtonType["Secondary"] = 1] = "Secondary";
})(NavigationButtonType = exports.NavigationButtonType || (exports.NavigationButtonType = {}));
var NavigationButton = (function (_super) {
    __extends(NavigationButton, _super);
    function NavigationButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function (e) {
            e.preventDefault();
            _this.setState({ navigate: true });
        };
        return _this;
    }
    NavigationButton.prototype.getPath = function () {
        if (typeof this.props.href === "string") {
            return this.props.href;
        }
        var query = URI.buildQuery(this.props.href.search);
        return {
            pathname: this.props.href.path,
            search: "?" + query
        };
    };
    NavigationButton.prototype.render = function () {
        if (this.state && this.state.navigate) {
            if (this.props.external) {
                this.setState({ navigate: false });
                window.open(this.props.href);
            }
            else {
                return React.createElement(InternalRedirect_1.default, { to: this.getPath(), push: true });
            }
        }
        switch (this.props.type) {
            case NavigationButtonType.Primary:
                var labelStylePrimary = {
                    fontSize: "0.8125rem",
                };
                return React.createElement(RaisedButton_1.default, { onClick: this.handleOnClick, label: this.props.label, title: this.props.label, icon: this.props.icon, disabled: this.props.disabled, backgroundColor: colors_1.secondaryDark, labelColor: colors_1.white, labelStyle: labelStylePrimary, disabledBackgroundColor: colors_1.disabledBackground, disabledLabelColor: colors_1.white, className: styles.globalActionButton });
            default:
                var labelStyle = {
                    color: this.props.disabled ? colors_1.secondaryText : colors_1.primary,
                    opacity: 1,
                    fontSize: "0.8125rem",
                };
                return React.createElement(FlatButton_1.default, { onClick: this.handleOnClick, label: this.props.label, title: this.props.label, icon: this.props.icon, labelStyle: labelStyle, disabled: this.props.disabled, className: styles.globalActionButton });
        }
    };
    return NavigationButton;
}(React.Component));
exports.NavigationButton = NavigationButton;
exports.default = NavigationButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Button\\NavigationButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Button\\NavigationButton.tsx"); } } })();

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InternalLink_1 = __webpack_require__(42);
exports.default = InternalLink_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\InternalLink\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\InternalLink\\index.tsx"); } } })();

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Markdown_1 = __webpack_require__(136);
var styles = __webpack_require__(1716);
// This is purely to give us a styling wrapper for all resource descriptions (eg. when shown in lists etc).
var MarkdownDescription = function (props) {
    return props.markup ? React.createElement("div", { className: styles.description },
        React.createElement(Markdown_1.default, { markup: props.markup })) : null;
};
exports.default = MarkdownDescription;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MarkdownDescription\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MarkdownDescription\\index.tsx"); } } })();

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_tippy_1 = __webpack_require__(1242);
__webpack_require__(1244);
var ToolTipPosition;
(function (ToolTipPosition) {
    ToolTipPosition["Right"] = "right";
    ToolTipPosition["Left"] = "left";
    ToolTipPosition["Top"] = "top";
    ToolTipPosition["Bottom"] = "bottom";
})(ToolTipPosition = exports.ToolTipPosition || (exports.ToolTipPosition = {}));
var ToolTip = function (props) {
    var content = props.content;
    if (typeof content === "function") {
        content = content();
    }
    var position = props.position ? props.position : ToolTipPosition.Top;
    return React.createElement(react_tippy_1.Tooltip, { open: props.open, trigger: props.trigger, arrow: true, position: position, html: React.createElement("span", null, content) }, props.children);
};
exports.default = ToolTip;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ToolTip\\ToolTip.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ToolTip\\ToolTip.tsx"); } } })();

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Tag_1 = __webpack_require__(280);
exports.default = Tag_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Tag\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Tag\\index.tsx"); } } })();

/***/ }),
/* 217 */,
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DimensionTypes;
(function (DimensionTypes) {
    DimensionTypes[DimensionTypes["None"] = 0] = "None";
    DimensionTypes[DimensionTypes["Release"] = 1] = "Release";
    DimensionTypes[DimensionTypes["Channel"] = 2] = "Channel";
    DimensionTypes[DimensionTypes["Environment"] = 3] = "Environment";
    DimensionTypes[DimensionTypes["Tenant"] = 4] = "Tenant";
    DimensionTypes[DimensionTypes["TagSet"] = 5] = "TagSet";
    DimensionTypes[DimensionTypes["Project"] = 6] = "Project";
    DimensionTypes[DimensionTypes["ProjectGroup"] = 7] = "ProjectGroup";
    DimensionTypes[DimensionTypes["ProjectName"] = 8] = "ProjectName"; //for filtering only
})(DimensionTypes || (DimensionTypes = {}));
exports.DimensionTypes = DimensionTypes;
var DimensionGetters = (_a = {},
    _a[DimensionTypes.Channel] = function (item) { return item.ChannelId; },
    _a[DimensionTypes.Release] = function (item) { return item.ReleaseId; },
    _a[DimensionTypes.Environment] = function (item) { return item.EnvironmentId; },
    _a[DimensionTypes.Tenant] = function (item) { return item.TenantId; },
    _a[DimensionTypes.Project] = function (item) { return item.ProjectId; },
    _a[DimensionTypes.None] = function (item) { return null; },
    _a);
exports.DimensionGetters = DimensionGetters;
var _a;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DataCube.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DataCube.tsx"); } } })();

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ProjectActions = {
    PROJECT_FETCHED: "PROJECT_FETCHED",
    PROJECT_SAVED: "PROJECT_SAVED",
    PROJECT_STEPS_UPDATED: "PROJECT_STEPS_UPDATED",
    PROJECT_UPDATED: "PROJECT_UPDATED",
};
function projectFetched(state) {
    return { type: ProjectActions.PROJECT_FETCHED, state: state };
}
exports.projectFetched = projectFetched;
function projectSaved(newState) {
    return { type: ProjectActions.PROJECT_SAVED, state: newState };
}
exports.projectSaved = projectSaved;
function projectStepsUpdated(numberOfSteps) {
    var _this = this;
    // We need to update just the numberOfSteps property of our currentProject...
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var currentProject;
        return __generator(this, function (_a) {
            currentProject = getState().projectsArea.currentProject;
            dispatch(projectUpdated({
                id: currentProject.id,
                name: currentProject.name,
                description: currentProject.description,
                logoUrl: currentProject.logoUrl,
                isDisabled: currentProject.isDisabled,
                slug: currentProject.slug,
                numberOfSteps: numberOfSteps,
            }));
            return [2 /*return*/];
        });
    }); };
}
exports.projectStepsUpdated = projectStepsUpdated;
function projectUpdated(state) {
    return { type: ProjectActions.PROJECT_UPDATED, state: state };
}
exports.projectUpdated = projectUpdated;
var projectsArea = function (state, action) {
    if (state === void 0) { state = { currentProject: null }; }
    switch (action.type) {
        case ProjectActions.PROJECT_SAVED:
        case ProjectActions.PROJECT_FETCHED:
        case ProjectActions.PROJECT_STEPS_UPDATED:
        case ProjectActions.PROJECT_UPDATED:
            var project = action.state;
            return {
                currentProject: {
                    name: project.name,
                    description: project.description,
                    logoUrl: project.logoUrl,
                    id: project.id,
                    isDisabled: project.isDisabled,
                    numberOfSteps: project.numberOfSteps,
                    slug: project.slug
                },
            };
        default:
            return state;
    }
};
exports.default = projectsArea;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\reducers\\projectsArea.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\reducers\\projectsArea.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var material_ui_1 = __webpack_require__(92);
var Popover = (function (_super) {
    __extends(Popover, _super);
    function Popover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Popover.prototype.render = function () {
        return React.createElement(material_ui_1.Popover, __assign({ scrollableContainer: "window" }, this.props), this.props.children);
    };
    return Popover;
}(React.Component));
exports.default = Popover;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Popover\\Popover.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Popover\\Popover.tsx"); } } })();

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StringHelper_1 = __webpack_require__(211);
var PageTitleHelper = (function () {
    function PageTitleHelper() {
    }
    PageTitleHelper.setPageTitle = function (title, breadcrumbTitle) {
        // This intentionally only sets the title if we're given one (don't set a default here). This lets us
        // call this helper in a fall-through style. ie. From our layouts first (via AreaTitle), then through to the
        // page (via PaperLayout).
        if (title && typeof title === "string" && title !== StringHelper_1.default.ellipsis) {
            var octopusDeploy = "Octopus Deploy";
            var pageTitle = octopusDeploy;
            // tslint:disable-next-line:prefer-conditional-expression
            if (breadcrumbTitle) {
                pageTitle = breadcrumbTitle + " > " + title + " - " + octopusDeploy; // Similar to TeamCity, show the most-relevant title first.
            }
            else {
                pageTitle = title + " - " + octopusDeploy; // Similar to TeamCity, show the most-relevant title first.
            }
            document.title = pageTitle;
        }
    };
    PageTitleHelper.setRootPageTitle = function () {
        document.title = "Octopus Deploy";
    };
    return PageTitleHelper;
}());
exports.default = PageTitleHelper;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\PageTitleHelper\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\PageTitleHelper\\index.tsx"); } } })();

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RemoveItemsList_1 = __webpack_require__(142);
var Text_1 = __webpack_require__(17);
var form_1 = __webpack_require__(15);
var ActionButton_1 = __webpack_require__(50);
var styles = __webpack_require__(1888);
var cn = __webpack_require__(19);
var KeyValueRemoveItemsList = (function (_super) {
    __extends(KeyValueRemoveItemsList, _super);
    function KeyValueRemoveItemsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return KeyValueRemoveItemsList;
}(RemoveItemsList_1.RemoveItemsList));
var noop = function () { return undefined; };
var KeyValueEditList = (function (_super) {
    __extends(KeyValueEditList, _super);
    function KeyValueEditList(props) {
        var _this = _super.call(this, props) || this;
        _this.adding = false;
        _this.handleRemoveRow = function (item) {
            var data = _this.state.source;
            data.splice(data.indexOf(item), 1);
            _this.invokeOnChange(data);
        };
        _this.handleRowRef = function (idx) { return function (input) {
            if (input && _this.adding && idx === 0) {
                input.focus();
                _this.adding = false;
            }
        }; };
        _this.handleKeyChange = function (idx) { return function (val) {
            var data = _this.state.source;
            data[idx].key = val;
            _this.invokeOnChange(data);
        }; };
        _this.handleValueChange = function (idx) { return function (val) {
            var data = _this.state.source;
            data[idx].value = val;
            _this.invokeOnChange(data);
        }; };
        _this.invokeOnChange = function (data) {
            _this.props.onChange(data.slice());
        };
        _this.handleAddClick = function () {
            _this.adding = true;
            _this.setState(function (prev) { return (__assign({}, prev, { source: prev.source.concat([{ key: "", value: "" }]) })); });
        };
        _this.renderRow = function (item, idx) {
            var fields = [React.createElement("div", { className: cn(styles.textControl, styles.textControlKey), key: "key" }, _this.props.hideBindOnKey
                    ? React.createElement(form_1.Text, { textInputRef: _this.props.reverseLayout ? noop : _this.handleRowRef(idx), value: item.key, onChange: _this.handleKeyChange(idx), label: _this.props.keyLabel, hintText: _this.props.keyHintText })
                    : React.createElement(Text_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, textInputRef: _this.props.reverseLayout ? noop : _this.handleRowRef(idx), value: item.key, onChange: _this.handleKeyChange(idx), label: _this.props.keyLabel, hintText: _this.props.keyHintText })),
                React.createElement("span", { className: styles.separator, key: "seperator" }, _this.props.separator),
                React.createElement("div", { className: styles.textControl, key: "value" },
                    React.createElement(Text_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, key: "value", textInputRef: _this.props.reverseLayout ? _this.handleRowRef(idx) : noop, value: item.value, onChange: _this.handleValueChange(idx), label: _this.props.valueLabel, hintText: _this.props.valueHintText }))];
            if (_this.props.reverseLayout) {
                fields = fields.reverse();
            }
            return React.createElement("div", { key: "KVI-" + idx, className: styles.itemContainer }, fields);
        };
        _this.state = {
            source: props.items()
        };
        return _this;
    }
    KeyValueEditList.prototype.render = function () {
        var actionButton = React.createElement(ActionButton_1.default, { key: "Add", label: "Add " + this.props.name, onClick: this.handleAddClick });
        return React.createElement(KeyValueRemoveItemsList, { listActions: [actionButton], data: this.state.source, onRemoveRow: this.handleRemoveRow, onRow: this.renderRow, clearButtonToolTip: "Remove " + this.props.name });
    };
    return KeyValueEditList;
}(React.PureComponent));
exports.KeyValueEditList = KeyValueEditList;
function stringToKeyValues(value) {
    if (value === null || value === undefined) {
        return [];
    }
    try {
        var source_1 = JSON.parse(value || "{}");
        return Object.keys(source_1).reduce(function (arr, key) {
            arr.push({ key: key, value: source_1[key] });
            return arr;
        }, []);
    }
    catch (e) {
        return [];
    }
}
function keyValuesToHash(values) {
    return values.reduce(function (idx, item) {
        idx[item.key] = item.value;
        return idx;
    }, {});
}
var StringKeyValueEditList = function (_a) {
    var items = _a.items, onChange = _a.onChange, rest = __rest(_a, ["items", "onChange"]);
    return (React.createElement(KeyValueEditList, __assign({ items: function () { return stringToKeyValues(items); }, onChange: function (values) { return onChange(JSON.stringify(keyValuesToHash(values))); } }, rest)));
};
exports.default = StringKeyValueEditList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EditList\\KeyValueEditList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EditList\\KeyValueEditList.tsx"); } } })();

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var react_router_1 = __webpack_require__(69);
var exposeComponentAsClass_1 = __webpack_require__(369);
var resolvePathWithSpaceId_1 = __webpack_require__(131);
var isUrlActive_1 = __webpack_require__(370);
var toPath_1 = __webpack_require__(1439);
var InternalNavLink = function (props) {
    var resolvedTo = resolvePathWithSpaceId_1.resolvePathWithSpaceId(props.to, props.match.params.spaceId);
    /* tslint:disable:jsx-ban-elements */
    return React.createElement(react_router_dom_1.NavLink, { className: props.className, key: props.to, to: resolvedTo, exact: props.exact, isActive: function () { return isUrlActive_1.isUrlActive(props.location.pathname, props.match.params.spaceId, toPath_1.toPath(resolvedTo), props.exact); }, activeClassName: props.activeClassName }, props.children);
};
exports.default = exposeComponentAsClass_1.exposeComponentAsClass(react_router_1.withRouter(InternalNavLink));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\InternalNavLink\\InternalNavLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\InternalNavLink\\InternalNavLink.tsx"); } } })();

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(67);
var Feature;
(function (Feature) {
    Feature[Feature["MultiTenancy"] = 0] = "MultiTenancy";
    Feature[Feature["CommunityActionTemplates"] = 1] = "CommunityActionTemplates";
    Feature[Feature["BuiltInRepoSync"] = 2] = "BuiltInRepoSync";
})(Feature = exports.Feature || (exports.Feature = {}));
var FeatureToggle = function (props) {
    var featureStatus;
    switch (props.feature) {
        case Feature.MultiTenancy:
            featureStatus = props.features.isMultiTenancyEnabled;
            break;
        case Feature.CommunityActionTemplates:
            featureStatus = props.features.isCommunityActionTemplatesEnabled;
            break;
        case Feature.BuiltInRepoSync:
            featureStatus = props.features.isBuiltInRepoSyncEnabled;
            break;
    }
    if ((featureStatus && props.enabled) || (!featureStatus && !props.enabled)) {
        return (React.createElement("span", null, props.children));
    }
    return null;
};
FeatureToggle.defaultProps = { enabled: true };
var mapStateToProps = function (state) {
    return {
        features: state.configurationArea.features
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(FeatureToggle);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FeatureToggle\\FeatureToggle.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FeatureToggle\\FeatureToggle.tsx"); } } })();

/***/ }),
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DeploymentStepResource = (function () {
    function DeploymentStepResource() {
    }
    return DeploymentStepResource;
}());
exports.DeploymentStepResource = DeploymentStepResource;
var StartTrigger;
(function (StartTrigger) {
    StartTrigger["StartWithPrevious"] = "StartWithPrevious";
    StartTrigger["StartAfterPrevious"] = "StartAfterPrevious";
})(StartTrigger = exports.StartTrigger || (exports.StartTrigger = {}));
var RunCondition;
(function (RunCondition) {
    RunCondition["Success"] = "Success";
    RunCondition["Failure"] = "Failure";
    RunCondition["Always"] = "Always";
    RunCondition["Variable"] = "Variable";
})(RunCondition = exports.RunCondition || (exports.RunCondition = {}));
var PackageRequirement;
(function (PackageRequirement) {
    PackageRequirement["LetOctopusDecide"] = "LetOctopusDecide";
    PackageRequirement["BeforePackageAcquisition"] = "BeforePackageAcquisition";
    PackageRequirement["AfterPackageAcquisition"] = "AfterPackageAcquisition";
})(PackageRequirement = exports.PackageRequirement || (exports.PackageRequirement = {}));
exports.default = DeploymentStepResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\deploymentStepResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\deploymentStepResource.ts"); } } })();

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getCurrentValue = function (id) {
    return localStorage.getItem("NotificationItemValue-" + id);
};
exports.getCurrentValue = getCurrentValue;
var setCurrentValue = function (id, value) {
    if (value === void 0) { value = new Date() + ""; }
    localStorage.setItem("NotificationItemValue-" + id, value);
};
exports.setCurrentValue = setCurrentValue;
var clearValue = function (id) {
    localStorage.removeItem("NotificationItemValue-" + id);
};
exports.clearValue = clearValue;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\NotificationPoller\\notificationLocalState.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\NotificationPoller\\notificationLocalState.ts"); } } })();

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Environment = (function () {
    function Environment() {
    }
    Environment.isInDevelopmentMode = function () {
        return !"production" || "production" !== "production";
    };
    return Environment;
}());
exports.default = Environment;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\environment.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\environment.ts"); } } })();

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var logger_1 = __webpack_require__(99);
var ErrorPanel_1 = __webpack_require__(83);
var clientInstance_1 = __webpack_require__(10);
var StackTrace = __webpack_require__(1216);
var ErrorBoundary = (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.stringify = function (frame) {
            var normalizedFrame = __assign({}, frame, { fileName: _this.normalizeFileName(frame.fileName) });
            return normalizedFrame.functionName + " (" + normalizedFrame.fileName + ":" + normalizedFrame.lineNumber + ":" + normalizedFrame.columnNumber + ")";
        };
        _this.state = {};
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        logger_1.default.error(error);
        logger_1.default.error(errorInfo);
        this.setState({ error: { originalError: error, info: errorInfo } });
        this.mapToOriginalSourceCode(error);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.error) {
            return React.createElement(ErrorPanel_1.default, { message: "An unexpected error occurred in Octopus v" + clientInstance_1.client.version + ": \"" + this.state.error.originalError.name + ": " + this.state.error.originalError.message + "\"", details: this.state.error.info.componentStack.split("\n").slice(1), fullException: this.state.error.mappedStackTrace || this.state.error.originalError.stack });
        }
        return this.props.children;
    };
    ErrorBoundary.prototype.mapToOriginalSourceCode = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            var frames, mappedStackTrace;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, StackTrace.fromError(error)];
                    case 1:
                        frames = _a.sent();
                        mappedStackTrace = error.stack.split("\n")[0] + "\n\n" + frames.map(this.stringify).join("\n");
                        this.setState(function (prevState) { return (__assign({}, prevState, { error: __assign({}, prevState.error, { mappedStackTrace: mappedStackTrace }) })); });
                        return [2 /*return*/];
                }
            });
        });
    };
    ErrorBoundary.prototype.normalizeFileName = function (fileName) {
        var index = Math.max(fileName.indexOf("/app"), fileName.indexOf("/node_modules"));
        if (index === -1) {
            return fileName;
        }
        return fileName.substr(index);
    };
    return ErrorBoundary;
}(React.Component));
exports.default = ErrorBoundary;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ErrorBoundary\\ErrorBoundary.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ErrorBoundary\\ErrorBoundary.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1189);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1205);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1246);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BusyIndicator_1 = __webpack_require__(98);
exports.default = BusyIndicator_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BusyIndicator\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BusyIndicator\\index.tsx"); } } })();

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1593);
var InputLabel = function (props) {
    return React.createElement("div", { className: styles.label }, props.label);
};
exports.default = InputLabel;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\InputLabel\\InputLabel.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\InputLabel\\InputLabel.tsx"); } } })();

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(139);
var styles = __webpack_require__(116);
var uiTestClasses_1 = __webpack_require__(77);
var FormSectionBase = (function (_super) {
    __extends(FormSectionBase, _super);
    function FormSectionBase(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleShowMoreInfo = function (e) {
            e.preventDefault();
            e.stopPropagation(); //prevent clicking the link toggling the panel
            _this.setState(function (state) { return ({ moreInformationExpanded: !state.moreInformationExpanded }); });
        };
        _this.handleMoreInfoClick = function (content) {
            _this.setState({
                moreInformationExpanded: true,
                moreInformation: content
            });
        };
        _this.hideMoreInfo = function (e) {
            e.preventDefault();
            _this.setState({
                moreInformationExpanded: false
            });
        };
        _this.isMoreInfo = function (child) {
            return child.props && child.props.hasOwnProperty("isMoreInfo");
        };
        _this.renderChild = function (child) {
            if (!child) {
                return child;
            }
            var children = child.props && child.props.children
                ? { children: _this.renderChildren(child.props.children) }
                : null;
            if (_this.isMoreInfo(child)) {
                return React.cloneElement(child, __assign({}, child.props, { onClick: _this.handleMoreInfoClick }));
            }
            if (_this.alterChild) {
                child = _this.alterChild(child);
            }
            var props = children ? __assign({}, child.props, children) : child.props;
            return React.isValidElement(child) ? React.cloneElement(child, props) : child;
        };
        _this.renderChildren = function (children) {
            return React.Children.map(children, _this.renderChild);
        };
        _this.state = {
            moreInformationExpanded: false,
            moreInformation: null
        };
        return _this;
    }
    FormSectionBase.prototype.title = function (title, subtitle) {
        return React.createElement("div", { className: styles.cardTitleContainer },
            React.createElement("span", { className: uiTestClasses_1.formSectionTitleClass + " " + styles.cardTitle }, title),
            subtitle);
    };
    FormSectionBase.prototype.help = function (help) {
        return React.createElement("span", { className: styles.cardSubTitle }, this.renderChild(help || React.createElement("div", null)));
    };
    FormSectionBase.prototype.body = function (className, expandable) {
        return React.createElement(Card_1.CardMedia, { className: uiTestClasses_1.formSectionBodyClass + " " + className, expandable: expandable },
            React.createElement("div", null, this.renderChildren(this.props.children)));
    };
    FormSectionBase.prototype.moreInformation = function () {
        return this.state.moreInformationExpanded
            ? React.createElement("div", { className: styles.moreInformation },
                React.createElement("div", { className: styles.hide },
                    React.createElement("a", { href: "#", onClick: this.hideMoreInfo }, "hide")),
                this.state.moreInformation)
            : React.createElement("span", null);
    };
    return FormSectionBase;
}(React.Component));
exports.FormSectionBase = FormSectionBase;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\FormSectionBase.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\FormSectionBase.tsx"); } } })();

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// The visibility of dialogs is stored in the Redux store so we need make sure each dialog is identified by
// a unique value. Otherwise, we risk opening multiple unrelated dialogs at the same time.
var UniqueSequenceGenerator_1 = __webpack_require__(364);
var DialogIdGenerator = (function () {
    function DialogIdGenerator() {
        this.sequence = new UniqueSequenceGenerator_1.UniqueSequenceGenerator();
    }
    DialogIdGenerator.prototype.next = function () {
        return this.sequence.next().toString();
    };
    return DialogIdGenerator;
}());
var dialogIdGenerator = new DialogIdGenerator();
exports.default = dialogIdGenerator;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\dialogIdGenerator.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\dialogIdGenerator.ts"); } } })();

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(67);
var dialog_1 = __webpack_require__(288);
var OpenDialogConnect = (function () {
    function OpenDialogConnect() {
    }
    OpenDialogConnect.to = function (internal, withRef) {
        if (withRef === void 0) { withRef = false; }
        var mapDispatchToProps = function (dispatch) {
            return {
                openDialog: function (key) {
                    dispatch(dialog_1.openDialog(key));
                }
            };
        };
        var mapStateToProps = function (state) { return ({
            openDialogs: state.dialogs || {}
        }); };
        return react_redux_1.connect(mapStateToProps, mapDispatchToProps, null, { withRef: withRef })(internal);
    };
    return OpenDialogConnect;
}());
exports.OpenDialogConnect = OpenDialogConnect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\OpenDialogConnect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\OpenDialogConnect.tsx"); } } })();

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var KeyboardHandler_1 = __webpack_require__(543);
var BaseComponent_1 = __webpack_require__(14);
var FormComponent = (function (_super) {
    __extends(FormComponent, _super);
    function FormComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onEnter = function (event) {
            var target = event.target ? event.target : event.srcElement;
            var tagName = target.tagName;
            if (tagName.toUpperCase() === "INPUT") {
                _this.props.onFormSubmit();
                return true;
            }
            return false;
        };
        _this.onCtrlEnter = function (event) {
            _this.props.onFormSubmit();
            return true;
        };
        return _this;
    }
    FormComponent.prototype.render = function () {
        var keyboardRegistrations = [
            { key: KeyboardHandler_1.Key.Enter, onKeyPressed: this.onEnter },
            { key: KeyboardHandler_1.Key.CtrlEnter, onKeyPressed: this.onCtrlEnter },
        ];
        return React.createElement("div", { style: { width: "100%" }, className: this.props.className },
            React.createElement(KeyboardHandler_1.default, { registrations: keyboardRegistrations, className: this.props.className }, this.props.children));
    };
    return FormComponent;
}(BaseComponent_1.BaseComponent));
exports.default = FormComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FormComponent\\FormComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FormComponent\\FormComponent.tsx"); } } })();

/***/ }),
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1880);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var Roles_1 = __webpack_require__(35);
var resources_1 = __webpack_require__(26);
var form_1 = __webpack_require__(15);
var PackageSelector_1 = __webpack_require__(58);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var Note_1 = __webpack_require__(22);
var CodeEditor_1 = __webpack_require__(119);
var ExternalLink_1 = __webpack_require__(29);
var feedResource_1 = __webpack_require__(54);
var clientInstance_1 = __webpack_require__(10);
var CommonSummaryHelper_1 = __webpack_require__(62);
var Text_1 = __webpack_require__(17);
var PackageDownloadOptions_1 = __webpack_require__(135);
var scriptingLanguage_1 = __webpack_require__(140);
var ScriptingLanguageSelector_1 = __webpack_require__(450);
var ExpandableFormSection_1 = __webpack_require__(44);
var ActionDetails_1 = __webpack_require__(27);
var resources_2 = __webpack_require__(26);
var ScriptActionSummary = (function (_super) {
    __extends(ScriptActionSummary, _super);
    function ScriptActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScriptActionSummary.prototype.render = function () {
        var runsOnServer = this.props.properties[specialVariables_1.default.Action.RunOnServer] === "true";
        return runsOnServer ?
            React.createElement("div", null,
                "Run a script on the Octopus Server ",
                this.props.targetRolesAsCSV &&
                    React.createElement("span", null,
                        "on behalf of targets in ",
                        React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }))) :
            React.createElement("div", null,
                "Run a script across targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }));
    };
    return ScriptActionSummary;
}(BaseComponent_1.BaseComponent));
// Note: this is also used in the Azure PowerShell step and the ServiceFabric PowerShell step
var ScriptActionEdit = (function (_super) {
    __extends(ScriptActionEdit, _super);
    function ScriptActionEdit(props) {
        var _this = _super.call(this, props) || this;
        var packageAcquisition = props.additionalActions && props.additionalActions.packageAcquisition;
        _this.state = {
            feeds: [],
            originalCanRunBeforeAcquisition: packageAcquisition ? packageAcquisition.canRunBeforeAcquisition : false,
            originalStepPackageRequirement: packageAcquisition ? packageAcquisition.stepPackageRequirement : resources_2.PackageRequirement.LetOctopusDecide
        };
        return _this;
    }
    ScriptActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var feeds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.properties["Octopus.Action.Script.ScriptSource"]) {
                            this.handleScriptSourceChanged("Inline", true);
                        }
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        feeds = _a.sent();
                        this.setState({ feeds: feeds });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ScriptActionEdit.prototype.handleScriptSourceChanged = function (val, initialise) {
        if (initialise === void 0) { initialise = false; }
        var isRunFromPackage = val === "Package";
        var properties = (_a = {}, _a["Octopus.Action.Script.ScriptSource"] = val, _a);
        if (isRunFromPackage) {
            properties["Octopus.Action.Script.Syntax"] = null;
            properties["Octopus.Action.Script.ScriptBody"] = null;
            properties["Octopus.Action.Package.FeedId"] = feedResource_1.BuiltInFeedId;
        }
        else {
            if (!this.props.properties["Octopus.Action.Script.Syntax"] && !this.props.powerShellOnly) {
                properties["Octopus.Action.Script.Syntax"] = "PowerShell";
            }
            properties["Octopus.Action.Script.ScriptFileName"] = null;
            properties["Octopus.Action.Package.FeedId"] = null;
            properties["Octopus.Action.Package.PackageId"] = null;
        }
        this.props.setProperties(properties, initialise);
        // if we are pulling the script from a package we might need to override things
        // if the user has set this step to run before package acquisition
        if (this.props.additionalActions) {
            if (isRunFromPackage) {
                this.props.additionalActions.packageAcquisition.onCanRunBeforeAcquisitionChanged(false);
            }
            else {
                this.props.additionalActions.packageAcquisition.onCanRunBeforeAcquisitionChanged(this.state.originalCanRunBeforeAcquisition);
            }
            if (this.state.originalStepPackageRequirement === resources_2.PackageRequirement.BeforePackageAcquisition) {
                var newValue = isRunFromPackage
                    ? resources_2.PackageRequirement.LetOctopusDecide
                    : this.state.originalStepPackageRequirement;
                this.props.additionalActions.packageAcquisition.onStepPackageRequirementChanged(newValue);
            }
        }
        var _a;
    };
    ScriptActionEdit.prototype.scriptSourceSummary = function () {
        if (this.props.properties["Octopus.Action.Script.ScriptSource"] === "Inline") {
            return form_1.Summary.default("The script is defined below");
        }
        else {
            return form_1.Summary.summary("The script is contained in a package");
        }
    };
    ScriptActionEdit.prototype.scriptBodySummary = function () {
        if (!this.props.properties["Octopus.Action.Script.ScriptBody"]) {
            return form_1.Summary.placeholder("The script body has not been defined");
        }
        if (this.props.powerShellOnly) {
            return form_1.Summary.summary("The script body has been defined");
        }
        var syntax = this.props.properties["Octopus.Action.Script.Syntax"];
        if (syntax === "FSharp") {
            return form_1.Summary.summary(React.createElement("span", null,
                "An ",
                React.createElement("strong", null, "F#"),
                " script has been defined"));
        }
        else if (syntax === "CSharp") {
            return form_1.Summary.summary(React.createElement("span", null,
                "A ",
                React.createElement("strong", null, "C#"),
                " script has been defined"));
        }
        return form_1.Summary.summary(React.createElement("span", null,
            "A ",
            React.createElement("strong", null, syntax),
            " script has been defined"));
    };
    ScriptActionEdit.prototype.packageScriptSummary = function () {
        var fileName = this.props.properties["Octopus.Action.Script.ScriptFileName"];
        if (!fileName) {
            return form_1.Summary.placeholder("The script file has not been defined");
        }
        return form_1.Summary.summary(React.createElement("span", null,
            "The script ",
            React.createElement("strong", null, fileName),
            " from the selected package will be run"));
    };
    ScriptActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var runOnServer = this.props.properties
            && this.props.properties["Octopus.Action.RunOnServer"]
            && this.props.properties["Octopus.Action.RunOnServer"].toLowerCase() === "true";
        return React.createElement("div", null,
            React.createElement(form_1.FormSectionHeading, { title: "Script" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "scriptsource", title: "Script Source", summary: this.scriptSourceSummary(), help: "Select where the script is defined." },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: properties["Octopus.Action.Script.ScriptSource"], onChange: function (val) { return _this.handleScriptSourceChanged(val); } },
                    React.createElement(RadioButton_1.default, { value: "Inline", label: "Source code" }),
                    React.createElement(Note_1.default, null, "The script body is defined in the Script content field below"),
                    React.createElement(RadioButton_1.default, { value: "Package", label: "Script file inside a package" }),
                    React.createElement(Note_1.default, null, "The script is contained in a package that will be deployed"))),
            properties["Octopus.Action.Script.ScriptSource"] === "Inline" && React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Script.ScriptBody", title: "Script Content", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, summary: this.scriptBodySummary(), help: this.props.powerShellOnly
                    ? "Enter the body of the script that will be executed."
                    : "Select the script language and enter the body of the script that will be executed." },
                !this.props.powerShellOnly &&
                    React.createElement(ScriptingLanguageSelector_1.default, { value: properties["Octopus.Action.Script.Syntax"], onlyRunnableOnServer: runOnServer, onChange: function (syntax) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Script.Syntax"] = syntax, _a));
                            var _a;
                        } }),
                this.props.powerShellOnly && React.createElement("h4", null, "PowerShell script"),
                React.createElement(CodeEditor_1.VariableLookupCodeEditor, { localNames: this.props.localNames, projectId: this.props.projectId, syntax: this.props.powerShellOnly ? scriptingLanguage_1.ScriptingLanguage.PowerShell : properties["Octopus.Action.Script.Syntax"], value: properties["Octopus.Action.Script.ScriptBody"], language: this.props.powerShellOnly ? scriptingLanguage_1.ScriptingLanguage.PowerShell : properties["Octopus.Action.Script.Syntax"], allowFullScreen: true, onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Script.ScriptBody"] = x, _a));
                        var _a;
                    } })),
            properties["Octopus.Action.Script.ScriptSource"] === "Package" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.FeedId|Octopus.Action.Package.PackageId", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(properties, this.state.feeds), help: React.createElement("span", null,
                        "This step is used to run a script. The package that you wish to deploy should contain your script and any files it needs to access. ",
                        React.createElement(ExternalLink_1.default, { href: "DocumentationPackaging" }, "Learn more about what your packages should contain, and how to create them"),
                        ".") },
                    React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors }),
                    React.createElement(PackageDownloadOptions_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, localNames: this.props.localNames, errors: this.props.errors })),
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Script.ScriptFileName|Octopus.Action.Script.ScriptParameters", title: "Script File", summary: this.packageScriptSummary(), help: "Enter the relative path to the script file within your package and any parameters that need to be passed to the script." },
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Script.ScriptFileName"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Script.ScriptFileName"] = x, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Script.ScriptFileName"), label: "Script file name" }),
                    React.createElement(Note_1.default, null,
                        "The relative path to the script file within the package.",
                        React.createElement("br", null),
                        "e.g. ",
                        React.createElement("code", null, "MyScript.ps1"),
                        " or ",
                        React.createElement("code", null, "Scripts\\MyScript.ps1")),
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Script.ScriptParameters"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Script.ScriptParameters"] = x, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Script.ScriptParameters"), label: "Script parameters" }),
                    this.props.powerShellOnly
                        ? React.createElement(Note_1.default, null,
                            "Parameters expected by the script. Use platform specific calling convention.",
                            React.createElement("br", null),
                            "e.g. ",
                            React.createElement("code", null,
                                "-Path #", "{VariableStoringPath}"),
                            " for PowerShell")
                        : React.createElement(Note_1.default, null,
                            "Parameters expected by the script. Use platform specific calling convention.",
                            React.createElement("br", null),
                            "e.g. ",
                            React.createElement("code", null,
                                "-Path #", "{VariableStoringPath}"),
                            " for PowerShell or ",
                            React.createElement("code", null,
                                "-- #", "{VariableStoringPath}"),
                            " for ScriptCS"))));
    };
    ScriptActionEdit.defaultProps = {
        powerShellOnly: false
    };
    return ScriptActionEdit;
}(BaseComponent_1.BaseComponent));
exports.ScriptActionEdit = ScriptActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    actionType: "Octopus.Script",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(ScriptActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: ScriptActionEdit,
    canHaveChildren: function (step) { return !!step.Properties[specialVariables_1.default.Action.TargetRoles]; },
    canBeChild: true,
    executionLocation: resources_1.ActionExecutionLocation.TargetOrServer,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) {
        if (action.Properties && action.Properties["Octopus.Action.Script.ScriptSource"] === "Package") {
            return true;
        }
        return false;
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\script\\scriptAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\script\\scriptAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Callout_1 = __webpack_require__(81);
var ExternalLink_1 = __webpack_require__(29);
var AzureServerTargetRolesInfo = function (props) {
    return props.stepTargetRoles
        ? React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
            "Ensure you have at least one active deployment target matching the selected role(s) at the time of your deployment. ",
            React.createElement(ExternalLink_1.default, { href: "CloudRegionTargets" }, "Cloud Region targets"),
            " can be used when deploying cloud applications to multiple geographic regions.")
        : null;
};
exports.default = AzureServerTargetRolesInfo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azurePowerShell\\AzureServerTargetRolesInfo.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azurePowerShell\\AzureServerTargetRolesInfo.tsx"); } } })();

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var FormSectionHeading_1 = __webpack_require__(46);
var form_1 = __webpack_require__(15);
var awsLoginComponent_1 = __webpack_require__(208);
var CodeEditor_1 = __webpack_require__(119);
var CommonSummaryHelper_1 = __webpack_require__(62);
var ExpandableFormSection_1 = __webpack_require__(44);
var Note_1 = __webpack_require__(22);
var RadioButton_1 = __webpack_require__(36);
var OpenDialogButton_1 = __webpack_require__(74);
var PackageSelector_1 = __webpack_require__(58);
var RadioButtonGroup_1 = __webpack_require__(33);
var clientInstance_1 = __webpack_require__(10);
var DynamicForm_1 = __webpack_require__(467);
var Text_1 = __webpack_require__(17);
var ExternalLink_1 = __webpack_require__(29);
var StringCheckbox_1 = __webpack_require__(38);
var UnstructuredFormSection_1 = __webpack_require__(444);
var sourceCodeDialog_1 = __webpack_require__(713);
var TerraformActionEdit = (function (_super) {
    __extends(TerraformActionEdit, _super);
    function TerraformActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feeds: [],
            accounts: []
        };
        _this.parameterValues = {};
        _this.parameters = {};
        _this.source = { octopus: "octopus" };
        return _this;
    }
    TerraformActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!this.props.properties["Octopus.Action.Aws.AssumeRole"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.Aws.AssumeRole"] = "False", _c), true);
                        }
                        if (!this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"]) {
                            this.props.setProperties((_d = {}, _d["Octopus.Action.AwsAccount.UseInstanceRole"] = "False", _d), true);
                        }
                        if (!this.props.properties["Octopus.Action.Terraform.ManagedAccount"]) {
                            this.props.setProperties((_e = {}, _e["Octopus.Action.Terraform.ManagedAccount"] = "None", _e), true);
                        }
                        if (!this.props.properties["Octopus.Action.Terraform.AllowPluginDownloads"]) {
                            this.props.setProperties((_f = {}, _f["Octopus.Action.Terraform.AllowPluginDownloads"] = "True", _f), true);
                        }
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _b.feeds = _g.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 2:
                        _a.apply(this, [(_b.accounts = _g.sent(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    TerraformActionEdit.prototype.componentWillMount = function () {
        if (this.props.properties["Octopus.Action.Script.ScriptSource"] &&
            this.props.properties["Octopus.Action.Script.ScriptSource"] === "Inline") {
            this.refreshParametersFromTemplate(this.props.properties["Octopus.Action.Terraform.Template"]);
        }
    };
    TerraformActionEdit.prototype.templateSourceSummary = function () {
        var source = this.props.properties["Octopus.Action.Script.ScriptSource"];
        if (source === "Inline") {
            return form_1.Summary.summary("Source code");
        }
        if (source === "Package") {
            return form_1.Summary.summary("File inside a package");
        }
        return form_1.Summary.placeholder("Template source not specified");
    };
    TerraformActionEdit.prototype.onChangeTemplateSource = function (value) {
        this.props.setProperties((_a = {},
            _a["Octopus.Action.Script.ScriptSource"] = value,
            _a["Octopus.Action.Terraform.Template"] = "",
            _a["Octopus.Action.Terraform.TemplateParameters"] = "",
            _a));
        // If the inline option is selected, we clear out the package selection
        if (value === "Inline") {
            this.props.setProperties((_b = {},
                _b["Octopus.Action.Package.PackageId"] = null,
                _b));
        }
        var _a, _b;
    };
    TerraformActionEdit.prototype.optionsSummary = function () {
        return form_1.Summary.summary(React.createElement("span", null,
            this.props.properties["Octopus.Action.Terraform.AllowPluginDownloads"] === "True" &&
                React.createElement("span", null, "Allowing additional plugins downloads"),
            this.props.properties["Octopus.Action.Terraform.AllowPluginDownloads"] !== "True" &&
                React.createElement("span", null, "Preventing additional plugins downloads"),
            this.props.properties["Octopus.Action.Terraform.PluginsDirectory"] &&
                this.props.properties["Octopus.Action.Terraform.PluginsDirectory"].trim() &&
                React.createElement("span", null,
                    " to the custom plugin cache directory of ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.Terraform.PluginsDirectory"].trim())),
            this.props.properties["Octopus.Action.Terraform.Workspace"] &&
                React.createElement("span", null,
                    ", and using the ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.Terraform.Workspace"]),
                    " workspace")));
    };
    TerraformActionEdit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Managed Account" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Terraform.ManagedAccount", title: "Managed Account", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, summary: this.managedAccountSummary(), help: "Select the source of the template." },
                React.createElement(RadioButtonGroup_1.default, { value: this.props.properties["Octopus.Action.Terraform.ManagedAccount"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.ManagedAccount"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Terraform.ManagedAccount") },
                    React.createElement(RadioButton_1.default, { value: "None", label: "None" }),
                    React.createElement(RadioButton_1.default, { value: "AWS", label: "AWS Account" })),
                React.createElement(Note_1.default, null, "You can optionally prepare the environment that Terraform runs in using the details defined in an account managed by Octopus. If an account is selected then those credentials do not need to be included in the Terraform template.")),
            this.props.properties["Octopus.Action.Terraform.ManagedAccount"] === "AWS" &&
                React.createElement("div", null,
                    React.createElement(awsLoginComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, plugin: this.props.plugin, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, errors: this.props.errors }),
                    React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.Region", title: "Region", summary: this.regionSummary(), help: "Specify the default region" },
                        React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.Region"], label: "Region", onChange: function (val) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.Region"] = val, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.Aws.Region") }),
                        React.createElement(Note_1.default, null,
                            "View the ",
                            React.createElement(ExternalLink_1.default, { href: "AWSRegions" }, "AWS Regions and Endpoints"),
                            " documentation for a current list of the available region codes."))),
            React.createElement(FormSectionHeading_1.default, { title: "Template" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Script.ScriptSource|Octopus.Action.Terraform.Template", title: "Template Source", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, summary: this.templateSourceSummary(), help: "Select the source of the template." },
                React.createElement(Note_1.default, null, "Templates can be entered as source-code, or contained in a package."),
                React.createElement(RadioButtonGroup_1.default, { value: this.props.properties["Octopus.Action.Script.ScriptSource"], onChange: function (val) { return _this.onChangeTemplateSource(val); }, error: this.props.getFieldError("Octopus.Action.Aws.TemplateSource") },
                    React.createElement(RadioButton_1.default, { value: "Inline", label: "Source code" }),
                    React.createElement(RadioButton_1.default, { value: "Package", label: "File inside a package" })),
                this.props.properties["Octopus.Action.Script.ScriptSource"] === "Inline" && React.createElement("div", null,
                    React.createElement("br", null),
                    this.props.properties["Octopus.Action.Terraform.Template"] &&
                        React.createElement(CodeEditor_1.default, { value: this.props.properties["Octopus.Action.Terraform.Template"], language: CodeEditor_1.TextFormat.JSON, allowFullScreen: false, readOnly: true, onChange: null }),
                    React.createElement("div", null,
                        React.createElement(OpenDialogButton_1.default, { label: this.props.properties["Octopus.Action.Terraform.Template"] ? "Edit Source Code" : "Add Source Code", wideDialog: true },
                            React.createElement(sourceCodeDialog_1.default, { template: this.props.properties["Octopus.Action.Terraform.Template"], doBusyTask: this.props.doBusyTask, saveDone: function (template, metadata) {
                                    _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.Template"] = template, _a));
                                    _this.refreshParametersFromMetadata(metadata);
                                    var _a;
                                }, textFormat: CodeEditor_1.TextFormat.JSON, metadata: "Terraform" }))))),
            this.props.properties["Octopus.Action.Script.ScriptSource"] === "Package" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.FeedId|Octopus.Action.Package.PackageId", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(this.props.properties, this.state.feeds), help: "Choose the package that contains the template source." },
                    React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors }),
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.TemplateDirectory"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.TemplateDirectory"] = x, _a));
                            var _a;
                        }, label: "Terraform template directory", error: this.props.getFieldError("Octopus.Action.Terraform.TemplateDirectory") }),
                    React.createElement(Note_1.default, null, "Specify the optional directory in the package from which Terraform will be run."),
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.FileSubstitution"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.FileSubstitution"] = x, _a));
                            var _a;
                        }, label: "Target files", error: this.props.getFieldError("Octopus.Action.Terraform.FileSubstitution"), multiLine: true }),
                    React.createElement(Note_1.default, null,
                        "A newline-separated list of file names to transform (in addition to all ",
                        React.createElement("em", null, "*.tf"),
                        ", ",
                        React.createElement("em", null, "*.tfvars"),
                        ", ",
                        React.createElement("em", null, "*.tf.json"),
                        " and ",
                        React.createElement("em", null, "*.tfvars.json"),
                        " files), relative to the package contents. Extended wildcard syntax is supported. E.g., ",
                        React.createElement("em", null, "Notes.txt"),
                        ", ",
                        React.createElement("em", null, "Config\\*.json"),
                        ", ",
                        React.createElement("em", null, "**\\specific-folder\\*.config."),
                        React.createElement("br", null),
                        "This field supports extended template syntax. Conditional ",
                        React.createElement("code", null, "if"),
                        " and ",
                        React.createElement("code", null, "unless"),
                        ":",
                        React.createElement("pre", null, "#{if MyVar}...#{/if}"),
                        "Iteration over variable sets or comma-separated values with ",
                        React.createElement("code", null, "each"),
                        ":",
                        React.createElement("pre", null, "#{each mv in MyVar}...#{mv}...#{/each}")),
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.VarFiles"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.VarFiles"] = x, _a));
                            var _a;
                        }, label: "Additional variable files", error: this.props.getFieldError("Octopus.Action.Terraform.VarFiles"), multiLine: true }),
                    React.createElement(Note_1.default, null,
                        "An optional newline-separated list of files that are passed as ",
                        React.createElement("strong", null, "-var-file"),
                        " parameters. Note that files called ",
                        React.createElement("strong", null, "terraform.tfvars"),
                        ", ",
                        React.createElement("strong", null, "terraform.tfvars.json"),
                        ",",
                        React.createElement("strong", null, "*.auto.tfvars"),
                        " and ",
                        React.createElement("strong", null, "*.auto.tfvars.json"),
                        " are automatically loaded by Terraform, and do not need to be listed here. Each line in this text area is passed as an individual ",
                        React.createElement("strong", null, "-var-file"),
                        " parameter."))),
            this.props.properties["Octopus.Action.Script.ScriptSource"] === "Inline" && this.state.parameterTypes && React.createElement("div", null,
                React.createElement(FormSectionHeading_1.default, { title: "Variables" }),
                React.createElement(UnstructuredFormSection_1.default, null,
                    React.createElement(Note_1.default, null, "Terraform variables are either strings, lists or maps."),
                    React.createElement(Note_1.default, null,
                        "Strings (including numbers and true/false) are supplied without quotes e.g. ",
                        React.createElement("strong", null, "my string"),
                        ", ",
                        React.createElement("strong", null, "true"),
                        " or ",
                        React.createElement("strong", null, "3.1415"),
                        ". Lists and maps are supplied as raw HCL or JSON structures, depending on the format of the template. For example, if the template is written in HCL, a list variable would be provided as ",
                        React.createElement("strong", null,
                            "[\"item1\", ",
                            "{",
                            "item2=\"embedded map\"",
                            "}",
                            "]"),
                        " and a map variable would be provided as ",
                        React.createElement("strong", null,
                            "{",
                            "item1=\"hi\", item2=\"there\"",
                            "}"),
                        ". If the template is written is JSON, a list variable would be provided as ",
                        React.createElement("strong", null,
                            "[\"item1\", ",
                            "{",
                            "\"item2\": \"embedded map\" ",
                            "}",
                            "]"),
                        " and a map variable would be provided as ",
                        React.createElement("strong", null,
                            "{",
                            "\"item1\": \"hi\", \"item2\": \"there\"",
                            "}"),
                        ".")),
                React.createElement(DynamicForm_1.default, { types: this.state.parameterTypes, values: this.state.parameterValues, isBindable: true, onChange: function (data) { return _this.updateParameters(data); } })),
            React.createElement(FormSectionHeading_1.default, { title: "Advanced Options" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Terraform.PreventDownload|Octopus.Action.Terraform.PluginsDirectory", title: "Terraform Options", help: "Specify the optional advanced options for Terraform", summary: this.optionsSummary() },
                React.createElement(Text_1.VariableLookupText, { label: "Terraform workspace", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.Workspace"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.Workspace"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Terraform.Workspace") }),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.PluginsDirectory"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.PluginsDirectory"] = x, _a));
                        var _a;
                    }, label: "Terraform plugin cache directory", error: this.props.getFieldError("Octopus.Action.Terraform.PluginsDirectory") }),
                React.createElement(Note_1.default, null, "Specify the optional directory that holds the Terraform plugins. This is useful when you want targets to share plugins instead of downloading their own local copy."),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: this.props.properties["Octopus.Action.Terraform.AllowPluginDownloads"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.AllowPluginDownloads"] = x, _a));
                        var _a;
                    }, label: "Allow additional plugin downloads", note: React.createElement("span", null, "Selecting this option allows Terraform to download plugins that are not found.") }),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.AdditionalInitParams"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.AdditionalInitParams"] = x, _a));
                        var _a;
                    }, label: "Custom terraform init parameters", error: this.props.getFieldError("Octopus.Action.Terraform.AdditionalInitParams") }),
                React.createElement(Note_1.default, null,
                    "An optional list of additional parameters to pass to the ",
                    React.createElement("strong", null, "terraform init"),
                    " command."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.AdditionalActionParams"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.AdditionalActionParams"] = x, _a));
                        var _a;
                    }, label: React.createElement("span", null,
                        "Custom terraform ",
                        this.props.actionName,
                        " parameters"), error: this.props.getFieldError("Octopus.Action.Terraform.AdditionalActionParams") }),
                React.createElement(Note_1.default, null,
                    "An optional list of additional parameters to pass to the ",
                    React.createElement("strong", null,
                        "terraform ",
                        this.props.actionName),
                    " command.")));
    };
    TerraformActionEdit.prototype.regionSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Aws.Region"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Using ",
                React.createElement("strong", null, properties["Octopus.Action.Aws.Region"]),
                " as the default region"));
        }
        return form_1.Summary.placeholder("Specify the default AWS region");
    };
    TerraformActionEdit.prototype.managedAccountSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Terraform.ManagedAccount"] && properties["Octopus.Action.Terraform.ManagedAccount"] !== "None") {
            return form_1.Summary.summary(React.createElement("span", null,
                "Using an ",
                React.createElement("strong", null, properties["Octopus.Action.Terraform.ManagedAccount"]),
                " account"));
        }
        return form_1.Summary.summary("Not using an account");
    };
    TerraformActionEdit.prototype.refreshParametersFromTemplate = function (template) {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.CloudTemplates.getMetadata(template, "Terraform")];
                    case 1:
                        response = _a.sent();
                        this.refreshParametersFromMetadata(response);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    TerraformActionEdit.prototype.refreshParametersFromMetadata = function (metadataResponse) {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var storedParameters, _a;
            return __generator(this, function (_b) {
                storedParameters = this.flattenParameters();
                Object.keys(metadataResponse.Values).forEach(function (key) {
                    if (typeof storedParameters[key] !== "undefined") {
                        metadataResponse.Values[key] = storedParameters[key];
                    }
                });
                this.props.setProperties((_a = {},
                    _a["Octopus.Action.Terraform.TemplateParameters"] = JSON.stringify(metadataResponse.Values),
                    _a));
                this.setState({ parameterTypes: metadataResponse.Metadata.Types, parameterValues: metadataResponse.Values });
                return [2 /*return*/];
            });
        }); });
    };
    /**
     * Takes the JSON representation of the variables (i.e. the tool specific format, in this case terraform)
     * and returns the flat data structure used by the dynamic form.
     * @returns {DataContext} The variable information for the dynamic form
     */
    TerraformActionEdit.prototype.flattenParameters = function () {
        try {
            if (this.props.properties["Octopus.Action.Terraform.TemplateParameters"]) {
                return JSON.parse(this.props.properties["Octopus.Action.Terraform.TemplateParameters"]);
            }
        }
        catch (ex) {
            // this.props.properties["Octopus.Action.Terraform.TemplateParametersRaw"] probably isn't
            // valid JSON, so return the empty data context.
        }
        return {};
    };
    /**
     * Takes the dynamic form variable information, and saves it in the tool specific JSON representation.
     * @param {DataContext} data The dynamic form variable data
     */
    TerraformActionEdit.prototype.updateParameters = function (data) {
        this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.TemplateParameters"] = JSON.stringify(data), _a));
        this.setState({ parameterTypes: this.state.parameterTypes, parameterValues: data });
        var _a;
    };
    return TerraformActionEdit;
}(BaseComponent_1.BaseComponent));
exports.default = TerraformActionEdit;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\terraform\\terraformAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\terraform\\terraformAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1698);
var ListTitle = function (props) {
    return React.createElement("h3", { className: styles.listTitle }, props.children);
};
ListTitle.displayName = "ListTitle";
exports.default = ListTitle;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ListTitle\\ListTitle.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ListTitle\\ListTitle.tsx"); } } })();

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1620);
var ActionList = function (props) {
    var centerStyle = props.center ? { justifyContent: "center" } : {};
    return React.createElement("div", { className: styles.actionList, style: centerStyle }, props.actions.map(function (action, index) { return !action ? null : React.cloneElement(action, __assign({}, action.props, { key: index })); }));
};
ActionList.displayName = "ActionList";
exports.default = ActionList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionList\\ActionList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionList\\ActionList.tsx"); } } })();

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var FlatButton_1 = __webpack_require__(101);
var styles = __webpack_require__(1607);
var cn = __webpack_require__(19);
var Note_1 = __webpack_require__(22);
var ExternalLink_1 = __webpack_require__(29);
var Text_1 = __webpack_require__(17);
var ToolTip_1 = __webpack_require__(215);
var MarkdownProvider_1 = __webpack_require__(1609);
var VariableLookup_1 = __webpack_require__(363);
var MarkdownEditor = (function (_super) {
    __extends(MarkdownEditor, _super);
    function MarkdownEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (value) {
            _this.callValidateAndChange(value);
        };
        _this.getInputState = function () {
            var value = _this.props.value == null ? "" : _this.props.value;
            var selection = _this.text.getSelection();
            return new MarkdownProvider_1.MarkdownProvider(value, selection.start, selection.end);
        };
        _this.setInputState = function (value, selectionStart, selectionEnd) {
            var selection = {
                start: selectionStart,
                end: selectionEnd
            };
            _this.text.setValueAndSelection(selection, value);
            _this.text.focus();
        };
        _this.bold = function () {
            _this.getInputState()
                .insertBefore("**")
                .insertAfter("**")
                .emptySelectionText("Bold text")
                .apply(_this.setInputState);
        };
        _this.italic = function () {
            _this.getInputState()
                .insertBefore("_")
                .insertAfter("_")
                .emptySelectionText("Italic text")
                .apply(_this.setInputState);
        };
        _this.bullet = function () {
            _this.getInputState()
                .surroundWithNewlines()
                .insertBefore("- ")
                .emptySelectionText("List item")
                .apply(_this.setInputState);
        };
        _this.number = function () {
            _this.getInputState()
                .surroundWithNewlines()
                .insertBefore("1. ")
                .emptySelectionText("List item")
                .apply(_this.setInputState);
        };
        _this.quote = function () {
            _this.getInputState()
                .surroundWithNewlines()
                .insertBefore("> ")
                .insertAfterNewlineInSelection("> ")
                .emptySelectionText("Quoted text")
                .apply(_this.setInputState);
        };
        _this.code = function () {
            _this.getInputState()
                .surroundWithNewlines()
                .insertBefore("```\n")
                .insertAfter("\n```")
                .emptySelectionText("Code")
                .apply(_this.setInputState);
        };
        _this.link = function () {
            var url = prompt("Please enter a url for the link:", "http://");
            if (url) {
                _this.getInputState()
                    .insertBefore("[")
                    .insertAfter("](" + url + ")")
                    .emptySelectionText("Enter link description here")
                    .apply(_this.setInputState);
            }
        };
        _this.image = function () {
            var url = prompt("Please enter a url for the image:", "http://");
            if (url) {
                _this.getInputState()
                    .insertBefore("![")
                    .insertAfter("](" + url + ")")
                    .emptySelectionText("Enter image description here")
                    .apply(_this.setInputState);
            }
        };
        _this.state = {
            error: null,
            showExternalError: true
        };
        return _this;
    }
    MarkdownEditor.prototype.componentWillReceiveProps = function (nextProps) {
        var isNewExternalErrorAvailable = nextProps.error !== this.props.error;
        if (isNewExternalErrorAvailable) {
            this.setState({ showExternalError: true });
        }
    };
    MarkdownEditor.prototype.callValidateAndChange = function (value) {
        if (this.props.validate) {
            var validateResult = this.props.validate(value);
            this.setState({ error: validateResult });
            if (this.props.onValidate) {
                this.props.onValidate(validateResult);
            }
        }
        this.setState({ showExternalError: false });
        this.props.onChange(value);
    };
    MarkdownEditor.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, label = _a.label, validate = _a.validate, error = _a.error, onChange = _a.onChange, onValidate = _a.onValidate, hintText = _a.hintText, textInputRef = _a.textInputRef, otherProps = __rest(_a, ["value", "label", "validate", "error", "onChange", "onValidate", "hintText", "textInputRef"]);
        var errorText = this.state.error || (this.state.showExternalError && error);
        var val = value ? value : "";
        return (React.createElement("div", { className: cn(styles.markdownEditorContainer, this.props.restrictHeight && styles.restrictedHeight) },
            this.createButtons(),
            React.createElement(Text_1.default, __assign({ textInputRef: function (text) {
                    if (_this.props.textInputRef) {
                        _this.props.textInputRef(text);
                    }
                    _this.text = text;
                }, value: val, onChange: this.handleChange, error: errorText, label: label, hintText: hintText, multiLine: true, rows: 3, showBorder: true }, otherProps)),
            React.createElement(Note_1.default, null,
                React.createElement(ExternalLink_1.default, { href: "MasteringMarkdown" },
                    React.createElement("em", { className: "fa fa-pencil " + styles.markdownSupported, "aria-hidden": "true" }),
                    "Styling with Markdown is supported"))));
    };
    MarkdownEditor.prototype.createButtons = function () {
        return React.createElement("div", { className: styles.iconButtonContainer }, [
            this.editAction("Bold", "fa-bold", this.bold),
            this.editAction("Italic", "fa-italic", this.italic),
            this.editAction("Bulleted list", "fa-list-ul", this.bullet),
            this.editAction("Numeric list", "fa-list-ol", this.number),
            this.editAction("Picture", "fa-image", this.image),
            this.editAction("Link", "fa-link", this.link),
            this.editAction("Code", "fa-code", this.code),
            this.editAction("Quotes", "fa-quote-left", this.quote),
        ]);
    };
    MarkdownEditor.prototype.editAction = function (label, faIcon, onClick) {
        return React.createElement(ToolTip_1.default, { content: label, key: "tooltip_" + faIcon },
            React.createElement(FlatButton_1.default, { tabIndex: -1, className: styles.iconButton, onClick: onClick, label: React.createElement("em", { className: "fa " + faIcon, "aria-hidden": "true" }) }));
    };
    MarkdownEditor.defaultProps = {
        autoFocus: false
    };
    return MarkdownEditor;
}(React.Component));
exports.default = MarkdownEditor;
var MarkdownEditorWithInputRef = function (props) { return React.createElement(MarkdownEditor, __assign({ textInputRef: props.textInputRef }, props)); };
exports.VariableLookupMarkdownEditor = VariableLookup_1.withVariableLookup()(MarkdownEditorWithInputRef);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\MarkdownEditor\\MarkdownEditor.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\MarkdownEditor\\MarkdownEditor.tsx"); } } })();

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var material_ui_1 = __webpack_require__(92);
var PagingBaseComponent_1 = __webpack_require__(460);
var ListInternalLink_1 = __webpack_require__(461);
var styles = __webpack_require__(386);
var colors_1 = __webpack_require__(32);
var PagingBaseComponent_2 = __webpack_require__(179);
var Section_1 = __webpack_require__(90);
var Divider_1 = __webpack_require__(143);
var InternalRedirect_1 = __webpack_require__(40);
var List = (function (_super) {
    __extends(List, _super);
    function List(props) {
        var _this = _super.call(this, props) || this;
        _this.empty = (React.createElement("div", null, "No results"));
        _this.empty = props.empty || _this.empty;
        return _this;
    }
    List.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: true });
        }
        if (!this.state.data || !this.state.data.Items) {
            return React.createElement(Section_1.Section, null);
        }
        var needToShowSearch = this.state.isShowingSearchResults || this.state.data.Items.length < this.state.data.TotalResults;
        return (React.createElement("div", null,
            this.renderFilterSearchComponents(),
            this.state.data.Items.length === 0 &&
                React.createElement("div", { className: styles.emptyList }, this.empty),
            React.createElement(material_ui_1.List, null,
                this.state.data.Items.filter(function (item) { return _this.onFilter(_this.state.filter, item); })
                    .map(function (item, index) { return _this.buildItem(item, index); }),
                this.state.data.Items.length < this.state.data.TotalResults
                    ?
                        this.props.showPagingInNumberedStyle
                            ? this.showPagingInNumberedStyle()
                            : this.showPagingInLoadMoreStyle()
                    : null)));
    };
    List.prototype.buildItem = function (item, index) {
        var _this = this;
        var redirectUrl = PagingBaseComponent_2.getNavigationUrl(this.props, item);
        var nodeRow = this.props.onRow(item);
        if (redirectUrl) {
            // Make these actual href links, so people can still right-click > open new window (this is expected usability for things you can click).
            nodeRow = React.createElement(ListInternalLink_1.default, { to: redirectUrl }, nodeRow);
        }
        var nodes = [
            React.createElement(material_ui_1.ListItem, { key: item.Id, className: styles.listItem, onClick: function (e) { return _this.navigate(item); }, hoverColor: colors_1.hover }, nodeRow)
        ];
        if (index < (this.state.data.Items.length - 1)) {
            nodes.push(React.createElement(Divider_1.default, null));
        }
        return (React.Children.toArray(nodes));
    };
    return List;
}(PagingBaseComponent_1.default));
exports.List = List;
List.defaultProps = {
    showFilterWithinSection: true,
    autoFocusOnFilterSearch: true
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\List\\List.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\List\\List.tsx"); } } })();

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(68);
var Chip_1 = __webpack_require__(285);
var colors_1 = __webpack_require__(32);
var uiTestClasses_1 = __webpack_require__(77);
var Tag = function (props) {
    var tagName = props.tagName, tagColor = props.tagColor, tabIndex = props.tabIndex, description = props.description, _a = props.small, small = _a === void 0 ? false : _a;
    var tagDescription = (description ? tagName + ": " + description : "Tag: " + tagName);
    if (!small) {
        return React.createElement(Chip_1.default, { className: uiTestClasses_1.tagClass, tabIndex: tabIndex, onClick: props.onClick, onRequestDelete: props.onRequestDelete, backgroundColor: tagColor, description: tagDescription, labelColor: colors_1.white }, tagName);
    }
    return (React.createElement(index_1.default, { content: tagName },
        React.createElement("em", { className: "fa fa-square tag-swatch" + " " + uiTestClasses_1.tagClass, style: { color: tagColor, marginLeft: "0.0625rem", marginRight: "0.0625rem" } })));
};
exports.default = Tag;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Tag\\Tag.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Tag\\Tag.tsx"); } } })();

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Chips_1 = __webpack_require__(23);
var LookupReferenceDataItemChip_1 = __webpack_require__(103);
var Chips_2 = __webpack_require__(23);
var MultiSelect_1 = __webpack_require__(108);
exports.EnvironmentTypedMultiSelect = MultiSelect_1.default();
var EnvironmentMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Environment, chipRender: function (item) { return React.createElement(Chips_1.EnvironmentChip, { onRequestDelete: onRequestDelete, environmentName: item.Name }); } });
    };
    return React.createElement(exports.EnvironmentTypedMultiSelect, __assign({ items: props.items, fieldName: "environments", renderChip: chipRenderer }, props));
};
exports.default = EnvironmentMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\EnvironmentMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\EnvironmentMultiSelect.tsx"); } } })();

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TenantedDeploymentMode;
(function (TenantedDeploymentMode) {
    TenantedDeploymentMode["Untenanted"] = "Untenanted";
    TenantedDeploymentMode["TenantedOrUntenanted"] = "TenantedOrUntenanted";
    TenantedDeploymentMode["Tenanted"] = "Tenanted";
})(TenantedDeploymentMode = exports.TenantedDeploymentMode || (exports.TenantedDeploymentMode = {}));
exports.default = TenantedDeploymentMode;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\tenantedDeploymentMode.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\tenantedDeploymentMode.ts"); } } })();

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DeploymentCreateGoal;
(function (DeploymentCreateGoal) {
    DeploymentCreateGoal["To"] = "to";
    DeploymentCreateGoal["TryAgain"] = "try-again";
})(DeploymentCreateGoal = exports.DeploymentCreateGoal || (exports.DeploymentCreateGoal = {}));
function createLink(root, releaseVersion, goal, previousId, tenantIds) {
    var previousSegment = previousId ? "/" + previousId : "";
    var uri = root + "/releases/" + releaseVersion + "/deployments/create/" + goal + previousSegment;
    if (!tenantIds) {
        return uri;
    }
    var tenants = (Array.isArray(tenantIds)) ? tenantIds : [tenantIds];
    return uri + "/" + tenants.join(",");
}
exports.default = function (root) { return ({
    releases: root + "/releases",
    releaseCreate: root + "/releases/create",
    release: function (releaseVersion) {
        if (!!releaseVersion && typeof releaseVersion !== "string") {
            releaseVersion = releaseVersion.Version;
        }
        return {
            root: root + "/releases/" + releaseVersion,
            edit: root + "/releases/" + releaseVersion + "/edit",
            deployments: {
                specific: function (deploymentId) {
                    if (typeof deploymentId !== "string") {
                        deploymentId = deploymentId.Id;
                    }
                    return root + "/releases/" + releaseVersion + "/deployments/" + deploymentId;
                },
                retry: function (previousDeploymentId) {
                    return createLink(root, releaseVersion, DeploymentCreateGoal.TryAgain, previousDeploymentId);
                },
                create: function (goal, previousId, tenantIds) {
                    return createLink(root, releaseVersion, goal, previousId, tenantIds);
                }
            }
        };
    }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\Releases\\ReleasesRoutes\\releaseRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\Releases\\ReleasesRoutes\\releaseRouteLinks.ts"); } } })();

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SimpleDataTable_1 = __webpack_require__(432);
exports.default = SimpleDataTable_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SimpleDataTable\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SimpleDataTable\\index.tsx"); } } })();

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Chip_1 = __webpack_require__(563);
var colors_1 = __webpack_require__(32);
var lodash_1 = __webpack_require__(16);
var ToolTip_1 = __webpack_require__(215);
var fontWeights_1 = __webpack_require__(76);
var defaultChip = {
    style: {
        lineHeight: "1.5rem",
        height: "1.5rem",
        // multiple chips in a row where some do/don't contain an avatar. E.g. environments list).
        margin: 4,
        display: "inline-flex",
        backgroundColor: colors_1.secondaryBackground,
        borderWidth: "0",
        borderStyle: "none",
        borderColor: "rgba(0,0,0,0)",
        cursor: "inherit",
        verticalAlign: "middle"
    },
    labelStyle: {
        lineHeight: "1.5rem",
        fontSize: "0.75rem",
        color: colors_1.primaryText,
        fontWeight: fontWeights_1.normal,
        maxWidth: "12.5rem",
        textDecoration: "none",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },
    deleteIconStyle: {
        margin: "0.0625rem 0.25rem 0 -8px",
        width: "1.375rem",
        height: "1.375rem"
    }
};
var Chip = function (props) {
    var chipStyle = lodash_1.merge({}, defaultChip);
    var markAsRemoved = props.markAsRemoved, avatar = props.avatar, fullWidth = props.fullWidth, rest = __rest(props, ["markAsRemoved", "avatar", "fullWidth"]);
    var otherProps = __assign({ tabIndex: -1 }, rest);
    chipStyle.labelStyle.textDecoration = markAsRemoved ? "line-through" : "none";
    if (props.backgroundColor) {
        chipStyle.style["backgroundColor"] = props.backgroundColor;
    }
    if (props.bordercolor) {
        chipStyle.style["borderWidth"] = "0.0625rem";
        chipStyle.style["borderStyle"] = "solid";
        chipStyle.style["borderColor"] = props.bordercolor;
    }
    if (props.labelColor) {
        chipStyle.labelStyle["color"] = props.labelColor;
    }
    if (props.fullWidth) {
        chipStyle.labelStyle["maxWidth"] = "none";
    }
    return React.createElement(Chip_1.default, __assign({ style: chipStyle.style, labelStyle: chipStyle.labelStyle, deleteIconStyle: chipStyle.deleteIconStyle }, otherProps),
        avatar,
        React.createElement(ToolTip_1.default, { content: React.createElement("span", null, props.description || props.children) }, props.children));
};
exports.default = Chip;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Chips\\Chip.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Chips\\Chip.tsx"); } } })();

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(16);
var ExpanderActions = {
    EXPANDER_STATE_CHANGED: "EXPANDER_STATE_CHANGED",
    EXPANDER_CONTAINER_DESTROYED: "EXPANDER_CONTAINER_DESTROYED",
    EXPANDER_CONTAINER_INITIAL_STATE: "EXPANDER_CONTAINER_INITIAL_STATE",
    EXPANDER_EXPAND_ERRORS: "EXPANDER_EXPAND_ERRORS",
    EXPANDER_TOGGLE_ALL: "EXPANDER_TOGGLE_ALL",
    EXPANDER_CREATED: "EXPANDER_CREATED",
    ALL_EXPANDERS_CREATED: "ALL_EXPANDERS_CREATED",
};
function onExpandErrors(containerKey, expandersWithErrors) {
    return { type: ExpanderActions.EXPANDER_EXPAND_ERRORS, containerKey: containerKey, expandersWithErrors: expandersWithErrors };
}
exports.onExpandErrors = onExpandErrors;
function onToggleAll(containerKey, expanded) {
    return { type: ExpanderActions.EXPANDER_TOGGLE_ALL, containerKey: containerKey, expanded: expanded };
}
exports.onToggleAll = onToggleAll;
function onExpanderCreated(containerKey, key, expanded) {
    return { type: ExpanderActions.EXPANDER_CREATED, containerKey: containerKey, key: key, expanded: expanded };
}
exports.onExpanderCreated = onExpanderCreated;
function onAllExpandersCreated(containerKey, keys, expanded) {
    return { type: ExpanderActions.ALL_EXPANDERS_CREATED, containerKey: containerKey, keys: keys, expanded: expanded };
}
exports.onAllExpandersCreated = onAllExpandersCreated;
function onExpanderContainerDestroyed(containerKey) {
    return { type: ExpanderActions.EXPANDER_CONTAINER_DESTROYED, containerKey: containerKey };
}
exports.onExpanderContainerDestroyed = onExpanderContainerDestroyed;
function onExpanderStateChanged(containerKey, key, expanded) {
    return { type: ExpanderActions.EXPANDER_STATE_CHANGED, containerKey: containerKey, key: key, expanded: expanded };
}
exports.onExpanderStateChanged = onExpanderStateChanged;
function onExpanderSetInitialState(containerKey, initialState) {
    return { type: ExpanderActions.EXPANDER_CONTAINER_INITIAL_STATE, containerKey: containerKey, initialState: initialState };
}
exports.onExpanderSetInitialState = onExpanderSetInitialState;
exports.defaultContainerKey = "default";
var expanders = function (state, action) {
    if (state === void 0) { state = {}; }
    var containerKey = action.containerKey || exports.defaultContainerKey;
    switch (action.type) {
        case ExpanderActions.EXPANDER_EXPAND_ERRORS:
            return expanderExpandErrors(state, action, containerKey);
        case ExpanderActions.EXPANDER_TOGGLE_ALL:
            return expanderToggleAll(state, action, containerKey);
        case ExpanderActions.EXPANDER_STATE_CHANGED:
            return expanderStateChanged(state, action, containerKey);
        case ExpanderActions.EXPANDER_CONTAINER_DESTROYED:
            return expanderContainerDestroyed(state, action, containerKey);
        case ExpanderActions.EXPANDER_CONTAINER_INITIAL_STATE:
            return expanderContainerInitialState(state, action, containerKey);
        case ExpanderActions.EXPANDER_CREATED:
            return expanderCreated(state, action, containerKey);
        case ExpanderActions.ALL_EXPANDERS_CREATED:
            return allExpandersCreated(state, action, containerKey);
        default:
            return state;
    }
};
function expanderExpandErrors(state, action, containerKey) {
    var container = state[containerKey] || defaultValue();
    var errored = action.expandersWithErrors
        .map(function (e) { return findMatchingKey(container.expanderValues, e); })
        .filter(function (e) { return e !== null; })
        .reduce(function (p, c) {
        return (__assign({}, p, (_a = {}, _a[c] = true, _a)));
        var _a;
    }, {});
    var updatedContainer = __assign({}, container, { expanderValues: __assign({}, container.expanderValues, errored) });
    if (lodash_1.isEqual(container, updatedContainer)) {
        return state;
    }
    return __assign({}, state, (_a = {}, _a[containerKey] = updatedContainer, _a));
    var _a;
}
function findMatchingKey(expanderValues, key) {
    // given an object with some pipe-delimited keys like:
    // {
    //     "first|second": true
    // }
    // given "first" return "first|second". This allows us to set errorkeys that
    // match multiple possible errors (ie if you have an expander with mutiple controls)
    // remove "Steps[12]." and "Actions[0]." from the start of the error key. Our validation adds that
    // to indicate which step the error is in
    var modKey = key.replace(/^Steps\[[0-9]+\]\./, "");
    modKey = modKey.replace(/^Actions\[[0-9]+\]\./, "");
    return Object.keys(expanderValues).find(function (k) { return k.split("|").some(function (f) { return f === modKey; }); });
}
function expanderToggleAll(state, action, containerKey) {
    var container = state[containerKey] || defaultValue();
    var updatedContainer = __assign({}, container, { expandingAll: action.expanded, expanderValues: setAllToValue(container.expanderValues, action.expanded) });
    return __assign({}, state, (_a = {}, _a[containerKey] = updatedContainer, _a));
    var _a;
}
function expanderStateChanged(state, action, containerKey) {
    var container = state[containerKey] || defaultValue();
    var updatedContainer = __assign({}, container, { expandingAll: false, expanderValues: __assign({}, container.expanderValues, (_a = {}, _a[action.key] = action.expanded, _a)) });
    return __assign({}, state, (_b = {}, _b[containerKey] = updatedContainer, _b));
    var _a, _b;
}
function expanderContainerDestroyed(state, action, containerKey) {
    var copy = __assign({}, state);
    delete copy[containerKey];
    return copy;
}
function expanderContainerInitialState(state, action, containerKey) {
    // set the initial state of the expander container, if there are already
    // expanders attached, set them to that state as well
    var container = state[containerKey] || defaultValue();
    var updatedContainer = {
        expanderValues: setAllToValue(container.expanderValues, null),
        initialState: action.initialState,
        expandingAll: false
    };
    return __assign({}, state, (_a = {}, _a[containerKey] = updatedContainer, _a));
    var _a;
}
function expanderCreated(state, action, containerKey) {
    var container = state[containerKey] || defaultValue();
    var existingValue = container.expanderValues[action.key];
    var expanderValue = existingValue !== undefined ? existingValue : action.expanded;
    var updatedContainer = __assign({}, container, { expanderValues: __assign({}, container.expanderValues, (_a = {}, _a[action.key] = expanderValue, _a)) });
    return __assign({}, state, (_b = {}, _b[containerKey] = updatedContainer, _b));
    var _a, _b;
}
function allExpandersCreated(state, action, containerKey) {
    // add a full set of expanders to a container. overwrite any existing.
    var container = state[containerKey] || defaultValue();
    var expanderValues = action.keys.reduce(function (acc, key) {
        acc[key] = action.expanded;
        return acc;
    }, {});
    return __assign({}, state, (_a = {}, _a[containerKey] = __assign({}, container, { expanderValues: expanderValues }), _a));
    var _a;
}
function defaultValue() {
    return { initialState: false, expanderValues: {}, expandingAll: false };
}
function setAllToValue(expanderValues, to) {
    var newExpanderValues = {};
    Object.keys(expanderValues).forEach(function (k) { newExpanderValues[k] = to; });
    return newExpanderValues;
}
exports.default = expanders;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\reducers\\expanders.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\reducers\\expanders.ts"); } } })();

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FilterSearchBox_1 = __webpack_require__(171);
exports.default = FilterSearchBox_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FilterSearchBox\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FilterSearchBox\\index.tsx"); } } })();

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DialogActions = {
    DIALOG_OPEN: "DIALOG_OPEN",
    DIALOG_CLOSE: "DIALOG_CLOSE"
};
function openDialog(key) {
    return { type: DialogActions.DIALOG_OPEN, key: key };
}
exports.openDialog = openDialog;
function onDialogClose() {
    return { type: DialogActions.DIALOG_CLOSE };
}
exports.onDialogClose = onDialogClose;
var dialogs = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case DialogActions.DIALOG_OPEN:
            var updated = {}; // only one open
            updated[action.key] = true;
            return updated;
        case DialogActions.DIALOG_CLOSE:
            return {}; // close all
    }
    return state;
};
exports.default = dialogs;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\reducers\\dialog.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\reducers\\dialog.ts"); } } })();

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(108);
var Chips_1 = __webpack_require__(23);
var LookupResourceChip_1 = __webpack_require__(144);
var Chips_2 = __webpack_require__(23);
var TeamTypedMultiSelect = MultiSelect_1.default();
var LookupTeamChip = LookupResourceChip_1.default();
var TeamMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupTeamChip, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Team, chipRender: function (item) { return React.createElement(Chips_1.TeamChip, { onRequestDelete: onRequestDelete, team: item }); } });
    };
    return React.createElement(TeamTypedMultiSelect, __assign({ items: props.items, label: "Select teams", renderChip: chipRenderer }, props));
};
exports.default = TeamMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\TeamMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\TeamMultiSelect.tsx"); } } })();

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var tenantTagsets = __webpack_require__(138);
var Tag_1 = __webpack_require__(216);
var MissingTagsList = (function (_super) {
    __extends(MissingTagsList, _super);
    function MissingTagsList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { tagIndex: null };
        return _this;
    }
    MissingTagsList.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, tenantTagsets.getTagIndex()];
                    case 1:
                        _a.apply(this, [(_b.tagIndex = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    MissingTagsList.prototype.render = function () {
        var _this = this;
        if (!this.state.tagIndex) {
            return null;
        }
        var groupedTagsets = tenantTagsets.groupByTagSet(this.props.tags);
        var items = [];
        var tagSets = Object.keys(groupedTagsets);
        tagSets.forEach(function (tagSetId) {
            var missingTags = groupedTagsets[tagSetId];
            if (items.length > 0) {
                items.push(React.createElement("span", { key: items.length }, " and "));
            }
            if (missingTags.length === 1) {
                var tag = _this.state.tagIndex[missingTags[0]];
                items.push(React.createElement(Tag_1.default, { key: items.length, description: tag.Description, tagName: tag.Name, tagColor: tag.Color, small: false }));
                return;
            }
            if (tagSets.length > 1) {
                items.push(React.createElement("span", { key: items.length }, "("));
            }
            for (var index = 0; index < missingTags.length; index++) {
                var tag = _this.state.tagIndex[missingTags[index]];
                if (index === missingTags.length - 1) {
                    items.push(React.createElement("span", { key: items.length }, " or "));
                }
                else if (index !== 0) {
                    items.push(React.createElement("span", { key: items.length }, ", "));
                }
                items.push(React.createElement(Tag_1.default, { key: items.length, tagName: tag.Name, description: tag.Description, tagColor: tag.Color, small: false }));
            }
            if (tagSets.length > 1) {
                items.push(React.createElement("span", { key: items.length }, ")"));
            }
        });
        return React.createElement("span", null, items);
    };
    return MissingTagsList;
}(React.Component));
exports.default = MissingTagsList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TenantTagDesignDialog\\MissingTagsList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TenantTagDesignDialog\\MissingTagsList.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Logo_1 = __webpack_require__(172);
exports.default = Logo_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Logo\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Logo\\index.tsx"); } } })();

/***/ }),
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Note_1 = __webpack_require__(22);
var MoreInfo = (function (_super) {
    __extends(MoreInfo, _super);
    function MoreInfo(props) {
        var _this = _super.call(this, props) || this;
        _this.openMoreInfo = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.props.onClick) {
                _this.props.onClick(_this.props.content);
            }
        };
        return _this;
    }
    MoreInfo.prototype.render = function () {
        return React.createElement(Note_1.default, null,
            React.createElement("a", { href: "#", onClick: this.openMoreInfo }, this.props.label || "More information"));
    };
    return MoreInfo;
}(React.Component));
MoreInfo.defaultProps = {
    isMoreInfo: true
};
exports.default = MoreInfo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\MoreInfo.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\MoreInfo.tsx"); } } })();

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(108);
var Tag_1 = __webpack_require__(216);
var tenantTagsets = __webpack_require__(138);
var TagResourceMultiSelect = MultiSelect_1.default();
var TenantTagMultiSelect = (function (_super) {
    __extends(TenantTagMultiSelect, _super);
    function TenantTagMultiSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.chipRenderer = function (tagSet, r, onRequestDelete) {
            var tag = tagSet.Tags.find(function (t) { return t.Id === r.Id; });
            return React.createElement(Tag_1.default, { onRequestDelete: onRequestDelete, description: tag.Description, tagName: tag.Name, tagColor: tag.Color });
        };
        _this.state = {
            tagSets: (_this.props.items ?
                (typeof _this.props.items === "function" ?
                    _this.props.items() :
                    _this.props.items).sort(function (t1, t2) { return t1.SortOrder - t2.SortOrder; }) :
                null)
        };
        return _this;
    }
    TenantTagMultiSelect.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var tagSets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.state.tagSets) return [3 /*break*/, 2];
                        return [4 /*yield*/, tenantTagsets.getAll()];
                    case 1:
                        tagSets = _a.sent();
                        this.setState({ tagSets: tagSets.sort(function (t1, t2) { return t1.SortOrder - t2.SortOrder; }) });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    TenantTagMultiSelect.prototype.onChange = function (tagSet, tagIds) {
        var oldState = tenantTagsets.groupByTagSet(this.props.value);
        oldState[tagSet.Name] = tagIds.map(function (id) { return tagSet.Tags.find(function (p) { return p.Id === id; }).CanonicalTagName; });
        var newState = tenantTagsets.flattenGroup(oldState);
        this.props.onChange(newState);
    };
    TenantTagMultiSelect.prototype.render = function () {
        var _this = this;
        if (!this.state.tagSets) {
            return null;
        }
        var options = this.state.tagSets.map(function (ts, index) {
            // No point showing the selector if this tagset has no tags.
            if (!ts.Tags || ts.Tags.length === 0) {
                return null;
            }
            var selected = _this.props.value
                ? ts.Tags.filter(function (t) { return _this.props.value.indexOf(t.CanonicalTagName) !== -1; }).map(function (t) { return t.Id; })
                : [];
            return React.createElement(TagResourceMultiSelect, { onChange: function (items) { return _this.onChange(ts, items); }, key: ts.Id, value: selected, items: ts.Tags ? ts.Tags.sort(function (t1, t2) { return t1.SortOrder - t2.SortOrder; }) : null, renderChip: function (r, dc) { return _this.chipRenderer(ts, r, dc); }, fieldName: ts.Name + " tags", description: ts.Description, autoFocus: _this.props.autoFocus && index === 0 });
        });
        return React.createElement("div", null, options);
    };
    return TenantTagMultiSelect;
}(React.Component));
exports.default = TenantTagMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\TenantTagMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\TenantTagMultiSelect.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(67);
var dialog_1 = __webpack_require__(288);
var DialogLayoutConnect = (function () {
    function DialogLayoutConnect() {
    }
    DialogLayoutConnect.to = function (internal) {
        var mapDispatchToProps = function (dispatch) {
            return {
                close: function () {
                    dispatch(dialog_1.onDialogClose());
                }
            };
        };
        return react_redux_1.connect(null, mapDispatchToProps)(internal);
    };
    return DialogLayoutConnect;
}());
exports.DialogLayoutConnect = DialogLayoutConnect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\DialogLayoutConnect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\DialogLayoutConnect.tsx"); } } })();

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ParseHelper_1 = __webpack_require__(422);
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var DeploymentProcessOverview_1 = __webpack_require__(1834);
var StepDetailsLoader_1 = __webpack_require__(1846);
var ActionTemplateSelector_1 = __webpack_require__(1878);
var ReloadableRoute_1 = __webpack_require__(80);
var DeploymentProcessRoute = (function (_super) {
    __extends(DeploymentProcessRoute, _super);
    function DeploymentProcessRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeploymentProcessRoute.nextStepReloadPath = function (currentPath, currentKey) {
        var path = currentPath;
        if (currentKey) {
            var keyNum = ParseHelper_1.default.safeParseInt(currentKey, 0) + 1;
            path = path.slice(0, -currentKey.length) + keyNum.toString();
        }
        else {
            path = path + "/1";
        }
        return path;
    };
    DeploymentProcessRoute.prototype.render = function () {
        var match = this.props.match;
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { path: match.path + "/step/new/:actionType/:template?", component: StepDetailsLoader_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: match.path + "/step/:stepId/new/:actionType/:template?", component: StepDetailsLoader_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: match.path + "/step/:stepId/:reloadKey?", component: StepDetailsLoader_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: match.path + "/steptemplates", component: ActionTemplateSelector_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: match.path + "/childsteptemplates/:parentStepId", component: ActionTemplateSelector_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: "" + match.path, component: DeploymentProcessOverview_1.default })));
    };
    return DeploymentProcessRoute;
}(React.Component));
exports.DeploymentProcessRoute = DeploymentProcessRoute;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentProcessRoute.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentProcessRoute.tsx"); } } })();

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RemoveItemsList_1 = __webpack_require__(142);
var ParseHelper_1 = __webpack_require__(75);
var Text_1 = __webpack_require__(17);
var ActionButton_1 = __webpack_require__(50);
var StringRemoveItemsList = (function (_super) {
    __extends(StringRemoveItemsList, _super);
    function StringRemoveItemsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StringRemoveItemsList;
}(RemoveItemsList_1.RemoveItemsList));
var StringEditList = (function (_super) {
    __extends(StringEditList, _super);
    function StringEditList(props) {
        var _this = _super.call(this, props) || this;
        _this.adding = false;
        _this.handleRemoveRow = function (item) {
            var data = _this.state.source;
            data.splice(data.indexOf(item), 1);
            _this.invokeOnChange(data);
        };
        _this.handleRowRef = function (idx) { return function (input) {
            if (input && _this.adding && idx === 0) {
                input.focus();
                _this.adding = false;
            }
        }; };
        _this.handleRowChange = function (idx) { return function (val) {
            var data = _this.state.source;
            data[idx] = val;
            _this.invokeOnChange(data);
        }; };
        _this.invokeOnChange = function (data) {
            _this.props.onChange(ParseHelper_1.default.encodeCSV(data.filter(function (t) { return t != null && t !== ""; })));
        };
        _this.handleAddClick = function () {
            var data = _this.state.source;
            _this.adding = true;
            _this.setState({ source: [""].concat(data) });
        };
        _this.renderRow = function (item, idx) {
            var data = _this.state.source;
            var warning = data.filter(function (t) { return t === item; }).length > 1 ? "This value has already been added" : null;
            return React.createElement(Text_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, textInputRef: _this.handleRowRef(idx), key: "KEYY-" + idx, value: item, onChange: _this.handleRowChange(idx), warning: warning, label: _this.props.label, hintText: _this.props.hintText });
        };
        _this.state = {
            source: []
        };
        return _this;
    }
    StringEditList.prototype.componentDidMount = function () {
        this.setInternalState(this.props);
    };
    StringEditList.prototype.setInternalState = function (props) {
        this.setState({ source: ParseHelper_1.default.parseCSV(this.props.items || "") });
    };
    StringEditList.prototype.render = function () {
        var name = this.props.name || this.props.label;
        var actionButton = React.createElement(ActionButton_1.default, { key: "Add", label: "Add " + name, onClick: this.handleAddClick });
        return React.createElement(StringRemoveItemsList, { listActions: [actionButton], data: this.state.source, onRemoveRow: this.handleRemoveRow, onRow: this.renderRow, clearButtonToolTip: "Remove " + name });
    };
    return StringEditList;
}(React.PureComponent));
exports.default = StringEditList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EditList\\StringEditList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EditList\\StringEditList.tsx"); } } })();

/***/ }),
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var TriggerFilterResource = (function () {
    function TriggerFilterResource() {
    }
    return TriggerFilterResource;
}());
exports.TriggerFilterResource = TriggerFilterResource;
var TriggerActionResource = (function () {
    function TriggerActionResource() {
    }
    return TriggerActionResource;
}());
exports.TriggerActionResource = TriggerActionResource;
var MachineFilterResource = (function (_super) {
    __extends(MachineFilterResource, _super);
    function MachineFilterResource() {
        var _this = _super.call(this) || this;
        _this.FilterType = TriggerFilterType.MachineFilter;
        return _this;
    }
    return MachineFilterResource;
}(TriggerFilterResource));
exports.MachineFilterResource = MachineFilterResource;
var AutoDeployActionResource = (function (_super) {
    __extends(AutoDeployActionResource, _super);
    function AutoDeployActionResource() {
        var _this = _super.call(this) || this;
        _this.ActionType = TriggerActionType.AutoDeploy;
        return _this;
    }
    return AutoDeployActionResource;
}(TriggerActionResource));
exports.AutoDeployActionResource = AutoDeployActionResource;
var TriggerFilterType;
(function (TriggerFilterType) {
    TriggerFilterType["MachineFilter"] = "MachineFilter";
    TriggerFilterType["DailySchedule"] = "DailySchedule";
    TriggerFilterType["DaysPerWeekSchedule"] = "DaysPerWeekSchedule";
    TriggerFilterType["DaysPerMonthSchedule"] = "DaysPerMonthSchedule";
    TriggerFilterType["CronExpressionSchedule"] = "CronExpressionSchedule";
})(TriggerFilterType = exports.TriggerFilterType || (exports.TriggerFilterType = {}));
var TriggerActionType;
(function (TriggerActionType) {
    TriggerActionType["AutoDeploy"] = "AutoDeploy";
    TriggerActionType["DeployLatestRelease"] = "DeployLatestRelease";
    TriggerActionType["DeployNewRelease"] = "DeployNewRelease";
})(TriggerActionType = exports.TriggerActionType || (exports.TriggerActionType = {}));
function isExistingTriggerResource(resource) {
    return resource.Links !== undefined;
}
exports.isExistingTriggerResource = isExistingTriggerResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\triggerResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\triggerResource.ts"); } } })();

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_actions_1 = __webpack_require__(502);
var ActionTypes = {
    UNHANDLED_ERROR_CLEARED: "UNHANDLED_ERROR_CLEARED",
};
function clearUnhandledErrorAction() {
    return { type: ActionTypes.UNHANDLED_ERROR_CLEARED };
}
exports.clearUnhandledErrorAction = clearUnhandledErrorAction;
var clearUnhandledError = redux_actions_1.handleActions((_a = {},
    _a[ActionTypes.UNHANDLED_ERROR_CLEARED] = function (state, action) {
        return null;
    },
    _a), null);
exports.default = clearUnhandledError;
var _a;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\StandardLayout\\reducers.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\StandardLayout\\reducers.tsx"); } } })();

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
function uploadLogo(resource, logo) {
    var fd = new FormData();
    fd.append("fileToUpload", logo);
    return clientInstance_1.client.post(resource.Links["Logo"], fd);
}
exports.uploadLogo = uploadLogo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\logoUpload.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\logoUpload.ts"); } } })();

/***/ }),
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1212);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var cn = __webpack_require__(19);
var InsertVariableButton_1 = __webpack_require__(1366);
var React = __webpack_require__(0);
var styles = __webpack_require__(1381);
function withVariableLookup() {
    return function (Comp) { return (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            var _this = this;
            var _a = this.props, localNames = _a.localNames, projectId = _a.projectId, syntax = _a.syntax, textInputRef = _a.textInputRef, wide = _a.wide, otherProps = __rest(_a, ["localNames", "projectId", "syntax", "textInputRef", "wide"]);
            var containerClassName = cn((_b = {}, _b[styles.container] = true, _b));
            return React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.wide },
                    React.createElement(Comp, __assign({ key: "component", textInputRef: function (ref) { return _this.textInputRef = ref; } }, otherProps))),
                React.createElement("div", { key: "buttons", className: styles.buttons },
                    React.createElement(InsertVariableButton_1.default, { syntax: this.props.syntax, projectId: this.props.projectId, localNames: this.props.localNames, onSelected: function (v) { return _this.insert(v); } })));
            var _b;
        };
        class_1.prototype.insert = function (val) {
            if (this.textInputRef) {
                this.textInputRef.insertAtCursor(val);
                this.textInputRef.focus();
            }
        };
        return class_1;
    }(React.Component)); };
}
exports.withVariableLookup = withVariableLookup;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\VariableLookup\\VariableLookup.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\VariableLookup\\VariableLookup.tsx"); } } })();

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UniqueSequenceGenerator = (function () {
    function UniqueSequenceGenerator() {
        this.currentValue = 0;
    }
    UniqueSequenceGenerator.prototype.next = function () {
        this.currentValue++;
        return this.currentValue;
    };
    return UniqueSequenceGenerator;
}());
exports.UniqueSequenceGenerator = UniqueSequenceGenerator;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\UniqueSequenceGenerator\\UniqueSequenceGenerator.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\UniqueSequenceGenerator\\UniqueSequenceGenerator.ts"); } } })();

/***/ }),
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
function exposeComponentAsClass(Component) {
    return (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            return React.createElement(Component, __assign({}, this.props));
        };
        return class_1;
    }(React.Component));
}
exports.exposeComponentAsClass = exposeComponentAsClass;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\exposeComponentAsClass.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\exposeComponentAsClass.tsx"); } } })();

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var resolvePathWithSpaceId_1 = __webpack_require__(131);
function isUrlActive(currentUrl, spaceId, toUrl, exact) {
    var resolvedToUrl = toUrl ? resolvePathWithSpaceId_1.resolveStringPathWithSpaceId(toUrl, spaceId) : toUrl;
    return exact ? currentUrl === resolvedToUrl : currentUrl.startsWith(resolvedToUrl);
}
exports.isUrlActive = isUrlActive;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\isUrlActive.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\isUrlActive.tsx"); } } })();

/***/ }),
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1603);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InputWithActions_1 = __webpack_require__(145);
exports.default = InputWithActions_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\InputWithActions\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\InputWithActions\\index.tsx"); } } })();

/***/ }),
/* 384 */,
/* 385 */,
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1687);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var resources_1 = __webpack_require__(26);
var CertificateSelect_1 = __webpack_require__(798);
var AccountSelect_1 = __webpack_require__(177);
var Sensitive_1 = __webpack_require__(82);
var styles = __webpack_require__(1861);
var AccountVariableSelect_1 = __webpack_require__(696);
var CertificateVariableSelect_1 = __webpack_require__(165);
var Options_1 = __webpack_require__(698);
var getResetValue_1 = __webpack_require__(397);
var DebounceValue_1 = __webpack_require__(173);
var Text_1 = __webpack_require__(17);
var Select_1 = __webpack_require__(41);
var StringCheckbox_1 = __webpack_require__(38);
var ActionTemplateParameterInput = (function (_super) {
    __extends(ActionTemplateParameterInput, _super);
    function ActionTemplateParameterInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getInputControl = function () {
            var _a = _this.props, warning = _a.warning, _b = _a.sourceItems, sourceItems = _b === void 0 ? {} : _b, doBusyTask = _a.doBusyTask, value = _a.value, localNames = _a.localNames, projectId = _a.projectId, error = _a.error, rest = __rest(_a, ["warning", "sourceItems", "doBusyTask", "value", "localNames", "projectId", "error"]);
            var resetValue = getResetValueFromParameter(_this.props.parameter);
            var type = _this.props.parameter.DisplaySettings["Octopus.ControlType"];
            var label = _this.props.parameter.Label || _this.props.parameter.Name;
            var formProps = __assign({}, rest, { label: label });
            var fieldValue = value !== undefined
                ? value
                : (typeof resetValue === "function" ? resetValue() : resetValue);
            switch (type) {
                case resources_1.ControlType.SingleLineText:
                    return React.createElement(Text_1.VariableLookupText, __assign({ projectId: sourceItems.projectId, localNames: localNames, warning: warning }, formProps, { value: fieldValue }));
                case resources_1.ControlType.MultiLineText:
                    return React.createElement(Text_1.VariableLookupText, __assign({ projectId: sourceItems.projectId, localNames: localNames, multiLine: true, warning: warning }, formProps, { value: fieldValue }));
                case resources_1.ControlType.Select: {
                    var options = Options_1.default(_this.props.parameter.DisplaySettings["Octopus.SelectOptions"]);
                    var allowClear = _this.props.parameter.AllowClear !== undefined ? _this.props.parameter.AllowClear : true;
                    return React.createElement(Select_1.BoundSelect, __assign({ variableLookup: {
                            localNames: localNames,
                            projectId: sourceItems.projectId
                        }, resetValue: resetValue, items: options, warning: warning, allowClear: allowClear, value: fieldValue }, formProps));
                }
                case resources_1.ControlType.Checkbox: {
                    return React.createElement(StringCheckbox_1.BoundStringCheckbox, __assign({ variableLookup: {
                            localNames: localNames,
                            projectId: sourceItems.projectId
                        }, resetValue: resetValue, warning: warning }, formProps, { value: fieldValue }));
                }
                case resources_1.ControlType.Sensitive:
                    return React.createElement(Sensitive_1.BoundSensitive, __assign({ variableLookup: {
                            localNames: localNames,
                            projectId: sourceItems.projectId
                        }, value: fieldValue, resetValue: resetValue }, formProps));
                case resources_1.ControlType.StepName:
                    var items = sourceItems.stepNames ? sourceItems.stepNames.map(function (s) { return ({ value: s, text: s }); }) : [];
                    return React.createElement(Select_1.BoundSelect, __assign({ variableLookup: {
                            localNames: localNames,
                            projectId: sourceItems.projectId
                        }, resetValue: resetValue, items: items, value: fieldValue, warning: warning }, formProps));
                case resources_1.ControlType.AzureAccount:
                    return React.createElement(AccountSelect_1.BoundAccountSelect, __assign({ variableLookup: {
                            localNames: localNames,
                            projectId: sourceItems.projectId
                        }, resetValue: resetValue, value: fieldValue, onRequestRefresh: sourceItems.accounts ? sourceItems.accounts.onRequestRefresh : _this.noop, items: sourceItems.accounts ? sourceItems.accounts.items : [], type: sourceItems.accounts ? sourceItems.accounts.type : [], warning: warning, allowClear: true }, formProps));
                case resources_1.ControlType.Certificate:
                    return sourceItems.projectId
                        ? React.createElement(CertificateVariableSelect_1.BoundCertificateVariableSelect, __assign({ variableLookup: {
                                localNames: _this.props.localNames,
                                projectId: _this.props.projectId
                            }, resetValue: resetValue, value: fieldValue, projectId: sourceItems.projectId, doBusyTask: _this.props.doBusyTask, allowClear: true }, formProps))
                        : React.createElement(CertificateSelect_1.BoundCertificateSelect, __assign({ variableLookup: {
                                localNames: localNames,
                                projectId: sourceItems.projectId
                            }, resetValue: resetValue, value: fieldValue, warning: warning, doBusyTask: doBusyTask, tenantId: _this.props.sourceItems.tenantId, allowClear: true }, formProps));
                case resources_1.ControlType.AmazonWebServicesAccount:
                    return sourceItems.projectId ?
                        React.createElement(AccountVariableSelect_1.BoundAccountVariableSelect, __assign({ value: fieldValue, resetValue: resetValue, projectId: sourceItems.projectId, doBusyTask: _this.props.doBusyTask, allowClear: true }, formProps)) :
                        React.createElement(AccountSelect_1.BoundAccountSelect, __assign({ resetValue: resetValue, value: fieldValue, onRequestRefresh: sourceItems.accounts ? sourceItems.accounts.onRequestRefresh : _this.noop, items: sourceItems.accounts ? sourceItems.accounts.items : [], type: [resources_1.AccountType.AmazonWebServicesAccount], warning: warning, allowClear: true }, formProps));
                default:
                    return React.createElement(Text_1.default, __assign({ warning: warning }, formProps, { value: fieldValue }));
            }
        };
        _this.noop = function () {
            return Promise.resolve();
        };
        return _this;
    }
    ActionTemplateParameterInput.prototype.render = function () {
        return React.createElement("div", { className: styles.container }, this.getInputControl());
    };
    return ActionTemplateParameterInput;
}(React.Component));
function getResetValueFromParameter(parameter) {
    return parameter.DisplaySettings &&
        parameter.DisplaySettings["Octopus.ControlType"] === "Sensitive" ? getResetValue_1.default(parameter.DefaultValue) : parameter.DefaultValue;
}
exports.default = DebounceValue_1.default(ActionTemplateParameterInput);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplateParameterInput\\ActionTemplateParameterInput.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplateParameterInput\\ActionTemplateParameterInput.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(16);
// Returns a reset-value function for use with bound-field directive
var getResetValue = function (model) {
    // If not an object, then it wasn't a sensitive-value
    if (typeof (model) !== "object") {
        return function () {
            return { HasValue: false };
        };
    }
    var initial = lodash_1.clone(model);
    return function () {
        return lodash_1.clone(initial);
    };
};
exports.default = getResetValue;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sensitive\\getResetValue.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sensitive\\getResetValue.ts"); } } })();

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(35);
var resources_1 = __webpack_require__(26);
var form_1 = __webpack_require__(15);
var PackageSelector_1 = __webpack_require__(58);
var PackageDownloadOptions_1 = __webpack_require__(135);
var ExternalLink_1 = __webpack_require__(29);
var InternalLink_1 = __webpack_require__(42);
var FormSectionHeading_1 = __webpack_require__(46);
var feedResource_1 = __webpack_require__(54);
var CommonSummaryHelper_1 = __webpack_require__(62);
var routeLinks_1 = __webpack_require__(20);
var getFeedName_1 = __webpack_require__(66);
var ActionDetails_1 = __webpack_require__(27);
var feedResource_2 = __webpack_require__(54);
var TentaclePackageAction = (function (_super) {
    __extends(TentaclePackageAction, _super);
    function TentaclePackageAction(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    TentaclePackageAction.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    TentaclePackageAction.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy package ",
            React.createElement("strong", null,
                this.props.properties[specialVariables_1.default.Action.Package.PackageId],
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, this.getFeedId()),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    TentaclePackageAction.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return TentaclePackageAction;
}(BaseComponent_1.BaseComponent));
var TentaclePackageActionEdit = (function (_super) {
    __extends(TentaclePackageActionEdit, _super);
    function TentaclePackageActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feeds: []
        };
        return _this;
    }
    TentaclePackageActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var feeds, properties;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        feeds = _a.sent();
                        properties = {};
                        if (!this.props.properties["Octopus.Action.Package.DownloadOnTentacle"]) {
                            properties["Octopus.Action.Package.DownloadOnTentacle"] = "False";
                        }
                        if (!this.props.properties["Octopus.Action.Package.FeedId"]) {
                            properties["Octopus.Action.Package.FeedId"] = feedResource_1.BuiltInFeedId;
                        }
                        this.props.setProperties(properties, true);
                        this.setState({ feeds: feeds });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    TentaclePackageActionEdit.prototype.render = function () {
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to deploy the contents of a package to one or more machines. You can configure the remote machines to deploy to in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.infrastructure.root, openInSelf: false }, "Infrastructure"),
                " tab. The package that you wish to deploy should contain all the files needed to run your application. Learn more about ",
                React.createElement(ExternalLink_1.default, { href: "DocumentationPackaging" }, "what your packages should contain, and how to create them"),
                ".")
            : React.createElement("span", null, "Choose the package you which to deploy");
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Package Details" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "package", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(this.props.properties, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors, feedType: [feedResource_2.FeedType.Nuget, feedResource_2.FeedType.Maven, feedResource_2.FeedType.GitHub] }),
                React.createElement(PackageDownloadOptions_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, localNames: this.props.localNames, errors: this.props.errors })));
    };
    return TentaclePackageActionEdit;
}(BaseComponent_1.BaseComponent));
exports.TentaclePackageActionEdit = TentaclePackageActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    actionType: "Octopus.TentaclePackage",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(TentaclePackageAction, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: TentaclePackageActionEdit,
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnTarget,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles",
            "Octopus.Features.IisHome", "Octopus.Features.IISWebSite", "Octopus.Features.RedGateDatabase", "Octopus.Features.WindowsService"],
        initial: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\tentaclePackage\\tentaclePackageAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\tentaclePackage\\tentaclePackageAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FormBaseComponent_1 = __webpack_require__(137);
exports.FormBaseComponent = FormBaseComponent_1.default;
exports.OptionalFormBaseComponentState = FormBaseComponent_1.OptionalFormBaseComponentState;
exports.default = FormBaseComponent_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FormBaseComponent\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FormBaseComponent\\index.ts"); } } })();

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DateFormatter_1 = __webpack_require__(743);
exports.default = DateFormatter_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\DateFormatter\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\DateFormatter\\index.tsx"); } } })();

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VariableType;
(function (VariableType) {
    VariableType["String"] = "String";
    VariableType["Sensitive"] = "Sensitive";
    VariableType["Certificate"] = "Certificate";
    VariableType["AmazonWebServicesAccount"] = "AmazonWebServicesAccount";
})(VariableType = exports.VariableType || (exports.VariableType = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\variableResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\variableResource.ts"); } } })();

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TaskState;
(function (TaskState) {
    TaskState["Queued"] = "Queued";
    TaskState["Executing"] = "Executing";
    TaskState["Failed"] = "Failed";
    TaskState["Canceled"] = "Canceled";
    TaskState["TimedOut"] = "TimedOut";
    TaskState["Success"] = "Success";
    TaskState["Cancelling"] = "Cancelling";
})(TaskState = exports.TaskState || (exports.TaskState = {}));
exports.default = TaskState;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\taskState.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\taskState.ts"); } } })();

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Roboto-Regular.3e1af3ef546b9e6ecef9f3ba197bf7d2.hashedasset.ttf";

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Roboto-italic.42bbe4eefcde1297b11dc4b6491e9746.hashedasset.ttf";

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Roboto-light.fc84e998bc29b297ea20321e4c90b6ed.hashedasset.ttf";

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Roboto-medium.d08840599e05db7345652d3d417574a9.hashedasset.ttf";

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Roboto-bold.ee7b96fa85d8fdb8c126409326ac2d2b.hashedasset.ttf";

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fontoctopus.8acc0c7e45d7d6f690a7342d70180835.hashedasset.woff";

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fontoctopus.5eed1ba76b15097fa82835184a007327.hashedasset.ttf";

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fontoctopus.84200d09800b6f6d6b36c793c47c0be5.hashedasset.svg";

/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FeatureToggle_1 = __webpack_require__(224);
exports.FeatureToggle = FeatureToggle_1.default;
exports.Feature = FeatureToggle_1.Feature;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FeatureToggle\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FeatureToggle\\index.tsx"); } } })();

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var namedResource_1 = __webpack_require__(187);
var AccountType;
(function (AccountType) {
    AccountType["None"] = "None";
    AccountType["UsernamePassword"] = "UsernamePassword";
    AccountType["SshKeyPair"] = "SshKeyPair";
    AccountType["AzureSubscription"] = "AzureSubscription";
    AccountType["AzureServicePrincipal"] = "AzureServicePrincipal";
    AccountType["AmazonWebServicesAccount"] = "AmazonWebServicesAccount";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var AccountResource = (function (_super) {
    __extends(AccountResource, _super);
    function AccountResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AccountResource;
}(namedResource_1.default));
exports.AccountResource = AccountResource;
var AzureServicePrincipalAccountResource = (function (_super) {
    __extends(AzureServicePrincipalAccountResource, _super);
    function AzureServicePrincipalAccountResource() {
        var _this = _super.call(this) || this;
        _this.AccountType = AccountType.AzureServicePrincipal;
        return _this;
    }
    return AzureServicePrincipalAccountResource;
}(AccountResource));
exports.AzureServicePrincipalAccountResource = AzureServicePrincipalAccountResource;
var AzureSubscriptionAccountResource = (function (_super) {
    __extends(AzureSubscriptionAccountResource, _super);
    function AzureSubscriptionAccountResource() {
        var _this = _super.call(this) || this;
        _this.AccountType = AccountType.AzureSubscription;
        return _this;
    }
    return AzureSubscriptionAccountResource;
}(AccountResource));
exports.AzureSubscriptionAccountResource = AzureSubscriptionAccountResource;
var SshKeyPairAccountResource = (function (_super) {
    __extends(SshKeyPairAccountResource, _super);
    function SshKeyPairAccountResource() {
        var _this = _super.call(this) || this;
        _this.AccountType = AccountType.SshKeyPair;
        return _this;
    }
    return SshKeyPairAccountResource;
}(AccountResource));
exports.SshKeyPairAccountResource = SshKeyPairAccountResource;
var UsernamePasswordAccountResource = (function (_super) {
    __extends(UsernamePasswordAccountResource, _super);
    function UsernamePasswordAccountResource() {
        var _this = _super.call(this) || this;
        _this.AccountType = AccountType.UsernamePassword;
        return _this;
    }
    return UsernamePasswordAccountResource;
}(AccountResource));
exports.UsernamePasswordAccountResource = UsernamePasswordAccountResource;
var AmazonWebServicesAccountResource = (function (_super) {
    __extends(AmazonWebServicesAccountResource, _super);
    function AmazonWebServicesAccountResource() {
        var _this = _super.call(this) || this;
        _this.AccountType = AccountType.AmazonWebServicesAccount;
        return _this;
    }
    return AmazonWebServicesAccountResource;
}(AccountResource));
exports.AmazonWebServicesAccountResource = AmazonWebServicesAccountResource;
exports.default = AccountResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\accountResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\accountResource.ts"); } } })();

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FormPaperLayout_1 = __webpack_require__(168);
exports.default = FormPaperLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FormPaperLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FormPaperLayout\\index.tsx"); } } })();

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DataTable_1 = __webpack_require__(725);
exports.DataTable = DataTable_1.DataTable;
var DataTableHeader_1 = __webpack_require__(731);
exports.DataTableHeader = DataTableHeader_1.DataTableHeader;
var DataTableHeaderColumn_1 = __webpack_require__(732);
exports.DataTableHeaderColumn = DataTableHeaderColumn_1.DataTableHeaderColumn;
var DataTableRowHeaderColumn_1 = __webpack_require__(746);
exports.DataTableRowHeaderColumn = DataTableRowHeaderColumn_1.DataTableRowHeaderColumn;
var DataTableBody_1 = __webpack_require__(720);
exports.DataTableBody = DataTableBody_1.DataTableBody;
var DataTableToolsRow_1 = __webpack_require__(1681);
exports.DataTableToolsRow = DataTableToolsRow_1.DataTableToolsRow;
var DataTableRow_1 = __webpack_require__(721);
exports.DataTableRow = DataTableRow_1.DataTableRow;
var DataTableRowColumn_1 = __webpack_require__(722);
exports.DataTableRowColumn = DataTableRowColumn_1.DataTableRowColumn;
var DataTableFooter_1 = __webpack_require__(1682);
exports.DataTableFooter = DataTableFooter_1.DataTableFooter;
var DataTableFooterColumn_1 = __webpack_require__(1683);
exports.DataTableFooterColumn = DataTableFooterColumn_1.DataTableFooterColumn;
var DataTableFooterRow_1 = __webpack_require__(1684);
exports.DataTableFooterRow = DataTableFooterRow_1.DataTableFooterRow;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\index.tsx"); } } })();

/***/ }),
/* 421 */,
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ParseHelper_1 = __webpack_require__(75);
exports.default = ParseHelper_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ParseHelper\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ParseHelper\\index.tsx"); } } })();

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Chips_1 = __webpack_require__(23);
var MultiSelect_1 = __webpack_require__(71);
var RoleTypedMultiSelect = MultiSelect_1.MultiSelect();
var RoleMultiSelect = function (props) {
    var onAdd = function (value) {
        props.onChange(props.value.concat(value));
    };
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(Chips_1.RoleChip, { onRequestDelete: onRequestDelete, role: r.Name });
    };
    return React.createElement(RoleTypedMultiSelect, { items: props.items.map(function (i) { return ({ Id: i, Name: i }); }), fieldName: "target roles", label: props.label, renderChip: chipRenderer, onNew: props.canAdd ? onAdd : null, value: props.value, onChange: props.onChange, error: props.error, openOnFocus: props.openOnFocus, autoFocus: props.autoFocus, addNewTemplate: function (text) { return "\"" + text + "\" (add new role)"; } });
};
exports.default = RoleMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\RoleMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\RoleMultiSelect.tsx"); } } })();

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var moment = __webpack_require__(104);
var DateFormatter_1 = __webpack_require__(400);
var styles = __webpack_require__(1676);
var TimeFromNowLabel = function (props) {
    return React.createElement("span", { className: styles.when }, props.useShortDateFormat
        ? React.createElement("abbr", { title: DateFormatter_1.default.momentAgo(props.time) }, DateFormatter_1.default.dateToShortFormat(props.time))
        : React.createElement("abbr", { title: DateFormatter_1.default.dateToLongFormat(props.time) }, moment(props.time).fromNow()));
};
exports.default = TimeFromNowLabel;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TimeLabels\\TimeFromNowLabel.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TimeLabels\\TimeFromNowLabel.tsx"); } } })();

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VariableSetContentType;
(function (VariableSetContentType) {
    VariableSetContentType["Variables"] = "Variables";
    VariableSetContentType["ScriptModule"] = "ScriptModule";
})(VariableSetContentType = exports.VariableSetContentType || (exports.VariableSetContentType = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\libraryVariableSetResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\libraryVariableSetResource.ts"); } } })();

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(67);
var expanders_1 = __webpack_require__(286);
var store_1 = __webpack_require__(147);
var styles = __webpack_require__(116);
var lodash_1 = __webpack_require__(16);
exports.toggleExpandos = function (expanded, containerKey) {
    store_1.default.dispatch(expanders_1.onToggleAll(containerKey, expanded));
};
var ExpansionButtonsInternal = (function (_super) {
    __extends(ExpansionButtonsInternal, _super);
    function ExpansionButtonsInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleExpand = function (isExpanded) {
            _this.props.onToggleAll(_this.props.containerKey, isExpanded);
        };
        _this.toggleExpandInt = function (e, isExpanded) {
            e.preventDefault();
            _this.toggleExpand(isExpanded);
        };
        return _this;
    }
    ExpansionButtonsInternal.prototype.componentDidMount = function () {
        this.props.onMount(this.props.containerKey, this.props.expandAllOnMount);
    };
    ExpansionButtonsInternal.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { className: styles.linkContainer },
            this.expandedValues().some(function (e) { return e === false; }) && React.createElement("a", { href: "#", className: styles.expandLink, onClick: function (e) { return _this.toggleExpandInt(e, true); } }, "EXPAND ALL"),
            this.expandedValues().some(function (e) { return e === true; }) && React.createElement("a", { href: "#", className: styles.expandLink, onClick: function (e) { return _this.toggleExpandInt(e, false); } }, "COLLAPSE ALL"));
    };
    ExpansionButtonsInternal.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.containerKey !== this.props.containerKey) {
            this.props.onDestroy(this.props.containerKey);
        }
        if (nextProps.containerKey !== this.props.containerKey || nextProps.expandAllOnMount !== this.props.expandAllOnMount) {
            this.props.onMount(this.props.containerKey, nextProps.expandAllOnMount);
        }
        this.openExpandersWithErrors(nextProps);
    };
    ExpansionButtonsInternal.prototype.componentWillUnmount = function () {
        this.props.onDestroy(this.props.containerKey);
    };
    ExpansionButtonsInternal.prototype.openExpandersWithErrors = function (nextProps) {
        // ref comparison seems to be okay here.
        if (nextProps.errors && !lodash_1.isEqual(nextProps.errors, this.props.errors)) {
            this.props.onExpandErrors(this.props.containerKey, Object.keys(nextProps.errors.fieldErrors));
        }
    };
    ExpansionButtonsInternal.prototype.expandedValues = function () {
        return this.props.expanded;
    };
    return ExpansionButtonsInternal;
}(React.Component));
ExpansionButtonsInternal.defaultProps = {
    expandAllOnMount: false
};
var mapStateToProps = function (state, ownProps) {
    var containerKey = ownProps.containerKey || expanders_1.defaultContainerKey;
    var container = state.expanders && state.expanders.hasOwnProperty(containerKey) ? state.expanders[containerKey] : null;
    var initialState = container && container.initialState;
    var storedValues = container ? container.expanderValues : {};
    var expanded = Object.keys(storedValues).map(getValueForKey);
    return { expanded: expanded };
    function getValueForKey(errorKey) {
        var value = storedValues[errorKey];
        return value === undefined || value === null ? initialState : value;
    }
};
var mapDispatchToProps = function (dispatch) {
    return {
        onToggleAll: function (containerKey, expanded) {
            exports.toggleExpandos(expanded, containerKey);
        },
        onExpandErrors: function (containerKey, errorKeys) {
            dispatch(expanders_1.onExpandErrors(containerKey, errorKeys));
        },
        onDestroy: function (containerKey) {
            dispatch(expanders_1.onExpanderContainerDestroyed(containerKey));
        },
        onMount: function (containerKey, initialState) {
            dispatch(expanders_1.onExpanderSetInitialState(containerKey, initialState));
        }
    };
};
var ExpansionButtons = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExpansionButtonsInternal);
exports.default = ExpansionButtons;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\ExpansionButtons.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\ExpansionButtons.tsx"); } } })();

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PermissionCheck_1 = __webpack_require__(45);
exports.PermissionCheck = PermissionCheck_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PermissionCheck\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PermissionCheck\\index.tsx"); } } })();

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
exports.renderWithLayout = function (layoutComponent, componentProps) {
    if (componentProps === void 0) { componentProps = {}; }
    return function (Component) {
        var RenderWithLayout = function (props) {
            var Layout = layoutComponent;
            return (React.createElement(Layout, __assign({}, props),
                React.createElement(Component, __assign({}, componentProps, props))));
        };
        return RenderWithLayout;
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\RenderWithLayout\\RenderWithLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\RenderWithLayout\\RenderWithLayout.tsx"); } } })();

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Clipboard = __webpack_require__(1663);
var ToolTip_1 = __webpack_require__(68);
var IconButton_1 = __webpack_require__(63);
var content_copy_1 = __webpack_require__(1671);
var CopyToClipboard = (function (_super) {
    __extends(CopyToClipboard, _super);
    function CopyToClipboard(props) {
        var _this = _super.call(this, props) || this;
        _this.setRef = function (el) {
            _this.element = el;
        };
        _this.state = { showConfirmation: false };
        return _this;
    }
    CopyToClipboard.prototype.componentDidMount = function () {
        var _this = this;
        this.clipboard = new Clipboard(this.element, {
            text: function () { return _this.props.value; }
        });
        this.clipboard.on("success", function () { return _this.onCopy(); });
    };
    CopyToClipboard.prototype.componentWillUnmount = function () {
        this.clipboard.destroy();
        if (this.hideTimeoutId) {
            window.clearTimeout(this.hideTimeoutId);
        }
    };
    CopyToClipboard.prototype.render = function () {
        var button = React.createElement("span", null,
            React.createElement(IconButton_1.default, null,
                React.createElement(content_copy_1.default, null)));
        return React.createElement("span", { ref: this.setRef },
            this.state.showConfirmation && React.createElement(ToolTip_1.default, { content: "Copied!", trigger: "manual", open: true }, button),
            !this.state.showConfirmation && React.createElement(ToolTip_1.default, { content: "Copy to clipboard" }, button));
    };
    CopyToClipboard.prototype.onCopy = function () {
        var _this = this;
        this.setState({ showConfirmation: true });
        if (this.hideTimeoutId) {
            window.clearTimeout(this.hideTimeoutId);
        }
        this.hideTimeoutId = window.setTimeout(function () { return _this.onHide(); }, 3500);
    };
    CopyToClipboard.prototype.onHide = function () {
        this.setState({ showConfirmation: false });
        this.hideTimeoutId = null;
    };
    return CopyToClipboard;
}(React.Component));
exports.default = CopyToClipboard;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\CopyToClipboardButton\\CopyToClipboardButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\CopyToClipboardButton\\CopyToClipboardButton.tsx"); } } })();

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var material_ui_1 = __webpack_require__(92);
var Section_1 = __webpack_require__(90);
var FilterSearchBox_1 = __webpack_require__(171);
var ListInternalLink_1 = __webpack_require__(461);
var styles = __webpack_require__(386);
var PagingBaseComponent_1 = __webpack_require__(179);
var Divider_1 = __webpack_require__(143);
var NumberedPagingBar_1 = __webpack_require__(672);
var InternalRedirect_1 = __webpack_require__(40);
var SimpleList = (function (_super) {
    __extends(SimpleList, _super);
    function SimpleList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { currentPageIndex: 0 };
        return _this;
    }
    SimpleList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.pageSize) {
            var newLastPageIndex = nextProps.items.length === 0 ? 1 : Math.ceil(nextProps.items.length / nextProps.pageSize);
            if (newLastPageIndex < this.state.currentPageIndex) {
                this.setState({ currentPageIndex: newLastPageIndex });
            }
        }
    };
    SimpleList.prototype.onFilter = function (item) {
        var filter = this.state.filter;
        if (!filter || filter === "" || !this.props.onFilter) {
            return true;
        }
        return this.props.onFilter(this.state.filter, item);
    };
    SimpleList.prototype.renderEmpty = function () {
        return this.props.empty ? this.props.empty : React.createElement("div", null, "No results");
    };
    SimpleList.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: true });
        }
        if (!this.props.items) {
            return null;
        }
        var filteredList = this.props.items
            .filter(function (item) { return _this.onFilter(item); });
        if (this.props.pageSize) {
            var firstItemIndex = this.props.pageSize * this.state.currentPageIndex;
            filteredList = filteredList.slice(firstItemIndex, firstItemIndex + this.props.pageSize);
        }
        return React.createElement(material_ui_1.List, null,
            this.props.onFilter && this.renderFilterSearchComponents(),
            (filteredList.length === 0) && React.createElement("div", { className: styles.emptyList }, this.renderEmpty()),
            filteredList.map(function (item, index) { return _this.buildItem(item, index); }),
            this.props.pageSize &&
                React.createElement(NumberedPagingBar_1.default, { currentPageIndex: this.state.currentPageIndex, totalItems: this.props.items.length, pageSize: this.props.pageSize, onPageSelected: function (skip, currentPageIndex) { return _this.setState({ currentPageIndex: currentPageIndex }); } }));
    };
    SimpleList.prototype.buildItem = function (item, index) {
        var _this = this;
        var redirectUrl = PagingBaseComponent_1.getNavigationUrl(this.props, item);
        var nodeRow = this.props.onRow(item);
        if (redirectUrl) {
            // Make these actual href links, so people can still right-click > open new window (this is expected usability for things you can click).
            nodeRow = React.createElement(ListInternalLink_1.default, { to: redirectUrl }, nodeRow);
        }
        var nodes = [
            React.createElement(material_ui_1.ListItem, { key: 0, className: styles.listItem, onClick: function (e) { return _this.navigate(item); }, disabled: this.props.disableListItem }, nodeRow)
        ];
        if (index < (this.props.items.length - 1)) {
            nodes.push(React.createElement(Divider_1.default, null));
        }
        return (React.Children.toArray(nodes));
    };
    SimpleList.prototype.navigate = function (item) {
        var redirectTo = PagingBaseComponent_1.getNavigationUrl(this.props, item);
        if (!redirectTo) {
            return;
        }
        this.setState({ redirectTo: redirectTo });
    };
    SimpleList.prototype.renderFilterSearchComponents = function () {
        var _this = this;
        return (React.createElement(Section_1.Section, null,
            React.createElement(FilterSearchBox_1.default, { hintText: "Filter...", onChange: function (filter) { return _this.setState({ filter: filter }); }, autoFocus: this.props.autoFocusOnFilterSearch })));
    };
    return SimpleList;
}(React.Component));
exports.SimpleList = SimpleList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\List\\SimpleList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\List\\SimpleList.tsx"); } } })();

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(120);
var react_router_dom_1 = __webpack_require__(61);
var InternalRedirect_1 = __webpack_require__(40);
var routeLinks_1 = __webpack_require__(20);
var notFoundImage = __webpack_require__(1703);
var styles = __webpack_require__(1704);
var RedirectAs404 = function () { return React.createElement(react_router_dom_1.Route, { render: function (_a) {
        var location = _a.location;
        return React.createElement(InternalRedirect_1.default, { to: __assign({}, location, { state: { is404: true } }) });
    } }); };
exports.RedirectAs404 = RedirectAs404;
var NotFound = function () {
    return React.createElement("main", { id: "maincontent" },
        React.createElement(index_1.default, { link: routeLinks_1.default.root, title: "Page not found" }),
        React.createElement("div", { className: styles.container },
            React.createElement("img", { src: notFoundImage, alt: "Page couldn't be found" }),
            React.createElement("h4", null, "Page not found."),
            React.createElement("p", null, "Sorry, the page you are looking for could not be found.")));
};
exports.NotFound = NotFound;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\NotFound\\NotFound.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\NotFound\\NotFound.tsx"); } } })();

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataTable_1 = __webpack_require__(420);
var BaseComponent_1 = __webpack_require__(60);
var styles = __webpack_require__(1808);
var cn = __webpack_require__(19);
var PagingBaseComponent_1 = __webpack_require__(179);
var InternalRedirect_1 = __webpack_require__(40);
var SimpleDataTable = (function (_super) {
    __extends(SimpleDataTable, _super);
    function SimpleDataTable(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    SimpleDataTable.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: true });
        }
        var _a = this.props, onToolsSection = _a.onToolsSection, data = _a.data, headerColumns = _a.headerColumns, headerColumnClassName = _a.headerColumnClassName, rowColumnClassName = _a.rowColumnClassName, onRow = _a.onRow, onEmpty = _a.onEmpty;
        if (!data) {
            return null;
        }
        return (React.createElement(DataTable_1.DataTable, null,
            React.createElement(DataTable_1.DataTableHeader, null,
                onToolsSection ?
                    React.createElement(DataTable_1.DataTableToolsRow, null,
                        React.createElement(DataTable_1.DataTableHeaderColumn, { colSpan: headerColumns.length }, onToolsSection()))
                    : null,
                data.length > 0
                    ? this.buildTableHeader(headerColumns, headerColumnClassName)
                    : null),
            React.createElement(DataTable_1.DataTableBody, null, data.length > 0
                ? data.map(function (item, index) {
                    return _this.buildTableRow(item, index, onRow(item), rowColumnClassName);
                })
                : React.createElement(DataTable_1.DataTableRow, { displayNoBorder: true },
                    React.createElement(DataTable_1.DataTableRowColumn, null, onEmpty)))));
    };
    SimpleDataTable.prototype.buildTableHeader = function (headerColumns, className) {
        return (React.createElement(DataTable_1.DataTableRow, null, headerColumns.map(function (col, index) {
            var props = {
                key: index
            };
            if (className) {
                props["className"] = className;
            }
            return (React.createElement(DataTable_1.DataTableHeaderColumn, __assign({}, props), col));
        })));
    };
    SimpleDataTable.prototype.buildTableRow = function (item, index, rowColumns, className) {
        var _this = this;
        // Only some tables include a redirect, so only show cursor if necessary.
        var redirectUrl = PagingBaseComponent_1.getNavigationUrl(this.props, item);
        var linkClassName = redirectUrl ? styles.linkableItem : null;
        return (React.createElement(DataTable_1.DataTableRow, { key: index, onClick: function (e) { return _this.navigate(item); } }, rowColumns.map(function (col, idx) {
            var props = {
                key: idx
            };
            if (className) {
                props["className"] = cn(className, props["className"]);
            }
            if (linkClassName) {
                props["className"] = cn(linkClassName, props["className"]);
            }
            return (React.createElement(DataTable_1.DataTableRowColumn, __assign({}, props), col));
        })));
    };
    SimpleDataTable.prototype.navigate = function (item) {
        var redirectTo = PagingBaseComponent_1.getNavigationUrl(this.props, item);
        if (!redirectTo) {
            return;
        }
        this.setState({ redirectTo: redirectTo });
    };
    return SimpleDataTable;
}(BaseComponent_1.default));
exports.default = SimpleDataTable;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SimpleDataTable\\SimpleDataTable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SimpleDataTable\\SimpleDataTable.tsx"); } } })();

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(96);
var ActionKeys;
(function (ActionKeys) {
    ActionKeys["CONFIGURATION_FEATURES_FETCHED"] = "CONFIGURATION_FEATURES_FETCHED";
    ActionKeys["OTHER_ACTION"] = "__any_other_action_type__";
})(ActionKeys || (ActionKeys = {}));
exports.configurationActions = {
    featuresFetched: function (features) { return ({
        type: ActionKeys.CONFIGURATION_FEATURES_FETCHED,
        features: features
    }); }
};
var featuresReducer = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case ActionKeys.CONFIGURATION_FEATURES_FETCHED:
            if (!action.features) {
                return null;
            }
            return {
                isBuiltInRepoSyncEnabled: action.features.IsBuiltInRepoSyncEnabled,
                isCommunityActionTemplatesEnabled: action.features.IsCommunityActionTemplatesEnabled,
                isMultiTenancyEnabled: action.features.IsMultiTenancyEnabled
            };
        default:
            return state;
    }
};
exports.configurationArea = redux_1.combineReducers({
    features: featuresReducer
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\configuration\\reducers\\configurationArea.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\configuration\\reducers\\configurationArea.ts"); } } })();

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(108);
var Chips_1 = __webpack_require__(23);
var LookupReferenceDataItemChip_1 = __webpack_require__(103);
var Chips_2 = __webpack_require__(23);
var StepTypedMultiSelect = MultiSelect_1.default();
var StepMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Environment, chipRender: function (item) { return React.createElement(Chips_1.StepChip, { onRequestDelete: onRequestDelete, stepName: item.Name, suffix: item.suffix }); } });
    };
    return React.createElement(StepTypedMultiSelect, __assign({ items: props.items, fieldName: "steps", renderChip: chipRenderer }, props));
};
exports.default = StepMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\StepMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\StepMultiSelect.tsx"); } } })();

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1832);
var PageDivider = function (props) {
    return React.createElement("p", { className: styles.pageDivider }, props.children);
};
exports.default = PageDivider;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PageDivider\\PageDivider.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PageDivider\\PageDivider.tsx"); } } })();

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Dialog_1 = __webpack_require__(121);
var dialogIdGenerator_1 = __webpack_require__(265);
var OpenDialogConnect_1 = __webpack_require__(266);
var DialogOpenerInternal = (function (_super) {
    __extends(DialogOpenerInternal, _super);
    function DialogOpenerInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.uniqueId = dialogIdGenerator_1.default.next();
        return _this;
    }
    DialogOpenerInternal.prototype.componentDidMount = function () {
        if (!this.props.openDialogs[this.uniqueId] && this.props.open) {
            this.props.openDialog(this.uniqueId);
        }
    };
    DialogOpenerInternal.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.props.openDialogs[this.uniqueId] && !nextProps.openDialogs[this.uniqueId] && !this.props.open && nextProps.open) {
            this.props.openDialog(this.uniqueId);
        }
        if (this.props.openDialogs[this.uniqueId] && !nextProps.openDialogs[this.uniqueId] && this.props.onClose) {
            this.props.onClose();
        }
    };
    DialogOpenerInternal.prototype.render = function () {
        return React.createElement(Dialog_1.default, { open: this.props.openDialogs[this.uniqueId], wide: this.props.wideDialog }, this.props.children);
    };
    return DialogOpenerInternal;
}(React.Component));
exports.DialogOpenerInternal = DialogOpenerInternal;
var DialogOpener = OpenDialogConnect_1.OpenDialogConnect.to(DialogOpenerInternal, true);
exports.default = DialogOpener;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\DialogOpener.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\DialogOpener.tsx"); } } })();

/***/ }),
/* 437 */,
/* 438 */,
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1424);
var avatarPlaceHolder = __webpack_require__(1426);
var octopusServiceImage = __webpack_require__(1427);
var userDefaultImage = __webpack_require__(1428);
exports.Avatar = function (props) {
    var size = props.size || 25;
    var imageSource = avatarPlaceHolder;
    if (!props.user) {
        imageSource = octopusServiceImage;
    }
    else if (props.user.IsService) {
        imageSource = octopusServiceImage;
    }
    else if (props.user.Links && props.user.Links.Avatar) {
        imageSource = props.user.Links.Avatar + "&s=" + size;
    }
    return (
    // Note: Do NOT use Material-UI's Avatar component to render avatars, as we need a fallback background image and
    // if you try to do this with the <img> tag, it'll then show broken external images on closed networks (I.e. networks
    // that can't access gravatar).
    React.createElement("div", { className: styles.avatarContainer, style: {
            backgroundImage: "url(\"" + userDefaultImage + "\")",
            width: size + "px",
            height: size + "px"
        } },
        React.createElement("div", { className: styles.avatarContainer, style: {
                backgroundImage: "url(\"" + imageSource + "\")",
                width: "100%",
                height: "100%"
            } })));
};
exports.default = exports.Avatar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Avatar\\Avatar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Avatar\\Avatar.tsx"); } } })();

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var StickyNode = __webpack_require__(1477);
// This is a monkey patch to fix this issue: https://github.com/yahoo/react-stickynode/issues/46
// We should go back and submit a PR to that repo when we have more time
// This is required for the variable editor headers
StickyNode.prototype.getTargetHeight = function (target) {
    return target && (target.offsetHeight + target.getBoundingClientRect().top) || 0;
};
// When you have multiple sticky components around the place that depend on each others positions,
// It looks like they need to be repositioned in a certain order so that they are all positioned correctly with respect to each other
// In fact, I think you even need to position a child sticky in a timeout after the parent/anchor sticky is positioned.
// This is a hack to help get around that issue... It doesn't seem to be entirely reliable but improves things considerably
// It repeatedly positions/renders the stickies until the position becomes stable. It will do this at least twice
var originalUpdateInitialDimension = StickyNode.prototype.updateInitialDimension;
function updateInitialDimension(options) {
    var _this = this;
    originalUpdateInitialDimension.call(this, options);
    var position = null;
    window.setTimeout(function () { return positionCheckingUpdateInitialDimension.call(_this); }, 0);
    function positionCheckingUpdateInitialDimension() {
        var _this = this;
        var oldPosition = position;
        var stickyElement = this.refs.inner;
        var outerElement = this.refs.outer;
        if (stickyElement || outerElement) {
            position = stickyElement.getBoundingClientRect();
            if (oldPosition === null
                || oldPosition.bottom !== position.bottom
                || oldPosition.top !== position.top
                || oldPosition.left !== position.left
                || oldPosition.right !== position.right
                || oldPosition.height !== position.height
                || oldPosition.width !== position.width) {
                originalUpdateInitialDimension.call(this, options);
                this.update();
                window.setTimeout(function () { return positionCheckingUpdateInitialDimension.call(_this); }, 0);
            }
        }
        else {
            window.setTimeout(function () { return positionCheckingUpdateInitialDimension.call(_this); }, 0);
        }
    }
}
StickyNode.prototype.updateInitialDimension = updateInitialDimension;
var StickyStatus;
(function (StickyStatus) {
    StickyStatus[StickyStatus["STATUS_ORIGINAL"] = 0] = "STATUS_ORIGINAL";
    StickyStatus[StickyStatus["STATUS_RELEASED"] = 1] = "STATUS_RELEASED";
    StickyStatus[StickyStatus["STATUS_FIXED"] = 2] = "STATUS_FIXED";
})(StickyStatus = exports.StickyStatus || (exports.StickyStatus = {}));
var Sticky = function (props) {
    return React.createElement(StickyNode, __assign({}, props));
};
exports.default = Sticky;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Sticky\\Sticky.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Sticky\\Sticky.tsx"); } } })();

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var LifecycleMapInternal_1 = __webpack_require__(1720);
var MapProgressionToStatus_1 = __webpack_require__(795);
var MarkdownDescription_1 = __webpack_require__(214);
var LifecycleMap = function (props) {
    var phases = props.lifecyclePreview.Phases
        ? props.lifecyclePreview.Phases
        : [];
    var lifecycleStatus = MapProgressionToStatus_1.mapProgressionToStatus();
    return React.createElement("div", null,
        props.showDescription && React.createElement(MarkdownDescription_1.default, { markup: props.lifecyclePreview.Description }),
        React.createElement(LifecycleMapInternal_1.default, { phases: phases, environmentsById: props.environmentsById, lifecycleStatus: lifecycleStatus, className: props.className }));
};
exports.default = LifecycleMap;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\library\\components\\Lifecycle\\LifecycleMap\\LifecycleMap.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\library\\components\\Lifecycle\\LifecycleMap\\LifecycleMap.tsx"); } } })();

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var UpgradeNotificationMode;
(function (UpgradeNotificationMode) {
    UpgradeNotificationMode["AlwaysShow"] = "AlwaysShow";
    UpgradeNotificationMode["ShowOnlyMajorMinor"] = "ShowOnlyMajorMinor";
    UpgradeNotificationMode["NeverShow"] = "NeverShow";
})(UpgradeNotificationMode = exports.UpgradeNotificationMode || (exports.UpgradeNotificationMode = {}));
var UpgradeConfigurationResource = (function (_super) {
    __extends(UpgradeConfigurationResource, _super);
    function UpgradeConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UpgradeConfigurationResource;
}(resource_1.default));
exports.UpgradeConfigurationResource = UpgradeConfigurationResource;
exports.default = UpgradeConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\upgradeConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\upgradeConfigurationResource.ts"); } } })();

/***/ }),
/* 443 */,
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(139);
var styles = __webpack_require__(116);
var FormSectionBase_1 = __webpack_require__(264);
var UnstructuredFormSection = (function (_super) {
    __extends(UnstructuredFormSection, _super);
    function UnstructuredFormSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnstructuredFormSection.prototype.render = function () {
        return React.createElement(Card_1.Card, { className: styles.formNonExpander, expanded: true }, this.body(styles.cardMediaNonExpander, false));
    };
    return UnstructuredFormSection;
}(FormSectionBase_1.FormSectionBase));
exports.default = UnstructuredFormSection;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\UnstructuredFormSection.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\UnstructuredFormSection.tsx"); } } })();

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var IconButtonList_1 = __webpack_require__(109);
var InputWithActions_1 = __webpack_require__(383);
var React = __webpack_require__(0);
var form_1 = __webpack_require__(15);
var styles = __webpack_require__(1610);
var Text_1 = __webpack_require__(17);
var IconButton_1 = __webpack_require__(56);
var chooseImage = __webpack_require__(1612);
var LogoEditor = (function (_super) {
    __extends(LogoEditor, _super);
    function LogoEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFileChange = function (e) {
            if (e.target.files.length < 1) {
                _this.onValidate("No file selected");
                return;
            }
            var file = e.target.files[0];
            var ValidImageTypes = ["image/gif", "image/jpeg", "image/png"];
            if (ValidImageTypes.indexOf(file.type) < 0) {
                _this.onValidate("Selected file was not an image");
                return;
            }
            _this.onValidate("");
            var value = {
                file: file,
                reset: false
            };
            _this.props.onChange(value);
        };
        _this.useDefault = function () {
            var value = {
                file: null,
                reset: true
            };
            _this.props.onChange(value);
        };
        _this.clear = function () {
            var value = {
                file: null,
                reset: false
            };
            _this.props.onChange(value);
        };
        _this.chooseFile = function () {
            _this.input.click();
        };
        _this.noop = function () {
            //empty on purpose
        };
        return _this;
    }
    LogoEditor.prototype.onValidate = function (message) {
        if (this.props.onValidate) {
            this.props.onValidate(message);
        }
    };
    LogoEditor.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, error = _a.error, hintText = _a.hintText;
        var v = (value == null || (value.file == null && !value.reset))
            ? "Current logo"
            : (value.file ? value.file.name : "Default logo");
        var removeFromScreen = {
            cursor: "pointer",
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            width: "100%",
            opacity: 0,
        };
        //TODO Use choose-image.svg rather than Image
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.logoContainer },
                React.createElement(InputWithActions_1.default, { input: React.createElement(Text_1.default, { type: "text", onChange: this.noop, hintText: hintText, value: v, error: error, onClick: this.chooseFile }), actions: React.createElement(IconButtonList_1.default, { buttons: [
                            React.createElement(IconButton_1.default, { onClick: this.chooseFile, icon: chooseImage, toolTipContent: "Choose image" }),
                            React.createElement(IconButton_1.default, { onClick: this.useDefault, icon: IconButton_1.Icon.UseDefaultImage, toolTipContent: "Use default image" })
                        ] }) }),
                React.createElement("input", { type: "file", style: removeFromScreen, onChange: this.handleFileChange, ref: function (input) { _this.input = input; } })),
            React.createElement(form_1.Note, null, "A transparent PNG, no larger than 100x100 pixels, is recommended. JPG and gif are also suitable.")));
    };
    return LogoEditor;
}(React.Component));
exports.default = LogoEditor;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\LogoEditor\\LogoEditor.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\LogoEditor\\LogoEditor.tsx"); } } })();

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(108);
var Chips_1 = __webpack_require__(23);
var LookupReferenceDataItemChip_1 = __webpack_require__(103);
var Chips_2 = __webpack_require__(23);
var TenantTypedMultiSelect = MultiSelect_1.default();
var TenantMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Tenant, chipRender: function (item) { return React.createElement(Chips_1.TenantChip, { onRequestDelete: onRequestDelete, tenant: item }); } });
    };
    return React.createElement(TenantTypedMultiSelect, __assign({ items: props.items, fieldName: "tenants", renderChip: chipRenderer }, props));
};
exports.default = TenantMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\TenantMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\TenantMultiSelect.tsx"); } } })();

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Tag_1 = __webpack_require__(216);
var index_1 = __webpack_require__(68);
var TagsList = function (props) {
    var tags = props.canonicalNames.map(function (name) { return props.tagIndex[name]; });
    return React.createElement("span", null, tags.map(function (tag) { return props.small ?
        React.createElement(index_1.default, { content: tag.Name, key: tag.Name },
            React.createElement(Tag_1.default, { tagName: tag.Name, tagColor: tag.Color, description: tag.Description, small: true }))
        :
            React.createElement(Tag_1.default, { key: tag.Name, description: tag.Description, tagName: tag.Name, tagColor: tag.Color }); }));
};
exports.default = TagsList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TagsList\\TagsList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TagsList\\TagsList.tsx"); } } })();

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Text_1 = __webpack_require__(17);
var Popover_1 = __webpack_require__(220);
var DataBaseComponent_1 = __webpack_require__(39);
var BusyIndicator_1 = __webpack_require__(98);
var BusyFromPromise_1 = __webpack_require__(176);
var DebounceValue_1 = __webpack_require__(173);
var styles = __webpack_require__(1734);
var IconButton_1 = __webpack_require__(56);
var ErrorPanel_1 = __webpack_require__(83);
var LabelStrategy_1 = __webpack_require__(174);
var IconButtonList_1 = __webpack_require__(109);
var VirtualListWithKeyboard_1 = __webpack_require__(669);
var BoundField_1 = __webpack_require__(95);
var keycode = __webpack_require__(52);
var DebounceText = DebounceValue_1.default(Text_1.default);
var VirtualList = VirtualListWithKeyboard_1.default();
var AutoCompleteInternal = (function (_super) {
    __extends(AutoCompleteInternal, _super);
    function AutoCompleteInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.textField = null;
        _this.cancelTimerToTrackNavigateAway = function () {
            clearTimeout(_this.timeoutId);
            _this.timeoutId = undefined;
        };
        _this.startTimerToTrackNavigateAway = function () {
            if (_this.timeoutId === undefined) {
                _this.timeoutId = setTimeout(function () { return _this.onNavigateAwayFromAutoComplete(); }, 0);
            }
        };
        _this.onFocus = function () {
            _this.cancelTimerToTrackNavigateAway();
            _this.setState({ hintText: _this.props.hintText });
            if (!_this.state.open) {
                _this.setState({ open: true, options: null });
                _this.requestOptions(_this.state.displayedValue);
            }
        };
        _this.onGlobalKeyDown = function (event) {
            var code = keycode(event);
            if (code === "esc") {
                if (_this.state.open) {
                    _this.setState({ open: false, options: null, displayedValue: _this.props.value });
                }
            }
        };
        _this.state = {
            open: false,
            displayedValue: props.value,
            options: null,
            hintText: null
        };
        return _this;
    }
    AutoCompleteInternal.prototype.componentDidMount = function () {
        window.document.addEventListener("keydown", this.onGlobalKeyDown);
    };
    AutoCompleteInternal.prototype.componentWillUnmount = function () {
        this.cancelTimerToTrackNavigateAway();
        window.document.removeEventListener("keydown", this.onGlobalKeyDown);
    };
    AutoCompleteInternal.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setState({ displayedValue: nextProps.value });
        }
    };
    AutoCompleteInternal.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { className: styles.autoCompleteContainer },
            React.createElement("div", { ref: function (textAnchor) { return _this.textAnchor = textAnchor; }, className: styles.textContainer, onKeyDown: function (ev) { return _this.onKeyDown(ev); } },
                React.createElement(DebounceText, { textInputRef: function (textField) { return _this.textField = textField; }, label: this.props.label, value: this.state.displayedValue, error: this.props.error, hintText: this.state.hintText, onChange: function (value) { return _this.onSearchTextChange(value); }, onFocus: this.onFocus, onClick: function (ev) {
                        ev.stopPropagation(); // This could bubble up and close the popup, even though the same mousedown event opened it (by focusing the input)
                        _this.onFocus();
                    }, onBlur: function (ev) { return _this.onBlurFromText(ev); } }),
                React.createElement("div", { className: styles.buttons },
                    React.createElement(IconButtonList_1.default, { buttons: this.buttons() }))),
            React.createElement(Popover_1.default, { open: this.state.open, anchorEl: this.textAnchor, onRequestClose: function () { return _this.setState({ open: false }); }, anchorOrigin: { horizontal: "left", vertical: "bottom" }, targetOrigin: { horizontal: "left", vertical: "top" }, useLayerForClickAway: false, className: styles.popover },
                React.createElement("div", { onFocus: this.cancelTimerToTrackNavigateAway, onBlur: this.startTimerToTrackNavigateAway, style: { minWidth: this.textAnchor ? this.textAnchor.offsetWidth + "px" : undefined }, ref: function (popoverContent) { return _this.popoverContent = popoverContent; } },
                    React.createElement("div", { className: styles.popoverContent },
                        React.createElement(BusyFromPromise_1.default, { promise: this.state.busy, children: function (busy) { return React.createElement(BusyIndicator_1.default, { show: busy }); } }),
                        this.renderErrors(),
                        !this.state.options && this.state.busy &&
                            React.createElement("div", { className: styles.popoverInfoText }, "Searching..."),
                        this.state.options && React.createElement(VirtualList, { maxHeightInRem: 17.5, multiSelectRef: function (el) { return _this.virtualList = el; }, items: this.state.options.items, renderItem: function (item) { return ({ primaryText: item.display || item.Name }); }, onSelected: function (id) { return _this.selectOption(id); }, onResized: function () {
                                // When the content's size changes, we re-render so that the
                                // popover can re-position itself based on the new `VirtualList` size
                                _this.forceUpdate();
                            }, onBlur: function () { return _this.textField.focus(); } })),
                    this.state.options && !this.state.options.containsAllResults &&
                        React.createElement("div", { className: styles.warning },
                            "Only showing ",
                            this.state.options.items.length,
                            " options, for more results narrow your search criteria"))));
    };
    AutoCompleteInternal.prototype.renderErrors = function () {
        var errors = this.state.errors;
        if (!errors) {
            return null;
        }
        return React.createElement(ErrorPanel_1.default, { message: errors.message, details: errors.details, detailLinks: errors.detailLinks, helpText: errors.helpText, fullException: errors.fullException, helpLink: errors.helpLink, scrollToPanel: false });
    };
    AutoCompleteInternal.prototype.focusText = function () {
        if (this.textField && !this.textField.isFocused()) {
            this.textField.focus();
        }
    };
    AutoCompleteInternal.prototype.onBlurFromText = function (ev) {
        this.setState({ hintText: null });
        this.startTimerToTrackNavigateAway();
    };
    AutoCompleteInternal.prototype.onNavigateAwayFromAutoComplete = function () {
        this.setState({ open: false, displayedValue: this.props.value });
    };
    AutoCompleteInternal.prototype.onKeyDown = function (ev) {
        var code = keycode(ev);
        if (code === "down") {
            if (this.virtualList && this.state.options && this.state.options.items.length) {
                ev.preventDefault();
                this.virtualList.focus();
            }
        }
    };
    AutoCompleteInternal.prototype.onSearchTextChange = function (searchText) {
        this.setState(function (prev) { return ({ displayedValue: searchText, open: true, options: prev.open ? prev.options : null }); });
        if (this.props.allowAnyTextValue) {
            this.props.onChange(searchText);
        }
        this.requestOptions(searchText);
    };
    AutoCompleteInternal.prototype.requestOptions = function (searchText) {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.getOptions(searchText)];
                    case 1:
                        options = _a.sent();
                        this.setState({ options: options });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AutoCompleteInternal.prototype.selectOption = function (id) {
        var option = this.state.options.items.find(function (i) { return i.Id === id; });
        this.setState({ displayedValue: option.Name, open: false });
        this.props.onChange(option.Id);
    };
    AutoCompleteInternal.prototype.clearValue = function () {
        this.setState({ open: false, displayedValue: "" });
        this.props.onChange("");
    };
    AutoCompleteInternal.prototype.buttons = function () {
        var _this = this;
        return [
            !!this.props.value && React.createElement(IconButton_1.default, { icon: IconButton_1.Icon.Cancel, onClick: function () { return _this.clearValue(); }, tabIndex: -1 }),
            React.createElement(IconButton_1.default, { icon: IconButton_1.Icon.ArrowDown, onClick: function () { return _this.focusText(); }, tabIndex: -1 })
        ].filter(function (b) { return !!b; });
    };
    return AutoCompleteInternal;
}(DataBaseComponent_1.DataBaseComponent));
var AutoComplete = LabelStrategy_1.default(AutoCompleteInternal, function (fieldName) { return fieldName; });
exports.default = AutoComplete;
exports.BoundAutoComplete = BoundField_1.withBoundField(function (props) {
    return React.createElement("div", { style: { display: "flex", alignItems: "baseline", width: "100%" } },
        React.createElement(AutoComplete, __assign({}, props)));
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\AutoComplete\\AutoComplete.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\AutoComplete\\AutoComplete.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ThumbprintText_1 = __webpack_require__(1854);
exports.default = ThumbprintText_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ThumbprintText\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ThumbprintText\\index.tsx"); } } })();

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var scriptingLanguage_1 = __webpack_require__(140);
var ScriptingLanguageSelector = function (props) {
    return React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { horizontal: true, value: props.value, autoFocus: props.autoFocus, onChange: props.onChange }, [React.createElement(RadioButton_1.default, { value: scriptingLanguage_1.ScriptingLanguage.PowerShell, label: "PowerShell", key: scriptingLanguage_1.ScriptingLanguage.PowerShell }),
        React.createElement(RadioButton_1.default, { value: scriptingLanguage_1.ScriptingLanguage.CSharp, label: "C#", key: scriptingLanguage_1.ScriptingLanguage.CSharp }),
        !props.onlyRunnableOnServer && React.createElement(RadioButton_1.default, { value: scriptingLanguage_1.ScriptingLanguage.Bash, label: "Bash", key: scriptingLanguage_1.ScriptingLanguage.Bash }),
        React.createElement(RadioButton_1.default, { value: scriptingLanguage_1.ScriptingLanguage.FSharp, label: "F#", key: scriptingLanguage_1.ScriptingLanguage.FSharp })].filter(function (option) { return !!option; }));
};
ScriptingLanguageSelector.displayName = "ScriptingLanguageSelector";
ScriptingLanguageSelector.defaultProps = {
    doNotAutoFocus: true
};
exports.default = ScriptingLanguageSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ScriptingLanguageSelector\\ScriptingLanguageSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ScriptingLanguageSelector\\ScriptingLanguageSelector.tsx"); } } })();

/***/ }),
/* 451 */,
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var DialogLayout_1 = __webpack_require__(141);
var ActionButton_1 = __webpack_require__(50);
var Dialog_1 = __webpack_require__(121);
var DeleteDialog = (function (_super) {
    __extends(DeleteDialog, _super);
    function DeleteDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    DeleteDialog.prototype.onDeleteClick = function () {
        var _this = this;
        return this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.onDeleteClick()];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.props.onClose();
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DeleteDialog.prototype.render = function () {
        var _this = this;
        var del = React.createElement(ActionButton_1.ActionButton, { key: "Continue", label: this.props.deleteButtonLabel || "Delete", type: ActionButton_1.ActionButtonType.Delete, busyLabel: this.props.deleteButtonBusyLabel || "Deleting...", disabled: this.state.busy, onClick: function () { return _this.onDeleteClick(); } });
        var cancel = React.createElement(ActionButton_1.ActionButton, { key: "Cancel", label: "Cancel", disabled: this.state.busy, onClick: function () { return _this.props.onClose(); } });
        return React.createElement(Dialog_1.default, { open: this.props.open || false },
            React.createElement(DialogLayout_1.DialogLayout, { actions: [cancel, del], title: this.props.title, busy: this.state.busy, closeDialog: this.props.onClose, errors: this.state.errors }, this.props.open && this.props.children));
    };
    return DeleteDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = DeleteDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\DeleteDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\DeleteDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Lookup_1 = __webpack_require__(457);
var Chips_1 = __webpack_require__(23);
function LookupResourceChipComponent() {
    return function (props) {
        return React.createElement(Lookup_1.default, { lookupCollection: props.lookupCollection, lookupId: props.lookupId, getIdFromElement: function (element) { return element.Id; }, render: function (item) { return props.chipRender(item); }, renderFallback: React.createElement(Chips_1.MissingChip, { lookupId: props.lookupId, type: props.type }) });
    };
}
exports.LookupResourceChipComponent = LookupResourceChipComponent;
exports.default = LookupResourceChipComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LookupResourceChip\\LookupResourceChip.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LookupResourceChip\\LookupResourceChip.tsx"); } } })();

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Lookup = function (props) {
    var item = props.lookupCollection.find(function (element) { return props.getIdFromElement(element) === props.lookupId; });
    return item ? props.render(item) : props.renderFallback;
};
exports.default = Lookup;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Lookup\\Lookup.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Lookup\\Lookup.tsx"); } } })();

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StringHelper = (function () {
    function StringHelper() {
    }
    StringHelper.capitalizeFirstLetter = function (value) {
        return value === null || typeof value === "undefined" || value.length === 0
            ? value
            : value.charAt(0).toUpperCase() + value.slice(1);
    };
    StringHelper.isNullOrWhiteSpace = function (value) {
        return value === null || typeof value === "undefined" || value.trim().length === 0;
    };
    StringHelper.join = function (values, separator) {
        return values.reduce(function (prev, cur) { return prev + separator + cur; });
    };
    StringHelper.formatDiff = function (diff) {
        if (!diff) {
            return diff;
        }
        var replaced = diff.replace(new RegExp("\r&para;", "g"), "");
        return replaced;
    };
    StringHelper.ellipsis = "...";
    return StringHelper;
}());
exports.default = StringHelper;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\StringHelper\\StringHelper.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\StringHelper\\StringHelper.tsx"); } } })();

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(108);
var index_1 = __webpack_require__(23);
var LookupResourceChip_1 = __webpack_require__(144);
var Chips_1 = __webpack_require__(23);
var ProjectTypedMultiSelect = MultiSelect_1.default();
var LookupProjectChip = LookupResourceChip_1.default();
var ProjectMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupProjectChip, { lookupCollection: props.items, lookupId: r.Id, type: Chips_1.ChipIcon.Project, chipRender: function (item) { return React.createElement(index_1.ProjectChip, { onRequestDelete: onRequestDelete, project: item }); } });
    };
    return React.createElement(ProjectTypedMultiSelect, __assign({ items: props.items, fieldName: "projects", renderChip: chipRenderer }, props));
};
exports.default = ProjectMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\ProjectMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\ProjectMultiSelect.tsx"); } } })();

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PagingBaseComponent_1 = __webpack_require__(179);
exports.PagingBaseProps = PagingBaseComponent_1.PagingBaseProps;
exports.PagingBaseState = PagingBaseComponent_1.PagingBaseState;
exports.Page = PagingBaseComponent_1.Page;
exports.HasId = PagingBaseComponent_1.HasId;
exports.default = PagingBaseComponent_1.PagingBaseComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PagingBaseComponent\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PagingBaseComponent\\index.tsx"); } } })();

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(625);
var InternalLink_1 = __webpack_require__(42);
var ListInternalLink = function (props) {
    return React.createElement(InternalLink_1.default, { className: cn(styles.listInternalLink, props.className), size: props.size, to: props.to, onClick: props.onClick }, props.children);
};
exports.default = ListInternalLink;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\InternalLink\\ListInternalLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\InternalLink\\ListInternalLink.tsx"); } } })();

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1723);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
function getActionLogoUrl(action) {
    var templateId = action.Properties["Octopus.Action.Template.Id"];
    var version = action.Properties["Octopus.Action.Template.Version"];
    return templateId ?
        clientInstance_1.client.resolveLinkTemplate("ActionTemplateVersionedLogo", { typeOrId: templateId, version: version }) :
        clientInstance_1.client.resolveLinkTemplate("ActionTemplateLogo", { typeOrId: action.ActionType });
}
exports.default = getActionLogoUrl;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\getActionLogoUrl.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\getActionLogoUrl.ts"); } } })();

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(1881);
var colors_1 = __webpack_require__(32);
var MarkdownDescription_1 = __webpack_require__(214);
var Logo_1 = __webpack_require__(172);
var styles = __webpack_require__(272);
var uiTestClasses_1 = __webpack_require__(77);
var ActionTemplateCard = function (props) {
    function formatText(text, maxLength) {
        text = (text || "").trim().replace(/\r?\n|\r/g, " ");
        return text.length > maxLength ? text.substr(0, maxLength) + " ..." : text;
    }
    function getStatusText(template) {
        if (template.IsBuiltIn) {
            return React.createElement("span", { style: { color: colors_1.white } }, "by Octopus Deploy");
        }
        if (template.IsInstalled) {
            return React.createElement("span", null, "Installed");
        }
        return React.createElement("span", { style: { color: colors_1.primary } }, formatText(template.Author, 24));
    }
    function getStatusLogo(template) {
        if (template.IsBuiltIn) {
            return React.createElement("em", { className: "fontoctopus-octopus", style: { color: colors_1.white } });
        }
        if (template.IsInstalled) {
            return React.createElement("em", { className: "fa fa-check-square-o", "aria-hidden": "true", style: { color: colors_1.primary } });
        }
        return React.createElement("em", { className: "fa fa-users", "aria-hidden": "true", style: { color: colors_1.primary } });
    }
    function getStatusClass(template) {
        if (template.IsBuiltIn) {
            return styles.templateStatusBuiltIn;
        }
        if (template.IsInstalled) {
            return styles.templateStatusInstalled;
        }
        return styles.templateStatusNotInstalled;
    }
    function getBackgroundColor(template) {
        if (template.IsBuiltIn) {
            return colors_1.primary;
        }
        if (template.IsInstalled) {
            return colors_1.divider;
        }
        return colors_1.white;
    }
    return React.createElement("li", null,
        React.createElement(Card_1.default, { logo: React.createElement(Logo_1.default, { url: props.template.Links.Logo }), className: uiTestClasses_1.stepCardClass, header: React.createElement("div", { className: styles.name }, formatText(props.template.Name, 46)), content: React.createElement("div", { className: styles.description },
                React.createElement(MarkdownDescription_1.default, { markup: props.template.Description })), includeContentFade: false, footerIcon: getStatusLogo(props.template), footerText: getStatusText(props.template), footerBackgroundColor: getBackgroundColor(props.template), onHoverView: React.createElement("div", { className: styles.onHoverActions },
                React.createElement("div", { className: styles.empty }),
                React.createElement("div", { className: styles.primaryAction }, props.primaryAction),
                props.secondaryAction && React.createElement("div", { className: styles.secondaryAction }, props.secondaryAction)) }));
};
ActionTemplateCard.displayName = "ActionTemplateCard";
exports.default = ActionTemplateCard;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplates\\ActionTemplateCard.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplates\\ActionTemplateCard.tsx"); } } })();

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function matchesFilter(template, filter) {
    if (!filter) {
        return true;
    }
    return (template.Name && template.Name.toLowerCase().includes(filter)) ||
        (template.Description && template.Description.toLowerCase().includes(filter)) ||
        (template.Category && template.Category.toLowerCase().includes(filter));
}
exports.default = matchesFilter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplates\\matchesFilter.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplates\\matchesFilter.ts"); } } })();

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(272);
var ActionTemplateCardList = function (props) {
    return React.createElement("ol", { className: styles.templates }, props.children);
};
exports.default = ActionTemplateCardList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplates\\ActionTemplateCardList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplates\\ActionTemplateCardList.tsx"); } } })();

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var resources_1 = __webpack_require__(26);
var form_1 = __webpack_require__(15);
var Text_1 = __webpack_require__(17);
var Validators_1 = __webpack_require__(170);
var MetadataTypeHelpers_1 = __webpack_require__(808);
var Select_1 = __webpack_require__(41);
var StringCheckbox_1 = __webpack_require__(38);
var Sensitive_1 = __webpack_require__(82);
var Either = function (_a) {
    var flag = _a.flag, renderLeft = _a.renderLeft, renderRight = _a.renderRight;
    return (!!flag === true) ? renderRight() : renderLeft();
};
var DynamicForm = function (props) {
    var noValueMessage = "No value provided";
    var getControlType = function (property) {
        if (property.DisplayInfo.ListApi || property.DisplayInfo.Options) {
            return resources_1.ControlType.Select;
        }
        switch (property.Type) {
            case "string":
            case "text":
            case "long":
            case "long?":
            case "int":
            case "int?":
                return resources_1.ControlType.SingleLineText;
            case "bool":
            case "bool?":
            case "boolean":
                return resources_1.ControlType.Checkbox;
            case "string[]":
            case "raw_map":
            case "raw_list":
                return resources_1.ControlType.MultiLineText;
            case "SensitiveValue":
                return resources_1.ControlType.Sensitive;
        }
    };
    var getBooleanDisplayValue = function (value) {
        return value === null || value === false ? "Disabled" : "Enabled";
    };
    var createSummary = function (property, value) {
        switch (property.Type) {
            case "bool":
            case "boolean":
            case "bool?":
                return form_1.Summary.summary(getBooleanDisplayValue(value));
            case "string":
            case "text":
            case "long":
            case "long?":
            case "int":
            case "int?":
            case "raw_map":
            case "raw_list":
                return value === null || value === "" ? form_1.Summary.placeholder(noValueMessage) : form_1.Summary.summary(value);
            case "string[]":
                return form_1.Summary.summary(value && value.join ? value.join(", ") : value);
            case "SensitiveValue":
                return value.HasValue === false ? form_1.Summary.placeholder(noValueMessage) : form_1.Summary.summary("Value set");
        }
    };
    var getReadonlyValue = function (property, value) {
        switch (property.Type) {
            case "bool":
            case "boolean":
            case "bool?":
                return getBooleanDisplayValue(value);
            case "string":
            case "text":
            case "long":
            case "long?":
            case "int":
            case "int?":
            case "string[]":
            case "raw_map":
            case "raw_list":
                return value === null || value === "" ? noValueMessage : value.toString();
            case "SensitiveValue":
                return value.HasValue === false ? noValueMessage : "Value set";
        }
    };
    var getSelectOptions = function (property) {
        if (property.DisplayInfo.Options && property.DisplayInfo.Options.Values) {
            var objectKeys = Object.getOwnPropertyNames(property.DisplayInfo.Options.Values);
            var options = objectKeys.map(function (key) { return ({ value: key.toString(), text: property.DisplayInfo.Options.Values[key].toString() }); });
            return options;
        }
        else if (property.DisplayInfo.ListApi) {
            return []; // TODO: load from api
        }
        else {
            return [];
        }
    };
    var getValidation = function (property) {
        var controlType = getControlType(property);
        if (property.DisplayInfo.Required && controlType !== resources_1.ControlType.Checkbox) {
            return Validators_1.required(MetadataTypeHelpers_1.default.getRequiredMessage(property));
        }
        else {
            return null;
        }
    };
    var getInputControl = function (property, dataContext) {
        var value = dataContext[property.Name];
        if (value && property.Type === "string[]") {
            // We might have a string value that was changed to an array, so don't
            // assume join is a valid method.
            if (value.join) {
                value = value.join("\n");
            }
        }
        var inputType = getControlType(property);
        var formProps = {
            label: property.DisplayInfo.Label,
            value: value || "",
            onChange: function (newValue) { return onChange(property, dataContext, newValue); }
        };
        switch (inputType) {
            case resources_1.ControlType.SingleLineText:
                return React.createElement(Either, { flag: props.isBindable, renderRight: function () { return React.createElement(Text_1.VariableLookupText, __assign({ id: property.Name }, formProps)); }, renderLeft: function () { return React.createElement(form_1.Text, __assign({ id: property.Name }, formProps)); } });
            case resources_1.ControlType.MultiLineText:
                return React.createElement(Either, { flag: props.isBindable, renderRight: function () { return React.createElement(Text_1.VariableLookupText, __assign({ id: property.Name }, formProps, { multiLine: true })); }, renderLeft: function () { return React.createElement(form_1.Text, __assign({ id: property.Name }, formProps, { multiLine: true })); } });
            case resources_1.ControlType.Select:
                return React.createElement(Either, { flag: props.isBindable, renderRight: function () { return React.createElement(Select_1.BoundSelect, __assign({ items: getSelectOptions(property), allowClear: false, resetValue: "" }, formProps)); }, renderLeft: function () { return React.createElement(Select_1.default, __assign({ items: getSelectOptions(property), allowClear: false }, formProps)); } });
            case resources_1.ControlType.Checkbox: {
                return React.createElement(Either, { flag: props.isBindable, renderRight: function () { return React.createElement(StringCheckbox_1.BoundStringCheckbox, __assign({ resetValue: "" }, formProps)); }, renderLeft: function () { return React.createElement(form_1.Checkbox, __assign({}, formProps)); } });
            }
            case resources_1.ControlType.Sensitive:
                return React.createElement(Either, { flag: props.isBindable, renderRight: function () { return React.createElement(Sensitive_1.BoundSensitive, __assign({ label: property.DisplayInfo.Label, resetValue: "" }, formProps)); }, renderLeft: function () { return React.createElement(form_1.Sensitive, __assign({}, formProps)); } });
            default:
                return React.createElement(form_1.Text, __assign({ id: property.Name }, formProps));
        }
    };
    var renderProperty = function (property, dataContext) {
        if (MetadataTypeHelpers_1.default.isCompositeType(property)) {
            var compositeType = props.types.filter(function (t) { return t.Name === property.Type; })[0];
            return renderSection(compositeType, dataContext[property.Name], property.Name);
        }
        var controlType = getControlType(property);
        var selectOptions = getSelectOptions(property);
        var description = property.DisplayInfo && property.DisplayInfo.Description
            ? property.DisplayInfo.Description
            : "Provide a value for " + property.DisplayInfo.Label;
        if (property.DisplayInfo.ReadOnly) {
            return React.createElement(form_1.FormSection, { title: property.Name, help: getReadonlyValue(property, dataContext[property.Name]) });
        }
        var controlToRender = getInputControl(property, dataContext);
        return React.createElement(form_1.ExpandableFormSection, { errorKey: property.Name, title: property.DisplayInfo.Label, help: description, key: property.Name, summary: createSummary(property, dataContext[property.Name]) }, controlToRender);
    };
    var renderSection = function (compositeType, dataContext, sectionName) {
        var types = compositeType && compositeType.Properties && compositeType.Properties.map(function (t) { return renderProperty(t, dataContext); });
        var sectionHeading = sectionName && React.createElement(form_1.FormSectionHeading, { title: sectionName, key: sectionName });
        return React.createElement("div", { key: sectionName },
            sectionHeading,
            React.createElement("div", null, types));
    };
    var onChange = function (property, dataContext, value) {
        var boundValue = value;
        if (property.Type === "string[]") {
            boundValue = value.split("\n");
        }
        // mutate state and trigger UI refresh
        // it would be really nice to replace this
        dataContext[property.Name] = boundValue;
        if (props.onChange) {
            props.onChange(props.values);
        }
    };
    if (props && props.types && props.types.length > 0) {
        return renderSection(props.types[0], props.values, null);
    }
    else {
        console.error("no types provided");
    }
    return null;
};
exports.default = DynamicForm;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DynamicForm\\DynamicForm.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DynamicForm\\DynamicForm.tsx"); } } })();

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "waiting-for-octopus.55f3fc473fe540b3c66e778a0e31dfd8.hashedasset.svg";

/***/ }),
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var LicenseStatusResource = (function (_super) {
    __extends(LicenseStatusResource, _super);
    function LicenseStatusResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LicenseStatusResource;
}(resource_1.default));
exports.LicenseStatusResource = LicenseStatusResource;
exports.default = LicenseStatusResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\licenseStatusResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\licenseStatusResource.ts"); } } })();

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ReferenceDataItem = (function () {
    function ReferenceDataItem() {
    }
    return ReferenceDataItem;
}());
exports.ReferenceDataItem = ReferenceDataItem;
exports.default = ReferenceDataItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\referenceDataItem.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\referenceDataItem.ts"); } } })();

/***/ }),
/* 500 */,
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var resources_1 = __webpack_require__(26);
var redux_actions_1 = __webpack_require__(502);
var ActionTypes = {
    UNHANDLED_ERROR_OCCURRED: "UNHANDLED_ERROR_OCCURRED",
};
function raiseUnhandledErrorAction(error) {
    return { type: ActionTypes.UNHANDLED_ERROR_OCCURRED, error: error };
}
exports.raiseUnhandledErrorAction = raiseUnhandledErrorAction;
var raiseUnhandledError = redux_actions_1.handleActions((_a = {},
    _a[ActionTypes.UNHANDLED_ERROR_OCCURRED] = function (state, action) {
        var error = action.error;
        if (error instanceof resources_1.OctopusError) {
            return {
                message: error.ErrorMessage,
                details: error.Errors
            };
        }
        if (error instanceof Error) {
            return {
                message: error.message,
                details: error.stack.split(" at ")
            };
        }
        return {
            message: JSON.stringify(error)
        };
    },
    _a), null);
exports.default = raiseUnhandledError;
var _a;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BaseComponent\\reducers.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BaseComponent\\reducers.tsx"); } } })();

/***/ }),
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var IconButton_1 = __webpack_require__(63);
var clear_1 = __webpack_require__(178);
var CloseButton = function (props) {
    var style = { verticalAlign: "middle", padding: "0" };
    if (props.size) {
        style.width = props.size;
        style.height = props.size;
    }
    return React.createElement(IconButton_1.default, { style: style, onClick: props.onClose, tooltip: props.tooltip },
        React.createElement(clear_1.default, null));
};
CloseButton.displayName = "CloseButton";
exports.default = CloseButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Button\\CloseButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Button\\CloseButton.tsx"); } } })();

/***/ }),
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var keycode = __webpack_require__(52);
var Key;
(function (Key) {
    Key["Esc"] = "esc";
    Key["Enter"] = "enter";
    Key["CtrlEnter"] = "ctrlenter";
})(Key = exports.Key || (exports.Key = {}));
var KeyboardHandler = (function (_super) {
    __extends(KeyboardHandler, _super);
    function KeyboardHandler(props) {
        var _this = _super.call(this, props) || this;
        _this.handleEsc = function (event) {
            if (!event.defaultPrevented) {
                for (var _i = 0, _a = _this.keyboardRegistrations; _i < _a.length; _i++) {
                    var registration = _a[_i];
                    if (keycode.codes.esc === keycode(registration.key) && keycode.codes.esc === keycode(keycode(event))) {
                        if (registration.onKeyPressed(event)) {
                            event.preventDefault();
                        }
                    }
                }
            }
        };
        _this.handleKey = function (e) {
            var event = e.nativeEvent;
            if (!event.defaultPrevented) {
                var keyName = keycode(event);
                for (var _i = 0, _a = _this.keyboardRegistrations; _i < _a.length; _i++) {
                    var registration = _a[_i];
                    if (keyName === keycode(keycode.codes.enter)) {
                        if (event.ctrlKey) {
                            // Ctrl + Enter
                            if (registration.key === Key.CtrlEnter) {
                                if (registration.onKeyPressed(event)) {
                                    event.preventDefault();
                                }
                            }
                        }
                        else {
                            // Enter, mac command+enter will fall into here
                            if (registration.key === Key.Enter) {
                                if (registration.onKeyPressed(event)) {
                                    event.preventDefault();
                                }
                            }
                        }
                    }
                    else {
                        // Any other keys
                        var code = keycode(keyName);
                        if (code !== undefined // don't want to fall through when undefined === undefined
                            && code === keycode(registration.key)) {
                            if (registration.onKeyPressed(event)) {
                                event.preventDefault();
                            }
                        }
                    }
                }
            }
        };
        _this.keyboardRegistrations = props.registrations;
        return _this;
    }
    KeyboardHandler.prototype.render = function () {
        return React.createElement("div", { onKeyDown: this.handleKey, style: { width: "100%" }, className: this.props.className }, this.props.children);
    };
    KeyboardHandler.prototype.componentDidMount = function () {
        if (this.hasEscRegistration()) {
            window.document.addEventListener("keydown", this.handleEsc);
        }
    };
    KeyboardHandler.prototype.componentWillUnmount = function () {
        if (this.hasEscRegistration()) {
            window.document.removeEventListener("keydown", this.handleEsc);
        }
    };
    KeyboardHandler.prototype.hasEscRegistration = function () {
        var escBinding = this.keyboardRegistrations.find(function (r) { return r.key === Key.Esc; });
        return !!escBinding;
    };
    return KeyboardHandler;
}(React.Component));
exports.default = KeyboardHandler;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\KeyboardHandler\\KeyboardHandler.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\KeyboardHandler\\KeyboardHandler.tsx"); } } })();

/***/ }),
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var ReactDOM = __webpack_require__(31);
var recompose_1 = __webpack_require__(362);
var transitions_1 = __webpack_require__(25);
var EnhancedTextarea_1 = __webpack_require__(1363);
var TextFieldHint_1 = __webpack_require__(549);
var TextFieldLabel_1 = __webpack_require__(550);
var TextFieldUnderline_1 = __webpack_require__(551);
var warning = __webpack_require__(30);
var colors_1 = __webpack_require__(32);
var fontWeights_1 = __webpack_require__(76);
var getStyles = function (props, context, state) {
    var _a = context.muiTheme, baseTheme = _a.baseTheme, _b = _a.textField, floatingLabelColor = _b.floatingLabelColor, focusColor = _b.focusColor, textColor = _b.textColor, disabledTextColor = _b.disabledTextColor, backgroundColor = _b.backgroundColor, errorColor = _b.errorColor;
    var styles = {
        root: {
            fontSize: fontWeights_1.baseSizeInPx,
            lineHeight: '1.5rem',
            width: props.fullWidth ? '100%' : 256,
            height: (props.rows - 1) * 24 + (props.floatingLabelText ? 62 : 48),
            display: 'inline-block',
            position: 'relative',
            backgroundColor: backgroundColor,
            fontFamily: baseTheme.fontFamily,
            transition: transitions_1.default.easeOut('200ms', 'height'),
            cursor: props.disabled ? 'not-allowed' : 'auto',
            marginTop: 0,
        },
        error: {
            position: 'relative',
            bottom: 2,
            fontSize: 12,
            lineHeight: '12px',
            color: errorColor,
            transition: transitions_1.default.easeOut(),
        },
        floatingLabel: {
            color: props.disabled ? disabledTextColor : floatingLabelColor,
            pointerEvents: 'none',
            top: 28,
        },
        input: {
            padding: 0,
            position: 'relative',
            width: '100%',
            border: 'none',
            outline: 'none',
            backgroundColor: 'rgba(0,0,0,0)',
            color: props.disabled ? disabledTextColor : textColor,
            cursor: 'inherit',
            font: 'inherit',
            WebkitOpacity: 1,
            WebkitTapHighlightColor: 'rgba(0,0,0,0)',
        },
        inputNative: {
            appearance: 'textfield',
        },
        underlineStyle: {
            borderColor: colors_1.secondaryText,
        },
        disabledTextColor: {
            color: colors_1.secondaryText,
        }
    };
    styles.textarea = Object.assign({}, styles.input, {
        marginTop: props.floatingLabelText ? 36 : 12,
        marginBottom: props.floatingLabelText ? -36 : -12,
        boxSizing: 'border-box',
        font: 'inherit',
    });
    // Do not assign a height to the textarea as he handles it on his own.
    styles.input.height = '100%';
    if (state.isFocused) {
        styles.floatingLabel.color = focusColor;
    }
    if (props.floatingLabelText) {
        styles.input.boxSizing = 'border-box';
        if (!props.multiLine) {
            styles.input.marginTop = 0;
        }
        if (state.errorText) {
            styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
        }
    }
    if (state.errorText) {
        if (state.isFocused) {
            styles.floatingLabel.color = styles.error.color;
        }
    }
    return styles;
};
/**
 * Check if a value is valid to be displayed inside an input.
 *
 * @param The value to check.
 * @returns True if the string provided is valid, false otherwise.
 */
function isValid(value) {
    return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
}
var TextField = (function (_super) {
    __extends(TextField, _super);
    function TextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isFocused: false,
            errorText: undefined,
            hasValue: false,
        };
        _this.handleInputBlur = function (event) {
            _this.setState({ isFocused: false });
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        _this.handleInputChange = function (event) {
            if (!_this.props.hasOwnProperty('value')) {
                _this.setState({ hasValue: isValid(event.target.value) });
            }
            if (_this.props.onChange) {
                _this.props.onChange(event, event.target.value);
            }
        };
        _this.handleInputFocus = function (event) {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({ isFocused: true });
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        _this.handleHeightChange = function (event, height) {
            var newHeight = height + 24;
            if (_this.props.floatingLabelText) {
                newHeight += 24;
            }
            ReactDOM.findDOMNode(_this).style.height = newHeight + "px";
        };
        return _this;
    }
    TextField.prototype.componentWillMount = function () {
        var _a = this.props, children = _a.children, name = _a.name, hintText = _a.hintText, floatingLabelText = _a.floatingLabelText, id = _a.id;
        var propsLeaf = children ? children.props : this.props;
        this.setState({
            errorText: this.props.errorText,
            hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue),
        });
        warning(name || hintText || floatingLabelText || id, "Material-UI: We don't have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.");
        var uniqueId = name + "-" + hintText + "-" + floatingLabelText + "-" + Math.floor(Math.random() * 0xFFFF);
        this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
    };
    TextField.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.disabled && !this.props.disabled) {
            this.setState({
                isFocused: false,
            });
        }
        if (nextProps.errorText !== this.props.errorText) {
            this.setState({
                errorText: nextProps.errorText,
            });
        }
        if (nextProps.children && nextProps.children.props) {
            nextProps = nextProps.children.props;
        }
        if (nextProps.hasOwnProperty('value')) {
            var hasValue = isValid(nextProps.value);
            this.setState({
                hasValue: hasValue,
            });
        }
    };
    TextField.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
        return (!recompose_1.shallowEqual(this.props, nextProps) ||
            !recompose_1.shallowEqual(this.state, nextState) ||
            !recompose_1.shallowEqual(this.context, nextContext));
    };
    TextField.prototype.blur = function () {
        if (this.input) {
            this.getInputNode().blur();
        }
    };
    TextField.prototype.focus = function () {
        if (this.input) {
            this.getInputNode().focus();
        }
    };
    TextField.prototype.select = function () {
        if (this.input) {
            this.getInputNode().select();
        }
    };
    TextField.prototype.getValue = function () {
        return this.input ? this.getInputNode().value : undefined;
    };
    TextField.prototype.getInputNode = function () {
        return (this.props.children || this.props.multiLine) ?
            this.input.getInputNode() : ReactDOM.findDOMNode(this.input);
    };
    TextField.prototype._isControlled = function () {
        return this.props.hasOwnProperty('value');
    };
    TextField.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, disabled = _a.disabled, errorStyle = _a.errorStyle, errorText = _a.errorText, // eslint-disable-line no-unused-vars
        floatingLabelFixed = _a.floatingLabelFixed, floatingLabelFocusStyle = _a.floatingLabelFocusStyle, floatingLabelShrinkStyle = _a.floatingLabelShrinkStyle, floatingLabelStyle = _a.floatingLabelStyle, floatingLabelText = _a.floatingLabelText, fullWidth = _a.fullWidth, // eslint-disable-line no-unused-vars
        hintText = _a.hintText, hintStyle = _a.hintStyle, id = _a.id, inputStyle = _a.inputStyle, multiLine = _a.multiLine, onBlur = _a.onBlur, // eslint-disable-line no-unused-vars
        onChange = _a.onChange, // eslint-disable-line no-unused-vars
        onFocus = _a.onFocus, // eslint-disable-line no-unused-vars
        style = _a.style, type = _a.type, underlineDisabledStyle = _a.underlineDisabledStyle, underlineFocusStyle = _a.underlineFocusStyle, underlineShow = _a.underlineShow, underlineStyle = _a.underlineStyle, rows = _a.rows, rowsMax = _a.rowsMax, textareaStyle = _a.textareaStyle, other = __rest(_a, ["children", "className", "disabled", "errorStyle", "errorText", "floatingLabelFixed", "floatingLabelFocusStyle", "floatingLabelShrinkStyle", "floatingLabelStyle", "floatingLabelText", "fullWidth", "hintText", "hintStyle", "id", "inputStyle", "multiLine", "onBlur", "onChange", "onFocus", "style", "type", "underlineDisabledStyle", "underlineFocusStyle", "underlineShow", "underlineStyle", "rows", "rowsMax", "textareaStyle"]);
        var prepareStyles = this.context.muiTheme.prepareStyles;
        var styles = getStyles(this.props, this.context, this.state);
        var inputId = id || this.uniqueId;
        var errorTextElement = this.state.errorText && (React.createElement("div", { style: prepareStyles(Object.assign(styles.error, errorStyle)) }, this.state.errorText));
        var floatingLabelTextElement = floatingLabelText && (React.createElement(TextFieldLabel_1.default, { muiTheme: this.context.muiTheme, style: Object.assign(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null), shrinkStyle: floatingLabelShrinkStyle, htmlFor: inputId, shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed, disabled: disabled }, floatingLabelText));
        var inputProps = {
            id: inputId,
            ref: function (elem) { return _this.input = elem; },
            disabled: this.props.disabled,
            onBlur: this.handleInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.handleInputFocus,
        };
        var childStyleMerged = Object.assign(styles.input, inputStyle);
        var inputElement;
        if (children) {
            inputElement = React.cloneElement(children, __assign({}, inputProps, children.props, { style: Object.assign(childStyleMerged, children.props.style) }));
        }
        else {
            inputElement = multiLine ? (React.createElement(EnhancedTextarea_1.default, __assign({ style: childStyleMerged, textareaStyle: Object.assign(styles.textarea, styles.inputNative, textareaStyle), rows: rows, rowsMax: rowsMax, hintText: hintText }, other, inputProps, { onHeightChange: this.handleHeightChange }))) : (React.createElement("input", __assign({ type: type, style: prepareStyles(Object.assign(styles.inputNative, childStyleMerged)) }, other, inputProps)));
        }
        var rootProps = {};
        if (children) {
            rootProps = other;
        }
        return (React.createElement("div", __assign({}, rootProps, { className: className, style: prepareStyles(Object.assign(styles.root, style)) }),
            floatingLabelTextElement,
            hintText ?
                React.createElement(TextFieldHint_1.default, { muiTheme: this.context.muiTheme, show: !(this.state.hasValue || (floatingLabelText && !this.state.isFocused)) ||
                        (!this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused), style: hintStyle, text: hintText }) :
                null,
            inputElement,
            underlineShow ?
                React.createElement(TextFieldUnderline_1.default, { disabled: disabled, disabledStyle: underlineDisabledStyle, error: !!this.state.errorText, errorStyle: errorStyle, focus: this.state.isFocused, focusStyle: underlineFocusStyle, muiTheme: this.context.muiTheme, style: underlineStyle }) :
                null,
            errorTextElement));
    };
    TextField.propTypes = {
        children: PropTypes.node,
        /**
         * The css class name of the root element.
         */
        className: PropTypes.string,
        /**
         * The text string to use for the default value.
         */
        defaultValue: PropTypes.any,
        /**
         * Disables the text field if set to true.
         */
        disabled: PropTypes.bool,
        /**
         * The style object to use to override error styles.
         */
        errorStyle: PropTypes.object,
        /**
         * The error content to display.
         */
        errorText: PropTypes.node,
        /**
         * If true, the floating label will float even when there is no value.
         */
        floatingLabelFixed: PropTypes.bool,
        /**
         * The style object to use to override floating label styles when focused.
         */
        floatingLabelFocusStyle: PropTypes.object,
        /**
         * The style object to use to override floating label styles when shrunk.
         */
        floatingLabelShrinkStyle: PropTypes.object,
        /**
         * The style object to use to override floating label styles.
         */
        floatingLabelStyle: PropTypes.object,
        /**
         * The content to use for the floating label element.
         */
        floatingLabelText: PropTypes.node,
        /**
         * If true, the field receives the property width 100%.
         */
        fullWidth: PropTypes.bool,
        /**
         * Override the inline-styles of the TextField's hint text element.
         */
        hintStyle: PropTypes.object,
        /**
         * The hint content to display.
         */
        hintText: PropTypes.node,
        /**
         * The id prop for the text field.
         */
        id: PropTypes.string,
        /**
         * Override the inline-styles of the TextField's input element.
         * When multiLine is false: define the style of the input element.
         * When multiLine is true: define the style of the container of the textarea.
         */
        inputStyle: PropTypes.object,
        /**
         * If true, a textarea element will be rendered.
         * The textarea also grows and shrinks according to the number of lines.
         */
        multiLine: PropTypes.bool,
        /**
         * Name applied to the input.
         */
        name: PropTypes.string,
        /** @ignore */
        onBlur: PropTypes.func,
        /**
         * Callback function that is fired when the textfield's value changes.
         *
         * @param {object} event Change event targeting the text field.
         * @param {string} newValue The new value of the text field.
         */
        onChange: PropTypes.func,
        /** @ignore */
        onFocus: PropTypes.func,
        /**
         * Number of rows to display when multiLine option is set to true.
         */
        rows: PropTypes.number,
        /**
         * Maximum number of rows to display when
         * multiLine option is set to true.
         */
        rowsMax: PropTypes.number,
        /**
         * Override the inline-styles of the root element.
         */
        style: PropTypes.object,
        /**
         * Override the inline-styles of the TextField's textarea element.
         * The TextField use either a textarea or an input,
         * this property has effects only when multiLine is true.
         */
        textareaStyle: PropTypes.object,
        /**
         * Specifies the type of input to display
         * such as "password" or "text".
         */
        type: PropTypes.string,
        /**
         * Override the inline-styles of the
         * TextField's underline element when disabled.
         */
        underlineDisabledStyle: PropTypes.object,
        /**
         * Override the inline-styles of the TextField's
         * underline element when focussed.
         */
        underlineFocusStyle: PropTypes.object,
        /**
         * If true, shows the underline for the text field.
         */
        underlineShow: PropTypes.bool,
        /**
         * Override the inline-styles of the TextField's underline element.
         */
        underlineStyle: PropTypes.object,
        /**
         * The value of the text field.
         */
        value: PropTypes.any,
    };
    TextField.defaultProps = {
        disabled: false,
        floatingLabelFixed: false,
        multiLine: false,
        fullWidth: false,
        type: 'text',
        underlineShow: true,
        rows: 1,
    };
    TextField.contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    return TextField;
}(React.Component));
exports.default = TextField;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Text\\TextField.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Text\\TextField.tsx"); } } })();

/***/ }),
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var material_ui_1 = __webpack_require__(92);
var FocusListItem = (function (_super) {
    __extends(FocusListItem, _super);
    function FocusListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setRef = function (el) {
            _this.element = el;
        };
        return _this;
    }
    FocusListItem.prototype.componentDidMount = function () {
        if (this.props.isFocused) {
            this.element.applyFocusState("keyboard-focused");
        }
    };
    FocusListItem.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.isFocused === this.props.isFocused) {
            return;
        }
        if (this.props.isFocused) {
            this.element.applyFocusState("keyboard-focused");
        }
    };
    FocusListItem.prototype.render = function () {
        return React.createElement(material_ui_1.ListItem, { ref: this.setRef, style: this.props.style, containerElement: this.props.containerElement, primaryText: this.props.primaryText, secondaryText: this.props.secondaryText, onClick: this.props.onRequestClose });
    };
    return FocusListItem;
}(React.Component));
exports.default = FocusListItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FocusListItem\\FocustListItem.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FocusListItem\\FocustListItem.tsx"); } } })();

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1422);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Dialog_1 = __webpack_require__(158);
var Toolbar_1 = __webpack_require__(593);
var BaseComponent_1 = __webpack_require__(14);
var GettingStartedDetails_1 = __webpack_require__(627);
var IconButton_1 = __webpack_require__(63);
var clear_1 = __webpack_require__(178);
var GettingStartedDialog = (function (_super) {
    __extends(GettingStartedDialog, _super);
    function GettingStartedDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.styles = {
            dialogRoot: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: 0
            },
            dialogContent: {
                position: "relative",
                width: "100%",
                maxWidth: "1300px",
                transform: ""
            },
            dialogBody: {
                paddingBottom: 0
            }
        };
        return _this;
    }
    GettingStartedDialog.prototype.render = function () {
        var _this = this;
        var close = React.createElement(Toolbar_1.Toolbar, { style: { backgroundColor: "initial", height: 0 }, noGutter: true },
            React.createElement(Toolbar_1.ToolbarGroup, { firstChild: true }),
            React.createElement(Toolbar_1.ToolbarGroup, { lastChild: true },
                React.createElement(IconButton_1.default, { tooltip: "Close", onClick: this.props.onClose },
                    React.createElement(clear_1.default, null))));
        return React.createElement(Dialog_1.default, { title: null, open: this.props.open, onRequestClose: this.props.onClose, contentStyle: this.styles.dialogContent, bodyStyle: this.styles.dialogBody, style: this.styles.dialogRoot, repositionOnUpdate: false, autoScrollBodyContent: true },
            close,
            React.createElement(GettingStartedDetails_1.GettingStartedDetails, { onNavigating: function () { return _this.props.onNavigating(); }, highlightSection: this.props.highlightSection }));
    };
    return GettingStartedDialog;
}(BaseComponent_1.BaseComponent));
exports.GettingStartedDialog = GettingStartedDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\GettingStartedDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\GettingStartedDialog.tsx"); } } })();

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var GettingStartedDetailSection_1 = __webpack_require__(1429);
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var BusyIndicator_1 = __webpack_require__(254);
var cn = __webpack_require__(19);
var gettingStartedStatus_1 = __webpack_require__(628);
var ExternalLink_1 = __webpack_require__(91);
var SectionStepLink_1 = __webpack_require__(1431);
var styles = __webpack_require__(205);
var routeLinks_1 = __webpack_require__(20);
var react_router_1 = __webpack_require__(69);
var WhatsNext_1 = __webpack_require__(629);
var resolvePathWithSpaceId_1 = __webpack_require__(131);
var imageOctopus = __webpack_require__(630);
var imageEnvironments = __webpack_require__(631);
var imagePackage = __webpack_require__(632);
var imageProject = __webpack_require__(633);
var imageDeploy = __webpack_require__(634);
var ActionLink = (function () {
    function ActionLink(item) {
        this.path = item.path;
        this.text = item.text;
        this.note = item.note;
        this.complete = item.complete;
        this.enabled = item.enabled;
        this.items = item.items;
    }
    return ActionLink;
}());
var Or = (function () {
    function Or() {
    }
    return Or;
}());
var LearnAbout = (function () {
    function LearnAbout(text, link, note) {
        this.text = text;
        this.link = link;
        this.note = note;
    }
    return LearnAbout;
}());
var GettingStartedDetailsInternal = (function (_super) {
    __extends(GettingStartedDetailsInternal, _super);
    function GettingStartedDetailsInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.onNavigating = function () {
            if (_this.props.onNavigating) {
                _this.props.onNavigating();
            }
        };
        _this.state = {
            next: "",
            projects: [],
            releases: [],
            sections: null,
        };
        return _this;
    }
    GettingStartedDetailsInternal.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var tasksStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, gettingStartedStatus_1.gettingStartedStatus.status()];
                    case 1:
                        tasksStatus = _a.sent();
                        this.refresh(tasksStatus);
                        if (!tasksStatus.tasks.Deploy.DeployedRelease.IsComplete) {
                            this.unsubscribe = gettingStartedStatus_1.gettingStartedStatus.subscribe(function (status) { return _this.refresh(status); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GettingStartedDetailsInternal.prototype.componentWillUnmount = function () {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    };
    GettingStartedDetailsInternal.prototype.render = function () {
        var _this = this;
        var isInEnvironmentPage = this.isInEnvironmentPage(this.props.location.pathname, this.props.match.params.spaceId);
        var whatsNext = WhatsNext_1.default(isInEnvironmentPage, this.state.next, this.state.projects, this.state.releases, this.props.onNavigating);
        return React.createElement("div", { className: cn(styles.container, !this.state.sections && styles.liftBusyIndicator) },
            !this.state.sections && React.createElement(BusyIndicator_1.default, { show: true, inline: false }),
            React.createElement("h2", null, "Welcome to Octopus Deploy"),
            React.createElement("p", { style: { textAlign: "center", width: "80%" } }, "The steps below introduce all the key Octopus concepts so you can easily automate deployments for all your applications and services in a safe, reliable and repeatable way."),
            React.createElement("div", { className: styles.gettingStartedSection }, this.state.sections && this.state.sections.items.map(function (section) {
                return React.createElement(GettingStartedDetailSection_1.default, { key: section.area, header: section.header, complete: section.complete, area: section.area, imgSrc: section.image, highlightSection: _this.props.highlightSection === section.area },
                    React.createElement("ul", { className: styles.actionsList }, section.actions.map(function (action, index) {
                        if (action instanceof ActionLink) {
                            return React.createElement("li", { key: action.text, className: cn((_a = {},
                                    _a[styles.edit] = !_this.state.sections.readonly && !action.complete,
                                    _a[styles.disabled] = !_this.state.sections.readonly && !action.enabled,
                                    _a[styles.complete] = !_this.state.sections.readonly && action.complete,
                                    _a[styles.completeReadOnly] = _this.state.sections.readonly,
                                    _a)) },
                                !action.enabled && React.createElement("span", null, action.text),
                                action.enabled && React.createElement(SectionStepLink_1.SectionStepLink, { onNavigating: _this.onNavigating, text: action.text, path: action.path, 
                                    /* given this is an onboarding we don't display more then 5 items in these dropdowns */
                                    items: action.items && action.items.slice(0, 5) }),
                                action.note && React.createElement("div", { className: styles.note }, action.note));
                        }
                        if (action instanceof LearnAbout) {
                            return React.createElement("li", { key: action.text, className: styles.info },
                                React.createElement(ExternalLink_1.default, { href: action.link, showIcon: false }, action.text),
                                React.createElement("div", { className: styles.note }, action.note));
                        }
                        if (action instanceof Or) {
                            return React.createElement("li", { key: section.area + "-" + index },
                                React.createElement("div", { style: { marginBottom: "0.5rem", marginTop: "-0.2rem" }, className: cn(styles.note, (_b = {}, _b[styles.disabled] = _this.state.sections.readonly, _b)) },
                                    React.createElement("strong", null, "OR")));
                        }
                        var _a, _b;
                    })),
                    React.createElement("span", { className: styles.help }, section.help));
            })),
            React.createElement("div", { className: styles.detailsWhatsNextContainer }, whatsNext.element));
    };
    GettingStartedDetailsInternal.prototype.isInEnvironmentPage = function (path, spaceId) {
        return resolvePathWithSpaceId_1.resolveStringPathWithSpaceId(routeLinks_1.default.infrastructure.environments.root, spaceId) === path;
    };
    GettingStartedDetailsInternal.prototype.refresh = function (status) {
        var deployRelease = (function () {
            var project = status.projects.find(function (p) {
                return p.Id === status.releases[0].ProjectId;
            });
            return routeLinks_1.default.project(project).root;
        }).bind(this);
        var deployMultipleRelease = (function () {
            var projectIds = [];
            projectIds = status.releases.reduce(function (state, r) {
                if (!state.includes(r.ProjectId)) {
                    state.push(r.ProjectId);
                }
                return state;
            }, projectIds);
            return status.projects
                .filter(function (p) { return projectIds.includes(p.Id); })
                .map(function (p) { return ({
                label: p.Name,
                link: routeLinks_1.default.project(p).root
            }); });
        }).bind(this);
        var sectionsList = [
            {
                header: "1. Install and set up",
                area: "OCTOPUS SERVER",
                complete: true,
                image: imageOctopus,
                actions: [
                    new ActionLink({
                        complete: true,
                        enabled: true,
                        text: "Create home directory"
                    }), new ActionLink({
                        complete: true,
                        enabled: true,
                        text: "Configure service account"
                    }), new ActionLink({
                        complete: true,
                        enabled: true,
                        text: "Specify SQL Server details"
                    }), new ActionLink({
                        complete: true,
                        enabled: true,
                        text: "Set up web portal"
                    }), new ActionLink({
                        complete: true,
                        enabled: true,
                        text: "Select authentication mode"
                    }), new ActionLink({
                        complete: true,
                        enabled: true,
                        text: "Create Octopus admin"
                    })
                ]
            },
            {
                header: "2. Configure",
                area: "INFRASTRUCTURE",
                complete: status.tasks.Infrastructure.IsComplete,
                image: imageEnvironments,
                help: React.createElement("span", null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingEnvironmentsLearnMore" }, "environments"),
                    ", ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingDeploymentTargetsLearnMore" }, "targets"),
                    "and ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingAccountsLearnMore" }, "accounts"),
                    "."),
                actions: [
                    new ActionLink({
                        text: "Create environments",
                        path: routeLinks_1.default.infrastructure.environments.root,
                        complete: status.tasks.Infrastructure.CreatedEnvironment.IsComplete,
                        enabled: status.tasks.Infrastructure.CreatedEnvironment.IsEnabled,
                        note: "Environments help you organise targets into groups. e.g., Dev, Test and Production."
                    }),
                    new ActionLink({
                        text: "Add deployment target",
                        path: routeLinks_1.default.infrastructure.machines.root,
                        complete: status.tasks.Infrastructure.CreatedMachine.IsComplete,
                        enabled: status.tasks.Infrastructure.CreatedMachine.IsEnabled,
                        note: "Targets are the servers where your applications will be deployed."
                    }),
                    new Or(),
                    new ActionLink({
                        text: "Add an account",
                        path: routeLinks_1.default.infrastructure.accounts.root,
                        complete: status.tasks.Infrastructure.AddedAzureAccount.IsComplete,
                        enabled: status.tasks.Infrastructure.AddedAzureAccount.IsEnabled,
                        note: "Accounts can be associated with deployment targets and include Azure subscriptions, SSH keys, and usernames and passwords."
                    })
                ]
            },
            {
                header: "3. Application",
                area: "PACKAGING",
                complete: status.tasks.Package.IsComplete,
                image: imagePackage,
                help: React.createElement("span", null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingVersioningLearnMore" }, "versioning"),
                    ", ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingPackagesLearnMore" }, "packaging"),
                    "and ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingPackageRepositoriesLearnMore" }, "external feeds"),
                    "."),
                actions: [
                    new LearnAbout("Learn about packaging and versioning", "OnboardingPackagesLearnMore", "Package and version your applications so they can be deployed."),
                    new ActionLink({
                        text: "Upload package",
                        path: routeLinks_1.default.library.builtInRepository.root,
                        complete: status.tasks.Package.UploadedPackage.IsComplete,
                        enabled: status.tasks.Package.UploadedPackage.IsEnabled,
                        note: "Push packages to the built-in repository manually or integrate with your existing build tool."
                    }),
                    new Or(),
                    new ActionLink({
                        text: "Add external feed",
                        path: routeLinks_1.default.library.feeds,
                        complete: status.tasks.Package.AddedFeed.IsComplete,
                        enabled: status.tasks.Package.AddedFeed.IsEnabled,
                        note: "Octopus can integrate with external package repositories like TeamCity and VSTS."
                    })
                ]
            },
            {
                header: "4. Create a",
                area: "PROJECT",
                complete: status.tasks.Project.IsComplete,
                image: imageProject,
                help: React.createElement("span", null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingProjectsLearnMore" }, "projects"),
                    "and ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingDeploymentProcessLearnMore" }, "deployment processes"),
                    "."),
                actions: [
                    new ActionLink({
                        text: "Create a project",
                        path: routeLinks_1.default.projects,
                        complete: status.tasks.Project.CreatedProject.IsComplete,
                        enabled: status.tasks.Project.CreatedProject.IsEnabled,
                        note: "Octopus projects specify the steps and configuration variables required to deploy your application."
                    }),
                    new ActionLink({
                        text: "Define its process",
                        path: status.projects.length === 1 ? routeLinks_1.default.project(status.projects[0]).process.root : null,
                        complete: status.tasks.Project.AddedProjectStep.IsComplete,
                        enabled: status.tasks.Project.AddedProjectStep.IsEnabled,
                        note: "A deployment process specifies the steps to deploy an application which allows you to deploy new versions consistently every time.",
                        items: status.projects.length > 1 ? status.projects.map(function (p) { return ({
                            label: p.Name,
                            link: routeLinks_1.default.project(p).process.root
                        }); }) : null
                    })
                ]
            },
            {
                header: "5. You're ready to",
                area: "DEPLOY",
                complete: status.tasks.Deploy.IsComplete,
                image: imageDeploy,
                help: React.createElement("span", null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingReleasesLearnMore" }, "creating and deploying releases"),
                    "."),
                actions: [
                    new ActionLink({
                        text: "Create a release",
                        path: status.projects.length === 1 ? routeLinks_1.default.project(status.projects[0]).releases : null,
                        complete: status.tasks.Deploy.CreatedRelease.IsComplete,
                        enabled: status.tasks.Deploy.CreatedRelease.IsEnabled,
                        note: (React.createElement("div", null,
                            "Releases contain all project and package details so it can be deployed safely over and over.",
                            React.createElement("br", null),
                            React.createElement("br", null),
                            "Creating a release can be done once steps 1-4 are complete.")),
                        items: status.projects.length > 1 ? status.projects.map(function (p) { return ({
                            label: p.Name,
                            link: routeLinks_1.default.project(p).releases
                        }); }) : null
                    }),
                    new ActionLink({
                        text: "Deploy a release",
                        path: status.releases.length === 1 ? deployRelease() : null,
                        complete: status.tasks.Deploy.DeployedRelease.IsComplete,
                        enabled: status.tasks.Deploy.DeployedRelease.IsEnabled,
                        note: "Deploy your first release to complete your journey into deployment automation.",
                        items: status.releases.length > 1 ? deployMultipleRelease() : null
                    })
                ]
            }
        ];
        this.setState({
            sections: {
                readonly: status.tasks.Deploy.DeployedRelease.IsComplete,
                items: sectionsList
            },
            next: status.next,
            projects: status.projects,
            releases: status.releases
        });
    };
    return GettingStartedDetailsInternal;
}(BaseComponent_1.BaseComponent));
exports.GettingStartedDetails = react_router_1.withRouter(GettingStartedDetailsInternal);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\GettingStartedDetails.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\GettingStartedDetails.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
var permission_1 = __webpack_require__(49);
var resources_1 = __webpack_require__(26);
var PermissionCheck_1 = __webpack_require__(45);
var GettingStartedStatus = (function () {
    function GettingStartedStatus() {
        this.next = "";
        this.projects = [];
        this.releases = [];
        this.subscribers = {};
        this.refreshPeriod = 2000;
        this.refresh = this.refresh.bind(this);
        this.init = this.init.bind(this);
        this.subscribe = this.subscribe.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
        this.populateReleasesList = this.populateReleasesList.bind(this);
        this.populateProjectsList = this.populateProjectsList.bind(this);
    }
    GettingStartedStatus.prototype.init = function () {
        return this.refresh();
    };
    GettingStartedStatus.prototype.subscribe = function (callback) {
        var subscriberId = ++GettingStartedStatus.subscriberId;
        this.subscribers[subscriberId] = callback;
        if (Object.getOwnPropertyNames(this.subscribers).length === 1) {
            this.refresh();
        }
        return subscriberId;
    };
    GettingStartedStatus.prototype.unsubscribe = function (subscriberId) {
        delete this.subscribers[subscriberId];
    };
    GettingStartedStatus.prototype.populateReleasesList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!PermissionCheck_1.isAllowed({ permission: permission_1.Permission.ReleaseView, wildcard: true })) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, clientInstance_1.repository.Releases.list()];
                    case 2: return [2 /*return*/, (_a.sent()).Items];
                    case 3:
                        ex_1 = _a.sent();
                        if (ex_1 instanceof resources_1.OctopusError && ex_1.StatusCode !== 403) {
                            throw ex_1;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, []];
                }
            });
        });
    };
    GettingStartedStatus.prototype.populateProjectsList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ex_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!PermissionCheck_1.isAllowed({ permission: permission_1.Permission.ProjectView, wildcard: true })) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, clientInstance_1.repository.Projects.all()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        ex_2 = _a.sent();
                        if (ex_2 instanceof resources_1.OctopusError && ex_2.StatusCode !== 403) {
                            throw ex_2;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, []];
                }
            });
        });
    };
    GettingStartedStatus.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var userOnboardingData, next, _i, _a, task, _b, projects, releases, _c, subscriberIds;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (this.tasks && document.hidden) {
                            setTimeout(function () { return _this.refresh(); }, this.refreshPeriod);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, clientInstance_1.repository.UserOnboarding.get()];
                    case 1:
                        userOnboardingData = _d.sent();
                        next = "";
                        this.tasks = { Infrastructure: null, Deploy: null, Package: null, Project: null };
                        for (_i = 0, _a = userOnboardingData.Tasks; _i < _a.length; _i++) {
                            task = _a[_i];
                            this.tasks[task.Category] = this.tasks[task.Category] || {};
                            this.tasks[task.Category][task.Name] = this.tasks[task.Category][task.Name] || {};
                            this.tasks[task.Category][task.Name].IsComplete = task.IsComplete;
                            this.tasks[task.Category][task.Name].IsEnabled = task.IsEnabled;
                        }
                        this.tasks.Infrastructure.IsEnabled = this.tasks.Infrastructure.CreatedEnvironment.IsEnabled;
                        this.tasks.Infrastructure.Percent = 0;
                        this.tasks.Infrastructure.IsComplete = false;
                        if (this.tasks.Infrastructure.CreatedEnvironment.IsComplete) {
                            this.tasks.Infrastructure.Percent += 50;
                        }
                        else if (!!!next) {
                            next = "Infrastructure.CreatedEnvironment";
                        }
                        if (this.tasks.Infrastructure.CreatedMachine.IsComplete) {
                            this.tasks.Infrastructure.Percent += 50;
                        }
                        else if (this.tasks.Infrastructure.AddedAzureAccount.IsComplete) {
                            this.tasks.Infrastructure.Percent += 50;
                        }
                        else if (!!!next) {
                            next = "Infrastructure.CreatedMachineOrAccount";
                        }
                        if (this.tasks.Infrastructure.Percent === 100) {
                            this.tasks.Infrastructure.IsComplete = true;
                        }
                        this.tasks.Package.IsEnabled = this.tasks.Package.UploadedPackage.IsEnabled;
                        this.tasks.Package.Percent = 0;
                        this.tasks.Package.IsComplete = false;
                        if (this.tasks.Package.UploadedPackage.IsComplete) {
                            this.tasks.Package.Percent += 100;
                        }
                        else if (this.tasks.Package.AddedFeed.IsComplete) {
                            this.tasks.Package.Percent += 100;
                        }
                        else if (!!!next) {
                            // tslint:disable-next-line
                            if (this.tasks.Deploy.CreatedRelease.IsEnabled && !this.tasks.Deploy.CreatedRelease.IsComplete) {
                                next = "Deploy.CreatedRelease";
                            }
                            else if (this.tasks.Deploy.DeployedRelease.IsEnabled && !this.tasks.Deploy.DeployedRelease.IsComplete) {
                                next = "Deploy.DeployedRelease";
                            }
                            else {
                                next = "Package";
                            }
                        }
                        if (this.tasks.Package.Percent === 100) {
                            this.tasks.Package.IsComplete = true;
                        }
                        this.tasks.Project.IsEnabled = this.tasks.Project.CreatedProject.IsEnabled;
                        this.tasks.Project.Percent = 0;
                        this.tasks.Project.IsComplete = false;
                        if (this.tasks.Project.CreatedProject.IsComplete) {
                            this.tasks.Project.Percent += 50;
                        }
                        else if (!!!next) {
                            next = "Project.CreatedProject";
                        }
                        if (this.tasks.Project.AddedProjectStep.IsComplete) {
                            this.tasks.Project.Percent += 50;
                        }
                        else if (!!!next) {
                            next = "Project.AddedProjectStep";
                        }
                        if (this.tasks.Project.Percent === 100) {
                            this.tasks.Project.IsComplete = true;
                        }
                        this.tasks.Deploy.IsEnabled = this.tasks.Deploy.CreatedRelease.IsEnabled;
                        this.tasks.Deploy.Percent = 0;
                        this.tasks.Deploy.IsComplete = false;
                        if (this.tasks.Deploy.CreatedRelease.IsComplete) {
                            this.tasks.Deploy.Percent += 50;
                        }
                        else if (!!!next) {
                            next = "Deploy.CreatedRelease";
                        }
                        if (this.tasks.Deploy.DeployedRelease.IsComplete) {
                            this.tasks.Deploy.Percent += 50;
                        }
                        else if (!!!next) {
                            next = "Deploy.DeployedRelease";
                        }
                        if (this.tasks.Deploy.Percent === 100) {
                            this.tasks.Deploy.IsComplete = true;
                        }
                        this.next = next;
                        if (!!this.tasks.Deploy.DeployedRelease.IsComplete) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.all([this.populateProjectsList(), this.populateReleasesList()])];
                    case 2:
                        _c = _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _c = [[], []];
                        _d.label = 4;
                    case 4:
                        _b = _c, projects = _b[0], releases = _b[1];
                        this.projects = projects;
                        this.releases = releases.filter(function (r) { return projects.some(function (p) { return p.Id === r.ProjectId; }); }); //Ensure we only display releases that we have projects for
                        subscriberIds = Object.getOwnPropertyNames(this.subscribers);
                        subscriberIds.forEach(function (s, _, subscribers) {
                            try {
                                _this.subscribers[s](_this);
                            }
                            catch (ex) {
                                //Ignore on purpose
                            }
                        }, this);
                        if (subscriberIds.length > 0 && !this.tasks.Deploy.DeployedRelease.IsComplete) {
                            setTimeout(function () { return _this.refresh(); }, this.refreshPeriod);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GettingStartedStatus.subscriberId = 0;
    return GettingStartedStatus;
}());
exports.GettingStartedStatus = GettingStartedStatus;
var gettingStartedStatusInstance = new GettingStartedStatus();
var gettingStartedStatus = {
    subscribe: function (callback) {
        var id = gettingStartedStatusInstance.subscribe(callback);
        return function () {
            gettingStartedStatusInstance.unsubscribe(id);
        };
    },
    status: function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, gettingStartedStatusInstance.init()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, gettingStartedStatusInstance];
            }
        });
    }); }
};
exports.gettingStartedStatus = gettingStartedStatus;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\gettingStartedStatus.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\gettingStartedStatus.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var NextButton_1 = __webpack_require__(1432);
var routeLinks_1 = __webpack_require__(20);
var PermissionCheck_1 = __webpack_require__(45);
var permission_1 = __webpack_require__(49);
var Callout_1 = __webpack_require__(59);
var styles = __webpack_require__(1435);
function getWhatsNext(isInEnvironmentPage, next, projects, releases, onClick) {
    switch (next) {
        case "Infrastructure.CreatedEnvironment":
            return {
                text: "To get started, create an environment.",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Create environment", items: [
                            {
                                label: "Create environment",
                                link: routeLinks_1.default.infrastructure.environments.root
                            }
                        ] }))
            };
        case "Infrastructure.CreatedMachineOrAccount":
            return {
                text: "Your new environment needs a deployment target.",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.MachineCreate, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.MachineCreate,
                            " permission is required to add a deployment target") },
                        React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Add deployment target", items: [
                                {
                                    label: "Add deployment target",
                                    link: isInEnvironmentPage ? routeLinks_1.default.infrastructure.machines.discover()
                                        : routeLinks_1.default.infrastructure.environments.root
                                }
                            ] })),
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.AccountCreate, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.AccountCreate,
                            " permission is required to add an account") },
                        React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Add an account", items: [
                                {
                                    label: "Add an account",
                                    link: routeLinks_1.default.infrastructure.accounts.root
                                }
                            ] })))
            };
        case "Package":
            return {
                text: "Upload package manually, automatically or via an external feed.",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.BuiltInFeedPush, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.BuiltInFeedPush,
                            " permission is required to upload a package") },
                        React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Upload package", items: [
                                {
                                    label: "Upload package",
                                    link: routeLinks_1.default.library.builtInRepository.root
                                }
                            ] })),
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.BuiltInFeedPush, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.BuiltInFeedPush,
                            " permission is required to upload a package") },
                        React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Add external feed", items: [
                                {
                                    label: "Add external feed",
                                    link: routeLinks_1.default.library.feeds
                                }
                            ] })))
            };
        case "Project.CreatedProject":
            return {
                text: "You're making great progress!",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.ProjectCreate, projectGroup: "*", alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.ProjectCreate,
                            " permission is required to add a project") },
                        React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Add project", items: [
                                {
                                    label: "Add project",
                                    link: routeLinks_1.default.projects
                                }
                            ] })))
            };
        case "Project.AddedProjectStep":
            return {
                text: "To create a release, a deployment process must be configured.",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Define your deployment process", items: projects.map(function (p) { return ({
                            label: p.Name,
                            link: routeLinks_1.default.project(p).process.root
                        }); }) }))
            };
        case "Deploy.CreatedRelease":
            return {
                text: "You can now create a release.",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.ReleaseCreate, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.ReleaseCreate,
                            " permission is required to deploy the release") },
                        React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Create release", items: projects.map(function (p) { return ({
                                label: p.Name,
                                link: routeLinks_1.default.project(p).releases
                            }); }) })))
            };
        case "Deploy.DeployedRelease":
            var deployRelease = (function () {
                var project = projects.find(function (p) {
                    return p.Id === releases[0].ProjectId;
                });
                return {
                    label: project.Name,
                    link: routeLinks_1.default.project(project).root
                };
            });
            var deployMultipleRelease = (function () {
                var projectIds = [];
                projectIds = releases.reduce(function (state, r) {
                    if (!state.includes(r.ProjectId)) {
                        state.push(r.ProjectId);
                    }
                    return state;
                }, projectIds);
                return projects
                    .filter(function (p) { return projectIds.includes(p.Id); })
                    .map(function (p) { return ({
                    label: p.Name,
                    link: routeLinks_1.default.project(p).root
                }); });
            });
            return {
                text: "Woohoo! Your first release is ready to deploy.",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.DeploymentCreate, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.DeploymentCreate,
                            " permission is required to deploy the release") },
                        releases.length === 1 && React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Deploy", items: [deployRelease()] }),
                        releases.length > 1 && React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Deploy", items: deployMultipleRelease() })))
            };
        default:
            return {
                text: null,
                element: null
            };
    }
}
exports.default = getWhatsNext;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\WhatsNext\\WhatsNext.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\WhatsNext\\WhatsNext.tsx"); } } })();

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Octopus.87d099af4960c9e52db0ca1ba0b9718c.hashedasset.svg";

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Environments.5eaa2cdf845ba9033d03e9492513d9d1.hashedasset.svg";

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Package.b17078af8dacc25c703f3b62fd6a32a9.hashedasset.svg";

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Project.c9fc7a11271a55ee2fb44b00548f20e2.hashedasset.svg";

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Deploy.35d78df753f0d28f800587e47dabe7d1.hashedasset.svg";

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(14);
var LinksMenu_1 = __webpack_require__(636);
var LinksMenuButton_1 = __webpack_require__(1438);
var MenuNode_1 = __webpack_require__(637);
var lodash_1 = __webpack_require__(16);
var React = __webpack_require__(0);
var react_event_listener_1 = __webpack_require__(55);
var react_router_1 = __webpack_require__(69);
var InternalNavLink_1 = __webpack_require__(223);
var isUrlActive_1 = __webpack_require__(370);
var PriorityNavigation = (function (_super) {
    __extends(PriorityNavigation, _super);
    function PriorityNavigation(props) {
        var _this = _super.call(this, props) || this;
        _this.widthsArray = [];
        _this.onResize = function () {
            if (_this.containerElement.offsetWidth === _this.lastKnownContainerWidth) {
                return; // Nothing changed
            }
            _this.setState({ availableWidth: null });
        };
        _this.showMoreMenu = function (event) {
            event.preventDefault();
            _this.setState({
                isMoreMenuOpen: !_this.state.isMoreMenuOpen
            });
        };
        _this.hideMoreMenu = function () {
            _this.setState({
                isMoreMenuOpen: false
            });
        };
        _this.setMeasurementDiv = function (el) {
            if (!el) {
                return;
            }
            _this.containerElement = el.parentNode;
            _this.lastKnownContainerWidth = _this.containerElement.offsetWidth;
            _this.setState({
                availableWidth: el.offsetWidth
            }, function () { return _this.updateNavigation(_this.props); });
        };
        _this.setNavigation = function (el) {
            _this.navigation = el;
        };
        _this.updateNavigation = _this.updateNavigation.bind(_this);
        _this.howManyItemsInMenuArray = _this.howManyItemsInMenuArray.bind(_this);
        _this.onResizeThrottled = lodash_1.throttle(_this.onResize, 100);
        _this.state = {
            hasMeasurements: false,
            isMoreMenuOpen: false,
            priorityItems: _this.props.navigationItems,
            moreItems: [],
            availableWidth: null
        };
        return _this;
    }
    PriorityNavigation.prototype.componentDidMount = function () {
        var _this = this;
        //Get width of all items in navigation menu
        this.widthsArray = Array.prototype.slice.call(this.navigation.children).map(function (item) { return item.getBoundingClientRect().width; });
        this.setState({ hasMeasurements: true }, function () { return _this.updateNavigation(_this.props); });
    };
    PriorityNavigation.prototype.componentWillReceiveProps = function (nextProps) {
        this.updateNavigation(nextProps);
    };
    PriorityNavigation.prototype.render = function () {
        var _this = this;
        var _a = this.state, priorityItems = _a.priorityItems, moreItems = _a.moreItems;
        // Do first pass to measure all items
        if (!this.state.hasMeasurements) {
            return React.createElement("nav", { className: this.props.className },
                React.createElement("ul", { ref: this.setNavigation },
                    priorityItems.map(function (item, index) { return React.createElement(RoutedNavItem, { key: "navItem-" + index, item: item, activeItemClassName: _this.props.activeItemClassName }); }),
                    React.createElement(LinksMenuButton_1.LinksMenuButton, { activeItemClassName: this.props.activeItemClassName, label: "More", moreItems: this.state.moreItems })));
        }
        // Measure the container to find out available width
        if (this.state.availableWidth === null) {
            // This div will live in the document for a brief moment, just long
            // enough for it to mount. We then use it to calculate its width, and
            // replace it immediately with the underlying component.
            return React.createElement("div", { style: { flexGrow: 1, width: "100%" }, ref: this.setMeasurementDiv });
        }
        return (React.createElement("nav", { className: this.props.className },
            React.createElement(react_event_listener_1.default, { target: "window", onResize: react_event_listener_1.withOptions(this.onResizeThrottled, { passive: true }) }),
            React.createElement("ul", null,
                priorityItems.map(function (item, index) {
                    return React.createElement(RoutedNavItem, { key: "navItem-" + index, item: item, activeItemClassName: _this.props.activeItemClassName });
                }),
                moreItems.length > 0 && React.createElement(LinksMenuButton_1.LinksMenuButton, { activeItemClassName: this.props.activeItemClassName, icon: this.props.showHamburgerIcon && priorityItems.length === 0 ? "fa fa-bars" : null, label: "More", moreItems: moreItems }))));
    };
    PriorityNavigation.prototype.howManyItemsInMenuArray = function (array, outerWidth, initialWidth, maximumNumberInNav) {
        var total = initialWidth;
        for (var i = 0; i < array.length; i++) {
            if (i > maximumNumberInNav) {
                return maximumNumberInNav;
            }
            total += array[i];
            if (total > outerWidth) {
                return i;
            }
        }
        return array.length;
    };
    PriorityNavigation.prototype.updateNavigation = function (props) {
        if (!(this.state.hasMeasurements && this.state.availableWidth !== null)) {
            return;
        }
        var arrayAmount = this.howManyItemsInMenuArray(this.widthsArray, this.state.availableWidth, this.widthsArray[this.widthsArray.length - 1], props.maxNavigationItems);
        var navItemsCopy = props.navigationItems;
        var priorityItems = navItemsCopy.slice(0, arrayAmount);
        var moreItems = priorityItems.length !== navItemsCopy.length
            ? navItemsCopy.slice(arrayAmount, navItemsCopy.length).filter(function (item) { return !MenuNode_1.isMenuPopper(item); })
            : [];
        this.setState({
            priorityItems: priorityItems,
            moreItems: moreItems
        });
    };
    return PriorityNavigation;
}(BaseComponent_1.BaseComponent));
var NavItem = function (props) {
    var item = props.item;
    if (MenuNode_1.isMenuGroup(item)) {
        var isActive = MenuNode_1.hasActiveDescendants(props.location.pathname, props.match.params.spaceId, item);
        return React.createElement("li", null,
            React.createElement(LinksMenu_1.LinksMenu, { activeItemClassName: isActive ? props.activeItemClassName : null, items: item.children, label: item.label }));
    }
    if (MenuNode_1.isMenuPopper(item)) {
        return React.createElement(MenuPopperLi, { class: isUrlActive_1.isUrlActive(props.location.pathname, props.match.params.spaceId, item.url, false) ? props.activeItemClassName : null, icon: item.icon, text: item.text, title: item.title, onClick: function (el) { return item.onClick(el); } });
    }
    return React.createElement("li", null,
        React.createElement(InternalNavLink_1.default, { activeClassName: props.activeItemClassName, to: item.url, exact: item.exact, title: item.title },
            item.icon,
            React.createElement("span", null, item.text)));
};
var RoutedNavItem = react_router_1.withRouter(NavItem);
var MenuPopperLi = (function (_super) {
    __extends(MenuPopperLi, _super);
    function MenuPopperLi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (event) {
            event.preventDefault();
            _this.props.onClick(_this.anchorEl);
        };
        _this.setRef = function (el) {
            _this.anchorEl = el;
        };
        return _this;
    }
    MenuPopperLi.prototype.render = function () {
        return React.createElement("li", { ref: this.setRef, className: this.props.itemClass },
            React.createElement("a", { className: this.props.class, onClick: this.onClick, href: "#", title: this.props.title }, this.props.icon));
    };
    return MenuPopperLi;
}(React.Component));
exports.default = PriorityNavigation;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PriorityNavigation\\PriorityNavigation.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PriorityNavigation\\PriorityNavigation.tsx"); } } })();

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var MenuNode_1 = __webpack_require__(637);
var material_ui_1 = __webpack_require__(92);
var Popover_1 = __webpack_require__(146);
var React = __webpack_require__(0);
var uiTestClasses_1 = __webpack_require__(77);
var LinksMenu = (function (_super) {
    __extends(LinksMenu, _super);
    function LinksMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.closeMenu = function () {
            _this.setState({ isOpen: false, anchor: null });
        };
        _this.state = { isOpen: false };
        return _this;
    }
    LinksMenu.prototype.render = function () {
        var _this = this;
        return React.createElement("a", { onClick: function (e) { return _this.openMenu(e); }, href: "#", className: this.props.activeItemClassName },
            this.props.icon && React.createElement("em", { className: this.props.icon }),
            !this.props.icon && React.createElement("span", null, this.props.label),
            !this.props.icon && React.createElement("em", { className: "fa fa-caret-down" }),
            React.createElement(Popover_1.default, { className: uiTestClasses_1.linkMenuClassName, open: this.state.isOpen, anchorEl: this.state.anchor, onRequestClose: function () { return _this.closeMenu(); }, anchorOrigin: { horizontal: "right", vertical: "bottom" }, targetOrigin: { horizontal: "right", vertical: "top" } },
                React.createElement(material_ui_1.Menu, null, this.props.items.map(function (item, i) {
                    return React.createElement(MenuNode_1.MenuNodeComponent, { node: item, key: i, onClick: _this.closeMenu });
                }))));
    };
    LinksMenu.prototype.openMenu = function (event) {
        event.preventDefault();
        var anchor = event.currentTarget;
        this.setState({ isOpen: true, anchor: anchor });
    };
    return LinksMenu;
}(React.Component));
exports.LinksMenu = LinksMenu;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LinksMenu\\LinksMenu.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LinksMenu\\LinksMenu.tsx"); } } })();

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(16);
var MenuItem_1 = __webpack_require__(97);
var navigation_arrow_drop_right_1 = __webpack_require__(1437);
var React = __webpack_require__(0);
var react_router_1 = __webpack_require__(69);
var InternalLink_1 = __webpack_require__(42);
var isUrlActive_1 = __webpack_require__(370);
var MenuNodeComponent = function (props) {
    var activeStyle = { color: "#2f93e0" };
    if (isMenuGroup(props.node)) {
        return React.createElement(MenuItem_1.default, { style: hasActiveDescendants(props.location.pathname, props.match.params.spaceId, props.node) ? activeStyle : {}, primaryText: props.node.label, rightIcon: React.createElement(navigation_arrow_drop_right_1.default, null), menuItems: props.node.children.map(function (c, index) { return React.createElement(RoutedMenuNodeComponent, { node: c, key: index, onClick: props.onClick }); }) });
    }
    if (isMenuPopper(props.node)) {
        return React.createElement(InternalLink_1.default, { to: props.node.url },
            React.createElement(MenuItem_1.default, { leftIcon: props.node.icon, onClick: function () { return props.onClick(); } }));
    }
    return React.createElement(InternalLink_1.default, { to: props.node.url },
        React.createElement(MenuItem_1.default, { style: isUrlActive_1.isUrlActive(props.location.pathname, props.match.params.spaceId, props.node.url, props.node.exact) ? activeStyle : {}, primaryText: props.node.text, onClick: function () { return props.onClick(); } }));
};
var RoutedMenuNodeComponent = react_router_1.withRouter(MenuNodeComponent);
exports.MenuNodeComponent = RoutedMenuNodeComponent;
function isMenuGroup(node) {
    return node.children !== undefined;
}
exports.isMenuGroup = isMenuGroup;
function isMenuPopper(node) {
    return node.onClick !== undefined;
}
exports.isMenuPopper = isMenuPopper;
function hasActiveDescendants(pathname, spaceId, group) {
    var allDescendantLinks = function (_) { return lodash_1.flatten(_.children.map(function (c) {
        if (isMenuGroup(c)) {
            return allDescendantLinks(c);
        }
        return [c];
    })); };
    return allDescendantLinks(group).some(function (l) { return isUrlActive_1.isUrlActive(pathname, spaceId, l.url, l.exact); });
}
exports.hasActiveDescendants = hasActiveDescendants;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LinksMenu\\MenuNode.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LinksMenu\\MenuNode.tsx"); } } })();

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(14);
var notificationLocalState = __webpack_require__(237);
var notifications_redux_1 = __webpack_require__(153);
var store_1 = __webpack_require__(147);
var NotificationPoller = (function (_super) {
    __extends(NotificationPoller, _super);
    function NotificationPoller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pollingPeriod = 1000 * 60 * 60 * 6; //6 hours
        _this.timeout = -1;
        return _this;
    }
    NotificationPoller.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationCheck()];
                    case 1:
                        _a.sent();
                        this.tick();
                        return [2 /*return*/];
                }
            });
        });
    };
    NotificationPoller.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.timeout);
    };
    NotificationPoller.prototype.render = function () {
        return null;
    };
    NotificationPoller.prototype.dismissNotification = function () {
        notificationLocalState.clearValue(this.notificationId);
        notifications_redux_1.dismissNotification(store_1.default.dispatch)(this.notificationId);
    };
    NotificationPoller.prototype.raiseNotification = function (notification) {
        notifications_redux_1.raiseNotification(store_1.default.dispatch)(notification);
    };
    NotificationPoller.prototype.tick = function () {
        var _this = this;
        this.timeout = window.setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.unmounted) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.notificationCheck()];
                    case 1:
                        _a.sent();
                        this.tick();
                        return [2 /*return*/];
                }
            });
        }); }, this.pollingPeriod);
    };
    return NotificationPoller;
}(BaseComponent_1.BaseComponent));
exports.NotificationPoller = NotificationPoller;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\NotificationPoller\\NotificationPoller.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\NotificationPoller\\NotificationPoller.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(287);
var index_2 = __webpack_require__(763);
var React = __webpack_require__(0);
var DataCube_1 = __webpack_require__(218);
var BaseComponent_1 = __webpack_require__(14);
var index_3 = __webpack_require__(778);
var DashboardDataSource_1 = __webpack_require__(781);
var AreaTitle_1 = __webpack_require__(120);
var Button_1 = __webpack_require__(51);
var index_4 = __webpack_require__(169);
var styles = __webpack_require__(1580);
var GettingStartedDetails_1 = __webpack_require__(627);
var form_1 = __webpack_require__(15);
var cn = __webpack_require__(19);
var lodash_1 = __webpack_require__(16);
var MobileDetect = __webpack_require__(443);
var routeLinks_1 = __webpack_require__(20);
var QueryStringFilters_1 = __webpack_require__(726);
var defaultFilter = {
    projectName: "",
    projectGroupId: ""
};
var DashboardQueryStringFilters = (function (_super) {
    __extends(DashboardQueryStringFilters, _super);
    function DashboardQueryStringFilters() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DashboardQueryStringFilters;
}(QueryStringFilters_1.QueryStringFilters));
var DashboardOverview = (function (_super) {
    __extends(DashboardOverview, _super);
    function DashboardOverview(props) {
        var _this = _super.call(this, props) || this;
        _this.renderDataSource = function (dataSource) {
            if (dataSource.hasInitialLoaded && Object.keys(dataSource.cube.projectIndex).length === 0) {
                return React.createElement(GettingStartedDetails_1.GettingStartedDetails, null);
            }
            return React.createElement(index_4.default, { flatStyle: true, busy: dataSource.busy, errors: dataSource.errors, className: styles.paper }, dataSource.hasInitialLoaded && _this.showDashboard(dataSource));
        };
        _this.handleGroupChange = function (projectGroupId) {
            _this.setState(function (prev) { return ({ filter: __assign({}, prev.filter, { projectGroupId: projectGroupId }) }); });
        };
        _this.handleNameChange = function (projectName) {
            _this.setState(function (prev) { return ({ filter: __assign({}, prev.filter, { projectName: projectName }) }); });
        };
        _this.createDashboardFilters = function () {
            var filter = _this.state.filter;
            var groupFilters = filter.projectGroupId !== "" ? (_a = {}, _a[filter.projectGroupId] = true, _a) : null;
            var projectNameFilters = filter.projectName !== "" ? (_b = {}, _b[filter.projectName] = true, _b) : null;
            return _c = {
                    rowDimension: DataCube_1.DimensionTypes.Project,
                    columnDimension: DataCube_1.DimensionTypes.Environment,
                    groupBy: DataCube_1.DimensionTypes.ProjectGroup
                },
                _c[DataCube_1.DimensionTypes.ProjectGroup] = groupFilters,
                _c[DataCube_1.DimensionTypes.ProjectName] = projectNameFilters,
                _c;
            var _a, _b, _c;
        };
        _this.handleProjectCountChange = function (matchCount) {
            // don't re-render is count is the same. Easier to check
            // here than shouldComponentUpdate
            if (matchCount !== _this.state.matchCount) {
                _this.setState({ matchCount: matchCount });
            }
        };
        _this.state = {
            filter: defaultFilter,
            matchCount: 0
        };
        return _this;
    }
    DashboardOverview.prototype.showDashboard = function (dashboardData) {
        var cube = dashboardData.cube;
        var groups = lodash_1.sortBy(cube.projectGroupIndex, function (g) { return g.Name.toLowerCase(); }).map(function (g) { return ({ value: g.Id, text: g.Name }); });
        var hasFilter = !lodash_1.isEqual(defaultFilter, this.state.filter);
        // Disable autoFocus filtering for mobile (Android has issues and is annoying users).
        var md = new MobileDetect(window.navigator.userAgent);
        var autoFocus = md.isPhoneSized() ? false : true;
        return [
            React.createElement("div", { className: styles.filterHeaderContainer, key: "A", role: "search" },
                React.createElement("div", { className: styles.filterFieldContainer },
                    React.createElement(index_2.default, { className: styles.filter },
                        React.createElement("div", { className: styles.filterField },
                            React.createElement(form_1.Select, { label: "Project group", items: groups, onChange: this.handleGroupChange, value: this.state.filter.projectGroupId, allowClear: true })),
                        React.createElement("div", { className: styles.filterField },
                            React.createElement(index_1.default, { hintText: "Project name", value: this.state.filter.projectName, onChange: this.handleNameChange, autoFocus: autoFocus, fullWidth: true })),
                        this.renderWarning(this.state.matchCount, dashboardData.projectLimit, hasFilter)))),
            React.createElement(index_3.default, { key: "B", cube: dashboardData.cube, filters: this.createDashboardFilters(), maximumRows: dashboardData.projectLimit, showDeploymentCounts: true, onProjectCountChanged: this.handleProjectCountChange })
        ];
    };
    DashboardOverview.prototype.render = function () {
        var _this = this;
        return React.createElement("main", { className: styles.container },
            React.createElement(DashboardQueryStringFilters, { filter: this.state.filter, getQuery: getQueryFromFilters, getFilter: getFilter, onFilterChange: function (filter) { return _this.setState({ filter: filter }); } }),
            React.createElement(AreaTitle_1.default, { link: routeLinks_1.default.root, title: "Dashboard" },
                React.createElement(Button_1.NavigationButton, { label: "Configure", href: routeLinks_1.default.dashboard.configure })),
            React.createElement(DashboardDataSource_1.default, { filters: this.createDashboardFilters(), render: this.renderDataSource }));
    };
    DashboardOverview.prototype.renderWarning = function (matchCount, projectLimit, hasFilter) {
        var hasLimit = projectLimit !== null && projectLimit !== undefined && projectLimit > 0;
        if (hasLimit && matchCount > projectLimit) {
            return React.createElement("span", { className: cn(styles.help, styles.alert) },
                "Only the first ",
                projectLimit,
                " projects and any projects with failing deployments are shown (",
                matchCount,
                " total)");
        }
        if (hasFilter && matchCount !== 1) {
            return React.createElement("span", { className: cn(styles.help, styles.info) },
                matchCount,
                " projects match");
        }
        if (hasFilter && matchCount === 1) {
            return React.createElement("span", { className: cn(styles.help, styles.info) }, "1 project matches");
        }
        return null;
    };
    return DashboardOverview;
}(BaseComponent_1.BaseComponent));
exports.default = DashboardOverview;
function getQueryFromFilters(filter) {
    return {
        projectGroupId: filter.projectGroupId,
        projectName: filter.projectName
    };
}
function getFilter(query) {
    return {
        projectGroupId: query.projectGroupId || "",
        projectName: query.projectName || ""
    };
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardOverview\\DashboardOverview.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardOverview\\DashboardOverview.tsx"); } } })();

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1455);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var InternalLink_1 = __webpack_require__(42);
var styles = __webpack_require__(1471);
var Breadcrumb = function (props) {
    return props.title
        ? React.createElement("div", { className: styles.breadcrumb }, props.path
            ? React.createElement(InternalLink_1.default, { className: props.isAreaLevelBreadcrumb ? styles.breadcrumbLink : null, to: props.path }, props.title)
            : React.createElement("div", null, props.title))
        : null;
};
exports.default = Breadcrumb;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Breadcrumb\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Breadcrumb\\index.tsx"); } } })();

/***/ }),
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(139);
var styles = __webpack_require__(116);
var FormSectionBase_1 = __webpack_require__(264);
var uiTestClasses_1 = __webpack_require__(77);
var FormSection = (function (_super) {
    __extends(FormSection, _super);
    function FormSection(props) {
        return _super.call(this, props) || this;
    }
    FormSection.prototype.render = function () {
        return React.createElement(Card_1.Card, { className: uiTestClasses_1.formSectionClass + " " + styles.formSection, expanded: true },
            React.createElement(Card_1.CardTitle, { title: this.title(this.props.title, this.help(this.props.help)) }),
            this.body(styles.cardMedia, false),
            this.moreInformation());
    };
    return FormSection;
}(FormSectionBase_1.FormSectionBase));
exports.default = FormSection;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\FormSection.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\FormSection.tsx"); } } })();

/***/ }),
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var FocustListItem_1 = __webpack_require__(624);
var react_virtualized_1 = __webpack_require__(438);
var styles = __webpack_require__(1637);
var fontWeights_1 = __webpack_require__(76);
function VirtualListWithKeyboard() {
    var VirtualListWithKeyboardInternal = (function (_super) {
        __extends(VirtualListWithKeyboardInternal, _super);
        function VirtualListWithKeyboardInternal(props) {
            var _this = _super.call(this, props) || this;
            _this.unmounted = false;
            _this.onListKeyDown = function (event, filteredList) {
                if (event.key === "ArrowDown" || (!event.shiftKey && event.key === "Tab")) {
                    var lastIndex_1 = filteredList.length - 1;
                    _this.setState(function (prevState) {
                        return { focusedRow: prevState.focusedRow <= lastIndex_1 ? prevState.focusedRow + 1 : lastIndex_1 };
                    });
                    event.preventDefault();
                }
                if (event.key === "ArrowUp" || (event.shiftKey && event.key === "Tab")) {
                    if (_this.state.focusedRow === 0) {
                        if (_this.props.onBlur) {
                            _this.props.onBlur();
                        }
                        _this.setState({ focusedRow: -1 });
                    }
                    else {
                        _this.setState(function (prevState) {
                            return { focusedRow: prevState.focusedRow > 0 ? prevState.focusedRow - 1 : 0 };
                        });
                    }
                    event.preventDefault();
                }
            };
            _this.rowHeight = function (params) {
                return _this.cellMeasurerCache.rowHeight(params);
            };
            _this.renderRow = function (filteredList, key, index, isVisible, style, parent) {
                var item = filteredList[index];
                var primaryText = null;
                var secondaryText = null;
                if (item.Id) {
                    var result = _this.props.renderItem(item);
                    primaryText = result.primaryText;
                    secondaryText = result.secondaryText;
                }
                else {
                    primaryText = _this.props.addNewTemplate();
                }
                return React.createElement(react_virtualized_1.CellMeasurer, { cache: _this.cellMeasurerCache, columnIndex: 0, key: key, parent: parent, rowIndex: index },
                    React.createElement("span", { style: style },
                        React.createElement(FocustListItem_1.default, { isFocused: index === _this.state.focusedRow, style: {}, primaryText: primaryText, secondaryText: secondaryText, onRequestClose: function () {
                                _this.props.onSelected(item.Id);
                            } })));
            };
            _this.state = {
                focusedRow: -1,
                containerHeight: VirtualListWithKeyboardInternal.defaultRowSize
            };
            _this.cellMeasurerCache = new react_virtualized_1.CellMeasurerCache({
                minHeight: VirtualListWithKeyboardInternal.defaultRowSize,
                defaultHeight: VirtualListWithKeyboardInternal.defaultRowSize,
                fixedWidth: true
            });
            return _this;
        }
        VirtualListWithKeyboardInternal.prototype.focus = function () {
            if (this.props.items.length > 0) {
                this.virtualList.scrollToRow(0);
                this.setState({
                    focusedRow: 0
                });
            }
        };
        VirtualListWithKeyboardInternal.prototype.componentDidMount = function () {
            this.props.multiSelectRef(this);
        };
        VirtualListWithKeyboardInternal.prototype.componentWillUnmount = function () {
            this.unmounted = true;
            this.props.multiSelectRef(null);
        };
        VirtualListWithKeyboardInternal.prototype.render = function () {
            var _this = this;
            setTimeout(function () { return _this.adjustContainerHeight(); }, 0);
            return React.createElement("div", { onKeyDown: function (e) { return _this.onListKeyDown(e, _this.props.items); } },
                this.props.items.length === 0 && React.createElement("div", { className: styles.empty }, "No results found"),
                React.createElement("div", { className: styles.menuContainer },
                    React.createElement(react_virtualized_1.AutoSizer, { disableHeight: true }, function (_a) {
                        var width = _a.width;
                        return React.createElement(react_virtualized_1.List, { ref: function (el) { return _this.virtualList = el; }, tabIndex: -1, height: _this.state.containerHeight, rowCount: _this.props.items.length, estimatedRowSize: VirtualListWithKeyboardInternal.defaultRowSize, deferredMeasurementCache: _this.cellMeasurerCache, rowHeight: _this.rowHeight, rowRenderer: function (_a) {
                                var index = _a.index, key = _a.key, isVisible = _a.isVisible, style = _a.style, parent = _a.parent;
                                return _this.renderRow(_this.props.items, key, index, isVisible, style, parent);
                            }, width: width });
                    })));
        };
        VirtualListWithKeyboardInternal.prototype.adjustContainerHeight = function () {
            if (this.unmounted || this.props.items.length === 0) {
                return;
            }
            var height = VirtualListWithKeyboardInternal.defaultRowSize * this.props.items.length;
            var maxHeightInPx = fontWeights_1.baseSizeInPx * this.props.maxHeightInRem;
            if (height > maxHeightInPx) {
                height = maxHeightInPx;
            }
            else {
                height = 0;
                // Measure the first 10 to get a more accurate height
                for (var index = 0; index < this.props.items.length; index++) {
                    height += this.cellMeasurerCache.rowHeight({ index: index });
                    if (height > maxHeightInPx) {
                        height = maxHeightInPx;
                        break;
                    }
                }
            }
            if (this.state.containerHeight === height) {
                return;
            }
            this.setState({ containerHeight: height });
            this.props.onResized();
        };
        VirtualListWithKeyboardInternal.defaultProps = {
            maxHeightInRem: 25
        };
        VirtualListWithKeyboardInternal.defaultRowSize = 48;
        return VirtualListWithKeyboardInternal;
    }(React.Component));
    return VirtualListWithKeyboardInternal;
}
exports.default = VirtualListWithKeyboard;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\VirtualListWithKeyboard\\VirtualListWithKeyboard.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\VirtualListWithKeyboard\\VirtualListWithKeyboard.tsx"); } } })();

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var material_ui_1 = __webpack_require__(92);
var colors_1 = __webpack_require__(32);
var BorderedListItem = function (props) {
    return React.createElement(material_ui_1.ListItem, __assign({ style: {
            borderRadius: "0.125rem",
            border: "0.0625rem solid",
            borderColor: colors_1.divider,
            background: colors_1.hover,
            marginBottom: "0.3125rem"
        } }, props), props.children);
};
exports.default = BorderedListItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BorderedListItem\\BorderedListItem.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BorderedListItem\\BorderedListItem.tsx"); } } })();

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1672);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(211);
var index_2 = __webpack_require__(51);
var styles = __webpack_require__(386);
var BusyIndicator_1 = __webpack_require__(98);
var NumberedPagingBar = function (props) {
    if (props.totalItems <= props.pageSize) {
        return null;
    }
    var currentPageIndex = props.currentPageIndex;
    var totalPages = props.totalItems === 0 ? 1 : Math.ceil(props.totalItems / props.pageSize);
    var pages = [];
    function addPage(i, text) {
        var page = {
            index: i,
            isActive: currentPageIndex === i,
            skip: i * props.pageSize,
            number: text
        };
        pages.push(page);
    }
    var pagesToShow = 16;
    var halfPagesToShow = 8;
    var isStartCollapsed = false;
    var isEndCollapsed = false;
    if (totalPages > 0) {
        addPage(0, "<<");
    }
    for (var i = 0; i < totalPages; i++) {
        var skip = !(totalPages < pagesToShow || ((i - currentPageIndex) < halfPagesToShow && (i - currentPageIndex) > -halfPagesToShow));
        if (skip && i < currentPageIndex && !isStartCollapsed) {
            addPage(Math.max(currentPageIndex - pagesToShow, 0), index_1.default.ellipsis);
            isStartCollapsed = true;
        }
        if (!skip) {
            addPage(i, String(i + 1));
        }
        if (skip && i > currentPageIndex && !isEndCollapsed) {
            addPage(Math.min(currentPageIndex + pagesToShow, totalPages - 1), index_1.default.ellipsis);
            isEndCollapsed = true;
        }
    }
    if (totalPages > 0) {
        addPage(totalPages - 1, ">>");
    }
    var pagingComponents = pages.map(function (page, i) {
        return React.createElement(index_2.PagingControlButton, { key: i, label: page.number, isActive: page.isActive, onPageSelected: function (e) { return props.onPageSelected(page.skip, page.index); } });
    });
    var classes = props.loadingMore ? styles.pagingControlContainer + " " + styles.disablePagingEvents : styles.pagingControlContainer;
    return totalPages > 1 &&
        React.createElement("div", { className: classes },
            React.createElement("div", null,
                pagingComponents,
                " "),
            props.loadingMore && React.createElement(BusyIndicator_1.default, { show: true }));
};
NumberedPagingBar.displayName = "NumberedPagingBar";
exports.default = NumberedPagingBar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PagingBaseComponent\\NumberedPagingBar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PagingBaseComponent\\NumberedPagingBar.tsx"); } } })();

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1719);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./empty.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./empty.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getSkippedState(phase, status) {
    return phase.IsOptionalPhase && !!status.progress[phase.Name] && status.progress[phase.Name] !== "Blocked" && status.progress[phase.Name] !== "Complete"
        && status.progress[phase.Name] !== "Current" && !status.deployed[getSingleDeploymentTarget(phase)];
}
exports.getSkippedState = getSkippedState;
function getSingleDeploymentTarget(phase) {
    if (phase.AutomaticDeploymentTargets.length > 0) {
        return phase.AutomaticDeploymentTargets[0];
    }
    else {
        return phase.OptionalDeploymentTargets[0];
    }
}
exports.getSingleDeploymentTarget = getSingleDeploymentTarget;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\PhaseHelper\\phaseHelpers.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\PhaseHelper\\phaseHelpers.ts"); } } })();

/***/ }),
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(16);
var Targets = (function (_super) {
    __extends(Targets, _super);
    function Targets() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Targets.prototype.render = function () {
        var targets = this.props.targets;
        return React.createElement("span", null, lodash_1.flatten(targets.map(function (target, index) {
            var nodes = [target];
            if (index === targets.length - 1) {
                return nodes;
            }
            nodes.push(React.createElement("span", { key: targets.length + index }, index === targets.length - 2 ? " and " : ", "));
            return nodes;
        })));
    };
    return Targets;
}(React.Component));
exports.Targets = Targets;
exports.default = Targets;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\Targets.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\Targets.tsx"); } } })();

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "step-rolling.a137e7e36fc6c412b05b522fb2a7bef2.hashedasset.svg";

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var withProjectVariables_1 = __webpack_require__(1863);
var withValidateOnChange_1 = __webpack_require__(1866);
var resources_1 = __webpack_require__(26);
var variableResource_1 = __webpack_require__(401);
var recompose_1 = __webpack_require__(362);
var VariableSelect_1 = __webpack_require__(1867);
exports.VariableSelect = VariableSelect_1.default;
var BoundField_1 = __webpack_require__(95);
var enhance = recompose_1.compose(withProjectVariables_1.default({
    controlType: resources_1.ControlType.AmazonWebServicesAccount,
    variableType: variableResource_1.VariableType.AmazonWebServicesAccount
}), withValidateOnChange_1.default());
exports.enhance = enhance;
var enhancedComponent = enhance(VariableSelect_1.default);
exports.default = enhancedComponent;
exports.BoundAccountVariableSelect = BoundField_1.withBoundField(enhancedComponent);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\AccountSelect\\AccountVariableSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\AccountSelect\\AccountVariableSelect.tsx"); } } })();

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var IconButtonList_1 = __webpack_require__(109);
var InputWithActions_1 = __webpack_require__(383);
var Select_1 = __webpack_require__(41);
var index_1 = __webpack_require__(254);
var IconButton_1 = __webpack_require__(56);
var routeLinks_1 = __webpack_require__(20);
var Busy = function (_a) {
    var isBusy = _a.isBusy, children = _a.children;
    return isBusy ? React.createElement(index_1.default, { show: true, inline: true }) : React.Children.only(children);
};
var gotoProjectVariables = function (projectId) {
    return function () { return window.open("#" + routeLinks_1.default.project(projectId).variables.root, "_blank"); };
};
var VariableSelect = function (_a) {
    var onChange = _a.onChange, onRequestRefresh = _a.onRequestRefresh, error = _a.error, isRefreshing = _a.isRefreshing, validation = _a.validation, variables = _a.variables, projectId = _a.projectId, otherProps = __rest(_a, ["onChange", "onRequestRefresh", "error", "isRefreshing", "validation", "variables", "projectId"]);
    return (React.createElement(Busy, { isBusy: isRefreshing },
        React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.default, __assign({ label: "Select Account variable" }, otherProps, { allowFilter: true, error: error || validation.error, onChange: onChange, items: variables.map(function (v) { return ({ value: v, text: v }); }) })), actions: React.createElement(IconButtonList_1.default, { buttons: [
                    React.createElement(Busy, { isBusy: isRefreshing },
                        React.createElement(IconButton_1.default, { toolTipContent: "Refresh", icon: IconButton_1.Icon.Refresh, onClick: onRequestRefresh })),
                    React.createElement(IconButton_1.default, { toolTipContent: "Add", icon: IconButton_1.Icon.Add, onClick: gotoProjectVariables(projectId) })
                ] }) })));
};
exports.VariableSelect = VariableSelect;
exports.default = VariableSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\VariableSelect\\VariableSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\VariableSelect\\VariableSelect.tsx"); } } })();

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function selectOptionsToItems(selectOptions) {
    var options = selectOptions || "";
    return options.split("\n")
        .filter(function (line) { return line.length !== 0; })
        .map(function (line) { return line.split("|"); })
        .map(function (keyValuePair) { return keyValuePair.length > 1 ? keyValuePair : [keyValuePair[0], keyValuePair[0]]; })
        .map(function (keyValuePair) { return ({
        value: keyValuePair[0].trim(),
        text: keyValuePair[1].trim()
    }); });
}
exports.default = selectOptionsToItems;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Select\\Options.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Select\\Options.tsx"); } } })();

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var form_1 = __webpack_require__(15);
var deploymentStepResource_1 = __webpack_require__(236);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var Callout_1 = __webpack_require__(59);
var ExternalLink_1 = __webpack_require__(29);
var StartConditionText = (_a = {},
    _a[deploymentStepResource_1.StartTrigger.StartAfterPrevious] = "Wait for the previous step to complete, then start",
    _a[deploymentStepResource_1.StartTrigger.StartWithPrevious] = "Run in parallel with the previous step",
    _a);
var StartTriggerRadioButtonGroup = (function (_super) {
    __extends(StartTriggerRadioButtonGroup, _super);
    function StartTriggerRadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StartTriggerRadioButtonGroup;
}(RadioButtonGroup_1.default));
var StartTriggerExpandableFormSection = (function (_super) {
    __extends(StartTriggerExpandableFormSection, _super);
    function StartTriggerExpandableFormSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StartTriggerExpandableFormSection.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.startTrigger !== this.props.startTrigger;
    };
    StartTriggerExpandableFormSection.prototype.render = function () {
        return React.createElement(form_1.ExpandableFormSection, { title: "Start Trigger", help: "Control whether this step waits for the previous step to complete, or runs in parallel with it.", summary: this.props.startTrigger === deploymentStepResource_1.StartTrigger.StartWithPrevious
                ? form_1.Summary.summary(StartConditionText[this.props.startTrigger])
                : form_1.Summary.default(StartConditionText[this.props.startTrigger]), errorKey: "starttrigger" },
            React.createElement(StartTriggerRadioButtonGroup, { value: this.props.startTrigger, onChange: this.props.onChange }, [deploymentStepResource_1.StartTrigger.StartWithPrevious, deploymentStepResource_1.StartTrigger.StartAfterPrevious]
                .map(function (rc) { return React.createElement(RadioButton_1.default, { value: rc, label: StartConditionText[rc], key: rc }); })),
            (this.props.startTrigger === deploymentStepResource_1.StartTrigger.StartWithPrevious) &&
                React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning, title: "Warning" },
                    "Please note that even with this setting, each target (excluding Azure endpoints) will still be limited to only performing a single deployment activity at once for safety reasons. See how to ",
                    React.createElement(ExternalLink_1.default, { href: "MultipleProcessesOnTentacle" }, "override this behavior"),
                    "."));
    };
    return StartTriggerExpandableFormSection;
}(React.Component));
exports.default = StartTriggerExpandableFormSection;
var _a;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\StartTriggerExpander.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\StartTriggerExpander.tsx"); } } })();

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var deploymentStepResource_1 = __webpack_require__(236);
var ExternalLink_1 = __webpack_require__(29);
var form_1 = __webpack_require__(15);
var form_2 = __webpack_require__(15);
var RadioButton_1 = __webpack_require__(36);
var RadioButtonGroup_1 = __webpack_require__(33);
var Text_1 = __webpack_require__(17);
var React = __webpack_require__(0);
var RunConditionRadioButtonGroup = (function (_super) {
    __extends(RunConditionRadioButtonGroup, _super);
    function RunConditionRadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RunConditionRadioButtonGroup;
}(RadioButtonGroup_1.default));
var RunConditionText = (_a = {},
    _a[deploymentStepResource_1.RunCondition.Success] = "Success: only run when previous steps succeed",
    _a[deploymentStepResource_1.RunCondition.Failure] = "Failure: only run when a previous step failed",
    _a[deploymentStepResource_1.RunCondition.Always] = "Always run",
    _a[deploymentStepResource_1.RunCondition.Variable] = "Variable: only run when the variable expression is true",
    _a);
var RunTriggerExpander = (function (_super) {
    __extends(RunTriggerExpander, _super);
    function RunTriggerExpander() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RunTriggerExpander.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.condition !== this.props.condition
            || nextProps.variableExpression !== this.props.variableExpression;
    };
    RunTriggerExpander.prototype.render = function () {
        var conditions = (this.props.isFirstStep) ?
            [deploymentStepResource_1.RunCondition.Success, deploymentStepResource_1.RunCondition.Always, deploymentStepResource_1.RunCondition.Variable] :
            [deploymentStepResource_1.RunCondition.Success, deploymentStepResource_1.RunCondition.Failure, deploymentStepResource_1.RunCondition.Always, deploymentStepResource_1.RunCondition.Variable];
        return React.createElement(form_2.ExpandableFormSection, { title: "Run Condition", help: "Limit when this step runs by setting a condition.", errorKey: "runcondition", summary: this.props.condition === deploymentStepResource_1.RunCondition.Success ?
                form_2.Summary.default(RunConditionText[this.props.condition]) :
                form_2.Summary.summary(RunConditionText[this.props.condition]) },
            React.createElement(RunConditionRadioButtonGroup, { value: this.props.condition, onChange: this.props.onConditionChange }, conditions.map(function (rc) { return React.createElement(RadioButton_1.default, { value: rc, label: RunConditionText[rc], key: rc }); })),
            this.props.condition === deploymentStepResource_1.RunCondition.Variable && React.createElement("div", null,
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Variable expression", value: this.props.variableExpression, onChange: this.props.onVariableExpressionChange }),
                React.createElement(form_1.Note, null,
                    "Limit when this step runs by setting a boolean variable expression that will be evaluated at run-time. See the ",
                    React.createElement(ExternalLink_1.default, { href: "VariableSubstitutionSyntax" }, "Variable Substitution Syntax"),
                    " documentation for examples.")));
    };
    return RunTriggerExpander;
}(React.Component));
exports.default = RunTriggerExpander;
var _a;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\RunTriggerExpander.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\RunTriggerExpander.tsx"); } } })();

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var form_1 = __webpack_require__(15);
var Text_1 = __webpack_require__(17);
var styles = __webpack_require__(207);
var MaxParallelism = function (props) {
    return React.createElement("div", null,
        React.createElement(Text_1.VariableLookupText, { localNames: [], projectId: props.projectId, value: props.value, onChange: props.onChange, label: "Window size" }),
        React.createElement(form_1.Note, null,
            React.createElement("p", null, "When deploying to multiple deployment targets, you can configure the rolling window size to use. For example:"),
            React.createElement("ul", { className: styles.noteList },
                React.createElement("li", null, "A window size of 1 will deploy to a single deployment target at a time. Octopus will wait for the step to finish running on deployment target A before starting on deployment target B."),
                React.createElement("li", null, "A window size of 3 will deploy to three deployment targets at a time. Octopus will wait for the step to finish running on deployment targets A, B or C before starting on deployment target D.")),
            React.createElement("p", null, "Omitting the window size will run the step against all deployment targets at once.")));
};
exports.default = MaxParallelism;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\MaxParallelism.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\MaxParallelism.tsx"); } } })();

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExtensionManager = (function () {
    function ExtensionManager() {
        this.extensions = {};
    }
    ExtensionManager.prototype.getExtension = function (name, type) {
        return this.extensions && this.extensions[type]
            ? this.extensions[type][name]
            : null;
    };
    ExtensionManager.prototype.registerExtension = function (name, type, extension) {
        if (!this.extensions[type]) {
            this.extensions[type] = { name: name, extension: extension };
        }
        this.extensions[type][name] = extension;
    };
    return ExtensionManager;
}());
exports.ExtensionManager = ExtensionManager;
var extensionManager = new ExtensionManager();
exports.default = extensionManager;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\extensionsManager.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\extensionsManager.ts"); } } })();

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "octopus.9edfb27b59f3259a3ec6501e41aa6748.hashedasset.svg";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Theme_1 = __webpack_require__(1919);
exports.default = Theme_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Theme\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Theme\\index.ts"); } } })();

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(16);
var ParameterDataType;
(function (ParameterDataType) {
    ParameterDataType["string"] = "string";
    ParameterDataType["secureString"] = "securestring";
    ParameterDataType["int"] = "int";
    ParameterDataType["bool"] = "bool";
    ParameterDataType["object"] = "object";
    ParameterDataType["secureObject"] = "secureobject";
    ParameterDataType["array"] = "array";
})(ParameterDataType = exports.ParameterDataType || (exports.ParameterDataType = {}));
var Source;
(function (Source) {
    Source["octopus"] = "octopus";
    Source["azureKeyVault"] = "azureKeyVault";
})(Source = exports.Source || (exports.Source = {}));
var ParameterValues = (function () {
    function ParameterValues() {
    }
    return ParameterValues;
}());
exports.ParameterValues = ParameterValues;
var AzureTemplateHelper = (function () {
    function AzureTemplateHelper() {
    }
    //Technically speaking type names should follow camelCase naming convention as per https://azure.microsoft.com/en-us/documentation/articles/resource-group-authoring-templates/
    //but even Visual Studio project does not follow it.
    AzureTemplateHelper.normalizeType = function (type) {
        return type.toLowerCase();
    };
    AzureTemplateHelper.extractParameters = function (templateFile, parametersFile) {
        if (parametersFile === void 0) { parametersFile = ""; }
        var parameterValues = new ParameterValues();
        var errors = [];
        var template;
        var parameters;
        try {
            template = JSON.parse(templateFile);
            parameters = (parametersFile) ? JSON.parse(parametersFile) : {};
            if (template.parameters) {
                _.each(template.parameters, function (parameter, parameterName) {
                    var existingParameterValue = parameters[parameterName];
                    var parameterType = AzureTemplateHelper.normalizeType(parameter.type);
                    var parameterValue = __assign({}, parameter, { type: parameterType, description: (parameter.metadata !== undefined) ? parameter.metadata.description : undefined, value: existingParameterValue
                            ? AzureTemplateHelper.getParameterValue(parameters[parameterName].value)
                            : parameter.defaultValue
                                ? parameter.defaultValue
                                : (parameterType === ParameterDataType.array)
                                    ? "[]"
                                    : (parameterType === ParameterDataType.object)
                                        ? "{}"
                                        : undefined, source: Source.octopus });
                    if (existingParameterValue && existingParameterValue.reference) {
                        parameterValue.keyVaultId = existingParameterValue.reference.keyVault.id;
                        parameterValue.keyVaultSecretName = existingParameterValue.reference.secretName;
                        parameterValue.source = Source.azureKeyVault;
                    }
                    parameterValues[parameterName] = parameterValue;
                });
            }
        }
        catch (e) {
            if (template) {
                // error with parametersFile
                errors.push("The parameter file is not valid JSON");
            }
            else {
                errors.push("The template file is not valid JSON");
            }
        }
        return { value: parameterValues, errors: errors };
    };
    AzureTemplateHelper.exportParameters = function (parameters) {
        var armParams = {};
        var invalidTemplateParameters = [];
        if (parameters) {
            _.each(parameters, function (paramValue, paramName) {
                var armParameterValue = {};
                if (paramValue.source !== Source.azureKeyVault) {
                    if (AzureTemplateHelper.shouldJsonParse(paramValue.type)) {
                        try {
                            armParameterValue.value = JSON.parse(paramValue.value);
                        }
                        catch (e) {
                            //Logger.error("Failed to parse '" + paramValue.value + "' as valid JSON.");
                            invalidTemplateParameters.push(paramName);
                            armParameterValue.value = paramValue.value; // Leave this as what the user typed in ... give them the opportunity to fix it.
                        }
                    }
                    else {
                        armParameterValue.value = paramValue.value;
                    }
                }
                else {
                    armParameterValue.reference = {
                        keyVault: {
                            id: paramValue.keyVaultId
                        },
                        secretName: paramValue.keyVaultSecretName
                    };
                }
                armParams[paramName] = armParameterValue;
            });
        }
        return { value: JSON.stringify(armParams), errors: invalidTemplateParameters };
    };
    AzureTemplateHelper.getParameterValue = function (value) {
        if (_.isObject(value)) {
            return JSON.stringify(value, undefined, 4);
        }
        else {
            return value;
        }
    };
    //Parameters that are of type 'array', 'object' or 'secureObject' needs to be parsed as JSON,
    //otherwise the template will not be deemed valid as they will be used as a string and the deployment
    //will fail with an error message similar to the below:
    //'Hyak.Common.CloudException: InvalidTemplate: Deployment template validation failed:
    //'The provided value for the template parameter '<parameterName>' at line 'x' and column 'y' is not valid.'.
    AzureTemplateHelper.shouldJsonParse = function (type) {
        return type === ParameterDataType.array || type === ParameterDataType.object || type === ParameterDataType.secureObject;
    };
    return AzureTemplateHelper;
}());
exports.AzureTemplateHelper = AzureTemplateHelper;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureTemplateHelper.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureTemplateHelper.ts"); } } })();

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Callout_1 = __webpack_require__(81);
var ExternalLink_1 = __webpack_require__(29);
var AzureServiceFabricSdkRequiredInfo = function (props) {
    return React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
        "The ",
        React.createElement(ExternalLink_1.default, { href: "ServiceFabricSdkDownload" }, "Service Fabric SDK"),
        " must be installed on the ",
        React.createElement("strong", null, "Octopus Server"),
        " for this step.  Additional information about this step can be found in the ",
        React.createElement(ExternalLink_1.default, { href: "ServiceFabricDeployingApps" }, "Deploying to Service Fabric documentation"),
        ".");
};
exports.default = AzureServiceFabricSdkRequiredInfo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureServiceFabricApp\\AzureServiceFabricSdkRequiredInfo.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureServiceFabricApp\\AzureServiceFabricSdkRequiredInfo.tsx"); } } })();

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var Note_1 = __webpack_require__(22);
var ExpandableFormSection_1 = __webpack_require__(44);
var Text_1 = __webpack_require__(17);
var Summary_1 = __webpack_require__(70);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var ExternalLink_1 = __webpack_require__(29);
var CertificateVariableSelect_1 = __webpack_require__(165);
var Sensitive_1 = __webpack_require__(82);
var SecurityMode;
(function (SecurityMode) {
    SecurityMode["Unsecure"] = "Unsecure";
    SecurityMode["SecureClientCertificate"] = "SecureClientCertificate";
    SecurityMode["SecureAzureAD"] = "SecureAzureAD";
})(SecurityMode = exports.SecurityMode || (exports.SecurityMode = {}));
var AADCredentialType;
(function (AADCredentialType) {
    AADCredentialType["ClientCredential"] = "ClientCredential";
    AADCredentialType["UserCredential"] = "UserCredential";
})(AADCredentialType = exports.AADCredentialType || (exports.AADCredentialType = {}));
var AzureServiceFabricAccountSelector = (function (_super) {
    __extends(AzureServiceFabricAccountSelector, _super);
    function AzureServiceFabricAccountSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null
        };
        return _this;
    }
    AzureServiceFabricAccountSelector.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.projectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        project = _a;
                        this.setState({
                            project: project
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AzureServiceFabricAccountSelector.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var securityModeErrorKey = "Octopus.Action.ServiceFabric.SecurityMode|"
            + "Octopus.Action.ServiceFabric.ServerCertThumbprint|"
            + "Octopus.Action.ServiceFabric.ClientCertVariable|"
            + "Octopus.Action.ServiceFabric.AadClientCredentialSecret";
        return React.createElement("div", null,
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.ConnectionEndpoint", title: "Connection Endpoint", summary: this.endpointSummary(), help: "Enter the connection endpoint of your Service Fabric cluster." },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.ConnectionEndpoint"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.ConnectionEndpoint"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.ConnectionEndpoint"), label: "Connection endpoint" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: securityModeErrorKey, title: "Security Mode", summary: this.securityModeSummary(), help: "Select the security mode use to connect to your Service Fabric cluster." },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: SecurityMode.Unsecure, value: properties["Octopus.Action.ServiceFabric.SecurityMode"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.SecurityMode"] = x, _a));
                        var _a;
                    }, label: "Security mode" },
                    React.createElement(RadioButton_1.default, { value: SecurityMode.Unsecure, label: "Unsecure", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: SecurityMode.SecureClientCertificate, label: "Secure Client Certificate" }),
                    React.createElement(Note_1.default, null,
                        "To learn about client certificate authentication, please see the ",
                        React.createElement(ExternalLink_1.default, { href: "ServiceFabricDeployingAppsAuthClientCerts" }, "Connecting Securely with Client Certificates documentation"),
                        "."),
                    React.createElement(RadioButton_1.default, { value: SecurityMode.SecureAzureAD, label: "Secure Azure Active Directory (AAD)" }),
                    React.createElement(Note_1.default, null,
                        "To learn about AAD authentication, please see the ",
                        React.createElement(ExternalLink_1.default, { href: "ServiceFabricDeployingAppsAuthAzureAd" }, "Connecting Securely with Azure Active Directory documentation"),
                        ".")),
                (properties["Octopus.Action.ServiceFabric.SecurityMode"] !== SecurityMode.Unsecure) && React.createElement("div", null,
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.ServerCertThumbprint"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.ServerCertThumbprint"] = x, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.ServerCertThumbprint"), label: "Server certificate thumbprint" }),
                    React.createElement(Note_1.default, null, "The server certificate thumbprint used to communicate with the secure cluster.")),
                (properties["Octopus.Action.ServiceFabric.SecurityMode"] === SecurityMode.SecureClientCertificate) && React.createElement("div", null,
                    this.state.project
                        ? React.createElement(CertificateVariableSelect_1.BoundCertificateVariableSelect, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: this.props.clientCertVariableResetValue, projectId: this.props.projectId, doBusyTask: this.props.doBusyTask, value: properties["Octopus.Action.ServiceFabric.ClientCertVariable"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.ClientCertVariable"] = x, _a));
                                var _a;
                            } })
                        : React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.ClientCertVariable"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.ClientCertVariable"] = x, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.ClientCertVariable"), label: "Client certificate" }),
                    React.createElement(Note_1.default, null, "The client certificate used to communicate with the secure cluster.")),
                (properties["Octopus.Action.ServiceFabric.SecurityMode"] === SecurityMode.SecureAzureAD) && React.createElement("div", null,
                    false && React.createElement("div", null,
                        React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: AADCredentialType.ClientCredential, value: properties["Octopus.Action.ServiceFabric.AadCredentialType"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.AadCredentialType"] = x, _a));
                                var _a;
                            }, label: "Credential type" },
                            React.createElement(RadioButton_1.default, { value: AADCredentialType.ClientCredential, label: "Client credential", isDefault: true }),
                            React.createElement(RadioButton_1.default, { value: AADCredentialType.UserCredential, label: "User credential" })),
                        React.createElement(Note_1.default, null, "The credential type to use for AAD authentication.")),
                    (properties["Octopus.Action.ServiceFabric.AadCredentialType"] === AADCredentialType.ClientCredential) && React.createElement("div", null,
                        React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.AadClientCredentialSecret"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.AadClientCredentialSecret"] = x, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.AadClientCredentialSecret"), label: "Client application secret" }),
                        React.createElement(Note_1.default, null, "The client application secret used to communicate with the secure cluster.")),
                    (properties["Octopus.Action.ServiceFabric.AadCredentialType"] === AADCredentialType.UserCredential) && React.createElement("div", null,
                        React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.AadUserCredentialUsername"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.AadUserCredentialUsername"] = x, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.AadUserCredentialUsername"), label: "Username" }),
                        React.createElement(Note_1.default, null, "The Azure AD user's username used to communicate with the secure cluster."),
                        React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "", value: properties["Octopus.Action.ServiceFabric.AadUserCredentialPassword"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.AadUserCredentialPassword"] = x, _a));
                                var _a;
                            }, label: "Password" }),
                        React.createElement(Note_1.default, null, "The Azure AD user's password used to communicate with the secure cluster.")))));
    };
    AzureServiceFabricAccountSelector.prototype.endpointSummary = function () {
        if (this.props.properties["Octopus.Action.ServiceFabric.ConnectionEndpoint"]) {
            return Summary_1.default.summary(this.props.properties["Octopus.Action.ServiceFabric.ConnectionEndpoint"]);
        }
        return Summary_1.default.placeholder("The connection endpoint has not been set");
    };
    AzureServiceFabricAccountSelector.prototype.securityModeSummary = function () {
        if (this.props.properties["Octopus.Action.ServiceFabric.SecurityMode"] === SecurityMode.Unsecure) {
            return Summary_1.default.default("Unsecure");
        }
        var summary = [];
        var thumbprint = this.props.properties["Octopus.Action.ServiceFabric.ServerCertThumbprint"];
        if (this.props.properties["Octopus.Action.ServiceFabric.SecurityMode"] === SecurityMode.SecureClientCertificate) {
            summary.push(React.createElement("span", null,
                "Security mode is ",
                React.createElement("strong", null, "Client Certificate")));
            this.contributeCertificateThumbprintSummary(thumbprint, summary);
            if (!this.props.properties["Octopus.Action.ServiceFabric.ClientCertVariable"]) {
                summary.push(React.createElement("span", null,
                    ",  the client certificate has ",
                    React.createElement("strong", null, "not"),
                    " been set"));
            }
            else {
                summary.push(React.createElement("span", null, ",  the client certificate has been set"));
            }
            return Summary_1.default.summary(React.Children.toArray(summary));
        }
        if (this.props.properties["Octopus.Action.ServiceFabric.SecurityMode"] === SecurityMode.SecureAzureAD) {
            summary.push(React.createElement("span", null,
                "Security mode is ",
                React.createElement("strong", null, "Azure Active Directory")));
            this.contributeCertificateThumbprintSummary(thumbprint, summary);
            if (!this.props.properties["Octopus.Action.ServiceFabric.AadUserCredentialUsername"]) {
                summary.push(React.createElement("span", null,
                    ",  the AAD credentials have ",
                    React.createElement("strong", null, "not"),
                    " been set"));
            }
            else {
                summary.push(React.createElement("span", null, ",  the AAD credentials have been set"));
            }
            return Summary_1.default.summary(React.Children.toArray(summary));
        }
        return Summary_1.default.placeholder("Security mode has not been set");
    };
    AzureServiceFabricAccountSelector.prototype.contributeCertificateThumbprintSummary = function (thumbprint, summary) {
        if (!thumbprint) {
            summary.push(React.createElement("span", null,
                ",  the certificate thumbprint has ",
                React.createElement("strong", null, "not"),
                " been set"));
        }
        else {
            summary.push(React.createElement("span", null, ",  the certificate thumbprint has been set"));
        }
    };
    return AzureServiceFabricAccountSelector;
}(React.Component));
exports.default = AzureServiceFabricAccountSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureServiceFabricApp\\AzureServiceFabricAccountSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureServiceFabricApp\\AzureServiceFabricAccountSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AccessType;
(function (AccessType) {
    AccessType["ReadOnly"] = "ReadOnly";
    AccessType["FullControl"] = "FullControl";
})(AccessType = exports.AccessType || (exports.AccessType = {}));
var StoreLocations;
(function (StoreLocations) {
    StoreLocations["LocalMachine"] = "LocalMachine";
    StoreLocations["CurrentUser"] = "CurrentUser";
    StoreLocations["CustomUser"] = "Custom User";
})(StoreLocations = exports.StoreLocations || (exports.StoreLocations = {}));
var StoreNames;
(function (StoreNames) {
    StoreNames["My"] = "My";
    StoreNames["Root"] = "Root";
    StoreNames["CA"] = "CA";
    StoreNames["TrustedPeople"] = "TrustedPeople";
    StoreNames["TrustedPublisher"] = "TrustedPublisher";
    StoreNames["AuthRoot"] = "AuthRoot";
    StoreNames["AddressBook"] = "AddressBook";
    StoreNames["Other"] = "Other";
})(StoreNames = exports.StoreNames || (exports.StoreNames = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\certificateImport\\CertificateImportTypes.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\certificateImport\\CertificateImportTypes.ts"); } } })();

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var StringCheckbox_1 = __webpack_require__(38);
var Note_1 = __webpack_require__(22);
var Select_1 = __webpack_require__(41);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var wildflyProperties_1 = __webpack_require__(1962);
var wildflyConnectionDetailsComponent_1 = __webpack_require__(710);
var Text_1 = __webpack_require__(17);
var StringProperties = {
    "WildFly.Deploy.Name": "",
    "WildFly.Deploy.Port": "",
    "WildFly.Deploy.Controller": "",
    "WildFly.Deploy.User": "",
    "WildFly.Deploy.Protocol": "",
    "WildFly.Deploy.ServerType": "",
    "WildFly.Deploy.Enabled": "",
    "WildFly.Deploy.DisabledServerGroup": "",
    "WildFly.Deploy.EnabledServerGroup": "",
};
var SensitiveProperties = {
    "WildFly.Deploy.Password": "",
};
var AllProperties = __assign({}, StringProperties, SensitiveProperties, wildflyProperties_1.WildflyStringProperties, wildflyProperties_1.WildflySensitiveStringProperties);
/**
 * A component that provide the connection details and application details
 * for a application deployment or state change.
 */
var WildflyFeatureTemplate = (function (_super) {
    __extends(WildflyFeatureTemplate, _super);
    function WildflyFeatureTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WildflyFeatureTemplate.prototype.shouldComponentUpdate = function (newProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(AllProperties, newProps, this.props);
    };
    WildflyFeatureTemplate.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var properties;
            return __generator(this, function (_a) {
                properties = {};
                if (!this.props.properties["WildFly.Deploy.Controller"]) {
                    properties["WildFly.Deploy.Controller"] = "localhost";
                }
                if (!this.props.properties["WildFly.Deploy.Port"]) {
                    properties["WildFly.Deploy.Port"] = "9990";
                }
                if (!this.props.properties["WildFly.Deploy.Protocol"]) {
                    properties["WildFly.Deploy.Protocol"] = "remote+http";
                }
                if (this.props.properties["WildFly.Deploy.ServerType"] !== "Standalone" &&
                    this.props.properties["WildFly.Deploy.ServerType"] !== "Domain") {
                    properties["WildFly.Deploy.ServerType"] = "Standalone";
                }
                if (!this.props.properties["WildFly.Deploy.Enabled"]) {
                    properties["WildFly.Deploy.Enabled"] = "True";
                }
                this.props.setProperties(properties, true);
                return [2 /*return*/];
            });
        }); });
    };
    WildflyFeatureTemplate.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var applicationErrorKey = "WildFly.Deploy.Name|"
            + "WildFly.Deploy.ServerType|"
            + "WildFly.Deploy.Enabled|"
            + "WildFly.Deploy.EnabledServerGroup|"
            + "WildFly.Deploy.DisabledServerGroup";
        return React.createElement("div", null,
            React.createElement(wildflyConnectionDetailsComponent_1.default, { properties: this.props.properties, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, projectId: this.props.projectId, applicationServerHostnameNote: this.props.applicationServerHostnameNote, actionDescription: React.createElement("span", null,
                    this.props.actionDescription,
                    " an application via the management interface listening on"), errors: this.props.errors }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: applicationErrorKey, title: "Application Details", summary: this.applicationSummary(), help: "Specify the details of the application." },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.Name"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.Name"] = x, _a));
                        var _a;
                    }, label: "Deployment name", error: this.props.getFieldError("WildFly.Deploy.Name") }),
                React.createElement(Note_1.default, null, this.props.applicationNameNote),
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "Standalone", value: properties["WildFly.Deploy.ServerType"], items: [{ text: "Standalone", value: "Standalone" }, { text: "Domain", value: "Domain" }], label: "Standalone or Domain Server", onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.ServerType"] = x, _a));
                        var _a;
                    } }),
                React.createElement(Note_1.default, null, "Select the kind of server you are deploying to."),
                properties["WildFly.Deploy.ServerType"] === "Standalone" &&
                    React.createElement("div", null,
                        React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "True", value: properties["WildFly.Deploy.Enabled"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.Enabled"] = x, _a));
                                var _a;
                            }, label: "Enable the deployment" }),
                        React.createElement(Note_1.default, null, this.props.applicationStateNote)),
                properties["WildFly.Deploy.ServerType"] === "Domain" &&
                    React.createElement("div", null,
                        React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.EnabledServerGroup"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.EnabledServerGroup"] = x, _a));
                                var _a;
                            }, label: "Enabled server groups" }),
                        React.createElement(Note_1.default, null,
                            "A comma separated list that defines the domain server groups where the deployment will be assigned and enabled. This value is ignored when deploying to a standalone instance. Set the ",
                            React.createElement("em", null, "Standalone or Domain Server"),
                            " option to ",
                            React.createElement("em", null, "Standalone"),
                            " to see the ",
                            React.createElement("em", null, "Enable/Disable the Deployment"),
                            " option to control the state of the application when deployed to a standalone server."),
                        React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.DisabledServerGroup"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.DisabledServerGroup"] = x, _a));
                                var _a;
                            }, label: "Disabled server groups" }),
                        React.createElement(Note_1.default, null,
                            "A comma separated list that defines the domain server groups where the deployment will be assigned and disabled. This value is ignored when deploying to a standalone instance. Set the ",
                            React.createElement("em", null, "Standalone or Domain Server"),
                            " option to ",
                            React.createElement("em", null, "Standalone"),
                            " to see the ",
                            React.createElement("em", null, "Enable/Disable the Deployment"),
                            " option to control the state of the application when deployed to a standalone server."))));
    };
    WildflyFeatureTemplate.prototype.applicationSummary = function () {
        var properties = this.props.properties;
        if (properties["WildFly.Deploy.ServerType"] === "Standalone") {
            return form_1.Summary.summary(React.createElement("span", null,
                properties["WildFly.Deploy.Enabled"] === "True" ? "Enabling " : "Disabling ",
                "the application",
                properties["WildFly.Deploy.Name"] &&
                    React.createElement("strong", null,
                        "\u00A0",
                        properties["WildFly.Deploy.Name"]),
                "\u00A0in a standalone server."));
        }
        else {
            if (properties["WildFly.Deploy.EnabledServerGroup"] || properties["WildFly.Deploy.DisabledServerGroup"]) {
                return form_1.Summary.summary(React.createElement("span", null,
                    "The application",
                    properties["WildFly.Deploy.Name"] &&
                        React.createElement("strong", null,
                            "\u00A0",
                            properties["WildFly.Deploy.Name"]),
                    properties["WildFly.Deploy.EnabledServerGroup"] &&
                        React.createElement("span", null,
                            "\u00A0will be enabled in server group",
                            properties["WildFly.Deploy.EnabledServerGroup"].indexOf(",") !== -1 && React.createElement("span", null, "s"),
                            "\u00A0",
                            React.createElement("strong", null, properties["WildFly.Deploy.EnabledServerGroup"])),
                    properties["WildFly.Deploy.EnabledServerGroup"] && properties["WildFly.Deploy.DisabledServerGroup"] &&
                        React.createElement("span", null, "\u00A0and"),
                    properties["WildFly.Deploy.DisabledServerGroup"] &&
                        React.createElement("span", null,
                            "\u00A0will be disabled in server group",
                            properties["WildFly.Deploy.DisabledServerGroup"].indexOf(",") !== -1 && React.createElement("span", null, "s"),
                            "\u00A0",
                            React.createElement("strong", null, properties["WildFly.Deploy.DisabledServerGroup"])),
                    "."));
            }
            else {
                return form_1.Summary.placeholder(React.createElement("span", null, this.props.domainDefaultMessage));
            }
        }
    };
    return WildflyFeatureTemplate;
}(BaseComponent_1.BaseComponent));
exports.default = WildflyFeatureTemplate;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\wildflyFeatureTemplate.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\wildflyFeatureTemplate.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var Note_1 = __webpack_require__(22);
var Text_1 = __webpack_require__(17);
var Summary_1 = __webpack_require__(70);
var Sensitive_1 = __webpack_require__(82);
/**
 * A component that displays the connection details for a Wildfly server
 */
var WildflyConnectionDetailsComponent = (function (_super) {
    __extends(WildflyConnectionDetailsComponent, _super);
    function WildflyConnectionDetailsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WildflyConnectionDetailsComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.props.properties["WildFly.Deploy.Controller"]) {
                    this.props.properties["WildFly.Deploy.Controller"] = "localhost";
                }
                if (!this.props.properties["WildFly.Deploy.Port"]) {
                    this.props.properties["WildFly.Deploy.Port"] = "9990";
                }
                if (!this.props.properties["WildFly.Deploy.Protocol"]) {
                    this.props.properties["WildFly.Deploy.Protocol"] = "remote+http";
                }
                if (this.props.properties["WildFly.Deploy.ServerType"] !== "Standalone" &&
                    this.props.properties["WildFly.Deploy.ServerType"] !== "Domain") {
                    this.props.properties["WildFly.Deploy.ServerType"] = "Standalone";
                }
                return [2 /*return*/];
            });
        }); });
    };
    WildflyConnectionDetailsComponent.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var applicationServerErrorKey = "WildFly.Deploy.Controller|"
            + "WildFly.Deploy.Port|"
            + "WildFly.Deploy.Protocol|"
            + "WildFly.Deploy.User|"
            + "WildFly.Deploy.Password";
        return React.createElement("div", null,
            React.createElement(form_1.ExpandableFormSection, { errorKey: applicationServerErrorKey, title: "Application Server Details", summary: this.wildflySummary(), help: "Specify the WildFly server details" },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.Controller"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.Controller"] = x, _a));
                        var _a;
                    }, label: "Management host or IP", error: this.props.getFieldError("WildFly.Deploy.Controller") }),
                React.createElement(Note_1.default, null,
                    this.props.applicationServerHostnameNote,
                    " This value is relative to the host that is executing the step. So if the Tentacle is on the same host as WildFly/Red Hat JBoss EAP, then this value may be something like ",
                    React.createElement("em", null, "localhost"),
                    "."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.Port"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.Port"] = x, _a));
                        var _a;
                    }, label: "Management port", error: this.props.getFieldError("WildFly.Deploy.Port") }),
                React.createElement(Note_1.default, null,
                    "This is the management port that the application server is listening to. For WildFly 10+ and Red Hat JBoss EAP 7+, the default is ",
                    React.createElement("em", null, "9990"),
                    ". For Red Hat JBoss EAP 6, the default is ",
                    React.createElement("em", null, "9999"),
                    "."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.Protocol"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.Protocol"] = x, _a));
                        var _a;
                    }, label: "Management protocol", error: this.props.getFieldError("WildFly.Deploy.Protocol") }),
                React.createElement(Note_1.default, null,
                    "This is the management protocol that the application server is listening to. For WildFly 10+ and Red Hat JBoss EAP 7+, the default is ",
                    React.createElement("em", null, "remote+http"),
                    ", or ",
                    React.createElement("em", null, "remote+https"),
                    " if the management port is configured to use HTTPS. For Red Hat JBoss EAP 6, the default is ",
                    React.createElement("em", null, "remoting"),
                    "."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.User"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.User"] = x, _a));
                        var _a;
                    }, label: "Management user" }),
                React.createElement(Note_1.default, null,
                    "The username to use with the management interface. This is typically configured via the",
                    React.createElement("em", null, " add-user"),
                    " script. By default WildFly does not require credentials for local connections (i.e. if the ",
                    React.createElement("em", null, "Management Host or IP"),
                    " is localhost or 127.0.0.1)."),
                React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["WildFly.Deploy.Password"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.Password"] = x, _a));
                        var _a;
                    }, label: "Management password" }),
                React.createElement(Note_1.default, null,
                    "The password to use with the management interface. This is typically configured via the",
                    React.createElement("em", null, " add-user"),
                    " script. By default WildFly does not require credentials for local connections (i.e. if the ",
                    React.createElement("em", null, "Management Host or IP"),
                    " is localhost or 127.0.0.1).")));
    };
    WildflyConnectionDetailsComponent.prototype.wildflySummary = function () {
        var properties = this.props.properties;
        if (properties["WildFly.Deploy.Controller"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                React.createElement("span", null,
                    this.props.actionDescription,
                    " an application via the management interface listening on"),
                properties["WildFly.Deploy.Protocol"] &&
                    React.createElement("strong", null,
                        "\u00A0",
                        properties["WildFly.Deploy.Protocol"],
                        "://"),
                React.createElement("strong", null, properties["WildFly.Deploy.Controller"]),
                properties["WildFly.Deploy.Port"] &&
                    React.createElement("strong", null,
                        ":",
                        properties["WildFly.Deploy.Port"]),
                properties["WildFly.Deploy.User"] &&
                    React.createElement("span", null,
                        "\u00A0with user ",
                        React.createElement("strong", null, properties["WildFly.Deploy.User"]))));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Specify the management hostname, port, protocol and credentials"));
    };
    return WildflyConnectionDetailsComponent;
}(BaseComponent_1.BaseComponent));
exports.default = WildflyConnectionDetailsComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\wildflyConnectionDetailsComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\wildflyConnectionDetailsComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var BaseComponent_1 = __webpack_require__(14);
var Note_1 = __webpack_require__(22);
var Text_1 = __webpack_require__(17);
var CertificateVariableSelect_1 = __webpack_require__(165);
var Sensitive_1 = __webpack_require__(82);
var JavaKeystoreComponent = (function (_super) {
    __extends(JavaKeystoreComponent, _super);
    function JavaKeystoreComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null
        };
        return _this;
    }
    JavaKeystoreComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        project = _a.sent();
                        this.setState({
                            project: project
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    JavaKeystoreComponent.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            this.props.projectId
                ? React.createElement(CertificateVariableSelect_1.BoundCertificateVariableSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, projectId: this.props.projectId, resetValue: "", doBusyTask: this.props.doBusyTask, value: this.props.properties["Java.Certificate.Variable"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Java.Certificate.Variable"] = val, _a));
                        var _a;
                    }, allowClear: true, error: this.props.getFieldError("Java.Certificate.Variable") })
                : React.createElement(Text_1.VariableLookupText, { label: "Certificate variable", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Java.Certificate.Variable"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Java.Certificate.Variable"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Java.Certificate.Variable") }),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Java.Certificate.KeystoreFilename"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Java.Certificate.KeystoreFilename"] = x, _a));
                    var _a;
                }, label: "Keystore filename", error: this.props.getFieldError("Java.Certificate.KeystoreFilename") }),
            React.createElement(Note_1.default, null, this.props.keystoreFilenameMessage),
            React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "", value: properties["Java.Certificate.Password"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Java.Certificate.Password"] = x, _a));
                    var _a;
                }, label: "Private key password" }),
            React.createElement(Note_1.default, null,
                "You can set an optional password which will be assigned to the private key. If this field is left blank, the default password of ",
                React.createElement("em", null, "changeit"),
                " will be used."),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Java.Certificate.KeystoreAlias"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Java.Certificate.KeystoreAlias"] = x, _a));
                    var _a;
                }, label: "Keystore alias" }),
            React.createElement(Note_1.default, null,
                "The optional alias to assign the private key to. If left blank, the default alias of ",
                React.createElement("em", null, "Octopus"),
                " will be used"));
    };
    return JavaKeystoreComponent;
}(BaseComponent_1.BaseComponent));
exports.default = JavaKeystoreComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\javaKeystore\\javaKeystoreComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\javaKeystore\\javaKeystoreComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var Note_1 = __webpack_require__(22);
var Text_1 = __webpack_require__(17);
var Validators_1 = __webpack_require__(170);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var styles = __webpack_require__(1968);
var Sensitive_1 = __webpack_require__(82);
var TomcatFeatureTemplate = (function (_super) {
    __extends(TomcatFeatureTemplate, _super);
    function TomcatFeatureTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TomcatFeatureTemplate.prototype.deploymentSummary = function () {
        var properties = this.props.properties;
        if (properties["Tomcat.Deploy.Name"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Deploying the package to the ",
                React.createElement("strong", null, this.props.properties["Tomcat.Deploy.Name"]),
                " context in a ",
                this.props.properties["Tomcat.Deploy.Enabled"] === "True" ? "started" : "stopped",
                " state",
                properties["Tomcat.Deploy.Version"] &&
                    React.createElement("span", null,
                        "\u00A0with the version ",
                        React.createElement("strong", null, properties["Tomcat.Deploy.Version"]))));
        }
        return form_1.Summary.placeholder(React.createElement("span", null, "Specify the Tomcat deployment context and optionally the version"));
    };
    TomcatFeatureTemplate.prototype.tomcatSummary = function () {
        var properties = this.props.properties;
        if (properties["Tomcat.Deploy.Controller"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                React.createElement("span", null,
                    "Deploying to Tomcat Manager hosted at ",
                    React.createElement("strong", null, properties["Tomcat.Deploy.Controller"])),
                properties["Tomcat.Deploy.User"] &&
                    React.createElement("span", null,
                        "\u00A0with the user ",
                        React.createElement("strong", null, properties["Tomcat.Deploy.User"]))));
        }
        return form_1.Summary.placeholder(React.createElement("span", null, "Specify the Tomcat manager URL, credentials and the state of the application"));
    };
    TomcatFeatureTemplate.prototype.componentDidMount = function () {
        var properties = {};
        if (!this.props.properties["Tomcat.Deploy.Controller"]) {
            properties["Tomcat.Deploy.Controller"] = "http://localhost:8080/manager";
        }
        if (!this.props.properties["Tomcat.Deploy.Enabled"]) {
            properties["Tomcat.Deploy.Enabled"] = "True";
        }
        this.props.setProperties(properties, true);
    };
    TomcatFeatureTemplate.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Tomcat.Deploy.Controller|Tomcat.Deploy.User|Tomcat.Deploy.Password", title: "Tomcat Details", summary: this.tomcatSummary(), help: "Specify the Tomcat manager URL and credentials." },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Deploy.Controller"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Deploy.Controller"] = x, _a));
                        var _a;
                    }, label: "Tomcat Manager URL", validate: Validators_1.required("Please enter a Tomcat Manager URL"), error: this.props.getFieldError("Tomcat.Deploy.Controller") }),
                React.createElement(Note_1.default, null,
                    "This is the URL of the Tomcat Manager instance that the package will be uploaded to. This URL is relative to the host that is executing the step. So if the Tentacle is on the same host as Tomcat, then this value may be something like ",
                    React.createElement("em", null, "http://localhost:8080/manager"),
                    "."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Deploy.User"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Deploy.User"] = x, _a));
                        var _a;
                    }, label: "Management user", validate: Validators_1.required("Please enter a Tomcat Manager user"), error: this.props.getFieldError("Tomcat.Deploy.User") }),
                React.createElement(Note_1.default, null,
                    "The username to use with the management interface. This user must be assigned to the ",
                    React.createElement("em", null, "manager-script"),
                    " group in the ",
                    React.createElement("em", null, "tomcat-users.xml"),
                    " file."),
                React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Tomcat.Deploy.Password"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Deploy.Password"] = x, _a));
                        var _a;
                    }, label: "Management password", error: this.props.getFieldError("Tomcat.Deploy.Password") }),
                React.createElement(Note_1.default, null, "The password to use with the management interface.")),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Tomcat.Deploy.Name|Tomcat.Deploy.Version|Tomcat.Deploy.Enabled", title: "Tomcat Deployment", summary: this.deploymentSummary(), help: "Specify the Tomcat deployment context, optionally the version and the state of the application." },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Deploy.Name"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Deploy.Name"] = x, _a));
                        var _a;
                    }, label: "Context path", error: this.props.getFieldError("Tomcat.Deploy.Name") }),
                React.createElement(Note_1.default, null,
                    "This field defines the context path of the deployed artifact. For example, setting this field to ",
                    React.createElement("em", null, "myapp"),
                    " will result in the deployment being having the context path ",
                    React.createElement("em", null, "/myapp"),
                    " in Tomcat. Set the value to ",
                    React.createElement("em", null, "/"),
                    " to deploy to the root context."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Deploy.Version"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Deploy.Version"] = x, _a));
                        var _a;
                    }, label: "Deployment version" }),
                React.createElement(Note_1.default, null,
                    "Tomcat versions are used with ",
                    React.createElement("a", { href: "https://tomcat.apache.org/tomcat-8.0-doc/config/context.html#Parallel_deployment" }, "parallel deployments"),
                    ".",
                    React.createElement("p", null, "Leave this field blank to to leave the Tomcat version undefined, in which case you will overwrite any existing deployment with the same context path, and parallel deployments will not be enabled."),
                    React.createElement("p", null,
                        "Alternatively you can define a custom Tomcat version. Typically this Tomcat version will match the package version using the variable ",
                        React.createElement("span", { className: styles.nowrap },
                            React.createElement("em", null, "#{Octopus.Action.Package.NuGetPackageVersion}")),
                        ", or the release number with the variable ",
                        React.createElement("span", { className: styles.nowrap },
                            React.createElement("em", null, "#{Octopus.Release.Number}")),
                        ".")),
                React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "True", value: properties["Tomcat.Deploy.Enabled"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Deploy.Enabled"] = x, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "True", label: "Leave the application running", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "False", label: "Stop the application" }))));
    };
    return TomcatFeatureTemplate;
}(BaseComponent_1.BaseComponent));
exports.default = TomcatFeatureTemplate;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\tomcat\\tomcatFeatureTemplate.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\tomcat\\tomcatFeatureTemplate.tsx"); } } })();

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var SaveDialogLayout_1 = __webpack_require__(105);
var CodeEditor_1 = __webpack_require__(119);
var clientInstance_1 = __webpack_require__(10);
var SourceCodeDialog = (function (_super) {
    __extends(SourceCodeDialog, _super);
    function SourceCodeDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: null,
            metadata: null,
            template: _this.props.template
        };
        return _this;
    }
    SourceCodeDialog.prototype.getMetadata = function (template) {
        return clientInstance_1.repository.CloudTemplates.getMetadata(template, this.props.metadata);
    };
    SourceCodeDialog.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var metadata, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getMetadata(this.state.template)];
                    case 1:
                        metadata = _a.sent();
                        this.props.saveDone(this.state.template, metadata);
                        return [2 /*return*/, true];
                    case 2:
                        err_1 = _a.sent();
                        this.setState({ errors: { message: err_1.ErrorMessage, details: err_1.Errors ? err_1.Errors.map(function (x) { return x.toString(); }) : null, fieldErrors: {} } });
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SourceCodeDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(SaveDialogLayout_1.default, { title: "Template source code", busy: null, errors: this.state.errors, onSaveClick: function () { return _this.save(); }, saveButtonLabel: "OK" },
            React.createElement(CodeEditor_1.default, { value: this.state.template, language: this.props.textFormat || CodeEditor_1.TextFormat.JSON, allowFullScreen: false, onChange: function (template) { _this.setState({ template: template }); } }));
    };
    return SourceCodeDialog;
}(BaseComponent_1.default));
exports.default = SourceCodeDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SourceCodeDialog\\sourceCodeDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SourceCodeDialog\\sourceCodeDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1984);
__webpack_require__(1985);
__webpack_require__(1986);
__webpack_require__(1987);
__webpack_require__(1988);
__webpack_require__(1989);
__webpack_require__(1994);
__webpack_require__(1995);
__webpack_require__(1996);
__webpack_require__(1997);
__webpack_require__(1998);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\index.ts"); } } })();

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Divider_1 = __webpack_require__(143);
var styles = __webpack_require__(1727);
var SidebarSide;
(function (SidebarSide) {
    SidebarSide[SidebarSide["Right"] = 0] = "Right";
    SidebarSide[SidebarSide["Left"] = 1] = "Left";
})(SidebarSide = exports.SidebarSide || (exports.SidebarSide = {}));
var SidebarLayout = function (props) {
    var sidebarSide = props.side ? props.side : SidebarSide.Right;
    return React.createElement("div", { className: styles.bodyWithSides },
        sidebarSide === SidebarSide.Left && renderSidebar(styles.sideBarLeft, props),
        React.createElement("div", { className: styles.main + " " + (props.overflowXHidden ? styles.overflowXHidden : "") },
            props.sideBar && !props.hideTopDivider ? React.createElement(Divider_1.default, { fullHeight: true }) : null,
            React.createElement("div", { className: !props.extendContentToEdges && props.sideBar ? styles.mainContent : "" }, props.children)),
        sidebarSide === SidebarSide.Right && renderSidebar(styles.sideBarRight, props));
};
function renderSidebar(dividerClassName, props) {
    if (!props.sideBar) {
        return null;
    }
    var className = styles.sidebarContainer + " " + (props.hideSidebarDivider ? "" : dividerClassName) + " " + styles.sideBar;
    var containerStyle = {};
    if (props.flexBasis) {
        containerStyle.flexBasis = props.flexBasis;
    }
    return React.createElement("div", { className: className, style: containerStyle },
        !props.hideTopDivider ? React.createElement(Divider_1.default, { fullHeight: true }) : null,
        React.createElement("div", { className: "" + (props.extendSidebarToEdges ? "" : styles.sideBarPadding) }, props.sideBar));
}
exports.default = SidebarLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SidebarLayout\\SidebarLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SidebarLayout\\SidebarLayout.tsx"); } } })();

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var List_1 = __webpack_require__(279);
var SimpleList_1 = __webpack_require__(430);
exports.SimpleList = SimpleList_1.SimpleList;
exports.default = List_1.List;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\List\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\List\\index.tsx"); } } })();

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TaskName;
(function (TaskName) {
    TaskName["Backup"] = "Backup";
    TaskName["Deploy"] = "Deploy";
    TaskName["Health"] = "Health";
    TaskName["AdHocScript"] = "AdHocScript";
    TaskName["AutoDeploy"] = "AutoDeploy";
    TaskName["ConfigureLetsEncrypt"] = "ConfigureLetsEncrypt";
    TaskName["Upgrade"] = "Upgrade";
    TaskName["TestEmail"] = "TestEmail";
    TaskName["TestAzureAccount"] = "TestAzureAccount";
    TaskName["TestAccount"] = "TestAccount";
    TaskName["Retention"] = "Retention";
    TaskName["Delete"] = "Delete";
    TaskName["SystemIntegrityCheck"] = "SystemIntegrityCheck";
    TaskName["SyncCommunityActionTemplates"] = "SyncCommunityActionTemplates";
    TaskName["SynchronizeBuiltInPackageRepositoryIndex"] = "SynchronizeBuiltInPackageRepositoryIndex";
    TaskName["SynchronizeExternalSecurityGroupsForUsers"] = "SynchronizeExternalSecurityGroupsForUsers";
    TaskName["UpdateCalamari"] = "UpdateCalamari";
    TaskName["Subscription"] = "Subscription";
    TaskName["MigrationSpacePartialExport"] = "MigrationSpacePartialExport";
    TaskName["MigrationSpaceImport"] = "MigrationSpaceImport";
})(TaskName = exports.TaskName || (exports.TaskName = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\taskResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\taskResource.ts"); } } })();

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActivityStatus;
(function (ActivityStatus) {
    ActivityStatus["Pending"] = "Pending";
    ActivityStatus["Running"] = "Running";
    ActivityStatus["Success"] = "Success";
    ActivityStatus["Failed"] = "Failed";
    ActivityStatus["Skipped"] = "Skipped";
    ActivityStatus["SuccessWithWarning"] = "SuccessWithWarning";
    ActivityStatus["Canceled"] = "Canceled";
})(ActivityStatus = exports.ActivityStatus || (exports.ActivityStatus = {}));
var ActivityLogEntryCategory;
(function (ActivityLogEntryCategory) {
    ActivityLogEntryCategory["Trace"] = "Trace";
    ActivityLogEntryCategory["Verbose"] = "Verbose";
    ActivityLogEntryCategory["Info"] = "Info";
    ActivityLogEntryCategory["Highlight"] = "Highlight";
    ActivityLogEntryCategory["Wait"] = "Wait";
    ActivityLogEntryCategory["Gap"] = "Gap";
    ActivityLogEntryCategory["Alert"] = "Alert";
    ActivityLogEntryCategory["Warning"] = "Warning";
    ActivityLogEntryCategory["Error"] = "Error";
    ActivityLogEntryCategory["Fatal"] = "Fatal";
    ActivityLogEntryCategory["Planned"] = "Planned";
    ActivityLogEntryCategory["Updated"] = "Updated";
    ActivityLogEntryCategory["Finished"] = "Finished";
    ActivityLogEntryCategory["Abandoned"] = "Abandoned";
})(ActivityLogEntryCategory = exports.ActivityLogEntryCategory || (exports.ActivityLogEntryCategory = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\taskDetailsResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\taskDetailsResource.ts"); } } })();

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Panel_1 = __webpack_require__(1718);
var styles = __webpack_require__(673);
var OnboardingPage = function (props) {
    return React.createElement("div", { className: styles.onboardingContainer },
        React.createElement("div", { className: styles.title },
            React.createElement("h2", null, props.title),
            props.intro && React.createElement("p", null, props.intro)),
        React.createElement("div", { className: styles.panels }, props.panels.map(function (panel) {
            return React.createElement(Panel_1.default, { key: panel.imageSrc, description: panel.description, imageSrc: panel.imageSrc, imageWidth: panel.imageWidth, imageHeight: panel.imageHeight, imageAlt: panel.imageAlt });
        })),
        React.createElement("div", { className: styles.onboardingCreateFirst },
            props.customNavigation,
            props.learnMore));
};
exports.default = OnboardingPage;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\OnboardingPage.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\OnboardingPage.tsx"); } } })();

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(89);
var DataTableBody = (function (_super) {
    __extends(DataTableBody, _super);
    function DataTableBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableBody.prototype.render = function () {
        return (React.createElement("tbody", { className: cn(this.props.className, styles.dataTableBody) }, this.props.children));
    };
    return DataTableBody;
}(React.Component));
exports.DataTableBody = DataTableBody;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableBody.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableBody.tsx"); } } })();

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(89);
var DataTableRow = (function (_super) {
    __extends(DataTableRow, _super);
    function DataTableRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableRow.prototype.render = function () {
        var _a = this.props, displayNoBorder = _a.displayNoBorder, className = _a.className, otherProps = __rest(_a, ["displayNoBorder", "className"]);
        return (React.createElement("tr", __assign({}, otherProps, { className: cn(className, styles.dataTableRow, displayNoBorder ? styles.noBorder : "") }), this.props.children));
    };
    return DataTableRow;
}(React.Component));
exports.DataTableRow = DataTableRow;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableRow.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableRow.tsx"); } } })();

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(89);
var DataTableRowColumn = function (props) {
    var className = props.className, fullWidth = props.fullWidth, fullHeight = props.fullHeight, otherProps = __rest(props, ["className", "fullWidth", "fullHeight"]);
    var style = {};
    if (fullHeight) {
        style.paddingBottom = 0;
        style.paddingTop = 0;
    }
    if (fullWidth) {
        style.paddingRight = 0;
        style.paddingLeft = 0;
    }
    return (React.createElement("td", __assign({}, otherProps, { style: style, className: cn(className, styles.dataTableRowColumn) }), props.children));
};
exports.DataTableRowColumn = DataTableRowColumn;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableRowColumn.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableRowColumn.tsx"); } } })();

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var TenantMultiSelect_1 = __webpack_require__(446);
var TenantTagMultiSelect_1 = __webpack_require__(295);
var TenantTagDesignDialog_1 = __webpack_require__(1729);
var LabelStrategy_1 = __webpack_require__(174);
var AdvancedTenantSelectorInternal = function (props) {
    return React.createElement("div", null,
        props.showTenants && React.createElement(TenantMultiSelect_1.default, { value: props.selectedTenantIds, items: props.tenants, onChange: function (tenantIds) { return props.onChange(tenantIds, props.selectedTenantTags); } }),
        React.createElement(TenantTagMultiSelect_1.default, { value: props.selectedTenantTags, onChange: function (includedTenantTags) { return props.onChange(props.selectedTenantIds, includedTenantTags); }, doBusyTask: props.doBusyTask }),
        React.createElement(LabelStrategy_1.ResetLabelStrategy, null,
            React.createElement(TenantTagDesignDialog_1.default, { selectedTags: props.selectedTenantTags, selectedTenants: props.selectedTenantIds, showTenants: props.showTenants, availableTenants: props.tenants ? props.tenants.map(function (t) { return t.Id; }) : null, onUpdate: function (selectedTenants, selectedTags) { return props.onChange(selectedTenants, selectedTags); } })));
};
exports.AdvancedTenantsAndTenantTagsSelector = function (props) {
    return React.createElement(AdvancedTenantSelectorInternal, { selectedTenantIds: props.selectedTenantIds, showTenants: true, tenants: props.tenants, selectedTenantTags: props.selectedTenantTags, onChange: props.onChange, doBusyTask: props.doBusyTask });
};
exports.AdvancedTenantTagsSelector = function (props) {
    return React.createElement(AdvancedTenantSelectorInternal, { selectedTenantIds: [], showTenants: false, tenants: null, selectedTenantTags: props.selectedTenantTags, onChange: function (tenants, tags) { return props.onChange(tags); }, doBusyTask: props.doBusyTask });
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\AdvancedTenantSelector\\AdvancedTenantSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\AdvancedTenantSelector\\AdvancedTenantSelector.tsx"); } } })();

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var moment = __webpack_require__(104);
var iconStyle_1 = __webpack_require__(1457);
exports.iconStyle = iconStyle_1.default;
var index_1 = __webpack_require__(68);
var resources_1 = __webpack_require__(26);
function momentFromFilter(fromDate, toDate) {
    if (!fromDate) {
        return null;
    }
    var fromMoment = moment(fromDate);
    var toMoment = toDate ? moment(toDate) : moment();
    var diff = fromMoment.diff(toMoment);
    var duration = moment.duration(diff);
    var mins = duration.minutes();
    var hours = duration.hours();
    var days = Math.floor(duration.asDays());
    var result = (mins === 1 ? "1 minute" : mins + " minutes");
    result = (hours !== 0 ? (hours === 1 ? "1 hour" : hours + " hours") + " and " : "") + result;
    result = (days !== 0 ? (days === 1 ? "1 day" : days + " days") + ", " : "") + result;
    return result;
}
function inspector(task) {
    var pendingInterruptions = task.HasPendingInterruptions;
    var warningsOrErrors = task.HasWarningsOrErrors;
    var duration = task.Duration;
    var errorMessage = task.ErrorMessage;
    var description = task.State;
    var tip = "";
    var html = React.createElement("em", null);
    if (pendingInterruptions && !task.IsCompleted) {
        html = React.createElement("em", { className: "fa fa-eye" });
        description = "Waiting...";
        tip = "This task is waiting for manual intervention. Duration: " + duration;
    }
    else if (task.State === resources_1.TaskState.Cancelling) {
        html = React.createElement("em", { className: "fa fa-user-times" });
        description = "Cancelling";
        tip = "Cancellation has been requested, attempting to stop the task.";
    }
    else if (task.State === resources_1.TaskState.Queued) {
        html = React.createElement("em", { className: "fa fa-clock-o" });
        description = "Queued...";
        var timeQueued = moment(task.QueueTime).calendar();
        tip = "This task was queued to run " + timeQueued;
    }
    else if (task.State === resources_1.TaskState.Executing) {
        html = React.createElement("em", { className: "fa fa-spinner fa-spin" });
        tip = "This task is being executed by the Octopus Server. Duration: " + duration;
    }
    else if (task.State === resources_1.TaskState.Failed) {
        html = React.createElement("em", { className: "fa fa-exclamation-triangle" });
        tip = "An error occurred while processing this task";
        tip = errorMessage && errorMessage.length > 0 ? tip + ": " + errorMessage : tip + ". See the task details for more information.";
    }
    else if (task.State === resources_1.TaskState.Canceled) {
        html = React.createElement("em", { className: "fa fa-user-times" });
        tip = "This task was canceled by a user.";
    }
    else if (task.State === resources_1.TaskState.TimedOut) {
        html = React.createElement("em", { className: "fa fa-clock-o" });
        description = "Timed out";
        var queueTime = moment(task.QueueTime).calendar();
        var expiryTime = momentFromFilter(task.QueueTimeExpiry, task.QueueTime);
        var lastUpdated = moment(task.LastUpdatedTime).calendar();
        tip = "The task was scheduled to run " + queueTime + " within " + expiryTime + " but the Octopus Server " +
            "attempted to run the task " + lastUpdated + ". This can happen when the Octopus Server is too busy to process the task.";
    }
    else if (task.State === resources_1.TaskState.Success) {
        if (warningsOrErrors) {
            html = (React.createElement("span", { style: { position: "relative" } },
                React.createElement("em", { className: "fa fa-check" }),
                React.createElement("span", { className: "status-overlay", style: { position: "absolute", bottom: "-8px", right: "-0.0625rem", fontSize: "10px" } },
                    React.createElement("em", { className: "fa fa-exclamation-triangle" }))));
            tip = "This task completed successfully, but warnings or errors were reported in the log. Duration: " + duration;
        }
        else {
            html = React.createElement("em", { className: "fa fa-check" });
            tip = "This task completed without any problems. Duration: " + duration;
        }
    }
    return {
        tip: tip,
        html: html,
        description: description
    };
}
var TaskStatusIcon = function (props) {
    var _a = inspector(props.item), tip = _a.tip, html = _a.html, description = _a.description;
    return (React.createElement(index_1.default, { content: tip },
        React.createElement("span", { className: iconStyle_1.default(props.item, props.smallIcon) }, html)));
};
exports.TaskStatusIcon = TaskStatusIcon;
TaskStatusIcon.displayName = "TaskStatusIcon";


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\TaskStatusIcon\\TaskStatusIcon.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\TaskStatusIcon\\TaskStatusIcon.tsx"); } } })();

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(89);
var DataTable = (function (_super) {
    __extends(DataTable, _super);
    function DataTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTable.prototype.render = function () {
        return (React.createElement("table", { className: cn(this.props.className, styles.dataTable) }, this.props.children));
    };
    return DataTable;
}(React.Component));
exports.DataTable = DataTable;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTable.tsx"); } } })();

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(16);
var React = __webpack_require__(0);
var react_router_1 = __webpack_require__(69);
var URI = __webpack_require__(106);
var QueryStringFiltersInternal = (function (_super) {
    __extends(QueryStringFiltersInternal, _super);
    function QueryStringFiltersInternal(props) {
        var _this = _super.call(this, props) || this;
        if (props.location.search) {
            _this.updateFiltersFromQueryString(props.location.search);
        }
        return _this;
    }
    QueryStringFiltersInternal.prototype.componentWillReceiveProps = function (props) {
        if (!lodash_1.isEqual(props.filter, this.props.filter)) {
            this.updateQueryStringFromFilters(props.filter);
            return;
        }
        if (props.location.search !== this.props.location.search) {
            this.updateFiltersFromQueryString(props.location.search);
        }
    };
    QueryStringFiltersInternal.prototype.render = function () {
        return null;
    };
    QueryStringFiltersInternal.prototype.updateQueryStringFromFilters = function (filter) {
        var query = this.props.getQuery(filter);
        var normalisedQuery = normaliseQuery(query);
        var queryString = new URI().search(normalisedQuery).search();
        if (this.props.location.search !== queryString) {
            var location = __assign({}, this.props.history, { search: queryString });
            this.props.history.replace(location);
        }
    };
    QueryStringFiltersInternal.prototype.updateFiltersFromQueryString = function (queryString) {
        var query = URI(queryString).search(true);
        var filter = this.props.getFilter(query);
        if (!lodash_1.isEqual(filter, this.props.filter)) {
            this.props.onFilterChange(filter);
        }
    };
    return QueryStringFiltersInternal;
}(React.Component));
function normaliseQuery(query) {
    var normalisedQuery = {};
    for (var key in query) {
        if (!query.hasOwnProperty(key)) {
            continue;
        }
        var value = query[key];
        normalisedQuery[key] = value instanceof Array
            ? value.length ? value : undefined
            : value || undefined;
    }
    return normalisedQuery;
}
exports.normaliseQuery = normaliseQuery;
var QueryStringFilters = (function (_super) {
    __extends(QueryStringFilters, _super);
    function QueryStringFilters() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueryStringFilters;
}((react_router_1.withRouter((function (_super) {
    __extends(class_1, _super);
    function class_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return class_1;
}(QueryStringFiltersInternal))))));
exports.QueryStringFilters = QueryStringFilters;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\QueryStringFilters\\QueryStringFilters.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\QueryStringFilters\\QueryStringFilters.tsx"); } } })();

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Markdown_1 = __webpack_require__(136);
var PermissionCheck_1 = __webpack_require__(45);
var ReloadableRoute_1 = __webpack_require__(80);
var lodash_1 = __webpack_require__(16);
var React = __webpack_require__(0);
var MediaQuery = __webpack_require__(767);
var react_router_1 = __webpack_require__(69);
var uiTestClasses_1 = __webpack_require__(77);
var fontWeights_1 = __webpack_require__(76);
var ErrorBoundary_1 = __webpack_require__(239);
var Logo_1 = __webpack_require__(172);
var PriorityNavigation_1 = __webpack_require__(635);
var styles = __webpack_require__(1653);
var InternalNavLink_1 = __webpack_require__(223);
var Navigation = (function () {
    function Navigation() {
    }
    Navigation.navItem = function (label, path, exact, permission) {
        return !permission || PermissionCheck_1.isAllowed(permission) ? { label: label, path: path, exact: !!exact } : null;
    };
    Navigation.navGroup = function (label, path, children, permission) {
        return !permission || PermissionCheck_1.isAllowed(permission) ? { groupLabel: label, defaultChildPath: path, children: children } : null;
    };
    return Navigation;
}());
exports.Navigation = Navigation;
var screenMd = 1279;
var NavigationSidebarLayout = function (props) {
    // we HAVE to use the render prop format here, if we use multiple MediaQuery tags all the content
    // gets torn down and remounted at the mediaquery breakpoints, which means you loose all state.
    // the props.content needs to be the same "shape" with the same key too so that it is retained.
    // Test that form content isn't cleared if you change this.
    return React.createElement("div", null,
        React.createElement(MediaQuery, { minWidth: screenMd }, function (matches) {
            if (matches) {
                return React.createElement("div", { className: styles.sidebarLayout },
                    React.createElement("div", { className: styles.sideMenu },
                        props.logoUrl && React.createElement(Logo_1.default, { url: props.logoUrl, size: 100 / fontWeights_1.baseSizeInPx + "rem" }),
                        props.image && props.image,
                        props.name && React.createElement("div", { className: styles.name }, props.name),
                        props.preNavbarComponent && React.createElement("div", { className: styles.preNav }, props.preNavbarComponent),
                        React.createElement("nav", { className: uiTestClasses_1.navLinksClass + " " + styles.links }, props.navLinks.filter(function (x) { return !!x; }).map(function (link, index) { return React.createElement(NavItemComponent, { item: link, key: index }); })),
                        props.description && React.createElement("div", { className: styles.description },
                            React.createElement(Markdown_1.default, { markup: props.description }))),
                    React.createElement("div", { className: styles.sidebarLayoutContent, key: "content" }, content(props)));
            }
            else {
                return React.createElement("div", { className: styles.stackedLayout },
                    (props.logoUrl || props.name) &&
                        React.createElement("div", { className: styles.title },
                            props.logoUrl &&
                                React.createElement("div", { className: styles.logo },
                                    React.createElement(Logo_1.default, { size: 50 / fontWeights_1.baseSizeInPx + "rem", url: props.logoUrl })),
                            props.name && React.createElement("div", { className: styles.nameHorizontal }, props.name)),
                    props.preNavbarComponent && React.createElement("div", { className: styles.preNav }, props.preNavbarComponent),
                    React.createElement(PriorityNavigation_1.default, { className: uiTestClasses_1.navLinksClass + " " + styles.horizontalLinks, activeItemClassName: styles.selected, maxNavigationItems: 99, navigationItems: props.navLinks.filter(function (x) { return !!x; }).map(convertNavItemToMenuNode) }),
                    React.createElement("div", { key: "content" }, content(props)));
            }
        }));
};
// ErrorBoundary doesn't reset its state when applied at a level lower than route level and that's why we have to do ourselves here.
function content(props) {
    return React.createElement(ErrorBoundary_1.default, { key: props.location.pathname }, props.content);
}
function convertNavItemToMenuNode(item) {
    if (isGroup(item)) {
        return { label: item.groupLabel, children: item.children.map(convertNavItemToMenuNode) };
    }
    return { url: item.path, text: item.label, exact: item.exact };
}
function isGroup(item) {
    return item.children !== undefined;
}
var NavItemComponent = function (props) {
    var item = props.item;
    return isGroup(item)
        ? renderNavLinkGroup(item)
        : renderNavLink(item.label, item.path, item.exact);
    function renderNavLinkGroup(group) {
        return React.createElement(ReloadableRoute_1.default, { render: function (routeProps) {
                return React.createElement(NavLinkGroup, { group: group, location: routeProps.location });
            } });
    }
};
function renderNavLink(label, path, exact) {
    return React.createElement(InternalNavLink_1.default, { to: path, activeClassName: styles.selected, className: styles.link, key: path, exact: exact }, label);
}
var NavLinkGroup = function (props) {
    var allDescendantLinks = getDescendantLinks(props.group);
    var anyDescendantsMatch = allDescendantLinks.some(function (l) { return !!react_router_1.matchPath(props.location.pathname, { path: l.path, exact: l.exact }); });
    return React.createElement("div", null,
        renderNavLink(props.group.groupLabel, props.group.defaultChildPath, anyDescendantsMatch),
        anyDescendantsMatch && React.createElement("div", { className: styles.nestedNavLinks }, props.group.children.map(function (g, index) { return React.createElement(NavItemComponent, { key: index, item: g }); })));
};
function getDescendantLinks(group) {
    return lodash_1.flatten(group.children.map(function (c) {
        if (isGroup(c)) {
            return getDescendantLinks(c);
        }
        return [c];
    }));
}
exports.default = react_router_1.withRouter(NavigationSidebarLayout);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\NavigationSidebarLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\NavigationSidebarLayout\\index.tsx"); } } })();

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_dnd_1 = __webpack_require__(421);
var react_dnd_html5_backend_1 = __webpack_require__(758);
var SortableItem_1 = __webpack_require__(1800);
var SortableList = (function (_super) {
    __extends(SortableList, _super);
    function SortableList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemMoved = function (dragIndex, hoverIndex) {
            var orderedItems = _this.props.items.slice();
            var dragItem = orderedItems[dragIndex];
            orderedItems.splice(dragIndex, 1);
            orderedItems.splice(hoverIndex, 0, dragItem);
            _this.props.onOrderChanged(orderedItems);
        };
        return _this;
    }
    SortableList.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null, this.props.items.map(function (item, index) { return (React.createElement(SortableItem_1.default, { key: item.Id, index: index, id: item.Id, name: item.Name, onItemMoved: _this.itemMoved })); }));
    };
    return SortableList;
}(React.Component));
exports.default = react_dnd_1.DragDropContext(react_dnd_html5_backend_1.default)(SortableList);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SortableList\\SortableList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SortableList\\SortableList.tsx"); } } })();

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(67);
var expanders_1 = __webpack_require__(286);
// HOC that hooks up a component that manages expansion to the redux store
function Expandable(Comp) {
    var ExpandableInternal = (function (_super) {
        __extends(ExpandableInternal, _super);
        function ExpandableInternal() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ExpandableInternal.prototype.componentDidMount = function () {
            this.props.onMount(this.props.errorKey, this.props.containerKey, this.props.isExpandedByDefault);
        };
        ExpandableInternal.prototype.componentWillReceiveProps = function (nextProps) {
            if (nextProps.containerKey !== this.props.containerKey || nextProps.errorKey !== this.props.errorKey) {
                this.props.onMount(nextProps.errorKey, nextProps.containerKey, nextProps.isExpandedByDefault);
            }
        };
        ExpandableInternal.prototype.render = function () {
            return React.createElement(Comp, __assign({}, this.props));
        };
        return ExpandableInternal;
    }(React.Component));
    function mapStateToProps(state, ownProps) {
        var containerKey = ownProps.containerKey || expanders_1.defaultContainerKey;
        var parentState = (state.expanders && state.expanders.hasOwnProperty(containerKey)) ? state.expanders[containerKey] : null;
        var expanderState = parentState && parentState.expanderValues[ownProps.errorKey];
        var initialState = (parentState && parentState.initialState);
        var isExpanded = expanderState === undefined || expanderState === null ? initialState : expanderState;
        var expandingAll = parentState ? parentState.expandingAll : false;
        return { isExpanded: isExpanded, expandingAll: expandingAll };
    }
    function mapDispatchToProps(dispatch, ownProps) {
        return {
            onExpandedChanged: function (state) {
                dispatch(expanders_1.onExpanderStateChanged(ownProps.containerKey || expanders_1.defaultContainerKey, ownProps.errorKey, state));
            },
            onMount: function (errorKey, containerKey, expanded) {
                dispatch(expanders_1.onExpanderCreated(containerKey || expanders_1.defaultContainerKey, errorKey, expanded));
            }
        };
    }
    return react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExpandableInternal);
}
exports.default = Expandable;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Expandable\\Expandable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Expandable\\Expandable.tsx"); } } })();

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(71);
var Chips_1 = __webpack_require__(23);
var LookupReferenceDataItemChip_1 = __webpack_require__(103);
var Chips_2 = __webpack_require__(23);
var MachineTypedMultiSelect = MultiSelect_1.MultiSelect();
var MachineMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Machine, chipRender: function (item) { return React.createElement(Chips_1.MachineChip, { onRequestDelete: onRequestDelete, machineName: item.Name }); } });
    };
    return React.createElement(MachineTypedMultiSelect, __assign({ items: props.items, fieldName: "targets", renderChip: chipRenderer }, props));
};
exports.default = MachineMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\MachineMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\MachineMultiSelect.tsx"); } } })();

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(89);
var DataTableHeader = (function (_super) {
    __extends(DataTableHeader, _super);
    function DataTableHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableHeader.prototype.render = function () {
        return (React.createElement("thead", { className: cn(this.props.className, styles.dataTableHeader) }, this.props.children));
    };
    return DataTableHeader;
}(React.Component));
exports.DataTableHeader = DataTableHeader;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableHeader.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableHeader.tsx"); } } })();

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(89);
var DataTableHeaderColumn = (function (_super) {
    __extends(DataTableHeaderColumn, _super);
    function DataTableHeaderColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableHeaderColumn.prototype.render = function () {
        var _a = this.props, className = _a.className, otherProps = __rest(_a, ["className"]);
        return (React.createElement("th", __assign({ className: cn(className, styles.dataTableHeaderColumn) }, otherProps), this.props.children));
    };
    return DataTableHeaderColumn;
}(React.Component));
exports.DataTableHeaderColumn = DataTableHeaderColumn;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableHeaderColumn.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableHeaderColumn.tsx"); } } })();

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__(99);
var RequestRaceConditioner = (function () {
    function RequestRaceConditioner() {
    }
    // To avoid race conditions, this helps check we are only showing the LAST request's response.
    // This was necessary on screens with a side-filter panel, as users can quickly select multiple
    // filters, causing multiple API requests, so this guarantees that "the last request wins".
    RequestRaceConditioner.prototype.avoidStaleResponsesForRequest = function (promise, completionCallback, staleCallback) {
        if (staleCallback === void 0) { staleCallback = null; }
        return __awaiter(this, void 0, void 0, function () {
            var requestTimestamp, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestTimestamp = Date.now();
                        this.requestTimestamp = requestTimestamp;
                        return [4 /*yield*/, promise];
                    case 1:
                        response = _a.sent();
                        if (this.requestTimestamp === requestTimestamp) {
                            completionCallback(response);
                        }
                        else {
                            logger_1.default.log("Ignoring stale response (this request has been superceded)");
                            if (staleCallback) {
                                staleCallback(response);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return RequestRaceConditioner;
}());
exports.default = RequestRaceConditioner;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\RequestRaceConditioner\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\RequestRaceConditioner\\index.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var DataBaseComponent_1 = __webpack_require__(39);
var DialogLayout_1 = __webpack_require__(141);
var ActionButton_1 = __webpack_require__(50);
var Dialog_1 = __webpack_require__(121);
var styles = __webpack_require__(1806);
var ConfirmationDialog = (function (_super) {
    __extends(ConfirmationDialog, _super);
    function ConfirmationDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    ConfirmationDialog.prototype.onContinueClick = function () {
        var _this = this;
        return this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.onContinueClick()];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.props.onClose();
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ConfirmationDialog.prototype.render = function () {
        var _this = this;
        var cont = React.createElement(ActionButton_1.ActionButton, { key: "Continue", label: this.props.continueButtonLabel || "Continue", type: this.props.continueButtonType || ActionButton_1.ActionButtonType.Save, busyLabel: this.props.continueButtonBusyLabel, disabled: this.state.busy, onClick: function () { return _this.onContinueClick(); } });
        var cancel = React.createElement(ActionButton_1.ActionButton, { key: "Cancel", label: "Cancel", disabled: this.state.busy, onClick: function () { return _this.props.onClose(); } });
        return React.createElement(Dialog_1.default, { open: this.props.open || false },
            React.createElement(DialogLayout_1.DialogLayout, { actions: [cancel, cont], title: this.props.title, titleIcon: React.createElement("em", { className: cn("fa fa-warning", styles.warningIcon) }), headerClassName: styles.dialogHeader, busy: this.state.busy, closeDialog: this.props.onClose, errors: this.state.errors }, this.props.open && this.props.children));
    };
    return ConfirmationDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = ConfirmationDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\ConfirmationDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\ConfirmationDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 735 */,
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1452);
var cn = __webpack_require__(19);
var ComponentRow = function (props) {
    return React.createElement("div", { className: cn(styles.componentRow, props.className) }, props.children);
};
ComponentRow.displayName = "ComponentRow";
exports.default = ComponentRow;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ComponentRow\\ComponentRow.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ComponentRow\\ComponentRow.tsx"); } } })();

/***/ }),
/* 737 */,
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataTable_1 = __webpack_require__(420);
var PagingBaseComponent_1 = __webpack_require__(460);
var lodash_1 = __webpack_require__(16);
var styles = __webpack_require__(1688);
var BusyIndicator_1 = __webpack_require__(98);
var cn = __webpack_require__(19);
var PagingBaseComponent_2 = __webpack_require__(179);
var Checkbox_1 = __webpack_require__(118);
var lodash_2 = __webpack_require__(16);
var InternalRedirect_1 = __webpack_require__(40);
var PagingDataTable = (function (_super) {
    __extends(PagingDataTable, _super);
    function PagingDataTable(props) {
        var _this = _super.call(this, props) || this;
        _this.empty = (React.createElement("div", null, "No results"));
        _this.toggleAllChecked = function (state) {
            var checkedItems = {};
            if (state) {
                checkedItems = _this.state.data.Items
                    .filter(function (item) { return _this.onFilter(_this.state.filter, item); })
                    .reduce(function (idx, item) {
                    idx[item.Id] = true;
                    return idx;
                }, {});
            }
            _this.setState({ checkedItems: checkedItems }, function () { return _this.props.onItemsChecked(Object.keys(checkedItems)); });
        };
        _this.itemChecked = function (item, state) {
            var checkedItems = __assign({}, _this.state.checkedItems);
            if (state) {
                checkedItems[item.Id] = true;
            }
            else {
                delete checkedItems[item.Id];
            }
            _this.setState({ checkedItems: checkedItems }, function () {
                _this.props.onItemsChecked(Object.keys(_this.state.checkedItems));
            });
        };
        _this.state = __assign({}, _this.state, { checkedItems: {} });
        _this.empty = props.empty || _this.empty;
        return _this;
    }
    PagingDataTable.prototype.componentWillUpdate = function (newProps, newState) {
        this.reEvaluateCheckedItems(newState);
    };
    PagingDataTable.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: true });
        }
        if (!this.state.data) {
            return React.createElement(BusyIndicator_1.default, { show: true });
        }
        var _a = this.props, onToolsSection = _a.onToolsSection, headerColumns = _a.headerColumns, headerColumnClassNames = _a.headerColumnClassNames, rowColumnClassName = _a.rowColumnClassName, onRow = _a.onRow, onEmpty = _a.onEmpty;
        var data = this.state.data;
        var thereIsData = data && data.Items && data.Items.length > 0;
        var items = thereIsData ?
            data.Items.filter(function (item) { return _this.onFilter(_this.state.filter, item); }) :
            null;
        var allChecked = thereIsData && items.length > 0 && this.props.onItemsChecked ?
            Object.keys(this.state.checkedItems).length === items.length :
            false;
        var fullColLength = this.props.onItemsChecked ? (headerColumns.length + 1) : headerColumns.length;
        return (React.createElement(DataTable_1.DataTable, null,
            React.createElement(DataTable_1.DataTableHeader, null,
                (this.props.filterSearchEnabled || onToolsSection) &&
                    React.createElement(DataTable_1.DataTableToolsRow, null,
                        React.createElement(DataTable_1.DataTableHeaderColumn, { colSpan: fullColLength },
                            this.renderFilterSearchComponents(),
                            onToolsSection && onToolsSection())),
                thereIsData
                    ? this.buildTableHeader(headerColumns, headerColumnClassNames, allChecked)
                    : null),
            React.createElement(DataTable_1.DataTableBody, null, thereIsData
                ? items.map(function (item, index) { return _this.buildTableRow(item, index, onRow(item), rowColumnClassName); })
                : React.createElement(DataTable_1.DataTableRow, { displayNoBorder: true },
                    React.createElement(DataTable_1.DataTableRowColumn, null, onEmpty ? onEmpty() : null))),
            thereIsData && data.Items.length < this.state.data.TotalResults
                ? React.createElement(DataTable_1.DataTableFooter, null,
                    React.createElement(DataTable_1.DataTableToolsRow, null,
                        React.createElement(DataTable_1.DataTableFooterColumn, { colSpan: fullColLength }, this.props.showPagingInNumberedStyle
                            ? this.showPagingInNumberedStyle()
                            : this.showPagingInLoadMoreStyle())))
                : null));
    };
    PagingDataTable.prototype.buildTableHeader = function (headerColumns, columnClassNames, allChecked) {
        var _this = this;
        return (React.createElement(DataTable_1.DataTableRow, null,
            this.props.onItemsChecked && React.createElement(DataTable_1.DataTableHeaderColumn, null,
                React.createElement(Checkbox_1.default, { noMargin: true, value: allChecked, onChange: function (state) { return _this.toggleAllChecked(state); } })),
            headerColumns.map(function (col, index) {
                var props = {
                    key: index
                };
                if (columnClassNames) {
                    var className = columnClassNames[index];
                    props["className"] = className;
                }
                return (React.createElement(DataTable_1.DataTableHeaderColumn, __assign({}, props), col));
            })));
    };
    PagingDataTable.prototype.buildTableRow = function (item, index, rowColumns, className) {
        var _this = this;
        // Only some tables include a redirect, so only show cursor if necessary.
        var redirectUrl = PagingBaseComponent_2.getNavigationUrl(this.props, item);
        var linkClassName = redirectUrl ? styles.linkableItem : null;
        return (React.createElement(DataTable_1.DataTableRow, { key: index, onClick: function (e) { return _this.navigate(item); } },
            this.props.onItemsChecked && React.createElement(DataTable_1.DataTableRowColumn, null,
                React.createElement(Checkbox_1.default, { value: !!this.state.checkedItems[item.Id], noMargin: true, onChange: function (val) { return _this.itemChecked(item, val); } })),
            rowColumns.map(function (col, idx) {
                var props = {
                    key: idx
                };
                if (className) {
                    props["className"] = cn(className, props["className"]);
                }
                if (linkClassName) {
                    props["className"] = cn(linkClassName, props["className"]);
                }
                return (React.createElement(DataTable_1.DataTableRowColumn, __assign({}, props), col));
            })));
    };
    // When the list is filtered or changed we need to re-evaluate which ones are selected.
    PagingDataTable.prototype.reEvaluateCheckedItems = function (newState) {
        var _this = this;
        if (!this.props.onItemsChecked || !newState.data) {
            return; // Selection isn't possible
        }
        if (this.state.data === newState.data && this.state.filter === newState.filter) {
            return; // Nothing has changed that should affect the selected items
        }
        var currentChecked = Object.keys(this.state.checkedItems);
        if (currentChecked.length === 0) {
            return; // Nothing selected already so no need to check what else has loaded
        }
        var validItems = newState.data.Items
            .filter(function (item) { return _this.onFilter(_this.state.filter, item); })
            .map(function (item) { return item.Id; });
        var newChecked = lodash_2.intersection(currentChecked, validItems)
            .reduce(function (idx, id) {
            idx[id] = true;
            return idx;
        }, {});
        // Only trigger change if there is a change in items
        if (!lodash_1.isEqual(currentChecked, Object.keys(newChecked))) {
            this.setState({ checkedItems: newChecked }, function () { return _this.props.onItemsChecked(Object.keys(_this.state.checkedItems)); });
        }
    };
    return PagingDataTable;
}(PagingBaseComponent_1.default));
exports.PagingDataTable = PagingDataTable;
PagingDataTable.defaultProps = {
    showFilterWithinSection: false,
    autoFocusOnFilterSearch: true
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PagingDataTable\\PagingDataTable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PagingDataTable\\PagingDataTable.tsx"); } } })();

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1714);
var Chips_1 = __webpack_require__(23);
var Card = function (props) {
    var header = null;
    if (props.isDisabled) {
        header = React.createElement("div", null,
            props.header,
            React.createElement("br", null),
            React.createElement(Chips_1.DisabledChip, null));
    }
    else {
        header = props.header;
    }
    return React.createElement("div", { className: cn(props.className, styles.container, props.isDisabled ? styles.disabled : null) },
        props.link && React.createElement("div", { className: styles.link }, props.link),
        React.createElement("div", { className: styles.logo }, props.logo),
        React.createElement("div", { className: styles.header }, header),
        React.createElement("div", { className: cn(styles.content, props.includeContentFade ? styles.contentFade : null) }, props.content),
        (props.footerText || props.footerIcon || props.footerBackgroundColor) && React.createElement("div", { className: styles.footer, style: { backgroundColor: props.footerBackgroundColor } },
            props.footerText,
            React.createElement("span", { className: styles.footerIcon }, props.footerIcon)),
        props.onHoverView && React.createElement("div", { className: styles.onHover }, props.onHoverView));
};
Card.displayName = "Card";
exports.default = Card;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Card\\Card.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Card\\Card.tsx"); } } })();

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cloud_1 = __webpack_require__(1803); //https://material.io/icons/#ic_cloud
exports.AzureIcon = cloud_1.default;
var lock_1 = __webpack_require__(1804); //https://material.io/icons/#ic_lock
exports.SshKeyIcon = lock_1.default;
var person_1 = __webpack_require__(1805); //https://material.io/icons/#ic_person
exports.UsernamePasswordIcon = person_1.default;
var SvgIcon_1 = __webpack_require__(21);
var resources_1 = __webpack_require__(26);
var colors_1 = __webpack_require__(32);
var AmazonIcon = function (props) { return (React.createElement(SvgIcon_1.default, __assign({}, props),
    React.createElement("path", { d: "M15.93,17.09C15.75,17.25 15.5,17.26 15.3,17.15C14.41,16.41 14.25,16.07 13.76,15.36C12.29,16.86 11.25,17.31 9.34,17.31C7.09,17.31 5.33,15.92 5.33,13.14C5.33,10.96 6.5,9.5 8.19,8.76C9.65,8.12 11.68,8 13.23,7.83V7.5C13.23,6.84 13.28,6.09 12.9,5.54C12.58,5.05 11.95,4.84 11.4,4.84C10.38,4.84 9.47,5.37 9.25,6.45C9.2,6.69 9,6.93 8.78,6.94L6.18,6.66C5.96,6.61 5.72,6.44 5.78,6.1C6.38,2.95 9.23,2 11.78,2C13.08,2 14.78,2.35 15.81,3.33C17.11,4.55 17,6.18 17,7.95V12.12C17,13.37 17.5,13.93 18,14.6C18.17,14.85 18.21,15.14 18,15.31L15.94,17.09H15.93M13.23,10.56V10C11.29,10 9.24,10.39 9.24,12.67C9.24,13.83 9.85,14.62 10.87,14.62C11.63,14.62 12.3,14.15 12.73,13.4C13.25,12.47 13.23,11.6 13.23,10.56M20.16,19.54C18,21.14 14.82,22 12.1,22C8.29,22 4.85,20.59 2.25,18.24C2.05,18.06 2.23,17.81 2.5,17.95C5.28,19.58 8.75,20.56 12.33,20.56C14.74,20.56 17.4,20.06 19.84,19.03C20.21,18.87 20.5,19.27 20.16,19.54M21.07,18.5C20.79,18.14 19.22,18.33 18.5,18.42C18.31,18.44 18.28,18.26 18.47,18.12C19.71,17.24 21.76,17.5 22,17.79C22.24,18.09 21.93,20.14 20.76,21.11C20.58,21.27 20.41,21.18 20.5,21C20.76,20.33 21.35,18.86 21.07,18.5Z" }))); };
exports.AmazonWebServicesIcon = AmazonIcon;
var AccountIcon = function (_a) {
    var accountType = _a.accountType, rest = __rest(_a, ["accountType"]);
    var defaults = { color: colors_1.secondaryText };
    switch (accountType) {
        case resources_1.AccountType.AmazonWebServicesAccount:
            return React.createElement(AmazonIcon, __assign({}, defaults, rest));
        case resources_1.AccountType.AzureServicePrincipal:
        case resources_1.AccountType.AzureSubscription:
            return React.createElement(cloud_1.default, __assign({}, defaults, rest));
        case resources_1.AccountType.SshKeyPair:
            return React.createElement(lock_1.default, __assign({}, defaults, rest));
        case resources_1.AccountType.UsernamePassword:
            return React.createElement(person_1.default, __assign({}, defaults, rest));
        default: return null;
    }
};
exports.AccountIcon = AccountIcon;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\components\\AccountsLayout\\AccountIcons.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\components\\AccountsLayout\\AccountIcons.tsx"); } } })();

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(96);
var typesafe_actions_1 = __webpack_require__(500);
exports.machineActions = {
    machineFetched: typesafe_actions_1.createAction("MACHINE_FETCHED", function (machine) { return ({ type: "MACHINE_FETCHED", payload: machine }); }),
    machineSaved: typesafe_actions_1.createAction("MACHINE_SAVED", function (machine) { return ({ type: "MACHINE_SAVED", payload: machine }); }),
    machineCleared: typesafe_actions_1.createAction("MACHINE_CLEARED")
};
var returnOfActions = Object.values(exports.machineActions).map(typesafe_actions_1.getReturnOfExpression);
var currentMachineReducer = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case typesafe_actions_1.getType(exports.machineActions.machineFetched):
        case typesafe_actions_1.getType(exports.machineActions.machineSaved):
            return action.payload;
        case typesafe_actions_1.getType(exports.machineActions.machineCleared):
            return null;
        default:
            return state;
    }
};
exports.default = redux_1.combineReducers({ current: currentMachineReducer });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\reducers\\machines.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\reducers\\machines.ts"); } } })();

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(96);
var ActionKeys;
(function (ActionKeys) {
    ActionKeys["TENANT_FETCHED"] = "TENANT_FETCHED";
    ActionKeys["TENANT_SAVED"] = "TENANT_SAVED";
    ActionKeys["TENANT_VARIABLES_FETCHED"] = "TENANT_VARIABLES_FETCHED";
    ActionKeys["TENANT_ENABLED_FETCHED"] = "TENANT_ENABLED_FETCHED";
    ActionKeys["OTHER_ACTION"] = "__any_other_action_type__";
})(ActionKeys || (ActionKeys = {}));
var currentTenantReducer = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case ActionKeys.TENANT_SAVED:
        case ActionKeys.TENANT_FETCHED:
            var tenant = action.tenant;
            return {
                name: tenant.Name,
                logoUrl: tenant.Links.Logo,
                id: tenant.Id,
                hasMissingVariables: false
            };
        case ActionKeys.TENANT_VARIABLES_FETCHED:
            return __assign({}, state, { hasMissingVariables: action.hasMissingVariables });
        default:
            return state;
    }
};
exports.tenantsActions = {
    tenantFetched: function (tenant) {
        return { type: ActionKeys.TENANT_FETCHED, tenant: tenant };
    },
    tenantSaved: function (tenant) {
        return { type: ActionKeys.TENANT_SAVED, tenant: tenant };
    },
    tenantMissingVariablesFetched: function (tenantMissingVariables) {
        return {
            type: ActionKeys.TENANT_VARIABLES_FETCHED,
            hasMissingVariables: !!tenantMissingVariables
        };
    }
};
exports.tenantsArea = redux_1.combineReducers({
    currentTenant: currentTenantReducer
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\tenants\\tenantsArea.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\tenants\\tenantsArea.ts"); } } })();

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(104);
var DateFormatter = (function () {
    function DateFormatter() {
    }
    DateFormatter.dateToShortFormat = function (dateTime) {
        if (!dateTime) {
            return null;
        }
        var dateMoment = moment(dateTime);
        return dateMoment.format("LLL");
    };
    DateFormatter.dateToLongFormat = function (dateTime) {
        if (!dateTime) {
            return null;
        }
        var dateMoment = moment(dateTime);
        return dateMoment.format("LLLL");
    };
    DateFormatter.dateToCustomFormat = function (dateTime, format) {
        if (!dateTime) {
            return null;
        }
        var dateMoment = moment(dateTime);
        return dateMoment.format(format);
    };
    DateFormatter.moment = function (input, format) {
        var when = new Date(Date.parse(input));
        var m = moment(when);
        format = format || "LLLL";
        var display = format === "ago" ? m.fromNow() : m.format(format);
        return display;
    };
    DateFormatter.momentAgo = function (input) {
        var when = new Date(Date.parse(input));
        return moment(when).fromNow();
    };
    DateFormatter.momentFrom = function (fromDate, toDate) {
        if (!fromDate) {
            return null;
        }
        var fromMoment = moment(fromDate);
        var toMoment = toDate ? moment(toDate) : moment();
        var diff = fromMoment.diff(toMoment);
        var duration = moment.duration(diff);
        var mins = duration.minutes();
        var hours = duration.hours();
        var days = Math.floor(duration.asDays());
        var result = (mins === 1 ? "1 minute" : mins + " minutes");
        result = (hours !== 0 ? (hours === 1 ? "1 hour" : hours + " hours") + " and " : "") + result;
        result = (days !== 0 ? (days === 1 ? "1 day" : days + " days") + ", " : "") + result;
        return result;
    };
    return DateFormatter;
}());
exports.default = DateFormatter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\DateFormatter\\DateFormatter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\DateFormatter\\DateFormatter.tsx"); } } })();

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var colors_1 = __webpack_require__(32);
var index_1 = __webpack_require__(68);
var MissingVariablesIcon = function (props) {
    if (!props.show) {
        return null;
    }
    return React.createElement(index_1.default, { content: "Some of the required variable values have not been set" },
        React.createElement("em", { className: "fa fa-warning", style: { color: colors_1.alert } }));
};
exports.default = MissingVariablesIcon;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\tenants\\MissingVariablesIcon\\MissingVariablesIcon.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\tenants\\MissingVariablesIcon\\MissingVariablesIcon.tsx"); } } })();

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(71);
var Chips_1 = __webpack_require__(23);
var LookupReferenceDataItemChip_1 = __webpack_require__(103);
var Chips_2 = __webpack_require__(23);
var ChannelTypedMultiSelect = MultiSelect_1.MultiSelect();
var ChannelMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Channel, chipRender: function (item) { return React.createElement(Chips_1.ChannelChip, { onRequestDelete: onRequestDelete, channelName: item.Name }); } });
    };
    return React.createElement(ChannelTypedMultiSelect, __assign({ items: props.items, fieldName: "channels", renderChip: chipRenderer }, props));
};
exports.default = ChannelMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\ChannelMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\ChannelMultiSelect.tsx"); } } })();

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(89);
var DataTableRowHeaderColumn = (function (_super) {
    __extends(DataTableRowHeaderColumn, _super);
    function DataTableRowHeaderColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableRowHeaderColumn.prototype.render = function () {
        var _a = this.props, className = _a.className, inSidebar = _a.inSidebar, otherProps = __rest(_a, ["className", "inSidebar"]);
        return (React.createElement("th", __assign({ className: cn(className, styles.dataTableRowHeaderColumn, inSidebar ? styles.dataTableRowHeaderColumnInSidebar : null) }, otherProps), this.props.children));
    };
    return DataTableRowHeaderColumn;
}(React.Component));
exports.DataTableRowHeaderColumn = DataTableRowHeaderColumn;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableRowHeaderColumn.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableRowHeaderColumn.tsx"); } } })();

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var clientInstance_1 = __webpack_require__(10);
var List_1 = __webpack_require__(279);
var CertificateSummary_1 = __webpack_require__(1851);
var routeLinks_1 = __webpack_require__(20);
var CertificateList = (function (_super) {
    __extends(CertificateList, _super);
    function CertificateList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CertificateList;
}(List_1.List));
var CertificateSearch = (function (_super) {
    __extends(CertificateSearch, _super);
    function CertificateSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.buildRow = function (certificate) {
            return [
                React.createElement(CertificateSummary_1.default, { onClick: function () {
                        if (!_this.props.onSelected) {
                            return;
                        }
                        _this.setState({ selectedId: certificate.Id }, function () {
                            _this.props.onSelected(certificate);
                        });
                    }, showSelection: _this.props.onSelected ? true : false, selected: certificate.Id === _this.state.selectedId, key: certificate.Id, certificate: certificate, environments: _this.state.environments, tenants: _this.state.tenants, tenantTags: _this.state.tenantTags })
            ];
        };
        _this.rowClicked = function (certificate) {
            if (_this.props.onSelected) {
                return null;
            }
            else {
                return routeLinks_1.default.library.certificate(certificate.Id);
            }
        };
        _this.state = {
            certificates: _this.props.certificates,
            environments: [],
            tenants: [],
            tenantTags: [],
            busy: false,
            selectedId: _this.props.selectedCertificateId
        };
        return _this;
    }
    CertificateSearch.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var certificates, environmentIds, tenantIds, _a, environments, tenants, tenantTags;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                certificates = this.state.certificates;
                                if (!!certificates) return [3 /*break*/, 2];
                                return [4 /*yield*/, clientInstance_1.repository.Certificates.list({ tenant: this.props.tenantId })];
                            case 1:
                                certificates = _b.sent();
                                _b.label = 2;
                            case 2:
                                environmentIds = certificates.Items.map(function (c) { return c.EnvironmentIds; }).reduce(function (list, ids) { return list.concat(ids); }, []);
                                tenantIds = certificates.Items.map(function (c) { return c.TenantIds; }).reduce(function (list, ids) { return list.concat(ids); }, []);
                                return [4 /*yield*/, Promise.all([
                                        clientInstance_1.repository.Environments.all({ ids: environmentIds }),
                                        clientInstance_1.repository.Tenants.all({ ids: tenantIds }),
                                        clientInstance_1.repository.TagSets.all()
                                    ])];
                            case 3:
                                _a = _b.sent(), environments = _a[0], tenants = _a[1], tenantTags = _a[2];
                                this.setState({
                                    certificates: certificates,
                                    environments: environments,
                                    tenants: tenants,
                                    tenantTags: tenantTags
                                });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    CertificateSearch.prototype.applyFilter = function (filter, resource) {
        return !filter || filter.length === 0 || !resource
            || resource.Name.toLowerCase().includes(filter.toLowerCase())
            || (resource.SubjectCommonName && resource.SubjectCommonName.toLowerCase().includes(filter.toLowerCase()))
            || resource.Thumbprint.toLowerCase().includes(filter.toLowerCase());
    };
    CertificateSearch.prototype.render = function () {
        // Note: This is wrapped in a <div> on purpose for CSS transition animations.
        return React.createElement("div", null, this.state.certificates && React.createElement(CertificateList, { initialData: this.state.certificates, onRow: this.buildRow, onRowRedirectUrl: this.rowClicked, onFilter: this.applyFilter, filterSearchEnabled: true, apiSearchParams: ["partialName"], selectedId: this.state.selectedId, filterHintText: "Filter by name, subject, or thumbprint" }));
    };
    return CertificateSearch;
}(BaseComponent_1.default));
exports.default = CertificateSearch;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\CertificateSearch\\CertificateSearch.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\CertificateSearch\\CertificateSearch.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(96);
var typesafe_actions_1 = __webpack_require__(500);
var clientInstance_1 = __webpack_require__(10);
var lodash_1 = __webpack_require__(16);
exports.accountActions = {
    fetchAll: typesafe_actions_1.createAction("ACCOUNTS_FETCH_ALL_REQUEST"),
    fetch: typesafe_actions_1.createAction("ACCOUNTS_FETCH_REQUEST"),
    fetchError: typesafe_actions_1.createAction("ACCOUNTS_FETCH_ERROR", function (error) { return ({ type: "ACCOUNTS_FETCH_ERROR", payload: error }); }),
    fetchAllSuccess: typesafe_actions_1.createAction("ACCOUNTS_FETCH_ALL_SUCCESS", function (accounts) { return ({ type: "ACCOUNTS_FETCH_ALL_SUCCESS", payload: accounts }); }),
    fetchSuccess: typesafe_actions_1.createAction("ACCOUNT_FETCH_SUCCESS", function (account) { return ({ type: "ACCOUNT_FETCH_SUCCESS", payload: account }); })
};
var returnOfActions = Object.values(exports.accountActions).map(typesafe_actions_1.getReturnOfExpression);
var accountIdsReducer = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case typesafe_actions_1.getType(exports.accountActions.fetchAllSuccess):
            return action.payload.map(function (x) { return x.Id; });
        case typesafe_actions_1.getType(exports.accountActions.fetchSuccess):
            return state.concat([action.payload.Id]);
        default: return state;
    }
};
var convertResource = function (account) { return ({
    accountId: account.Id,
    accountType: account.AccountType,
    name: account.Name,
    description: account.Description
}); };
var accountsByIdReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case typesafe_actions_1.getType(exports.accountActions.fetchAllSuccess):
            return __assign({}, state, lodash_1.keyBy(action.payload.map(convertResource), function (x) { return x.accountId; }));
        case typesafe_actions_1.getType(exports.accountActions.fetchSuccess):
            return __assign({}, state, (_a = {}, _a[action.payload.Id] = convertResource(action.payload), _a));
        default: return state;
    }
    var _a;
};
function fetchAllAccounts() {
    return function (dispatch) {
        dispatch(exports.accountActions.fetchAll());
        return clientInstance_1.repository.Accounts.all().then(function (result) {
            dispatch(exports.accountActions.fetchAllSuccess(result));
        }).catch(function (error) {
            dispatch(exports.accountActions.fetchError(error));
        });
    };
}
exports.fetchAllAccounts = fetchAllAccounts;
exports.default = redux_1.combineReducers({ byId: accountsByIdReducer, allIds: accountIdsReducer });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\reducers\\accounts.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\reducers\\accounts.ts"); } } })();

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getInfrastructureState = function (state) { return state.infrastructureArea; };
var getAccountsState = function (state) { return getInfrastructureState(state).accounts; };
var getMachinesState = function (state) { return getInfrastructureState(state).machines; };
var getAccounts = function (state) { return getAccountsState(state).byId; };
exports.getAccountById = function (state, props) {
    return getAccounts(state)[props.accountId];
};
exports.getCurrentMachine = function (state) { return getMachinesState(state).current; };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\reducers\\selectors.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\reducers\\selectors.ts"); } } })();

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
var ActionTemplateActions = {
    ACTIONTEMPLATE_FETCHED: "ACTIONTEMPLATE_FETCHED",
};
function actionTemplateFetch(actionTemplate) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var usages, pendingUpdates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, clientInstance_1.repository.ActionTemplates.getUsage(actionTemplate)];
                case 1:
                    usages = _a.sent();
                    pendingUpdates = usages.filter(function (u) { return u.Version.toString() !== actionTemplate.Version.toString(); }).length;
                    dispatch(actionTemplateFetched({
                        id: actionTemplate.Id,
                        name: actionTemplate.Name,
                        logo: actionTemplate.Links["Logo"],
                        pendingUpdates: pendingUpdates
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
}
exports.actionTemplateFetch = actionTemplateFetch;
function actionTemplateFetched(state) {
    return { type: ActionTemplateActions.ACTIONTEMPLATE_FETCHED, state: state };
}
exports.actionTemplateFetched = actionTemplateFetched;
var libraryArea = function (state, action) {
    if (state === void 0) { state = { currentActionTemplate: null }; }
    switch (action.type) {
        case ActionTemplateActions.ACTIONTEMPLATE_FETCHED:
            var actionTemplate = action.state;
            return {
                currentActionTemplate: {
                    id: actionTemplate.id,
                    name: actionTemplate.name,
                    logo: actionTemplate.logo,
                    pendingUpdates: actionTemplate.pendingUpdates
                }
            };
        default:
            return state;
    }
};
exports.default = libraryArea;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\library\\reducers\\libraryArea.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\library\\reducers\\libraryArea.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 751 */,
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1605);
var DialogLayout_1 = __webpack_require__(141);
var Dialog_1 = __webpack_require__(121);
var ActionButton_1 = __webpack_require__(50);
var Text_1 = __webpack_require__(17);
var ColorPicker = (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (value) {
            if (_this.props.validate) {
                var result = _this.props.validate(value);
                _this.setState({ error: result });
                if (_this.props.onValidate) {
                    _this.props.onValidate(result);
                }
            }
            _this.props.onChange(value);
        };
        _this.renderPaletteSwatch = function (color) {
            return React.createElement("a", { key: color, className: styles.colorPickItem, style: { backgroundColor: color }, title: color, onClick: function (e) {
                    e.preventDefault();
                    _this.handleChange(color);
                    _this.setState({ pickerOpen: false });
                } });
        };
        _this.state = {
            pickerOpen: false,
            error: null
        };
        return _this;
    }
    ColorPicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, label = _a.label, validate = _a.validate, error = _a.error, onChange = _a.onChange, onValidate = _a.onValidate, defaultColor = _a.defaultColor, value = _a.value, warning = _a.warning;
        var err = this.state.error || error;
        var errorText = err || warning;
        var val = value ? value : "";
        var colorSet1 = ["#983230", "#A77B22", "#227647", "#52818C", "#203A88", "#752BA5", "#6e6e6e"];
        var colorSet2 = ["#E8634F", "#ECAD3F", "#36A766", "#77B7C5", "#3156B3", "#9786A7", "#9d9d9d"];
        var cancel = React.createElement(ActionButton_1.default, { key: "CancelButton", label: "Cancel", onClick: function () { return _this.setState({ pickerOpen: false }); } });
        return (React.createElement("div", { className: styles.container },
            React.createElement(Text_1.default, { id: id, hintText: defaultColor, value: val, onChange: this.handleChange, error: errorText, label: label }),
            React.createElement("a", { className: styles.colorSwatch, style: { backgroundColor: val || defaultColor }, onClick: function (e) {
                    e.preventDefault();
                    _this.setState({ pickerOpen: true });
                } }),
            React.createElement(Dialog_1.default, { open: this.state.pickerOpen || false },
                React.createElement(DialogLayout_1.DialogLayout, { actions: [cancel], title: "Standard Palette", busy: null, closeDialog: function () { return _this.setState({ pickerOpen: false }); }, errors: null },
                    React.createElement("div", null,
                        React.createElement("div", { className: styles.colorAllOptions }, colorSet1.map(this.renderPaletteSwatch)),
                        React.createElement("div", { className: styles.colorAllOptions }, colorSet2.map(this.renderPaletteSwatch)))))));
    };
    return ColorPicker;
}(React.Component));
exports.default = ColorPicker;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\ColorPicker\\ColorPicker.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\ColorPicker\\ColorPicker.tsx"); } } })();

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ByteSizeFormatter_1 = __webpack_require__(754);
var Text_1 = __webpack_require__(17);
var InputWithActions_1 = __webpack_require__(145);
var IconButtonList_1 = __webpack_require__(109);
var IconButton_1 = __webpack_require__(56);
var MaxFileSize = Math.pow(1024, 5);
var SensitiveFileUpload = (function (_super) {
    __extends(SensitiveFileUpload, _super);
    function SensitiveFileUpload(props) {
        var _this = _super.call(this, props) || this;
        _this.openSelector = function (e) {
            e.preventDefault();
            _this.input.click();
        };
        _this.handleFileChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var files, file, bytes, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ error: null });
                        files = e.currentTarget.files;
                        if (files.length < 1) {
                            return [2 /*return*/];
                        }
                        file = files[0];
                        if (file.size === 0) {
                            this.reportError("Attached file is empty. Please select a different file.");
                            return [2 /*return*/];
                        }
                        if (file.size > MaxFileSize) {
                            this.reportError("Selected file is too big!");
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.loadFileBytes(file)];
                    case 2:
                        bytes = _a.sent();
                        this.props.onChange({ HasValue: true, NewValue: bytes });
                        this.setState({ selectedFile: file });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.setState({ error: err_1 });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.currentValue = function () {
            return _this.props.value || {
                HasValue: false,
            };
        };
        _this.handleSetOrChange = function () {
            _this.input.click();
        };
        _this.handleRemove = function (e) {
            _this.input.value = null;
            _this.setState({
                selectedFile: null
            }, function () {
                _this.props.onChange({
                    HasValue: false
                });
            });
        };
        _this.noop = function () {
            // Empty on purpose
        };
        _this.state = {};
        return _this;
    }
    SensitiveFileUpload.prototype.reportError = function (error) {
        this.setState({ error: error, selectedFile: null });
    };
    SensitiveFileUpload.prototype.loadFileBytes = function (file) {
        return new Promise(function (res, rej) {
            var reader = new FileReader();
            reader.onload = function (evt) {
                var target = evt.target;
                if (target.readyState === FileReader.DONE) {
                    var b6 = target.result.indexOf("base64,") + 7;
                    var ress = target.result.slice(b6);
                    res(ress);
                }
            };
            reader.onerror = function (evt) {
                rej(evt.message);
            };
            reader.readAsDataURL(file);
        });
    };
    SensitiveFileUpload.prototype.getName = function () {
        if (this.props.value && this.props.value.HasValue && this.props.value.NewValue === null) {
            return this.props.availablePlaceholder || "A file exists";
        }
        var selectedFile = this.state.selectedFile;
        if (selectedFile) {
            return selectedFile.name + " (" + ByteSizeFormatter_1.default(selectedFile.size) + ")";
        }
        return this.props.hintText || "";
    };
    SensitiveFileUpload.prototype.render = function () {
        var _this = this;
        var currentValue = this.currentValue();
        var setOrChange = currentValue.HasValue ? "Change file" : "Choose file";
        var _a = this.props, error = _a.error, warning = _a.warning, label = _a.label, onChange = _a.onChange, value = _a.value, hintText = _a.hintText;
        var err = this.state.error || error;
        var errorText = err || warning;
        return React.createElement("div", null,
            React.createElement(InputWithActions_1.default, { input: React.createElement(Text_1.default, { type: "text", hintText: hintText, value: this.getName(), label: label, onChange: this.noop, onClick: this.openSelector, error: errorText }), actions: React.createElement(IconButtonList_1.default, { buttons: this.buttons(setOrChange, currentValue) }) }),
            React.createElement("input", { type: "file", style: { display: "none" }, onChange: this.handleFileChange, ref: function (input) { return _this.input = input; } }));
    };
    SensitiveFileUpload.prototype.buttons = function (uploadText, currentValue) {
        return [
            React.createElement(IconButton_1.default, { toolTipContent: uploadText, onClick: this.handleSetOrChange, icon: IconButton_1.Icon.Upload }),
            currentValue.HasValue ? React.createElement(IconButton_1.default, { toolTipContent: "Remove file", onClick: this.handleRemove, icon: IconButton_1.Icon.Remove }) : null
        ].filter(function (b) { return !!b; });
    };
    return SensitiveFileUpload;
}(React.Component));
exports.default = SensitiveFileUpload;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\SensitiveFileUpload\\SensitiveFileUpload.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\SensitiveFileUpload\\SensitiveFileUpload.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ByteSizeFormatter_1 = __webpack_require__(1613);
exports.default = ByteSizeFormatter_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ByteSizeFormatter\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ByteSizeFormatter\\index.tsx"); } } })();

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Chip_1 = __webpack_require__(285);
var Chips_1 = __webpack_require__(23);
var UserChip = function (props) {
    var user = props.user, rest = __rest(props, ["user"]);
    var name = userDisplayName(user);
    var description = "User: " + name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), name);
};
exports.UserChip = UserChip;
function userDisplayName(resource) {
    return resource.DisplayName !== resource.Username
        ? resource.DisplayName + " (" + resource.Username + ")"
        : resource.DisplayName;
}
exports.userDisplayName = userDisplayName;
function userList(set, selectedIds) {
    return Chips_1.matchesToChips(set, selectedIds, function (x) { return React.createElement(UserChip, { user: x, key: x.Id }); });
}
exports.userList = userList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Chips\\UserChip.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Chips\\UserChip.tsx"); } } })();

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1674);
var NothingToSeeHere = (function (_super) {
    __extends(NothingToSeeHere, _super);
    function NothingToSeeHere() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NothingToSeeHere.prototype.render = function () {
        return React.createElement("span", { className: styles.content }, this.props.content);
    };
    return NothingToSeeHere;
}(React.Component));
exports.NothingToSeeHere = NothingToSeeHere;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\NothingToSeeHere\\NothingToSeeHere.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\NothingToSeeHere\\NothingToSeeHere.tsx"); } } })();

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(16);
var InternalLink_1 = __webpack_require__(42);
var routeLinks_1 = __webpack_require__(20);
var documentTypeToLinkLookups = lodash_1.memoize(function (spaceId) { return linksFor(spaceId); });
function linkTo(documentId, documentType, spaceId) {
    if (!documentId || !documentType) {
        return "";
    }
    var documentTypeSpecificLink = documentTypeToLinkLookups(spaceId)[documentType];
    if (!documentTypeSpecificLink) {
        return "/not-found";
    }
    return documentTypeSpecificLink(documentId);
}
exports.EventFormatter = function (props) {
    var message = props.event.Message;
    var references = props.event.MessageReferences;
    var indexes = !references || references.length === 0 ? [{ reference: null, index: 0 }, { reference: null, index: message.length }]
        : toIndexes(references, message);
    var last = null;
    var parts = [];
    indexes.map(function (index) {
        if (last) {
            parts.push({ reference: last.reference, message: message.substring(last.index, index.index) });
        }
        last = index;
    });
    var encodedParts = parts.map(function (part) {
        var encodedMessage = React.createElement("span", null, part.message);
        if (part.reference) {
            var documentId = part.reference.ReferencedDocumentId;
            var documentType = retrieveDocumentTypeFromId(documentId);
            if (documentType !== "interruption") {
                return React.createElement(InternalLink_1.default, { to: linkTo(documentId, documentType, "") }, encodedMessage);
            }
            else {
                return encodedMessage;
            }
        }
        else {
            return encodedMessage;
        }
    });
    return (React.createElement("span", null, React.Children.toArray(encodedParts)));
};
function retrieveDocumentTypeFromId(documentId) {
    var index = documentId.indexOf("-");
    return index === -1 ? null : documentId.substr(0, index).toLowerCase();
}
function toIndexes(references, message) {
    var indexes = [];
    var refStart = references[0];
    if (refStart.StartIndex !== 0) {
        indexes.push({ reference: null, index: 0 });
    }
    var lastRef = null;
    references.forEach(function (reference) {
        if (!lastRef || lastRef.StartIndex !== reference.StartIndex) {
            indexes.push({ reference: reference, index: reference.StartIndex });
        }
        indexes.push({ reference: null, index: reference.StartIndex + reference.Length });
        lastRef = reference;
    });
    var refEnd = references[references.length - 1];
    var endIndex = (refEnd.StartIndex + refEnd.Length);
    if (endIndex !== message.length) {
        indexes.push({ reference: null, index: message.length });
    }
    return indexes;
}
function linksFor(spaceId) {
    var lookup = {};
    var routeLinks = routeLinks_1.parameterizedRouteLinks(spaceId ? spaceId : "");
    lookup["actiontemplates"] = function (id) { return routeLinks.library.stepTemplate(id).root; };
    lookup["deployments"] = function (id) { return routeLinks.deployment(id).root; };
    lookup["environments"] = function (id) { return routeLinks.infrastructure.environment(id); };
    lookup["feeds"] = function (id) { return routeLinks.library.feed(id).root; };
    lookup["libraryvariablesets"] = function (id) { return routeLinks.library.variableSet(id); };
    lookup["lifecycles"] = function (id) { return routeLinks.library.lifecycle(id); };
    lookup["machinepolicies"] = function (id) { return routeLinks.infrastructure.machinePolicy(id); };
    lookup["machines"] = function (id) { return routeLinks.infrastructure.machine(id).root; };
    lookup["projects"] = function (id) { return routeLinks.project(id).root; };
    lookup["projectgroups"] = function (id) { return routeLinks.projectGroup(id).root; };
    lookup["proxys"] = function (id) { return routeLinks.infrastructure.proxy(id); };
    lookup["proxies"] = function (id) { return routeLinks.infrastructure.proxy(id); };
    lookup["releases"] = function (id) { return routeLinks.release(id); };
    lookup["servertasks"] = function (id) { return routeLinks.task(id).root; };
    lookup["tagsets"] = function (id) { return routeLinks.library.tagSet(id); };
    lookup["teams"] = function (id) { return routeLinks.configuration.team(id); };
    lookup["tenants"] = function (id) { return routeLinks.tenant(id).root; };
    lookup["users"] = function (id) { return routeLinks.configuration.user(id); };
    lookup["subscriptions"] = function (id) { return routeLinks.configuration.subscription(id); };
    lookup["certificates"] = function (id) { return routeLinks.library.certificate(id); };
    lookup["projecttriggers"] = function (id) { return routeLinks.trigger(id); };
    lookup["channels"] = function (id) { return routeLinks.channel(id); };
    return lookup;
}
exports.default = exports.EventFormatter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EventFormatter\\EventFormatter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EventFormatter\\EventFormatter.tsx"); } } })();

/***/ }),
/* 758 */,
/* 759 */,
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var feedResource_1 = __webpack_require__(54);
var ParseHelper_1 = __webpack_require__(75);
var _ = __webpack_require__(16);
var DeploymentActionResource = (function (_super) {
    __extends(DeploymentActionResource, _super);
    function DeploymentActionResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeploymentActionResource;
}(resource_1.default));
exports.DeploymentActionResource = DeploymentActionResource;
exports.default = DeploymentActionResource;
function IsPackageAction(action) {
    return !!action.Properties["Octopus.Action.Package.PackageId"];
}
exports.IsPackageAction = IsPackageAction;
function IsDeployReleaseAction(action) {
    return !!action.Properties["Octopus.Action.DeployRelease.ProjectId"];
}
exports.IsDeployReleaseAction = IsDeployReleaseAction;
function GetFeedId(action) {
    return IsDeployReleaseAction(action)
        ? feedResource_1.OctopusReleaseFeedId
        : action.Properties["Octopus.Action.Package.FeedId"];
}
exports.GetFeedId = GetFeedId;
function HasManualInterventionResponsibleTeams(action) {
    return _.some(ParseHelper_1.default.parseCSV(action.Properties["Octopus.Action.Manual.ResponsibleTeamIds"]));
}
exports.HasManualInterventionResponsibleTeams = HasManualInterventionResponsibleTeams;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\deploymentActionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\deploymentActionResource.ts"); } } })();

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var styles = __webpack_require__(243);
var DeleteDialog_1 = __webpack_require__(452);
var ActionButton_1 = __webpack_require__(50);
var OpenDeleteDialogButton = (function (_super) {
    __extends(OpenDeleteDialogButton, _super);
    function OpenDeleteDialogButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { open: false };
        return _this;
    }
    OpenDeleteDialogButton.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { className: styles.buttonWrapper },
            React.createElement(ActionButton_1.default, { type: this.props.type || ActionButton_1.ActionButtonType.Delete, onClick: function () { return _this.setState({ open: true }); }, label: this.props.label, disabled: this.props.disabled }),
            React.createElement(DeleteDialog_1.default, { title: this.props.dialogTitle, deleteButtonLabel: this.props.dialogButtonLabel, deleteButtonBusyLabel: this.props.dialogButtonBusyLabel, open: this.state.open, onClose: function () { return _this.setState({ open: false }); }, onDeleteClick: function () { return _this.props.onDeleteClick(); } }, this.props.children));
    };
    return OpenDeleteDialogButton;
}(BaseComponent_1.BaseComponent));
exports.default = OpenDeleteDialogButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Button\\OpenDeleteDialogButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Button\\OpenDeleteDialogButton.tsx"); } } })();

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VariablesTab;
(function (VariablesTab) {
    VariablesTab["CommonVariables"] = "commonVariables";
    VariablesTab["ProjectVariables"] = "projectVariables";
})(VariablesTab = exports.VariablesTab || (exports.VariablesTab = {}));
exports.default = function (root) { return ({
    tenants: root + "/tenants",
    tenant: function (tenantId) {
        if (typeof tenantId !== "string") {
            tenantId = tenantId.Id;
        }
        var specificRoot = root + "/tenants/" + tenantId;
        return {
            root: specificRoot,
            overview: specificRoot + "/overview",
            settings: specificRoot + "/settings",
            variables: function (activeTab) {
                return {
                    pathname: specificRoot + "/variables",
                    search: activeTab ? "?activeTab=" + activeTab : ""
                };
            }
        };
    },
    v3tenantRoutes: {
        newTenant: root + "/tenants/new"
    }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\tenants\\TenantsRoutes\\tenantRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\tenants\\TenantsRoutes\\tenantRouteLinks.ts"); } } })();

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ComponentRow_1 = __webpack_require__(736);
exports.default = ComponentRow_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ComponentRow\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ComponentRow\\index.tsx"); } } })();

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// copied from material-ui so that we can set tabIndex
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var keyboard_arrow_up_1 = __webpack_require__(454);
var keyboard_arrow_down_1 = __webpack_require__(455);
var IconButton_1 = __webpack_require__(63);
var CardExpandable = (function (_super) {
    __extends(CardExpandable, _super);
    function CardExpandable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardExpandable.prototype.render = function () {
        return (React.createElement(IconButton_1.default, { onClick: this.props.onExpanding, tabIndex: this.props.tabIndex, title: this.props.expanded ? "Collapse" : "Expand" }, this.props.expanded ? React.createElement(keyboard_arrow_up_1.default, null) : React.createElement(keyboard_arrow_down_1.default, null)));
    };
    CardExpandable.contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    return CardExpandable;
}(React.Component));
exports.default = CardExpandable;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\CardExpandable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\CardExpandable.tsx"); } } })();

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActionList_1 = __webpack_require__(277);
exports.default = ActionList_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionList\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionList\\index.tsx"); } } })();

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Lookup_1 = __webpack_require__(457);
var Chips_1 = __webpack_require__(23);
var LookupReferenceDataItemChip = function (props) {
    return React.createElement(Lookup_1.default, { lookupCollection: props.lookupCollection, lookupId: props.lookupId, getIdFromElement: function (element) { return element.Id; }, render: function (item) { return props.chipRender(item); }, renderFallback: React.createElement(Chips_1.MissingChip, { lookupId: props.lookupId, type: props.type }) });
};
exports.default = LookupReferenceDataItemChip;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LookupReferenceDataItemChip\\LookupReferenceDataItemChip.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LookupReferenceDataItemChip\\LookupReferenceDataItemChip.tsx"); } } })();

/***/ }),
/* 767 */,
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var PagingDataTable_1 = __webpack_require__(738);
var EventFormatter_1 = __webpack_require__(757);
var clientInstance_1 = __webpack_require__(10);
var permission_1 = __webpack_require__(49);
var PermissionCheck_1 = __webpack_require__(427);
var Callout_1 = __webpack_require__(59);
var ExternalLink_1 = __webpack_require__(29);
var Button_1 = __webpack_require__(51);
var EventDetails_1 = __webpack_require__(792);
var TimeFromNowLabel_1 = __webpack_require__(424);
var styles = __webpack_require__(1692);
var EventListingDataTable = (function (_super) {
    __extends(EventListingDataTable, _super);
    function EventListingDataTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventListingDataTable;
}(PagingDataTable_1.PagingDataTable));
var EventListing = (function (_super) {
    __extends(EventListing, _super);
    function EventListing(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnEmpty = function () {
            return (React.createElement("div", null,
                "No events found, or ",
                React.createElement(ExternalLink_1.default, { href: "UserRoles" }, "your permissions"),
                " reduced what you can see."));
        };
        _this.handleShowHideDetails = function (event) {
            event.detailsVisible = !event.detailsVisible;
            _this.setState({});
        };
        _this.state = {
            data: null
        };
        return _this;
    }
    EventListing.prototype.render = function () {
        var _this = this;
        var initialData = this.state.data ? this.state.data : this.props.data;
        return React.createElement("div", null,
            React.createElement(PermissionCheck_1.PermissionCheck, { permission: permission_1.Permission.EventView, wildcard: true, alternate: React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                    "The ",
                    permission_1.Permission.EventView,
                    " permission is required to view results here.") }, initialData
                ? React.createElement(EventListingDataTable, { initialData: initialData, onRow: function (item) { return _this.buildAuditRow(item); }, headerColumns: ["When", "Who", "What"], headerColumnClassNames: [styles.headerColumnOccurredDate, styles.headerColumnFixedWidth, null], onEmpty: this.handleOnEmpty, showPagingInNumberedStyle: true, onPageSelected: function (skip, p) { return __awaiter(_this, void 0, void 0, function () {
                        var result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, clientInstance_1.repository.Events.list({ regarding: this.props.regarding, skip: skip })];
                                case 1:
                                    result = _a.sent();
                                    this.setState({ data: result });
                                    return [2 /*return*/];
                            }
                        });
                    }); } })
                : React.createElement("div", null, this.props.noDataMessage || "There's no data to show.")));
    };
    EventListing.prototype.buildAuditRow = function (event) {
        var _this = this;
        return [
            React.createElement("div", null,
                React.createElement(TimeFromNowLabel_1.default, { time: event.Occurred, useShortDateFormat: false })),
            React.createElement("div", { title: event.IdentityEstablishedWith }, event.Username),
            React.createElement("div", null,
                React.createElement(EventFormatter_1.EventFormatter, { event: event }),
                event.Details &&
                    React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Ternary, label: event.detailsVisible ? "hide details" : "show details", onClick: function () { return _this.handleShowHideDetails(event); } }),
                event.Details && event.detailsVisible && React.createElement(EventDetails_1.default, { eventDetails: event.Details }))
        ];
    };
    return EventListing;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = EventListing;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EventListing\\EventListing.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EventListing\\EventListing.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IdHelper_1 = __webpack_require__(1700);
exports.default = IdHelper_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\IdHelper\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\IdHelper\\index.tsx"); } } })();

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(462);
var ExecutingIcon_1 = __webpack_require__(1724);
var phaseHelpers_1 = __webpack_require__(674);
var PhaseStatusIcon = function (props) {
    var classes = getClasses(props.phase, props.status, props.environmentId);
    return showExecutingIcon(classes)
        ? React.createElement(ExecutingIcon_1.default, null)
        : React.createElement("span", { className: cn(styles.phaseIcon, classes) });
};
var showExecutingIcon = function (classes) {
    return classes[styles.executing]
        && !classes[styles.queued]
        && !classes[styles.warning]
        && !classes[styles.skipped];
};
var getClasses = function (phase, status, environmentId) {
    if (!environmentId) {
        return _a = {},
            _a[styles.optional] = phase.IsOptionalPhase,
            _a[styles.blocked] = status.progress[phase.Name] === "Blocked",
            _a[styles.current] = status.progress[phase.Name] === "Current",
            _a[styles.complete] = status.progress[phase.Name] === "Complete",
            _a[styles.automatic] = phase.AutomaticDeploymentTargets.length > 0,
            _a[styles.deployed] = status.deployed[phaseHelpers_1.getSingleDeploymentTarget(phase)],
            _a[styles.executing] = status.executing[phaseHelpers_1.getSingleDeploymentTarget(phase)],
            _a[styles.queued] = status.queued[phaseHelpers_1.getSingleDeploymentTarget(phase)],
            _a[styles.warning] = status.warning[phaseHelpers_1.getSingleDeploymentTarget(phase)],
            _a[styles.skipped] = phaseHelpers_1.getSkippedState(phase, status),
            _a;
    }
    else {
        return _b = {},
            _b[styles.blocked] = phase.AutomaticDeploymentTargets.length > 0 ? false : status.progress[phase.Name] === "Blocked",
            _b[styles.automatic] = status.deployed[environmentId] ? false : phase.AutomaticDeploymentTargets.some(function (envId) { return envId === environmentId; }),
            _b[styles.deployed] = status.deployed[environmentId],
            _b[styles.warning] = status.warning[environmentId],
            _b[styles.executing] = status.executing[environmentId],
            _b[styles.queued] = status.queued[environmentId],
            _b[styles.skipped] = phase.IsOptionalPhase && !status.deployed[environmentId] && status.progress[phase.Name] !== "Blocked",
            _b;
    }
    var _a, _b;
};
exports.default = PhaseStatusIcon;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PhaseStatusIcon\\PhaseStatusIcon.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PhaseStatusIcon\\PhaseStatusIcon.tsx"); } } })();

/***/ }),
/* 771 */,
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Summary_1 = __webpack_require__(70);
var resources_1 = __webpack_require__(26);
var Options_1 = __webpack_require__(698);
var ActionTemplateParameterInput_1 = __webpack_require__(396);
var ExpandableFormSection_1 = __webpack_require__(44);
var ActionTemplateParameterInputRenderer_1 = __webpack_require__(802);
var ActionTemplateParameterInputExpandableFormElement = (function (_super) {
    __extends(ActionTemplateParameterInputExpandableFormElement, _super);
    function ActionTemplateParameterInputExpandableFormElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionTemplateParameterInputExpandableFormElement.prototype.shouldComponentUpdate = function (newProps) {
        return ActionTemplateParameterInputRenderer_1.hasParameterChanged(newProps, this.props);
    };
    ActionTemplateParameterInputExpandableFormElement.prototype.render = function () {
        var _a = this.props, isExpandedByDefault = _a.isExpandedByDefault, customHelpText = _a.customHelpText, inputProps = __rest(_a, ["isExpandedByDefault", "customHelpText"]);
        var parameter = inputProps.parameter;
        var options = Options_1.default(parameter.DisplaySettings["Octopus.SelectOptions"]);
        var type = parameter.DisplaySettings["Octopus.ControlType"];
        var label = ActionTemplateParameterInputRenderer_1.getLabel(parameter);
        return React.createElement(ExpandableFormSection_1.default, { errorKey: parameter.Name, title: label, isExpandedByDefault: isExpandedByDefault, help: ActionTemplateParameterInputRenderer_1.getHelpText(parameter, customHelpText), summary: createSummaryFor(label, type, options)(this.props.value) },
            React.createElement(ActionTemplateParameterInput_1.default, __assign({}, inputProps)));
    };
    return ActionTemplateParameterInputExpandableFormElement;
}(React.Component));
exports.default = ActionTemplateParameterInputExpandableFormElement;
function createSummaryFor(label, type, options) {
    return function (value) {
        if (value === undefined || value === null) {
            return Summary_1.default.placeholder("Provide " + label);
        }
        if (typeof value === "object") {
            return Summary_1.default.summary("******");
        }
        if (type === resources_1.ControlType.Select) {
            var option = options.find(function (o) { return o.value === value; });
            if (option) {
                return Summary_1.default.summary(option.text);
            }
        }
        return Summary_1.default.summary(value);
    };
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplateParameterInput\\ActionTemplateParameterInputExpandableFormElement.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplateParameterInput\\ActionTemplateParameterInputExpandableFormElement.tsx"); } } })();

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var URI = __webpack_require__(106);
var URITemplate = __webpack_require__(913);
// The Resolver is used to take URI's like "/api/foo/bar" and turn them into
// fully qualified URI's depending on the Octopus
// server we are talking to (e.g.,
// http://your-octopus/api/foo/bar or perhaps even, http://your-octopus/vdir1/vdir2/api/foo/bar).
var Resolver = (function () {
    function Resolver(baseUri) {
        this.baseUri = baseUri;
        this.baseUri = this.baseUri.endsWith("/") ? this.baseUri : this.baseUri + "/";
        var lastIndexOfMandatorySegment = this.baseUri.lastIndexOf("/api/");
        if (lastIndexOfMandatorySegment >= 1) {
            this.baseUri = this.baseUri.substring(0, lastIndexOfMandatorySegment);
        }
        else {
            if (this.baseUri.endsWith("/api")) {
                this.baseUri = this.baseUri.substring(0, -4);
            }
        }
        this.baseUri = this.baseUri.endsWith("/") ? this.baseUri.substring(0, this.baseUri.length - 1) : this.baseUri;
        var parsed = URI(this.baseUri);
        this.rootUri = parsed.scheme() + "://" + parsed.authority();
        this.rootUri = this.rootUri.endsWith("/") ? this.rootUri.substring(0, this.rootUri.length - 1) : this.rootUri;
    }
    Resolver.prototype.resolve = function (path, uriTemplateParameters) {
        if (!path) {
            throw new Error("The link is not set to a value");
        }
        if (path.startsWith("~/")) {
            path = path.substring(1, path.length);
            path = this.baseUri + path;
        }
        else {
            path = this.rootUri + path;
        }
        var template = new URITemplate(path);
        var result = template.expand(uriTemplateParameters || {});
        return result;
    };
    return Resolver;
}());
exports.default = Resolver;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resolver.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resolver.ts"); } } })();

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PhaseProgress;
(function (PhaseProgress) {
    PhaseProgress["Pending"] = "Pending";
    PhaseProgress["Current"] = "Current";
    PhaseProgress["Complete"] = "Complete";
})(PhaseProgress = exports.PhaseProgress || (exports.PhaseProgress = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\lifecycleProgressionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\lifecycleProgressionResource.ts"); } } })();

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MachineModelHealthStatus;
(function (MachineModelHealthStatus) {
    MachineModelHealthStatus["Healthy"] = "Healthy";
    MachineModelHealthStatus["Unavailable"] = "Unavailable";
    MachineModelHealthStatus["Unknown"] = "Unknown";
    MachineModelHealthStatus["HasWarnings"] = "HasWarnings";
    MachineModelHealthStatus["Unhealthy"] = "Unhealthy";
})(MachineModelHealthStatus = exports.MachineModelHealthStatus || (exports.MachineModelHealthStatus = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineResource.ts"); } } })();

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// Octopus prefix is used here as there is already a built-in type called Error
var OctopusError = (function (_super) {
    __extends(OctopusError, _super);
    function OctopusError(StatusCode, message) {
        var _this = _super.call(this, message) || this;
        _this.StatusCode = StatusCode;
        _this.ErrorMessage = message;
        _this.Errors = [];
        Object.setPrototypeOf(_this, OctopusError.prototype);
        return _this;
    }
    OctopusError.create = function (statusCode, response) {
        var e = new OctopusError(statusCode);
        var n = __assign({}, e, response);
        Object.setPrototypeOf(n, OctopusError.prototype);
        return n;
    };
    return OctopusError;
}(Error));
exports.OctopusError = OctopusError;
exports.default = OctopusError;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\octopusError.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\octopusError.ts"); } } })();

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BusyFromPromise_1 = __webpack_require__(176);
exports.default = BusyFromPromise_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BusyFromPromise\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BusyFromPromise\\index.tsx"); } } })();

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProjectDashboard_1 = __webpack_require__(1454);
exports.default = ProjectDashboard_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\index.tsx"); } } })();

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var TaskStatusIcon_1 = __webpack_require__(724);
var cn = __webpack_require__(19);
var DateFormatter_1 = __webpack_require__(400);
var styles = __webpack_require__(1460);
var InternalLink_1 = __webpack_require__(42);
var routeLinks_1 = __webpack_require__(20);
var index_1 = __webpack_require__(23);
var TaskStatusDetails = function (props) {
    var task = props.item;
    var additional = task.IsPrevious ? styles.taskPrevious : (task.IsCurrent === false ? styles.taskArchived : "");
    var link = (props.deploymentId && props.projectSlug) ?
        routeLinks_1.default.project(props.projectSlug).release(task.ReleaseVersion).deployments.specific(props.deploymentId) :
        routeLinks_1.default.task(task.TaskId).root;
    return (React.createElement(InternalLink_1.default, { to: link, className: styles.taskLink },
        React.createElement("div", { className: cn(styles.container, additional), style: props.style },
            React.createElement(TaskStatusIcon_1.TaskStatusIcon, { item: task, smallIcon: false }),
            React.createElement("div", { className: styles.details },
                React.createElement("span", { className: styles.version }, task.ReleaseVersion),
                props.showName && React.createElement("div", { className: styles.taskName },
                    "\u21E2\u00A0",
                    task.Name),
                props.channelName && React.createElement(index_1.ChannelChip, { channelName: props.channelName }),
                React.createElement("span", { title: DateFormatter_1.default.dateToLongFormat(task.StartTime || task.QueueTime), className: styles.date }, DateFormatter_1.default.dateToCustomFormat(task.StartTime || task.QueueTime, "MMMM Do YYYY"))),
            props.additionalDetails && React.createElement("div", { className: styles.additionalDetails }, props.additionalDetails))));
};
exports.TaskStatusDetails = TaskStatusDetails;
TaskStatusDetails.displayName = "TaskStatusDetails";


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\TaskStatusDetails\\TaskStatusDetails.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\TaskStatusDetails\\TaskStatusDetails.tsx"); } } })();

/***/ }),
/* 780 */,
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
var resources_1 = __webpack_require__(26);
var DashboardDataCube_1 = __webpack_require__(1576);
var ProgressionDataCube_1 = __webpack_require__(1577);
var DataCube_1 = __webpack_require__(218);
var tenantTagsets = __webpack_require__(138);
var DataBaseComponent_1 = __webpack_require__(39);
var lodash_1 = __webpack_require__(16);
var DashboardDataSource = (function (_super) {
    __extends(DashboardDataSource, _super);
    function DashboardDataSource(props) {
        var _this = _super.call(this, props) || this;
        _this.refreshCube = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        clearTimeout(this.timeoutId);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, this.refreshFunction()];
                    case 1:
                        _a.apply(this, [(_b.cube = _c.sent(),
                                _b)]);
                        this.timeoutId = setTimeout(this.refreshCube, 6000);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            hasInitialLoaded: false
        };
        _this.provideErrorHandling(_this.refreshCube);
        return _this;
    }
    DashboardDataSource.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.project = this.props.project;
                        this.filters = this.props.filters;
                        return [4 /*yield*/, this.setupDashboard()];
                    case 1:
                        _a.sent();
                        this.setState({ hasInitialLoaded: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardDataSource.prototype.componentWillUnmount = function () {
        clearTimeout(this.timeoutId);
    };
    DashboardDataSource.prototype.componentWillReceiveProps = function (nextProps) {
        return __awaiter(this, void 0, void 0, function () {
            var refresh;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        refresh = false;
                        if (nextProps.filters !== this.props.filters) {
                            refresh = true;
                        }
                        if (nextProps.project !== this.props.project) {
                            refresh = true;
                        }
                        if (!refresh) {
                            return [2 /*return*/];
                        }
                        this.project = nextProps.project;
                        this.filters = nextProps.filters;
                        return [4 /*yield*/, this.setupDashboard()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardDataSource.prototype.render = function () {
        return this.props.render(this.state);
    };
    DashboardDataSource.prototype.loadDashboardData = function (releaseId) {
        return __awaiter(this, void 0, void 0, function () {
            var args;
            return __generator(this, function (_a) {
                args = this.project
                    ? { projectId: this.project.Id, showAll: true }
                    : { highestLatestVersionPerProjectAndEnvironment: true };
                if (releaseId) {
                    args.releaseId = releaseId;
                }
                return [2 /*return*/, clientInstance_1.repository.Dashboards.getDashboard(args)];
            });
        });
    };
    DashboardDataSource.prototype.loadProgressionData = function () {
        return clientInstance_1.repository.Progression.getProgression(this.project);
    };
    DashboardDataSource.prototype.loadChannels = function (channelIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Channels.all({ ids: channelIds })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DashboardDataSource.prototype.loadReleases = function (releaseId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, result;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!releaseId) return [3 /*break*/, 2];
                        _b = (_a = Promise).resolve;
                        return [4 /*yield*/, clientInstance_1.repository.Releases.get(releaseId)];
                    case 1: return [2 /*return*/, _b.apply(_a, [[_c.sent()]])];
                    case 2: return [4 /*yield*/, clientInstance_1.repository.Projects.getReleases(this.project)];
                    case 3:
                        result = _c.sent();
                        return [2 /*return*/, result.Items];
                }
            });
        });
    };
    DashboardDataSource.prototype.filteredRelease = function () {
        if (this.filters[DataCube_1.DimensionTypes.Release]) {
            return Object.keys(this.filters[DataCube_1.DimensionTypes.Release])[0];
        }
        return null;
    };
    DashboardDataSource.prototype.loadPromotionData = function (release) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, clientInstance_1.repository.Releases.getDeploymentTemplate(release)];
            });
        });
    };
    DashboardDataSource.prototype.loadLifecycles = function (channelsAsync) {
        return __awaiter(this, void 0, void 0, function () {
            var channels, lifecycleIds, lifecycles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, channelsAsync];
                    case 1:
                        channels = _a.sent();
                        lifecycleIds = channels.map(function (channel) { return channel.LifecycleId; });
                        return [4 /*yield*/, clientInstance_1.repository.Lifecycles.allById(lifecycleIds)];
                    case 2:
                        lifecycles = _a.sent();
                        return [2 /*return*/, Object.keys(lifecycles).map(function (id) { return lifecycles[id]; })];
                }
            });
        });
    };
    DashboardDataSource.prototype.listTenantsWithMissingVariables = function () {
        return __awaiter(this, void 0, void 0, function () {
            var missingVariables;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Tenants.missingVariables({ projectId: this.project.Id }, false)];
                    case 1:
                        missingVariables = _a.sent();
                        return [2 /*return*/, missingVariables.map(function (mv) { return mv.TenantId; })];
                }
            });
        });
    };
    DashboardDataSource.prototype.setupMainDashboard = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.refreshFunction = function () { return __awaiter(_this, void 0, void 0, function () {
                            var data;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.loadDashboardData()];
                                    case 1:
                                        data = _a.sent();
                                        this.setState({ projectLimit: data.ProjectLimit || 200 });
                                        return [2 /*return*/, new DashboardDataCube_1.default(data, data.Tenants, [], [], null, [], [])];
                                }
                            });
                        }); };
                        return [4 /*yield*/, this.refreshCube()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardDataSource.prototype.setupTenantedProjectDashboard = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.refreshFunction = function () { return __awaiter(_this, void 0, void 0, function () {
                            var releaseId, releases, channeldIds, channelsLoader, _a, data, channels, promotions, tagSets, lifecycles, missingVariableTenants;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        releaseId = this.filteredRelease();
                                        return [4 /*yield*/, this.loadReleases(releaseId)];
                                    case 1:
                                        releases = _b.sent();
                                        channeldIds = lodash_1.uniq(releases.map(function (r) { return r.ChannelId; }));
                                        channelsLoader = this.loadChannels(channeldIds);
                                        return [4 /*yield*/, Promise.all([
                                                this.loadDashboardData(releaseId),
                                                channelsLoader,
                                                releaseId ? this.loadPromotionData(releases[0]) : Promise.resolve(null),
                                                tenantTagsets.getAll(),
                                                this.loadLifecycles(channelsLoader),
                                                this.listTenantsWithMissingVariables()
                                            ])];
                                    case 2:
                                        _a = _b.sent(), data = _a[0], channels = _a[1], promotions = _a[2], tagSets = _a[3], lifecycles = _a[4], missingVariableTenants = _a[5];
                                        return [2 /*return*/, new DashboardDataCube_1.default(data, data.Tenants, releases, channels, promotions, tagSets, lifecycles, this.project, releaseId, missingVariableTenants)];
                                }
                            });
                        }); };
                        return [4 /*yield*/, this.refreshCube()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardDataSource.prototype.setupProjectDashboard = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.refreshFunction = function () { return __awaiter(_this, void 0, void 0, function () {
                            var data, channeldIds, channels;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.loadProgressionData()];
                                    case 1:
                                        data = _a.sent();
                                        channeldIds = Object.keys(data.ChannelEnvironments);
                                        return [4 /*yield*/, this.loadChannels(channeldIds)];
                                    case 2:
                                        channels = _a.sent();
                                        return [2 /*return*/, new ProgressionDataCube_1.default(data, channels, this.project)];
                                }
                            });
                        }); };
                        return [4 /*yield*/, this.refreshCube()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardDataSource.prototype.setupDashboard = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!!this.project) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this.setupMainDashboard()];
                                case 1:
                                    _a.sent();
                                    return [3 /*break*/, 6];
                                case 2:
                                    if (!(this.project.TenantedDeploymentMode !== resources_1.TenantedDeploymentMode.Untenanted)) return [3 /*break*/, 4];
                                    return [4 /*yield*/, this.setupTenantedProjectDashboard()];
                                case 3:
                                    _a.sent();
                                    return [3 /*break*/, 6];
                                case 4: return [4 /*yield*/, this.setupProjectDashboard()];
                                case 5:
                                    _a.sent();
                                    _a.label = 6;
                                case 6: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    return DashboardDataSource;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = DashboardDataSource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DashboardDataSource.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DashboardDataSource.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var TextField_1 = __webpack_require__(598);
var DropDownMenu_1 = __webpack_require__(1583);
var colors_1 = __webpack_require__(32);
var fontWeights_1 = __webpack_require__(76);
function getStyles(props, _) {
    return {
        root: {
            marginTop: 0,
        },
        label: {
            paddingLeft: 0,
            top: props.floatingLabelText ? 14 : -4,
        },
        floatingLabelStyle: {
            fontWeight: fontWeights_1.normal,
            color: colors_1.secondaryText,
        },
        icon: {
            right: 0,
            top: props.floatingLabelText ? 8 : 0,
            marginTop: 0,
            fill: colors_1.secondaryText,
        },
        hideDropDownUnderline: {
            borderTop: "none",
        },
        dropDownMenu: {
            display: "block",
        },
    };
}
var SelectField = (function (_super) {
    __extends(SelectField, _super);
    function SelectField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectField.prototype.render = function () {
        var _a = this.props, allowClear = _a.allowClear, autoWidth = _a.autoWidth, multiple = _a.multiple, children = _a.children, style = _a.style, labelStyle = _a.labelStyle, iconStyle = _a.iconStyle, id = _a.id, underlineDisabledStyle = _a.underlineDisabledStyle, underlineFocusStyle = _a.underlineFocusStyle, menuItemStyle = _a.menuItemStyle, selectedMenuItemStyle = _a.selectedMenuItemStyle, underlineStyle = _a.underlineStyle, dropDownMenuProps = _a.dropDownMenuProps, errorStyle = _a.errorStyle, disabled = _a.disabled, floatingLabelFixed = _a.floatingLabelFixed, floatingLabelText = _a.floatingLabelText, floatingLabelStyle = _a.floatingLabelStyle, hintStyle = _a.hintStyle, hintText = _a.hintText, fullWidth = _a.fullWidth, errorText = _a.errorText, listStyle = _a.listStyle, maxHeight = _a.maxHeight, menuStyle = _a.menuStyle, onFocus = _a.onFocus, onBlur = _a.onBlur, onChange = _a.onChange, selectionRenderer = _a.selectionRenderer, value = _a.value, type = _a.type, filter = _a.filter, autoFocus = _a.autoFocus, other = __rest(_a, ["allowClear", "autoWidth", "multiple", "children", "style", "labelStyle", "iconStyle", "id", "underlineDisabledStyle", "underlineFocusStyle", "menuItemStyle", "selectedMenuItemStyle", "underlineStyle", "dropDownMenuProps", "errorStyle", "disabled", "floatingLabelFixed", "floatingLabelText", "floatingLabelStyle", "hintStyle", "hintText", "fullWidth", "errorText", "listStyle", "maxHeight", "menuStyle", "onFocus", "onBlur", "onChange", "selectionRenderer", "value", "type", "filter", "autoFocus"]);
        var styles = getStyles(this.props, this.context);
        return (React.createElement(TextField_1.default, __assign({}, other, { style: style, disabled: disabled, floatingLabelFixed: floatingLabelFixed, floatingLabelText: floatingLabelText, floatingLabelStyle: Object.assign(styles.floatingLabelStyle, floatingLabelStyle), hintStyle: hintStyle, hintText: (!hintText && !floatingLabelText) ? " " : hintText, fullWidth: fullWidth, errorText: errorText, underlineStyle: { borderColor: colors_1.secondaryText, position: "relative" }, errorStyle: errorStyle, onFocus: onFocus, onBlur: onBlur, id: id, underlineDisabledStyle: underlineDisabledStyle, underlineFocusStyle: { borderColor: colors_1.primary, bottom: "10px" } }),
            React.createElement(DropDownMenu_1.default, __assign({ allowClear: allowClear, disabled: disabled, style: Object.assign(styles.dropDownMenu, menuStyle), labelStyle: Object.assign(styles.label, labelStyle), iconStyle: Object.assign(styles.icon, iconStyle), menuItemStyle: menuItemStyle, selectedMenuItemStyle: selectedMenuItemStyle, underlineStyle: styles.hideDropDownUnderline, listStyle: listStyle, autoWidth: autoWidth, value: value, onChange: onChange, maxHeight: maxHeight, multiple: multiple, selectionRenderer: selectionRenderer, filter: filter, autoFocus: autoFocus }, dropDownMenuProps), children)));
    };
    // static propTypes = {
    //   /**
    //    * If true, the width will automatically be set according to the
    //    * items inside the menu.
    //    * To control the width in CSS instead, leave this prop set to `false`.
    //    */
    //   autoWidth: PropTypes.bool,
    //   /**
    //    * The `MenuItem` elements to populate the select field with.
    //    * If the menu items have a `label` prop, that value will
    //    * represent the selected menu item in the rendered select field.
    //    */
    //   children: PropTypes.node,
    //   /**
    //    * If true, the select field will be disabled.
    //    */
    //   disabled: PropTypes.bool,
    //   /**
    //    * Object that can handle and override any property of component DropDownMenu.
    //    */
    //   dropDownMenuProps: PropTypes.object,
    //   /**
    //    * Override the inline-styles of the error element.
    //    */
    //   errorStyle: PropTypes.object,
    //   /**
    //    * The error content to display.
    //    */
    //   errorText: PropTypes.node,
    //   /**
    //    * If true, the floating label will float even when no value is selected.
    //    */
    //   floatingLabelFixed: PropTypes.bool,
    //   /**
    //    * Override the inline-styles of the floating label.
    //    */
    //   floatingLabelStyle: PropTypes.object,
    //   /**
    //    * The content of the floating label.
    //    */
    //   floatingLabelText: PropTypes.node,
    //   /**
    //    * If true, the select field will take up the full width of its container.
    //    */
    //   fullWidth: PropTypes.bool,
    //   /**
    //    * Override the inline-styles of the hint element.
    //    */
    //   hintStyle: PropTypes.object,
    //   /**
    //    * The hint content to display.
    //    */
    //   hintText: PropTypes.node,
    //   /**
    //    * Override the inline-styles of the icon element.
    //    */
    //   iconStyle: PropTypes.object,
    //   /**
    //    * The id prop for the text field.
    //    */
    //   id: PropTypes.string,
    //   /**
    //    * Override the label style when the select field is inactive.
    //    */
    //   labelStyle: PropTypes.object,
    //   /**
    //    * Override the inline-styles of the underlying `List` element.
    //    */
    //   listStyle: PropTypes.object,
    //   /**
    //    * Override the default max-height of the underlying `DropDownMenu` element.
    //    */
    //   maxHeight: PropTypes.number,
    //   /**
    //    * Override the inline-styles of menu items.
    //    */
    //   menuItemStyle: PropTypes.object,
    //   /**
    //    * Override the inline-styles of the underlying `DropDownMenu` element.
    //    */
    //   menuStyle: PropTypes.object,
    //   /**
    //    * If true, `value` must be an array and the menu will support
    //    * multiple selections.
    //    */
    //   multiple: PropTypes.bool,
    //   /** @ignore */
    //   onBlur: PropTypes.func,
    //   /**
    //    * Callback function fired when a menu item is selected.
    //    *
    //    * @param {object} event TouchTap event targeting the menu item
    //    * that was selected.
    //    * @param {number} key The index of the selected menu item, or undefined
    //    * if `multiple` is true.
    //    * @param {any} payload If `multiple` is true, the menu"s `value`
    //    * array with either the menu item"s `value` added (if
    //    * it wasn"t already selected) or omitted (if it was already selected).
    //    * Otherwise, the `value` of the menu item.
    //    */
    //   onChange: PropTypes.func,
    //   /** @ignore */
    //   onFocus: PropTypes.func,
    //   /**
    //    * Override the inline-styles of selected menu items.
    //    */
    //   selectedMenuItemStyle: PropTypes.object,
    //   /**
    //    * Customize the rendering of the selected item.
    //    *
    //    * @param {any} value If `multiple` is true, the menu"s `value`
    //    * array with either the menu item"s `value` added (if
    //    * it wasn"t already selected) or omitted (if it was already selected).
    //    * Otherwise, the `value` of the menu item.
    //    * @param {any} menuItem The selected `MenuItem`.
    //    * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
    //    */
    //   selectionRenderer: PropTypes.func,
    //   /**
    //    * Override the inline-styles of the root element.
    //    */
    //   style: PropTypes.object,
    //   /**
    //    * Override the inline-styles of the underline element when the select
    //    * field is disabled.
    //    */
    //   underlineDisabledStyle: PropTypes.object,
    //   /**
    //    * Override the inline-styles of the underline element when the select field
    //    * is focused.
    //    */
    //   underlineFocusStyle: PropTypes.object,
    //   /**
    //    * Override the inline-styles of the underline element.
    //    */
    //   underlineStyle: PropTypes.object,
    //   /**
    //    * If `multiple` is true, an array of the `value`s of the selected
    //    * menu items. Otherwise, the `value` of the selected menu item.
    //    * If provided, the menu will be a controlled component.
    //    */
    //   value: PropTypes.any,
    //   filter: PropTypes.node,
    // };
    SelectField.defaultProps = {
        autoWidth: false,
        disabled: false,
        fullWidth: false,
        multiple: false,
    };
    SelectField.contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    return SelectField;
}(React.Component));
exports.default = SelectField;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Select\\SelectField.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Select\\SelectField.tsx"); } } })();

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var InputWithActions_1 = __webpack_require__(145);
var Text_1 = __webpack_require__(17);
var IconButtonList_1 = __webpack_require__(109);
var IconButton_1 = __webpack_require__(56);
var FileUpload = (function (_super) {
    __extends(FileUpload, _super);
    function FileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFileChange = function (e) {
            if (e.target.files.length < 1) {
                return;
            }
            var file = e.target.files[0];
            _this.props.onChange(file);
        };
        _this.handleClearSelected = function () {
            _this.input.value = null;
            _this.props.onChange(null);
        };
        _this.openSelector = function () {
            _this.input.click();
        };
        _this.noop = function () {
            // Empty on purpose
        };
        return _this;
    }
    FileUpload.prototype.render = function () {
        var _this = this;
        var name = this.props.value ? this.props.value.name : "";
        return React.createElement("div", null,
            React.createElement(InputWithActions_1.default, { input: React.createElement(Text_1.default, { hintText: this.props.hintText, value: name, onChange: this.noop, label: this.props.label, onClick: this.openSelector }), actions: React.createElement(IconButtonList_1.default, { buttons: this.buttons() }) }),
            React.createElement("input", { type: "file", style: { display: "none" }, onChange: this.handleFileChange, ref: function (input) { return _this.input = input; } }));
    };
    FileUpload.prototype.buttons = function () {
        return [
            React.createElement(IconButton_1.default, { toolTipContent: "Choose file", onClick: this.openSelector, icon: IconButton_1.Icon.Upload }),
            this.props.value ? React.createElement(IconButton_1.default, { toolTipContent: "Remove file", onClick: this.handleClearSelected, icon: IconButton_1.Icon.Remove }) : null
        ].filter(function (b) { return !!b; });
    };
    return FileUpload;
}(React.Component));
exports.default = FileUpload;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\FileUpload\\FileUpload.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\FileUpload\\FileUpload.tsx"); } } })();

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var DeleteDialog_1 = __webpack_require__(452);
var OpenDeleteDialogMenuItem = (function (_super) {
    __extends(OpenDeleteDialogMenuItem, _super);
    function OpenDeleteDialogMenuItem(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function () {
            _this.setState({ open: true });
        };
        _this.state = { open: false };
        return _this;
    }
    OpenDeleteDialogMenuItem.prototype.render = function () {
        var _this = this;
        return React.createElement(DeleteDialog_1.default, { title: this.props.dialogTitle, open: this.state.open, deleteButtonLabel: this.props.deleteButtonLabel, deleteButtonBusyLabel: this.props.deleteButtonBusyLabel, onClose: function () { return _this.setState({ open: false }); }, onDeleteClick: function () { return _this.props.onDeleteClick(); } }, this.props.children);
    };
    return OpenDeleteDialogMenuItem;
}(BaseComponent_1.BaseComponent));
exports.default = OpenDeleteDialogMenuItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Menu\\OpenDeleteDialogMenuItem.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Menu\\OpenDeleteDialogMenuItem.tsx"); } } })();

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Dialog_1 = __webpack_require__(121);
var dialogIdGenerator_1 = __webpack_require__(265);
var OpenDialogConnect_1 = __webpack_require__(266);
var OpenDialogMenuItemInternal = (function (_super) {
    __extends(OpenDialogMenuItemInternal, _super);
    function OpenDialogMenuItemInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.text = _this.props.label;
        _this.uniqueId = dialogIdGenerator_1.default.next();
        return _this;
    }
    OpenDialogMenuItemInternal.prototype.onClick = function () {
        this.props.openDialog(this.uniqueId);
    };
    OpenDialogMenuItemInternal.prototype.render = function () {
        return React.createElement(Dialog_1.default, { open: this.props.openDialogs[this.uniqueId] }, this.props.children);
    };
    return OpenDialogMenuItemInternal;
}(React.Component));
exports.OpenDialogMenuItemInternal = OpenDialogMenuItemInternal;
var OpenDialogMenuItem = OpenDialogConnect_1.OpenDialogConnect.to(OpenDialogMenuItemInternal, true);
exports.default = OpenDialogMenuItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Menu\\OpenDialogMenuItem.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Menu\\OpenDialogMenuItem.tsx"); } } })();

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var showdown = __webpack_require__(1628);
var xss = __webpack_require__(1629);
var style = __webpack_require__(1633);
var Markdown = function (props) {
    var converter = new showdown.Converter({
        tables: true,
        strikethrough: true,
        openLinksInNewWindow: true,
        disableForced4SpacesIndentedSublists: true
    });
    var html = xss(converter.makeHtml(props.markup));
    return React.createElement("div", { className: style.markdown, dangerouslySetInnerHTML: { __html: html } });
};
exports.default = Markdown;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Markdown\\Markdown.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Markdown\\Markdown.tsx"); } } })();

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var LookupResourceChip_1 = __webpack_require__(144);
var Chips_1 = __webpack_require__(23);
var MultiSelect_1 = __webpack_require__(108);
var UserChip_1 = __webpack_require__(755);
var UserTypedMultiSelect = MultiSelect_1.default();
var LookupUserChip = LookupResourceChip_1.default();
var UserMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupUserChip, { lookupCollection: props.items, lookupId: r.Id, type: Chips_1.ChipIcon.Environment, chipRender: function (item) { return React.createElement(UserChip_1.UserChip, { onRequestDelete: onRequestDelete, user: item }); } });
    };
    var items = props.items, rest = __rest(props, ["items"]);
    return React.createElement(UserTypedMultiSelect, __assign({ items: items.map(function (i) {
            var user = __assign({}, i, { Name: UserChip_1.userDisplayName(i) + " " + (i.EmailAddress || "") });
            return user;
        }), fieldName: "users", renderChip: chipRenderer, renderItem: function (i) { return ({ primaryText: UserChip_1.userDisplayName(i), secondaryText: i.EmailAddress }); } }, rest));
};
exports.default = UserMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\UserMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\UserMultiSelect.tsx"); } } })();

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
function findKey(val, template) {
    if (!template) {
        return val;
    }
    var found = Object.keys(template).find(function (k) { return k.toLowerCase() === val.toLowerCase(); });
    return found ? found : val;
}
function matchErrorsToFieldNames(err, template) {
    var details = err.Details
        ? Object.keys(err.Details).reduce(function (acc, val) {
            acc[findKey(val, template)] = err.Details[val];
            return acc;
        }, {})
        : {};
    return __assign({}, details);
}
exports.default = matchErrorsToFieldNames;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FormBaseComponent\\matchErrorsToFieldNames.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FormBaseComponent\\matchErrorsToFieldNames.ts"); } } })();

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Section_1 = __webpack_require__(90);
var OpenDialogButton_1 = __webpack_require__(74);
var RemoveItemsList_1 = __webpack_require__(142);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var AddApiKeyDialog_1 = __webpack_require__(1661);
var NothingToSeeHere_1 = __webpack_require__(1673);
var TimeFromNowLabel_1 = __webpack_require__(424);
var styles = __webpack_require__(671);
var ApiKeyList = (function (_super) {
    __extends(ApiKeyList, _super);
    function ApiKeyList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ApiKeyList;
}(RemoveItemsList_1.RemoveItemsList));
var UserApiKeysList = (function (_super) {
    __extends(UserApiKeysList, _super);
    function UserApiKeysList(props) {
        var _this = _super.call(this, props) || this;
        _this.renderApiKeys = function () {
            var actions = [React.createElement(OpenDialogButton_1.default, { key: "newKey", label: "New API Key" },
                    React.createElement(AddApiKeyDialog_1.default, { apiKey: _this.state.lastApiKey, onAdd: function (purpose) { return _this.handleKeyAdded(purpose); }, onClose: function () { return _this.setState({ lastApiKey: null }); } }))
            ];
            return React.createElement(ApiKeyList, { listActions: actions, data: _this.state.apiKeyCollection.Items, onRow: function (apiKey) { return React.createElement("div", { key: apiKey.Id },
                    React.createElement("h3", { className: styles.apiKeyEntry }, apiKey.Purpose || "General-purpose API key"),
                    React.createElement("div", null,
                        "Created ",
                        React.createElement(TimeFromNowLabel_1.default, { time: apiKey.Created }))); }, onRemoveRow: function (apiKey) { return _this.handleKeyRemoved(apiKey); } });
        };
        _this.handleKeyRemoved = function (deleteThisApiKey) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.Users.revokeApiKey(deleteThisApiKey)];
                                    case 1:
                                        result = _a.sent();
                                        this.setState(function (state) { return ({
                                            apiKeyCollection: __assign({}, state.apiKeyCollection, { Items: state.apiKeyCollection.Items.filter(function (i) { return i.Id !== deleteThisApiKey.Id; }).slice() })
                                        }); });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = ({
            apiKeyCollection: null,
            purpose: null,
            lastApiKey: null
        });
        return _this;
    }
    UserApiKeysList.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var apiKeyCollection;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Users.listApiKeys(this.props.user)];
                    case 1:
                        apiKeyCollection = _a.sent();
                        this.setState({
                            apiKeyCollection: apiKeyCollection
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    UserApiKeysList.prototype.render = function () {
        return React.createElement(Section_1.Section, null,
            this.state.apiKeyCollection && this.renderApiKeys(),
            this.state.apiKeyCollection
                && this.state.apiKeyCollection.Items.length === 0
                && React.createElement(NothingToSeeHere_1.NothingToSeeHere, { content: "There aren't currently any API keys to show." }));
    };
    UserApiKeysList.prototype.handleKeyAdded = function (purpose) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var newKey;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.Users.createApiKey(this.props.user, purpose)];
                                    case 1:
                                        newKey = _a.sent();
                                        this.setState(function (state) { return ({
                                            apiKeyCollection: __assign({}, state.apiKeyCollection, { Items: [newKey].concat(state.apiKeyCollection.Items) }),
                                            lastApiKey: newKey.ApiKey
                                        }); });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return UserApiKeysList;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = UserApiKeysList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserApiKeys\\UserApiKeysList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserApiKeys\\UserApiKeysList.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var BorderedListItem_1 = __webpack_require__(670);
__export(__webpack_require__(670));
exports.default = BorderedListItem_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BorderedListItem\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\BorderedListItem\\index.ts"); } } })();

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var FormBaseComponent_1 = __webpack_require__(137);
var clientInstance_1 = __webpack_require__(10);
var SaveDialogLayout_1 = __webpack_require__(105);
var Section_1 = __webpack_require__(90);
var form_1 = __webpack_require__(15);
var Validators_1 = __webpack_require__(170);
var UserChangePasswordDialog = (function (_super) {
    __extends(UserChangePasswordDialog, _super);
    function UserChangePasswordDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = __assign({}, this.state.user, { Password: this.state.model.password });
                        if (!this.isConfirmPasswordCorrect()) {
                            this.setState({
                                dontMatch: "The passwords do not match"
                            });
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, clientInstance_1.repository.Users.save(user)];
                                        case 1:
                                            result = _a.sent();
                                            this.setState({
                                                cleanModel: this.buildModel(user),
                                                model: this.buildModel(user)
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.state = {
            user: null,
            model: null,
            cleanModel: null,
            dontMatch: null
        };
        return _this;
    }
    UserChangePasswordDialog.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var user, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!this.props.userId) return [3 /*break*/, 2];
                                        return [4 /*yield*/, clientInstance_1.repository.Users.get(this.props.userId)];
                                    case 1:
                                        _a = _b.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = null;
                                        _b.label = 3;
                                    case 3:
                                        user = _a;
                                        this.setState({
                                            user: user,
                                            model: this.buildModel(user),
                                            cleanModel: this.buildModel(user)
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserChangePasswordDialog.prototype.buildModel = function (user) {
        return user
            ? {
                original: user,
            }
            : {
                original: null,
            };
    };
    UserChangePasswordDialog.prototype.render = function () {
        var _this = this;
        return this.state.model &&
            React.createElement(SaveDialogLayout_1.default, { onSaveClick: function () { return _this.handleSaveClick(); }, busy: this.state.busy, errors: this.state.errors, title: this.isSelf() ? "Change Your Password" : "Change Password for This User" },
                React.createElement(Section_1.Section, null,
                    React.createElement(form_1.Text, { value: this.state.model.password, type: "password", onChange: function (password) { return _this.setModelState({ password: password }); }, label: "New password", autoFocus: true })),
                React.createElement(Section_1.Section, null,
                    React.createElement(form_1.Text, { value: this.state.model.confirmPassword, type: "password", onChange: function (confirmPassword) { return _this.setModelState({ confirmPassword: confirmPassword }); }, label: "Confirm new password", error: this.state.dontMatch, validate: this.isConfirmRequired() })));
    };
    UserChangePasswordDialog.prototype.isConfirmPasswordCorrect = function () {
        if (!this.state.model.password) {
            return true;
        }
        return this.state.model.password
            && this.state.model.password.localeCompare(this.state.model.confirmPassword) === 0;
    };
    UserChangePasswordDialog.prototype.isConfirmRequired = function () {
        return this.isConfirmPasswordCorrect() ? null : Validators_1.required("Passwords don't match");
    };
    UserChangePasswordDialog.prototype.isSelf = function () {
        return clientInstance_1.session.currentUser.Id === this.props.userId;
    };
    return UserChangePasswordDialog;
}(FormBaseComponent_1.default));
exports.default = UserChangePasswordDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\configuration\\components\\Users\\UserChangePasswordDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\configuration\\components\\Users\\UserChangePasswordDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var StringHelper_1 = __webpack_require__(458);
var styles = __webpack_require__(1690);
var EventDetails = function (props) {
    var eventDetails = props.eventDetails, rest = __rest(props, ["eventDetails"]);
    return React.createElement("div", __assign({}, rest),
        React.createElement("pre", { className: styles.preWrapped },
            React.createElement("div", { dangerouslySetInnerHTML: { __html: StringHelper_1.default.formatDiff(eventDetails) } })));
};
EventDetails.displayName = "EventDetails";
exports.default = EventDetails;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EventDetails\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EventDetails\\index.tsx"); } } })();

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(16);
var BaseComponent_1 = __webpack_require__(60);
var identityType_1 = __webpack_require__(1695);
var ProviderIdentities_1 = __webpack_require__(1696);
var ProviderGroups = (function (_super) {
    __extends(ProviderGroups, _super);
    function ProviderGroups(props) {
        var _this = _super.call(this, props) || this;
        _this.determineType = function (name) {
            /*
            Octopus.Node.Extensibility.Authentication.Extensions.IAuthenticationProvider
            doesn't make use of enum Octopus.Core.Resources.IdentityType
            so just hacking it here till can be solved properly
            */
            if (name.indexOf("Azure") !== -1 || name.indexOf("Google") !== -1) {
                return identityType_1.default.OAuth;
            }
            else if (_this.isActiveDirectory(name)) {
                return identityType_1.default.ActiveDirectory;
            }
            else if (name.indexOf("Guest") !== -1) {
                return identityType_1.default.Guest;
            }
            else {
                return identityType_1.default.UsernamePassword;
            }
        };
        _this.state = {};
        return _this;
    }
    ProviderGroups.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            " ",
            this.props.enabledAuthenticationProviders &&
                this.buildIdentitiesByProvider()
                    .map(function (p) {
                    return React.createElement(ProviderIdentities_1.ProviderIdentities, { key: p.providerName, provider: p, enabledToSupportAdding: _this.props.enabledProvidersMetadata
                            && _this.props.enabledProvidersMetadata.some(function (ep) { return ep.IdentityProviderName === p.providerName; }), canCurrentUserEditIdentitiesForUser: _this.props.canCurrentUserEditIdentitiesForUser, onChange: function (changed) { return _this.providerGroupChanged(changed); } });
                }));
    };
    ProviderGroups.prototype.buildIdentitiesByProvider = function () {
        var _this = this;
        var userIdentities = this.props.userIdentities || [];
        return this.props.enabledAuthenticationProviders
            .filter(function (ap) { return identityType_1.default[ap.IdentityType] === identityType_1.default.ActiveDirectory || identityType_1.default[ap.IdentityType] === identityType_1.default.OAuth; })
            .filter(function (filterOutForServiceAccounts) { return _this.props.isServiceAccount ? _this.isActiveDirectory(filterOutForServiceAccounts.Name) : true; })
            .map(function (p) {
            return {
                providerName: p.Name,
                providerDetails: _this.props.enabledProvidersMetadata.find(function (ep) { return ep.IdentityProviderName === p.Name; }),
                identityType: _this.determineType(p.Name),
                identities: userIdentities ? userIdentities.filter(function (i) { return i.IdentityProviderName === p.Name; }) : []
            };
        })
            .sort(function (a, b) { return a.providerName.localeCompare(b.providerName); });
    };
    ProviderGroups.prototype.providerGroupChanged = function (update) {
        var identityByProvider = this.buildIdentitiesByProvider().filter(function (p) { return p.providerName !== update.providerName; }).concat([
            update
        ]).sort(function (a, b) { return a.providerName.localeCompare(b.providerName); });
        this.props.onChange(lodash_1.flatten(identityByProvider.map(function (ibp) { return ibp.identities; })));
    };
    ProviderGroups.prototype.isActiveDirectory = function (name) {
        return name.indexOf("Directory") !== -1;
    };
    return ProviderGroups;
}(BaseComponent_1.default));
exports.ProviderGroups = ProviderGroups;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\configuration\\components\\Users\\ProviderGroups.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\configuration\\components\\Users\\ProviderGroups.tsx"); } } })();

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(16);
var envCount = function (phase) {
    return lodash_1.union(phase.AutomaticDeploymentTargets, phase.OptionalDeploymentTargets).length;
};
exports.default = envCount;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\library\\components\\Lifecycle\\LifecycleMap\\envCount.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\library\\components\\Lifecycle\\LifecycleMap\\envCount.ts"); } } })();

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var taskState_1 = __webpack_require__(402);
function mapProgressionToStatus(progression) {
    var p = {
        deployed: {},
        tasks: {},
        warning: {},
        executing: {},
        queued: {},
        progress: {}
    };
    if (!progression) {
        return p;
    }
    progression.Phases.forEach(function (phase) {
        var phaseStatus = phase.Progress.toString();
        if (phase.Blocked) {
            phaseStatus = "Blocked";
        }
        p.progress[phase.Name] = phaseStatus;
        phase.Deployments.forEach(function (deployment) {
            p.deployed[deployment.Deployment.EnvironmentId] = true;
            p.tasks[deployment.Deployment.EnvironmentId] = deployment.Task.Id;
            p.warning[deployment.Deployment.EnvironmentId] = deployment.Task.HasWarningsOrErrors;
            p.executing[deployment.Deployment.EnvironmentId] = deployment.Task.State !== taskState_1.TaskState.Success;
            p.queued[deployment.Deployment.EnvironmentId] = deployment.Task.State === taskState_1.TaskState.Queued;
        });
    });
    return p;
}
exports.mapProgressionToStatus = mapProgressionToStatus;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\MapProgressionToStatus\\MapProgressionToStatus.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\MapProgressionToStatus\\MapProgressionToStatus.ts"); } } })();

/***/ }),
/* 796 */,
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ActionButton_1 = __webpack_require__(50);
var DialogLayout_1 = __webpack_require__(141);
var DialogLayoutConnect_1 = __webpack_require__(296);
var FormComponent_1 = __webpack_require__(267);
var styles = __webpack_require__(244);
var InfoDialogLayoutInternal = (function (_super) {
    __extends(InfoDialogLayoutInternal, _super);
    function InfoDialogLayoutInternal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoDialogLayoutInternal.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, other = __rest(_a, ["children"]);
        var close = React.createElement(ActionButton_1.ActionButton, { label: this.props.closeButtonLabel || "Close", disabled: this.props.busy, onClick: function () { return _this.props.close(); } });
        return React.createElement(DialogLayout_1.DialogLayout, __assign({ actions: close, closeDialog: this.props.close }, other),
            React.createElement(FormComponent_1.default, { onFormSubmit: this.props.close, className: styles.dialogWrapper }, children));
    };
    return InfoDialogLayoutInternal;
}(React.Component));
var InfoDialogLayout = DialogLayoutConnect_1.DialogLayoutConnect.to(InfoDialogLayoutInternal);
InfoDialogLayout.displayName = "InfoDialogLayout";
exports.default = InfoDialogLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DialogLayout\\InfoDialogLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DialogLayout\\InfoDialogLayout.tsx"); } } })();

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var CertificateSelector_1 = __webpack_require__(1850);
var Select_1 = __webpack_require__(41);
var https_1 = __webpack_require__(759);
var moment = __webpack_require__(104);
var colors_1 = __webpack_require__(32);
var styles = __webpack_require__(1857);
var OpenDialogIconButton_1 = __webpack_require__(801);
var IconButton_1 = __webpack_require__(56);
var InputWithActions_1 = __webpack_require__(145);
var clientInstance_1 = __webpack_require__(10);
var BusyIndicator_1 = __webpack_require__(98);
var BoundField_1 = __webpack_require__(95);
var CertificateSelect = (function (_super) {
    __extends(CertificateSelect, _super);
    function CertificateSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (certificateId) {
            var value = certificateId === "" ? null : certificateId;
            if (_this.props.validate) {
                var result = _this.props.validate(value);
                _this.setState({ error: result });
                if (_this.props.onValidate) {
                    _this.props.onValidate(result);
                }
            }
            _this.props.onChange(value);
        };
        _this.selectionRenderer = function (certificateId) {
            var certificate = _this.state.certificates.find(function (acc) { return acc.Id === certificateId; });
            if (!certificate) {
                return certificateId;
            }
            if (_this.isCertificateExpired(certificate)) {
                return React.createElement("div", { style: { color: colors_1.danger } },
                    React.createElement("span", { className: styles.selectedIcon },
                        React.createElement(https_1.default, { color: colors_1.danger })),
                    certificate.Name,
                    " (expired)");
            }
            return React.createElement("div", null,
                React.createElement("span", { className: styles.selectedIcon },
                    React.createElement(https_1.default, null)),
                certificate.Name);
        };
        _this.state = {
            error: null,
            showSearchDialog: false,
            certificates: [],
            isDataLoaded: false
        };
        return _this;
    }
    CertificateSelect.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var certificates;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, clientInstance_1.repository.Certificates.list({ tenant: this.props.tenantId, take: 1000 })];
                            case 1:
                                certificates = (_a.sent()).Items;
                                this.setState({ certificates: certificates, isDataLoaded: true });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    CertificateSelect.prototype.getItems = function () {
        var _this = this;
        return this.state.certificates.map(function (certificate) {
            var expired = _this.isCertificateExpired(certificate);
            var icon = expired ? React.createElement(https_1.default, { color: colors_1.danger }) : React.createElement(https_1.default, null);
            return {
                value: certificate.Id,
                text: certificate.Name + (expired ? " (expired)" : ""),
                icon: icon,
                style: expired ? { color: colors_1.danger } : null
            };
        });
    };
    CertificateSelect.prototype.render = function () {
        var _this = this;
        if (!this.state.isDataLoaded) {
            return React.createElement(BusyIndicator_1.default, { show: true, inline: true });
        }
        var _a = this.props, onChange = _a.onChange, onValidate = _a.onValidate, tenantId = _a.tenantId, doBusyTask = _a.doBusyTask, otherProps = __rest(_a, ["onChange", "onValidate", "tenantId", "doBusyTask"]);
        return (React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.default, __assign({ label: "Select certificate" }, otherProps, { allowFilter: true, onChange: this.handleChange, items: this.getItems(), selectionRenderer: this.selectionRenderer })), actions: React.createElement(OpenDialogIconButton_1.default, { toolTipContent: "Search", wideDialog: true, icon: IconButton_1.Icon.Search },
                React.createElement(CertificateSelector_1.default, { onSelected: function (certificate) { return _this.handleChange(certificate.Id); }, selectedCertificateId: this.props.value, tenantId: this.props.tenantId })) }));
    };
    CertificateSelect.prototype.isCertificateExpired = function (certificate) {
        var now = moment();
        var certificateExpiry = moment(certificate.NotAfter);
        return certificateExpiry.isBefore(now);
    };
    return CertificateSelect;
}(React.Component));
exports.default = CertificateSelect;
exports.BoundCertificateSelect = BoundField_1.withBoundField(CertificateSelect);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\CertificateSelect\\CertificateSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\CertificateSelect\\CertificateSelect.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 799 */,
/* 800 */,
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var OpenDialogConnect_1 = __webpack_require__(266);
var Dialog_1 = __webpack_require__(121);
var dialogIdGenerator_1 = __webpack_require__(265);
var styles = __webpack_require__(349);
var IconButton_1 = __webpack_require__(56);
var OpenDialogIconButtonInternal = (function (_super) {
    __extends(OpenDialogIconButtonInternal, _super);
    function OpenDialogIconButtonInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.uniqueId = dialogIdGenerator_1.default.next();
        return _this;
    }
    OpenDialogIconButtonInternal.prototype.render = function () {
        var _this = this;
        var isOpen = this.props.openDialogs[this.uniqueId];
        return React.createElement("div", { className: styles.buttonDialogContainer },
            React.createElement(IconButton_1.default, { icon: this.props.icon, disabled: this.props.disabled, toolTipContent: this.props.toolTipContent, onClick: function () { return _this.props.openDialog(_this.uniqueId); } }),
            React.createElement(Dialog_1.default, { open: isOpen, wide: this.props.wideDialog }, this.props.children));
    };
    return OpenDialogIconButtonInternal;
}(React.Component));
var OpenDialogIconButton = OpenDialogConnect_1.OpenDialogConnect.to(OpenDialogIconButtonInternal);
exports.default = OpenDialogIconButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\OpenDialogIconButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\OpenDialogIconButton.tsx"); } } })();

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(136);
var FormSection_1 = __webpack_require__(664);
var ActionTemplateParameterInput_1 = __webpack_require__(396);
var _ = __webpack_require__(16);
// The purpose of this class is to provide consistent labels/help text etc for components that are external to the actual input
var ActionTemplateParameterInputFormElement = (function (_super) {
    __extends(ActionTemplateParameterInputFormElement, _super);
    function ActionTemplateParameterInputFormElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionTemplateParameterInputFormElement.prototype.shouldComponentUpdate = function (newProps) {
        return hasParameterChanged(newProps, this.props);
    };
    ActionTemplateParameterInputFormElement.prototype.render = function () {
        var parameter = this.props.parameter;
        var label = getLabel(parameter);
        return React.createElement(FormSection_1.default, { title: label, help: getHelpText(parameter) },
            React.createElement(ActionTemplateParameterInput_1.default, __assign({}, this.props)));
    };
    return ActionTemplateParameterInputFormElement;
}(React.Component));
exports.default = ActionTemplateParameterInputFormElement;
function hasParameterChanged(newParam, oldParam) {
    return !_.isEqual(newParam.value, oldParam.value) ||
        !_.isEqual(newParam.error, oldParam.error) ||
        !_.isEqual(newParam.warning, oldParam.warning) ||
        !_.isEqual(newParam.sourceItems, oldParam.sourceItems);
}
exports.hasParameterChanged = hasParameterChanged;
function getLabel(parameter) {
    return parameter.Label || parameter.Name;
}
exports.getLabel = getLabel;
function getHelpText(parameter, customEmptyHelpTextMarkup) {
    if (customEmptyHelpTextMarkup === void 0) { customEmptyHelpTextMarkup = null; }
    var label = parameter.Label || parameter.Name;
    var helpText = parameter.HelpText
        ? parameter.HelpText
        : customEmptyHelpTextMarkup ? customEmptyHelpTextMarkup(label) : "Provide a value for " + label;
    return React.createElement(index_1.default, { markup: helpText });
}
exports.getHelpText = getHelpText;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplateParameterInput\\ActionTemplateParameterInputRenderer.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplateParameterInput\\ActionTemplateParameterInputRenderer.tsx"); } } })();

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var ActionEditor = (function (_super) {
    __extends(ActionEditor, _super);
    function ActionEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionEditor.prototype.componentDidMount = function () {
        var properties = __assign({}, this.props.properties);
        if (this.props.isNew) {
            // Enable any permanent or initial features
            if (this.props.plugin.features) {
                var enabledFeatures_1 = [];
                if (this.props.plugin.features.permanent) {
                    this.props.plugin.features.permanent.forEach(function (feature) {
                        var featurePlugin = pluginRegistry_1.default.getFeature(feature);
                        if (featurePlugin.enable) {
                            featurePlugin.enable(properties);
                        }
                        enabledFeatures_1.push(feature);
                    });
                }
                if (this.props.plugin.features.initial) {
                    this.props.plugin.features.initial.forEach(function (feature) {
                        var featurePlugin = pluginRegistry_1.default.getFeature(feature);
                        if (featurePlugin.enable) {
                            featurePlugin.enable(properties);
                        }
                        enabledFeatures_1.push(feature);
                    });
                }
                properties["Octopus.Action.EnabledFeatures"] = enabledFeatures_1.join(",");
                this.props.setProperties(properties);
            }
        }
    };
    ActionEditor.prototype.render = function () {
        if (!this.props.plugin.edit) {
            throw new Error("Plugin " + this.props.plugin.actionType + " is missing 'Edit' property");
        }
        return React.createElement(this.props.plugin.edit, { plugin: this.props.plugin, projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, doBusyTask: this.props.doBusyTask, setProperties: this.props.setProperties, additionalActions: this.props.additionalActions, getFieldError: this.props.getFieldError, errors: this.props.errors });
    };
    return ActionEditor;
}(React.Component));
exports.default = ActionEditor;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionEditor\\ActionEditor.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionEditor\\ActionEditor.tsx"); } } })();

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var FeatureEditor = (function (_super) {
    __extends(FeatureEditor, _super);
    function FeatureEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            plugins: []
        };
        return _this;
    }
    FeatureEditor.prototype.componentDidMount = function () {
        this.refreshPlugins(this.props.enabledFeatures);
    };
    FeatureEditor.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.enabledFeatures !== this.props.enabledFeatures) {
            this.refreshPlugins(newProps.enabledFeatures);
        }
    };
    FeatureEditor.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null, this.state.plugins.map(function (plugin) {
            return React.createElement(plugin.edit, { key: "featureeditor-" + plugin.featureName, plugin: _this.props.plugin, projectId: _this.props.projectId, localNames: _this.props.localNames, properties: _this.props.properties, doBusyTask: _this.props.doBusyTask, setProperties: _this.props.setProperties, getFieldError: _this.props.getFieldError, errors: _this.props.errors });
        }));
    };
    FeatureEditor.prototype.refreshPlugins = function (enabledFeatures) {
        var featureNames = (enabledFeatures || "").split(",");
        var allFeatures = pluginRegistry_1.default.getAllFeatures();
        var plugins = [];
        allFeatures.forEach(function (feature) {
            var isEnabled = featureNames.includes(feature.featureName);
            if (!isEnabled) {
                return;
            }
            plugins.push(feature);
        });
        this.setState({ plugins: plugins });
    };
    return FeatureEditor;
}(React.Component));
exports.default = FeatureEditor;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FeatureEditor\\FeatureEditor.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\FeatureEditor\\FeatureEditor.tsx"); } } })();

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var OpenDialogButton_1 = __webpack_require__(74);
var ConfigureFeaturesContent_1 = __webpack_require__(1869);
var OpenFeatureDialog = function (props) {
    return React.createElement(OpenDialogButton_1.default, { label: "Configure features", wideDialog: true },
        React.createElement(ConfigureFeaturesContent_1.default, { actionType: props.actionType, properties: props.properties, saveDone: props.saveDone }));
};
OpenFeatureDialog.displayName = "OpenFeatureDialog";
exports.default = OpenFeatureDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\OpenFeatureDialog\\OpenFeatureDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\OpenFeatureDialog\\OpenFeatureDialog.tsx"); } } })();

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(16);
var ActionTemplateCategory_1 = __webpack_require__(1879);
var ActionTemplateCard_1 = __webpack_require__(464);
var ActionButton_1 = __webpack_require__(50);
var CommunityTemplateInstallation_1 = __webpack_require__(1882);
var matchesFilter_1 = __webpack_require__(465);
var Callout_1 = __webpack_require__(59);
var FeatureToggle_1 = __webpack_require__(224);
var InternalLink_1 = __webpack_require__(42);
var OpenDialogButton_1 = __webpack_require__(74);
var styles = __webpack_require__(272);
var PageDivider_1 = __webpack_require__(435);
var ActionTemplateCardList_1 = __webpack_require__(466);
var routeLinks_1 = __webpack_require__(20);
var InternalRedirect_1 = __webpack_require__(40);
__webpack_require__(1883);
var CommunityActionTemplateList = (function (_super) {
    __extends(CommunityActionTemplateList, _super);
    function CommunityActionTemplateList(props) {
        var _this = _super.call(this, props) || this;
        _this.showCategories = function () {
            _this.setState({ categoryTemplates: [], categories: _this.categoriseTemplates(_this.props.templates) });
        };
        _this.showAllTemplates = function () {
            _this.setState({ categoryTemplates: _this.props.templates, categories: [] });
        };
        _this.installationSucceeded = function (actionTemplate) {
            var url = _this.props.onPostSelectionUrlRequested({ Type: actionTemplate.ActionType, Id: actionTemplate.Id });
            _this.setState({ redirectTo: url });
        };
        _this.state = {
            categories: _this.categoriseTemplates(props.templates),
            categoryTemplates: []
        };
        return _this;
    }
    CommunityActionTemplateList.prototype.categoriseTemplates = function (templates) {
        var categorised = lodash_1.groupBy(templates, function (t) { return t.Category; });
        return Object.keys(categorised).sort(function (category1, category2) { return category1.toLowerCase().localeCompare(category2.toLowerCase()); })
            .map(function (categoryName) { return ({ name: categoryName, templates: categorised[categoryName] }); });
    };
    CommunityActionTemplateList.prototype.showCategoryTemplates = function (templates) {
        // We are setting min-hight here to avoid "screen jumping" when the user switches from categories to templates.
        // Ideally this would be handled by a CSS transform but it did not work.
        this.categoryTemplatesElement.style.minHeight = this.categoriesElement.clientHeight + "px";
        this.setState({ categoryTemplates: templates, categories: [] });
    };
    CommunityActionTemplateList.prototype.isInCategoryMode = function () {
        return this.state.categoryTemplates.length === 0 && this.state.categories.length > 0;
    };
    CommunityActionTemplateList.prototype.isInCategoryTemplatesMode = function () {
        return this.state.categoryTemplates.length > 0 && this.state.categories.length === 0;
    };
    CommunityActionTemplateList.prototype.componentWillReceiveProps = function (nextProps) {
        var nextState = { categories: this.categoriseTemplates(nextProps.templates) };
        if (!nextProps.filter) {
            nextState.categoryTemplates = [];
        }
        this.setState(nextState);
    };
    CommunityActionTemplateList.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: true });
        }
        var searchAllTemplates = this.props.filter;
        return React.createElement("div", null,
            React.createElement(PageDivider_1.default, null, "Community Contributed Step Templates"),
            React.createElement(FeatureToggle_1.default, { feature: FeatureToggle_1.Feature.CommunityActionTemplates, enabled: false },
                React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                    "Community library integration is disabled. If you want to take advantage of hundreds of great templates developed by the members of our community then please ",
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.configuration.features }, "enable the integration feature."))),
            React.createElement(FeatureToggle_1.default, { feature: FeatureToggle_1.Feature.CommunityActionTemplates }, this.props.templates.length === 0 && !this.props.filter && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                "Community library integration is enabled but there aren't any community step templates available. Review the community step templates ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.configuration.features }, "feature toggle"),
                " for more information.")),
            !searchAllTemplates ?
                React.createElement("div", null,
                    React.createElement("div", { className: styles.actions },
                        this.isInCategoryMode() && React.createElement(ActionButton_1.ActionButton, { label: "Show all", type: ActionButton_1.ActionButtonType.Ternary, onClick: this.showAllTemplates }),
                        this.isInCategoryTemplatesMode() &&
                            React.createElement(ActionButton_1.ActionButton, { label: "Back", type: ActionButton_1.ActionButtonType.Ternary, onClick: this.showCategories })),
                    React.createElement("div", { className: styles.groupingContainer },
                        React.createElement("ol", { className: styles.categories, ref: function (element) { return _this.categoriesElement = element; } },
                            React.createElement("div", null, this.state.categories.map(function (category) {
                                return _this.withAnimation(category.name, React.createElement(ActionTemplateCategory_1.default, { name: category.name, templates: category.templates, onCategorySelected: function () { return _this.showCategoryTemplates(category.templates); } }));
                            }))),
                        React.createElement("ol", { className: styles.categoryTemplates, ref: function (element) { return _this.categoryTemplatesElement = element; } },
                            React.createElement("div", null, this.state.categoryTemplates.map(function (template) { return _this.renderSingle(template); })))))
                :
                    this.filteredTemplates());
    };
    CommunityActionTemplateList.prototype.filteredTemplates = function () {
        var _this = this;
        var filteredResults = this.props.templates.filter(function (at) { return matchesFilter_1.default(at, _this.props.filter); });
        if (filteredResults.length === 0 && this.props.filter) {
            return React.createElement("p", null, "There are no community step templates that match your filter criteria.");
        }
        return React.createElement(ActionTemplateCardList_1.default, null, filteredResults.map(function (template) { return _this.renderSingle(template); }));
    };
    CommunityActionTemplateList.prototype.renderSingle = function (template) {
        return this.withAnimation(template.Type + template.Id, React.createElement(ActionTemplateCard_1.default, { template: template, primaryAction: this.installationDialog(template), secondaryAction: React.createElement(InternalLink_1.default, { size: 0.75, to: this.props.onDetailsUrlRequested(template) }, "View details") }));
    };
    CommunityActionTemplateList.prototype.withAnimation = function (key, content) {
        return React.createElement("div", { key: key, className: "animated zoomIn" }, content);
    };
    CommunityActionTemplateList.prototype.installationDialog = function (template) {
        return React.createElement(OpenDialogButton_1.default, { label: this.props.installationActionName, type: ActionButton_1.ActionButtonType.Primary },
            React.createElement(CommunityTemplateInstallation_1.default, { communityTemplateId: template.Id, title: this.props.installationActionName, detailsLink: this.props.onDetailsUrlRequested(template), saveDone: this.installationSucceeded }));
    };
    return CommunityActionTemplateList;
}(React.Component));
exports.default = CommunityActionTemplateList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplates\\CommunityActionTemplateList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplates\\CommunityActionTemplateList.tsx"); } } })();

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EmailPriority;
(function (EmailPriority) {
    EmailPriority["Low"] = "Low";
    EmailPriority["Normal"] = "Normal";
    EmailPriority["High"] = "High";
})(EmailPriority = exports.EmailPriority || (exports.EmailPriority = {}));
exports.default = EmailPriority;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\emailPriority.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\emailPriority.ts"); } } })();

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MetadataTypeHelpers = (function () {
    function MetadataTypeHelpers() {
    }
    MetadataTypeHelpers.isCompositeType = function (property) {
        var validSimpleTypes = ["raw_list", "raw_map", "bool", "boolean", "string", "string[]", "long", "int", "bool?", "long?", "int?", "SensitiveValue"];
        return !validSimpleTypes.includes(property.Type);
    };
    MetadataTypeHelpers.isValidatableType = function (property) {
        var validValidationTypes = ["string", "string[]", "long", "int", "SensitiveValue"];
        return validValidationTypes.includes(property.Type);
    };
    MetadataTypeHelpers.getRequiredMessage = function (property) {
        return property.DisplayInfo.Label + " is required";
    };
    return MetadataTypeHelpers;
}());
exports.default = MetadataTypeHelpers;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DynamicForm\\MetadataTypeHelpers.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DynamicForm\\MetadataTypeHelpers.tsx"); } } })();

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var EmailLink = function (props) {
    if (props.emailAddress) {
        var href = "mailto:" + props.emailAddress;
        return React.createElement("a", { href: href, "aria-label": props.emailAddress }, props.emailAddress);
    }
    else {
        return null;
    }
};
exports.default = EmailLink;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EmailLink\\EmailLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EmailLink\\EmailLink.tsx"); } } })();

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(811);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(31);
var react_redux_1 = __webpack_require__(67);
var App_1 = __webpack_require__(885);
__webpack_require__(1926);
var colors_1 = __webpack_require__(32);
var store_1 = __webpack_require__(147);
var extensionsManager_1 = __webpack_require__(702);
var Theme_1 = __webpack_require__(704);
__webpack_require__(1929);
__webpack_require__(714);
var ErrorBoundary_1 = __webpack_require__(239);
window.Octopus = extensionsManager_1.default;
var render = function (Component) {
    ReactDOM.render(React.createElement(ErrorBoundary_1.default, null,
        React.createElement(Theme_1.default, { theme: colors_1.theme },
            React.createElement(react_redux_1.Provider, { store: store_1.default },
                React.createElement(Component, null)))), document.getElementById("app"));
};
render(App_1.default);
//Do NOT move to a separate file as this wil break hot reloading
if (false) {
    module.hot.accept("./reducers", function () {
        // When reducers change, replace them but keep the current app state
        console.log("Store updated. Replacing root reducer");
        // If the callback to hot.accept throws
        // an exception, the HMR update will fail. If using
        // webpack-dev-server, the page will be reloaded,
        // and we lose the error. So try/catch/log.
        //
        try {
            var nextReducer = require("./reducers").reducers;
            store_1.default.replaceReducer(nextReducer);
        }
        catch (err) {
            console.error("Error updating store", err);
        }
    });
    module.hot.accept("./App", function () {
        try {
            var NextApp = require("./App").default;
            render(NextApp);
        }
        catch (err) {
            console.error("Error updating store", err);
        }
    });
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\index.tsx"); } } })();

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(812);
__webpack_require__(834);
__webpack_require__(839);
__webpack_require__(841);
__webpack_require__(843);
__webpack_require__(846);
__webpack_require__(848);
__webpack_require__(850);
__webpack_require__(854);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\polyfills.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\polyfills.ts"); } } })();

/***/ }),
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var react_router_dom_2 = __webpack_require__(61);
var SecureRoute_1 = __webpack_require__(904);
var StandardLayout_1 = __webpack_require__(1236);
var SignIn_1 = __webpack_require__(1899);
var SignOut_1 = __webpack_require__(1908);
var Register_1 = __webpack_require__(1912);
var ConfirmNavigate_1 = __webpack_require__(1916);
var AuthenticationLayout_1 = __webpack_require__(1920);
var ReloadableRoute_1 = __webpack_require__(80);
var routeLinks_1 = __webpack_require__(20);
var App = (function (_super) {
    __extends(App, _super);
    function App(props) {
        return _super.call(this, props) || this;
    }
    App.prototype.render = function () {
        return React.createElement(react_router_dom_2.HashRouter, { getUserConfirmation: ConfirmNavigate_1.default },
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.signIn, render: function (props) { return React.createElement(AuthenticationLayout_1.default, null,
                        React.createElement(SignIn_1.default, __assign({}, props))); } }),
                React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.signOut, render: function (props) { return React.createElement(AuthenticationLayout_1.default, null,
                        React.createElement(SignOut_1.default, __assign({}, props))); } }),
                React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.register(":inviteCode"), render: function (props) { return React.createElement(AuthenticationLayout_1.default, null,
                        React.createElement(Register_1.default, __assign({}, props))); } }),
                React.createElement(SecureRoute_1.default, { path: routeLinks_1.default.root, component: StandardLayout_1.StandardLayout })));
    };
    return App;
}(React.Component));
exports.default = App;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\App.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\App.tsx"); } } })();

/***/ }),
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SecureRoute_1 = __webpack_require__(905);
exports.default = SecureRoute_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SecureRoute\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SecureRoute\\index.tsx"); } } })();

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var ReloadableRoute_1 = __webpack_require__(80);
var InternalRedirect_1 = __webpack_require__(40);
var routeLinks_1 = __webpack_require__(20);
var SecureRoute = (function (_super) {
    __extends(SecureRoute, _super);
    function SecureRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SecureRoute.prototype.render = function () {
        var _a = this.props, Component = _a.component, rest = __rest(_a, ["component"]);
        return (React.createElement(ReloadableRoute_1.default, __assign({}, rest, { render: function (props) {
                return clientInstance_1.session.isAuthenticated() ?
                    React.createElement(Component, __assign({}, rest)) :
                    React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.currentUser.signIn, state: { from: props.location } } });
            } })));
    };
    return SecureRoute;
}(React.Component));
exports.default = SecureRoute;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SecureRoute\\SecureRoute.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SecureRoute\\SecureRoute.tsx"); } } })();

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = __webpack_require__(907);
exports.Client = client_1.default;
var repository_1 = __webpack_require__(1070);
exports.Repository = repository_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\index.ts"); } } })();

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var resolver_1 = __webpack_require__(773);
var logger_1 = __webpack_require__(99);
var ajax_1 = __webpack_require__(914);
var environment_1 = __webpack_require__(238);
// The Octopus Client implements the low-level semantics of the Octopus Deploy REST API
var Client = (function () {
    function Client(configuration) {
        configuration = this.extend({ serverEndpoint: null }, configuration);
        var endpoint = this.normalizeEndpoint(configuration.serverEndpoint);
        logger_1.default.log("Creating Octopus client for endpoint: " + endpoint);
        this.currentResolver = new resolver_1.default(endpoint);
        this.rootDocument = null;
        this.resolve = this.currentResolver.resolve.bind(this.currentResolver);
    }
    Client.prototype.connect = function (progressCallback) {
        var _this = this;
        progressCallback("Checking your credentials. Please wait...", "");
        return new Promise(function (resolve, reject) {
            if (_this.rootDocument) {
                resolve(_this.rootDocument);
                return;
            }
            var attempt = function (success, fail) {
                _this.get("~/api")
                    .then(success, fail);
            };
            var onSuccess = function (root) {
                _this.rootDocument = root;
                _this.version = root.Version;
                resolve(_this.rootDocument);
            };
            var fails = 0;
            var onFail = function (err) {
                if (err.StatusCode !== 503) {
                    fails++;
                }
                if ((err.StatusCode === 0 || err.StatusCode === 503) && fails < 20) {
                    logger_1.default.warn("Unable to connect, trying again in 1 second...", err);
                    if (err.StatusCode === 503) {
                        progressCallback(err.ErrorMessage, "success");
                    }
                    else if (err.StatusCode === 0) {
                        progressCallback("The Octopus Server does not appear to have started, trying again...", "warning");
                    }
                    setTimeout(function () {
                        logger_1.default.warn("Trying again", err);
                        attempt(onSuccess, onFail);
                    }, 1000);
                }
                else {
                    progressCallback("Unable to connect, unexpected error, or timeout exceeded.", "error");
                    logger_1.default.error("Unable to connect, unexpected error, or timeout exceeded", err);
                    reject(err);
                }
            };
            attempt(onSuccess, onFail);
        });
    };
    Client.prototype.get = function (path, args) {
        var url = this.currentResolver.resolve(path, args);
        return this.dispatchRequest("GET", url);
    };
    Client.prototype.getRaw = function (path, args) {
        var _this = this;
        var url = this.currentResolver.resolve(path, args);
        return new Promise(function (resolve, reject) {
            new ajax_1.default({
                client: _this,
                method: "GET",
                error: function (e) { return reject(e); },
                url: url,
                raw: true,
                success: function (data) { return resolve(data); }
            }).execute();
        });
    };
    Client.prototype.post = function (path, resource, args) {
        var url = this.currentResolver.resolve(path, args);
        return this.dispatchRequest("POST", url, resource);
    };
    Client.prototype.create = function (path, resource, args) {
        var _this = this;
        var url = this.currentResolver.resolve(path, args);
        return new Promise(function (resolve, reject) {
            _this.dispatchRequest("POST", url, resource)
                .then(function (result) {
                _this.dispatchRequest("GET", _this.currentResolver.resolve(result.Links.Self))
                    .then(function (result2) {
                    resolve(result2);
                }, reject);
            }, reject);
        });
    };
    Client.prototype.update = function (path, resource, args) {
        var _this = this;
        var url = this.currentResolver.resolve(path, args);
        return new Promise(function (resolve, reject) {
            _this.dispatchRequest("PUT", url, resource)
                .then(function () {
                _this.dispatchRequest("GET", url)
                    .then(function (result2) {
                    resolve(result2);
                }, reject);
            }, reject);
        });
    };
    Client.prototype.del = function (path, resource, args) {
        var url = this.currentResolver.resolve(path, args);
        return this.dispatchRequest("DELETE", url, resource);
    };
    Client.prototype.put = function (path, resource) {
        var url = this.currentResolver.resolve(path);
        return this.dispatchRequest("PUT", url, resource);
    };
    Client.prototype.getAntiforgeryToken = function () {
        if (!this.isConnected()) {
            return null;
        }
        var installationId = this.getRootDocument().InstallationId;
        if (!installationId) {
            return null;
        }
        // If we have come this far we know we are on a version of Octopus Server which supports anti-forgery tokens
        var antiforgeryCookieName = "Octopus-Csrf-Token_" + installationId;
        var antiforgeryCookies = document.cookie.split(";").filter(function (c) {
            return c.trim().indexOf(antiforgeryCookieName) === 0;
        }).map(function (c) {
            return c.trim();
        });
        if (antiforgeryCookies && antiforgeryCookies.length === 1) {
            var antiforgeryToken = antiforgeryCookies[0].split("=")[1];
            return antiforgeryToken;
        }
        else {
            if (environment_1.default.isInDevelopmentMode()) {
                return "FAKE TOKEN USED FOR DEVELOPMENT";
            }
            return null;
        }
    };
    Client.prototype.getRootDocument = function () {
        if (!this.isConnected()) {
            throw new Error("The Octopus Client has not connected.");
        }
        return this.rootDocument;
    };
    Client.prototype.resolveLinkTemplate = function (link, args) {
        return this.resolve(this.getRootDocument().Links[link], args);
    };
    Client.prototype.extend = function (arg1, arg2) {
        return __assign({}, arg1, arg2);
    };
    Client.prototype.dispatchRequest = function (method, url, requestBody) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            new ajax_1.default({
                client: _this,
                error: function (e) { return reject(e); },
                method: method,
                url: url,
                requestBody: requestBody,
                success: function (data) { return resolve(data); },
            }).execute();
        });
    };
    Client.prototype.isConnected = function () {
        return this.rootDocument !== null;
    };
    Client.prototype.normalizeEndpoint = function (endpoint) {
        if (endpoint == null || endpoint.length === 0) {
            endpoint = "" + window.location.protocol;
            if (!endpoint.endsWith("//")) {
                endpoint = endpoint + "//";
            }
            endpoint = endpoint + window.location.host;
            var path = window.location.pathname;
            if (!path.startsWith("/")) {
                path = "/" + path;
            }
            if (path.length >= 1) {
                var lastSegmentIndex = path.lastIndexOf("/");
                if (lastSegmentIndex >= 0) {
                    path = path.substring(0, lastSegmentIndex + 1);
                }
            }
            endpoint = endpoint + path;
        }
        return endpoint;
    };
    return Client;
}());
exports.default = Client;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\client.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\client.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 908 */,
/* 909 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// We use our own AJAX function so that we"re not too coupled to jQuery
var logger_1 = __webpack_require__(99);
var clientInstance_1 = __webpack_require__(10);
var resources_1 = __webpack_require__(26);
var serverVersionNotificationCheck_1 = __webpack_require__(1001);
var Ajax = (function () {
    function Ajax(options) {
        if (options === void 0) { options = {
            method: "GET",
            nonStale: true,
            raw: false,
            url: null,
            client: null,
            error: function (e) { return undefined; },
            requestBody: null,
            success: function (data) { return undefined; }
        }; }
        var _this = this;
        this.checkAuthentication = function () {
            // If we don't have an anti-forgery token we need to get one by logging in again
            if (clientInstance_1.session.isAuthenticated() && !clientInstance_1.client.getAntiforgeryToken() && !isAnonymous(_this.options.url)) {
                logger_1.default.warn("The expected anti-forgery cookie is missing or has expired. Redirecting to login page, but will return to " + window.location.href + ". " +
                    "See http://g.octopushq.com/CSRF for more details and troubleshooting.");
                _this.reAuthenticateAndReturn();
                return false;
            }
            else {
                return true;
            }
        };
        this.reAuthenticateAndReturn = function () {
            clientInstance_1.repository.Users.signOut().then(function () {
                clientInstance_1.session.end();
                window.location.reload();
            });
        };
        this.handleSuccess = function (request, cachedResult) {
            serverVersionNotificationCheck_1.serverVersionNotificationCheck(request);
            var responseBody = cachedResult;
            if (!responseBody || !clientInstance_1.session.cache.canUseCachedValue(request)) {
                responseBody = request.responseText;
                clientInstance_1.session.cache.updateCache(request, _this.options);
            }
            _this.options.success(deserialize(responseBody, _this.options.raw));
        };
        this.handleError = function (request) {
            var err = generateOctopusError(request);
            if (err.StatusCode === 401 && !isAnonymous(_this.options.url) && !isAuthenticationCheck(_this.options.url)) {
                logger_1.default.warn("Session Auth Cookie has expired or is missing. Redirecting to login page, but will return to " + window.location.href + ".");
                _this.reAuthenticateAndReturn();
            }
            _this.options.error(err);
        };
        this.options = options;
    }
    Ajax.prototype.execute = function () {
        var _this = this;
        var request = createXMLHTTPObject();
        if (!request) {
            return;
        }
        request.open(getMethod(this.options.method).method, this.options.url, true);
        request.withCredentials = true;
        this.setHeaders(request);
        var cachedResult = clientInstance_1.session.cache.setHeaderAndGetValue(request, this.options);
        request.onreadystatechange = function () {
            if (request.readyState !== XMLHttpRequest.DONE) {
                return;
            }
            else if (request.status < 100 || request.status >= 400) {
                _this.handleError(request);
            }
            else {
                _this.handleSuccess(request, cachedResult);
            }
        };
        if (request.readyState === XMLHttpRequest.DONE) {
            return;
        }
        if (!this.checkAuthentication()) {
            logger_1.default.log("Canceled request", request);
            return;
        }
        this.sendRequest(request);
    };
    Ajax.prototype.sendRequest = function (request) {
        var body = this.options.requestBody;
        if (typeof (body) === "undefined") {
            request.send();
        }
        else if (typeof (body) === "string" || isFormData(body)) {
            request.send(body);
        }
        else {
            var bodyJson = JSON.stringify(body);
            request.send(bodyJson);
        }
    };
    Ajax.prototype.setHeaders = function (request) {
        var _a = getMethod(this.options.method), method = _a.method, methodOverride = _a.methodOverride;
        request.setRequestHeader("X-Octopus-User-Agent", "OctopusClient-js/" + this.options.client.version);
        request.setRequestHeader("Accept", "application/json");
        if (this.options.requestBody && !isFormData(this.options.requestBody)) {
            request.setRequestHeader("Content-type", "application/json");
        }
        if (methodOverride) {
            request.setRequestHeader("X-HTTP-Method-Override", methodOverride);
        }
        // Set X-Octopus-Csrf-Token header if there is an antiforgery cookie available and it"s a mutating request
        if (method === "POST" || method === "PUT" || method === "DELETE") {
            var antiforgeryToken = this.options.client.getAntiforgeryToken();
            if (antiforgeryToken) {
                request.setRequestHeader("X-Octopus-Csrf-Token", antiforgeryToken);
            }
        }
    };
    return Ajax;
}());
exports.default = Ajax;
var deserialize = function (responseText, raw, forceJson) {
    if (forceJson === void 0) { forceJson = false; }
    if (raw && !forceJson) {
        return responseText;
    }
    if (responseText && responseText.length) {
        return JSON.parse(responseText);
    }
    return null;
};
var getMethod = function (method) {
    var methodOverride = null;
    if (method === "PUT") {
        methodOverride = "PUT";
        method = "POST";
    }
    if (method === "DELETE") {
        methodOverride = "DELETE";
        method = "POST";
    }
    return { method: method, methodOverride: methodOverride };
};
var isAnonymous = function (url) {
    return url.includes("/users/register/") || url.endsWith("/users/login") || url.endsWith("/users/logout") || url.endsWith("/api");
};
var isAuthenticationCheck = function (url) {
    return url.endsWith("/users/me");
};
var isFormData = function (item) {
    return item instanceof FormData;
};
var generateOctopusError = function (request) {
    var error = new resources_1.OctopusError(request.status);
    try {
        if (request.status === XMLHttpRequest.UNSENT) {
            error.ErrorMessage = "There was a problem with your request.";
            error.Errors = ["Unable to establish a connection to the Octopus Deploy server. " +
                    "The server may be offline. Please check your network connection."];
        }
        else {
            error = resources_1.OctopusError.create(request.status, deserialize(request.responseText, false, true));
            if (!error.ErrorMessage) {
                error.ErrorMessage = "There was a problem with your request.";
                error.Errors = ["The Octopus Deploy server returned a status of: " + request.status];
                error.FullException = request.response;
            }
        }
    }
    catch (err) {
        error.ErrorMessage = "There was a problem with your request.";
        error.Errors = ["Unhandled error when communicating with the Octopus Deploy server. " +
                "The server returned a status of: " + request.status];
        error.FullException = err.toString();
    }
    return error;
};
var XMLHttpFactories = [
    function () {
        return new XMLHttpRequest();
    },
    function () {
        return new ActiveXObject("Msxml2.XMLHTTP");
    },
    function () {
        return new ActiveXObject("Msxml3.XMLHTTP");
    },
    function () {
        return new ActiveXObject("MSXML2.XMLHTTP.3.0");
    },
    function () {
        return new ActiveXObject("Microsoft.XMLHTTP");
    }
];
var createXMLHTTPObject = function () {
    var xmlhttp = null;
    // tslint:disable-next-line
    for (var i = 0; i < XMLHttpFactories.length; i++) {
        try {
            xmlhttp = XMLHttpFactories[i]();
        }
        catch (e) {
            continue;
        }
        break;
    }
    return xmlhttp;
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\ajax.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\ajax.ts"); } } })();

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\actionTemplateResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\actionTemplateResource.ts"); } } })();

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\actionTemplateParameterResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\actionTemplateParameterResource.ts"); } } })();

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AccountUsageResource = (function () {
    function AccountUsageResource() {
    }
    return AccountUsageResource;
}());
exports.AccountUsageResource = AccountUsageResource;
var TargetUsageEntry = (function () {
    function TargetUsageEntry() {
    }
    return TargetUsageEntry;
}());
exports.TargetUsageEntry = TargetUsageEntry;
var ProjectVariableSetUsage = (function () {
    function ProjectVariableSetUsage() {
    }
    return ProjectVariableSetUsage;
}());
exports.ProjectVariableSetUsage = ProjectVariableSetUsage;
var LibraryVariableSetUsageEntry = (function () {
    function LibraryVariableSetUsageEntry() {
    }
    return LibraryVariableSetUsageEntry;
}());
exports.LibraryVariableSetUsageEntry = LibraryVariableSetUsageEntry;
var ReleaseUsage = (function () {
    function ReleaseUsage() {
    }
    return ReleaseUsage;
}());
exports.ReleaseUsage = ReleaseUsage;
var ReleaseUsageEntry = (function () {
    function ReleaseUsageEntry() {
    }
    return ReleaseUsageEntry;
}());
exports.ReleaseUsageEntry = ReleaseUsageEntry;
var StepUsage = (function () {
    function StepUsage() {
    }
    return StepUsage;
}());
exports.StepUsage = StepUsage;
var StepUsageEntry = (function () {
    function StepUsageEntry() {
    }
    return StepUsageEntry;
}());
exports.StepUsageEntry = StepUsageEntry;
exports.default = AccountUsageResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\accountUsageResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\accountUsageResource.ts"); } } })();

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AlertSeverity;
(function (AlertSeverity) {
    AlertSeverity["Info"] = "Info";
    AlertSeverity["Warning"] = "Warning";
    AlertSeverity["Danger"] = "Danger";
})(AlertSeverity = exports.AlertSeverity || (exports.AlertSeverity = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\alertResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\alertResource.ts"); } } })();

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\artifactResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\artifactResource.ts"); } } })();

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var ApiKeyResource = (function (_super) {
    __extends(ApiKeyResource, _super);
    function ApiKeyResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ApiKeyResource;
}(resource_1.default));
exports.ApiKeyResource = ApiKeyResource;
exports.default = ApiKeyResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\apiKeyResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\apiKeyResource.ts"); } } })();

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\azureWebSite.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\azureWebSite.ts"); } } })();

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\builtInFeedStatsResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\builtInFeedStatsResource.ts"); } } })();

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var BuiltInRepositoryConfigurationResource = (function (_super) {
    __extends(BuiltInRepositoryConfigurationResource, _super);
    function BuiltInRepositoryConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BuiltInRepositoryConfigurationResource;
}(resource_1.default));
exports.BuiltInRepositoryConfigurationResource = BuiltInRepositoryConfigurationResource;
exports.default = BuiltInRepositoryConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\builtInRepositoryConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\builtInRepositoryConfigurationResource.ts"); } } })();

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\channelResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\channelResource.ts"); } } })();

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\channelVersionRuleResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\channelVersionRuleResource.ts"); } } })();

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var CertificateConfigurationResource = (function (_super) {
    __extends(CertificateConfigurationResource, _super);
    function CertificateConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CertificateConfigurationResource;
}(resource_1.default));
exports.CertificateConfigurationResource = CertificateConfigurationResource;
exports.default = CertificateConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\certificateConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\certificateConfigurationResource.ts"); } } })();

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CertificateDataFormat;
(function (CertificateDataFormat) {
    CertificateDataFormat["Pkcs12"] = "Pkcs12";
    CertificateDataFormat["Der"] = "Der";
    CertificateDataFormat["Pem"] = "Pem";
})(CertificateDataFormat = exports.CertificateDataFormat || (exports.CertificateDataFormat = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\certificateResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\certificateResource.ts"); } } })();

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ControlType;
(function (ControlType) {
    ControlType["SingleLineText"] = "SingleLineText";
    ControlType["MultiLineText"] = "MultiLineText";
    ControlType["Select"] = "Select";
    ControlType["Checkbox"] = "Checkbox";
    ControlType["Sensitive"] = "Sensitive";
    ControlType["StepName"] = "StepName";
    ControlType["AzureAccount"] = "AzureAccount";
    ControlType["Certificate"] = "Certificate";
    ControlType["AmazonWebServicesAccount"] = "AmazonWebServicesAccount";
})(ControlType = exports.ControlType || (exports.ControlType = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\controlType.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\controlType.ts"); } } })();

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardConfigurationResource.ts"); } } })();

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardEnvironmentResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardEnvironmentResource.ts"); } } })();

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardItemResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardItemResource.ts"); } } })();

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardProjectGroupResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardProjectGroupResource.ts"); } } })();

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardProjectResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardProjectResource.ts"); } } })();

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardResource.ts"); } } })();

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardTenantResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\dashboardTenantResource.ts"); } } })();

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var DeploymentProcessResource = (function (_super) {
    __extends(DeploymentProcessResource, _super);
    function DeploymentProcessResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeploymentProcessResource;
}(resource_1.default));
exports.DeploymentProcessResource = DeploymentProcessResource;
exports.default = DeploymentProcessResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\deploymentProcessResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\deploymentProcessResource.ts"); } } })();

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\deploymentResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\deploymentResource.ts"); } } })();

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\deploymentTemplateResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\deploymentTemplateResource.ts"); } } })();

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var namedResource_1 = __webpack_require__(187);
var CommunicationStyle;
(function (CommunicationStyle) {
    CommunicationStyle["None"] = "None";
    CommunicationStyle["TentaclePassive"] = "TentaclePassive";
    CommunicationStyle["TentacleActive"] = "TentacleActive";
    CommunicationStyle["Ssh"] = "Ssh";
    CommunicationStyle["OfflineDrop"] = "OfflineDrop";
    CommunicationStyle["AzureWebApp"] = "AzureWebApp";
    CommunicationStyle["Ftp"] = "Ftp";
    CommunicationStyle["AzureCloudService"] = "AzureCloudService";
})(CommunicationStyle = exports.CommunicationStyle || (exports.CommunicationStyle = {}));
var EndpointResource = (function (_super) {
    __extends(EndpointResource, _super);
    function EndpointResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EndpointResource;
}(namedResource_1.default));
exports.EndpointResource = EndpointResource;
var TentacleEndpointResource = (function (_super) {
    __extends(TentacleEndpointResource, _super);
    function TentacleEndpointResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TentacleEndpointResource;
}(EndpointResource));
exports.TentacleEndpointResource = TentacleEndpointResource;
var ListeningTentacleEndpointResource = (function (_super) {
    __extends(ListeningTentacleEndpointResource, _super);
    function ListeningTentacleEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.TentaclePassive;
        return _this;
    }
    return ListeningTentacleEndpointResource;
}(TentacleEndpointResource));
exports.ListeningTentacleEndpointResource = ListeningTentacleEndpointResource;
var PollingTentacleEndpointResource = (function (_super) {
    __extends(PollingTentacleEndpointResource, _super);
    function PollingTentacleEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.TentacleActive;
        return _this;
    }
    return PollingTentacleEndpointResource;
}(TentacleEndpointResource));
exports.PollingTentacleEndpointResource = PollingTentacleEndpointResource;
// tslint:disable-next-line:no-empty-interface
var AgentlessEndpointResource = (function (_super) {
    __extends(AgentlessEndpointResource, _super);
    function AgentlessEndpointResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AgentlessEndpointResource;
}(EndpointResource));
exports.AgentlessEndpointResource = AgentlessEndpointResource;
var AzureWebAppEndpointResource = (function (_super) {
    __extends(AzureWebAppEndpointResource, _super);
    function AzureWebAppEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.AzureWebApp;
        return _this;
    }
    return AzureWebAppEndpointResource;
}(AgentlessEndpointResource));
exports.AzureWebAppEndpointResource = AzureWebAppEndpointResource;
var CloudRegionEndpointResource = (function (_super) {
    __extends(CloudRegionEndpointResource, _super);
    function CloudRegionEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.None;
        return _this;
    }
    return CloudRegionEndpointResource;
}(AgentlessEndpointResource));
exports.CloudRegionEndpointResource = CloudRegionEndpointResource;
var CloudServiceEndpointResource = (function (_super) {
    __extends(CloudServiceEndpointResource, _super);
    function CloudServiceEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.AzureCloudService;
        return _this;
    }
    return CloudServiceEndpointResource;
}(AgentlessEndpointResource));
exports.CloudServiceEndpointResource = CloudServiceEndpointResource;
var OfflineDropEndpointResource = (function (_super) {
    __extends(OfflineDropEndpointResource, _super);
    function OfflineDropEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.OfflineDrop;
        return _this;
    }
    return OfflineDropEndpointResource;
}(AgentlessEndpointResource));
exports.OfflineDropEndpointResource = OfflineDropEndpointResource;
var SshEndpointResource = (function (_super) {
    __extends(SshEndpointResource, _super);
    function SshEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.Ssh;
        return _this;
    }
    return SshEndpointResource;
}(AgentlessEndpointResource));
exports.SshEndpointResource = SshEndpointResource;
exports.default = EndpointResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\endpointResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\endpointResource.ts"); } } })();

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\environmentResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\environmentResource.ts"); } } })();

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\environmentSummaryResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\environmentSummaryResource.ts"); } } })();

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\environmentsSummaryResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\environmentsSummaryResource.ts"); } } })();

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\eventResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\eventResource.ts"); } } })();

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\extensionsInfoResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\extensionsInfoResource.ts"); } } })();

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\externalSecurityGroupProviderResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\externalSecurityGroupProviderResource.ts"); } } })();

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var FeaturesConfigurationResource = (function (_super) {
    __extends(FeaturesConfigurationResource, _super);
    function FeaturesConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FeaturesConfigurationResource;
}(resource_1.default));
exports.FeaturesConfigurationResource = FeaturesConfigurationResource;
exports.default = FeaturesConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\featuresConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\featuresConfigurationResource.ts"); } } })();

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\interruptionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\interruptionResource.ts"); } } })();

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var InvitationResource = (function (_super) {
    __extends(InvitationResource, _super);
    function InvitationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InvitationResource;
}(resource_1.default));
exports.InvitationResource = InvitationResource;
exports.default = InvitationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\invitationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\invitationResource.ts"); } } })();

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var LetsEncryptConfigurationResource = (function (_super) {
    __extends(LetsEncryptConfigurationResource, _super);
    function LetsEncryptConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LetsEncryptConfigurationResource;
}(resource_1.default));
exports.LetsEncryptConfigurationResource = LetsEncryptConfigurationResource;
exports.default = LetsEncryptConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\letsEncryptConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\letsEncryptConfigurationResource.ts"); } } })();

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var licenseStatusResource_1 = __webpack_require__(498);
var LicenseResource = (function (_super) {
    __extends(LicenseResource, _super);
    function LicenseResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LicenseResource;
}(licenseStatusResource_1.LicenseStatusResource));
exports.LicenseResource = LicenseResource;
exports.default = LicenseResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\licenseResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\licenseResource.ts"); } } })();

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\lifecycleResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\lifecycleResource.ts"); } } })();

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\linksCollection.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\linksCollection.ts"); } } })();

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\loginCommand.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\loginCommand.ts"); } } })();

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\loginState.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\loginState.ts"); } } })();

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DeleteMachinesBehavior;
(function (DeleteMachinesBehavior) {
    DeleteMachinesBehavior["DoNotDelete"] = "DoNotDelete";
    DeleteMachinesBehavior["DeleteUnavailableMachines"] = "DeleteUnavailableMachines";
})(DeleteMachinesBehavior = exports.DeleteMachinesBehavior || (exports.DeleteMachinesBehavior = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineCleanupPolicy.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineCleanupPolicy.ts"); } } })();

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MachineConnectivityBehavior;
(function (MachineConnectivityBehavior) {
    MachineConnectivityBehavior["ExpectedToBeOnline"] = "ExpectedToBeOnline";
    MachineConnectivityBehavior["MayBeOfflineAndCanBeSkipped"] = "MayBeOfflineAndCanBeSkipped";
})(MachineConnectivityBehavior = exports.MachineConnectivityBehavior || (exports.MachineConnectivityBehavior = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineConnectivityPolicy.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineConnectivityPolicy.ts"); } } })();

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineConnectionStatus.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineConnectionStatus.ts"); } } })();

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineHealthCheckPolicy.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineHealthCheckPolicy.ts"); } } })();

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machinePolicyResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machinePolicyResource.ts"); } } })();

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MachineScriptPolicyRunType;
(function (MachineScriptPolicyRunType) {
    MachineScriptPolicyRunType["InheritFromDefault"] = "InheritFromDefault";
    MachineScriptPolicyRunType["Inline"] = "Inline";
    MachineScriptPolicyRunType["OnlyConnectivity"] = "OnlyConnectivity";
})(MachineScriptPolicyRunType = exports.MachineScriptPolicyRunType || (exports.MachineScriptPolicyRunType = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineScriptPolicy.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineScriptPolicy.ts"); } } })();

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CalamariUpdateBehavior;
(function (CalamariUpdateBehavior) {
    CalamariUpdateBehavior["UpdateOnDeployment"] = "UpdateOnDeployment";
    CalamariUpdateBehavior["UpdateOnNewMachine"] = "UpdateOnNewMachine";
    CalamariUpdateBehavior["UpdateAlways"] = "UpdateAlways";
})(CalamariUpdateBehavior = exports.CalamariUpdateBehavior || (exports.CalamariUpdateBehavior = {}));
var TentacleUpdateBehavior;
(function (TentacleUpdateBehavior) {
    TentacleUpdateBehavior["NeverUpdate"] = "NeverUpdate";
    TentacleUpdateBehavior["Update"] = "Update";
})(TentacleUpdateBehavior = exports.TentacleUpdateBehavior || (exports.TentacleUpdateBehavior = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineUpdatePolicy.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\machineUpdatePolicy.ts"); } } })();

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var MaintenanceConfigurationResource = (function (_super) {
    __extends(MaintenanceConfigurationResource, _super);
    function MaintenanceConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MaintenanceConfigurationResource;
}(resource_1.default));
exports.MaintenanceConfigurationResource = MaintenanceConfigurationResource;
exports.default = MaintenanceConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\maintenanceConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\maintenanceConfigurationResource.ts"); } } })();

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\namedReferenceItem.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\namedReferenceItem.ts"); } } })();

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\octopusServerNodeResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\octopusServerNodeResource.ts"); } } })();

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\packageResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\packageResource.ts"); } } })();

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\permissions.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\permissions.ts"); } } })();

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\permissionDescriptionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\permissionDescriptionResource.ts"); } } })();

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\progressionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\progressionResource.ts"); } } })();

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GuidedFailureMode;
(function (GuidedFailureMode) {
    GuidedFailureMode["EnvironmentDefault"] = "EnvironmentDefault";
    GuidedFailureMode["Off"] = "Off";
    GuidedFailureMode["On"] = "On";
})(GuidedFailureMode = exports.GuidedFailureMode || (exports.GuidedFailureMode = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\projectResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\projectResource.ts"); } } })();

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\projectGroupResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\projectGroupResource.ts"); } } })();

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\proxyResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\proxyResource.ts"); } } })();

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\propertyValueResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\propertyValueResource.ts"); } } })();

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\releaseProgressionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\releaseProgressionResource.ts"); } } })();

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\releaseResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\releaseResource.ts"); } } })();

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\releaseTemplateResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\releaseTemplateResource.ts"); } } })();

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\resourceCollection.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\resourceCollection.ts"); } } })();

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RetentionUnit;
(function (RetentionUnit) {
    RetentionUnit["Days"] = "Days";
    RetentionUnit["Items"] = "Items";
})(RetentionUnit = exports.RetentionUnit || (exports.RetentionUnit = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\retentionPeriod.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\retentionPeriod.ts"); } } })();

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var RootResource = (function (_super) {
    __extends(RootResource, _super);
    function RootResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RootResource;
}(resource_1.default));
exports.RootResource = RootResource;
exports.default = RootResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\rootResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\rootResource.ts"); } } })();

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\scheduledTaskDetailsResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\scheduledTaskDetailsResource.ts"); } } })();

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["Event"] = "Event";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
function isExistingSubscriptionResource(T) {
    return T.Links !== undefined;
}
exports.isExistingSubscriptionResource = isExistingSubscriptionResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\subscriptionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\subscriptionResource.ts"); } } })();

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\serverConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\serverConfigurationResource.ts"); } } })();

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\serverConfigurationSettingsSetResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\serverConfigurationSettingsSetResource.ts"); } } })();

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\serverStatusResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\serverStatusResource.ts"); } } })();

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\serverTimezoneResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\serverTimezoneResource.ts"); } } })();

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\smtpConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\smtpConfigurationResource.ts"); } } })();

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var SystemInfoResource = (function (_super) {
    __extends(SystemInfoResource, _super);
    function SystemInfoResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SystemInfoResource;
}(resource_1.default));
exports.SystemInfoResource = SystemInfoResource;
exports.default = SystemInfoResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\systemInfoResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\systemInfoResource.ts"); } } })();

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\tagResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\tagResource.ts"); } } })();

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\tagSetResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\tagSetResource.ts"); } } })();

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\teamResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\teamResource.ts"); } } })();

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\tenantResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\tenantResource.ts"); } } })();

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\tenantMissingVariablesResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\tenantMissingVariablesResource.ts"); } } })();

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\tenantVariableResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\tenantVariableResource.ts"); } } })();

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var TimeSpanString = (function (_super) {
    __extends(TimeSpanString, _super);
    function TimeSpanString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeSpanString.Zero = "00:00:00";
    TimeSpanString.OneHour = "0.01:00:00";
    TimeSpanString.TenSeconds = "00:00:10";
    return TimeSpanString;
}(String));
exports.TimeSpanString = TimeSpanString;
exports.default = TimeSpanString;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\timeSpan.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\timeSpan.ts"); } } })();

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserPermissionRestriction = (function () {
    function UserPermissionRestriction() {
    }
    return UserPermissionRestriction;
}());
exports.UserPermissionRestriction = UserPermissionRestriction;
exports.default = UserPermissionRestriction;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\userPermissionRestriction.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\userPermissionRestriction.ts"); } } })();

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(53);
var UserPermissionSetResource = (function (_super) {
    __extends(UserPermissionSetResource, _super);
    function UserPermissionSetResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UserPermissionSetResource;
}(resource_1.default));
exports.UserPermissionSetResource = UserPermissionSetResource;
exports.default = UserPermissionSetResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\userPermissionSetResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\userPermissionSetResource.ts"); } } })();

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var namedResource_1 = __webpack_require__(187);
var UserResource = (function (_super) {
    __extends(UserResource, _super);
    function UserResource() {
        var _this = _super.call(this) || this;
        _this.Name = _this.DisplayName;
        return _this;
    }
    return UserResource;
}(namedResource_1.default));
exports.UserResource = UserResource;
exports.default = UserResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\userResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\userResource.ts"); } } })();

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var namedResource_1 = __webpack_require__(187);
var UserRoleResource = (function (_super) {
    __extends(UserRoleResource, _super);
    function UserRoleResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UserRoleResource;
}(namedResource_1.default));
exports.UserRoleResource = UserRoleResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\userRoleResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\userRoleResource.ts"); } } })();

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\variablesScopedToEnvironmentResponse.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\variablesScopedToEnvironmentResponse.ts"); } } })();

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var referenceDataItem_1 = __webpack_require__(499);
var ProjectedTeamReferenceDataItem = (function (_super) {
    __extends(ProjectedTeamReferenceDataItem, _super);
    function ProjectedTeamReferenceDataItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProjectedTeamReferenceDataItem;
}(referenceDataItem_1.default));
exports.ProjectedTeamReferenceDataItem = ProjectedTeamReferenceDataItem;
exports.default = ProjectedTeamReferenceDataItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\projectedTeamReferenceDataItem.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\projectedTeamReferenceDataItem.ts"); } } })();

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var triggerResource_1 = __webpack_require__(322);
var TriggerScheduleResource = (function (_super) {
    __extends(TriggerScheduleResource, _super);
    function TriggerScheduleResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TriggerScheduleResource;
}(triggerResource_1.TriggerFilterResource));
exports.TriggerScheduleResource = TriggerScheduleResource;
var TriggerScheduleIntervalType;
(function (TriggerScheduleIntervalType) {
    TriggerScheduleIntervalType["OnceDaily"] = "OnceDaily";
    TriggerScheduleIntervalType["OnceHourly"] = "OnceHourly";
    TriggerScheduleIntervalType["OnceEveryMinute"] = "OnceEveryMinute";
})(TriggerScheduleIntervalType = exports.TriggerScheduleIntervalType || (exports.TriggerScheduleIntervalType = {}));
var TriggerScheduleRunType;
(function (TriggerScheduleRunType) {
    TriggerScheduleRunType["ScheduledTime"] = "ScheduledTime";
    TriggerScheduleRunType["Continuously"] = "Continuously";
})(TriggerScheduleRunType = exports.TriggerScheduleRunType || (exports.TriggerScheduleRunType = {}));
var DailyTriggerScheduleResource = (function (_super) {
    __extends(DailyTriggerScheduleResource, _super);
    function DailyTriggerScheduleResource() {
        var _this = _super.call(this) || this;
        _this.Interval = TriggerScheduleIntervalType.OnceDaily;
        _this.FilterType = triggerResource_1.TriggerFilterType.DailySchedule;
        return _this;
    }
    return DailyTriggerScheduleResource;
}(TriggerScheduleResource));
exports.DailyTriggerScheduleResource = DailyTriggerScheduleResource;
var TriggerScheduleIntervalResource = (function () {
    function TriggerScheduleIntervalResource() {
        this.Interval = TriggerScheduleIntervalType.OnceDaily;
    }
    return TriggerScheduleIntervalResource;
}());
exports.TriggerScheduleIntervalResource = TriggerScheduleIntervalResource;
var MonthlyScheduleType;
(function (MonthlyScheduleType) {
    MonthlyScheduleType["DateOfMonth"] = "DateOfMonth";
    MonthlyScheduleType["DayOfMonth"] = "DayOfMonth";
})(MonthlyScheduleType = exports.MonthlyScheduleType || (exports.MonthlyScheduleType = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Monday"] = "1";
    DayOfWeek["Tuesday"] = "2";
    DayOfWeek["Wednesday"] = "3";
    DayOfWeek["Thursday"] = "4";
    DayOfWeek["Friday"] = "5";
    DayOfWeek["Saturday"] = "6";
    DayOfWeek["Sunday"] = "0";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var DaysPerMonthTriggerScheduleResource = (function (_super) {
    __extends(DaysPerMonthTriggerScheduleResource, _super);
    function DaysPerMonthTriggerScheduleResource() {
        var _this = _super.call(this) || this;
        _this.FilterType = triggerResource_1.TriggerFilterType.DaysPerMonthSchedule;
        return _this;
    }
    return DaysPerMonthTriggerScheduleResource;
}(TriggerScheduleResource));
exports.DaysPerMonthTriggerScheduleResource = DaysPerMonthTriggerScheduleResource;
var DaysPerWeekTriggerScheduleResource = (function (_super) {
    __extends(DaysPerWeekTriggerScheduleResource, _super);
    function DaysPerWeekTriggerScheduleResource() {
        var _this = _super.call(this) || this;
        _this.FilterType = triggerResource_1.TriggerFilterType.DaysPerWeekSchedule;
        return _this;
    }
    return DaysPerWeekTriggerScheduleResource;
}(DailyTriggerScheduleResource));
exports.DaysPerWeekTriggerScheduleResource = DaysPerWeekTriggerScheduleResource;
var CronTriggerScheduleResource = (function (_super) {
    __extends(CronTriggerScheduleResource, _super);
    function CronTriggerScheduleResource() {
        var _this = _super.call(this) || this;
        _this.FilterType = triggerResource_1.TriggerFilterType.CronExpressionSchedule;
        return _this;
    }
    return CronTriggerScheduleResource;
}(TriggerScheduleResource));
exports.CronTriggerScheduleResource = CronTriggerScheduleResource;
var ScopedDeploymentActionResource = (function (_super) {
    __extends(ScopedDeploymentActionResource, _super);
    function ScopedDeploymentActionResource() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.TenantIds = [];
        _this.TenantTags = [];
        return _this;
    }
    return ScopedDeploymentActionResource;
}(triggerResource_1.TriggerActionResource));
exports.ScopedDeploymentActionResource = ScopedDeploymentActionResource;
var DeployLatestReleaseActionResource = (function (_super) {
    __extends(DeployLatestReleaseActionResource, _super);
    function DeployLatestReleaseActionResource() {
        var _this = _super.call(this) || this;
        _this.ActionType = triggerResource_1.TriggerActionType.DeployLatestRelease;
        return _this;
    }
    return DeployLatestReleaseActionResource;
}(ScopedDeploymentActionResource));
exports.DeployLatestReleaseActionResource = DeployLatestReleaseActionResource;
var DeployNewReleaseActionResource = (function (_super) {
    __extends(DeployNewReleaseActionResource, _super);
    function DeployNewReleaseActionResource() {
        var _this = _super.call(this) || this;
        _this.ActionType = triggerResource_1.TriggerActionType.DeployNewRelease;
        return _this;
    }
    return DeployNewReleaseActionResource;
}(ScopedDeploymentActionResource));
exports.DeployNewReleaseActionResource = DeployNewReleaseActionResource;
var ScheduleIntervalResource = (function () {
    function ScheduleIntervalResource() {
    }
    return ScheduleIntervalResource;
}());
exports.ScheduleIntervalResource = ScheduleIntervalResource;
var ScheduleIntervalType;
(function (ScheduleIntervalType) {
    ScheduleIntervalType["Once"] = "Once";
    ScheduleIntervalType["Hour"] = "Hour";
    ScheduleIntervalType["Minute"] = "Minute";
})(ScheduleIntervalType = exports.ScheduleIntervalType || (exports.ScheduleIntervalType = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\scheduledProjectTriggerResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\scheduledProjectTriggerResource.ts"); } } })();

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(147);
var notifications_redux_1 = __webpack_require__(153);
var clientInstance_1 = __webpack_require__(10);
var notificationLocalState = __webpack_require__(237);
var notificationId = "Notification/ClientVersionOutdated";
var HTTPHeader = "Octopus-Node";
exports.serverVersionNotificationCheck = function (request) {
    var clientVersion = clientInstance_1.client.version;
    var apiVersion = getApiVersion(request);
    if (!apiVersion) {
        return;
    }
    if (apiVersion === clientVersion) {
        notificationLocalState.clearValue(notificationId);
        notifications_redux_1.dismissNotification(store_1.default.dispatch)(notificationId);
        return;
    }
    var description = "The current web portal is running as version " + clientVersion + " however Octopus Server is\n    running " + apiVersion + ". Refresh this page to ensure you have the latest portal version.";
    notifications_redux_1.raiseNotification(store_1.default.dispatch)({
        id: notificationId,
        value: apiVersion,
        type: notifications_redux_1.NotificationType.info,
        description: description,
        text: "Server version updated",
        links: [{ type: "Refresh", label: "Reload Site" }]
    });
};
function getApiVersion(request) {
    var nodeVersion = request.getResponseHeader(HTTPHeader);
    if (!nodeVersion) {
        return;
    }
    nodeVersion = nodeVersion.split("; ").find(function (v) { return v.startsWith("version="); });
    if (!nodeVersion) {
        return;
    }
    return nodeVersion.substr(8);
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\http\\serverVersionNotificationCheck.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\http\\serverVersionNotificationCheck.tsx"); } } })();

/***/ }),
/* 1002 */,
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(96);
var redux_composers_1 = __webpack_require__(1004);
var infrastructureArea_1 = __webpack_require__(1009);
var libraryArea_1 = __webpack_require__(750);
var projectsArea_1 = __webpack_require__(219);
var reducers_1 = __webpack_require__(501);
var reducers_2 = __webpack_require__(327);
var tenantsArea_1 = __webpack_require__(742);
var expanders_1 = __webpack_require__(286);
var dialog_1 = __webpack_require__(288);
var notifications_redux_1 = __webpack_require__(153);
var configurationArea_1 = __webpack_require__(433);
var reducers = redux_1.combineReducers({
    libraryArea: libraryArea_1.default,
    infrastructureArea: infrastructureArea_1.default,
    projectsArea: projectsArea_1.default,
    tenantsArea: tenantsArea_1.tenantsArea,
    configurationArea: configurationArea_1.configurationArea,
    expanders: expanders_1.default,
    dialogs: dialog_1.default,
    notifications: notifications_redux_1.notificationReducer,
    unhandledError: redux_composers_1.chainReducers([reducers_1.default, reducers_2.default]),
});
exports.reducers = reducers;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\reducers\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\reducers\\index.ts"); } } })();

/***/ }),
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var machines_1 = __webpack_require__(741);
var accounts_1 = __webpack_require__(748);
var redux_1 = __webpack_require__(96);
__export(__webpack_require__(749));
exports.default = redux_1.combineReducers({
    machines: machines_1.default,
    accounts: accounts_1.default
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\reducers\\infrastructureArea.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\reducers\\infrastructureArea.ts"); } } })();

/***/ }),
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var accountRepository_1 = __webpack_require__(1071);
var actionTemplateRepository_1 = __webpack_require__(1072);
var alertRepository_1 = __webpack_require__(1073);
var artifactRepository_1 = __webpack_require__(1074);
var authenticationRepository_1 = __webpack_require__(1075);
var backupRepository_1 = __webpack_require__(1076);
var builtInRepositoryConfigurationRepository_1 = __webpack_require__(1077);
var certificateConfigurationRepository_1 = __webpack_require__(1078);
var certificateRepository_1 = __webpack_require__(1079);
var channelRepository_1 = __webpack_require__(1080);
var communityActionTemplateRepository_1 = __webpack_require__(1081);
var dashoboardConfigurationRepository_1 = __webpack_require__(1082);
var dashboardRepository_1 = __webpack_require__(1083);
var defectRepository_1 = __webpack_require__(1084);
var deploymentProcessRepository_1 = __webpack_require__(1085);
var environmentRepository_1 = __webpack_require__(1086);
var eventRepository_1 = __webpack_require__(1087);
var externalSecurityGroupProviderRepository_1 = __webpack_require__(1088);
var externalSecurityGroupRepository_1 = __webpack_require__(1089);
var externalUsersRepository_1 = __webpack_require__(1090);
var featuresConfigurationRepository_1 = __webpack_require__(1091);
var feedRepository_1 = __webpack_require__(1092);
var interruptionRepository_1 = __webpack_require__(1093);
var libraryVariableRepository_1 = __webpack_require__(1094);
var licenseRepository_1 = __webpack_require__(1095);
var lifecycleRepository_1 = __webpack_require__(1096);
var machinePolicyRepository_1 = __webpack_require__(1097);
var machineRepository_1 = __webpack_require__(1098);
var machineRoleRepository_1 = __webpack_require__(1099);
var maintenanceConfigurationRepository_1 = __webpack_require__(1100);
var octopusServerNodeRepository_1 = __webpack_require__(1101);
var packageRepository_1 = __webpack_require__(1102);
var permissionDescriptionRepository_1 = __webpack_require__(1103);
var progressionRepository_1 = __webpack_require__(1104);
var projectGroupRepository_1 = __webpack_require__(1105);
var projectRepository_1 = __webpack_require__(1106);
var projectTriggerRepository_1 = __webpack_require__(1107);
var proxyRepository_1 = __webpack_require__(1108);
var releasesRepository_1 = __webpack_require__(1109);
var retentionPolicyRepository_1 = __webpack_require__(1110);
var schedulerRepository_1 = __webpack_require__(1111);
var serverStatusRepository_1 = __webpack_require__(1112);
var serverConfigurationRepository_1 = __webpack_require__(1113);
var smtpConfigurationRepository_1 = __webpack_require__(1114);
var subscriptionRepository_1 = __webpack_require__(1115);
var tagSetRepository_1 = __webpack_require__(1116);
var taskRepository_1 = __webpack_require__(1117);
var teamRepository_1 = __webpack_require__(1118);
var tenantRepository_1 = __webpack_require__(1119);
var tenantVariableRepository_1 = __webpack_require__(1120);
var upgradeConfigurationRepository_1 = __webpack_require__(1121);
var userIdentityMetadataRepository_1 = __webpack_require__(1122);
var userOnBoardingRepository_1 = __webpack_require__(1123);
var userRepository_1 = __webpack_require__(1124);
var userRoleRepository_1 = __webpack_require__(1125);
var variableRepository_1 = __webpack_require__(1126);
var letsEncryptConfigurationRepository_1 = __webpack_require__(1127);
var deploymentRepository_1 = __webpack_require__(1128);
var settingsRepository_1 = __webpack_require__(1129);
var cloudTemplateRepository_1 = __webpack_require__(1130);
// Repositories provide a helpful abstraction around the Octopus Deploy API
var Repository = (function () {
    function Repository(client) {
        this.takeAll = 2147483647;
        this.resolve = client.resolve;
        this.resolveLinkTemplate = client.resolveLinkTemplate;
        this.Accounts = new accountRepository_1.default(client);
        this.ActionTemplates = new actionTemplateRepository_1.default(client);
        this.Alerts = new alertRepository_1.default(client);
        this.Artifacts = new artifactRepository_1.default(client);
        this.Authentication = new authenticationRepository_1.default(client);
        this.Backups = new backupRepository_1.default(client);
        this.BuiltInRepositoryConfiguration = new builtInRepositoryConfigurationRepository_1.default(client);
        this.CertificateConfiguration = new certificateConfigurationRepository_1.default(client);
        this.Certificates = new certificateRepository_1.default(client);
        this.Channels = new channelRepository_1.default(client);
        this.CloudTemplates = new cloudTemplateRepository_1.default(client);
        this.CommunityActionTemplates = new communityActionTemplateRepository_1.default(client);
        this.DashboardConfiguration = new dashoboardConfigurationRepository_1.default(client);
        this.Dashboards = new dashboardRepository_1.default(client);
        this.Defects = new defectRepository_1.default(client);
        this.Deployments = new deploymentRepository_1.default(client);
        this.DeploymentProcesses = new deploymentProcessRepository_1.default(client);
        this.Environments = new environmentRepository_1.default(client);
        this.Events = new eventRepository_1.default(client);
        this.ExternalSecurityGroupProviders = new externalSecurityGroupProviderRepository_1.default(client);
        this.ExternalSecurityGroups = new externalSecurityGroupRepository_1.default(client);
        this.ExternalUsers = new externalUsersRepository_1.default(client);
        this.FeaturesConfiguration = new featuresConfigurationRepository_1.default(client);
        this.Feeds = new feedRepository_1.default(client);
        this.Interruptions = new interruptionRepository_1.default(client);
        this.LetsEncryptConfiguration = new letsEncryptConfigurationRepository_1.default(client);
        this.LibraryVariableSets = new libraryVariableRepository_1.default(client);
        this.Licenses = new licenseRepository_1.default(client);
        this.Lifecycles = new lifecycleRepository_1.default(client);
        this.MachinePolicies = new machinePolicyRepository_1.default(client);
        this.MachineRoles = new machineRoleRepository_1.default(client);
        this.Machines = new machineRepository_1.default(client);
        this.MaintenanceConfiguration = new maintenanceConfigurationRepository_1.default(client);
        this.OctopusServerNodes = new octopusServerNodeRepository_1.default(client);
        this.Packages = new packageRepository_1.default(client);
        this.PermissionDescriptions = new permissionDescriptionRepository_1.default(client);
        this.Progression = new progressionRepository_1.default(client);
        this.ProjectGroups = new projectGroupRepository_1.default(client);
        this.Projects = new projectRepository_1.default(client);
        this.ProjectTriggers = new projectTriggerRepository_1.default(client);
        this.Proxies = new proxyRepository_1.default(client);
        this.Releases = new releasesRepository_1.default(client);
        this.RetentionPolicies = new retentionPolicyRepository_1.default(client);
        this.Scheduler = new schedulerRepository_1.default(client);
        this.ServerStatus = new serverStatusRepository_1.default(client);
        this.ServerConfiguration = new serverConfigurationRepository_1.default(client);
        this.Settings = new settingsRepository_1.default(client);
        this.SmtpConfiguration = new smtpConfigurationRepository_1.default(client);
        this.Subscriptions = new subscriptionRepository_1.default(client);
        this.TagSets = new tagSetRepository_1.default(client);
        this.Tasks = new taskRepository_1.default(client);
        this.Teams = new teamRepository_1.default(client);
        this.Tenants = new tenantRepository_1.default(client);
        this.TenantVariables = new tenantVariableRepository_1.default(client);
        this.UpgradeConfiguration = new upgradeConfigurationRepository_1.default(client);
        this.UserIdentityMetadata = new userIdentityMetadataRepository_1.default(client);
        this.UserOnboarding = new userOnBoardingRepository_1.default(client);
        this.UserRoles = new userRoleRepository_1.default(client);
        this.Users = new userRepository_1.default(client);
        this.Variables = new variableRepository_1.default(client);
        this.getRootDocument = client.getRootDocument.bind(client);
    }
    return Repository;
}());
exports.default = Repository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repository.ts"); } } })();

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var AccountRepository = (function (_super) {
    __extends(AccountRepository, _super);
    function AccountRepository(client) {
        return _super.call(this, "Accounts", client) || this;
    }
    AccountRepository.prototype.getWebSites = function (account) {
        return this.client.get(account.Links["WebSites"]);
    };
    AccountRepository.prototype.getCloudServices = function (account) {
        return this.client.get(account.Links["CloudServices"]);
    };
    AccountRepository.prototype.getStorageAccounts = function (account) {
        return this.client.get(account.Links["StorageAccounts"]);
    };
    AccountRepository.prototype.getResourceGroups = function (account) {
        return this.client.get(account.Links["ResourceGroups"]);
    };
    AccountRepository.prototype.getFabricApplications = function (account) {
        return this.client.get(account.Links["FabricApplications"]);
    };
    AccountRepository.prototype.getAccountUsages = function (account) {
        return this.client.get(account.Links["Usages"]);
    };
    return AccountRepository;
}(basicRepository_1.default));
exports.default = AccountRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\accountRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\accountRepository.ts"); } } })();

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var logoUpload_1 = __webpack_require__(328);
var ActionTemplateRepository = (function (_super) {
    __extends(ActionTemplateRepository, _super);
    function ActionTemplateRepository(client) {
        return _super.call(this, "ActionTemplates", client) || this;
    }
    ActionTemplateRepository.prototype.getUsage = function (template) {
        return this.client.get(template.Links["Usage"]);
    };
    ActionTemplateRepository.prototype.getByCommunityTemplate = function (communityTemplate) {
        var allArgs = __assign({}, { id: communityTemplate.Id });
        return this.client.get(communityTemplate.Links["InstalledTemplate"], allArgs);
    };
    ActionTemplateRepository.prototype.search = function () {
        return this.client.get(this.client.getRootDocument().Links["ActionTemplatesSearch"]);
    };
    ActionTemplateRepository.prototype.updateActions = function (actionTemplate, actionIdsByProcessId, defaults, overrides) {
        if (defaults === void 0) { defaults = {}; }
        if (overrides === void 0) { overrides = {}; }
        defaults = defaults || {};
        overrides = overrides || {};
        return this.client.post(actionTemplate.Links["ActionsUpdate"], {
            actionIdsByProcessId: actionIdsByProcessId,
            defaultPropertyValues: defaults,
            overrides: overrides,
            version: actionTemplate.Version
        });
    };
    ActionTemplateRepository.prototype.getVersion = function (actionTemplate, version) {
        return this.client.get(actionTemplate.Links["Versions"], { version: version });
    };
    ActionTemplateRepository.prototype.uploadLogo = function (actionTemplate, logo) {
        return logoUpload_1.uploadLogo(actionTemplate, logo);
    };
    return ActionTemplateRepository;
}(basicRepository_1.default));
exports.default = ActionTemplateRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\actionTemplateRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\actionTemplateRepository.ts"); } } })();

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var AlertRepository = (function (_super) {
    __extends(AlertRepository, _super);
    function AlertRepository(client) {
        return _super.call(this, "Alerts", client) || this;
    }
    AlertRepository.prototype.getDetails = function (task, options) {
        return this.client.get(task.Links["Details"], options);
    };
    AlertRepository.prototype.getQueuedBehind = function (task, options) {
        return this.client.get(task.Links["QueuedBehind"], options);
    };
    AlertRepository.prototype.getRaw = function (task) {
        return this.client.getRaw(task.Links["Raw"]);
    };
    AlertRepository.prototype.filter = function (options) {
        return this.client.get(this.client.getRootDocument().Links["Tasks"], options);
    };
    AlertRepository.prototype.rerun = function (task) {
        return this.client.post(task.Links["Rerun"]);
    };
    AlertRepository.prototype.cancel = function (task) {
        return this.client.post(task.Links["Cancel"]);
    };
    AlertRepository.prototype.changeState = function (task, state, reason) {
        return this.client.post(task.Links["State"], { state: state, reason: reason });
    };
    return AlertRepository;
}(basicRepository_1.default));
exports.default = AlertRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\alertRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\alertRepository.ts"); } } })();

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var ArtifactRepository = (function (_super) {
    __extends(ArtifactRepository, _super);
    function ArtifactRepository(client) {
        return _super.call(this, "Artifacts", client) || this;
    }
    return ArtifactRepository;
}(basicRepository_1.default));
exports.default = ArtifactRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\artifactRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\artifactRepository.ts"); } } })();

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var AuthenticationRepository = (function (_super) {
    __extends(AuthenticationRepository, _super);
    function AuthenticationRepository(client) {
        return _super.call(this, "Authentication", client) || this;
    }
    AuthenticationRepository.prototype.get = function () {
        return this.client.get(this.client.getRootDocument().Links["Authentication"]);
    };
    return AuthenticationRepository;
}(basicRepository_1.default));
exports.default = AuthenticationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\authentication\\authenticationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\authentication\\authenticationRepository.ts"); } } })();

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BackupRepository = (function () {
    function BackupRepository(client) {
        this.client = client;
    }
    BackupRepository.prototype.getConfiguration = function () {
        return this.client.get(this.client.getRootDocument().Links["BackupConfiguration"]);
    };
    BackupRepository.prototype.updateConfiguration = function (configuration) {
        return this.client.update(configuration.Links["Self"], configuration);
    };
    return BackupRepository;
}());
exports.default = BackupRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\backupRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\backupRepository.ts"); } } })();

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(111);
var BuiltInRepositoryConfigurationRepository = (function (_super) {
    __extends(BuiltInRepositoryConfigurationRepository, _super);
    function BuiltInRepositoryConfigurationRepository(client) {
        return _super.call(this, "RepositoryConfiguration", client) || this;
    }
    return BuiltInRepositoryConfigurationRepository;
}(configurationRepository_1.default));
exports.default = BuiltInRepositoryConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\builtInRepositoryConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\builtInRepositoryConfigurationRepository.ts"); } } })();

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var CertificateConfigurationRepository = (function (_super) {
    __extends(CertificateConfigurationRepository, _super);
    function CertificateConfigurationRepository(client) {
        return _super.call(this, "CertificateConfiguration", client) || this;
    }
    CertificateConfigurationRepository.prototype.global = function () {
        return this.get("certificate-global");
    };
    CertificateConfigurationRepository.prototype.azure = function () {
        return this.get("certificate-azure");
    };
    CertificateConfigurationRepository.prototype.export = function (certificate, exportOptions) {
        return this.client.get(certificate.Links["Export"], exportOptions);
    };
    CertificateConfigurationRepository.prototype.archive = function (certificate) {
        return this.client.post(certificate.Links["Archive"]);
    };
    CertificateConfigurationRepository.prototype.unarchive = function (certificate) {
        return this.client.post(certificate.Links["Unarchive"]);
    };
    CertificateConfigurationRepository.prototype.usage = function (certificate) {
        return this.client.get(certificate.Links["Usage"]);
    };
    CertificateConfigurationRepository.prototype.replace = function (certificate, newCertificateData, newPassword) {
        return this.client.post(certificate.Links["Replace"], {
            certificateData: newCertificateData,
            password: newPassword
        });
    };
    return CertificateConfigurationRepository;
}(basicRepository_1.default));
exports.default = CertificateConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\certificateConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\certificateConfigurationRepository.ts"); } } })();

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var CertificateRepository = (function (_super) {
    __extends(CertificateRepository, _super);
    function CertificateRepository(client) {
        return _super.call(this, "Certificates", client) || this;
    }
    CertificateRepository.prototype.names = function (projectId, projectEnvironmentsFilter) {
        return this.client.get(this.client.getRootDocument().Links["VariableNames"], {
            project: projectId,
            projectEnvironmentsFilter: projectEnvironmentsFilter ?
                projectEnvironmentsFilter.join(",") : projectEnvironmentsFilter
        });
    };
    CertificateRepository.prototype.nonPrintableChars = function (variableSet) {
        return this.client.post(this.client.getRootDocument().Links["VariablesNonPrintableChars"], variableSet);
    };
    return CertificateRepository;
}(basicRepository_1.default));
exports.default = CertificateRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\certificateRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\certificateRepository.ts"); } } })();

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var ChannelRepository = (function (_super) {
    __extends(ChannelRepository, _super);
    function ChannelRepository(client) {
        return _super.call(this, "Channels", client) || this;
    }
    ChannelRepository.prototype.ruleTest = function (version, searchOptions) {
        return this.client.post(this.client.getRootDocument().Links["VersionRuleTest"], {
            preReleaseTag: searchOptions.preReleaseTag,
            version: version,
            versionRange: searchOptions.versionRange,
            feedType: searchOptions.feedType
        });
    };
    ChannelRepository.prototype.getReleases = function (channel, options) {
        return this.client.get(channel.Links["Releases"], options);
    };
    return ChannelRepository;
}(basicRepository_1.default));
exports.default = ChannelRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\channelRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\channelRepository.ts"); } } })();

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var CommunityActionTemplateRepository = (function () {
    function CommunityActionTemplateRepository(client) {
        this.client = client;
    }
    CommunityActionTemplateRepository.prototype.get = function (id) {
        var allArgs = __assign({}, { id: id });
        return this.client.get(this.client.getRootDocument().Links["CommunityActionTemplates"], allArgs);
    };
    CommunityActionTemplateRepository.prototype.install = function (communityActionTemplate) {
        return this.client.post(communityActionTemplate.Links["Installation"]);
    };
    CommunityActionTemplateRepository.prototype.updateInstallation = function (communityActionTemplate) {
        return this.client.put(communityActionTemplate.Links["Installation"]);
    };
    return CommunityActionTemplateRepository;
}());
exports.default = CommunityActionTemplateRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\communityActionTemplateRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\communityActionTemplateRepository.ts"); } } })();

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(111);
var DashboardConfigurationRepository = (function (_super) {
    __extends(DashboardConfigurationRepository, _super);
    function DashboardConfigurationRepository(client) {
        return _super.call(this, "DashboardConfiguration", client) || this;
    }
    return DashboardConfigurationRepository;
}(configurationRepository_1.default));
exports.default = DashboardConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\dashoboardConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\dashoboardConfigurationRepository.ts"); } } })();

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardRepository = (function () {
    function DashboardRepository(client) {
        this.client = client;
    }
    DashboardRepository.prototype.getDeploymentsCountedByWeek = function (projectIds) {
        return this.client.get(this.client.getRootDocument().Links["Reporting/DeploymentsCountedByWeek"], { projectIds: projectIds.join(",") });
    };
    DashboardRepository.prototype.getDashboard = function (dashboardFilter) {
        return this.client.get(this.client.getRootDocument().Links["Dashboard"], dashboardFilter);
    };
    return DashboardRepository;
}());
exports.default = DashboardRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\dashboardRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\dashboardRepository.ts"); } } })();

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DefectRepository = (function () {
    function DefectRepository(client) {
        this.client = client;
    }
    DefectRepository.prototype.all = function (release) {
        return this.client.get(release.Links["Defects"]);
    };
    DefectRepository.prototype.report = function (release, description) {
        return this.client.post(release.Links["ReportDefect"], { Description: description });
    };
    DefectRepository.prototype.resolve = function (release) {
        return this.client.post(release.Links["ResolveDefect"]);
    };
    return DefectRepository;
}());
exports.default = DefectRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\defectRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\defectRepository.ts"); } } })();

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var DeploymentProcessRepository = (function (_super) {
    __extends(DeploymentProcessRepository, _super);
    function DeploymentProcessRepository(client) {
        return _super.call(this, "DeploymentProcesses", client) || this;
    }
    DeploymentProcessRepository.prototype.getTemplate = function (deploymentProcess, channelId, releaseId) {
        return this.client.get(deploymentProcess.Links["Template"], { channel: channelId, releaseId: releaseId });
    };
    return DeploymentProcessRepository;
}(basicRepository_1.default));
exports.default = DeploymentProcessRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\deploymentProcessRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\deploymentProcessRepository.ts"); } } })();

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var EnvironmentRepository = (function (_super) {
    __extends(EnvironmentRepository, _super);
    function EnvironmentRepository(client) {
        return _super.call(this, "Environments", client) || this;
    }
    EnvironmentRepository.prototype.sort = function (order) {
        return this.client.put(this.client.getRootDocument().Links["EnvironmentSortOrder"], order);
    };
    EnvironmentRepository.prototype.variablesScopedOnlyToThisEnvironment = function (environment) {
        return this.client.get(environment.Links["SinglyScopedVariableDetails"]);
    };
    EnvironmentRepository.prototype.machines = function (args) {
        return this.client.get(args.environment.Links["Machines"], args);
    };
    EnvironmentRepository.prototype.summary = function (args) {
        return this.client.get(this.client.getRootDocument().Links["EnvironmentsSummary"], args);
    };
    return EnvironmentRepository;
}(basicRepository_1.default));
exports.default = EnvironmentRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\environmentRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\environmentRepository.ts"); } } })();

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var EventRepository = (function (_super) {
    __extends(EventRepository, _super);
    function EventRepository(client) {
        return _super.call(this, "Events", client) || this;
    }
    EventRepository.prototype.categories = function (options) {
        return this.client.get(this.client.getRootDocument().Links["EventCategories"], options);
    };
    EventRepository.prototype.groups = function (options) {
        return this.client.get(this.client.getRootDocument().Links["EventGroups"], options);
    };
    EventRepository.prototype.documentTypes = function (options) {
        return this.client.get(this.client.getRootDocument().Links["EventDocumentTypes"], options);
    };
    return EventRepository;
}(basicRepository_1.default));
exports.default = EventRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\eventRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\eventRepository.ts"); } } })();

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExternalSecurityGroupProviderRepository = (function () {
    function ExternalSecurityGroupProviderRepository(client) {
        this.client = client;
    }
    ExternalSecurityGroupProviderRepository.prototype.all = function () {
        return this.client.get(this.client.getRootDocument().Links["ExternalSecurityGroupProviders"]);
    };
    return ExternalSecurityGroupProviderRepository;
}());
exports.default = ExternalSecurityGroupProviderRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\externalSecurityGroupProviderRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\externalSecurityGroupProviderRepository.ts"); } } })();

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExternalSecurityGroupRepository = (function () {
    function ExternalSecurityGroupRepository(client) {
        this.client = client;
    }
    ExternalSecurityGroupRepository.prototype.search = function (url, partialName) {
        return this.client.get(url, { partialName: partialName });
    };
    return ExternalSecurityGroupRepository;
}());
exports.default = ExternalSecurityGroupRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\externalSecurityGroupRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\externalSecurityGroupRepository.ts"); } } })();

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExternalUsersRepository = (function () {
    function ExternalUsersRepository(client) {
        this.client = client;
    }
    ExternalUsersRepository.prototype.search = function (partialName) {
        return this.client.get(this.client.getRootDocument().Links["ExternalUserSearch"], { partialName: partialName });
    };
    ExternalUsersRepository.prototype.searchProvider = function (providerUrl, partialName) {
        return this.client.get(providerUrl, { partialName: partialName });
    };
    return ExternalUsersRepository;
}());
exports.default = ExternalUsersRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\externalUsersRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\externalUsersRepository.ts"); } } })();

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(111);
var FeaturesConfigurationRepository = (function (_super) {
    __extends(FeaturesConfigurationRepository, _super);
    function FeaturesConfigurationRepository(client) {
        return _super.call(this, "FeaturesConfiguration", client) || this;
    }
    return FeaturesConfigurationRepository;
}(configurationRepository_1.default));
exports.default = FeaturesConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\featuresConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\featuresConfigurationRepository.ts"); } } })();

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var FeedRepository = (function (_super) {
    __extends(FeedRepository, _super);
    function FeedRepository(client) {
        return _super.call(this, "Feeds", client) || this;
    }
    FeedRepository.prototype.searchPackages = function (feed, searchOptions) {
        return this.client.get(feed.Links["SearchPackagesTemplate"], searchOptions);
    };
    FeedRepository.prototype.searchPackageVersions = function (feed, packageId, searchOptions) {
        return this.client.get(feed.Links["SearchPackageVersionsTemplate"], __assign({ packageId: packageId }, searchOptions));
    };
    FeedRepository.prototype.getNotes = function (feed, packageId, version) {
        return this.client.getRaw(feed.Links["NotesTemplate"], { packageId: packageId, version: version });
    };
    return FeedRepository;
}(basicRepository_1.default));
exports.default = FeedRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\feedRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\feedRepository.ts"); } } })();

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var InterruptionRepository = (function (_super) {
    __extends(InterruptionRepository, _super);
    function InterruptionRepository(client) {
        return _super.call(this, "Interruptions", client) || this;
    }
    InterruptionRepository.prototype.submit = function (interruption, result) {
        return this.client.post(interruption.Links["Submit"], result);
    };
    InterruptionRepository.prototype.takeResponsibility = function (interruption) {
        return this.client.put(interruption.Links["Responsible"]);
    };
    return InterruptionRepository;
}(basicRepository_1.default));
exports.default = InterruptionRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\interruptionRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\interruptionRepository.ts"); } } })();

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var LibraryVariableRepository = (function (_super) {
    __extends(LibraryVariableRepository, _super);
    function LibraryVariableRepository(client) {
        return _super.call(this, "LibraryVariables", client) || this;
    }
    return LibraryVariableRepository;
}(basicRepository_1.default));
exports.default = LibraryVariableRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\libraryVariableRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\libraryVariableRepository.ts"); } } })();

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var LicenseRepository = (function (_super) {
    __extends(LicenseRepository, _super);
    function LicenseRepository(client) {
        return _super.call(this, "Licenses", client) || this;
    }
    LicenseRepository.prototype.getCurrent = function () {
        return this.client.get(this.client.getRootDocument().Links["CurrentLicense"]);
    };
    LicenseRepository.prototype.getCurrentStatus = function () {
        return this.client.get(this.client.getRootDocument().Links["CurrentLicenseStatus"]);
    };
    return LicenseRepository;
}(basicRepository_1.default));
exports.default = LicenseRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\licenseRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\licenseRepository.ts"); } } })();

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var LifecycleRepository = (function (_super) {
    __extends(LifecycleRepository, _super);
    function LifecycleRepository(client) {
        return _super.call(this, "Lifecycles", client) || this;
    }
    LifecycleRepository.prototype.preview = function (lifecycle) {
        return this.client.get(lifecycle.Links["Preview"]);
    };
    LifecycleRepository.prototype.projects = function (lifecycle) {
        return this.client.get(lifecycle.Links["Projects"]);
    };
    return LifecycleRepository;
}(basicRepository_1.default));
exports.default = LifecycleRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\lifecycleRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\lifecycleRepository.ts"); } } })();

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var MachinePolicyRepository = (function (_super) {
    __extends(MachinePolicyRepository, _super);
    function MachinePolicyRepository(client) {
        return _super.call(this, "MachinePolicies", client) || this;
    }
    MachinePolicyRepository.prototype.getMachines = function (machinePolicy) {
        return this.client.get(machinePolicy.Links["Machines"]);
    };
    return MachinePolicyRepository;
}(basicRepository_1.default));
exports.default = MachinePolicyRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\machinePolicyRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\machinePolicyRepository.ts"); } } })();

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var MachineRepository = (function (_super) {
    __extends(MachineRepository, _super);
    function MachineRepository(client) {
        return _super.call(this, "Machines", client) || this;
    }
    MachineRepository.prototype.list = function (args) {
        return this.client.get(this.client.getRootDocument().Links["Machines"], args);
    };
    MachineRepository.prototype.listByEnvironment = function (environment) {
        return this.client.get(environment.Links["Machines"]);
    };
    MachineRepository.prototype.discover = function (host, port, type, proxyId) {
        return this.client.get(this.client.getRootDocument().Links["DiscoverMachine"], { host: host, port: port, type: type, proxyId: proxyId });
    };
    MachineRepository.prototype.getConnectionStatus = function (machine) {
        return this.client.get(machine.Links["Connection"]);
    };
    MachineRepository.prototype.getTasks = function (machine, options) {
        return this.client.get(machine.Links["TasksTemplate"], options);
    };
    MachineRepository.prototype.hosted = function () {
        var allArgs = { id: "hosted" };
        return this.client.get(this.client.getRootDocument().Links["Machines"], allArgs);
    };
    MachineRepository.prototype.listByDeployment = function (deployment) {
        return this.client.get(this.client.getRootDocument().Links["Machines"], { deploymentId: deployment.Id, id: "all" });
    };
    return MachineRepository;
}(basicRepository_1.default));
exports.default = MachineRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\machineRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\machineRepository.ts"); } } })();

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MachineRoleRepository = (function () {
    function MachineRoleRepository(client) {
        this.client = client;
    }
    MachineRoleRepository.prototype.all = function () {
        return this.client.get(this.client.getRootDocument().Links["MachineRoles"]);
    };
    return MachineRoleRepository;
}());
exports.default = MachineRoleRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\machineRoleRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\machineRoleRepository.ts"); } } })();

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(111);
var MaintenanceConfigurationRepository = (function (_super) {
    __extends(MaintenanceConfigurationRepository, _super);
    function MaintenanceConfigurationRepository(client) {
        return _super.call(this, "MaintenanceConfiguration", client) || this;
    }
    return MaintenanceConfigurationRepository;
}(configurationRepository_1.default));
exports.default = MaintenanceConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\maintenanceConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\maintenanceConfigurationRepository.ts"); } } })();

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var OctopusServerNodeRepository = (function (_super) {
    __extends(OctopusServerNodeRepository, _super);
    function OctopusServerNodeRepository(client) {
        return _super.call(this, "OctopusServerNodes", client) || this;
    }
    return OctopusServerNodeRepository;
}(basicRepository_1.default));
exports.default = OctopusServerNodeRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\octopusServerNodeRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\octopusServerNodeRepository.ts"); } } })();

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var PackageRepository = (function (_super) {
    __extends(PackageRepository, _super);
    function PackageRepository(client) {
        return _super.call(this, "Packages", client) || this;
    }
    PackageRepository.prototype.deleteMany = function (packageIds) {
        return this.client.del(this.client.getRootDocument().Links["PackagesBulk"], null, { ids: packageIds });
    };
    PackageRepository.prototype.upload = function (pkg, replace) {
        var fd = new FormData();
        fd.append("fileToUpload", pkg);
        return this.client.post(this.client.getRootDocument().Links["PackageUpload"], fd, { replace: replace });
    };
    PackageRepository.prototype.getNotes = function (packages) {
        var packageIds = packages.reduce(function (result, item) { return result +
            (result.length === 0 ? "" : ",") +
            encodeURIComponent(item.FeedId) + ":" +
            encodeURIComponent(item.PackageId) + ":" +
            encodeURIComponent(item.Version); }, "");
        return this.client.get(this.client.getRootDocument().Links["PackageNotesList"], { packageIds: packageIds });
    };
    return PackageRepository;
}(basicRepository_1.default));
exports.default = PackageRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\packageRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\packageRepository.ts"); } } })();

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PermissionDescriptionRepository = (function () {
    function PermissionDescriptionRepository(client) {
        this.client = client;
    }
    PermissionDescriptionRepository.prototype.all = function () {
        return this.client.get(this.client.getRootDocument().Links["PermissionDescriptions"], null);
    };
    return PermissionDescriptionRepository;
}());
exports.default = PermissionDescriptionRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\permissionDescriptionRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\permissionDescriptionRepository.ts"); } } })();

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProgressionRepository = (function () {
    function ProgressionRepository(client) {
        this.client = client;
    }
    ProgressionRepository.prototype.getProgression = function (project, options) {
        return this.client.get(project.Links["Progression"], options);
    };
    return ProgressionRepository;
}());
exports.default = ProgressionRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\progressionRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\progressionRepository.ts"); } } })();

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var ProjectGroupRepository = (function (_super) {
    __extends(ProjectGroupRepository, _super);
    function ProjectGroupRepository(client) {
        return _super.call(this, "ProjectGroups", client) || this;
    }
    return ProjectGroupRepository;
}(basicRepository_1.default));
exports.default = ProjectGroupRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\projectGroupRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\projectGroupRepository.ts"); } } })();

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var logoUpload_1 = __webpack_require__(328);
var clientInstance_1 = __webpack_require__(10);
var ProjectRepository = (function (_super) {
    __extends(ProjectRepository, _super);
    function ProjectRepository(client) {
        return _super.call(this, "Projects", client) || this;
    }
    ProjectRepository.prototype.getDeployments = function (project) {
        return this.client.get(this.client.getRootDocument().Links["Deployments"], { projects: project.Id });
    };
    ProjectRepository.prototype.getReleases = function (project, args) {
        return this.client.get(project.Links["Releases"], args);
    };
    ProjectRepository.prototype.getReleaseByVersion = function (project, version) {
        return this.client.get(project.Links["Releases"], { version: version });
    };
    ProjectRepository.prototype.listByGroup = function (projectGroup) {
        return this.client.get(projectGroup.Links["Projects"]);
    };
    ProjectRepository.prototype.getChannels = function (project, skip, take) {
        if (skip === void 0) { skip = 0; }
        if (take === void 0) { take = clientInstance_1.repository.takeAll; }
        return this.client.get(project.Links["Channels"], { skip: skip, take: take });
    };
    ProjectRepository.prototype.getTriggers = function (project, skip, take) {
        return this.client.get(project.Links["Triggers"], { skip: skip, take: take });
    };
    ProjectRepository.prototype.orderChannels = function (project, channelIds) {
        return this.client.post(project.Links["OrderChannels"], channelIds);
    };
    ProjectRepository.prototype.getPulse = function (projects) {
        var projectIds = projects.map(function (p) {
            return p.Id;
        }).join(",");
        return this.client.get(this.client.getRootDocument().Links["ProjectPulse"], { projectIds: projectIds });
    };
    ProjectRepository.prototype.uploadLogo = function (project, logo) {
        return logoUpload_1.uploadLogo(project, logo);
    };
    return ProjectRepository;
}(basicRepository_1.default));
exports.default = ProjectRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\projectRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\projectRepository.ts"); } } })();

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var ProjectTriggerRepository = (function (_super) {
    __extends(ProjectTriggerRepository, _super);
    function ProjectTriggerRepository(client) {
        return _super.call(this, "ProjectTriggers", client) || this;
    }
    return ProjectTriggerRepository;
}(basicRepository_1.default));
exports.default = ProjectTriggerRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\projectTriggerRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\projectTriggerRepository.ts"); } } })();

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var ProxyRepository = (function (_super) {
    __extends(ProxyRepository, _super);
    function ProxyRepository(client) {
        return _super.call(this, "Proxies", client) || this;
    }
    return ProxyRepository;
}(basicRepository_1.default));
exports.default = ProxyRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\proxyRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\proxyRepository.ts"); } } })();

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var ReleasesRepository = (function (_super) {
    __extends(ReleasesRepository, _super);
    function ReleasesRepository(client) {
        return _super.call(this, "Releases", client) || this;
    }
    ReleasesRepository.prototype.getDeployments = function (release, options) {
        return this.client.get(release.Links["Deployments"], options);
    };
    ReleasesRepository.prototype.getDeploymentTemplate = function (release) {
        return this.client.get(release.Links["DeploymentTemplate"]);
    };
    ReleasesRepository.prototype.getDeploymentPreview = function (promotionTarget) {
        return this.client.get(promotionTarget.Links["Preview"], { includeDisabledSteps: true });
    };
    ReleasesRepository.prototype.progression = function (release) {
        return this.client.get(release.Links["Progression"]);
    };
    ReleasesRepository.prototype.snapshotVariables = function (release) {
        return this.client.post(release.Links["SnapshotVariables"]);
    };
    return ReleasesRepository;
}(basicRepository_1.default));
exports.default = ReleasesRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\releasesRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\releasesRepository.ts"); } } })();

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var RetentionPolicyRepository = (function (_super) {
    __extends(RetentionPolicyRepository, _super);
    function RetentionPolicyRepository(client) {
        return _super.call(this, "RetentionPolicies", client) || this;
    }
    return RetentionPolicyRepository;
}(basicRepository_1.default));
exports.default = RetentionPolicyRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\retentionPolicyRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\retentionPolicyRepository.ts"); } } })();

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var SchedulerRepository = (function (_super) {
    __extends(SchedulerRepository, _super);
    function SchedulerRepository(client) {
        return _super.call(this, "Scheduler", client) || this;
    }
    SchedulerRepository.prototype.getDetails = function (name, options) {
        var args = __assign({}, options, { name: name });
        return this.client.get(this.client.getRootDocument().Links["Scheduler"], args);
    };
    return SchedulerRepository;
}(basicRepository_1.default));
exports.default = SchedulerRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\schedulerRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\schedulerRepository.ts"); } } })();

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServerStatusRepository = (function () {
    function ServerStatusRepository(client) {
        this.client = client;
    }
    ServerStatusRepository.prototype.getServerStatus = function () {
        return this.client.get(this.client.getRootDocument().Links["ServerStatus"]);
    };
    ServerStatusRepository.prototype.getLogs = function (status, args) {
        return this.client.get(status.Links["RecentLogs"], args);
    };
    ServerStatusRepository.prototype.getSystemInfo = function (status) {
        return this.client.get(status.Links["SystemInfo"]);
    };
    ServerStatusRepository.prototype.getBuiltInFeedStats = function (status) {
        return this.client.get(status.Links["BuiltInFeedStats"]);
    };
    ServerStatusRepository.prototype.gcCollect = function (status) {
        return this.client.post(status.Links["GCCollect"], status);
    };
    ServerStatusRepository.prototype.getExtensionStats = function () {
        return this.client.get(this.client.getRootDocument().Links["ExtensionStats"]);
    };
    ServerStatusRepository.prototype.getTimezones = function () {
        return this.client.get(this.client.getRootDocument().Links["Timezones"]);
    };
    return ServerStatusRepository;
}());
exports.default = ServerStatusRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\serverStatusRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\serverStatusRepository.ts"); } } })();

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(111);
var ServerConfigurationRepository = (function (_super) {
    __extends(ServerConfigurationRepository, _super);
    function ServerConfigurationRepository(client) {
        return _super.call(this, "ServerConfiguration", client) || this;
    }
    ServerConfigurationRepository.prototype.settings = function () {
        return this.client.get(this.client.getRootDocument().Links["ServerConfigurationSettings"]);
    };
    return ServerConfigurationRepository;
}(configurationRepository_1.default));
exports.default = ServerConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\serverConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\serverConfigurationRepository.ts"); } } })();

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(111);
var SmtpConfigurationRepository = (function (_super) {
    __extends(SmtpConfigurationRepository, _super);
    function SmtpConfigurationRepository(client) {
        return _super.call(this, "SmtpConfiguration", client) || this;
    }
    return SmtpConfigurationRepository;
}(configurationRepository_1.default));
exports.default = SmtpConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\smtpConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\smtpConfigurationRepository.ts"); } } })();

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var SubscriptionRepository = (function (_super) {
    __extends(SubscriptionRepository, _super);
    function SubscriptionRepository(client) {
        return _super.call(this, "Subscriptions", client) || this;
    }
    return SubscriptionRepository;
}(basicRepository_1.default));
exports.default = SubscriptionRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\subscriptionRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\subscriptionRepository.ts"); } } })();

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var TagSetRepository = (function (_super) {
    __extends(TagSetRepository, _super);
    function TagSetRepository(client) {
        return _super.call(this, "TagSets", client) || this;
    }
    TagSetRepository.prototype.sort = function (ids) {
        return this.client.put(this.client.getRootDocument().Links["TagSetSortOrder"], ids);
    };
    return TagSetRepository;
}(basicRepository_1.default));
exports.default = TagSetRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\tagSetRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\tagSetRepository.ts"); } } })();

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var TaskRepository = (function (_super) {
    __extends(TaskRepository, _super);
    function TaskRepository(client) {
        return _super.call(this, "Tasks", client) || this;
    }
    TaskRepository.prototype.details = function (task, args) {
        return this.client.get(task.Links["Details"], args);
    };
    TaskRepository.prototype.getQueuedBehind = function (task, args) {
        return this.client.get(task.Links["QueuedBehind"], args);
    };
    TaskRepository.prototype.getRaw = function (task) {
        return this.client.getRaw(task.Links["Raw"]);
    };
    TaskRepository.prototype.filter = function (args) {
        return this.client.get(this.client.getRootDocument().Links["Tasks"], args);
    };
    TaskRepository.prototype.rerun = function (task) {
        return this.client.post(task.Links["Rerun"]);
    };
    TaskRepository.prototype.cancel = function (task) {
        return this.client.post(task.Links["Cancel"]);
    };
    TaskRepository.prototype.changeState = function (task, state, reason) {
        return this.client.post(task.Links["State"], { state: state, reason: reason });
    };
    TaskRepository.prototype.list = function (args) {
        return _super.prototype.list.call(this, args);
    };
    return TaskRepository;
}(basicRepository_1.default));
exports.default = TaskRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\taskRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\taskRepository.ts"); } } })();

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var TeamRepository = (function (_super) {
    __extends(TeamRepository, _super);
    function TeamRepository(client) {
        return _super.call(this, "Teams", client) || this;
    }
    return TeamRepository;
}(basicRepository_1.default));
exports.default = TeamRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\teamRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\teamRepository.ts"); } } })();

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var logoUpload_1 = __webpack_require__(328);
var PermissionCheck_1 = __webpack_require__(45);
var permission_1 = __webpack_require__(49);
var TenantRepository = (function (_super) {
    __extends(TenantRepository, _super);
    function TenantRepository(client) {
        return _super.call(this, "Tenants", client) || this;
    }
    TenantRepository.prototype.tagTest = function (tenantIds, tags) {
        return this.client.get(this.client.getRootDocument().Links["TenantTagTest"], { tenantIds: tenantIds, tags: tags });
    };
    TenantRepository.prototype.getVariables = function (tenant) {
        return this.client.get(tenant.Links["Variables"]);
    };
    TenantRepository.prototype.setVariables = function (tenant, variables) {
        return this.client.put(tenant.Links["Variables"], variables);
    };
    TenantRepository.prototype.missingVariables = function (filterOptions, includeDetails) {
        if (filterOptions === void 0) { filterOptions = {}; }
        if (includeDetails === void 0) { includeDetails = false; }
        var payload = {
            environmentId: filterOptions.environmentId,
            includeDetails: !!includeDetails,
            projectId: filterOptions.projectId,
            tenantId: filterOptions.tenantId
        };
        return this.client.get(this.client.getRootDocument().Links["TenantsMissingVariables"], payload);
    };
    TenantRepository.prototype.uploadLogo = function (tenant, logo) {
        return logoUpload_1.uploadLogo(tenant, logo);
    };
    TenantRepository.prototype.all = function (args) {
        if (!PermissionCheck_1.isAllowed({ permission: permission_1.Permission.TenantView, tenant: "*" })) {
            return Promise.resolve([]);
        }
        return _super.prototype.all.call(this, args);
    };
    return TenantRepository;
}(basicRepository_1.default));
exports.default = TenantRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\tenantRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\tenantRepository.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var TenantVariableRepository = (function (_super) {
    __extends(TenantVariableRepository, _super);
    function TenantVariableRepository(client) {
        return _super.call(this, "TenantVariables", client) || this;
    }
    return TenantVariableRepository;
}(basicRepository_1.default));
exports.default = TenantVariableRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\tenantVariableRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\tenantVariableRepository.ts"); } } })();

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(111);
var UpgradeConfigurationRepository = (function (_super) {
    __extends(UpgradeConfigurationRepository, _super);
    function UpgradeConfigurationRepository(client) {
        return _super.call(this, "UpgradeConfiguration", client) || this;
    }
    return UpgradeConfigurationRepository;
}(configurationRepository_1.default));
exports.default = UpgradeConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\upgradeConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\upgradeConfigurationRepository.ts"); } } })();

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserIdentityMetadataRepository = (function () {
    function UserIdentityMetadataRepository(client) {
        this.client = client;
    }
    UserIdentityMetadataRepository.prototype.all = function () {
        return this.client.get(this.client.getRootDocument().Links["UserIdentityMetadata"]);
    };
    UserIdentityMetadataRepository.prototype.authenticationConfiguration = function (userId) {
        return this.client.get(this.client.getRootDocument().Links["UserAuthentication"], { userId: userId });
    };
    return UserIdentityMetadataRepository;
}());
exports.default = UserIdentityMetadataRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\userIdentityMetadataRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\userIdentityMetadataRepository.ts"); } } })();

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserOnBoardingRepository = (function () {
    function UserOnBoardingRepository(client) {
        this.client = client;
    }
    UserOnBoardingRepository.prototype.get = function () {
        return this.client.get(this.client.getRootDocument().Links["UserOnboarding"]);
    };
    return UserOnBoardingRepository;
}());
exports.default = UserOnBoardingRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\userOnBoardingRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\userOnBoardingRepository.ts"); } } })();

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var UserRepository = (function (_super) {
    __extends(UserRepository, _super);
    function UserRepository(client) {
        return _super.call(this, "Users", client) || this;
    }
    UserRepository.prototype.signIn = function (loginCommand) {
        var _this = this;
        return this.client.post(this.client.getRootDocument().Links["SignIn"], loginCommand)
            .then(function (authenticatedUser) {
            var antiforgeryToken = _this.client.getAntiforgeryToken();
            if (antiforgeryToken) {
                return authenticatedUser;
            }
            else {
                throw new Error("The required anti-forgery cookie is missing. Perhaps your browser " +
                    "or another network device is blocking cookies? " +
                    "See http://g.octopushq.com/CSRF for more details and troubleshooting.");
            }
        });
    };
    UserRepository.prototype.signOut = function () {
        return this.client.post(this.client.getRootDocument().Links["SignOut"], {});
    };
    UserRepository.prototype.getCurrent = function () {
        return this.client.get(this.client.getRootDocument().Links["CurrentUser"]);
    };
    UserRepository.prototype.getPermissions = function (user) {
        return this.client.get(user.Links["Permissions"]);
    };
    UserRepository.prototype.createApiKey = function (user, purpose) {
        return this.client.post(user.Links["ApiKeys"], { Purpose: purpose });
    };
    UserRepository.prototype.listApiKeys = function (user) {
        return this.client.get(user.Links["ApiKeys"]);
    };
    UserRepository.prototype.revokeApiKey = function (apiKey) {
        return this.client.del(apiKey.Links["Self"]);
    };
    UserRepository.prototype.invite = function (teamIds) {
        return this.client.post(this.client.getRootDocument().Links["Invitations"], { AddToTeamIds: teamIds });
    };
    UserRepository.prototype.register = function (registerCommand) {
        return this.client.post(this.client.getRootDocument().Links["Register"], registerCommand);
    };
    UserRepository.prototype.getTriggers = function (user) {
        return this.client.get(user.Links["Triggers"]);
    };
    return UserRepository;
}(basicRepository_1.default));
exports.default = UserRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\userRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\userRepository.ts"); } } })();

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var UserRoleRepository = (function (_super) {
    __extends(UserRoleRepository, _super);
    function UserRoleRepository(client) {
        return _super.call(this, "UserRoles", client) || this;
    }
    return UserRoleRepository;
}(basicRepository_1.default));
exports.default = UserRoleRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\userRoleRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\userRoleRepository.ts"); } } })();

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var VariableRepository = (function (_super) {
    __extends(VariableRepository, _super);
    function VariableRepository(client) {
        return _super.call(this, "Variables", client) || this;
    }
    VariableRepository.prototype.names = function (projectId, projectEnvironmentsFilter) {
        return this.client.get(this.client.getRootDocument().Links["VariableNames"], {
            project: projectId,
            projectEnvironmentsFilter: projectEnvironmentsFilter ?
                projectEnvironmentsFilter.join(",") : projectEnvironmentsFilter
        });
    };
    VariableRepository.prototype.preview = function (projectId, actionId, environmentId, role, machineId, channelId, tenantId) {
        return this.client.get(this.client.getRootDocument().Links["VariablePreview"], {
            project: projectId,
            environment: environmentId,
            channel: channelId,
            tenant: tenantId,
            action: actionId,
            role: role,
            machine: machineId
        });
    };
    VariableRepository.prototype.nonPrintableChars = function (variableSet) {
        return this.client.post(this.client.getRootDocument().Links["VariablesNonPrintableChars"], variableSet);
    };
    return VariableRepository;
}(basicRepository_1.default));
exports.default = VariableRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\variableRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\variableRepository.ts"); } } })();

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(111);
var LetsEncryptConfigurationRepository = (function (_super) {
    __extends(LetsEncryptConfigurationRepository, _super);
    function LetsEncryptConfigurationRepository(client) {
        return _super.call(this, "LetsEncryptConfiguration", client) || this;
    }
    return LetsEncryptConfigurationRepository;
}(configurationRepository_1.default));
exports.default = LetsEncryptConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\letsEncryptConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\letsEncryptConfigurationRepository.ts"); } } })();

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var DeploymentRepository = (function (_super) {
    __extends(DeploymentRepository, _super);
    function DeploymentRepository(client) {
        return _super.call(this, "Deployments", client) || this;
    }
    return DeploymentRepository;
}(basicRepository_1.default));
exports.default = DeploymentRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\deploymentRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\deploymentRepository.ts"); } } })();

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(28);
var SettingsRepository = (function (_super) {
    __extends(SettingsRepository, _super);
    function SettingsRepository(client) {
        return _super.call(this, "Configuration", client) || this;
    }
    SettingsRepository.prototype.getById = function (id) {
        return this.client.get(this.client.getRootDocument().Links["Configuration"], { id: id });
    };
    SettingsRepository.prototype.getValues = function (resource) {
        return this.client.get(resource.Links["Values"]);
    };
    SettingsRepository.prototype.getMetadata = function (resource) {
        return this.client.get(resource.Links["Metadata"]);
    };
    SettingsRepository.prototype.saveValues = function (metadataResource, resource) {
        return this.client.put(metadataResource.Links["Values"], resource);
    };
    return SettingsRepository;
}(basicRepository_1.default));
exports.default = SettingsRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\configuration\\settingsRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\configuration\\settingsRepository.ts"); } } })();

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CloudTemplateRepository = (function () {
    function CloudTemplateRepository(client) {
        this.client = client;
    }
    CloudTemplateRepository.prototype.getMetadata = function (templateBody, id) {
        var templateResource = { template: encodeURI(templateBody) };
        return this.client.post(this.client.getRootDocument().Links["CloudTemplate"], templateResource, { id: id.toString() });
    };
    return CloudTemplateRepository;
}());
exports.default = CloudTemplateRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\cloudTemplateRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\repositories\\cloudTemplateRepository.ts"); } } })();

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var caching_1 = __webpack_require__(1132);
var logger_1 = __webpack_require__(99);
var userPermissions_1 = __webpack_require__(1133);
var store_1 = __webpack_require__(147);
var configurationArea_1 = __webpack_require__(433);
var Session = (function () {
    function Session() {
        this.cache = new caching_1.default();
    }
    Session.prototype.start = function (user, permissions, features) {
        logger_1.default.info("Starting session for " + user.DisplayName + " user.");
        this.currentUser = user;
        this.currentPermissions = new userPermissions_1.UserPermissions(permissions);
        this.setFeatures(features);
    };
    Session.prototype.end = function () {
        if (this.currentUser) {
            logger_1.default.info("Ending session for " + this.currentUser.DisplayName + " user.");
        }
        this.currentUser = null;
        this.currentPermissions = null;
        this.setFeatures(null);
        this.cache.clearAll();
    };
    Session.prototype.refreshPermissions = function (permissions) {
        this.currentPermissions = new userPermissions_1.UserPermissions(permissions);
    };
    Session.prototype.isAuthenticated = function () {
        return this.currentUser != null;
    };
    Session.prototype.setFeatures = function (features) {
        store_1.default.dispatch(configurationArea_1.configurationActions.featuresFetched(features));
    };
    return Session;
}());
exports.default = Session;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\session.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\session.ts"); } } })();

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Caching = (function () {
    function Caching(options) {
        this.cache = {};
        options = options || {};
        this.maxMemory = options.maxMemory || Math.pow(1024, 2) * 1000 / 2; //1GB /2 (1 character in js is 2 bytes)
        this.dataVersionHeader = "X-Octopus-Data-Version";
        this.authorizationHashHeader = "X-Octopus-Authorization-Hash";
    }
    Caching.prototype.clearAll = function () {
        this.cache = {};
    };
    Caching.prototype.setHeaderAndGetValue = function (request, options) {
        if (this.cache[options.url]) {
            request.setRequestHeader(this.dataVersionHeader, this.cache[options.url].dataVersion);
            request.setRequestHeader(this.authorizationHashHeader, this.cache[options.url].authorizationHash);
            this.cache[options.url].lastAccessed = new Date();
            return this.cache[options.url].value;
        }
    };
    Caching.prototype.updateCache = function (request, options) {
        try {
            var dataVersion = request.getResponseHeader(this.dataVersionHeader);
            var authorizationHash = request.getResponseHeader(this.authorizationHashHeader);
            if (!!dataVersion && !!authorizationHash) {
                var item = {
                    dataVersion: dataVersion,
                    authorizationHash: authorizationHash,
                    lastAccessed: new Date(),
                    value: request.responseText
                };
                var itemSize = this.itemSizeInMemory(options.url, item);
                if (itemSize < this.maxMemory) {
                    this.cache[options.url] = item;
                }
                this.memoryPressureCleanup();
            }
            else {
                delete this.cache[options.url];
            }
        }
        catch (e) {
            delete this.cache[options.url];
        }
    };
    Caching.prototype.canUseCachedValue = function (request) {
        return (request.status === 304 && (request.responseText === "" || !request.responseText));
    };
    Caching.prototype.memoryPressureCleanup = function () {
        var currentMemory = this.roughSizeOfReleasableMemory();
        while (currentMemory >= this.maxMemory) {
            this.removeOldest();
            var newMemoryLevel = this.roughSizeOfReleasableMemory();
            if (newMemoryLevel === currentMemory) {
                return;
            }
            currentMemory = newMemoryLevel;
        }
    };
    Caching.prototype.itemSizeInMemory = function (url, item) {
        return url.length + item.value.length;
    };
    Caching.prototype.removeOldest = function () {
        var _this = this;
        var oldestUrl;
        var oldestResponded = -1;
        var now = new Date();
        Object.keys(this.cache).forEach(function (url) {
            var age = now.valueOf() - _this.cache[url].lastAccessed.valueOf();
            if (age > oldestResponded) {
                oldestResponded = age;
                oldestUrl = url;
            }
        });
        delete this.cache[oldestUrl];
    };
    Caching.prototype.roughSizeOfReleasableMemory = function () {
        var _this = this;
        return Object.keys(this.cache).reduce(function (total, url) {
            var item = _this.cache[url];
            return total + _this.itemSizeInMemory(url, item);
        }, 0);
    };
    return Caching;
}());
exports.default = Caching;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\caching.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\caching.ts"); } } })();

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserPermissions = (function () {
    function UserPermissions(permissions) {
        var ps = {};
        Object.keys(permissions).forEach(function (k) {
            ps[k.toLowerCase()] = permissions[k].map(function (e) {
                return {
                    projectIds: (e.RestrictedToProjectIds || []).map(function (id) { return id.toLowerCase(); }),
                    environmentIds: (e.RestrictedToEnvironmentIds || []).map(function (id) { return id.toLowerCase(); }),
                    projectGroupIds: (e.RestrictedToProjectGroupIds || []).map(function (id) { return id.toLowerCase(); }),
                    tenantIds: (e.RestrictedToTenantIds || []).map(function (id) { return id.toLowerCase(); })
                };
            });
        });
        this.internalPermissions = ps;
    }
    UserPermissions.prototype.firstAuthorized = function (permissions) {
        var _this = this;
        var match = null;
        permissions.forEach(function (p) {
            var restrictions = _this.internalPermissions[p.toLowerCase()];
            if (!restrictions) {
                return;
            }
            if (!match) {
                match = p;
            }
        });
        return match;
    };
    UserPermissions.prototype.isAuthorized = function (authorization) {
        var isWildcard = function (s) {
            return s === "*";
        };
        var restrictions = this.internalPermissions[authorization.permission.toLowerCase()];
        if (!restrictions) {
            // User doesn't have the permission in any scope
            return false;
        }
        if (restrictions.length === 0) {
            // No restrictions
            return true;
        }
        for (var _i = 0, restrictions_1 = restrictions; _i < restrictions_1.length; _i++) {
            var restriction = restrictions_1[_i];
            var allowed = true;
            if (restriction.projectIds.length !== 0) {
                if (authorization.projectId == null ||
                    (!isWildcard(authorization.projectId) && !restriction.projectIds.includes(authorization.projectId.toLowerCase()))) {
                    allowed = false;
                }
            }
            if (restriction.environmentIds.length !== 0) {
                if (authorization.environmentId == null ||
                    (!isWildcard(authorization.environmentId) && !restriction.environmentIds.includes(authorization.environmentId.toLowerCase()))) {
                    allowed = false;
                }
            }
            if (restriction.projectGroupIds.length !== 0) {
                if (authorization.projectGroupId == null ||
                    (!isWildcard(authorization.projectGroupId) && !restriction.projectGroupIds.includes(authorization.projectGroupId.toLowerCase()))) {
                    allowed = false;
                }
            }
            if (restriction.tenantIds.length !== 0) {
                if (authorization.tenantId == null ||
                    (!isWildcard(authorization.tenantId) && !restriction.tenantIds.includes(authorization.tenantId.toLowerCase()))) {
                    allowed = false;
                }
            }
            if (allowed) {
                return true;
            }
        }
        return false;
    };
    return UserPermissions;
}());
exports.UserPermissions = UserPermissions;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\userPermissions.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\userPermissions.ts"); } } })();

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorBoundary_1 = __webpack_require__(239);
__export(__webpack_require__(239));
exports.default = ErrorBoundary_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ErrorBoundary\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ErrorBoundary\\index.ts"); } } })();

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1136);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_error__3zI1F{padding:1.5rem 1rem;color:#db4437;background-color:#f8e8e6;text-align:left}.style_error__3zI1F ul{padding-left:1rem;margin-bottom:0;list-style-type:disc;font-weight:400}.style_titleContainer__2bAHe{display:flex;justify-content:space-between}.style_title__A5dbg{font-weight:500}.style_detailLink__3naxR{padding-top:.25rem;padding-bottom:.25rem}", ""]);

// exports
exports.locals = {
	"error": "style_error__3zI1F",
	"titleContainer": "style_titleContainer__2bAHe",
	"title": "style_title__A5dbg",
	"detailLink": "style_detailLink__3naxR"
};

/***/ }),
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1829v{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__XTsGt{display:none!important}}@media (max-width:79.9rem){.style_hide-md__1UGwQ{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1za9-{display:none!important}}.style_popoverMenu__1p7R9 a{color:#fff}.style_pagingControlButton__3tD1Z{cursor:pointer;border:0;padding:0;margin:0 .0625rem;width:1.5rem;height:1.5rem;border-radius:0;background-color:#fff;color:#9e9e9e}@media (max-width:37.4rem){.style_pagingControlButton__3tD1Z{width:2rem;height:2rem}}.style_pagingControlButton__3tD1Z:focus,.style_pagingControlButton__3tD1Z:hover{background-color:#9e9e9e;color:#fff;outline:0}.style_pagingControlButton__3tD1Z:active{background-color:#fff;color:#9e9e9e}.style_pagingControlButton__3tD1Z .style_pagingControlButtonText__2nTLE{width:.5rem;height:1.25rem;font-family:Roboto;font-size:.75rem;line-height:1.36rem;text-align:left}.style_pagingControlButtonActive__3HE6R{background-color:#9e9e9e;color:#fff}.style_pagingControlButtonInactive__rDMPp{background-color:#fff;color:#9e9e9e}.style_buttonWrapper__3gxle{display:inline-block}.style_globalActionButton__2W3W_{white-space:nowrap!important}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1829v",
	"hideSm": "style_hide-sm__1829v",
	"visible-sm": "style_visible-sm__XTsGt",
	"visibleSm": "style_visible-sm__XTsGt",
	"hide-md": "style_hide-md__1UGwQ",
	"hideMd": "style_hide-md__1UGwQ",
	"visible-md": "style_visible-md__1za9-",
	"visibleMd": "style_visible-md__1za9-",
	"popoverMenu": "style_popoverMenu__1p7R9",
	"pagingControlButton": "style_pagingControlButton__3tD1Z",
	"pagingControlButtonText": "style_pagingControlButtonText__2nTLE",
	"pagingControlButtonActive": "style_pagingControlButtonActive__3HE6R",
	"pagingControlButtonInactive": "style_pagingControlButtonInactive__rDMPp",
	"buttonWrapper": "style_buttonWrapper__3gxle",
	"globalActionButton": "style_globalActionButton__2W3W_"
};

/***/ }),
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(243);
var PagingControlButton = function (props) {
    var activeClass = props.isActive ? styles.pagingControlButtonActive : styles.pagingControlButtonInactive;
    return (React.createElement("button", { className: styles.pagingControlButton + " " + activeClass, onClick: props.onPageSelected, title: props.label },
        React.createElement("span", { className: styles.pagingControlButtonText }, props.label)));
};
exports.default = PagingControlButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Button\\PagingControlButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Button\\PagingControlButton.tsx"); } } })();

/***/ }),
/* 1201 */,
/* 1202 */,
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1204);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_busyIndicator__1Ka4K div:first-child{background-color:#ccc}.style_busyIndicatorHiddenSpacer__3iMs6{height:.25rem}.style_circularBusyIndicator__15KpB div:first-child{vertical-align:middle;background-color:transparent}", ""]);

// exports
exports.locals = {
	"busyIndicator": "style_busyIndicator__1Ka4K",
	"busyIndicatorHiddenSpacer": "style_busyIndicatorHiddenSpacer__3iMs6",
	"circularBusyIndicator": "style_circularBusyIndicator__15KpB"
};

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_layout__3F9l_{display:flex;flex-direction:column;width:100%}.style_headerContentAlignment__2DmFe{padding-left:1rem;padding-right:1rem}.style_title__1aUJB{padding:1rem;font-size:1.063rem;font-weight:500}.style_titleIcon__1WDUq{margin-right:.5rem;display:inline-block}.style_body__3C98V{margin-top:.5rem;font-size:.875rem;line-height:1.25rem;padding-left:1rem;padding-right:1rem;padding-bottom:1rem;overflow-y:auto;flex-direction:column}.style_actions__3f7mN{padding:1rem;display:flex;justify-content:space-between;flex:0 0 auto;flex-wrap:wrap}.style_materialDialogBody__1XgjK{padding:0}.style_primaryActions__2EV5A>*{margin-left:.5rem}.style_secondaryActions__1ZOtb>*{margin-right:.5rem}.style_dialogWrapper__11h1h{display:flex;flex-direction:column;height:100%}", ""]);

// exports
exports.locals = {
	"layout": "style_layout__3F9l_",
	"headerContentAlignment": "style_headerContentAlignment__2DmFe",
	"title": "style_title__1aUJB",
	"titleIcon": "style_titleIcon__1WDUq",
	"body": "style_body__3C98V",
	"actions": "style_actions__3f7mN",
	"materialDialogBody": "style_materialDialogBody__1XgjK",
	"primaryActions": "style_primaryActions__2EV5A",
	"secondaryActions": "style_secondaryActions__1ZOtb",
	"dialogWrapper": "style_dialogWrapper__11h1h"
};

/***/ }),
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__3DD5e{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__1HGi2{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2rwez{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2O3zd{display:none!important}}.style_buttonDialogContainer__J2Ndc{display:inline-block}.style_materialDialogContent__2lizw{padding:0}@media (max-width:37.4rem){.style_materialDialogContent__2lizw{width:90%!important}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3DD5e",
	"hideSm": "style_hide-sm__3DD5e",
	"visible-sm": "style_visible-sm__1HGi2",
	"visibleSm": "style_visible-sm__1HGi2",
	"hide-md": "style_hide-md__2rwez",
	"hideMd": "style_hide-md__2rwez",
	"visible-md": "style_visible-md__2O3zd",
	"visibleMd": "style_visible-md__2O3zd",
	"buttonDialogContainer": "style_buttonDialogContainer__J2Ndc",
	"materialDialogContent": "style_materialDialogContent__2lizw"
};

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// https://codepen.io/brian-baum/pen/mJZxJX
var smoothScroll = {
    timer: null,
    stop: function () {
        clearTimeout(this.timer);
    },
    scrollTo: function (node) {
        var settings = {
            duration: 600,
            easing: {
                outQuint: function (x, t, b, c, d) {
                    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
                }
            }
        };
        var nodeTop = node.offsetTop;
        var nodeHeight = node.offsetHeight;
        var body = document.body;
        var html = document.documentElement;
        var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        var windowHeight = window.innerHeight;
        var offset = window.pageYOffset;
        var delta = nodeTop - offset;
        var bottomScrollableY = height - windowHeight;
        var targetY = (bottomScrollableY < delta) ?
            bottomScrollableY - (height - nodeTop - nodeHeight + offset) :
            delta;
        var startTime = Date.now();
        var percentage = 0;
        if (this.timer) {
            clearInterval(this.timer);
        }
        function step() {
            var yScroll;
            var elapsed = Date.now() - startTime;
            if (elapsed > settings.duration) {
                clearTimeout(this.timer);
            }
            percentage = elapsed / settings.duration;
            if (percentage > 1) {
                clearTimeout(this.timer);
            }
            else {
                yScroll = settings.easing.outQuint(0, elapsed, offset, targetY, settings.duration);
                window.scrollTo(0, yScroll);
                this.timer = setTimeout(step, 10);
            }
        }
        this.timer = setTimeout(step, 10);
    }
};
exports.default = smoothScroll;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ErrorPanel\\smoothscroll.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ErrorPanel\\smoothscroll.ts"); } } })();

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1215);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_note__4cGKf{font-family:Roboto;font-size:.75rem;line-height:1.5rem;text-align:left;font-weight:300;margin-bottom:.5rem;color:#666}.style_note__4cGKf a{color:#2f93e0}", ""]);

// exports
exports.locals = {
	"note": "style_note__4cGKf"
};

/***/ }),
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var releaseRouteLinks_1 = __webpack_require__(283);
var triggerResource_1 = __webpack_require__(322);
exports.default = function (root) { return ({
    v3projectRoutes: {
        newProject: root + "/projects/new"
    },
    projects: root + "/projects",
    trigger: trigger(root),
    channel: channel(root),
    release: function (releaseId) { return root + "/releases/" + releaseId; },
    project: function (projectSlug) {
        if (!!projectSlug && typeof projectSlug !== "string") {
            projectSlug = projectSlug.Slug;
        }
        var specificRoot = root + "/projects/" + projectSlug;
        return __assign({ root: specificRoot }, releaseRouteLinks_1.default(specificRoot), { overview: specificRoot + "/overview", settings: specificRoot + "/settings", channels: specificRoot + "/channels", channel: channel(specificRoot), triggers: specificRoot + "/triggers", trigger: trigger(specificRoot), scheduledTrigger: function (triggerId) {
                if (!!triggerId && typeof triggerId !== "string") {
                    triggerId = triggerId.Id;
                }
                return specificRoot + "/triggers/scheduled/edit/" + triggerId;
            }, variables: {
                root: specificRoot + "/variables",
                projectTemplates: specificRoot + "/variables/projectvariabletemplates",
                commonTemplates: specificRoot + "/variables/commonvariabletemplates",
                library: specificRoot + "/variables/library",
                preview: specificRoot + "/variables/preview",
                all: specificRoot + "/variables/all"
            }, process: {
                root: specificRoot + "/process",
                stepTemplates: specificRoot + "/process/steptemplates",
                childStepTemplates: function (parentStepId) { return ({
                    root: specificRoot + "/process/childsteptemplates/" + parentStepId
                }); },
                stepNew: function (templateType, parentStepId, templateId) {
                    var base = specificRoot + "/process/step";
                    if (parentStepId) {
                        base = base + "/" + parentStepId;
                    }
                    base = base + "/new/" + templateType;
                    if (templateId) {
                        base = base + "/" + templateId;
                    }
                    return base;
                },
                step: function (actionId) { return specificRoot + "/process/step/" + actionId; }
            }, childStepTemplates: function (parentStepId) { return ({
                root: specificRoot + "/childsteptemplates/" + parentStepId
            }); }, steptemplates: specificRoot + "/steptemplates" });
    }
}); };
function trigger(root) {
    return function (triggerId, triggerType) {
        if (triggerType === void 0) { triggerType = triggerResource_1.TriggerActionType.AutoDeploy; }
        if (!!triggerId && typeof triggerId !== "string") {
            triggerId = triggerId.Id;
        }
        if (triggerType === triggerResource_1.TriggerActionType.AutoDeploy) {
            return root + "/triggers/edit/" + triggerId;
        }
        return root + "/triggers/scheduled/edit/" + triggerId;
    };
}
function channel(root) {
    return function (channelId) {
        if (!!channelId && typeof channelId !== "string") {
            channelId = channelId.Id;
        }
        return root + "/channels/edit/" + channelId;
    };
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectsRoutes\\projectRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectsRoutes\\projectRouteLinks.ts"); } } })();

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) {
    var libraryRoot = root + "/library";
    var stepTemplatesRoot = libraryRoot + "/steptemplates";
    return {
        root: libraryRoot,
        feeds: libraryRoot + "/feeds",
        feedCreate: libraryRoot + "/feeds/create",
        feed: function (feedId) { return ({
            root: libraryRoot + "/feeds/" + feedId,
            test: libraryRoot + "/feeds/" + feedId + "/test"
        }); },
        stepTemplates: {
            root: stepTemplatesRoot,
            builtIn: stepTemplatesRoot + "/builtin",
            community: stepTemplatesRoot + "/community",
            installedStep: function (template) { return stepTemplatesRoot + "?installedStep=" + template.Id; },
            new: function (templateSearch) { return stepTemplatesRoot + "/new/" + templateSearch.Type; },
            communityTemplate: function (communityTemplateId, projectId) {
                if (!!communityTemplateId && typeof communityTemplateId !== "string") {
                    communityTemplateId = communityTemplateId.CommunityActionTemplateId;
                }
                return {
                    root: stepTemplatesRoot + "/community/" + communityTemplateId + (projectId ? "?projectId=" + projectId : ""),
                    details: stepTemplatesRoot + "/community/" + communityTemplateId + "/details"
                };
            }
        },
        stepTemplate: function (templateId) {
            if (!!templateId && typeof templateId !== "string") {
                templateId = templateId.Id;
            }
            var stepTemplateRoot = stepTemplatesRoot + "/" + templateId;
            return {
                root: "" + stepTemplateRoot,
                usage: stepTemplateRoot + "/usage",
                run: stepTemplateRoot + "/run"
            };
        },
        lifecycles: libraryRoot + "/lifecycles",
        lifecyclesCreate: libraryRoot + "/lifecycles/create",
        lifecycle: function (lifecycleId) { return libraryRoot + "/lifecycles/" + lifecycleId; },
        certificates: {
            root: libraryRoot + "/certificates",
            archive: libraryRoot + "/certificates/archive",
            create: libraryRoot + "/certificates/create"
        },
        certificate: function (certificateId) { return libraryRoot + "/certificates/" + certificateId; },
        variableSets: libraryRoot + "/variables",
        variableSet: function (variableSetId, activeTab) {
            if (!!variableSetId && typeof variableSetId !== "string") {
                variableSetId = variableSetId.Id;
            }
            return libraryRoot + "/variables/" + variableSetId + (activeTab ? "?activeTab=" + activeTab : "");
        },
        tagSets: {
            root: libraryRoot + "/tagsets",
            create: libraryRoot + "/tagsets/create"
        },
        tagSet: function (tagSetId) { return libraryRoot + "/tagsets/" + tagSetId; },
        builtInRepository: {
            root: libraryRoot + "/builtinrepository",
            package: function (versionedPackage) { return libraryRoot + "/builtinrepository/" + versionedPackage; },
            versions: function (packageId) { return libraryRoot + "/builtinrepository/versions/" + packageId; }
        },
        scripts: {
            root: libraryRoot + "/scripts",
            create: libraryRoot + "/scripts/create",
        },
        script: function (scriptId) { return libraryRoot + "/scripts/" + scriptId; },
        v3routes: {
            certificates: {
                create: libraryRoot + "/certificates/new"
            },
            feeds: {
                create: libraryRoot + "/feeds/new"
            },
            lifecycles: {
                create: libraryRoot + "/lifecycles/new"
            },
            scripts: {
                create: libraryRoot + "/scripts/new"
            },
            tagSets: {
                create: libraryRoot + "/tagsets/new"
            },
            variableSets: {
                create: libraryRoot + "/variables/new"
            }
        }
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\library\\components\\LibraryRoutes\\libraryRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\library\\components\\LibraryRoutes\\libraryRouteLinks.ts"); } } })();

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var URI = __webpack_require__(106);
exports.default = function (root) {
    var infraRoot = root + "/infrastructure";
    return {
        root: infraRoot,
        overview: infraRoot + "/overview",
        environments: {
            root: infraRoot + "/environments",
            create: infraRoot + "/environments/create",
            filtered: function (obj) { return infraRoot + "/environments" + (new URI()).search(obj).search(); }
        },
        environment: function (environmentId) {
            if (!!environmentId && typeof environmentId !== "string") {
                environmentId = environmentId.Id;
            }
            return infraRoot + "/environments/" + environmentId;
        },
        machines: {
            root: infraRoot + "/machines",
            create: infraRoot + "/machines/create",
            filtered: function (obj) { return infraRoot + "/machines" + (new URI()).search(obj).search(); },
            discover: function (environmentId) { return infraRoot + "/machines/discover" + (environmentId ? "/" + environmentId : ""); }
        },
        machine: function (machineId) {
            if (!!machineId && typeof machineId !== "string") {
                machineId = machineId.Id;
            }
            var machineRoot = infraRoot + "/machines/" + machineId;
            return {
                root: machineRoot,
                settings: machineRoot + "/settings",
                deployments: machineRoot + "/deployments",
                connection: machineRoot + "/connection",
                events: machineRoot + "/events"
            };
        },
        proxies: {
            root: infraRoot + "/proxies",
            create: infraRoot + "/proxies/create",
        },
        proxy: function (proxyId) { return infraRoot + "/proxies/" + proxyId; },
        machinePolicies: {
            root: infraRoot + "/machinepolicies",
            create: infraRoot + "/machinepolicies/create",
        },
        machinePolicy: function (machinePolicyId) { return infraRoot + "/machinepolicies/" + machinePolicyId; },
        accounts: {
            root: infraRoot + "/accounts",
            create: infraRoot + "/accounts/create"
        },
        account: function (accountId) { return infraRoot + "/accounts/" + accountId; }
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\infrastructureRouteLinks.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\infrastructureRouteLinks.tsx"); } } })();

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) {
    var taskRoot = root + "/tasks";
    return {
        tasks: {
            root: taskRoot,
            console: taskRoot + "/console",
            filtered: function (taskIds) {
                var qs = taskIds ? "?ids=" + taskIds.join(",") : "";
                return "" + taskRoot + qs;
            }
        },
        task: function (taskId) {
            if (!!taskId && typeof taskId !== "string") {
                taskId = isDeploymentResource(taskId) ? taskId.TaskId : taskId.Id;
            }
            return {
                root: taskRoot + "/" + taskId,
                raw: taskRoot + "/" + taskId + "/raw",
            };
        }
    };
};
function isDeploymentResource(resource) {
    return !!resource.TaskId;
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\tasks\\components\\TaskRoutes\\taskRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\tasks\\components\\TaskRoutes\\taskRouteLinks.ts"); } } })();

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) {
    var configRoot = root + "/configuration";
    return {
        root: configRoot,
        userInvites: configRoot + "/userinvites",
        audit: configRoot + "/audit",
        machineEventsForUser: function (user, category) { return configRoot + "/audit?users=" + encodeURIComponent(user) + "&eventCategories=" + category + "&documentTypes=Machines"; },
        backup: configRoot + "/backup",
        features: configRoot + "/features",
        license: configRoot + "/license",
        smtp: configRoot + "/smtp",
        nodes: {
            root: configRoot + "/nodes",
            serverSettings: configRoot + "/nodes/serverSetttings",
            config: configRoot + "/nodes/config"
        },
        thumbprint: configRoot + "/thumbprint",
        maintenance: configRoot + "/maintenance",
        v3route: {
            certificates: configRoot + "/certificates",
            usersInvite: configRoot + "/users/invite",
            testPermissions: configRoot + "/teams/test"
        },
        letsEncrypt: {
            root: configRoot + "/letsencrypt",
            configure: configRoot + "/letsencrypt/configure"
        },
        testPermissions: configRoot + "/testpermissions",
        testPermission: function (userId) { return configRoot + "/testpermissions/" + userId; },
        subscriptions: {
            root: configRoot + "/subscriptions",
            create: configRoot + "/subscriptions/create",
        },
        subscription: function (subscriptionId) { return configRoot + "/subscriptions/" + subscriptionId; },
        users: {
            root: configRoot + "/users",
            create: configRoot + "/users/create",
        },
        user: function (userId) {
            if (!!userId && typeof userId !== "string") {
                userId = userId.Id;
            }
            return configRoot + "/users/" + userId;
        },
        spaces: {
            root: configRoot + "/spaces",
            create: configRoot + "/spaces/create",
        },
        teams: {
            root: configRoot + "/teams",
            create: configRoot + "/teams/create",
        },
        team: function (teamId) {
            if (!!teamId && typeof teamId !== "string") {
                teamId = teamId.Id;
            }
            return configRoot + "/teams/" + teamId;
        },
        roles: {
            root: configRoot + "/roles",
            create: configRoot + "/roles/create",
        },
        role: function (roleId) {
            if (!!roleId && typeof roleId !== "string") {
                roleId = roleId.Id;
            }
            return configRoot + "/roles/" + roleId;
        },
        diagnostics: {
            root: configRoot + "/diagnostics",
            logs: {
                root: configRoot + "/diagnostics/logs",
                autoDeploy: configRoot + "/diagnostics/autodeploy",
                scheduledDeploy: configRoot + "/diagnostics/scheduleddeploy",
                machineCleanup: configRoot + "/diagnostics/machinecleanup",
                subscription: configRoot + "/diagnostics/subscription",
            }
        },
        settings: {
            root: configRoot + "/settings",
        },
        setting: function (settingId) {
            return configRoot + "/settings/" + settingId;
        }
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\configuration\\components\\ConfigurationRoutes\\configurationRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\configuration\\components\\ConfigurationRoutes\\configurationRouteLinks.ts"); } } })();

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) { return ({
    projectGroup: function (projectGroupId) {
        var specificRoot = root + "/projectGroups/" + projectGroupId;
        return {
            root: specificRoot,
        };
    }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectGroupLayout\\projectGroupRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectGroupLayout\\projectGroupRouteLinks.ts"); } } })();

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) { return ({
    deployments: root + "/deployments",
    deployment: function (deploymentId) {
        var specificRoot = root + "/deployments/" + deploymentId;
        return {
            root: specificRoot,
        };
    }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\deployments\\deploymentRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\deployments\\deploymentRouteLinks.ts"); } } })();

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) {
    var users = root + "/users";
    var me = users + "/me";
    return {
        me: me,
        logins: me + "/logins",
        details: me + "/details",
        apiKeys: me + "/apiKeys",
        activity: me + "/activity",
        register: function (inviteCode) { return users + "/register/" + inviteCode; },
        signIn: users + "/sign-in",
        signOut: users + "/sign-out"
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserProfileRoutes\\userProfileRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserProfileRoutes\\userProfileRouteLinks.ts"); } } })();

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) {
    var specificRoot = root + "/dashboard";
    return {
        root: specificRoot,
        configure: specificRoot + "/configure"
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardOverview\\dashboardRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardOverview\\dashboardRouteLinks.ts"); } } })();

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StandardLayout_1 = __webpack_require__(1237);
exports.StandardLayout = StandardLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\StandardLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\StandardLayout\\index.tsx"); } } })();

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StandardLayoutInternal_1 = __webpack_require__(1238);
var react_redux_1 = __webpack_require__(67);
var redux_1 = __webpack_require__(96);
var reducers_1 = __webpack_require__(327);
var StandardLayout = react_redux_1.connect(function (state) {
    return {
        unhandledError: state.unhandledError
    };
}, function (dispatch) {
    return {
        onErrorClose: redux_1.bindActionCreators(reducers_1.clearUnhandledErrorAction, dispatch)
    };
})(StandardLayoutInternal_1.default);
exports.default = StandardLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\StandardLayout\\StandardLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\StandardLayout\\StandardLayout.tsx"); } } })();

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Navbar_1 = __webpack_require__(1239);
var ErrorPanel_1 = __webpack_require__(1446);
var RootRoutes_1 = __webpack_require__(1447);
var GettingStartedFooter_1 = __webpack_require__(1890);
var SystemMessagesBanner_1 = __webpack_require__(1896);
var Sticky_1 = __webpack_require__(440);
var clientInstance_1 = __webpack_require__(10);
var StandardLayoutInternal = (function (_super) {
    __extends(StandardLayoutInternal, _super);
    function StandardLayoutInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onErrorClose = function () {
            _this.props.onErrorClose();
        };
        return _this;
    }
    StandardLayoutInternal.prototype.render = function () {
        return React.createElement("div", null,
            React.createElement(Sticky_1.default, { innerZ: 10 },
                React.createElement("div", { id: "toppanel" },
                    React.createElement(Navbar_1.Navbar, null),
                    this.props.unhandledError &&
                        React.createElement(ErrorPanel_1.default, { message: "An unexpected error occurred in Octopus v" + clientInstance_1.client.version + ": " + this.props.unhandledError.message, details: this.props.unhandledError.details, fullWidth: true, canClose: true, onErrorClose: this.onErrorClose }),
                    React.createElement(SystemMessagesBanner_1.default, null))),
            React.createElement(RootRoutes_1.default, null),
            React.createElement(GettingStartedFooter_1.default, null));
    };
    return StandardLayoutInternal;
}(React.Component));
exports.default = StandardLayoutInternal;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\StandardLayout\\StandardLayoutInternal.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\StandardLayout\\StandardLayoutInternal.tsx"); } } })();

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Navbar_1 = __webpack_require__(1240);
exports.Navbar = Navbar_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\index.tsx"); } } })();

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var resources_1 = __webpack_require__(26);
var clientInstance_1 = __webpack_require__(10);
var EAPBar_1 = __webpack_require__(1241);
var ProjectSwitcher_1 = __webpack_require__(1247);
var UserAccountMenu_1 = __webpack_require__(1423);
var PermissionCheck_1 = __webpack_require__(45);
var PriorityNavigation_1 = __webpack_require__(635);
var environment_1 = __webpack_require__(238);
var SvgIcon_1 = __webpack_require__(21);
var React = __webpack_require__(0);
var routeLinks_1 = __webpack_require__(20);
var LicenceNotificationPoller_1 = __webpack_require__(1440);
var UpdateAvailableNotificationPoller_1 = __webpack_require__(1441);
var NotificationsMenu_1 = __webpack_require__(1442);
var styles = __webpack_require__(245);
var react_redux_1 = __webpack_require__(67);
var react_router_1 = __webpack_require__(69);
var ProjectSwitchIcon = function (props) { return React.createElement(SvgIcon_1.default, __assign({}, props, { color: "white", viewBox: "0 0 24 24" }),
    React.createElement("path", { d: "M16.2,6.4c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3c1.1,0,2.1-0.3,3-0.9l2.6,2.6c0.2,0.2,0.4,0.3,0.7,0.3c0.6,0,1-0.4,1-1c0-0.3-0.1-0.5-0.3-0.7l-2.6-2.6c0.6-0.9,0.9-1.9,0.9-3C21.5,8.8,19.1,6.4,16.2,6.4z M16.3,15.3c-1.9,0-3.4-1.6-3.4-3.4c0-1.9,1.6-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4S18.2,15.3,16.3,15.3z M18.9,17.3c-0.8,0.6-1.7,0.7-2.7,0.7c-2.4,0-4.5-1.3-5.5-3.3l-0.1,0H7.3c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h3c-0.2-0.5-0.3-1-0.3-1.5H7.4C7.2,12.4,7,12.2,7,12s0.2-0.4,0.4-0.4h2.5c0,0,0,0,0,0c0-0.5,0.1-1,0.2-1.5H7.4C7.2,10.1,7,9.9,7,9.7s0.2-0.4,0.4-0.4h3c0.9-2.3,3.2-3.9,5.8-3.9c1.1,0,2.1,0.3,3,0.8V5.7c0-0.9-0.7-1.6-1.6-1.6H1.8c-0.9,0-1.6,0.7-1.6,1.6v12.7c0,0.9,0.7,1.6,1.6,1.6h15.9c0.9,0,1.6-0.7,1.6-1.6V17C19.3,17,19.2,17.2,18.9,17.3z M5.8,13.2h-4v-4h4V13.2z" })); };
var Navbar = (function (_super) {
    __extends(Navbar, _super);
    function Navbar(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollToMainContent = function () {
            document.getElementById("maincontent").scrollIntoView();
        };
        _this.closeProjectSwitcher = function () {
            _this.setState({
                openProjectSwitcher: false
            });
        };
        _this.toggleProjectSwitcher = function (e) {
            _this.setState({
                openProjectSwitcher: !_this.state.openProjectSwitcher,
                projectSwitcherAnchorEl: e
            });
        };
        _this.state = {
            openProjectSwitcher: false,
            projectSwitcherAnchorEl: null,
            eapIsHidden: false,
        };
        return _this;
    }
    Navbar.prototype.render = function () {
        var _this = this;
        // The topnavbar id is used by E2E UI tests
        return React.createElement("div", { id: "topnavbar", className: styles.topnavbar },
            React.createElement(EAPBar_1.default, { onCloseClicked: function () { return _this.setState({ eapIsHidden: true }); } }),
            React.createElement("div", { className: styles.navbar },
                React.createElement(PriorityNavigation_1.default, { navigationItems: this.getNavigationItems(this.props.isMultiTenancyEnabled, this.state.eapIsHidden), maxNavigationItems: 99, activeItemClassName: styles.navItemActive, className: styles.navbarCenter, showHamburgerIcon: true }),
                PermissionCheck_1.isAllowed({ permission: resources_1.Permission.ProjectView, wildcard: true }) &&
                    React.createElement(ProjectSwitcher_1.default, { open: this.state.openProjectSwitcher, onRequestClose: this.closeProjectSwitcher, anchorEl: this.state.projectSwitcherAnchorEl }),
                React.createElement("nav", { className: styles.navbarRight },
                    React.createElement(UpdateAvailableNotificationPoller_1.default, null),
                    React.createElement(LicenceNotificationPoller_1.default, null),
                    React.createElement(NotificationsMenu_1.default, null),
                    React.createElement(UserAccountMenu_1.default, { currentUser: clientInstance_1.session.currentUser }))));
    };
    Navbar.prototype.getNavigationItems = function (isMultiTenancyEnabled, eapIsHidden) {
        var navigationItems = [];
        // only show the dashboard icon if no spaces, otherwise spaces will handle it
        navigationItems.push({ url: routeLinks_1.default.root, text: "Dashboard", icon: React.createElement("em", { className: "fontoctopus-octopus" }), exact: true });
        if (PermissionCheck_1.isAllowed({ permission: resources_1.Permission.ProjectView, wildcard: true })) {
            navigationItems.push({ url: routeLinks_1.default.projects, text: "Projects" });
        }
        if (PermissionCheck_1.isAllowed({ permission: resources_1.Permission.ProjectView, wildcard: true })) {
            navigationItems.push({ url: null, icon: React.createElement(ProjectSwitchIcon, null), title: "Project switcher", onClick: this.toggleProjectSwitcher });
        }
        if (PermissionCheck_1.isAllowed({ permission: resources_1.Permission.MachineView, wildcard: true })) {
            navigationItems.push({ url: routeLinks_1.default.infrastructure.root, text: "Infrastructure" });
        }
        if (isMultiTenancyEnabled && PermissionCheck_1.isAllowed({ permission: resources_1.Permission.TenantView, tenant: "*" })) {
            navigationItems.push({ url: routeLinks_1.default.tenants, text: "Tenants" });
        }
        if (PermissionCheck_1.isAllowed({
            permission: [resources_1.Permission.FeedView, resources_1.Permission.LifecycleEdit, resources_1.Permission.VariableView, resources_1.Permission.ActionTemplateView, resources_1.Permission.CertificateView],
            wildcard: true
        })) {
            navigationItems.push({ url: routeLinks_1.default.library.root, text: "Library" });
        }
        if (PermissionCheck_1.isAllowed({ permission: resources_1.Permission.TaskView, wildcard: true })) {
            navigationItems.push({ url: routeLinks_1.default.tasks.root, text: "Tasks" });
        }
        if (PermissionCheck_1.isAllowed({ permission: [resources_1.Permission.AdministerSystem, resources_1.Permission.AuditView, resources_1.Permission.TeamView, resources_1.Permission.UserView, resources_1.Permission.UserRoleView] })) {
            navigationItems.push({ url: routeLinks_1.default.configuration.root, text: "Configuration" });
        }
        var addons = this.getAddons(isMultiTenancyEnabled);
        if (addons.length) {
            navigationItems.push({
                label: "Addons",
                children: addons
            });
        }
        if (environment_1.default.isInDevelopmentMode() && !eapIsHidden) {
            navigationItems.push({ url: routeLinks_1.default.styleGuide, text: "Style Guide [dev]" });
            navigationItems.push({ url: routeLinks_1.default.codeGuide, icon: React.createElement("em", { className: "fa fa-industry" }), text: "Code Guide [dev]" });
        }
        return navigationItems;
    };
    Navbar.prototype.getAddons = function (IsMultiTenancyEnabled) {
        var addons = [];
        if (!IsMultiTenancyEnabled && PermissionCheck_1.isAllowed({ permission: resources_1.Permission.TenantView, tenant: "*" })) {
            addons.push({ url: routeLinks_1.default.tenants, text: "Tenants" });
        }
        return addons;
    };
    return Navbar;
}(React.Component));
var mapStateToProps = function (state) {
    return {
        isMultiTenancyEnabled: state.configurationArea.features.isMultiTenancyEnabled
    };
};
// Unfortunately this component needs to be connected to the router purely so that it updates when the route changes.
// Otherwise, the connect() breaks all route-related updates.  This might be fixed in React 16.3 which should introduce the new context API
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps)(Navbar));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\Navbar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\Navbar.tsx"); } } })();

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ToolTip_1 = __webpack_require__(68);
var ExternalLink_1 = __webpack_require__(29);
var React = __webpack_require__(0);
var styles = __webpack_require__(245);
var clientInstance_1 = __webpack_require__(10);
var CloseButton_1 = __webpack_require__(537);
var EAPBar = (function (_super) {
    __extends(EAPBar, _super);
    function EAPBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isEarlyAccessProgram: false,
            isHidden: false,
            version: ""
        };
        return _this;
    }
    EAPBar.prototype.componentDidMount = function () {
        var root = clientInstance_1.repository.getRootDocument();
        var isEarlyAccessProgram = root.IsEarlyAccessProgram || false;
        var version = root.Version;
        this.setState({
            isEarlyAccessProgram: isEarlyAccessProgram,
            version: version
        });
    };
    EAPBar.prototype.onClose = function () {
        this.setState({ isHidden: true });
        this.props.onCloseClicked();
    };
    EAPBar.prototype.render = function () {
        var _this = this;
        if (!this.state.isEarlyAccessProgram || this.state.isHidden) {
            return null;
        }
        return React.createElement("div", { className: styles.eapBanner },
            React.createElement(ToolTip_1.default, { content: "Due to the unstable nature of EAP releases we do not recommend using them in production, or upgrading them to/from a production instance" },
                React.createElement(ExternalLink_1.default, { href: "WhatIsEAP", showIcon: false },
                    "EAP Release - v",
                    this.state.version)),
            React.createElement("div", { className: styles.closeEAPBanner },
                React.createElement(CloseButton_1.default, { onClose: function () { return _this.onClose(); } })));
    };
    return EAPBar;
}(React.Component));
exports.default = EAPBar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\EAPBar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\EAPBar.tsx"); } } })();

/***/ }),
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1TM0J{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__3TDiA{display:none!important}}@media (max-width:79.9rem){.style_hide-md__3CNCJ{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2JXiF{display:none!important}}.style_topnavbar__16z8s{width:100%;display:flex;flex-direction:column}.style_eapBanner__1pwaF{background-color:#fb8c00;color:#fff;font-size:.8125rem;height:1.5rem;display:flex;justify-content:center;align-items:center;font-weight:600}.style_eapBanner__1pwaF a,.style_eapBanner__1pwaF a:hover{color:#fff}.style_closeEAPBanner__bN6-l{position:absolute;right:0;top:-.75rem;height:auto}.style_navbar__3F4L7{height:3.125rem;background-color:#2f93e0;display:flex}.style_navbarLeft__3lP5L,.style_navbarRight__1sksi{display:flex;flex-direction:row;justify-content:flex-start;align-items:center;height:100%;flex-grow:0;flex-shrink:0}.style_navbarCenter__x3dqj{flex-grow:1;flex-shrink:1}.style_navbarCenter__x3dqj ul{height:100%;margin:0;display:flex}.style_navbarCenter__x3dqj ul li{display:inline-block;height:100%}.style_navbarCenter__x3dqj ul li a{cursor:pointer;height:100%;color:#fff;padding:0 1rem;display:flex;align-items:center;text-decoration:none}.style_navbarCenter__x3dqj ul li a:hover{background-color:#74c0fb;color:#fff}.style_navbarCenter__x3dqj ul li a:active,.style_navbarCenter__x3dqj ul li a:focus{background-color:#0a67b1}.style_navbarCenter__x3dqj ul li a em{font-size:1.0625rem;padding:0 .5rem}.style_navbarRight__1sksi{float:right}.style_button__25zsx{cursor:pointer;height:100%;color:#fff;padding:0 1rem;display:flex;align-items:center;text-decoration:none}.style_button__25zsx:hover{background-color:#74c0fb;color:#fff}.style_button__25zsx:active,.style_button__25zsx:focus,.style_navItemActive__2Qjuj{background-color:#0a67b1}.style_icon__lbPxK{font-size:1.0625rem;padding:0 .5rem}.style_spaceName__tLekJ,.style_userName__19kyn{text-align:left;vertical-align:middle;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-right:1rem;padding-left:.5rem;min-width:3rem}.style_spaceName__tLekJ{padding-left:.5rem}.style_navbarRight__1sksi>div{height:100%}@media (max-width:37.4rem){.style_navbar__3F4L7{height:2.5rem}.style_navbarRight__1sksi{margin-right:.5rem}.style_navbarLeft__3lP5L{margin-left:.5rem;margin-right:.5rem;float:none}.style_spaceButton__29TpN{flex-grow:2}.style_spaceName__tLekJ{width:100%}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1TM0J",
	"hideSm": "style_hide-sm__1TM0J",
	"visible-sm": "style_visible-sm__3TDiA",
	"visibleSm": "style_visible-sm__3TDiA",
	"hide-md": "style_hide-md__3CNCJ",
	"hideMd": "style_hide-md__3CNCJ",
	"visible-md": "style_visible-md__2JXiF",
	"visibleMd": "style_visible-md__2JXiF",
	"topnavbar": "style_topnavbar__16z8s",
	"eapBanner": "style_eapBanner__1pwaF",
	"closeEAPBanner": "style_closeEAPBanner__bN6-l",
	"closeEapBanner": "style_closeEAPBanner__bN6-l",
	"navbar": "style_navbar__3F4L7",
	"navbarLeft": "style_navbarLeft__3lP5L",
	"navbarRight": "style_navbarRight__1sksi",
	"navbarCenter": "style_navbarCenter__x3dqj",
	"button": "style_button__25zsx",
	"navItemActive": "style_navItemActive__2Qjuj",
	"icon": "style_icon__lbPxK",
	"userName": "style_userName__19kyn",
	"spaceName": "style_spaceName__tLekJ",
	"spaceButton": "style_spaceButton__29TpN"
};

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Popover_1 = __webpack_require__(220);
var FilterSearchBox_1 = __webpack_require__(287);
var clientInstance_1 = __webpack_require__(10);
var lodash_1 = __webpack_require__(16);
var styles = __webpack_require__(1385);
var BaseComponent_1 = __webpack_require__(14);
var routeLinks_1 = __webpack_require__(20);
var resources_1 = __webpack_require__(26);
var PermissionCheck_1 = __webpack_require__(45);
var react_virtualized_1 = __webpack_require__(438);
var FocustListItem_1 = __webpack_require__(624);
var InternalLink_1 = __webpack_require__(42);
var ProjectSwitcher = (function (_super) {
    __extends(ProjectSwitcher, _super);
    function ProjectSwitcher(props) {
        var _this = _super.call(this, props) || this;
        _this.onRowsRendered = function (_a) {
            var startIndex = _a.startIndex;
            _this.setState({ firstVisibleRow: startIndex });
        };
        _this.setSearchRef = function (el) {
            _this.searchRef = el;
        };
        _this.onRequestClose = function () {
            _this.setState({
                filter: "",
                focusedRow: -1
            });
            _this.props.onRequestClose();
        };
        _this.onKeyEsc = function (event) {
            if (event.key === "Escape") {
                _this.onRequestClose();
            }
        };
        _this.onArrowDown = function (event) {
            if (event.key === "ArrowDown" || event.key === "Tab") {
                if (_this.state.filteredList.length === 0) {
                    return;
                }
                _this.setState({ focusedRow: _this.state.firstVisibleRow });
                event.preventDefault();
            }
        };
        _this.onListKeyDown = function (event) {
            if (event.key === "ArrowDown" || (!event.shiftKey && event.key === "Tab")) {
                var lastIndex_1 = _this.state.filteredList.length - 1;
                _this.setState(function (prevState) {
                    return { focusedRow: prevState.focusedRow <= lastIndex_1 ? prevState.focusedRow + 1 : lastIndex_1 };
                });
                event.preventDefault();
            }
            if (event.key === "ArrowUp" || (event.shiftKey && event.key === "Tab")) {
                if (_this.state.focusedRow === 0) {
                    _this.searchRef.focus();
                    _this.setState({ focusedRow: -1 });
                }
                else {
                    _this.setState(function (prevState) {
                        return { focusedRow: prevState.focusedRow > 0 ? prevState.focusedRow - 1 : 0 };
                    });
                }
                event.preventDefault();
            }
        };
        _this.handleFilterChanged = function (val) {
            _this.setState({
                filteredList: _this.filteredList(_this.state.projects, val),
                filter: val
            });
        };
        _this.refreshProjects = _this.refreshProjects.bind(_this);
        _this.state = {
            filter: "",
            projects: [],
            filteredList: [],
            showGroup: false,
            firstVisibleRow: 0,
            focusedRow: -1
        };
        return _this;
    }
    ProjectSwitcher.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refreshProjects()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectSwitcher.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.open) {
            this.refreshProjects();
        }
    };
    ProjectSwitcher.prototype.render = function () {
        var _this = this;
        var list = this.state.filteredList;
        var virtualList = function () {
            var rowHeight = function (_a) {
                var index = _a.index;
                var height = _this.state.showGroup ? 72 : 48;
                var p = list[index];
                if (p.name.length > 43) {
                    height += 18;
                }
                return height;
            };
            var renderRow = function (_a) {
                var key = _a.key, index = _a.index, isVisible = _a.isVisible, style = _a.style;
                var p = list[index];
                return React.createElement(FocustListItem_1.default, { key: key, isFocused: index === _this.state.focusedRow, style: style, containerElement: React.createElement(InternalLink_1.default, { to: routeLinks_1.default.project(p.slug).root }), primaryText: p.name, secondaryText: p.group, onRequestClose: _this.onRequestClose });
            };
            return React.createElement(react_virtualized_1.AutoSizer, null, function (_a) {
                var height = _a.height, width = _a.width;
                return React.createElement("div", { onKeyDown: _this.onListKeyDown },
                    React.createElement(react_virtualized_1.List, { tabIndex: -1, height: height, rowCount: list.length, estimatedRowSize: _this.state.showGroup ? 72 : 48, rowHeight: rowHeight, onRowsRendered: _this.onRowsRendered, rowRenderer: function (_a) {
                            var index = _a.index, key = _a.key, isVisible = _a.isVisible, style = _a.style;
                            return renderRow({
                                index: index,
                                key: key,
                                isVisible: isVisible,
                                style: style
                            });
                        }, width: width }));
            });
        };
        return React.createElement(Popover_1.default, { open: this.props.open, anchorEl: this.props.anchorEl, onRequestClose: this.onRequestClose, anchorOrigin: { horizontal: "left", vertical: "bottom" }, targetOrigin: { horizontal: "left", vertical: "top" } },
            React.createElement("div", { className: styles.container, onKeyDown: this.onKeyEsc },
                this.state.projects.length === 0 && React.createElement("div", { className: styles.empty }, "There are no projects yet!"),
                this.state.projects.length > 0 && React.createElement("div", { className: styles.filter },
                    React.createElement(FilterSearchBox_1.default, { innerRef: this.setSearchRef, autoFocus: true, value: this.state.filter, hintText: "Jump to project...", onChange: this.handleFilterChanged, fullWidth: true, onKeyDown: this.onArrowDown, containerClassName: styles.filterFieldContainer })),
                React.createElement("div", { className: styles.menuContainer }, virtualList())));
    };
    ProjectSwitcher.prototype.filteredList = function (projects, filter) {
        var matchesFilter = function (n) { return n.toLowerCase().search(filter.toLowerCase()) !== -1; };
        return (filter.length > 0
            ? projects.filter(function (p) { return matchesFilter(p.name) || (p.group ? matchesFilter(p.group) : false); })
            : projects);
    };
    ProjectSwitcher.prototype.refreshProjects = function () {
        return __awaiter(this, void 0, void 0, function () {
            var projectResources, projectGroupMap, showGroup, groups, sortedProjects, projectGroup, projects;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.all()];
                    case 1:
                        projectResources = _a.sent();
                        projectGroupMap = null;
                        showGroup = false;
                        if (!PermissionCheck_1.isAllowed({ permission: resources_1.Permission.ProjectGroupView, projectGroup: "*" })) return [3 /*break*/, 3];
                        return [4 /*yield*/, clientInstance_1.repository.ProjectGroups.all()];
                    case 2:
                        groups = _a.sent();
                        if (groups.length > 1) {
                            showGroup = true;
                            projectGroupMap = lodash_1.keyBy(groups, "Id");
                        }
                        _a.label = 3;
                    case 3:
                        sortedProjects = lodash_1.sortBy(projectResources, function (p) { return p.Name.toLowerCase(); });
                        projectGroup = function (gId) {
                            return projectGroupMap.hasOwnProperty(gId) ? projectGroupMap[gId].Name : null;
                        };
                        projects = sortedProjects.map(function (p) { return ({
                            id: p.Id,
                            slug: p.Slug,
                            name: p.Name,
                            group: projectGroupMap ? projectGroup(p.ProjectGroupId) : null
                        }); });
                        this.setState({ projects: projects, filteredList: this.filteredList(projects, this.state.filter), showGroup: showGroup });
                        return [2 /*return*/];
                }
            });
        });
    };
    return ProjectSwitcher;
}(BaseComponent_1.BaseComponent));
exports.default = ProjectSwitcher;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\ProjectSwitcher.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\ProjectSwitcher.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var react_event_listener_1 = __webpack_require__(55);
var rowsHeight = 24;
function getStyles(props, context, state) {
    return {
        root: {
            position: 'relative',
        },
        textarea: {
            height: state.height,
            width: '100%',
            resize: 'none',
            font: 'inherit',
            padding: 0,
            cursor: 'inherit',
        },
        shadow: {
            resize: 'none',
            // Overflow also needed to here to remove the extra row
            // added to textareas in Firefox.
            overflow: 'hidden',
            // Visibility needed to hide the extra text area on ipads
            visibility: 'hidden',
            position: 'absolute',
            height: 'auto',
        },
    };
}
var EnhancedTextarea = (function (_super) {
    __extends(EnhancedTextarea, _super);
    function EnhancedTextarea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            height: null,
        };
        _this.handleResize = function (event) {
            _this.syncHeightWithShadow(_this.props.value, event);
        };
        _this.handleChange = function (event) {
            if (!_this.props.hasOwnProperty('value')) {
                _this.syncHeightWithShadow(event.target.value);
            }
            if (_this.props.hasOwnProperty('valueLink')) {
                _this.props.valueLink.requestChange(event.target.value);
            }
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
        };
        return _this;
    }
    EnhancedTextarea.prototype.componentWillMount = function () {
        this.setState({
            height: this.props.rows * rowsHeight,
        });
    };
    EnhancedTextarea.prototype.componentDidMount = function () {
        this.syncHeightWithShadow(this.props.value);
    };
    EnhancedTextarea.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== this.props.value ||
            nextProps.rowsMax !== this.props.rowsMax) {
            this.syncHeightWithShadow(nextProps.value, null, nextProps);
        }
    };
    EnhancedTextarea.prototype.getInputNode = function () {
        return this.refs.input;
    };
    EnhancedTextarea.prototype.setValue = function (value) {
        this.getInputNode().value = value;
        this.syncHeightWithShadow(value);
    };
    EnhancedTextarea.prototype.syncHeightWithShadow = function (newValue, event, props) {
        if (event === void 0) { event = undefined; }
        if (props === void 0) { props = undefined; }
        var shadow = this.refs.shadow;
        var displayText = this.props.hintText && (newValue === '' || newValue === undefined || newValue === null) ?
            this.props.hintText : newValue;
        if (displayText !== undefined) {
            shadow.value = displayText;
        }
        var newHeight = shadow.scrollHeight;
        // Guarding for jsdom, where scrollHeight isn't present.
        // See https://github.com/tmpvar/jsdom/issues/1013
        if (newHeight === undefined)
            return;
        props = props || this.props;
        if (props.rowsMax >= props.rows) {
            newHeight = Math.min(props.rowsMax * rowsHeight, newHeight);
        }
        newHeight = Math.max(newHeight, rowsHeight);
        if (this.state.height !== newHeight) {
            var input_1 = this.refs.input;
            var cursorPosition_1 = input_1.selectionStart;
            this.setState({
                height: newHeight,
            }, function () {
                if (input_1 === document.activeElement) {
                    input_1.setSelectionRange(cursorPosition_1, cursorPosition_1);
                }
            });
            if (props.onHeightChange) {
                props.onHeightChange(event, newHeight);
            }
        }
    };
    EnhancedTextarea.prototype.render = function () {
        var _a = this.props, onChange = _a.onChange, // eslint-disable-line no-unused-vars
        onHeightChange = _a.onHeightChange, // eslint-disable-line no-unused-vars
        rows = _a.rows, // eslint-disable-line no-unused-vars
        rowsMax = _a.rowsMax, // eslint-disable-line no-unused-vars
        shadowStyle = _a.shadowStyle, style = _a.style, hintText = _a.hintText, // eslint-disable-line no-unused-vars
        textareaStyle = _a.textareaStyle, valueLink = _a.valueLink, // eslint-disable-line no-unused-vars
        other = __rest(_a, ["onChange", "onHeightChange", "rows", "rowsMax", "shadowStyle", "style", "hintText", "textareaStyle", "valueLink"]);
        var prepareStyles = this.context.muiTheme.prepareStyles;
        var styles = getStyles(this.props, this.context, this.state);
        var rootStyles = Object.assign(styles.root, style);
        var textareaStyles = Object.assign(styles.textarea, textareaStyle);
        var shadowStyles = Object.assign({}, textareaStyles, styles.shadow, shadowStyle);
        if (this.props.hasOwnProperty('valueLink')) {
            other.value = this.props.valueLink.value;
        }
        return (React.createElement("div", { style: prepareStyles(rootStyles) },
            React.createElement(react_event_listener_1.default, { target: "window", onResize: this.handleResize }),
            React.createElement("textarea", { ref: "shadow", style: prepareStyles(shadowStyles), tabIndex: -1, rows: this.props.rows, defaultValue: this.props.defaultValue, readOnly: true, value: this.props.value }),
            React.createElement("textarea", __assign({}, other, { ref: "input", rows: this.props.rows, style: prepareStyles(textareaStyles), onChange: this.handleChange }))));
    };
    EnhancedTextarea.propTypes = {
        defaultValue: PropTypes.any,
        disabled: PropTypes.bool,
        hintText: PropTypes.node,
        onChange: PropTypes.func,
        onHeightChange: PropTypes.func,
        rows: PropTypes.number,
        rowsMax: PropTypes.number,
        shadowStyle: PropTypes.object,
        /**
         * Override the inline-styles of the root element.
         */
        style: PropTypes.object,
        textareaStyle: PropTypes.object,
        value: PropTypes.string,
        valueLink: PropTypes.object,
    };
    EnhancedTextarea.defaultProps = {
        rows: 1,
    };
    EnhancedTextarea.contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    return EnhancedTextarea;
}(React.Component));
exports.default = EnhancedTextarea;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Text\\EnhancedTextarea.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Text\\EnhancedTextarea.tsx"); } } })();

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1365);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@font-face{font-family:Roboto;src:url(" + __webpack_require__(403) + ");font-weight:400}@font-face{font-family:Roboto;src:url(" + __webpack_require__(404) + ");font-weight:400;font-style:italic}@font-face{font-family:Roboto;src:url(" + __webpack_require__(405) + ");font-weight:300}@font-face{font-family:Roboto;src:url(" + __webpack_require__(406) + ");font-weight:500}@font-face{font-family:Roboto;src:url(" + __webpack_require__(407) + ");font-weight:600}@font-face{font-family:fontoctopus;src:url(" + __webpack_require__(210) + ");src:url(" + __webpack_require__(210) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(408) + ") format(\"woff\"),url(" + __webpack_require__(409) + ") format(\"truetype\"),url(" + __webpack_require__(410) + ") format(\"svg\");font-weight:400;font-style:normal}.style_fontoctopus-octopus__2N8AD{display:inline-block;font:normal normal normal 1em fontoctopus;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;speak:none}.style_fontoctopus-octopus__2N8AD:before{content:\"\\E800\"}/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(411) + ");src:url(" + __webpack_require__(412) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + __webpack_require__(413) + ") format(\"woff2\"),url(" + __webpack_require__(414) + ") format(\"woff\"),url(" + __webpack_require__(415) + ") format(\"truetype\"),url(" + __webpack_require__(416) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.style_fa__2Stzz{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.style_fa-lg__1bG3h{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.style_fa-2x__2_hqT{font-size:2em}.style_fa-3x__Stup6{font-size:3em}.style_fa-4x___nR0M{font-size:4em}.style_fa-5x__vUgdf{font-size:5em}.style_fa-fw__1jESs{width:1.28571429em;text-align:center}.style_fa-ul__22z2m{padding-left:0;margin-left:2.14285714em;list-style-type:none}.style_fa-ul__22z2m>li{position:relative}.style_fa-li__1xMKd{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.style_fa-li__1xMKd.style_fa-lg__1bG3h{left:-1.85714286em}.style_fa-border__N_IDS{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.style_fa-pull-left__19hOZ{float:left}.style_fa-pull-right__1IGi0{float:right}.style_fa__2Stzz.style_fa-pull-left__19hOZ{margin-right:.3em}.style_fa__2Stzz.style_fa-pull-right__1IGi0{margin-left:.3em}.style_pull-right__Ekb6T{float:right}.style_pull-left__6kkds{float:left}.style_fa__2Stzz.style_pull-left__6kkds{margin-right:.3em}.style_fa__2Stzz.style_pull-right__Ekb6T{margin-left:.3em}.style_fa-spin__3OLtN{-webkit-animation:style_fa-spin__3OLtN 2s infinite linear;animation:style_fa-spin__3OLtN 2s infinite linear}.style_fa-pulse__3YIU7{-webkit-animation:style_fa-spin__3OLtN 1s infinite steps(8);animation:style_fa-spin__3OLtN 1s infinite steps(8)}@-webkit-keyframes style_fa-spin__3OLtN{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes style_fa-spin__3OLtN{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.style_fa-rotate-90__V_q9A{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.style_fa-rotate-180__AlfVc{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.style_fa-rotate-270__zfwx-{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.style_fa-flip-horizontal__SlkBZ{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.style_fa-flip-vertical__oocW6{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}:root .style_fa-flip-horizontal__SlkBZ,:root .style_fa-flip-vertical__oocW6,:root .style_fa-rotate-90__V_q9A,:root .style_fa-rotate-180__AlfVc,:root .style_fa-rotate-270__zfwx-{filter:none}.style_fa-stack__2CYwt{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.style_fa-stack-1x__1VBdj,.style_fa-stack-2x__3ku48{position:absolute;left:0;width:100%;text-align:center}.style_fa-stack-1x__1VBdj{line-height:inherit}.style_fa-stack-2x__3ku48{font-size:2em}.style_fa-inverse__1m291{color:#fff}.style_fa-glass__16k7J:before{content:\"\\F000\"}.style_fa-music__kkflz:before{content:\"\\F001\"}.style_fa-search__qCxf9:before{content:\"\\F002\"}.style_fa-envelope-o__xXTWd:before{content:\"\\F003\"}.style_fa-heart__3Ug_1:before{content:\"\\F004\"}.style_fa-star__3N6qV:before{content:\"\\F005\"}.style_fa-star-o__2CD-u:before{content:\"\\F006\"}.style_fa-user__3khUP:before{content:\"\\F007\"}.style_fa-film__gBI0K:before{content:\"\\F008\"}.style_fa-th-large__2fszA:before{content:\"\\F009\"}.style_fa-th__2awmn:before{content:\"\\F00A\"}.style_fa-th-list__2FtcN:before{content:\"\\F00B\"}.style_fa-check__3AIyn:before{content:\"\\F00C\"}.style_fa-close__1knvb:before,.style_fa-remove__3cnS0:before,.style_fa-times__3yoPt:before{content:\"\\F00D\"}.style_fa-search-plus__33Lij:before{content:\"\\F00E\"}.style_fa-search-minus__2yHac:before{content:\"\\F010\"}.style_fa-power-off__3QfoZ:before{content:\"\\F011\"}.style_fa-signal__2LNOs:before{content:\"\\F012\"}.style_fa-cog__2S0eu:before,.style_fa-gear__1aqXg:before{content:\"\\F013\"}.style_fa-trash-o__Jy4Qd:before{content:\"\\F014\"}.style_fa-home__2aA7l:before{content:\"\\F015\"}.style_fa-file-o__2XOwD:before{content:\"\\F016\"}.style_fa-clock-o__2WKaF:before{content:\"\\F017\"}.style_fa-road__2emGR:before{content:\"\\F018\"}.style_fa-download__2Jf5l:before{content:\"\\F019\"}.style_fa-arrow-circle-o-down__1zZ7Q:before{content:\"\\F01A\"}.style_fa-arrow-circle-o-up__KMZ50:before{content:\"\\F01B\"}.style_fa-inbox__3BPi6:before{content:\"\\F01C\"}.style_fa-play-circle-o__1PlJd:before{content:\"\\F01D\"}.style_fa-repeat__2EtMa:before,.style_fa-rotate-right__1U5RB:before{content:\"\\F01E\"}.style_fa-refresh__1BjiR:before{content:\"\\F021\"}.style_fa-list-alt__2UUVE:before{content:\"\\F022\"}.style_fa-lock__2AxqE:before{content:\"\\F023\"}.style_fa-flag__1u53R:before{content:\"\\F024\"}.style_fa-headphones__3Yhkq:before{content:\"\\F025\"}.style_fa-volume-off__3LfY-:before{content:\"\\F026\"}.style_fa-volume-down__1JuvK:before{content:\"\\F027\"}.style_fa-volume-up__3rdlp:before{content:\"\\F028\"}.style_fa-qrcode__2UZke:before{content:\"\\F029\"}.style_fa-barcode__3NqNI:before{content:\"\\F02A\"}.style_fa-tag__2O9hk:before{content:\"\\F02B\"}.style_fa-tags__-8Rh_:before{content:\"\\F02C\"}.style_fa-book__3Nk-f:before{content:\"\\F02D\"}.style_fa-bookmark__3qaOT:before{content:\"\\F02E\"}.style_fa-print__YyG1f:before{content:\"\\F02F\"}.style_fa-camera__aUjmZ:before{content:\"\\F030\"}.style_fa-font__gGxlk:before{content:\"\\F031\"}.style_fa-bold__ks_J4:before{content:\"\\F032\"}.style_fa-italic__20ogU:before{content:\"\\F033\"}.style_fa-text-height___0LQ7:before{content:\"\\F034\"}.style_fa-text-width__jeOjf:before{content:\"\\F035\"}.style_fa-align-left__22Zw8:before{content:\"\\F036\"}.style_fa-align-center__3Iq_1:before{content:\"\\F037\"}.style_fa-align-right__Eka7e:before{content:\"\\F038\"}.style_fa-align-justify__pARZF:before{content:\"\\F039\"}.style_fa-list__1OD3U:before{content:\"\\F03A\"}.style_fa-dedent__YI-PY:before,.style_fa-outdent__Q3A49:before{content:\"\\F03B\"}.style_fa-indent__1jwPG:before{content:\"\\F03C\"}.style_fa-video-camera__3zM_P:before{content:\"\\F03D\"}.style_fa-image__1Zij8:before,.style_fa-photo__12fAw:before,.style_fa-picture-o__2kh9I:before{content:\"\\F03E\"}.style_fa-pencil__SPg_-:before{content:\"\\F040\"}.style_fa-map-marker__2B57R:before{content:\"\\F041\"}.style_fa-adjust__22duV:before{content:\"\\F042\"}.style_fa-tint__2hInd:before{content:\"\\F043\"}.style_fa-edit__2hUlG:before,.style_fa-pencil-square-o__E9ibP:before{content:\"\\F044\"}.style_fa-share-square-o__2RDHE:before{content:\"\\F045\"}.style_fa-check-square-o__2K-Dz:before{content:\"\\F046\"}.style_fa-arrows__35WFl:before{content:\"\\F047\"}.style_fa-step-backward__1CcyE:before{content:\"\\F048\"}.style_fa-fast-backward__1Blqo:before{content:\"\\F049\"}.style_fa-backward__3e-fg:before{content:\"\\F04A\"}.style_fa-play__ETJ_t:before{content:\"\\F04B\"}.style_fa-pause__3ro_2:before{content:\"\\F04C\"}.style_fa-stop__3ZrVE:before{content:\"\\F04D\"}.style_fa-forward__38fYD:before{content:\"\\F04E\"}.style_fa-fast-forward__12ERo:before{content:\"\\F050\"}.style_fa-step-forward__1HhqA:before{content:\"\\F051\"}.style_fa-eject__3iYgQ:before{content:\"\\F052\"}.style_fa-chevron-left__3n6Ih:before{content:\"\\F053\"}.style_fa-chevron-right__17qWa:before{content:\"\\F054\"}.style_fa-plus-circle__1_Hd6:before{content:\"\\F055\"}.style_fa-minus-circle__2lFkp:before{content:\"\\F056\"}.style_fa-times-circle__3sN8j:before{content:\"\\F057\"}.style_fa-check-circle__2wkS0:before{content:\"\\F058\"}.style_fa-question-circle__2fk1Y:before{content:\"\\F059\"}.style_fa-info-circle__2gaYm:before{content:\"\\F05A\"}.style_fa-crosshairs__1LEU-:before{content:\"\\F05B\"}.style_fa-times-circle-o__2TSHm:before{content:\"\\F05C\"}.style_fa-check-circle-o__3WaoE:before{content:\"\\F05D\"}.style_fa-ban__2Qhpz:before{content:\"\\F05E\"}.style_fa-arrow-left__1Tt32:before{content:\"\\F060\"}.style_fa-arrow-right__1FESc:before{content:\"\\F061\"}.style_fa-arrow-up__3wcyR:before{content:\"\\F062\"}.style_fa-arrow-down__3Mskv:before{content:\"\\F063\"}.style_fa-mail-forward__2NDhk:before,.style_fa-share__3l_NS:before{content:\"\\F064\"}.style_fa-expand__3GAJ3:before{content:\"\\F065\"}.style_fa-compress__2wbOP:before{content:\"\\F066\"}.style_fa-plus__22pw4:before{content:\"\\F067\"}.style_fa-minus__poN8Q:before{content:\"\\F068\"}.style_fa-asterisk__33jbA:before{content:\"\\F069\"}.style_fa-exclamation-circle__1xJgn:before{content:\"\\F06A\"}.style_fa-gift__3nKN8:before{content:\"\\F06B\"}.style_fa-leaf__FnNeM:before{content:\"\\F06C\"}.style_fa-fire__iabFV:before{content:\"\\F06D\"}.style_fa-eye__zJEkG:before{content:\"\\F06E\"}.style_fa-eye-slash__2bjSj:before{content:\"\\F070\"}.style_fa-exclamation-triangle__1FI1o:before,.style_fa-warning__3f1BB:before{content:\"\\F071\"}.style_fa-plane__r9HNn:before{content:\"\\F072\"}.style_fa-calendar__1lGhc:before{content:\"\\F073\"}.style_fa-random__3oSfN:before{content:\"\\F074\"}.style_fa-comment__1XcXN:before{content:\"\\F075\"}.style_fa-magnet__3Ra7v:before{content:\"\\F076\"}.style_fa-chevron-up__1IJay:before{content:\"\\F077\"}.style_fa-chevron-down__3VgR7:before{content:\"\\F078\"}.style_fa-retweet__3bBmk:before{content:\"\\F079\"}.style_fa-shopping-cart__wsIiy:before{content:\"\\F07A\"}.style_fa-folder__3pZY8:before{content:\"\\F07B\"}.style_fa-folder-open__2e7-y:before{content:\"\\F07C\"}.style_fa-arrows-v__3lYN9:before{content:\"\\F07D\"}.style_fa-arrows-h__2AKrb:before{content:\"\\F07E\"}.style_fa-bar-chart-o__1N0Fi:before,.style_fa-bar-chart__2GC9g:before{content:\"\\F080\"}.style_fa-twitter-square__25459:before{content:\"\\F081\"}.style_fa-facebook-square__34MaH:before{content:\"\\F082\"}.style_fa-camera-retro__3UpEF:before{content:\"\\F083\"}.style_fa-key__PomoZ:before{content:\"\\F084\"}.style_fa-cogs__2mWvc:before,.style_fa-gears__3bHU8:before{content:\"\\F085\"}.style_fa-comments__1TsY2:before{content:\"\\F086\"}.style_fa-thumbs-o-up__CdiXO:before{content:\"\\F087\"}.style_fa-thumbs-o-down__z4NN5:before{content:\"\\F088\"}.style_fa-star-half__Iest8:before{content:\"\\F089\"}.style_fa-heart-o__2m_lH:before{content:\"\\F08A\"}.style_fa-sign-out__1lcQa:before{content:\"\\F08B\"}.style_fa-linkedin-square__3kZOS:before{content:\"\\F08C\"}.style_fa-thumb-tack__1o_WC:before{content:\"\\F08D\"}.style_fa-external-link__1PHHE:before{content:\"\\F08E\"}.style_fa-sign-in__1qcVV:before{content:\"\\F090\"}.style_fa-trophy__3_XYL:before{content:\"\\F091\"}.style_fa-github-square__2Ylwu:before{content:\"\\F092\"}.style_fa-upload__1fS8f:before{content:\"\\F093\"}.style_fa-lemon-o__2eZyK:before{content:\"\\F094\"}.style_fa-phone__3YoRI:before{content:\"\\F095\"}.style_fa-square-o__1N8kv:before{content:\"\\F096\"}.style_fa-bookmark-o__jfvFO:before{content:\"\\F097\"}.style_fa-phone-square__3ZRc_:before{content:\"\\F098\"}.style_fa-twitter__2yG2o:before{content:\"\\F099\"}.style_fa-facebook-f__2lRUc:before,.style_fa-facebook__32LSL:before{content:\"\\F09A\"}.style_fa-github__2Ke1H:before{content:\"\\F09B\"}.style_fa-unlock__3LTVN:before{content:\"\\F09C\"}.style_fa-credit-card__17tW0:before{content:\"\\F09D\"}.style_fa-feed__2gj0C:before,.style_fa-rss__2TJ7S:before{content:\"\\F09E\"}.style_fa-hdd-o__3p7M9:before{content:\"\\F0A0\"}.style_fa-bullhorn__2nBQr:before{content:\"\\F0A1\"}.style_fa-bell__xhSCD:before{content:\"\\F0F3\"}.style_fa-certificate__1UjXn:before{content:\"\\F0A3\"}.style_fa-hand-o-right__170tV:before{content:\"\\F0A4\"}.style_fa-hand-o-left__1bZCj:before{content:\"\\F0A5\"}.style_fa-hand-o-up__FOPJs:before{content:\"\\F0A6\"}.style_fa-hand-o-down__3EtW7:before{content:\"\\F0A7\"}.style_fa-arrow-circle-left__4Si1c:before{content:\"\\F0A8\"}.style_fa-arrow-circle-right__o2B_F:before{content:\"\\F0A9\"}.style_fa-arrow-circle-up__1t6C_:before{content:\"\\F0AA\"}.style_fa-arrow-circle-down__2JhhB:before{content:\"\\F0AB\"}.style_fa-globe__25Cen:before{content:\"\\F0AC\"}.style_fa-wrench__258HL:before{content:\"\\F0AD\"}.style_fa-tasks__2oxZT:before{content:\"\\F0AE\"}.style_fa-filter__3HM1H:before{content:\"\\F0B0\"}.style_fa-briefcase__2JNBT:before{content:\"\\F0B1\"}.style_fa-arrows-alt__1sD0o:before{content:\"\\F0B2\"}.style_fa-group__20X3W:before,.style_fa-users__1Wv4i:before{content:\"\\F0C0\"}.style_fa-chain__3gkVR:before,.style_fa-link__15zB7:before{content:\"\\F0C1\"}.style_fa-cloud__1Ddfl:before{content:\"\\F0C2\"}.style_fa-flask__1wJvc:before{content:\"\\F0C3\"}.style_fa-cut___XyZV:before,.style_fa-scissors__AYHcI:before{content:\"\\F0C4\"}.style_fa-copy__1Ossh:before,.style_fa-files-o__3sJJ-:before{content:\"\\F0C5\"}.style_fa-paperclip__1hTCr:before{content:\"\\F0C6\"}.style_fa-floppy-o__2TnBm:before,.style_fa-save__1LOCv:before{content:\"\\F0C7\"}.style_fa-square__28Zx1:before{content:\"\\F0C8\"}.style_fa-bars__Wlajt:before,.style_fa-navicon__1X1U8:before,.style_fa-reorder__18Czt:before{content:\"\\F0C9\"}.style_fa-list-ul__2D7G5:before{content:\"\\F0CA\"}.style_fa-list-ol__C0x7T:before{content:\"\\F0CB\"}.style_fa-strikethrough__3t6ML:before{content:\"\\F0CC\"}.style_fa-underline__1SFb4:before{content:\"\\F0CD\"}.style_fa-table__19Se0:before{content:\"\\F0CE\"}.style_fa-magic___i3Nz:before{content:\"\\F0D0\"}.style_fa-truck__ZtSgC:before{content:\"\\F0D1\"}.style_fa-pinterest__22id1:before{content:\"\\F0D2\"}.style_fa-pinterest-square__369gS:before{content:\"\\F0D3\"}.style_fa-google-plus-square__hBjwt:before{content:\"\\F0D4\"}.style_fa-google-plus__3y50_:before{content:\"\\F0D5\"}.style_fa-money__1Qjqs:before{content:\"\\F0D6\"}.style_fa-caret-down__2x_8t:before{content:\"\\F0D7\"}.style_fa-caret-up__26GUW:before{content:\"\\F0D8\"}.style_fa-caret-left__irqU0:before{content:\"\\F0D9\"}.style_fa-caret-right__P8lmz:before{content:\"\\F0DA\"}.style_fa-columns__2tlq9:before{content:\"\\F0DB\"}.style_fa-sort__OJrdh:before,.style_fa-unsorted__1Kqx5:before{content:\"\\F0DC\"}.style_fa-sort-desc__2XfG6:before,.style_fa-sort-down__1Ru3s:before{content:\"\\F0DD\"}.style_fa-sort-asc__U5a_d:before,.style_fa-sort-up__24qNy:before{content:\"\\F0DE\"}.style_fa-envelope__1AvyZ:before{content:\"\\F0E0\"}.style_fa-linkedin__reVK3:before{content:\"\\F0E1\"}.style_fa-rotate-left__1KZgM:before,.style_fa-undo__3TtfA:before{content:\"\\F0E2\"}.style_fa-gavel__6RQAi:before,.style_fa-legal__3kLMa:before{content:\"\\F0E3\"}.style_fa-dashboard__2DuDP:before,.style_fa-tachometer__1cwGN:before{content:\"\\F0E4\"}.style_fa-comment-o__1JPzx:before{content:\"\\F0E5\"}.style_fa-comments-o__1bL7J:before{content:\"\\F0E6\"}.style_fa-bolt__2jVjr:before,.style_fa-flash__3nAJC:before{content:\"\\F0E7\"}.style_fa-sitemap__3DNmq:before{content:\"\\F0E8\"}.style_fa-umbrella__O7zIG:before{content:\"\\F0E9\"}.style_fa-clipboard__1gVaK:before,.style_fa-paste__1DC1m:before{content:\"\\F0EA\"}.style_fa-lightbulb-o__rfE_N:before{content:\"\\F0EB\"}.style_fa-exchange__32Bx_:before{content:\"\\F0EC\"}.style_fa-cloud-download__3HJaV:before{content:\"\\F0ED\"}.style_fa-cloud-upload__2mTgC:before{content:\"\\F0EE\"}.style_fa-user-md__2an77:before{content:\"\\F0F0\"}.style_fa-stethoscope__1Vpz0:before{content:\"\\F0F1\"}.style_fa-suitcase__3CTJq:before{content:\"\\F0F2\"}.style_fa-bell-o__zcNr6:before{content:\"\\F0A2\"}.style_fa-coffee__2sCU6:before{content:\"\\F0F4\"}.style_fa-cutlery__3Ya5Y:before{content:\"\\F0F5\"}.style_fa-file-text-o__20xzO:before{content:\"\\F0F6\"}.style_fa-building-o__2YAYY:before{content:\"\\F0F7\"}.style_fa-hospital-o__2nAdh:before{content:\"\\F0F8\"}.style_fa-ambulance__367f4:before{content:\"\\F0F9\"}.style_fa-medkit__2umfr:before{content:\"\\F0FA\"}.style_fa-fighter-jet__1XQZm:before{content:\"\\F0FB\"}.style_fa-beer__3F4Fo:before{content:\"\\F0FC\"}.style_fa-h-square__3UZBQ:before{content:\"\\F0FD\"}.style_fa-plus-square__2pCA8:before{content:\"\\F0FE\"}.style_fa-angle-double-left__34cFJ:before{content:\"\\F100\"}.style_fa-angle-double-right__sfWlQ:before{content:\"\\F101\"}.style_fa-angle-double-up__XjAIq:before{content:\"\\F102\"}.style_fa-angle-double-down__2eg81:before{content:\"\\F103\"}.style_fa-angle-left__DUgjE:before{content:\"\\F104\"}.style_fa-angle-right__3V_P0:before{content:\"\\F105\"}.style_fa-angle-up__2csFP:before{content:\"\\F106\"}.style_fa-angle-down__1gNw4:before{content:\"\\F107\"}.style_fa-desktop__2xX4m:before{content:\"\\F108\"}.style_fa-laptop__3MT5H:before{content:\"\\F109\"}.style_fa-tablet__1JL66:before{content:\"\\F10A\"}.style_fa-mobile-phone__32S3m:before,.style_fa-mobile__1pbSy:before{content:\"\\F10B\"}.style_fa-circle-o__1Yyd-:before{content:\"\\F10C\"}.style_fa-quote-left__DjQVx:before{content:\"\\F10D\"}.style_fa-quote-right__1mvs9:before{content:\"\\F10E\"}.style_fa-spinner__3HVZk:before{content:\"\\F110\"}.style_fa-circle__2snKq:before{content:\"\\F111\"}.style_fa-mail-reply__2AC6z:before,.style_fa-reply__3G6Se:before{content:\"\\F112\"}.style_fa-github-alt__x_v-T:before{content:\"\\F113\"}.style_fa-folder-o__2VA-0:before{content:\"\\F114\"}.style_fa-folder-open-o__3RqaW:before{content:\"\\F115\"}.style_fa-smile-o__3KiYu:before{content:\"\\F118\"}.style_fa-frown-o__3H7-N:before{content:\"\\F119\"}.style_fa-meh-o__3-bgG:before{content:\"\\F11A\"}.style_fa-gamepad__mPyU7:before{content:\"\\F11B\"}.style_fa-keyboard-o__wAOHk:before{content:\"\\F11C\"}.style_fa-flag-o__321XR:before{content:\"\\F11D\"}.style_fa-flag-checkered__2VtGO:before{content:\"\\F11E\"}.style_fa-terminal__1fUHJ:before{content:\"\\F120\"}.style_fa-code__SRKGP:before{content:\"\\F121\"}.style_fa-mail-reply-all__Lz9Ih:before,.style_fa-reply-all__1t63J:before{content:\"\\F122\"}.style_fa-star-half-empty__19XZq:before,.style_fa-star-half-full__3Y45l:before,.style_fa-star-half-o__a-5to:before{content:\"\\F123\"}.style_fa-location-arrow__2qgJ1:before{content:\"\\F124\"}.style_fa-crop__2OK7-:before{content:\"\\F125\"}.style_fa-code-fork__1WC5P:before{content:\"\\F126\"}.style_fa-chain-broken__UtNIl:before,.style_fa-unlink__2vPUr:before{content:\"\\F127\"}.style_fa-question__3Y6e1:before{content:\"\\F128\"}.style_fa-info__1YJhf:before{content:\"\\F129\"}.style_fa-exclamation__1gQg6:before{content:\"\\F12A\"}.style_fa-superscript__2w6Zr:before{content:\"\\F12B\"}.style_fa-subscript__14RTM:before{content:\"\\F12C\"}.style_fa-eraser__S3iJb:before{content:\"\\F12D\"}.style_fa-puzzle-piece__199HV:before{content:\"\\F12E\"}.style_fa-microphone__27dax:before{content:\"\\F130\"}.style_fa-microphone-slash__3oZE7:before{content:\"\\F131\"}.style_fa-shield__3DkNX:before{content:\"\\F132\"}.style_fa-calendar-o__S43Cp:before{content:\"\\F133\"}.style_fa-fire-extinguisher__pDFqQ:before{content:\"\\F134\"}.style_fa-rocket__35oGO:before{content:\"\\F135\"}.style_fa-maxcdn__fFV60:before{content:\"\\F136\"}.style_fa-chevron-circle-left__3Ylxn:before{content:\"\\F137\"}.style_fa-chevron-circle-right__3cfR0:before{content:\"\\F138\"}.style_fa-chevron-circle-up__1NCOc:before{content:\"\\F139\"}.style_fa-chevron-circle-down__1ZTjz:before{content:\"\\F13A\"}.style_fa-html5__2AmMy:before{content:\"\\F13B\"}.style_fa-css3__197Tg:before{content:\"\\F13C\"}.style_fa-anchor__CwQXw:before{content:\"\\F13D\"}.style_fa-unlock-alt__33y20:before{content:\"\\F13E\"}.style_fa-bullseye__3Fzdl:before{content:\"\\F140\"}.style_fa-ellipsis-h__1xO9Y:before{content:\"\\F141\"}.style_fa-ellipsis-v__DGE5R:before{content:\"\\F142\"}.style_fa-rss-square__1EZtw:before{content:\"\\F143\"}.style_fa-play-circle__1UNzy:before{content:\"\\F144\"}.style_fa-ticket__2Hhzi:before{content:\"\\F145\"}.style_fa-minus-square__3rxP2:before{content:\"\\F146\"}.style_fa-minus-square-o__3Qd79:before{content:\"\\F147\"}.style_fa-level-up__3W8ml:before{content:\"\\F148\"}.style_fa-level-down__2hdzw:before{content:\"\\F149\"}.style_fa-check-square__PXToN:before{content:\"\\F14A\"}.style_fa-pencil-square__3BxAj:before{content:\"\\F14B\"}.style_fa-external-link-square__1BIFy:before{content:\"\\F14C\"}.style_fa-share-square__1V1tB:before{content:\"\\F14D\"}.style_fa-compass__2SPjB:before{content:\"\\F14E\"}.style_fa-caret-square-o-down__2E4Mb:before,.style_fa-toggle-down__3JopC:before{content:\"\\F150\"}.style_fa-caret-square-o-up__1VOkN:before,.style_fa-toggle-up__1vJD0:before{content:\"\\F151\"}.style_fa-caret-square-o-right__2U1ay:before,.style_fa-toggle-right__1vs4i:before{content:\"\\F152\"}.style_fa-eur__3MXW5:before,.style_fa-euro__1jXcx:before{content:\"\\F153\"}.style_fa-gbp__2Ps1g:before{content:\"\\F154\"}.style_fa-dollar__3Pc9r:before,.style_fa-usd__3Iq-9:before{content:\"\\F155\"}.style_fa-inr__XhhvZ:before,.style_fa-rupee__1NZ0t:before{content:\"\\F156\"}.style_fa-cny__2vF4f:before,.style_fa-jpy__6ngge:before,.style_fa-rmb__14IpQ:before,.style_fa-yen__3rbpG:before{content:\"\\F157\"}.style_fa-rouble__2UTPI:before,.style_fa-rub__3PmCg:before,.style_fa-ruble__1MHOp:before{content:\"\\F158\"}.style_fa-krw__11g7e:before,.style_fa-won__1buvn:before{content:\"\\F159\"}.style_fa-bitcoin__1Pk94:before,.style_fa-btc__3b4vn:before{content:\"\\F15A\"}.style_fa-file__3PW0K:before{content:\"\\F15B\"}.style_fa-file-text__1i0b9:before{content:\"\\F15C\"}.style_fa-sort-alpha-asc__3Wl8L:before{content:\"\\F15D\"}.style_fa-sort-alpha-desc__X0x0e:before{content:\"\\F15E\"}.style_fa-sort-amount-asc__2VAur:before{content:\"\\F160\"}.style_fa-sort-amount-desc__3wj0k:before{content:\"\\F161\"}.style_fa-sort-numeric-asc__2roSh:before{content:\"\\F162\"}.style_fa-sort-numeric-desc__1qZDn:before{content:\"\\F163\"}.style_fa-thumbs-up__1Wg1I:before{content:\"\\F164\"}.style_fa-thumbs-down__2xAxS:before{content:\"\\F165\"}.style_fa-youtube-square__3nFIw:before{content:\"\\F166\"}.style_fa-youtube__31ODZ:before{content:\"\\F167\"}.style_fa-xing__27cX2:before{content:\"\\F168\"}.style_fa-xing-square__35esg:before{content:\"\\F169\"}.style_fa-youtube-play__2C5gj:before{content:\"\\F16A\"}.style_fa-dropbox__1d8d4:before{content:\"\\F16B\"}.style_fa-stack-overflow__2GZ-H:before{content:\"\\F16C\"}.style_fa-instagram__3fb9Q:before{content:\"\\F16D\"}.style_fa-flickr__WhIVy:before{content:\"\\F16E\"}.style_fa-adn__3-Z8l:before{content:\"\\F170\"}.style_fa-bitbucket__CbNjZ:before{content:\"\\F171\"}.style_fa-bitbucket-square__t0VxH:before{content:\"\\F172\"}.style_fa-tumblr__2_oM_:before{content:\"\\F173\"}.style_fa-tumblr-square__3F7CC:before{content:\"\\F174\"}.style_fa-long-arrow-down__2oVs-:before{content:\"\\F175\"}.style_fa-long-arrow-up__bklzU:before{content:\"\\F176\"}.style_fa-long-arrow-left__3APTL:before{content:\"\\F177\"}.style_fa-long-arrow-right__21tW8:before{content:\"\\F178\"}.style_fa-apple__1wtga:before{content:\"\\F179\"}.style_fa-windows__19Xi6:before{content:\"\\F17A\"}.style_fa-android__2vJKQ:before{content:\"\\F17B\"}.style_fa-linux__1dLmz:before{content:\"\\F17C\"}.style_fa-dribbble__ZWptF:before{content:\"\\F17D\"}.style_fa-skype__27gQr:before{content:\"\\F17E\"}.style_fa-foursquare__3QNVL:before{content:\"\\F180\"}.style_fa-trello__2sbpV:before{content:\"\\F181\"}.style_fa-female__2gRF2:before{content:\"\\F182\"}.style_fa-male__1CNvk:before{content:\"\\F183\"}.style_fa-gittip__mo97w:before,.style_fa-gratipay__3YS56:before{content:\"\\F184\"}.style_fa-sun-o__2iTX9:before{content:\"\\F185\"}.style_fa-moon-o__1SqMg:before{content:\"\\F186\"}.style_fa-archive__3VLlT:before{content:\"\\F187\"}.style_fa-bug__2fFru:before{content:\"\\F188\"}.style_fa-vk__3KpkN:before{content:\"\\F189\"}.style_fa-weibo__2RfmV:before{content:\"\\F18A\"}.style_fa-renren__1QDdr:before{content:\"\\F18B\"}.style_fa-pagelines__fm95T:before{content:\"\\F18C\"}.style_fa-stack-exchange__2qfzD:before{content:\"\\F18D\"}.style_fa-arrow-circle-o-right__K7ffa:before{content:\"\\F18E\"}.style_fa-arrow-circle-o-left__3EN-J:before{content:\"\\F190\"}.style_fa-caret-square-o-left__3gHuI:before,.style_fa-toggle-left__2etkD:before{content:\"\\F191\"}.style_fa-dot-circle-o__1QlOs:before{content:\"\\F192\"}.style_fa-wheelchair__3DlnR:before{content:\"\\F193\"}.style_fa-vimeo-square__2QJq0:before{content:\"\\F194\"}.style_fa-try__B8huM:before,.style_fa-turkish-lira__uIPlz:before{content:\"\\F195\"}.style_fa-plus-square-o__15P7a:before{content:\"\\F196\"}.style_fa-space-shuttle__zzUXH:before{content:\"\\F197\"}.style_fa-slack__1WXhk:before{content:\"\\F198\"}.style_fa-envelope-square__3j9ps:before{content:\"\\F199\"}.style_fa-wordpress__2xzZ6:before{content:\"\\F19A\"}.style_fa-openid__D94GP:before{content:\"\\F19B\"}.style_fa-bank__3rkbQ:before,.style_fa-institution__2hjdN:before,.style_fa-university__3HLWm:before{content:\"\\F19C\"}.style_fa-graduation-cap__Mv-zi:before,.style_fa-mortar-board__lir21:before{content:\"\\F19D\"}.style_fa-yahoo__3KkpO:before{content:\"\\F19E\"}.style_fa-google__3FGuH:before{content:\"\\F1A0\"}.style_fa-reddit__11v_6:before{content:\"\\F1A1\"}.style_fa-reddit-square__3lV5F:before{content:\"\\F1A2\"}.style_fa-stumbleupon-circle__3aLV5:before{content:\"\\F1A3\"}.style_fa-stumbleupon__YCZC2:before{content:\"\\F1A4\"}.style_fa-delicious__3_9p9:before{content:\"\\F1A5\"}.style_fa-digg__Aqqnb:before{content:\"\\F1A6\"}.style_fa-pied-piper-pp__2Jh-d:before{content:\"\\F1A7\"}.style_fa-pied-piper-alt__1RYAN:before{content:\"\\F1A8\"}.style_fa-drupal__2CBnI:before{content:\"\\F1A9\"}.style_fa-joomla__2jLpt:before{content:\"\\F1AA\"}.style_fa-language__12ZtE:before{content:\"\\F1AB\"}.style_fa-fax__2brsY:before{content:\"\\F1AC\"}.style_fa-building__3gMtm:before{content:\"\\F1AD\"}.style_fa-child__aLfmj:before{content:\"\\F1AE\"}.style_fa-paw__3AdLQ:before{content:\"\\F1B0\"}.style_fa-spoon__31Ta2:before{content:\"\\F1B1\"}.style_fa-cube__E4C4A:before{content:\"\\F1B2\"}.style_fa-cubes__1Oc2M:before{content:\"\\F1B3\"}.style_fa-behance__3xSZc:before{content:\"\\F1B4\"}.style_fa-behance-square__3Nx9s:before{content:\"\\F1B5\"}.style_fa-steam__1qOBr:before{content:\"\\F1B6\"}.style_fa-steam-square__1uMzy:before{content:\"\\F1B7\"}.style_fa-recycle__109Ji:before{content:\"\\F1B8\"}.style_fa-automobile__rH9KD:before,.style_fa-car__3jJSC:before{content:\"\\F1B9\"}.style_fa-cab__2AAWR:before,.style_fa-taxi__16hc8:before{content:\"\\F1BA\"}.style_fa-tree__3TAew:before{content:\"\\F1BB\"}.style_fa-spotify__3zndM:before{content:\"\\F1BC\"}.style_fa-deviantart__k7QPs:before{content:\"\\F1BD\"}.style_fa-soundcloud__21KtU:before{content:\"\\F1BE\"}.style_fa-database__3x11l:before{content:\"\\F1C0\"}.style_fa-file-pdf-o__1UWXX:before{content:\"\\F1C1\"}.style_fa-file-word-o__Zxcy6:before{content:\"\\F1C2\"}.style_fa-file-excel-o__3tuIt:before{content:\"\\F1C3\"}.style_fa-file-powerpoint-o__2ldG5:before{content:\"\\F1C4\"}.style_fa-file-image-o__1N9tp:before,.style_fa-file-photo-o__3syks:before,.style_fa-file-picture-o__1ZXeo:before{content:\"\\F1C5\"}.style_fa-file-archive-o__10aGo:before,.style_fa-file-zip-o__1AycK:before{content:\"\\F1C6\"}.style_fa-file-audio-o__Gfwou:before,.style_fa-file-sound-o__VeT3V:before{content:\"\\F1C7\"}.style_fa-file-movie-o__3ichx:before,.style_fa-file-video-o__3Jcv3:before{content:\"\\F1C8\"}.style_fa-file-code-o__2K797:before{content:\"\\F1C9\"}.style_fa-vine__3OeCe:before{content:\"\\F1CA\"}.style_fa-codepen__1dXdy:before{content:\"\\F1CB\"}.style_fa-jsfiddle__3UgBp:before{content:\"\\F1CC\"}.style_fa-life-bouy__1_S3D:before,.style_fa-life-buoy__ve2oz:before,.style_fa-life-ring__25W_g:before,.style_fa-life-saver__ACpfj:before,.style_fa-support__3m5m6:before{content:\"\\F1CD\"}.style_fa-circle-o-notch__3cukx:before{content:\"\\F1CE\"}.style_fa-ra__1BSfX:before,.style_fa-rebel__yZmt9:before,.style_fa-resistance__1R8LL:before{content:\"\\F1D0\"}.style_fa-empire__2MYaA:before,.style_fa-ge__3Jxbo:before{content:\"\\F1D1\"}.style_fa-git-square__2fz0z:before{content:\"\\F1D2\"}.style_fa-git__273FN:before{content:\"\\F1D3\"}.style_fa-hacker-news__1BOsy:before,.style_fa-y-combinator-square__1kZaq:before,.style_fa-yc-square__2rvQu:before{content:\"\\F1D4\"}.style_fa-tencent-weibo__3QMpj:before{content:\"\\F1D5\"}.style_fa-qq__32_v9:before{content:\"\\F1D6\"}.style_fa-wechat__3RMBl:before,.style_fa-weixin__PIRz-:before{content:\"\\F1D7\"}.style_fa-paper-plane__22F4t:before,.style_fa-send__XzgHa:before{content:\"\\F1D8\"}.style_fa-paper-plane-o__rthxb:before,.style_fa-send-o__1VUws:before{content:\"\\F1D9\"}.style_fa-history__3jmj5:before{content:\"\\F1DA\"}.style_fa-circle-thin__pujpG:before{content:\"\\F1DB\"}.style_fa-header__3M7hI:before{content:\"\\F1DC\"}.style_fa-paragraph__AHVpO:before{content:\"\\F1DD\"}.style_fa-sliders__3qlRM:before{content:\"\\F1DE\"}.style_fa-share-alt__3pA8S:before{content:\"\\F1E0\"}.style_fa-share-alt-square__2TLPh:before{content:\"\\F1E1\"}.style_fa-bomb__9R958:before{content:\"\\F1E2\"}.style_fa-futbol-o__1a0Ku:before,.style_fa-soccer-ball-o__3Zpz3:before{content:\"\\F1E3\"}.style_fa-tty__3dhCE:before{content:\"\\F1E4\"}.style_fa-binoculars__1lRi4:before{content:\"\\F1E5\"}.style_fa-plug__4R_-Z:before{content:\"\\F1E6\"}.style_fa-slideshare__2AFjK:before{content:\"\\F1E7\"}.style_fa-twitch__2pHuI:before{content:\"\\F1E8\"}.style_fa-yelp__3uIb0:before{content:\"\\F1E9\"}.style_fa-newspaper-o__2uVdd:before{content:\"\\F1EA\"}.style_fa-wifi__I10MG:before{content:\"\\F1EB\"}.style_fa-calculator__2peOS:before{content:\"\\F1EC\"}.style_fa-paypal__3ZedC:before{content:\"\\F1ED\"}.style_fa-google-wallet__1xZG3:before{content:\"\\F1EE\"}.style_fa-cc-visa__3wYa7:before{content:\"\\F1F0\"}.style_fa-cc-mastercard__x-8Hg:before{content:\"\\F1F1\"}.style_fa-cc-discover__WkJEt:before{content:\"\\F1F2\"}.style_fa-cc-amex__QATKk:before{content:\"\\F1F3\"}.style_fa-cc-paypal__31MqT:before{content:\"\\F1F4\"}.style_fa-cc-stripe__27I4-:before{content:\"\\F1F5\"}.style_fa-bell-slash__2wVQT:before{content:\"\\F1F6\"}.style_fa-bell-slash-o__3q6J0:before{content:\"\\F1F7\"}.style_fa-trash__2nsCq:before{content:\"\\F1F8\"}.style_fa-copyright__36jSb:before{content:\"\\F1F9\"}.style_fa-at__1gbqK:before{content:\"\\F1FA\"}.style_fa-eyedropper__2sfZR:before{content:\"\\F1FB\"}.style_fa-paint-brush__29gLz:before{content:\"\\F1FC\"}.style_fa-birthday-cake__2LFE-:before{content:\"\\F1FD\"}.style_fa-area-chart__2xoVG:before{content:\"\\F1FE\"}.style_fa-pie-chart__Lt9J9:before{content:\"\\F200\"}.style_fa-line-chart__v5Vz7:before{content:\"\\F201\"}.style_fa-lastfm__3Xbey:before{content:\"\\F202\"}.style_fa-lastfm-square__rcQZJ:before{content:\"\\F203\"}.style_fa-toggle-off__1RgJ-:before{content:\"\\F204\"}.style_fa-toggle-on__JzsTX:before{content:\"\\F205\"}.style_fa-bicycle__2Hi3o:before{content:\"\\F206\"}.style_fa-bus__2uqLm:before{content:\"\\F207\"}.style_fa-ioxhost__dz7I5:before{content:\"\\F208\"}.style_fa-angellist__1qU9h:before{content:\"\\F209\"}.style_fa-cc__1KTQC:before{content:\"\\F20A\"}.style_fa-ils__3RZz4:before,.style_fa-shekel__1TsRx:before,.style_fa-sheqel__2JXWS:before{content:\"\\F20B\"}.style_fa-meanpath__s-P0R:before{content:\"\\F20C\"}.style_fa-buysellads__31FsM:before{content:\"\\F20D\"}.style_fa-connectdevelop__3vxtL:before{content:\"\\F20E\"}.style_fa-dashcube__2SiAc:before{content:\"\\F210\"}.style_fa-forumbee__1N2en:before{content:\"\\F211\"}.style_fa-leanpub__GsGbD:before{content:\"\\F212\"}.style_fa-sellsy__3Voml:before{content:\"\\F213\"}.style_fa-shirtsinbulk__3Uicd:before{content:\"\\F214\"}.style_fa-simplybuilt__1S1iQ:before{content:\"\\F215\"}.style_fa-skyatlas__1lEy_:before{content:\"\\F216\"}.style_fa-cart-plus__6xtgm:before{content:\"\\F217\"}.style_fa-cart-arrow-down__TN9vq:before{content:\"\\F218\"}.style_fa-diamond__38kag:before{content:\"\\F219\"}.style_fa-ship__3jBZU:before{content:\"\\F21A\"}.style_fa-user-secret__1MNpY:before{content:\"\\F21B\"}.style_fa-motorcycle__2pfNe:before{content:\"\\F21C\"}.style_fa-street-view__2FFQt:before{content:\"\\F21D\"}.style_fa-heartbeat__10Izl:before{content:\"\\F21E\"}.style_fa-venus__25JDj:before{content:\"\\F221\"}.style_fa-mars__288UC:before{content:\"\\F222\"}.style_fa-mercury__2Q58M:before{content:\"\\F223\"}.style_fa-intersex__3kLL4:before,.style_fa-transgender__28Vug:before{content:\"\\F224\"}.style_fa-transgender-alt__2Nq6s:before{content:\"\\F225\"}.style_fa-venus-double__3h-Iv:before{content:\"\\F226\"}.style_fa-mars-double__bq6_W:before{content:\"\\F227\"}.style_fa-venus-mars__2vx7g:before{content:\"\\F228\"}.style_fa-mars-stroke__JBS4E:before{content:\"\\F229\"}.style_fa-mars-stroke-v__2DjaF:before{content:\"\\F22A\"}.style_fa-mars-stroke-h__2XBCX:before{content:\"\\F22B\"}.style_fa-neuter__tkR2L:before{content:\"\\F22C\"}.style_fa-genderless__3g8-C:before{content:\"\\F22D\"}.style_fa-facebook-official__1fixN:before{content:\"\\F230\"}.style_fa-pinterest-p__2Uacv:before{content:\"\\F231\"}.style_fa-whatsapp__5M37Z:before{content:\"\\F232\"}.style_fa-server__2Js8W:before{content:\"\\F233\"}.style_fa-user-plus__2FeQ9:before{content:\"\\F234\"}.style_fa-user-times__Z2cdB:before{content:\"\\F235\"}.style_fa-bed__165DP:before,.style_fa-hotel__3RJFT:before{content:\"\\F236\"}.style_fa-viacoin__1Mu6P:before{content:\"\\F237\"}.style_fa-train__1Z4yd:before{content:\"\\F238\"}.style_fa-subway__2F9i5:before{content:\"\\F239\"}.style_fa-medium__3M6ms:before{content:\"\\F23A\"}.style_fa-y-combinator__4aqOG:before,.style_fa-yc__ISZRJ:before{content:\"\\F23B\"}.style_fa-optin-monster__3bMTf:before{content:\"\\F23C\"}.style_fa-opencart__2Pd3y:before{content:\"\\F23D\"}.style_fa-expeditedssl__3lRxq:before{content:\"\\F23E\"}.style_fa-battery-4__nkX2e:before,.style_fa-battery-full__3k_LA:before,.style_fa-battery__1_1Ry:before{content:\"\\F240\"}.style_fa-battery-3__38FV_:before,.style_fa-battery-three-quarters__3_3TH:before{content:\"\\F241\"}.style_fa-battery-2__1LDMi:before,.style_fa-battery-half__3Lta2:before{content:\"\\F242\"}.style_fa-battery-1__1AjVY:before,.style_fa-battery-quarter__3KT3K:before{content:\"\\F243\"}.style_fa-battery-0__34q9q:before,.style_fa-battery-empty__NN-XE:before{content:\"\\F244\"}.style_fa-mouse-pointer__1se8l:before{content:\"\\F245\"}.style_fa-i-cursor__3-J0x:before{content:\"\\F246\"}.style_fa-object-group__8uZFN:before{content:\"\\F247\"}.style_fa-object-ungroup__3AfpG:before{content:\"\\F248\"}.style_fa-sticky-note__qC99I:before{content:\"\\F249\"}.style_fa-sticky-note-o__1shOs:before{content:\"\\F24A\"}.style_fa-cc-jcb__2JWFq:before{content:\"\\F24B\"}.style_fa-cc-diners-club__3aTNT:before{content:\"\\F24C\"}.style_fa-clone__3ICmj:before{content:\"\\F24D\"}.style_fa-balance-scale__15vCS:before{content:\"\\F24E\"}.style_fa-hourglass-o__2hHT1:before{content:\"\\F250\"}.style_fa-hourglass-1__2xFOM:before,.style_fa-hourglass-start__2oPRM:before{content:\"\\F251\"}.style_fa-hourglass-2__LMzUF:before,.style_fa-hourglass-half__8Nr-6:before{content:\"\\F252\"}.style_fa-hourglass-3__33jx-:before,.style_fa-hourglass-end__7sF5b:before{content:\"\\F253\"}.style_fa-hourglass__2hNrb:before{content:\"\\F254\"}.style_fa-hand-grab-o__1XsHN:before,.style_fa-hand-rock-o__1o7JV:before{content:\"\\F255\"}.style_fa-hand-paper-o__2D9tl:before,.style_fa-hand-stop-o__2tfzy:before{content:\"\\F256\"}.style_fa-hand-scissors-o__1RKVE:before{content:\"\\F257\"}.style_fa-hand-lizard-o__1zYpr:before{content:\"\\F258\"}.style_fa-hand-spock-o__YbrEg:before{content:\"\\F259\"}.style_fa-hand-pointer-o__1JnN-:before{content:\"\\F25A\"}.style_fa-hand-peace-o__yLVOp:before{content:\"\\F25B\"}.style_fa-trademark__3u2jI:before{content:\"\\F25C\"}.style_fa-registered__2qgyG:before{content:\"\\F25D\"}.style_fa-creative-commons__vPYgb:before{content:\"\\F25E\"}.style_fa-gg__3IYl-:before{content:\"\\F260\"}.style_fa-gg-circle__3-1rl:before{content:\"\\F261\"}.style_fa-tripadvisor__2L5A9:before{content:\"\\F262\"}.style_fa-odnoklassniki__nVekf:before{content:\"\\F263\"}.style_fa-odnoklassniki-square__16pjb:before{content:\"\\F264\"}.style_fa-get-pocket__104ns:before{content:\"\\F265\"}.style_fa-wikipedia-w__X8BYC:before{content:\"\\F266\"}.style_fa-safari__2sTvN:before{content:\"\\F267\"}.style_fa-chrome__2_0YB:before{content:\"\\F268\"}.style_fa-firefox__2CaNy:before{content:\"\\F269\"}.style_fa-opera__j5rM7:before{content:\"\\F26A\"}.style_fa-internet-explorer__322q3:before{content:\"\\F26B\"}.style_fa-television__2RVy1:before,.style_fa-tv__3YwR3:before{content:\"\\F26C\"}.style_fa-contao__23lBh:before{content:\"\\F26D\"}.style_fa-500px__17Jvu:before{content:\"\\F26E\"}.style_fa-amazon__1ymX6:before{content:\"\\F270\"}.style_fa-calendar-plus-o__3llpH:before{content:\"\\F271\"}.style_fa-calendar-minus-o__1eQIz:before{content:\"\\F272\"}.style_fa-calendar-times-o__1W9qV:before{content:\"\\F273\"}.style_fa-calendar-check-o__2qp9Q:before{content:\"\\F274\"}.style_fa-industry__32YjN:before{content:\"\\F275\"}.style_fa-map-pin__26nyt:before{content:\"\\F276\"}.style_fa-map-signs__1R7I6:before{content:\"\\F277\"}.style_fa-map-o__1B_Uf:before{content:\"\\F278\"}.style_fa-map__3Asmz:before{content:\"\\F279\"}.style_fa-commenting__2eYPk:before{content:\"\\F27A\"}.style_fa-commenting-o__1iYBT:before{content:\"\\F27B\"}.style_fa-houzz__1sfmW:before{content:\"\\F27C\"}.style_fa-vimeo__314lZ:before{content:\"\\F27D\"}.style_fa-black-tie__1Kqx8:before{content:\"\\F27E\"}.style_fa-fonticons__2zdba:before{content:\"\\F280\"}.style_fa-reddit-alien__2UPcO:before{content:\"\\F281\"}.style_fa-edge__1mSW1:before{content:\"\\F282\"}.style_fa-credit-card-alt__3UiPe:before{content:\"\\F283\"}.style_fa-codiepie__1EoyT:before{content:\"\\F284\"}.style_fa-modx__ISmGq:before{content:\"\\F285\"}.style_fa-fort-awesome__2C8ry:before{content:\"\\F286\"}.style_fa-usb__2bSi9:before{content:\"\\F287\"}.style_fa-product-hunt__WmzHD:before{content:\"\\F288\"}.style_fa-mixcloud__26EqX:before{content:\"\\F289\"}.style_fa-scribd__1nd52:before{content:\"\\F28A\"}.style_fa-pause-circle__2P49M:before{content:\"\\F28B\"}.style_fa-pause-circle-o__xcp3U:before{content:\"\\F28C\"}.style_fa-stop-circle__2rV8_:before{content:\"\\F28D\"}.style_fa-stop-circle-o__3k47o:before{content:\"\\F28E\"}.style_fa-shopping-bag__3TzmQ:before{content:\"\\F290\"}.style_fa-shopping-basket__1n0W7:before{content:\"\\F291\"}.style_fa-hashtag__1Au2Q:before{content:\"\\F292\"}.style_fa-bluetooth__f-IoV:before{content:\"\\F293\"}.style_fa-bluetooth-b__2ZV1n:before{content:\"\\F294\"}.style_fa-percent__3GeyB:before{content:\"\\F295\"}.style_fa-gitlab__2-Bar:before{content:\"\\F296\"}.style_fa-wpbeginner__2u02I:before{content:\"\\F297\"}.style_fa-wpforms__1PAVg:before{content:\"\\F298\"}.style_fa-envira__2Vlp_:before{content:\"\\F299\"}.style_fa-universal-access__1gPZ1:before{content:\"\\F29A\"}.style_fa-wheelchair-alt__PYJAx:before{content:\"\\F29B\"}.style_fa-question-circle-o__VU9cE:before{content:\"\\F29C\"}.style_fa-blind__14GsC:before{content:\"\\F29D\"}.style_fa-audio-description__193tW:before{content:\"\\F29E\"}.style_fa-volume-control-phone__1wydK:before{content:\"\\F2A0\"}.style_fa-braille__1Zz06:before{content:\"\\F2A1\"}.style_fa-assistive-listening-systems__2HSSD:before{content:\"\\F2A2\"}.style_fa-american-sign-language-interpreting__WTHMO:before,.style_fa-asl-interpreting__2_Ohd:before{content:\"\\F2A3\"}.style_fa-deaf__gNpY3:before,.style_fa-deafness__1RQ5h:before,.style_fa-hard-of-hearing__dxouv:before{content:\"\\F2A4\"}.style_fa-glide__2JkuE:before{content:\"\\F2A5\"}.style_fa-glide-g__7lw0r:before{content:\"\\F2A6\"}.style_fa-sign-language__3Kh8E:before,.style_fa-signing__1LBGN:before{content:\"\\F2A7\"}.style_fa-low-vision__3kvJs:before{content:\"\\F2A8\"}.style_fa-viadeo__VoezI:before{content:\"\\F2A9\"}.style_fa-viadeo-square__2UHUK:before{content:\"\\F2AA\"}.style_fa-snapchat__2jKmj:before{content:\"\\F2AB\"}.style_fa-snapchat-ghost__2xwud:before{content:\"\\F2AC\"}.style_fa-snapchat-square__2ay8Y:before{content:\"\\F2AD\"}.style_fa-pied-piper__1cKv9:before{content:\"\\F2AE\"}.style_fa-first-order__1aHV7:before{content:\"\\F2B0\"}.style_fa-yoast__3l7Nw:before{content:\"\\F2B1\"}.style_fa-themeisle__IVgBM:before{content:\"\\F2B2\"}.style_fa-google-plus-circle__3YTOV:before,.style_fa-google-plus-official__3j2-g:before{content:\"\\F2B3\"}.style_fa-fa__16B4w:before,.style_fa-font-awesome__a8j_I:before{content:\"\\F2B4\"}.style_fa-handshake-o__14uNQ:before{content:\"\\F2B5\"}.style_fa-envelope-open__1mSeC:before{content:\"\\F2B6\"}.style_fa-envelope-open-o__3IpGG:before{content:\"\\F2B7\"}.style_fa-linode__3MNS1:before{content:\"\\F2B8\"}.style_fa-address-book__3-Qpd:before{content:\"\\F2B9\"}.style_fa-address-book-o__aCKzG:before{content:\"\\F2BA\"}.style_fa-address-card__3k6ik:before,.style_fa-vcard__6M2eg:before{content:\"\\F2BB\"}.style_fa-address-card-o__3QTYS:before,.style_fa-vcard-o__iyiuV:before{content:\"\\F2BC\"}.style_fa-user-circle__1_cde:before{content:\"\\F2BD\"}.style_fa-user-circle-o__2YUao:before{content:\"\\F2BE\"}.style_fa-user-o__1V2Up:before{content:\"\\F2C0\"}.style_fa-id-badge__1CYVn:before{content:\"\\F2C1\"}.style_fa-drivers-license__e2Mlt:before,.style_fa-id-card__3sBIr:before{content:\"\\F2C2\"}.style_fa-drivers-license-o__QjBUI:before,.style_fa-id-card-o__24M2v:before{content:\"\\F2C3\"}.style_fa-quora__3pF-w:before{content:\"\\F2C4\"}.style_fa-free-code-camp__mJ0F4:before{content:\"\\F2C5\"}.style_fa-telegram__1SQJJ:before{content:\"\\F2C6\"}.style_fa-thermometer-4__18hgc:before,.style_fa-thermometer-full__zru6l:before,.style_fa-thermometer__2FEkA:before{content:\"\\F2C7\"}.style_fa-thermometer-3__2zo1R:before,.style_fa-thermometer-three-quarters__3rjIl:before{content:\"\\F2C8\"}.style_fa-thermometer-2__12ejr:before,.style_fa-thermometer-half__2tRDU:before{content:\"\\F2C9\"}.style_fa-thermometer-1__24a3O:before,.style_fa-thermometer-quarter__f5Fhv:before{content:\"\\F2CA\"}.style_fa-thermometer-0__3739I:before,.style_fa-thermometer-empty__1SOIG:before{content:\"\\F2CB\"}.style_fa-shower__2wAa7:before{content:\"\\F2CC\"}.style_fa-bath__aZawX:before,.style_fa-bathtub__1i6ao:before,.style_fa-s15__24ar6:before{content:\"\\F2CD\"}.style_fa-podcast__lVPTY:before{content:\"\\F2CE\"}.style_fa-window-maximize__2RO54:before{content:\"\\F2D0\"}.style_fa-window-minimize__3IN2X:before{content:\"\\F2D1\"}.style_fa-window-restore__3QFHb:before{content:\"\\F2D2\"}.style_fa-times-rectangle__BvQG5:before,.style_fa-window-close__2mrEp:before{content:\"\\F2D3\"}.style_fa-times-rectangle-o__wCN68:before,.style_fa-window-close-o__3apzx:before{content:\"\\F2D4\"}.style_fa-bandcamp__HoVp0:before{content:\"\\F2D5\"}.style_fa-grav__3c47r:before{content:\"\\F2D6\"}.style_fa-etsy__2I3s2:before{content:\"\\F2D7\"}.style_fa-imdb__vfJgy:before{content:\"\\F2D8\"}.style_fa-ravelry__1zUZZ:before{content:\"\\F2D9\"}.style_fa-eercast__3WehH:before{content:\"\\F2DA\"}.style_fa-microchip__1OQ4R:before{content:\"\\F2DB\"}.style_fa-snowflake-o__2yftS:before{content:\"\\F2DC\"}.style_fa-superpowers__3oE6q:before{content:\"\\F2DD\"}.style_fa-wpexplorer__2Fz14:before{content:\"\\F2DE\"}.style_fa-meetup__3VCYC:before{content:\"\\F2E0\"}.style_sr-only__28X0u{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.style_sr-only-focusable__3hrEM:active,.style_sr-only-focusable__3hrEM:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.style_monospace__3wtSm{font-family:Menlo,Monaco,Consolas,Courier New,monospace;line-height:1.2rem}.style_text__2pyMd{vertical-align:baseline!important;width:100%!important;min-width:0!important}.style_container__1dFxU{width:100%}.style_monospacedText__1120V{font-family:Menlo,Monaco,Consolas,Courier New,monospace!important}", ""]);

// exports
exports.locals = {
	"fontoctopus-octopus": "style_fontoctopus-octopus__2N8AD",
	"fontoctopusOctopus": "style_fontoctopus-octopus__2N8AD",
	"fa": "style_fa__2Stzz",
	"fa-lg": "style_fa-lg__1bG3h",
	"faLg": "style_fa-lg__1bG3h",
	"fa-2x": "style_fa-2x__2_hqT",
	"fa2X": "style_fa-2x__2_hqT",
	"fa-3x": "style_fa-3x__Stup6",
	"fa3X": "style_fa-3x__Stup6",
	"fa-4x": "style_fa-4x___nR0M",
	"fa4X": "style_fa-4x___nR0M",
	"fa-5x": "style_fa-5x__vUgdf",
	"fa5X": "style_fa-5x__vUgdf",
	"fa-fw": "style_fa-fw__1jESs",
	"faFw": "style_fa-fw__1jESs",
	"fa-ul": "style_fa-ul__22z2m",
	"faUl": "style_fa-ul__22z2m",
	"fa-li": "style_fa-li__1xMKd",
	"faLi": "style_fa-li__1xMKd",
	"fa-border": "style_fa-border__N_IDS",
	"faBorder": "style_fa-border__N_IDS",
	"fa-pull-left": "style_fa-pull-left__19hOZ",
	"faPullLeft": "style_fa-pull-left__19hOZ",
	"fa-pull-right": "style_fa-pull-right__1IGi0",
	"faPullRight": "style_fa-pull-right__1IGi0",
	"pull-right": "style_pull-right__Ekb6T",
	"pullRight": "style_pull-right__Ekb6T",
	"pull-left": "style_pull-left__6kkds",
	"pullLeft": "style_pull-left__6kkds",
	"fa-spin": "style_fa-spin__3OLtN",
	"faSpin": "style_fa-spin__3OLtN",
	"fa-pulse": "style_fa-pulse__3YIU7",
	"faPulse": "style_fa-pulse__3YIU7",
	"fa-rotate-90": "style_fa-rotate-90__V_q9A",
	"faRotate90": "style_fa-rotate-90__V_q9A",
	"fa-rotate-180": "style_fa-rotate-180__AlfVc",
	"faRotate180": "style_fa-rotate-180__AlfVc",
	"fa-rotate-270": "style_fa-rotate-270__zfwx-",
	"faRotate270": "style_fa-rotate-270__zfwx-",
	"fa-flip-horizontal": "style_fa-flip-horizontal__SlkBZ",
	"faFlipHorizontal": "style_fa-flip-horizontal__SlkBZ",
	"fa-flip-vertical": "style_fa-flip-vertical__oocW6",
	"faFlipVertical": "style_fa-flip-vertical__oocW6",
	"fa-stack": "style_fa-stack__2CYwt",
	"faStack": "style_fa-stack__2CYwt",
	"fa-stack-1x": "style_fa-stack-1x__1VBdj",
	"faStack1X": "style_fa-stack-1x__1VBdj",
	"fa-stack-2x": "style_fa-stack-2x__3ku48",
	"faStack2X": "style_fa-stack-2x__3ku48",
	"fa-inverse": "style_fa-inverse__1m291",
	"faInverse": "style_fa-inverse__1m291",
	"fa-glass": "style_fa-glass__16k7J",
	"faGlass": "style_fa-glass__16k7J",
	"fa-music": "style_fa-music__kkflz",
	"faMusic": "style_fa-music__kkflz",
	"fa-search": "style_fa-search__qCxf9",
	"faSearch": "style_fa-search__qCxf9",
	"fa-envelope-o": "style_fa-envelope-o__xXTWd",
	"faEnvelopeO": "style_fa-envelope-o__xXTWd",
	"fa-heart": "style_fa-heart__3Ug_1",
	"faHeart": "style_fa-heart__3Ug_1",
	"fa-star": "style_fa-star__3N6qV",
	"faStar": "style_fa-star__3N6qV",
	"fa-star-o": "style_fa-star-o__2CD-u",
	"faStarO": "style_fa-star-o__2CD-u",
	"fa-user": "style_fa-user__3khUP",
	"faUser": "style_fa-user__3khUP",
	"fa-film": "style_fa-film__gBI0K",
	"faFilm": "style_fa-film__gBI0K",
	"fa-th-large": "style_fa-th-large__2fszA",
	"faThLarge": "style_fa-th-large__2fszA",
	"fa-th": "style_fa-th__2awmn",
	"faTh": "style_fa-th__2awmn",
	"fa-th-list": "style_fa-th-list__2FtcN",
	"faThList": "style_fa-th-list__2FtcN",
	"fa-check": "style_fa-check__3AIyn",
	"faCheck": "style_fa-check__3AIyn",
	"fa-remove": "style_fa-remove__3cnS0",
	"faRemove": "style_fa-remove__3cnS0",
	"fa-close": "style_fa-close__1knvb",
	"faClose": "style_fa-close__1knvb",
	"fa-times": "style_fa-times__3yoPt",
	"faTimes": "style_fa-times__3yoPt",
	"fa-search-plus": "style_fa-search-plus__33Lij",
	"faSearchPlus": "style_fa-search-plus__33Lij",
	"fa-search-minus": "style_fa-search-minus__2yHac",
	"faSearchMinus": "style_fa-search-minus__2yHac",
	"fa-power-off": "style_fa-power-off__3QfoZ",
	"faPowerOff": "style_fa-power-off__3QfoZ",
	"fa-signal": "style_fa-signal__2LNOs",
	"faSignal": "style_fa-signal__2LNOs",
	"fa-gear": "style_fa-gear__1aqXg",
	"faGear": "style_fa-gear__1aqXg",
	"fa-cog": "style_fa-cog__2S0eu",
	"faCog": "style_fa-cog__2S0eu",
	"fa-trash-o": "style_fa-trash-o__Jy4Qd",
	"faTrashO": "style_fa-trash-o__Jy4Qd",
	"fa-home": "style_fa-home__2aA7l",
	"faHome": "style_fa-home__2aA7l",
	"fa-file-o": "style_fa-file-o__2XOwD",
	"faFileO": "style_fa-file-o__2XOwD",
	"fa-clock-o": "style_fa-clock-o__2WKaF",
	"faClockO": "style_fa-clock-o__2WKaF",
	"fa-road": "style_fa-road__2emGR",
	"faRoad": "style_fa-road__2emGR",
	"fa-download": "style_fa-download__2Jf5l",
	"faDownload": "style_fa-download__2Jf5l",
	"fa-arrow-circle-o-down": "style_fa-arrow-circle-o-down__1zZ7Q",
	"faArrowCircleODown": "style_fa-arrow-circle-o-down__1zZ7Q",
	"fa-arrow-circle-o-up": "style_fa-arrow-circle-o-up__KMZ50",
	"faArrowCircleOUp": "style_fa-arrow-circle-o-up__KMZ50",
	"fa-inbox": "style_fa-inbox__3BPi6",
	"faInbox": "style_fa-inbox__3BPi6",
	"fa-play-circle-o": "style_fa-play-circle-o__1PlJd",
	"faPlayCircleO": "style_fa-play-circle-o__1PlJd",
	"fa-rotate-right": "style_fa-rotate-right__1U5RB",
	"faRotateRight": "style_fa-rotate-right__1U5RB",
	"fa-repeat": "style_fa-repeat__2EtMa",
	"faRepeat": "style_fa-repeat__2EtMa",
	"fa-refresh": "style_fa-refresh__1BjiR",
	"faRefresh": "style_fa-refresh__1BjiR",
	"fa-list-alt": "style_fa-list-alt__2UUVE",
	"faListAlt": "style_fa-list-alt__2UUVE",
	"fa-lock": "style_fa-lock__2AxqE",
	"faLock": "style_fa-lock__2AxqE",
	"fa-flag": "style_fa-flag__1u53R",
	"faFlag": "style_fa-flag__1u53R",
	"fa-headphones": "style_fa-headphones__3Yhkq",
	"faHeadphones": "style_fa-headphones__3Yhkq",
	"fa-volume-off": "style_fa-volume-off__3LfY-",
	"faVolumeOff": "style_fa-volume-off__3LfY-",
	"fa-volume-down": "style_fa-volume-down__1JuvK",
	"faVolumeDown": "style_fa-volume-down__1JuvK",
	"fa-volume-up": "style_fa-volume-up__3rdlp",
	"faVolumeUp": "style_fa-volume-up__3rdlp",
	"fa-qrcode": "style_fa-qrcode__2UZke",
	"faQrcode": "style_fa-qrcode__2UZke",
	"fa-barcode": "style_fa-barcode__3NqNI",
	"faBarcode": "style_fa-barcode__3NqNI",
	"fa-tag": "style_fa-tag__2O9hk",
	"faTag": "style_fa-tag__2O9hk",
	"fa-tags": "style_fa-tags__-8Rh_",
	"faTags": "style_fa-tags__-8Rh_",
	"fa-book": "style_fa-book__3Nk-f",
	"faBook": "style_fa-book__3Nk-f",
	"fa-bookmark": "style_fa-bookmark__3qaOT",
	"faBookmark": "style_fa-bookmark__3qaOT",
	"fa-print": "style_fa-print__YyG1f",
	"faPrint": "style_fa-print__YyG1f",
	"fa-camera": "style_fa-camera__aUjmZ",
	"faCamera": "style_fa-camera__aUjmZ",
	"fa-font": "style_fa-font__gGxlk",
	"faFont": "style_fa-font__gGxlk",
	"fa-bold": "style_fa-bold__ks_J4",
	"faBold": "style_fa-bold__ks_J4",
	"fa-italic": "style_fa-italic__20ogU",
	"faItalic": "style_fa-italic__20ogU",
	"fa-text-height": "style_fa-text-height___0LQ7",
	"faTextHeight": "style_fa-text-height___0LQ7",
	"fa-text-width": "style_fa-text-width__jeOjf",
	"faTextWidth": "style_fa-text-width__jeOjf",
	"fa-align-left": "style_fa-align-left__22Zw8",
	"faAlignLeft": "style_fa-align-left__22Zw8",
	"fa-align-center": "style_fa-align-center__3Iq_1",
	"faAlignCenter": "style_fa-align-center__3Iq_1",
	"fa-align-right": "style_fa-align-right__Eka7e",
	"faAlignRight": "style_fa-align-right__Eka7e",
	"fa-align-justify": "style_fa-align-justify__pARZF",
	"faAlignJustify": "style_fa-align-justify__pARZF",
	"fa-list": "style_fa-list__1OD3U",
	"faList": "style_fa-list__1OD3U",
	"fa-dedent": "style_fa-dedent__YI-PY",
	"faDedent": "style_fa-dedent__YI-PY",
	"fa-outdent": "style_fa-outdent__Q3A49",
	"faOutdent": "style_fa-outdent__Q3A49",
	"fa-indent": "style_fa-indent__1jwPG",
	"faIndent": "style_fa-indent__1jwPG",
	"fa-video-camera": "style_fa-video-camera__3zM_P",
	"faVideoCamera": "style_fa-video-camera__3zM_P",
	"fa-photo": "style_fa-photo__12fAw",
	"faPhoto": "style_fa-photo__12fAw",
	"fa-image": "style_fa-image__1Zij8",
	"faImage": "style_fa-image__1Zij8",
	"fa-picture-o": "style_fa-picture-o__2kh9I",
	"faPictureO": "style_fa-picture-o__2kh9I",
	"fa-pencil": "style_fa-pencil__SPg_-",
	"faPencil": "style_fa-pencil__SPg_-",
	"fa-map-marker": "style_fa-map-marker__2B57R",
	"faMapMarker": "style_fa-map-marker__2B57R",
	"fa-adjust": "style_fa-adjust__22duV",
	"faAdjust": "style_fa-adjust__22duV",
	"fa-tint": "style_fa-tint__2hInd",
	"faTint": "style_fa-tint__2hInd",
	"fa-edit": "style_fa-edit__2hUlG",
	"faEdit": "style_fa-edit__2hUlG",
	"fa-pencil-square-o": "style_fa-pencil-square-o__E9ibP",
	"faPencilSquareO": "style_fa-pencil-square-o__E9ibP",
	"fa-share-square-o": "style_fa-share-square-o__2RDHE",
	"faShareSquareO": "style_fa-share-square-o__2RDHE",
	"fa-check-square-o": "style_fa-check-square-o__2K-Dz",
	"faCheckSquareO": "style_fa-check-square-o__2K-Dz",
	"fa-arrows": "style_fa-arrows__35WFl",
	"faArrows": "style_fa-arrows__35WFl",
	"fa-step-backward": "style_fa-step-backward__1CcyE",
	"faStepBackward": "style_fa-step-backward__1CcyE",
	"fa-fast-backward": "style_fa-fast-backward__1Blqo",
	"faFastBackward": "style_fa-fast-backward__1Blqo",
	"fa-backward": "style_fa-backward__3e-fg",
	"faBackward": "style_fa-backward__3e-fg",
	"fa-play": "style_fa-play__ETJ_t",
	"faPlay": "style_fa-play__ETJ_t",
	"fa-pause": "style_fa-pause__3ro_2",
	"faPause": "style_fa-pause__3ro_2",
	"fa-stop": "style_fa-stop__3ZrVE",
	"faStop": "style_fa-stop__3ZrVE",
	"fa-forward": "style_fa-forward__38fYD",
	"faForward": "style_fa-forward__38fYD",
	"fa-fast-forward": "style_fa-fast-forward__12ERo",
	"faFastForward": "style_fa-fast-forward__12ERo",
	"fa-step-forward": "style_fa-step-forward__1HhqA",
	"faStepForward": "style_fa-step-forward__1HhqA",
	"fa-eject": "style_fa-eject__3iYgQ",
	"faEject": "style_fa-eject__3iYgQ",
	"fa-chevron-left": "style_fa-chevron-left__3n6Ih",
	"faChevronLeft": "style_fa-chevron-left__3n6Ih",
	"fa-chevron-right": "style_fa-chevron-right__17qWa",
	"faChevronRight": "style_fa-chevron-right__17qWa",
	"fa-plus-circle": "style_fa-plus-circle__1_Hd6",
	"faPlusCircle": "style_fa-plus-circle__1_Hd6",
	"fa-minus-circle": "style_fa-minus-circle__2lFkp",
	"faMinusCircle": "style_fa-minus-circle__2lFkp",
	"fa-times-circle": "style_fa-times-circle__3sN8j",
	"faTimesCircle": "style_fa-times-circle__3sN8j",
	"fa-check-circle": "style_fa-check-circle__2wkS0",
	"faCheckCircle": "style_fa-check-circle__2wkS0",
	"fa-question-circle": "style_fa-question-circle__2fk1Y",
	"faQuestionCircle": "style_fa-question-circle__2fk1Y",
	"fa-info-circle": "style_fa-info-circle__2gaYm",
	"faInfoCircle": "style_fa-info-circle__2gaYm",
	"fa-crosshairs": "style_fa-crosshairs__1LEU-",
	"faCrosshairs": "style_fa-crosshairs__1LEU-",
	"fa-times-circle-o": "style_fa-times-circle-o__2TSHm",
	"faTimesCircleO": "style_fa-times-circle-o__2TSHm",
	"fa-check-circle-o": "style_fa-check-circle-o__3WaoE",
	"faCheckCircleO": "style_fa-check-circle-o__3WaoE",
	"fa-ban": "style_fa-ban__2Qhpz",
	"faBan": "style_fa-ban__2Qhpz",
	"fa-arrow-left": "style_fa-arrow-left__1Tt32",
	"faArrowLeft": "style_fa-arrow-left__1Tt32",
	"fa-arrow-right": "style_fa-arrow-right__1FESc",
	"faArrowRight": "style_fa-arrow-right__1FESc",
	"fa-arrow-up": "style_fa-arrow-up__3wcyR",
	"faArrowUp": "style_fa-arrow-up__3wcyR",
	"fa-arrow-down": "style_fa-arrow-down__3Mskv",
	"faArrowDown": "style_fa-arrow-down__3Mskv",
	"fa-mail-forward": "style_fa-mail-forward__2NDhk",
	"faMailForward": "style_fa-mail-forward__2NDhk",
	"fa-share": "style_fa-share__3l_NS",
	"faShare": "style_fa-share__3l_NS",
	"fa-expand": "style_fa-expand__3GAJ3",
	"faExpand": "style_fa-expand__3GAJ3",
	"fa-compress": "style_fa-compress__2wbOP",
	"faCompress": "style_fa-compress__2wbOP",
	"fa-plus": "style_fa-plus__22pw4",
	"faPlus": "style_fa-plus__22pw4",
	"fa-minus": "style_fa-minus__poN8Q",
	"faMinus": "style_fa-minus__poN8Q",
	"fa-asterisk": "style_fa-asterisk__33jbA",
	"faAsterisk": "style_fa-asterisk__33jbA",
	"fa-exclamation-circle": "style_fa-exclamation-circle__1xJgn",
	"faExclamationCircle": "style_fa-exclamation-circle__1xJgn",
	"fa-gift": "style_fa-gift__3nKN8",
	"faGift": "style_fa-gift__3nKN8",
	"fa-leaf": "style_fa-leaf__FnNeM",
	"faLeaf": "style_fa-leaf__FnNeM",
	"fa-fire": "style_fa-fire__iabFV",
	"faFire": "style_fa-fire__iabFV",
	"fa-eye": "style_fa-eye__zJEkG",
	"faEye": "style_fa-eye__zJEkG",
	"fa-eye-slash": "style_fa-eye-slash__2bjSj",
	"faEyeSlash": "style_fa-eye-slash__2bjSj",
	"fa-warning": "style_fa-warning__3f1BB",
	"faWarning": "style_fa-warning__3f1BB",
	"fa-exclamation-triangle": "style_fa-exclamation-triangle__1FI1o",
	"faExclamationTriangle": "style_fa-exclamation-triangle__1FI1o",
	"fa-plane": "style_fa-plane__r9HNn",
	"faPlane": "style_fa-plane__r9HNn",
	"fa-calendar": "style_fa-calendar__1lGhc",
	"faCalendar": "style_fa-calendar__1lGhc",
	"fa-random": "style_fa-random__3oSfN",
	"faRandom": "style_fa-random__3oSfN",
	"fa-comment": "style_fa-comment__1XcXN",
	"faComment": "style_fa-comment__1XcXN",
	"fa-magnet": "style_fa-magnet__3Ra7v",
	"faMagnet": "style_fa-magnet__3Ra7v",
	"fa-chevron-up": "style_fa-chevron-up__1IJay",
	"faChevronUp": "style_fa-chevron-up__1IJay",
	"fa-chevron-down": "style_fa-chevron-down__3VgR7",
	"faChevronDown": "style_fa-chevron-down__3VgR7",
	"fa-retweet": "style_fa-retweet__3bBmk",
	"faRetweet": "style_fa-retweet__3bBmk",
	"fa-shopping-cart": "style_fa-shopping-cart__wsIiy",
	"faShoppingCart": "style_fa-shopping-cart__wsIiy",
	"fa-folder": "style_fa-folder__3pZY8",
	"faFolder": "style_fa-folder__3pZY8",
	"fa-folder-open": "style_fa-folder-open__2e7-y",
	"faFolderOpen": "style_fa-folder-open__2e7-y",
	"fa-arrows-v": "style_fa-arrows-v__3lYN9",
	"faArrowsV": "style_fa-arrows-v__3lYN9",
	"fa-arrows-h": "style_fa-arrows-h__2AKrb",
	"faArrowsH": "style_fa-arrows-h__2AKrb",
	"fa-bar-chart-o": "style_fa-bar-chart-o__1N0Fi",
	"faBarChartO": "style_fa-bar-chart-o__1N0Fi",
	"fa-bar-chart": "style_fa-bar-chart__2GC9g",
	"faBarChart": "style_fa-bar-chart__2GC9g",
	"fa-twitter-square": "style_fa-twitter-square__25459",
	"faTwitterSquare": "style_fa-twitter-square__25459",
	"fa-facebook-square": "style_fa-facebook-square__34MaH",
	"faFacebookSquare": "style_fa-facebook-square__34MaH",
	"fa-camera-retro": "style_fa-camera-retro__3UpEF",
	"faCameraRetro": "style_fa-camera-retro__3UpEF",
	"fa-key": "style_fa-key__PomoZ",
	"faKey": "style_fa-key__PomoZ",
	"fa-gears": "style_fa-gears__3bHU8",
	"faGears": "style_fa-gears__3bHU8",
	"fa-cogs": "style_fa-cogs__2mWvc",
	"faCogs": "style_fa-cogs__2mWvc",
	"fa-comments": "style_fa-comments__1TsY2",
	"faComments": "style_fa-comments__1TsY2",
	"fa-thumbs-o-up": "style_fa-thumbs-o-up__CdiXO",
	"faThumbsOUp": "style_fa-thumbs-o-up__CdiXO",
	"fa-thumbs-o-down": "style_fa-thumbs-o-down__z4NN5",
	"faThumbsODown": "style_fa-thumbs-o-down__z4NN5",
	"fa-star-half": "style_fa-star-half__Iest8",
	"faStarHalf": "style_fa-star-half__Iest8",
	"fa-heart-o": "style_fa-heart-o__2m_lH",
	"faHeartO": "style_fa-heart-o__2m_lH",
	"fa-sign-out": "style_fa-sign-out__1lcQa",
	"faSignOut": "style_fa-sign-out__1lcQa",
	"fa-linkedin-square": "style_fa-linkedin-square__3kZOS",
	"faLinkedinSquare": "style_fa-linkedin-square__3kZOS",
	"fa-thumb-tack": "style_fa-thumb-tack__1o_WC",
	"faThumbTack": "style_fa-thumb-tack__1o_WC",
	"fa-external-link": "style_fa-external-link__1PHHE",
	"faExternalLink": "style_fa-external-link__1PHHE",
	"fa-sign-in": "style_fa-sign-in__1qcVV",
	"faSignIn": "style_fa-sign-in__1qcVV",
	"fa-trophy": "style_fa-trophy__3_XYL",
	"faTrophy": "style_fa-trophy__3_XYL",
	"fa-github-square": "style_fa-github-square__2Ylwu",
	"faGithubSquare": "style_fa-github-square__2Ylwu",
	"fa-upload": "style_fa-upload__1fS8f",
	"faUpload": "style_fa-upload__1fS8f",
	"fa-lemon-o": "style_fa-lemon-o__2eZyK",
	"faLemonO": "style_fa-lemon-o__2eZyK",
	"fa-phone": "style_fa-phone__3YoRI",
	"faPhone": "style_fa-phone__3YoRI",
	"fa-square-o": "style_fa-square-o__1N8kv",
	"faSquareO": "style_fa-square-o__1N8kv",
	"fa-bookmark-o": "style_fa-bookmark-o__jfvFO",
	"faBookmarkO": "style_fa-bookmark-o__jfvFO",
	"fa-phone-square": "style_fa-phone-square__3ZRc_",
	"faPhoneSquare": "style_fa-phone-square__3ZRc_",
	"fa-twitter": "style_fa-twitter__2yG2o",
	"faTwitter": "style_fa-twitter__2yG2o",
	"fa-facebook-f": "style_fa-facebook-f__2lRUc",
	"faFacebookF": "style_fa-facebook-f__2lRUc",
	"fa-facebook": "style_fa-facebook__32LSL",
	"faFacebook": "style_fa-facebook__32LSL",
	"fa-github": "style_fa-github__2Ke1H",
	"faGithub": "style_fa-github__2Ke1H",
	"fa-unlock": "style_fa-unlock__3LTVN",
	"faUnlock": "style_fa-unlock__3LTVN",
	"fa-credit-card": "style_fa-credit-card__17tW0",
	"faCreditCard": "style_fa-credit-card__17tW0",
	"fa-feed": "style_fa-feed__2gj0C",
	"faFeed": "style_fa-feed__2gj0C",
	"fa-rss": "style_fa-rss__2TJ7S",
	"faRss": "style_fa-rss__2TJ7S",
	"fa-hdd-o": "style_fa-hdd-o__3p7M9",
	"faHddO": "style_fa-hdd-o__3p7M9",
	"fa-bullhorn": "style_fa-bullhorn__2nBQr",
	"faBullhorn": "style_fa-bullhorn__2nBQr",
	"fa-bell": "style_fa-bell__xhSCD",
	"faBell": "style_fa-bell__xhSCD",
	"fa-certificate": "style_fa-certificate__1UjXn",
	"faCertificate": "style_fa-certificate__1UjXn",
	"fa-hand-o-right": "style_fa-hand-o-right__170tV",
	"faHandORight": "style_fa-hand-o-right__170tV",
	"fa-hand-o-left": "style_fa-hand-o-left__1bZCj",
	"faHandOLeft": "style_fa-hand-o-left__1bZCj",
	"fa-hand-o-up": "style_fa-hand-o-up__FOPJs",
	"faHandOUp": "style_fa-hand-o-up__FOPJs",
	"fa-hand-o-down": "style_fa-hand-o-down__3EtW7",
	"faHandODown": "style_fa-hand-o-down__3EtW7",
	"fa-arrow-circle-left": "style_fa-arrow-circle-left__4Si1c",
	"faArrowCircleLeft": "style_fa-arrow-circle-left__4Si1c",
	"fa-arrow-circle-right": "style_fa-arrow-circle-right__o2B_F",
	"faArrowCircleRight": "style_fa-arrow-circle-right__o2B_F",
	"fa-arrow-circle-up": "style_fa-arrow-circle-up__1t6C_",
	"faArrowCircleUp": "style_fa-arrow-circle-up__1t6C_",
	"fa-arrow-circle-down": "style_fa-arrow-circle-down__2JhhB",
	"faArrowCircleDown": "style_fa-arrow-circle-down__2JhhB",
	"fa-globe": "style_fa-globe__25Cen",
	"faGlobe": "style_fa-globe__25Cen",
	"fa-wrench": "style_fa-wrench__258HL",
	"faWrench": "style_fa-wrench__258HL",
	"fa-tasks": "style_fa-tasks__2oxZT",
	"faTasks": "style_fa-tasks__2oxZT",
	"fa-filter": "style_fa-filter__3HM1H",
	"faFilter": "style_fa-filter__3HM1H",
	"fa-briefcase": "style_fa-briefcase__2JNBT",
	"faBriefcase": "style_fa-briefcase__2JNBT",
	"fa-arrows-alt": "style_fa-arrows-alt__1sD0o",
	"faArrowsAlt": "style_fa-arrows-alt__1sD0o",
	"fa-group": "style_fa-group__20X3W",
	"faGroup": "style_fa-group__20X3W",
	"fa-users": "style_fa-users__1Wv4i",
	"faUsers": "style_fa-users__1Wv4i",
	"fa-chain": "style_fa-chain__3gkVR",
	"faChain": "style_fa-chain__3gkVR",
	"fa-link": "style_fa-link__15zB7",
	"faLink": "style_fa-link__15zB7",
	"fa-cloud": "style_fa-cloud__1Ddfl",
	"faCloud": "style_fa-cloud__1Ddfl",
	"fa-flask": "style_fa-flask__1wJvc",
	"faFlask": "style_fa-flask__1wJvc",
	"fa-cut": "style_fa-cut___XyZV",
	"faCut": "style_fa-cut___XyZV",
	"fa-scissors": "style_fa-scissors__AYHcI",
	"faScissors": "style_fa-scissors__AYHcI",
	"fa-copy": "style_fa-copy__1Ossh",
	"faCopy": "style_fa-copy__1Ossh",
	"fa-files-o": "style_fa-files-o__3sJJ-",
	"faFilesO": "style_fa-files-o__3sJJ-",
	"fa-paperclip": "style_fa-paperclip__1hTCr",
	"faPaperclip": "style_fa-paperclip__1hTCr",
	"fa-save": "style_fa-save__1LOCv",
	"faSave": "style_fa-save__1LOCv",
	"fa-floppy-o": "style_fa-floppy-o__2TnBm",
	"faFloppyO": "style_fa-floppy-o__2TnBm",
	"fa-square": "style_fa-square__28Zx1",
	"faSquare": "style_fa-square__28Zx1",
	"fa-navicon": "style_fa-navicon__1X1U8",
	"faNavicon": "style_fa-navicon__1X1U8",
	"fa-reorder": "style_fa-reorder__18Czt",
	"faReorder": "style_fa-reorder__18Czt",
	"fa-bars": "style_fa-bars__Wlajt",
	"faBars": "style_fa-bars__Wlajt",
	"fa-list-ul": "style_fa-list-ul__2D7G5",
	"faListUl": "style_fa-list-ul__2D7G5",
	"fa-list-ol": "style_fa-list-ol__C0x7T",
	"faListOl": "style_fa-list-ol__C0x7T",
	"fa-strikethrough": "style_fa-strikethrough__3t6ML",
	"faStrikethrough": "style_fa-strikethrough__3t6ML",
	"fa-underline": "style_fa-underline__1SFb4",
	"faUnderline": "style_fa-underline__1SFb4",
	"fa-table": "style_fa-table__19Se0",
	"faTable": "style_fa-table__19Se0",
	"fa-magic": "style_fa-magic___i3Nz",
	"faMagic": "style_fa-magic___i3Nz",
	"fa-truck": "style_fa-truck__ZtSgC",
	"faTruck": "style_fa-truck__ZtSgC",
	"fa-pinterest": "style_fa-pinterest__22id1",
	"faPinterest": "style_fa-pinterest__22id1",
	"fa-pinterest-square": "style_fa-pinterest-square__369gS",
	"faPinterestSquare": "style_fa-pinterest-square__369gS",
	"fa-google-plus-square": "style_fa-google-plus-square__hBjwt",
	"faGooglePlusSquare": "style_fa-google-plus-square__hBjwt",
	"fa-google-plus": "style_fa-google-plus__3y50_",
	"faGooglePlus": "style_fa-google-plus__3y50_",
	"fa-money": "style_fa-money__1Qjqs",
	"faMoney": "style_fa-money__1Qjqs",
	"fa-caret-down": "style_fa-caret-down__2x_8t",
	"faCaretDown": "style_fa-caret-down__2x_8t",
	"fa-caret-up": "style_fa-caret-up__26GUW",
	"faCaretUp": "style_fa-caret-up__26GUW",
	"fa-caret-left": "style_fa-caret-left__irqU0",
	"faCaretLeft": "style_fa-caret-left__irqU0",
	"fa-caret-right": "style_fa-caret-right__P8lmz",
	"faCaretRight": "style_fa-caret-right__P8lmz",
	"fa-columns": "style_fa-columns__2tlq9",
	"faColumns": "style_fa-columns__2tlq9",
	"fa-unsorted": "style_fa-unsorted__1Kqx5",
	"faUnsorted": "style_fa-unsorted__1Kqx5",
	"fa-sort": "style_fa-sort__OJrdh",
	"faSort": "style_fa-sort__OJrdh",
	"fa-sort-down": "style_fa-sort-down__1Ru3s",
	"faSortDown": "style_fa-sort-down__1Ru3s",
	"fa-sort-desc": "style_fa-sort-desc__2XfG6",
	"faSortDesc": "style_fa-sort-desc__2XfG6",
	"fa-sort-up": "style_fa-sort-up__24qNy",
	"faSortUp": "style_fa-sort-up__24qNy",
	"fa-sort-asc": "style_fa-sort-asc__U5a_d",
	"faSortAsc": "style_fa-sort-asc__U5a_d",
	"fa-envelope": "style_fa-envelope__1AvyZ",
	"faEnvelope": "style_fa-envelope__1AvyZ",
	"fa-linkedin": "style_fa-linkedin__reVK3",
	"faLinkedin": "style_fa-linkedin__reVK3",
	"fa-rotate-left": "style_fa-rotate-left__1KZgM",
	"faRotateLeft": "style_fa-rotate-left__1KZgM",
	"fa-undo": "style_fa-undo__3TtfA",
	"faUndo": "style_fa-undo__3TtfA",
	"fa-legal": "style_fa-legal__3kLMa",
	"faLegal": "style_fa-legal__3kLMa",
	"fa-gavel": "style_fa-gavel__6RQAi",
	"faGavel": "style_fa-gavel__6RQAi",
	"fa-dashboard": "style_fa-dashboard__2DuDP",
	"faDashboard": "style_fa-dashboard__2DuDP",
	"fa-tachometer": "style_fa-tachometer__1cwGN",
	"faTachometer": "style_fa-tachometer__1cwGN",
	"fa-comment-o": "style_fa-comment-o__1JPzx",
	"faCommentO": "style_fa-comment-o__1JPzx",
	"fa-comments-o": "style_fa-comments-o__1bL7J",
	"faCommentsO": "style_fa-comments-o__1bL7J",
	"fa-flash": "style_fa-flash__3nAJC",
	"faFlash": "style_fa-flash__3nAJC",
	"fa-bolt": "style_fa-bolt__2jVjr",
	"faBolt": "style_fa-bolt__2jVjr",
	"fa-sitemap": "style_fa-sitemap__3DNmq",
	"faSitemap": "style_fa-sitemap__3DNmq",
	"fa-umbrella": "style_fa-umbrella__O7zIG",
	"faUmbrella": "style_fa-umbrella__O7zIG",
	"fa-paste": "style_fa-paste__1DC1m",
	"faPaste": "style_fa-paste__1DC1m",
	"fa-clipboard": "style_fa-clipboard__1gVaK",
	"faClipboard": "style_fa-clipboard__1gVaK",
	"fa-lightbulb-o": "style_fa-lightbulb-o__rfE_N",
	"faLightbulbO": "style_fa-lightbulb-o__rfE_N",
	"fa-exchange": "style_fa-exchange__32Bx_",
	"faExchange": "style_fa-exchange__32Bx_",
	"fa-cloud-download": "style_fa-cloud-download__3HJaV",
	"faCloudDownload": "style_fa-cloud-download__3HJaV",
	"fa-cloud-upload": "style_fa-cloud-upload__2mTgC",
	"faCloudUpload": "style_fa-cloud-upload__2mTgC",
	"fa-user-md": "style_fa-user-md__2an77",
	"faUserMd": "style_fa-user-md__2an77",
	"fa-stethoscope": "style_fa-stethoscope__1Vpz0",
	"faStethoscope": "style_fa-stethoscope__1Vpz0",
	"fa-suitcase": "style_fa-suitcase__3CTJq",
	"faSuitcase": "style_fa-suitcase__3CTJq",
	"fa-bell-o": "style_fa-bell-o__zcNr6",
	"faBellO": "style_fa-bell-o__zcNr6",
	"fa-coffee": "style_fa-coffee__2sCU6",
	"faCoffee": "style_fa-coffee__2sCU6",
	"fa-cutlery": "style_fa-cutlery__3Ya5Y",
	"faCutlery": "style_fa-cutlery__3Ya5Y",
	"fa-file-text-o": "style_fa-file-text-o__20xzO",
	"faFileTextO": "style_fa-file-text-o__20xzO",
	"fa-building-o": "style_fa-building-o__2YAYY",
	"faBuildingO": "style_fa-building-o__2YAYY",
	"fa-hospital-o": "style_fa-hospital-o__2nAdh",
	"faHospitalO": "style_fa-hospital-o__2nAdh",
	"fa-ambulance": "style_fa-ambulance__367f4",
	"faAmbulance": "style_fa-ambulance__367f4",
	"fa-medkit": "style_fa-medkit__2umfr",
	"faMedkit": "style_fa-medkit__2umfr",
	"fa-fighter-jet": "style_fa-fighter-jet__1XQZm",
	"faFighterJet": "style_fa-fighter-jet__1XQZm",
	"fa-beer": "style_fa-beer__3F4Fo",
	"faBeer": "style_fa-beer__3F4Fo",
	"fa-h-square": "style_fa-h-square__3UZBQ",
	"faHSquare": "style_fa-h-square__3UZBQ",
	"fa-plus-square": "style_fa-plus-square__2pCA8",
	"faPlusSquare": "style_fa-plus-square__2pCA8",
	"fa-angle-double-left": "style_fa-angle-double-left__34cFJ",
	"faAngleDoubleLeft": "style_fa-angle-double-left__34cFJ",
	"fa-angle-double-right": "style_fa-angle-double-right__sfWlQ",
	"faAngleDoubleRight": "style_fa-angle-double-right__sfWlQ",
	"fa-angle-double-up": "style_fa-angle-double-up__XjAIq",
	"faAngleDoubleUp": "style_fa-angle-double-up__XjAIq",
	"fa-angle-double-down": "style_fa-angle-double-down__2eg81",
	"faAngleDoubleDown": "style_fa-angle-double-down__2eg81",
	"fa-angle-left": "style_fa-angle-left__DUgjE",
	"faAngleLeft": "style_fa-angle-left__DUgjE",
	"fa-angle-right": "style_fa-angle-right__3V_P0",
	"faAngleRight": "style_fa-angle-right__3V_P0",
	"fa-angle-up": "style_fa-angle-up__2csFP",
	"faAngleUp": "style_fa-angle-up__2csFP",
	"fa-angle-down": "style_fa-angle-down__1gNw4",
	"faAngleDown": "style_fa-angle-down__1gNw4",
	"fa-desktop": "style_fa-desktop__2xX4m",
	"faDesktop": "style_fa-desktop__2xX4m",
	"fa-laptop": "style_fa-laptop__3MT5H",
	"faLaptop": "style_fa-laptop__3MT5H",
	"fa-tablet": "style_fa-tablet__1JL66",
	"faTablet": "style_fa-tablet__1JL66",
	"fa-mobile-phone": "style_fa-mobile-phone__32S3m",
	"faMobilePhone": "style_fa-mobile-phone__32S3m",
	"fa-mobile": "style_fa-mobile__1pbSy",
	"faMobile": "style_fa-mobile__1pbSy",
	"fa-circle-o": "style_fa-circle-o__1Yyd-",
	"faCircleO": "style_fa-circle-o__1Yyd-",
	"fa-quote-left": "style_fa-quote-left__DjQVx",
	"faQuoteLeft": "style_fa-quote-left__DjQVx",
	"fa-quote-right": "style_fa-quote-right__1mvs9",
	"faQuoteRight": "style_fa-quote-right__1mvs9",
	"fa-spinner": "style_fa-spinner__3HVZk",
	"faSpinner": "style_fa-spinner__3HVZk",
	"fa-circle": "style_fa-circle__2snKq",
	"faCircle": "style_fa-circle__2snKq",
	"fa-mail-reply": "style_fa-mail-reply__2AC6z",
	"faMailReply": "style_fa-mail-reply__2AC6z",
	"fa-reply": "style_fa-reply__3G6Se",
	"faReply": "style_fa-reply__3G6Se",
	"fa-github-alt": "style_fa-github-alt__x_v-T",
	"faGithubAlt": "style_fa-github-alt__x_v-T",
	"fa-folder-o": "style_fa-folder-o__2VA-0",
	"faFolderO": "style_fa-folder-o__2VA-0",
	"fa-folder-open-o": "style_fa-folder-open-o__3RqaW",
	"faFolderOpenO": "style_fa-folder-open-o__3RqaW",
	"fa-smile-o": "style_fa-smile-o__3KiYu",
	"faSmileO": "style_fa-smile-o__3KiYu",
	"fa-frown-o": "style_fa-frown-o__3H7-N",
	"faFrownO": "style_fa-frown-o__3H7-N",
	"fa-meh-o": "style_fa-meh-o__3-bgG",
	"faMehO": "style_fa-meh-o__3-bgG",
	"fa-gamepad": "style_fa-gamepad__mPyU7",
	"faGamepad": "style_fa-gamepad__mPyU7",
	"fa-keyboard-o": "style_fa-keyboard-o__wAOHk",
	"faKeyboardO": "style_fa-keyboard-o__wAOHk",
	"fa-flag-o": "style_fa-flag-o__321XR",
	"faFlagO": "style_fa-flag-o__321XR",
	"fa-flag-checkered": "style_fa-flag-checkered__2VtGO",
	"faFlagCheckered": "style_fa-flag-checkered__2VtGO",
	"fa-terminal": "style_fa-terminal__1fUHJ",
	"faTerminal": "style_fa-terminal__1fUHJ",
	"fa-code": "style_fa-code__SRKGP",
	"faCode": "style_fa-code__SRKGP",
	"fa-mail-reply-all": "style_fa-mail-reply-all__Lz9Ih",
	"faMailReplyAll": "style_fa-mail-reply-all__Lz9Ih",
	"fa-reply-all": "style_fa-reply-all__1t63J",
	"faReplyAll": "style_fa-reply-all__1t63J",
	"fa-star-half-empty": "style_fa-star-half-empty__19XZq",
	"faStarHalfEmpty": "style_fa-star-half-empty__19XZq",
	"fa-star-half-full": "style_fa-star-half-full__3Y45l",
	"faStarHalfFull": "style_fa-star-half-full__3Y45l",
	"fa-star-half-o": "style_fa-star-half-o__a-5to",
	"faStarHalfO": "style_fa-star-half-o__a-5to",
	"fa-location-arrow": "style_fa-location-arrow__2qgJ1",
	"faLocationArrow": "style_fa-location-arrow__2qgJ1",
	"fa-crop": "style_fa-crop__2OK7-",
	"faCrop": "style_fa-crop__2OK7-",
	"fa-code-fork": "style_fa-code-fork__1WC5P",
	"faCodeFork": "style_fa-code-fork__1WC5P",
	"fa-unlink": "style_fa-unlink__2vPUr",
	"faUnlink": "style_fa-unlink__2vPUr",
	"fa-chain-broken": "style_fa-chain-broken__UtNIl",
	"faChainBroken": "style_fa-chain-broken__UtNIl",
	"fa-question": "style_fa-question__3Y6e1",
	"faQuestion": "style_fa-question__3Y6e1",
	"fa-info": "style_fa-info__1YJhf",
	"faInfo": "style_fa-info__1YJhf",
	"fa-exclamation": "style_fa-exclamation__1gQg6",
	"faExclamation": "style_fa-exclamation__1gQg6",
	"fa-superscript": "style_fa-superscript__2w6Zr",
	"faSuperscript": "style_fa-superscript__2w6Zr",
	"fa-subscript": "style_fa-subscript__14RTM",
	"faSubscript": "style_fa-subscript__14RTM",
	"fa-eraser": "style_fa-eraser__S3iJb",
	"faEraser": "style_fa-eraser__S3iJb",
	"fa-puzzle-piece": "style_fa-puzzle-piece__199HV",
	"faPuzzlePiece": "style_fa-puzzle-piece__199HV",
	"fa-microphone": "style_fa-microphone__27dax",
	"faMicrophone": "style_fa-microphone__27dax",
	"fa-microphone-slash": "style_fa-microphone-slash__3oZE7",
	"faMicrophoneSlash": "style_fa-microphone-slash__3oZE7",
	"fa-shield": "style_fa-shield__3DkNX",
	"faShield": "style_fa-shield__3DkNX",
	"fa-calendar-o": "style_fa-calendar-o__S43Cp",
	"faCalendarO": "style_fa-calendar-o__S43Cp",
	"fa-fire-extinguisher": "style_fa-fire-extinguisher__pDFqQ",
	"faFireExtinguisher": "style_fa-fire-extinguisher__pDFqQ",
	"fa-rocket": "style_fa-rocket__35oGO",
	"faRocket": "style_fa-rocket__35oGO",
	"fa-maxcdn": "style_fa-maxcdn__fFV60",
	"faMaxcdn": "style_fa-maxcdn__fFV60",
	"fa-chevron-circle-left": "style_fa-chevron-circle-left__3Ylxn",
	"faChevronCircleLeft": "style_fa-chevron-circle-left__3Ylxn",
	"fa-chevron-circle-right": "style_fa-chevron-circle-right__3cfR0",
	"faChevronCircleRight": "style_fa-chevron-circle-right__3cfR0",
	"fa-chevron-circle-up": "style_fa-chevron-circle-up__1NCOc",
	"faChevronCircleUp": "style_fa-chevron-circle-up__1NCOc",
	"fa-chevron-circle-down": "style_fa-chevron-circle-down__1ZTjz",
	"faChevronCircleDown": "style_fa-chevron-circle-down__1ZTjz",
	"fa-html5": "style_fa-html5__2AmMy",
	"faHtml5": "style_fa-html5__2AmMy",
	"fa-css3": "style_fa-css3__197Tg",
	"faCss3": "style_fa-css3__197Tg",
	"fa-anchor": "style_fa-anchor__CwQXw",
	"faAnchor": "style_fa-anchor__CwQXw",
	"fa-unlock-alt": "style_fa-unlock-alt__33y20",
	"faUnlockAlt": "style_fa-unlock-alt__33y20",
	"fa-bullseye": "style_fa-bullseye__3Fzdl",
	"faBullseye": "style_fa-bullseye__3Fzdl",
	"fa-ellipsis-h": "style_fa-ellipsis-h__1xO9Y",
	"faEllipsisH": "style_fa-ellipsis-h__1xO9Y",
	"fa-ellipsis-v": "style_fa-ellipsis-v__DGE5R",
	"faEllipsisV": "style_fa-ellipsis-v__DGE5R",
	"fa-rss-square": "style_fa-rss-square__1EZtw",
	"faRssSquare": "style_fa-rss-square__1EZtw",
	"fa-play-circle": "style_fa-play-circle__1UNzy",
	"faPlayCircle": "style_fa-play-circle__1UNzy",
	"fa-ticket": "style_fa-ticket__2Hhzi",
	"faTicket": "style_fa-ticket__2Hhzi",
	"fa-minus-square": "style_fa-minus-square__3rxP2",
	"faMinusSquare": "style_fa-minus-square__3rxP2",
	"fa-minus-square-o": "style_fa-minus-square-o__3Qd79",
	"faMinusSquareO": "style_fa-minus-square-o__3Qd79",
	"fa-level-up": "style_fa-level-up__3W8ml",
	"faLevelUp": "style_fa-level-up__3W8ml",
	"fa-level-down": "style_fa-level-down__2hdzw",
	"faLevelDown": "style_fa-level-down__2hdzw",
	"fa-check-square": "style_fa-check-square__PXToN",
	"faCheckSquare": "style_fa-check-square__PXToN",
	"fa-pencil-square": "style_fa-pencil-square__3BxAj",
	"faPencilSquare": "style_fa-pencil-square__3BxAj",
	"fa-external-link-square": "style_fa-external-link-square__1BIFy",
	"faExternalLinkSquare": "style_fa-external-link-square__1BIFy",
	"fa-share-square": "style_fa-share-square__1V1tB",
	"faShareSquare": "style_fa-share-square__1V1tB",
	"fa-compass": "style_fa-compass__2SPjB",
	"faCompass": "style_fa-compass__2SPjB",
	"fa-toggle-down": "style_fa-toggle-down__3JopC",
	"faToggleDown": "style_fa-toggle-down__3JopC",
	"fa-caret-square-o-down": "style_fa-caret-square-o-down__2E4Mb",
	"faCaretSquareODown": "style_fa-caret-square-o-down__2E4Mb",
	"fa-toggle-up": "style_fa-toggle-up__1vJD0",
	"faToggleUp": "style_fa-toggle-up__1vJD0",
	"fa-caret-square-o-up": "style_fa-caret-square-o-up__1VOkN",
	"faCaretSquareOUp": "style_fa-caret-square-o-up__1VOkN",
	"fa-toggle-right": "style_fa-toggle-right__1vs4i",
	"faToggleRight": "style_fa-toggle-right__1vs4i",
	"fa-caret-square-o-right": "style_fa-caret-square-o-right__2U1ay",
	"faCaretSquareORight": "style_fa-caret-square-o-right__2U1ay",
	"fa-euro": "style_fa-euro__1jXcx",
	"faEuro": "style_fa-euro__1jXcx",
	"fa-eur": "style_fa-eur__3MXW5",
	"faEur": "style_fa-eur__3MXW5",
	"fa-gbp": "style_fa-gbp__2Ps1g",
	"faGbp": "style_fa-gbp__2Ps1g",
	"fa-dollar": "style_fa-dollar__3Pc9r",
	"faDollar": "style_fa-dollar__3Pc9r",
	"fa-usd": "style_fa-usd__3Iq-9",
	"faUsd": "style_fa-usd__3Iq-9",
	"fa-rupee": "style_fa-rupee__1NZ0t",
	"faRupee": "style_fa-rupee__1NZ0t",
	"fa-inr": "style_fa-inr__XhhvZ",
	"faInr": "style_fa-inr__XhhvZ",
	"fa-cny": "style_fa-cny__2vF4f",
	"faCny": "style_fa-cny__2vF4f",
	"fa-rmb": "style_fa-rmb__14IpQ",
	"faRmb": "style_fa-rmb__14IpQ",
	"fa-yen": "style_fa-yen__3rbpG",
	"faYen": "style_fa-yen__3rbpG",
	"fa-jpy": "style_fa-jpy__6ngge",
	"faJpy": "style_fa-jpy__6ngge",
	"fa-ruble": "style_fa-ruble__1MHOp",
	"faRuble": "style_fa-ruble__1MHOp",
	"fa-rouble": "style_fa-rouble__2UTPI",
	"faRouble": "style_fa-rouble__2UTPI",
	"fa-rub": "style_fa-rub__3PmCg",
	"faRub": "style_fa-rub__3PmCg",
	"fa-won": "style_fa-won__1buvn",
	"faWon": "style_fa-won__1buvn",
	"fa-krw": "style_fa-krw__11g7e",
	"faKrw": "style_fa-krw__11g7e",
	"fa-bitcoin": "style_fa-bitcoin__1Pk94",
	"faBitcoin": "style_fa-bitcoin__1Pk94",
	"fa-btc": "style_fa-btc__3b4vn",
	"faBtc": "style_fa-btc__3b4vn",
	"fa-file": "style_fa-file__3PW0K",
	"faFile": "style_fa-file__3PW0K",
	"fa-file-text": "style_fa-file-text__1i0b9",
	"faFileText": "style_fa-file-text__1i0b9",
	"fa-sort-alpha-asc": "style_fa-sort-alpha-asc__3Wl8L",
	"faSortAlphaAsc": "style_fa-sort-alpha-asc__3Wl8L",
	"fa-sort-alpha-desc": "style_fa-sort-alpha-desc__X0x0e",
	"faSortAlphaDesc": "style_fa-sort-alpha-desc__X0x0e",
	"fa-sort-amount-asc": "style_fa-sort-amount-asc__2VAur",
	"faSortAmountAsc": "style_fa-sort-amount-asc__2VAur",
	"fa-sort-amount-desc": "style_fa-sort-amount-desc__3wj0k",
	"faSortAmountDesc": "style_fa-sort-amount-desc__3wj0k",
	"fa-sort-numeric-asc": "style_fa-sort-numeric-asc__2roSh",
	"faSortNumericAsc": "style_fa-sort-numeric-asc__2roSh",
	"fa-sort-numeric-desc": "style_fa-sort-numeric-desc__1qZDn",
	"faSortNumericDesc": "style_fa-sort-numeric-desc__1qZDn",
	"fa-thumbs-up": "style_fa-thumbs-up__1Wg1I",
	"faThumbsUp": "style_fa-thumbs-up__1Wg1I",
	"fa-thumbs-down": "style_fa-thumbs-down__2xAxS",
	"faThumbsDown": "style_fa-thumbs-down__2xAxS",
	"fa-youtube-square": "style_fa-youtube-square__3nFIw",
	"faYoutubeSquare": "style_fa-youtube-square__3nFIw",
	"fa-youtube": "style_fa-youtube__31ODZ",
	"faYoutube": "style_fa-youtube__31ODZ",
	"fa-xing": "style_fa-xing__27cX2",
	"faXing": "style_fa-xing__27cX2",
	"fa-xing-square": "style_fa-xing-square__35esg",
	"faXingSquare": "style_fa-xing-square__35esg",
	"fa-youtube-play": "style_fa-youtube-play__2C5gj",
	"faYoutubePlay": "style_fa-youtube-play__2C5gj",
	"fa-dropbox": "style_fa-dropbox__1d8d4",
	"faDropbox": "style_fa-dropbox__1d8d4",
	"fa-stack-overflow": "style_fa-stack-overflow__2GZ-H",
	"faStackOverflow": "style_fa-stack-overflow__2GZ-H",
	"fa-instagram": "style_fa-instagram__3fb9Q",
	"faInstagram": "style_fa-instagram__3fb9Q",
	"fa-flickr": "style_fa-flickr__WhIVy",
	"faFlickr": "style_fa-flickr__WhIVy",
	"fa-adn": "style_fa-adn__3-Z8l",
	"faAdn": "style_fa-adn__3-Z8l",
	"fa-bitbucket": "style_fa-bitbucket__CbNjZ",
	"faBitbucket": "style_fa-bitbucket__CbNjZ",
	"fa-bitbucket-square": "style_fa-bitbucket-square__t0VxH",
	"faBitbucketSquare": "style_fa-bitbucket-square__t0VxH",
	"fa-tumblr": "style_fa-tumblr__2_oM_",
	"faTumblr": "style_fa-tumblr__2_oM_",
	"fa-tumblr-square": "style_fa-tumblr-square__3F7CC",
	"faTumblrSquare": "style_fa-tumblr-square__3F7CC",
	"fa-long-arrow-down": "style_fa-long-arrow-down__2oVs-",
	"faLongArrowDown": "style_fa-long-arrow-down__2oVs-",
	"fa-long-arrow-up": "style_fa-long-arrow-up__bklzU",
	"faLongArrowUp": "style_fa-long-arrow-up__bklzU",
	"fa-long-arrow-left": "style_fa-long-arrow-left__3APTL",
	"faLongArrowLeft": "style_fa-long-arrow-left__3APTL",
	"fa-long-arrow-right": "style_fa-long-arrow-right__21tW8",
	"faLongArrowRight": "style_fa-long-arrow-right__21tW8",
	"fa-apple": "style_fa-apple__1wtga",
	"faApple": "style_fa-apple__1wtga",
	"fa-windows": "style_fa-windows__19Xi6",
	"faWindows": "style_fa-windows__19Xi6",
	"fa-android": "style_fa-android__2vJKQ",
	"faAndroid": "style_fa-android__2vJKQ",
	"fa-linux": "style_fa-linux__1dLmz",
	"faLinux": "style_fa-linux__1dLmz",
	"fa-dribbble": "style_fa-dribbble__ZWptF",
	"faDribbble": "style_fa-dribbble__ZWptF",
	"fa-skype": "style_fa-skype__27gQr",
	"faSkype": "style_fa-skype__27gQr",
	"fa-foursquare": "style_fa-foursquare__3QNVL",
	"faFoursquare": "style_fa-foursquare__3QNVL",
	"fa-trello": "style_fa-trello__2sbpV",
	"faTrello": "style_fa-trello__2sbpV",
	"fa-female": "style_fa-female__2gRF2",
	"faFemale": "style_fa-female__2gRF2",
	"fa-male": "style_fa-male__1CNvk",
	"faMale": "style_fa-male__1CNvk",
	"fa-gittip": "style_fa-gittip__mo97w",
	"faGittip": "style_fa-gittip__mo97w",
	"fa-gratipay": "style_fa-gratipay__3YS56",
	"faGratipay": "style_fa-gratipay__3YS56",
	"fa-sun-o": "style_fa-sun-o__2iTX9",
	"faSunO": "style_fa-sun-o__2iTX9",
	"fa-moon-o": "style_fa-moon-o__1SqMg",
	"faMoonO": "style_fa-moon-o__1SqMg",
	"fa-archive": "style_fa-archive__3VLlT",
	"faArchive": "style_fa-archive__3VLlT",
	"fa-bug": "style_fa-bug__2fFru",
	"faBug": "style_fa-bug__2fFru",
	"fa-vk": "style_fa-vk__3KpkN",
	"faVk": "style_fa-vk__3KpkN",
	"fa-weibo": "style_fa-weibo__2RfmV",
	"faWeibo": "style_fa-weibo__2RfmV",
	"fa-renren": "style_fa-renren__1QDdr",
	"faRenren": "style_fa-renren__1QDdr",
	"fa-pagelines": "style_fa-pagelines__fm95T",
	"faPagelines": "style_fa-pagelines__fm95T",
	"fa-stack-exchange": "style_fa-stack-exchange__2qfzD",
	"faStackExchange": "style_fa-stack-exchange__2qfzD",
	"fa-arrow-circle-o-right": "style_fa-arrow-circle-o-right__K7ffa",
	"faArrowCircleORight": "style_fa-arrow-circle-o-right__K7ffa",
	"fa-arrow-circle-o-left": "style_fa-arrow-circle-o-left__3EN-J",
	"faArrowCircleOLeft": "style_fa-arrow-circle-o-left__3EN-J",
	"fa-toggle-left": "style_fa-toggle-left__2etkD",
	"faToggleLeft": "style_fa-toggle-left__2etkD",
	"fa-caret-square-o-left": "style_fa-caret-square-o-left__3gHuI",
	"faCaretSquareOLeft": "style_fa-caret-square-o-left__3gHuI",
	"fa-dot-circle-o": "style_fa-dot-circle-o__1QlOs",
	"faDotCircleO": "style_fa-dot-circle-o__1QlOs",
	"fa-wheelchair": "style_fa-wheelchair__3DlnR",
	"faWheelchair": "style_fa-wheelchair__3DlnR",
	"fa-vimeo-square": "style_fa-vimeo-square__2QJq0",
	"faVimeoSquare": "style_fa-vimeo-square__2QJq0",
	"fa-turkish-lira": "style_fa-turkish-lira__uIPlz",
	"faTurkishLira": "style_fa-turkish-lira__uIPlz",
	"fa-try": "style_fa-try__B8huM",
	"faTry": "style_fa-try__B8huM",
	"fa-plus-square-o": "style_fa-plus-square-o__15P7a",
	"faPlusSquareO": "style_fa-plus-square-o__15P7a",
	"fa-space-shuttle": "style_fa-space-shuttle__zzUXH",
	"faSpaceShuttle": "style_fa-space-shuttle__zzUXH",
	"fa-slack": "style_fa-slack__1WXhk",
	"faSlack": "style_fa-slack__1WXhk",
	"fa-envelope-square": "style_fa-envelope-square__3j9ps",
	"faEnvelopeSquare": "style_fa-envelope-square__3j9ps",
	"fa-wordpress": "style_fa-wordpress__2xzZ6",
	"faWordpress": "style_fa-wordpress__2xzZ6",
	"fa-openid": "style_fa-openid__D94GP",
	"faOpenid": "style_fa-openid__D94GP",
	"fa-institution": "style_fa-institution__2hjdN",
	"faInstitution": "style_fa-institution__2hjdN",
	"fa-bank": "style_fa-bank__3rkbQ",
	"faBank": "style_fa-bank__3rkbQ",
	"fa-university": "style_fa-university__3HLWm",
	"faUniversity": "style_fa-university__3HLWm",
	"fa-mortar-board": "style_fa-mortar-board__lir21",
	"faMortarBoard": "style_fa-mortar-board__lir21",
	"fa-graduation-cap": "style_fa-graduation-cap__Mv-zi",
	"faGraduationCap": "style_fa-graduation-cap__Mv-zi",
	"fa-yahoo": "style_fa-yahoo__3KkpO",
	"faYahoo": "style_fa-yahoo__3KkpO",
	"fa-google": "style_fa-google__3FGuH",
	"faGoogle": "style_fa-google__3FGuH",
	"fa-reddit": "style_fa-reddit__11v_6",
	"faReddit": "style_fa-reddit__11v_6",
	"fa-reddit-square": "style_fa-reddit-square__3lV5F",
	"faRedditSquare": "style_fa-reddit-square__3lV5F",
	"fa-stumbleupon-circle": "style_fa-stumbleupon-circle__3aLV5",
	"faStumbleuponCircle": "style_fa-stumbleupon-circle__3aLV5",
	"fa-stumbleupon": "style_fa-stumbleupon__YCZC2",
	"faStumbleupon": "style_fa-stumbleupon__YCZC2",
	"fa-delicious": "style_fa-delicious__3_9p9",
	"faDelicious": "style_fa-delicious__3_9p9",
	"fa-digg": "style_fa-digg__Aqqnb",
	"faDigg": "style_fa-digg__Aqqnb",
	"fa-pied-piper-pp": "style_fa-pied-piper-pp__2Jh-d",
	"faPiedPiperPp": "style_fa-pied-piper-pp__2Jh-d",
	"fa-pied-piper-alt": "style_fa-pied-piper-alt__1RYAN",
	"faPiedPiperAlt": "style_fa-pied-piper-alt__1RYAN",
	"fa-drupal": "style_fa-drupal__2CBnI",
	"faDrupal": "style_fa-drupal__2CBnI",
	"fa-joomla": "style_fa-joomla__2jLpt",
	"faJoomla": "style_fa-joomla__2jLpt",
	"fa-language": "style_fa-language__12ZtE",
	"faLanguage": "style_fa-language__12ZtE",
	"fa-fax": "style_fa-fax__2brsY",
	"faFax": "style_fa-fax__2brsY",
	"fa-building": "style_fa-building__3gMtm",
	"faBuilding": "style_fa-building__3gMtm",
	"fa-child": "style_fa-child__aLfmj",
	"faChild": "style_fa-child__aLfmj",
	"fa-paw": "style_fa-paw__3AdLQ",
	"faPaw": "style_fa-paw__3AdLQ",
	"fa-spoon": "style_fa-spoon__31Ta2",
	"faSpoon": "style_fa-spoon__31Ta2",
	"fa-cube": "style_fa-cube__E4C4A",
	"faCube": "style_fa-cube__E4C4A",
	"fa-cubes": "style_fa-cubes__1Oc2M",
	"faCubes": "style_fa-cubes__1Oc2M",
	"fa-behance": "style_fa-behance__3xSZc",
	"faBehance": "style_fa-behance__3xSZc",
	"fa-behance-square": "style_fa-behance-square__3Nx9s",
	"faBehanceSquare": "style_fa-behance-square__3Nx9s",
	"fa-steam": "style_fa-steam__1qOBr",
	"faSteam": "style_fa-steam__1qOBr",
	"fa-steam-square": "style_fa-steam-square__1uMzy",
	"faSteamSquare": "style_fa-steam-square__1uMzy",
	"fa-recycle": "style_fa-recycle__109Ji",
	"faRecycle": "style_fa-recycle__109Ji",
	"fa-automobile": "style_fa-automobile__rH9KD",
	"faAutomobile": "style_fa-automobile__rH9KD",
	"fa-car": "style_fa-car__3jJSC",
	"faCar": "style_fa-car__3jJSC",
	"fa-cab": "style_fa-cab__2AAWR",
	"faCab": "style_fa-cab__2AAWR",
	"fa-taxi": "style_fa-taxi__16hc8",
	"faTaxi": "style_fa-taxi__16hc8",
	"fa-tree": "style_fa-tree__3TAew",
	"faTree": "style_fa-tree__3TAew",
	"fa-spotify": "style_fa-spotify__3zndM",
	"faSpotify": "style_fa-spotify__3zndM",
	"fa-deviantart": "style_fa-deviantart__k7QPs",
	"faDeviantart": "style_fa-deviantart__k7QPs",
	"fa-soundcloud": "style_fa-soundcloud__21KtU",
	"faSoundcloud": "style_fa-soundcloud__21KtU",
	"fa-database": "style_fa-database__3x11l",
	"faDatabase": "style_fa-database__3x11l",
	"fa-file-pdf-o": "style_fa-file-pdf-o__1UWXX",
	"faFilePdfO": "style_fa-file-pdf-o__1UWXX",
	"fa-file-word-o": "style_fa-file-word-o__Zxcy6",
	"faFileWordO": "style_fa-file-word-o__Zxcy6",
	"fa-file-excel-o": "style_fa-file-excel-o__3tuIt",
	"faFileExcelO": "style_fa-file-excel-o__3tuIt",
	"fa-file-powerpoint-o": "style_fa-file-powerpoint-o__2ldG5",
	"faFilePowerpointO": "style_fa-file-powerpoint-o__2ldG5",
	"fa-file-photo-o": "style_fa-file-photo-o__3syks",
	"faFilePhotoO": "style_fa-file-photo-o__3syks",
	"fa-file-picture-o": "style_fa-file-picture-o__1ZXeo",
	"faFilePictureO": "style_fa-file-picture-o__1ZXeo",
	"fa-file-image-o": "style_fa-file-image-o__1N9tp",
	"faFileImageO": "style_fa-file-image-o__1N9tp",
	"fa-file-zip-o": "style_fa-file-zip-o__1AycK",
	"faFileZipO": "style_fa-file-zip-o__1AycK",
	"fa-file-archive-o": "style_fa-file-archive-o__10aGo",
	"faFileArchiveO": "style_fa-file-archive-o__10aGo",
	"fa-file-sound-o": "style_fa-file-sound-o__VeT3V",
	"faFileSoundO": "style_fa-file-sound-o__VeT3V",
	"fa-file-audio-o": "style_fa-file-audio-o__Gfwou",
	"faFileAudioO": "style_fa-file-audio-o__Gfwou",
	"fa-file-movie-o": "style_fa-file-movie-o__3ichx",
	"faFileMovieO": "style_fa-file-movie-o__3ichx",
	"fa-file-video-o": "style_fa-file-video-o__3Jcv3",
	"faFileVideoO": "style_fa-file-video-o__3Jcv3",
	"fa-file-code-o": "style_fa-file-code-o__2K797",
	"faFileCodeO": "style_fa-file-code-o__2K797",
	"fa-vine": "style_fa-vine__3OeCe",
	"faVine": "style_fa-vine__3OeCe",
	"fa-codepen": "style_fa-codepen__1dXdy",
	"faCodepen": "style_fa-codepen__1dXdy",
	"fa-jsfiddle": "style_fa-jsfiddle__3UgBp",
	"faJsfiddle": "style_fa-jsfiddle__3UgBp",
	"fa-life-bouy": "style_fa-life-bouy__1_S3D",
	"faLifeBouy": "style_fa-life-bouy__1_S3D",
	"fa-life-buoy": "style_fa-life-buoy__ve2oz",
	"faLifeBuoy": "style_fa-life-buoy__ve2oz",
	"fa-life-saver": "style_fa-life-saver__ACpfj",
	"faLifeSaver": "style_fa-life-saver__ACpfj",
	"fa-support": "style_fa-support__3m5m6",
	"faSupport": "style_fa-support__3m5m6",
	"fa-life-ring": "style_fa-life-ring__25W_g",
	"faLifeRing": "style_fa-life-ring__25W_g",
	"fa-circle-o-notch": "style_fa-circle-o-notch__3cukx",
	"faCircleONotch": "style_fa-circle-o-notch__3cukx",
	"fa-ra": "style_fa-ra__1BSfX",
	"faRa": "style_fa-ra__1BSfX",
	"fa-resistance": "style_fa-resistance__1R8LL",
	"faResistance": "style_fa-resistance__1R8LL",
	"fa-rebel": "style_fa-rebel__yZmt9",
	"faRebel": "style_fa-rebel__yZmt9",
	"fa-ge": "style_fa-ge__3Jxbo",
	"faGe": "style_fa-ge__3Jxbo",
	"fa-empire": "style_fa-empire__2MYaA",
	"faEmpire": "style_fa-empire__2MYaA",
	"fa-git-square": "style_fa-git-square__2fz0z",
	"faGitSquare": "style_fa-git-square__2fz0z",
	"fa-git": "style_fa-git__273FN",
	"faGit": "style_fa-git__273FN",
	"fa-y-combinator-square": "style_fa-y-combinator-square__1kZaq",
	"faYCombinatorSquare": "style_fa-y-combinator-square__1kZaq",
	"fa-yc-square": "style_fa-yc-square__2rvQu",
	"faYcSquare": "style_fa-yc-square__2rvQu",
	"fa-hacker-news": "style_fa-hacker-news__1BOsy",
	"faHackerNews": "style_fa-hacker-news__1BOsy",
	"fa-tencent-weibo": "style_fa-tencent-weibo__3QMpj",
	"faTencentWeibo": "style_fa-tencent-weibo__3QMpj",
	"fa-qq": "style_fa-qq__32_v9",
	"faQq": "style_fa-qq__32_v9",
	"fa-wechat": "style_fa-wechat__3RMBl",
	"faWechat": "style_fa-wechat__3RMBl",
	"fa-weixin": "style_fa-weixin__PIRz-",
	"faWeixin": "style_fa-weixin__PIRz-",
	"fa-send": "style_fa-send__XzgHa",
	"faSend": "style_fa-send__XzgHa",
	"fa-paper-plane": "style_fa-paper-plane__22F4t",
	"faPaperPlane": "style_fa-paper-plane__22F4t",
	"fa-send-o": "style_fa-send-o__1VUws",
	"faSendO": "style_fa-send-o__1VUws",
	"fa-paper-plane-o": "style_fa-paper-plane-o__rthxb",
	"faPaperPlaneO": "style_fa-paper-plane-o__rthxb",
	"fa-history": "style_fa-history__3jmj5",
	"faHistory": "style_fa-history__3jmj5",
	"fa-circle-thin": "style_fa-circle-thin__pujpG",
	"faCircleThin": "style_fa-circle-thin__pujpG",
	"fa-header": "style_fa-header__3M7hI",
	"faHeader": "style_fa-header__3M7hI",
	"fa-paragraph": "style_fa-paragraph__AHVpO",
	"faParagraph": "style_fa-paragraph__AHVpO",
	"fa-sliders": "style_fa-sliders__3qlRM",
	"faSliders": "style_fa-sliders__3qlRM",
	"fa-share-alt": "style_fa-share-alt__3pA8S",
	"faShareAlt": "style_fa-share-alt__3pA8S",
	"fa-share-alt-square": "style_fa-share-alt-square__2TLPh",
	"faShareAltSquare": "style_fa-share-alt-square__2TLPh",
	"fa-bomb": "style_fa-bomb__9R958",
	"faBomb": "style_fa-bomb__9R958",
	"fa-soccer-ball-o": "style_fa-soccer-ball-o__3Zpz3",
	"faSoccerBallO": "style_fa-soccer-ball-o__3Zpz3",
	"fa-futbol-o": "style_fa-futbol-o__1a0Ku",
	"faFutbolO": "style_fa-futbol-o__1a0Ku",
	"fa-tty": "style_fa-tty__3dhCE",
	"faTty": "style_fa-tty__3dhCE",
	"fa-binoculars": "style_fa-binoculars__1lRi4",
	"faBinoculars": "style_fa-binoculars__1lRi4",
	"fa-plug": "style_fa-plug__4R_-Z",
	"faPlug": "style_fa-plug__4R_-Z",
	"fa-slideshare": "style_fa-slideshare__2AFjK",
	"faSlideshare": "style_fa-slideshare__2AFjK",
	"fa-twitch": "style_fa-twitch__2pHuI",
	"faTwitch": "style_fa-twitch__2pHuI",
	"fa-yelp": "style_fa-yelp__3uIb0",
	"faYelp": "style_fa-yelp__3uIb0",
	"fa-newspaper-o": "style_fa-newspaper-o__2uVdd",
	"faNewspaperO": "style_fa-newspaper-o__2uVdd",
	"fa-wifi": "style_fa-wifi__I10MG",
	"faWifi": "style_fa-wifi__I10MG",
	"fa-calculator": "style_fa-calculator__2peOS",
	"faCalculator": "style_fa-calculator__2peOS",
	"fa-paypal": "style_fa-paypal__3ZedC",
	"faPaypal": "style_fa-paypal__3ZedC",
	"fa-google-wallet": "style_fa-google-wallet__1xZG3",
	"faGoogleWallet": "style_fa-google-wallet__1xZG3",
	"fa-cc-visa": "style_fa-cc-visa__3wYa7",
	"faCcVisa": "style_fa-cc-visa__3wYa7",
	"fa-cc-mastercard": "style_fa-cc-mastercard__x-8Hg",
	"faCcMastercard": "style_fa-cc-mastercard__x-8Hg",
	"fa-cc-discover": "style_fa-cc-discover__WkJEt",
	"faCcDiscover": "style_fa-cc-discover__WkJEt",
	"fa-cc-amex": "style_fa-cc-amex__QATKk",
	"faCcAmex": "style_fa-cc-amex__QATKk",
	"fa-cc-paypal": "style_fa-cc-paypal__31MqT",
	"faCcPaypal": "style_fa-cc-paypal__31MqT",
	"fa-cc-stripe": "style_fa-cc-stripe__27I4-",
	"faCcStripe": "style_fa-cc-stripe__27I4-",
	"fa-bell-slash": "style_fa-bell-slash__2wVQT",
	"faBellSlash": "style_fa-bell-slash__2wVQT",
	"fa-bell-slash-o": "style_fa-bell-slash-o__3q6J0",
	"faBellSlashO": "style_fa-bell-slash-o__3q6J0",
	"fa-trash": "style_fa-trash__2nsCq",
	"faTrash": "style_fa-trash__2nsCq",
	"fa-copyright": "style_fa-copyright__36jSb",
	"faCopyright": "style_fa-copyright__36jSb",
	"fa-at": "style_fa-at__1gbqK",
	"faAt": "style_fa-at__1gbqK",
	"fa-eyedropper": "style_fa-eyedropper__2sfZR",
	"faEyedropper": "style_fa-eyedropper__2sfZR",
	"fa-paint-brush": "style_fa-paint-brush__29gLz",
	"faPaintBrush": "style_fa-paint-brush__29gLz",
	"fa-birthday-cake": "style_fa-birthday-cake__2LFE-",
	"faBirthdayCake": "style_fa-birthday-cake__2LFE-",
	"fa-area-chart": "style_fa-area-chart__2xoVG",
	"faAreaChart": "style_fa-area-chart__2xoVG",
	"fa-pie-chart": "style_fa-pie-chart__Lt9J9",
	"faPieChart": "style_fa-pie-chart__Lt9J9",
	"fa-line-chart": "style_fa-line-chart__v5Vz7",
	"faLineChart": "style_fa-line-chart__v5Vz7",
	"fa-lastfm": "style_fa-lastfm__3Xbey",
	"faLastfm": "style_fa-lastfm__3Xbey",
	"fa-lastfm-square": "style_fa-lastfm-square__rcQZJ",
	"faLastfmSquare": "style_fa-lastfm-square__rcQZJ",
	"fa-toggle-off": "style_fa-toggle-off__1RgJ-",
	"faToggleOff": "style_fa-toggle-off__1RgJ-",
	"fa-toggle-on": "style_fa-toggle-on__JzsTX",
	"faToggleOn": "style_fa-toggle-on__JzsTX",
	"fa-bicycle": "style_fa-bicycle__2Hi3o",
	"faBicycle": "style_fa-bicycle__2Hi3o",
	"fa-bus": "style_fa-bus__2uqLm",
	"faBus": "style_fa-bus__2uqLm",
	"fa-ioxhost": "style_fa-ioxhost__dz7I5",
	"faIoxhost": "style_fa-ioxhost__dz7I5",
	"fa-angellist": "style_fa-angellist__1qU9h",
	"faAngellist": "style_fa-angellist__1qU9h",
	"fa-cc": "style_fa-cc__1KTQC",
	"faCc": "style_fa-cc__1KTQC",
	"fa-shekel": "style_fa-shekel__1TsRx",
	"faShekel": "style_fa-shekel__1TsRx",
	"fa-sheqel": "style_fa-sheqel__2JXWS",
	"faSheqel": "style_fa-sheqel__2JXWS",
	"fa-ils": "style_fa-ils__3RZz4",
	"faIls": "style_fa-ils__3RZz4",
	"fa-meanpath": "style_fa-meanpath__s-P0R",
	"faMeanpath": "style_fa-meanpath__s-P0R",
	"fa-buysellads": "style_fa-buysellads__31FsM",
	"faBuysellads": "style_fa-buysellads__31FsM",
	"fa-connectdevelop": "style_fa-connectdevelop__3vxtL",
	"faConnectdevelop": "style_fa-connectdevelop__3vxtL",
	"fa-dashcube": "style_fa-dashcube__2SiAc",
	"faDashcube": "style_fa-dashcube__2SiAc",
	"fa-forumbee": "style_fa-forumbee__1N2en",
	"faForumbee": "style_fa-forumbee__1N2en",
	"fa-leanpub": "style_fa-leanpub__GsGbD",
	"faLeanpub": "style_fa-leanpub__GsGbD",
	"fa-sellsy": "style_fa-sellsy__3Voml",
	"faSellsy": "style_fa-sellsy__3Voml",
	"fa-shirtsinbulk": "style_fa-shirtsinbulk__3Uicd",
	"faShirtsinbulk": "style_fa-shirtsinbulk__3Uicd",
	"fa-simplybuilt": "style_fa-simplybuilt__1S1iQ",
	"faSimplybuilt": "style_fa-simplybuilt__1S1iQ",
	"fa-skyatlas": "style_fa-skyatlas__1lEy_",
	"faSkyatlas": "style_fa-skyatlas__1lEy_",
	"fa-cart-plus": "style_fa-cart-plus__6xtgm",
	"faCartPlus": "style_fa-cart-plus__6xtgm",
	"fa-cart-arrow-down": "style_fa-cart-arrow-down__TN9vq",
	"faCartArrowDown": "style_fa-cart-arrow-down__TN9vq",
	"fa-diamond": "style_fa-diamond__38kag",
	"faDiamond": "style_fa-diamond__38kag",
	"fa-ship": "style_fa-ship__3jBZU",
	"faShip": "style_fa-ship__3jBZU",
	"fa-user-secret": "style_fa-user-secret__1MNpY",
	"faUserSecret": "style_fa-user-secret__1MNpY",
	"fa-motorcycle": "style_fa-motorcycle__2pfNe",
	"faMotorcycle": "style_fa-motorcycle__2pfNe",
	"fa-street-view": "style_fa-street-view__2FFQt",
	"faStreetView": "style_fa-street-view__2FFQt",
	"fa-heartbeat": "style_fa-heartbeat__10Izl",
	"faHeartbeat": "style_fa-heartbeat__10Izl",
	"fa-venus": "style_fa-venus__25JDj",
	"faVenus": "style_fa-venus__25JDj",
	"fa-mars": "style_fa-mars__288UC",
	"faMars": "style_fa-mars__288UC",
	"fa-mercury": "style_fa-mercury__2Q58M",
	"faMercury": "style_fa-mercury__2Q58M",
	"fa-intersex": "style_fa-intersex__3kLL4",
	"faIntersex": "style_fa-intersex__3kLL4",
	"fa-transgender": "style_fa-transgender__28Vug",
	"faTransgender": "style_fa-transgender__28Vug",
	"fa-transgender-alt": "style_fa-transgender-alt__2Nq6s",
	"faTransgenderAlt": "style_fa-transgender-alt__2Nq6s",
	"fa-venus-double": "style_fa-venus-double__3h-Iv",
	"faVenusDouble": "style_fa-venus-double__3h-Iv",
	"fa-mars-double": "style_fa-mars-double__bq6_W",
	"faMarsDouble": "style_fa-mars-double__bq6_W",
	"fa-venus-mars": "style_fa-venus-mars__2vx7g",
	"faVenusMars": "style_fa-venus-mars__2vx7g",
	"fa-mars-stroke": "style_fa-mars-stroke__JBS4E",
	"faMarsStroke": "style_fa-mars-stroke__JBS4E",
	"fa-mars-stroke-v": "style_fa-mars-stroke-v__2DjaF",
	"faMarsStrokeV": "style_fa-mars-stroke-v__2DjaF",
	"fa-mars-stroke-h": "style_fa-mars-stroke-h__2XBCX",
	"faMarsStrokeH": "style_fa-mars-stroke-h__2XBCX",
	"fa-neuter": "style_fa-neuter__tkR2L",
	"faNeuter": "style_fa-neuter__tkR2L",
	"fa-genderless": "style_fa-genderless__3g8-C",
	"faGenderless": "style_fa-genderless__3g8-C",
	"fa-facebook-official": "style_fa-facebook-official__1fixN",
	"faFacebookOfficial": "style_fa-facebook-official__1fixN",
	"fa-pinterest-p": "style_fa-pinterest-p__2Uacv",
	"faPinterestP": "style_fa-pinterest-p__2Uacv",
	"fa-whatsapp": "style_fa-whatsapp__5M37Z",
	"faWhatsapp": "style_fa-whatsapp__5M37Z",
	"fa-server": "style_fa-server__2Js8W",
	"faServer": "style_fa-server__2Js8W",
	"fa-user-plus": "style_fa-user-plus__2FeQ9",
	"faUserPlus": "style_fa-user-plus__2FeQ9",
	"fa-user-times": "style_fa-user-times__Z2cdB",
	"faUserTimes": "style_fa-user-times__Z2cdB",
	"fa-hotel": "style_fa-hotel__3RJFT",
	"faHotel": "style_fa-hotel__3RJFT",
	"fa-bed": "style_fa-bed__165DP",
	"faBed": "style_fa-bed__165DP",
	"fa-viacoin": "style_fa-viacoin__1Mu6P",
	"faViacoin": "style_fa-viacoin__1Mu6P",
	"fa-train": "style_fa-train__1Z4yd",
	"faTrain": "style_fa-train__1Z4yd",
	"fa-subway": "style_fa-subway__2F9i5",
	"faSubway": "style_fa-subway__2F9i5",
	"fa-medium": "style_fa-medium__3M6ms",
	"faMedium": "style_fa-medium__3M6ms",
	"fa-yc": "style_fa-yc__ISZRJ",
	"faYc": "style_fa-yc__ISZRJ",
	"fa-y-combinator": "style_fa-y-combinator__4aqOG",
	"faYCombinator": "style_fa-y-combinator__4aqOG",
	"fa-optin-monster": "style_fa-optin-monster__3bMTf",
	"faOptinMonster": "style_fa-optin-monster__3bMTf",
	"fa-opencart": "style_fa-opencart__2Pd3y",
	"faOpencart": "style_fa-opencart__2Pd3y",
	"fa-expeditedssl": "style_fa-expeditedssl__3lRxq",
	"faExpeditedssl": "style_fa-expeditedssl__3lRxq",
	"fa-battery-4": "style_fa-battery-4__nkX2e",
	"faBattery4": "style_fa-battery-4__nkX2e",
	"fa-battery": "style_fa-battery__1_1Ry",
	"faBattery": "style_fa-battery__1_1Ry",
	"fa-battery-full": "style_fa-battery-full__3k_LA",
	"faBatteryFull": "style_fa-battery-full__3k_LA",
	"fa-battery-3": "style_fa-battery-3__38FV_",
	"faBattery3": "style_fa-battery-3__38FV_",
	"fa-battery-three-quarters": "style_fa-battery-three-quarters__3_3TH",
	"faBatteryThreeQuarters": "style_fa-battery-three-quarters__3_3TH",
	"fa-battery-2": "style_fa-battery-2__1LDMi",
	"faBattery2": "style_fa-battery-2__1LDMi",
	"fa-battery-half": "style_fa-battery-half__3Lta2",
	"faBatteryHalf": "style_fa-battery-half__3Lta2",
	"fa-battery-1": "style_fa-battery-1__1AjVY",
	"faBattery1": "style_fa-battery-1__1AjVY",
	"fa-battery-quarter": "style_fa-battery-quarter__3KT3K",
	"faBatteryQuarter": "style_fa-battery-quarter__3KT3K",
	"fa-battery-0": "style_fa-battery-0__34q9q",
	"faBattery0": "style_fa-battery-0__34q9q",
	"fa-battery-empty": "style_fa-battery-empty__NN-XE",
	"faBatteryEmpty": "style_fa-battery-empty__NN-XE",
	"fa-mouse-pointer": "style_fa-mouse-pointer__1se8l",
	"faMousePointer": "style_fa-mouse-pointer__1se8l",
	"fa-i-cursor": "style_fa-i-cursor__3-J0x",
	"faICursor": "style_fa-i-cursor__3-J0x",
	"fa-object-group": "style_fa-object-group__8uZFN",
	"faObjectGroup": "style_fa-object-group__8uZFN",
	"fa-object-ungroup": "style_fa-object-ungroup__3AfpG",
	"faObjectUngroup": "style_fa-object-ungroup__3AfpG",
	"fa-sticky-note": "style_fa-sticky-note__qC99I",
	"faStickyNote": "style_fa-sticky-note__qC99I",
	"fa-sticky-note-o": "style_fa-sticky-note-o__1shOs",
	"faStickyNoteO": "style_fa-sticky-note-o__1shOs",
	"fa-cc-jcb": "style_fa-cc-jcb__2JWFq",
	"faCcJcb": "style_fa-cc-jcb__2JWFq",
	"fa-cc-diners-club": "style_fa-cc-diners-club__3aTNT",
	"faCcDinersClub": "style_fa-cc-diners-club__3aTNT",
	"fa-clone": "style_fa-clone__3ICmj",
	"faClone": "style_fa-clone__3ICmj",
	"fa-balance-scale": "style_fa-balance-scale__15vCS",
	"faBalanceScale": "style_fa-balance-scale__15vCS",
	"fa-hourglass-o": "style_fa-hourglass-o__2hHT1",
	"faHourglassO": "style_fa-hourglass-o__2hHT1",
	"fa-hourglass-1": "style_fa-hourglass-1__2xFOM",
	"faHourglass1": "style_fa-hourglass-1__2xFOM",
	"fa-hourglass-start": "style_fa-hourglass-start__2oPRM",
	"faHourglassStart": "style_fa-hourglass-start__2oPRM",
	"fa-hourglass-2": "style_fa-hourglass-2__LMzUF",
	"faHourglass2": "style_fa-hourglass-2__LMzUF",
	"fa-hourglass-half": "style_fa-hourglass-half__8Nr-6",
	"faHourglassHalf": "style_fa-hourglass-half__8Nr-6",
	"fa-hourglass-3": "style_fa-hourglass-3__33jx-",
	"faHourglass3": "style_fa-hourglass-3__33jx-",
	"fa-hourglass-end": "style_fa-hourglass-end__7sF5b",
	"faHourglassEnd": "style_fa-hourglass-end__7sF5b",
	"fa-hourglass": "style_fa-hourglass__2hNrb",
	"faHourglass": "style_fa-hourglass__2hNrb",
	"fa-hand-grab-o": "style_fa-hand-grab-o__1XsHN",
	"faHandGrabO": "style_fa-hand-grab-o__1XsHN",
	"fa-hand-rock-o": "style_fa-hand-rock-o__1o7JV",
	"faHandRockO": "style_fa-hand-rock-o__1o7JV",
	"fa-hand-stop-o": "style_fa-hand-stop-o__2tfzy",
	"faHandStopO": "style_fa-hand-stop-o__2tfzy",
	"fa-hand-paper-o": "style_fa-hand-paper-o__2D9tl",
	"faHandPaperO": "style_fa-hand-paper-o__2D9tl",
	"fa-hand-scissors-o": "style_fa-hand-scissors-o__1RKVE",
	"faHandScissorsO": "style_fa-hand-scissors-o__1RKVE",
	"fa-hand-lizard-o": "style_fa-hand-lizard-o__1zYpr",
	"faHandLizardO": "style_fa-hand-lizard-o__1zYpr",
	"fa-hand-spock-o": "style_fa-hand-spock-o__YbrEg",
	"faHandSpockO": "style_fa-hand-spock-o__YbrEg",
	"fa-hand-pointer-o": "style_fa-hand-pointer-o__1JnN-",
	"faHandPointerO": "style_fa-hand-pointer-o__1JnN-",
	"fa-hand-peace-o": "style_fa-hand-peace-o__yLVOp",
	"faHandPeaceO": "style_fa-hand-peace-o__yLVOp",
	"fa-trademark": "style_fa-trademark__3u2jI",
	"faTrademark": "style_fa-trademark__3u2jI",
	"fa-registered": "style_fa-registered__2qgyG",
	"faRegistered": "style_fa-registered__2qgyG",
	"fa-creative-commons": "style_fa-creative-commons__vPYgb",
	"faCreativeCommons": "style_fa-creative-commons__vPYgb",
	"fa-gg": "style_fa-gg__3IYl-",
	"faGg": "style_fa-gg__3IYl-",
	"fa-gg-circle": "style_fa-gg-circle__3-1rl",
	"faGgCircle": "style_fa-gg-circle__3-1rl",
	"fa-tripadvisor": "style_fa-tripadvisor__2L5A9",
	"faTripadvisor": "style_fa-tripadvisor__2L5A9",
	"fa-odnoklassniki": "style_fa-odnoklassniki__nVekf",
	"faOdnoklassniki": "style_fa-odnoklassniki__nVekf",
	"fa-odnoklassniki-square": "style_fa-odnoklassniki-square__16pjb",
	"faOdnoklassnikiSquare": "style_fa-odnoklassniki-square__16pjb",
	"fa-get-pocket": "style_fa-get-pocket__104ns",
	"faGetPocket": "style_fa-get-pocket__104ns",
	"fa-wikipedia-w": "style_fa-wikipedia-w__X8BYC",
	"faWikipediaW": "style_fa-wikipedia-w__X8BYC",
	"fa-safari": "style_fa-safari__2sTvN",
	"faSafari": "style_fa-safari__2sTvN",
	"fa-chrome": "style_fa-chrome__2_0YB",
	"faChrome": "style_fa-chrome__2_0YB",
	"fa-firefox": "style_fa-firefox__2CaNy",
	"faFirefox": "style_fa-firefox__2CaNy",
	"fa-opera": "style_fa-opera__j5rM7",
	"faOpera": "style_fa-opera__j5rM7",
	"fa-internet-explorer": "style_fa-internet-explorer__322q3",
	"faInternetExplorer": "style_fa-internet-explorer__322q3",
	"fa-tv": "style_fa-tv__3YwR3",
	"faTv": "style_fa-tv__3YwR3",
	"fa-television": "style_fa-television__2RVy1",
	"faTelevision": "style_fa-television__2RVy1",
	"fa-contao": "style_fa-contao__23lBh",
	"faContao": "style_fa-contao__23lBh",
	"fa-500px": "style_fa-500px__17Jvu",
	"fa500Px": "style_fa-500px__17Jvu",
	"fa-amazon": "style_fa-amazon__1ymX6",
	"faAmazon": "style_fa-amazon__1ymX6",
	"fa-calendar-plus-o": "style_fa-calendar-plus-o__3llpH",
	"faCalendarPlusO": "style_fa-calendar-plus-o__3llpH",
	"fa-calendar-minus-o": "style_fa-calendar-minus-o__1eQIz",
	"faCalendarMinusO": "style_fa-calendar-minus-o__1eQIz",
	"fa-calendar-times-o": "style_fa-calendar-times-o__1W9qV",
	"faCalendarTimesO": "style_fa-calendar-times-o__1W9qV",
	"fa-calendar-check-o": "style_fa-calendar-check-o__2qp9Q",
	"faCalendarCheckO": "style_fa-calendar-check-o__2qp9Q",
	"fa-industry": "style_fa-industry__32YjN",
	"faIndustry": "style_fa-industry__32YjN",
	"fa-map-pin": "style_fa-map-pin__26nyt",
	"faMapPin": "style_fa-map-pin__26nyt",
	"fa-map-signs": "style_fa-map-signs__1R7I6",
	"faMapSigns": "style_fa-map-signs__1R7I6",
	"fa-map-o": "style_fa-map-o__1B_Uf",
	"faMapO": "style_fa-map-o__1B_Uf",
	"fa-map": "style_fa-map__3Asmz",
	"faMap": "style_fa-map__3Asmz",
	"fa-commenting": "style_fa-commenting__2eYPk",
	"faCommenting": "style_fa-commenting__2eYPk",
	"fa-commenting-o": "style_fa-commenting-o__1iYBT",
	"faCommentingO": "style_fa-commenting-o__1iYBT",
	"fa-houzz": "style_fa-houzz__1sfmW",
	"faHouzz": "style_fa-houzz__1sfmW",
	"fa-vimeo": "style_fa-vimeo__314lZ",
	"faVimeo": "style_fa-vimeo__314lZ",
	"fa-black-tie": "style_fa-black-tie__1Kqx8",
	"faBlackTie": "style_fa-black-tie__1Kqx8",
	"fa-fonticons": "style_fa-fonticons__2zdba",
	"faFonticons": "style_fa-fonticons__2zdba",
	"fa-reddit-alien": "style_fa-reddit-alien__2UPcO",
	"faRedditAlien": "style_fa-reddit-alien__2UPcO",
	"fa-edge": "style_fa-edge__1mSW1",
	"faEdge": "style_fa-edge__1mSW1",
	"fa-credit-card-alt": "style_fa-credit-card-alt__3UiPe",
	"faCreditCardAlt": "style_fa-credit-card-alt__3UiPe",
	"fa-codiepie": "style_fa-codiepie__1EoyT",
	"faCodiepie": "style_fa-codiepie__1EoyT",
	"fa-modx": "style_fa-modx__ISmGq",
	"faModx": "style_fa-modx__ISmGq",
	"fa-fort-awesome": "style_fa-fort-awesome__2C8ry",
	"faFortAwesome": "style_fa-fort-awesome__2C8ry",
	"fa-usb": "style_fa-usb__2bSi9",
	"faUsb": "style_fa-usb__2bSi9",
	"fa-product-hunt": "style_fa-product-hunt__WmzHD",
	"faProductHunt": "style_fa-product-hunt__WmzHD",
	"fa-mixcloud": "style_fa-mixcloud__26EqX",
	"faMixcloud": "style_fa-mixcloud__26EqX",
	"fa-scribd": "style_fa-scribd__1nd52",
	"faScribd": "style_fa-scribd__1nd52",
	"fa-pause-circle": "style_fa-pause-circle__2P49M",
	"faPauseCircle": "style_fa-pause-circle__2P49M",
	"fa-pause-circle-o": "style_fa-pause-circle-o__xcp3U",
	"faPauseCircleO": "style_fa-pause-circle-o__xcp3U",
	"fa-stop-circle": "style_fa-stop-circle__2rV8_",
	"faStopCircle": "style_fa-stop-circle__2rV8_",
	"fa-stop-circle-o": "style_fa-stop-circle-o__3k47o",
	"faStopCircleO": "style_fa-stop-circle-o__3k47o",
	"fa-shopping-bag": "style_fa-shopping-bag__3TzmQ",
	"faShoppingBag": "style_fa-shopping-bag__3TzmQ",
	"fa-shopping-basket": "style_fa-shopping-basket__1n0W7",
	"faShoppingBasket": "style_fa-shopping-basket__1n0W7",
	"fa-hashtag": "style_fa-hashtag__1Au2Q",
	"faHashtag": "style_fa-hashtag__1Au2Q",
	"fa-bluetooth": "style_fa-bluetooth__f-IoV",
	"faBluetooth": "style_fa-bluetooth__f-IoV",
	"fa-bluetooth-b": "style_fa-bluetooth-b__2ZV1n",
	"faBluetoothB": "style_fa-bluetooth-b__2ZV1n",
	"fa-percent": "style_fa-percent__3GeyB",
	"faPercent": "style_fa-percent__3GeyB",
	"fa-gitlab": "style_fa-gitlab__2-Bar",
	"faGitlab": "style_fa-gitlab__2-Bar",
	"fa-wpbeginner": "style_fa-wpbeginner__2u02I",
	"faWpbeginner": "style_fa-wpbeginner__2u02I",
	"fa-wpforms": "style_fa-wpforms__1PAVg",
	"faWpforms": "style_fa-wpforms__1PAVg",
	"fa-envira": "style_fa-envira__2Vlp_",
	"faEnvira": "style_fa-envira__2Vlp_",
	"fa-universal-access": "style_fa-universal-access__1gPZ1",
	"faUniversalAccess": "style_fa-universal-access__1gPZ1",
	"fa-wheelchair-alt": "style_fa-wheelchair-alt__PYJAx",
	"faWheelchairAlt": "style_fa-wheelchair-alt__PYJAx",
	"fa-question-circle-o": "style_fa-question-circle-o__VU9cE",
	"faQuestionCircleO": "style_fa-question-circle-o__VU9cE",
	"fa-blind": "style_fa-blind__14GsC",
	"faBlind": "style_fa-blind__14GsC",
	"fa-audio-description": "style_fa-audio-description__193tW",
	"faAudioDescription": "style_fa-audio-description__193tW",
	"fa-volume-control-phone": "style_fa-volume-control-phone__1wydK",
	"faVolumeControlPhone": "style_fa-volume-control-phone__1wydK",
	"fa-braille": "style_fa-braille__1Zz06",
	"faBraille": "style_fa-braille__1Zz06",
	"fa-assistive-listening-systems": "style_fa-assistive-listening-systems__2HSSD",
	"faAssistiveListeningSystems": "style_fa-assistive-listening-systems__2HSSD",
	"fa-asl-interpreting": "style_fa-asl-interpreting__2_Ohd",
	"faAslInterpreting": "style_fa-asl-interpreting__2_Ohd",
	"fa-american-sign-language-interpreting": "style_fa-american-sign-language-interpreting__WTHMO",
	"faAmericanSignLanguageInterpreting": "style_fa-american-sign-language-interpreting__WTHMO",
	"fa-deafness": "style_fa-deafness__1RQ5h",
	"faDeafness": "style_fa-deafness__1RQ5h",
	"fa-hard-of-hearing": "style_fa-hard-of-hearing__dxouv",
	"faHardOfHearing": "style_fa-hard-of-hearing__dxouv",
	"fa-deaf": "style_fa-deaf__gNpY3",
	"faDeaf": "style_fa-deaf__gNpY3",
	"fa-glide": "style_fa-glide__2JkuE",
	"faGlide": "style_fa-glide__2JkuE",
	"fa-glide-g": "style_fa-glide-g__7lw0r",
	"faGlideG": "style_fa-glide-g__7lw0r",
	"fa-signing": "style_fa-signing__1LBGN",
	"faSigning": "style_fa-signing__1LBGN",
	"fa-sign-language": "style_fa-sign-language__3Kh8E",
	"faSignLanguage": "style_fa-sign-language__3Kh8E",
	"fa-low-vision": "style_fa-low-vision__3kvJs",
	"faLowVision": "style_fa-low-vision__3kvJs",
	"fa-viadeo": "style_fa-viadeo__VoezI",
	"faViadeo": "style_fa-viadeo__VoezI",
	"fa-viadeo-square": "style_fa-viadeo-square__2UHUK",
	"faViadeoSquare": "style_fa-viadeo-square__2UHUK",
	"fa-snapchat": "style_fa-snapchat__2jKmj",
	"faSnapchat": "style_fa-snapchat__2jKmj",
	"fa-snapchat-ghost": "style_fa-snapchat-ghost__2xwud",
	"faSnapchatGhost": "style_fa-snapchat-ghost__2xwud",
	"fa-snapchat-square": "style_fa-snapchat-square__2ay8Y",
	"faSnapchatSquare": "style_fa-snapchat-square__2ay8Y",
	"fa-pied-piper": "style_fa-pied-piper__1cKv9",
	"faPiedPiper": "style_fa-pied-piper__1cKv9",
	"fa-first-order": "style_fa-first-order__1aHV7",
	"faFirstOrder": "style_fa-first-order__1aHV7",
	"fa-yoast": "style_fa-yoast__3l7Nw",
	"faYoast": "style_fa-yoast__3l7Nw",
	"fa-themeisle": "style_fa-themeisle__IVgBM",
	"faThemeisle": "style_fa-themeisle__IVgBM",
	"fa-google-plus-circle": "style_fa-google-plus-circle__3YTOV",
	"faGooglePlusCircle": "style_fa-google-plus-circle__3YTOV",
	"fa-google-plus-official": "style_fa-google-plus-official__3j2-g",
	"faGooglePlusOfficial": "style_fa-google-plus-official__3j2-g",
	"fa-fa": "style_fa-fa__16B4w",
	"faFa": "style_fa-fa__16B4w",
	"fa-font-awesome": "style_fa-font-awesome__a8j_I",
	"faFontAwesome": "style_fa-font-awesome__a8j_I",
	"fa-handshake-o": "style_fa-handshake-o__14uNQ",
	"faHandshakeO": "style_fa-handshake-o__14uNQ",
	"fa-envelope-open": "style_fa-envelope-open__1mSeC",
	"faEnvelopeOpen": "style_fa-envelope-open__1mSeC",
	"fa-envelope-open-o": "style_fa-envelope-open-o__3IpGG",
	"faEnvelopeOpenO": "style_fa-envelope-open-o__3IpGG",
	"fa-linode": "style_fa-linode__3MNS1",
	"faLinode": "style_fa-linode__3MNS1",
	"fa-address-book": "style_fa-address-book__3-Qpd",
	"faAddressBook": "style_fa-address-book__3-Qpd",
	"fa-address-book-o": "style_fa-address-book-o__aCKzG",
	"faAddressBookO": "style_fa-address-book-o__aCKzG",
	"fa-vcard": "style_fa-vcard__6M2eg",
	"faVcard": "style_fa-vcard__6M2eg",
	"fa-address-card": "style_fa-address-card__3k6ik",
	"faAddressCard": "style_fa-address-card__3k6ik",
	"fa-vcard-o": "style_fa-vcard-o__iyiuV",
	"faVcardO": "style_fa-vcard-o__iyiuV",
	"fa-address-card-o": "style_fa-address-card-o__3QTYS",
	"faAddressCardO": "style_fa-address-card-o__3QTYS",
	"fa-user-circle": "style_fa-user-circle__1_cde",
	"faUserCircle": "style_fa-user-circle__1_cde",
	"fa-user-circle-o": "style_fa-user-circle-o__2YUao",
	"faUserCircleO": "style_fa-user-circle-o__2YUao",
	"fa-user-o": "style_fa-user-o__1V2Up",
	"faUserO": "style_fa-user-o__1V2Up",
	"fa-id-badge": "style_fa-id-badge__1CYVn",
	"faIdBadge": "style_fa-id-badge__1CYVn",
	"fa-drivers-license": "style_fa-drivers-license__e2Mlt",
	"faDriversLicense": "style_fa-drivers-license__e2Mlt",
	"fa-id-card": "style_fa-id-card__3sBIr",
	"faIdCard": "style_fa-id-card__3sBIr",
	"fa-drivers-license-o": "style_fa-drivers-license-o__QjBUI",
	"faDriversLicenseO": "style_fa-drivers-license-o__QjBUI",
	"fa-id-card-o": "style_fa-id-card-o__24M2v",
	"faIdCardO": "style_fa-id-card-o__24M2v",
	"fa-quora": "style_fa-quora__3pF-w",
	"faQuora": "style_fa-quora__3pF-w",
	"fa-free-code-camp": "style_fa-free-code-camp__mJ0F4",
	"faFreeCodeCamp": "style_fa-free-code-camp__mJ0F4",
	"fa-telegram": "style_fa-telegram__1SQJJ",
	"faTelegram": "style_fa-telegram__1SQJJ",
	"fa-thermometer-4": "style_fa-thermometer-4__18hgc",
	"faThermometer4": "style_fa-thermometer-4__18hgc",
	"fa-thermometer": "style_fa-thermometer__2FEkA",
	"faThermometer": "style_fa-thermometer__2FEkA",
	"fa-thermometer-full": "style_fa-thermometer-full__zru6l",
	"faThermometerFull": "style_fa-thermometer-full__zru6l",
	"fa-thermometer-3": "style_fa-thermometer-3__2zo1R",
	"faThermometer3": "style_fa-thermometer-3__2zo1R",
	"fa-thermometer-three-quarters": "style_fa-thermometer-three-quarters__3rjIl",
	"faThermometerThreeQuarters": "style_fa-thermometer-three-quarters__3rjIl",
	"fa-thermometer-2": "style_fa-thermometer-2__12ejr",
	"faThermometer2": "style_fa-thermometer-2__12ejr",
	"fa-thermometer-half": "style_fa-thermometer-half__2tRDU",
	"faThermometerHalf": "style_fa-thermometer-half__2tRDU",
	"fa-thermometer-1": "style_fa-thermometer-1__24a3O",
	"faThermometer1": "style_fa-thermometer-1__24a3O",
	"fa-thermometer-quarter": "style_fa-thermometer-quarter__f5Fhv",
	"faThermometerQuarter": "style_fa-thermometer-quarter__f5Fhv",
	"fa-thermometer-0": "style_fa-thermometer-0__3739I",
	"faThermometer0": "style_fa-thermometer-0__3739I",
	"fa-thermometer-empty": "style_fa-thermometer-empty__1SOIG",
	"faThermometerEmpty": "style_fa-thermometer-empty__1SOIG",
	"fa-shower": "style_fa-shower__2wAa7",
	"faShower": "style_fa-shower__2wAa7",
	"fa-bathtub": "style_fa-bathtub__1i6ao",
	"faBathtub": "style_fa-bathtub__1i6ao",
	"fa-s15": "style_fa-s15__24ar6",
	"faS15": "style_fa-s15__24ar6",
	"fa-bath": "style_fa-bath__aZawX",
	"faBath": "style_fa-bath__aZawX",
	"fa-podcast": "style_fa-podcast__lVPTY",
	"faPodcast": "style_fa-podcast__lVPTY",
	"fa-window-maximize": "style_fa-window-maximize__2RO54",
	"faWindowMaximize": "style_fa-window-maximize__2RO54",
	"fa-window-minimize": "style_fa-window-minimize__3IN2X",
	"faWindowMinimize": "style_fa-window-minimize__3IN2X",
	"fa-window-restore": "style_fa-window-restore__3QFHb",
	"faWindowRestore": "style_fa-window-restore__3QFHb",
	"fa-times-rectangle": "style_fa-times-rectangle__BvQG5",
	"faTimesRectangle": "style_fa-times-rectangle__BvQG5",
	"fa-window-close": "style_fa-window-close__2mrEp",
	"faWindowClose": "style_fa-window-close__2mrEp",
	"fa-times-rectangle-o": "style_fa-times-rectangle-o__wCN68",
	"faTimesRectangleO": "style_fa-times-rectangle-o__wCN68",
	"fa-window-close-o": "style_fa-window-close-o__3apzx",
	"faWindowCloseO": "style_fa-window-close-o__3apzx",
	"fa-bandcamp": "style_fa-bandcamp__HoVp0",
	"faBandcamp": "style_fa-bandcamp__HoVp0",
	"fa-grav": "style_fa-grav__3c47r",
	"faGrav": "style_fa-grav__3c47r",
	"fa-etsy": "style_fa-etsy__2I3s2",
	"faEtsy": "style_fa-etsy__2I3s2",
	"fa-imdb": "style_fa-imdb__vfJgy",
	"faImdb": "style_fa-imdb__vfJgy",
	"fa-ravelry": "style_fa-ravelry__1zUZZ",
	"faRavelry": "style_fa-ravelry__1zUZZ",
	"fa-eercast": "style_fa-eercast__3WehH",
	"faEercast": "style_fa-eercast__3WehH",
	"fa-microchip": "style_fa-microchip__1OQ4R",
	"faMicrochip": "style_fa-microchip__1OQ4R",
	"fa-snowflake-o": "style_fa-snowflake-o__2yftS",
	"faSnowflakeO": "style_fa-snowflake-o__2yftS",
	"fa-superpowers": "style_fa-superpowers__3oE6q",
	"faSuperpowers": "style_fa-superpowers__3oE6q",
	"fa-wpexplorer": "style_fa-wpexplorer__2Fz14",
	"faWpexplorer": "style_fa-wpexplorer__2Fz14",
	"fa-meetup": "style_fa-meetup__3VCYC",
	"faMeetup": "style_fa-meetup__3VCYC",
	"sr-only": "style_sr-only__28X0u",
	"srOnly": "style_sr-only__28X0u",
	"sr-only-focusable": "style_sr-only-focusable__3hrEM",
	"srOnlyFocusable": "style_sr-only-focusable__3hrEM",
	"monospace": "style_monospace__3wtSm",
	"text": "style_text__2pyMd",
	"container": "style_container__1dFxU",
	"monospacedText": "style_monospacedText__1120V"
};

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(60);
var React = __webpack_require__(0);
var FilterSearchBox_1 = __webpack_require__(287);
var List_1 = __webpack_require__(293);
var clientInstance_1 = __webpack_require__(10);
var Popover_1 = __webpack_require__(220);
var scriptingLanguage_1 = __webpack_require__(140);
var styles = __webpack_require__(1367);
var IconButton_1 = __webpack_require__(56);
var insertVariableIcon = __webpack_require__(1380);
var InsertVariableButton = (function (_super) {
    __extends(InsertVariableButton, _super);
    function InsertVariableButton(props) {
        var _this = _super.call(this, props) || this;
        _this.showInsertPopup = function (event) {
            event.preventDefault();
            _this.setState({
                isInsertPopupOpen: true
            });
        };
        _this.hideInsertPopup = function () {
            _this.setState({
                isInsertPopupOpen: false
            });
        };
        _this.handleSelected = function (value, delimit) {
            var delimited = delimit ? _this.delimit(value) : value;
            _this.props.onSelected(delimited);
            _this.hideInsertPopup();
        };
        _this.onKeyDown = function (event) {
            if (event.keyCode === 27 /*esc*/) {
                _this.setState({ isInsertPopupOpen: false });
            }
        };
        _this.setRef = function (el) {
            _this.showInsertPopupButton = el;
        };
        _this.delimit = function (varname) {
            var syntax = _this.props.syntax;
            if (!syntax) {
                return "#{" + varname + "}";
            }
            // Some escaping is probably required here.
            if (syntax === scriptingLanguage_1.ScriptingLanguage.PowerShell) {
                if (varname.match(/^[A-z0-9]+$/)) {
                    return "$" + varname;
                }
                else {
                    return "$OctopusParameters[\"" + varname + "\"]";
                }
            }
            if (syntax === scriptingLanguage_1.ScriptingLanguage.CSharp) {
                return "Octopus.Parameters[\"" + varname + "\"]";
            }
            if (syntax === scriptingLanguage_1.ScriptingLanguage.Bash) {
                return "get_octopusvariable \"" + varname + "\"";
            }
            if (syntax === scriptingLanguage_1.ScriptingLanguage.FSharp) {
                return "Octopus.findVariable \"" + varname + "\"";
            }
            return varname;
        };
        _this.getFunctions = function () {
            return _this.getLanguageFunctions()
                .concat([
                "#{if VariableName}value_if_true#{/if}",
                "#{unless VariableName}value_if_false#{/unless}",
                "#{each item in VariablePrefix}#{item.Postfix}#{/each}",
                "#{each number in NumberArrayVariable}#{number}#{/each}",
                "#{each item in JsonObjectVariable}#{item.Key}: #{item.Value.Property}#{/each}",
                "#{ VariableName | HtmlEscape }",
                "#{ VariableName | JsonEscape }",
                "#{ VariableName | XmlEscape }",
                "#{ VariableName | Markdown }",
                "#{ VariableName | ToLower }",
                "#{ VariableName | ToUpper }",
                "#{ | NowDate }",
                "#{ | NowDateUtc }",
                "#{ | NowDate \\\"HH dd-MMM-yyyy\\\" }",
                "#{ | NowDate zz }",
                "#{ | NowDate #{MyFormat} }",
                "#{ VariableName | Format C}"
            ]);
        };
        _this.getLanguageFunctions = function () {
            switch (_this.props.syntax) {
                case scriptingLanguage_1.ScriptingLanguage.PowerShell:
                    return [
                        "New-OctopusArtifact",
                        "Set-OctopusVariable",
                        "Fail-Step",
                        "Write-Verbose",
                        "Write-Highlight",
                        "Write-Wait",
                        "Write-Warning"
                    ];
                case scriptingLanguage_1.ScriptingLanguage.Bash:
                    return [
                        "new_octopusartifact",
                        "set_octopusvariable",
                        "fail_step",
                        "write_verbose",
                        "write_highlight",
                        "write_wait",
                        "write_warning"
                    ];
                case scriptingLanguage_1.ScriptingLanguage.FSharp:
                    return [
                        "createArtifact",
                        "setVariable",
                        "failStep",
                        "writeVerbose",
                        "writeHighlight",
                        "writeWait",
                        "writeWarning"
                    ];
                case scriptingLanguage_1.ScriptingLanguage.CSharp:
                    return [
                        "Octopus.CreateArtifact",
                        "Octopus.SetVariable",
                        "Octopus.FailStep",
                        "Octopus.WriteVerbose",
                        "Octopus.WriteHighlight",
                        "Octopus.WriteWait",
                        "Octopus.WriteWarning"
                    ];
                default:
                    return [];
            }
        };
        _this.state = {
            allNames: null,
            isInsertPopupOpen: false,
            filter: ""
        };
        return _this;
    }
    InsertVariableButton.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var values, names, _i, values_1, value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Variables.names(this.props.projectId, this.props.projectEnvironmentsFilter)];
                    case 1:
                        values = _a.sent();
                        names = this.props.localNames ? this.props.localNames.slice() : [];
                        for (_i = 0, values_1 = values; _i < values_1.length; _i++) {
                            value = values_1[_i];
                            names.push(value);
                        }
                        this.setState({
                            allNames: names,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    InsertVariableButton.prototype.render = function () {
        //TODO Insert variable icon to be added
        var _this = this;
        var lcFilter = this.state.filter.toLowerCase();
        var filterFunc = function (item) { return !lcFilter || item.toLowerCase().includes(lcFilter); };
        var names = (this.state.allNames || [])
            .filter(filterFunc)
            .map(function (n, i) { return React.createElement(List_1.ListItem, { key: "item-" + i, primaryText: n, onClick: function () { return _this.handleSelected(n, true); } }); });
        var functions = this.getFunctions()
            .filter(filterFunc)
            .map(function (n, i) { return React.createElement(List_1.ListItem, { key: "item-" + i, primaryText: n, onClick: function () { return _this.handleSelected(n, false); } }); });
        return React.createElement("div", { ref: this.setRef },
            React.createElement(IconButton_1.default, { toolTipContent: "Insert a variable", onClick: this.showInsertPopup, icon: insertVariableIcon }),
            React.createElement(Popover_1.default, { open: this.state.isInsertPopupOpen, anchorEl: this.showInsertPopupButton, onRequestClose: this.hideInsertPopup, anchorOrigin: { horizontal: "middle", vertical: "bottom" }, targetOrigin: { horizontal: "middle", vertical: "top" } },
                React.createElement("div", { className: styles.container, onKeyDown: this.onKeyDown },
                    React.createElement("div", { className: styles.filter },
                        React.createElement(FilterSearchBox_1.default, { autoFocus: true, value: this.state.filter, hintText: "Find...", onChange: function (filter) { return _this.setState({ filter: filter }); } })),
                    this.state.isInsertPopupOpen && React.createElement(List_1.List, { className: styles.menuContainer },
                        names,
                        functions))));
    };
    return InsertVariableButton;
}(BaseComponent_1.default));
exports.default = InsertVariableButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\InsertVariableButton\\InsertVariableButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\InsertVariableButton\\InsertVariableButton.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1368);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_menuIcon__2kpue{font-size:1.375rem;display:flex;align-items:center;text-decoration:none;color:#333}.style_menuIcon__2kpue:visited{color:#333}.style_menuIcon__2kpue:hover{opacity:.5}.style_container__3ABIN{display:flex;flex-direction:column;width:31.25rem}.style_menuContainer__2R1aB{overflow-y:auto;height:25rem}.style_filter__251fd{margin:0 1rem}", ""]);

// exports
exports.locals = {
	"menuIcon": "style_menuIcon__2kpue",
	"container": "style_container__3ABIN",
	"menuContainer": "style_menuContainer__2R1aB",
	"filter": "style_filter__251fd"
};

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1370);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_materialUIIcon__PT3Bb{width:1.5rem!important;height:1.5rem!important;min-width:1.5rem!important;line-height:1.5rem!important;padding:0!important;opacity:.7}.style_materialUIIcon__PT3Bb span{padding:0!important}.style_materialUIIcon__PT3Bb:hover{background-color:#fff!important;opacity:1}.style_imageIcon__2Bet0{width:1.5rem;height:1.5rem;opacity:.7}.style_imageIcon__2Bet0:hover{opacity:1}.style_fontAwesomeIcon__24Xxz{opacity:.7}.style_fontAwesomeIcon__24Xxz:hover{opacity:1}", ""]);

// exports
exports.locals = {
	"materialUIIcon": "style_materialUIIcon__PT3Bb",
	"materialUiIcon": "style_materialUIIcon__PT3Bb",
	"imageIcon": "style_imageIcon__2Bet0",
	"fontAwesomeIcon": "style_fontAwesomeIcon__24Xxz"
};

/***/ }),
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "insert-variable.9344cc9087b8f1add3408a7c745b4731.hashedasset.svg";

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1382);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1vPog{width:100%;display:flex;flex-direction:row}.style_container__1vPog>.style_wide__3iHkR{flex-grow:1}.style_container__1vPog>.style_buttons__3RezA{padding-top:1rem}.style_container__1vPog>:nth-child(2){margin-left:1rem}", ""]);

// exports
exports.locals = {
	"container": "style_container__1vPog",
	"wide": "style_wide__3iHkR",
	"buttons": "style_buttons__3RezA"
};

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1384);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_filterField__2Hghd{position:relative;display:inline-block}.style_filterField__2Hghd .style_searchIcon__xNH7f{position:absolute;right:0;top:10px;width:1.5rem;height:1.5rem}.style_filterTextBoxStandardWidth__1ZsgI{width:15.6rem!important}.style_filterTextBoxFullWidth__x0qya{width:100%!important}", ""]);

// exports
exports.locals = {
	"filterField": "style_filterField__2Hghd",
	"searchIcon": "style_searchIcon__xNH7f",
	"filterTextBoxStandardWidth": "style_filterTextBoxStandardWidth__1ZsgI",
	"filterTextBoxFullWidth": "style_filterTextBoxFullWidth__x0qya"
};

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1386);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./projectSwitcher.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./projectSwitcher.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".projectSwitcher_container__3P1x6{display:flex;flex-direction:column;width:25rem}.projectSwitcher_menuContainer__1daZ3{overflow-y:auto;height:25rem}.projectSwitcher_filter__2z0UZ{margin:0 1rem}.projectSwitcher_filterFieldContainer__2yWyi{width:100%}.projectSwitcher_groupName__QFcSJ{background-color:hsla(0,0%,60%,.08);padding:.5rem 1.125rem;font-size:.9375rem}.projectSwitcher_empty__3bdIj{padding:.625rem}", ""]);

// exports
exports.locals = {
	"container": "projectSwitcher_container__3P1x6",
	"menuContainer": "projectSwitcher_menuContainer__1daZ3",
	"filter": "projectSwitcher_filter__2z0UZ",
	"filterFieldContainer": "projectSwitcher_filterFieldContainer__2yWyi",
	"groupName": "projectSwitcher_groupName__QFcSJ",
	"empty": "projectSwitcher_empty__3bdIj"
};

/***/ }),
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_internalLink__WVl2K{color:#2f93e0;text-decoration:none}.style_internalLink__WVl2K:hover{color:#0a67b1}.style_listInternalLink__3Z097,.style_listInternalLink__3Z097:focus,.style_listInternalLink__3Z097:hover{color:inherit}", ""]);

// exports
exports.locals = {
	"internalLink": "style_internalLink__WVl2K",
	"listInternalLink": "style_listInternalLink__3Z097"
};

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var Popover_1 = __webpack_require__(146);
var Menu_1 = __webpack_require__(175);
var Avatar_1 = __webpack_require__(439);
var ExternalLink_1 = __webpack_require__(91);
var GettingStartedDialog_1 = __webpack_require__(626);
var MenuItem_1 = __webpack_require__(97);
var clientInstance_1 = __webpack_require__(10);
var colors_1 = __webpack_require__(32);
var styles = __webpack_require__(245);
var Divider_1 = __webpack_require__(143);
var InternalLink_1 = __webpack_require__(42);
var routeLinks_1 = __webpack_require__(20);
var UserAccountMenu = (function (_super) {
    __extends(UserAccountMenu, _super);
    function UserAccountMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.setRef = function (el) {
            _this.menuButton = el;
        };
        _this.closeGettingStarted = function () {
            _this.setState({ showGettingStarted: false });
        };
        _this.handleTouchTap = function (event) {
            event.preventDefault();
            _this.setState({
                isMenuOpen: !_this.state.isMenuOpen
            });
        };
        _this.handleRequestClose = function () {
            _this.setState({
                isMenuOpen: false,
            });
        };
        _this.showGettingStarted = function () {
            _this.setState({
                isMenuOpen: false,
                showGettingStarted: true
            });
        };
        _this.state = {
            isMenuOpen: false,
            showGettingStarted: false,
            version: ""
        };
        return _this;
    }
    UserAccountMenu.prototype.componentDidMount = function () {
        var version = clientInstance_1.repository.getRootDocument().Version;
        this.setState({ version: version });
    };
    UserAccountMenu.prototype.render = function () {
        return React.createElement("div", null,
            this.state.showGettingStarted && React.createElement(GettingStartedDialog_1.GettingStartedDialog, { onNavigating: this.closeGettingStarted, open: this.state.showGettingStarted, onClose: this.closeGettingStarted }),
            React.createElement("a", { className: cn(styles.button), onClick: this.handleTouchTap, href: "#", ref: this.setRef },
                React.createElement(Avatar_1.Avatar, { user: this.props.currentUser, size: 24 }),
                React.createElement("span", { className: cn(styles.userName, "hide-sm") }, this.props.currentUser.DisplayName),
                React.createElement("em", { className: cn("fa fa-caret-down", styles.icon) })),
            React.createElement(Popover_1.default, { open: this.state.isMenuOpen, anchorEl: this.menuButton, onRequestClose: this.handleRequestClose, anchorOrigin: { horizontal: "right", vertical: "bottom" }, targetOrigin: { horizontal: "right", vertical: "top" } },
                React.createElement(Menu_1.default, null,
                    React.createElement(MenuItem_1.default, { style: { color: colors_1.secondaryText, fontSize: "0.875rem" }, disabled: true }, "Octopus v" + this.state.version),
                    React.createElement(Divider_1.default, null),
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.currentUser.signOut, onClick: this.handleRequestClose },
                        React.createElement(MenuItem_1.default, { primaryText: "Sign Out" })),
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.currentUser.me, onClick: this.handleRequestClose },
                        React.createElement(MenuItem_1.default, { primaryText: "Profile" })),
                    React.createElement(MenuItem_1.default, { primaryText: "Show Getting Started", onClick: this.showGettingStarted }),
                    React.createElement(Divider_1.default, null),
                    React.createElement(ExternalLink_1.default, { href: "DocumentationHome", showIcon: false },
                        React.createElement(MenuItem_1.default, { style: { color: colors_1.primary }, onClick: this.handleRequestClose, primaryText: "Documentation" })),
                    React.createElement(ExternalLink_1.default, { href: window.location.origin + window.location.pathname + "/../swaggerui/", showIcon: false },
                        React.createElement(MenuItem_1.default, { style: { color: colors_1.primary }, onClick: this.handleRequestClose, primaryText: "API Documentation" })),
                    React.createElement(ExternalLink_1.default, { href: "HelpGeneral", showIcon: false },
                        React.createElement(MenuItem_1.default, { style: { color: colors_1.primary }, onClick: this.handleRequestClose, primaryText: "Support" })),
                    React.createElement(ExternalLink_1.default, { href: "TrainingVideos", showIcon: false },
                        React.createElement(MenuItem_1.default, { style: { color: colors_1.primary }, onClick: this.handleRequestClose, primaryText: "Training Videos" })),
                    React.createElement(ExternalLink_1.default, { href: "HelpMakeSuggestion", showIcon: false },
                        React.createElement(MenuItem_1.default, { style: { color: colors_1.primary }, onClick: this.handleRequestClose, primaryText: "Suggestions" })),
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/downloads", showIcon: false },
                        React.createElement(MenuItem_1.default, { style: { color: colors_1.primary }, onClick: this.handleRequestClose, primaryText: "Downloads" })))));
    };
    return UserAccountMenu;
}(React.Component));
exports.default = UserAccountMenu;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\UserAccountMenu.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\UserAccountMenu.tsx"); } } })();

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1425);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_avatarContainer__g7FH3{display:inline-flex;align-items:center;justify-content:center;border-radius:50%}", ""]);

// exports
exports.locals = {
	"avatarContainer": "style_avatarContainer__g7FH3"
};

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "avatar-placeholder.0876f92fb5eea75f41a4872a88b45c39.hashedasset.svg";

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "octopus-service-440.d67f868bec6e1167abe0f9f649f4f34f.hashedasset.svg";

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "user-placeholder.fd4b3910137a5cbcbd834121d24f1877.hashedasset.svg";

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(205);
var GettingStartedDetailSection = function (props) {
    return React.createElement("span", { className: cn(styles.section, (_a = {}, _a[styles.pulseSection] = props.highlightSection, _a)) },
        props.complete && React.createElement("div", { className: styles.complete },
            React.createElement("em", { className: "fa fa-check", "aria-hidden": "true" })),
        React.createElement("div", { className: styles.top },
            React.createElement("img", { src: props.imgSrc, height: "50", alt: props.area }),
            React.createElement("div", null, props.header),
            React.createElement("div", { className: styles.area }, props.area)),
        React.createElement("div", { className: styles.content }, props.children));
    var _a;
};
exports.default = GettingStartedDetailSection;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\GettingStartedDetailSection.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\GettingStartedDetailSection.tsx"); } } })();

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1qGL9{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__Isrzx{display:none!important}}@media (max-width:79.9rem){.style_hide-md__1vtbS{display:none!important}}@media (min-width:79.9rem){.style_visible-md__3vFPC{display:none!important}}.style_progressContainer__1TeC3{width:4rem;height:4rem}.style_title__S9Exc{color:#fff;font-size:.5rem;text-align:center;margin-top:.25rem}.style_progressWrapper__2VYT4{flex-direction:column;display:flex;align-items:center;position:relative}.style_progressWrapper__2VYT4 div.style_complete__30TO8{width:1.25rem;height:1.25rem;border-radius:50px;color:#fff;background-color:#53b953;position:absolute;top:.0625rem;right:19px;z-index:10;font-size:.625rem;align-items:center;justify-content:center;display:flex}.style_gettingStartedFooter__3iESu{position:fixed;left:0;bottom:0;height:auto;width:100%;background:#053b62;z-index:30}.style_gettingStartedFooter__3iESu .style_firstSuccessfulDeploymentContainer__3Xtep{color:#fff;display:flex;justify-content:center}.style_gettingStartedFooter__3iESu .style_firstSuccessfulDeploymentContainer__3Xtep .style_firstSuccessfulDeployment__32UQQ{display:flex;flex-flow:row}.style_gettingStartedFooter__3iESu .style_firstSuccessfulDeploymentContainer__3Xtep .style_firstSuccessfulDeployment__32UQQ div p{color:#fff}.style_gettingStartedFooter__3iESu .style_gettingStartedFooterActions__J1Obb{position:fixed;margin:.125rem;right:0;z-index:2}.style_gettingStartedFooter__3iESu .style_gettingStartedFooterActions__J1Obb .style_gettingStartedButton__yxInE{color:#fff;min-width:5.3125rem;padding:.1875rem;margin-bottom:2px;display:block;text-align:right;cursor:pointer}.style_gettingStartedFooter__3iESu .style_gettingStartedFooterActions__J1Obb .style_gettingStartedButton__yxInE:hover{background-color:#2f93e0}.style_gettingStartedFooter__3iESu .style_gettingStartedFooterActions__J1Obb .style_gettingStartedButton__yxInE:hover span{display:inline}.style_gettingStartedFooter__3iESu .style_gettingStartedFooterActions__J1Obb .style_gettingStartedButton__yxInE span{font-size:.8125rem;display:none;padding-right:.1875rem;padding-left:.1875rem;vertical-align:middle}.style_gettingStartedFooter__3iESu .style_gettingStartedMinimize__3dHKy{height:1.8125rem}.style_gettingStartedFooter__3iESu .style_whatsNextContainer__1TBd6{display:flex;align-items:center}@media (max-width:79.9rem){.style_gettingStartedFooter__3iESu .style_whatsNextContainer__1TBd6{justify-content:center}}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe{display:flex;padding:.625rem}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_whatsNext__3fcgc{color:#fff;text-align:left;margin:.3125rem;display:flex;flex-flow:column;align-items:center}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_whatsNext__3fcgc .style_whatsNextText__1y7bz{font-size:.75rem;font-weight:400;margin-bottom:.3125rem}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStepWrapper__155_k{display:flex;flex-grow:1;justify-content:flex-end;margin-right:5rem}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStepWrapper__155_k .style_progressStep__1ei9g{display:flex;flex-direction:column;min-width:6.25rem}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStepWrapper__155_k .style_progressStep__1ei9g a{cursor:pointer}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStepWrapper__155_k .style_progressStep__1ei9g:hover{color:#333}@media (max-width:79.9rem){.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe{flex-direction:column}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_whatsNext__3fcgc{margin:0}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_whatsNext__3fcgc .style_whatsNextText__1y7bz{display:inline-block;margin-left:.3125rem;margin-right:.3125rem}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStepWrapper__155_k{margin-right:2.5rem;justify-content:center;margin-right:0}}@media (max-width:37.4rem){.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_whatsNext__3fcgc{text-align:left;width:80%}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStep__1ei9g{margin-top:1.25rem}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStepWrapper__155_k{display:none}}.style_gettingStartedFooter__3iESu .style_gettingStartedDetail__3Zjm6{background-color:#fff;margin:1.25rem}.style_li-style__l9UpK{font-family:FontAwesome;display:inline-block;padding-right:5px}@keyframes style_section-pulse__9LYyk{0%{transform:scale(1)}30%{transform:scale(1.08)}40%{transform:scale(1)}50%{transform:scale(1.08)}60%{transform:scale(1.02)}70%{transform:scale(1.06)}80%{transform:scale(1)}to{transform:scale(1)}}.style_pulseSection__1BhfS{animation-duration:2s;animation-iteration-count:1;animation-name:style_section-pulse__9LYyk;animation-delay:0s}.style_liftBusyIndicator__molZw div:first-child{margin-top:-1.5rem}.style_gettingStartedSection__2PC-b{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;width:100%;padding-bottom:20px}.style_section__FP2lJ{margin-right:1.25rem;margin-top:.625rem;display:flex;flex-direction:column;width:13.125rem;position:relative;box-shadow:0 .0625rem .25rem 0 rgba(0,0,0,.12);background:#fff}.style_section__FP2lJ div.style_complete__30TO8{width:2.0625rem;height:2.0625rem;border-radius:50px;color:#fff;background-color:#53b953;position:absolute;top:-15px;right:-15px;z-index:1;font-size:.9375rem;align-items:center;justify-content:center;display:flex}.style_section__FP2lJ .style_top__2dj6-{height:9.375rem;font-size:1.125rem;text-align:center;color:#333}.style_section__FP2lJ .style_top__2dj6- .style_area__2gSY9{font-weight:600}.style_section__FP2lJ .style_top__2dj6- img{margin-bottom:.625rem;margin-top:1.25rem}.style_section__FP2lJ .style_content__3p-R-{padding:0 1rem 1.5rem;min-height:30rem;background-color:#fff;position:relative;margin-top:-2px;font-size:.8125rem}.style_actionsList__2d-tv{list-style:none;text-align:left;padding:0}.style_actionsList__2d-tv li{padding:.125rem;text-indent:-10px;margin-left:1rem}.style_actionsList__2d-tv li.style_complete__30TO8 a{color:#2f93e0}.style_actionsList__2d-tv li.style_complete__30TO8:before{content:\"\\F00C\";color:#53b953;font-family:FontAwesome;display:inline-block;padding-right:5px}.style_actionsList__2d-tv li.style_edit__FmgWI a{color:#2f93e0}.style_actionsList__2d-tv li.style_edit__FmgWI:before{content:\"\\F14B\";color:#2f93e0;font-family:FontAwesome;display:inline-block;padding-right:5px}.style_actionsList__2d-tv li.style_info__1Wric a{color:#2f93e0}.style_actionsList__2d-tv li.style_info__1Wric:before{content:\"\\F05A\";color:#2f93e0;font-family:FontAwesome;display:inline-block;padding-right:5px}.style_actionsList__2d-tv li.style_disabled__6Kyhu{opacity:.5}.style_actionsList__2d-tv li.style_disabled__6Kyhu:before{color:#333}.style_actionsList__2d-tv li.style_completeReadOnly__2gim1{font-weight:600;text-indent:0}.style_actionsList__2d-tv li.style_completeReadOnly__2gim1 div.style_note__14HFH{font-weight:400}.style_actionsList__2d-tv li a,.style_actionsList__2d-tv li span{font-weight:600}.style_actionsList__2d-tv li div.style_note__14HFH{text-indent:0;margin-top:4px;margin-bottom:10px}.style_actionsList__2d-tv li div.style_note__14HFH.style_disabled__6Kyhu{opacity:.5}.style_actionsList__2d-tv li ul.style_dropdown-menu__2PnKD li{text-indent:0;margin-left:0}.style_actionsList__2d-tv li ul.style_dropdown-menu__2PnKD a{font-weight:400}.style_help__1LB_v{position:absolute;bottom:0;text-align:left;margin:.625rem .625rem .625rem 0;color:#9e9e9e}.style_getting-started-details-next-action__hmR4Y{margin:1.875rem 0}.style_container__1dK4v{display:flex;align-items:center;justify-content:center;flex-direction:column}.style_container__1dK4v>div{display:flex;flex-direction:row;flex-wrap:wrap;width:100%}@media (max-width:543px){.style_container__1dK4v{padding:0 1rem}.style_section__FP2lJ{width:100%;display:block;margin-top:.625rem}.style_section__FP2lJ .style_top__2dj6-{width:100%;padding:.625rem .625rem 0;height:3.4375rem;font-size:.875rem;letter-spacing:-.25px}.style_section__FP2lJ .style_top__2dj6- img{float:left;margin-right:.625rem;width:1.875rem;top:-8px;position:relative;margin-top:0;margin-bottom:0}.style_section__FP2lJ .style_top__2dj6- div{float:left;margin-right:.4375rem;margin-top:.4375rem}.style_section__FP2lJ div.style_complete__30TO8{width:1.5625rem;height:1.5625rem;top:-6px;right:-11px;font-size:.75rem;padding-top:.25rem}.style_section__FP2lJ:first-child{margin-top:1.875rem}.style_section__FP2lJ .style_content__3p-R-{min-height:0}.style_section__FP2lJ .style_content__3p-R- .style_help__1LB_v{position:relative;bottom:0;left:0;text-align:left;margin:0}.style_section__FP2lJ .style_content__3p-R- .style_actionsList__2d-tv li p{font-size:.8125rem}}.style_lookLikeALink__1P6_L{color:#2f93e0;cursor:pointer}.style_successAnimation__3ZmEj{height:250px}.style_successAnimation__3ZmEj .style_balloon__2EOj8,.style_successAnimation__3ZmEj .style_fireworkBlue__2FVnb,.style_successAnimation__3ZmEj .style_fireworkWhite__3gac2,.style_successAnimation__3ZmEj .style_octopus__JP07K,.style_successAnimation__3ZmEj .style_thread__1b-OJ{display:none\\9}.style_detailsWhatsNextContainer__14nww{justify-content:center;padding-bottom:1rem}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1qGL9",
	"hideSm": "style_hide-sm__1qGL9",
	"visible-sm": "style_visible-sm__Isrzx",
	"visibleSm": "style_visible-sm__Isrzx",
	"hide-md": "style_hide-md__1vtbS",
	"hideMd": "style_hide-md__1vtbS",
	"visible-md": "style_visible-md__3vFPC",
	"visibleMd": "style_visible-md__3vFPC",
	"progressContainer": "style_progressContainer__1TeC3",
	"title": "style_title__S9Exc",
	"progressWrapper": "style_progressWrapper__2VYT4",
	"complete": "style_complete__30TO8",
	"gettingStartedFooter": "style_gettingStartedFooter__3iESu",
	"firstSuccessfulDeploymentContainer": "style_firstSuccessfulDeploymentContainer__3Xtep",
	"firstSuccessfulDeployment": "style_firstSuccessfulDeployment__32UQQ",
	"gettingStartedFooterActions": "style_gettingStartedFooterActions__J1Obb",
	"gettingStartedButton": "style_gettingStartedButton__yxInE",
	"gettingStartedMinimize": "style_gettingStartedMinimize__3dHKy",
	"whatsNextContainer": "style_whatsNextContainer__1TBd6",
	"gettingStartedContent": "style_gettingStartedContent__2myTe",
	"whatsNext": "style_whatsNext__3fcgc",
	"whatsNextText": "style_whatsNextText__1y7bz",
	"progressStepWrapper": "style_progressStepWrapper__155_k",
	"progressStep": "style_progressStep__1ei9g",
	"gettingStartedDetail": "style_gettingStartedDetail__3Zjm6",
	"li-style": "style_li-style__l9UpK",
	"liStyle": "style_li-style__l9UpK",
	"pulseSection": "style_pulseSection__1BhfS",
	"section-pulse": "style_section-pulse__9LYyk",
	"sectionPulse": "style_section-pulse__9LYyk",
	"liftBusyIndicator": "style_liftBusyIndicator__molZw",
	"gettingStartedSection": "style_gettingStartedSection__2PC-b",
	"section": "style_section__FP2lJ",
	"top": "style_top__2dj6-",
	"area": "style_area__2gSY9",
	"content": "style_content__3p-R-",
	"actionsList": "style_actionsList__2d-tv",
	"edit": "style_edit__FmgWI",
	"info": "style_info__1Wric",
	"disabled": "style_disabled__6Kyhu",
	"completeReadOnly": "style_completeReadOnly__2gim1",
	"note": "style_note__14HFH",
	"dropdown-menu": "style_dropdown-menu__2PnKD",
	"dropdownMenu": "style_dropdown-menu__2PnKD",
	"help": "style_help__1LB_v",
	"getting-started-details-next-action": "style_getting-started-details-next-action__hmR4Y",
	"gettingStartedDetailsNextAction": "style_getting-started-details-next-action__hmR4Y",
	"container": "style_container__1dK4v",
	"lookLikeALink": "style_lookLikeALink__1P6_L",
	"successAnimation": "style_successAnimation__3ZmEj",
	"fireworkBlue": "style_fireworkBlue__2FVnb",
	"fireworkWhite": "style_fireworkWhite__3gac2",
	"balloon": "style_balloon__2EOj8",
	"thread": "style_thread__1b-OJ",
	"octopus": "style_octopus__JP07K",
	"detailsWhatsNextContainer": "style_detailsWhatsNextContainer__14nww"
};

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Popover_1 = __webpack_require__(146);
var Menu_1 = __webpack_require__(175);
var MenuItem_1 = __webpack_require__(97);
var colors_1 = __webpack_require__(32);
var styles = __webpack_require__(205);
var InternalLink_1 = __webpack_require__(42);
var popoverStyle = {
    backgroundColor: colors_1.white,
    color: colors_1.primaryText
};
var menuItemStyle = {
    color: colors_1.primaryText
};
var SectionStepLink = (function (_super) {
    __extends(SectionStepLink, _super);
    function SectionStepLink(props) {
        var _this = _super.call(this, props) || this;
        _this.handleNavigate = function () {
            _this.setState({
                open: false
            });
            if (_this.props.onNavigating) {
                _this.props.onNavigating();
            }
        };
        _this.handleTouchTap = function (event) {
            event.preventDefault();
            _this.setState({
                open: true,
                anchor: event.currentTarget
            });
        };
        _this.handleRequestClose = function () {
            _this.setState({
                open: false
            });
        };
        _this.state = {
            open: false,
            anchor: null,
        };
        return _this;
    }
    SectionStepLink.prototype.render = function () {
        var _this = this;
        if (this.props.items) {
            return (React.createElement("span", null,
                React.createElement(Popover_1.default, { open: this.state.open, style: popoverStyle, canAutoPosition: true, anchorEl: this.state.anchor, anchorOrigin: { horizontal: "left", vertical: "bottom" }, targetOrigin: { horizontal: "left", vertical: "top" }, onRequestClose: this.handleRequestClose },
                    React.createElement(Menu_1.default, null, this.props.items.map(function (item) {
                        return React.createElement(InternalLink_1.default, { key: item.label, to: item.link },
                            React.createElement(MenuItem_1.default, { key: item.label, style: menuItemStyle, primaryText: item.label, onClick: _this.handleNavigate }));
                    }))),
                React.createElement("span", { className: styles.lookLikeALink, onClick: this.handleTouchTap },
                    this.props.text,
                    this.props.items && React.createElement("em", { style: { paddingLeft: "11px" }, className: "fa fa-caret-down" }))));
        }
        if (this.props.path) {
            return React.createElement(InternalLink_1.default, { to: this.props.path },
                React.createElement("span", { className: styles.lookLikeALink, onClick: function () { return _this.handleNavigate(); } }, this.props.text));
        }
        return React.createElement("span", null, this.props.text);
    };
    return SectionStepLink;
}(React.Component));
exports.SectionStepLink = SectionStepLink;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\SectionStepLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\SectionStepLink.tsx"); } } })();

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RaisedButton_1 = __webpack_require__(217);
var Popover_1 = __webpack_require__(146);
var Menu_1 = __webpack_require__(175);
var MenuItem_1 = __webpack_require__(97);
var colors_1 = __webpack_require__(32);
var InternalLink_1 = __webpack_require__(42);
var buttonStyle = {
    labelColor: colors_1.white,
    backgroundColor: colors_1.success,
};
var popoverStyle = {
    backgroundColor: colors_1.success,
    color: colors_1.white
};
var menuItemStyle = {
    color: colors_1.white
};
var NextButton = (function (_super) {
    __extends(NextButton, _super);
    function NextButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTouchTap = function (event) {
            event.preventDefault();
            _this.setState({
                open: true,
                anchor: event.currentTarget
            });
        };
        _this.handleRequestClose = function () {
            _this.setState({
                open: false
            });
        };
        _this.state = {
            open: false,
            anchor: null
        };
        return _this;
    }
    NextButton.prototype.render = function () {
        var _this = this;
        if (this.props.items.length === 0) {
            return null;
        }
        if (this.props.items.length > 1) {
            var popover = (React.createElement(Popover_1.default, { open: this.state.open, style: popoverStyle, canAutoPosition: true, anchorEl: this.state.anchor, anchorOrigin: { horizontal: "left", vertical: "bottom" }, targetOrigin: { horizontal: "left", vertical: "top" }, onRequestClose: this.handleRequestClose },
                React.createElement(Menu_1.default, null, this.props.items.map(function (item) {
                    return React.createElement(InternalLink_1.default, { key: item.label, to: item.link, onClick: _this.props.onClick },
                        React.createElement(MenuItem_1.default, { primaryText: item.label, style: menuItemStyle, onClick: _this.handleRequestClose }));
                }))));
            return (React.createElement("div", null,
                React.createElement(RaisedButton_1.default, __assign({}, buttonStyle, { style: { margin: "0.5rem" }, label: this.props.defaultLabel, labelPosition: "before", icon: React.createElement("em", { className: "fa fa-caret-down", style: { color: colors_1.white } }), onClick: this.handleTouchTap })),
                popover));
        }
        return (React.createElement(InternalLink_1.default, { to: this.props.items[0].link, onClick: this.props.onClick },
            React.createElement(RaisedButton_1.default, __assign({}, buttonStyle, { style: { margin: "0.5rem" }, label: this.props.defaultLabel }))));
    };
    return NextButton;
}(React.Component));
exports.NextButton = NextButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\NextButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\NextButton.tsx"); } } })();

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1434);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_box__WuJnm,.style_information__hNEcB{padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_information__hNEcB{background:rgba(33,86,128,.1)}.style_information__hNEcB .style_title__3E4i5{color:#215680}.style_success__2MJei{background:rgba(83,185,83,.1);padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_success__2MJei .style_title__3E4i5{color:#53b953}.style_warning__mS5OQ{background:rgba(251,140,0,.1);padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_warning__mS5OQ .style_title__3E4i5{color:#fb8c00}.style_danger__3pDp5{background:rgba(219,68,55,.1);padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_danger__3pDp5 .style_title__3E4i5{color:#db4437}.style_none__3NoL2{padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_title__3E4i5{margin-bottom:.625rem}", ""]);

// exports
exports.locals = {
	"box": "style_box__WuJnm",
	"information": "style_information__hNEcB",
	"title": "style_title__3E4i5",
	"success": "style_success__2MJei",
	"warning": "style_warning__mS5OQ",
	"danger": "style_danger__3pDp5",
	"none": "style_none__3NoL2"
};

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1436);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1u_rv{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__8-REi{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2fzKy{display:none!important}}@media (min-width:79.9rem){.style_visible-md__pCGNQ{display:none!important}}.style_whatsNextButtonsContainer__13Mzc{display:flex;flex-flow:row;align-items:center;justify-content:space-between}@media (max-width:37.4rem){.style_whatsNextButtonsContainer__13Mzc{flex-flow:column}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1u_rv",
	"hideSm": "style_hide-sm__1u_rv",
	"visible-sm": "style_visible-sm__8-REi",
	"visibleSm": "style_visible-sm__8-REi",
	"hide-md": "style_hide-md__2fzKy",
	"hideMd": "style_hide-md__2fzKy",
	"visible-md": "style_visible-md__pCGNQ",
	"visibleMd": "style_visible-md__pCGNQ",
	"whatsNextButtonsContainer": "style_whatsNextButtonsContainer__13Mzc"
};

/***/ }),
/* 1437 */,
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinksMenu_1 = __webpack_require__(636);
var React = __webpack_require__(0);
exports.LinksMenuButton = function (props) { return React.createElement("li", { key: "navItem-more" },
    React.createElement(LinksMenu_1.LinksMenu, { items: props.moreItems, label: props.label, icon: props.icon })); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LinksMenu\\LinksMenuButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\LinksMenu\\LinksMenuButton.tsx"); } } })();

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function toPath(to) {
    if (typeof to !== "string") {
        return to.pathname;
    }
    return to;
}
exports.toPath = toPath;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\toPath.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navigation\\toPath.ts"); } } })();

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
var notifications_redux_1 = __webpack_require__(153);
var NotificationPoller_1 = __webpack_require__(638);
var notificationLocalState = __webpack_require__(237);
var PermissionCheck_1 = __webpack_require__(45);
var permission_1 = __webpack_require__(49);
var routeLinks_1 = __webpack_require__(20);
var moment = __webpack_require__(104);
var LicenceNotificationPoller = (function (_super) {
    __extends(LicenceNotificationPoller, _super);
    function LicenceNotificationPoller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notificationId = "Notification/LicenceCheck";
        _this.notificationCheck = function () { return __awaiter(_this, void 0, void 0, function () {
            var licenseStatus, isExpired, isExpiringSoon, showLicenseExpiringNotification, isAdmin, licenseRenewalUrl, license;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Licenses.getCurrentStatus()];
                    case 1:
                        licenseStatus = _a.sent();
                        isExpired = licenseStatus.MaintenanceExpiresIn < 0;
                        isExpiringSoon = licenseStatus.MaintenanceExpiresIn >= 0 && licenseStatus.MaintenanceExpiresIn < 15;
                        showLicenseExpiringNotification = isExpiringSoon || isExpired;
                        if (!showLicenseExpiringNotification) {
                            return [2 /*return*/, this.dismissNotification()];
                        }
                        if (this.wasDismissedLoadedOverTwoDasyAgo()) {
                            notificationLocalState.clearValue(this.notificationId);
                        }
                        isAdmin = false;
                        licenseRenewalUrl = "Renew";
                        if (!PermissionCheck_1.isAllowed({ permission: permission_1.Permission.AdministerSystem })) return [3 /*break*/, 3];
                        return [4 /*yield*/, clientInstance_1.repository.Licenses.getCurrent()];
                    case 2:
                        license = _a.sent();
                        isAdmin = license != null;
                        licenseRenewalUrl = "Renew?licenseKey=" + license.LicenseKey;
                        _a.label = 3;
                    case 3:
                        this.raiseNotification({
                            id: this.notificationId,
                            text: isExpired ? "Your license has expired." : "Your license is expiring soon.",
                            description: "Renew now to continue receiving support and updates.",
                            links: isAdmin
                                ? [{ type: "External", label: "Renew Now", href: licenseRenewalUrl },
                                    { type: "Internal", label: "View license details", href: routeLinks_1.default.configuration.license }]
                                : [{ type: "None", label: "Contact your Octopus administrator to review and renew your license." }],
                            type: isExpired ? notifications_redux_1.NotificationType.error : notifications_redux_1.NotificationType.warn
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    LicenceNotificationPoller.prototype.wasDismissedLoadedOverTwoDasyAgo = function () {
        var userReadLicenseRenewalNotificationOnDateString = notificationLocalState.getCurrentValue(this.notificationId);
        if (userReadLicenseRenewalNotificationOnDateString === null) {
            return false;
        }
        var dateAsNumber = Date.parse(userReadLicenseRenewalNotificationOnDateString);
        if (isNaN(dateAsNumber)) {
            return true;
        }
        return moment(dateAsNumber).isBefore(moment().subtract(2, "days"));
    };
    return LicenceNotificationPoller;
}(NotificationPoller_1.NotificationPoller));
exports.default = LicenceNotificationPoller;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\NotificationPoller\\LicenceNotificationPoller.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\NotificationPoller\\LicenceNotificationPoller.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
var upgradeConfigurationResource_1 = __webpack_require__(442);
var notifications_redux_1 = __webpack_require__(153);
var NotificationPoller_1 = __webpack_require__(638);
var UpdateAvailableNotificationPoller = (function (_super) {
    __extends(UpdateAvailableNotificationPoller, _super);
    function UpdateAvailableNotificationPoller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notificationId = "Notification/UpgradeAvailable";
        _this.notificationCheck = function () { return __awaiter(_this, void 0, void 0, function () {
            var status, config, canUpgradeFreeOfCharge, expiryMessage, description;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.ServerStatus.getServerStatus()];
                    case 1:
                        status = _a.sent();
                        // No upgrade available
                        if (!status.IsUpgradeAvailable) {
                            return [2 /*return*/, this.dismissNotification()];
                        }
                        return [4 /*yield*/, clientInstance_1.repository.UpgradeConfiguration.get()];
                    case 2:
                        config = _a.sent();
                        if (config.NotificationMode === upgradeConfigurationResource_1.UpgradeNotificationMode.NeverShow ||
                            config.NotificationMode === upgradeConfigurationResource_1.UpgradeNotificationMode.ShowOnlyMajorMinor && !status.IsMajorMinorUpgrade) {
                            return [2 /*return*/, this.dismissNotification()];
                        }
                        canUpgradeFreeOfCharge = status.MaximumAvailableVersion === status.MaximumAvailableVersionCoveredByLicense;
                        expiryMessage = status.MaintenanceExpires != null ? "expired on " + status.MaintenanceExpires : "has expired";
                        description = "Version " + status.MaximumAvailableVersion + " of Octopus has been released\n             " + (canUpgradeFreeOfCharge
                            ? " and you can upgrade free of charge!"
                            : ". Your license " + expiryMessage + " and covers updates through to " + status.MaximumAvailableVersionCoveredByLicense + ".\n             Please renew your license to upgrade to " + status.MaximumAvailableVersion + ".");
                        this.raiseNotification({
                            id: this.notificationId,
                            value: status.MaximumAvailableVersion,
                            text: "New release available.",
                            type: notifications_redux_1.NotificationType.info,
                            description: description,
                            links: [{
                                    type: "External",
                                    href: "ProductDownloadPage",
                                    label: "Download now"
                                }],
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    return UpdateAvailableNotificationPoller;
}(NotificationPoller_1.NotificationPoller));
exports.default = UpdateAvailableNotificationPoller;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\NotificationPoller\\UpdateAvailableNotificationPoller.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\NotificationPoller\\UpdateAvailableNotificationPoller.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var Popover_1 = __webpack_require__(146);
var notifications_1 = __webpack_require__(1443);
var ExternalLink_1 = __webpack_require__(91);
var InternalLink_1 = __webpack_require__(213);
var Divider_1 = __webpack_require__(248);
var Badge_1 = __webpack_require__(453);
var styles = __webpack_require__(1444);
var stylesDefault = __webpack_require__(245);
var colors_1 = __webpack_require__(32);
var BaseComponent_1 = __webpack_require__(14);
var lodash_1 = __webpack_require__(16);
var react_redux_1 = __webpack_require__(67);
var notifications_redux_1 = __webpack_require__(153);
var notificationLocalState = __webpack_require__(237);
var NotificationsMenu = (function (_super) {
    __extends(NotificationsMenu, _super);
    function NotificationsMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.checkNotificationsAlert = function (props) {
            var showNewNotificationsAlert = !!props.notifications
                .find(function (n) {
                var currentValue = notificationLocalState.getCurrentValue(n.id);
                var notificationHasValue = !!n.value;
                return !currentValue ||
                    !((notificationHasValue && currentValue === n.value) || !notificationHasValue);
            });
            _this.setState({ showNewNotificationsAlert: showNewNotificationsAlert });
        };
        _this.renderNotification = function (notification, index) {
            return React.createElement("div", { key: notification.text, className: styles.container },
                index > 0 && React.createElement(Divider_1.default, null),
                React.createElement("div", { className: styles.notification },
                    React.createElement("div", { className: styles.grow },
                        React.createElement("div", { className: cn(styles.title, (_a = {},
                                _a[styles.textHappy] = notification.type === notifications_redux_1.NotificationType.happy,
                                _a[styles.textInfo] = notification.type === notifications_redux_1.NotificationType.info,
                                _a[styles.textWarn] = notification.type === notifications_redux_1.NotificationType.warn,
                                _a[styles.textError] = notification.type === notifications_redux_1.NotificationType.error,
                                _a)) }, notification.text),
                        React.createElement("div", { className: styles.description }, notification.description),
                        notification.links && React.createElement("div", { className: styles.links }, notification.links.map(function (link, i) {
                            return React.createElement("span", { key: i },
                                i > 0 && " | ",
                                _this.renderLink(link));
                        }))),
                    React.createElement("div", { className: styles.icon }, _this.displayIcon(notification.type))));
            var _a;
        };
        _this.markNotificationsAsRead = function () {
            _this.props.notifications
                .forEach(function (n) { return notificationLocalState.setCurrentValue(n.id, n.value); });
            _this.setState({
                showNewNotificationsAlert: false
            });
        };
        _this.displayIcon = function (type) {
            switch (type) {
                case notifications_redux_1.NotificationType.happy:
                    return React.createElement("div", { className: cn("fa fa-smile-o", styles.notificationIcon, styles.bgHappy) });
                case notifications_redux_1.NotificationType.info:
                    return React.createElement("div", { className: cn("fa fa-info-circle", styles.notificationIcon, styles.bgInfo) });
                case notifications_redux_1.NotificationType.warn:
                    return React.createElement("div", { className: cn("fa fa-warning", styles.notificationIcon, styles.bgWarn) });
                case notifications_redux_1.NotificationType.error:
                    return React.createElement("div", { className: cn("fa fa-warning", styles.notificationIcon, styles.bgError) });
            }
        };
        _this.setRef = function (el) {
            _this.menuButton = el;
        };
        _this.handleTouchTap = function (event) {
            event.preventDefault();
            _this.markNotificationsAsRead();
            _this.setState({
                isMenuOpen: !_this.state.isMenuOpen
            });
        };
        _this.handleRequestClose = function () {
            _this.setState({
                isMenuOpen: false,
            });
        };
        _this.state = {
            isMenuOpen: false,
            notifications: [NotificationsMenu.defaultNotification],
            showNewNotificationsAlert: false,
        };
        return _this;
    }
    NotificationsMenu.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.checkNotificationsAlert(this.props);
                return [2 /*return*/];
            });
        });
    };
    NotificationsMenu.prototype.componentWillReceiveProps = function (newProps) {
        if (this.props.notifications !== newProps.notifications) {
            this.checkNotificationsAlert(newProps);
        }
    };
    NotificationsMenu.prototype.renderBadge = function () {
        if (this.state.showNewNotificationsAlert) {
            return React.createElement(Badge_1.default, { style: { padding: 0 }, badgeContent: "", badgeStyle: {
                    backgroundColor: colors_1.danger,
                    border: "white 2px solid",
                    top: 0,
                    right: 0,
                    width: 12,
                    height: 12
                } },
                React.createElement(notifications_1.default, { color: colors_1.white }));
        }
        return React.createElement(Badge_1.default, { style: { padding: 0 }, badgeContent: "", badgeStyle: { width: 0, height: 0 } },
            React.createElement(notifications_1.default, { color: colors_1.white }));
    };
    NotificationsMenu.prototype.renderLink = function (link) {
        switch (link.type) {
            case "External": {
                return React.createElement(ExternalLink_1.default, { href: link.href }, link.label);
            }
            case "Internal": {
                return React.createElement(InternalLink_1.default, { to: link.href }, link.label);
            }
            case "Refresh": {
                return React.createElement(InternalLink_1.default, { onClick: function () { return window.location.reload(); }, to: {} }, link.label);
            }
            default: {
                return React.createElement("span", null, link.label);
            }
        }
    };
    NotificationsMenu.prototype.render = function () {
        var notifications = this.props.notifications.slice();
        if (notifications.length === 0) {
            notifications.push(NotificationsMenu.defaultNotification);
        }
        return React.createElement("div", null,
            React.createElement("a", { className: stylesDefault.button, onClick: this.handleTouchTap, href: "#", title: "Notifications", ref: this.setRef }, this.renderBadge()),
            React.createElement(Popover_1.default, { open: this.state.isMenuOpen, anchorEl: this.menuButton, onRequestClose: this.handleRequestClose, anchorOrigin: { horizontal: "right", vertical: "bottom" }, targetOrigin: { horizontal: "right", vertical: "top" } }, notifications.map(this.renderNotification)));
    };
    NotificationsMenu.defaultNotification = {
        id: null,
        text: "You have no notifications.",
        type: notifications_redux_1.NotificationType.happy,
        description: "Happy deployments!"
    };
    return NotificationsMenu;
}(BaseComponent_1.BaseComponent));
exports.default = react_redux_1.connect(function (state, props) {
    return {
        notifications: lodash_1.values(state.notifications)
    };
}, function (dispatch) {
    return {};
})(NotificationsMenu);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\NotificationsMenu.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Navbar\\NotificationsMenu.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1443 */,
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1445);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./notifications.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./notifications.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.notifications_hide-sm__2ipZG{display:none!important}}@media (min-width:37.4rem){.notifications_visible-sm__2BKM8{display:none!important}}@media (max-width:79.9rem){.notifications_hide-md___eL7A{display:none!important}}@media (min-width:79.9rem){.notifications_visible-md__pp_fZ{display:none!important}}.notifications_container__1gCNU{display:flex;flex-direction:column;width:18.75rem}@media (max-width:37.4rem){.notifications_container__1gCNU{width:16.25rem}}.notifications_grow__3dIkf{flex-grow:1;padding-right:.625rem}.notifications_notification__2xotL{padding:.4375rem .75rem;display:flex}.notifications_title__ItsQn{font-size:.875rem;font-weight:600;padding-bottom:.0625rem}.notifications_description__1DcYx{font-size:.8125rem;color:#666}.notifications_icon__3jaRG{display:flex;align-items:center}.notifications_links__2erm-{margin-top:.625rem;font-size:.8125rem}.notifications_notificationIcon__2I-wP{width:1.625rem;height:1.625rem;line-height:1.625rem!important;text-align:center;border-radius:.125rem;font-size:.875rem;color:#fff}.notifications_textHappy__3uVq4{color:#74c0fb}.notifications_bgHappy__1a-IF{background-color:#74c0fb}.notifications_textInfo__3VQbg{color:#74c0fb}.notifications_bgInfo__1wzjH{background-color:#74c0fb}.notifications_textWarn__-4KTH{color:#fb8c00}.notifications_bgWarn__NaFUU{background-color:#fb8c00}.notifications_textError__1Lb-D{color:#db4437}.notifications_bgError__1nmGI{background-color:#db4437}", ""]);

// exports
exports.locals = {
	"hide-sm": "notifications_hide-sm__2ipZG",
	"hideSm": "notifications_hide-sm__2ipZG",
	"visible-sm": "notifications_visible-sm__2BKM8",
	"visibleSm": "notifications_visible-sm__2BKM8",
	"hide-md": "notifications_hide-md___eL7A",
	"hideMd": "notifications_hide-md___eL7A",
	"visible-md": "notifications_visible-md__pp_fZ",
	"visibleMd": "notifications_visible-md__pp_fZ",
	"container": "notifications_container__1gCNU",
	"grow": "notifications_grow__3dIkf",
	"notification": "notifications_notification__2xotL",
	"title": "notifications_title__ItsQn",
	"description": "notifications_description__1DcYx",
	"icon": "notifications_icon__3jaRG",
	"links": "notifications_links__2erm-",
	"notificationIcon": "notifications_notificationIcon__2I-wP",
	"textHappy": "notifications_textHappy__3uVq4",
	"bgHappy": "notifications_bgHappy__1a-IF",
	"textInfo": "notifications_textInfo__3VQbg",
	"bgInfo": "notifications_bgInfo__1wzjH",
	"textWarn": "notifications_textWarn__-4KTH",
	"bgWarn": "notifications_bgWarn__NaFUU",
	"textError": "notifications_textError__1Lb-D",
	"bgError": "notifications_bgError__1nmGI"
};

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ErrorPanel_1 = __webpack_require__(83);
exports.default = ErrorPanel_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ErrorPanel\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ErrorPanel\\index.tsx"); } } })();

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RootRoutes_1 = __webpack_require__(1448);
exports.default = RootRoutes_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\RootRoutes\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\RootRoutes\\index.tsx"); } } })();

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var importAsync_1 = __webpack_require__(1449);
var DashboardRoutes_1 = __webpack_require__(1450);
var DashboardOverview_1 = __webpack_require__(639);
var UserProfileRoutes_1 = __webpack_require__(1649);
var ProjectGroupLayout_1 = __webpack_require__(1706);
var DeploymentRoutes_1 = __webpack_require__(1708);
var environment_1 = __webpack_require__(238);
var ReloadableRoute_1 = __webpack_require__(80);
var routeLinks_1 = __webpack_require__(20);
var V3EnvironmentRoutes_1 = __webpack_require__(1710);
var V3AccountRoutes_1 = __webpack_require__(1711);
var V3MachineRoutes_1 = __webpack_require__(1712);
var NotFound_1 = __webpack_require__(431);
var InternalRedirect_1 = __webpack_require__(40);
var ProjectChildRedirect_1 = __webpack_require__(1713);
var ProjectRoutes = importAsync_1.default(function () { return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1999)); }, function (index) { return index.ProjectRoutes; });
var LibraryRoutes = importAsync_1.default(function () { return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 2000)); }, function (index) { return index.LibraryRoutes; });
var InfrastructureRoutes = importAsync_1.default(function () { return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 2001)); }, function (index) { return index.InfrastructureRoutes; });
var TenantsRoutes = importAsync_1.default(function () { return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 2002)); }, function (index) { return index.TenantsRoutes; });
var ConfigurationRoutes = importAsync_1.default(function () { return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 2003)); }, function (index) { return index.ConfigurationRoutes; });
var TaskRoutes = importAsync_1.default(function () { return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 2004)); }, function (index) { return index.TaskRoutes; });
var StyleGuide = importAsync_1.default(function () { return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 2005)); }, function (index) { return index.StyleGuide; }, !environment_1.default.isInDevelopmentMode());
var CodeGuide = importAsync_1.default(function () { return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 2006)); }, function (index) { return index.CodeGuide; }, !environment_1.default.isInDevelopmentMode());
var RootRoutes = function (props) { return (React.createElement(react_router_dom_1.Route, { render: function (_a) {
        var location = _a.location;
        if (location.state && location.state.is404) {
            return React.createElement(NotFound_1.NotFound, null);
        }
        // some links out in the wild contain / encoded to %2F which the angular router handled but react-router does not
        if (location.pathname.toUpperCase().includes("%2F")) {
            return React.createElement(InternalRedirect_1.default, { to: location.pathname.replace("%2F", "/").replace("%2f", "/").replace("//", "/") });
        }
        return React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { exact: true, path: routeLinks_1.default.root, component: DashboardOverview_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.dashboard.root, component: DashboardRoutes_1.DashboardRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.projects, component: ProjectRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.projects, component: ProjectRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.projectGroup(":ProjectGroupId").root, component: ProjectGroupLayout_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.infrastructure.root, component: InfrastructureRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.tenants, component: TenantsRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.library.root, component: LibraryRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.tasks.root, component: TaskRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.deployments, component: DeploymentRoutes_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.me, component: UserProfileRoutes_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.configuration.root, component: ConfigurationRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.styleGuide, component: StyleGuide }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.codeGuide, component: CodeGuide }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.release(":releaseId"), render: function (p) { return React.createElement(ProjectChildRedirect_1.ReleaseRedirect, { releaseId: p.match.params.releaseId }); } }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.trigger(":triggerId"), render: function (p) { return React.createElement(ProjectChildRedirect_1.TriggerRedirect, { triggerId: p.match.params.triggerId }); } }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.channel(":channelId"), render: function (p) { return React.createElement(ProjectChildRedirect_1.ChannelRedirect, { channelId: p.match.params.channelId }); } }),
            React.createElement(ReloadableRoute_1.default, { path: "/manage/console", render: function (p) { return React.createElement(InternalRedirect_1.default, { to: __assign({}, p.location, { pathname: routeLinks_1.default.tasks.console }) }); } }),
            React.createElement(ReloadableRoute_1.default, { path: "/environments", component: V3EnvironmentRoutes_1.V3EnvironmentRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: "/accounts", component: V3AccountRoutes_1.V3AccountRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: "/machines", component: V3MachineRoutes_1.V3MachineRoutes }),
            React.createElement(NotFound_1.RedirectAs404, null));
    } })); };
exports.default = RootRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\RootRoutes\\RootRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\RootRoutes\\RootRoutes.tsx"); } } })();

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BusyIndicator_1 = __webpack_require__(98);
//https://medium.com/@apostolos/server-side-rendering-code-splitting-and-hot-reloading-with-react-router-v4-87239cfc172c
function importAsync(getArea, getComponent, deferLoading) {
    if (getComponent === void 0) { getComponent = function (m) { return m.default; }; }
    if (deferLoading === void 0) { deferLoading = false; }
    var asyncComponent = (_a = (function (_super) {
            __extends(AsyncComponent, _super);
            function AsyncComponent() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.mounted = false;
                _this.state = {
                    Component: AsyncComponent.Component
                };
                return _this;
            }
            AsyncComponent.loadInBackground = function () {
                AsyncComponent.load();
            };
            AsyncComponent.componentAccessorToString = function (accessor) {
                return accessor.toString().replace("function", "");
            };
            AsyncComponent.load = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var area, component, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (AsyncComponent.Component) {
                                    return [2 /*return*/];
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                console.log("Loading dynamic chunk: " + AsyncComponent.componentAccessorToString(getComponent));
                                return [4 /*yield*/, getArea()];
                            case 2:
                                area = _a.sent();
                                component = getComponent(area);
                                AsyncComponent.Component = component;
                                console.log("Loaded dynamic chunk: " + AsyncComponent.componentAccessorToString(getComponent));
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _a.sent();
                                console.log("Failed to load a dynamic chunk: " + AsyncComponent.componentAccessorToString(getComponent));
                                console.error(error_1);
                                console.log("Reloading application...");
                                location.reload(true);
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            };
            AsyncComponent.prototype.componentDidMount = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.mounted = true;
                                if (!(this.state.Component === null)) return [3 /*break*/, 3];
                                if (!!AsyncComponent.Component) return [3 /*break*/, 2];
                                return [4 /*yield*/, AsyncComponent.load()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (this.mounted) {
                                    this.setState({ Component: AsyncComponent.Component });
                                }
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            };
            AsyncComponent.prototype.componentWillUnmount = function () {
                this.mounted = false;
            };
            AsyncComponent.prototype.render = function () {
                var Component = this.state.Component;
                if (Component) {
                    return React.createElement(Component, __assign({}, this.props));
                }
                return React.createElement(BusyIndicator_1.default, { show: true });
            };
            return AsyncComponent;
        }(React.Component)),
        _a.Component = null,
        _a);
    if (!deferLoading) {
        asyncComponent.loadInBackground();
    }
    return asyncComponent;
    var _a;
}
exports.default = importAsync;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\importAsync.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\importAsync.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardRoutes_1 = __webpack_require__(1451);
exports.DashboardRoutes = DashboardRoutes_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardRoutes\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardRoutes\\index.tsx"); } } })();

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var DashboardOverview_1 = __webpack_require__(639);
var DashboardLayout_1 = __webpack_require__(1617);
var DashboardConfiguration_1 = __webpack_require__(1619);
var RenderWithLayout_1 = __webpack_require__(428);
var ReloadableRoute_1 = __webpack_require__(80);
var dashboardConfiguration = RenderWithLayout_1.renderWithLayout(DashboardLayout_1.default)(DashboardConfiguration_1.default);
var DashboardRoutes = function (props) {
    var match = props.match;
    return (React.createElement(react_router_dom_1.Switch, null,
        React.createElement(ReloadableRoute_1.default, { path: match.url + "/configure", component: dashboardConfiguration }),
        React.createElement(ReloadableRoute_1.default, { path: match.url + "/", component: DashboardOverview_1.default })));
};
exports.default = DashboardRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardRoutes\\DashboardRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardRoutes\\DashboardRoutes.tsx"); } } })();

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1453);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_componentRow__3veX_{display:flex;flex-direction:row;align-items:flex-start}.style_componentRow__3veX_>*{margin-right:1rem}", ""]);

// exports
exports.locals = {
	"componentRow": "style_componentRow__3veX_"
};

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataCube_1 = __webpack_require__(218);
var styles = __webpack_require__(640);
var DashboardCell_1 = __webpack_require__(1456);
var resources_1 = __webpack_require__(26);
var index_1 = __webpack_require__(169);
var NavigationButton_1 = __webpack_require__(212);
var lodash_1 = __webpack_require__(16);
var routeLinks_1 = __webpack_require__(20);
var releaseRouteLinks_1 = __webpack_require__(283);
var DataSet_1 = __webpack_require__(1562);
var ScrollableTable_1 = __webpack_require__(1574);
var PaperLayout_1 = __webpack_require__(117);
var InternalNavLink_1 = __webpack_require__(223);
var ProjectDashboard = (function (_super) {
    __extends(ProjectDashboard, _super);
    function ProjectDashboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.emptyGroupMessage = function (dataSet, groupId) {
            var projectId = _this.tryGetValue(dataSet, DataCube_1.DimensionTypes.Project)(null, null, null);
            if (projectId === null) {
                return null;
            }
            var releaseCreateUri = routeLinks_1.default.project(_this.props.cube.projectIndex[projectId]).releaseCreate;
            if (dataSet.groupDimension === DataCube_1.DimensionTypes.Channel) {
                return React.createElement("div", { className: styles.emptyCell },
                    "There are no releases for this channel yet. ",
                    React.createElement(InternalNavLink_1.default, { to: releaseCreateUri + "?channelId=" + groupId }, "Create a release"));
            }
            else if (dataSet.groupDimension === DataCube_1.DimensionTypes.None) {
                return React.createElement("div", { className: styles.emptyCell },
                    "There are no releases for this project yet. ",
                    React.createElement(InternalNavLink_1.default, { to: releaseCreateUri }, "Create a release"));
            }
            return null;
        };
        _this.getChannelName = function (channelId) {
            var channel = _this.props.cube.channelIndex[channelId];
            if (channel) {
                return channel.Name;
            }
            return null;
        };
        _this.getReleaseVersion = function (releaseId) {
            var release = _this.props.cube.releaseIndex[releaseId];
            if (release) {
                return release.Version;
            }
            return null;
        };
        return _this;
    }
    ProjectDashboard.prototype.shouldComponentUpdate = function (nextProps) {
        return !lodash_1.isEqual(getPropsForComparison(nextProps), getPropsForComparison(this.props));
        function getPropsForComparison(props) {
            var onProjectCountChanged = props.onProjectCountChanged, rest = __rest(props, ["onProjectCountChanged"]);
            return rest;
        }
    };
    ProjectDashboard.prototype.render = function () {
        var _this = this;
        var dataSet = DataSet_1.getDataSet(this.props.filters, this.props.cube);
        var deploymentContext = this.getDeploymentContext(dataSet);
        var groups = this.getProjectRowsLimitedToMaximum(dataSet, this.props.maximumRows);
        if (this.props.onProjectCountChanged) {
            // We calling this in a timeout because the parent sets state
            setTimeout(function () { return _this.props.onProjectCountChanged(lodash_1.flatten(groups.map(function (g) { return g.rowsInGroup; })).length); }, 0);
        }
        return React.createElement("div", null, this.redrawMatrix(dataSet, groups, deploymentContext));
    };
    ProjectDashboard.prototype.getDeploymentContext = function (dataSet) {
        var _this = this;
        return function (groupId, rowId, columnId) { return ({
            environmentId: _this.tryGetValue(dataSet, DataCube_1.DimensionTypes.Environment)(groupId, rowId, columnId),
            releaseId: _this.tryGetValue(dataSet, DataCube_1.DimensionTypes.Release)(groupId, rowId, columnId),
            tenantId: _this.tryGetValue(dataSet, DataCube_1.DimensionTypes.Tenant)(groupId, rowId, columnId),
            projectId: _this.tryGetValue(dataSet, DataCube_1.DimensionTypes.Project)(groupId, rowId, columnId)
        }); };
    };
    ProjectDashboard.prototype.tryGetValue = function (dataSet, dimensionType) {
        var filters = this.props.filters;
        if (dataSet.groupDimension === dimensionType) {
            return function (groupId, rowId, columnId) { return groupId; };
        }
        else if (dataSet.rowDimension === dimensionType) {
            return function (groupId, rowId, columnId) { return rowId; };
        }
        else if (dataSet.columnDimension === dimensionType) {
            return function (groupId, rowId, columnId) { return columnId; };
        }
        else if (filters[dimensionType]) {
            var environmentIds_1 = Object.keys(filters[dimensionType]);
            if (environmentIds_1.length === 1) {
                return function (groupId, rowId, columnId) { return environmentIds_1[0]; };
            }
        }
        return function () { return null; };
    };
    ProjectDashboard.prototype.buildColumnTitle = function (cube, dataSet, groupId, columnId) {
        var environmentId = columnId;
        if (dataSet.columnDimension === DataCube_1.DimensionTypes.Environment &&
            dataSet.rowDimension === DataCube_1.DimensionTypes.Tenant &&
            this.props.filters[DataCube_1.DimensionTypes.Release]) {
            var releaseFilters = Object.keys(this.props.filters[DataCube_1.DimensionTypes.Release]);
            if (releaseFilters.length === 1) {
                var releaseId = Object.keys(this.props.filters[DataCube_1.DimensionTypes.Release])[0];
                var projectId_1 = Object.keys(this.props.filters[DataCube_1.DimensionTypes.Project])[0];
                var groupTenantsWithoutSuccess_1 = dataSet.getRowsForGroup(groupId)
                    .filter(function (tenantId) {
                    return (tenantId !== null && cube.tenantIndex[tenantId].ProjectEnvironments[projectId_1].indexOf(environmentId) !== -1) &&
                        (!dataSet.matrix[groupId] ||
                            !dataSet.matrix[groupId][tenantId] ||
                            !dataSet.matrix[groupId][tenantId][environmentId] ||
                            !dataSet.matrix[groupId][tenantId][environmentId].find(function (item) { return item.State === resources_1.TaskState.Success; }));
                });
                var availableDeployments = ((cube.nextAvailableDeployments[releaseFilters[0]] || {})[environmentId]);
                if (availableDeployments) {
                    var canDeployAll = availableDeployments.filter(function (t) { return groupTenantsWithoutSuccess_1.indexOf(t) !== -1; });
                    if (canDeployAll.length > 0) {
                        var uri = routeLinks_1.default.project(cube.projectIndex[projectId_1])
                            .release(cube.releaseIndex[releaseId] ? cube.releaseIndex[releaseId].Version : releaseId)
                            .deployments.create(releaseRouteLinks_1.DeploymentCreateGoal.To, environmentId, groupTenantsWithoutSuccess_1);
                        return React.createElement("div", { className: styles.deployAllCell },
                            dataSet.columnTitle(columnId),
                            React.createElement(NavigationButton_1.NavigationButton, { label: "Deploy All", href: uri }));
                    }
                }
            }
        }
        return dataSet.columnTitle(columnId);
    };
    ProjectDashboard.prototype.redrawMatrix = function (dataSet, groups, deploymentContext) {
        var _this = this;
        if (!dataSet) {
            return null;
        }
        return groups.map(function (g) {
            var groupId = g.groupId;
            var rowsInGroup = g.rowsInGroup;
            var emptyGroupMessage = _this.emptyGroupMessage(dataSet, groupId);
            if (rowsInGroup.length === 0 && !emptyGroupMessage) {
                return null;
            }
            var columnsInGroup = dataSet.getColumnsForGroup(groupId);
            var headers = columnsInGroup.map(function (columnId) {
                return React.createElement("div", { className: styles.centerCell }, _this.buildColumnTitle(_this.props.cube, dataSet, groupId, columnId));
            });
            var group = dataSet.matrix[groupId] || {};
            var cube = _this.props.cube;
            var rows = rowsInGroup.map(function (rowId) {
                var row = group[rowId] || {};
                return columnsInGroup.map(function (columnId) {
                    var context = deploymentContext(groupId, rowId, columnId);
                    var deployments = row[columnId];
                    var deployment = _this.getDeployment(deployments);
                    return React.createElement(DashboardCell_1.default, { deployment: deployment, deployments: deployments, deploymentContext: context, allowDeployments: _this.props.allowDeployments, showDeploymentCounts: _this.props.showDeploymentCounts, tenants: Object.values(cube.tenantIndex), showChannelChips: Object.keys(cube.channelIndex).length > 1, channelName: deployment ? _this.getChannelName(deployment.ChannelId) : null, hasReleases: Object.keys(cube.releaseIndex).length > 0, environment: cube.environmentIndex[context.environmentId], project: cube.projectIndex[context.projectId], nextAvailableDeploymentEnvironments: cube.nextAvailableDeployments[context.releaseId], releaseVersion: context ? _this.getReleaseVersion(context.releaseId) : null });
                });
            });
            var firstColumns = [
                React.createElement("div", { className: styles.centerCell }, dataSet.groupTitle(groupId) || dataSet.rowLabel())
            ].concat(rowsInGroup.map(function (rowId) { return dataSet.rowTitle(rowId); }));
            return React.createElement(index_1.default, { key: groupId, fullWidth: true, innerClassName: styles.container, flatStyle: _this.props.flatStyle },
                React.createElement(ScrollableTable_1.default, { debug: groupId, top: [PaperLayout_1.headerId, "toppanel"], headers: headers, firstColumn: firstColumns, rows: rows, empty: emptyGroupMessage }));
        });
    };
    ProjectDashboard.prototype.getDeployment = function (deployments) {
        if (!deployments || !deployments.length) {
            return null;
        }
        return deployments.find(function (item) {
            return item.State === resources_1.TaskState.Executing ||
                item.State === resources_1.TaskState.Failed ||
                (item.State === resources_1.TaskState.Success && item.HasWarningsOrErrors);
        })
            || deployments[0];
    };
    ProjectDashboard.prototype.getProjectRowsLimitedToMaximum = function (dataSet, maximumRows) {
        var hasLimit = maximumRows !== null && maximumRows !== undefined && maximumRows > 0;
        var maxRows = hasLimit ? maximumRows : null;
        // get rows for each group, track our use against the limit
        var groups = dataSet.getGroups().reduce(function (acc, groupId) {
            var value = {
                groupId: groupId,
                rowsInGroup: dataSet.getRowsForGroup(groupId, maxRows)
            };
            if (hasLimit) {
                maxRows = maxRows - value.rowsInGroup.length;
            }
            acc.push(value);
            return acc;
        }, []);
        return groups;
    };
    return ProjectDashboard;
}(React.Component));
exports.default = ProjectDashboard;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\ProjectDashboard.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\ProjectDashboard.tsx"); } } })();

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_group__34D0R{margin-top:4rem}.style_deployAllCell__3A0Pr{display:flex;flex-direction:column;align-items:center}.style_deploy__2LCgp{text-transform:uppercase;text-decoration:none;color:#2f93e0;font-size:.875rem}.style_border__2wzaH,.style_dashboardTable__a5vIL td,.style_spacerCell__1NGeP{border-top:.0625rem solid #ccc}.style_spacerCell__1NGeP{width:100%}.style_headerCell__3CB_E{font-size:1.0625rem;padding:1rem;font-weight:500;word-break:break-all;width:15.625rem}.style_headerCell__3CB_E a{font-weight:500}.style_columnHead__3tL0c{font-size:1.0625rem;padding:.5rem;font-weight:400;display:flex}.style_highlightColumn__3Ur_n{font-weight:600;padding-left:1rem;display:flex}.style_centerCell__wc3-E{display:flex;align-items:center;justify-content:flex-start;text-align:left;min-width:12.5rem}.style_blankCell__3syzF{width:.0625rem;height:5rem}.style_container__oYOe7{overflow-x:hidden;margin-bottom:2rem}.style_scrollableContainer__1ED8p{flex-grow:1;overflow-x:auto}.style_emptyCell__2BvyH{padding:1rem;width:100%}.style_headersOverflowContainer__2ynKo{z-index:2;position:absolute;background-color:#fff;overflow-x:auto}.style_dataContainer__3SK0W,.style_headersContainer__22OIL{display:flex;flex-direction:row}.style_dataContainer__3SK0W{position:relative}.style_firstColumnContainer__3aL_R{display:flex;flex-direction:column;z-index:3}.style_scrollbarPadding__BEZDs{height:20px}.style_hideScrollbarPanel__3RPNf{position:absolute;bottom:0;left:0;z-index:2;background-color:#fff;width:100%;height:20px}.style_rightContainer__xQbeA{overflow-x:hidden;flex-grow:1}.style_scrollableTableContainer__3HKqG{display:flex}", ""]);

// exports
exports.locals = {
	"group": "style_group__34D0R",
	"deployAllCell": "style_deployAllCell__3A0Pr",
	"deploy": "style_deploy__2LCgp",
	"dashboardTable": "style_dashboardTable__a5vIL",
	"border": "style_border__2wzaH",
	"spacerCell": "style_spacerCell__1NGeP",
	"headerCell": "style_headerCell__3CB_E",
	"columnHead": "style_columnHead__3tL0c",
	"highlightColumn": "style_highlightColumn__3Ur_n",
	"centerCell": "style_centerCell__wc3-E",
	"blankCell": "style_blankCell__3syzF",
	"container": "style_container__oYOe7",
	"scrollableContainer": "style_scrollableContainer__1ED8p",
	"emptyCell": "style_emptyCell__2BvyH",
	"headersOverflowContainer": "style_headersOverflowContainer__2ynKo",
	"headersContainer": "style_headersContainer__22OIL",
	"dataContainer": "style_dataContainer__3SK0W",
	"firstColumnContainer": "style_firstColumnContainer__3aL_R",
	"scrollbarPadding": "style_scrollbarPadding__BEZDs",
	"hideScrollbarPanel": "style_hideScrollbarPanel__3RPNf",
	"rightContainer": "style_rightContainer__xQbeA",
	"scrollableTableContainer": "style_scrollableTableContainer__3HKqG"
};

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var TaskStatusDetails_1 = __webpack_require__(779);
var resources_1 = __webpack_require__(26);
var Button_1 = __webpack_require__(51);
var index_1 = __webpack_require__(1465);
var index_2 = __webpack_require__(68);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1468);
var routeLinks_1 = __webpack_require__(20);
var releaseRouteLinks_1 = __webpack_require__(283);
var PermissionCheck_1 = __webpack_require__(45);
var permission_1 = __webpack_require__(49);
var DashboardCell = (function (_super) {
    __extends(DashboardCell, _super);
    function DashboardCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getUnavailableToDeployWarning = function (projectId, environmentId) {
            var missing = [];
            if (!projectId) {
                missing.push("project");
            }
            if (!environmentId) {
                missing.push("environment");
            }
            var missingDescription = "";
            if (missing.length === 1) {
                missingDescription = missing[0];
            }
            else if (missing.length > 1) {
                missingDescription = missing.slice(0, missing.length - 1).join(", ").concat(" and ").concat(missing[missing.length - 1]);
            }
            var text = "Filter the dashboard by " + missingDescription + " to perform a deployment.";
            return (React.createElement(index_2.default, { content: text },
                React.createElement(Button_1.ActionButton, { label: "Deploy", disabled: true })));
        };
        _this.tenantDeploymentCount = function (visibleDeploymentItem) {
            var _a = _this.props, deployments = _a.deployments, deploymentContext = _a.deploymentContext;
            if (deploymentContext.tenantId) {
                // If tenant already in context, then no point extending in "Z" dimension
                return null;
            }
            var projectId = deploymentContext.projectId;
            if (!projectId) {
                // Seems like tenants aren't involved in this project
                return null;
            }
            var environmentId = deploymentContext.environmentId;
            if (!environmentId) {
                // We need an environment to tell how many tenants are relevant
                return null;
            }
            var tenantsInProjectEnvironment = _this.props.tenants.filter(function (tenant) {
                var projectEnvs = tenant.ProjectEnvironments[projectId];
                return projectEnvs && projectEnvs.indexOf(environmentId) !== -1;
            });
            if (tenantsInProjectEnvironment.length === 0) {
                // No tenants involved in this tenanted project, no point showing anything
                return null;
            }
            var haveCountedTenant = {};
            var progress = deployments.reduce(function (sum, deployment) {
                if (deployment.ReleaseId === visibleDeploymentItem.ReleaseId &&
                    deployment.TenantId && !haveCountedTenant[deployment.TenantId] &&
                    //Only consider if tenant currently in environment (ignore if deployed when previously linked)
                    tenantsInProjectEnvironment.find(function (t) { return t.Id === deployment.TenantId; })) {
                    haveCountedTenant[deployment.TenantId] = true;
                    if (deployment.State === resources_1.TaskState.Success) {
                        return sum + 1;
                    }
                }
                return sum;
            }, 0);
            return React.createElement(index_1.default, { progress: progress, expected: tenantsInProjectEnvironment.length });
        };
        return _this;
    }
    DashboardCell.prototype.render = function () {
        var _a = this.props, deployments = _a.deployments, deploymentContext = _a.deploymentContext, allowDeployments = _a.allowDeployments;
        if (deployments && deployments.length) {
            return this.renderTaskStatusCell();
        }
        if (!allowDeployments) {
            return null;
        }
        var projectId = deploymentContext.projectId, releaseId = deploymentContext.releaseId, environmentId = deploymentContext.environmentId, tenantId = deploymentContext.tenantId;
        // You've got a tenant... but this tenant can't deploy this environment so... nah
        if (!!tenantId) {
            var tenant = this.props.tenants.find(function (t) { return t.Id === tenantId; });
            if (tenant && tenant.ProjectEnvironments[projectId].indexOf(environmentId) === -1) {
                var environment = this.props.environment;
                return React.createElement("div", { className: styles.centerCell }, this.renderNoDeployCell(tenant.Name + " is not linked to the " + environment.Name + " environment", projectId, environmentId, tenantId));
            }
        }
        // We are looking at an untenanted deployment on a project that can't do untenanted deployments, so... nope.
        if (!tenantId && !this.props.project.CanPerformUntenantedDeployment) {
            return React.createElement("div", { className: styles.centerCell }, this.renderNoDeployCell("This project can not perform untenanted deployments", projectId, environmentId));
        }
        // No release
        if (!releaseId) {
            var text = "Create a release first to deploy project";
            if (this.props.hasReleases) {
                text = "Filter the dashboard by releases to perform a deployment";
            }
            return React.createElement("div", { className: styles.centerCell },
                React.createElement(index_2.default, { content: text },
                    React.createElement(Button_1.ActionButton, { label: "Deploy", disabled: true })));
        }
        // This scenario is likely only available when we add more filters
        if (!environmentId || !projectId) {
            return React.createElement("div", { className: styles.centerCell }, this.getUnavailableToDeployWarning(projectId, environmentId));
        }
        // Ok... so looks like you can deploy to this environment
        var nextAvailableDeploymentEnvironments = this.props.nextAvailableDeploymentEnvironments;
        if (nextAvailableDeploymentEnvironments) {
            var tenantReleases = nextAvailableDeploymentEnvironments[environmentId];
            if (tenantReleases && tenantReleases.indexOf(tenantId) !== -1) {
                var uri = routeLinks_1.default.project(this.props.project)
                    .release(this.props.releaseVersion)
                    .deployments.create(releaseRouteLinks_1.DeploymentCreateGoal.To, environmentId, tenantId);
                return React.createElement("div", { className: styles.centerCell },
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.DeploymentCreate, project: projectId, environment: environmentId, tenant: tenantId },
                        React.createElement(Button_1.NavigationButton, { label: "Deploy", href: uri })));
            }
        }
        return React.createElement("div", { className: styles.centerCell }, this.renderNoDeployCell("Release " + this.props.releaseVersion + " can not be deployed to the " + this.props.environment.Name + " environment", projectId, environmentId, tenantId));
    };
    DashboardCell.prototype.renderTaskStatusCell = function () {
        var totalDiv = this.props.showDeploymentCounts && this.tenantDeploymentCount(this.props.deployment);
        var project = this.props.project;
        var projectSlug = project ? project.Slug : null;
        return React.createElement("div", { className: styles.taskDetailsCell },
            React.createElement(TaskStatusDetails_1.TaskStatusDetails, { item: this.props.deployment, channelName: this.props.showChannelChips ? this.props.channelName : null, projectSlug: projectSlug, deploymentId: this.props.deployment.DeploymentId, additionalDetails: totalDiv }));
    };
    DashboardCell.prototype.renderNoDeployCell = function (message, projectId, environmentId, tenantId) {
        return React.createElement(PermissionCheck_1.default, { permission: permission_1.default.DeploymentCreate, project: projectId, environment: environmentId, tenant: tenantId },
            React.createElement(index_2.default, { content: message },
                React.createElement("div", { className: styles.blockIcon },
                    React.createElement("em", { className: cn("fa fa-ban") }))));
    };
    return DashboardCell;
}(React.PureComponent));
exports.default = DashboardCell;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\DashboardCell\\DashboardCell.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\DashboardCell\\DashboardCell.tsx"); } } })();

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var cn = __webpack_require__(19);
var resources_1 = __webpack_require__(26);
var styles = __webpack_require__(1458);
exports.default = function (item, small) {
    if (small === void 0) { small = false; }
    var stateClass = item.State;
    if (item.HasPendingInterruptions && !item.IsCompleted) {
        stateClass = "Paused";
    }
    else if (item.State === resources_1.TaskState.Success && item.HasWarningsOrErrors) {
        stateClass = "SuccessWithWarnings";
    }
    var iconStyles = cn(styles.status, styles[stateClass], small ? styles.small : null);
    if (item.IsPrevious) {
        iconStyles = cn(iconStyles, "status-previous");
    }
    else if (item.IsCurrent === false && item.IsPrevious === false) {
        iconStyles = cn(iconStyles, "status-archive");
    }
    return iconStyles;
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\TaskStatusIcon\\iconStyle.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\TaskStatusIcon\\iconStyle.tsx"); } } })();

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1459);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_status__1M01p{display:flex;justify-content:center;align-items:center;width:2.25rem;height:2.25rem;border-radius:.125rem;font-size:1.25rem;color:#fff}.style_small__1y0Fs{width:1.25rem;height:1.25rem;font-size:.875rem}.style_Queued__h1K9m{background-color:#215680}.style_Executing__dnX0l{background-color:#0a67b1}.style_Paused__34Pyd,.style_TimedOut__l4mEw{background-color:#fb8c00}.style_Failed__3c1N0{background-color:#db4437}.style_Canceled__37cqN,.style_Cancelling__3c8CE{background-color:#333}.style_Success__2Lz42,.style_SuccessWithWarnings__39_yv{background-color:#53b953}", ""]);

// exports
exports.locals = {
	"status": "style_status__1M01p",
	"small": "style_small__1y0Fs",
	"Queued": "style_Queued__h1K9m",
	"queued": "style_Queued__h1K9m",
	"Executing": "style_Executing__dnX0l",
	"executing": "style_Executing__dnX0l",
	"Paused": "style_Paused__34Pyd",
	"paused": "style_Paused__34Pyd",
	"TimedOut": "style_TimedOut__l4mEw",
	"timedOut": "style_TimedOut__l4mEw",
	"Failed": "style_Failed__3c1N0",
	"failed": "style_Failed__3c1N0",
	"Canceled": "style_Canceled__37cqN",
	"canceled": "style_Canceled__37cqN",
	"Cancelling": "style_Cancelling__3c8CE",
	"cancelling": "style_Cancelling__3c8CE",
	"Success": "style_Success__2Lz42",
	"success": "style_Success__2Lz42",
	"SuccessWithWarnings": "style_SuccessWithWarnings__39_yv",
	"successWithWarnings": "style_SuccessWithWarnings__39_yv"
};

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1461);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1LhW1{display:flex;flex-direction:row;align-items:center;justify-content:left;min-width:180px;padding:.5rem}.style_container__1LhW1 .style_additionalDetails__q5-QQ{margin-left:.5rem}.style_task-previous__mHeho{opacity:.65}.style_task-archived__G1KfB{opacity:.2}.style_details__10UKL{display:flex;flex-direction:column;justify-content:space-between;align-items:flex-start;padding-left:.5rem}.style_taskName__z8Cch,.style_version__3y8GX{color:#333;font-weight:500;font-size:.9375rem;display:flex;align-items:center}.style_date__1SpQz{color:#666;font-weight:400;font-size:.6875rem}.style_taskLink__1_d2s:hover{background-color:hsla(0,0%,60%,.08)}", ""]);

// exports
exports.locals = {
	"container": "style_container__1LhW1",
	"additionalDetails": "style_additionalDetails__q5-QQ",
	"task-previous": "style_task-previous__mHeho",
	"taskPrevious": "style_task-previous__mHeho",
	"task-archived": "style_task-archived__G1KfB",
	"taskArchived": "style_task-archived__G1KfB",
	"details": "style_details__10UKL",
	"version": "style_version__3y8GX",
	"taskName": "style_taskName__z8Cch",
	"date": "style_date__1SpQz",
	"taskLink": "style_taskLink__1_d2s"
};

/***/ }),
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* <span class="label tenant-count"><span class="progress-count">2</span><span class="total-count">/2</span>    </span> */
var React = __webpack_require__(0);
var styles = __webpack_require__(1466);
var TenantDeploymentCount = function (props) {
    return React.createElement("span", { className: styles.container },
        React.createElement("span", { className: styles.progress }, props.progress),
        React.createElement("span", { className: styles.expected },
            "/",
            props.expected),
        "    ");
};
exports.default = TenantDeploymentCount;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\TenantDeploymentCount\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\TenantDeploymentCount\\index.tsx"); } } })();

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1467);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1_0si{display:flex;justify-content:center;align-items:center;height:1.25rem;color:#fff;font-size:.69rem;text-shadow:0 -.0625rem 0 rgba(0,0,0,.2);padding:0 .25rem;white-space:nowrap;border-radius:.25em;background:#9e9e9e}.style_expected__voO9P,.style_progress__jXOt-{visibility:visible}", ""]);

// exports
exports.locals = {
	"container": "style_container__1_0si",
	"progress": "style_progress__jXOt-",
	"expected": "style_expected__voO9P"
};

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1469);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_taskDetailsCell__dEHne{display:flex}.style_blockIcon__36wOe{opacity:.2;font-size:2.5rem}.style_centerCell__2eveG{display:flex;align-items:center;justify-content:left;padding:.5rem}", ""]);

// exports
exports.locals = {
	"taskDetailsCell": "style_taskDetailsCell__dEHne",
	"blockIcon": "style_blockIcon__36wOe",
	"centerCell": "style_centerCell__2eveG"
};

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var Breadcrumb_1 = __webpack_require__(641);
var RefreshIndicator_1 = __webpack_require__(582);
var colors_1 = __webpack_require__(32);
var BusyFromPromise_1 = __webpack_require__(176);
var styles = __webpack_require__(1473);
var SectionTitle = function (props) {
    return React.createElement("div", { className: cn(styles.container, props.className) },
        React.createElement("div", { className: styles.titleContainer },
            React.createElement(Breadcrumb_1.default, { title: props.breadcrumbTitle, path: props.breadcrumbPath }),
            React.createElement("div", { className: styles.title },
                props.titleLogo && React.createElement("div", { className: styles.logo }, props.titleLogo),
                React.createElement("h2", { className: styles.header }, props.title),
                React.createElement(BusyFromPromise_1.default, { promise: props.busy }, function (busy) {
                    return busy && props.enableLessIntrusiveLoadingIndicator
                        ? React.createElement("div", { className: styles.refreshContainer },
                            React.createElement(RefreshIndicator_1.default, { size: 28, left: 10, top: 0, status: "loading", loadingColor: colors_1.secondaryText, style: {
                                    display: "inline-block",
                                    position: "relative",
                                    boxShadow: "unset",
                                } }))
                        : null;
                }))),
        props.sectionControl);
};
exports.default = SectionTitle;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SectionTitle\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SectionTitle\\index.tsx"); } } })();

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1472);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_breadcrumb__qeygb{font-size:.875rem;line-height:1rem;color:#9e9e9e}.style_breadcrumb__qeygb .style_breadcrumbLink__20imO{color:#333;text-decoration:none}.style_breadcrumb__qeygb .style_breadcrumbLink__20imO>:active,.style_breadcrumb__qeygb .style_breadcrumbLink__20imO>:visited{color:#333}.style_breadcrumb__qeygb .style_breadcrumbLink__20imO:hover{color:#2f93e0}", ""]);

// exports
exports.locals = {
	"breadcrumb": "style_breadcrumb__qeygb",
	"breadcrumbLink": "style_breadcrumbLink__20imO"
};

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1474);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__3rXsY{display:flex;padding:1.5rem 1rem;align-items:center;flex-wrap:wrap;justify-content:space-between;min-height:5.25rem}.style_titleContainer__3-W7u{display:flex;flex-direction:column;font-size:1.25rem}.style_header__2STZ0{margin:0;padding:0}.style_title__YSj5Z{display:flex;flex-direction:row;align-items:center;line-height:1.75rem}.style_logo__13jHw{margin-right:.5rem}.style_refreshContainer__1D4wv{position:relative;height:1.75rem;opacity:.8}", ""]);

// exports
exports.locals = {
	"container": "style_container__3rXsY",
	"titleContainer": "style_titleContainer__3-W7u",
	"header": "style_header__2STZ0",
	"title": "style_title__YSj5Z",
	"logo": "style_logo__13jHw",
	"refreshContainer": "style_refreshContainer__1D4wv"
};

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1476);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__n_Ecp{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__P2EKE{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2DPYJ{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2OHkK{display:none!important}}.style_paperContent__382gV{box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2),0 .125rem .125rem 0 rgba(0,0,0,.12),0 0 .125rem 0 rgba(0,0,0,.14);background-color:#fff;width:100%;max-width:1280px;margin:0 1.5rem 1rem;position:relative;display:flex;align-items:stretch;flex-direction:column}@media (max-width:79.9rem){.style_paperContent__382gV{margin:0 1rem .5rem}}@media (max-width:37.4rem){.style_paperContent__382gV{margin:0}}.style_paperContentFlat__QSsBj{box-shadow:0;background-color:transparent;width:100%;max-width:1280px;margin:0 1rem 1rem;position:relative;display:flex;align-items:stretch;flex-direction:column}@media (max-width:37.4rem){.style_paperContentFlat__QSsBj{margin:.8rem}}.style_paperFullWidth__8SfP3{max-width:none}.style_container__23_qZ{display:flex;width:100%;justify-content:center}.style_headerContainer__1Wp7n{background:#fff}.style_busyFromPromise__m7JN_{width:100%}.style_title__1zL1H{word-wrap:break-word;background-color:#fff}.style_stickied__3AmB4{box-shadow:0 .0625rem .1875rem -.0625rem rgba(0,0,0,.34)}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__n_Ecp",
	"hideSm": "style_hide-sm__n_Ecp",
	"visible-sm": "style_visible-sm__P2EKE",
	"visibleSm": "style_visible-sm__P2EKE",
	"hide-md": "style_hide-md__2DPYJ",
	"hideMd": "style_hide-md__2DPYJ",
	"visible-md": "style_visible-md__2OHkK",
	"visibleMd": "style_visible-md__2OHkK",
	"paperContent": "style_paperContent__382gV",
	"paperContentFlat": "style_paperContentFlat__QSsBj",
	"paperFullWidth": "style_paperFullWidth__8SfP3",
	"container": "style_container__23_qZ",
	"headerContainer": "style_headerContainer__1Wp7n",
	"busyFromPromise": "style_busyFromPromise__m7JN_",
	"title": "style_title__1zL1H",
	"stickied": "style_stickied__3AmB4"
};

/***/ }),
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataCube_1 = __webpack_require__(218);
var cn = __webpack_require__(19);
var index_1 = __webpack_require__(68);
var InternalLink_1 = __webpack_require__(42);
var styles = __webpack_require__(1563);
var routeLinks_1 = __webpack_require__(20);
var untenantedDeploymentLogo = __webpack_require__(1565);
var Logo_1 = __webpack_require__(172);
var Tag_1 = __webpack_require__(280);
var lodash_1 = __webpack_require__(16);
var MissingVariablesIcon_1 = __webpack_require__(744);
var TenantMatchesFilter_1 = __webpack_require__(1573);
function getDataSet(filter, self) {
    var rowDimension = filter.rowDimension || DataCube_1.DimensionTypes.None;
    var columnDimension = filter.columnDimension || DataCube_1.DimensionTypes.None;
    var groupDimension = filter.groupBy || DataCube_1.DimensionTypes.None;
    var deployments = self.deployments;
    if (filter[DataCube_1.DimensionTypes.Release]) {
        //To make the rest of the process quicker, filter releases (probably could filter any & all)
        deployments = deployments.filter(function (i) {
            return filter[DataCube_1.DimensionTypes.Release][DataCube_1.DimensionGetters[DataCube_1.DimensionTypes.Release](i)];
        });
    }
    var groupedTagSet = groupDimension === DataCube_1.DimensionTypes.TagSet ?
        self.tagSetIndex[filter.groupByExtra] :
        null;
    var matrix = enterTheMatrix(deployments, getGroupGetter(groupDimension, self), rowDimension, columnDimension);
    var showUntenantedRow = showUntenanted(self);
    return {
        matrix: matrix,
        getGroups: function () {
            var groups = [null];
            if (groupDimension === DataCube_1.DimensionTypes.TagSet) {
                groups = [null].concat(lodash_1.sortBy(groupedTagSet.Tags, function (t) { return t.SortOrder; }).map(function (t) { return t.CanonicalTagName; }));
            }
            else if (groupDimension === DataCube_1.DimensionTypes.ProjectGroup) {
                groups = lodash_1.sortBy(self.projectGroupIndex, function (g) { return g.Name; }).map(function (g) { return g.Id; });
            }
            else if (filter.groupBy === DataCube_1.DimensionTypes.Channel) {
                groups = Object.keys(self.channelIndex)
                    .map(function (c) { return self.channelIndex[c]; })
                    .sort(function (channelA, channelB) {
                    return (
                    // Sort by default channel first
                    channelA.IsDefault === channelB.IsDefault ? 0
                        : channelA.IsDefault ? -1
                            : 1) || (
                    // Then sort by name alphabetically
                    channelA.Name.toLowerCase() === channelB.Name.toLowerCase() ? 0
                        : channelA.Name.toLowerCase() < channelB.Name.toLowerCase() ? -1
                            : 1);
                }).map(function (channel) { return channel.Id; });
            }
            if (filter.groupBy === DataCube_1.DimensionTypes.TagSet) {
                // If we are filtering by the same tag set that we are grouping by,
                // then all tenants within an excluded group will be filtered out in `getRowsForGroup`
                // But we still want to exclude tenants that don't have any tags from the tag set we are grouping by (i.e. the `null` group)
                return groups.filter(function (g) { return g !== null; });
            }
            else if (filter[filter.groupBy]) {
                return groups.filter(function (groupId) { return filter[filter.groupBy][groupId]; });
            }
            return groups;
        },
        groupTitle: function (groupId) {
            if (!groupDimension || !groupId) {
                return null;
            }
            if (groupDimension === DataCube_1.DimensionTypes.Channel) {
                if (Object.keys(self.channelIndex).length < 2) {
                    return null;
                }
                return React.createElement("div", null,
                    "Channel: ",
                    self.channelIndex[groupId].Name);
            }
            else if (groupDimension === DataCube_1.DimensionTypes.TagSet) {
                var tag = groupedTagSet.Tags.find(function (t) { return t.CanonicalTagName === groupId; });
                return React.createElement("div", null,
                    groupedTagSet.Name,
                    ": ",
                    React.createElement(Tag_1.default, { tagName: tag.Name, description: tag.Description, tagColor: tag.Color, showTooltip: false }));
            }
            else if (groupDimension === DataCube_1.DimensionTypes.ProjectGroup) {
                return self.projectGroupIndex[groupId].Name;
            }
            else if (filter.groupBy === DataCube_1.DimensionTypes.Channel) {
                if (Object.keys(self.channelIndex).length < 2) {
                    return null;
                }
                return React.createElement("div", null,
                    "Channel: ",
                    self.channelIndex[groupId].Name);
            }
            throw new Error("Only Channel Grouping Supported");
        },
        getRowsForGroup: function (groupId, take) {
            var rows = [];
            if (rowDimension === DataCube_1.DimensionTypes.Tenant) {
                rows = Object.keys(self.tenantIndex);
                if (showUntenantedRow) {
                    if (groupDimension !== DataCube_1.DimensionTypes.TagSet ||
                        (groupId === null && groupDimension === DataCube_1.DimensionTypes.TagSet)) {
                        rows = [null].concat(rows);
                    }
                }
                if (groupDimension === DataCube_1.DimensionTypes.TagSet) {
                    rows = rows.filter(function (tenantId) {
                        var tenant = self.tenantIndex[tenantId];
                        if (groupId === null) {
                            return !tenant || !groupedTagSet.Tags.find(function (t) { return tenant.TenantTags.indexOf(t.CanonicalTagName) !== -1; });
                        }
                        else {
                            return tenant && tenant.TenantTags.indexOf(groupId) !== -1;
                        }
                    });
                }
                // Tenant tag filters on the row only really makes sense if the row is tenants
                if (filter[DataCube_1.DimensionTypes.TagSet]) {
                    var filters_1 = Object.keys(filter[DataCube_1.DimensionTypes.TagSet]).filter(function (k) { return filter[DataCube_1.DimensionTypes.TagSet][k]; });
                    var filteredTagsGroupedByTagSet_1 = Object.keys(self.tagSetIndex)
                        .map(function (k) { return self.tagSetIndex[k]; })
                        .map(function (ts) {
                        return ts.Tags.map(function (t) { return t.CanonicalTagName; })
                            .filter(function (t) { return filters_1.includes(t); });
                    })
                        .filter(function (t) { return t.length > 0; });
                    rows = rows.filter(function (tenantId) {
                        var tenant = self.tenantIndex[tenantId];
                        return tenant && TenantMatchesFilter_1.default(tenant.TenantTags, filteredTagsGroupedByTagSet_1);
                    });
                }
            }
            else if (rowDimension === DataCube_1.DimensionTypes.Project) {
                rows = Object.keys(self.projectIndex);
                if (groupDimension === DataCube_1.DimensionTypes.ProjectGroup) {
                    rows = rows.filter(function (projectId) { return self.projectIndex[projectId].ProjectGroupId === groupId; });
                    if (filter[DataCube_1.DimensionTypes.ProjectName]) {
                        var filterName_1 = Object.keys(filter[DataCube_1.DimensionTypes.ProjectName])[0];
                        rows = rows.filter(function (projectId) { return self.projectIndex[projectId].Name.toLocaleUpperCase().includes(filterName_1.toLocaleUpperCase()); });
                    }
                    if (take && rows.length > take) {
                        rows = limitProjects(rows, deployments, take);
                    }
                }
            }
            else if (rowDimension === DataCube_1.DimensionTypes.Release) {
                rows = filter.groupBy === DataCube_1.DimensionTypes.Channel ?
                    Object.keys(self.releaseIndex).filter(function (r) { return self.releaseIndex[r].ChannelId === groupId; }) :
                    Object.keys(self.releaseIndex);
            }
            if (filter[rowDimension]) {
                return rows.filter(function (rowId) { return filter[rowDimension][rowId]; });
            }
            return rows;
        },
        rowTitle: function (rowId) {
            if (rowDimension === DataCube_1.DimensionTypes.Tenant) {
                if (rowId === null) {
                    return tile(untenantedDeploymentLogo, "Untenanted");
                }
                else {
                    var hasMissingVariable = self.missingVariableTenants.indexOf(rowId) !== -1;
                    var tenant = self.tenantIndex[rowId];
                    return React.createElement("div", { className: styles.rowHeader, style: { justifyContent: "space-between" } },
                        tile(tenant.Links.Logo, tenant.Name, routeLinks_1.default.tenant(rowId).root),
                        hasMissingVariable && React.createElement(InternalLink_1.default, { to: routeLinks_1.default.tenant(rowId).variables() },
                            React.createElement(MissingVariablesIcon_1.default, { show: true })));
                }
            }
            else if (rowDimension === DataCube_1.DimensionTypes.Project) {
                var project = self.projectIndex[rowId];
                return tile(project.Links.Logo, project.Name, routeLinks_1.default.project(project).root, project.IsDisabled);
            }
            else if (rowDimension === DataCube_1.DimensionTypes.Release) {
                var release = self.releaseIndex[rowId];
                var msg = "This release has been blocked from future deployments. View the release details for more information.";
                return React.createElement("div", { className: styles.rowCell },
                    React.createElement("div", { className: styles.rowHeader },
                        React.createElement(InternalLink_1.default, { to: routeLinks_1.default.project(self.projectIndex[release.ProjectId]).release(release).root }, release.Version)),
                    self.blockedReleases.indexOf(rowId) !== -1 &&
                        React.createElement("div", { className: styles.blockAlert },
                            React.createElement(index_1.default, { content: msg },
                                React.createElement("em", { className: cn("fa fa-exclamation-triangle", styles.blockAlertIcon) }))));
            }
        },
        getColumnsForGroup: function (groupId) {
            var colms = Object.keys(self.environmentIndex);
            if (groupDimension === DataCube_1.DimensionTypes.Channel) {
                colms = self.channelEnvironments[groupId]
                    .filter(function (environmentId) { return colms.includes(environmentId); });
            }
            else if (groupDimension === DataCube_1.DimensionTypes.ProjectGroup) {
                var projectEnvironments_1 = Object.keys(self.projectIndex).map(function (p) { return self.projectIndex[p]; })
                    .filter(function (p) { return p.ProjectGroupId === groupId; }).reduce(function (arr, p) { return arr.concat(p.EnvironmentIds); }, []);
                colms = colms.filter(function (environmentId) { return projectEnvironments_1.indexOf(environmentId) !== -1; });
            }
            if (filter[columnDimension]) {
                return colms.filter(function (rowId) { return filter[columnDimension][rowId]; });
            }
            return colms;
        },
        columnTitle: function (columnId) {
            //Currently only supports environments for column
            return self.environmentIndex[columnId].Name;
        },
        rowLabel: function () {
            switch (rowDimension) {
                case DataCube_1.DimensionTypes.Tenant:
                    return "Tenant";
                case DataCube_1.DimensionTypes.Release:
                    return "Release";
                default:
                    return "";
            }
        },
        groupDimension: groupDimension,
        rowDimension: rowDimension,
        columnDimension: columnDimension
    };
}
exports.getDataSet = getDataSet;
function getGroupGetter(groupDimension, cube) {
    if (groupDimension === DataCube_1.DimensionTypes.TagSet) {
        // Tag sets need special getter since they aren't stored on the deployment item itself
        return function (item) { return item.TenantId ? (cube.tenantTagIndex[item.TenantId] || []) : []; };
        //groupedTagSet = cube.tagSetIndex[filter.groupByExtra];
    }
    else if (groupDimension === DataCube_1.DimensionTypes.ProjectGroup) {
        // Project groups need special getter since they aren't stored on the deployment item itself
        return function (item) {
            var project = cube.projectIndex[item.ProjectId]; //the project won't be here if we've filterd due to project limit
            return project ? project.ProjectGroupId : null;
        };
    }
    return DataCube_1.DimensionGetters[groupDimension];
}
function showUntenanted(self) {
    var canPerformUntenanted = self.projectIndex[Object.keys(self.projectIndex)[0]].CanPerformUntenantedDeployment;
    if (canPerformUntenanted) {
        return true;
    }
    return !!self.deployments.find(function (d) { return d.TenantId === null; });
}
function tile(logoUrl, name, toUrl, isDisabled) {
    // These need to be in separate spans (otherwise lots of text smooshes the image, aka. main dashboard).
    if (toUrl) {
        return React.createElement(InternalLink_1.default, { to: toUrl, className: cn(styles.rowHeader, isDisabled ? styles.disabled : null) },
            React.createElement("span", null,
                React.createElement(Logo_1.default, { url: logoUrl, size: "2.25rem", isDisabled: isDisabled })),
            React.createElement("span", { style: { paddingLeft: "0.25rem" }, title: isDisabled ? "Disabled" : "" }, name));
    }
    else {
        return React.createElement("div", { className: cn(styles.rowHeader, isDisabled ? styles.disabled : null) },
            React.createElement("span", null,
                React.createElement(Logo_1.default, { url: logoUrl, size: "2.25rem", isDisabled: isDisabled })),
            React.createElement("span", { style: { paddingLeft: "0.25rem" }, title: isDisabled ? "Disabled" : "" }, name));
    }
}
function enterTheMatrix(deployments, groupByFunction, rowDimension, columnDimension) {
    var rowFromTask = DataCube_1.DimensionGetters[rowDimension];
    var columnFromTask = DataCube_1.DimensionGetters[columnDimension];
    var matrix = {};
    deployments.forEach(function (deploymentTask) {
        var groupingIds = groupByFunction(deploymentTask);
        if (!Array.isArray(groupingIds)) {
            groupingIds = [groupingIds];
        }
        if (groupingIds.length === 0) {
            groupingIds = [null];
        }
        groupingIds.forEach(function (groupingId) {
            var group = matrix[groupingId];
            if (!group) {
                group = matrix[groupingId] = {};
            }
            var rowId = rowFromTask(deploymentTask);
            var row = group[rowId];
            if (!row) {
                row = group[rowId] = {};
            }
            var columnId = columnFromTask(deploymentTask);
            if (!row[columnId]) {
                row[columnId] = [];
            }
            row[columnId].push(deploymentTask);
        });
    });
    Object.keys(matrix)
        .forEach(function (groupId) { return Object.keys(matrix[groupId])
        .forEach(function (rowId) { return Object.keys(matrix[groupId][rowId])
        .forEach(function (columnId) {
        var latestByContext = getLatestDeploymentPerContext(matrix[groupId][rowId][columnId]);
        matrix[groupId][rowId][columnId] = lodash_1.sortBy(latestByContext, [function (t) { return t.ReleaseVersion; }, function (t) { return new Date(t.CompletedTime || t.Created); }]);
    }); }); });
    return matrix;
}
function getLatestDeploymentPerContext(deployments) {
    var latestPerDeploymentContext = deployments.reduce(function (idx, item) {
        var key = item.EnvironmentId + item.ReleaseId + item.TenantId + item.ProjectId;
        var current = idx[key] || null;
        if (!current || new Date(current.CompletedTime || current.Created) < new Date(item.CompletedTime || current.Created)) {
            idx[key] = item;
        }
        return idx;
    }, {});
    return Object.keys(latestPerDeploymentContext).map(function (e) { return latestPerDeploymentContext[e]; });
}
function limitProjects(data, items, limit) {
    if (data.length <= limit) {
        return;
    }
    var included = limit > 0 ? data.slice(0, limit) : [];
    var erroredOrRunning = items.filter(function (p) { return p.HasWarningsOrErrors || !p.IsCompleted; });
    var keep = data
        .slice(limit)
        .filter(function (p) { return erroredOrRunning.some(function (e) { return e.ProjectId === p; }); });
    return included.concat(keep);
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DataSet.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DataSet.tsx"); } } })();

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1564);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_rowHeader__FuLu8{display:flex;flex-direction:row;align-items:center;height:100%;justify-content:left;font-weight:500}.style_blockAlert__2Mq41{font-size:1.3rem}.style_blockAlertIcon__7fWsI{font-size:1.25rem;opacity:.2}.style_rowCell__3gFsd{display:flex;justify-content:space-between;align-items:center}.style_disabled__uK73w *{color:#9e9e9e}", ""]);

// exports
exports.locals = {
	"rowHeader": "style_rowHeader__FuLu8",
	"blockAlert": "style_blockAlert__2Mq41",
	"blockAlertIcon": "style_blockAlertIcon__7fWsI",
	"rowCell": "style_rowCell__3gFsd",
	"disabled": "style_disabled__uK73w"
};

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "un-tenanted-deployment-logo.8ea431cf9cc0acc1ad26ca59cc16f376.hashedasset.svg";

/***/ }),
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1572);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_logo__M4qZr{display:flex;align-items:center;align-content:center;justify-content:center}.style_logo__M4qZr img{height:auto;width:auto}.style_logo__M4qZr .style_disabled__LoIvK{-webkit-filter:grayscale(1);filter:grayscale(1);opacity:.4}", ""]);

// exports
exports.locals = {
	"logo": "style_logo__M4qZr",
	"disabled": "style_disabled__LoIvK"
};

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// This logic matches our logic for filtering by tenant tags as described here:
// https://octopus.com/docs/reference/tenant-tags#TenantTags-Tag-basedfilters
// Ideally, we should be using this function anywhere we filter by tenant tags on the client
function tenantMatchesFilter(tenantTags, filterBy) {
    return filterBy.every(function (tagSet) { return tagSet.some(function (t) { return tenantTags.includes(t); }); });
}
exports.default = tenantMatchesFilter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\tenants\\TenantMatchesFilter.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\tenants\\TenantMatchesFilter.ts"); } } })();

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MeasureScrollableTable_1 = __webpack_require__(1575);
var ScrollableTable = (function (_super) {
    __extends(ScrollableTable, _super);
    function ScrollableTable(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChanges = function (s) {
            _this.setState(function (prev) { return ({
                beforeMeasured: undefined,
                afterMeasured: __assign({}, prev.beforeMeasured, s)
            }); });
        };
        _this.state = {
            beforeMeasured: props
        };
        return _this;
    }
    ScrollableTable.prototype.componentWillReceiveProps = function (newProps) {
        this.setState({ beforeMeasured: newProps });
    };
    ScrollableTable.prototype.render = function () {
        return React.createElement("div", null,
            this.state.afterMeasured && React.createElement("div", null,
                React.createElement(MeasureScrollableTable_1.default, __assign({ measurements: this.state.afterMeasured }, this.state.afterMeasured, { onWindowResized: this.handleChanges }))),
            this.state.beforeMeasured && React.createElement("div", { style: { visibility: "hidden" } },
                React.createElement(MeasureScrollableTable_1.default, __assign({}, this.state.beforeMeasured, { onMeasured: this.handleChanges }))));
    };
    return ScrollableTable;
}(React.Component));
exports.default = ScrollableTable;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\ScrollableTable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\ScrollableTable.tsx"); } } })();

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(640);
var lodash_1 = __webpack_require__(16);
var react_event_listener_1 = __webpack_require__(55);
var cn = __webpack_require__(19);
var MeasureScrollableTable = (function (_super) {
    __extends(MeasureScrollableTable, _super);
    function MeasureScrollableTable(props) {
        var _this = _super.call(this, props) || this;
        _this.offsetHeight = 0;
        _this.stickyElements = [];
        _this.tableTop = undefined;
        _this.tableHeight = 0;
        _this.handleWindowScroll = lodash_1.debounce(function () {
            var headerContainerTop = _this.tableTop - (_this.props.measurements.dataContainerTopMargin || 0) - window.pageYOffset - _this.offsetHeight;
            var top = 0;
            if (headerContainerTop < 0) {
                top = Math.abs(headerContainerTop);
                // Don't move the header all the way to the bottom otherwise user can't see last row
                var maxAllowed = _this.tableHeight - 100;
                if (maxAllowed < 0) {
                    top = 0;
                }
                else if (top > maxAllowed) {
                    top = maxAllowed;
                }
            }
            _this.headersOverflowContainer.style.top = top + "px";
            _this.headersContainer.style.borderBottom = top > 0 ? "solid 0.0625rem #e0e0e0" : "";
            _this.headersOverflowContainer.style.backgroundColor = top > 0 ? "#fafafa" : "#ffffff";
            _this.headersOverflowContainer.style.boxShadow = top > 0 ? "0px 2px 3px -2px rgba(0,0,0,0.6)" : "";
        }, 50);
        _this.handleTableHeaderScroll = lodash_1.throttle(function () {
            _this.handleTableScroll(function () { return _this.scrollableContainer.scrollLeft = _this.headersOverflowContainer.scrollLeft; });
        }, 50);
        _this.handleTableDataScroll = lodash_1.throttle(function () {
            _this.handleTableScroll(function () { return _this.headersOverflowContainer.scrollLeft = _this.scrollableContainer.scrollLeft; });
        }, 50);
        _this.handleWindowResize = lodash_1.debounce(function () {
            _this.setOffsetHeight();
            if (_this.dataContainer) {
                var dataContainerRect = _this.getBoundingClientRectRounded(_this.dataContainer);
                if (_this.onWindowResized) {
                    _this.onWindowResized(__assign({}, _this.props.measurements, { headersOverflowContainerWidth: dataContainerRect.width }));
                }
            }
            if (_this.scrollableContainer) {
                var tableRect = _this.getBoundingClientRectRounded(_this.scrollableContainer);
                _this.tableTop = tableRect.top + window.pageYOffset;
                _this.tableHeight = tableRect.height;
            }
            _this.handleWindowScroll();
        }, 1000);
        _this.arrayValue = function (value, idx) {
            if (value) {
                return value[idx];
            }
            return "initial";
        };
        _this.getValue = function (value) {
            if (value) {
                return value;
            }
            return "initial";
        };
        _this.setOffsetHeight = function () {
            if (_this.stickyElements.length > 0) {
                _this.offsetHeight = _this.stickyElements.reduce(function (p, c) { return p + _this.getBoundingClientRectRounded(c).height; }, 0);
            }
        };
        _this.adjustLayout = function () {
            var _a = _this.measureCells(), columnsWidths = _a.columnsWidths, rowHeights = _a.rowHeights;
            var totalColumnsWidth = columnsWidths.slice(1).reduce(function (p, c) { return p + c; }, 0);
            _this.setState({
                columnsWidths: columnsWidths,
                rowHeights: rowHeights,
                headersContainerWidth: totalColumnsWidth
            });
        };
        _this.measureCells = function () {
            var columnsWidths = [];
            var rowHeights = [];
            // 1. measure all firstcolumns including table title (0, 0)
            // tslint:disable-next-line:prefer-for-of
            var firstColumnContainerTable = _this.firstColumnContainer.children[0];
            for (var idx = 0; idx < firstColumnContainerTable.rows.length; idx++) {
                var cell = firstColumnContainerTable.rows[idx].cells[0].children[0];
                var cellRect = _this.getBoundingClientRectRounded(cell);
                if (idx === 0) {
                    columnsWidths.push(0); //Not used
                }
                rowHeights.push(cellRect.height);
            }
            // 2. measure all headers
            // tslint:disable-next-line:prefer-for-of
            for (var idx = 0; idx < _this.headersContainer.children.length; idx++) {
                var cell = _this.headersContainer.children[idx];
                var cellRect = _this.getBoundingClientRectRounded(cell);
                columnsWidths.push(cellRect.width);
                rowHeights[0] = Math.max(rowHeights[0], cellRect.height);
            }
            // 3. measure data cells
            if (_this.props.rows.length > 0 && _this.props.rows[0].length > 0) {
                var yAxisLength = _this.tableContainer.rows.length;
                var xAxisLength = _this.tableContainer.rows[0].cells.length - 1;
                var calcCoordIdx = function (idx, maxIdx) { return idx >= maxIdx ? maxIdx - 1 : idx; };
                var maxLength = Math.max(yAxisLength, xAxisLength);
                for (var coordIdx = 0; coordIdx < maxLength; coordIdx++) {
                    var x = calcCoordIdx(coordIdx, xAxisLength);
                    var y = calcCoordIdx(coordIdx, yAxisLength);
                    var cell = _this.tableContainer.rows[y].cells[x];
                    var cellRect = _this.getBoundingClientRectRounded(cell);
                    rowHeights[y + 1] = Math.max(rowHeights[y + 1], cellRect.height);
                    columnsWidths[x + 1] = Math.max(columnsWidths[x + 1], cellRect.width);
                }
            }
            return { columnsWidths: columnsWidths, rowHeights: rowHeights };
        };
        _this.handleTableScroll = function (action) {
            if (_this.props.rows.length > 0) {
                action();
                _this.firstColumnContainer.style.boxShadow = _this.scrollableContainer.scrollLeft > 0 ? "3px 2px 3px -2px rgba(0,0,0,0.6)" : "";
                _this.firstColumnContainer.style.backgroundColor = _this.scrollableContainer.scrollLeft > 0 ? "#fafafa" : "";
            }
        };
        _this.isMeasuring = function () {
            return !!_this.onMeasured;
        };
        _this.onWindowScroll = _this.handleWindowScroll;
        _this.onScrollTableHeaderContainer = _this.handleTableHeaderScroll;
        _this.onScrollTableDataContainer = _this.handleTableDataScroll;
        _this.onWindowResize = _this.handleWindowResize;
        props.top.forEach(function (id) {
            var element = document.getElementById(id);
            if (element) {
                _this.stickyElements.push(element);
            }
        });
        _this.onMeasured = props.onMeasured;
        _this.onWindowResized = props.onWindowResized;
        _this.setOffsetHeight();
        _this.state = {
            columnsWidths: undefined,
            rowHeights: undefined,
            dataContainerTopMargin: undefined,
            headersContainerWidth: undefined,
            headersOverflowContainerWidth: undefined
        };
        return _this;
    }
    MeasureScrollableTable.prototype.componentDidMount = function () {
        if (this.isMeasuring()) {
            this.adjustLayout();
        }
        else {
            this.setOffsetHeight();
            var tableRect = this.getBoundingClientRectRounded(this.scrollableContainer);
            this.tableTop = tableRect.top + window.pageYOffset;
            this.tableHeight = tableRect.height;
            this.headersOverflowContainer.addEventListener("scroll", this.onScrollTableHeaderContainer, false);
            this.scrollableContainer.addEventListener("scroll", this.onScrollTableDataContainer, false);
        }
    };
    MeasureScrollableTable.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.isMeasuring()) {
            this.setState({
                columnsWidths: undefined,
                rowHeights: undefined,
                dataContainerTopMargin: undefined,
                headersContainerWidth: undefined,
                headersOverflowContainerWidth: undefined
            });
        }
    };
    MeasureScrollableTable.prototype.componentDidUpdate = function () {
        var _this = this;
        if (this.state.columnsWidths === undefined) {
            this.adjustLayout();
            return;
        }
        if (this.state.headersOverflowContainerWidth === undefined) {
            var dataContainerRect = this.getBoundingClientRectRounded(this.dataContainer);
            this.setState({ headersOverflowContainerWidth: dataContainerRect.width });
            return;
        }
        if (this.state.dataContainerTopMargin === undefined) {
            this.setState({
                dataContainerTopMargin: this.getBoundingClientRectRounded(this.headersOverflowContainer).height
            }, function () {
                if (_this.isMeasuring()) {
                    _this.onMeasured(_this.state);
                }
            });
            return;
        }
    };
    MeasureScrollableTable.prototype.componentWillUnmount = function () {
        this.onScrollTableHeaderContainer.cancel();
        this.onScrollTableDataContainer.cancel();
        this.headersOverflowContainer.removeEventListener("scroll", this.onScrollTableHeaderContainer, false);
        this.scrollableContainer.removeEventListener("scroll", this.onScrollTableDataContainer, false);
        this.onWindowScroll.cancel();
        this.onWindowResize.cancel();
    };
    MeasureScrollableTable.prototype.render = function () {
        var _this = this;
        var measurements = this.props.measurements ? this.props.measurements : this.state;
        return React.createElement("div", { className: styles.scrollableTableContainer },
            !this.isMeasuring() && React.createElement(react_event_listener_1.default, { target: window, onScroll: react_event_listener_1.withOptions(this.onWindowScroll, { passive: true, capture: false }), onResize: react_event_listener_1.withOptions(this.onWindowResize, { passive: true, capture: false }) }),
            React.createElement("div", { ref: function (el) { return _this.firstColumnContainer = el; }, className: styles.firstColumnContainer },
                React.createElement("table", { cellPadding: 0, cellSpacing: 0 },
                    React.createElement("tbody", null, this.props.firstColumn.map(function (cell, idx) {
                        return React.createElement("tr", { key: idx },
                            React.createElement("td", { className: cn((_a = {}, _a[styles.border] = idx !== 0, _a)) },
                                React.createElement("div", { className: cn(styles.headerCell, (_b = {}, _b[styles.highlightColumn] = idx === 0, _b)), style: {
                                        height: idx === 0
                                            ? _this.getValue(measurements.dataContainerTopMargin)
                                            : _this.arrayValue(measurements.rowHeights, idx)
                                    } }, cell)));
                        var _a, _b;
                    }))),
                React.createElement("div", { className: styles.scrollbarPadding })),
            React.createElement("div", { className: styles.rightContainer },
                React.createElement("div", { ref: function (el) { return _this.headersOverflowContainer = el; }, className: styles.headersOverflowContainer, style: { width: this.getValue(measurements.headersOverflowContainerWidth) } },
                    React.createElement("div", { ref: function (el) { return _this.headersContainer = el; }, className: styles.headersContainer, style: { width: this.getValue(measurements.headersContainerWidth) } }, this.props.headers.map(function (cell, idx) {
                        return React.createElement("div", { key: idx, className: styles.columnHead, style: {
                                height: _this.arrayValue(measurements.rowHeights, 0),
                                width: _this.arrayValue(measurements.columnsWidths, idx + 1),
                            } }, cell);
                    }))),
                React.createElement("div", { ref: function (el) { return _this.dataContainer = el; }, className: styles.dataContainer, style: { marginTop: this.getValue(measurements.dataContainerTopMargin) } },
                    React.createElement("div", { className: styles.scrollableContainer, ref: function (el) { return _this.scrollableContainer = el; } },
                        React.createElement("table", { ref: function (el) { return _this.tableContainer = el; }, cellPadding: 0, cellSpacing: 0 },
                            React.createElement("tbody", null,
                                this.props.rows.length === 0 && React.createElement("tr", null,
                                    React.createElement("td", { className: styles.emptyCell }, this.props.empty),
                                    React.createElement("td", { className: styles.spacerCell })),
                                this.props.rows.map(function (row, rowIdx) { return React.createElement("tr", { key: rowIdx },
                                    row.map(function (cell, colIdx) { return React.createElement("td", { key: rowIdx + "=" + colIdx, className: styles.border },
                                        React.createElement("div", { className: styles.centerCell, style: {
                                                height: _this.arrayValue(measurements.rowHeights, rowIdx + 1),
                                                width: _this.arrayValue(measurements.columnsWidths, colIdx + 1),
                                            } }, cell)); }),
                                    React.createElement("td", { className: styles.spacerCell })); }))),
                        React.createElement("div", { className: styles.scrollbarPadding })),
                    React.createElement("div", { className: styles.hideScrollbarPanel }))));
    };
    /// Need to round sizes otherwise different browsers do different things
    MeasureScrollableTable.prototype.getBoundingClientRectRounded = function (element) {
        var rect = element.getBoundingClientRect();
        return {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            top: Math.round(rect.top),
            bottom: Math.round(rect.bottom)
        };
    };
    return MeasureScrollableTable;
}(React.Component));
exports.default = MeasureScrollableTable;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\MeasureScrollableTable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\MeasureScrollableTable.tsx"); } } })();

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(16);
var tenantedDeploymentMode_1 = __webpack_require__(282);
var DashboardDataCube = (function () {
    function DashboardDataCube(data, tenants, releases, channels, promotions, tagSets, lifeCycles, project, releaseId, missingVariableTenants) {
        var _this = this;
        this.blockedReleases = [];
        this.nextAvailableDeployments = {};
        this.tagSetIndex = {};
        this.environmentIndex = {};
        this.channelIndex = {};
        this.releaseIndex = {};
        this.tenantIndex = {};
        this.tenantTagIndex = {};
        this.projectIndex = {};
        this.projectGroupIndex = {};
        this.missingVariableTenants = [];
        this.data = data;
        this.releaseIndex = lodash_1.keyBy(releases, function (rel) { return rel.Id; });
        this.projectIndex = lodash_1.keyBy(data.Projects, function (proj) { return proj.Id; });
        this.channelIndex = lodash_1.keyBy(channels, function (ch) { return ch.Id; });
        this.environmentIndex = lodash_1.keyBy(this.data.Environments, function (env) { return env.Id; });
        this.deployments = data.Items;
        this.missingVariableTenants = missingVariableTenants;
        if (project) {
            this.projectIndex[project.Id] = {
                Slug: project.Slug,
                Name: project.Name,
                IsDisabled: project.IsDisabled,
                Id: project.Id,
                Links: project.Links,
                EnvironmentIds: null,
                ProjectGroupId: project.ProjectGroupId,
                CanPerformUntenantedDeployment: project.TenantedDeploymentMode !== tenantedDeploymentMode_1.TenantedDeploymentMode.Tenanted
            };
            this.lifecycleIndex = lodash_1.keyBy(lifeCycles, function (ch) { return ch.Id; });
            // We wont have a project object for main dashboard,
            // but then again we probably wont be grouping by channel or needing lifecycles!
            this.channelEnvironments = channels.reduce(function (b, ch) {
                var lifecycle = _this.lifecycleIndex[ch.LifecycleId];
                if (!lifecycle) {
                    lifecycle = _this.lifecycleIndex[project.LifecycleId];
                }
                if (!lifecycle) {
                    b[ch.Id] = [];
                }
                else {
                    b[ch.Id] = lifecycle.Phases.reduce(function (a, p) {
                        return a.concat(p.AutomaticDeploymentTargets).concat(p.OptionalDeploymentTargets);
                    }, []);
                    if (b[ch.Id].length === 0) {
                        b[ch.Id] = Object.keys(_this.environmentIndex);
                    }
                }
                return b;
            }, {});
        }
        this.projectGroupIndex = lodash_1.keyBy(data.ProjectGroups, function (pj) { return pj.Id; });
        if (releaseId) {
            this.nextAvailableDeployments = (_a = {},
                _a[releaseId] = this.processReleasePromotion(promotions),
                _a);
        }
        this.tenantIndex = {};
        var tagIndex = {};
        this.tenantTagIndex = tenants.reduce(function (idx, tenant) {
            idx[tenant.Id] = tenant.TenantTags;
            _this.tenantIndex[tenant.Id] = tenant;
            tenant.TenantTags.forEach(function (tt) {
                tagIndex[tt] = true;
            });
            return idx;
        }, {});
        tagSets.forEach(function (ts) {
            if (ts.Tags.find(function (t) { return tagIndex[t.CanonicalTagName]; })) {
                _this.tagSetIndex[ts.Id] = ts;
            }
        });
        var _a;
    }
    DashboardDataCube.prototype.processReleasePromotion = function (promotions) {
        var releasePromotions = promotions.PromoteTo.reduce(function (promos, environment) {
            promos[environment.Id] = [null];
            return promos;
        }, {});
        promotions.TenantPromotions.forEach(function (tp) {
            tp.PromoteTo.forEach(function (environment) {
                releasePromotions[environment.Id] = (releasePromotions[environment.Id] || []);
                releasePromotions[environment.Id].push(tp.Id);
            });
        });
        return releasePromotions;
    };
    return DashboardDataCube;
}());
exports.default = DashboardDataCube;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DashboardDataCube.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DashboardDataCube.tsx"); } } })();

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tenantedDeploymentMode_1 = __webpack_require__(282);
var lodash_1 = __webpack_require__(16);
var ProgressionDataCube = (function () {
    function ProgressionDataCube(data, channels, project) {
        var _this = this;
        this.nextAvailableDeployments = {};
        this.blockedReleases = [];
        this.tenantTagIndex = {};
        this.tagSetIndex = {};
        this.channelIndex = {};
        this.releaseIndex = {};
        this.projectIndex = {};
        this.projectGroupIndex = {};
        this.tenantIndex = {};
        this.environmentIndex = {};
        this.missingVariableTenants = [];
        this.deployments = [];
        this.data = data;
        this.channelIndex = lodash_1.keyBy(channels, function (ch) { return ch.Id; });
        this.lifecycleIndex = {};
        this.releaseIndex = {};
        this.nextAvailableDeployments = {};
        this.projectIndex[project.Id] = {
            Slug: project.Slug,
            Name: project.Name,
            IsDisabled: project.IsDisabled,
            Id: project.Id,
            Links: project.Links,
            EnvironmentIds: null,
            ProjectGroupId: project.ProjectGroupId,
            CanPerformUntenantedDeployment: project.TenantedDeploymentMode !== tenantedDeploymentMode_1.TenantedDeploymentMode.Tenanted
        };
        this.channelEnvironments = Object.keys(data.ChannelEnvironments).reduce(function (idx, channelId) {
            idx[channelId] = data.ChannelEnvironments[channelId].map(function (k) { return k.Id; });
            return idx;
        }, {});
        this.deployments = (!data || !data.Releases)
            ? []
            : data.Releases.reduce(function (a, r) {
                if (r.HasUnresolvedDefect) {
                    _this.blockedReleases.push(r.Release.Id);
                }
                _this.releaseIndex[r.Release.Id] = r.Release;
                // may not have access to this due to lacking permission
                if (r.NextDeployments) {
                    _this.nextAvailableDeployments[r.Release.Id] = r.NextDeployments
                        .reduce(function (ax, e) {
                        ax[e] = [null]; //The progression dataset is currently only used for non tenant releases
                        return ax;
                    }, {});
                }
                var g = Object.keys(r.Deployments).map(function (j) { return r.Deployments[j]; });
                a = a.concat.apply(a, g);
                return a;
            }, []);
        this.environmentIndex = lodash_1.keyBy(this.data.Environments, function (env) { return env.Id; });
    }
    return ProgressionDataCube;
}());
exports.default = ProgressionDataCube;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\ProgressionDataCube.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\ProgressionDataCube.tsx"); } } })();

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1579);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1rfbU{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2pCpd{display:none!important}}@media (max-width:79.9rem){.style_hide-md__3xdAx{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1SgQn{display:none!important}}.style_titleBar__3251A{background-color:#fff;height:3.125rem;display:flex;justify-content:space-between;align-items:center;padding:0 1rem}@media (min-width:79.9rem){.style_titleBar__3251A{height:4.3125rem}}.style_title__Yghwr{flex-grow:1;font-size:1.25rem}.style_title__Yghwr h1,.style_title__Yghwr h2{font-size:1.25rem;margin:0;padding:0}.style_pageTitleLink__10IIo{color:#333;text-decoration:none}.style_pageTitleLink__10IIo>:active,.style_pageTitleLink__10IIo>:visited{color:#333}.style_pageTitleLink__10IIo:hover{color:#2f93e0}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1rfbU",
	"hideSm": "style_hide-sm__1rfbU",
	"visible-sm": "style_visible-sm__2pCpd",
	"visibleSm": "style_visible-sm__2pCpd",
	"hide-md": "style_hide-md__3xdAx",
	"hideMd": "style_hide-md__3xdAx",
	"visible-md": "style_visible-md__1SgQn",
	"visibleMd": "style_visible-md__1SgQn",
	"titleBar": "style_titleBar__3251A",
	"title": "style_title__Yghwr",
	"pageTitleLink": "style_pageTitleLink__10IIo"
};

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1581);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__G_FWA{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__1Iju0{display:none!important}}@media (max-width:79.9rem){.style_hide-md__3uGtP{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1eIJt{display:none!important}}.style_container__1nbJ-{display:flex;flex-direction:column}.style_paper__1v4cg div:first-child{max-width:none}.style_filterHeaderContainer__3LCpd{display:flex;flex-direction:row;align-items:flex-end;flex:1 0 auto;width:100%}@media (max-width:37.4rem){.style_filterHeaderContainer__3LCpd{flex-direction:column;align-items:flex-start}}.style_filterFieldContainer__V-gTq{display:flex;flex-direction:row;align-items:flex-end;flex:1 0 auto;width:100%;justify-content:flex-start}@media (max-width:37.4rem){.style_filterFieldContainer__V-gTq{flex-direction:column;align-items:flex-start}}.style_filter__2CExS{margin-left:1.5rem;align-items:flex-end;flex:1 0 auto}@media (max-width:37.4rem){.style_filter__2CExS{flex-direction:column}}.style_filterField__2gTVE{width:100%;max-width:24rem!important}.style_filterField__2gTVE>div{width:100%}.style_help__mi7iM{margin-bottom:12px}.style_alert__14IXe{color:#fb8c00}.style_info__3bm8F{color:#215680}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__G_FWA",
	"hideSm": "style_hide-sm__G_FWA",
	"visible-sm": "style_visible-sm__1Iju0",
	"visibleSm": "style_visible-sm__1Iju0",
	"hide-md": "style_hide-md__3uGtP",
	"hideMd": "style_hide-md__3uGtP",
	"visible-md": "style_visible-md__1eIJt",
	"visibleMd": "style_visible-md__1eIJt",
	"container": "style_container__1nbJ-",
	"paper": "style_paper__1v4cg",
	"filterHeaderContainer": "style_filterHeaderContainer__3LCpd",
	"filterFieldContainer": "style_filterFieldContainer__V-gTq",
	"filter": "style_filter__2CExS",
	"filterField": "style_filterField__2gTVE",
	"help": "style_help__mi7iM",
	"alert": "style_alert__14IXe",
	"info": "style_info__3bm8F"
};

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DatePicker_1 = __webpack_require__(564);
var moment = __webpack_require__(104);
var UniqueSequenceGenerator_1 = __webpack_require__(364);
var DatePicker = (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.genericName = "name" + DatePicker.sequence.next();
        return _this;
    }
    DatePicker.prototype.handleChange = function (_, value) {
        if (this.props.validate) {
            var validateResult = this.props.validate(value);
            if (this.props.onValidate) {
                this.props.onValidate(validateResult);
            }
        }
        this.props.onChange(value);
    };
    DatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, label = _a.label, validate = _a.validate, error = _a.error, onChange = _a.onChange, name = _a.name, onValidate = _a.onValidate, otherProps = __rest(_a, ["value", "label", "validate", "error", "onChange", "name", "onValidate"]);
        var date = value ? moment(value).toDate() : null;
        return (React.createElement(DatePicker_1.default, __assign({ value: date, onChange: function (_, val) { return _this.handleChange(_, val); }, errorText: error, floatingLabelText: label, container: "inline", name: name || this.genericName, mode: "landscape" }, otherProps)));
    };
    DatePicker.sequence = new UniqueSequenceGenerator_1.UniqueSequenceGenerator();
    return DatePicker;
}(React.Component));
exports.default = DatePicker;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\DatePicker\\DatePicker.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\DatePicker\\DatePicker.tsx"); } } })();

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var ReactDOM = __webpack_require__(31);
var transitions_1 = __webpack_require__(25);
var arrow_drop_down_1 = __webpack_require__(357);
var clear_1 = __webpack_require__(178);
var Menu_1 = __webpack_require__(1584);
var ClearFix_1 = __webpack_require__(566);
var Popover_1 = __webpack_require__(132);
var PopoverAnimationVertical_1 = __webpack_require__(250);
var keycode = __webpack_require__(52);
var events_1 = __webpack_require__(196);
var IconButton_1 = __webpack_require__(63);
var fontWeights_1 = __webpack_require__(76);
function getStyles(props, context) {
    var disabled = props.disabled;
    var spacing = context.muiTheme.baseTheme.spacing;
    var palette = context.muiTheme.baseTheme.palette;
    var accentColor = context.muiTheme.dropDownMenu.accentColor;
    return {
        control: {
            cursor: disabled ? "not-allowed" : "pointer",
            height: "100%",
            position: "relative",
            width: "100%",
        },
        icon: {
            fill: accentColor,
            width: "1.5rem",
            height: "1.5rem",
            padding: 0
        },
        iconChildren: {
            fill: "inherit",
        },
        label: {
            color: disabled ? palette.disabledColor : palette.textColor,
            height: spacing.desktopToolbarHeight + "px",
            lineHeight: spacing.desktopToolbarHeight + "px",
            overflow: "hidden",
            opacity: 1,
            position: "relative",
            paddingLeft: spacing.desktopGutter,
            paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
            textOverflow: "ellipsis",
            top: 0,
            whiteSpace: "nowrap",
        },
        labelWhenOpen: {
            opacity: 0,
            top: (spacing.desktopToolbarHeight / 8),
        },
        root: {
            display: "inline-block",
            fontSize: spacing.desktopDropDownMenuFontSize,
            height: spacing.desktopSubheaderHeight,
            fontFamily: context.muiTheme.baseTheme.fontFamily,
            outline: "none",
            position: "relative",
            transition: transitions_1.default.easeOut(),
        },
        rootWhenOpen: {
            opacity: 1,
        },
        underline: {
            borderTop: "solid 0.0625rem " + accentColor,
            bottom: 1,
            left: 0,
            margin: "-0.0625rem " + spacing.desktopGutter + "px",
            right: 0,
            position: "absolute",
        },
        buttons: {
            position: "absolute",
            right: 0,
            top: 13 / fontWeights_1.baseSizeInPx + "rem"
        }
    };
}
var DropDownMenu = (function (_super) {
    __extends(DropDownMenu, _super);
    function DropDownMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
            anchorEl: null
        };
        _this.rootNode = undefined;
        _this.arrowNode = undefined;
        _this.handleTouchTapControl = function (event) {
            event.preventDefault();
            if (!_this.props.disabled) {
                _this.setState({
                    open: !_this.state.open,
                    anchorEl: _this.rootNode,
                });
            }
        };
        _this.handleRequestCloseMenu = function () {
            _this.close(false);
        };
        _this.handleEscKeyDownMenu = function () {
            _this.close(true);
        };
        _this.handleKeyDown = function (event) {
            switch (keycode(event)) {
                case "up":
                case "down":
                case "space":
                case "enter":
                    event.preventDefault();
                    _this.setState({
                        open: true,
                        anchorEl: _this.rootNode,
                    });
                    break;
            }
        };
        _this.handleClearTouchTap = function (event) {
            event.stopPropagation();
            event.preventDefault();
            if (_this.props.onChange) {
                _this.props.onChange(event, undefined, "");
            }
        };
        _this.handleFilterKeyDown = function (event) {
            switch (keycode(event)) {
                case "esc":
                    _this.close(true);
                    break;
                case "down":
                    if (_this.menu && React.Children.count(_this.props.children) > 0) {
                        event.preventDefault();
                        _this.menu.setFocusIndex(event, 0, true);
                    }
                    break;
            }
        };
        _this.handleItemTouchTap = function (event, child, index) {
            if (_this.props.multiple) {
                if (!_this.state.open) {
                    _this.setState({ open: true });
                }
            }
            else {
                event.persist();
                event.preventDefault();
                _this.setState({
                    open: false,
                }, function () {
                    if (_this.props.onChange) {
                        _this.props.onChange(event, index, child.props.value);
                    }
                    _this.close(events_1.default.isKeyboard(event));
                });
            }
        };
        _this.handleChange = function (event, value) {
            if (_this.props.multiple && _this.props.onChange) {
                _this.props.onChange(event, undefined, value);
            }
        };
        _this.close = function (isKeyboard) {
            _this.setState({
                open: false,
            }, function () {
                if (_this.props.onClose) {
                    _this.props.onClose();
                }
                if (isKeyboard) {
                    var dropArrow = _this.arrowNode;
                    var dropNode = ReactDOM.findDOMNode(dropArrow);
                    dropNode.focus();
                    dropArrow.setKeyboardFocus(true);
                }
            });
        };
        return _this;
    }
    DropDownMenu.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.autoWidth) {
            this.setWidth();
        }
        if (this.props.openImmediately) {
            // TODO: Temporary fix to make openImmediately work with popover.
            /* eslint-disable react/no-did-mount-set-state */
            setTimeout(function () { return _this.setState({
                open: true,
                anchorEl: _this.rootNode,
            }); }, 0);
            /* eslint-enable react/no-did-mount-set-state */
        }
        if (this.props.autoFocus) {
            // this focuses
            this.close(true);
        }
    };
    DropDownMenu.prototype.componentWillReceiveProps = function () {
        if (this.props.autoWidth) {
            this.setWidth();
        }
    };
    /**
     * This method is deprecated but still here because the TextField
     * need it in order to work. TODO: That will be addressed later.
     */
    DropDownMenu.prototype.getInputNode = function () {
        var _this = this;
        var rootNode = this.rootNode;
        rootNode.focus = function () {
            if (!_this.props.disabled) {
                _this.setState({
                    open: !_this.state.open,
                    anchorEl: _this.rootNode,
                });
            }
        };
        return rootNode;
    };
    DropDownMenu.prototype.setWidth = function () {
        var el = this.rootNode;
        if (!this.props.style || !this.props.style.hasOwnProperty("width")) {
            el.style.width = "auto";
        }
    };
    DropDownMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, animated = _a.animated, animation = _a.animation, autoWidth = _a.autoWidth, multiple = _a.multiple, children = _a.children, className = _a.className, disabled = _a.disabled, iconStyle = _a.iconStyle, labelStyle = _a.labelStyle, listStyle = _a.listStyle, maxHeight = _a.maxHeight, menuStyleProp = _a.menuStyle, selectionRenderer = _a.selectionRenderer, onClose = _a.onClose, // eslint-disable-line no-unused-vars
        openImmediately = _a.openImmediately, // eslint-disable-line no-unused-vars
        menuItemStyle = _a.menuItemStyle, selectedMenuItemStyle = _a.selectedMenuItemStyle, style = _a.style, underlineStyle = _a.underlineStyle, value = _a.value, iconButton = _a.iconButton, anchorOrigin = _a.anchorOrigin, targetOrigin = _a.targetOrigin, allowClear = _a.allowClear, other = __rest(_a, ["animated", "animation", "autoWidth", "multiple", "children", "className", "disabled", "iconStyle", "labelStyle", "listStyle", "maxHeight", "menuStyle", "selectionRenderer", "onClose", "openImmediately", "menuItemStyle", "selectedMenuItemStyle", "style", "underlineStyle", "value", "iconButton", "anchorOrigin", "targetOrigin", "allowClear"]);
        var _b = this.state, anchorEl = _b.anchorEl, open = _b.open;
        var prepareStyles = this.context.muiTheme.prepareStyles;
        var styles = getStyles(this.props, this.context);
        var displayValue = "";
        if (!multiple) {
            React.Children.forEach(children, function (child) {
                if (child && value === child.props.value) {
                    if (selectionRenderer) {
                        displayValue = selectionRenderer(value, child);
                    }
                    else {
                        // This will need to be improved (in case primaryText is a node)
                        displayValue = child.props.label || child.props.primaryText;
                    }
                }
            });
        }
        else {
            var values_1 = [];
            var selectionRendererChildren_1 = [];
            React.Children.forEach(children, function (child) {
                if (child && value && value.indexOf(child.props.value) > -1) {
                    if (selectionRenderer) {
                        values_1.push(child.props.value);
                        selectionRendererChildren_1.push(child);
                    }
                    else {
                        values_1.push(child.props.label || child.props.primaryText);
                    }
                }
            });
            displayValue = "";
            if (selectionRenderer) {
                displayValue = selectionRenderer(values_1, selectionRendererChildren_1);
            }
            else {
                displayValue = values_1.join(", ");
            }
        }
        var menuStyle;
        if (anchorEl && !autoWidth) {
            menuStyle = Object.assign({
                width: anchorEl.clientWidth,
            }, menuStyleProp);
        }
        else {
            menuStyle = menuStyleProp;
        }
        return (React.createElement("div", __assign({}, other, { ref: function (node) {
                _this.rootNode = node;
            }, className: className, style: prepareStyles(Object.assign({}, styles.root, open && styles.rootWhenOpen, style)) }),
            React.createElement(ClearFix_1.default, { style: styles.control, onClick: this.handleTouchTapControl },
                React.createElement("div", { style: prepareStyles(Object.assign({}, styles.label, open && styles.labelWhenOpen, labelStyle)) }, displayValue),
                React.createElement("div", { style: styles.buttons },
                    allowClear && value && React.createElement(IconButton_1.default, { onFocus: function (e) { e.preventDefault(); e.stopPropagation(); }, disabled: disabled, onClick: this.handleClearTouchTap, style: Object.assign({}, styles.icon, iconStyle), iconStyle: styles.iconChildren },
                        React.createElement(clear_1.default, null)),
                    React.createElement(IconButton_1.default, { disabled: disabled, onKeyDown: this.handleKeyDown, ref: function (node) {
                            _this.arrowNode = node;
                        }, style: Object.assign({}, styles.icon, iconStyle), iconStyle: styles.iconChildren }, iconButton)),
                React.createElement("div", { style: prepareStyles(Object.assign({}, styles.underline, underlineStyle)) })),
            React.createElement(Popover_1.default, { anchorOrigin: anchorOrigin, targetOrigin: targetOrigin, anchorEl: anchorEl, animation: animation || PopoverAnimationVertical_1.default, open: open, animated: animated, onRequestClose: this.handleRequestCloseMenu },
                this.props.filter && React.createElement("div", { onKeyDown: this.handleFilterKeyDown }, this.props.filter),
                React.createElement(Menu_1.default, { ref: function (menu) { return _this.menu = menu; }, disableAutoFocus: this.props.filter && true, multiple: multiple, maxHeight: maxHeight, desktop: true, value: value, onEscKeyDown: this.handleEscKeyDownMenu, style: menuStyle, listStyle: listStyle, onItemTouchTap: this.handleItemTouchTap, onChange: this.handleChange, menuItemStyle: menuItemStyle, selectedMenuItemStyle: selectedMenuItemStyle, autoWidth: autoWidth, width: !autoWidth && menuStyle ? menuStyle.width : null }, children))));
    };
    DropDownMenu.muiName = "DropDownMenu";
    // The nested styles for drop-down-menu are modified by toolbar and possibly
    // other user components, so it will give full access to its js styles rather
    // than just the parent.
    // static propTypes = {
    //   /**
    //    * This is the point on the anchor that the popover"s
    //    * `targetOrigin` will attach to.
    //    * Options:
    //    * vertical: [top, center, bottom]
    //    * horizontal: [left, middle, right].
    //    */
    //   anchorOrigin: propTypes.origin,
    //   /**
    //    * If true, the popover will apply transitions when
    //    * it gets added to the DOM.
    //    */
    //   animated: PropTypes.bool,
    //   /**
    //    * Override the default animation component used.
    //    */
    //   animation: PropTypes.func,
    //   /**
    //    * The width will automatically be set according to the items inside the menu.
    //    * To control this width in css instead, set this prop to `false`.
    //    */
    //   autoWidth: PropTypes.bool,
    //   /**
    //    * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
    //    * prop `label` that value will be used to render the representation of that
    //    * item within the field.
    //    */
    //   children: PropTypes.node,
    //   /**
    //    * The css class name of the root element.
    //    */
    //   className: PropTypes.string,
    //   /**
    //    * Disables the menu.
    //    */
    //   disabled: PropTypes.bool,
    //   /**
    //    * Overrides default `SvgIcon` dropdown arrow component.
    //    */
    //   iconButton: PropTypes.node,
    //   /**
    //    * Overrides the styles of icon element.
    //    */
    //   iconStyle: PropTypes.object,
    //   /**
    //    * Overrides the styles of label when the `DropDownMenu` is inactive.
    //    */
    //   labelStyle: PropTypes.object,
    //   /**
    //    * The style object to use to override underlying list style.
    //    */
    //   listStyle: PropTypes.object,
    //   /**
    //    * The maximum height of the `Menu` when it is displayed.
    //    */
    //   maxHeight: PropTypes.number,
    //   /**
    //    * Override the inline-styles of menu items.
    //    */
    //   menuItemStyle: PropTypes.object,
    //   /**
    //    * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
    //    */
    //   menuStyle: PropTypes.object,
    //   /**
    //    * If true, `value` must be an array and the menu will support
    //    * multiple selections.
    //    */
    //   multiple: PropTypes.bool,
    //   /**
    //    * Callback function fired when a menu item is clicked, other than the one currently selected.
    //    *
    //    * @param {object} event TouchTap event targeting the menu item that was clicked.
    //    * @param {number} key The index of the clicked menu item in the `children` collection.
    //    * @param {any} value If `multiple` is true, the menu"s `value`
    //    * array with either the menu item"s `value` added (if
    //    * it wasn"t already selected) or omitted (if it was already selected).
    //    * Otherwise, the `value` of the menu item.
    //    */
    //   onChange: PropTypes.func,
    //   /**
    //    * Callback function fired when the menu is closed.
    //    */
    //   onClose: PropTypes.func,
    //   /**
    //    * Set to true to have the `DropDownMenu` automatically open on mount.
    //    */
    //   openImmediately: PropTypes.bool,
    //   /**
    //    * Override the inline-styles of selected menu items.
    //    */
    //   selectedMenuItemStyle: PropTypes.object,
    //   /**
    //    * Callback function fired when a menu item is clicked, other than the one currently selected.
    //    *
    //    * @param {any} value If `multiple` is true, the menu"s `value`
    //    * array with either the menu item"s `value` added (if
    //    * it wasn"t already selected) or omitted (if it was already selected).
    //    * Otherwise, the `value` of the menu item.
    //    * @param {any} menuItem The selected `MenuItem`.
    //    * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
    //    */
    //   selectionRenderer: PropTypes.func,
    //   /**
    //    * Override the inline-styles of the root element.
    //    */
    //   style: PropTypes.object,
    //   /**
    //    * This is the point on the popover which will attach to
    //    * the anchor"s origin.
    //    * Options:
    //    * vertical: [top, center, bottom]
    //    * horizontal: [left, middle, right].
    //    */
    //   targetOrigin: propTypes.origin,
    //   /**
    //    * Overrides the inline-styles of the underline.
    //    */
    //   underlineStyle: PropTypes.object,
    //   /**
    //    * If `multiple` is true, an array of the `value`s of the selected
    //    * menu items. Otherwise, the `value` of the selected menu item.
    //    * If provided, the menu will be a controlled component.
    //    */
    //   value: PropTypes.any,
    //   filter: PropTypes.node,
    // };
    DropDownMenu.defaultProps = {
        animated: true,
        autoWidth: true,
        disabled: false,
        iconButton: React.createElement(arrow_drop_down_1.default, null),
        openImmediately: false,
        maxHeight: 500,
        multiple: false,
        allowClear: false,
        anchorOrigin: {
            vertical: "top",
            horizontal: "left",
        },
    };
    DropDownMenu.contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    return DropDownMenu;
}(React.Component));
exports.default = DropDownMenu;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Select\\DropDownMenu.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Select\\DropDownMenu.tsx"); } } })();

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var ReactDOM = __webpack_require__(31);
var recompose_1 = __webpack_require__(362);
var ClickAwayListener_1 = __webpack_require__(247);
var keycode = __webpack_require__(52);
var List_1 = __webpack_require__(293);
var menuUtils_1 = __webpack_require__(553);
function getStyles(props, context) {
    var desktop = props.desktop, maxHeight = props.maxHeight, width = props.width;
    var muiTheme = context.muiTheme;
    var styles = {
        root: {
            // Nested div because the List scales x faster than it scales y
            zIndex: muiTheme.zIndex.menu,
            maxHeight: maxHeight,
            overflowY: maxHeight ? 'auto' : null,
        },
        divider: {
            marginTop: 7,
            marginBottom: 8,
        },
        list: {
            display: 'table-cell',
            paddingBottom: desktop ? 16 : 8,
            paddingTop: desktop ? 16 : 8,
            userSelect: 'none',
            width: width,
        },
        selectedMenuItem: {
            color: muiTheme.menuItem.selectedTextColor,
        },
    };
    return styles;
}
var Menu = (function (_super) {
    __extends(Menu, _super);
    function Menu(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.handleClickAway = function (event) {
            if (event.defaultPrevented) {
                return;
            }
            var focusIndex = _this.state.focusIndex;
            if (focusIndex < 0) {
                return;
            }
            var filteredChildren = _this.getFilteredChildren(_this.props.children);
            var focusedItem = filteredChildren[focusIndex];
            if (!!focusedItem && focusedItem.props.menuItems && focusedItem.props.menuItems.length > 0) {
                return;
            }
            _this.setFocusIndex(event, -1, false);
        };
        _this.handleKeyDown = function (event) {
            var filteredChildren = _this.getFilteredChildren(_this.props.children);
            var key = keycode(event);
            switch (key) {
                case 'down':
                    event.preventDefault();
                    _this.incrementKeyboardFocusIndex(event, filteredChildren);
                    break;
                case 'esc':
                    _this.props.onEscKeyDown(event);
                    break;
                case 'tab':
                    event.preventDefault();
                    if (event.shiftKey) {
                        _this.decrementKeyboardFocusIndex(event);
                    }
                    else {
                        _this.incrementKeyboardFocusIndex(event, filteredChildren);
                    }
                    break;
                case 'up':
                    event.preventDefault();
                    _this.decrementKeyboardFocusIndex(event);
                    break;
                default:
                    if (key && key.length === 1) {
                        var hotKeys = _this.hotKeyHolder.append(key);
                        if (_this.setFocusIndexStartsWith(event, hotKeys)) {
                            event.preventDefault();
                        }
                    }
            }
            _this.props.onKeyDown(event);
        };
        _this.handleOnWheel = function (event) {
            var scrollContainer = _this.refs.scrollContainer;
            // Only scroll lock if the the Menu is scrollable.
            if (scrollContainer.scrollHeight <= scrollContainer.clientHeight)
                return;
            var scrollTop = scrollContainer.scrollTop, scrollHeight = scrollContainer.scrollHeight, clientHeight = scrollContainer.clientHeight;
            var wheelDelta = event.deltaY;
            var isDeltaPositive = wheelDelta > 0;
            if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
                scrollContainer.scrollTop = scrollHeight;
                return _this.cancelScrollEvent(event);
            }
            else if (!isDeltaPositive && -wheelDelta > scrollTop) {
                scrollContainer.scrollTop = 0;
                return _this.cancelScrollEvent(event);
            }
        };
        var filteredChildren = _this.getFilteredChildren(props.children);
        var selectedIndex = _this.getLastSelectedIndex(props, filteredChildren);
        var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
        if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
            props.onMenuItemFocusChange(null, newFocusIndex);
        }
        _this.state = {
            focusIndex: newFocusIndex,
            isKeyboardFocused: props.initiallyKeyboardFocused,
            keyWidth: props.desktop ? 64 : 56,
        };
        _this.hotKeyHolder = new menuUtils_1.HotKeyHolder();
        return _this;
    }
    Menu.prototype.componentDidMount = function () {
        if (this.props.autoWidth) {
            this.setWidth();
        }
        this.setScollPosition();
    };
    Menu.prototype.componentWillReceiveProps = function (nextProps) {
        var selectedIndex;
        var filteredChildren = this.getFilteredChildren(nextProps.children);
        selectedIndex = this.state.focusIndex;
        var fallBack = nextProps.disableAutoFocus ? -1 : 0;
        var newFocusIndex = selectedIndex >= 0 ? selectedIndex : fallBack;
        if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
            this.props.onMenuItemFocusChange(null, newFocusIndex);
        }
        this.setState({
            focusIndex: newFocusIndex,
            keyWidth: nextProps.desktop ? 64 : 56,
        });
    };
    Menu.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
        return (!recompose_1.shallowEqual(this.props, nextProps) ||
            !recompose_1.shallowEqual(this.state, nextState) ||
            !recompose_1.shallowEqual(this.context, nextContext));
    };
    Menu.prototype.componentDidUpdate = function () {
        if (this.props.autoWidth)
            this.setWidth();
    };
    // Do not use outside of this component, it will be removed once valueLink is deprecated
    Menu.prototype.getValueLink = function (props) {
        return props.valueLink || {
            value: props.value,
            requestChange: props.onChange,
        };
    };
    Menu.prototype.setKeyboardFocused = function (keyboardFocused) {
        this.setState({
            isKeyboardFocused: keyboardFocused,
        });
    };
    Menu.prototype.getFilteredChildren = function (children) {
        var filteredChildren = [];
        React.Children.forEach(children, function (child) {
            if (child) {
                filteredChildren.push(child);
            }
        });
        return filteredChildren;
    };
    Menu.prototype.cloneMenuItem = function (child, childIndex, styles, index) {
        var _this = this;
        var childIsDisabled = child.props.disabled;
        var selectedChildStyles = {};
        if (!childIsDisabled) {
            var selected = this.isChildSelected(child, this.props);
            if (selected) {
                Object.assign(selectedChildStyles, styles.selectedMenuItem, this.props.selectedMenuItemStyle);
            }
        }
        var mergedChildStyles = Object.assign({}, child.props.style, this.props.menuItemStyle, selectedChildStyles);
        var extraProps = {
            desktop: this.props.desktop,
            style: mergedChildStyles,
        };
        if (!childIsDisabled) {
            var isFocused = childIndex === this.state.focusIndex;
            var focusState = 'none';
            if (isFocused) {
                focusState = this.state.isKeyboardFocused ?
                    'keyboard-focused' : 'focused';
            }
            Object.assign(extraProps, {
                focusState: focusState,
                onClick: function (event) {
                    _this.handleMenuItemTouchTap(event, child, index);
                    if (child.props.onClick)
                        child.props.onClick(event);
                },
                ref: isFocused ? 'focusedMenuItem' : null,
            });
        }
        return React.cloneElement(child, extraProps);
    };
    Menu.prototype.decrementKeyboardFocusIndex = function (event) {
        var index = this.state.focusIndex;
        index--;
        if (index < 0)
            index = 0;
        this.setFocusIndex(event, index, true);
    };
    Menu.prototype.getMenuItemCount = function (filteredChildren) {
        var menuItemCount = 0;
        filteredChildren.forEach(function (child) {
            var childIsADivider = child.type && child.type.muiName === 'Divider';
            var childIsDisabled = child.props.disabled;
            if (!childIsADivider && !childIsDisabled)
                menuItemCount++;
        });
        return menuItemCount;
    };
    Menu.prototype.getLastSelectedIndex = function (props, filteredChildren) {
        var _this = this;
        var selectedIndex = -1;
        var menuItemIndex = 0;
        filteredChildren.forEach(function (child) {
            var childIsADivider = child.type && child.type.muiName === 'Divider';
            if (_this.isChildSelected(child, props))
                selectedIndex = menuItemIndex;
            if (!childIsADivider)
                menuItemIndex++;
        });
        return selectedIndex;
    };
    Menu.prototype.setFocusIndexStartsWith = function (event, keys) {
        var foundIndex = -1;
        React.Children.forEach(this.props.children, function (child, index) {
            if (foundIndex >= 0) {
                return;
            }
            var primaryText = child.props.primaryText;
            if (typeof primaryText === 'string' && primaryText.substr(0, keys.length).toLowerCase() === keys.toLowerCase()) {
                foundIndex = index;
            }
        });
        if (foundIndex >= 0) {
            this.setFocusIndex(event, foundIndex, true);
            return true;
        }
        return false;
    };
    Menu.prototype.handleMenuItemTouchTap = function (event, item, index) {
        var children = this.props.children;
        var multiple = this.props.multiple;
        var valueLink = this.getValueLink(this.props);
        var menuValue = valueLink.value;
        var itemValue = item.props.value;
        var focusIndex = React.isValidElement(children) ? 0 : children.indexOf(item);
        this.setFocusIndex(event, focusIndex, false);
        if (multiple) {
            menuValue = menuValue || [];
            var itemIndex = menuValue.indexOf(itemValue);
            var newMenuValue = menuValue.slice(0);
            if (itemIndex === -1) {
                newMenuValue.push(itemValue);
            }
            else {
                newMenuValue.splice(itemIndex, 1);
            }
            valueLink.requestChange(event, newMenuValue);
        }
        else if (!multiple && itemValue !== menuValue) {
            valueLink.requestChange(event, itemValue);
        }
        this.props.onItemTouchTap(event, item, index);
    };
    Menu.prototype.incrementKeyboardFocusIndex = function (event, filteredChildren) {
        var index = this.state.focusIndex;
        var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
        index++;
        if (index > maxIndex)
            index = maxIndex;
        this.setFocusIndex(event, index, true);
    };
    Menu.prototype.isChildSelected = function (child, props) {
        var menuValue = this.getValueLink(props).value;
        var childValue = child.props.value;
        if (props.multiple) {
            return menuValue && menuValue.length && menuValue.indexOf(childValue) !== -1;
        }
        else {
            return child.props.hasOwnProperty('value') && menuValue === childValue;
        }
    };
    Menu.prototype.setFocusIndex = function (event, newIndex, isKeyboardFocused) {
        if (this.props.onMenuItemFocusChange) {
            // Do this even if `newIndex === this.state.focusIndex` to allow users
            // to detect up-arrow on the first MenuItem or down-arrow on the last.
            this.props.onMenuItemFocusChange(event, newIndex);
        }
        this.setState({
            focusIndex: newIndex,
            isKeyboardFocused: isKeyboardFocused,
        });
    };
    Menu.prototype.setScollPosition = function () {
        var desktop = this.props.desktop;
        var focusedMenuItem = this.refs.focusedMenuItem;
        var menuItemHeight = desktop ? 32 : 48;
        if (focusedMenuItem) {
            var selectedOffSet = ReactDOM.findDOMNode(focusedMenuItem).offsetTop;
            // Make the focused item be the 2nd item in the list the user sees
            var scrollTop = selectedOffSet - menuItemHeight;
            if (scrollTop < menuItemHeight)
                scrollTop = 0;
            ReactDOM.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
        }
    };
    Menu.prototype.cancelScrollEvent = function (event) {
        event.stopPropagation();
        event.preventDefault();
        return false;
    };
    Menu.prototype.setWidth = function () {
        var el = ReactDOM.findDOMNode(this);
        var listEl = ReactDOM.findDOMNode(this.refs.list);
        var elWidth = el.offsetWidth;
        var keyWidth = this.state.keyWidth;
        var minWidth = keyWidth * 1.5;
        var keyIncrements = elWidth / keyWidth;
        var newWidth;
        keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
        newWidth = keyIncrements * keyWidth;
        if (newWidth < minWidth)
            newWidth = minWidth;
        el.style.width = newWidth + "px";
        listEl.style.width = newWidth + "px";
    };
    Menu.prototype.render = function () {
        var _this = this;
        var _a = this.props, autoWidth = _a.autoWidth, // eslint-disable-line no-unused-vars
        children = _a.children, desktop = _a.desktop, // eslint-disable-line no-unused-vars
        disableAutoFocus = _a.disableAutoFocus, // eslint-disable-line no-unused-vars
        initiallyKeyboardFocused = _a.initiallyKeyboardFocused, // eslint-disable-line no-unused-vars
        listStyle = _a.listStyle, maxHeight = _a.maxHeight, // eslint-disable-line no-unused-vars
        multiple = _a.multiple, // eslint-disable-line no-unused-vars
        onItemTouchTap = _a.onItemTouchTap, // eslint-disable-line no-unused-vars
        onEscKeyDown = _a.onEscKeyDown, // eslint-disable-line no-unused-vars
        onMenuItemFocusChange = _a.onMenuItemFocusChange, // eslint-disable-line no-unused-vars
        selectedMenuItemStyle = _a.selectedMenuItemStyle, // eslint-disable-line no-unused-vars
        menuItemStyle = _a.menuItemStyle, // eslint-disable-line no-unused-vars
        style = _a.style, value = _a.value, // eslint-disable-line no-unused-vars
        valueLink = _a.valueLink, // eslint-disable-line no-unused-vars
        width = _a.width, // eslint-disable-line no-unused-vars
        other = __rest(_a, ["autoWidth", "children", "desktop", "disableAutoFocus", "initiallyKeyboardFocused", "listStyle", "maxHeight", "multiple", "onItemTouchTap", "onEscKeyDown", "onMenuItemFocusChange", "selectedMenuItemStyle", "menuItemStyle", "style", "value", "valueLink", "width"]);
        var prepareStyles = this.context.muiTheme.prepareStyles;
        var styles = getStyles(this.props, this.context);
        var mergedRootStyles = Object.assign(styles.root, style);
        var mergedListStyles = Object.assign(styles.list, listStyle);
        var filteredChildren = this.getFilteredChildren(children);
        var menuItemIndex = 0;
        var newChildren = React.Children.map(filteredChildren, function (child, index) {
            var childIsDisabled = child.props.disabled;
            var childName = child.type ? child.type.muiName : '';
            var newChild = child;
            switch (childName) {
                case 'MenuItem':
                    newChild = _this.cloneMenuItem(child, menuItemIndex, styles, index);
                    break;
                case 'Divider':
                    newChild = React.cloneElement(child, {
                        style: Object.assign({}, styles.divider, child.props.style),
                    });
                    break;
            }
            if (childName === 'MenuItem' && !childIsDisabled) {
                menuItemIndex++;
            }
            return newChild;
        });
        return (React.createElement(ClickAwayListener_1.default, { onClickAway: this.handleClickAway },
            React.createElement("div", { onKeyDown: this.handleKeyDown, onWheel: this.handleOnWheel, style: prepareStyles(mergedRootStyles), ref: "scrollContainer", role: "presentation" },
                React.createElement(List_1.default, __assign({}, other, { ref: "list", style: mergedListStyles, role: "menu" }), newChildren))));
    };
    Menu.propTypes = {
        /**
         * If true, the width of the menu will be set automatically
         * according to the widths of its children,
         * using proper keyline increments (64px for desktop,
         * 56px otherwise).
         */
        autoWidth: PropTypes.bool,
        /**
         * The content of the menu. This is usually used to pass `MenuItem`
         * elements.
         */
        children: PropTypes.node,
        /**
         * If true, the menu item will render with compact desktop styles.
         */
        desktop: PropTypes.bool,
        /**
         * If true, the menu will not be auto-focused.
         */
        disableAutoFocus: PropTypes.bool,
        /**
         * If true, the menu will be keyboard-focused initially.
         */
        initiallyKeyboardFocused: PropTypes.bool,
        /**
         * Override the inline-styles of the underlying `List` element.
         */
        listStyle: PropTypes.object,
        /**
         * The maximum height of the menu in pixels. If specified,
         * the menu will be scrollable if it is taller than the provided
         * height.
         */
        maxHeight: PropTypes.number,
        /**
         * Override the inline-styles of menu items.
         */
        menuItemStyle: PropTypes.object,
        /**
         * If true, `value` must be an array and the menu will support
         * multiple selections.
         */
        multiple: PropTypes.bool,
        /**
         * Callback function fired when a menu item with `value` not
         * equal to the current `value` of the menu is touch-tapped.
         *
         * @param {object} event TouchTap event targeting the menu item.
         * @param {any}  value If `multiple` is true, the menu's `value`
         * array with either the menu item's `value` added (if
         * it wasn't already selected) or omitted (if it was already selected).
         * Otherwise, the `value` of the menu item.
         */
        onChange: PropTypes.func,
        /**
         * Callback function fired when the menu is focused and the *Esc* key
         * is pressed.
         *
         * @param {object} event `keydown` event targeting the menu.
         */
        onEscKeyDown: PropTypes.func,
        /**
         * Callback function fired when a menu item is touch-tapped.
         *
         * @param {object} event TouchTap event targeting the menu item.
         * @param {object} menuItem The menu item.
         * @param {number} index The index of the menu item.
         */
        onItemTouchTap: PropTypes.func,
        /** @ignore */
        onKeyDown: PropTypes.func,
        /**
         * Callback function fired when the focus on a `MenuItem` is changed.
         * There will be some "duplicate" changes reported if two different
         * focusing event happen, for example if a `MenuItem` is focused via
         * the keyboard and then it is clicked on.
         *
         * @param {object} event The event that triggered the focus change.
         * The event can be null since the focus can be changed for non-event
         * reasons such as prop changes.
         * @param {number} newFocusIndex The index of the newly focused
         * `MenuItem` or `-1` if focus was lost.
         */
        onMenuItemFocusChange: PropTypes.func,
        /**
         * Override the inline-styles of selected menu items.
         */
        selectedMenuItemStyle: PropTypes.object,
        /**
         * Override the inline-styles of the root element.
         */
        style: PropTypes.object,
        /**
         * If `multiple` is true, an array of the `value`s of the selected
         * menu items. Otherwise, the `value` of the selected menu item.
         * If provided, the menu will be a controlled component.
         * This component also supports valueLink.
         */
        value: PropTypes.any,
        /**
         * ValueLink for the menu's `value`.
         */
        valueLink: PropTypes.object,
        /**
         * The width of the menu. If not specified, the menu's width
         * will be set according to the widths of its children, using
         * proper keyline increments (64px for desktop, 56px otherwise).
         */
        width: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    };
    Menu.defaultProps = {
        autoWidth: true,
        desktop: false,
        disableAutoFocus: false,
        initiallyKeyboardFocused: false,
        //maxHeight: null,
        multiple: false,
        onChange: function () { },
        onEscKeyDown: function () { },
        onItemTouchTap: function () { },
        onKeyDown: function () { },
    };
    Menu.contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    return Menu;
}(React.Component));
exports.default = Menu;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Menu\\Menu.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Menu\\Menu.tsx"); } } })();

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1586);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_select__2_RsT{width:100%!important;min-width:0!important;overflow:visible}.style_filter__2glUo{margin:0 1rem}.style_container__3SU6A{width:100%}", ""]);

// exports
exports.locals = {
	"select": "style_select__2_RsT",
	"filter": "style_filter__2glUo",
	"container": "style_container__3SU6A"
};

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1588);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_menuIcon__gk7RU{font-size:1.375rem;display:flex;align-items:center;text-decoration:none;color:#333}.style_menuIcon__gk7RU:visited{color:#333}.style_menuIcon__gk7RU:hover{opacity:.5}.style_container__2DcBs{display:flex;flex-direction:row}.style_container__2DcBs>:nth-child(2){margin-left:1rem}.style_buttons__36Ekq{padding-top:1rem}", ""]);

// exports
exports.locals = {
	"menuIcon": "style_menuIcon__gk7RU",
	"container": "style_container__2DcBs",
	"buttons": "style_buttons__36Ekq"
};

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bind.26969b5c1fed2a000d9605571a26dc2c.hashedasset.svg";

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "unbind.e722236d2634c9623af4d451108f729c.hashedasset.svg";

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1592);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_topMargin__t0_A5{margin-top:1rem;width:100%}.style_title__1j5K0{color:rgba(0,0,0,.3);font-size:.75rem;font-weight:400;margin-bottom:.25rem}.style_checkboxNote__1BltZ{margin-left:40px}.style_message__10cC8{font-size:.75rem}.style_message__10cC8 hr{border-width:2px;margin-bottom-width:.25rem}", ""]);

// exports
exports.locals = {
	"topMargin": "style_topMargin__t0_A5",
	"title": "style_title__1j5K0",
	"checkboxNote": "style_checkboxNote__1BltZ",
	"message": "style_message__10cC8"
};

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1594);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_label__n7Byj{color:#9e9e9e;font-size:.8125rem;font-weight:400;margin-bottom:.25rem}", ""]);

// exports
exports.locals = {
	"label": "style_label__n7Byj"
};

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1596);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1Zgi2{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__3Ot6w{display:none!important}}@media (max-width:79.9rem){.style_hide-md__20yNZ{display:none!important}}@media (min-width:79.9rem){.style_visible-md__22YNx{display:none!important}}.style_container__3dBIA{display:flex;align-items:baseline;flex-wrap:nowrap;width:100%}@media (max-width:37.4rem){.style_container__3dBIA{flex-wrap:wrap}}.style_input__3ISz3{flex:1 1 auto}.style_actions__2ieOf{margin-left:.5rem}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1Zgi2",
	"hideSm": "style_hide-sm__1Zgi2",
	"visible-sm": "style_visible-sm__3Ot6w",
	"visibleSm": "style_visible-sm__3Ot6w",
	"hide-md": "style_hide-md__20yNZ",
	"hideMd": "style_hide-md__20yNZ",
	"visible-md": "style_visible-md__22YNx",
	"visibleMd": "style_visible-md__22YNx",
	"container": "style_container__3dBIA",
	"input": "style_input__3ISz3",
	"actions": "style_actions__2ieOf"
};

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.maxInputWidth = "26rem";


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\sizes.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\sizes.ts"); } } })();

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1599);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_buttonList__1GeoC{display:flex;flex-direction:row;align-items:center}.style_buttonList__1GeoC>*{margin-right:1rem}", ""]);

// exports
exports.locals = {
	"buttonList": "style_buttonList__1GeoC"
};

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\FormFieldProps.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\FormFieldProps.ts"); } } })();

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__CfhpE{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__p61Qc{display:none!important}}@media (max-width:79.9rem){.style_hide-md__s2-Mn{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2QaGg{display:none!important}}.style_formExpander__G5da1,.style_formNonExpander__WevSy{width:100%;box-shadow:none!important;border-radius:0!important;border-style:solid;border-width:.0625rem 0;border-color:#ccc;border-bottom:none}.style_formSection__23pJN{width:100%;box-shadow:none!important}.style_cardTitleContainer__skChO{display:flex;align-items:top;word-wrap:break-word}@media (max-width:37.4rem){.style_cardTitleContainer__skChO{display:block}}.style_cardTitle__Dxdzg{top:1rem;width:15rem!important;min-width:15rem!important;min-height:1.5rem!important;font-family:Roboto!important;font-size:1rem!important;font-weight:600!important;line-height:1.5!important;text-align:right!important;color:#333!important}@media (max-width:37.4rem){.style_cardTitle__Dxdzg{text-align:left!important;position:static!important}}.style_cardDefaultSubTitle__3iGhW,.style_cardPlaceholderSubTitle__2k0Zs,.style_cardSubTitle__LHY7-{font-family:Roboto!important;font-size:1rem!important;line-height:1.5!important;text-align:left!important;color:#333!important;margin-left:1.6rem!important;margin-right:2rem!important;display:block!important;word-wrap:break-word;min-width:50%;cursor:pointer}@media (max-width:37.4rem){.style_cardDefaultSubTitle__3iGhW,.style_cardPlaceholderSubTitle__2k0Zs,.style_cardSubTitle__LHY7-{margin-left:0!important}}.style_cardSubTitle__LHY7->div>p{margin:0}.style_cardPlaceholderSubTitle__2k0Zs{color:#9e9e9e!important}.style_cardDefaultSubTitle__3iGhW:after{content:\" (default)\";color:#9e9e9e!important}.style_cardMedia__fR0T3{margin-left:17.6rem;margin-right:4rem;margin-top:-.5rem;padding-bottom:1rem;max-width:37.5rem}@media (max-width:37.4rem){.style_cardMedia__fR0T3{margin-left:1.1rem!important;margin-right:1.1rem}}.style_cardMediaFillRight__M_MJc{max-width:none}.style_cardMediaFillAll__20uwJ{margin-left:0;margin-right:0}.style_cardMedia__fR0T3 .style_container__2kJfg{padding-bottom:.5rem!important}.style_cardMediaNonExpander__21uV8{margin:0 1.1rem;padding:1rem 0}.style_expandLink__VuLUw{width:6rem;height:1.19rem;font-family:Roboto;font-size:.8125rem;line-height:1.36rem;color:#9e9e9e;margin-right:1.5rem}.style_expandLink__VuLUw:hover{color:#2f93e0}.style_linkContainer__2ZGQj{width:100%;text-align:right;padding:.3125rem 0}.style_moreInformation__R6jJv{padding:1rem;background:hsla(0,0%,60%,.08);font-size:.875rem}.style_hide__2Um8X{font-family:Roboto;font-size:.75rem;line-height:1.83rem;text-align:left;color:#9e9e9e;text-align:right}.style_hide__2Um8X a{color:#2f93e0}.style_sectionHeading__13Bbq{width:100%;border-radius:0!important;margin:0 0 -.0725rem}.style_dialogSectionHeading__2qicb,.style_sectionHeading__13Bbq{background:hsla(0,0%,60%,.08);border-style:solid;border-width:.0625rem 0;border-color:#ccc}.style_dialogSectionHeading__2qicb{margin:2rem -1rem 1rem}.style_sectionHeadingTitle__1H3Lk{padding:.6rem 1rem;font-size:1.0625rem}.style_expandCollapse__3qTMH{top:0;bottom:0;right:.25rem;position:absolute}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__CfhpE",
	"hideSm": "style_hide-sm__CfhpE",
	"visible-sm": "style_visible-sm__p61Qc",
	"visibleSm": "style_visible-sm__p61Qc",
	"hide-md": "style_hide-md__s2-Mn",
	"hideMd": "style_hide-md__s2-Mn",
	"visible-md": "style_visible-md__2QaGg",
	"visibleMd": "style_visible-md__2QaGg",
	"formExpander": "style_formExpander__G5da1",
	"formNonExpander": "style_formNonExpander__WevSy",
	"formSection": "style_formSection__23pJN",
	"cardTitleContainer": "style_cardTitleContainer__skChO",
	"cardTitle": "style_cardTitle__Dxdzg",
	"cardSubTitle": "style_cardSubTitle__LHY7-",
	"cardPlaceholderSubTitle": "style_cardPlaceholderSubTitle__2k0Zs",
	"cardDefaultSubTitle": "style_cardDefaultSubTitle__3iGhW",
	"cardMedia": "style_cardMedia__fR0T3",
	"cardMediaFillRight": "style_cardMediaFillRight__M_MJc",
	"cardMediaFillAll": "style_cardMediaFillAll__20uwJ",
	"container": "style_container__2kJfg",
	"cardMediaNonExpander": "style_cardMediaNonExpander__21uV8",
	"expandLink": "style_expandLink__VuLUw",
	"linkContainer": "style_linkContainer__2ZGQj",
	"moreInformation": "style_moreInformation__R6jJv",
	"hide": "style_hide__2Um8X",
	"sectionHeading": "style_sectionHeading__13Bbq",
	"dialogSectionHeading": "style_dialogSectionHeading__2qicb",
	"sectionHeadingTitle": "style_sectionHeadingTitle__1H3Lk",
	"expandCollapse": "style_expandCollapse__3qTMH"
};

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var RadioButton_1 = __webpack_require__(36);
var warning = __webpack_require__(30);
// import {PropTypes} from "prop-types";
var styles = __webpack_require__(382);
// modified to handle children which aren't a radio button
var RadioButtonGroup = (function (_super) {
    __extends(RadioButtonGroup, _super);
    /**
     *
     */
    function RadioButtonGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event, newSelection) {
            _this.updateRadioButtons(newSelection);
            // Successful update
            if (_this.state.numberCheckedRadioButtons === 0) {
                if (_this.props.onChange) {
                    _this.props.onChange(event, newSelection);
                }
            }
        };
        var cnt = 0;
        var selected = "";
        var _a = _this.props, valueSelected = _a.valueSelected, defaultSelected = _a.defaultSelected;
        if (valueSelected !== undefined) {
            selected = valueSelected;
        }
        else if (defaultSelected !== undefined) {
            selected = defaultSelected;
        }
        React.Children.forEach(_this.props.children, function (option) {
            if (_this.hasCheckAttribute(option)) {
                cnt++;
            }
        });
        _this.state = {
            numberCheckedRadioButtons: cnt,
            selected: selected,
        };
        return _this;
    }
    RadioButtonGroup.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.hasOwnProperty("valueSelected")) {
            this.setState({
                selected: nextProps.valueSelected,
            });
        }
    };
    RadioButtonGroup.prototype.hasCheckAttribute = function (radioButton) {
        return radioButton.props && radioButton.props.hasOwnProperty("checked") &&
            radioButton.props.checked;
    };
    RadioButtonGroup.prototype.updateRadioButtons = function (newSelection) {
        if (this.state.numberCheckedRadioButtons === 0) {
            this.setState({ selected: newSelection });
        }
        else {
            warning(false, "Material-UI: Cannot select a different radio button while another radio button\n        has the \"checked\" property set to true.");
        }
    };
    RadioButtonGroup.prototype.getSelectedValue = function () {
        return this.state.selected;
    };
    RadioButtonGroup.prototype.setSelectedValue = function (newSelectionValue) {
        this.updateRadioButtons(newSelectionValue);
    };
    RadioButtonGroup.prototype.clearValue = function () {
        this.setSelectedValue("");
    };
    RadioButtonGroup.prototype.isRadioButton = function (element) {
        return element.props && element.props.hasOwnProperty("checked");
    };
    RadioButtonGroup.prototype.render = function () {
        var _this = this;
        var prepareStyles = this.context.muiTheme.prepareStyles;
        var autoFocus = this.props.autoFocus;
        var options = React.Children.map(this.props.children, function (child) {
            if (!_this.isRadioButton(child)) {
                return child;
            }
            var _a = child.props, name = _a.name, // eslint-disable-line no-unused-vars
            value = _a.value, // eslint-disable-line no-unused-vars
            label = _a.label, // eslint-disable-line no-unused-vars
            onCheck = _a.onCheck, // eslint-disable-line no-unused-vars
            other = __rest(_a, ["name", "value", "label", "onCheck"]);
            var checked = child.props.value === _this.state.selected;
            return (React.createElement(RadioButton_1.default, __assign({}, other, { className: styles.radioButton, ref: child.props.value, name: _this.props.name, key: child.props.value, value: child.props.value, label: child.props.label, labelPosition: _this.props.labelPosition, onCheck: _this.handleChange, checked: checked, autoFocus: checked && autoFocus })));
        });
        return (React.createElement("div", { style: prepareStyles(__assign({}, this.props.style)), className: this.props.className }, options));
    };
    RadioButtonGroup.defaultProps = {
        style: {}
    };
    RadioButtonGroup.contextTypes = {
        muiTheme: PropTypes.object.isRequired
    };
    return RadioButtonGroup;
}(React.Component));
exports.default = RadioButtonGroup;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\RadioButton\\RadioButtonGroupInternal.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\RadioButton\\RadioButtonGroupInternal.tsx"); } } })();

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1UYNO{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__onwxa{display:none!important}}@media (max-width:79.9rem){.style_hide-md__HxPYA{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1B--X{display:none!important}}.style_errorText__3PMlt{margin-top:.3rem;font-size:.75rem;line-height:.75rem;color:#db4437}.style_isDefault__2FXJR:after{content:\" (default)\";color:#9e9e9e!important}.style_radioButton__CUKRk{margin-bottom:.25rem;font-size:1rem}.style_radioButtonGroup__1ZPDK>:not(.style_radioButton__CUKRk){margin-left:2.5rem}.style_label__2-obS{color:#9e9e9e;font-size:.8125rem;font-weight:400;margin-bottom:.25rem}.style_container__1nYEr{width:100%}.style_topMargin__DJ5-6{margin-top:1rem}.style_horizontal__DoY4a{display:flex;flex-direction:row}@media (max-width:37.4rem){.style_horizontal__DoY4a{flex-direction:column}}.style_horizontal__DoY4a>div{width:auto!important;margin-right:3rem}@media (max-width:37.4rem){.style_horizontal__DoY4a>div{margin-right:unset}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1UYNO",
	"hideSm": "style_hide-sm__1UYNO",
	"visible-sm": "style_visible-sm__onwxa",
	"visibleSm": "style_visible-sm__onwxa",
	"hide-md": "style_hide-md__HxPYA",
	"hideMd": "style_hide-md__HxPYA",
	"visible-md": "style_visible-md__1B--X",
	"visibleMd": "style_visible-md__1B--X",
	"errorText": "style_errorText__3PMlt",
	"isDefault": "style_isDefault__2FXJR",
	"radioButton": "style_radioButton__CUKRk",
	"radioButtonGroup": "style_radioButtonGroup__1ZPDK",
	"label": "style_label__2-obS",
	"container": "style_container__1nYEr",
	"topMargin": "style_topMargin__DJ5-6",
	"horizontal": "style_horizontal__DoY4a"
};

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var InputLabel_1 = __webpack_require__(263);
__export(__webpack_require__(263));
exports.default = InputLabel_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\InputLabel\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\InputLabel\\index.ts"); } } })();

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1606);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1aUeT{display:flex;width:7rem;position:relative;flex:0 0 7rem}.style_colorSwatch__2rOye{width:1.5rem;height:1.5rem;border-radius:.25em;position:absolute;bottom:1rem;right:.5rem;cursor:pointer}.style_colorPickItem__249hZ{width:2.5rem;height:2.5rem;cursor:pointer;transition:background-color .1s linear;border-radius:0}.style_colorAllOptions__2ExLA{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center}", ""]);

// exports
exports.locals = {
	"container": "style_container__1aUeT",
	"colorSwatch": "style_colorSwatch__2rOye",
	"colorPickItem": "style_colorPickItem__249hZ",
	"colorAllOptions": "style_colorAllOptions__2ExLA"
};

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1608);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_markdownEditorContainer__1G5rk{position:relative;width:100%}.style_restrictedHeight__kHLAa{max-height:15rem}.style_iconButton___5HNj{width:2rem!important;min-width:2rem!important}.style_iconButton___5HNj:hover span{opacity:1}.style_iconButton___5HNj span{padding-left:0!important;padding-right:0!important;opacity:.6}.style_markdownSupported__2F-aV{padding-right:.25rem}.style_iconButtonContainer__1pHWS{display:flex;flex-direction:row;justify-content:flex-end;background:hsla(0,0%,60%,.08);border:.0625rem solid #ccc;border-bottom:0}.style_textarea__vr5fk{max-width:inherit!important}", ""]);

// exports
exports.locals = {
	"markdownEditorContainer": "style_markdownEditorContainer__1G5rk",
	"restrictedHeight": "style_restrictedHeight__kHLAa",
	"iconButton": "style_iconButton___5HNj",
	"markdownSupported": "style_markdownSupported__2F-aV",
	"iconButtonContainer": "style_iconButtonContainer__1pHWS",
	"textarea": "style_textarea__vr5fk"
};

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MarkdownProvider = (function () {
    function MarkdownProvider(value, selectionStart, selectionEnd) {
        this.value = value;
        this.selectionStart = selectionStart;
        this.selectionEnd = selectionEnd;
        this.before = "";
        this.after = "";
        this.addNewLine = false;
        this.afterNewline = "";
        this.emptyText = "";
    }
    MarkdownProvider.prototype.insertBefore = function (before) {
        this.before = before;
        return this;
    };
    MarkdownProvider.prototype.insertAfter = function (after) {
        this.after = after;
        return this;
    };
    MarkdownProvider.prototype.surroundWithNewlines = function () {
        this.addNewLine = true;
        return this;
    };
    MarkdownProvider.prototype.insertAfterNewlineInSelection = function (afterNewline) {
        this.afterNewline = afterNewline;
        return this;
    };
    MarkdownProvider.prototype.emptySelectionText = function (emptyText) {
        this.emptyText = emptyText;
        return this;
    };
    MarkdownProvider.prototype.apply = function (callback) {
        this.trimSelection();
        if (this.emptyText && this.selectionStart === this.selectionEnd) {
            this.addEmptyText();
        }
        if (this.addNewLine) {
            this.addNewLineImpl();
        }
        this.value = this.splice(this.value, this.selectionEnd, this.after);
        this.value = this.splice(this.value, this.selectionStart, this.before);
        this.selectionStart = this.selectionStart + this.before.length;
        this.selectionEnd = this.selectionEnd + this.before.length;
        if (this.afterNewline) {
            this.insertAfterNewlineInSelectionImpl();
        }
        callback(this.value, this.selectionStart, this.selectionEnd);
    };
    MarkdownProvider.prototype.splice = function (input, start, newSubStr) {
        return input.slice(0, start) + newSubStr + input.slice(start);
    };
    MarkdownProvider.prototype.addNewLineImpl = function () {
        // add a newline character for lists and comments,
        // but not if there is already one there
        var beforeSelection = this.value[this.selectionStart - 1];
        if (beforeSelection !== "\n" && beforeSelection !== undefined) {
            this.value = this.splice(this.value, this.selectionStart, "\n");
            this.selectionStart += 1;
            this.selectionEnd += 1;
        }
        var afterSelection = this.value[this.selectionEnd];
        if (afterSelection !== "\n" && afterSelection !== undefined) {
            this.value = this.splice(this.value, this.selectionEnd, "\n");
        }
    };
    MarkdownProvider.prototype.trimSelection = function () {
        // trim whitespace from the selection (this was implemented in
        // other online markdown editors when I checked how they handled selection)
        while (this.value[this.selectionStart] === " " && this.selectionStart < this.selectionEnd) {
            this.selectionStart += 1;
        }
        while (this.value[this.selectionEnd - 1] === " " && this.selectionStart < this.selectionEnd) {
            this.selectionEnd -= 1;
        }
    };
    MarkdownProvider.prototype.insertAfterNewlineInSelectionImpl = function () {
        // insert something after each newLine in the selection
        var selectedText = this.value.slice(this.selectionStart, this.selectionEnd);
        var updatedText = selectedText.replace(new RegExp("\n", "g"), "\n" + this.afterNewline);
        this.value = this.value.slice(0, this.selectionStart) + updatedText + this.value.slice(this.selectionEnd);
        this.selectionEnd = this.selectionEnd - selectedText.length + updatedText.length;
    };
    MarkdownProvider.prototype.addEmptyText = function () {
        this.value = this.splice(this.value, this.selectionStart, this.emptyText);
        this.selectionEnd = this.selectionEnd + this.emptyText.length;
    };
    return MarkdownProvider;
}());
exports.MarkdownProvider = MarkdownProvider;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\MarkdownEditor\\MarkdownProvider.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\MarkdownEditor\\MarkdownProvider.ts"); } } })();

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1611);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__iiH-l{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__Yt2OF{display:none!important}}@media (max-width:79.9rem){.style_hide-md__1b_oL{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1LxbM{display:none!important}}.style_logoContainer__EB3_j{display:flex;flex-direction:row;flex-wrap:wrap;width:100%;align-items:center}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__iiH-l",
	"hideSm": "style_hide-sm__iiH-l",
	"visible-sm": "style_visible-sm__Yt2OF",
	"visibleSm": "style_visible-sm__Yt2OF",
	"hide-md": "style_hide-md__1b_oL",
	"hideMd": "style_hide-md__1b_oL",
	"visible-md": "style_visible-md__1LxbM",
	"visibleMd": "style_visible-md__1LxbM",
	"logoContainer": "style_logoContainer__EB3_j"
};

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "choose-image.db1937ca7f18c18df016811ab88e75cd.hashedasset.svg";

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var sizes = ["B", "KB", "MB", "GB", "TB", "PB"];
function formattedFileSize(bytes) {
    if (isNaN(bytes)) {
        return "";
    }
    if (bytes === 0) {
        return "0 bytes";
    }
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    return +(bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
}
exports.default = formattedFileSize;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ByteSizeFormatter\\ByteSizeFormatter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ByteSizeFormatter\\ByteSizeFormatter.tsx"); } } })();

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var NumericInput = __webpack_require__(737);
var fontWeights_1 = __webpack_require__(76);
var styles = __webpack_require__(1615);
var Meridiem;
(function (Meridiem) {
    Meridiem[Meridiem["AM"] = 0] = "AM";
    Meridiem[Meridiem["PM"] = 1] = "PM";
})(Meridiem || (Meridiem = {}));
var TimePicker = (function (_super) {
    __extends(TimePicker, _super);
    function TimePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.getMeridiem = function (time) {
            var hour = time.getHours();
            return hour < 12 ? Meridiem.AM : Meridiem.PM;
        };
        _this.getMinutes = function (time) {
            var n = time.getMinutes();
            if (n === 0) {
                return n;
            }
            n = Math.round(n / 15) * 15;
            if (n > 45) {
                n = 45;
            }
            return n;
        };
        _this.getHours = function (time) {
            var hour = time.getHours();
            if (hour > 12) {
                return hour - 12;
            }
            if (hour === 0) {
                return 12;
            }
            return hour;
        };
        _this.updateMeridiem = function (e) {
            e.preventDefault();
            _this.setState({
                meridiem: _this.state.meridiem === Meridiem.AM ? Meridiem.PM : Meridiem.AM
            }, function () { return _this.raiseChange(); });
        };
        _this.padding = function (value) {
            if (value === "0") {
                return "00";
            }
            return value.toString();
        };
        _this.updateHours = function (value) {
            _this.setState({
                hours: value
            }, function () { return _this.raiseChange(); });
        };
        _this.updateMinutes = function (value) {
            _this.setState({
                minutes: value
            }, function () { return _this.raiseChange(); });
        };
        _this.state = _this.initState(_this.props.value);
        return _this;
    }
    TimePicker.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setState(this.initState(nextProps.value));
        }
    };
    TimePicker.prototype.render = function () {
        var imputStyle = {
            input: {
                border: "0",
                fontSize: fontWeights_1.baseSizeInPx,
                height: "100%"
            }
        };
        return (React.createElement("div", { className: styles.container },
            React.createElement(NumericInput, { onChange: this.updateHours, value: this.state.hours, min: 1, max: 12, step: 1, size: 1, mobile: true, style: imputStyle }),
            React.createElement("span", { className: styles.separator }, ":"),
            React.createElement(NumericInput, { onChange: this.updateMinutes, value: this.state.minutes, min: 0, max: 45, step: 15, size: 1, snap: true, style: imputStyle, mobile: true, format: this.padding, readOnly: true }),
            React.createElement("a", { className: styles.ampm, href: "#", onClick: this.updateMeridiem }, this.state.meridiem === Meridiem.AM ? "AM" : "PM")));
    };
    TimePicker.prototype.initState = function (value) {
        var time = value || new Date();
        return {
            meridiem: this.getMeridiem(time),
            hours: this.getHours(time),
            minutes: this.getMinutes(time)
        };
    };
    TimePicker.prototype.raiseChange = function () {
        var date = new Date();
        var hours = this.state.hours;
        if (this.state.meridiem === Meridiem.PM) {
            if (hours === 12) {
                hours = 12;
            }
            else {
                hours += 12;
            }
        }
        else {
            if (hours === 12) {
                hours = 0;
            }
        }
        date.setHours(hours, this.state.minutes, 0, 0);
        this.props.onChange(date);
    };
    return TimePicker;
}(React.Component));
exports.default = TimePicker;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\DatePicker\\TimePicker.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\DatePicker\\TimePicker.tsx"); } } })();

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1616);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__9af8H{display:flex;align-items:center}.style_separator__nIuvl{margin:0 .125rem}.style_ampm__3wJd2{margin-left:.1875rem}", ""]);

// exports
exports.locals = {
	"container": "style_container__9af8H",
	"separator": "style_separator__nIuvl",
	"ampm": "style_ampm__3wJd2"
};

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardLayout_1 = __webpack_require__(1618);
exports.default = DashboardLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardLayout\\index.tsx"); } } })();

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var AreaTitle_1 = __webpack_require__(120);
var routeLinks_1 = __webpack_require__(20);
var DashboardLayout = function (props) {
    return (React.createElement("main", { id: "maincontent" },
        React.createElement(AreaTitle_1.default, { link: routeLinks_1.default.root, title: "Dashboard" }),
        props.children));
};
exports.default = DashboardLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardLayout\\DashboardLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardLayout\\DashboardLayout.tsx"); } } })();

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(419);
var EnvironmentMultiSelect_1 = __webpack_require__(281);
var ProjectMultiSelect_1 = __webpack_require__(459);
var form_1 = __webpack_require__(15);
var RadioButton_1 = __webpack_require__(36);
var form_2 = __webpack_require__(15);
var clientInstance_1 = __webpack_require__(10);
var Text_1 = __webpack_require__(17);
var TenantTagMultiSelect_1 = __webpack_require__(295);
var MultiSelect_1 = __webpack_require__(71);
var Chips_1 = __webpack_require__(23);
var MissingTagsList_1 = __webpack_require__(290);
var FormBaseComponent_1 = __webpack_require__(137);
var permission_1 = __webpack_require__(49);
var styles = __webpack_require__(1647);
var FeatureToggle_1 = __webpack_require__(417);
var PermissionCheck_1 = __webpack_require__(427);
exports.DefaultProjectLimit = "200";
var DashboardConfiguration = (function (_super) {
    __extends(DashboardConfiguration, _super);
    function DashboardConfiguration(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a, includeAllEnvironments, includeAllProjects, includeAllTenants, dashboardConfig;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.state.model, includeAllEnvironments = _a.includeAllEnvironments, includeAllProjects = _a.includeAllProjects, includeAllTenants = _a.includeAllTenants, dashboardConfig = __rest(_a, ["includeAllEnvironments", "includeAllProjects", "includeAllTenants"]);
                        if (includeAllProjects) {
                            dashboardConfig.IncludedProjectIds.length = 0;
                        }
                        if (includeAllEnvironments) {
                            dashboardConfig.IncludedEnvironmentIds.length = 0;
                        }
                        if (includeAllTenants) {
                            dashboardConfig.IncludedTenantTags.length = 0;
                            dashboardConfig.IncludedTenantIds.length = 0;
                        }
                        return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                var resource;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, clientInstance_1.repository.DashboardConfiguration.modify(dashboardConfig)];
                                        case 1:
                                            resource = _a.sent();
                                            this.setState(function (s) {
                                                return {
                                                    submitted: true,
                                                    model: _this.buildModel(resource),
                                                    cleanModel: _this.buildModel(resource)
                                                };
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            projects: [],
            environments: [],
            tenants: [],
        };
        return _this;
    }
    DashboardConfiguration.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, projects, environments, tenants, dashboardConfiguration, _b, _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0: return [4 /*yield*/, Promise.all([
                                            clientInstance_1.repository.Projects.all(),
                                            clientInstance_1.repository.Environments.all(),
                                            clientInstance_1.repository.Tenants.all(),
                                            clientInstance_1.repository.DashboardConfiguration.get()
                                        ])];
                                    case 1:
                                        _a = _d.sent(), projects = _a[0], environments = _a[1], tenants = _a[2], dashboardConfiguration = _a[3];
                                        _b = this.setState;
                                        _c = {
                                            model: this.buildModel(dashboardConfiguration),
                                            cleanModel: this.buildModel(dashboardConfiguration)
                                        };
                                        return [4 /*yield*/, projects];
                                    case 2:
                                        _c.projects = _d.sent();
                                        return [4 /*yield*/, environments];
                                    case 3:
                                        _c.environments = _d.sent();
                                        return [4 /*yield*/, tenants];
                                    case 4:
                                        _b.apply(this, [(_c.tenants = _d.sent(),
                                                _c)]);
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardConfiguration.prototype.buildModel = function (resource) {
        return __assign({}, resource, { includeAllProjects: !resource.IncludedProjectIds.length, includeAllEnvironments: !resource.IncludedEnvironmentIds.length, includeAllTenants: !resource.IncludedTenantIds.length && !resource.IncludedTenantTags.length });
    };
    DashboardConfiguration.prototype.environmentsSummary = function () {
        return this.state.model.IncludedEnvironmentIds && this.state.model.IncludedEnvironmentIds.length
            ? form_2.Summary.summary(React.createElement("div", null,
                "Only show ",
                Chips_1.environmentChipList(this.state.environments, this.state.model.IncludedEnvironmentIds)))
            : form_2.Summary.default("All environments are shown");
    };
    DashboardConfiguration.prototype.projectsSummary = function () {
        return this.state.model.IncludedProjectIds && this.state.model.IncludedProjectIds.length
            ? form_2.Summary.summary(React.createElement("div", null,
                "Only show ",
                Chips_1.projectChipList(this.state.projects, this.state.model.IncludedProjectIds)))
            : form_2.Summary.default("All projects are shown");
    };
    DashboardConfiguration.prototype.maximumProjectSummary = function () {
        var limit = this.state.model.ProjectLimit || exports.DefaultProjectLimit;
        var wrapper = this.state.model.ProjectLimit ? form_2.Summary.summary : form_2.Summary.default;
        return wrapper("Only " + limit + " project" + (limit === 1 ? "" : "s") + " will be shown (plus any with failing deployments).");
    };
    DashboardConfiguration.prototype.tenantSummary = function () {
        var tenants = this.state.model.IncludedTenantIds || [];
        var tags = this.state.model.IncludedTenantTags || [];
        if (tenants.length === 0 && tags.length === 0) {
            return form_2.Summary.default("All tenants are included");
        }
        if (tenants.length === 0) {
            return form_2.Summary.summary(React.createElement("span", null,
                "Only show deployments for tenants with ",
                React.createElement(MissingTagsList_1.default, { tags: tags }),
                " tags"));
        }
        return form_2.Summary.summary(React.createElement("span", null,
            "Only show deployments for ",
            Chips_1.tenantChipList(this.state.tenants, tenants),
            tags.length === 0 || React.createElement("span", null,
                " or any tenants with ",
                React.createElement(MissingTagsList_1.default, { tags: tags }),
                " tags")));
    };
    DashboardConfiguration.prototype.render = function () {
        var _this = this;
        return React.createElement(index_1.default, { title: "Configure", className: styles.paper, busy: this.state.busy, errors: this.state.errors, model: this.state.model, cleanModel: this.state.cleanModel, onSaveClick: this.handleSaveClick }, this.state.model && React.createElement("div", null,
            React.createElement(form_2.ExpandableFormSection, { errorKey: "ProjectLimit", title: "Maximum Projects", focusOnExpandAll: true, summary: this.maximumProjectSummary(), help: "The maximum number of projects to display on the dashboard." },
                React.createElement(Text_1.default, { value: this.convertToString(this.state.model.ProjectLimit), min: 1, type: "number", hintText: exports.DefaultProjectLimit, onChange: function (projectLimit) { return _this.setModelState({ ProjectLimit: _this.parseToInt(projectLimit) }); }, autoFocus: true })),
            React.createElement(form_2.ExpandableFormSection, { errorKey: "includedProjectIds", title: "Projects", summary: this.projectsSummary(), help: "Filter the dashboard to only show a subset of your projects." },
                React.createElement(form_1.BooleanRadioButtonGroup, { onChange: function (includeAllProjects) { return _this.setModelState({ includeAllProjects: includeAllProjects }); }, value: this.state.model.includeAllProjects },
                    React.createElement(RadioButton_1.default, { value: true, label: "All projects", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: false, label: "Only selected projects" })),
                this.state.model.includeAllProjects ||
                    React.createElement(ProjectMultiSelect_1.default, { onChange: function (IncludedProjectIds) { return _this.setModelState({ IncludedProjectIds: IncludedProjectIds }); }, value: this.state.model.IncludedProjectIds, items: this.state.projects })),
            React.createElement(form_2.ExpandableFormSection, { errorKey: "includedEnvironmentIds", title: "Environments", summary: this.environmentsSummary(), help: "Filter the dashboard to only show a subset of your environments." },
                React.createElement(form_1.BooleanRadioButtonGroup, { onChange: function (includeAllEnvironments) { return _this.setModelState({ includeAllEnvironments: includeAllEnvironments }); }, value: this.state.model.includeAllEnvironments },
                    React.createElement(RadioButton_1.default, { value: true, label: "All environments", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: false, label: "Only selected environments" })),
                this.state.model.includeAllEnvironments ||
                    React.createElement(EnvironmentMultiSelect_1.default, { items: this.state.environments, onChange: function (IncludedEnvironmentIds) { return _this.setModelState({ IncludedEnvironmentIds: IncludedEnvironmentIds }); }, value: this.state.model.IncludedEnvironmentIds })),
            React.createElement(FeatureToggle_1.FeatureToggle, { feature: FeatureToggle_1.Feature.MultiTenancy },
                React.createElement(PermissionCheck_1.PermissionCheck, { permission: permission_1.default.TenantView, tenant: "*" },
                    React.createElement(form_2.ExpandableFormSection, { errorKey: "Tenants", title: "Tenants", summary: this.tenantSummary(), help: "Filter the dashboard to only show releases for specific tenants." },
                        React.createElement(form_1.BooleanRadioButtonGroup, { onChange: function (includeAllTenants) { return _this.setModelState({ includeAllTenants: includeAllTenants }); }, value: this.state.model.includeAllTenants },
                            React.createElement(RadioButton_1.default, { value: true, label: "All tenants", isDefault: true }),
                            React.createElement(RadioButton_1.default, { value: false, label: "Only selected tenants" })),
                        this.state.model.includeAllTenants ||
                            React.createElement("div", null,
                                React.createElement(MultiSelect_1.TenantMultiSelect, { value: this.state.model.IncludedTenantIds, items: this.state.tenants, onChange: function (IncludedTenantIds) { return _this.setModelState({ IncludedTenantIds: IncludedTenantIds }); } }),
                                React.createElement(TenantTagMultiSelect_1.default, { value: this.state.model.IncludedTenantTags, doBusyTask: this.doBusyTask, onChange: function (IncludedTenantTags) { return _this.setModelState({ IncludedTenantTags: IncludedTenantTags }); } })))))));
    };
    DashboardConfiguration.prototype.convertToString = function (value) {
        return value ? value.toString() : "";
    };
    DashboardConfiguration.prototype.parseToInt = function (value) {
        return value ? parseInt(value, 10) : null;
    };
    return DashboardConfiguration;
}(FormBaseComponent_1.default));
exports.default = DashboardConfiguration;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardConfiguration\\DashboardConfiguration.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\dashboard\\DashboardConfiguration\\DashboardConfiguration.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1621);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_actionList__37i_d{display:flex;flex-direction:row;align-items:flex-start;flex-wrap:wrap}.style_actionList__37i_d>:not(:first-child){margin-left:.25rem}", ""]);

// exports
exports.locals = {
	"actionList": "style_actionList__37i_d"
};

/***/ }),
/* 1622 */,
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1624);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_menuIcon__rA8-Q{font-size:1.375rem;height:2.25rem!important;padding:0!important;display:flex;align-items:center;text-decoration:none;color:#333}.style_menuIcon__rA8-Q:visited{color:#333}.style_menuIcon__rA8-Q:hover{opacity:.5}.style_disabledItem__1s4p7{cursor:not-allowed;color:#9e9e9e}", ""]);

// exports
exports.locals = {
	"menuIcon": "style_menuIcon__rA8-Q",
	"disabledItem": "style_disabledItem__1s4p7"
};

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var exposeComponentAsClass_1 = __webpack_require__(369);
var react_router_1 = __webpack_require__(69);
var resolvePathWithSpaceId_1 = __webpack_require__(131);
var OverflowMenuLink = function (props) {
    var resolvedTo = props.resolve ? resolvePathWithSpaceId_1.resolvePathWithSpaceId(props.to, props.match.params.spaceId) : props.to;
    var href = typeof resolvedTo === "string" ? resolvedTo : props.history.createHref(resolvedTo);
    var download = props.downloadFileName ? { download: props.downloadFileName } : {};
    // Ideally we would not use spread operator here. Unfortunately, material-ui injects bunch of properties here
    // and we need to pass all of them so the UI looks consistent.
    var _a = props, staticContext = _a.staticContext, resolve = _a.resolve, to = _a.to, downloadFileName = _a.downloadFileName, rest = __rest(_a, ["staticContext", "resolve", "to", "downloadFileName"]);
    return React.createElement("a", __assign({}, rest, { href: href }, download));
};
OverflowMenuLink.defaultProps = {
    resolve: true
};
exports.default = exposeComponentAsClass_1.exposeComponentAsClass(react_router_1.withRouter(OverflowMenuLink));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Menu\\OverflowMenuLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Menu\\OverflowMenuLink.tsx"); } } })();

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1627);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__3vFhG{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__20C9B{display:none!important}}@media (max-width:79.9rem){.style_hide-md__1BZaV{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1kb-w{display:none!important}}.style_formContainer__1XosJ{display:flex;flex-direction:column;align-items:stretch;flex:1 1 auto}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3vFhG",
	"hideSm": "style_hide-sm__3vFhG",
	"visible-sm": "style_visible-sm__20C9B",
	"visibleSm": "style_visible-sm__20C9B",
	"hide-md": "style_hide-md__1BZaV",
	"hideMd": "style_hide-md__1BZaV",
	"visible-md": "style_visible-md__1kb-w",
	"visibleMd": "style_visible-md__1kb-w",
	"formContainer": "style_formContainer__1XosJ"
};

/***/ }),
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1634);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_markdown__14Azh{line-height:normal}.style_markdown__14Azh ul{list-style-type:disc;padding-left:2.5rem}.style_markdown__14Azh ol{list-style-type:decimal;padding-left:2.5rem}.style_markdown__14Azh blockquote{border-left:.25rem solid #ccc;padding-left:1rem}", ""]);

// exports
exports.locals = {
	"markdown": "style_markdown__14Azh"
};

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var DebounceValue_1 = __webpack_require__(173);
__export(__webpack_require__(173));
exports.default = DebounceValue_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DebounceValue\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DebounceValue\\index.ts"); } } })();

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IconButton_1 = __webpack_require__(56);
exports.default = IconButton_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\IconButton\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\IconButton\\index.tsx"); } } })();

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1638);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./VirtualListWithKeyboard.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./VirtualListWithKeyboard.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".VirtualListWithKeyboard_menuContainer__3RXtt{max-height:25rem}.VirtualListWithKeyboard_empty__qv1G4{padding:.625rem}", ""]);

// exports
exports.locals = {
	"menuContainer": "VirtualListWithKeyboard_menuContainer__3RXtt",
	"empty": "VirtualListWithKeyboard_empty__qv1G4"
};

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1640);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./MultiSelect.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./MultiSelect.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".MultiSelect_textContainer__1Hiv8{position:relative}.MultiSelect_iconContainer__2tDbT{position:absolute;right:0;top:0;cursor:pointer;margin:.5625rem}.MultiSelect_error__26LJz{font-Size:.75rem;line-Height:.75rem;color:#db4437;transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}.MultiSelect_label__2F3iK{line-height:22px;transition:all .45s cubic-bezier(.23,1,.32,1) 0ms;user-select:none;color:#2f93e0;font-size:.75rem;font-weight:400}", ""]);

// exports
exports.locals = {
	"textContainer": "MultiSelect_textContainer__1Hiv8",
	"iconContainer": "MultiSelect_iconContainer__2tDbT",
	"error": "MultiSelect_error__26LJz",
	"label": "MultiSelect_label__2F3iK"
};

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(71);
var index_1 = __webpack_require__(23);
var LookupResourceChip_1 = __webpack_require__(144);
var Chips_1 = __webpack_require__(23);
var EventCategoryTypedMultiSelect = MultiSelect_1.MultiSelect();
var LookupEventCategoryChip = LookupResourceChip_1.default();
var EventCategoryMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupEventCategoryChip, { lookupCollection: props.items, lookupId: r.Id, type: Chips_1.ChipIcon.EventCategory, chipRender: function (item) { return React.createElement(index_1.EventCategoryChip, { onRequestDelete: onRequestDelete, eventCategory: item }); } });
    };
    return React.createElement(EventCategoryTypedMultiSelect, __assign({ items: props.items, fieldName: "event categories", renderChip: chipRenderer }, props));
};
exports.default = EventCategoryMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\EventCategoryMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\EventCategoryMultiSelect.tsx"); } } })();

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(71);
var index_1 = __webpack_require__(23);
var LookupReferenceDataItemChip_1 = __webpack_require__(103);
var Chips_1 = __webpack_require__(23);
var EventGroupTypedMultiSelect = MultiSelect_1.MultiSelect();
var EventGroupMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_1.ChipIcon.EventGroup, chipRender: function (item) { return React.createElement(index_1.EventGroupChip, { onRequestDelete: onRequestDelete, eventGroup: item }); } });
    };
    return React.createElement(EventGroupTypedMultiSelect, __assign({ items: props.items, fieldName: "event groups", renderChip: chipRenderer }, props));
};
exports.default = EventGroupMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\EventGroupMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\EventGroupMultiSelect.tsx"); } } })();

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(71);
var index_1 = __webpack_require__(23);
var LookupResourceChip_1 = __webpack_require__(144);
var Chips_1 = __webpack_require__(23);
var DocumentTypeTypedMultiSelect = MultiSelect_1.MultiSelect();
var LookupDocumentTypeChip = LookupResourceChip_1.default();
var DocumentTypeMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupDocumentTypeChip, { lookupCollection: props.items, lookupId: r.Id, type: Chips_1.ChipIcon.DocumentType, chipRender: function (item) { return React.createElement(index_1.DocumentTypeChip, { onRequestDelete: onRequestDelete, documentType: item }); } });
    };
    return React.createElement(DocumentTypeTypedMultiSelect, __assign({ items: props.items, fieldName: "document types", renderChip: chipRenderer }, props));
};
exports.default = DocumentTypeMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\DocumentTypeMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\DocumentTypeMultiSelect.tsx"); } } })();

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(71);
var index_1 = __webpack_require__(23);
var LookupReferenceDataItemChip_1 = __webpack_require__(103);
var Chips_1 = __webpack_require__(23);
var ProjectGroupTypedMultiSelect = MultiSelect_1.MultiSelect();
var ProjectGroupMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_1.ChipIcon.ProjectGroup, chipRender: function (item) { return React.createElement(index_1.ProjectGroupChip, { onRequestDelete: onRequestDelete, projectGroup: item }); } });
    };
    return React.createElement(ProjectGroupTypedMultiSelect, __assign({ items: props.items, label: "Select project groups", renderChip: chipRenderer }, props));
};
exports.default = ProjectGroupMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\ProjectGroupMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\ProjectGroupMultiSelect.tsx"); } } })();

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(71);
var Chips_1 = __webpack_require__(23);
var LookupReferenceDataItemChip_1 = __webpack_require__(103);
var Chips_2 = __webpack_require__(23);
var MachineModelHealthStatusTypedMultiSelect = MultiSelect_1.MultiSelect();
var MachineModelHealthStatusMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.MachineModelHealthStatus, chipRender: function (item) { return React.createElement(Chips_1.MachineModelHealthStatusChip, { onRequestDelete: onRequestDelete, healthStatus: item }); } });
    };
    return React.createElement(MachineModelHealthStatusTypedMultiSelect, __assign({ items: props.items, fieldName: "health statuses", renderChip: chipRenderer }, props));
};
exports.default = MachineModelHealthStatusMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\MachineModelHealthStatusMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\MachineModelHealthStatusMultiSelect.tsx"); } } })();

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(71);
var Chips_1 = __webpack_require__(23);
var LookupReferenceDataItemChip_1 = __webpack_require__(103);
var Chips_2 = __webpack_require__(23);
var EndpointCommunicationStyleTypedMultiSelect = MultiSelect_1.MultiSelect();
var EndpointCommunicationStyleMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.CommunicationStyle, chipRender: function (item) { return React.createElement(Chips_1.EndpointCommunicationStyleChip, { onRequestDelete: onRequestDelete, commStyle: item }); } });
    };
    return React.createElement(EndpointCommunicationStyleTypedMultiSelect, __assign({ items: props.items, fieldName: "communication styles", renderChip: chipRenderer }, props));
};
exports.default = EndpointCommunicationStyleMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\EndpointCommunicationStyleMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\MultiSelect\\EndpointCommunicationStyleMultiSelect.tsx"); } } })();

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1648);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_paper__1M1Nb{margin-top:1.5rem}", ""]);

// exports
exports.locals = {
	"paper": "style_paper__1M1Nb"
};

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserProfileRoutes_1 = __webpack_require__(1650);
exports.default = UserProfileRoutes_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserProfileRoutes\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserProfileRoutes\\index.tsx"); } } })();

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var UserProfileLayout_1 = __webpack_require__(1651);
var UserApiKeys_1 = __webpack_require__(1656);
var UserProfile_1 = __webpack_require__(1678);
var UserRecentActivity_1 = __webpack_require__(1679);
var UserLogins_1 = __webpack_require__(1694);
var RenderWithLayout_1 = __webpack_require__(428);
var ReloadableRoute_1 = __webpack_require__(80);
var NotFound_1 = __webpack_require__(431);
var InternalRedirect_1 = __webpack_require__(40);
var routeLinks_1 = __webpack_require__(20);
var userProfile = RenderWithLayout_1.renderWithLayout(UserProfileLayout_1.default)(UserProfile_1.default);
var userRecentActivity = RenderWithLayout_1.renderWithLayout(UserProfileLayout_1.default)(UserRecentActivity_1.default);
var userApiKeys = RenderWithLayout_1.renderWithLayout(UserProfileLayout_1.default)(UserApiKeys_1.default);
var userLogins = RenderWithLayout_1.renderWithLayout(UserProfileLayout_1.default)(UserLogins_1.default);
var UserProfileRoutes = (function (_super) {
    __extends(UserProfileRoutes, _super);
    function UserProfileRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserProfileRoutes.prototype.render = function () {
        var match = this.props.match;
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.details, render: function (props) { return userProfile(props); } }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.activity, render: function (props) { return userRecentActivity(props); } }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.apiKeys, render: function (props) { return userApiKeys(props); } }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.logins, render: function (props) { return userLogins(props); } }),
            React.createElement(InternalRedirect_1.default, { from: routeLinks_1.default.currentUser.me, exact: true, to: routeLinks_1.default.currentUser.details }),
            React.createElement(NotFound_1.RedirectAs404, null)));
    };
    return UserProfileRoutes;
}(React.Component));
exports.UserProfileRoutes = UserProfileRoutes;
exports.default = UserProfileRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserProfileRoutes\\UserProfileRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserProfileRoutes\\UserProfileRoutes.tsx"); } } })();

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserProfileLayout_1 = __webpack_require__(1652);
exports.default = UserProfileLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserProfileLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserProfileLayout\\index.tsx"); } } })();

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var AreaTitle_1 = __webpack_require__(120);
var NavigationSidebarLayout_1 = __webpack_require__(727);
var Gravatar_1 = __webpack_require__(1655);
var resources_1 = __webpack_require__(26);
var clientInstance_1 = __webpack_require__(10);
var clientInstance_2 = __webpack_require__(10);
var routeLinks_1 = __webpack_require__(20);
var UserProfileLayout = (function (_super) {
    __extends(UserProfileLayout, _super);
    function UserProfileLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.state = ({
            user: null
        });
        return _this;
    }
    UserProfileLayout.prototype.currentUserId = function () {
        return clientInstance_1.session && clientInstance_1.session.currentUser ? clientInstance_1.session.currentUser.Id : null;
    };
    UserProfileLayout.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.currentUserId()) return [3 /*break*/, 2];
                        return [4 /*yield*/, clientInstance_2.repository.Users.get(this.currentUserId())];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        user = _a;
                        this.setState({ user: user });
                        return [2 /*return*/];
                }
            });
        });
    };
    UserProfileLayout.prototype.render = function () {
        var navLinks = [
            NavigationSidebarLayout_1.Navigation.navItem("My Profile", routeLinks_1.default.currentUser.details),
            NavigationSidebarLayout_1.Navigation.navItem("My Logins", routeLinks_1.default.currentUser.logins),
            NavigationSidebarLayout_1.Navigation.navItem("My API Keys", routeLinks_1.default.currentUser.apiKeys),
            NavigationSidebarLayout_1.Navigation.navItem("My Recent Activity", routeLinks_1.default.currentUser.activity, null, { permission: resources_1.Permission.EventView, wildcard: true }),
        ];
        return (React.createElement("main", { id: "maincontent" },
            React.createElement(AreaTitle_1.default, { link: routeLinks_1.default.currentUser.me, title: "My Profile" }),
            React.createElement(NavigationSidebarLayout_1.default, { image: this.state.user ? React.createElement(Gravatar_1.default, { user: this.state.user, size: 200 }) : React.createElement("div", null), navLinks: navLinks, content: this.props.children })));
    };
    return UserProfileLayout;
}(BaseComponent_1.default));
exports.UserProfileLayout = UserProfileLayout;
exports.default = UserProfileLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserProfileLayout\\UserProfileLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserProfileLayout\\UserProfileLayout.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1654);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__3NMdz{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__37riV{display:none!important}}@media (max-width:79.9rem){.style_hide-md__3MEWR{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2Epc5{display:none!important}}.style_sideMenu__3snR5{padding-left:1rem;width:15.6rem;flex:0 0 auto}.style_breakword__1oHZK{word-wrap:break-word;word-break:break-word}.style_name__2PBbU{line-height:1.5rem;padding-top:1.5rem;line-height:1.75rem}.style_name__2PBbU,.style_nameHorizontal__XTzy0{word-wrap:break-word;word-break:break-word;font-size:1.625rem;min-width:50%}.style_nameHorizontal__XTzy0{line-height:1.5rem}.style_description__2TiHz{word-wrap:break-word;word-break:break-word;padding-top:1.5rem}.style_preNav__3QsqB{padding:1rem 0}.style_links__3g04A{padding-top:1rem}.style_link__3iy9E{display:block;font-size:1rem;line-height:2.5;text-align:left;color:#333;text-decoration:none;padding-left:1rem}.style_link__3iy9E>:active,.style_link__3iy9E>:visited{color:#333}a.style_link__3iy9E:hover{color:#0a67b1;background:hsla(0,0%,60%,.08)}.style_selected__2qZfA{color:#2f93e0!important;font-weight:500}.style_stackedLayout__LzKWO{display:flex;flex-direction:column}.style_title__1XBCO{display:flex;flex-direction:row;margin:.5rem;align-items:center}.style_logo__29wa4{margin-left:.5rem;margin-right:.5rem}.style_horizontalLinks__1bSGP{height:2.5rem;margin:0;padding-bottom:1rem}.style_horizontalLinks__1bSGP ul{margin:0}.style_horizontalLinks__1bSGP ul li{display:inline-block}.style_horizontalLinks__1bSGP ul li a{display:block;font-size:1rem;line-height:2.5;text-align:left;color:#333;text-decoration:none;padding-left:1rem;padding-right:1rem}.style_horizontalLinks__1bSGP ul li a>:active,.style_horizontalLinks__1bSGP ul li a>:visited{color:#333}.style_horizontalLinks__1bSGP ul li a:hover{color:#0a67b1;background:hsla(0,0%,60%,.08)}.style_horizontalLinks__1bSGP ul li a em{font-size:1.0625rem;padding:0 .5rem}.style_sidebarLayout__1uGZT{display:flex;margin-top:1.5rem;margin-right:1rem}.style_sidebarLayoutContent__uTRUj{flex:1 1 auto;display:flex;justify-content:space-around;padding:.125rem;min-width:0}.style_nestedNavLinks__JgA1U{margin-left:1rem}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3NMdz",
	"hideSm": "style_hide-sm__3NMdz",
	"visible-sm": "style_visible-sm__37riV",
	"visibleSm": "style_visible-sm__37riV",
	"hide-md": "style_hide-md__3MEWR",
	"hideMd": "style_hide-md__3MEWR",
	"visible-md": "style_visible-md__2Epc5",
	"visibleMd": "style_visible-md__2Epc5",
	"sideMenu": "style_sideMenu__3snR5",
	"breakword": "style_breakword__1oHZK",
	"name": "style_name__2PBbU",
	"nameHorizontal": "style_nameHorizontal__XTzy0",
	"description": "style_description__2TiHz",
	"preNav": "style_preNav__3QsqB",
	"links": "style_links__3g04A",
	"link": "style_link__3iy9E",
	"selected": "style_selected__2qZfA",
	"stackedLayout": "style_stackedLayout__LzKWO",
	"title": "style_title__1XBCO",
	"logo": "style_logo__29wa4",
	"horizontalLinks": "style_horizontalLinks__1bSGP",
	"sidebarLayout": "style_sidebarLayout__1uGZT",
	"sidebarLayoutContent": "style_sidebarLayoutContent__uTRUj",
	"nestedNavLinks": "style_nestedNavLinks__JgA1U"
};

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Avatar_1 = __webpack_require__(439);
var ExternalLink_1 = __webpack_require__(91);
var Gravatar = function (props) {
    return React.createElement("div", null,
        React.createElement(Avatar_1.Avatar, { user: props.user, size: props.size }),
        React.createElement("div", null,
            "You can change your picture at ",
            React.createElement(ExternalLink_1.default, { href: "http://g.octopushq.com/Gravatar" }, "Gravatar.com")));
};
Gravatar.displayName = "Gravatar";
exports.default = Gravatar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Gravatar\\Gravatar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Gravatar\\Gravatar.tsx"); } } })();

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ExternalLink_1 = __webpack_require__(29);
var PaperLayout_1 = __webpack_require__(117);
var Section_1 = __webpack_require__(90);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var clientInstance_2 = __webpack_require__(10);
var UserApiKeysList_1 = __webpack_require__(789);
var UserApiKeys = (function (_super) {
    __extends(UserApiKeys, _super);
    function UserApiKeys(props) {
        var _this = _super.call(this, props) || this;
        _this.state = ({
            user: null
        });
        return _this;
    }
    UserApiKeys.prototype.currentUserId = function () {
        return clientInstance_2.session && clientInstance_2.session.currentUser ? clientInstance_2.session.currentUser.Id : null;
    };
    UserApiKeys.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var user, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!this.currentUserId()) return [3 /*break*/, 2];
                                        return [4 /*yield*/, clientInstance_1.repository.Users.get(this.currentUserId())];
                                    case 1:
                                        _a = _b.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = null;
                                        _b.label = 3;
                                    case 3:
                                        user = _a;
                                        this.setState({
                                            user: user
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserApiKeys.prototype.render = function () {
        return React.createElement(PaperLayout_1.default, { title: "My API Keys", busy: this.state.busy, errors: this.state.errors },
            React.createElement(Section_1.Section, null,
                "You can use an API key to connect ",
                React.createElement(ExternalLink_1.default, { href: "http://g.octopushq.com/ExternalToolOctoTools" }, "automated tools"),
                " to Octopus, in place of a username and password. API keys are useful because they avoid the need to record your personal password in configuration files and scripts. A unique API key can be created for each use, and then individually revoked when no longer needed."),
            this.state.user && React.createElement(UserApiKeysList_1.default, { user: this.state.user }));
    };
    return UserApiKeys;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = UserApiKeys;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserApiKeys\\UserApiKeys.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserApiKeys\\UserApiKeys.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1658);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__12oKq{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2Rcor{display:none!important}}@media (max-width:79.9rem){.style_hide-md__361fe{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2Sczv{display:none!important}}h1{font-size:1.625rem;font-weight:400}@media (max-width:37.4rem){h1{font-size:1.4375rem}}h2{font-size:1.25rem;font-weight:400}@media (max-width:37.4rem){h2{font-size:1.0625rem}}h3{font-size:1.125rem;font-weight:400}@media (max-width:37.4rem){h3{font-size:1.0625rem}}h4{font-size:1.0625rem;font-weight:500;margin:1rem 0 .5rem}h5{font-size:.8125rem;font-weight:400}hr{display:block;height:.0625rem;border:0;border-top:.0625rem solid #ccc;margin:1em 0;padding:0}a{color:#2f93e0}a:hover{color:#0a67b1}p{margin:1rem 0;color:#333}input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #fff inset!important}input::-ms-clear{width:0;height:0}small{font-size:.875rem;line-height:1.1875rem}.style_secondary__OlUSy{color:#9e9e9e}.style_section__2Jp-W{flex-grow:1}.style_sectionHeader__1WJUP{padding:0 1rem;margin:1rem 0 .5rem}.style_sectionBody__2cABV{padding:0 1rem;color:#666;font-size:.875rem}.style_sectionBody__2cABV p{color:#333}.style_sectionNoHeader__2GCHR{margin:1rem 0 .5rem;width:100%}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__12oKq",
	"hideSm": "style_hide-sm__12oKq",
	"visible-sm": "style_visible-sm__2Rcor",
	"visibleSm": "style_visible-sm__2Rcor",
	"hide-md": "style_hide-md__361fe",
	"hideMd": "style_hide-md__361fe",
	"visible-md": "style_visible-md__2Sczv",
	"visibleMd": "style_visible-md__2Sczv",
	"secondary": "style_secondary__OlUSy",
	"section": "style_section__2Jp-W",
	"sectionHeader": "style_sectionHeader__1WJUP",
	"sectionBody": "style_sectionBody__2cABV",
	"sectionNoHeader": "style_sectionNoHeader__2GCHR"
};

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1660);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_emptyList__1cZJE{padding:1.25rem}.style_actionsMenu__3x1Ih{display:flex;justify-content:flex-end;flex-wrap:wrap}", ""]);

// exports
exports.locals = {
	"emptyList": "style_emptyList__1cZJE",
	"actionsMenu": "style_actionsMenu__3x1Ih"
};

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Text_1 = __webpack_require__(17);
var OkDialogLayout_1 = __webpack_require__(107);
var Section_1 = __webpack_require__(90);
var DataBaseComponent_1 = __webpack_require__(39);
var CopyToClipboardButton_1 = __webpack_require__(1662);
var styles = __webpack_require__(671);
var AddApiKeyDialog = (function (_super) {
    __extends(AddApiKeyDialog, _super);
    function AddApiKeyDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.saveAndShowKey = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.props.apiKey) {
                            this.props.onClose();
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, this.props.onAdd(this.state.purpose)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, false];
                }
            });
        }); };
        _this.state = {};
        return _this;
    }
    AddApiKeyDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { onOkClick: function () { return _this.saveAndShowKey(); }, busy: this.state.busy, errors: this.state.errors, hideCancel: !!this.props.apiKey, title: "Generate New API Key", okButtonLabel: this.props.apiKey ? "Close" : "Generate New" }, this.props.apiKey ? this.renderResult() : this.renderSetupApiKey());
    };
    AddApiKeyDialog.prototype.renderResult = function () {
        return React.createElement("div", null,
            React.createElement(Section_1.Section, null, "Your new API key is:"),
            React.createElement(Section_1.Section, null,
                React.createElement("strong", null, this.props.apiKey),
                React.createElement(CopyToClipboardButton_1.default, { value: this.props.apiKey })),
            React.createElement(Section_1.Section, null, "API keys cannot be retrieved once they are created. Make sure you save this key in a safe place like a password management tool."));
    };
    AddApiKeyDialog.prototype.renderSetupApiKey = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(Section_1.Section, null, "API keys can be used to authenticate with the Octopus Deploy REST API in place of a username and password. Using API keys lets you keep your username and password secret, but the API key itself is still sensitive information that needs to be protected."),
            React.createElement(Section_1.Section, null,
                React.createElement(Text_1.default, { value: this.state.purpose, onChange: function (purpose) { return _this.setState({ purpose: purpose }); }, autoFocus: true, label: "Purpose" })),
            React.createElement(Section_1.Section, null, "Record the purpose of this key so that you can revoke it when no longer required."));
    };
    return AddApiKeyDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = AddApiKeyDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserApiKeys\\AddApiKeyDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserApiKeys\\AddApiKeyDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var CopyToClipboardButton_1 = __webpack_require__(429);
__export(__webpack_require__(429));
exports.default = CopyToClipboardButton_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\CopyToClipboardButton\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\CopyToClipboardButton\\index.ts"); } } })();

/***/ }),
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_apiKeyEntry__Jm2KX{margin-top:0}", ""]);

// exports
exports.locals = {
	"apiKeyEntry": "style_apiKeyEntry__Jm2KX"
};

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NothingToSeeHere_1 = __webpack_require__(756);
exports.NothingToSeeHere = NothingToSeeHere_1.NothingToSeeHere;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\NothingToSeeHere\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\NothingToSeeHere\\index.ts"); } } })();

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1675);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1i21H{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__1v0p6{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2FSnb{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2-vLO{display:none!important}}.style_content__3lySZ{color:#9e9e9e}@media (max-width:37.4rem){.style_content__3lySZ{padding-left:1rem}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1i21H",
	"hideSm": "style_hide-sm__1i21H",
	"visible-sm": "style_visible-sm__1v0p6",
	"visibleSm": "style_visible-sm__1v0p6",
	"hide-md": "style_hide-md__2FSnb",
	"hideMd": "style_hide-md__2FSnb",
	"visible-md": "style_visible-md__2-vLO",
	"visibleMd": "style_visible-md__2-vLO",
	"content": "style_content__3lySZ"
};

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1677);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_when__1lHKf abbr[title]{text-decoration:none;cursor:help;border-bottom:.05rem dotted #777}", ""]);

// exports
exports.locals = {
	"when": "style_when__1lHKf"
};

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var FormPaperLayout_1 = __webpack_require__(168);
var clientInstance_2 = __webpack_require__(10);
var OpenDialogButton_1 = __webpack_require__(74);
var FormBaseComponent_1 = __webpack_require__(137);
var UserChangePasswordDialog_1 = __webpack_require__(791);
var form_1 = __webpack_require__(15);
var UserProfile = (function (_super) {
    __extends(UserProfile, _super);
    function UserProfile(props) {
        var _this = _super.call(this, props) || this;
        _this.tenantId = null;
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var userDisplaNameChanged, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userDisplaNameChanged = this.state.cleanModel.displayName !== this.state.model.displayName;
                        user = __assign({}, this.state.user, { DisplayName: this.state.model.displayName, EmailAddress: this.state.model.emailAddress, Username: this.state.model.username });
                        return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, clientInstance_1.repository.Users.save(user)];
                                        case 1:
                                            result = _a.sent();
                                            this.setState({
                                                cleanModel: this.buildModel(user),
                                                model: this.buildModel(user)
                                            });
                                            if (userDisplaNameChanged) {
                                                // we did this in old portal, and we do it for the feature toggles
                                                window.location.reload();
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            user: null,
            model: null,
            cleanModel: null,
        };
        return _this;
    }
    UserProfile.prototype.buildModel = function (user) {
        return user
            ? {
                displayName: user.DisplayName,
                username: user.Username,
                emailAddress: user.EmailAddress,
            }
            : {
                displayName: "",
                username: "",
                emailAddress: "",
            };
    };
    UserProfile.prototype.currentUserId = function () {
        return clientInstance_2.session && clientInstance_2.session.currentUser ? clientInstance_2.session.currentUser.Id : null;
    };
    UserProfile.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var user, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!this.currentUserId()) return [3 /*break*/, 2];
                                        return [4 /*yield*/, clientInstance_1.repository.Users.get(this.currentUserId())];
                                    case 1:
                                        _a = _b.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = null;
                                        _b.label = 3;
                                    case 3:
                                        user = _a;
                                        this.setState({
                                            user: user,
                                            model: this.buildModel(user),
                                            cleanModel: this.buildModel(user),
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserProfile.prototype.render = function () {
        var _this = this;
        return React.createElement(FormPaperLayout_1.default, { title: "My Profile", busy: this.state.busy, errors: this.state.errors, model: this.state.model, cleanModel: this.state.cleanModel, onSaveClick: this.handleSaveClick, secondaryAction: this.changePassword() }, this.state.model && React.createElement("div", null,
            React.createElement(form_1.ExpandableFormSection, { errorKey: "displayName", title: "Display Name", focusOnExpandAll: true, summary: form_1.Summary.summary(this.state.model.displayName ? this.state.model.displayName : "No display name specified yet."), help: "Your name. This does not need to be unique." },
                React.createElement(form_1.Text, { value: this.state.model.displayName, onChange: function (displayName) { return _this.setModelState({ displayName: displayName }); }, label: "Display name", autoFocus: true })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "emailAddress", title: "Email Address", summary: form_1.Summary.summary(this.state.model.emailAddress ? this.state.model.emailAddress : "Your email is not specified yet."), help: this.state.model.emailAddress ? "Your email address." : "Enter an email address." },
                React.createElement(form_1.Text, { value: this.state.model.emailAddress, onChange: function (emailAddress) { return _this.setModelState({ emailAddress: emailAddress }); }, label: "Email address" }))));
    };
    UserProfile.prototype.changePassword = function () {
        return this.state.model &&
            React.createElement(OpenDialogButton_1.default, { label: "Change Password" },
                React.createElement(UserChangePasswordDialog_1.default, { userId: this.currentUserId() }));
    };
    return UserProfile;
}(FormBaseComponent_1.default));
exports.default = UserProfile;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserProfile\\UserProfile.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserProfile\\UserProfile.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PaperLayout_1 = __webpack_require__(117);
var Section_1 = __webpack_require__(90);
var EventListing_1 = __webpack_require__(768);
var DataBaseComponent_1 = __webpack_require__(39);
var PermissionCheck_1 = __webpack_require__(45);
var clientInstance_1 = __webpack_require__(10);
var clientInstance_2 = __webpack_require__(10);
var permission_1 = __webpack_require__(49);
var Callout_1 = __webpack_require__(59);
var UserRecentActivity = (function (_super) {
    __extends(UserRecentActivity, _super);
    function UserRecentActivity(props) {
        var _this = _super.call(this, props) || this;
        _this.state = ({
            events: null,
        });
        return _this;
    }
    UserRecentActivity.prototype.currentUserId = function () {
        return clientInstance_2.session && clientInstance_2.session.currentUser ? clientInstance_2.session.currentUser.Id : null;
    };
    UserRecentActivity.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var events;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.Events.list({ users: [this.props.userId || this.currentUserId()] })];
                                    case 1:
                                        events = _a.sent();
                                        this.setState({
                                            events: events
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserRecentActivity.prototype.render = function () {
        return React.createElement(PaperLayout_1.default, { title: "My Recent Activity", busy: this.state.busy, errors: this.state.errors },
            React.createElement(PermissionCheck_1.default, { permission: permission_1.Permission.EventView, wildcard: true, alternate: React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                    "The ",
                    permission_1.Permission.EventView,
                    " permission is required to view recent activity") },
                React.createElement(Section_1.Section, null, this.state.events && React.createElement(EventListing_1.default, { data: this.state.events, regarding: [this.props.userId], noDataMessage: "There's no activity to show" }))));
    };
    return UserRecentActivity;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = UserRecentActivity;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserRecentActivity\\UserRecentActivity.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserRecentActivity\\UserRecentActivity.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__3DfJC{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2tYxV{display:none!important}}@media (max-width:79.9rem){.style_hide-md__3z8Vd{display:none!important}}@media (min-width:79.9rem){.style_visible-md__3p5Xu{display:none!important}}.style_dataTable__whkhc{border-collapse:collapse;background-color:#fff;width:100%;font-size:.875rem;line-height:1rem}.style_dataTableHeader__2-Fqn .style_dataTableRow__1qs4i{border-top:none}.style_dataTableHeader__2-Fqn .style_dataTableRow__1qs4i:focus,.style_dataTableHeader__2-Fqn .style_dataTableRow__1qs4i:hover{background-color:transparent}.style_dataTableHeaderColumn__2MIVp{color:#9e9e9e;padding:0 1.125rem .75rem;line-height:1rem;font-weight:400;padding-bottom:1rem;padding-top:1rem;box-sizing:border-box;text-align:left}.style_dataTableRowHeaderColumn__3t3gr{vertical-align:top;padding-top:.875rem;text-align:right;width:16rem}.style_dataTableRowHeaderColumnInSidebar__1XNmt{width:8rem!important}.style_dataTableFooterColumn__1l7bp{color:#9e9e9e;padding:0;line-height:1rem;font-weight:400;padding-bottom:1rem;text-align:left;box-sizing:border-box}.style_dataTableRow__1qs4i{border-top:.0625rem solid #ccc}.style_dataTableRow__1qs4i:last-child{border-bottom:.0625rem solid #ccc}.style_dataTableRow__1qs4i:focus,.style_dataTableRow__1qs4i:hover{background-color:hsla(0,0%,60%,.08)}.style_dataTableRow__1qs4i.style_noBorder__vK-uc{border:none}.style_dataTableRow__1qs4i.style_noBorder__vK-uc:focus,.style_dataTableRow__1qs4i.style_noBorder__vK-uc:hover{background-color:transparent}.style_dataTableRowColumn__3K1eH{box-sizing:border-box;color:#333;vertical-align:top;padding:.875rem 1.125rem}.style_dataTableRowColumn__3K1eH:first-child{font-weight:500}.style_dataTableRowColumn__3K1eH a{text-align:left;color:#2f93e0}@media (max-width:37.4rem){.style_dataTable__whkhc,.style_dataTableBody__2iZtk,.style_dataTableFooterColumn__1l7bp,.style_dataTableHeader__2-Fqn,.style_dataTableHeaderColumn__2MIVp,.style_dataTableRow__1qs4i,.style_dataTableRowColumn__3K1eH{display:block}.style_dataTable__whkhc{border:none}.style_dataTableHeader__2-Fqn .style_dataTableRow__1qs4i:not(.style_dataTableToolsRow__DQOfG){position:absolute;top:-9999px;left:-9999px}.style_dataTableRowColumn__3K1eH{border:none;position:relative;line-height:1.5rem;padding-top:.5rem;padding-bottom:0;max-width:100%}.style_dataTableRowHeaderColumn__3t3gr{padding:.875rem 1.125rem;text-align:left;width:unset}.style_dataTableRowHeaderColumnInSidebar__1XNmt{width:unset}.style_dataTableRowColumn__3K1eH:first-child,.style_dataTableRowColumn__3K1eH:not(:first-child){width:100%}.style_dataTableRowColumn__3K1eH:not(:first-child){padding-top:0}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3DfJC",
	"hideSm": "style_hide-sm__3DfJC",
	"visible-sm": "style_visible-sm__2tYxV",
	"visibleSm": "style_visible-sm__2tYxV",
	"hide-md": "style_hide-md__3z8Vd",
	"hideMd": "style_hide-md__3z8Vd",
	"visible-md": "style_visible-md__3p5Xu",
	"visibleMd": "style_visible-md__3p5Xu",
	"dataTable": "style_dataTable__whkhc",
	"dataTableHeader": "style_dataTableHeader__2-Fqn",
	"dataTableRow": "style_dataTableRow__1qs4i",
	"dataTableHeaderColumn": "style_dataTableHeaderColumn__2MIVp",
	"dataTableRowHeaderColumn": "style_dataTableRowHeaderColumn__3t3gr",
	"dataTableRowHeaderColumnInSidebar": "style_dataTableRowHeaderColumnInSidebar__1XNmt",
	"dataTableFooterColumn": "style_dataTableFooterColumn__1l7bp",
	"noBorder": "style_noBorder__vK-uc",
	"dataTableRowColumn": "style_dataTableRowColumn__3K1eH",
	"dataTableBody": "style_dataTableBody__2iZtk",
	"dataTableToolsRow": "style_dataTableToolsRow__DQOfG"
};

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(89);
var DataTableToolsRow = (function (_super) {
    __extends(DataTableToolsRow, _super);
    function DataTableToolsRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableToolsRow.prototype.render = function () {
        return (React.createElement("tr", { className: cn(this.props.className, styles.dataTableToolsRow) }, this.props.children));
    };
    return DataTableToolsRow;
}(React.Component));
exports.DataTableToolsRow = DataTableToolsRow;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableToolsRow.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableToolsRow.tsx"); } } })();

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(89);
var DataTableFooter = (function (_super) {
    __extends(DataTableFooter, _super);
    function DataTableFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableFooter.prototype.render = function () {
        return (React.createElement("tfoot", { className: cn(this.props.className, styles.dataTableFooter) }, this.props.children));
    };
    return DataTableFooter;
}(React.Component));
exports.DataTableFooter = DataTableFooter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableFooter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableFooter.tsx"); } } })();

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(89);
var DataTableFooterColumn = (function (_super) {
    __extends(DataTableFooterColumn, _super);
    function DataTableFooterColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableFooterColumn.prototype.render = function () {
        var _a = this.props, className = _a.className, otherProps = __rest(_a, ["className"]);
        return (React.createElement("td", __assign({ className: cn(className, styles.dataTableFooterColumn) }, otherProps), this.props.children));
    };
    return DataTableFooterColumn;
}(React.Component));
exports.DataTableFooterColumn = DataTableFooterColumn;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableFooterColumn.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableFooterColumn.tsx"); } } })();

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(89);
var DataTableFooterRow = (function (_super) {
    __extends(DataTableFooterRow, _super);
    function DataTableFooterRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableFooterRow.prototype.render = function () {
        return (React.createElement("tr", { className: cn(this.props.className, styles.dataTableFooterRow) }, this.props.children));
    };
    return DataTableFooterRow;
}(React.Component));
exports.DataTableFooterRow = DataTableFooterRow;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableFooterRow.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\DataTable\\DataTableFooterRow.tsx"); } } })();

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1686);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_listItem__20dF_{padding:1.25rem;font-size:.875rem!important}.style_emptyList__Jfq7l{padding:1.25rem}.style_loadMore__1k4D4{text-align:center}.style_pagingControlContainer__uFwzY{margin:1.5rem 1rem}.style_disablePagingEvents__NzHoU{pointer-events:none}", ""]);

// exports
exports.locals = {
	"listItem": "style_listItem__20dF_",
	"emptyList": "style_emptyList__Jfq7l",
	"loadMore": "style_loadMore__1k4D4",
	"pagingControlContainer": "style_pagingControlContainer__uFwzY",
	"disablePagingEvents": "style_disablePagingEvents__NzHoU"
};

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_listItem__2xFzu{padding:1.25rem;word-wrap:break-word;font-size:.875rem!important}.style_listItem__2xFzu:hover{background-color:hsla(0,0%,60%,.08)!important}.style_emptyList__3wyfm{padding:1.25rem;font-size:.875rem;color:#9e9e9e}.style_loadMore__1aFgx{text-align:center}.style_pagingControlContainer__HVBB1{margin:1.5rem 1rem}.style_disablePagingEvents__1U2Kg{pointer-events:none}", ""]);

// exports
exports.locals = {
	"listItem": "style_listItem__2xFzu",
	"emptyList": "style_emptyList__3wyfm",
	"loadMore": "style_loadMore__1aFgx",
	"pagingControlContainer": "style_pagingControlContainer__HVBB1",
	"disablePagingEvents": "style_disablePagingEvents__1U2Kg"
};

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1689);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_linkableItem__4eNnA{cursor:pointer}", ""]);

// exports
exports.locals = {
	"linkableItem": "style_linkableItem__4eNnA"
};

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1691);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_preWrapped__2WHzi{padding:6.5pt;margin:0 0 7pt;font-size:9pt;word-break:break-all;word-wrap:break-word;background-color:hsla(0,0%,60%,.08);border:.0625rem solid #ccc;border-radius:.125rem}", ""]);

// exports
exports.locals = {
	"preWrapped": "style_preWrapped__2WHzi"
};

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1693);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_headerColumnFixedWidth__2y2mZ{width:9.375rem}.style_headerColumnOccurredDate__11k3c{width:9.375rem;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"headerColumnFixedWidth": "style_headerColumnFixedWidth__2y2mZ",
	"headerColumnOccurredDate": "style_headerColumnOccurredDate__11k3c"
};

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var FormBaseComponent_1 = __webpack_require__(137);
var clientInstance_1 = __webpack_require__(10);
var FormPaperLayout_1 = __webpack_require__(419);
var Section_1 = __webpack_require__(90);
var ProviderGroups_1 = __webpack_require__(793);
var UserLogins = (function (_super) {
    __extends(UserLogins, _super);
    function UserLogins(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = __assign({}, this.state.user, { Identities: this.state.model.identities });
                        return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, clientInstance_1.repository.Users.save(user)];
                                        case 1:
                                            result = _a.sent();
                                            this.setState({
                                                cleanModel: this.buildModel(user),
                                                model: this.buildModel(user)
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            user: null,
            model: null,
            cleanModel: null,
            canCurrentUserEditIdentitiesForUser: true,
            enabledAuthenticationProviders: null,
            enabledProvidersMetadata: null
        };
        return _this;
    }
    UserLogins.prototype.currentUserId = function () {
        return clientInstance_1.session && clientInstance_1.session.currentUser ? clientInstance_1.session.currentUser.Id : null;
    };
    UserLogins.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var user, _a, configDoc, metadataDoc;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!this.currentUserId()) return [3 /*break*/, 2];
                                        return [4 /*yield*/, clientInstance_1.repository.Users.get(this.currentUserId())];
                                    case 1:
                                        _a = _b.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = null;
                                        _b.label = 3;
                                    case 3:
                                        user = _a;
                                        return [4 /*yield*/, clientInstance_1.repository.UserIdentityMetadata.authenticationConfiguration(user.Id)];
                                    case 4:
                                        configDoc = _b.sent();
                                        return [4 /*yield*/, clientInstance_1.repository.UserIdentityMetadata.all()];
                                    case 5:
                                        metadataDoc = _b.sent();
                                        this.setState({
                                            user: user,
                                            model: this.buildModel(user),
                                            cleanModel: this.buildModel(user),
                                            enabledAuthenticationProviders: configDoc.AuthenticationProviders || [],
                                            canCurrentUserEditIdentitiesForUser: configDoc.CanCurrentUserEditIdentitiesForUser,
                                            enabledProvidersMetadata: metadataDoc.Providers
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserLogins.prototype.handleAddIdentity = function (identity) {
        this.setState(function (state) { return ({
            model: __assign({}, state.model, { identities: [identity].concat(state.model.identities) })
        }); });
        return true;
    };
    UserLogins.prototype.render = function () {
        var _this = this;
        return React.createElement(FormPaperLayout_1.default, { title: "My Logins", busy: this.state.busy, errors: this.state.errors, model: this.state.model, cleanModel: this.state.cleanModel, onSaveClick: this.handleSaveClick }, this.state.model && this.state.enabledAuthenticationProviders.length > 0
            ? React.createElement(ProviderGroups_1.ProviderGroups, { userIdentities: this.state.model.identities, enabledAuthenticationProviders: this.state.enabledAuthenticationProviders, canCurrentUserEditIdentitiesForUser: this.state.canCurrentUserEditIdentitiesForUser, enabledProvidersMetadata: this.state.enabledProvidersMetadata, isServiceAccount: this.state.user.IsService, onChange: function (identities) { return _this.setModelState({ identities: identities }); } })
            : this.state.enabledAuthenticationProviders &&
                React.createElement(Section_1.Section, null, "There are no providers that support external identities enabled."));
    };
    UserLogins.prototype.buildModel = function (user) {
        return user
            ? {
                original: user,
                identities: user.Identities
            }
            : {
                original: null,
                identities: []
            };
    };
    return UserLogins;
}(FormBaseComponent_1.default));
exports.default = UserLogins;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserLogins\\UserLogins.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\users\\UserLogins\\UserLogins.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IdentityType;
(function (IdentityType) {
    IdentityType[IdentityType["Guest"] = 0] = "Guest";
    IdentityType[IdentityType["UsernamePassword"] = 1] = "UsernamePassword";
    IdentityType[IdentityType["ActiveDirectory"] = 2] = "ActiveDirectory";
    IdentityType[IdentityType["OAuth"] = 3] = "OAuth";
})(IdentityType || (IdentityType = {}));
exports.default = IdentityType;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\identityType.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\client\\resources\\identityType.ts"); } } })();

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RemoveItemsList_1 = __webpack_require__(142);
var DataBaseComponent_1 = __webpack_require__(39);
var OpenDialogButton_1 = __webpack_require__(74);
var AddIdentityDialog_1 = __webpack_require__(1697);
var index_1 = __webpack_require__(68);
var form_1 = __webpack_require__(15);
var ListTitle_1 = __webpack_require__(276);
var IdentityList = (function (_super) {
    __extends(IdentityList, _super);
    function IdentityList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IdentityList;
}(RemoveItemsList_1.RemoveItemsList));
var ProviderIdentities = (function (_super) {
    __extends(ProviderIdentities, _super);
    function ProviderIdentities(props) {
        var _this = _super.call(this, props) || this;
        _this.providerIdentitiesSummary = function () {
            var qty = _this.props.provider.identities.length;
            var msg = qty > 0
                ? _this.identityClaims()
                : "No logins are associated";
            return form_1.Summary.placeholder("" + msg);
        };
        _this.identityClaims = function () {
            var claims = _this.props.provider.identities[0].Claims;
            var claimKey = Object.keys(claims).filter(function (key) { return claims[key].IsIdentifyingClaim; })[0];
            return _this.claimLabel(claimKey, _this.props.provider.providerDetails) + ": " + claims[claimKey].Value;
        };
        _this.renderIdentityDetails = function (provider, identity) {
            var claims = identity.Claims;
            var keys = Object.keys(claims);
            return React.createElement("div", null,
                " ",
                Object.keys(claims).map(function (key, i) { return React.createElement("div", { key: i },
                    " ",
                    claims[key].Value &&
                        React.createElement(index_1.default, { content: _this.claimDescription(key, provider) }, claims[key].IsIdentifyingClaim
                            ? React.createElement(ListTitle_1.default, null,
                                _this.claimLabel(key, provider),
                                ": ",
                                claims[key].Value)
                            : React.createElement("div", null,
                                _this.claimLabel(key, provider),
                                ": ",
                                claims[key].Value))); }));
        };
        _this.addIdentity = function (identity) {
            _this.props.onChange(__assign({}, _this.props.provider, { identities: [identity].concat(_this.props.provider.identities) }));
            return true;
        };
        _this.removeIdentity = function (identity) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.onChange(__assign({}, this.props.provider, { identities: this.props.provider.identities.filter(function (i) { return i !== identity; }).slice() }));
                return [2 /*return*/, true];
            });
        }); };
        return _this;
    }
    ProviderIdentities.prototype.render = function () {
        var _this = this;
        var addAction = React.createElement(OpenDialogButton_1.default, { key: "addIdentity-" + this.props.provider.providerName, label: "Add Login" },
            React.createElement(AddIdentityDialog_1.AddIdentityDialog, { selectedProvider: this.props.provider.providerDetails, key: "addEmail-" + this.props.provider.providerName, onAddIdentity: this.addIdentity }));
        return React.createElement(form_1.ExpandableFormSection, { errorKey: this.props.provider.providerName, title: this.props.provider.providerName, summary: this.providerIdentitiesSummary(), help: "A set of accounts for " + this.props.provider.providerName + "." },
            React.createElement("div", null,
                React.createElement(IdentityList, { data: this.props.provider.identities, listActions: this.props.enabledToSupportAdding &&
                        this.props.canCurrentUserEditIdentitiesForUser &&
                        this.props.provider.identities.length === 0 ? [addAction] : [], onRow: function (identity, i) { return React.createElement("div", { key: _this.props.provider + "-" + i }, _this.renderIdentityDetails(_this.props.provider.providerDetails, identity)); }, onRemoveRow: this.props.canCurrentUserEditIdentitiesForUser ? function (identity) { return _this.removeIdentity(identity); } : null })));
    };
    ProviderIdentities.prototype.claimLabel = function (key, provider) {
        return this.findProviderByKey(key, provider).Label;
    };
    ProviderIdentities.prototype.claimDescription = function (key, provider) {
        return this.findProviderByKey(key, provider).Description;
    };
    ProviderIdentities.prototype.findProviderByKey = function (key, provider) {
        return provider.ClaimDescriptors.find(function (d) { return d.Type === key; });
    };
    return ProviderIdentities;
}(DataBaseComponent_1.DataBaseComponent));
exports.ProviderIdentities = ProviderIdentities;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\configuration\\components\\Users\\ProviderIdentities.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\configuration\\components\\Users\\ProviderIdentities.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var lodash_1 = __webpack_require__(16);
var OkDialogLayout_1 = __webpack_require__(107);
var Callout_1 = __webpack_require__(59);
var ListTitle_1 = __webpack_require__(276);
var List_1 = __webpack_require__(716);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var IdHelper_1 = __webpack_require__(769);
var Button_1 = __webpack_require__(51);
var form_1 = __webpack_require__(15);
var Validators_1 = __webpack_require__(170);
var styles = __webpack_require__(1701);
var IdentityResults = (function (_super) {
    __extends(IdentityResults, _super);
    function IdentityResults() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IdentityResults;
}(List_1.SimpleList));
var AddIdentityDialog = (function (_super) {
    __extends(AddIdentityDialog, _super);
    function AddIdentityDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.addIdentity = function () {
            if (_this.state.selectedSearchResultKey) {
                var identityToAdd = _this.state.searchResults
                    .find(function (i) { return i.Id === _this.state.selectedSearchResultKey; });
                if (identityToAdd) {
                    return _this.props.onAddIdentity(identityToAdd);
                }
            }
            return _this.props.onAddIdentity(_this.state.identity);
        };
        _this.setClaim = function (key, value) {
            _this.setState(function (state) {
                var Claims = __assign({}, state.identity.Claims, (_a = {}, _a[key] = __assign({}, state.identity.Claims[key], { Value: value }), _a));
                return { identity: __assign({}, state.identity, { Claims: Claims }) };
                var _a;
            });
        };
        _this.buildSearchResultRow = function (identity) {
            var claims = identity.Claims;
            var entries = Object.keys(claims).map(function (key, i) {
                var keyAndValue = _this.claimLabel(key) + ": " + claims[key].Value;
                return claims[key].Value &&
                    React.createElement("div", { key: i, onClick: function () { return _this.setState({ selectedSearchResultKey: identity.Id }); } }, claims[key].IsIdentifyingClaim
                        ? React.createElement(ListTitle_1.default, null, keyAndValue)
                        : React.createElement("span", null, keyAndValue));
            });
            return React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.select },
                    React.createElement(RadioButtonGroup_1.default, { value: identity.Id === _this.state.selectedSearchResultKey, onChange: null },
                        React.createElement(RadioButton_1.default, { value: true }))),
                React.createElement("div", { className: styles.claimContent }, entries));
        };
        _this.state = {
            identity: _this.createIdentity(),
            supportsSearch: _this.supportsSearch(),
            searchResults: null //when it's an empty list we can show message showing no results
        };
        return _this;
    }
    AddIdentityDialog.prototype.render = function () {
        return React.createElement(OkDialogLayout_1.default, { onOkClick: this.addIdentity, okButtonDisabled: this.disableAddIdentity(), busy: this.state.busy, errors: this.state.errors, okButtonLabel: this.state.supportsSearch ? "Select" : "Add", title: "Add Login" },
            React.createElement("h4", null, "External Login Details"),
            this.state.identity
                ? (this.state.supportsSearch ? this.renderSearch() : this.renderControlsForClaim())
                : React.createElement("div", null, "There seems to be a problem with the properties on this identity provider"));
    };
    AddIdentityDialog.prototype.disableAddIdentity = function () {
        if (this.state.supportsSearch) {
            return !this.state.selectedSearchResultKey;
        }
        var claims = this.state.identity.Claims;
        var claimsValues = Object.keys(claims)
            .map(function (key, i) { return ({
            identifying: claims[key].IsIdentifyingClaim,
            value: claims[key].Value
        }); });
        return !claimsValues.some(function (c) { return c.identifying && !!c.value; });
    };
    AddIdentityDialog.prototype.renderControlsForClaim = function () {
        var _this = this;
        var claims = this.state.identity.Claims;
        return Object.keys(claims).map(function (key, i) { return React.createElement("div", { key: i },
            React.createElement(form_1.Text, { value: claims[key].Value, onChange: function (v) { return _this.setClaim(key, v); }, label: _this.claimLabel(key), validate: claims[key].IsIdentifyingClaim && Validators_1.required("Please enter " + _this.claimDescription(key)) })); });
    };
    AddIdentityDialog.prototype.renderSearch = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement("h4", null, "Search"),
            React.createElement("div", { className: styles.inlineSearch },
                React.createElement(form_1.Text, { value: this.state.query, onChange: function (query) { return _this.setState({ query: query }); }, label: "Search" }),
                React.createElement(Button_1.ActionButton, { onClick: function () { return _this.search(); }, label: "Search", busyLabel: "Searching...", disabled: this.state.busy })),
            this.state.searchResults !== null &&
                (this.state.searchResults.length === 0
                    ? React.createElement(Callout_1.default, { title: "No results were found", type: Callout_1.CalloutType.Information }, "Enter the start of a group name. For example, to find \"Domain Users\", type \"Domain\".")
                    : React.createElement(IdentityResults, { items: this.state.searchResults, onRow: this.buildSearchResultRow, onRowRedirectUrl: function () { return null; } })));
    };
    AddIdentityDialog.prototype.createIdentity = function () {
        if (!this.props.selectedProvider) {
            return null;
        }
        var identity = {
            // Id just to help in UI
            Id: IdHelper_1.default.newId(),
            // this structure to support saving
            IdentityProviderName: this.props.selectedProvider.IdentityProviderName,
            Claims: {}
        };
        this.props.selectedProvider.ClaimDescriptors.forEach(function (d) {
            return identity.Claims[d.Type] = {
                Value: "",
                IsIdentifyingClaim: d.IsIdentifyingClaim
            };
        });
        return identity;
    };
    AddIdentityDialog.prototype.supportsSearch = function () {
        return this.props.selectedProvider && this.props.selectedProvider.Links &&
            lodash_1.some(this.props.selectedProvider.Links, function (v, key) { return key === "UserSearch"; });
    };
    AddIdentityDialog.prototype.search = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var uri, partialName, result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!this.props.selectedProvider.Links) {
                                            this.setState({ searchResults: [] });
                                            return [2 /*return*/];
                                        }
                                        uri = lodash_1.find(this.props.selectedProvider.Links, function (v, key) { return key === "UserSearch"; });
                                        partialName = this.state.query;
                                        return [4 /*yield*/, clientInstance_1.repository.ExternalUsers.searchProvider(uri, partialName)];
                                    case 1:
                                        result = _a.sent();
                                        this.setState({
                                            // add some Ids to help with selecting it for return from this popup
                                            searchResults: result.Identities.map(function (x) { return (__assign({}, x, { Id: IdHelper_1.default.newId() })); }) || [],
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // if the claim object can just be built with these properties via createIdentity then they won't be needed
    AddIdentityDialog.prototype.claimLabel = function (key) {
        return this.findProviderByKey(key).Label;
    };
    AddIdentityDialog.prototype.claimDescription = function (key) {
        return this.findProviderByKey(key).Description;
    };
    AddIdentityDialog.prototype.findProviderByKey = function (key) {
        return this.props.selectedProvider && this.props.selectedProvider.ClaimDescriptors
            && this.props.selectedProvider.ClaimDescriptors.find(function (d) { return d.Type === key; });
    };
    return AddIdentityDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.AddIdentityDialog = AddIdentityDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\AddIdentityDialog\\AddIdentityDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\AddIdentityDialog\\AddIdentityDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1699);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_listTitle__2-j_A{font-size:1.063rem;line-height:1.18rem;color:#2f93e0;margin:.25rem 0;font-weight:500}", ""]);

// exports
exports.locals = {
	"listTitle": "style_listTitle__2-j_A"
};

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IdHelper = (function () {
    function IdHelper() {
    }
    IdHelper.newId = function () {
        return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }
    };
    return IdHelper;
}());
exports.default = IdHelper;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\IdHelper\\IdHelper.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\IdHelper\\IdHelper.tsx"); } } })();

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1702);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1ZVzG{display:flex;flex-direction:row;align-items:flex-start}.style_select__1cFb6{display:flex;justify-content:center;align-items:center}.style_inlineSearch__3IJgD{display:flex;flex-direction:row;align-items:baseline}.style_claimContent__gSpai{display:block}", ""]);

// exports
exports.locals = {
	"container": "style_container__1ZVzG",
	"select": "style_select__1cFb6",
	"inlineSearch": "style_inlineSearch__3IJgD",
	"claimContent": "style_claimContent__gSpai"
};

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "notfound.42f85dfb624a6cadc92b501d221a7e22.hashedasset.png";

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1705);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1wFpO{display:flex;align-items:center;margin:1rem;justify-content:center;flex-direction:column}", ""]);

// exports
exports.locals = {
	"container": "style_container__1wFpO"
};

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProjectGroupLayout_1 = __webpack_require__(1707);
exports.default = ProjectGroupLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectGroupLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectGroupLayout\\index.tsx"); } } })();

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var FormPaperLayout_1 = __webpack_require__(168);
var FormBaseComponent_1 = __webpack_require__(399);
var lodash_1 = __webpack_require__(16);
var Markdown_1 = __webpack_require__(136);
var form_1 = __webpack_require__(15);
var AreaTitle_1 = __webpack_require__(120);
var MarkdownEditor_1 = __webpack_require__(278);
var OverflowMenu_1 = __webpack_require__(209);
var permission_1 = __webpack_require__(49);
var StringHelper_1 = __webpack_require__(211);
var routeLinks_1 = __webpack_require__(20);
var InternalRedirect_1 = __webpack_require__(40);
var ProjectGroupLayout = (function (_super) {
    __extends(ProjectGroupLayout, _super);
    function ProjectGroupLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var isNew, result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        isNew = this.state.model.Id == null;
                                        return [4 /*yield*/, clientInstance_1.repository.ProjectGroups.save(this.state.model)];
                                    case 1:
                                        result = _a.sent();
                                        this.setState({
                                            model: result,
                                            cleanModel: lodash_1.cloneDeep(result),
                                            newId: isNew ? result.Id : null
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleDeleteConfirm = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.ProjectGroups.del(this.state.model)];
                    case 1:
                        result = _a.sent();
                        this.setState(function (state) {
                            return {
                                model: null,
                                cleanModel: null,
                                deleted: true
                            };
                        });
                        return [2 /*return*/, true];
                }
            });
        }); };
        _this.state = {
            deleted: false,
            newId: null
        };
        return _this;
    }
    ProjectGroupLayout.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var projectGroupPromise, projectGroup;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        projectGroupPromise = clientInstance_1.repository.ProjectGroups.get(this.props.match.params.ProjectGroupId);
                                        return [4 /*yield*/, projectGroupPromise];
                                    case 1:
                                        projectGroup = _a.sent();
                                        this.setState({
                                            model: projectGroup,
                                            cleanModel: lodash_1.cloneDeep(projectGroup)
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectGroupLayout.prototype.descriptionSummary = function () {
        return this.state.model.Description ?
            form_1.Summary.summary(React.createElement(Markdown_1.default, { markup: this.state.model.Description })) :
            form_1.Summary.placeholder("No project group description provided");
    };
    ProjectGroupLayout.prototype.render = function () {
        var _this = this;
        var title = this.props.create
            ? "Create project group"
            : this.state.model
                ? this.state.model.Name
                : StringHelper_1.default.ellipsis;
        var overFlowActions = [];
        if (!this.props.create) {
            overFlowActions.push(OverflowMenu_1.default.deleteItemDefault("project group", this.handleDeleteConfirm, { permission: permission_1.default.ProjectGroupDelete, projectGroup: "*" }));
        }
        var saveText = this.state.newId
            ? "Project group created"
            : "Project group details updated";
        return React.createElement("main", { id: "maincontent" },
            React.createElement(AreaTitle_1.default, { link: routeLinks_1.default.projects, title: "Projects" }),
            React.createElement(FormPaperLayout_1.default, { title: title, busy: this.state.busy, errors: this.state.errors, model: this.state.model, cleanModel: this.state.cleanModel, savePermission: { permission: this.props.create ? permission_1.default.ProjectGroupCreate : permission_1.default.ProjectGroupEdit, projectGroup: "*" }, onSaveClick: this.handleSaveClick, saveText: saveText, expandAllOnMount: this.props.create, overFlowActions: overFlowActions },
                this.state.deleted && React.createElement(InternalRedirect_1.default, { to: routeLinks_1.default.projects }),
                this.state.newId && React.createElement(InternalRedirect_1.default, { to: routeLinks_1.default.projectGroup(this.state.newId).root }),
                this.state.model && React.createElement("div", null,
                    React.createElement(form_1.ExpandableFormSection, { errorKey: "Name", title: "Name", summary: this.state.model.Name ? form_1.Summary.summary(this.state.model.Name) : form_1.Summary.placeholder("Please enter a name for your project group"), help: "A short, memorable, unique name for this project group." },
                        React.createElement(form_1.Text, { value: this.state.model.Name, onChange: function (Name) { return _this.setModelState({ Name: Name }); }, label: "Name", validate: form_1.required("Please enter a project group name"), autoFocus: true })),
                    React.createElement(form_1.ExpandableFormSection, { errorKey: "description", title: "Description", summary: this.descriptionSummary(), help: "Enter a description for your project group." },
                        React.createElement(MarkdownEditor_1.default, { value: this.state.model.Description, label: "Project group description", onChange: function (Description) { return _this.setModelState({ Description: Description }); } })))));
    };
    return ProjectGroupLayout;
}(FormBaseComponent_1.default));
exports.default = ProjectGroupLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectGroupLayout\\ProjectGroupLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ProjectGroupLayout\\ProjectGroupLayout.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var DeploymentToProjectTaskRedirect_1 = __webpack_require__(1709);
var ReloadableRoute_1 = __webpack_require__(80);
var DeploymentRoutes = (function (_super) {
    __extends(DeploymentRoutes, _super);
    function DeploymentRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeploymentRoutes.prototype.render = function () {
        var match = this.props.match;
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { path: match.url + "/:deploymentId", component: DeploymentToProjectTaskRedirect_1.default })));
    };
    return DeploymentRoutes;
}(React.Component));
exports.default = DeploymentRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\deployments\\DeploymentRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\deployments\\DeploymentRoutes.tsx"); } } })();

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var DataBaseComponent_1 = __webpack_require__(167);
var routeLinks_1 = __webpack_require__(20);
var PaperLayout_1 = __webpack_require__(169);
var index_1 = __webpack_require__(120);
var InternalRedirect_1 = __webpack_require__(40);
var DeploymentToProjectTaskRedirect = (function (_super) {
    __extends(DeploymentToProjectTaskRedirect, _super);
    function DeploymentToProjectTaskRedirect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            redirectTo: null
        };
        return _this;
    }
    DeploymentToProjectTaskRedirect.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var deploymentId, deployment, release, path;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deploymentId = this.props.match.params.deploymentId;
                        return [4 /*yield*/, clientInstance_1.repository.Deployments.get(deploymentId)];
                    case 1:
                        deployment = _a.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Releases.get(deployment.ReleaseId)];
                    case 2:
                        release = _a.sent();
                        path = routeLinks_1.default.project(release.ProjectId).release(release).deployments.specific(deployment);
                        this.setState({
                            redirectTo: path
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DeploymentToProjectTaskRedirect.prototype.render = function () {
        var redirectTo = this.state.redirectTo;
        if (!redirectTo) {
            return React.createElement("main", { id: "maincontent" },
                React.createElement(index_1.default, { link: routeLinks_1.default.projects, title: "Projects" }),
                React.createElement(PaperLayout_1.default, { busy: this.state.busy, fullWidth: true, errors: this.state.errors }));
        }
        return React.createElement(InternalRedirect_1.default, { push: false, to: { pathname: redirectTo } });
    };
    return DeploymentToProjectTaskRedirect;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = DeploymentToProjectTaskRedirect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\deployments\\DeploymentToProjectTaskRedirect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\deployments\\DeploymentToProjectTaskRedirect.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var routeLinks_1 = __webpack_require__(20);
var ReloadableRoute_1 = __webpack_require__(80);
var InternalRedirect_1 = __webpack_require__(40);
var EditEnvironment = function (props) {
    return React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.environment(props.match.params.environmentId), search: props.location.search } });
};
var EditProxy = function (props) {
    return React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.proxy(props.match.params.proxyId), search: props.location.search } });
};
var EditMachinePolicy = function (props) {
    return React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machinePolicy(props.match.params.machinePolicyId), search: props.location.search } });
};
var V3EnvironmentRoutes = (function (_super) {
    __extends(V3EnvironmentRoutes, _super);
    function V3EnvironmentRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    V3EnvironmentRoutes.prototype.render = function () {
        var match = this.props.match;
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { path: "/environments/proxies/new" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.proxies.create, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/proxies/:proxyId", component: EditProxy }),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/proxies" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.proxies.root, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/machinepolicies/new" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machinePolicies.create, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/machinepolicies/:machinePolicyId", component: EditMachinePolicy }),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/machinepolicies" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machinePolicies.root, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/new" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.environments.create, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/:environmentId", component: EditEnvironment }),
            React.createElement(ReloadableRoute_1.default, null,
                React.createElement(InternalRedirect_1.default, { to: routeLinks_1.default.infrastructure.environments.root }))));
    };
    return V3EnvironmentRoutes;
}(React.Component));
exports.V3EnvironmentRoutes = V3EnvironmentRoutes;
exports.default = V3EnvironmentRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\V3EnvironmentRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\V3EnvironmentRoutes.tsx"); } } })();

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var routeLinks_1 = __webpack_require__(20);
var ReloadableRoute_1 = __webpack_require__(80);
var InternalRedirect_1 = __webpack_require__(40);
var EditAccount = function (props) {
    return React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.account(props.match.params.accountId), search: props.location.search } });
};
var V3AccountRoutes = (function (_super) {
    __extends(V3AccountRoutes, _super);
    function V3AccountRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    V3AccountRoutes.prototype.render = function () {
        var match = this.props.match;
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { path: "/accounts/new" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.accounts.create, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/accounts/:accountId", component: EditAccount }),
            React.createElement(ReloadableRoute_1.default, null,
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.accounts.root, search: this.props.location.search } }))));
    };
    return V3AccountRoutes;
}(React.Component));
exports.V3AccountRoutes = V3AccountRoutes;
exports.default = V3AccountRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\V3AccountRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\V3AccountRoutes.tsx"); } } })();

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var routeLinks_1 = __webpack_require__(20);
var ReloadableRoute_1 = __webpack_require__(80);
var InternalRedirect_1 = __webpack_require__(40);
var EditMachine = function (props) {
    return React.createElement(react_router_dom_1.Switch, null,
        React.createElement(ReloadableRoute_1.default, { path: props.match.path + "/connection" },
            React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machine(props.match.params.machineId).connection, search: props.location.search } })),
        React.createElement(ReloadableRoute_1.default, { path: props.match.path + "/deployments" },
            React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machine(props.match.params.machineId).deployments, search: props.location.search } })),
        React.createElement(ReloadableRoute_1.default, { path: props.match.path + "/events" },
            React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machine(props.match.params.machineId).events, search: props.location.search } })),
        React.createElement(ReloadableRoute_1.default, null,
            React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machine(props.match.params.machineId).root, search: props.location.search } })));
};
var V3MachineRoutes = (function (_super) {
    __extends(V3MachineRoutes, _super);
    function V3MachineRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    V3MachineRoutes.prototype.render = function () {
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { path: "/machines/new" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machines.create, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/machines/:machineId", component: EditMachine }),
            React.createElement(ReloadableRoute_1.default, null,
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machines.root, search: this.props.location.search } }))));
    };
    return V3MachineRoutes;
}(React.Component));
exports.V3MachineRoutes = V3MachineRoutes;
exports.default = V3MachineRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\V3MachineRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\V3MachineRoutes.tsx"); } } })();

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var index_1 = __webpack_require__(167);
var routeLinks_1 = __webpack_require__(20);
var index_2 = __webpack_require__(169);
var index_3 = __webpack_require__(120);
var InternalRedirect_1 = __webpack_require__(40);
var ProjectChildRedirect = (function (_super) {
    __extends(ProjectChildRedirect, _super);
    function ProjectChildRedirect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            redirectTo: null
        };
        return _this;
    }
    ProjectChildRedirect.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var projectId, redirectTo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.getProjectId(clientInstance_1.repository)];
                    case 1:
                        projectId = _a.sent();
                        redirectTo = this.props.getRedirectPath(projectId);
                        this.setState({
                            redirectTo: redirectTo
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ProjectChildRedirect.prototype.render = function () {
        var redirectTo = this.state.redirectTo;
        if (!redirectTo) {
            return React.createElement("main", { id: "maincontent" },
                React.createElement(index_3.default, { link: routeLinks_1.default.projects, title: "Projects" }),
                React.createElement(index_2.default, { busy: this.state.busy, fullWidth: true, errors: this.state.errors }));
        }
        return React.createElement(InternalRedirect_1.default, { push: false, to: { pathname: redirectTo } });
    };
    return ProjectChildRedirect;
}(index_1.DataBaseComponent));
exports.ReleaseRedirect = function (props) {
    return React.createElement(ProjectChildRedirect, { getProjectId: function (r) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, r.Releases.get(props.releaseId)];
                case 1: return [2 /*return*/, (_a.sent()).ProjectId];
            }
        }); }); }, getRedirectPath: function (projectId) { return routeLinks_1.default.project(projectId).release(props.releaseId).root; } });
};
exports.TriggerRedirect = function (props) {
    return React.createElement(ProjectChildRedirect, { getProjectId: function (r) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, r.ProjectTriggers.get(props.triggerId)];
                case 1: return [2 /*return*/, (_a.sent()).ProjectId];
            }
        }); }); }, getRedirectPath: function (projectId) { return routeLinks_1.default.project(projectId).trigger(props.triggerId); } });
};
exports.ChannelRedirect = function (props) {
    return React.createElement(ProjectChildRedirect, { getProjectId: function (r) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, r.Channels.get(props.channelId)];
                case 1: return [2 /*return*/, (_a.sent()).ProjectId];
            }
        }); }); }, getRedirectPath: function (projectId) { return routeLinks_1.default.project(projectId).channel(props.channelId); } });
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\RootRoutes\\ProjectChildRedirect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\RootRoutes\\ProjectChildRedirect.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1715);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__34AXe{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__3Cv2k{display:none!important}}@media (max-width:79.9rem){.style_hide-md__fzmTu{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1-kcH{display:none!important}}.style_container__2HuiA{width:12.75rem;padding:1rem 1rem 0;margin:.8rem;position:relative;display:flex;flex-direction:column;align-items:center;flex:0 1 auto;box-shadow:0 .0625rem .25rem 0 rgba(0,0,0,.12);background:#fff;transition:background-color .1s ease-in}.style_container__2HuiA,.style_container__2HuiA:active,.style_container__2HuiA:visited{color:#333;text-decoration:none}.style_container__2HuiA:hover{box-shadow:0 .0625rem .3125rem 0 rgba(0,0,0,.2),0 .1875rem .25rem 0 rgba(0,0,0,.12),0 .125rem .25rem 0 rgba(0,0,0,.14)}.style_container__2HuiA:hover .style_onHover__W0b2Z{background-color:hsla(0,0%,62%,.4);position:absolute;display:flex;flex-direction:column;bottom:0;left:0;height:100%;width:100%;justify-content:center;align-items:center}@media (max-width:37.4rem){.style_container__2HuiA{margin:.8rem 0}}.style_onHover__W0b2Z{display:none}.style_header__2_mHJ{max-width:12.25rem;font-size:1.0625rem;margin-top:1rem;text-align:center;color:#333;word-wrap:break-word;word-break:break-word}.style_link__2dgP6>a{position:absolute;display:flex;flex-direction:column;bottom:0;left:0;height:100%;width:100%;z-index:1}.style_disabled__1TIYv *{color:#9e9e9e}.style_content__3Ox8D{text-align:center;max-width:12.25rem;color:#9e9e9e;font-size:.8125rem;line-height:1rem;max-height:4.5rem;margin-bottom:1rem;height:100%;position:relative;overflow:hidden;text-overflow:ellipsis;word-wrap:break-word;font-weight:300}.style_content__3Ox8D p{margin:.5rem 0}.style_contentFade__2BsiQ:after{position:absolute;bottom:-1rem;height:3rem;width:100%;content:\"\";background:linear-gradient(0deg,#fff 40%,hsla(0,0%,100%,0));pointer-events:none;left:0;z-index:1;overflow:hidden}.style_footer__MG2_d{margin-top:auto;width:12.75rem;font-size:.625rem;padding-top:.5rem;padding-bottom:.5rem;text-align:center}.style_footerIcon__2eLyu{margin-left:.1875rem}@media (max-width:37.4rem){.style_content__3Ox8D{display:none}.style_header__2_mHJ{margin-top:auto;margin-bottom:auto;margin-left:.5rem;max-width:none;flex:1 1 auto;text-align:left}.style_container__2HuiA{display:flex;flex-direction:row;justify-content:space-between;align-items:stretch;padding:.5rem;height:auto;width:100%}.style_footer__MG2_d>*{display:none}.style_footer__MG2_d{padding:0;margin:0;width:1.5rem;height:auto;display:flex;align-items:center}.style_footerIcon__2eLyu{display:block}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__34AXe",
	"hideSm": "style_hide-sm__34AXe",
	"visible-sm": "style_visible-sm__3Cv2k",
	"visibleSm": "style_visible-sm__3Cv2k",
	"hide-md": "style_hide-md__fzmTu",
	"hideMd": "style_hide-md__fzmTu",
	"visible-md": "style_visible-md__1-kcH",
	"visibleMd": "style_visible-md__1-kcH",
	"container": "style_container__2HuiA",
	"onHover": "style_onHover__W0b2Z",
	"header": "style_header__2_mHJ",
	"link": "style_link__2dgP6",
	"disabled": "style_disabled__1TIYv",
	"content": "style_content__3Ox8D",
	"contentFade": "style_contentFade__2BsiQ",
	"footer": "style_footer__MG2_d",
	"footerIcon": "style_footerIcon__2eLyu"
};

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1717);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_description__2nM_J{color:#666;font-size:.8125rem;font-weight:300;line-height:1rem}.style_description__2nM_J p{margin:.5rem 0;font-size:.8125rem;color:#666}", ""]);

// exports
exports.locals = {
	"description": "style_description__2nM_J"
};

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(673);
var Panel = function (props) {
    return React.createElement("div", { className: styles.panel },
        React.createElement("div", { className: styles.header },
            React.createElement("img", { src: props.imageSrc, alt: props.imageAlt, width: props.imageWidth, height: props.imageHeight })),
        React.createElement("div", { className: styles.body }, props.description));
};
exports.default = Panel;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\Panel.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\Panel.tsx"); } } })();

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.empty_hide-sm__3LFt_{display:none!important}}@media (min-width:37.4rem){.empty_visible-sm__2PbGS{display:none!important}}@media (max-width:79.9rem){.empty_hide-md__2LD03{display:none!important}}@media (min-width:79.9rem){.empty_visible-md__3r2WF{display:none!important}}.empty_panel__2DGYD{position:relative;background-color:#fff;margin:1rem;box-shadow:0 .0625rem .25rem 0 rgba(0,0,0,.12)}.empty_panel__2DGYD .empty_header__3ckCP{margin:0;padding:0 1.25rem;text-align:center}.empty_panel__2DGYD .empty_header__3ckCP img{max-width:80%;max-height:16vh}.empty_panel__2DGYD .empty_body__2QdzK{padding:1.25rem .625rem;font-size:.875rem;line-height:1.1875rem}.empty_panel__2DGYD .empty_body__2QdzK ol,.empty_panel__2DGYD .empty_body__2QdzK ul{padding-left:2.5rem}.empty_panel__2DGYD .empty_body__2QdzK ul{list-style:square}.empty_panel__2DGYD .empty_body__2QdzK ol{list-style:decimal}.empty_panelCard__3rduS{margin-left:.9375rem;margin-right:.9375rem;margin-bottom:1.875rem;position:relative;background-color:#fff;box-shadow:0 .0625rem .25rem 0 rgba(0,0,0,.12);background:#fff;transition:background-color .1s ease-in}.empty_panelCard__3rduS .empty_header__3ckCP{margin:0;padding:0 1.25rem}.empty_panelCard__3rduS .empty_header__3ckCP img{max-width:80%;max-height:80%}.empty_panelCard__3rduS .empty_body__2QdzK{padding:1.25rem .625rem;font-size:.875rem;line-height:1.1875rem}.empty_panelCard__3rduS .empty_body__2QdzK ol,.empty_panelCard__3rduS .empty_body__2QdzK ul{padding-left:2.5rem}.empty_panelCard__3rduS .empty_body__2QdzK ul{list-style:square}.empty_panelCard__3rduS .empty_body__2QdzK ol{list-style:decimal}.empty_onboardingContainer__KbjjK{margin:1rem 3rem;display:flex;flex-direction:column;align-items:center}.empty_title__1tqAP{text-align:center;margin-bottom:1rem}.empty_onboardingCreateFirst__2F3d4{text-align:center;font-size:.8125rem;color:#9e9e9e}.empty_panels__1kplu{display:flex;flex-wrap:wrap;justify-content:center;width:100%}.empty_panels__1kplu>*{flex-grow:1;max-width:37.5rem;width:30%;box-sizing:border-box}@media (max-width:37.4rem){.empty_panels__1kplu>*{width:100%}.empty_onboardingContainer__KbjjK{margin:0}}", ""]);

// exports
exports.locals = {
	"hide-sm": "empty_hide-sm__3LFt_",
	"hideSm": "empty_hide-sm__3LFt_",
	"visible-sm": "empty_visible-sm__2PbGS",
	"visibleSm": "empty_visible-sm__2PbGS",
	"hide-md": "empty_hide-md__2LD03",
	"hideMd": "empty_hide-md__2LD03",
	"visible-md": "empty_visible-md__3r2WF",
	"visibleMd": "empty_visible-md__3r2WF",
	"panel": "empty_panel__2DGYD",
	"header": "empty_header__3ckCP",
	"body": "empty_body__2QdzK",
	"panelCard": "empty_panelCard__3rduS",
	"onboardingContainer": "empty_onboardingContainer__KbjjK",
	"title": "empty_title__1tqAP",
	"onboardingCreateFirst": "empty_onboardingCreateFirst__2F3d4",
	"panels": "empty_panels__1kplu"
};

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var envCount_1 = __webpack_require__(794);
var phaseHelpers_1 = __webpack_require__(674);
var styles = __webpack_require__(1721);
var iconStyles = __webpack_require__(462);
var routeLinks_1 = __webpack_require__(20);
var PhaseStatusIcon_1 = __webpack_require__(770);
var LifecycleMapInternal = (function (_super) {
    __extends(LifecycleMapInternal, _super);
    function LifecycleMapInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.phaseHasSingleTargetEnvironmentWithSameName = function (p) {
            var env = _this.props.environmentsById[phaseHelpers_1.getSingleDeploymentTarget(p)];
            return envCount_1.default(p) === 1 && env && p.Name === env.Name;
        };
        _this.PhaseOnly = function (props) {
            var s = _this.props.lifecycleStatus;
            var target = phaseHelpers_1.getSingleDeploymentTarget(props.phase);
            var task = s.tasks[target];
            var phaseName = task
                ? React.createElement("a", { className: styles.phaseName, href: routeLinks_1.default.task(task).root }, _this.props.environmentsById[target].Name)
                : React.createElement("span", { className: styles.phaseName }, _this.props.environmentsById[target].Name);
            return React.createElement("div", null,
                React.createElement(PhaseStatusIcon_1.default, { phase: props.phase, status: _this.props.lifecycleStatus }),
                phaseName,
                React.createElement(_this.PhaseConstraintOptional, { phase: props.phase }));
        };
        _this.PhaseAndAllTargetEnvironments = function (props) {
            return React.createElement("div", null,
                React.createElement(PhaseStatusIcon_1.default, { phase: props.phase, status: _this.props.lifecycleStatus }),
                React.createElement("span", { className: styles.phaseName }, props.phase.Name),
                React.createElement(_this.PhaseConstraintAny, { phase: props.phase }),
                React.createElement(_this.PhaseConstraintOptional, { phase: props.phase }),
                React.createElement("ul", null,
                    props.phase.AutomaticDeploymentTargets.map(function (e) {
                        return React.createElement(_this.AutomaticDeploymentTarget, { key: e, target: e });
                    }),
                    props.phase.OptionalDeploymentTargets.map(function (e) {
                        return React.createElement(_this.OptionalDeploymentTarget, { key: e, target: e });
                    })));
        };
        _this.PhaseConstraintAny = function (props) {
            var p = props.phase;
            var show = p.MinimumEnvironmentsBeforePromotion > 0 && p.MinimumEnvironmentsBeforePromotion < envCount_1.default(p) && !p.IsOptionalPhase;
            return show ? React.createElement("span", { className: styles.phaseConstraint },
                " (any ",
                p.MinimumEnvironmentsBeforePromotion,
                ")") : null;
        };
        _this.PhaseConstraintOptional = function (props) {
            return props.phase.IsOptionalPhase ? React.createElement("span", { className: styles.phaseConstraint }, " (optional)") : null;
        };
        _this.AutomaticDeploymentTarget = function (props) {
            return (_this.props.environmentsById[props.target])
                ? React.createElement("li", { className: styles.target, title: "Automatically deploy to this environment", key: props.target },
                    React.createElement("span", { className: cn(iconStyles.phaseIcon, iconStyles.automatic) }),
                    React.createElement(_this.EnvironmentName, __assign({}, props)))
                : null;
        };
        _this.OptionalDeploymentTarget = function (props) {
            return (_this.props.environmentsById[props.target])
                ? React.createElement("li", { className: styles.target, title: "Manually deploy to this environment", key: props.target },
                    React.createElement("span", { className: cn(iconStyles.phaseIcon, iconStyles.optional) }),
                    React.createElement(_this.EnvironmentName, __assign({}, props)))
                : null;
        };
        _this.EnvironmentName = function (props) {
            return _this.props.lifecycleStatus.tasks[props.target]
                ? React.createElement("a", { href: "#/tasks/{{ tasks[e] }}" }, _this.props.environmentsById[props.target].Name)
                : React.createElement("span", null, _this.props.environmentsById[props.target].Name);
        };
        return _this;
    }
    LifecycleMapInternal.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { className: cn(styles.lifecycleMap, this.props.className) },
            React.createElement("ul", null, this.props.phases.map(function (p) {
                return React.createElement("li", { className: styles.phase, key: p.Name }, _this.phaseHasSingleTargetEnvironmentWithSameName(p)
                    ? React.createElement(_this.PhaseOnly, { phase: p })
                    : React.createElement(_this.PhaseAndAllTargetEnvironments, { phase: p }));
            })));
    };
    return LifecycleMapInternal;
}(React.Component));
exports.default = LifecycleMapInternal;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\library\\components\\Lifecycle\\LifecycleMap\\LifecycleMapInternal.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\library\\components\\Lifecycle\\LifecycleMap\\LifecycleMapInternal.tsx"); } } })();

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1722);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_lifecycle-map__1YqE4{position:relative;overflow:hidden}.style_lifecycle-map__1YqE4>ul:before{content:\"\";position:absolute;top:1.25rem;bottom:1.5rem;left:.375rem;width:.0625rem;background:#9e9e9e}.style_lifecycle-map__1YqE4 li{position:relative;list-style-type:none;margin:.5rem .25rem .5rem 0;font-size:.875rem;font-weight:400;line-height:1.36rem;text-align:left}.style_lifecycle-map__1YqE4>ul>li.style_phase__sK0_L .style_phase-name__UOlFy{font-weight:500}.style_lifecycle-map__1YqE4 li.style_phase__sK0_L ul{list-style-type:none;margin-left:1.5rem;padding-left:0}.style_lifecycle-map__1YqE4 li.style_phase__sK0_L li{list-style-type:none;margin-left:0;padding-left:0}.style_lifecycle-map__1YqE4 li.style_target__3FUvu:before{content:\"\";position:absolute;top:.5rem;left:-1.125rem;width:1.125rem;height:.0625rem;background:#9e9e9e}.style_lifecycle-map__1YqE4 li.style_phase__sK0_L{padding-left:0}", ""]);

// exports
exports.locals = {
	"lifecycle-map": "style_lifecycle-map__1YqE4",
	"lifecycleMap": "style_lifecycle-map__1YqE4",
	"phase": "style_phase__sK0_L",
	"phase-name": "style_phase-name__UOlFy",
	"phaseName": "style_phase-name__UOlFy",
	"target": "style_target__3FUvu"
};

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_phase-icon__UXMYG{box-sizing:border-box;background:#9e9e9e;width:1rem;height:1rem;display:inline-flex;vertical-align:top;margin-right:.5rem;align-items:center;justify-content:center;color:#fff;border-radius:.125rem}.style_phase-icon-before__5-17V{font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_optional__3mVRg{background:linear-gradient(90deg,#9e9e9e 50%,#fff 0);border:.0625rem solid #9e9e9e}.style_phase-icon__UXMYG.style_blocked__1mQZu{background:#fff!important;border:.0625rem solid #333}.style_phase-icon__UXMYG.style_blocked__1mQZu:after{content:\"\";width:.625rem;height:.625rem;background:#db4437;position:relative;display:inline-block}.style_phase-icon__UXMYG.style_blocked__1mQZu:before{display:none}.style_phase-icon__UXMYG.style_current__7QBG1{background:#2f93e0;border:none}.style_phase-icon__UXMYG.style_current__7QBG1:before{content:\"\\F061\";padding-bottom:.125rem;font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_complete__1UGTu{background:#53b953}.style_phase-icon__UXMYG.style_complete__1UGTu:before{content:\"\\F00C\";font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_deployed__PtPiA{background:#53b953}.style_phase-icon__UXMYG.style_deployed__PtPiA:before{content:\"\\F00C\";font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_automatic__1d9gs{background:#fb8c00}.style_phase-icon__UXMYG.style_automatic__1d9gs:before{content:\"\\F0E7\";padding-left:.125rem;font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_queued__1kcdt{background:#215680}.style_phase-icon__UXMYG.style_queued__1kcdt:before{content:\"\\F017\";font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_warning__380pO{background:#53b953}.style_phase-icon__UXMYG.style_warning__380pO:before{content:\"\\F071\";font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_skipped__1hLQB{width:1rem;height:1rem;background:#ccc;border:.125rem dashed #9e9e9e}", ""]);

// exports
exports.locals = {
	"phase-icon": "style_phase-icon__UXMYG",
	"phaseIcon": "style_phase-icon__UXMYG",
	"phase-icon-before": "style_phase-icon-before__5-17V",
	"phaseIconBefore": "style_phase-icon-before__5-17V",
	"optional": "style_optional__3mVRg",
	"blocked": "style_blocked__1mQZu",
	"current": "style_current__7QBG1",
	"complete": "style_complete__1UGTu",
	"deployed": "style_deployed__PtPiA",
	"automatic": "style_automatic__1d9gs",
	"queued": "style_queued__1kcdt",
	"warning": "style_warning__380pO",
	"skipped": "style_skipped__1hLQB"
};

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1725);
var ExecutingIcon = function () {
    return React.createElement("div", { className: styles.outer },
        React.createElement("div", { className: styles.border },
            React.createElement("div", { className: styles.wrapper },
                React.createElement("div", { className: cn(styles.pie, styles.spinner) }),
                React.createElement("div", { className: cn(styles.pie, styles.filler1) }),
                React.createElement("div", { className: cn(styles.pie, styles.filler2) }),
                React.createElement("div", { className: styles.mask1 }),
                React.createElement("div", { className: styles.mask2 }))));
};
exports.default = ExecutingIcon;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PhaseStatusIcon\\ExecutingIcon.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\PhaseStatusIcon\\ExecutingIcon.tsx"); } } })();

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1726);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./executingStyle.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./executingStyle.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "*{box-sizing:border-box}.executingStyle_outer__2d-m8{display:inline-block;background:#215680;width:.875rem;height:.875rem;padding:.0625rem;vertical-align:top;margin-right:.5rem;margin-top:.0625rem}.executingStyle_border__13jj5{background:#215680;width:.75rem;height:.75rem;border:.0625rem solid #fff;border-radius:50%;padding:.0625rem}.executingStyle_wrapper__17eop{width:.5rem;height:.5rem;position:relative;background:#215680;border-radius:50%}.executingStyle_pie__3CDat{width:50%;height:100%;transform-origin:100% 50%;position:absolute;background:#fff}.executingStyle_spinner__1Omhr{border-radius:.25rem 0 0 .25rem;z-index:200;border-right:none;animation:executingStyle_rota__2wuej 5s linear infinite}.executingStyle_filler1__1cEbx{border-radius:0 .25rem .25rem 0;left:50%;opacity:0;z-index:100;animation:executingStyle_fill1__2_QXK 5s steps(1) infinite;border-left:none}.executingStyle_filler2___mQXq{border-radius:.25rem 0 0 .25rem;opacity:1;z-index:100;animation:executingStyle_fill2__5AU_J 5s steps(1) infinite;border-left:none}.executingStyle_mask1__26Pin{border-radius:.25rem 0 0 .25rem;animation:executingStyle_mask1__26Pin 5s steps(1) infinite}.executingStyle_mask1__26Pin,.executingStyle_mask2__3tLqT{width:50%;height:100%;position:absolute;background:inherit;opacity:1;z-index:300}.executingStyle_mask2__3tLqT{border-radius:0 .25rem .25rem 0;left:50%;animation:executingStyle_mask2__3tLqT 5s steps(1) infinite}@keyframes executingStyle_rota__2wuej{0%{transform:rotate(0deg)}50%{transform:rotate(1turn)}50.01%{transform:rotate(180deg)}to{transform:rotate(540deg)}}@keyframes executingStyle_mask1__26Pin{0%{opacity:1}25%,to{opacity:0}}@keyframes executingStyle_mask2__3tLqT{0%{opacity:0}75%,to{opacity:1}}@keyframes executingStyle_fill1__2_QXK{0%{opacity:0}25%,50%{opacity:1}50.01%,to{opacity:0}}@keyframes executingStyle_fill2__5AU_J{0%{opacity:0}50%,75%{opacity:1}75.01%,to{opacity:0}}", ""]);

// exports
exports.locals = {
	"outer": "executingStyle_outer__2d-m8",
	"border": "executingStyle_border__13jj5",
	"wrapper": "executingStyle_wrapper__17eop",
	"pie": "executingStyle_pie__3CDat",
	"spinner": "executingStyle_spinner__1Omhr",
	"rota": "executingStyle_rota__2wuej",
	"filler1": "executingStyle_filler1__1cEbx",
	"fill1": "executingStyle_fill1__2_QXK",
	"filler2": "executingStyle_filler2___mQXq",
	"fill2": "executingStyle_fill2__5AU_J",
	"mask1": "executingStyle_mask1__26Pin",
	"mask2": "executingStyle_mask2__3tLqT"
};

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1728);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__Ia6wX{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__a12PU{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2a0Q-{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2DeIf{display:none!important}}.style_bodyWithSides__1xywl{display:flex;flex:1 1 auto;padding:0}@media (max-width:37.4rem){.style_bodyWithSides__1xywl{flex-direction:column}}@media (min-width:37.4rem){.style_sideBarRight__2_Hml{border-left:.0625rem solid #ccc}}@media (min-width:37.4rem){.style_sideBarLeft__V3RKB{border-right:.0625rem solid #ccc}}.style_sidebarContainer__3MmJB{flex-basis:17.6rem}.style_sideBar__3WzhS{font-size:.875rem}@media (max-width:37.4rem){.style_sideBar__3WzhS{border-top:.0625rem solid #ccc}}.style_sideBarPadding__jE6Gd{padding:0 1rem}.style_main__3txB4{flex-grow:1;flex-basis:1rem;min-width:0}@media (max-width:37.4rem){.style_main__3txB4{flex-basis:auto}}.style_overflowXHidden__Cjipd{overflow-x:hidden}.style_mainContent__2tIQ4{padding-top:0}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__Ia6wX",
	"hideSm": "style_hide-sm__Ia6wX",
	"visible-sm": "style_visible-sm__a12PU",
	"visibleSm": "style_visible-sm__a12PU",
	"hide-md": "style_hide-md__2a0Q-",
	"hideMd": "style_hide-md__2a0Q-",
	"visible-md": "style_visible-md__2DeIf",
	"visibleMd": "style_visible-md__2DeIf",
	"bodyWithSides": "style_bodyWithSides__1xywl",
	"sideBarRight": "style_sideBarRight__2_Hml",
	"sideBarLeft": "style_sideBarLeft__V3RKB",
	"sidebarContainer": "style_sidebarContainer__3MmJB",
	"sideBar": "style_sideBar__3WzhS",
	"sideBarPadding": "style_sideBarPadding__jE6Gd",
	"main": "style_main__3txB4",
	"overflowXHidden": "style_overflowXHidden__Cjipd",
	"mainContent": "style_mainContent__2tIQ4"
};

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TenantFilterButton_1 = __webpack_require__(1730);
exports.default = TenantFilterButton_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TenantTagDesignDialog\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TenantTagDesignDialog\\index.tsx"); } } })();

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Button_1 = __webpack_require__(51);
var TenantTagDesignDialogLayout_1 = __webpack_require__(1731);
var OpenDialogButton_1 = __webpack_require__(74);
var TenantFilterButton = (function (_super) {
    __extends(TenantFilterButton, _super);
    function TenantFilterButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TenantFilterButton.prototype.render = function () {
        return React.createElement(OpenDialogButton_1.default, { label: "Tenant Preview", type: Button_1.ActionButtonType.Ternary, wideDialog: true },
            React.createElement(TenantTagDesignDialogLayout_1.default, { hideTenantsByName: !this.props.showTenants, availableTenants: this.props.availableTenants, selectedTenants: this.props.selectedTenants, onUpdate: this.props.onUpdate, selectedTags: this.props.selectedTags }));
    };
    return TenantFilterButton;
}(React.Component));
exports.default = TenantFilterButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TenantTagDesignDialog\\TenantFilterButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TenantTagDesignDialog\\TenantFilterButton.tsx"); } } })();

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(71);
var clientInstance_1 = __webpack_require__(10);
var tenantTagsets = __webpack_require__(138);
var TextField_1 = __webpack_require__(159);
var Checkbox_1 = __webpack_require__(118);
var Table_1 = __webpack_require__(586);
var MissingTagsList_1 = __webpack_require__(290);
var index_1 = __webpack_require__(68);
var TagsList_1 = __webpack_require__(447);
var styles = __webpack_require__(1732);
var OkDialogLayout_1 = __webpack_require__(107);
var DataBaseComponent_1 = __webpack_require__(39);
var TenantTagDesignDialogLayout = (function (_super) {
    __extends(TenantTagDesignDialogLayout, _super);
    function TenantTagDesignDialogLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.tagChanged = function (tags) {
            _this.setState({ selectedTags: tags }, function () { return _this.runTagTest(); });
        };
        _this.tenantChanged = function (tags) {
            _this.setState({ selectedTenants: tags }, function () { return _this.runTagTest(); });
        };
        _this.state = {
            selectedTags: _this.props.selectedTags || [],
            selectedTenants: _this.props.selectedTenants || [],
            matchCount: 0,
            allTenants: undefined,
            allTags: undefined,
            tagIndex: null,
            matchResults: [],
            searchText: "",
            onlyShowMatching: true,
            tenantIndex: {}
        };
        return _this;
    }
    TenantTagDesignDialogLayout.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a, allTenants, allTags, tagIndex, tenantIndex, availableTenants;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([clientInstance_1.repository.Tenants.all(), tenantTagsets.getAll(), tenantTagsets.getTagIndex()])];
                    case 1:
                        _a = _b.sent(), allTenants = _a[0], allTags = _a[1], tagIndex = _a[2];
                        tenantIndex = allTenants.reduce(function (idx, item) { idx[item.Id] = item; return idx; }, {});
                        availableTenants = allTenants;
                        if (this.props.availableTenants) {
                            availableTenants = allTenants.filter(function (t) { return _this.props.availableTenants.indexOf(t.Id) !== -1; });
                        }
                        this.setState({ allTenants: availableTenants, allTags: allTags, tenantIndex: tenantIndex, tagIndex: tagIndex }, function () { return _this.runTagTest(); });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    TenantTagDesignDialogLayout.prototype.runTagTest = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var result, matchCount, matchResults;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Tenants.tagTest(this.state.selectedTenants, this.state.selectedTags)];
                    case 1:
                        result = _a.sent();
                        matchCount = 0;
                        matchResults = Object.keys(result).map(function (tenantId) {
                            var tenantTestResult = result[tenantId];
                            var tenant = _this.state.tenantIndex[tenantId];
                            var isAvailable = !_this.props.availableTenants || _this.props.availableTenants.indexOf(tenantId) !== -1;
                            var isMatch = tenantTestResult.IsMatched && isAvailable;
                            if (isMatch) {
                                matchCount++;
                            }
                            var matchedTags = tenant.TenantTags.filter(function (tag) { return _this.state.selectedTags.indexOf(tag) !== -1; });
                            return {
                                id: tenantId,
                                name: tenant.Name,
                                reason: isAvailable ? tenantTestResult.Reason : "Tenant not available in this context",
                                missingTags: tenantTestResult.MissingTags,
                                isMatchedByName: _this.state.selectedTenants.indexOf(tenantId) !== -1,
                                matchedTags: matchedTags,
                                isMatched: isMatch
                            };
                        }).sort(function (resultA, resultB) {
                            if (resultA.isMatched && !resultB.isMatched) {
                                return -1;
                            }
                            else if (!resultA.isMatched && resultB.isMatched) {
                                return 1;
                            }
                            if (resultA.name < resultB.name) {
                                return -1;
                            }
                            else if (resultA.name > resultB.name) {
                                return 1;
                            }
                            else {
                                return 0;
                            }
                        });
                        this.setState({ matchCount: matchCount, matchResults: matchResults });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    TenantTagDesignDialogLayout.prototype.render = function () {
        var _this = this;
        if (!this.state.allTenants) {
            return null;
        }
        var searchText = this.state.searchText.toLowerCase();
        return React.createElement(OkDialogLayout_1.default, { title: "Tenant Preview", errors: this.state.errors, busy: this.state.busy, onOkClick: function () {
                _this.props.onUpdate(_this.state.selectedTenants, _this.state.selectedTags);
                return true;
            } },
            React.createElement("div", null,
                !this.props.hideTenantsByName && React.createElement("h3", null, "Include tenants by name"),
                !this.props.hideTenantsByName && React.createElement(MultiSelect_1.TenantMultiSelect, { onChange: this.tenantChanged, value: this.state.selectedTenants, items: this.state.allTenants }),
                React.createElement("h3", null, "Include tenants by tags"),
                React.createElement(MultiSelect_1.TenantTagMultiSelect, { onChange: this.tagChanged, value: this.state.selectedTags, doBusyTask: this.doBusyTask, items: this.state.allTags }),
                React.createElement("div", { className: styles.previewHeader },
                    React.createElement("h3", { className: styles.previewTitle },
                        "Preview - ",
                        this.state.matchCount,
                        " matching tenant",
                        this.state.matchCount === 1 ? "" : "s"),
                    React.createElement("div", null,
                        React.createElement(TextField_1.default, { hintText: "Filter results...", value: this.state.searchText, onChange: function (e) { return _this.setState({ searchText: e.target.value }); }, className: styles.previewFilter }),
                        React.createElement(Checkbox_1.default, { label: "Only show matching", value: this.state.onlyShowMatching, onChange: function (e) { return _this.setState({ onlyShowMatching: !_this.state.onlyShowMatching }); } })))),
            React.createElement("div", null,
                React.createElement(Table_1.Table, { selectable: false, multiSelectable: false },
                    React.createElement(Table_1.TableBody, { displayRowCheckbox: false, deselectOnClickaway: false }, this.state.matchResults
                        .filter(function (t) { return (t.isMatched || !_this.state.onlyShowMatching) &&
                        (_this.state.searchText.length < 1 || t.name.toLowerCase().includes(searchText)); })
                        .map(function (row, index) { return (React.createElement(Table_1.TableRow, { key: index },
                        React.createElement(Table_1.TableRowColumn, null, (row.isMatched) && React.createElement("em", { className: "fa fa-check" })),
                        React.createElement(Table_1.TableRowColumn, null, row.name),
                        React.createElement(Table_1.TableRowColumn, { style: { overflow: "visible" } }, _this.renderReason(row)))); })))));
    };
    TenantTagDesignDialogLayout.prototype.renderReason = function (match) {
        if (match.isMatchedByName) {
            return null;
        }
        if (match.isMatched) {
            return React.createElement(TagsList_1.default, { canonicalNames: match.matchedTags, tagIndex: this.state.tagIndex });
        }
        var content = match.reason === "Missing Tags" ?
            React.createElement("div", null,
                React.createElement("div", null, "Missing Tags"),
                React.createElement(MissingTagsList_1.default, { tags: match.missingTags })) : match.reason;
        return content && React.createElement(index_1.default, { content: content },
            React.createElement("em", { className: "fa fa-info-circle" }));
    };
    return TenantTagDesignDialogLayout;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = TenantTagDesignDialogLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TenantTagDesignDialog\\TenantTagDesignDialogLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TenantTagDesignDialog\\TenantTagDesignDialogLayout.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1733);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_previewHeader__29Ste{display:flex;flex-direction:row;align-items:center;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"previewHeader": "style_previewHeader__29Ste"
};

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1735);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_textContainer__qxe7b{position:relative;display:flex;align-items:flex-end}.style_iconContainer__1baDV{position:absolute;right:0;cursor:pointer;margin:.5625rem;top:18px}.style_autoCompleteContainer__3JypX{width:100%}.style_popover__smxSz>div,.style_popoverContent__3lIcb{overflow-x:hidden}.style_popoverInfoText__2oEe8{margin:1rem}.style_warning__3Z_HM{margin:.5rem 1rem;color:#fb8c00;font-size:.75rem}.style_buttons__30ybd{padding-bottom:.5rem}", ""]);

// exports
exports.locals = {
	"textContainer": "style_textContainer__qxe7b",
	"iconContainer": "style_iconContainer__1baDV",
	"autoCompleteContainer": "style_autoCompleteContainer__3JypX",
	"popover": "style_popover__smxSz",
	"popoverContent": "style_popoverContent__3lIcb",
	"popoverInfoText": "style_popoverInfoText__2oEe8",
	"warning": "style_warning__3Z_HM",
	"buttons": "style_buttons__30ybd"
};

/***/ }),
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_dom_1 = __webpack_require__(31);
var react_dnd_1 = __webpack_require__(421);
var styles = __webpack_require__(1801);
// Inspired :) by https://github.com/react-dnd/react-dnd/tree/master/examples/04%20Sortable/Simple
var source = {
    beginDrag: function (props) {
        return {
            id: props.id,
            index: props.index,
        };
    },
};
var target = {
    hover: function (props, monitor, component) {
        var dragIndex = monitor.getItem().index;
        var hoverIndex = props.index;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }
        // Determine rectangle on screen
        var hoverBoundingRect = react_dom_1.findDOMNode(component).getBoundingClientRect();
        // Get vertical middle
        var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        // Determine mouse position
        var clientOffset = monitor.getClientOffset();
        // Get pixels to the top
        var hoverClientY = clientOffset.y - hoverBoundingRect.top;
        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }
        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }
        // Time to actually perform the action
        props.onItemMoved(dragIndex, hoverIndex);
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    },
};
var DropTargetInstance = react_dnd_1.DropTarget("SortableItem", target, function (connect) { return ({
    connectDropTarget: connect.dropTarget()
}); });
var DragSourceInstance = react_dnd_1.DragSource("SortableItem", source, function (connect, monitor) { return ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
}); });
var SortableItem = (function (_super) {
    __extends(SortableItem, _super);
    function SortableItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SortableItem.prototype.render = function () {
        var _a = this.props, name = _a.name, isDragging = _a.isDragging, connectDragSource = _a.connectDragSource, connectDropTarget = _a.connectDropTarget;
        var opacity = isDragging ? 0 : 1;
        return connectDragSource(connectDropTarget(React.createElement("div", { className: styles.sortableItem, style: { opacity: opacity } },
            React.createElement("em", { className: "fa fa-sort" }),
            React.createElement("span", { className: styles.name }, name))));
    };
    return SortableItem;
}(React.Component));
exports.default = DropTargetInstance(DragSourceInstance(SortableItem));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SortableList\\SortableItem.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SortableList\\SortableItem.tsx"); } } })();

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1802);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_sortableItem__1BSoO{border:.0625rem solid #ccc;padding:.5rem 1rem;margin-bottom:.5rem;background-color:hsla(0,0%,60%,.08);cursor:move;color:#000}.style_name__-RgrS{padding-left:1rem}", ""]);

// exports
exports.locals = {
	"sortableItem": "style_sortableItem__1BSoO",
	"name": "style_name__-RgrS"
};

/***/ }),
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1807);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./confirmationDialog.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./confirmationDialog.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".confirmationDialog_dialogHeader__3Axs1{background:#fcf1e2}.confirmationDialog_warningIcon__1WYSq{color:#fb8c00}", ""]);

// exports
exports.locals = {
	"dialogHeader": "confirmationDialog_dialogHeader__3Axs1",
	"warningIcon": "confirmationDialog_warningIcon__1WYSq"
};

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1809);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_linkableItem__2Jc-m{cursor:pointer}", ""]);

// exports
exports.locals = {
	"linkableItem": "style_linkableItem__2Jc-m"
};

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1811);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".styles_codeEditorContainer__ZhfWq{position:relative;height:15rem;border:.0625rem solid #ccc}.styles_codeEditorContainerFullScreen__3zcZN{position:fixed;top:0;bottom:0;left:0;right:0;width:auto;height:auto;z-index:999;background:#fff}.styles_enterFullScreen__3y4A-{position:relative;text-align:right;float:right;padding-right:1.25rem;z-index:9}.styles_exitFullScreen__1unSG{text-align:right;position:absolute;z-index:2;top:0;right:0;left:0;padding:.5rem}", ""]);

// exports
exports.locals = {
	"codeEditorContainer": "styles_codeEditorContainer__ZhfWq",
	"codeEditorContainerFullScreen": "styles_codeEditorContainerFullScreen__3zcZN",
	"enterFullScreen": "styles_enterFullScreen__3y4A-",
	"exitFullScreen": "styles_exitFullScreen__1unSG"
};

/***/ }),
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1816);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./codeMirror.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./codeMirror.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports
exports.i(__webpack_require__(1817), "");
exports.i(__webpack_require__(1818), "");

// module
exports.push([module.i, ".CodeMirror{height:inherit}.CodeMirror-fullscreen{top:1.875rem}.ReactCodeMirror{height:100%;top:0;bottom:0;left:0;right:0;position:absolute;font-size:.875rem}", ""]);

// exports


/***/ }),
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1833);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".styles_pageDivider__MsBlZ{background-color:hsla(0,0%,60%,.08);padding:.5rem 1.125rem;margin-right:1rem;font-size:1.0625rem}", ""]);

// exports
exports.locals = {
	"pageDivider": "styles_pageDivider__MsBlZ"
};

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(68);
var Onboarding_1 = __webpack_require__(1835);
var resources_1 = __webpack_require__(26);
var clientInstance_1 = __webpack_require__(10);
var PaperLayout_1 = __webpack_require__(169);
var specialVariables_1 = __webpack_require__(47);
var DeploymentPart_1 = __webpack_require__(1838);
var Roles_1 = __webpack_require__(35);
var pluginRegistry_1 = __webpack_require__(18);
var NavigationButton_1 = __webpack_require__(212);
var SideBar_1 = __webpack_require__(1841);
var ActionButton_1 = __webpack_require__(50);
var ActionList_1 = __webpack_require__(277);
var DeploymentPartSorter_1 = __webpack_require__(1844);
var OverflowMenu_1 = __webpack_require__(209);
var SelectParentStep_1 = __webpack_require__(1845);
var DataBaseComponent_1 = __webpack_require__(39);
var libraryVariableSetResource_1 = __webpack_require__(425);
var lodash_1 = __webpack_require__(16);
var tenantTagsets = __webpack_require__(138);
var OpenDialogButton_1 = __webpack_require__(74);
var material_ui_1 = __webpack_require__(92);
var colors_1 = __webpack_require__(32);
var SvgIcon_1 = __webpack_require__(21);
var SidebarLayout_1 = __webpack_require__(715);
var projectsArea_1 = __webpack_require__(219);
var react_redux_1 = __webpack_require__(67);
var routeLinks_1 = __webpack_require__(20);
var permission_1 = __webpack_require__(49);
var PermissionCheck_1 = __webpack_require__(45);
var getActionLogoUrl_1 = __webpack_require__(463);
var styles = __webpack_require__(207);
var InternalRedirect_1 = __webpack_require__(40);
var rollingStep = __webpack_require__(695);
var ParallelIcon = function () { return React.createElement(SvgIcon_1.default, { color: "#9E9E9E", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M14.91466 15.012048V12L20 16l-5.08534 4v-3.012048H4v-1.975904M14.91466 7.012048V4L20 8l-5.08534 4V8.987952H4V7.012048" })); };
var Divider = function (props) {
    if (!props.parallel) {
        return React.createElement(material_ui_1.Divider, { style: { backgroundColor: colors_1.divider, height: 1, width: "100%" } });
    }
    return React.createElement("div", { className: styles.divider },
        React.createElement(material_ui_1.Divider, { style: { width: 20, backgroundColor: colors_1.divider, height: 1 } }),
        React.createElement(index_1.default, { content: "run in parallel" },
            React.createElement(ParallelIcon, null)),
        React.createElement(material_ui_1.Divider, { style: { backgroundColor: colors_1.divider, height: 1, width: "100%" } }));
};
var DeploymentProcessOverviewInternal = (function (_super) {
    __extends(DeploymentProcessOverviewInternal, _super);
    function DeploymentProcessOverviewInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.refreshData = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return _this.loadData(); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.canBeChildStep = function (step) { return step.Actions.every(function (action) { return pluginRegistry_1.default.getDeploymentAction(action.ActionType).canBeChild; }); };
        _this.state = {
            deploymentProcess: null,
            redirectTo: null,
            project: null,
            open: false,
            isLoaded: false,
            selectedParentStepId: null,
            includedScriptModules: null,
            lifecyclePreview: null,
            tagIndex: null
        };
        return _this;
    }
    DeploymentProcessOverviewInternal.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var project, _a, deploymentProcess, scriptModules, environmentsById, lifecycle, channels, tagIndex, lifecyclePreview, _b, channelsById, includedScriptModules;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.match.params.projectSlug)];
                    case 1:
                        project = _c.sent();
                        return [4 /*yield*/, Promise.all([
                                clientInstance_1.repository.DeploymentProcesses.get(project.DeploymentProcessId),
                                PermissionCheck_1.isAllowed({ permission: permission_1.default.LibraryVariableSetView }) ? clientInstance_1.repository.LibraryVariableSets.all({ contentType: libraryVariableSetResource_1.VariableSetContentType.ScriptModule }) : [],
                                clientInstance_1.repository.Environments.allById(),
                                PermissionCheck_1.isAllowed({ permission: permission_1.default.LifecycleView }) ? clientInstance_1.repository.Lifecycles.get(project.LifecycleId) : null,
                                clientInstance_1.repository.Projects.getChannels(project),
                                tenantTagsets.getTagIndex()
                            ])];
                    case 2:
                        _a = _c.sent(), deploymentProcess = _a[0], scriptModules = _a[1], environmentsById = _a[2], lifecycle = _a[3], channels = _a[4], tagIndex = _a[5];
                        if (!PermissionCheck_1.isAllowed({ permission: permission_1.default.LifecycleView })) return [3 /*break*/, 4];
                        return [4 /*yield*/, clientInstance_1.repository.Lifecycles.preview(lifecycle)];
                    case 3:
                        _b = _c.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _b = null;
                        _c.label = 5;
                    case 5:
                        lifecyclePreview = _b;
                        channelsById = lodash_1.keyBy(channels.Items, function (ch) { return ch.Id; });
                        includedScriptModules = scriptModules.filter(function (sm) { return project.IncludedLibraryVariableSetIds.includes(sm.Id); });
                        this.setState({
                            deploymentProcess: deploymentProcess,
                            environmentsById: environmentsById,
                            project: project,
                            includedScriptModules: includedScriptModules,
                            lifecyclePreview: lifecyclePreview,
                            channelsById: channelsById,
                            tagIndex: tagIndex,
                            isLoaded: true
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DeploymentProcessOverviewInternal.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return _this.loadData(); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DeploymentProcessOverviewInternal.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: true });
        }
        var actions = [];
        if (this.state.isLoaded) {
            if (this.state.deploymentProcess.Steps && this.state.deploymentProcess.Steps.length > 1) {
                actions.push(this.reorderStepsButton());
            }
            actions.push(this.addStepButton());
            actions.push(React.createElement(OverflowMenu_1.default, { menuItems: [
                    OverflowMenu_1.default.downloadItem("Download as JSON", this.state.project.Slug + "-process.json", clientInstance_1.client.resolveLinkTemplate("DeploymentProcesses", { id: this.state.deploymentProcess.Id }))
                ] }));
        }
        return React.createElement(PaperLayout_1.default, { busy: this.state.busy, errors: this.state.errors, title: "Process", sectionControl: this.state.isLoaded &&
                React.createElement(ActionList_1.default, { actions: actions }) }, this.state.isLoaded &&
            React.createElement(SidebarLayout_1.default, { sideBar: React.createElement(SideBar_1.default, { deploymentProcess: this.state.deploymentProcess, includedScriptModules: this.state.includedScriptModules, lifecyclePreview: this.state.lifecyclePreview, environmentsById: this.state.environmentsById, onDataChanged: function () { return _this.refreshData(); } }) },
                React.createElement("div", null,
                    this.state.deploymentProcess.Steps.length === 0 && React.createElement(Onboarding_1.default, null),
                    React.createElement("div", { className: styles.steps }, this.state.deploymentProcess.Steps.map(function (step, index) { return step.Actions.length === 1 ?
                        _this.buildAction(step, step.Actions[0], index + 1) :
                        _this.buildStep(step, index + 1); })))));
    };
    DeploymentProcessOverviewInternal.prototype.reorderStepsButton = function () {
        return React.createElement(PermissionCheck_1.default, { permission: permission_1.default.ProcessEdit, project: this.state.project.Id },
            React.createElement(OpenDialogButton_1.default, { label: "Reorder steps", type: ActionButton_1.ActionButtonType.Secondary },
                React.createElement(DeploymentPartSorter_1.default, { title: "Reorder Steps", deploymentProcessId: this.state.project.DeploymentProcessId, saveDone: this.refreshData })));
    };
    DeploymentProcessOverviewInternal.prototype.addStepButton = function () {
        return React.createElement(PermissionCheck_1.default, { permission: permission_1.default.ProcessEdit, project: this.state.project.Id },
            React.createElement(NavigationButton_1.NavigationButton, { type: NavigationButton_1.NavigationButtonType.Primary, label: "Add Step", href: routeLinks_1.default.project(this.state.project).steptemplates }));
    };
    DeploymentProcessOverviewInternal.prototype.buildStep = function (step, stepIndex) {
        var _this = this;
        return React.createElement("div", { key: step.Id },
            stepIndex > 1 && React.createElement(Divider, { parallel: step.StartTrigger === resources_1.StartTrigger.StartWithPrevious }),
            React.createElement(DeploymentPart_1.default, { name: step.Name, logoUrl: rollingStep, index: stepIndex + ".", detailsUrl: this.calculateDetailsUrl(step.Id), menuItems: this.getOverflowMenuItems(step), mainAction: React.createElement(PermissionCheck_1.default, { permission: permission_1.default.ProcessEdit, project: this.state.project.Id },
                    React.createElement(NavigationButton_1.NavigationButton, { type: NavigationButton_1.NavigationButtonType.Secondary, label: "Add Child Step", href: this.addChildStepUrl(step) })) },
                step.Properties[specialVariables_1.default.Action.MaxParallelism] ? React.createElement("span", null, "Rolling deployment") :
                    React.createElement("span", null, "Multi-step deployment"),
                " ",
                "across deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: step.Properties[specialVariables_1.default.Action.TargetRoles] })),
            React.createElement("div", { className: styles.actions }, step.Actions.map(function (action, index) { return _this.buildAction(step, action, index + 1, stepIndex); })));
    };
    DeploymentProcessOverviewInternal.prototype.buildAction = function (step, action, actionIndex, stepIndex) {
        var _this = this;
        var isChildAction = !!stepIndex;
        var environmentsUserCanAccess = function (environments) {
            return environments.filter(function (e) { return Object.keys(_this.state.environmentsById).includes(e); });
        };
        return React.createElement("div", { key: action.Id },
            (stepIndex || actionIndex > 1) && React.createElement(Divider, { parallel: isChildAction === false && step.StartTrigger === resources_1.StartTrigger.StartWithPrevious }),
            React.createElement(DeploymentPart_1.default, { name: action.Name, logoUrl: getActionLogoUrl_1.default(action), environments: environmentsUserCanAccess(action.Environments).map(function (id) { return _this.state.environmentsById[id]; }), excludedEnvironments: environmentsUserCanAccess(action.ExcludedEnvironments).map(function (id) { return _this.state.environmentsById[id]; }), channels: action.Channels.map(function (id) { return _this.state.channelsById[id]; }), tags: this.getTags(action), index: stepIndex ? stepIndex + "." + actionIndex : actionIndex + ".", isDisabled: action.IsDisabled, detailsUrl: this.calculateDetailsUrl(action.Id), menuItems: this.getOverflowMenuItems(step, action, isChildAction) }, pluginRegistry_1.default.getDeploymentAction(action.ActionType)
                .summary(action.Properties, isChildAction ? null : step.Properties[specialVariables_1.default.Action.TargetRoles])));
    };
    DeploymentProcessOverviewInternal.prototype.getOverflowMenuItems = function (step, action, isChildAction) {
        var _this = this;
        var menuItems = [];
        var processEditPermission = { permission: permission_1.default.ProcessEdit, project: this.state.project.Id };
        var canEdit = PermissionCheck_1.isAllowed(processEditPermission);
        menuItems.push(OverflowMenu_1.default.navItem(canEdit ? "Edit" : "View Details", this.calculateDetailsUrl(action ? action.Id : step.Id)));
        if (!isChildAction) {
            if (!this.canHaveChildren(step)) {
                menuItems.push(OverflowMenu_1.default.disabledItem("Add child step", "This step type does not support child steps"));
            }
            else {
                menuItems.push(OverflowMenu_1.default.navItem("Add child step", this.addChildStepUrl(step), null, processEditPermission));
            }
        }
        if (action) {
            menuItems.push(OverflowMenu_1.default.item(action.IsDisabled ? "Enable" : "Disable", function () { return action.IsDisabled ? _this.enable(action) : _this.disable(action); }, processEditPermission));
        }
        if (!action && this.canHaveChildren(step)) {
            menuItems.push(OverflowMenu_1.default.item("Enable all", function () { return _this.enableAll(step); }, processEditPermission));
            menuItems.push(OverflowMenu_1.default.item("Disable all", function () { return _this.disableAll(step); }, processEditPermission));
        }
        if (isChildAction) {
            menuItems.push(OverflowMenu_1.default.item("Move out", function () { return _this.moveOut(step, action); }, processEditPermission));
        }
        if (action) {
            if (!this.canMoveIn(step.Id)) {
                menuItems.push(OverflowMenu_1.default.disabledItem("Move into...", "No steps available that can have children or this step type cannot be a child step."));
            }
            else {
                var stepsToMoveInto = this.state.deploymentProcess.Steps.filter(function (s) { return s.Id !== step.Id && _this.canHaveChildren(s); });
                var selectParentStep = React.createElement(SelectParentStep_1.default, { steps: stepsToMoveInto, actionName: action.Name, currentlyTargetedRoles: step.Properties[specialVariables_1.default.Action.TargetRoles], onStepSelected: function (parentStepId) { return _this.moveIn(step, action, parentStepId); } });
                menuItems.push(OverflowMenu_1.default.dialogItem("Move into...", selectParentStep, processEditPermission));
            }
        }
        if (action) {
            menuItems.push(OverflowMenu_1.default.item("Clone", function () { return _this.cloneStep(step, action); }, processEditPermission));
            menuItems.push(OverflowMenu_1.default.deleteItemDefault("step", function () { return _this.deleteStep(step, action); }, processEditPermission));
        }
        else {
            menuItems.push(OverflowMenu_1.default.item("Clone", function () { return _this.cloneStep(step); }, processEditPermission));
            menuItems.push(OverflowMenu_1.default.item("Delete", function () { return _this.deleteStep(step); }, processEditPermission));
        }
        if (!action) {
            menuItems.push(OverflowMenu_1.default.dialogItem("Reorder child steps", React.createElement(DeploymentPartSorter_1.default, { deploymentProcessId: this.state.project.DeploymentProcessId, title: "Reorder child steps", stepId: step.Id, saveDone: this.refreshData }), processEditPermission));
        }
        return menuItems;
    };
    DeploymentProcessOverviewInternal.prototype.deleteStep = function (step, action) {
        return __awaiter(this, void 0, void 0, function () {
            var deleteStep, actionIndex, stepIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deleteStep = false;
                        if (action) {
                            actionIndex = step.Actions.indexOf(action);
                            step.Actions.splice(actionIndex, 1);
                            deleteStep = step.Actions.length === 0;
                        }
                        else {
                            deleteStep = true;
                        }
                        if (deleteStep) {
                            stepIndex = this.state.deploymentProcess.Steps.indexOf(step);
                            this.state.deploymentProcess.Steps.splice(stepIndex, 1);
                        }
                        else {
                            if (step.Actions.length === 1) {
                                step.Name = step.Actions[0].Name;
                            }
                        }
                        return [4 /*yield*/, this.saveChanges()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    DeploymentProcessOverviewInternal.prototype.canHaveChildren = function (step) {
        return step.Actions.filter(function (a) {
            var actionDefinition = pluginRegistry_1.default.getDeploymentAction(a.ActionType);
            return actionDefinition.canHaveChildren(step);
        }).length > 0;
    };
    DeploymentProcessOverviewInternal.prototype.disableAll = function (step) {
        step.Actions.forEach(function (a) { return a.IsDisabled = true; });
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.enableAll = function (step) {
        step.Actions.forEach(function (a) { return a.IsDisabled = false; });
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.moveOut = function (step, action) {
        var newStep = {
            Id: null,
            Name: action.Name,
            PackageRequirement: step.PackageRequirement,
            Properties: step.Properties,
            Condition: step.Condition,
            StartTrigger: step.StartTrigger,
            Actions: [
                action
            ]
        };
        var name = newStep.Name;
        var i = 1;
        var isStep = function (s) { return s.Name === newStep.Name; };
        while (true) {
            if (!this.state.deploymentProcess.Steps.some(isStep)) {
                break;
            }
            newStep.Name = name + " " + i;
            i++;
        }
        var actionIndex = step.Actions.indexOf(action);
        step.Actions.splice(actionIndex, 1);
        if (step.Actions.length === 1) {
            step.Name = step.Actions[0].Name;
        }
        var stepIndex = this.state.deploymentProcess.Steps.indexOf(step);
        this.state.deploymentProcess.Steps.splice(stepIndex + 1, 0, newStep);
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.moveIn = function (step, action, parentStepId) {
        // Copy the action to the new step
        var newParent = this.state.deploymentProcess.Steps.find(function (s) { return s.Id === parentStepId; });
        newParent.Actions.splice(newParent.Actions.length, 0, action);
        // Remove action from the old step
        var actionIndex = step.Actions.indexOf(action);
        step.Actions.splice(actionIndex, 1);
        // Remove parent step if no actions left
        if (step.Actions.length === 0) {
            var stepIndex = this.state.deploymentProcess.Steps.indexOf(step);
            this.state.deploymentProcess.Steps.splice(stepIndex, 1);
        }
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.enable = function (action) {
        action.IsDisabled = false;
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.disable = function (action) {
        action.IsDisabled = true;
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.calculateDetailsUrl = function (id) {
        return routeLinks_1.default.project(this.state.project).process.step(id);
    };
    DeploymentProcessOverviewInternal.prototype.canMoveIn = function (stepId) {
        var _this = this;
        var currentStep = this.state.deploymentProcess.Steps.find(function (step) { return step.Id === stepId; });
        var isChildStep = this.canBeChildStep(currentStep);
        var hasParentStep = this.state.deploymentProcess.Steps.filter(function (step) { return step.Id !== stepId && _this.canHaveChildren(step); }).length > 0;
        return isChildStep && hasParentStep;
    };
    DeploymentProcessOverviewInternal.prototype.cloneStep = function (step, action) {
        var deploymentProcess = this.state.deploymentProcess;
        var nameOfActionExists = function (steps, actionName) {
            return steps.filter(function (s) { return s.Name === actionName || (s.Actions.filter(function (a) { return a.Name === actionName; }).length > 0); })
                .length > 0;
        };
        var getNewActionName = function (steps, clonedAction) {
            var suffix = "";
            var counter = 1;
            while (nameOfActionExists(steps, clonedAction.Name + suffix)) {
                suffix = " - clone (" + counter + ")";
                counter++;
            }
            return clonedAction.Name + suffix;
        };
        var stepNameExists = function (steps, stepName) {
            return steps.filter(function (s) { return s.Name === stepName; }).length > 0;
        };
        var getNewStepName = function (steps, clonedStep) {
            var suffix = "";
            var counter = 1;
            while (stepNameExists(steps, clonedStep.Name + suffix)) {
                suffix = " - clone (" + counter + ")";
                counter++;
            }
            return clonedStep.Name + suffix;
        };
        if (action && step.Actions.length > 1) {
            var clonedAction = JSON.parse(JSON.stringify(action));
            clonedAction.Id = "";
            clonedAction.Name = getNewActionName(deploymentProcess.Steps, clonedAction);
            var actionIndex = step.Actions.indexOf(action);
            step.Actions.splice(actionIndex + 1, 0, clonedAction);
        }
        else {
            var clonedStep_1 = JSON.parse(JSON.stringify(step));
            clonedStep_1.Id = "";
            clonedStep_1.Name = getNewStepName(deploymentProcess.Steps, clonedStep_1);
            clonedStep_1.Actions.forEach(function (a, index) {
                clonedStep_1.Actions[index].Id = "";
                clonedStep_1.Actions[index].Name = getNewActionName(deploymentProcess.Steps, clonedStep_1.Actions[index]);
            });
            var stepIndex = deploymentProcess.Steps.indexOf(step);
            var updatedSteps = deploymentProcess.Steps.splice(stepIndex + 1, 0, clonedStep_1);
        }
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.saveChanges = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var succeess;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.modify(this.state.deploymentProcess)];
                                    case 1:
                                        result = _a.sent();
                                        this.props.onProjectStepsUpdated(result.Steps ? result.Steps.length : null);
                                        this.setState({ deploymentProcess: result });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        succeess = _a.sent();
                        if (!!succeess) return [3 /*break*/, 3];
                        // since our changes mutate this.state.deploymentProcess then save, if we fail reload
                        return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            _a = this.setState;
                                            _b = {};
                                            return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.get(this.state.project.DeploymentProcessId)];
                                        case 1:
                                            _a.apply(this, [(_b.deploymentProcess = _c.sent(), _b)]);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, false)];
                    case 2:
                        // since our changes mutate this.state.deploymentProcess then save, if we fail reload
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DeploymentProcessOverviewInternal.prototype.getTags = function (action) {
        var _this = this;
        if (this.state.project.TenantedDeploymentMode === resources_1.TenantedDeploymentMode.Untenanted) {
            return [];
        }
        return action.TenantTags.map(function (name) { return _this.state.tagIndex[name]; });
    };
    DeploymentProcessOverviewInternal.prototype.addChildStepUrl = function (step) {
        return this.props.match.url + "/childsteptemplates/" + step.Id;
    };
    return DeploymentProcessOverviewInternal;
}(DataBaseComponent_1.DataBaseComponent));
var mapDispatchToProps = function (dispatch) {
    return {
        onProjectStepsUpdated: function (numberOfSteps) {
            dispatch(projectsArea_1.projectStepsUpdated(numberOfSteps));
        },
    };
};
var DeploymentProcessOverview = react_redux_1.connect(null, mapDispatchToProps)(DeploymentProcessOverviewInternal);
exports.default = DeploymentProcessOverview;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentProcessOverview.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentProcessOverview.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ExternalLink_1 = __webpack_require__(29);
var OnboardingPage_1 = __webpack_require__(719);
var Onboarding = function () {
    var panels = [
        {
            imageSrc: __webpack_require__(1836),
            imageWidth: 690,
            imageHeight: 345,
            imageAlt: "Built-in steps",
            description: React.createElement("div", null, "The Octopus built-in steps are powerful and flexible to handle the most common deployment scenarios, such as deploying an IIS Web Site or a Windows Service application.")
        },
        {
            imageSrc: __webpack_require__(1837),
            imageWidth: 690,
            imageHeight: 345,
            imageAlt: "Community steps",
            description: React.createElement("div", null, "Octopus Community Library integration makes it easy to find step templates that work with the frameworks and technologies you use without the need for custom scripting.")
        }
    ];
    return (React.createElement(OnboardingPage_1.default, { title: "Add steps to configure your deployment process", intro: "A deployment process specifies the steps to deploy an application, which allows you to deploy new versions consistently every time.", learnMore: React.createElement("p", null,
            "Learn more about ",
            React.createElement(ExternalLink_1.default, { href: "OnboardingAddStepsLearnMore" }, "adding steps"),
            "."), panels: panels }));
};
exports.default = Onboarding;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\Onboarding.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\Onboarding.tsx"); } } })();

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "onboarding-steps.c00ee331a6ae184027c9acbdc1c562c7.hashedasset.svg";

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "onboarding-communitysteps.a1c361a0401543e867f7e6cea476c73c.hashedasset.svg";

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var Logo_1 = __webpack_require__(291);
var InternalLink_1 = __webpack_require__(213);
var ActionList_1 = __webpack_require__(277);
var OverflowMenu_1 = __webpack_require__(209);
var index_1 = __webpack_require__(23);
var Tag_1 = __webpack_require__(280);
var FeatureToggle_1 = __webpack_require__(224);
var uiTestClasses_1 = __webpack_require__(77);
var index_2 = __webpack_require__(23);
var cn = __webpack_require__(19);
var fontWeights_1 = __webpack_require__(76);
var styles = __webpack_require__(207);
var DeploymentPart = (function (_super) {
    __extends(DeploymentPart, _super);
    function DeploymentPart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeploymentPart.prototype.render = function () {
        return React.createElement("div", { className: styles.deploymentPart },
            React.createElement("div", { className: styles.actionSummary },
                React.createElement("div", { className: styles.logo },
                    React.createElement(Logo_1.default, { url: this.props.logoUrl, isDisabled: this.props.isDisabled })),
                React.createElement("div", { className: cn(styles.content, this.props.isDisabled ? styles.disabled : null) },
                    React.createElement("div", { className: styles.contentHeader },
                        React.createElement("span", { className: styles.index }, this.props.index),
                        React.createElement(InternalLink_1.default, { to: this.props.detailsUrl, size: 17 / fontWeights_1.baseSizeInPx }, this.props.isDisabled
                            ? React.createElement("span", { className: "" + uiTestClasses_1.deploymentPartNameClass },
                                this.props.name,
                                " ",
                                React.createElement(index_2.DisabledChip, null))
                            : React.createElement("span", { className: uiTestClasses_1.deploymentPartNameClass }, this.props.name))),
                    React.createElement("div", { className: styles.contentBody },
                        this.props.children,
                        React.createElement("div", null,
                            this.props.environments && this.props.environments.map(function (e) { return React.createElement(index_1.EnvironmentChip, { key: e.Id, environmentName: e.Name }); }),
                            this.props.excludedEnvironments &&
                                this.props.excludedEnvironments.map(function (e) { return React.createElement(index_1.EnvironmentChip, { key: e.Id, environmentName: e.Name, isExcluded: true }); }),
                            this.props.channels && this.props.channels.map(function (ch) { return React.createElement(index_1.ChannelChip, { key: ch.Id, channelName: ch.Name }); }),
                            React.createElement(FeatureToggle_1.default, { feature: FeatureToggle_1.Feature.MultiTenancy, enabled: true }, this.props.tags && this.props.tags.map(function (tag) { return React.createElement(Tag_1.default, { key: tag.Id, description: tag.Description, tagName: tag.Name, tagColor: tag.Color }); }))))),
                React.createElement("div", { className: styles.contextualActions },
                    React.createElement(ActionList_1.default, { actions: [
                            this.props.mainAction,
                            React.createElement(OverflowMenu_1.default, { key: this.props.name + "-overflow", menuKey: this.props.name + "-overflow", menuItems: this.props.menuItems })
                        ].filter(function (a) { return !!a; }) }))));
    };
    return DeploymentPart;
}(BaseComponent_1.default));
exports.default = DeploymentPart;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentPart.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentPart.tsx"); } } })();

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__OQ0gg{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__3WVtt{display:none!important}}@media (max-width:79.9rem){.style_hide-md__1nJ-R{display:none!important}}@media (min-width:79.9rem){.style_visible-md__3amf3{display:none!important}}.style_deploymentPart__140yQ{min-height:5.1rem}.style_divider__18wfT{display:flex;align-items:center}.style_actionSummary__2r_NW{display:flex;flex-flow:row;padding-top:1rem;padding-bottom:1rem}.style_disabled__2CF7p *{color:#9e9e9e}.style_logo__1vCvZ{order:1}.style_content__1oScE{flex:4 0;order:2;margin-left:1rem}.style_contextualActions__2EraV{order:3}.style_actions__10Lga{margin-left:4.1rem;padding-left:0}.style_steps__2n-iJ{padding-left:1rem}.style_index__259qL{margin-right:1rem;font-size:1.0625rem}.style_contentHeader__tW9Nq{margin-bottom:.5rem;font-weight:500}.style_contentBody__1TO-I{font-size:.875rem}.style_environment__32zrj{text-align:right;padding-bottom:.25rem}.style_scriptModulesStatus__DWWLJ{font-size:.875rem;margin:0}.style_includedScriptModules__27G1I{list-style:disc inside;color:#2f93e0}.style_lifeCycleName__1V_RW{font-size:1rem;font-weight:600}.style_scriptModuleDescription__3OBWJ{margin-left:2.5rem;margin-top:.5rem;margin-bottom:.5rem;font-size:.875rem}.style_noteList__26od2{list-style-type:disc;padding:0 1rem;max-width:36rem}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__OQ0gg",
	"hideSm": "style_hide-sm__OQ0gg",
	"visible-sm": "style_visible-sm__3WVtt",
	"visibleSm": "style_visible-sm__3WVtt",
	"hide-md": "style_hide-md__1nJ-R",
	"hideMd": "style_hide-md__1nJ-R",
	"visible-md": "style_visible-md__3amf3",
	"visibleMd": "style_visible-md__3amf3",
	"deploymentPart": "style_deploymentPart__140yQ",
	"divider": "style_divider__18wfT",
	"actionSummary": "style_actionSummary__2r_NW",
	"disabled": "style_disabled__2CF7p",
	"logo": "style_logo__1vCvZ",
	"content": "style_content__1oScE",
	"contextualActions": "style_contextualActions__2EraV",
	"actions": "style_actions__10Lga",
	"steps": "style_steps__2n-iJ",
	"index": "style_index__259qL",
	"contentHeader": "style_contentHeader__tW9Nq",
	"contentBody": "style_contentBody__1TO-I",
	"environment": "style_environment__32zrj",
	"scriptModulesStatus": "style_scriptModulesStatus__DWWLJ",
	"includedScriptModules": "style_includedScriptModules__27G1I",
	"lifeCycleName": "style_lifeCycleName__1V_RW",
	"scriptModuleDescription": "style_scriptModuleDescription__3OBWJ",
	"noteList": "style_noteList__26od2"
};

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Targets_1 = __webpack_require__(694);
var TargetList = (function (_super) {
    __extends(TargetList, _super);
    function TargetList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TargetList.prototype.render = function () {
        var _this = this;
        return React.createElement(Targets_1.default, { targets: this.props.targets.map(function (target) { return _this.props.renderTarget(target); }) });
    };
    return TargetList;
}(React.Component));
exports.TargetList = TargetList;
exports.default = TargetList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\TargetList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\TargetList.tsx"); } } })();

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var SelectScriptModules_1 = __webpack_require__(1842);
var InternalLink_1 = __webpack_require__(42);
var LifecycleMap_1 = __webpack_require__(441);
var SelectLifecycle_1 = __webpack_require__(1843);
var OpenDialogButton_1 = __webpack_require__(74);
var resources_1 = __webpack_require__(26);
var PermissionCheck_1 = __webpack_require__(45);
var Callout_1 = __webpack_require__(59);
var styles = __webpack_require__(207);
var routeLinks_1 = __webpack_require__(20);
var Note_1 = __webpack_require__(22);
var SideBar = (function (_super) {
    __extends(SideBar, _super);
    function SideBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SideBar.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(PermissionCheck_1.default, { permission: resources_1.Permission.LifecycleView, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                    "The ",
                    resources_1.Permission.LifecycleView,
                    " permission is required to view the Lifecycle") }, this.props.lifecyclePreview && React.createElement("div", null,
                React.createElement("h4", null, "Lifecycle"),
                React.createElement(Note_1.default, null,
                    "Lifecycles can be defined in the ",
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.lifecycles }, "Library")),
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.lifecycle(this.props.lifecyclePreview.Id) },
                    React.createElement("span", { className: styles.lifeCycleName }, this.props.lifecyclePreview.Name)),
                React.createElement(LifecycleMap_1.default, { environmentsById: this.props.environmentsById, lifecyclePreview: this.props.lifecyclePreview }),
                React.createElement(OpenDialogButton_1.default, { label: "CHANGE", permission: {
                        permission: resources_1.Permission.ProcessEdit,
                        project: this.props.deploymentProcess.ProjectId,
                    } },
                    React.createElement(SelectLifecycle_1.default, { projectId: this.props.deploymentProcess.ProjectId, saveDone: function () { return _this.props.onDataChanged(); } })))),
            React.createElement("hr", null),
            React.createElement(PermissionCheck_1.default, { permission: resources_1.Permission.LibraryVariableSetView, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                    "The ",
                    resources_1.Permission.LibraryVariableSetView,
                    " permission is required to view any included script modules") }, this.props.includedScriptModules && React.createElement("div", null,
                React.createElement("h4", null, "Script modules"),
                this.hasScriptModules()
                    ? React.createElement("p", { className: styles.scriptModulesStatus }, "Included script modules:")
                    : React.createElement("div", null,
                        React.createElement("p", null, "No script modules have been included"),
                        React.createElement(Note_1.default, null,
                            "Modules can be created in the ",
                            React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.scripts.root }, "Library"))),
                React.createElement("ul", { className: styles.includedScriptModules }, this.props.includedScriptModules.map(function (sm) { return React.createElement("li", { key: sm.Id },
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.script(sm.Id) }, sm.Name)); })),
                React.createElement(OpenDialogButton_1.default, { label: this.hasScriptModules() ? "CHANGE" : "INCLUDE", permission: {
                        permission: resources_1.Permission.ProcessEdit,
                        project: this.props.deploymentProcess.ProjectId,
                    } },
                    React.createElement(SelectScriptModules_1.default, { projectId: this.props.deploymentProcess.ProjectId, saveDone: function () { return _this.props.onDataChanged(); } }))))));
    };
    SideBar.prototype.hasScriptModules = function () {
        return this.props.includedScriptModules.length > 0;
    };
    return SideBar;
}(BaseComponent_1.default));
exports.default = SideBar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SideBar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SideBar.tsx"); } } })();

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var form_1 = __webpack_require__(15);
var libraryVariableSetResource_1 = __webpack_require__(425);
var List_1 = __webpack_require__(279);
var InternalLink_1 = __webpack_require__(42);
var SaveDialogLayout_1 = __webpack_require__(105);
var styles = __webpack_require__(207);
var routeLinks_1 = __webpack_require__(20);
var InfoDialogLayout_1 = __webpack_require__(797);
var SimpleList_1 = __webpack_require__(430);
var ScriptModuleList = (function (_super) {
    __extends(ScriptModuleList, _super);
    function ScriptModuleList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ScriptModuleList;
}(List_1.List));
var ScriptModuleListSimple = (function (_super) {
    __extends(ScriptModuleListSimple, _super);
    function ScriptModuleListSimple() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ScriptModuleListSimple;
}(SimpleList_1.SimpleList));
var SelectScriptModules = (function (_super) {
    __extends(SelectScriptModules, _super);
    function SelectScriptModules(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectionChange = function (state) {
            _this.setState({ onlyCurrentlySelected: state, loaded: false }, function () { return _this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var scriptModules, currentlySelectedScriptModules;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!this.state.currentlySelectedScriptModules) return [3 /*break*/, 2];
                            return [4 /*yield*/, clientInstance_1.repository.LibraryVariableSets.all({ contentType: libraryVariableSetResource_1.VariableSetContentType.ScriptModule })];
                        case 1:
                            scriptModules = _a.sent();
                            currentlySelectedScriptModules = scriptModules
                                .filter(function (item) { return _this.state.originallySelected.includes(item.Id); });
                            this.setState({ currentlySelectedScriptModules: currentlySelectedScriptModules, loaded: true });
                            return [3 /*break*/, 3];
                        case 2:
                            this.setState({ loaded: true });
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); }); });
        };
        _this.renderList = function () {
            if (!_this.state.loaded) {
                return null;
            }
            if (_this.state.onlyCurrentlySelected) {
                return React.createElement(ScriptModuleListSimple, { filterHintText: "Filter by name or description", items: _this.state.currentlySelectedScriptModules, onFilter: _this.filter, onRow: _this.buildRow });
            }
            else {
                var additionalRequestParams = new Map();
                additionalRequestParams.set("contentType", libraryVariableSetResource_1.VariableSetContentType.ScriptModule);
                return React.createElement(ScriptModuleList, { filterHintText: "Filter by name or description", showPagingInNumberedStyle: true, initialData: _this.state.scriptModules, onRow: _this.buildRow, onFilter: _this.filter, filterSearchEnabled: true, apiSearchParams: ["partialName"], additionalRequestParams: additionalRequestParams });
            }
        };
        _this.renderCurrentlySelectedCheckbox = function () {
            if (!_this.state.loaded) {
                return null;
            }
            return React.createElement("div", { style: { width: "100%", display: "flex", flexDirection: "row-reverse", height: 0 } },
                React.createElement("div", { style: {
                        top: "1rem",
                        position: "relative"
                    } },
                    React.createElement(form_1.Checkbox, { label: "Only Currently Selected", value: _this.state.onlyCurrentlySelected, onChange: _this.handleSelectionChange })));
        };
        _this.filter = function (filter, item) {
            return item.Name.includes(filter) || item.Description.includes(filter);
        };
        _this.buildRow = function (item) {
            return React.createElement("div", null,
                React.createElement(form_1.Checkbox, { value: _this.state.project.IncludedLibraryVariableSetIds.includes(item.Id), label: item.Name, onChange: function (checked) { return _this.inclusionChanged(checked, item.Id); } }),
                item.Description && React.createElement("p", { className: styles.scriptModuleDescription }, item.Description));
        };
        _this.inclusionChanged = function (checked, id) {
            if (checked) {
                _this.setState(function (state) { return ({
                    project: __assign({}, state.project, { IncludedLibraryVariableSetIds: state.project.IncludedLibraryVariableSetIds.concat([id]) })
                }); });
            }
            else {
                _this.setState(function (state) { return ({
                    project: __assign({}, state.project, { IncludedLibraryVariableSetIds: state.project.IncludedLibraryVariableSetIds.filter(function (value) { return value !== id; }) })
                }); });
            }
        };
        _this.state = {
            loaded: false,
            scriptModules: null,
            currentlySelectedScriptModules: null,
            project: null,
            onlyCurrentlySelected: false,
            originallySelected: null,
        };
        return _this;
    }
    SelectScriptModules.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var _a, scriptModules, project;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, Promise.all([
                                        clientInstance_1.repository.LibraryVariableSets.list({ take: 8, contentType: libraryVariableSetResource_1.VariableSetContentType.ScriptModule }),
                                        clientInstance_1.repository.Projects.get(this.props.projectId)
                                    ])];
                                case 1:
                                    _a = _b.sent(), scriptModules = _a[0], project = _a[1];
                                    this.setState({ scriptModules: scriptModules, project: project, loaded: true, originallySelected: project.IncludedLibraryVariableSetIds });
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    SelectScriptModules.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.modify(this.state.project)];
                                case 1:
                                    _a.sent();
                                    this.props.saveDone();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    SelectScriptModules.prototype.render = function () {
        var _this = this;
        if (this.state.loaded && this.state.scriptModules.Items.length === 0) {
            return React.createElement(InfoDialogLayout_1.default, { title: "Include a Script Module", busy: this.state.busy, errors: this.state.errors },
                React.createElement("p", null,
                    React.createElement("strong", null, "The Library is empty."),
                    " Please, go to ",
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.scripts.root }, " the Library"),
                    " and add some script modules first."));
        }
        return React.createElement(SaveDialogLayout_1.default, { title: "Include a Script Module", busy: this.state.busy, errors: this.state.errors, onSaveClick: function () { return _this.save(); } },
            this.renderCurrentlySelectedCheckbox(),
            this.renderList());
    };
    return SelectScriptModules;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = SelectScriptModules;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SelectScriptModules.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SelectScriptModules.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var Select_1 = __webpack_require__(41);
var LifecycleMap_1 = __webpack_require__(441);
var SaveDialogLayout_1 = __webpack_require__(105);
var SelectLifecycle = (function (_super) {
    __extends(SelectLifecycle, _super);
    function SelectLifecycle(props) {
        var _this = _super.call(this, props) || this;
        _this.handleLifeCycleChange = function (value) {
            _this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.setChildState1("project", { LifecycleId: value });
                    return [2 /*return*/];
                });
            }); });
        };
        _this.state = {};
        return _this;
    }
    SelectLifecycle.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var _a, lifecycles, project, environmentsById, lifecyclePreviews;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, Promise.all([
                                        clientInstance_1.repository.Lifecycles.all(),
                                        clientInstance_1.repository.Projects.get(this.props.projectId),
                                        clientInstance_1.repository.Environments.allById()
                                    ])];
                                case 1:
                                    _a = _b.sent(), lifecycles = _a[0], project = _a[1], environmentsById = _a[2];
                                    return [4 /*yield*/, Promise.all(lifecycles.map(function (l) { return clientInstance_1.repository.Lifecycles.preview(l); }))];
                                case 2:
                                    lifecyclePreviews = _b.sent();
                                    this.setState({ lifecyclePreviews: lifecyclePreviews, project: project, environmentsById: environmentsById });
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    SelectLifecycle.prototype.save = function () {
        var _this = this;
        return this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.modify(this.state.project)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.saveDone()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    SelectLifecycle.prototype.render = function () {
        var _this = this;
        var body = this.state.project &&
            React.createElement("div", null,
                React.createElement(Select_1.default, { value: this.state.project.LifecycleId, onChange: this.handleLifeCycleChange, items: this.state.lifecyclePreviews.map(function (l) { return ({ value: l.Id, text: l.Name }); }), autoFocus: true, label: "Lifecycle" }),
                React.createElement(LifecycleMap_1.default, { environmentsById: this.state.environmentsById, lifecyclePreview: this.state.lifecyclePreviews.find(function (l) { return l.Id === _this.state.project.LifecycleId; }), showDescription: true }));
        return React.createElement(SaveDialogLayout_1.default, { title: "Change lifecycle", busy: this.state.busy, errors: this.state.errors, onSaveClick: function () { return _this.save(); } }, body);
    };
    return SelectLifecycle;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = SelectLifecycle;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SelectLifecycle.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SelectLifecycle.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var SortableList_1 = __webpack_require__(728);
var SaveDialogLayout_1 = __webpack_require__(105);
var DataBaseComponent_1 = __webpack_require__(39);
var DeploymentPartSorter = (function (_super) {
    __extends(DeploymentPartSorter, _super);
    function DeploymentPartSorter(props) {
        var _this = _super.call(this, props) || this;
        _this.stepsOrderChanged = function (Steps) {
            _this.setChildState1("deploymentProcess", { Steps: Steps });
        };
        _this.actionsOrderChanged = function (actions) {
            _this.setState(function (state) {
                var steps = state.deploymentProcess.Steps.slice();
                var index = steps.findIndex(function (s) { return s.Id === _this.props.stepId; });
                steps[index] = __assign({}, steps[index], { Actions: actions });
                return {
                    deploymentProcess: __assign({}, state.deploymentProcess, { Steps: steps })
                };
            });
        };
        _this.state = {
            deploymentProcess: null
        };
        return _this;
    }
    DeploymentPartSorter.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var deploymentProcess;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.get(this.props.deploymentProcessId)];
                                case 1:
                                    deploymentProcess = _a.sent();
                                    this.setState({ deploymentProcess: deploymentProcess });
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    DeploymentPartSorter.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.modify(this.state.deploymentProcess)];
                                case 1:
                                    _a.sent();
                                    this.props.saveDone();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    DeploymentPartSorter.prototype.render = function () {
        var _this = this;
        var deploymentProcess = this.state.deploymentProcess;
        var body = deploymentProcess &&
            React.createElement(SortableList_1.default, { onOrderChanged: this.props.stepId ? this.actionsOrderChanged : this.stepsOrderChanged, items: this.props.stepId
                    ? this.getStep(deploymentProcess.Steps, this.props.stepId).Actions
                    : deploymentProcess.Steps });
        return React.createElement(SaveDialogLayout_1.default, { title: this.props.title, busy: this.state.busy, errors: this.state.errors, onSaveClick: function () { return _this.save(); } }, body);
    };
    DeploymentPartSorter.prototype.getStep = function (steps, stepId) {
        return steps.filter(function (s) { return s.Id === stepId; })[0];
    };
    return DeploymentPartSorter;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = DeploymentPartSorter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentPartSorter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentPartSorter.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Select_1 = __webpack_require__(41);
var Callout_1 = __webpack_require__(59);
var specialVariables_1 = __webpack_require__(47);
var DataBaseComponent_1 = __webpack_require__(39);
var OkDialogLayout_1 = __webpack_require__(107);
var SelectParentStep = (function (_super) {
    __extends(SelectParentStep, _super);
    function SelectParentStep(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedStepId: null
        };
        return _this;
    }
    SelectParentStep.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { title: "Move into Parent Step", busy: this.state.busy, errors: this.state.errors, onOkClick: function () { return _this.onOk(); } },
            React.createElement("p", null,
                "Move the step ",
                React.createElement("strong", null, this.props.actionName),
                " into the new parent step:"),
            this.changeToTargetRoles() &&
                React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning, title: "Confirm target role change" }, "This step previously targeted a different set of roles than the step you are moving it to. This means the step is now likely to run on a different set of machines. Are you sure you wish to move the step?"),
            React.createElement(Select_1.default, { label: "Select step", value: this.state.selectedStepId, error: this.state.errors && this.state.errors.fieldErrors.selectedStepId, items: this.props.steps.map(function (s) { return ({ value: s.Id, text: s.Name }); }), onChange: function (stepId) { return _this.setState({ selectedStepId: stepId, errors: null }); }, allowClear: true }));
    };
    SelectParentStep.prototype.onOk = function () {
        if (!this.state.selectedStepId) {
            this.setState({
                errors: {
                    message: "Please select a step",
                    details: null,
                    fieldErrors: { selectedStepId: "Select a step" }
                }
            });
            return false;
        }
        this.props.onStepSelected(this.state.selectedStepId);
        return true;
    };
    SelectParentStep.prototype.changeToTargetRoles = function () {
        var _this = this;
        return this.state.selectedStepId &&
            this.props.currentlyTargetedRoles !== this.props.steps.find(function (s) { return s.Id === _this.state.selectedStepId; }).Properties[specialVariables_1.default.Action.TargetRoles];
    };
    return SelectParentStep;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = SelectParentStep;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SelectParentStep.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SelectParentStep.tsx"); } } })();

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var resources_1 = __webpack_require__(26);
var pluginRegistry_1 = __webpack_require__(18);
var lodash_1 = __webpack_require__(16);
var clientInstance_1 = __webpack_require__(10);
var PaperLayout_1 = __webpack_require__(117);
var DataBaseComponent_1 = __webpack_require__(167);
var permission_1 = __webpack_require__(49);
var PermissionCheck_1 = __webpack_require__(45);
var tenantTagsets = __webpack_require__(138);
var ActionDetails_1 = __webpack_require__(27);
var ParentStepDetails_1 = __webpack_require__(1877);
var StringHelper_1 = __webpack_require__(211);
var routeLinks_1 = __webpack_require__(20);
var StepDetailsLoader = (function (_super) {
    __extends(StepDetailsLoader, _super);
    function StepDetailsLoader(props) {
        var _this = _super.call(this, props) || this;
        _this.load = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var found, action, step, project, _a, environments, machineRoles, feeds, tagIndex, lookups, _b, getTemplate, _c, channels, actionTemplate, isNewChildStep, stepIndex, isNotFirstStep;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.match.params.projectSlug)];
                    case 1:
                        project = _d.sent();
                        return [4 /*yield*/, Promise.all([
                                clientInstance_1.repository.Environments.all(),
                                clientInstance_1.repository.MachineRoles.all(),
                                PermissionCheck_1.isAllowed({ permission: permission_1.Permission.FeedView, project: project.Id, wildcard: true }) ? clientInstance_1.repository.Feeds.all() : [],
                                tenantTagsets.getTagIndex()
                            ])];
                    case 2:
                        _a = _d.sent(), environments = _a[0], machineRoles = _a[1], feeds = _a[2], tagIndex = _a[3];
                        lookups = {
                            environments: environments,
                            availableRoles: machineRoles,
                            feeds: feeds,
                            project: project,
                            tagIndex: tagIndex
                        };
                        _b = lookups;
                        return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.get(lookups.project.DeploymentProcessId)];
                    case 3:
                        _b.deploymentProcess = _d.sent();
                        if (!this.props.match.params.actionType) {
                            found = this.findAction(lookups.deploymentProcess, this.props.match.params.stepId);
                        }
                        getTemplate = this.props.match.params.template
                            ? clientInstance_1.repository.ActionTemplates.get(this.props.match.params.template)
                            : found && found.action.Properties["Octopus.Action.Template.Id"]
                                ? clientInstance_1.repository.ActionTemplates.get(found.action.Properties["Octopus.Action.Template.Id"])
                                : Promise.resolve(null);
                        return [4 /*yield*/, Promise.all([
                                clientInstance_1.repository.Projects.getChannels(project),
                                getTemplate
                            ])];
                    case 4:
                        _c = _d.sent(), channels = _c[0], actionTemplate = _c[1];
                        lookups.channels = channels.Items;
                        lookups.actionTemplate = actionTemplate;
                        if (!this.props.match.params.actionType) {
                            if (found) {
                                step = found.step;
                                action = found.action;
                                //pageTitle(that.step.Name);
                            }
                            else {
                                step = lodash_1.find(lookups.deploymentProcess.Steps, function (s) { return s.Id === _this.props.match.params.stepId; });
                                action = null;
                                //pageTitle(that.step.Name);
                            }
                        }
                        else {
                            if (this.props.match.params.stepId) {
                                step = lodash_1.find(lookups.deploymentProcess.Steps, function (s) {
                                    return s.Id === _this.props.match.params.stepId;
                                });
                                if (step) {
                                    action = {
                                        Id: null,
                                        ActionType: this.props.match.params.actionType,
                                        Name: "",
                                        Environments: [],
                                        ExcludedEnvironments: [],
                                        Channels: [],
                                        TenantTags: [],
                                        Properties: {},
                                        IsDisabled: false,
                                        Links: null
                                    };
                                }
                                //pageTitle("New step for: " + step.Name);
                            }
                            if (!step) {
                                step = {
                                    Id: null,
                                    Name: "",
                                    Properties: {},
                                    Condition: "Success",
                                    StartTrigger: "StartAfterPrevious",
                                    PackageRequirement: "LetOctopusDecide",
                                    Actions: [
                                        {
                                            Id: null,
                                            ActionType: this.props.match.params.actionType,
                                            Name: "",
                                            Environments: [],
                                            ExcludedEnvironments: [],
                                            Channels: [],
                                            TenantTags: [],
                                            Properties: {},
                                            IsDisabled: false,
                                            Links: null
                                        }
                                    ]
                                };
                                action = step.Actions[0];
                                //pageTitle("New step");
                            }
                            if (lookups.actionTemplate) {
                                action.Name = step.Name = lookups.actionTemplate.Name;
                                action.Properties = lodash_1.clone(lookups.actionTemplate.Properties);
                                action.Properties["Octopus.Action.Template.Id"] = lookups.actionTemplate.Id;
                                action.Properties["Octopus.Action.Template.Version"] = lookups.actionTemplate.Version;
                                lookups.actionTemplate.Parameters.forEach(function (parameter) {
                                    if (typeof parameter.DefaultValue !== "undefined" && parameter.DefaultValue !== null && parameter.DefaultValue !== "") {
                                        if (parameter.DisplaySettings["Octopus.ControlType"] === "Sensitive") {
                                            if (typeof parameter.DefaultValue === "object") {
                                                action.Properties[parameter.Name] = {
                                                    HasValue: true,
                                                    NewValue: null,
                                                    IsSensitive: true
                                                };
                                            }
                                            else {
                                                action.Properties[parameter.Name] = {
                                                    HasValue: true,
                                                    NewValue: parameter.DefaultValue,
                                                    IsSensitive: true
                                                };
                                            }
                                            return;
                                        }
                                        action.Properties[parameter.Name] = parameter.DefaultValue;
                                    }
                                });
                            }
                        }
                        if (!!action) {
                            // Provide default fallback for script templates.
                            if (action.ActionType === "Octopus.Script" && action.Properties && action.Properties["Octopus.Action.RunOnServer"] == null) {
                                action.Properties["Octopus.Action.RunOnServer"] = "false";
                            }
                            lookups.isNew = (!action.Name);
                            lookups.plugin = pluginRegistry_1.default.getDeploymentAction(action.ActionType);
                            if (lookups.isNew && this.pluginHasPackages(lookups.plugin, action) && lookups.feeds.length === 0) {
                                throw new Error("A NuGet package feed is required before that step can be configured. Please add a feed in the Configuration area and try again.");
                            }
                            // If the execution location is optional, default it to run on the target
                            if (lookups.isNew && lookups.plugin.executionLocation === resources_1.ActionExecutionLocation.TargetOrServer) {
                                action.Properties["Octopus.Action.RunOnServer"] = "false";
                            }
                            // If the execution location is locked, clean up the mess we've made by accidentally setting "Octopus.Action.RunOnServer" for all actions
                            if (lookups.plugin.executionLocation !== resources_1.ActionExecutionLocation.TargetOrServer) {
                                delete action.Properties["Octopus.Action.RunOnServer"];
                            }
                            lookups.hasFeatures = pluginRegistry_1.default.hasFeaturesForAction(action.ActionType);
                            isNewChildStep = lookups.isNew && !!this.props.match.params.stepId;
                            lookups.isChildStep = step.Actions.length > 1 || isNewChildStep;
                        }
                        stepIndex = lookups.deploymentProcess.Steps.indexOf(step);
                        isNotFirstStep = (stepIndex > 0 || (stepIndex < 0 && lookups.deploymentProcess.Steps.length > 0));
                        lookups.isFirstStep = !isNotFirstStep;
                        // If we DON'T have an action, or the action does NOT have packages, we canRunBeforeAcquisition
                        lookups.canRunBeforeAcquisition = !action || !this.pluginHasPackages(pluginRegistry_1.default.getDeploymentAction(action.ActionType), action);
                        lookups.deploymentProcess.Steps.forEach(function (s, i) {
                            if (!lookups.canRunBeforeAcquisition) {
                                return;
                            }
                            if (i <= stepIndex || stepIndex < 0) {
                                var hasPackages = s.Actions.some(function (a) {
                                    var actionDefinition = pluginRegistry_1.default.getDeploymentAction(a.ActionType);
                                    return actionDefinition && _this.pluginHasPackages(actionDefinition, a);
                                });
                                if (hasPackages) {
                                    lookups.canRunBeforeAcquisition = false;
                                }
                            }
                        });
                        if (step.Condition === null || step.Condition === "") {
                            step.Condition = resources_1.RunCondition.Success;
                        }
                        this.setState(__assign({}, lookups, { action: action,
                            step: step }));
                        return [2 /*return*/];
                }
            });
        }); };
        _this.findAction = function (deploymentProcess, id) {
            for (var i = 0; i < deploymentProcess.Steps.length; i++) {
                var step = deploymentProcess.Steps[i];
                for (var j = 0; j < step.Actions.length; j++) {
                    var action = step.Actions[j];
                    if (action.Id === id) {
                        return { action: action, step: step, actionIndex: j, stepIndex: i };
                    }
                }
            }
            return null;
        };
        _this.runsOnServer = function (action, executionLocation) {
            return action && executionLocation &&
                (executionLocation === resources_1.ActionExecutionLocation.AlwaysOnServer ||
                    (executionLocation === resources_1.ActionExecutionLocation.TargetOrServer && action.Properties["Octopus.Action.RunOnServer"] === "true"));
        };
        _this.state = {};
        return _this;
    }
    StepDetailsLoader.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.load()];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    StepDetailsLoader.prototype.render = function () {
        if (this.state && this.state.action) {
            return React.createElement(ActionDetails_1.default, __assign({}, this.props, this.state));
        }
        if (this.state && this.state.step) {
            return React.createElement(ParentStepDetails_1.default, __assign({}, this.props, this.state, { step: this.state.step }));
        }
        return React.createElement(PaperLayout_1.default, { title: StringHelper_1.default.ellipsis, breadcrumbTitle: "Process", breadcrumbPath: this.state.project ? routeLinks_1.default.project(this.state.project).process.root : null, busy: this.state ? this.state.busy : null, errors: this.state ? this.state.errors : null },
            React.createElement("div", null));
    };
    StepDetailsLoader.prototype.pluginHasPackages = function (actionDefinition, action) {
        return actionDefinition.hasPackages ? actionDefinition.hasPackages(action) : false;
    };
    return StepDetailsLoader;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = StepDetailsLoader;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\StepDetailsLoader.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\StepDetailsLoader.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConfirmationDialog_1 = __webpack_require__(734);
var React = __webpack_require__(0);
var PromiseConfirmationDialog = function (props) {
    var deferred = props.deferred, children = props.children, otherProps = __rest(props, ["deferred", "children"]);
    return (React.createElement(ConfirmationDialog_1.default, __assign({ open: deferred && !deferred.resolved, onClose: function () { return deferred.resolve(false); }, onContinueClick: function () { return deferred.resolve(true); } }, otherProps), props.children));
};
var Deferred = (function () {
    function Deferred() {
        var _this = this;
        this.resolved = false;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = function (value) {
                if (_this.resolved) {
                    return;
                }
                _this.resolved = true;
                resolve(value);
            };
            _this.reject = function (reason) {
                if (_this.resolved) {
                    return;
                }
                _this.resolved = true;
                reject(reason);
            };
        });
    }
    return Deferred;
}());
exports.Deferred = Deferred;
exports.default = PromiseConfirmationDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\PromiseConfirmationDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Dialog\\PromiseConfirmationDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ParseHelper_1 = __webpack_require__(422);
var Markdown_1 = __webpack_require__(136);
var SimpleDataTable_1 = __webpack_require__(284);
var ActionPropertyTable_1 = __webpack_require__(1849);
var ActionButton_1 = __webpack_require__(50);
var Callout_1 = __webpack_require__(59);
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var ActionTemplateParameterInput_1 = __webpack_require__(396);
var form_1 = __webpack_require__(15);
var BaseComponent_1 = __webpack_require__(14);
var react_router_1 = __webpack_require__(69);
var lodash_1 = __webpack_require__(16);
var DeploymentProcessRoute_1 = __webpack_require__(297);
var InternalLink_1 = __webpack_require__(213);
var routeLinks_1 = __webpack_require__(20);
var Note_1 = __webpack_require__(22);
var ActionTemplateParameterInputExpandableFormElement_1 = __webpack_require__(772);
var InternalRedirect_1 = __webpack_require__(40);
var ActionTemplateEditor = (function (_super) {
    __extends(ActionTemplateEditor, _super);
    function ActionTemplateEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.resolveTable = function () {
            return React.createElement(SimpleDataTable_1.default, { data: _this.props.actionTemplate.Parameters, headerColumns: ["Property Name", "Current Property Value", "New Property Value"], onRow: _this.buildRow });
        };
        _this.buildRow = function (parameter) {
            return [
                React.createElement("span", null, parameter.Label || parameter.Name),
                _this.state.currentPropertyValues[parameter.Name],
                React.createElement("div", null,
                    React.createElement(ActionTemplateParameterInput_1.default, { parameter: parameter, doBusyTask: _this.props.doBusyTask, value: _this.state.overrides[parameter.Name], sourceItems: _this.state.sourceItems, onChange: function (x) { return _this.handleParameterInputChanged(parameter.Name, x); } }),
                    React.createElement(Note_1.default, null,
                        React.createElement(Markdown_1.default, { markup: parameter.HelpText })))
            ];
        };
        _this.handleParameterInputChanged = function (name, value) {
            _this.setState(function (state) {
                return ({ overrides: __assign({}, state.overrides, (_a = {}, _a[name] = value, _a)) });
                var _a;
            });
        };
        _this.resolveConflicts = function () {
            _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var overrides, actionIdsByProcessId, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            overrides = __assign({}, this.state.overrides);
                            this.props.actionTemplate.Parameters.forEach(function (p) {
                                if (overrides[p.Name] === undefined) {
                                    overrides[p.Name] = null;
                                }
                            });
                            this.setState({ overrides: overrides });
                            actionIdsByProcessId = {};
                            actionIdsByProcessId[this.props.process.Id] = [this.props.actionId];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, clientInstance_1.repository.ActionTemplates.updateActions(this.props.actionTemplate, actionIdsByProcessId, null, overrides)];
                        case 2:
                            _a.sent();
                            this.reloadThePage();
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            if (error_1.StatusCode !== 400) {
                                throw error_1;
                            }
                            this.setState({ manualMergeRequired: true });
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.mergeLatest = function () {
            _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var actionIdsByProcessId, error_2, overrides_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            actionIdsByProcessId = {};
                            actionIdsByProcessId[this.props.process.Id] = [this.props.actionId];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, clientInstance_1.repository.ActionTemplates.updateActions(this.props.actionTemplate, actionIdsByProcessId)];
                        case 2:
                            _a.sent();
                            this.reloadThePage();
                            return [3 /*break*/, 4];
                        case 3:
                            error_2 = _a.sent();
                            if (error_2.StatusCode !== 400) {
                                throw error_2;
                            }
                            overrides_1 = {};
                            this.props.actionTemplate.Parameters.forEach(function (p) {
                                var propertyValue = _this.props.properties[p.Name];
                                if (propertyValue !== undefined) {
                                    overrides_1[p.Name] = propertyValue;
                                }
                            });
                            this.setState({ overrides: overrides_1, manualMergeRequired: true });
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        };
        var version = ParseHelper_1.default.safeParseInt(_this.props.properties["Octopus.Action.Template.Version"]);
        var currentPropertyValues = {};
        lodash_1.each(_this.props.properties, function (propertyValue, propertyName) {
            currentPropertyValues[propertyName] = _this.isPropertySensitive(propertyValue)
                ? "******"
                : propertyValue;
        });
        var stepNames = props.process ? lodash_1.flatten(props.process.Steps.map(function (a) { return a.Actions.map(function (action) { return action.Name; }); })) : [];
        _this.state = {
            manualMergeRequired: false,
            isUpToDate: _this.props.actionTemplate.Version === version,
            version: version,
            actionTemplateVersion: null,
            currentPropertyValues: currentPropertyValues,
            sourceItems: { stepNames: stepNames, projectId: _this.props.projectId },
            overrides: {},
            redirectTo: null
        };
        return _this;
    }
    ActionTemplateEditor.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var versionGetter, actionTemplateVersion, error_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                versionGetter = this.state.isUpToDate
                                    ? Promise.resolve(this.props.actionTemplate)
                                    : clientInstance_1.repository.ActionTemplates.getVersion(this.props.actionTemplate, this.state.version);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, versionGetter];
                            case 2:
                                actionTemplateVersion = _a.sent();
                                this.setState({ actionTemplateVersion: actionTemplateVersion });
                                return [3 /*break*/, 4];
                            case 3:
                                error_3 = _a.sent();
                                if (error_3.StatusCode !== 404) {
                                    throw error_3;
                                }
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    ActionTemplateEditor.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: false });
        }
        return React.createElement("div", null,
            React.createElement(form_1.FormSectionHeading, { title: this.props.actionTemplate.Name }),
            React.createElement(form_1.UnstructuredFormSection, null,
                React.createElement("span", null,
                    "This step is based on a ",
                    this.props.actionTemplate.CommunityActionTemplateId ? "community" : "custom",
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.stepTemplate(this.props.actionTemplate.Id).root },
                        React.createElement("strong", null,
                            " ",
                            this.props.actionTemplate.Name,
                            " ")),
                    "step template.")),
            !this.state.manualMergeRequired && !this.state.isUpToDate && React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Danger },
                React.createElement("strong", null, "This step is out of date."),
                React.createElement("br", null),
                "'",
                this.props.actionTemplate.Name,
                "' step template has changed since this step was configured. Update now to merge the latest changes.",
                React.createElement("br", null),
                !this.state.actionTemplateVersion && React.createElement("p", null,
                    "Version '",
                    this.state.version,
                    "' of '",
                    this.props.actionTemplate.Name,
                    "' step template is not available and properties can only be displayed in read-only mode. To start storing all versions of '",
                    this.props.actionTemplate.Name,
                    "' step template and safely update automatically in the future, update to the latest version now."),
                React.createElement(ActionButton_1.default, { type: ActionButton_1.ActionButtonType.Secondary, label: "Update", busyLabel: "Updating...", onClick: this.mergeLatest })),
            !this.state.manualMergeRequired && !this.state.actionTemplateVersion &&
                React.createElement(ActionPropertyTable_1.default, { actionProperties: this.props.properties, currentPropertyValues: this.state.currentPropertyValues }),
            !this.state.manualMergeRequired && this.state.actionTemplateVersion && React.createElement("div", null, this.state.actionTemplateVersion.Parameters.map(function (parameter) {
                return React.createElement(ActionTemplateParameterInputExpandableFormElement_1.default, { parameter: parameter, key: parameter.Name, projectId: _this.props.projectId, localNames: _this.props.localNames, value: _this.props.properties[parameter.Name], doBusyTask: _this.props.doBusyTask, sourceItems: _this.state.sourceItems, onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a[parameter.Name] = x, _a));
                        var _a;
                    } });
            })),
            this.state.manualMergeRequired && React.createElement("div", null,
                React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Warning },
                    "Unfortunately the step must be updated manually because we don't have enough information to do it automatically. Please, review carefully the new property values below and confirm them when you are ready.",
                    React.createElement("br", null),
                    React.createElement(ActionButton_1.default, { type: ActionButton_1.ActionButtonType.Secondary, label: "Confirm", onClick: this.resolveConflicts })),
                this.resolveTable()));
    };
    ActionTemplateEditor.prototype.reloadThePage = function () {
        var currentPath = this.props.location.pathname;
        var reloadKey = this.props.match.params.reloadKey;
        var path = DeploymentProcessRoute_1.DeploymentProcessRoute.nextStepReloadPath(currentPath, reloadKey);
        this.setState({ redirectTo: path });
    };
    ActionTemplateEditor.prototype.isPropertySensitive = function (property) {
        return Object.prototype.toString.call(property) === "[object Object]";
    };
    return ActionTemplateEditor;
}(BaseComponent_1.BaseComponent));
var Editor = react_router_1.withRouter(ActionTemplateEditor);
exports.default = Editor;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplateEditor\\ActionTemplateEditor.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplateEditor\\ActionTemplateEditor.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var SimpleDataTable_1 = __webpack_require__(284);
var ActionPropertyTable = function (props) {
    var data = Object.keys(props.actionProperties).map(function (ap) { return ({ name: ap, value: props.currentPropertyValues[ap] }); });
    return React.createElement(SimpleDataTable_1.default, { data: data, headerColumns: ["Property Name", "Property Value"], onRow: buildRow });
};
var buildRow = function (dataPoint) {
    return [
        dataPoint.name,
        dataPoint.value,
    ];
};
exports.default = ActionPropertyTable;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplateEditor\\ActionPropertyTable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplateEditor\\ActionPropertyTable.tsx"); } } })();

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var CertificateSearch_1 = __webpack_require__(747);
var OkDialogLayout_1 = __webpack_require__(107);
var DataBaseComponent_1 = __webpack_require__(39);
var CertificateSelector = (function (_super) {
    __extends(CertificateSelector, _super);
    function CertificateSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            certificate: null
        };
        return _this;
    }
    CertificateSelector.prototype.onOk = function () {
        this.props.onSelected(this.state.certificate);
        return true;
    };
    CertificateSelector.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { title: "Select Certificate", busy: this.state.busy, errors: this.state.errors, onOkClick: function () { return _this.onOk(); } },
            React.createElement(CertificateSearch_1.default, { selectedCertificateId: this.props.selectedCertificateId, tenantId: this.props.tenantId, onSelected: function (certificate) { return _this.setState({ certificate: certificate }); }, doBusyTask: this.doBusyTask }));
    };
    return CertificateSelector;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = CertificateSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\CertificateSelect\\CertificateSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\CertificateSelect\\CertificateSelector.tsx"); } } })();

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(23);
var colors_1 = __webpack_require__(32);
var account_box_1 = __webpack_require__(799);
var fingerprint_1 = __webpack_require__(771);
var info_outline_1 = __webpack_require__(800);
var index_2 = __webpack_require__(216);
var ListTitle_1 = __webpack_require__(276);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var styles = __webpack_require__(1852);
var ThumbprintText_1 = __webpack_require__(449);
var MarkdownDescription_1 = __webpack_require__(214);
var fontWeights_1 = __webpack_require__(76);
var CertificateSummary = function (props) {
    var certificate = props.certificate;
    return React.createElement("div", { className: styles.container, onClick: props.onClick },
        props.showSelection && React.createElement("div", { className: styles.select },
            React.createElement(RadioButtonGroup_1.default, { value: props.selected, onChange: null },
                React.createElement(RadioButton_1.default, { value: true }))),
        React.createElement("div", { className: styles.summary },
            React.createElement("div", { className: styles.titleContainer },
                React.createElement("div", { className: styles.title },
                    React.createElement(ListTitle_1.default, null, certificate.Name)),
                React.createElement("div", { className: styles.details },
                    React.createElement("span", { className: styles.icon }, certificate.CertificateChain.length > 0 && React.createElement("em", { className: "fa fa-chain", title: "Contains a certificate chain" })),
                    React.createElement("span", { className: styles.icon }, certificate.HasPrivateKey && React.createElement("em", { className: "fa fa-key", title: "Contains a private-key" })),
                    React.createElement(index_1.CertificateExpiryChip, { certificate: certificate }))),
            certificate.Notes && React.createElement("div", { className: styles.row },
                React.createElement(MarkdownDescription_1.default, { markup: certificate.Notes })),
            React.createElement("div", { className: styles.row, style: { fontWeight: fontWeights_1.normal } },
                React.createElement("div", { className: styles.propertyContainer },
                    React.createElement("span", null,
                        React.createElement(info_outline_1.default, { color: colors_1.primaryText, style: { width: "16px", height: "16px" } })),
                    React.createElement("span", null, certificate.SubjectCommonName || certificate.SubjectOrganization || certificate.SubjectDistinguishedName)),
                React.createElement("div", { className: styles.propertyContainer },
                    React.createElement("span", null,
                        React.createElement(account_box_1.default, { color: colors_1.primaryText, style: { width: "16px", height: "16px" } })),
                    React.createElement("span", null, certificate.SelfSigned ? ("Self-Signed") : (certificate.IssuerCommonName || certificate.IssuerOrganization || certificate.IssuerDistinguishedName))),
                React.createElement("div", { className: styles.propertyContainer },
                    React.createElement("span", null,
                        React.createElement(fingerprint_1.default, { color: colors_1.primaryText, style: { width: "16px", height: "16px" } })),
                    React.createElement(ThumbprintText_1.default, { thumbprint: certificate.Thumbprint }))),
            React.createElement("div", { className: styles.row },
                React.createElement("span", null, index_1.environmentChipList(props.environments, certificate.EnvironmentIds)),
                (!!certificate.TenantIds.length || !!certificate.TenantTags.length) && React.createElement("span", null,
                    index_1.tenantChipList(props.tenants, certificate.TenantIds),
                    certificate.TenantTags.map(function (tt) {
                        var result = props.tenantTags.find(function (t) { return !!t.Tags.find(function (tag) { return tag.CanonicalTagName === tt; }); });
                        if (result) {
                            var fu = result.Tags.find(function (tag) { return tag.CanonicalTagName === tt; });
                            return React.createElement(index_2.default, { key: fu.Id, description: fu.Description, tagName: fu.Name, tagColor: fu.Color });
                        }
                    })))));
};
exports.default = CertificateSummary;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\CertificateSearch\\CertificateSummary.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\CertificateSearch\\CertificateSummary.tsx"); } } })();

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1853);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__2wjRD{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2MnDs{display:none!important}}@media (max-width:79.9rem){.style_hide-md__165Gg{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2eyR8{display:none!important}}.style_container__2gDxh{display:flex;flex-direction:row;align-items:flex-start}.style_select__F6zV8{display:flex;justify-content:center;align-items:center;flex:0 0 auto}.style_summary__S_TBQ{display:flex;flex-direction:column;justify-content:space-between;align-items:flex-start;flex:1 1 100%}.style_row__1Veoa{display:flex;flex-wrap:wrap;align-items:center;width:100%}.style_row__1Veoa:last-child{margin-top:.5rem}.style_titleContainer__3R39k{display:flex;flex-direction:row;width:100%}.style_title__1AHNH{width:100%}.style_details__11prN{display:flex;flex-direction:row}.style_icon__1mnue{padding:0 0 0 .4rem;align-self:center}.style_propertyContainer__1YqQN{padding:.4rem .4rem 0 0;display:flex;color:#333;font-size:.875rem}.style_propertyContainer__1YqQN span:nth-child(2){margin-left:.25rem;margin-right:.75rem}.style_propertyContainer__1YqQN+.style_thumbprint__2NMpH{font-weight:400}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__2wjRD",
	"hideSm": "style_hide-sm__2wjRD",
	"visible-sm": "style_visible-sm__2MnDs",
	"visibleSm": "style_visible-sm__2MnDs",
	"hide-md": "style_hide-md__165Gg",
	"hideMd": "style_hide-md__165Gg",
	"visible-md": "style_visible-md__2eyR8",
	"visibleMd": "style_visible-md__2eyR8",
	"container": "style_container__2gDxh",
	"select": "style_select__F6zV8",
	"summary": "style_summary__S_TBQ",
	"row": "style_row__1Veoa",
	"titleContainer": "style_titleContainer__3R39k",
	"title": "style_title__1AHNH",
	"details": "style_details__11prN",
	"icon": "style_icon__1mnue",
	"propertyContainer": "style_propertyContainer__1YqQN",
	"thumbprint": "style_thumbprint__2NMpH"
};

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1855);
var ThumbprintText = (function (_super) {
    __extends(ThumbprintText, _super);
    function ThumbprintText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThumbprintText.prototype.render = function () {
        return React.createElement("span", { className: styles.thumbprint }, this.props.thumbprint);
    };
    return ThumbprintText;
}(React.PureComponent));
exports.default = ThumbprintText;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ThumbprintText\\ThumbprintText.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ThumbprintText\\ThumbprintText.tsx"); } } })();

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1856);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_thumbprint__EjJv1{font-weight:500}", ""]);

// exports
exports.locals = {
	"thumbprint": "style_thumbprint__EjJv1"
};

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1858);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_selectedIcon__3fJJ7{top:.2rem;position:relative;padding-right:.5rem}", ""]);

// exports
exports.locals = {
	"selectedIcon": "style_selectedIcon__3fJJ7"
};

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1860);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__KRYx2{display:flex;width:100%;align-items:flex-end}.style_selectedIcon__sA0M_{top:.2rem;position:relative;padding-right:.5rem}.style_outerContainer__2cu41{width:100%}.style_innerContainer__3mocN{overflow:hidden;text-overflow:ellipsis}.style_actions__1dJnI{margin-left:.5rem}.style_select__3VB4M{flex:1 1 auto}", ""]);

// exports
exports.locals = {
	"container": "style_container__KRYx2",
	"selectedIcon": "style_selectedIcon__sA0M_",
	"outerContainer": "style_outerContainer__2cu41",
	"innerContainer": "style_innerContainer__3mocN",
	"actions": "style_actions__1dJnI",
	"select": "style_select__3VB4M"
};

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1862);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__14HPx{width:100%}", ""]);

// exports
exports.locals = {
	"container": "style_container__14HPx"
};

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var ProjectVariableCollation_1 = __webpack_require__(1864);
var withProjectVariables = function (_a) {
    var controlType = _a.controlType, variableType = _a.variableType, _b = _a.fetchLibraryVariableSet, fetchLibraryVariableSet = _b === void 0 ? function (id) { return clientInstance_1.repository.LibraryVariableSets.get(id); } : _b, _c = _a.fetchVariableSet, fetchVariableSet = _c === void 0 ? function (id) { return clientInstance_1.repository.Variables.get(id); } : _c, _d = _a.fetchProject, fetchProject = _d === void 0 ? function (id) { return clientInstance_1.repository.Projects.get(id); } : _d;
    return function (Component) {
        var callbacks = { fetchLibraryVariableSet: fetchLibraryVariableSet, fetchVariableSet: fetchVariableSet };
        var fetchVariablesForProject = ProjectVariableCollation_1.collateProjectVariables(callbacks, controlType, variableType);
        var result = (_a = (function (_super) {
                __extends(WithProjectVariables, _super);
                function WithProjectVariables(props) {
                    var _this = _super.call(this, props) || this;
                    _this.onRequestRefresh = function () { return __awaiter(_this, void 0, void 0, function () {
                        var variables;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.setState({ isRefreshing: true });
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, , 3, 4]);
                                    return [4 /*yield*/, fetchVariablesForProject(this.state.project)];
                                case 2:
                                    variables = _a.sent();
                                    this.setState({ variables: variables });
                                    return [3 /*break*/, 4];
                                case 3:
                                    this.setState({ isRefreshing: false });
                                    return [7 /*endfinally*/];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); };
                    _this.state = {
                        error: null,
                        isRefreshing: false,
                        project: null,
                        variables: [],
                        isDataLoaded: false
                    };
                    return _this;
                }
                WithProjectVariables.prototype.componentDidMount = function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var project, variables;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, fetchProject(this.props.projectId)];
                                        case 1:
                                            project = _a.sent();
                                            return [4 /*yield*/, fetchVariablesForProject(project)];
                                        case 2:
                                            variables = _a.sent();
                                            this.setState({ project: project, variables: variables, isDataLoaded: true });
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                            return [2 /*return*/];
                        });
                    });
                };
                WithProjectVariables.prototype.render = function () {
                    var _a = this.state, isDataLoaded = _a.isDataLoaded, state = __rest(_a, ["isDataLoaded"]);
                    return (React.createElement(Component, __assign({}, this.props, state, { onRequestRefresh: this.onRequestRefresh })));
                };
                return WithProjectVariables;
            }(React.Component)),
            _a.displayName = "WithProjectVariables(" + (Component.displayName || Component.name) + ")",
            _a);
        return result;
        var _a;
    };
};
exports.withProjectVariables = withProjectVariables;
exports.default = withProjectVariables;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\withProjectVariables.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\withProjectVariables.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1865));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ProjectVariableCollation\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ProjectVariableCollation\\index.ts"); } } })();

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(16);
var lodash_1 = __webpack_require__(16);
var isControlType = lodash_1.curry(function (controlType, template) {
    return !!template.DisplaySettings && template.DisplaySettings["Octopus.ControlType"] === controlType;
});
exports.isControlType = isControlType;
var isVariableType = lodash_1.curry(function (variableType, resource) {
    return resource.Type === variableType;
});
exports.isVariableType = isVariableType;
var fetchEach = function (callback, ids) { return Promise.all(ids.map(callback)); };
var pickVariableSetId = function (item) { return item.VariableSetId; };
var pickVariables = function (item) { return item.Variables; };
var pickTemplates = function (item) { return item.Templates; };
var pickName = function (item) { return item.Name; };
var collateProjectVariables = lodash_1.curry(function (callbacks, controlType, variableType, project) { return __awaiter(_this, void 0, void 0, function () {
    var libraryVariableSets, variableSetIds, variableResults, variables, templates;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchEach(callbacks.fetchLibraryVariableSet, project.IncludedLibraryVariableSetIds)];
            case 1:
                libraryVariableSets = _a.sent();
                variableSetIds = _.union([project.VariableSetId], libraryVariableSets.map(pickVariableSetId));
                return [4 /*yield*/, fetchEach(callbacks.fetchVariableSet, variableSetIds).then(function (x) { return x.map(pickVariables); })];
            case 2:
                variableResults = _a.sent();
                variables = _.flattenDeep(variableResults).filter(isVariableType(variableType));
                templates = _.union(project.Templates, _.flattenDeep(libraryVariableSets.map(pickTemplates))).filter(isControlType(controlType));
                return [2 /*return*/, _.chain(variables)
                        .union(templates)
                        .map(pickName)
                        .sort()
                        .uniq()
                        .value()];
        }
    });
}); });
exports.collateProjectVariables = collateProjectVariables;
exports.default = collateProjectVariables;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ProjectVariableCollation\\collateProjectVariables.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\utils\\ProjectVariableCollation\\collateProjectVariables.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var withValidateOnChange = function (options) {
    if (options === void 0) { options = {}; }
    return function (Component) {
        return _a = (function (_super) {
                __extends(WithValidateOnChange, _super);
                function WithValidateOnChange(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleChange = function (fieldValue) {
                        var _a = _this.props, validate = _a.validate, onValidate = _a.onValidate, onChange = _a.onChange;
                        var value = fieldValue === "" ? null : fieldValue;
                        if (validate) {
                            var result = validate(value);
                            _this.setState({ error: result });
                            if (onValidate) {
                                onValidate(result);
                            }
                        }
                        if (onChange) {
                            onChange(value);
                        }
                    };
                    _this.state = {
                        error: null
                    };
                    return _this;
                }
                WithValidateOnChange.prototype.render = function () {
                    var validate = { validation: this.state };
                    return (React.createElement(Component, __assign({ onChange: this.handleChange }, this.props, validate)));
                };
                return WithValidateOnChange;
            }(React.Component)),
            _a.displayName = "WithValidateOnChange(" + (Component.displayName || Component.name) + ")",
            _a;
        var _a;
    };
};
exports.withValidateOnChange = withValidateOnChange;
exports.default = withValidateOnChange;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\withValidateOnChange.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\withValidateOnChange.tsx"); } } })();

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(697));
var VariableSelect_1 = __webpack_require__(697);
exports.default = VariableSelect_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\VariableSelect\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\VariableSelect\\index.ts"); } } })();

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var form_1 = __webpack_require__(15);
var deploymentStepResource_1 = __webpack_require__(236);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var PackageRequirementText = (_a = {},
    _a[deploymentStepResource_1.PackageRequirement.LetOctopusDecide] = "Let Octopus decide",
    _a[deploymentStepResource_1.PackageRequirement.AfterPackageAcquisition] = "After package acquisition",
    _a[deploymentStepResource_1.PackageRequirement.BeforePackageAcquisition] = "Before package acquisition",
    _a);
var PackageRequirementRadioButtonGroup = (function (_super) {
    __extends(PackageRequirementRadioButtonGroup, _super);
    function PackageRequirementRadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PackageRequirementRadioButtonGroup;
}(RadioButtonGroup_1.default));
var PackageRequirementExpandableFormSection = (function (_super) {
    __extends(PackageRequirementExpandableFormSection, _super);
    function PackageRequirementExpandableFormSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PackageRequirementExpandableFormSection.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.packageRequirement !== this.props.packageRequirement;
    };
    PackageRequirementExpandableFormSection.prototype.render = function () {
        return React.createElement(form_1.ExpandableFormSection, { title: "Package Requirement", help: "Controls if this step needs to run before or after package acquisition.", summary: this.props.packageRequirement === deploymentStepResource_1.PackageRequirement.LetOctopusDecide
                ? form_1.Summary.default(PackageRequirementText[this.props.packageRequirement])
                : form_1.Summary.summary(PackageRequirementText[this.props.packageRequirement]), errorKey: "packagerequirement" },
            React.createElement(PackageRequirementRadioButtonGroup, { value: this.props.packageRequirement, onChange: this.props.onChange }, Object.keys(PackageRequirementText)
                .map(function (pr) { return React.createElement(RadioButton_1.default, { value: pr, label: PackageRequirementText[pr], key: pr }); })));
    };
    return PackageRequirementExpandableFormSection;
}(React.Component));
exports.default = PackageRequirementExpandableFormSection;
var _a;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\PackageRequirementExpander.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\PackageRequirementExpander.tsx"); } } })();

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var pluginRegistry_1 = __webpack_require__(18);
var OkDialogLayout_1 = __webpack_require__(107);
var FeatureList_1 = __webpack_require__(1870);
var Callout_1 = __webpack_require__(81);
var ConfigureFeaturesContent = (function (_super) {
    __extends(ConfigureFeaturesContent, _super);
    function ConfigureFeaturesContent(props) {
        var _this = _super.call(this, props) || this;
        _this.featureToggled = function () {
            var removedFeatures = _this.state.features.filter(function (feature) {
                return feature.wasEnabled && !feature.isEnabled;
            }).map(function (feature) {
                return feature.title;
            });
            _this.setState({
                removedFeatures: removedFeatures
            });
        };
        _this.handleIsEnabledChanged = function (value, featureName) {
            _this.setState(function (prevState) {
                var features = prevState.features.map(function (f) {
                    return f.featureName === featureName
                        ? __assign({}, f, { isEnabled: value }) : f;
                });
                return { features: features };
            }, _this.featureToggled);
        };
        _this.state = {
            features: [],
            removedFeatures: [],
            actionType: null
        };
        return _this;
    }
    ConfigureFeaturesContent.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var features, action, allFeatures, enabledFeatures;
                        return __generator(this, function (_a) {
                            features = [];
                            action = pluginRegistry_1.default.getDeploymentAction(this.props.actionType);
                            allFeatures = pluginRegistry_1.default.getAllFeatures();
                            enabledFeatures = (this.props.properties["Octopus.Action.EnabledFeatures"])
                                ? this.props.properties["Octopus.Action.EnabledFeatures"].split(",")
                                : [];
                            if (action.features && action.features.optional) {
                                allFeatures.sort(function (a, b) { return a.priority - b.priority; }).forEach(function (feature) {
                                    if (!action.features.optional.includes(feature.featureName)) {
                                        return;
                                    }
                                    features.push({
                                        featureName: feature.featureName,
                                        title: feature.title,
                                        description: feature.description,
                                        instance: feature,
                                        isEnabled: enabledFeatures.includes(feature.featureName),
                                        wasEnabled: enabledFeatures.includes(feature.featureName)
                                    });
                                });
                            }
                            this.setState({
                                features: features,
                                actionType: action
                            });
                            return [2 /*return*/];
                        });
                    }); })];
            });
        });
    };
    ConfigureFeaturesContent.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        var currentlyEnabled;
                        return __generator(this, function (_a) {
                            currentlyEnabled = (this.state.actionType.features && this.state.actionType.features.permanent)
                                ? this.state.actionType.features.permanent.slice() : [];
                            this.state.features.forEach(function (feature) {
                                if (feature.isEnabled) {
                                    currentlyEnabled.push(feature.featureName);
                                }
                                if (!feature.wasEnabled && feature.isEnabled) {
                                    if (feature.instance.enable) {
                                        feature.instance.enable(_this.props.properties);
                                    }
                                }
                            });
                            this.props.saveDone(currentlyEnabled.join(","));
                            return [2 /*return*/];
                        });
                    }); })];
            });
        });
    };
    ConfigureFeaturesContent.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { title: "Enabled Features", busy: this.state.busy, errors: this.state.errors, onOkClick: function () { return _this.save(); } }, this.state.features && React.createElement("div", null,
            this.state.removedFeatures.length > 0 && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning },
                React.createElement("span", null,
                    "You have deselected the feature",
                    this.state.removedFeatures.length > 1 ? React.createElement("span", null, "s") : "",
                    " "),
                this.state.removedFeatures.map(function (feature, index, arr) {
                    var last = index === arr.length - 1;
                    var first = index === 0;
                    var middle = !last && !first;
                    return React.createElement("span", { key: "removed" + index },
                        last && !first ? " and " : "",
                        middle ? ", " : "",
                        React.createElement("b", null, feature));
                }),
                React.createElement("span", null,
                    ". This will remove any related settings for ",
                    this.state.removedFeatures.length > 1 ? React.createElement("span", null, "these features") : React.createElement("span", null, "this feature"),
                    ".")),
            React.createElement(FeatureList_1.default, { features: this.state.features, onIsEnabledChanged: this.handleIsEnabledChanged })));
    };
    return ConfigureFeaturesContent;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = ConfigureFeaturesContent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\OpenFeatureDialog\\ConfigureFeaturesContent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\OpenFeatureDialog\\ConfigureFeaturesContent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var SimpleDataTable_1 = __webpack_require__(432);
var MarkdownDescription_1 = __webpack_require__(214);
var Checkbox_1 = __webpack_require__(118);
var styles = __webpack_require__(1871);
var FeatureTable = (function (_super) {
    __extends(FeatureTable, _super);
    function FeatureTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FeatureTable;
}(SimpleDataTable_1.default));
var FeatureList = function (props) {
    return React.createElement(FeatureTable, { data: props.features, headerColumns: ["Feature", "Description"], headerColumnClassName: styles.headerColumn, rowColumnClassName: styles.rowColumn, onRow: function (res) { return buildResultRow(res, props.onIsEnabledChanged); } });
};
var buildResultRow = function (item, onIsEnabledChanged) {
    return [
        React.createElement(Checkbox_1.default, { value: item.isEnabled, onChange: function (val) { return onIsEnabledChanged(val, item.featureName); }, label: item.title }),
        React.createElement(MarkdownDescription_1.default, { markup: item.description })
    ];
};
FeatureList.displayName = "FeatureList";
exports.default = FeatureList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\OpenFeatureDialog\\FeatureList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\OpenFeatureDialog\\FeatureList.tsx"); } } })();

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1872);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_headerColumn__22CvW:first-child{width:18.75rem!important}.style_rowColumn__13kPZ{word-break:normal;white-space:normal;padding:0 1.125rem!important;vertical-align:middle!important}.style_rowColumn__13kPZ p{margin:.5rem 0}.style_center__2WdKe{text-align:center}", ""]);

// exports
exports.locals = {
	"headerColumn": "style_headerColumn__22CvW",
	"rowColumn": "style_rowColumn__13kPZ",
	"center": "style_center__2WdKe"
};

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Chips_1 = __webpack_require__(23);
var Callout_1 = __webpack_require__(81);
var EnvironmentMultiSelect_1 = __webpack_require__(281);
var ExpandableFormSection_1 = __webpack_require__(44);
var form_1 = __webpack_require__(15);
var ActionDetails_1 = __webpack_require__(27);
var Callout_2 = __webpack_require__(81);
var EnvironmentOptionRadioButtonGroup = (function (_super) {
    __extends(EnvironmentOptionRadioButtonGroup, _super);
    function EnvironmentOptionRadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EnvironmentOptionRadioButtonGroup;
}(form_1.RadioButtonGroup));
var Environments = (function (_super) {
    __extends(Environments, _super);
    function Environments() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Environments.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.environmentOption !== this.props.environmentOption
            || nextProps.inclusiveEnvironments !== this.props.inclusiveEnvironments
            || nextProps.exclusiveEnvironments !== this.props.exclusiveEnvironments;
    };
    Environments.prototype.render = function () {
        return React.createElement(ExpandableFormSection_1.default, { title: "Environments", help: "Choose which environments this step applies to.", summary: this.environmentSummary(), errorKey: "environments" },
            React.createElement(EnvironmentOptionRadioButtonGroup, { value: this.props.environmentOption, onChange: this.props.onEnvironmentOptionChanged },
                React.createElement(form_1.RadioButton, { value: ActionDetails_1.EnvironmentOption.All, label: "Run for all applicable Lifecycle environments", disabled: this.props.hasHiddenEnvironments, isDefault: true }),
                React.createElement(form_1.RadioButton, { value: ActionDetails_1.EnvironmentOption.Include, label: "Run only for specific environments", disabled: this.props.hasHiddenEnvironments }),
                this.props.environmentOption === ActionDetails_1.EnvironmentOption.Include && React.createElement("div", null,
                    React.createElement(EnvironmentMultiSelect_1.default, { items: this.props.environments, onChange: this.props.onInclusiveEnvironmentsChanged, value: this.props.inclusiveEnvironments }),
                    React.createElement(form_1.Note, null, "Choose the specific environments under which you want this step to run."),
                    this.props.hasHiddenEnvironments && React.createElement(Callout_1.default, { type: Callout_2.CalloutType.Information }, "The environment condition type cannot be changed because you do not have access to an environment that is specifically marked for inclusion.")),
                React.createElement(form_1.RadioButton, { value: ActionDetails_1.EnvironmentOption.Exclude, label: "Skip specific environments", disabled: this.props.hasHiddenEnvironments }),
                this.props.environmentOption === ActionDetails_1.EnvironmentOption.Exclude && React.createElement("div", null,
                    React.createElement(EnvironmentMultiSelect_1.default, { items: this.props.environments, onChange: this.props.onExclusiveEnvironmentsChanged, value: this.props.exclusiveEnvironments }),
                    React.createElement(form_1.Note, null, "Choose the environments for which you want this step to be skipped."),
                    this.props.hasHiddenEnvironments && React.createElement(Callout_1.default, { type: Callout_2.CalloutType.Information }, "The environment condition type cannot be changed because you do not have access to an environment that is specifically marked for inclusion."))));
    };
    Environments.prototype.environmentSummary = function () {
        if (this.props.environmentOption === ActionDetails_1.EnvironmentOption.Include) {
            return form_1.Summary.summary(React.createElement("span", null,
                "This step will only run in ",
                this.getChipsForEnvironments(this.props.inclusiveEnvironments)));
        }
        if (this.props.environmentOption === ActionDetails_1.EnvironmentOption.Exclude) {
            return form_1.Summary.summary(React.createElement("span", null,
                "This step will be run in all applicable Lifecycle environments ",
                React.createElement("em", null, "except"),
                " ",
                this.getChipsForEnvironments(this.props.exclusiveEnvironments)));
        }
        return form_1.Summary.default("This step will run for all applicable Lifecycle environments");
    };
    Environments.prototype.getChipsForEnvironments = function (environments) {
        if (environments.length === 0) {
            return React.createElement("em", null, "please select environments");
        }
        return Chips_1.environmentChipList(this.props.environments, environments);
    };
    return Environments;
}(React.Component));
exports.default = Environments;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\Environments.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\Environments.tsx"); } } })();

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resources_1 = __webpack_require__(26);
var React = __webpack_require__(0);
var form_1 = __webpack_require__(15);
var ParseHelper_1 = __webpack_require__(75);
var ActionDetails_1 = __webpack_require__(27);
var Chips_1 = __webpack_require__(23);
var MultiSelect_1 = __webpack_require__(71);
var MaxParallelism_1 = __webpack_require__(701);
var ExecutionPlan = (function (_super) {
    __extends(ExecutionPlan, _super);
    function ExecutionPlan(props) {
        var _this = _super.call(this, props) || this;
        _this.renderRunOnOptions = function () {
            var alwaysOnServer = _this.props.executionLocation === resources_1.ActionExecutionLocation.AlwaysOnServer;
            if (alwaysOnServer && _this.props.targetRoleOption !== ActionDetails_1.TargetRoles.Optional) {
                return React.createElement("div", null, "Run on the Octopus Server");
            }
            if (_this.props.executionLocation === resources_1.ActionExecutionLocation.AlwaysOnTarget) {
                return React.createElement("div", null, "Run on deployment targets");
            }
            return React.createElement(form_1.StringRadioButtonGroup, { value: _this.props.runOn, onChange: _this.props.onRunOnChanged },
                !_this.props.isChildStep && React.createElement(form_1.RadioButton, { value: ActionDetails_1.RunOn.OctopusServer, label: "Octopus Server" }),
                React.createElement(form_1.RadioButton, { value: ActionDetails_1.RunOn.OctopusServerForRoles, label: "Octopus Server on behalf of roles" }),
                !alwaysOnServer && React.createElement(form_1.RadioButton, { value: ActionDetails_1.RunOn.DeploymentTarget, label: "Deployment targets", isDefault: true }));
        };
        _this.renderRolesOptions = function () {
            if (_this.props.targetRoleOption === ActionDetails_1.TargetRoles.None) {
                return React.createElement(form_1.Note, null, "This step will run once on the Octopus Server");
            }
            if (_this.props.isChildStep) {
                return (_this.props.runsOnServer)
                    ? React.createElement("p", { className: "text-muted" },
                        "This step is part of a rolling step, which runs on the Octopus Server on behalf of deployment targets in the following roles:",
                        _this.roleList(_this.props.targetRoles))
                    : React.createElement("p", { className: "text-muted" },
                        "This step is part of a rolling step, which runs on deployment targets in the following roles:",
                        _this.roleList(_this.props.targetRoles));
            }
            var nodes = [];
            if (_this.props.runOn !== ActionDetails_1.RunOn.OctopusServer) {
                nodes.push(React.createElement(MultiSelect_1.RoleMultiSelect, { onChange: _this.props.onTargetRolesChanged, value: ParseHelper_1.default.parseCSV(_this.props.targetRoles), label: _this.props.runOn === ActionDetails_1.RunOn.DeploymentTarget ? "Runs on targets in roles" : "On behalf of target roles", validate: function (roles) { return roles.length === 0 ? "Please enter one or more roles" : ""; }, error: _this.props.targetRolesError, items: _this.props.availableRoles }));
            }
            if (_this.props.runOn === ActionDetails_1.RunOn.OctopusServer) {
                nodes.push(React.createElement(form_1.Note, null,
                    React.createElement("p", { className: "text-muted" }, "This step will run once on the Octopus Server")));
            }
            else {
                if (_this.state.showWindowSize) {
                    nodes.push(React.createElement(form_1.Note, null,
                        React.createElement("p", { className: "text-muted" },
                            "This is a rolling step that will run on ",
                            React.createElement("span", null, "the Octopus Server on behalf of"),
                            " a limited number of deployment targets at once.\u00A0",
                            React.createElement("a", { href: "#", onClick: function (e) {
                                    e.preventDefault();
                                    _this.setState({ showWindowSize: false });
                                    _this.props.onMaxParallelismChanged("");
                                } }, "Deploy to all deployment targets in parallel"),
                            ".")));
                    nodes.push(React.createElement(MaxParallelism_1.default, { key: "maxparallelism", projectId: _this.props.projectId, value: _this.props.maxParallelism, onChange: function (x) { return _this.props.onMaxParallelismChanged(x); } }));
                }
                else {
                    nodes.push(React.createElement(form_1.Note, null,
                        "This step will be run on ",
                        React.createElement("span", null, _this.props.runsOnServer ? "the Octopus Server on behalf of" : ""),
                        " all deployment targets in parallel.\u00A0",
                        React.createElement("a", { href: "#", onClick: function (e) {
                                e.preventDefault();
                                _this.setState({ showWindowSize: true });
                                _this.props.onMaxParallelismChanged("1");
                            } }, "Configure a rolling deployment"),
                        "."));
                }
            }
            return React.Children.toArray(nodes);
        };
        _this.state = {
            showWindowSize: props.maxParallelism ? props.maxParallelism.length > 0 : false
        };
        return _this;
    }
    ExecutionPlan.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return nextProps.runOn !== this.props.runOn
            || nextProps.targetRoles !== this.props.targetRoles
            || nextProps.maxParallelism !== this.props.maxParallelism
            || nextProps.targetRolesError !== this.props.targetRolesError
            || nextState.showWindowSize !== this.state.showWindowSize;
    };
    ExecutionPlan.prototype.render = function () {
        return React.createElement(form_1.ExpandableFormSection, { isExpandedByDefault: this.props.expandedByDefault, errorKey: "Octopus.Action.TargetRoles", title: "Execution Plan", summary: this.executionPlanSummary(), help: "Where should this step run?" },
            this.renderRunOnOptions(),
            this.renderRolesOptions());
    };
    ExecutionPlan.prototype.executionPlanSummary = function () {
        var summary = [React.createElement("span", null, "This step will run on")];
        var runOnServer = false;
        // keeping these as four cases not two and combining the if checks because I am
        // not sure of the priority of Octopus.Action.RunOnServer over props.executionLocation
        if (this.props.executionLocation === resources_1.ActionExecutionLocation.AlwaysOnServer) {
            summary.push(React.createElement("span", null,
                " the ",
                React.createElement("strong", null, "Octopus Server")));
            runOnServer = true;
        }
        else if (this.props.executionLocation === resources_1.ActionExecutionLocation.AlwaysOnTarget) {
            summary.push(React.createElement("span", null,
                " ",
                React.createElement("strong", null, "deployment targets")));
        }
        else if (this.props.runOn === ActionDetails_1.RunOn.DeploymentTarget) {
            summary.push(React.createElement("span", null,
                " ",
                React.createElement("strong", null, "deployment targets")));
        }
        else {
            summary.push(React.createElement("span", null,
                " the ",
                React.createElement("strong", null, "Octopus Server")));
            runOnServer = true;
        }
        if (this.props.targetRoleOption === ActionDetails_1.TargetRoles.None) {
            summary.push(React.createElement("p", null));
            return form_1.Summary.summary(React.Children.toArray(summary));
        }
        var roles = ParseHelper_1.default.parseCSV(this.props.targetRoles);
        if (this.props.runOn !== ActionDetails_1.RunOn.OctopusServer) {
            if (roles.length > 0) {
                summary.push(runOnServer
                    ? React.createElement("span", null, " on behalf of ")
                    : roles.length > 1
                        ? React.createElement("span", null, " in roles")
                        : React.createElement("span", null, " in role"));
                roles.forEach(function (r) {
                    summary.push(React.createElement(Chips_1.RoleChip, { role: r, key: "role-" + r }));
                });
            }
            else {
                summary.push(runOnServer
                    ? React.createElement("span", null, " on behalf of roles, but the roles have not been selected")
                    : React.createElement("span", null, " but the roles have not been selected"));
            }
        }
        summary.push(React.createElement("p", null));
        if (this.props.maxParallelism) {
            summary.push(React.createElement("span", null,
                "This is a rolling step that will run ",
                runOnServer ? "on behalf of" : "on",
                "\u00A0",
                React.createElement("strong", null, this.props.maxParallelism),
                " target",
                this.props.maxParallelism !== "1" ? "s" : "",
                " at a time"));
        }
        else {
            if (!this.props.runsOnServer || roles.length > 0) {
                summary.push(React.createElement("span", null,
                    "All deployments will be run in ",
                    React.createElement("strong", null, "parallel")));
            }
        }
        return form_1.Summary.summary(React.Children.toArray(summary));
    };
    ExecutionPlan.prototype.roleList = function (csv) {
        var list = ParseHelper_1.default.parseCSV(csv);
        return list.map(function (r) { return React.createElement(Chips_1.RoleChip, { role: r, key: "role-" + r }); });
    };
    return ExecutionPlan;
}(React.Component));
exports.default = ExecutionPlan;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\ExecutionPlan.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\ExecutionPlan.tsx"); } } })();

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var form_1 = __webpack_require__(15);
var TagsList_1 = __webpack_require__(1876);
var AdvancedTenantSelector_1 = __webpack_require__(723);
var TenantsExpander = (function (_super) {
    __extends(TenantsExpander, _super);
    function TenantsExpander() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TenantsExpander.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.tenantTags !== this.props.tenantTags;
    };
    TenantsExpander.prototype.render = function () {
        var _this = this;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "tenantTags", title: "Tenants", summary: this.props.tenantTags.length > 0
                ? form_1.Summary.summary(React.createElement("span", null,
                    "This step will only run for certain tenants: ",
                    React.createElement(TagsList_1.default, { canonicalNames: this.props.tenantTags, tagIndex: this.props.tagIndex })))
                : form_1.Summary.default("This step will run for all tenants"), help: "Choose which tenants this step applies to." },
            React.createElement(form_1.Note, null, "This step will only run for tenants matching this filter. Clear the filter to make the step run for all tenants. Note: if you define a filter, this step will be skipped when performing un-tenanted deployments."),
            React.createElement(AdvancedTenantSelector_1.AdvancedTenantTagsSelector, { selectedTenantTags: this.props.tenantTags, doBusyTask: this.props.doBusyTask, onChange: function (tags) { return _this.props.onTenantTagsChange(tags); } }));
    };
    return TenantsExpander;
}(React.Component));
exports.default = TenantsExpander;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\TenantsExpander.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\TenantsExpander.tsx"); } } })();

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TagsList_1 = __webpack_require__(447);
exports.default = TagsList_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TagsList\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\TagsList\\index.tsx"); } } })();

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(291);
var React = __webpack_require__(0);
var FormPaperLayout_1 = __webpack_require__(168);
var FormBaseComponent_1 = __webpack_require__(137);
var Text_1 = __webpack_require__(17);
var form_1 = __webpack_require__(15);
var index_2 = __webpack_require__(23);
var lodash_1 = __webpack_require__(16);
var ParseHelper_1 = __webpack_require__(75);
var RoleMultiSelect_1 = __webpack_require__(423);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var clientInstance_1 = __webpack_require__(10);
var RunTriggerExpander_1 = __webpack_require__(700);
var StartTriggerExpander_1 = __webpack_require__(699);
var permission_1 = __webpack_require__(49);
var projectsArea_1 = __webpack_require__(219);
var react_redux_1 = __webpack_require__(67);
var DeploymentProcessRoute_1 = __webpack_require__(297);
var routeLinks_1 = __webpack_require__(20);
var MaxParallelism_1 = __webpack_require__(701);
var InternalRedirect_1 = __webpack_require__(40);
var rollingStep = __webpack_require__(695);
var ParentStepDetailsInternal = (function (_super) {
    __extends(ParentStepDetailsInternal, _super);
    function ParentStepDetailsInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            var deploymentProcess, originalStep;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.get(this.props.project.DeploymentProcessId)];
                                    case 1:
                                        deploymentProcess = _a.sent();
                                        originalStep = deploymentProcess.Steps.find(function (s) { return s.Id === _this.props.match.params.stepId; });
                                        originalStep.Name = this.state.model.name;
                                        originalStep.Properties = __assign({}, originalStep.Properties, this.state.model.props);
                                        originalStep.Condition = this.state.model.condition;
                                        originalStep.StartTrigger = this.state.model.startTrigger;
                                        return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.modify(deploymentProcess)];
                                    case 2:
                                        deploymentProcess = _a.sent();
                                        this.props.onProjectStepsUpdated(deploymentProcess.Steps ? deploymentProcess.Steps.length : null);
                                        this.reloadThePage();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var step = _this.props.step;
        var model = {
            name: step.Name,
            props: step.Properties,
            condition: step.Condition,
            startTrigger: step.StartTrigger
        };
        _this.state = {
            model: model,
            cleanModel: lodash_1.cloneDeep(model),
            showWindowSize: model.props["Octopus.Action.MaxParallelism"]
                ? model.props["Octopus.Action.MaxParallelism"].toString().length > 0
                : false
        };
        return _this;
    }
    ParentStepDetailsInternal.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo });
        }
        var title = this.state.model && this.state.model.name
            ? this.state.model.name
            : "Step Details"; /* mark.siedle - This is an exception to the usual ellipsis pattern because of the StepDetailsLoader. */
        return React.createElement(FormPaperLayout_1.default, { title: title, titleLogo: React.createElement(index_1.default, { url: rollingStep }), breadcrumbTitle: "Process", breadcrumbPath: routeLinks_1.default.project(this.props.project).process.root, busy: this.state.busy, errors: this.state.errors, model: this.state.model, cleanModel: this.state.cleanModel, savePermission: {
                permission: permission_1.default.ProcessEdit,
                project: this.props.project && this.props.project.Id,
            }, onSaveClick: this.handleSaveClick, saveText: "Step details updated" },
            React.createElement(form_1.ExpandableFormSection, { isExpandedByDefault: !this.state.model.name, errorKey: "Name", title: "Step Name", focusOnExpandAll: true, summary: this.state.model.name
                    ? form_1.Summary.summary(this.state.model.name)
                    : form_1.Summary.placeholder("Please enter a name for your step"), help: "A short, memorable, unique name for this step." },
                React.createElement(Text_1.default, { value: this.state.model.name, onChange: function (name) { return _this.setModelState({ name: name }); }, label: "Step name", autoFocus: true })),
            React.createElement(form_1.ExpandableFormSection, { isExpandedByDefault: !this.state.model.name, errorKey: "Octopus.Action.TargetRoles", title: "Execution Plan", summary: this.executionPlanSummary(), help: "Where should this step run?" },
                React.createElement(RoleMultiSelect_1.default, { label: "Runs on targets in roles", onChange: function (roles) {
                        return _this.setProperties((_a = {}, _a["Octopus.Action.TargetRoles"] = ParseHelper_1.default.encodeCSV(roles), _a));
                        var _a;
                    }, value: ParseHelper_1.default.parseCSV(this.state.model.props["Octopus.Action.TargetRoles"]), validate: function (roles) { return roles.length === 0 ? "Please enter one or more roles" : ""; }, error: this.getFieldError("Octopus.Action.TargetRoles"), items: this.props.availableRoles }),
                React.createElement(RadioButtonGroup_1.BooleanRadioButtonGroup, { onChange: function (v) {
                        _this.setState({ showWindowSize: v });
                        _this.setProperties((_a = {}, _a["Octopus.Action.MaxParallelism"] = (v ? "1" : ""), _a));
                        var _a;
                    }, value: this.state.showWindowSize },
                    React.createElement(RadioButton_1.default, { value: false, label: "Deploy to all deployment targets in parallel." }),
                    React.createElement(RadioButton_1.default, { value: true, label: "Configure a rolling deployment" })),
                this.state.showWindowSize && this.renderWindowSize()),
            React.createElement(form_1.FormSectionHeading, { title: "Conditions" }),
            React.createElement(RunTriggerExpander_1.default, { isFirstStep: this.props.isFirstStep, condition: this.state.model.condition, onConditionChange: function (condition) { return _this.setModelState({ condition: condition }); }, variableExpression: this.state.model.props["Octopus.Action.ConditionVariableExpression"], onVariableExpressionChange: function (x) {
                    return _this.setProperties((_a = {}, _a["Octopus.Action.ConditionVariableExpression"] = x, _a));
                    var _a;
                }, projectId: this.props.project.Id }),
            !this.props.isFirstStep && React.createElement(StartTriggerExpander_1.default, { startTrigger: this.state.model.startTrigger, onChange: function (startTrigger) { return _this.setModelState({ startTrigger: startTrigger }); } }));
    };
    ParentStepDetailsInternal.prototype.renderWindowSize = function () {
        var _this = this;
        var maxParallelism = this.state.model.props["Octopus.Action.MaxParallelism"];
        return React.createElement(MaxParallelism_1.default, { projectId: this.props.project.Id, value: maxParallelism, onChange: function (x) {
                return _this.setProperties((_a = {}, _a["Octopus.Action.MaxParallelism"] = x, _a));
                var _a;
            } });
    };
    ParentStepDetailsInternal.prototype.setProperties = function (properties) {
        this.setState(function (state) {
            return {
                model: __assign({}, state.model, { props: __assign({}, state.model.props, properties) })
            };
        });
    };
    ParentStepDetailsInternal.prototype.executionPlanSummary = function () {
        var summary = [React.createElement("span", null, "This step will run on")];
        var onBehalf = false;
        var roles = ParseHelper_1.default.parseCSV(this.state.model.props["Octopus.Action.TargetRoles"]);
        var parallelism = this.state.model.props["Octopus.Action.MaxParallelism"];
        if (roles.length > 0) {
            summary.push(onBehalf
                ? React.createElement("span", null, " on behalf of ")
                : roles.length > 1
                    ? React.createElement("span", null, " in roles")
                    : React.createElement("span", null, " in role"));
            roles.forEach(function (r) {
                summary.push(React.createElement(index_2.RoleChip, { role: r, key: "role-" + r }));
            });
        }
        if (parallelism) {
            // tslint:disable-next-line
            summary.push(React.createElement("span", null,
                "as ",
                React.createElement("strong", null, "rolling step"),
                " that will run ",
                onBehalf ? "on behalf of" : "on",
                " ",
                React.createElement("strong", null, parallelism),
                " target",
                parallelism !== "1" ? "s" : "",
                " at a time"));
        }
        else {
            summary.push(React.createElement("span", null,
                "with all targets deployed in ",
                React.createElement("strong", null, "parallel")));
        }
        return form_1.Summary.summary(React.Children.toArray(summary));
    };
    ParentStepDetailsInternal.prototype.reloadThePage = function () {
        var currentPath = this.props.location.pathname;
        var reloadKey = this.props.match.params.reloadKey;
        var path = DeploymentProcessRoute_1.DeploymentProcessRoute.nextStepReloadPath(currentPath, reloadKey);
        this.setState({ redirectTo: path });
    };
    return ParentStepDetailsInternal;
}(FormBaseComponent_1.default));
var mapDispatchToProps = function (dispatch) {
    return {
        onProjectStepsUpdated: function (numberOfSteps) {
            dispatch(projectsArea_1.projectStepsUpdated(numberOfSteps));
        },
    };
};
var ParentStepDetails = react_redux_1.connect(null, mapDispatchToProps)(ParentStepDetailsInternal);
exports.default = ParentStepDetails;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\ParentStepDetails.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\ParentStepDetails.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PaperLayout_1 = __webpack_require__(117);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var CommunityActionTemplateList_1 = __webpack_require__(806);
var InstalledActionTemplateList_1 = __webpack_require__(1885);
var pluginRegistry_1 = __webpack_require__(18);
var FilterSearchBox_1 = __webpack_require__(171);
var styles = __webpack_require__(1886);
var routeLinks_1 = __webpack_require__(20);
var ActionTemplateSelector = (function (_super) {
    __extends(ActionTemplateSelector, _super);
    function ActionTemplateSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.getDetailsUrl = function (template) {
            return routeLinks_1.default.library.stepTemplates.communityTemplate(template, _this.props.match.params.projectSlug).root;
        };
        _this.getNewStepUrl = function (template) {
            return routeLinks_1.default.project(_this.props.match.params.projectSlug).process
                .stepNew(template.Type, _this.props.match.params.parentStepId, template.Id);
        };
        _this.state = {
            isLoaded: false,
            templates: [],
            childActionTypes: []
        };
        return _this;
    }
    ActionTemplateSelector.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var templates, childActionTypes;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.ActionTemplates.search()];
                                    case 1:
                                        templates = _a.sent();
                                        childActionTypes = pluginRegistry_1.default.getAllActions()
                                            .filter(function (action) { return action.canBeChild; })
                                            .map(function (action) { return action.actionType; });
                                        this.setState({ isLoaded: true, templates: templates, childActionTypes: childActionTypes });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ActionTemplateSelector.prototype.render = function () {
        var _this = this;
        return React.createElement(PaperLayout_1.default, { title: "Choose Step Template", breadcrumbTitle: "Process", breadcrumbPath: routeLinks_1.default.project(this.props.match.params.projectSlug).process.root, busy: this.state.busy, errors: this.state.errors, fullWidth: true, flatStyle: true }, this.state.isLoaded &&
            React.createElement("div", null,
                React.createElement(FilterSearchBox_1.default, { hintText: "Filter by name, category or description...", onChange: function (value) { return _this.setState({ filterText: value.toLowerCase() }); }, fullWidth: true, containerClassName: styles.filterSearchBoxContainer, autoFocus: true }),
                React.createElement(InstalledActionTemplateList_1.default, { templates: this.installedTemplates(), onDetailsUrlRequested: this.getDetailsUrl, onPostSelectionUrlRequested: this.getNewStepUrl, filter: this.state.filterText }),
                React.createElement(CommunityActionTemplateList_1.default, { templates: this.state.templates.filter(function (at) { return !at.IsInstalled; }), filter: this.state.filterText, installationActionName: "Install and add", onDetailsUrlRequested: this.getDetailsUrl, onPostSelectionUrlRequested: this.getNewStepUrl })));
    };
    ActionTemplateSelector.prototype.installedTemplates = function () {
        var _this = this;
        var installed = this.state.templates.filter(function (at) { return at.IsInstalled; });
        var parentStepId = this.props.match.params.parentStepId;
        if (!parentStepId) {
            return installed;
        }
        return installed.filter(function (at) { return _this.state.childActionTypes.includes(at.Type); });
    };
    return ActionTemplateSelector;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = ActionTemplateSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ActionTemplateSelector\\ActionTemplateSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ActionTemplateSelector\\ActionTemplateSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Logo_1 = __webpack_require__(172);
var styles = __webpack_require__(272);
var ActionTemplateCategory = function (props) {
    var firstTemplate = props.templates[0];
    return React.createElement("li", { className: styles.actionCategory, onClick: props.onCategorySelected },
        React.createElement("div", { className: styles.logo },
            React.createElement(Logo_1.default, { url: firstTemplate.Links.Logo, size: "4.375rem" })),
        React.createElement("div", { className: styles.categoryName },
            React.createElement("small", null, props.name)));
};
ActionTemplateCategory.displayName = "ActionTemplateCategory";
exports.default = ActionTemplateCategory;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplates\\ActionTemplateCategory.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplates\\ActionTemplateCategory.tsx"); } } })();

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.styles_hide-sm__lYa4_{display:none!important}}@media (min-width:37.4rem){.styles_visible-sm__3PJu9{display:none!important}}@media (max-width:79.9rem){.styles_hide-md__2FW8f{display:none!important}}@media (min-width:79.9rem){.styles_visible-md__3_nD9{display:none!important}}.styles_templates__3rz1U{display:flex;flex-direction:row;flex-wrap:wrap}.styles_templates__3rz1U li{display:flex}.styles_categories__3n7So>div,.styles_categoryTemplates__1uJoA>div{display:flex;flex-direction:row;flex-wrap:wrap}.styles_categoryTemplates__1uJoA li{display:flex;height:100%}@media (max-width:37.4rem){.styles_categoryTemplates__1uJoA>div,.styles_templates__3rz1U{flex-direction:column}}.styles_actionCategory__2DARh{display:flex;flex-direction:column;justify-content:center;align-items:center;margin-left:1.25rem;margin-bottom:1rem;padding:.625rem;background:#fff;box-shadow:0 .0625rem .25rem 0 rgba(0,0,0,.12)}.styles_actionCategory__2DARh:focus,.styles_actionCategory__2DARh:hover{cursor:pointer;box-shadow:0 .0625rem .3125rem 0 rgba(0,0,0,.2),0 .1875rem .25rem 0 rgba(0,0,0,.12),0 .125rem .25rem 0 rgba(0,0,0,.14)}.styles_categoryName__1jvQG{color:#2f93e0;text-align:center;margin-top:.8125rem;margin-bottom:.8125rem;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width:5.9375rem}.styles_actions__3qX0c{text-align:right;margin-right:1rem}.styles_onHoverActions__38l5m{display:flex;flex-direction:column;height:100%;width:100%;align-items:center;background-color:hsla(0,0%,100%,.5)}.styles_primaryAction__3X1hT{flex:4}.styles_secondaryAction__xWXcu{background-color:#fff;padding-bottom:.5rem;padding-top:.5rem;width:100%;text-align:center}.styles_empty__cfcJZ{flex:3}.styles_templateListTitle__2m-nj{background-color:hsla(0,0%,60%,.08);border-top:.0625rem dashed #ccc;border-bottom:.0625rem dashed #ccc;padding:.5rem 1.125rem;margin-right:1rem}", ""]);

// exports
exports.locals = {
	"hide-sm": "styles_hide-sm__lYa4_",
	"hideSm": "styles_hide-sm__lYa4_",
	"visible-sm": "styles_visible-sm__3PJu9",
	"visibleSm": "styles_visible-sm__3PJu9",
	"hide-md": "styles_hide-md__2FW8f",
	"hideMd": "styles_hide-md__2FW8f",
	"visible-md": "styles_visible-md__3_nD9",
	"visibleMd": "styles_visible-md__3_nD9",
	"templates": "styles_templates__3rz1U",
	"categoryTemplates": "styles_categoryTemplates__1uJoA",
	"categories": "styles_categories__3n7So",
	"actionCategory": "styles_actionCategory__2DARh",
	"categoryName": "styles_categoryName__1jvQG",
	"actions": "styles_actions__3qX0c",
	"onHoverActions": "styles_onHoverActions__38l5m",
	"primaryAction": "styles_primaryAction__3X1hT",
	"secondaryAction": "styles_secondaryAction__xWXcu",
	"empty": "styles_empty__cfcJZ",
	"templateListTitle": "styles_templateListTitle__2m-nj"
};

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Card_1 = __webpack_require__(739);
exports.default = Card_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Card\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Card\\index.tsx"); } } })();

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var InternalLink_1 = __webpack_require__(42);
var Callout_1 = __webpack_require__(59);
var ExternalLink_1 = __webpack_require__(29);
var DataBaseComponent_1 = __webpack_require__(39);
var SaveDialogLayout_1 = __webpack_require__(105);
var routeLinks_1 = __webpack_require__(20);
var CommunityTemplateInstallation = (function (_super) {
    __extends(CommunityTemplateInstallation, _super);
    function CommunityTemplateInstallation(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    CommunityTemplateInstallation.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var communityTemplate;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, clientInstance_1.repository.CommunityActionTemplates.get(this.props.communityTemplateId)];
                                case 1:
                                    communityTemplate = _a.sent();
                                    this.setState({ communityTemplate: communityTemplate });
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    CommunityTemplateInstallation.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var actionTemplate;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.CommunityActionTemplates.install(this.state.communityTemplate)];
                                    case 1:
                                        actionTemplate = _a.sent();
                                        return [4 /*yield*/, this.props.saveDone(actionTemplate)];
                                    case 2:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CommunityTemplateInstallation.prototype.render = function () {
        var _this = this;
        var body = this.state.communityTemplate &&
            React.createElement("div", null,
                React.createElement("h4", null,
                    React.createElement(InternalLink_1.default, { to: this.props.detailsLink }, this.state.communityTemplate.Name)),
                React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                    "This is a community contributed step that will be installed into your ",
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.stepTemplates.root }, "step templates"),
                    " library. Read our ",
                    React.createElement(ExternalLink_1.default, { href: "CommunityContributedStepTemplates" }, "community step documentation"),
                    " for more information."));
        return React.createElement(SaveDialogLayout_1.default, { title: this.props.title, busy: this.state.busy, errors: this.state.errors, onSaveClick: function () { return _this.save(); } }, body);
    };
    return CommunityTemplateInstallation;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = CommunityTemplateInstallation;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplates\\CommunityTemplateInstallation.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ActionTemplates\\CommunityTemplateInstallation.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1883 */,
/* 1884 */,
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ActionTemplateCard_1 = __webpack_require__(464);
var NavigationButton_1 = __webpack_require__(212);
var matchesFilter_1 = __webpack_require__(465);
var Callout_1 = __webpack_require__(59);
var permission_1 = __webpack_require__(49);
var ExternalLink_1 = __webpack_require__(29);
var InternalLink_1 = __webpack_require__(42);
var PageDivider_1 = __webpack_require__(435);
var ActionTemplateCardList_1 = __webpack_require__(466);
var PermissionCheck_1 = __webpack_require__(45);
var InstalledActionTemplateList = (function (_super) {
    __extends(InstalledActionTemplateList, _super);
    function InstalledActionTemplateList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InstalledActionTemplateList.prototype.render = function () {
        var _this = this;
        var filteredResults = this.props.templates.filter(function (at) { return matchesFilter_1.default(at, _this.props.filter); });
        if (filteredResults.length === 0 && this.props.filter) {
            return React.createElement("p", null, "There are no installed step templates that match your filter criteria.");
        }
        return React.createElement("div", null,
            React.createElement(PageDivider_1.default, null, "Installed Step Templates"),
            !PermissionCheck_1.isAllowed({ permission: permission_1.Permission.ActionTemplateView }) &&
                React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                    "You can't see custom installed step templates because you don't have",
                    React.createElement(ExternalLink_1.default, { href: "UserRoles" },
                        " ",
                        permission_1.Permission.ActionTemplateView),
                    " permission."),
            React.createElement(ActionTemplateCardList_1.default, null, filteredResults.map(function (template) {
                return React.createElement(ActionTemplateCard_1.default, { key: template.Type + template.Id, template: template, primaryAction: React.createElement(NavigationButton_1.NavigationButton, { label: "Add", type: NavigationButton_1.NavigationButtonType.Primary, href: _this.props.onPostSelectionUrlRequested(template) }), secondaryAction: template.HasUpdate &&
                        React.createElement(InternalLink_1.default, { size: 0.75, to: _this.props.onDetailsUrlRequested(template) }, "Update available") });
            })));
    };
    return InstalledActionTemplateList;
}(React.Component));
exports.default = InstalledActionTemplateList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ActionTemplateSelector\\InstalledActionTemplateList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\projects\\components\\ActionTemplateSelector\\InstalledActionTemplateList.tsx"); } } })();

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1887);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_filterSearchBoxContainer__2em71{width:320px}", ""]);

// exports
exports.locals = {
	"filterSearchBoxContainer": "style_filterSearchBoxContainer__2em71"
};

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1889);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__12ocB{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2Lb4d{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2STES{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1UVop{display:none!important}}.style_textControl__2gK1t{flex:1 1 auto}.style_textControlKey__2qUqO{max-width:12.5rem}.style_separator__2h2-4{margin:0 2rem;font-weight:600}.style_itemContainer__35UFk{display:flex;align-items:baseline}@media (max-width:79.9rem){.style_textControl__2gK1t{width:100%}.style_itemContainer__35UFk{flex-direction:column}.style_separator__2h2-4{display:none}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__12ocB",
	"hideSm": "style_hide-sm__12ocB",
	"visible-sm": "style_visible-sm__2Lb4d",
	"visibleSm": "style_visible-sm__2Lb4d",
	"hide-md": "style_hide-md__2STES",
	"hideMd": "style_hide-md__2STES",
	"visible-md": "style_visible-md__1UVop",
	"visibleMd": "style_visible-md__1UVop",
	"textControl": "style_textControl__2gK1t",
	"textControlKey": "style_textControlKey__2qUqO",
	"separator": "style_separator__2h2-4",
	"itemContainer": "style_itemContainer__35UFk"
};

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var GettingStartedProgress_1 = __webpack_require__(1891);
var React = __webpack_require__(0);
var permission_1 = __webpack_require__(49);
var BaseComponent_1 = __webpack_require__(14);
var gettingStartedStatus_1 = __webpack_require__(628);
var styles = __webpack_require__(205);
var GettingStartedDialog_1 = __webpack_require__(626);
var FlatButton_1 = __webpack_require__(101);
var PermissionCheck_1 = __webpack_require__(45);
var react_router_1 = __webpack_require__(69);
var WhatsNext_1 = __webpack_require__(629);
var routeLinks_1 = __webpack_require__(20);
var resolvePathWithSpaceId_1 = __webpack_require__(131);
var imageCongrats = __webpack_require__(1895);
var imageOctopus = __webpack_require__(630);
var imageEnvironments = __webpack_require__(631);
var imagePackage = __webpack_require__(632);
var imageProject = __webpack_require__(633);
var imageDeploy = __webpack_require__(634);
var GettingStartedFooter = (function (_super) {
    __extends(GettingStartedFooter, _super);
    function GettingStartedFooter(props) {
        var _this = _super.call(this, props) || this;
        _this.setDivRef = function (el) {
            _this.divEl = el;
        };
        _this.state = {
            showBar: true,
            expand: true,
            canDismiss: false,
            progressSections: null,
            showDetails: false,
            status: null,
            highlightSection: null,
            spacer: 0,
            isDashboard: _this.isDashboard(_this.props.location.pathname, _this.props.match.params.spaceId)
        };
        return _this;
    }
    GettingStartedFooter.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var tasksStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!PermissionCheck_1.isAllowed({ permission: permission_1.Permission.AdministerSystem })) {
                            this.setState({
                                showBar: false
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, gettingStartedStatus_1.gettingStartedStatus.status()];
                    case 1:
                        tasksStatus = _a.sent();
                        if (tasksStatus.tasks.Deploy.DeployedRelease.IsComplete) {
                            this.setState({
                                showBar: false
                            });
                            return [2 /*return*/];
                        }
                        this.setState({
                            expand: this.isBarExpanded()
                        });
                        if (this.divEl) {
                            this.setState({
                                spacer: this.divEl.getBoundingClientRect().height
                            });
                        }
                        this.unsubscribe = gettingStartedStatus_1.gettingStartedStatus.subscribe(function (status) { return _this.refresh(status); });
                        this.refresh(tasksStatus);
                        return [2 /*return*/];
                }
            });
        });
    };
    GettingStartedFooter.prototype.componentWillUnmount = function () {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    };
    GettingStartedFooter.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            isDashboard: this.isDashboard(nextProps.location.pathname, nextProps.match.params.spaceId)
        });
    };
    GettingStartedFooter.prototype.componentDidUpdate = function () {
        if (!this.divEl) {
            return;
        }
        var newHeight = this.divEl.getBoundingClientRect().height;
        if (this.state.spacer === newHeight) {
            return;
        }
        this.setState({
            spacer: newHeight
        });
    };
    GettingStartedFooter.prototype.render = function () {
        var _this = this;
        if (this.state.isDashboard || !this.state.showBar || !this.state.progressSections) {
            return null;
        }
        var isInEnvironmentPage = this.isInEnvironmentPage(this.props.location.pathname, this.props.match.params.spaceId);
        return React.createElement("div", null,
            this.state.showDetails && React.createElement(GettingStartedDialog_1.GettingStartedDialog, { onNavigating: function () { return _this.setState({ showDetails: false }); }, highlightSection: this.state.highlightSection, open: this.state.showDetails, onClose: function () { return _this.setState({ showDetails: false }); } }),
            React.createElement("div", { ref: this.setDivRef, className: styles.gettingStartedFooter },
                !this.state.canDismiss && React.createElement("div", { className: styles.gettingStartedFooterActions },
                    React.createElement("a", { className: styles.gettingStartedButton, onClick: function () { return _this.toggle(); } },
                        React.createElement("span", null, "Hide"),
                        React.createElement("em", { className: "fa fa-minus", "aria-hidden": "true" })),
                    React.createElement("a", { className: styles.gettingStartedButton, onClick: function () { return _this.toggleDetail(); } },
                        React.createElement("span", null, "Show detail"),
                        React.createElement("em", { className: "fa fa-window-maximize", "aria-hidden": "true" }))),
                !(this.state.canDismiss || this.state.expand) && React.createElement("div", { className: styles.gettingStartedMinimize },
                    React.createElement("div", { className: styles.gettingStartedFooterActions },
                        React.createElement("a", { className: styles.gettingStartedButton, onClick: function () { return _this.toggle(); } },
                            React.createElement("span", null, "Show getting started guide"),
                            React.createElement("em", { className: "fa fa-plus", "aria-hidden": "true" })))),
                this.state.canDismiss && React.createElement("div", { className: styles.gettingStartedMinimize },
                    React.createElement("div", { className: styles.gettingStartedFooterActions },
                        React.createElement("a", { className: styles.gettingStartedButton, onClick: function () { return _this.dismiss(); } },
                            React.createElement("span", null, "Thanks for your help! I don't need the progress bar anymore."),
                            React.createElement("em", { className: "fa fa-times", "aria-hidden": "true" })))),
                this.state.canDismiss && React.createElement("div", { className: styles.firstSuccessfulDeploymentContainer },
                    React.createElement("div", { className: styles.firstSuccessfulDeployment },
                        React.createElement("div", { className: styles.successAnimation },
                            React.createElement("img", { src: imageCongrats, alt: "Congratulations animation" })),
                        React.createElement("div", null,
                            React.createElement("h3", null,
                                React.createElement("strong", null, "Congratulations!")),
                            React.createElement("p", null,
                                "That was your first successful deployment for this project. We hope everything went smoothly!",
                                React.createElement("br", null),
                                " Celebrate this moment by tweeting about it."),
                            React.createElement("p", null,
                                React.createElement("strong", null, "Happy deployments!"),
                                React.createElement("br", null),
                                "- The team at Octopus"),
                            React.createElement("div", null,
                                React.createElement(FlatButton_1.default, { href: "https://g.octopushq.com/OctopusTweetNow?text=We just completed our first successful deployment with @OctopusDeploy!", target: "_blank", label: "Tweet now", labelStyle: { color: "#2f93e0" }, icon: React.createElement("em", { style: { color: "#2f93e0" }, className: "fa fa-twitter", "aria-hidden": "true" }) }))))),
                !this.state.canDismiss && this.state.expand && React.createElement("div", { className: styles.gettingStartedContent },
                    React.createElement("div", { className: styles.whatsNextContainer }, this.renderWhatsNext(isInEnvironmentPage)),
                    React.createElement("div", { className: styles.progressStepWrapper }, this.state.progressSections.map(function (s) { return React.createElement("span", { key: s.header, className: styles.progressStep },
                        React.createElement("a", { className: styles.gettingStartedButton, onClick: function () { return _this.toggleDetail(s.header); } },
                            React.createElement(GettingStartedProgress_1.default, { percent: s.percent, enabled: s.enabled, imgSrc: s.image, header: s.header }))); })))),
            React.createElement("div", { style: { paddingTop: this.state.spacer + "px" } }));
    };
    GettingStartedFooter.prototype.renderWhatsNext = function (isInEnvironmentPage) {
        var whatsNext = WhatsNext_1.default(isInEnvironmentPage, this.state.status.next, this.state.status.projects, this.state.status.releases);
        return React.createElement("div", { className: styles.whatsNext },
            React.createElement("div", { className: styles.whatsNextText }, whatsNext.text),
            whatsNext.element);
    };
    GettingStartedFooter.prototype.dismiss = function () {
        this.setState({ showBar: false });
        if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
        }
    };
    GettingStartedFooter.prototype.isDashboard = function (path, spaceId) {
        return resolvePathWithSpaceId_1.resolveStringPathWithSpaceId(routeLinks_1.default.root, spaceId) === path ||
            resolvePathWithSpaceId_1.resolveStringPathWithSpaceId(routeLinks_1.default.dashboard.root, spaceId) === path;
    };
    GettingStartedFooter.prototype.isInEnvironmentPage = function (path, spaceId) {
        return resolvePathWithSpaceId_1.resolveStringPathWithSpaceId(routeLinks_1.default.infrastructure.environments.root, spaceId) === path;
    };
    GettingStartedFooter.prototype.toggleDetail = function (highlightSection) {
        this.setState({ showDetails: true, highlightSection: highlightSection });
    };
    GettingStartedFooter.prototype.toggle = function () {
        localStorage.setItem("gettingStartedProgressBarExpanded", (!this.state.expand).toString());
        this.setState({
            expand: !this.state.expand
        });
    };
    GettingStartedFooter.prototype.isBarExpanded = function () {
        if (localStorage.getItem("gettingStartedProgressBarExpanded") !== null) {
            return localStorage.getItem("gettingStartedProgressBarExpanded") === "true" ? true : false;
        }
        return true;
    };
    GettingStartedFooter.prototype.refresh = function (status) {
        var sections = [{
                percent: 100,
                enabled: true,
                image: imageOctopus,
                header: "OCTOPUS SERVER"
            },
            {
                percent: status.tasks.Infrastructure.Percent,
                enabled: status.tasks.Infrastructure.IsEnabled,
                image: imageEnvironments,
                header: "INFRASTRUCTURE"
            },
            {
                percent: status.tasks.Package.Percent,
                enabled: status.tasks.Package.IsEnabled,
                image: imagePackage,
                header: "PACKAGING"
            },
            {
                percent: status.tasks.Project.Percent,
                enabled: status.tasks.Project.IsEnabled,
                image: imageProject,
                header: "PROJECT"
            },
            {
                percent: status.tasks.Deploy.Percent,
                enabled: status.tasks.Deploy.IsEnabled,
                image: imageDeploy,
                header: "DEPLOY"
            }];
        if (status.tasks.Deploy.DeployedRelease.IsComplete) {
            this.setState({
                canDismiss: true
            });
        }
        this.setState({
            status: status,
            progressSections: sections
        });
    };
    return GettingStartedFooter;
}(BaseComponent_1.BaseComponent));
exports.default = react_router_1.withRouter(GettingStartedFooter);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\GettingStartedFooter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\GettingStartedFooter.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CircularProgressbar_1 = __webpack_require__(1892);
var React = __webpack_require__(0);
var styles = __webpack_require__(205);
var GettingStartedProgress = function (props) { return React.createElement("div", { className: styles.progressWrapper },
    props.percent === 100 && React.createElement("div", { className: styles.complete },
        React.createElement("em", { className: "fa fa-check", "aria-hidden": "true" })),
    React.createElement("div", { className: styles.progressContainer },
        React.createElement(CircularProgressbar_1.default, { percentage: props.percent, strokeWidth: 6, image: props.imgSrc })),
    React.createElement("div", { className: styles.title }, props.header)); };
exports.default = GettingStartedProgress;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\GettingStartedProgress.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\GettingStartedProgress.tsx"); } } })();

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1893);
var MIN_PERCENTAGE = 0;
var MAX_PERCENTAGE = 100;
var CircularProgressbar = (function (_super) {
    __extends(CircularProgressbar, _super);
    function CircularProgressbar(props) {
        return _super.call(this, props) || this;
    }
    CircularProgressbar.prototype.getPathDescription = function () {
        var radius = this.getRadius();
        return "\n      M 50,50 m 0,-" + radius + "\n      a " + radius + "," + radius + " 0 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " 0 1 1 0,-" + 2 * radius + "\n    ";
    };
    CircularProgressbar.prototype.getProgressStyle = function () {
        var diameter = Math.PI * 2 * this.getRadius();
        var truncatedPercentage = Math.min(Math.max(this.props.percentage, MIN_PERCENTAGE), MAX_PERCENTAGE);
        return {
            strokeDasharray: diameter + "px " + diameter + "px",
            strokeDashoffset: ((100 - truncatedPercentage) / 100 * diameter) + "px",
            fill: "#fff"
        };
    };
    CircularProgressbar.prototype.getRadius = function () {
        return (50 - this.props.strokeWidth / 2);
    };
    CircularProgressbar.prototype.render = function () {
        var pathDescription = this.getPathDescription();
        return (React.createElement("svg", { className: styles.CircularProgressbar, viewBox: "0 0 100 100" },
            React.createElement("path", { className: styles.CircularProgressbarTrail, d: pathDescription, strokeWidth: this.props.strokeWidth, fillOpacity: 1 }),
            React.createElement("path", { className: styles.CircularProgressbarPath, d: pathDescription, strokeWidth: this.props.percentage === 0 ? 0 : this.props.strokeWidth, fillOpacity: 1, style: this.getProgressStyle() }),
            React.createElement("image", { xlinkHref: this.props.image, x: 25, y: 27, width: "50", height: "45" })));
    };
    return CircularProgressbar;
}(React.Component));
exports.default = CircularProgressbar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\CircularProgressbar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\GettingStarted\\CircularProgressbar.tsx"); } } })();

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1894);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./CircularProgressbar.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./CircularProgressbar.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".CircularProgressbar_CircularProgressbar__3sS_v{width:100%}.CircularProgressbar_CircularProgressbar__3sS_v .CircularProgressbar_CircularProgressbarPath__3Wumb{stroke:#53b953;stroke-linecap:round;transition:stroke-dashoffset .5s ease 0s}.CircularProgressbar_CircularProgressbar__3sS_v .CircularProgressbar_CircularProgressbarTrail__11oh0{stroke:#fff}.CircularProgressbar_CircularProgressbar__3sS_v .CircularProgressbar_CircularProgressbarText__2yDaK{fill:#2f93e0;font-size:1.25rem;text-anchor:middle}", ""]);

// exports
exports.locals = {
	"CircularProgressbar": "CircularProgressbar_CircularProgressbar__3sS_v",
	"circularProgressbar": "CircularProgressbar_CircularProgressbar__3sS_v",
	"CircularProgressbarPath": "CircularProgressbar_CircularProgressbarPath__3Wumb",
	"circularProgressbarPath": "CircularProgressbar_CircularProgressbarPath__3Wumb",
	"CircularProgressbarTrail": "CircularProgressbar_CircularProgressbarTrail__11oh0",
	"circularProgressbarTrail": "CircularProgressbar_CircularProgressbarTrail__11oh0",
	"CircularProgressbarText": "CircularProgressbar_CircularProgressbarText__2yDaK",
	"circularProgressbarText": "CircularProgressbar_CircularProgressbarText__2yDaK"
};

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "success-ani.cff96f558ccecff5d03a7aec739a2efe.hashedasset.svg";

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ExternalLink_1 = __webpack_require__(91);
var clientInstance_1 = __webpack_require__(10);
var Divider_1 = __webpack_require__(143);
var DataBaseComponent_1 = __webpack_require__(39);
var ErrorPanel_1 = __webpack_require__(83);
var Callout_1 = __webpack_require__(59);
var styles = __webpack_require__(1897);
var SystemMessagesBanner = (function (_super) {
    __extends(SystemMessagesBanner, _super);
    function SystemMessagesBanner(props) {
        var _this = _super.call(this, props) || this;
        var browserNotSupported = false;
        var browserName = "";
        var ieVersion = document["documentMode"];
        if (ieVersion && ieVersion <= 10) {
            browserNotSupported = true;
            browserName = "Internet Explorer " + ieVersion;
        }
        _this.state = {
            isInMaintenanceMode: false,
            browserNotSupported: browserNotSupported,
            browserName: browserName
        };
        return _this;
    }
    SystemMessagesBanner.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.beginRefreshLoop(function () { return _this.refreshData(); }, 10000)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SystemMessagesBanner.prototype.refreshData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.ServerStatus.getServerStatus()];
                    case 1:
                        status = _a.sent();
                        return [2 /*return*/, { isInMaintenanceMode: status.IsInMaintenanceMode }];
                }
            });
        });
    };
    SystemMessagesBanner.prototype.render = function () {
        return React.createElement("div", { className: styles.pageBanners },
            this.state.isInMaintenanceMode && React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Warning },
                React.createElement("p", { className: styles.warning }, "This Octopus Server is currently undergoing maintenance, and is read-only. Only Octopus administrators may make changes.")),
            this.state.errors && React.createElement(ErrorPanel_1.default, { message: this.state.errors.message, details: this.state.errors.details }),
            this.state.isInMaintenanceMode && this.state.browserNotSupported && React.createElement(Divider_1.default, null),
            this.state.browserNotSupported && React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Warning },
                React.createElement("p", { className: styles.warning },
                    "Your current browser, ",
                    React.createElement("strong", null, this.state.browserName),
                    ", is not supported in ",
                    React.createElement("strong", null, "Octopus 4"),
                    ". We still allow you to use Octopus but no guarantee that everything works!",
                    React.createElement("br", null),
                    "If you have any questions or feedback then please share them with us ",
                    React.createElement("strong", null,
                        React.createElement(ExternalLink_1.default, { href: "https://github.com/OctopusDeploy/Issues/issues/3457" }, "here")),
                    ".")));
    };
    return SystemMessagesBanner;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = SystemMessagesBanner;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SystemMessagesBanner\\SystemMessagesBanner.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\SystemMessagesBanner\\SystemMessagesBanner.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1898);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_pageBanners__1DkZ_{display:flex;flex-direction:column;background-color:#fff}.style_warning__luMpL{width:100%;text-align:center}", ""]);

// exports
exports.locals = {
	"pageBanners": "style_pageBanners__1DkZ_",
	"warning": "style_warning__luMpL"
};

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SignIn_1 = __webpack_require__(1900);
exports.default = SignIn_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\SignIn\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\SignIn\\index.tsx"); } } })();

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Checkbox_1 = __webpack_require__(118);
var AuthProvider_1 = __webpack_require__(1901);
var clientInstance_1 = __webpack_require__(10);
var URI = __webpack_require__(106);
var logger_1 = __webpack_require__(99);
var cn = __webpack_require__(19);
var form_1 = __webpack_require__(15);
var Button_1 = __webpack_require__(51);
var environment_1 = __webpack_require__(238);
var loginStateCalculator_1 = __webpack_require__(1904);
var ErrorPanel_1 = __webpack_require__(83);
var BaseComponent_1 = __webpack_require__(60);
var ExternalLink_1 = __webpack_require__(91);
var styles = __webpack_require__(1905);
var PageTitleHelper_1 = __webpack_require__(221);
var InternalRedirect_1 = __webpack_require__(40);
var routeLinks_1 = __webpack_require__(20);
var waitingForOctopusImagePath = __webpack_require__(468);
var SignIn = (function (_super) {
    __extends(SignIn, _super);
    function SignIn(props) {
        var _this = _super.call(this, props) || this;
        _this.passwordField = null;
        _this.authenticate = function (userName, password, rememberMe) { return __awaiter(_this, void 0, void 0, function () {
            var loginCommand, user, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        logger_1.default.log("Attempting to sign in: " + userName);
                        loginCommand = {
                            Username: userName,
                            Password: password,
                            RememberMe: rememberMe,
                            State: this.state.loginState
                        };
                        return [4 /*yield*/, clientInstance_1.repository.Users.signIn(loginCommand)];
                    case 1:
                        user = _a.sent();
                        return [4 /*yield*/, this.authenticationSucceeded(user)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.setError(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.onExternalAuthenticationProviderError = function (error) {
            _this.setError(error);
        };
        _this.signIn = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var busyIndicator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        busyIndicator = this.authenticate(this.state.userName, this.state.password, this.state.rememberMe);
                        this.setState({ busyIndicator: busyIndicator });
                        return [4 /*yield*/, busyIndicator];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.signInAsGuest = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authenticate("guest", "guest", true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.hideAccountTypeSelector = function () {
            _this.setState({ showAccountTypeSelector: false });
        };
        PageTitleHelper_1.default.setRootPageTitle();
        var from = ((_this.props.location && _this.props.location.state) ? _this.props.location.state : { from: { pathname: "/" } }).from;
        _this.state = {
            inProgressMessage: "Trying to connect to Octopus",
            isReady: false,
            redirectToReferrer: false,
            showAccountTypeSelector: false,
            shouldAutoSignIn: false,
            userName: "",
            password: "",
            rememberMe: false,
            loginState: _this.calculateLoginState(from.pathname + (from.search || ""))
        };
        return _this;
    }
    SignIn.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var alreadyAuthenticated, browserURI;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.client.connect(function (progress, indicator) {
                            logger_1.default.log(progress);
                            _this.setState({ inProgressMessage: progress });
                        })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.continueIfAlreadyAuthenticated()];
                    case 2:
                        alreadyAuthenticated = _a.sent();
                        if (!!alreadyAuthenticated) return [3 /*break*/, 4];
                        browserURI = URI(window.location);
                        browserURI.hasQuery("error", function (error) {
                            if (!error) {
                                return;
                            }
                            _this.setError(error);
                        });
                        return [4 /*yield*/, this.setupAuthenticationProviders()];
                    case 3:
                        _a.sent();
                        this.chromeAutoFillFix();
                        _a.label = 4;
                    case 4:
                        this.setState({ isReady: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    SignIn.prototype.render = function () {
        var _this = this;
        var from = ((this.props.location && this.props.location.state) ? this.props.location.state : { from: { pathname: routeLinks_1.default.root } }).from;
        if (!this.state.isReady) {
            return this.progressStatus();
        }
        if (this.state.redirectToReferrer) {
            return React.createElement(InternalRedirect_1.default, { to: from });
        }
        return React.createElement("div", { className: styles.container }, !this.anyAuthenticationProviders ?
            this.noAuthenticationProvidersEnabled()
            :
                React.createElement("div", null, this.state.showAccountTypeSelector ?
                    this.accountTypeSelection()
                    :
                        React.createElement("div", null,
                            React.createElement("div", { className: styles.content },
                                React.createElement("div", { className: styles.logo },
                                    React.createElement("div", null,
                                        React.createElement("em", { className: "fontoctopus-octopus" })),
                                    !this.state.authenticationError && React.createElement("div", null, this.state.shouldAutoSignIn
                                        ? React.createElement("h4", null, "Signing in, please wait...")
                                        : React.createElement("h4", null, "Welcome! Please sign in."))),
                                this.state.authenticationError && this.showError(this.state.authenticationError),
                                (this.anyFormsAuthenticationProviders || this.formsProvidersWithLinks.length > 0) &&
                                    React.createElement("div", null,
                                        this.anyFormsAuthenticationProviders &&
                                            React.createElement("form", { onSubmit: this.signIn, className: styles.form },
                                                React.createElement(form_1.Text, { value: this.state.userName, label: "Username", onChange: function (userName) { return _this.setState({ userName: userName }); }, autoFocus: true, name: "userName", id: "userName" }),
                                                React.createElement(form_1.Text, { label: "Password", textInputRef: function (ref) { return _this.passwordField = ref; }, value: this.state.password, name: "password", id: "password", type: "password", onChange: function (password) { return _this.setState({ password: password }); } }),
                                                React.createElement(Checkbox_1.default, { label: "Remember me on this computer", onChange: function (rememberMe) { return _this.setState({ rememberMe: rememberMe }); }, value: this.state.rememberMe, className: styles.rememberMe }),
                                                React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Primary, label: "SIGN IN", busyLabel: "SIGNING IN...", onClick: this.signIn })),
                                        this.formsProvidersWithLinks.map(function (p) {
                                            return React.createElement("div", { className: styles.externalAuthProvider, key: p.Name },
                                                React.createElement(AuthProvider_1.default, { provider: p, shouldAutoSignIn: _this.state.shouldAutoSignIn, loginState: _this.state.loginState, onError: _this.onExternalAuthenticationProviderError }));
                                        })),
                                this.anyNonFormsAuthenticationProviders &&
                                    React.createElement("div", { className: styles.externalNonFormsProviders }, this.nonFormsAuthenticationProviders.map(function (p) {
                                        return React.createElement("div", { className: styles.externalAuthProvider, key: p.Name },
                                            React.createElement(AuthProvider_1.default, { provider: p, shouldAutoSignIn: _this.state.shouldAutoSignIn, loginState: _this.state.loginState, onError: _this.onExternalAuthenticationProviderError }));
                                    }))),
                            this.isGuestProviderEnabled &&
                                React.createElement("div", { className: styles.guestProvider, onClick: this.signInAsGuest },
                                    React.createElement("a", null, "I AM A GUEST")))));
    };
    SignIn.prototype.setError = function (error) {
        if (!error) {
            return;
        }
        logger_1.default.error(error);
        var authenticationError = {
            ErrorMessage: error.ErrorMessage || error.message || error.toString(),
            Errors: error.Errors || []
        };
        this.setState({ authenticationError: authenticationError });
    };
    SignIn.prototype.progressStatus = function () {
        return React.createElement("div", null,
            React.createElement("img", { src: waitingForOctopusImagePath, alt: "Waiting" }),
            React.createElement("div", { className: styles.inProgressMessage }, this.state.inProgressMessage),
            this.state.authenticationError && this.showError(this.state.authenticationError));
    };
    SignIn.prototype.accountTypeSelection = function () {
        return React.createElement("div", { className: cn(styles.accountTypeSelection, styles.areas) },
            React.createElement("div", { className: styles.guestAccount, onClick: this.signInAsGuest },
                React.createElement("div", { className: styles.guestAccountIcon }),
                React.createElement("h2", null, "I am a guest")),
            React.createElement("div", { className: styles.authenticatedAccount, onClick: this.hideAccountTypeSelector },
                React.createElement("div", { className: styles.authenticatedAccountIcon }),
                React.createElement("h2", null, "I have an account")));
    };
    SignIn.prototype.setupAuthenticationProviders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var document, formsAuthenticationProviders, singleNonFormsAuthenticationProvider, showAccountTypeSelector, shouldAutoSignIn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Authentication.get()];
                    case 1:
                        document = _a.sent();
                        this.authenticationProviders = document.AuthenticationProviders;
                        this.nonFormsAuthenticationProviders = this.authenticationProviders.filter(function (p) {
                            return !p.FormsLoginEnabled && !_this.isActiveDirectory(p) && p.IdentityType !== "Guest";
                        });
                        formsAuthenticationProviders = this.authenticationProviders.filter(function (p) {
                            return p.FormsLoginEnabled && p.IdentityType !== "Guest";
                        });
                        this.anyFormsAuthenticationProviders = formsAuthenticationProviders.length > 0;
                        this.anyNonFormsAuthenticationProviders = this.nonFormsAuthenticationProviders.length > 0;
                        this.formsProvidersWithLinks = this.authenticationProviders.filter(this.isActiveDirectory);
                        this.anyAuthenticationProviders = this.anyFormsAuthenticationProviders || this.anyNonFormsAuthenticationProviders || this.formsProvidersWithLinks.length > 0;
                        this.isGuestProviderEnabled = this.authenticationProviders.filter(function (p) { return p.IdentityType === "Guest"; }).length > 0;
                        singleNonFormsAuthenticationProvider = !this.anyFormsAuthenticationProviders &&
                            (this.nonFormsAuthenticationProviders.length === 1 || this.formsProvidersWithLinks.length === 1);
                        showAccountTypeSelector = this.isGuestProviderEnabled && !this.state.authenticationError;
                        shouldAutoSignIn = document.AutoLoginEnabled && !this.state.authenticationError && singleNonFormsAuthenticationProvider && !showAccountTypeSelector;
                        this.setState({ showAccountTypeSelector: showAccountTypeSelector, shouldAutoSignIn: shouldAutoSignIn });
                        return [2 /*return*/];
                }
            });
        });
    };
    SignIn.prototype.authenticationSucceeded = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.startSession(user)];
                    case 1:
                        _a.sent();
                        this.setState({ redirectToReferrer: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    SignIn.prototype.startSession = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, permissionSet, features, error_2, message, reason, errorMessage;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Promise.all([clientInstance_1.repository.Users.getPermissions(user), clientInstance_1.repository.FeaturesConfiguration.get()])];
                    case 1:
                        _a = _b.sent(), permissionSet = _a[0], features = _a[1];
                        clientInstance_1.session.start(user, permissionSet.Permissions, features);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _b.sent();
                        logger_1.default.log(error_2);
                        message = "The sign in succeeded but we failed to get the resultant permissions for this user account. ";
                        reason = (error_2.StatusCode === 401)
                            ? "This can happen if the Octopus authentication cookie is blocked."
                            : "There was a problem communicating with the Octopus Server: " + error_2.ErrorMessage;
                        errorMessage = message + reason;
                        this.setError(errorMessage);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SignIn.prototype.isActiveDirectory = function (provider) {
        return provider.Name === "Active Directory";
    };
    SignIn.prototype.continueIfAlreadyAuthenticated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, authenticationError_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, clientInstance_1.repository.Users.getCurrent()];
                    case 1:
                        user = _a.sent();
                        logger_1.default.log("User already authenticated");
                        return [4 /*yield*/, this.authenticationSucceeded(user)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3:
                        authenticationError_1 = _a.sent();
                        logger_1.default.log(authenticationError_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, false];
                }
            });
        });
    };
    SignIn.prototype.noAuthenticationProvidersEnabled = function () {
        return React.createElement("div", null,
            "There are no authentication providers enabled. Learn about enabling ",
            React.createElement(ExternalLink_1.default, { href: "AuthenticationProviders" }, "authentication providers"));
    };
    SignIn.prototype.calculateLoginState = function (redirectToPath) {
        return loginStateCalculator_1.default(location.href, redirectToPath, environment_1.default.isInDevelopmentMode());
    };
    SignIn.prototype.showError = function (authenticationError) {
        return React.createElement("div", { className: styles.authenticationError },
            React.createElement(ErrorPanel_1.default, { message: authenticationError.ErrorMessage, details: authenticationError.Errors }));
    };
    SignIn.prototype.chromeAutoFillFix = function () {
        var _this = this;
        //Sniff for chrome
        if (!window.hasOwnProperty("chrome")) {
            return;
        }
        // When chrome autofills a password it doesn't actually put the value
        // in until the page gets clicked, but it does show the password placeholders.
        // So the text control is still in "no value" state and the label sits
        // under the placeholders.
        // Poll for the appearance of the pseudo-class chrome adds, and if we find
        // it force the control into "has value" mode.
        // More details https://stackoverflow.com/questions/35049555/chrome-autofill-autocomplete-no-value-for-password
        var checkForAutofill = setInterval(function () {
            var filled = document.querySelector("input[type=password]:-webkit-autofill");
            if (filled && _this.passwordField) {
                _this.passwordField.forceHasValue();
                clearInterval(checkForAutofill);
            }
        }, 250);
        setTimeout(function () { return clearInterval(checkForAutofill); }, 5000);
    };
    return SignIn;
}(BaseComponent_1.default));
exports.default = SignIn;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\SignIn\\SignIn.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\SignIn\\SignIn.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuthProvider_1 = __webpack_require__(1902);
exports.default = AuthProvider_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\AuthProvider\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\AuthProvider\\index.tsx"); } } })();

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(31);
var clientInstance_1 = __webpack_require__(10);
var logger_1 = __webpack_require__(99);
var extensionsManager_1 = __webpack_require__(702);
var $script = __webpack_require__(1903);
var AuthProvider = (function (_super) {
    __extends(AuthProvider, _super);
    function AuthProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthProvider.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, provider, loginState, shouldAutoSignIn, onError;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, provider = _a.provider, loginState = _a.loginState, shouldAutoSignIn = _a.shouldAutoSignIn, onError = _a.onError;
                        return [4 /*yield*/, Promise.all(this.loadCSS(provider.CSSLinks))];
                    case 1:
                        _b.sent();
                        $script(provider.JavascriptLinks.map(function (link) {
                            logger_1.default.log("Loading JS " + link);
                            return clientInstance_1.client.resolve(link);
                        }), provider.Name);
                        $script.ready(provider.Name, function () {
                            var extension = extensionsManager_1.default.getExtension(provider.Name, "auth_provider");
                            if (!extension) {
                                logger_1.default.error("Could not find authentication " + provider.Name + " extension");
                            }
                            var authProvider = extension(clientInstance_1.client, provider, loginState, onError);
                            var node = ReactDOM.findDOMNode(_this.refs.root);
                            node.innerHTML = authProvider.LinkHtml;
                            node.addEventListener("click", authProvider.SignIn);
                            if (shouldAutoSignIn) {
                                authProvider.SignIn();
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthProvider.prototype.render = function () {
        return (
        // tslint:disable:jsx-no-string-ref
        React.createElement("div", { ref: "root" }));
    };
    AuthProvider.prototype.loadCSS = function (urls) {
        return urls.map(function (url) {
            logger_1.default.log("Loading CSS " + url);
            return new Promise(function (resolve, reject) {
                var linkElement = document.createElement("link");
                linkElement.setAttribute("rel", "stylesheet");
                linkElement.setAttribute("type", "text/css");
                linkElement.setAttribute("href", clientInstance_1.client.resolve(url));
                document.getElementsByTagName("head")[0].appendChild(linkElement);
                resolve();
            });
        });
    };
    return AuthProvider;
}(React.Component));
exports.default = AuthProvider;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\AuthProvider\\AuthProvider.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\AuthProvider\\AuthProvider.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1903 */,
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var URI = __webpack_require__(106);
function calculateLoginState(currentAbsoluteUrl, redirectToPath, isInDevelopmentMode) {
    if (!currentAbsoluteUrl) {
        throw new Error("url must be set to a value");
    }
    var octopusServerKey = "octopus.server";
    var octopusServerIndex = currentAbsoluteUrl.indexOf(octopusServerKey);
    var pathName = octopusServerIndex !== -1 ?
        new URI(currentAbsoluteUrl.substring(octopusServerIndex + octopusServerKey.length + 1)).fragment()
        :
            new URI(currentAbsoluteUrl).fragment();
    var targetUrl = currentAbsoluteUrl.toString().replace(pathName, redirectToPath);
    return {
        RedirectAfterLoginTo: isInDevelopmentMode ? targetUrl : toRelative(targetUrl),
        UsingSecureConnection: currentAbsoluteUrl.startsWith("https://")
    };
}
function toRelative(url) {
    return (new URI(url)).resource();
}
exports.default = calculateLoginState;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\SignIn\\loginStateCalculator.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\SignIn\\loginStateCalculator.ts"); } } })();

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1906);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__2PH9g{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__n8_HP{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2Arrc{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2qUvv{display:none!important}}.style_container__2bfgY{margin:auto;position:relative;display:table-cell;vertical-align:middle}.style_content__gi25K{box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2),0 .125rem .125rem 0 rgba(0,0,0,.12),0 0 .125rem 0 rgba(0,0,0,.14);background-color:#fff;width:22.5rem}.style_content__gi25K,.style_content__gi25K form{display:flex;flex-direction:column;align-items:center}.style_content__gi25K form{margin:1rem 0 1.5rem}.style_rememberMe__1sdtJ{margin-top:1.5rem;margin-bottom:1.5rem}.style_logo__wUwUk{color:#fff;font-size:2rem;background-color:#2f93e0;display:flex;flex-direction:column;width:100%;justify-content:center;align-items:center}.style_logo__wUwUk h4{margin:0 0 1rem!important}.style_logo__wUwUk>div:first-child{margin:1rem 0}.style_externalAuthProvider__r6K6E{text-align:center;width:18rem;margin:1rem auto}.style_externalNonFormsProviders__2i6nn{background:hsla(0,0%,60%,.08);padding:1rem 0;width:100%}.style_guestProvider__3ormK{text-align:center;margin:1rem auto;cursor:pointer;color:#2f93e0}.style_authenticationError__14bBt{width:100%}.style_accountTypeSelection__gPucf{display:flex;flex-direction:row;align-items:center;justify-content:center;box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2)}@media (max-width:37.4rem){.style_accountTypeSelection__gPucf{flex-direction:column}}.style_guestAccount__qkhDh{background-color:#fff;color:#2f93e0;cursor:pointer;display:flex;flex-direction:column;justify-content:baseline;width:19rem;height:19rem;padding-top:5.5rem;text-align:center;-webkit-transition:all .5s linear;transition:all .5s linear}.style_guestAccount__qkhDh .style_guestAccountIcon__5EoW7{background-image:url(" + __webpack_require__(1907) + ");background-repeat:no-repeat;height:4rem;background-position:50%;margin-bottom:2rem}.style_authenticatedAccount__5T_hi{background-color:#2f93e0;color:#fff;cursor:pointer;display:flex;flex-direction:column;justify-content:baseline;width:19rem;height:19rem;padding-top:5.5rem;text-align:center;-webkit-transition:all .5s linear;transition:all .5s linear}.style_inProgressMessage__1EGl9{text-align:center}.style_authenticatedAccountIcon__1ZBkV{background-image:url(" + __webpack_require__(703) + ");background-repeat:no-repeat;height:4rem;background-position:50%;margin-bottom:2rem}.style_areas__BVG70>div{opacity:1;transition:all .5s linear}.style_areas__BVG70:hover>.style_authenticatedAccount__5T_hi:hover,.style_areas__BVG70:hover>.style_guestAccount__qkhDh:hover{opacity:1;transition:all .5s linear;box-shadow:0 .0625rem .3125rem 0 rgba(0,0,0,.2),0 .1875rem .25rem 0 rgba(0,0,0,.12),0 .125rem .25rem 0 rgba(0,0,0,.14)}.style_areas__BVG70:hover>.style_authenticatedAccount__5T_hi:not(:hover),.style_areas__BVG70:hover>.style_guestAccount__qkhDh:not(:hover){opacity:.5;transition:all .5s linear}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__2PH9g",
	"hideSm": "style_hide-sm__2PH9g",
	"visible-sm": "style_visible-sm__n8_HP",
	"visibleSm": "style_visible-sm__n8_HP",
	"hide-md": "style_hide-md__2Arrc",
	"hideMd": "style_hide-md__2Arrc",
	"visible-md": "style_visible-md__2qUvv",
	"visibleMd": "style_visible-md__2qUvv",
	"container": "style_container__2bfgY",
	"content": "style_content__gi25K",
	"rememberMe": "style_rememberMe__1sdtJ",
	"logo": "style_logo__wUwUk",
	"externalAuthProvider": "style_externalAuthProvider__r6K6E",
	"externalNonFormsProviders": "style_externalNonFormsProviders__2i6nn",
	"guestProvider": "style_guestProvider__3ormK",
	"authenticationError": "style_authenticationError__14bBt",
	"accountTypeSelection": "style_accountTypeSelection__gPucf",
	"guestAccount": "style_guestAccount__qkhDh",
	"guestAccountIcon": "style_guestAccountIcon__5EoW7",
	"authenticatedAccount": "style_authenticatedAccount__5T_hi",
	"inProgressMessage": "style_inProgressMessage__1EGl9",
	"authenticatedAccountIcon": "style_authenticatedAccountIcon__1ZBkV",
	"areas": "style_areas__BVG70"
};

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "starfish.790888107b17ffd42ac5f115f1b2c956.hashedasset.svg";

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SignOut_1 = __webpack_require__(1909);
exports.default = SignOut_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\SignOut\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\SignOut\\index.tsx"); } } })();

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Button_1 = __webpack_require__(51);
var clientInstance_1 = __webpack_require__(10);
var BaseComponent_1 = __webpack_require__(60);
var styles = __webpack_require__(1910);
var ErrorPanel_1 = __webpack_require__(83);
var PageTitleHelper_1 = __webpack_require__(221);
var InternalRedirect_1 = __webpack_require__(40);
var routeLinks_1 = __webpack_require__(20);
var SignOut = (function (_super) {
    __extends(SignOut, _super);
    function SignOut(props) {
        var _this = _super.call(this, props) || this;
        _this.goBack = function () {
            _this.props.history.goBack();
        };
        _this.signOut = function () { return __awaiter(_this, void 0, void 0, function () {
            var err_1, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, clientInstance_1.repository.Users.signOut()];
                    case 1:
                        _a.sent();
                        clientInstance_1.session.end();
                        this.setState({ isSignedOut: true });
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        error = {
                            message: err_1.ErrorMessage || err_1.message || err_1.toString(),
                            details: err_1.Errors || []
                        };
                        this.setState({ error: error });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        PageTitleHelper_1.default.setRootPageTitle();
        _this.state = { isSignedOut: false };
        return _this;
    }
    SignOut.prototype.render = function () {
        return this.state.isSignedOut ? React.createElement(InternalRedirect_1.default, { to: routeLinks_1.default.currentUser.signIn }) :
            React.createElement("div", { className: styles.content },
                !this.state.error && React.createElement("div", { className: styles.logo },
                    React.createElement("em", { className: "fontoctopus-octopus" })),
                this.state.error && this.showError(this.state.error),
                React.createElement("div", { className: styles.description },
                    React.createElement("h3", null, "Are you sure you want to sign out?"),
                    React.createElement("p", null,
                        "Clicking ",
                        React.createElement("strong", null, "Sign out"),
                        " will clear our cookies and log you out on this device."),
                    React.createElement("div", null,
                        React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Primary, label: "SIGN OUT", busyLabel: "SIGNING OUT...", onClick: this.signOut })),
                    React.createElement("div", { className: styles.back },
                        React.createElement("a", { href: "#", onClick: this.goBack }, "No, I want to stay!"))));
    };
    SignOut.prototype.showError = function (error) {
        return React.createElement("div", { className: styles.authenticationError },
            React.createElement(ErrorPanel_1.default, { message: error.message, details: error.details }));
    };
    return SignOut;
}(BaseComponent_1.default));
exports.default = SignOut;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\SignOut\\SignOut.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\SignOut\\SignOut.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1911);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__33tvz{display:flex;flex-direction:column;text-align:center}.style_container__33tvz>*{margin:1.5rem 0 0}.style_content__1LOJa{display:flex;flex-direction:column;align-items:center;background:#fff;width:23.5rem;text-align:center;box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2),0 .125rem .125rem 0 rgba(0,0,0,.12),0 0 .125rem 0 rgba(0,0,0,.14)}.style_description__27bFu{padding:0 1.5rem 1.5rem;width:100%}.style_back__16GgO{padding-top:1.5rem}.style_logo__1S36P{background-color:#2f93e0;color:#fff;font-size:2rem;display:flex;flex-direction:row;width:100%;justify-content:center;align-items:center;padding:.5rem}", ""]);

// exports
exports.locals = {
	"container": "style_container__33tvz",
	"content": "style_content__1LOJa",
	"description": "style_description__27bFu",
	"back": "style_back__16GgO",
	"logo": "style_logo__1S36P"
};

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Register_1 = __webpack_require__(1913);
exports.default = Register_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\Register\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\Register\\index.tsx"); } } })();

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var logger_1 = __webpack_require__(99);
var form_1 = __webpack_require__(15);
var Button_1 = __webpack_require__(51);
var Section_1 = __webpack_require__(90);
var ErrorPanel_1 = __webpack_require__(83);
var BaseComponent_1 = __webpack_require__(60);
var ExternalLink_1 = __webpack_require__(91);
var styles = __webpack_require__(1914);
var InternalRedirect_1 = __webpack_require__(40);
var routeLinks_1 = __webpack_require__(20);
var waitingForOctopusImagePath = __webpack_require__(468);
var Register = (function (_super) {
    __extends(Register, _super);
    function Register(props) {
        var _this = _super.call(this, props) || this;
        _this.register = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var busyIndicator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        busyIndicator = this.registerUser(this.state.userName, this.state.password);
                        this.setState({ busyIndicator: busyIndicator });
                        return [4 /*yield*/, busyIndicator];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.registerUser = function (userName, password) { return __awaiter(_this, void 0, void 0, function () {
            var result, user, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (this.state.password !== this.state.confirmPassword) {
                            this.setError({
                                ErrorMessage: "There was a problem with your request.",
                                Errors: ["The passwords you entered do not match."]
                            });
                            return [2 /*return*/];
                        }
                        if (userName === null || userName.trim().length === 0) {
                            this.setError({
                                ErrorMessage: "There was a problem with your request.",
                                Errors: ["Please supply a username."]
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, clientInstance_1.repository.Users.register({
                                Username: userName,
                                DisplayName: this.state.displayName,
                                EmailAddress: this.state.emailAddress,
                                Password: password,
                                InvitationCode: this.state.inviteCode,
                                IsActive: true
                            })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Users.signIn({ Username: userName, Password: password })];
                    case 2:
                        user = _a.sent();
                        return [4 /*yield*/, this.authenticationSucceeded(user)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.setError(error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            inProgressMessage: "Trying to connect to Octopus",
            isReady: false,
            redirectToReferrer: false,
            userName: "",
            password: "",
            confirmPassword: "",
            inviteCode: "",
            displayName: "",
            emailAddress: ""
        };
        return _this;
    }
    Register.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var inviteCode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.client.connect(function (progress, indicator) {
                            logger_1.default.log(progress);
                            _this.setState({ inProgressMessage: progress });
                        })];
                    case 1:
                        _a.sent();
                        inviteCode = this.props.match.params.inviteCode;
                        this.setState({
                            isReady: true,
                            inviteCodeInUri: !!inviteCode,
                            inviteCode: inviteCode
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Register.prototype.render = function () {
        var _this = this;
        if (!this.state.isReady) {
            return this.progressStatus();
        }
        if (this.state.redirectToReferrer) {
            return React.createElement(InternalRedirect_1.default, { to: routeLinks_1.default.root });
        }
        return React.createElement("div", { className: styles.content },
            React.createElement("div", { className: styles.logo },
                React.createElement("div", null,
                    React.createElement("em", { className: "fontoctopus-octopus" })),
                !this.state.authenticationError && React.createElement("div", null,
                    React.createElement("h4", null, "Let's get started."))),
            this.state.authenticationError && this.showError(this.state.authenticationError),
            React.createElement(Section_1.Section, null,
                "Welcome to ",
                React.createElement(ExternalLink_1.default, { href: "ProductHomePage" }, "Octopus Deploy!"),
                " Since this is your first time here, you will need to create an account."),
            React.createElement("form", { onSubmit: this.register, className: styles.form },
                !this.state.inviteCodeInUri &&
                    React.createElement(form_1.Text, { value: this.state.inviteCode, label: "Invitation code", onChange: function (inviteCode) { return _this.setState({ inviteCode: inviteCode }); } }),
                React.createElement(form_1.Text, { value: this.state.userName, label: "Username", onChange: function (userName) { return _this.setState({ userName: userName }); }, autoFocus: true }),
                React.createElement(form_1.Text, { value: this.state.displayName, label: "Display name", onChange: function (displayName) { return _this.setState({ displayName: displayName }); } }),
                React.createElement(form_1.Text, { value: this.state.emailAddress, label: "Email address", onChange: function (emailAddress) { return _this.setState({ emailAddress: emailAddress }); } }),
                React.createElement("span", null,
                    "This will be used to show your ",
                    React.createElement(ExternalLink_1.default, { href: "Gravatar" }, "Gravatar"),
                    "."),
                React.createElement(form_1.Text, { label: "Password", value: this.state.password, type: "password", onChange: function (password) { return _this.setState({ password: password }); } }),
                React.createElement(form_1.Text, { value: this.state.confirmPassword, type: "password", onChange: function (confirmPassword) { return _this.setState({ confirmPassword: confirmPassword }); }, label: "Confirm password" }),
                React.createElement("div", { className: styles.footerActions },
                    React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Primary, label: "Create Account", busyLabel: "Creating...", onClick: this.register }),
                    React.createElement("div", null, "or"),
                    React.createElement(Button_1.NavigationButton, { href: routeLinks_1.default.currentUser.signIn, label: "sign in" }))));
    };
    Register.prototype.progressStatus = function () {
        return React.createElement("div", null,
            React.createElement("img", { src: waitingForOctopusImagePath, alt: "Waiting" }),
            React.createElement("div", { className: styles.inProgressMessage }, this.state.inProgressMessage),
            this.state.authenticationError && this.showError(this.state.authenticationError));
    };
    Register.prototype.authenticationSucceeded = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.startSession(user)];
                    case 1:
                        _a.sent();
                        this.setState({ redirectToReferrer: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    Register.prototype.startSession = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, permissionSet, features, error_2, message, reason, errorMessage;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Promise.all([clientInstance_1.repository.Users.getPermissions(user), clientInstance_1.repository.FeaturesConfiguration.get()])];
                    case 1:
                        _a = _b.sent(), permissionSet = _a[0], features = _a[1];
                        clientInstance_1.session.start(user, permissionSet.Permissions, features);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _b.sent();
                        logger_1.default.log(error_2);
                        message = "The sign in succeeded but we failed to get the resultant permissions for this user account. ";
                        reason = (error_2.StatusCode === 401)
                            ? "This can happen if the Octopus authentication cookie is blocked."
                            : "There was a problem communicating with the Octopus Server: " + error_2.ErrorMessage;
                        errorMessage = message + reason;
                        this.setError(errorMessage);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Register.prototype.setError = function (error) {
        if (!error) {
            return;
        }
        logger_1.default.error(error);
        var authenticationError = {
            ErrorMessage: error.ErrorMessage || error.message || error.toString(),
            Errors: error.Errors || []
        };
        this.setState({ authenticationError: authenticationError });
    };
    Register.prototype.showError = function (authenticationError) {
        return React.createElement("div", { className: styles.authenticationError },
            React.createElement(ErrorPanel_1.default, { message: authenticationError.ErrorMessage, details: authenticationError.Errors }));
    };
    return Register;
}(BaseComponent_1.default));
exports.default = Register;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\Register\\Register.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\Register\\Register.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1915);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1B6f-{margin:auto;position:relative;display:table-cell;vertical-align:middle}.style_content__3ipwL{box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2),0 .125rem .125rem 0 rgba(0,0,0,.12),0 0 .125rem 0 rgba(0,0,0,.14);background-color:#fff;width:22.5rem}.style_content__3ipwL,.style_content__3ipwL form{display:flex;flex-direction:column;align-items:center}.style_content__3ipwL form{margin:1rem 0 1.5rem}.style_rememberMe__g7_Zx{margin-top:1.5rem;margin-bottom:1.5rem}.style_logo__a7107{color:#fff;font-size:2rem;background-color:#2f93e0;display:flex;flex-direction:column;width:100%;justify-content:center;align-items:center}.style_logo__a7107 h4{margin:0 0 1rem!important}.style_logo__a7107>div:first-child{margin:1rem 0}.style_authenticationError__2jxOi{width:100%}.style_accountTypeSelection__1CPDs{display:flex;width:38rem;height:19rem;box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2)}.style_authenticatedAccount__5vIV-{background-color:#2f93e0;color:#fff;cursor:pointer;width:50%;padding-top:5.5rem;text-align:center;-webkit-transition:all .5s linear;transition:all .5s linear}.style_waitingForOctopus__18CU8{margin:auto;width:22rem;position:relative;display:block;vertical-align:middle;text-align:center}.style_waitingForOctopus__18CU8>div{text-align:center}.style_waitingLogo__MG9Qk{color:#2f93e0;margin:0 auto;font-size:4rem;width:60px;height:63px;object-fit:contain;position:relative;bottom:0;z-index:2;margin-bottom:20px}.style_authenticatedAccountIcon__BuTUQ{background-image:url(" + __webpack_require__(703) + ");background-repeat:no-repeat;height:4rem;background-position:50%;margin-bottom:2rem}.style_areas__oMPzg>div{opacity:1;transition:all .5s linear}.style_areas__oMPzg:hover>.style_authenticatedAccount__5vIV-:hover,.style_areas__oMPzg:hover>.style_guestAccount__1StFV:hover{opacity:1;transition:all .5s linear;box-shadow:0 .0625rem .3125rem 0 rgba(0,0,0,.2),0 .1875rem .25rem 0 rgba(0,0,0,.12),0 .125rem .25rem 0 rgba(0,0,0,.14)}.style_areas__oMPzg:hover>.style_authenticatedAccount__5vIV-:not(:hover),.style_areas__oMPzg:hover>.style_guestAccount__1StFV:not(:hover){opacity:.5;transition:all .5s linear}.style_footerActions__1FPqe{width:100%;display:flex;flex-direction:row;justify-content:space-between;align-items:center}", ""]);

// exports
exports.locals = {
	"container": "style_container__1B6f-",
	"content": "style_content__3ipwL",
	"rememberMe": "style_rememberMe__g7_Zx",
	"logo": "style_logo__a7107",
	"authenticationError": "style_authenticationError__2jxOi",
	"accountTypeSelection": "style_accountTypeSelection__1CPDs",
	"authenticatedAccount": "style_authenticatedAccount__5vIV-",
	"waitingForOctopus": "style_waitingForOctopus__18CU8",
	"waitingLogo": "style_waitingLogo__MG9Qk",
	"authenticatedAccountIcon": "style_authenticatedAccountIcon__BuTUQ",
	"areas": "style_areas__oMPzg",
	"guestAccount": "style_guestAccount__1StFV",
	"footerActions": "style_footerActions__1FPqe"
};

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getUserConfirmation_1 = __webpack_require__(1917);
exports.default = getUserConfirmation_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ConfirmNavigate\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ConfirmNavigate\\index.ts"); } } })();

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ConfirmNavigate_1 = __webpack_require__(1918);
var ReactDOM = __webpack_require__(31);
var React = __webpack_require__(0);
var colors_1 = __webpack_require__(32);
var Theme_1 = __webpack_require__(704);
var getUserConfirmation = function (message, callback) {
    var app = document.getElementById("app");
    var modal = document.createElement("div");
    app.appendChild(modal);
    var withCleanup = function (answer) {
        callback(answer);
        setTimeout(function () {
            // give the close animation time
            ReactDOM.unmountComponentAtNode(modal);
            app.removeChild(modal);
        }, 500);
    };
    ReactDOM.render(
    // we HAVE to explicitly set the theme here or this doesn't work
    React.createElement(Theme_1.default, { theme: colors_1.theme },
        React.createElement(ConfirmNavigate_1.default, { message: message, callback: withCleanup })), modal);
};
exports.default = getUserConfirmation;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ConfirmNavigate\\getUserConfirmation.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ConfirmNavigate\\getUserConfirmation.tsx"); } } })();

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Dialog_1 = __webpack_require__(158);
var ActionButton_1 = __webpack_require__(50);
var react_event_listener_1 = __webpack_require__(55);
var ConfirmNavigate = (function (_super) {
    __extends(ConfirmNavigate, _super);
    function ConfirmNavigate(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTouchTap = function (navigate) {
            _this.setState({
                show: false
            });
            _this.props.callback(navigate);
        };
        _this.handleKeyDown = function (event) {
            if (event.keyCode === 27 /*esc*/) {
                _this.handleTouchTap(false);
            }
        };
        _this.state = {
            show: true
        };
        return _this;
    }
    ConfirmNavigate.prototype.render = function () {
        var _this = this;
        var actions = [
            React.createElement(ActionButton_1.default, { style: { marginRight: "5px" }, key: "discard", label: "Discard Changes", onClick: function () { return _this.handleTouchTap(true); } }),
            React.createElement(ActionButton_1.default, { key: "cancel", label: "Cancel", type: ActionButton_1.ActionButtonType.Primary, keyboardFocused: true, onClick: function () { return _this.handleTouchTap(false); } })
        ];
        return React.createElement(Dialog_1.default, { title: "Unsaved Changes", actions: actions, modal: true, open: this.state.show, autoScrollBodyContent: true },
            React.createElement(react_event_listener_1.default, { target: "document", onKeyDown: this.handleKeyDown }),
            this.props.message);
    };
    return ConfirmNavigate;
}(React.Component));
exports.default = ConfirmNavigate;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ConfirmNavigate\\ConfirmNavigate.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\ConfirmNavigate\\ConfirmNavigate.tsx"); } } })();

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MuiThemeProvider_1 = __webpack_require__(571);
var getMuiTheme_1 = __webpack_require__(572);
var Theme = function (props) {
    return React.createElement(MuiThemeProvider_1.default, { muiTheme: getMuiTheme_1.default(props.theme) }, props.children);
};
exports.default = Theme;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Theme\\Theme.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Theme\\Theme.tsx"); } } })();

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuthenticationLayout_1 = __webpack_require__(1921);
exports.default = AuthenticationLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\AuthenticationLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\AuthenticationLayout\\index.tsx"); } } })();

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuthenticationLayoutInternal_1 = __webpack_require__(1922);
var react_redux_1 = __webpack_require__(67);
var AuthenticationLayout = react_redux_1.connect(function (state) {
    return {
        unhandledError: state.unhandledError
    };
})(AuthenticationLayoutInternal_1.default);
exports.default = AuthenticationLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\AuthenticationLayout\\AuthenticationLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\AuthenticationLayout\\AuthenticationLayout.tsx"); } } })();

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var CenteredLayout_1 = __webpack_require__(1923);
var ErrorPanel_1 = __webpack_require__(83);
var AuthenticationLayoutInternal = (function (_super) {
    __extends(AuthenticationLayoutInternal, _super);
    function AuthenticationLayoutInternal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthenticationLayoutInternal.prototype.render = function () {
        return React.createElement(CenteredLayout_1.default, null,
            this.props.unhandledError && React.createElement(ErrorPanel_1.default, { message: this.props.unhandledError.message, details: this.props.unhandledError.details }),
            this.props.children);
    };
    return AuthenticationLayoutInternal;
}(React.Component));
exports.default = AuthenticationLayoutInternal;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\AuthenticationLayout\\AuthenticationLayoutInternal.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\areas\\authentication\\AuthenticationLayout\\AuthenticationLayoutInternal.tsx"); } } })();

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1924);
var CenteredLayout = (function (_super) {
    __extends(CenteredLayout, _super);
    function CenteredLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CenteredLayout.prototype.render = function () {
        return React.createElement("div", { className: styles.container }, this.props.children);
    };
    return CenteredLayout;
}(React.Component));
exports.default = CenteredLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\CenteredLayout\\CenteredLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\CenteredLayout\\CenteredLayout.tsx"); } } })();

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1925);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_container__2TMMJ{display:flex;align-items:center;height:100vh;justify-content:center;flex-direction:column}", ""]);

// exports
exports.locals = {
	"container": "style_container__2TMMJ"
};

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1927);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../node_modules/less-loader/dist/cjs.js!./index.less", function() {
			var newContent = require("!!../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../node_modules/less-loader/dist/cjs.js!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports
exports.i(__webpack_require__(1928), "");

// module
exports.push([module.i, "@media (max-width:37.4rem){.hide-sm{display:none!important}}@media (min-width:37.4rem){.visible-sm{display:none!important}}@media (max-width:79.9rem){.hide-md{display:none!important}}@media (min-width:79.9rem){.visible-md{display:none!important}}@font-face{font-family:Roboto;src:url(" + __webpack_require__(403) + ");font-weight:400}@font-face{font-family:Roboto;src:url(" + __webpack_require__(404) + ");font-weight:400;font-style:italic}@font-face{font-family:Roboto;src:url(" + __webpack_require__(405) + ");font-weight:300}@font-face{font-family:Roboto;src:url(" + __webpack_require__(406) + ");font-weight:500}@font-face{font-family:Roboto;src:url(" + __webpack_require__(407) + ");font-weight:600}@font-face{font-family:fontoctopus;src:url(" + __webpack_require__(210) + ");src:url(" + __webpack_require__(210) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(408) + ") format(\"woff\"),url(" + __webpack_require__(409) + ") format(\"truetype\"),url(" + __webpack_require__(410) + ") format(\"svg\");font-weight:400;font-style:normal}.fontoctopus-octopus{display:inline-block;font:normal normal normal 1em fontoctopus;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;speak:none}.fontoctopus-octopus:before{content:\"\\E800\"}@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(411) + ");src:url(" + __webpack_require__(412) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + __webpack_require__(413) + ") format(\"woff2\"),url(" + __webpack_require__(414) + ") format(\"woff\"),url(" + __webpack_require__(415) + ") format(\"truetype\"),url(" + __webpack_require__(416) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes index_fa-spin__2DYmt{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes index_fa-spin__2DYmt{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.monospace{font-family:Menlo,Monaco,Consolas,Courier New,monospace;line-height:1.2rem}h1{font-size:1.625rem;font-weight:400}@media (max-width:37.4rem){h1{font-size:1.4375rem}}h2{font-size:1.25rem;font-weight:400}@media (max-width:37.4rem){h2{font-size:1.0625rem}}h3{font-size:1.125rem;font-weight:400}@media (max-width:37.4rem){h3{font-size:1.0625rem}}h4{font-size:1.0625rem;font-weight:500;margin:1rem 0 .5rem}h5{font-size:.8125rem;font-weight:400}hr{display:block;height:.0625rem;border:0;border-top:.0625rem solid #ccc;margin:1em 0;padding:0}a{color:#2f93e0}a:hover{color:#0a67b1}p{margin:1rem 0;color:#333}input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #fff inset!important}input::-ms-clear{width:0;height:0}small{font-size:.875rem;line-height:1.1875rem}.secondary{color:#9e9e9e}a{text-decoration:none}ol,ul{list-style-type:none;padding:0}code{font-family:Menlo,Monaco,Consolas,Courier New,monospace;color:#441c7f;border-radius:.125rem;padding:.125rem .25rem;line-height:normal}code,pre{background-color:#f4ebf9}pre{border:.0625rem solid #ccc;padding:.4rem;margin:0 0 .4rem;word-break:break-all;word-wrap:break-word;white-space:pre-wrap}", ""]);

// exports
exports.locals = {
	"fa-spin": "index_fa-spin__2DYmt",
	"faSpin": "index_fa-spin__2DYmt"
};

/***/ }),
/* 1928 */,
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1930);
__webpack_require__(273);
__webpack_require__(1932);
__webpack_require__(398);
__webpack_require__(1933);
__webpack_require__(1934);
__webpack_require__(1935);
__webpack_require__(1937);
__webpack_require__(1939);
__webpack_require__(1941);
__webpack_require__(1943);
__webpack_require__(1947);
__webpack_require__(1948);
__webpack_require__(1949);
__webpack_require__(1951);
__webpack_require__(1955);
__webpack_require__(1956);
__webpack_require__(1958);
__webpack_require__(1959);
__webpack_require__(1960);
__webpack_require__(1961);
__webpack_require__(1963);
__webpack_require__(1964);
__webpack_require__(1966);
__webpack_require__(1967);
__webpack_require__(1970);
__webpack_require__(1971);
__webpack_require__(1972);
__webpack_require__(1973);
__webpack_require__(1974);
__webpack_require__(1976);
__webpack_require__(1977);
__webpack_require__(1978);
__webpack_require__(1979);
__webpack_require__(1980);
__webpack_require__(1981);
__webpack_require__(1982);
__webpack_require__(1983);
__webpack_require__(714);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\index.ts"); } } })();

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var tentaclePackageAction_1 = __webpack_require__(398);
var getFeedName_1 = __webpack_require__(66);
var ActionDetails_1 = __webpack_require__(27);
var IISActionSummary = (function (_super) {
    __extends(IISActionSummary, _super);
    function IISActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    IISActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    IISActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy to IIS using package ",
            React.createElement("strong", null,
                this.props.properties[specialVariables_1.default.Action.Package.PackageId],
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, this.getFeedId()),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    IISActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return IISActionSummary;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.IIS",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(IISActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: tentaclePackageAction_1.TentaclePackageActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
    features: {
        permanent: ["Octopus.Features.IISWebSite"],
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"],
        initial: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\iis\\iisAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\iis\\iisAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var AutoComplete_1 = __webpack_require__(448);
__export(__webpack_require__(448));
exports.default = AutoComplete_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\AutoComplete\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\AutoComplete\\index.ts"); } } })();

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ActionDetails_1 = __webpack_require__(27);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var Roles_1 = __webpack_require__(35);
var resources_1 = __webpack_require__(26);
var form_1 = __webpack_require__(15);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var FormSectionHeading_1 = __webpack_require__(46);
var HealthCheckActionSummary = (function (_super) {
    __extends(HealthCheckActionSummary, _super);
    function HealthCheckActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HealthCheckActionSummary.prototype.render = function () {
        var healthCheckTypeName = this.humanise(this.props.properties[specialVariables_1.default.Action.HealthCheck.Type]);
        return React.createElement("div", null,
            " Perform a ",
            healthCheckTypeName,
            " ",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                "for ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    HealthCheckActionSummary.prototype.humanise = function (type) {
        switch (type) {
            case "FullHealthCheck": return "full health check";
            case "ConnectionTest": return "connection check";
        }
        return "check";
    };
    return HealthCheckActionSummary;
}(BaseComponent_1.BaseComponent));
var HealthCheckActionEdit = (function (_super) {
    __extends(HealthCheckActionEdit, _super);
    function HealthCheckActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HealthCheckActionEdit.prototype.componentDidMount = function () {
        var properties = this.props.properties;
        this.props.setProperties((_a = {},
            _a["Octopus.Action.HealthCheck.Type"] = properties["Octopus.Action.HealthCheck.Type"] || "FullHealthCheck",
            _a["Octopus.Action.HealthCheck.ErrorHandling"] = properties["Octopus.Action.HealthCheck.ErrorHandling"] || "TreatExceptionsAsErrors",
            _a["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"] = properties["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"] || "DoNotAlterMachines",
            _a), true);
        var _a;
    };
    HealthCheckActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Health check" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.HealthCheck.Type", title: "Health check type", summary: properties["Octopus.Action.HealthCheck.Type"] === "FullHealthCheck"
                    ? form_1.Summary.default("Perform a full health check")
                    : form_1.Summary.summary("Perform a connection-only test"), help: "Choose to perform a full health check or a conneciton-only test" },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: properties["Octopus.Action.HealthCheck.Type"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.HealthCheck.Type"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "FullHealthCheck", label: "Perform a full health check", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "ConnectionTest", label: "Perform a connection-only test" }))),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.HealthCheck.ErrorHandling", title: "Health check errors", summary: properties["Octopus.Action.HealthCheck.ErrorHandling"] === "TreatExceptionsAsErrors"
                    ? form_1.Summary.default("Fail the deployment if any targets are unavailable")
                    : form_1.Summary.summary("Skip deployment targets that are unavailable"), help: "Select which action to take on a health check error" },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: properties["Octopus.Action.HealthCheck.ErrorHandling"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.HealthCheck.ErrorHandling"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "TreatExceptionsAsErrors", label: "Fail the deployment", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "TreatExceptionsAsWarnings", label: "Skip deployment targets that are unavailable" }))),
            React.createElement(FormSectionHeading_1.default, { title: "Machine Selection" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.HealthCheck.IncludeMachinesInDeployment", title: "New Deployment Targets", summary: properties["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"] === "DoNotAlterMachines"
                    ? form_1.Summary.default("Ignore any newly available deployment targets")
                    : form_1.Summary.summary("Include new deployment targets in the deployment"), help: "Select which action to take on new machines." },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: properties["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "DoNotAlterMachines", label: "Ignore any newly available deployment targets", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "IncludeCheckedMachines", label: "Include new deployment targets in the deployment" }))));
    };
    return HealthCheckActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    actionType: "Octopus.HealthCheck",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(HealthCheckActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: HealthCheckActionEdit,
    canHaveChildren: function (step) { return false; },
    canBeChild: false,
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    targetRoleOption: ActionDetails_1.TargetRoles.Required,
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\healthCheck\\healthCheckAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\healthCheck\\healthCheckAction.tsx"); } } })();

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var tentaclePackageAction_1 = __webpack_require__(398);
var getFeedName_1 = __webpack_require__(66);
var ActionDetails_1 = __webpack_require__(27);
var WindowsServiceActionSummary = (function (_super) {
    __extends(WindowsServiceActionSummary, _super);
    function WindowsServiceActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    WindowsServiceActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    WindowsServiceActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy Windows Service using package ",
            React.createElement("strong", null,
                this.props.properties[specialVariables_1.default.Action.Package.PackageId],
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, this.getFeedId()),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    WindowsServiceActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return WindowsServiceActionSummary;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.WindowsService",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(WindowsServiceActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: tentaclePackageAction_1.TentaclePackageActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
    features: {
        permanent: ["Octopus.Features.WindowsService"],
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"],
        initial: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\windowsService\\windowsServiceAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\windowsService\\windowsServiceAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var clientInstance_1 = __webpack_require__(10);
var index_1 = __webpack_require__(23);
var form_1 = __webpack_require__(15);
var TeamMultiSelect_1 = __webpack_require__(289);
var ParseHelper_1 = __webpack_require__(75);
var actionExecutionLocation_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(27);
var MarkdownEditor_1 = __webpack_require__(278);
var ManualActionSummary = (function (_super) {
    __extends(ManualActionSummary, _super);
    function ManualActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ManualActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Manual intervention");
    };
    return ManualActionSummary;
}(BaseComponent_1.BaseComponent));
var ManualActionEdit = (function (_super) {
    __extends(ManualActionEdit, _super);
    function ManualActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            teams: [],
        };
        return _this;
    }
    ManualActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var teams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Teams.all()];
                    case 1:
                        teams = _a.sent();
                        this.setState({ teams: teams });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ManualActionEdit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(form_1.FormSectionHeading, { title: "Manual Intervention" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Manual.Instructions", title: "Instructions", help: "These instructions will be presented to the user to follow.", summary: this.instructionsSummary() },
                React.createElement(MarkdownEditor_1.VariableLookupMarkdownEditor, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Manual.Instructions"], label: "Instructions", error: this.props.getFieldError("Octopus.Action.Manual.Instructions"), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Manual.Instructions"] = val, _a));
                        var _a;
                    }, validate: form_1.required("Please provide instructions to display during the step") })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Manual.ResponsibleTeamIds", title: "Responsible Teams", summary: this.teamSummary(), help: "Select the teams responsible for this manual step." },
                React.createElement(TeamMultiSelect_1.default, { label: "Responsible teams", items: this.state.teams, value: ParseHelper_1.default.parseCSV(this.props.properties["Octopus.Action.Manual.ResponsibleTeamIds"]), error: this.props.getFieldError("Octopus.Action.Manual.ResponsibleTeamIds"), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Manual.ResponsibleTeamIds"] = ParseHelper_1.default.encodeCSV(val), _a));
                        var _a;
                    } }),
                React.createElement(form_1.Note, null, "If no teams are specified, all users who have permission to deploy the project will be able to perform the manual step. When one or more teams are specified, as in the case of an approval workflow, then only members of those teams will be able to perform the step."),
                React.createElement(form_1.Note, null, "Specifying responsible teams will make the step unable to be skipped.")));
    };
    ManualActionEdit.prototype.instructionsSummary = function () {
        var instructions = this.props.properties["Octopus.Action.Manual.Instructions"];
        return instructions
            ? form_1.Summary.summary("Instructions have been provided")
            : form_1.Summary.placeholder("Instructions have not been provided");
    };
    ManualActionEdit.prototype.teamSummary = function () {
        var teams = ParseHelper_1.default.parseCSV(this.props.properties["Octopus.Action.Manual.ResponsibleTeamIds"]);
        if (teams.length === 0) {
            return form_1.Summary.placeholder("All authorized teams");
        }
        var chips = this.state.teams.filter(function (t) { return teams.indexOf(t.Id) !== -1; }).map(function (t) { return React.createElement(index_1.TeamChip, { team: t, key: t.Id }); });
        return form_1.Summary.summary(React.createElement("div", null, chips));
    };
    return ManualActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.Manual",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(ManualActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return false; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.None,
    hasPackages: function (action) { return false; },
    edit: ManualActionEdit
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\manual\\manualAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\manual\\manualAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var EmailLink_1 = __webpack_require__(1936);
var Targets_1 = __webpack_require__(694);
var Chips_1 = __webpack_require__(23);
var FormSectionHeading_1 = __webpack_require__(46);
var form_1 = __webpack_require__(15);
var Text_1 = __webpack_require__(17);
var TeamMultiSelect_1 = __webpack_require__(289);
var ParseHelper_1 = __webpack_require__(75);
var actionExecutionLocation_1 = __webpack_require__(37);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var MoreInfo_1 = __webpack_require__(294);
var emailPriority_1 = __webpack_require__(807);
var ActionDetails_1 = __webpack_require__(27);
var LookupResourceChip_1 = __webpack_require__(144);
var TeamsList = (function (_super) {
    __extends(TeamsList, _super);
    function TeamsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TeamsList;
}(Targets_1.default));
var LookupTeamChip = LookupResourceChip_1.default();
var EmailActionSummary = (function (_super) {
    __extends(EmailActionSummary, _super);
    function EmailActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    EmailActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var teams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Teams.all()];
                    case 1:
                        teams = _a.sent();
                        this.setState({ teams: teams });
                        return [2 /*return*/];
                }
            });
        });
    };
    EmailActionSummary.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var toTeamIds = properties[specialVariables_1.default.Action.Email.ToTeamIds];
        var teamIds = toTeamIds ? toTeamIds.split(",") : [];
        return React.createElement("div", null,
            "Send an email to ",
            React.createElement(EmailLink_1.default, { emailAddress: properties[specialVariables_1.default.Action.Email.To] }),
            teamIds && this.state.teams && React.createElement("span", null,
                React.createElement(TeamsList, { targets: teamIds.map(function (id) {
                        return React.createElement(LookupTeamChip, { lookupCollection: _this.state.teams, key: id, lookupId: id, type: Chips_1.ChipIcon.Team, chipRender: function (team) { return React.createElement(Chips_1.TeamChip, { team: team }); } });
                    }) })),
            properties[specialVariables_1.default.Action.Email.CC] || properties[specialVariables_1.default.Action.Email.CCTeamIds] ||
                properties[specialVariables_1.default.Action.Email.Bcc] || properties[specialVariables_1.default.Action.Email.BccTeamIds] ? " (including CC/BCC)" : null);
    };
    return EmailActionSummary;
}(BaseComponent_1.BaseComponent));
var EmailActionEdit = (function (_super) {
    __extends(EmailActionEdit, _super);
    function EmailActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            teams: [],
            bodyHelpExpanded: false
        };
        return _this;
    }
    EmailActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var teams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Teams.all()];
                    case 1:
                        teams = _a.sent();
                        this.setState({ teams: teams });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    EmailActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Send an Email" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Email.To", title: "To", summary: this.toSummary(), help: React.createElement("div", null,
                    "At least one ",
                    React.createElement("em", null, "To"),
                    " address or ",
                    React.createElement("em", null, "Team"),
                    " must be entered.") },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "To", hintText: "Separate multiple email addresses with ; or ,", value: properties["Octopus.Action.Email.To"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.To"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Email.To") }),
                React.createElement(TeamMultiSelect_1.default, { label: "To Teams", items: this.state.teams, value: ParseHelper_1.default.parseCSV(properties["Octopus.Action.Email.ToTeamIds"]), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.ToTeamIds"] = ParseHelper_1.default.encodeCSV(val), _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Email.CC", title: "CC", summary: this.ccSummary() },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "CC", hintText: "Separate multiple email addresses with ; or ,", value: properties["Octopus.Action.Email.CC"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.CC"] = val, _a));
                        var _a;
                    } }),
                React.createElement(TeamMultiSelect_1.default, { label: "CC Teams", items: this.state.teams, value: ParseHelper_1.default.parseCSV(properties["Octopus.Action.Email.CCTeamIds"]), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.CCTeamIds"] = ParseHelper_1.default.encodeCSV(val), _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Email.Bcc", title: "BCC", summary: this.bccSummary() },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "BCC", hintText: "Separate multiple email addresses with ; or ,", value: properties["Octopus.Action.Email.Bcc"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.Bcc"] = val, _a));
                        var _a;
                    } }),
                React.createElement(TeamMultiSelect_1.default, { label: "CC Teams", items: this.state.teams, value: ParseHelper_1.default.parseCSV(properties["Octopus.Action.Email.BccTeamIds"]), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.BccTeamIds"] = ParseHelper_1.default.encodeCSV(val), _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Email.Priority", title: "Priority", help: "Select the priority of the email.", summary: this.prioritySummary() },
                React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Octopus.Action.Email.Priority"] || emailPriority_1.EmailPriority.Normal, onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.Priority"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: emailPriority_1.EmailPriority.Low, label: "Low" }),
                    React.createElement(RadioButton_1.default, { value: emailPriority_1.EmailPriority.Normal, label: "Normal" }),
                    React.createElement(RadioButton_1.default, { value: emailPriority_1.EmailPriority.High, label: "High" }))),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Email.Subject", title: "Subject", help: "Provide the subject line of the email.", summary: this.subjectSummary() },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Subject", value: properties["Octopus.Action.Email.Subject"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.Subject"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Email.Subject") })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Email.Body", title: "Body", help: "Provide the email body as raw text or HTML.", summary: this.bodySummary() },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Body", multiLine: true, value: properties["Octopus.Action.Email.Body"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.Body"] = val, _a));
                        var _a;
                    } }),
                React.createElement(MoreInfo_1.default, { label: "This field supports extended template syntax.", content: React.createElement("div", null,
                        React.createElement("p", null,
                            React.createElement("b", null, "Extended template syntax")),
                        React.createElement("span", null,
                            "Conditional ",
                            React.createElement("code", null, "if"),
                            " and ",
                            React.createElement("code", null, "unless"),
                            ":",
                            React.createElement("pre", null, "#{if MyVar}...#{/if}")),
                        React.createElement("br", null),
                        React.createElement("span", null,
                            "Iteration over variable sets or comma-separated values with ",
                            React.createElement("code", null, "each"),
                            ":",
                            React.createElement("pre", null, "#{each mv in MyVar}...#{mv}...#{/each}"))) }),
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { label: "Email body format", value: properties["Octopus.Action.Email.IsHtml"] || "False", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.IsHtml"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "False", label: "Body is plain text", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "True", label: "Body is HTML" }))));
    };
    EmailActionEdit.prototype.toSummary = function () {
        return this.emailSummary("No recipient addresses set", "Octopus.Action.Email.To", "Octopus.Action.Email.ToTeamIds");
    };
    EmailActionEdit.prototype.ccSummary = function () {
        return this.emailSummary("No CC addresses set", "Octopus.Action.Email.CC", "Octopus.Action.Email.CCTeamIds");
    };
    EmailActionEdit.prototype.bccSummary = function () {
        return this.emailSummary("No BCC addresses set", "Octopus.Action.Email.Bcc", "Octopus.Action.Email.BccTeamIds");
    };
    EmailActionEdit.prototype.emailSummary = function (nothing, text, teamIds) {
        var _this = this;
        var bcc = this.props.properties[text];
        var teams = ParseHelper_1.default.parseCSV(this.props.properties[teamIds]);
        if (!bcc && teams.length === 0) {
            return form_1.Summary.placeholder(nothing);
        }
        var chips = teams.map(function (t) {
            return React.createElement(LookupTeamChip, { lookupCollection: _this.state.teams, key: t, lookupId: t, type: Chips_1.ChipIcon.Environment, chipRender: function (team) { return React.createElement(Chips_1.TeamChip, { team: team }); } });
        });
        return form_1.Summary.summary(React.createElement("div", null,
            bcc,
            " ",
            chips));
    };
    EmailActionEdit.prototype.subjectSummary = function () {
        var val = this.props.properties["Octopus.Action.Email.Subject"];
        return val
            ? form_1.Summary.summary(val)
            : form_1.Summary.placeholder("The email subject has not been provided");
    };
    EmailActionEdit.prototype.prioritySummary = function () {
        var val = this.props.properties["Octopus.Action.Email.Priority"] || emailPriority_1.EmailPriority.Normal;
        return val === emailPriority_1.EmailPriority.Normal ? form_1.Summary.default("Normal") : form_1.Summary.summary(val);
    };
    EmailActionEdit.prototype.bodySummary = function () {
        var val = this.props.properties["Octopus.Action.Email.Body"];
        return val
            ? form_1.Summary.summary("The email body has been provided")
            : form_1.Summary.placeholder("An email body has not been provided");
    };
    return EmailActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.Email",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(EmailActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return false; },
    canBeChild: true,
    edit: EmailActionEdit,
    targetRoleOption: ActionDetails_1.TargetRoles.None
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\email\\emailAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\email\\emailAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EmailLink_1 = __webpack_require__(809);
exports.default = EmailLink_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EmailLink\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EmailLink\\index.tsx"); } } })();

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var clientInstance_1 = __webpack_require__(10);
var FormSectionHeading_1 = __webpack_require__(46);
var form_1 = __webpack_require__(15);
var actionExecutionLocation_1 = __webpack_require__(37);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var ActionDetails_1 = __webpack_require__(27);
var EditList_1 = __webpack_require__(1938);
var ExpandableFormSection_1 = __webpack_require__(44);
var Select_1 = __webpack_require__(41);
var Note_1 = __webpack_require__(22);
var ExternalLink_1 = __webpack_require__(29);
var InternalLink_1 = __webpack_require__(42);
var routeLinks_1 = __webpack_require__(20);
var DeployReleaseSummary = (function (_super) {
    __extends(DeployReleaseSummary, _super);
    function DeployReleaseSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null
        };
        return _this;
    }
    DeployReleaseSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id, project, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = this.props.properties["Octopus.Action.DeployRelease.ProjectId"];
                        if (!id.includes("#{")) return [3 /*break*/, 1];
                        _a = null;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, clientInstance_1.repository.Projects.get(id)];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        project = _a;
                        this.setState({ project: project });
                        return [2 /*return*/];
                }
            });
        });
    };
    DeployReleaseSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy a release from project ",
            React.createElement("b", null, this.state.project ? this.state.project.Name : this.props.properties["Octopus.Action.DeployRelease.ProjectId"]),
            ".");
    };
    return DeployReleaseSummary;
}(BaseComponent_1.BaseComponent));
var DeploymentCondition;
(function (DeploymentCondition) {
    DeploymentCondition["Always"] = "Always";
    DeploymentCondition["IfNotCurrentVersion"] = "IfNotCurrentVersion";
    DeploymentCondition["IfNewer"] = "IfNewer";
})(DeploymentCondition || (DeploymentCondition = {}));
var DeployReleaseEdit = (function (_super) {
    __extends(DeployReleaseEdit, _super);
    function DeployReleaseEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            projects: []
        };
        return _this;
    }
    DeployReleaseEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var projects, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.properties["Octopus.Action.DeployRelease.DeploymentCondition"]) {
                            this.props.setProperties((_a = {}, _a["Octopus.Action.DeployRelease.DeploymentCondition"] = DeploymentCondition.Always, _a));
                        }
                        return [4 /*yield*/, clientInstance_1.repository.Projects.all()];
                    case 1:
                        projects = _b.sent();
                        this.setState({ projects: projects.filter(function (p) { return p.Id !== _this.props.projectId; }).map(function (p) { return ({ value: p.Id, text: p.Name }); }) });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DeployReleaseEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Deploy a release" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.DeployRelease.ProjectId", title: "Project", summary: this.summary(), help: React.createElement("div", null, "Select a project that will be deployed.") },
                React.createElement(Select_1.BoundSelect, { label: "Select a Project", variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", items: this.state.projects, onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.DeployRelease.ProjectId"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.DeployRelease.ProjectId"), allowFilter: true, autoFocus: true, value: this.props.properties["Octopus.Action.DeployRelease.ProjectId"] }),
                React.createElement(Note_1.default, null,
                    "See our ",
                    React.createElement(ExternalLink_1.default, { href: "DeployReleaseStep" }, "documentation"),
                    " for more information on deploying projects with the Deploy Release step.")),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.DeployRelease.DeploymentCondition", title: "Deployment condition", summary: this.summaryDeployment(), help: React.createElement("span", null, "Control when this deployment should run.") },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: DeploymentCondition.Always, value: this.props.properties["Octopus.Action.DeployRelease.DeploymentCondition"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.DeployRelease.DeploymentCondition"] = x, _a));
                        var _a;
                    }, label: "Deployment condition" },
                    React.createElement(RadioButton_1.default, { value: DeploymentCondition.Always, label: "Always", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: DeploymentCondition.IfNotCurrentVersion, label: "If the selected release is not the current release in the environment" }),
                    React.createElement(RadioButton_1.default, { value: DeploymentCondition.IfNewer, label: "If the selected release has a higher version than the current release in the environment" }))),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.DeployRelease.Variables", title: "Variables", summary: this.summaryVariables(), fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, help: React.createElement("span", null, "Pass variables through to the child deployment.") },
                React.createElement(EditList_1.KeyValueEditList, { items: this.props.properties["Octopus.Action.DeployRelease.Variables"], name: "Variable", separator: "=", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.DeployRelease.Variables"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Variable name", hideBindOnKey: true, localNames: this.props.localNames, projectId: this.props.projectId }),
                React.createElement(Note_1.default, null,
                    "See our ",
                    React.createElement(ExternalLink_1.default, { href: "DeployReleaseStepVariables" }, "documentation"),
                    " for more information on passing variables to deployments triggered by the Create Release step.")));
    };
    DeployReleaseEdit.prototype.summary = function () {
        var type = this.props.properties["Octopus.Action.DeployRelease.ProjectId"];
        if (!type) {
            return form_1.Summary.placeholder("Select a project that will be deployed");
        }
        var projectId = this.props.properties["Octopus.Action.DeployRelease.ProjectId"];
        var projectName = this.getProjectName(projectId);
        // Don't link to bound fields
        var link = projectId.includes("#{") ?
            React.createElement("b", null, projectName) :
            React.createElement(InternalLink_1.default, { to: routeLinks_1.default.project(encodeURIComponent(projectId)).root }, projectName);
        return form_1.Summary.summary(React.createElement("span", null,
            "Deploy a release from project ",
            link));
    };
    DeployReleaseEdit.prototype.summaryDeployment = function () {
        var condition = this.props.properties["Octopus.Action.DeployRelease.DeploymentCondition"];
        if (condition === DeploymentCondition.IfNotCurrentVersion) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Deploy the release if it is ",
                React.createElement("b", null, "not the current release"),
                " in the environment"));
        }
        if (condition === DeploymentCondition.IfNewer) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Deploy the release if it has a ",
                React.createElement("b", null, "higher version"),
                " than the current release in the environment"));
        }
        return form_1.Summary.default(React.createElement("span", null, "Deploy every time"));
    };
    DeployReleaseEdit.prototype.summaryVariables = function () {
        var variables = JSON.parse(this.props.properties["Octopus.Action.DeployRelease.Variables"] || "{}");
        if (Object.keys(variables).length === 0) {
            return form_1.Summary.placeholder("No variables specified");
        }
        else {
            var text = Object.keys(variables).map(function (m) { return m + " = " + variables[m]; }).join(", ");
            return form_1.Summary.summary(text);
        }
    };
    DeployReleaseEdit.prototype.getProjectName = function (projectId) {
        var project = this.state.projects.find(function (p) { return p.value === projectId; });
        return project ? project.text : projectId;
    };
    return DeployReleaseEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.DeployRelease",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DeployReleaseSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return false; },
    canBeChild: false,
    edit: DeployReleaseEdit,
    targetRoleOption: ActionDetails_1.TargetRoles.None
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\deployRelease\\deployReleaseAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\deployRelease\\deployReleaseAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var KeyValueEditList_1 = __webpack_require__(222);
exports.KeyValueEditList = KeyValueEditList_1.default;
var StringEditList_1 = __webpack_require__(298);
exports.StringEditList = StringEditList_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EditList\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\EditList\\index.ts"); } } })();

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var isBound_1 = __webpack_require__(84);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var form_1 = __webpack_require__(15);
var resources_1 = __webpack_require__(26);
var feedResource_1 = __webpack_require__(54);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(58);
var ExternalLink_1 = __webpack_require__(29);
var AccountSelect_1 = __webpack_require__(177);
var RadioButton_1 = __webpack_require__(36);
var RadioButtonGroup_1 = __webpack_require__(33);
var AzureServerTargetRolesInfo_1 = __webpack_require__(274);
var AzurePowerShellScriptInfo_1 = __webpack_require__(166);
var AzureCloudServiceSelector_1 = __webpack_require__(1940);
var WarningFormSection_1 = __webpack_require__(122);
var getFeedName_1 = __webpack_require__(66);
var ActionDetails_1 = __webpack_require__(27);
var Select_1 = __webpack_require__(41);
var AzureCloudServiceActionSummary = (function (_super) {
    __extends(AzureCloudServiceActionSummary, _super);
    function AzureCloudServiceActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    AzureCloudServiceActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureCloudServiceActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy Azure Cloud Service",
            React.createElement("strong", null,
                " ",
                this.props.properties[specialVariables_1.default.Action.Package.PackageId],
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, this.getFeedId()),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    AzureCloudServiceActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return AzureCloudServiceActionSummary;
}(BaseComponent_1.BaseComponent));
var AzureCloudServiceActionEdit = (function (_super) {
    __extends(AzureCloudServiceActionEdit, _super);
    function AzureCloudServiceActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.getAccountId = function () {
            return isBound_1.default(_this.props.properties["Octopus.Action.Azure.AccountId"]) ? undefined : _this.props.properties["Octopus.Action.Azure.AccountId"];
        };
        _this.refreshAccounts = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                        case 1:
                            _a.apply(this, [(_b.accounts = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            accounts: [],
            account: null,
            accountIsBound: isBound_1.default(props.properties["Octopus.Action.Azure.AccountId"], false),
        };
        return _this;
    }
    AzureCloudServiceActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _b.feeds = _d.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 2:
                        _a.apply(this, [(_b.accounts = _d.sent(),
                                _b)]);
                        if (!this.props.properties["Octopus.Action.Package.FeedId"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.Package.FeedId"] = feedResource_1.BuiltInFeedId, _c), true);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AzureCloudServiceActionEdit.prototype.accountSummary = function () {
        var summary = [];
        var accountId = this.props.properties["Octopus.Action.Azure.AccountId"];
        if (accountId) {
            var account = this.state.accounts.find(function (x) { return x.Id === accountId; });
            if (account) {
                summary.push(React.createElement("span", null,
                    "Using the ",
                    React.createElement("strong", null, account.Name),
                    " account"));
                (this.props.properties["Octopus.Action.Azure.CloudServiceName"])
                    ? summary.push(React.createElement("span", null,
                        ", with the ",
                        React.createElement("strong", null, this.props.properties["Octopus.Action.Azure.CloudServiceName"]),
                        " cloud service"))
                    : summary.push(React.createElement("span", null,
                        ", with ",
                        React.createElement("em", null, "(no cloud service selected)")));
                (this.props.properties["Octopus.Action.Azure.StorageAccountName"])
                    ? summary.push(React.createElement("span", null,
                        ", and the ",
                        React.createElement("strong", null, this.props.properties["Octopus.Action.Azure.StorageAccountName"]),
                        " storage account"))
                    : summary.push(React.createElement("span", null,
                        ", and ",
                        React.createElement("em", null, "(no storage account selected)")));
                return form_1.Summary.summary(React.Children.toArray(summary));
            }
            if (isBound_1.default(accountId, false)) {
                return form_1.Summary.summary(React.createElement("span", null,
                    "Account is bound to ",
                    React.createElement("strong", null, accountId)));
            }
        }
        return form_1.Summary.placeholder("No account has been selected");
    };
    AzureCloudServiceActionEdit.prototype.slotSummary = function () {
        var slot = this.props.properties["Octopus.Action.Azure.Slot"];
        if (slot) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Using the ",
                slot,
                " deployment slot"));
        }
        return form_1.Summary.placeholder("Deployment slot not specified");
    };
    AzureCloudServiceActionEdit.prototype.swapSummary = function () {
        var swap = this.props.properties["Octopus.Action.Azure.SwapIfPossible"];
        if (swap === "False") {
            return form_1.Summary.summary("When deploying to production always perform a new deployment");
        }
        if (swap === "True") {
            return form_1.Summary.summary("When deploying to production swap staging to production, if possible");
        }
        return form_1.Summary.placeholder("Swap setting not specified");
    };
    AzureCloudServiceActionEdit.prototype.instanceCountSummary = function () {
        var instanceCount = this.props.properties["Octopus.Action.Azure.UseCurrentInstanceCount"];
        if (instanceCount === "True") {
            return form_1.Summary.summary("Using the instance count from the current Azure deployment");
        }
        if (instanceCount === "False") {
            return form_1.Summary.summary("Using the instance count defined in the service configuration XML file");
        }
        return form_1.Summary.placeholder("Instance count not specified");
    };
    AzureCloudServiceActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var account = this.state.accounts.find(function (a) { return a.Id === properties["Octopus.Action.Azure.AccountId"]; });
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to deploy the contents of a package. The package that you wish to deploy should contain all the files needed to run your application. Learn more about ",
                React.createElement(ExternalLink_1.default, { href: "DocumentationPackaging" }, "what your packages should contain, and how to create them"),
                ".")
            : React.createElement("span", null, "Choose the package you which to deploy");
        return React.createElement("div", null,
            React.createElement(WarningFormSection_1.default, null,
                this.props.additionalActions && React.createElement(AzureServerTargetRolesInfo_1.default, { stepTargetRoles: this.props.additionalActions.stepTargetRoles }),
                React.createElement(AzurePowerShellScriptInfo_1.default, { actionType: this.props.plugin.actionType })),
            React.createElement(form_1.FormSectionHeading, { title: "Package" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(this.props.properties, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors })),
            React.createElement(form_1.FormSectionHeading, { title: "Azure" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.AccountId", title: "Account", summary: this.accountSummary(), help: "Select the account to use for the connection. Only Azure management-certificate accounts may be selected." },
                (this.props.properties["Octopus.Action.Azure.SubscriptionId"] && !this.props.properties["Octopus.Action.Azure.AccountId"]) &&
                    React.createElement(form_1.UnstructuredFormSection, null,
                        React.createElement(form_1.Note, null, "This step is using a subscription ID value imported from Octopus Deploy 2. This value, along with the default Azure certificate, will be used until an Account is selected below. From then on the subscription details from the selected Account will be used."),
                        React.createElement(form_1.Text, { value: this.props.properties["Octopus.Action.Azure.SubscriptionId"], label: "Subscription", disabled: true, onChange: null })),
                React.createElement(AccountSelect_1.BoundAccountSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: properties["Octopus.Action.Azure.AccountId"], label: "Account", value: properties["Octopus.Action.Azure.AccountId"], isBound: this.state.accountIsBound, onIsBoundChanged: function (value) { return _this.setState({ accountIsBound: value }); }, type: [resources_1.AccountType.AzureSubscription], allowClear: true, onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.AccountId"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Azure.AccountId"), items: this.state.accounts, onRequestRefresh: this.refreshAccounts }),
                React.createElement(AzureCloudServiceSelector_1.default, { doBusyTask: this.props.doBusyTask, properties: this.props.properties, setProperties: this.props.setProperties, getFieldError: this.props.getFieldError, projectId: this.props.projectId, accountId: this.getAccountId(), isAccountBound: this.state.accountIsBound, localNames: this.props.localNames })),
            React.createElement(form_1.FormSectionHeading, { title: "Deployment" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.Slot", title: "Slot", summary: this.slotSummary(), help: React.createElement("span", null,
                    "Select the deployment slot, usually ",
                    React.createElement("em", null, "Production"),
                    " or ",
                    React.createElement("em", null, "Staging"),
                    ".") },
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", label: "Slot", value: this.props.properties["Octopus.Action.Azure.Slot"], items: ["Staging", "Production"].map(function (item) { return ({ value: item, text: item }); }), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.Slot"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Azure.Slot") })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.SwapIfPossible", title: "Swap", summary: this.swapSummary(), help: React.createElement("span", null, "Azure allows staging and production deployments to be swapped, by switching virtual IP addresses. When deploying to production, Octopus can detect whether the current staging deployment can be swapped, and if so, it can do a swap rather than a new deployment.") },
                React.createElement(RadioButtonGroup_1.default, { value: this.props.properties["Octopus.Action.Azure.SwapIfPossible"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.SwapIfPossible"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Azure.SwapIfPossible") },
                    React.createElement(RadioButton_1.default, { value: "False", label: "Always deploy" }),
                    React.createElement(RadioButton_1.default, { value: "True", label: "Swap staging to production if possible" }))),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.UseCurrentInstanceCount", title: "Instance Count", summary: this.instanceCountSummary(), help: React.createElement("span", null, "If you have previously scaled your service by changing the number of instances using the Azure management portal, Octopus can retrieve these values and use them in the deployment, so that the instance count remains unchanged.") },
                React.createElement(RadioButtonGroup_1.default, { value: this.props.properties["Octopus.Action.Azure.UseCurrentInstanceCount"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.UseCurrentInstanceCount"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Azure.UseCurrentInstanceCount") },
                    React.createElement(RadioButton_1.default, { value: "True", label: "Use the instance count from the current Azure deployment" }),
                    React.createElement(RadioButton_1.default, { value: "False", label: "Use the instance count defined in the service configuration XML file" }))));
    };
    return AzureCloudServiceActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzureCloudService",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AzureCloudServiceActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return false; },
    canBeChild: false,
    edit: AzureCloudServiceActionEdit,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureCloudService\\azureCloudServiceAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureCloudService\\azureCloudServiceAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var Select_1 = __webpack_require__(41);
var isBound_1 = __webpack_require__(84);
var Note_1 = __webpack_require__(22);
var AzureCloudServiceSelector = (function (_super) {
    __extends(AzureCloudServiceSelector, _super);
    function AzureCloudServiceSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            account: null,
            cloudServices: [],
            storageAccounts: [],
            serviceIsBound: isBound_1.default(_this.props.properties["Octopus.Action.Azure.CloudServiceName"], false),
            storageIsBound: isBound_1.default(_this.props.properties["Octopus.Action.Azure.StorageAccountName"], false),
        };
        return _this;
    }
    AzureCloudServiceSelector.prototype.componentDidMount = function () {
        if (!this.props.isAccountBound) {
            this.loadData();
        }
    };
    AzureCloudServiceSelector.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.accountId !== this.props.accountId) {
            this.loadData();
        }
    };
    AzureCloudServiceSelector.prototype.componentWillReceiveProps = function (newprops) {
        if (newprops.isAccountBound && !this.state.serviceIsBound) {
            this.setState({ serviceIsBound: true });
        }
        if (newprops.isAccountBound && !this.state.storageIsBound) {
            this.setState({ storageIsBound: true });
        }
        if (!newprops.isAccountBound && newprops.accountId !== this.props.accountId) {
            this.loadData();
        }
    };
    AzureCloudServiceSelector.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var account, _a, cloudServices_1, storageAccounts_1;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!(!this.props.isAccountBound && this.props.accountId)) return [3 /*break*/, 3];
                                return [4 /*yield*/, clientInstance_1.repository.Accounts.get(this.props.accountId)];
                            case 1:
                                account = _b.sent();
                                return [4 /*yield*/, Promise.all([
                                        clientInstance_1.repository.Accounts.getCloudServices(account),
                                        clientInstance_1.repository.Accounts.getStorageAccounts(account)
                                    ])];
                            case 2:
                                _a = _b.sent(), cloudServices_1 = _a[0], storageAccounts_1 = _a[1];
                                this.setState({
                                    account: account,
                                    cloudServices: Object.keys(cloudServices_1).map(function (item) { return cloudServices_1[item]; }),
                                    storageAccounts: Object.keys(storageAccounts_1).map(function (item) { return storageAccounts_1[item]; })
                                });
                                return [3 /*break*/, 4];
                            case 3:
                                this.setState({
                                    account: null,
                                    cloudServices: [],
                                    storageAccounts: []
                                });
                                _b.label = 4;
                            case 4: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    AzureCloudServiceSelector.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(Select_1.BoundSelect, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: this.props.properties["Octopus.Action.Azure.CloudServiceName"], isBound: this.state.serviceIsBound, onIsBoundChanged: function (value) { return _this.setState({ serviceIsBound: _this.props.isAccountBound || value }); }, hideBindButton: this.props.isAccountBound, value: this.props.properties["Octopus.Action.Azure.CloudServiceName"], onChange: function (val) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.CloudServiceName"] = val, _a));
                    var _a;
                }, items: this.state.cloudServices.map(function (item) { return ({ value: item.Name, text: item.Name + " - " + item.Location }); }), label: "Cloud service", allowClear: true, allowFilter: true, error: this.props.getFieldError("Octopus.Action.Azure.CloudServiceName") }),
            React.createElement(Note_1.default, null, "The name of the cloud service to which files will be deployed."),
            React.createElement(Select_1.BoundSelect, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: this.props.properties["Octopus.Action.Azure.StorageAccountName"], isBound: this.state.storageIsBound, onIsBoundChanged: function (value) { return _this.setState({ storageIsBound: _this.props.isAccountBound || value }); }, hideBindButton: this.props.isAccountBound, value: this.props.properties["Octopus.Action.Azure.StorageAccountName"], onChange: function (val) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.StorageAccountName"] = val, _a));
                    var _a;
                }, items: this.state.storageAccounts.map(function (item) { return ({ value: item.Name, text: item.Name + " - " + item.Location }); }), label: "Storage account", allowClear: true, allowFilter: true, error: this.props.getFieldError("Octopus.Action.Azure.StorageAccountName") }),
            React.createElement(Note_1.default, null, "The name of a storage account that CSPKG files will be uploaded to before deployment."));
    };
    return AzureCloudServiceSelector;
}(React.Component));
exports.default = AzureCloudServiceSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureCloudService\\AzureCloudServiceSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureCloudService\\AzureCloudServiceSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var isBound_1 = __webpack_require__(84);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var clientInstance_1 = __webpack_require__(10);
var Summary_1 = __webpack_require__(70);
var FormSectionHeading_1 = __webpack_require__(46);
var ExpandableFormSection_1 = __webpack_require__(44);
var BoundField_1 = __webpack_require__(95);
var AzureServerTargetRolesInfo_1 = __webpack_require__(274);
var AzurePowerShellScriptInfo_1 = __webpack_require__(166);
var resources_1 = __webpack_require__(26);
var AzurePowerShellAccountInfo_1 = __webpack_require__(1942);
var WarningFormSection_1 = __webpack_require__(122);
var AccountSelect_1 = __webpack_require__(177);
var scriptAction_1 = __webpack_require__(273);
var ActionDetails_1 = __webpack_require__(27);
var AzurePowerShellActionSummary = (function (_super) {
    __extends(AzurePowerShellActionSummary, _super);
    function AzurePowerShellActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AzurePowerShellActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Run a PowerShell script using an Azure subscription with Azure modules loaded",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return AzurePowerShellActionSummary;
}(BaseComponent_1.BaseComponent));
var BoundAccountSelect = BoundField_1.withBoundField(AccountSelect_1.default);
var AzurePowerShellActionEdit = (function (_super) {
    __extends(AzurePowerShellActionEdit, _super);
    function AzurePowerShellActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.refreshAccounts = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                        case 1:
                            _a.apply(this, [(_b.accounts = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            accounts: [],
            account: null
        };
        return _this;
    }
    AzurePowerShellActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 1:
                        _a.apply(this, [(_b.accounts = _c.sent(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AzurePowerShellActionEdit.prototype.accountSummary = function () {
        var accountId = this.props.properties["Octopus.Action.Azure.AccountId"];
        if (!accountId) {
            return Summary_1.default.placeholder("No account has been selected");
        }
        var account = this.state.accounts.find(function (a) { return a.Id === accountId; });
        if (account) {
            return Summary_1.default.summary(account.Name);
        }
        if (isBound_1.default(accountId, false)) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Account is bound to ",
                React.createElement("strong", null, accountId)));
        }
        return Summary_1.default.placeholder("No account has been selected");
    };
    AzurePowerShellActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var account = this.state.accounts.find(function (a) { return a.Id === properties["Octopus.Action.Azure.AccountId"]; });
        return React.createElement("div", null,
            React.createElement(WarningFormSection_1.default, null,
                this.props.additionalActions && React.createElement(AzureServerTargetRolesInfo_1.default, { stepTargetRoles: this.props.additionalActions.stepTargetRoles }),
                React.createElement(AzurePowerShellScriptInfo_1.default, { actionType: this.props.plugin.actionType }),
                React.createElement(AzurePowerShellAccountInfo_1.default, { accountType: account && account.AccountType })),
            React.createElement(FormSectionHeading_1.default, { title: "Azure" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.AccountId", title: "Account", summary: this.accountSummary(), help: "Select the Azure account to use to run the script" },
                React.createElement(BoundAccountSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: this.props.properties["Octopus.Action.Azure.AccountId"], type: [resources_1.AccountType.AzureSubscription, resources_1.AccountType.AzureServicePrincipal], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.AccountId"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Azure.AccountId"), items: this.state.accounts, onRequestRefresh: this.refreshAccounts })),
            React.createElement(scriptAction_1.ScriptActionEdit, { plugin: this.props.plugin, projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, powerShellOnly: true, errors: this.props.errors }));
    };
    return AzurePowerShellActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzurePowerShell",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AzurePowerShellActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: AzurePowerShellActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return false; },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azurePowerShell\\azurePowerShellAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azurePowerShell\\azurePowerShellAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Callout_1 = __webpack_require__(81);
var ExternalLink_1 = __webpack_require__(29);
var resources_1 = __webpack_require__(26);
var AzurePowerShellAccountInfo = function (props) {
    if (props.accountType === resources_1.AccountType.AzureSubscription) {
        return React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
            "When using an Azure Management Certificate account, ",
            React.createElement(ExternalLink_1.default, { href: "AzureResourceManagerCmdlets" }, "Resource Manager"),
            " cmdlets can not be used. To use Resource Manager cmdlets, select an ",
            React.createElement(ExternalLink_1.default, { href: "DocumentationCreatingAzureAccount" }, "Azure Service Principal account"),
            ".");
    }
    if (props.accountType === resources_1.AccountType.AzureServicePrincipal) {
        return React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
            "When using an Azure Service Principal account, ",
            React.createElement(ExternalLink_1.default, { href: "AzureServiceManagementCmdlets" }, "Service Management"),
            " cmdlets can not be used. To use Service Management cmdlets, select an ",
            React.createElement(ExternalLink_1.default, { href: "DocumentationCreatingAzureAccount" }, "Azure Management Certificate account"),
            ".");
    }
    return null;
};
exports.default = AzurePowerShellAccountInfo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azurePowerShell\\AzurePowerShellAccountInfo.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azurePowerShell\\AzurePowerShellAccountInfo.tsx"); } } })();

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var isBound_1 = __webpack_require__(84);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var resources_1 = __webpack_require__(26);
var clientInstance_1 = __webpack_require__(10);
var form_1 = __webpack_require__(15);
var AccountSelect_1 = __webpack_require__(177);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(58);
var feedResource_1 = __webpack_require__(54);
var RadioButton_1 = __webpack_require__(36);
var RadioButtonGroup_1 = __webpack_require__(33);
var AzureServerTargetRolesInfo_1 = __webpack_require__(274);
var AzurePowerShellScriptInfo_1 = __webpack_require__(166);
var WarningFormSection_1 = __webpack_require__(122);
var CodeEditor_1 = __webpack_require__(119);
var OpenDialogButton_1 = __webpack_require__(74);
var AzureResourceGroupSelector_1 = __webpack_require__(1944);
var AzureResourceGroupParameters_1 = __webpack_require__(1945);
var AzureResourceGroupSourceCodeDialog_1 = __webpack_require__(1946);
var ExpandableFormSection_1 = __webpack_require__(44);
var ActionDetails_1 = __webpack_require__(27);
var Select_1 = __webpack_require__(41);
var Text_1 = __webpack_require__(17);
var AzureResourceGroupActionSummary = (function (_super) {
    __extends(AzureResourceGroupActionSummary, _super);
    function AzureResourceGroupActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AzureResourceGroupActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy an Azure Resource Manager Template",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return AzureResourceGroupActionSummary;
}(BaseComponent_1.BaseComponent));
var AzureResourceGroupActionEdit = (function (_super) {
    __extends(AzureResourceGroupActionEdit, _super);
    function AzureResourceGroupActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.armJsonParamTypeArray = "array";
        _this.armJsonParamTypes = [_this.armJsonParamTypeArray, "object", "secureObject"];
        _this.getAccountId = function () {
            return isBound_1.default(_this.props.properties["Octopus.Action.Azure.AccountId"]) ? undefined : _this.props.properties["Octopus.Action.Azure.AccountId"];
        };
        _this.refreshAccounts = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                        case 1:
                            _a.apply(this, [(_b.accounts = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            accounts: [],
            account: null,
            accountIsBound: isBound_1.default(props.properties["Octopus.Action.Azure.AccountId"], false),
        };
        _this.parameterValues = {};
        _this.parameters = {};
        _this.source = { octopus: "octopus", azureKeyVault: "azureKeyVault" };
        return _this;
    }
    AzureResourceGroupActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _b.feeds = _e.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 2:
                        _a.apply(this, [(_b.accounts = _e.sent(),
                                _b)]);
                        if (!this.props.properties["Octopus.Action.Package.FeedId"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.Package.FeedId"] = feedResource_1.BuiltInFeedId, _c), true);
                        }
                        if (!this.props.properties["Octopus.Action.Azure.ResourceGroupDeploymentMode"]) {
                            this.props.setProperties((_d = {}, _d["Octopus.Action.Azure.ResourceGroupDeploymentMode"] = "Incremental", _d), true);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AzureResourceGroupActionEdit.prototype.accountSummary = function () {
        var summary = [];
        var accountId = this.props.properties["Octopus.Action.Azure.AccountId"];
        if (accountId) {
            var account = this.state.accounts.find(function (x) { return x.Id === accountId; });
            if (account) {
                summary.push(React.createElement("span", null,
                    "Using the ",
                    React.createElement("strong", null, account.Name),
                    " account"));
                (this.props.properties["Octopus.Action.Azure.ResourceGroupName"])
                    ? summary.push(React.createElement("span", null,
                        " and the ",
                        React.createElement("strong", null, this.props.properties["Octopus.Action.Azure.ResourceGroupName"]),
                        " resource group"))
                    : summary.push(React.createElement("span", null,
                        " and ",
                        React.createElement("em", null, "(no resource group selected)")));
                (this.props.properties["Octopus.Action.Azure.ResourceGroupDeploymentMode"])
                    ? summary.push(React.createElement("span", null,
                        " with the ",
                        React.createElement("strong", null, this.props.properties["Octopus.Action.Azure.ResourceGroupDeploymentMode"]),
                        " deployment mode"))
                    : summary.push(React.createElement("span", null,
                        " with ",
                        React.createElement("em", null, "no deployment mode selected")));
                return form_1.Summary.summary(React.Children.toArray(summary));
            }
            if (isBound_1.default(accountId, false)) {
                return form_1.Summary.summary(React.createElement("span", null,
                    "Account is bound to ",
                    React.createElement("strong", null, accountId)));
            }
        }
        return form_1.Summary.placeholder("No account has been selected");
    };
    AzureResourceGroupActionEdit.prototype.templateSourceSummary = function () {
        var source = this.props.properties["Octopus.Action.Azure.TemplateSource"];
        if (source === "Inline") {
            return form_1.Summary.summary("Source code");
        }
        if (source === "Package") {
            return form_1.Summary.summary("File inside a package");
        }
        return form_1.Summary.placeholder("Template source not specified");
    };
    AzureResourceGroupActionEdit.prototype.pathsSummary = function () {
        var summary = [];
        (this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"])
            ? summary.push(React.createElement("span", null,
                "Using the template in ",
                React.createElement("strong", null, this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"])))
            : summary.push(React.createElement("span", null,
                " ",
                React.createElement("em", null, "no template path specified")));
        (this.props.properties["Octopus.Action.Azure.ResourceGroupTemplateParameters"])
            ? summary.push(React.createElement("span", null,
                " with the parameters in ",
                React.createElement("strong", null, this.props.properties["Octopus.Action.Azure.ResourceGroupTemplateParameters"])))
            : summary.push(React.createElement("span", null,
                " ",
                React.createElement("em", null, "no parameters path specified")));
        return form_1.Summary.summary(React.Children.toArray(summary));
    };
    AzureResourceGroupActionEdit.prototype.onChangeTemplateSource = function (value) {
        this.props.setProperties((_a = {},
            _a["Octopus.Action.Azure.TemplateSource"] = value,
            _a["Octopus.Action.Azure.ResourceGroupTemplate"] = "",
            _a["Octopus.Action.Azure.ResourceGroupTemplateParameters"] = "",
            _a));
        var _a;
    };
    AzureResourceGroupActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var account = this.state.accounts.find(function (a) { return a.Id === properties["Octopus.Action.Azure.AccountId"]; });
        return React.createElement("div", null,
            React.createElement(WarningFormSection_1.default, null,
                this.props.additionalActions && React.createElement(AzureServerTargetRolesInfo_1.default, { stepTargetRoles: this.props.additionalActions.stepTargetRoles }),
                React.createElement(AzurePowerShellScriptInfo_1.default, { actionType: this.props.plugin.actionType })),
            React.createElement(form_1.FormSectionHeading, { title: "Azure" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.AccountId", title: "Account", summary: this.accountSummary(), help: "Select the account to use for the connection. Only Azure service principal accounts may be selected." },
                React.createElement(AccountSelect_1.BoundAccountSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: properties["Octopus.Action.Azure.AccountId"], label: "Account", value: properties["Octopus.Action.Azure.AccountId"], isBound: this.state.accountIsBound, onIsBoundChanged: function (value) { return _this.setState({ accountIsBound: value }); }, type: [resources_1.AccountType.AzureServicePrincipal], allowClear: true, onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.AccountId"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Azure.AccountId"), items: this.state.accounts, onRequestRefresh: this.refreshAccounts }),
                React.createElement(AzureResourceGroupSelector_1.default, { doBusyTask: this.props.doBusyTask, properties: this.props.properties, setProperties: this.props.setProperties, getFieldError: this.props.getFieldError, projectId: this.props.projectId, accountId: this.getAccountId(), isAccountBound: this.state.accountIsBound, localNames: this.props.localNames }),
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", label: "Deployment mode", value: this.props.properties["Octopus.Action.Azure.ResourceGroupDeploymentMode"], items: ["Incremental", "Complete"].map(function (item) { return ({ value: item, text: item }); }), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupDeploymentMode"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Azure.ResourceGroupDeploymentMode") })),
            React.createElement(form_1.FormSectionHeading, { title: "Template" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.TemplateSource", title: "Template Source", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, summary: this.templateSourceSummary(), help: "Select the source of the template." },
                React.createElement(form_1.Note, null, "Templates can be entered as source-code, or contained in a package."),
                React.createElement(RadioButtonGroup_1.default, { value: this.props.properties["Octopus.Action.Azure.TemplateSource"], onChange: function (val) { return _this.onChangeTemplateSource(val); }, error: this.props.getFieldError("Octopus.Action.Azure.TemplateSource") },
                    React.createElement(RadioButton_1.default, { value: "Inline", label: "Source code" }),
                    React.createElement(RadioButton_1.default, { value: "Package", label: "File inside a package" })),
                this.props.properties["Octopus.Action.Azure.TemplateSource"] === "Inline" && React.createElement("div", null,
                    React.createElement("br", null),
                    this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"] &&
                        React.createElement(CodeEditor_1.default, { value: this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"], language: CodeEditor_1.TextFormat.JSON, allowFullScreen: false, readOnly: true, onChange: null }),
                    React.createElement("div", null,
                        React.createElement(OpenDialogButton_1.default, { label: this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"] ? "Edit Source Code" : "Add Source Code", wideDialog: true },
                            React.createElement(AzureResourceGroupSourceCodeDialog_1.default, { template: this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"], saveDone: function (val) {
                                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupTemplate"] = val, _a));
                                    var _a;
                                } }))))),
            this.props.properties["Octopus.Action.Azure.TemplateSource"] === "Package" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(this.props.properties, this.state.feeds), help: "Choose the package that contains the template source." },
                    React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors })),
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.ResourceGroupTemplate|Octopus.Action.Azure.ResourceGroupTemplateParameters", title: "Paths", summary: this.pathsSummary(), help: "Enter relative the paths for the template and parameter files in the package." },
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Template path", value: this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupTemplate"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Azure.ResourceGroupTemplate") }),
                    React.createElement(form_1.Note, null, "Relative path to the JSON template file contained in the package"),
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Template parameters path", value: this.props.properties["Octopus.Action.Azure.ResourceGroupTemplateParameters"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupTemplateParameters"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Azure.ResourceGroupTemplateParameters") }),
                    React.createElement(form_1.Note, null, "Relative path to the JSON parameters file contained in the package"))),
            this.props.properties["Octopus.Action.Azure.TemplateSource"] === "Inline" && React.createElement("div", null,
                React.createElement(form_1.FormSectionHeading, { title: "Parameters" }),
                React.createElement(AzureResourceGroupParameters_1.default, { projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask })));
    };
    return AzureResourceGroupActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzureResourceGroup",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AzureResourceGroupActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: AzureResourceGroupActionEdit,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureResourceGroup\\azureResourceGroupAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureResourceGroup\\azureResourceGroupAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var Select_1 = __webpack_require__(41);
var Note_1 = __webpack_require__(22);
var AzureResourceGroupSelector = (function (_super) {
    __extends(AzureResourceGroupSelector, _super);
    function AzureResourceGroupSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            account: null,
            resourceGroups: []
        };
        return _this;
    }
    AzureResourceGroupSelector.prototype.componentDidMount = function () {
        this.loadData();
    };
    AzureResourceGroupSelector.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.accountId !== this.props.accountId) {
            this.loadData();
        }
    };
    AzureResourceGroupSelector.prototype.componentWillReceiveProps = function (newprops) {
        if (!newprops.isAccountBound && newprops.accountId !== this.props.accountId) {
            this.loadData();
        }
    };
    AzureResourceGroupSelector.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var account, resourceGroups_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(!this.props.isAccountBound && this.props.accountId)) return [3 /*break*/, 3];
                                return [4 /*yield*/, clientInstance_1.repository.Accounts.get(this.props.accountId)];
                            case 1:
                                account = _a.sent();
                                return [4 /*yield*/, clientInstance_1.repository.Accounts.getResourceGroups(account)];
                            case 2:
                                resourceGroups_1 = _a.sent();
                                this.setState({
                                    account: account,
                                    resourceGroups: Object.keys(resourceGroups_1).map(function (item) { return resourceGroups_1[item]; })
                                });
                                return [3 /*break*/, 4];
                            case 3:
                                this.setState({
                                    account: null,
                                    resourceGroups: []
                                });
                                _a.label = 4;
                            case 4: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    AzureResourceGroupSelector.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(Select_1.BoundSelect, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: this.props.properties["Octopus.Action.Azure.ResourceGroupName"], isBound: this.props.isAccountBound, hideBindButton: this.props.isAccountBound, value: this.props.properties["Octopus.Action.Azure.ResourceGroupName"], onChange: function (val) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupName"] = val, _a));
                    var _a;
                }, items: this.state.resourceGroups.map(function (item) { return ({ value: item.Name, text: item.Name }); }), label: "Resource Group", allowClear: true, allowFilter: true, error: this.props.getFieldError("Octopus.Action.Azure.ResourceGroupName") }),
            React.createElement(Note_1.default, null, "The name of the Azure Resource Group. The Resource Group must exist."),
            React.createElement(Note_1.default, null, "A Resource Group can be created through the Azure Portal, or by using the New-AzureRMResourceGroup PowerShell cmdlet."));
    };
    return AzureResourceGroupSelector;
}(React.Component));
exports.default = AzureResourceGroupSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureResourceGroupSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureResourceGroupSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var form_1 = __webpack_require__(15);
var RadioButton_1 = __webpack_require__(36);
var RadioButtonGroup_1 = __webpack_require__(33);
var ExternalLink_1 = __webpack_require__(29);
var AzureTemplateHelper_1 = __webpack_require__(705);
var Select_1 = __webpack_require__(41);
var StringCheckbox_1 = __webpack_require__(38);
var Text_1 = __webpack_require__(17);
var AzureResourceGroupParameters = (function (_super) {
    __extends(AzureResourceGroupParameters, _super);
    function AzureResourceGroupParameters(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            paramValues: {},
            paramErrors: []
        };
        return _this;
    }
    AzureResourceGroupParameters.prototype.componentDidMount = function () {
        this.loadParameterValues();
    };
    AzureResourceGroupParameters.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.properties["Octopus.Action.Azure.ResourceGroupTemplate"] !== this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"]) {
            this.loadParameterValues();
        }
    };
    AzureResourceGroupParameters.prototype.loadParameterValues = function () {
        var _this = this;
        var paramValues = {};
        var result = AzureTemplateHelper_1.AzureTemplateHelper.extractParameters(this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"], this.props.properties["Octopus.Action.Azure.ResourceGroupTemplateParameters"]);
        paramValues = result.value;
        this.setState(({ paramValues: paramValues }), function () { return _this.updateParameterValues(); });
    };
    AzureResourceGroupParameters.prototype.updateParameterValues = function () {
        var result = AzureTemplateHelper_1.AzureTemplateHelper.exportParameters(this.state.paramValues);
        this.setState({ paramErrors: result.errors });
        this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupTemplateParameters"] = result.value, _a));
        var _a;
    };
    AzureResourceGroupParameters.prototype.onParameterValueChange = function (paramName, newValue, key) {
        var _this = this;
        if (key === void 0) { key = "value"; }
        this.setState(function (prevState) {
            return ({
                paramValues: __assign({}, prevState.paramValues, (_a = {}, _a[paramName] = __assign({}, prevState.paramValues[paramName], (_b = {}, _b[key] = newValue, _b)), _a))
            });
            var _a, _b;
        }, function () { return _this.updateParameterValues(); });
    };
    AzureResourceGroupParameters.prototype.parameterValueSummary = function (parameter) {
        if (parameter.type === AzureTemplateHelper_1.ParameterDataType.secureString && parameter.source === AzureTemplateHelper_1.Source.azureKeyVault) {
            return form_1.Summary.summary("Using Azure Key Vault");
        }
        if (parameter.type === AzureTemplateHelper_1.ParameterDataType.bool) {
            return form_1.Summary.summary((parameter.value && parameter.value !== "False") ? "True" : "False");
        }
        if (parameter.value) {
            return form_1.Summary.summary(parameter.value);
        }
        return form_1.Summary.placeholder("Value not provided");
    };
    AzureResourceGroupParameters.prototype.parameterValueHelp = function (paramName, parameter) {
        if (parameter.description) {
            return parameter.description;
        }
        if (parameter.type === AzureTemplateHelper_1.ParameterDataType.bool) {
            return "Select value for " + paramName;
        }
        return "Enter a value for " + paramName;
    };
    AzureResourceGroupParameters.prototype.getParamError = function (paramName) {
        var parameter = this.state.paramErrors.find(function (x) { return x === paramName; });
        if (parameter) {
            return parameter + " is not valid";
        }
        return null;
    };
    AzureResourceGroupParameters.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null, this.state.paramValues && Object.keys(this.state.paramValues).map(function (paramName) {
            return React.createElement("div", { key: paramName }, (function () {
                var paramValue = _this.state.paramValues[paramName];
                if (paramValue.allowedValues) {
                    return React.createElement(form_1.ExpandableFormSection, { errorKey: paramName, title: paramName, summary: _this.parameterValueSummary(paramValue), help: _this.parameterValueHelp(paramName, paramValue) },
                        React.createElement(Select_1.BoundSelect, { variableLookup: {
                                localNames: _this.props.localNames,
                                projectId: _this.props.projectId
                            }, resetValue: "", label: paramName, value: paramValue.value, items: paramValue.allowedValues.map(function (item) { return ({ value: item, text: item }); }), onChange: function (val) { return _this.onParameterValueChange(paramName, val); } }));
                }
                else {
                    switch (paramValue.type) {
                        case AzureTemplateHelper_1.ParameterDataType.bool:
                            return React.createElement(form_1.ExpandableFormSection, { errorKey: paramName, title: paramName, summary: _this.parameterValueSummary(paramValue), help: _this.parameterValueHelp(paramName, paramValue) },
                                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                                        localNames: _this.props.localNames,
                                        projectId: _this.props.projectId
                                    }, resetValue: "", key: paramName, label: paramName, value: paramValue.value, onChange: function (val) { return _this.onParameterValueChange(paramName, val); } }));
                        case AzureTemplateHelper_1.ParameterDataType.int:
                            return React.createElement(form_1.ExpandableFormSection, { errorKey: paramName, title: paramName, summary: _this.parameterValueSummary(paramValue), help: _this.parameterValueHelp(paramName, paramValue) },
                                React.createElement(Text_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, key: paramName, label: paramName, type: "number", value: paramValue.value, onChange: function (val) { return _this.onParameterValueChange(paramName, val && parseInt(val, 10)); } }));
                        case AzureTemplateHelper_1.ParameterDataType.string:
                            return React.createElement(form_1.ExpandableFormSection, { errorKey: paramName, title: paramName, summary: _this.parameterValueSummary(paramValue), help: _this.parameterValueHelp(paramName, paramValue) },
                                React.createElement(Text_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, key: paramName, label: paramName, value: paramValue.value, onChange: function (val) { return _this.onParameterValueChange(paramName, val); } }));
                        case AzureTemplateHelper_1.ParameterDataType.secureString:
                            return React.createElement(form_1.ExpandableFormSection, { errorKey: paramName, title: paramName, summary: _this.parameterValueSummary(paramValue), help: _this.parameterValueHelp(paramName, paramValue) },
                                React.createElement(RadioButtonGroup_1.default, { value: paramValue.source, onChange: function (val) { return _this.onParameterValueChange(paramName, val, "source"); } },
                                    React.createElement(RadioButton_1.default, { value: AzureTemplateHelper_1.Source.octopus, label: "From Octopus" }),
                                    React.createElement(RadioButton_1.default, { value: AzureTemplateHelper_1.Source.azureKeyVault, label: "From Azure Key Vault" }),
                                    React.createElement(form_1.Note, null,
                                        React.createElement(ExternalLink_1.default, { href: "https://azure.microsoft.com/en-us/documentation/articles/key-vault-get-started" }, "Azure Key Vault"),
                                        " allows sensitive data to be stored outside of Octopus and then used in ",
                                        React.createElement(ExternalLink_1.default, { href: "https://azure.microsoft.com/en-us/documentation/articles/resource-manager-keyvault-parameter/" }, "Resource Manager templates."))),
                                paramValue.source === AzureTemplateHelper_1.Source.azureKeyVault
                                    ? React.createElement("div", null,
                                        React.createElement(Text_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, label: "Resource Id", value: paramValue.keyVaultId, onChange: function (val) { return _this.onParameterValueChange(paramName, val, "keyVaultId"); } }),
                                        React.createElement(form_1.Note, null,
                                            React.createElement(ExternalLink_1.default, { href: "https://docs.microsoft.com/en-us/powershell/module/azurerm.keyvault/get-azurermkeyvault" }, "Get-AzureRMKeyVault"),
                                            " PowerShell cmdlet can be used to retrieve this value."),
                                        React.createElement(Text_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, label: "Secret Name", value: paramValue.keyVaultSecretName, onChange: function (val) { return _this.onParameterValueChange(paramName, val, "keyVaultSecretName"); } }))
                                    : React.createElement("div", null,
                                        React.createElement(Text_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, label: paramName, value: paramValue.value, onChange: function (val) { return _this.onParameterValueChange(paramName, val); } }),
                                        React.createElement(form_1.Note, null,
                                            "This parameter's type is 'secureString'. To avoid it being stored in plain text, please do not enter values directly. Instead use either a ",
                                            React.createElement(ExternalLink_1.default, { href: "SensitiveVariables" }, "Sensitive Variable"),
                                            React.createElement("span", null, " or "),
                                            React.createElement(ExternalLink_1.default, { href: "https://azure.microsoft.com/en-us/documentation/articles/key-vault-get-started" }, "Azure Key Vault"))));
                        case AzureTemplateHelper_1.ParameterDataType.array:
                        default:
                            return React.createElement(form_1.ExpandableFormSection, { errorKey: paramName, title: paramName, summary: _this.parameterValueSummary(paramValue), help: _this.parameterValueHelp(paramName, paramValue) },
                                React.createElement(Text_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, key: paramName, label: paramName, multiLine: true, rows: 5, value: paramValue.value, error: _this.getParamError(paramName), onChange: function (val) { return _this.onParameterValueChange(paramName, val); } }),
                                paramValue.type === AzureTemplateHelper_1.ParameterDataType.array &&
                                    React.createElement(form_1.Note, null,
                                        "This parameter's type is 'array'. Data should be entered in array format. Examples: ",
                                        React.createElement("code", null, "[10, 100, 1000]"),
                                        ", ",
                                        React.createElement("code", null, "[\"Rick\", \"Morty\"]")));
                    }
                }
            })());
        })));
    };
    return AzureResourceGroupParameters;
}(React.Component));
exports.default = AzureResourceGroupParameters;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureResourceGroupParameters.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureResourceGroupParameters.tsx"); } } })();

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var SaveDialogLayout_1 = __webpack_require__(105);
var CodeEditor_1 = __webpack_require__(119);
var AzureTemplateHelper_1 = __webpack_require__(705);
var AzureResourceGroupSourceCodeDialog = (function (_super) {
    __extends(AzureResourceGroupSourceCodeDialog, _super);
    function AzureResourceGroupSourceCodeDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: null,
            template: _this.props.template
        };
        return _this;
    }
    AzureResourceGroupSourceCodeDialog.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = AzureTemplateHelper_1.AzureTemplateHelper.extractParameters(this.state.template);
                        if (!(result.errors.length > 0)) return [3 /*break*/, 1];
                        this.setState({
                            errors: {
                                message: "The source code contains errors",
                                details: result.errors.slice(),
                                fieldErrors: {}
                            }
                        });
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.props.saveDone(this.state.template)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AzureResourceGroupSourceCodeDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(SaveDialogLayout_1.default, { title: "Template source code", busy: null, errors: this.state.errors, onSaveClick: function () { return _this.save(); }, saveButtonLabel: "OK" },
            React.createElement(CodeEditor_1.default, { value: this.state.template, language: CodeEditor_1.TextFormat.JSON, allowFullScreen: false, onChange: function (template) { return _this.setState({ template: template }); } }));
    };
    return AzureResourceGroupSourceCodeDialog;
}(BaseComponent_1.default));
exports.default = AzureResourceGroupSourceCodeDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureResourceGroupSourceCodeDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureResourceGroupSourceCodeDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var feedResource_1 = __webpack_require__(54);
var PackageSelector_1 = __webpack_require__(58);
var ExternalLink_1 = __webpack_require__(29);
var CommonSummaryHelper_1 = __webpack_require__(62);
var ExpandableFormSection_1 = __webpack_require__(44);
var FormSectionHeading_1 = __webpack_require__(46);
var AzurePowerShellScriptInfo_1 = __webpack_require__(166);
var WarningFormSection_1 = __webpack_require__(122);
var AzureServiceFabricSdkRequiredInfo_1 = __webpack_require__(706);
var Text_1 = __webpack_require__(17);
var AzureServiceFabricAccountSelector_1 = __webpack_require__(707);
var Note_1 = __webpack_require__(22);
var Summary_1 = __webpack_require__(70);
var StringCheckbox_1 = __webpack_require__(38);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var getFeedName_1 = __webpack_require__(66);
var ActionDetails_1 = __webpack_require__(27);
var AzureServiceFabricAppActionSummary = (function (_super) {
    __extends(AzureServiceFabricAppActionSummary, _super);
    function AzureServiceFabricAppActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    AzureServiceFabricAppActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureServiceFabricAppActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy Azure Service Fabric Application",
            React.createElement("strong", null,
                " ",
                this.props.properties[specialVariables_1.default.Action.Package.PackageId],
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, this.getFeedId()),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    AzureServiceFabricAppActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return AzureServiceFabricAppActionSummary;
}(BaseComponent_1.BaseComponent));
var UpgradeBehavior;
(function (UpgradeBehavior) {
    UpgradeBehavior["None"] = "None";
    UpgradeBehavior["ForceUpgrade"] = "ForceUpgrade";
    UpgradeBehavior["VetoUpgrade"] = "VetoUpgrade";
})(UpgradeBehavior || (UpgradeBehavior = {}));
var OverwriteBehavior;
(function (OverwriteBehavior) {
    OverwriteBehavior["Never"] = "Never";
    OverwriteBehavior["Always"] = "Always";
    OverwriteBehavior["SameAppTypeAndVersion"] = "SameAppTypeAndVersion";
})(OverwriteBehavior || (OverwriteBehavior = {}));
var AzureServiceFabricAppActionEdit = (function (_super) {
    __extends(AzureServiceFabricAppActionEdit, _super);
    function AzureServiceFabricAppActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feeds: [],
            resetValues: {
                ClientCertVariable: props.properties["Octopus.Action.ServiceFabric.ClientCertVariable"]
            }
        };
        return _this;
    }
    AzureServiceFabricAppActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, properties;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _a.apply(this, [(_b.feeds = _c.sent(),
                                _b)]);
                        properties = {};
                        if (!this.props.properties["Octopus.Action.ServiceFabric.OverrideUpgradeBehavior"]) {
                            properties["Octopus.Action.ServiceFabric.OverrideUpgradeBehavior"] = UpgradeBehavior.None;
                        }
                        if (!this.props.properties["Octopus.Action.ServiceFabric.OverwriteBehavior"]) {
                            properties["Octopus.Action.ServiceFabric.OverwriteBehavior"] = OverwriteBehavior.SameAppTypeAndVersion;
                        }
                        if (!this.props.properties["Octopus.Action.ServiceFabric.SecurityMode"]) {
                            properties["Octopus.Action.ServiceFabric.SecurityMode"] = AzureServiceFabricAccountSelector_1.SecurityMode.Unsecure;
                        }
                        if (!this.props.properties["Octopus.Action.ServiceFabric.AadCredentialType"]) {
                            properties["Octopus.Action.ServiceFabric.AadCredentialType"] = AzureServiceFabricAccountSelector_1.AADCredentialType.UserCredential;
                        }
                        if (!this.props.properties["Octopus.Action.Package.FeedId"]) {
                            properties["Octopus.Action.Package.FeedId"] = feedResource_1.BuiltInFeedId;
                        }
                        this.props.setProperties(properties, true);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AzureServiceFabricAppActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(WarningFormSection_1.default, null,
                React.createElement(AzureServiceFabricSdkRequiredInfo_1.default, null),
                React.createElement(AzurePowerShellScriptInfo_1.default, { actionType: this.props.plugin.actionType })),
            React.createElement(FormSectionHeading_1.default, { title: "Package" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(properties, this.state.feeds), help: React.createElement("span", null,
                    "This step is used to deploy the contents of a Service Fabric package. The package that you wish to deploy should contain your ",
                    React.createElement("em", null, "ApplicationParameters"),
                    " and ",
                    React.createElement("em", null, "PublishProfiles"),
                    " folders, as well as your application package folder(s). Please see the ",
                    React.createElement(ExternalLink_1.default, { href: "ServiceFabricPackaging" }, "Service Fabric Packaging guide"),
                    " to learn about what your package should contain, and how to create them.") },
                React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors })),
            React.createElement(FormSectionHeading_1.default, { title: "Service Fabric Cluster" }),
            React.createElement(AzureServiceFabricAccountSelector_1.default, { projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, clientCertVariableResetValue: this.state.resetValues.ClientCertVariable, setProperties: this.props.setProperties, getFieldError: this.props.getFieldError, doBusyTask: this.props.doBusyTask }),
            React.createElement(FormSectionHeading_1.default, { title: "Deployment" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.PublishProfileFile", title: "Publish Profile File", summary: properties["Octopus.Action.ServiceFabric.PublishProfileFile"]
                    ? Summary_1.default.summary(properties["Octopus.Action.ServiceFabric.PublishProfileFile"])
                    : Summary_1.default.placeholder("Publish profile file not provided"), help: "Select the path to your publish profile file." },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.PublishProfileFile"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.PublishProfileFile"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.PublishProfileFile"), hintText: "eg. PublishProfiles\\Cloud.xml", label: "Publish profile file" }),
                React.createElement(Note_1.default, null,
                    "Octopus will use the ApplicationParameters file referenced in this publish profile. This value is typically ",
                    React.createElement("code", null, "PublishProfiles\\Cloud.xml"))),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.DeployOnly", title: "Deploy Only", summary: properties["Octopus.Action.ServiceFabric.DeployOnly"] && properties["Octopus.Action.ServiceFabric.DeployOnly"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "The application will ",
                        React.createElement("strong", null, "not"),
                        " but created or updated"))
                    : Summary_1.default.default("The application will be created or updated"), help: "If selected, the Service Fabric application will not be created or upgraded after registering the application type." },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: properties["Octopus.Action.ServiceFabric.DeployOnly"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.DeployOnly"] = x, _a));
                        var _a;
                    }, label: "Deploy only" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.UnregisterUnusedApplicationVersionsAfterUpgrade", title: "Unregister Unused Versions", summary: properties["Octopus.Action.ServiceFabric.UnregisterUnusedApplicationVersionsAfterUpgrade"]
                    && properties["Octopus.Action.ServiceFabric.UnregisterUnusedApplicationVersionsAfterUpgrade"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "Unused versions ",
                        React.createElement("strong", null, "will"),
                        " be unregistered"))
                    : Summary_1.default.default("Unused versions will not be unregistered"), help: "Select to unregister any unused application versions that exist after an upgrade is finished." },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: properties["Octopus.Action.ServiceFabric.UnregisterUnusedApplicationVersionsAfterUpgrade"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.UnregisterUnusedApplicationVersionsAfterUpgrade"] = x, _a));
                        var _a;
                    }, label: "Unregister" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.OverrideUpgradeBehavior", title: "Override Upgrade Behavior", summary: this.upgradeBehaviorSummary(), help: "Indicates the behavior used to override the upgrade settings specified by the publish profile." },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: UpgradeBehavior.None, value: properties["Octopus.Action.ServiceFabric.OverrideUpgradeBehavior"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.OverrideUpgradeBehavior"] = x, _a));
                        var _a;
                    }, label: "Upgrade behavior" },
                    React.createElement(RadioButton_1.default, { value: UpgradeBehavior.None, label: "None", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: UpgradeBehavior.ForceUpgrade, label: "Force upgrade" }),
                    React.createElement(RadioButton_1.default, { value: UpgradeBehavior.VetoUpgrade, label: "Veto upgrade" }))),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.OverwriteBehavior", title: "Overwrite Behavior", summary: this.overwriteBehaviorSummary(), help: "Overwrite behavior if an application exists in the cluster with the same name. This setting is not applicable when upgrading an application." },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: OverwriteBehavior.SameAppTypeAndVersion, value: properties["Octopus.Action.ServiceFabric.OverwriteBehavior"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.OverwriteBehavior"] = x, _a));
                        var _a;
                    }, label: "Overwrite behavior" },
                    React.createElement(RadioButton_1.default, { value: OverwriteBehavior.Never, label: "Never" }),
                    React.createElement(RadioButton_1.default, { value: OverwriteBehavior.Always, label: "Always" }),
                    React.createElement(RadioButton_1.default, { value: OverwriteBehavior.SameAppTypeAndVersion, label: "Same app type and version", isDefault: true }))),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.SkipPackageValidation", title: "Skip Package Validation", summary: properties["Octopus.Action.ServiceFabric.SkipPackageValidation"]
                    && properties["Octopus.Action.ServiceFabric.SkipPackageValidation"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "Tell Service Fabric ",
                        React.createElement("strong", null, "not"),
                        " to perform package validation"))
                    : Summary_1.default.default("Service Fabric will perform package validation"), help: "Select to tell Service Fabric not to validate the package before deployment." },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: properties["Octopus.Action.ServiceFabric.SkipPackageValidation"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.SkipPackageValidation"] = x, _a));
                        var _a;
                    }, label: "Skip validation" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.CopyPackageTimeoutSec", title: "Copy Package Timeout", summary: properties["Octopus.Action.ServiceFabric.CopyPackageTimeoutSec"]
                    ? Summary_1.default.summary(React.createElement("span", null,
                        properties["Octopus.Action.ServiceFabric.CopyPackageTimeoutSec"],
                        " seconds"))
                    : Summary_1.default.default("Unchanged"), help: "Enter a value in seconds to override the timeout for copying an application package to the image store." },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.CopyPackageTimeoutSec"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.CopyPackageTimeoutSec"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.CopyPackageTimeoutSec"), label: "Copy package timeout (seconds)" })));
    };
    AzureServiceFabricAppActionEdit.prototype.upgradeBehaviorSummary = function () {
        var behavior = this.props.properties["Octopus.Action.ServiceFabric.OverrideUpgradeBehavior"];
        if (behavior === UpgradeBehavior.None) {
            return Summary_1.default.default("None");
        }
        if (behavior === UpgradeBehavior.ForceUpgrade) {
            return Summary_1.default.summary("Force upgrade");
        }
        if (behavior === UpgradeBehavior.VetoUpgrade) {
            return Summary_1.default.summary("Veto upgrade");
        }
        return Summary_1.default.summary("Bound to a project variable");
    };
    AzureServiceFabricAppActionEdit.prototype.overwriteBehaviorSummary = function () {
        var behavior = this.props.properties["Octopus.Action.ServiceFabric.OverwriteBehavior"];
        if (behavior === OverwriteBehavior.Never) {
            return Summary_1.default.summary("Never");
        }
        if (behavior === OverwriteBehavior.Always) {
            return Summary_1.default.summary("Always");
        }
        if (behavior === OverwriteBehavior.SameAppTypeAndVersion) {
            return Summary_1.default.default("Same app type and version");
        }
        return Summary_1.default.summary("Bound to a project variable");
    };
    return AzureServiceFabricAppActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzureServiceFabricApp",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AzureServiceFabricAppActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: AzureServiceFabricAppActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
    features: {
        optional: [
            "Octopus.Features.ConfigurationTransforms",
            "Octopus.Features.ConfigurationVariables",
            "Octopus.Features.CustomScripts",
            "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.SubstituteInFiles"
        ]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureServiceFabricApp\\azureServiceFabricAppAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureServiceFabricApp\\azureServiceFabricAppAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var FormSectionHeading_1 = __webpack_require__(46);
var AzurePowerShellScriptInfo_1 = __webpack_require__(166);
var WarningFormSection_1 = __webpack_require__(122);
var AzureServiceFabricSdkRequiredInfo_1 = __webpack_require__(706);
var AzureServiceFabricAccountSelector_1 = __webpack_require__(707);
var scriptAction_1 = __webpack_require__(273);
var ActionDetails_1 = __webpack_require__(27);
var AzureServiceFabricPowerShellSummary = (function (_super) {
    __extends(AzureServiceFabricPowerShellSummary, _super);
    function AzureServiceFabricPowerShellSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AzureServiceFabricPowerShellSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Run a PowerShell script using an Azure Service Fabric cluster context",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return AzureServiceFabricPowerShellSummary;
}(BaseComponent_1.BaseComponent));
var AzureServiceFabricPowerShellActionEdit = (function (_super) {
    __extends(AzureServiceFabricPowerShellActionEdit, _super);
    function AzureServiceFabricPowerShellActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            resetValues: {
                ClientCertVariable: props.properties["Octopus.Action.ServiceFabric.ClientCertVariable"]
            }
        };
        return _this;
    }
    AzureServiceFabricPowerShellActionEdit.prototype.componentDidMount = function () {
        var properties = {};
        if (!this.props.properties["Octopus.Action.ServiceFabric.SecurityMode"]) {
            properties["Octopus.Action.ServiceFabric.SecurityMode"] = "Unsecure";
        }
        if (!this.props.properties["Octopus.Action.ServiceFabric.AadCredentialType"]) {
            properties["Octopus.Action.ServiceFabric.AadCredentialType"] = "UserCredential";
        }
        this.props.setProperties(properties, true);
    };
    AzureServiceFabricPowerShellActionEdit.prototype.render = function () {
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(WarningFormSection_1.default, null,
                React.createElement(AzureServiceFabricSdkRequiredInfo_1.default, null),
                React.createElement(AzurePowerShellScriptInfo_1.default, { actionType: this.props.plugin.actionType })),
            React.createElement(FormSectionHeading_1.default, { title: "Service Fabric Cluster" }),
            React.createElement(AzureServiceFabricAccountSelector_1.default, { projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, clientCertVariableResetValue: this.state.resetValues.ClientCertVariable, setProperties: this.props.setProperties, getFieldError: this.props.getFieldError, doBusyTask: this.props.doBusyTask }),
            React.createElement(scriptAction_1.ScriptActionEdit, { plugin: this.props.plugin, projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, powerShellOnly: true, errors: this.props.errors }));
    };
    return AzureServiceFabricPowerShellActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzureServiceFabricPowerShell",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AzureServiceFabricPowerShellSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: AzureServiceFabricPowerShellActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    hasPackages: function (action) { return false; },
    targetRoleOption: ActionDetails_1.TargetRoles.Optional
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureServiceFabricPowerShell\\azureServiceFabricPowerShellAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureServiceFabricPowerShell\\azureServiceFabricPowerShellAction.tsx"); } } })();

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var Note_1 = __webpack_require__(22);
var Text_1 = __webpack_require__(17);
var ExpandableFormSection_1 = __webpack_require__(44);
var PackageSelector_1 = __webpack_require__(58);
var ExternalLink_1 = __webpack_require__(29);
var CommonSummaryHelper_1 = __webpack_require__(62);
var Summary_1 = __webpack_require__(70);
var AzurePowerShellScriptInfo_1 = __webpack_require__(166);
var resources_1 = __webpack_require__(26);
var feedResource_1 = __webpack_require__(54);
var AzureServerTargetRolesInfo_1 = __webpack_require__(274);
var isBound_1 = __webpack_require__(84);
var AzureWebSiteSelector_1 = __webpack_require__(1950);
var FormSectionHeading_1 = __webpack_require__(46);
var WarningFormSection_1 = __webpack_require__(122);
var StringCheckbox_1 = __webpack_require__(38);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var AccountSelect_1 = __webpack_require__(177);
var getFeedName_1 = __webpack_require__(66);
var ActionDetails_1 = __webpack_require__(27);
var AzureWebAppActionSummary = (function (_super) {
    __extends(AzureWebAppActionSummary, _super);
    function AzureWebAppActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    AzureWebAppActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureWebAppActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy an Azure Web App",
            React.createElement("strong", null,
                " ",
                this.props.properties[specialVariables_1.default.Action.Package.PackageId],
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, this.getFeedId()),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    AzureWebAppActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return AzureWebAppActionSummary;
}(BaseComponent_1.BaseComponent));
var AzureWebAppEdit = (function (_super) {
    __extends(AzureWebAppEdit, _super);
    function AzureWebAppEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.getAccountId = function () {
            return isBound_1.default(_this.props.properties["Octopus.Action.Azure.AccountId"]) ? undefined : _this.props.properties["Octopus.Action.Azure.AccountId"];
        };
        _this.refreshAccounts = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                        case 1:
                            _a.apply(this, [(_b.accounts = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            accounts: [],
            account: null,
            accountIsBound: isBound_1.default(props.properties["Octopus.Action.Azure.AccountId"], false)
        };
        return _this;
    }
    AzureWebAppEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, properties;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _b.feeds = _c.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 2:
                        _a.apply(this, [(_b.accounts = _c.sent(),
                                _b)]);
                        properties = {};
                        if (this.props.properties["Octopus.Action.Azure.UseChecksum"] === undefined) {
                            properties["Octopus.Action.Azure.UseChecksum"] = "False";
                        }
                        if (!this.props.properties["Octopus.Action.Package.FeedId"]) {
                            properties["Octopus.Action.Package.FeedId"] = feedResource_1.BuiltInFeedId;
                        }
                        this.props.setProperties(properties, true);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AzureWebAppEdit.prototype.accountSummary = function () {
        var accountId = this.props.properties["Octopus.Action.Azure.AccountId"];
        if (!accountId) {
            return Summary_1.default.placeholder("No account has been selected");
        }
        var account = this.state.accounts.find(function (a) { return a.Id === accountId; });
        if (!account) {
            if (isBound_1.default(accountId, false)) {
                return Summary_1.default.summary(React.createElement("span", null,
                    "Account is bound to ",
                    React.createElement("strong", null, accountId)));
            }
            return Summary_1.default.placeholder("No account has been selected");
        }
        var webAppName = this.props.properties["Octopus.Action.Azure.WebAppName"];
        var resourceGroup = this.props.properties["Octopus.Action.Azure.ResourceGroupName"];
        if (!webAppName) {
            return Summary_1.default.placeholder("No Web App has been selected");
        }
        var summary = [];
        summary.push(React.createElement("span", null,
            "Account ",
            React.createElement("strong", null, account.Name),
            " will be used to deploy web app ",
            React.createElement("strong", null, webAppName)));
        if (resourceGroup) {
            summary.push(React.createElement("span", null,
                " in resource group ",
                React.createElement("strong", null, resourceGroup)));
        }
        return Summary_1.default.summary(React.Children.toArray(summary));
    };
    AzureWebAppEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var account = this.state.accounts.find(function (a) { return a.Id === properties["Octopus.Action.Azure.AccountId"]; });
        return React.createElement("div", null,
            React.createElement(WarningFormSection_1.default, null,
                this.props.additionalActions && React.createElement(AzureServerTargetRolesInfo_1.default, { stepTargetRoles: this.props.additionalActions.stepTargetRoles }),
                React.createElement(AzurePowerShellScriptInfo_1.default, { actionType: this.props.plugin.actionType })),
            React.createElement(FormSectionHeading_1.default, { title: "Package" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "package", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(properties, this.state.feeds), help: React.createElement("span", null,
                    "This step is used to deploy an Azure Web App. The package that you select should contain your all the files needed to run your application. ",
                    React.createElement(ExternalLink_1.default, { href: "DocumentationPackaging" }, "Learn more about what your packages should contain, and how to create them"),
                    ".") },
                React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors })),
            React.createElement(FormSectionHeading_1.default, { title: "Azure" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.AccountId|Octopus.Action.Azure.WebAppName|Octopus.Action.Azure.ResourceGroupName", title: "Account and Web App", summary: this.accountSummary(), help: "Select the Azure account and Web App for the deployment." },
                React.createElement(AccountSelect_1.BoundAccountSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: properties["Octopus.Action.Azure.AccountId"], label: "Account", value: properties["Octopus.Action.Azure.AccountId"], isBound: this.state.accountIsBound, onIsBoundChanged: function (value) { return _this.setState({ accountIsBound: value }); }, type: [resources_1.AccountType.AzureSubscription, resources_1.AccountType.AzureServicePrincipal], allowClear: true, onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.AccountId"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Azure.AccountId"), items: this.state.accounts, onRequestRefresh: this.refreshAccounts }),
                React.createElement(AzureWebSiteSelector_1.default, { doBusyTask: this.props.doBusyTask, webAppName: properties["Octopus.Action.Azure.WebAppName"], webAppNameError: this.props.getFieldError("Octopus.Action.Azure.WebAppName"), resourceGroupName: properties["Octopus.Action.Azure.ResourceGroupName"], resourceGroupError: this.props.getFieldError("Octopus.Action.Azure.ResourceGroupName"), onWebAppNameChanged: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.WebAppName"] = x, _a));
                        var _a;
                    }, onResourceGroupChanged: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupName"] = x, _a));
                        var _a;
                    }, projectId: this.props.projectId, accountId: this.getAccountId(), isAccountBound: this.state.accountIsBound, localNames: this.props.localNames })),
            React.createElement(FormSectionHeading_1.default, { title: "Deployment" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.PhysicalPath", title: "Physical Path", summary: properties["Octopus.Action.Azure.PhysicalPath"]
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "The physical path is ",
                        React.createElement("strong", null, properties["Octopus.Action.Azure.PhysicalPath"])))
                    : Summary_1.default.placeholder("No physical path has been entered"), help: "Enter the physical path to the site root." },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Azure.PhysicalPath"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.PhysicalPath"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Azure.PhysicalPath"), label: "Physical path" }),
                React.createElement(Note_1.default, null,
                    "Physical path relative to site root. e.g. 'foo' will deploy to 'site\\wwwroot\\foo'.",
                    React.createElement("br", null),
                    "Leave blank to deploy to root.")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.RemoveAdditionalFiles", title: "Remove Additional Files", summary: properties["Octopus.Action.Azure.RemoveAdditionalFiles"] && properties["Octopus.Action.Azure.RemoveAdditionalFiles"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "Files in the destination that are not part of the deployment ",
                        React.createElement("strong", null, "will"),
                        " be removed"))
                    : Summary_1.default.default("Files in the destination that are not part of the deployment will not be removed"), help: "Select to remove additional files on the destination that are not part of the deployment." },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Octopus.Action.Azure.RemoveAdditionalFiles"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.RemoveAdditionalFiles"] = x, _a));
                        var _a;
                    }, label: "Remove additional files" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.PreserveAppData", title: "Preserve App_Data", summary: properties["Octopus.Action.Azure.PreserveAppData"] && properties["Octopus.Action.Azure.PreserveAppData"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "Files in the App_Data folder ",
                        React.createElement("strong", null, "will not"),
                        " be removed"))
                    : Summary_1.default.default("Files in the App_Data folder will be removed"), help: "Select to preserve files in the App_Data folder before deployment." },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Octopus.Action.Azure.PreserveAppData"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.PreserveAppData"] = x, _a));
                        var _a;
                    }, label: "Preserve App_Data" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.AppOffline", title: "Enable AppOffline", summary: properties["Octopus.Action.Azure.AppOffline"] && properties["Octopus.Action.Azure.AppOffline"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "The app domain ",
                        React.createElement("strong", null, "will"),
                        " be safely brought down using a blank app_offline.html"))
                    : Summary_1.default.default("The app domain will not be safely brought down using a blank app_offline.html"), help: "Select to safely bring down the app domain with app_offline.html in root" },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Octopus.Action.Azure.AppOffline"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.AppOffline"] = x, _a));
                        var _a;
                    }, label: "Enable AppOffline" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.UseChecksum", title: "File Comparison Method", summary: properties["Octopus.Action.Azure.UseChecksum"] && properties["Octopus.Action.Azure.UseChecksum"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "File ",
                        React.createElement("strong", null, "checksums"),
                        " will be used to compare files (may increase deployment time)"))
                    : Summary_1.default.default("File timestamps will be used to compare files"), help: "Select which method will be used to determine which files will be updated during deployment." },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Octopus.Action.Azure.UseChecksum"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.UseChecksum"] = x, _a));
                        var _a;
                    }, label: "File comparison method" },
                    React.createElement(RadioButton_1.default, { label: "Timestamp", value: "False", isDefault: true }),
                    React.createElement(Note_1.default, null, "Use file timestamps to compare files"),
                    React.createElement(RadioButton_1.default, { label: "Checksum", value: "True" }),
                    React.createElement(Note_1.default, null,
                        "Use file checksums to compare files",
                        React.createElement("br", null),
                        " ",
                        React.createElement("em", null, "Warning:"),
                        " the checksum method may cause deployment times to increase significantly"))));
    };
    return AzureWebAppEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzureWebApp",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AzureWebAppActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: AzureWebAppEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureWebApp\\azureWebAppAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureWebApp\\azureWebAppAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var clientInstance_1 = __webpack_require__(10);
var Note_1 = __webpack_require__(22);
var Text_1 = __webpack_require__(17);
var Select_1 = __webpack_require__(41);
var ParseHelper_1 = __webpack_require__(75);
var isBound_1 = __webpack_require__(84);
var AzureWebSiteSelector = (function (_super) {
    __extends(AzureWebSiteSelector, _super);
    function AzureWebSiteSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectedSiteChanged = function (value) {
            var index = ParseHelper_1.default.safeParseInt(value, null);
            var selectedSite = index !== null ? _this.state.sites[index] : null;
            _this.props.onResourceGroupChanged(selectedSite ? selectedSite.ResourceGroup : null);
            _this.props.onWebAppNameChanged(selectedSite ? selectedSite.Name : null);
            _this.setState({ selectedSiteIndex: index !== null ? index.toString() : null });
        };
        _this.state = {
            reset: {
                resourceGroupName: null,
                name: null
            },
            siteIsBound: isBound_1.default(props.webAppName, false),
            sites: [],
            siteItems: [],
            selectedSiteIndex: null
        };
        return _this;
    }
    AzureWebSiteSelector.prototype.componentDidMount = function () {
        if (!this.props.isAccountBound) {
            this.getWebSites(this.props.accountId);
        }
    };
    AzureWebSiteSelector.prototype.componentWillReceiveProps = function (newprops) {
        if (newprops.isAccountBound && !this.state.siteIsBound) {
            this.setState({ siteIsBound: true });
        }
        if (!newprops.isAccountBound && newprops.accountId !== this.props.accountId) {
            this.getWebSites(newprops.accountId);
        }
    };
    AzureWebSiteSelector.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            this.state.siteIsBound && React.createElement("div", null,
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.resourceGroupName, onChange: this.props.onResourceGroupChanged, error: this.props.resourceGroupError, label: "Resource Group" }),
                React.createElement(Note_1.default, null,
                    "The Resource Group of your Azure Web App.",
                    React.createElement("br", null),
                    "If not specified then all Resource Groups are searched.")),
            React.createElement(Select_1.BoundSelect, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: this.state.selectedSiteIndex, isBound: this.state.siteIsBound, onIsBoundChanged: function (value) { return _this.setState({ siteIsBound: _this.props.isAccountBound || value }); }, hideBindButton: this.props.isAccountBound, value: this.state.siteIsBound ? this.props.webAppName : this.state.selectedSiteIndex, onChange: this.state.siteIsBound ? this.props.onWebAppNameChanged : this.handleSelectedSiteChanged, items: this.state.siteItems, error: this.props.webAppNameError, label: "Web app" }),
            React.createElement(Note_1.default, null, "The name of your Azure Web App."));
    };
    AzureWebSiteSelector.prototype.resetWebSites = function () {
        this.setState({ sites: [] });
    };
    AzureWebSiteSelector.prototype.getWebSites = function (accountId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    var account, sites, selectedSiteIndex, resourceGroupName_1, selectedSite, index, siteItems;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!accountId) {
                                    this.setState({
                                        sites: [],
                                        siteItems: [],
                                        selectedSiteIndex: null
                                    });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, clientInstance_1.repository.Accounts.get(accountId)];
                            case 1:
                                account = _a.sent();
                                return [4 /*yield*/, clientInstance_1.repository.Accounts.getWebSites(account)];
                            case 2:
                                sites = _a.sent();
                                selectedSiteIndex = null;
                                if (this.props.webAppName) {
                                    resourceGroupName_1 = this.props.resourceGroupName === undefined ? null : this.props.resourceGroupName;
                                    selectedSite = sites.find(function (s) { return s.Name === _this.props.webAppName && s.ResourceGroup === resourceGroupName_1; });
                                    if (selectedSite) {
                                        index = sites.indexOf(selectedSite);
                                        selectedSiteIndex = index < 0 ? null : index.toString();
                                    }
                                }
                                siteItems = sites.map(function (site, index) {
                                    var details = site.ResourceGroup ? site.ResourceGroup + " " + site.Region : site.Region;
                                    return {
                                        value: index.toString(),
                                        text: site.Name + " " + details
                                    };
                                });
                                this.setState({
                                    sites: sites,
                                    siteItems: siteItems,
                                    selectedSiteIndex: selectedSiteIndex
                                });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    return AzureWebSiteSelector;
}(BaseComponent_1.BaseComponent));
exports.default = AzureWebSiteSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureWebApp\\AzureWebSiteSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\azureWebApp\\AzureWebSiteSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var _ = __webpack_require__(16);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var form_1 = __webpack_require__(15);
var CertificateVariableSelect_1 = __webpack_require__(165);
var Button_1 = __webpack_require__(51);
var OpenDialogButton_1 = __webpack_require__(74);
var SimpleDataTable_1 = __webpack_require__(284);
var clientInstance_1 = __webpack_require__(10);
var CertificateImportTypes_1 = __webpack_require__(708);
var PrivateKeyAccessRuleDialog_1 = __webpack_require__(1952);
var styles = __webpack_require__(1953);
var ActionDetails_1 = __webpack_require__(27);
var Text_1 = __webpack_require__(17);
var Select_1 = __webpack_require__(41);
var StringCheckbox_1 = __webpack_require__(38);
var CertificateImportActionSummary = (function (_super) {
    __extends(CertificateImportActionSummary, _super);
    function CertificateImportActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CertificateImportActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Import Certificate from variable ",
            React.createElement("strong", null, this.props.properties[specialVariables_1.default.Action.Certificate.Variable]),
            " into Windows Certificate Store ",
            React.createElement("strong", null, this.props.properties[specialVariables_1.default.Action.Certificate.StoreLocation]),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return CertificateImportActionSummary;
}(BaseComponent_1.BaseComponent));
var CertificateImportActionEdit = (function (_super) {
    __extends(CertificateImportActionEdit, _super);
    function CertificateImportActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null,
            storeLocation: null,
            storeName: null,
            customStoreName: null,
            accessRules: []
        };
        return _this;
    }
    CertificateImportActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.projectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        project = _a.sent();
                        this.setState({
                            project: project
                        });
                        _a.label = 2;
                    case 2:
                        this.initializeStoreLocation();
                        this.initializeStoreName();
                        this.initializePrivateKeyAccess();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    CertificateImportActionEdit.prototype.initializeStoreLocation = function () {
        var _this = this;
        var currentStoreLocation = this.props.properties["Octopus.Action.Certificate.StoreLocation"];
        var currentStoreUser = this.props.properties["Octopus.Action.Certificate.StoreUser"];
        var storeLocation = null;
        storeLocation = currentStoreLocation
            ? currentStoreLocation
            : currentStoreUser
                ? CertificateImportTypes_1.StoreLocations.CustomUser
                : CertificateImportTypes_1.StoreLocations.LocalMachine;
        this.setState({ storeLocation: storeLocation }, function () { return _this.updateStoreLocation(); });
    };
    CertificateImportActionEdit.prototype.initializeStoreName = function () {
        var _this = this;
        var currentStoreName = this.props.properties["Octopus.Action.Certificate.StoreName"];
        var storeName = null;
        var customStoreName = null;
        if (!currentStoreName) {
            // If this is the first time, default the store name to 'My'
            storeName = CertificateImportTypes_1.StoreNames.My;
        }
        else if (currentStoreName in CertificateImportTypes_1.StoreNames) {
            // If the store name has been previously set to one of the pre-defined values, then use it
            storeName = currentStoreName;
        }
        else {
            // Else, a custom value has been used
            storeName = CertificateImportTypes_1.StoreNames.Other;
            customStoreName = currentStoreName;
        }
        this.setState({ storeName: storeName, customStoreName: customStoreName }, function () { return _this.updateStoreName(); });
    };
    CertificateImportActionEdit.prototype.initializePrivateKeyAccess = function () {
        if (this.props.properties["Octopus.Action.Certificate.PrivateKeyExportable"] === undefined) {
            this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.PrivateKeyExportable"] = "False", _a), true);
        }
        if (!this.props.properties["Octopus.Action.Certificate.PrivateKeyAccessRules"]) {
            this.props.setProperties((_b = {}, _b["Octopus.Action.Certificate.PrivateKeyAccessRules"] = "[]", _b), true);
        }
        if (this.props.properties["Octopus.Action.Certificate.PrivateKeyAccessRules"]) {
            var privateKeyAccessRules = JSON.parse(this.props.properties["Octopus.Action.Certificate.PrivateKeyAccessRules"]);
            this.setState({ accessRules: privateKeyAccessRules });
        }
        var _a, _b;
    };
    CertificateImportActionEdit.prototype.updateStoreLocation = function () {
        if (this.state.storeLocation === CertificateImportTypes_1.StoreLocations.CustomUser) {
            if (this.props.properties["Octopus.Action.Certificate.StoreLocation"]) {
                this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.StoreLocation"] = null, _a));
            }
        }
        else {
            this.props.setProperties((_b = {}, _b["Octopus.Action.Certificate.StoreLocation"] = this.state.storeLocation, _b));
            if (this.props.properties["Octopus.Action.Certificate.StoreUser"]) {
                this.props.setProperties((_c = {}, _c["Octopus.Action.Certificate.StoreUser"] = null, _c));
            }
        }
        var _a, _b, _c;
    };
    CertificateImportActionEdit.prototype.updateStoreName = function () {
        if (this.state.storeName === CertificateImportTypes_1.StoreNames.Other) {
            this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.StoreName"] = this.state.customStoreName, _a));
        }
        else {
            this.props.setProperties((_b = {}, _b["Octopus.Action.Certificate.StoreName"] = this.state.storeName, _b));
        }
        var _a, _b;
    };
    CertificateImportActionEdit.prototype.updatePrivateKeyAccess = function () {
        this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.PrivateKeyAccessRules"] = JSON.stringify(this.state.accessRules), _a));
        var _a;
    };
    CertificateImportActionEdit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(form_1.FormSectionHeading, { title: "Certificate" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Certificate.Variable", title: "Certificate Variable", help: "The variable representing the certificate to be imported", summary: this.certificateSummary() }, this.props.projectId
                ? React.createElement(CertificateVariableSelect_1.BoundCertificateVariableSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, projectId: this.props.projectId, resetValue: "", doBusyTask: this.props.doBusyTask, value: this.props.properties["Octopus.Action.Certificate.Variable"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.Variable"] = val, _a));
                        var _a;
                    }, allowClear: true })
                : React.createElement(Text_1.VariableLookupText, { label: "Certificate variable", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Certificate.Variable"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.Variable"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.FormSectionHeading, { title: "Store" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Certificate.StoreLocation|Octopus.Action.Certificate.StoreUser", title: "Store Location", help: "Select the location of the certificate store.", summary: this.storeLocationSummary() },
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", label: "Store location", value: this.state.storeLocation, items: Object.values(CertificateImportTypes_1.StoreLocations).map(function (item) { return ({ value: item, text: item }); }), onChange: function (storeLocation) { return _this.setState({ storeLocation: storeLocation }, function () { return _this.updateStoreLocation(); }); }, error: this.props.getFieldError("Octopus.Action.Certificate.StoreLocation") }),
                this.state.storeLocation === CertificateImportTypes_1.StoreLocations.CustomUser && React.createElement("div", null,
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Custom user", hintText: "Enter a user name", value: this.props.properties["Octopus.Action.Certificate.StoreUser"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.StoreUser"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Certificate.StoreUser") }),
                    React.createElement(form_1.Note, null,
                        "A user to use as the certificate store location. Examples: ",
                        React.createElement("em", null, "MachineA\\UserA"),
                        ", ",
                        React.createElement("em", null, "DomainB\\UserB")))),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Certificate.StoreName", title: "Store Name", help: "Select the name of the Windows certificate store.", summary: this.storeNameSummary() },
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", label: "Store name", value: this.state.storeName, items: Object.values(CertificateImportTypes_1.StoreNames).map(function (item) { return ({ value: item, text: item }); }), onChange: function (storeName) { return _this.setState({ storeName: storeName }, function () { return _this.updateStoreName(); }); }, error: this.props.getFieldError("Octopus.Action.Certificate.StoreName") }),
                React.createElement(form_1.Note, null,
                    "The name of the Windows certificate store. Use one of the pre-defined stores, or choose ",
                    React.createElement("em", null, "Other"),
                    " to enter a custom store name."),
                this.state.storeName === CertificateImportTypes_1.StoreNames.Other &&
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Custom store name", hintText: "Enter a store name", value: this.state.customStoreName, onChange: function (customStoreName) { return _this.setState({ customStoreName: customStoreName }, function () { return _this.updateStoreName(); }); } })),
            React.createElement(form_1.FormSectionHeading, { title: "Private Key" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Certificate.PrivateKeyExportable", title: "Private Key Exportable", help: "Select whether the private-key is exportable.", summary: this.privateKeyExportableSummary() },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", label: "Private key exportable", value: this.props.properties["Octopus.Action.Certificate.PrivateKeyExportable"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.PrivateKeyExportable"] = val, _a));
                        var _a;
                    }, note: React.createElement("span", null, "If the certificate includes a private-key it will be marked as exportable.") })),
            this.state.storeLocation === CertificateImportTypes_1.StoreLocations.LocalMachine &&
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Certificate.PrivateKeyAccessRules", title: "Private Key Access", help: "Define who has access to the private-key on the target machine", summary: this.privateKeyAccessSummary() },
                    React.createElement(SimpleDataTable_1.default, { data: this.state.accessRules, headerColumns: ["Identity", "Access", "Actions"], headerColumnClassName: styles.headerColumn, rowColumnClassName: styles.rowColumn, onRow: function (rule) { return [
                            rule.Identity,
                            rule.Access,
                            React.createElement("span", null,
                                React.createElement(OpenDialogButton_1.default, { label: "Edit" },
                                    React.createElement(PrivateKeyAccessRuleDialog_1.default, { rule: _.clone(rule), saveDone: function (newRule) { return _this.setState(function (prevState) {
                                            return ({ accessRules: prevState.accessRules.map(function (r) { return (r === rule) ? newRule : r; }) });
                                        }, function () { return _this.updatePrivateKeyAccess(); }); } })),
                                React.createElement(Button_1.ActionButton, { label: "Delete", onClick: function () { return _this.setState(function (prevState) {
                                        return ({ accessRules: prevState.accessRules.filter(function (r) { return r !== rule; }) });
                                    }, function () { return _this.updatePrivateKeyAccess(); }); } }))
                        ]; } }),
                    React.createElement("div", { className: styles.addRule },
                        React.createElement(OpenDialogButton_1.default, { label: "Add Access Rule" },
                            React.createElement(PrivateKeyAccessRuleDialog_1.default, { rule: { Identity: null, Access: CertificateImportTypes_1.AccessType.ReadOnly }, saveDone: function (newRule) { return _this.setState(function (prevState) {
                                    return ({ accessRules: _this.state.accessRules.concat([newRule]) });
                                }, function () { return _this.updatePrivateKeyAccess(); }); } }))),
                    React.createElement(form_1.Note, null, "By default, both the machine Administrators group and the account the Tentacle Service is executing as will be granted access.")));
    };
    CertificateImportActionEdit.prototype.certificateSummary = function () {
        var certificateVariable = this.props.properties["Octopus.Action.Certificate.Variable"];
        return certificateVariable
            ? form_1.Summary.summary(React.createElement("span", null,
                "The certificate ",
                React.createElement("b", null, certificateVariable),
                " will be imported"))
            : form_1.Summary.placeholder("The certificate variable has not been provided");
    };
    CertificateImportActionEdit.prototype.storeLocationSummary = function () {
        var storeLocation = this.props.properties["Octopus.Action.Certificate.StoreLocation"]
            ? this.props.properties["Octopus.Action.Certificate.StoreLocation"]
            : this.props.properties["Octopus.Action.Certificate.StoreUser"];
        return form_1.Summary.summary(React.createElement("span", null,
            "The selected certificate store is ",
            React.createElement("b", null, storeLocation)));
    };
    CertificateImportActionEdit.prototype.storeNameSummary = function () {
        var storeName = this.props.properties["Octopus.Action.Certificate.StoreName"];
        return form_1.Summary.summary(React.createElement("span", null,
            "The selected store name is ",
            React.createElement("b", null, storeName)));
    };
    CertificateImportActionEdit.prototype.privateKeyAccessSummary = function () {
        return (this.state.accessRules && this.state.accessRules.length > 0)
            ? this.state.accessRules.length > 1
                ? form_1.Summary.summary(React.createElement("span", null,
                    "There are ",
                    React.createElement("b", null, this.state.accessRules.length),
                    " access rules defined"))
                : form_1.Summary.summary(React.createElement("span", null,
                    "There is ",
                    React.createElement("b", null, "1"),
                    " access rule defined"))
            : form_1.Summary.placeholder("There are no access rules defined");
    };
    CertificateImportActionEdit.prototype.privateKeyExportableSummary = function () {
        var exportable = this.props.properties["Octopus.Action.Certificate.PrivateKeyExportable"];
        return exportable === "True"
            ? form_1.Summary.summary(React.createElement("span", null, "The private-key is exportable"))
            : form_1.Summary.summary(React.createElement("span", null, "The private-key is not exportable"));
    };
    return CertificateImportActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.Certificate.Import",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(CertificateImportActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return false; },
    edit: CertificateImportActionEdit
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\certificateImport\\certificateImportAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\certificateImport\\certificateImportAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(167);
var SaveDialogLayout_1 = __webpack_require__(105);
var form_1 = __webpack_require__(15);
var CertificateImportTypes_1 = __webpack_require__(708);
var PrivateKeyAccessRuleDialog = (function (_super) {
    __extends(PrivateKeyAccessRuleDialog, _super);
    function PrivateKeyAccessRuleDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            identity: _this.props.rule.Identity,
            access: _this.props.rule.Access,
        };
        return _this;
    }
    PrivateKeyAccessRuleDialog.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.state.identity) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.saveDone({ Identity: this.state.identity, Access: this.state.access })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        this.setState({
                            errors: {
                                message: "Identity must be provided",
                                details: ["Please enter an identity"],
                                fieldErrors: {}
                            }
                        });
                        return [2 /*return*/, false];
                }
            });
        });
    };
    PrivateKeyAccessRuleDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(SaveDialogLayout_1.default, { title: this.props.rule.Identity ? "Edit Access Rule" : "Add Access Rule", busy: this.state.busy, errors: this.state.errors, onSaveClick: function () { return _this.save(); } },
            React.createElement(form_1.Text, { label: "Identity", hintText: "Enter an identity", value: this.state.identity, validate: form_1.required("Please enter an identity"), onChange: function (val) { return _this.setState({ identity: val }); }, autoFocus: true }),
            React.createElement(form_1.Note, null,
                "The user or group identity. e.g. ",
                React.createElement("em", null, "DOMAIN\\userOrGroup")),
            React.createElement(form_1.Select, { label: "Access", value: this.state.access, items: Object.values(CertificateImportTypes_1.AccessType).map(function (item) { return ({ value: item, text: item }); }), onChange: function (val) { return _this.setState({ access: val }); } }));
    };
    return PrivateKeyAccessRuleDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = PrivateKeyAccessRuleDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\certificateImport\\PrivateKeyAccessRuleDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\certificateImport\\PrivateKeyAccessRuleDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1954);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_headerColumn__1rN3h:nth-child(3){padding-left:2.95rem}.style_rowColumn__3VYV1{word-break:break-all;word-wrap:break-word;white-space:normal;padding:.175rem 1.125rem!important;vertical-align:middle!important}.style_addRule__1-q6f{margin:1rem 0}", ""]);

// exports
exports.locals = {
	"headerColumn": "style_headerColumn__1rN3h",
	"rowColumn": "style_rowColumn__3VYV1",
	"addRule": "style_addRule__1-q6f"
};

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var form_1 = __webpack_require__(15);
var Note_1 = __webpack_require__(22);
var FormSectionHeading_1 = __webpack_require__(46);
var clientInstance_1 = __webpack_require__(10);
var Text_1 = __webpack_require__(17);
var Select_1 = __webpack_require__(41);
var StringEditList_1 = __webpack_require__(298);
var ActionDetails_1 = __webpack_require__(27);
var DockerNetworkActionSummary = (function (_super) {
    __extends(DockerNetworkActionSummary, _super);
    function DockerNetworkActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DockerNetworkActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Create a Docker Network",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return DockerNetworkActionSummary;
}(BaseComponent_1.BaseComponent));
var NetworkTypes = {
    bridge: {
        name: "Bridge (Default)",
        description: "Connect the container to the bridge via veth interfaces."
    },
    other: {
        name: "Custom",
        description: "Use an installed third party or own custom network driver."
    }
};
var DockerNetworkAction = (function (_super) {
    __extends(DockerNetworkAction, _super);
    function DockerNetworkAction(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            teams: [],
        };
        return _this;
    }
    DockerNetworkAction.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.props.properties["Octopus.Action.Docker.NetworkType"]) {
            this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkType"] = "bridge", _a), true);
        }
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var teams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Teams.all()];
                    case 1:
                        teams = _a.sent();
                        this.setState({ teams: teams });
                        return [2 /*return*/];
                }
            });
        }); });
        var _a;
    };
    DockerNetworkAction.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Networking Options" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.NetworkType", title: "Network Type", summary: this.networkTypeSummary(), help: "Proxy used to communicate with this deployment target." },
                React.createElement(Select_1.default, { label: "Network type", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkType"] = val, _a));
                        var _a;
                    }, value: this.props.properties["Octopus.Action.Docker.NetworkType"], items: Object.keys(NetworkTypes).map(function (nt) { return ({ value: nt, text: NetworkTypes[nt].name }); }) }),
                this.props.properties["Octopus.Action.Docker.NetworkType"] &&
                    React.createElement(Note_1.default, null, NetworkTypes[this.props.properties["Octopus.Action.Docker.NetworkType"]].description),
                this.props.properties["Octopus.Action.Docker.NetworkType"] === "other" &&
                    React.createElement(Text_1.default, { label: "Custom Driver", onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkCustomDriver"] = val, _a));
                            var _a;
                        }, value: this.props.properties["Octopus.Action.Docker.NetworkCustomDriver"] })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.NetworkSubnet", title: "Subnets", summary: this.propertySummary("Octopus.Action.Docker.NetworkSubnet", "No specific subnet specified"), help: "Subnet in CIDR format that represents a network segment. On a bridge network you can only specify a single subnet" },
                React.createElement(StringEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.NetworkSubnet"], label: "Subnet", hintText: "CIDR format (e.g. 172.28.5.0/24)", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkSubnet"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.NetworkIPRange", title: "IP Range", summary: this.propertySummary("Octopus.Action.Docker.NetworkIPRange", "No specific IP range specified"), help: "Allocate container ip from a sub-range." },
                React.createElement(StringEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.NetworkIPRange"], label: "IP range", hintText: "CIDR format (e.g. 172.28.5.0/24)", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkIPRange"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.NetworkGateway", title: "Network Gateway", summary: this.propertySummary("Octopus.Action.Docker.NetworkGateway", "No specific network gateway specified"), help: "IPv4 or IPv6 gateway for the master subnet. By default the Docker engine will select one from inside a preferred pool." },
                React.createElement(StringEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.NetworkGateway"], label: "Network gateway", hintText: "IPv4 or IPv6 (e.g. 172.28.5.1)", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkGateway"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.Args", title: "Additional Arguments", summary: this.propertySummary("Octopus.Action.Docker.Args", "No additional arguments specified"), help: React.createElement("span", null,
                    "Provide any other arguments that will be passed to the ",
                    React.createElement("code", null, "docker network create"),
                    " command.") },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Additional arguments", value: this.props.properties["Octopus.Action.Docker.Args"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.Args"] = val, _a));
                        var _a;
                    } })));
    };
    DockerNetworkAction.prototype.propertySummary = function (property, defaultValue) {
        var subnet = this.props.properties[property];
        return subnet
            ? form_1.Summary.summary(subnet)
            : form_1.Summary.placeholder(defaultValue);
    };
    DockerNetworkAction.prototype.networkTypeSummary = function () {
        var type = this.props.properties["Octopus.Action.Docker.NetworkType"];
        if (!type) {
            return form_1.Summary.default(NetworkTypes.bridge.description);
        }
        if (type === "other") {
            return form_1.Summary.summary(this.props.properties["Octopus.Action.Docker.NetworkCustomDriver"] + " (custom)");
        }
        return form_1.Summary.summary(NetworkTypes[type].description);
    };
    return DockerNetworkAction;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.DockerNetwork",
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DockerNetworkActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: DockerNetworkAction
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\dockerNetwork\\dockerNetworkAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\dockerNetwork\\dockerNetworkAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var FormSectionHeading_1 = __webpack_require__(46);
var form_1 = __webpack_require__(15);
var Note_1 = __webpack_require__(22);
var Text_1 = __webpack_require__(17);
var PackageSelector_1 = __webpack_require__(58);
var ExternalLink_1 = __webpack_require__(29);
var feedResource_1 = __webpack_require__(54);
var RadioButton_1 = __webpack_require__(36);
var RadioButtonGroup_1 = __webpack_require__(33);
var StringCheckbox_1 = __webpack_require__(38);
var lodash_1 = __webpack_require__(16);
var RemoveItemsList_1 = __webpack_require__(142);
var ActionButton_1 = __webpack_require__(50);
var DialogOpener_1 = __webpack_require__(436);
var VolumeBindingDialog_1 = __webpack_require__(1957);
var ParseHelper_1 = __webpack_require__(75);
var KeyValueEditList_1 = __webpack_require__(222);
var StringEditList_1 = __webpack_require__(298);
var getFeedName_1 = __webpack_require__(66);
var ActionDetails_1 = __webpack_require__(27);
var BindingList = (function (_super) {
    __extends(BindingList, _super);
    function BindingList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BindingList;
}(RemoveItemsList_1.RemoveItemsList));
var DockerRunActionSummary = (function (_super) {
    __extends(DockerRunActionSummary, _super);
    function DockerRunActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    DockerRunActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    DockerRunActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy and Run a Docker Container",
            React.createElement("strong", null,
                " ",
                this.props.properties[specialVariables_1.default.Action.Package.PackageId],
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, this.getFeedId()),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    DockerRunActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return DockerRunActionSummary;
}(BaseComponent_1.BaseComponent));
var NetworkTypes = (_a = {},
    _a[""] = {
        name: "Default",
        description: "Provide no explicit type and use host default."
    },
    _a.none = {
        name: "None",
        description: "No networking."
    },
    _a.bridge = {
        name: "Bridge (Linux Default)",
        description: "Connect the container to the bridge via veth interfaces."
    },
    _a.host = {
        name: "Host",
        description: "Use the host's network stack inside the container."
    },
    _a.container = {
        name: "Container",
        description: "Use the network stack of another container, specified via its name or id."
    },
    _a.network = {
        name: "Custom network",
        description: "Connects the container to a user created network."
    },
    _a);
var RestartPolicies = (_b = {
        no: {
            name: "No (default)",
            description: "Do not automatically restart the container when it exits."
        }
    },
    _b["on-failure"] = {
        name: "On failure",
        description: "Restart only if the container exits with a non-zero exit status. " +
            "Optionally, limit the number of restart retries the Docker daemon attempts."
    },
    _b.always = {
        name: "Always",
        description: "Always restart the container regardless of the exit status. " +
            "When you specify always, the Docker daemon will try to restart the container indefinitely. " +
            "The container will also always start on daemon startup, regardless of the current state of the container."
    },
    _b["unless-stopped"] = {
        name: "Unless stopped",
        description: "Always restart the container regardless of the exit status, but do not start it on daemon startup if the container has been put to a stopped state before."
    },
    _b);
var DockerRunAction = (function (_super) {
    __extends(DockerRunAction, _super);
    function DockerRunAction(props) {
        var _this = _super.call(this, props) || this;
        _this.addBinding = function () {
            var binding = {
                host: "",
                container: "",
                readOnly: "False",
                noCopy: "False"
            };
            _this.setState({
                editBinding: binding,
                editBindingIndex: null
            });
        };
        _this.removeBinding = function (b) {
            var bindings = _this.state.volumeBindings.slice();
            bindings.splice(_this.state.volumeBindings.indexOf(b), 1);
            _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.VolumeBindings"] = _this.bindingsToString(bindings), _a));
            var _a;
        };
        _this.saveBinding = function (binding) {
            var bindings = _this.state.volumeBindings.slice();
            if (_this.state.editBindingIndex === null) {
                bindings.push(binding);
            }
            else {
                bindings[_this.state.editBindingIndex] = binding;
            }
            _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.VolumeBindings"] = _this.bindingsToString(bindings), _a));
            _this.resetSelectedBinding();
            return true;
            var _a;
        };
        _this.resetSelectedBinding = function () {
            _this.setState({
                editBinding: null,
                editBindingIndex: null
            });
        };
        _this.editBinding = function (binding) {
            _this.setState({
                editBinding: lodash_1.clone(binding),
                editBindingIndex: _this.state.volumeBindings.indexOf(binding)
            });
        };
        _this.state = {
            feeds: [],
            editBinding: null,
            editBindingIndex: 0,
            volumeBindings: []
        };
        return _this;
    }
    DockerRunAction.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var feeds, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.properties["Octopus.Action.Package.FeedId"]) {
                            this.props.setProperties((_a = {}, _a["Octopus.Action.Package.FeedId"] = feedResource_1.BuiltInFeedId, _a), true);
                        }
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        feeds = _b.sent();
                        this.setState({
                            feeds: feeds,
                            volumeBindings: this.bindingsFromString(this.props.properties["Octopus.Action.Docker.VolumeBindings"])
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DockerRunAction.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.properties["Octopus.Action.Docker.VolumeBindings"] !== nextProps.properties["Octopus.Action.Docker.VolumeBindings"]) {
            this.setState({ volumeBindings: this.bindingsFromString(nextProps.properties["Octopus.Action.Docker.VolumeBindings"]) });
        }
    };
    DockerRunAction.prototype.bindingsFromString = function (rawProperty) {
        if (!rawProperty) {
            return [];
        }
        var bindings = JSON.parse(rawProperty);
        return Object.keys(bindings).map(function (t) { return ({
            container: t,
            host: bindings[t].host,
            readOnly: bindings[t].readOnly,
            noCopy: bindings[t].noCopy
        }); });
    };
    DockerRunAction.prototype.bindingsToString = function (bindings) {
        var bindingObject = bindings.reduce(function (idx, b) {
            idx[b.container] = {
                host: b.host,
                readOnly: b.readOnly,
                noCopy: b.noCopy
            };
            return idx;
        }, {});
        return JSON.stringify(bindingObject);
    };
    DockerRunAction.prototype.render = function () {
        var _this = this;
        var editBindingDialog = React.createElement(DialogOpener_1.default, { open: !!this.state.editBinding, onClose: this.resetSelectedBinding },
            React.createElement(VolumeBindingDialog_1.default, { existingContainerMappings: this.state.volumeBindings
                    .filter(function (p) { return !_this.state.editBinding || p.container !== _this.state.editBinding.container; }).map(function (vm) { return vm.container; }), binding: this.state.editBinding, project: undefined, projectId: this.props.projectId, localNames: this.props.localNames, onAdd: this.saveBinding }));
        return React.createElement("div", null,
            editBindingDialog,
            React.createElement(FormSectionHeading_1.default, { title: "Docker Image details" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", title: "Docker Image", summary: this.summaryPackage(), help: React.createElement("span", null,
                    "This step is used to run a docker container. The package that you wish to deploy should contain all the files needed to run your application. ",
                    React.createElement(ExternalLink_1.default, { href: "DocumentationPackaging" }, "Learn more about what your packages should contain, and how to create them"),
                    ".") },
                React.createElement(PackageSelector_1.default, { feedType: [feedResource_1.FeedType.Docker], setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors })),
            React.createElement(FormSectionHeading_1.default, { title: "Networking Options" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.NetworkType|Octopus.Action.Docker.NetworkContainer|Octopus.Action.Docker.NetworkName", title: "Network Type", summary: this.summaryNetworkType(), help: "Connect a container to a network." },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: this.props.properties["Octopus.Action.Docker.NetworkType"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkType"] = val, _a));
                        var _a;
                    } }, Object.keys(NetworkTypes).map(function (type) { return [
                    React.createElement(RadioButton_1.default, { value: type, label: NetworkTypes[type].name, key: "rdo-" + type }),
                    React.createElement(Note_1.default, { key: "note-" + type }, NetworkTypes[type].description)
                ]; })
                    .reduce(function (arr, dom) { return arr.concat(dom); }, [])),
                this.props.properties["Octopus.Action.Docker.NetworkType"] === "container" &&
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Container name or ID", onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkContainer"] = val, _a));
                            var _a;
                        }, value: this.props.properties["Octopus.Action.Docker.NetworkContainer"] }),
                this.props.properties["Octopus.Action.Docker.NetworkType"] === "network" &&
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Network name or ID", onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkName"] = val, _a));
                            var _a;
                        }, value: this.props.properties["Octopus.Action.Docker.NetworkName"] })),
            this.props.properties["Octopus.Action.Docker.NetworkType"] === "network" &&
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.NetworkAlias", title: "Network Alias", summary: this.propertySummary("Octopus.Action.Docker.NetworkAlias", "No network alias specified"), help: "Add network-scoped alias for the container." },
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Network alias", onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkAlias"] = val, _a));
                            var _a;
                        }, value: this.props.properties["Octopus.Action.Docker.NetworkAlias"] })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.PortMapping|Octopus.Action.Docker.PortAutoMap", title: "Port Mapping", summary: this.summaryPortMappings(), help: React.createElement("div", null,
                    React.createElement(ExternalLink_1.default, { href: "https://docs.docker.com/engine/reference/run/#/expose-incoming-ports" }, "Publish"),
                    " a container's port or a range of ports to the host.") },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.PortMapping"], separator: ":", name: "Port mapping", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.PortMapping"] = val, _a));
                        var _a;
                    }, valueLabel: "Host port", keyLabel: "Container port", projectId: this.props.projectId, reverseLayout: true }),
                React.createElement(StringCheckbox_1.default, { value: this.props.properties["Octopus.Action.Docker.PortAutoMap"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.PortAutoMap"] = x, _a));
                        var _a;
                    }, label: "Automatically map to ephemeral port", note: React.createElement("span", null,
                        "Allows mapping exposed network port in the container to ports on the host. See ",
                        React.createElement(ExternalLink_1.default, { href: "https://docs.docker.com/engine/userguide/networking/default_network/dockerlinks/#/connect-using-network-port-mapping" }, "Docker docs"),
                        " for more information about network port mapping.") })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.AddedHost", title: "Host Entry", summary: this.summaryAddedHost(), help: "Adds a line to /etc/hosts." },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.AddedHost"], name: "Host entry", separator: ":", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.AddedHost"] = val, _a));
                        var _a;
                    }, valueLabel: "Host name", projectId: this.props.projectId, keyLabel: "IP" })),
            React.createElement(FormSectionHeading_1.default, { title: "Volumes" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.VolumeBindings", title: "Bind Mounts", summary: this.summaryBindMounts(), help: React.createElement("span", null,
                    "A ",
                    React.createElement(ExternalLink_1.default, { href: "https://docs.docker.com/engine/tutorials/dockervolumes/" }, "data volume"),
                    " is a specially-designated directory within one or more containers that bypasses the ",
                    React.createElement(ExternalLink_1.default, { href: "https://docs.docker.com/engine/reference/glossary/#union-file-system" }, "Union File System"),
                    ".") },
                React.createElement(BindingList, { listActions: [React.createElement(ActionButton_1.default, { label: "Add volume binding", onClick: function () { return _this.addBinding(); } })], data: this.state.volumeBindings, onRow: function (binding) {
                        return React.createElement("div", { key: binding.container },
                            binding.host ?
                                React.createElement("span", null,
                                    React.createElement("b", null, "Host: "),
                                    binding.host,
                                    " : ",
                                    React.createElement("b", null, "Container: "),
                                    binding.container) :
                                binding.container,
                            _this.isTrue(binding.readOnly, "readonly") && React.createElement("b", null, " readonly"),
                            _this.isTrue(binding.noCopy, "nocopy") && React.createElement("b", null, " nocopy"));
                    }, onRowTouch: function (binding) { return _this.editBinding(binding); }, onRemoveRow: function (binding) { return _this.removeBinding(binding); } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.VolumeDriver", title: "Volume Driver", summary: this.propertySummary("Octopus.Action.Docker.VolumeDriver", "No volume driver specified"), help: "Optional volume driver for the container." },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Volume driver", value: this.props.properties["Octopus.Action.Docker.VolumeDriver"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.VolumeDriver"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.VolumesFrom", title: "Volumes From", summary: this.summaryVolumesFromContainers(), help: "Mount all volumes from the given container(s)." },
                React.createElement(StringEditList_1.default, { label: "Container volumes", items: this.props.properties["Octopus.Action.Docker.VolumesFrom"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.VolumesFrom"] = val, _a));
                        var _a;
                    } })),
            React.createElement(FormSectionHeading_1.default, { title: "Variables" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.EnvVariable", title: "Explicit Variable Mapping", summary: this.summaryVariables(), help: React.createElement("span", null,
                    "Passes through variables into the container accessible as environment variables. See ",
                    React.createElement(ExternalLink_1.default, { href: "https://docs.docker.com/engine/reference/run/#/env-environment-variables" }, "Docker docs"),
                    " for more information about environment variables.") },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.EnvVariable"], name: "Variable mapping", separator: "=", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.EnvVariable"] = val, _a));
                        var _a;
                    }, valueLabel: "Mapping", projectId: this.props.projectId, keyLabel: "Variable name" })),
            React.createElement(FormSectionHeading_1.default, { title: "Additional Arguments" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.RestartPolicy|Octopus.Action.Docker.RestartPolicyMax", title: "Restart Policy", summary: this.summaryRestartPolicy(), help: React.createElement("span", null,
                    "Restart policy to apply when a container exits. See ",
                    React.createElement(ExternalLink_1.default, { href: "'https://docs.docker.com/engine/reference/run/#restart-policies-restart" }, "Docker docs"),
                    " for more information.") },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: this.props.properties["Octopus.Action.Docker.RestartPolicy"] || "no", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RestartPolicy"] = val, _a));
                        var _a;
                    } }, Object.keys(RestartPolicies).map(function (type) { return [
                    React.createElement(RadioButton_1.default, { value: type, label: RestartPolicies[type].name, key: "rdo-" + type }),
                    React.createElement(Note_1.default, { key: "note-" + type }, RestartPolicies[type].description)
                ]; })
                    .reduce(function (arr, dom) { return arr.concat(dom); }, [])),
                this.props.properties["Octopus.Action.Docker.RestartPolicy"] === "on-failure" &&
                    React.createElement(Text_1.default, { label: "Maximum retry count", hintText: "Unlimited retry", value: this.props.properties["Octopus.Action.Docker.RestartPolicyMax"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RestartPolicyMax"] = val, _a));
                            var _a;
                        } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.DontRun", title: "Don't Auto-run", summary: this.summaryAutoRun(), help: React.createElement("span", null, "This creates the writable layer on top of the image and prepares it for running without actually starting it . This may be useful if there is other configuration you would like to perform before startup.") },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", label: React.createElement("span", null,
                        "Perform ",
                        React.createElement("code", null, "create"),
                        " command instead of ",
                        React.createElement("code", null, "run")), value: this.props.properties["Octopus.Action.Docker.DontRun"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.DontRun"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.Command", title: "Command", summary: this.propertySummary("Octopus.Action.Docker.Command", "No custom command specified"), help: React.createElement("span", null,
                    React.createElement(ExternalLink_1.default, { href: "https://docs.docker.com/engine/reference/run/#cmd-default-command-or-options" }, "Override default"),
                    " ",
                    React.createElement("code", null, "CMD"),
                    " instruction provided by the image.") },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Command", value: this.props.properties["Octopus.Action.Docker.Command"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.Command"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.Args", title: "Additional Arguments", summary: this.propertySummary("Octopus.Action.Docker.Args", "No additional arguments specified."), help: React.createElement("span", null,
                    "Provide any other arguments that will be passed to the ",
                    React.createElement("code", null, "docker run"),
                    " command.") },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Additional arguments", value: this.props.properties["Octopus.Action.Docker.Args"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.Args"] = val, _a));
                        var _a;
                    } }),
                React.createElement(Note_1.default, null,
                    "A full description of the additional arguments which can be supplied can be found on the ",
                    React.createElement(ExternalLink_1.default, { href: "DockerRun" }, "Docker reference page"),
                    ".")));
    };
    DockerRunAction.prototype.isTrue = function (noCopy, trueString) {
        return (!!noCopy && (noCopy === true || noCopy.toLowerCase() === "true" || noCopy.toLowerCase() === trueString));
    };
    DockerRunAction.prototype.summaryPackage = function () {
        var properties = this.props.properties;
        var summary = [];
        if (properties["Octopus.Action.Package.PackageId"]) {
            summary.push(React.createElement("span", null,
                "Deploy package ",
                React.createElement("strong", null, properties["Octopus.Action.Package.PackageId"])));
        }
        if (properties["Octopus.Action.Package.FeedId"]) {
            var feed = this.state.feeds.find(function (f) { return f.Id === properties["Octopus.Action.Package.FeedId"]; });
            if (feed) {
                summary.push(React.createElement("span", null,
                    " from feed ",
                    React.createElement("strong", null, feed.Name)));
            }
        }
        if (summary.length > 0) {
            return form_1.Summary.summary(React.Children.toArray(summary));
        }
        return form_1.Summary.placeholder("Choose a package to be deployed");
    };
    DockerRunAction.prototype.propertySummary = function (property, defaultValue) {
        var subnet = this.props.properties[property];
        return subnet
            ? form_1.Summary.summary(subnet)
            : form_1.Summary.placeholder(defaultValue);
    };
    DockerRunAction.prototype.summaryNetworkType = function () {
        var type = this.props.properties["Octopus.Action.Docker.NetworkType"] || "";
        var text = NetworkTypes[type].description;
        if (type === "") {
            return form_1.Summary.default(text);
        }
        if (type === "container") {
            text += " (" + this.props.properties["Octopus.Action.Docker.NetworkContainer"] + ")";
        }
        else if (type === "network") {
            text += " (" + this.props.properties["Octopus.Action.Docker.NetworkName"] + ")";
        }
        return form_1.Summary.summary(text);
    };
    DockerRunAction.prototype.summaryPortMappings = function () {
        var portMappings = JSON.parse(this.props.properties["Octopus.Action.Docker.PortMapping"] || "{}");
        if (Object.keys(portMappings).length === 0) {
            return form_1.Summary.placeholder("No port mappings provided");
        }
        else {
            var text = Object.keys(portMappings).map(function (m) { return (portMappings[m] ? portMappings[m] + " : " : "") + m; }).join(", ");
            return form_1.Summary.summary(text);
        }
    };
    DockerRunAction.prototype.summaryAddedHost = function () {
        var hosts = JSON.parse(this.props.properties["Octopus.Action.Docker.AddedHost"] || "{}");
        if (Object.keys(hosts).length === 0) {
            return form_1.Summary.placeholder("No host entries added");
        }
        else {
            var text = Object.keys(hosts).map(function (m) { return m + (hosts[m] ? " : " + hosts[m] : ""); }).join(", ");
            return form_1.Summary.summary(text);
        }
    };
    DockerRunAction.prototype.summaryVolumesFromContainers = function () {
        var raw = ParseHelper_1.default.parseCSV(this.props.properties["Octopus.Action.Docker.VolumesFrom"] || "");
        if (raw.length === 0) {
            return form_1.Summary.placeholder("No container volumes specified");
        }
        var pluralized = (raw.length === 1 ? "" : "s");
        return form_1.Summary.summary(React.createElement("span", null,
            "Volume",
            pluralized,
            " mounted from container",
            pluralized,
            " ",
            React.createElement("b", null, raw.join(", "))));
    };
    DockerRunAction.prototype.summaryBindMounts = function () {
        if (this.state.volumeBindings.length === 0) {
            return form_1.Summary.placeholder("No volume bindings specified");
        }
        var containerBindings = this.state.volumeBindings.map(function (b) { return b.container; });
        var pluralized = (containerBindings.length === 1 ? "" : "s");
        return form_1.Summary.summary(React.createElement("span", null,
            "Volume binding",
            pluralized,
            " mapped to mount",
            pluralized,
            " ",
            React.createElement("b", null, containerBindings.join(", "))));
    };
    DockerRunAction.prototype.summaryAutoRun = function () {
        var val = this.props.properties["Octopus.Action.Docker.DontRun"] || "false";
        if (val.toLowerCase() === "true") {
            return form_1.Summary.summary("Container will be created in stopped mode");
        }
        return form_1.Summary.placeholder("Container will run when created");
    };
    DockerRunAction.prototype.summaryRestartPolicy = function () {
        var policy = this.props.properties["Octopus.Action.Docker.RestartPolicy"];
        var restartPolicyMax = this.props.properties["Octopus.Action.Docker.RestartPolicyMax"];
        if (!policy) {
            policy = "no";
        }
        var text = RestartPolicies[policy].description;
        if (policy === "no") {
            return form_1.Summary.default(text);
        }
        if (policy === "on-failure") {
            text += restartPolicyMax ? " (max " + restartPolicyMax + " restarts)" : "(unlimited restarts)";
        }
        return form_1.Summary.summary(text);
    };
    DockerRunAction.prototype.summaryVariables = function () {
        var variables = JSON.parse(this.props.properties["Octopus.Action.Docker.EnvVariable"] || "{}");
        if (Object.keys(variables).length === 0) {
            return form_1.Summary.placeholder("No environment variables specified");
        }
        else {
            var text = Object.keys(variables).map(function (m) { return m + " = " + variables[m]; }).join(", ");
            return form_1.Summary.summary(text);
        }
    };
    return DockerRunAction;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.DockerRun",
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DockerRunActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: DockerRunAction
});
var _a, _b;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\dockerRun\\dockerRunAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\dockerRun\\dockerRunAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Text_1 = __webpack_require__(17);
var OkDialogLayout_1 = __webpack_require__(107);
var DataBaseComponent_1 = __webpack_require__(39);
var Note_1 = __webpack_require__(22);
var StringCheckbox_1 = __webpack_require__(38);
var VolumeBindingDialog = (function (_super) {
    __extends(VolumeBindingDialog, _super);
    function VolumeBindingDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.save = function () {
            return _this.props.onAdd(_this.state.binding);
        };
        _this.state = {
            binding: props.binding,
        };
        return _this;
    }
    VolumeBindingDialog.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); });
    };
    VolumeBindingDialog.prototype.render = function () {
        var _this = this;
        var existingError = this.props.existingContainerMappings.indexOf(this.state.binding.container) === -1 ?
            null :
            "A volume binding already exists for this path";
        return React.createElement(OkDialogLayout_1.default, { onOkClick: this.save, okButtonDisabled: existingError !== null || this.state.binding.container === "", busy: this.state.busy, errors: this.state.errors, title: "Add Volume Binding" }, this.state.binding && React.createElement("div", null,
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.container, onChange: function (x) { return _this.setChildState1("binding", { container: x }); }, error: existingError, label: "Container Dest" }),
            React.createElement(Note_1.default, null,
                " ",
                existingError === null && "Mount point inside container to create volume."),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.host, onChange: function (x) { return _this.setChildState1("binding", { host: x }); }, label: "Host Source" }),
            React.createElement(Note_1.default, null, "An optional absolute path or a name value to a resource on the host."),
            React.createElement("br", null),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "false", value: this.state.binding.readOnly, onChange: function (x) { return _this.setChildState1("binding", { readOnly: x }); }, label: "Read Only", note: React.createElement("span", null, "Volume defaults mode to read-write.") }),
            React.createElement("br", null),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "false", value: this.state.binding.noCopy, onChange: function (x) { return _this.setChildState1("binding", { noCopy: x }); }, label: "No Copy", note: React.createElement("span", null, "Disable automatic copying volume path in the container to the volume storage location.") })));
    };
    return VolumeBindingDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = VolumeBindingDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\dockerRun\\VolumeBindingDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\dockerRun\\VolumeBindingDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var FormSectionHeading_1 = __webpack_require__(46);
var ExpandableFormSection_1 = __webpack_require__(44);
var Summary_1 = __webpack_require__(70);
var RadioButton_1 = __webpack_require__(36);
var RadioButtonGroup_1 = __webpack_require__(33);
var StepMultiSelect_1 = __webpack_require__(434);
var ParseHelper_1 = __webpack_require__(75);
var Note_1 = __webpack_require__(22);
var StringCheckbox_1 = __webpack_require__(38);
var KeyValueEditList_1 = __webpack_require__(222);
var Text_1 = __webpack_require__(17);
var clientInstance_1 = __webpack_require__(10);
var lodash_1 = __webpack_require__(16);
var ActionDetails_1 = __webpack_require__(27);
var DockerStopActionSummary = (function (_super) {
    __extends(DockerStopActionSummary, _super);
    function DockerStopActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DockerStopActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Stop a Docker Resource",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return DockerStopActionSummary;
}(BaseComponent_1.BaseComponent));
var DockerStopAction = (function (_super) {
    __extends(DockerStopAction, _super);
    function DockerStopAction(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            name: "XX",
            steps: []
        };
        return _this;
    }
    DockerStopAction.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var project, deployment, actions;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!this.props.projectId) return [3 /*break*/, 3];
                                        return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                                    case 1:
                                        project = _a.sent();
                                        return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.get(project.DeploymentProcessId)];
                                    case 2:
                                        deployment = _a.sent();
                                        actions = lodash_1.flatten(deployment.Steps.map(function (step, stepIndex) {
                                            return step.Actions.map(function (action, actionIndex) {
                                                var num = "" + stepIndex + 1;
                                                if (step.Actions.length > 1) {
                                                    num = num + "." + (actionIndex + 1);
                                                }
                                                return __assign({}, action, { NumberedName: num + ". " + action.Name });
                                            });
                                        })).filter(function (action) { return action.ActionType === "Octopus.DockerNetwork" || action.ActionType === "Octopus.DockerRun"; });
                                        this.setState({ steps: actions });
                                        _a.label = 3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DockerStopAction.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Removal Rules" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Docker.Remove", title: "Perform", summary: this.summaryRemove(), help: "Action to take place." },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: this.props.properties["Octopus.Action.Docker.Remove"] || "False", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.Remove"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "False", label: "Stop", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "True", label: "Stop and remove" }))),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Docker.RemoveSteps", title: "From Steps", summary: this.summarySteps(), help: "Resources created from these Docker steps should be removed." },
                React.createElement(StepMultiSelect_1.default, { items: this.state.steps, label: "Docker steps", value: ParseHelper_1.default.parseCSV(this.props.properties["Octopus.Action.Docker.RemoveSteps"]), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RemoveSteps"] = ParseHelper_1.default.encodeCSV(val), _a));
                        var _a;
                    } }),
                React.createElement(Note_1.default, null,
                    "Note that leaving blank will remove resources created from ",
                    React.createElement("em", null, "all"),
                    " docker steps and therefore may remove resources from the same release if this step runs after other Docker steps.")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Docker.RemoveByEnvironment|Octopus.Action.Docker.RemoveByRelease|Octopus.Action.Docker.RemoveByTenant", title: "Resources Matching", summary: this.summaryMatches(), help: "Containers created though Octopus are tagged with the relevant context to allow the following selection during this stop process." },
                React.createElement(StringCheckbox_1.default, { value: "True", onChange: function (x) { return undefined; }, disabled: true, label: "Project", note: React.createElement("span", null, "Resources will be removed where they match the current project. This cannot be disabled.") }),
                React.createElement("br", null),
                React.createElement(StringCheckbox_1.default, { value: this.props.properties["Octopus.Action.Docker.RemoveByEnvironment"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RemoveByEnvironment"] = x, _a));
                        var _a;
                    }, label: "Environment", note: React.createElement("span", null, "Resources will be removed only where they also match the current environment.") }),
                React.createElement("br", null),
                React.createElement(StringCheckbox_1.default, { value: this.props.properties["Octopus.Action.Docker.RemoveByRelease"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RemoveByRelease"] = x, _a));
                        var _a;
                    }, label: "Release", note: React.createElement("span", null, "Resources will be removed only where they also match the current release.") }),
                React.createElement("br", null),
                React.createElement(StringCheckbox_1.default, { value: this.props.properties["Octopus.Action.Docker.RemoveByTenant"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RemoveByTenant"] = x, _a));
                        var _a;
                    }, label: "Tenant (if applicable)", note: React.createElement("span", null, "If the release includes tenants then resources will be removed only where they also match the currently deploying tenant.") })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Docker.RemoveCustomTags", title: "Custom Tag Filters", summary: this.summaryTags(), help: React.createElement("span", null,
                    "These tags will be included when searching for resources using the ",
                    React.createElement("code", null, "--filter \"label=X\""),
                    " argument. If the value is not provided, the resource will be included so long as the tag is present with any value") },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.RemoveCustomTags"], separator: "=", name: "Custom tag", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RemoveCustomTags"] = val, _a));
                        var _a;
                    }, keyLabel: "Label", valueLabel: "Value" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Docker.StopTimeout", title: "Timeout (sec)", summary: this.propertySummary("Octopus.Action.Docker.StopTimeout", "No timeout value supplied"), help: React.createElement("span", null,
                    "Seconds to wait for process to stop before killing it (Docker default 10) . The main process inside the container will receive ",
                    React.createElement("code", null, "SIGTERM"),
                    ", and after a grace period, ",
                    React.createElement("code", null, "SIGKILL"),
                    ".") },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Docker.StopTimeout"], label: "Timeout (sec)", hintText: "10", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.StopTimeout"] = val, _a));
                        var _a;
                    } })));
    };
    DockerStopAction.prototype.summaryTags = function () {
        var tags = JSON.parse(this.props.properties["Octopus.Action.Docker.RemoveCustomTags"] || "{}");
        if (Object.keys(tags).length === 0) {
            return Summary_1.default.placeholder("No custom tags specified");
        }
        else {
            var text = Object.keys(tags).map(function (m) { return m + " = " + tags[m]; }).join(", ");
            return Summary_1.default.summary(text);
        }
    };
    DockerStopAction.prototype.summarySteps = function () {
        var removeSteps = this.props.properties["Octopus.Action.Docker.RemoveSteps"];
        return Summary_1.default.placeholder("No steps have been selected");
    };
    DockerStopAction.prototype.summaryMatches = function () {
        var matches = [];
        if ((this.props.properties["Octopus.Action.Docker.RemoveByEnvironment"] || "true").toLowerCase() === "true") {
            matches.push("environment");
        }
        if ((this.props.properties["Octopus.Action.Docker.RemoveByRelease"] || "true").toLowerCase() === "true") {
            matches.push("release");
        }
        if ((this.props.properties["Octopus.Action.Docker.RemoveByTenant"] || "true").toLowerCase() === "true") {
            matches.push("tenant (if applicable)");
        }
        if (matches.length === 0) {
            return Summary_1.default.default("This project");
        }
        return Summary_1.default.summary("The relevant " + matches.join(", ") + " and this project");
    };
    DockerStopAction.prototype.propertySummary = function (property, defaultValue) {
        var subnet = this.props.properties[property];
        return subnet
            ? Summary_1.default.summary(subnet)
            : Summary_1.default.placeholder(defaultValue);
    };
    DockerStopAction.prototype.summaryRemove = function () {
        var remove = this.props.properties["Octopus.Action.Docker.Remove"];
        if (!remove || remove === "False") {
            return Summary_1.default.default("Stop");
        }
        else if (remove === "True") {
            return Summary_1.default.summary("Stop and Remove");
        }
        return Summary_1.default.summary(remove);
    };
    return DockerStopAction;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.DockerStop",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DockerStopActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    edit: DockerStopAction
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\dockerStop\\dockerStopAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\dockerStop\\dockerStopAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var FormSectionHeading_1 = __webpack_require__(46);
var feedResource_1 = __webpack_require__(54);
var InternalLink_1 = __webpack_require__(42);
var ExpandableFormSection_1 = __webpack_require__(44);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(58);
var PackageDownloadOptions_1 = __webpack_require__(135);
var Text_1 = __webpack_require__(17);
var Note_1 = __webpack_require__(22);
var Summary_1 = __webpack_require__(70);
var routeLinks_1 = __webpack_require__(20);
var getFeedName_1 = __webpack_require__(66);
var ActionDetails_1 = __webpack_require__(27);
var AzureCloudServiceActionSummary = (function (_super) {
    __extends(AzureCloudServiceActionSummary, _super);
    function AzureCloudServiceActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    AzureCloudServiceActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureCloudServiceActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Transfer package",
            React.createElement("strong", null,
                " ",
                this.props.properties[specialVariables_1.default.Action.Package.PackageId],
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, this.getFeedId()),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    AzureCloudServiceActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return AzureCloudServiceActionSummary;
}(BaseComponent_1.BaseComponent));
var TransferPackageActionEdit = (function (_super) {
    __extends(TransferPackageActionEdit, _super);
    function TransferPackageActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feeds: []
        };
        return _this;
    }
    TransferPackageActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!this.props.properties["Octopus.Action.Package.FeedId"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.Package.FeedId"] = feedResource_1.BuiltInFeedId, _c), true);
                        }
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _a.apply(this, [(_b.feeds = _d.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    TransferPackageActionEdit.prototype.transferPathSummary = function () {
        var transferPath = this.props.properties["Octopus.Action.Package.TransferPath"];
        if (!transferPath) {
            return Summary_1.default.placeholder("The transfer path has not been configured");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "The package will be moved to ",
            React.createElement("strong", null, transferPath),
            " once it is transfered"));
    };
    TransferPackageActionEdit.prototype.render = function () {
        var _this = this;
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to push the contents of a package to one or more machines which may be sourced from an external feed or the Octopus built-in feed. You can configure the remote machines to deploy to in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.infrastructure.root, openInSelf: false }, "Infrastructure"),
                " tab.")
            : React.createElement("span", null, "Choose the package you which to transfer");
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Package Details" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(this.props.properties, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, feedType: [feedResource_1.FeedType.Nuget, feedResource_1.FeedType.Maven, feedResource_1.FeedType.GitHub], getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors }),
                React.createElement(PackageDownloadOptions_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, localNames: this.props.localNames, errors: this.props.errors })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.TransferPath", title: "Transfer Path", summary: this.transferPathSummary(), help: "Enter the path the package should be moved to on the remove target." },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Package.TransferPath"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.TransferPath"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Package.TransferPath"), label: "Transfer path" }),
                React.createElement(Note_1.default, null, "The location that the package should be moved to once it is uploaded to the remote target.")));
    };
    return TransferPackageActionEdit;
}(BaseComponent_1.BaseComponent));
exports.TransferPackageActionEdit = TransferPackageActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.TransferPackage",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AzureCloudServiceActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: TransferPackageActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\transferPackage\\transferPackageAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\transferPackage\\transferPackageAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(37);
var FormSectionHeading_1 = __webpack_require__(46);
var feedResource_1 = __webpack_require__(54);
var InternalLink_1 = __webpack_require__(42);
var ExpandableFormSection_1 = __webpack_require__(44);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(58);
var PackageDownloadOptions_1 = __webpack_require__(135);
var routeLinks_1 = __webpack_require__(20);
var getFeedName_1 = __webpack_require__(66);
var ActionDetails_1 = __webpack_require__(27);
var DeployToWildflyActionSummary = (function (_super) {
    __extends(DeployToWildflyActionSummary, _super);
    function DeployToWildflyActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    DeployToWildflyActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    DeployToWildflyActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Deploy a Java application to Wildfly 10+ and Red Hat JBoss EAP 6+");
    };
    DeployToWildflyActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return DeployToWildflyActionSummary;
}(BaseComponent_1.BaseComponent));
var DeployToWildflyActionEdit = (function (_super) {
    __extends(DeployToWildflyActionEdit, _super);
    function DeployToWildflyActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feeds: []
        };
        return _this;
    }
    DeployToWildflyActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var properties, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        properties = {};
                        properties["Octopus.Features.WildflyDeployCLI"] = "True";
                        if (!this.props.properties["Octopus.Action.Package.FeedId"]) {
                            properties["Octopus.Action.Package.FeedId"] = feedResource_1.BuiltInFeedId;
                        }
                        this.props.setProperties(properties, true);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DeployToWildflyActionEdit.prototype.render = function () {
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to deploy a package to one or more machines which may be sourced from an external feed or the Octopus built-in feed. You can configure the remote machines to deploy to in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.infrastructure.root, openInSelf: false }, "Infrastructure"),
                " tab.")
            : React.createElement("span", null, "Choose the package you wish to deploy.");
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Package Details" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(this.props.properties, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors, feedType: [feedResource_1.FeedType.Nuget, feedResource_1.FeedType.Maven] }),
                React.createElement(PackageDownloadOptions_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, localNames: this.props.localNames, errors: this.props.errors })));
    };
    return DeployToWildflyActionEdit;
}(BaseComponent_1.BaseComponent));
exports.DeployToWildflyActionEdit = DeployToWildflyActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.WildFlyDeploy",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DeployToWildflyActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: DeployToWildflyActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.CustomScripts",
            "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.SubstituteInFiles"],
        permanent: ["Octopus.Features.WildflyDeployCLI"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\deployToWildflyAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\deployToWildflyAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var actionExecutionLocation_1 = __webpack_require__(37);
var wildflyFeatureTemplate_1 = __webpack_require__(709);
var getFeedName_1 = __webpack_require__(66);
var ActionDetails_1 = __webpack_require__(27);
var ChangeStateInWildflyActionSummary = (function (_super) {
    __extends(ChangeStateInWildflyActionSummary, _super);
    function ChangeStateInWildflyActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    ChangeStateInWildflyActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    ChangeStateInWildflyActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Enable or disable an application in WildFly 10+ or Red Hat JBoss EAP 6+");
    };
    ChangeStateInWildflyActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return ChangeStateInWildflyActionSummary;
}(BaseComponent_1.BaseComponent));
var ChangeStateInWildflyActionEdit = (function (_super) {
    __extends(ChangeStateInWildflyActionEdit, _super);
    function ChangeStateInWildflyActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangeStateInWildflyActionEdit.prototype.render = function () {
        return React.createElement(wildflyFeatureTemplate_1.default, { actionDescription: "Modifying", domainDefaultMessage: "Modifying an application in a domain.", properties: this.props.properties, plugin: this.props.plugin, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, errors: this.props.errors, applicationNameNote: React.createElement("span", null, "This is the name of the deployment to enable or disable."), applicationStateNote: React.createElement("span", null,
                "This option allows you to enable or disable an application deployed to a standalone server. This value has no effect when deploying to domain servers. Set the ",
                React.createElement("em", null, "Standalone or Domain Server"),
                " option to ",
                React.createElement("em", null, "Domain"),
                " to see the ",
                React.createElement("em", null, "Enabled Server Groups"),
                " and ",
                React.createElement("em", null, "Disabled Server Groups"),
                " options, which allow you to configure the state of the application during a deployment to a domain."), applicationServerHostnameNote: React.createElement("span", null, "This is the hostname or IP address of the application server hosting the application to be enabled or disabled.") });
    };
    return ChangeStateInWildflyActionEdit;
}(BaseComponent_1.BaseComponent));
exports.ChangeStateInWildflyActionEdit = ChangeStateInWildflyActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.WildFlyState",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(ChangeStateInWildflyActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: ChangeStateInWildflyActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\changeStateInWildflyAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\changeStateInWildflyAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WildflyStringProperties = {
    "WildFly.Deploy.Port": "",
    "WildFly.Deploy.Controller": "",
    "WildFly.Deploy.User": "",
    "WildFly.Deploy.Protocol": "",
    "WildFly.Deploy.ServerType": "",
    "WildFly.Deploy.DisabledServerGroup": "",
    "WildFly.Deploy.EnabledServerGroup": "",
};
exports.WildflySensitiveStringProperties = {
    "WildFly.Deploy.Password": ""
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\wildflyProperties.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\wildflyProperties.ts"); } } })();

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var wildflyFeatureTemplate_1 = __webpack_require__(709);
var DeplotToWildflyFeature = (function (_super) {
    __extends(DeplotToWildflyFeature, _super);
    function DeplotToWildflyFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeplotToWildflyFeature.prototype.render = function () {
        return React.createElement(wildflyFeatureTemplate_1.default, { actionDescription: "Deploying", domainDefaultMessage: "Deploying an application to a domain.", properties: this.props.properties, plugin: this.props.plugin, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, errors: this.props.errors, projectId: this.props.projectId, applicationNameNote: React.createElement("span", null,
                "This optional field can be used to override the name of the deployed artifact. For example, setting this field to ",
                React.createElement("em", null, "myapp.war"),
                " will result in the deployment being having that name in WildFly regardless of the name of the package that was selected above."), applicationStateNote: React.createElement("span", null,
                "This option allows you to deploy the application in either an enabled or disabled state to a standalone server. This value has no effect when deploying to domain servers. Set the ",
                React.createElement("em", null, "Standalone or Domain Server"),
                " option to ",
                React.createElement("em", null, "Domain"),
                " to see the ",
                React.createElement("em", null, "Enabled Server Groups"),
                " and ",
                React.createElement("em", null, "Disabled Server Groups"),
                " options, which allow you to configure the state of the application during a deployment to a domain."), applicationServerHostnameNote: React.createElement("span", null, "This is the hostname or IP address of the application server that the package will be uploaded to.") });
    };
    return DeplotToWildflyFeature;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.WildflyDeployCLI",
    title: "Wildfly deployment feature",
    description: "Deploys packages to Wildfly via the manager API",
    edit: DeplotToWildflyFeature,
    priority: 1
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\deployToWildflyFeature.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\deployToWildflyFeature.tsx"); } } })();

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var pluginRegistry_1 = __webpack_require__(18);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(37);
var wildflyConnectionDetailsComponent_1 = __webpack_require__(710);
var javaKeystoreComponent_1 = __webpack_require__(711);
var ExpandableFormSection_1 = __webpack_require__(44);
var Note_1 = __webpack_require__(22);
var Text_1 = __webpack_require__(17);
var Summary_1 = __webpack_require__(70);
var FormSectionHeading_1 = __webpack_require__(46);
var wildflyRelativeLocationComponent_1 = __webpack_require__(1965);
var RadioButtonGroup_1 = __webpack_require__(33);
var material_ui_1 = __webpack_require__(92);
var Roles_1 = __webpack_require__(35);
var ActionDetails_1 = __webpack_require__(27);
var DeployCertificateToTomcatActionSummary = (function (_super) {
    __extends(DeployCertificateToTomcatActionSummary, _super);
    function DeployCertificateToTomcatActionSummary(props) {
        return _super.call(this, props) || this;
    }
    DeployCertificateToTomcatActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Configure a certificate in WildFly 10+ or JBoss EAP 6+ standalone server to deployment targets in ",
            React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }));
    };
    return DeployCertificateToTomcatActionSummary;
}(BaseComponent_1.BaseComponent));
var DeployCertificateToTomcatActionEdit = (function (_super) {
    __extends(DeployCertificateToTomcatActionEdit, _super);
    function DeployCertificateToTomcatActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null,
        };
        return _this;
    }
    DeployCertificateToTomcatActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var properties;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var project;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                            case 1:
                                project = _a.sent();
                                this.setState({ project: project });
                                return [2 /*return*/];
                        }
                    });
                }); });
                properties = this.props.properties;
                if (properties["WildFly.Deploy.DeployCertificate"] !== "True" &&
                    properties["WildFly.Deploy.DeployCertificate"] !== "False") {
                    properties["WildFly.Deploy.DeployCertificate"] = "True";
                }
                if (properties["WildFly.Deploy.ServerType"] !== "Standalone" &&
                    properties["WildFly.Deploy.ServerType"] !== "Domain") {
                    properties["WildFly.Deploy.ServerType"] = "Standalone";
                }
                if (!properties["WildFly.Deploy.CertificateRelativeTo"]) {
                    properties["WildFly.Deploy.CertificateRelativeTo"] = "NONE";
                }
                if (!properties["WildFly.Deploy.CertificateProfiles"]) {
                    properties["WildFly.Deploy.CertificateProfiles"] = "default";
                }
                this.props.setProperties(properties);
                return [2 /*return*/];
            });
        });
    };
    DeployCertificateToTomcatActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var serverDetailsErrorKey = "WildFly.Deploy.ServerType|" +
            "Java.Certificate.KeystoreFilename|" +
            "WildFly.Deploy.CertificateRelativeTo|" +
            "Java.Certificate.Password|" +
            "Java.Certificate.KeystoreAlias|" +
            "Java.Certificate.Variable";
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Application Server Details" }),
            React.createElement(wildflyConnectionDetailsComponent_1.default, { properties: this.props.properties, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, errors: this.props.errors, projectId: this.props.projectId, applicationServerHostnameNote: React.createElement("span", null, "This is the hostname or IP address of the application server that the certificate will be configured in."), actionDescription: React.createElement("span", null, "Deploy a certificate via the management interface listening on") }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: serverDetailsErrorKey, title: "Certificate Configuration", summary: this.keystoreSummary(), help: "Specify the certificate details" },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: properties["WildFly.Deploy.ServerType"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.ServerType"] = x, _a));
                        var _a;
                    }, label: "Standalone or domain server" },
                    React.createElement(material_ui_1.RadioButton, { value: "Standalone", label: "Standalone" }),
                    React.createElement(material_ui_1.RadioButton, { value: "Domain", label: "Domain" })),
                React.createElement(Note_1.default, null, "Select the kind of server you are deploying to."),
                properties["WildFly.Deploy.ServerType"] === "Standalone" &&
                    React.createElement("div", null,
                        React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "NONE", value: properties["WildFly.Deploy.DeployCertificate"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.DeployCertificate"] = x, _a));
                                var _a;
                            }, label: "Keystore creation" },
                            React.createElement(material_ui_1.RadioButton, { value: "True", label: "Create a new keystore" }),
                            React.createElement(material_ui_1.RadioButton, { value: "False", label: "Reference an existing keystore" })),
                        properties["WildFly.Deploy.DeployCertificate"] === "True" &&
                            React.createElement(javaKeystoreComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, plugin: this.props.plugin, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, errors: this.props.errors, keystoreFilenameMessage: React.createElement("span", null,
                                    React.createElement("p", null,
                                        "The optional path of the keystore file to create. If defined, this must be an absolute path, the parent directory must exist, and the path must include the keystore filename e.g. ",
                                        React.createElement("em", null, "C:\\Keys\\my.keystore"),
                                        " or ",
                                        React.createElement("em", null, "/opt/server/conf/keys.store"),
                                        "."),
                                    React.createElement("p", null, "If the file exists, it will be overwritten."),
                                    React.createElement("p", null,
                                        "If this value is not defined a new certificate will be created in the application server's ",
                                        React.createElement("em", null, "configuration"),
                                        " directory.")) })),
                properties["WildFly.Deploy.ServerType"] === "Domain" &&
                    React.createElement("div", null,
                        React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.CertificateProfiles"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.CertificateProfiles"] = x, _a));
                                var _a;
                            }, label: "Domain profiles" }),
                        React.createElement(Note_1.default, null, "A comma separated list that defines the domain server groups where the certificate will be configured.")),
                (properties["WildFly.Deploy.ServerType"] === "Domain" ||
                    properties["WildFly.Deploy.DeployCertificate"] !== "True") &&
                    React.createElement(wildflyRelativeLocationComponent_1.default, { properties: this.props.properties, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, errors: this.props.errors })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "AdvancedOptions", title: "Advanced Options", summary: this.advancedSummary(), help: "Specify optional advanced security options" },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.HTTPSPortBindingName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.HTTPSPortBindingName"] = x, _a));
                        var _a;
                    }, label: "HTTPS socket binding name" }),
                React.createElement(Note_1.default, null,
                    "This field defines the port binding that is used to listen to HTTPS requests in the application server. If left blank, it will default to ",
                    React.createElement("em", null, "https"),
                    "."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.SecurityRealmName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.SecurityRealmName"] = x, _a));
                        var _a;
                    }, label: "Legacy security realm name" }),
                React.createElement(Note_1.default, null,
                    "This field defines the name of the security realm that will be created in applicable application servers. If left blank, this value will default to ",
                    React.createElement("em", null, "OctopusHttps"),
                    "."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.ElytronKeystoreName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.ElytronKeystoreName"] = x, _a));
                        var _a;
                    }, label: "Elytron key store name" }),
                React.createElement(Note_1.default, null,
                    "This field defines the name of the the Elytron key store. If left blank, this value will default to ",
                    React.createElement("em", null, "OctopusHttpsKS"),
                    "."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.ElytronKeymanagerName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.ElytronKeymanagerName"] = x, _a));
                        var _a;
                    }, label: "Elytron key manager name" }),
                React.createElement(Note_1.default, null,
                    "This field defines the name of the the Elytron key manager. If left blank, this value will default to ",
                    React.createElement("em", null, "OctopusHttpsKM"),
                    "."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.ElytronSSLContextName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.ElytronSSLContextName"] = x, _a));
                        var _a;
                    }, label: "Elytron server SSL context name" }),
                React.createElement(Note_1.default, null,
                    "This field defines the name of the the Elytron server SSL context. If left blank, this value will default to ",
                    React.createElement("em", null, "OctopusHttpsSSC"),
                    ".")));
    };
    DeployCertificateToTomcatActionEdit.prototype.advancedSummary = function () {
        var properties = this.props.properties;
        var customPortBinding = properties["WildFly.Deploy.HTTPSPortBindingName"] && properties["WildFly.Deploy.HTTPSPortBindingName"] !== "https";
        var customSecurityRealm = properties["WildFly.Deploy.SecurityRealmName"] && properties["WildFly.Deploy.SecurityRealmName"] !== "OctopusHTTPS";
        var customKeystore = properties["WildFly.Deploy.ElytronKeystoreName"] && properties["WildFly.Deploy.ElytronKeystoreName"] !== "octopusHttpsKS";
        var customKeymanager = properties["WildFly.Deploy.ElytronKeymanagerName"] && properties["WildFly.Deploy.ElytronKeymanagerName"] !== "octopusHttpsKM";
        var customSSLContext = properties["WildFly.Deploy.ElytronSSLContextName"] && properties["WildFly.Deploy.ElytronSSLContextName"] !== "octopusHttpsSSC";
        if (customPortBinding ||
            customSecurityRealm ||
            customKeystore ||
            customKeymanager ||
            customSSLContext) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Configuring HTTPS with",
                customPortBinding &&
                    React.createElement("span", null,
                        "\u00A0a port binding called ",
                        React.createElement("strong", null, properties["WildFly.Deploy.HTTPSPortBindingName"])),
                customPortBinding &&
                    React.createElement("span", null, ","),
                customPortBinding && !(customKeystore || customKeymanager || customSSLContext) &&
                    React.createElement("span", null, " and"),
                customSecurityRealm &&
                    React.createElement("span", null,
                        "\u00A0a security realm called ",
                        React.createElement("strong", null, properties["WildFly.Deploy.SecurityRealmName"])),
                (customPortBinding || customSecurityRealm) &&
                    React.createElement("span", null, ","),
                customKeystore && !(customKeymanager || customSSLContext) &&
                    React.createElement("span", null, " and"),
                customKeystore &&
                    React.createElement("span", null,
                        "\u00A0an Elytron KeyStore called ",
                        React.createElement("strong", null, properties["WildFly.Deploy.ElytronKeystoreName"])),
                (customPortBinding || customSecurityRealm || customKeystore) &&
                    React.createElement("span", null, ","),
                customKeymanager && !customSSLContext &&
                    React.createElement("span", null, " and"),
                customKeymanager &&
                    React.createElement("span", null,
                        "\u00A0an Elyton KeyManager called ",
                        React.createElement("strong", null, properties["WildFly.Deploy.ElytronKeymanagerName"])),
                (customPortBinding || customSecurityRealm || customKeystore || customKeymanager) &&
                    React.createElement("span", null, ", and"),
                customSSLContext &&
                    React.createElement("span", null,
                        "\u00A0an Elytron SSL Context called ",
                        React.createElement("strong", null, properties["WildFly.Deploy.ElytronSSLContextName"]))));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define optional advanced security settings."));
    };
    DeployCertificateToTomcatActionEdit.prototype.keystoreSummary = function () {
        var properties = this.props.properties;
        return Summary_1.default.summary(React.createElement("span", null,
            "Deploying to a ",
            properties["WildFly.Deploy.ServerType"],
            " server",
            properties["WildFly.Deploy.ServerType"] === "Standalone" &&
                properties["WildFly.Deploy.DeployCertificate"] === "True" &&
                React.createElement("span", null,
                    "\u00A0creating a new keystore",
                    properties["Java.Certificate.KeystoreFilename"] &&
                        React.createElement("span", null,
                            "\u00A0at ",
                            React.createElement("strong", null, properties["Java.Certificate.KeystoreFilename"])),
                    !properties["Java.Certificate.KeystoreFilename"] &&
                        React.createElement("span", null, "\u00A0in the default location"),
                    properties["Java.Certificate.Password"] &&
                        React.createElement("span", null,
                            "\u00A0with a custom password",
                            properties["Java.Certificate.KeystoreAlias"] &&
                                React.createElement("span", null, "\u00A0and")),
                    properties["Java.Certificate.KeystoreAlias"] &&
                        React.createElement("span", null,
                            "\u00A0with a custom alias ",
                            React.createElement("strong", null, properties["Java.Certificate.KeystoreAlias"]))),
            (properties["WildFly.Deploy.ServerType"] === "Domain" ||
                properties["WildFly.Deploy.DeployCertificate"] !== "True") &&
                React.createElement("span", null,
                    "\u00A0referencing the existing keystore",
                    properties["Java.Certificate.KeystoreFilename"] &&
                        React.createElement("span", null,
                            "\u00A0at\u00A0",
                            properties["WildFly.Deploy.CertificateRelativeTo"] !== "NONE" &&
                                React.createElement("strong", null,
                                    "$",
                                    "{",
                                    properties["WildFly.Deploy.CertificateRelativeTo"],
                                    "}",
                                    "/"),
                            React.createElement("strong", null, properties["Java.Certificate.KeystoreFilename"])))));
    };
    return DeployCertificateToTomcatActionEdit;
}(BaseComponent_1.BaseComponent));
exports.DeployCertificateToTomcatActionEdit = DeployCertificateToTomcatActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.default.AlwaysOnTarget,
    actionType: "Octopus.WildFlyCertificateDeploy",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DeployCertificateToTomcatActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: DeployCertificateToTomcatActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return false; },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\deployCertificate.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\deployCertificate.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var Note_1 = __webpack_require__(22);
var Text_1 = __webpack_require__(17);
var Select_1 = __webpack_require__(41);
var Sensitive_1 = __webpack_require__(82);
/**
 * A component that displays the details of a keystore to reference
 */
var WildflyRelativeLocationComponent = (function (_super) {
    __extends(WildflyRelativeLocationComponent, _super);
    function WildflyRelativeLocationComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WildflyRelativeLocationComponent.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Java.Certificate.KeystoreFilename"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Java.Certificate.KeystoreFilename"] = x, _a));
                    var _a;
                }, label: "Keystore Filename", error: this.props.getFieldError("Java.Certificate.KeystoreFilename") }),
            React.createElement(Note_1.default, null,
                "The path to the existing keystore file. This can be an absolute file path, or can be relative to one of the standard base paths defined by the application server, which can be selected in the ",
                React.createElement("em", null, "Relative base path"),
                " list."),
            React.createElement(Select_1.BoundSelect, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "NONE", value: properties["WildFly.Deploy.CertificateRelativeTo"], items: this.getBasePaths(), label: "Relative base path", onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.CertificateRelativeTo"] = x, _a));
                    var _a;
                } }),
            React.createElement(Note_1.default, null,
                "This defines the relative path that the keystore file will be resolved from. Select ",
                React.createElement("em", null, "No relative path base"),
                " if the keystore filename is an absolute path."),
            React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "", value: properties["Java.Certificate.Password"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Java.Certificate.Password"] = x, _a));
                    var _a;
                }, label: "Private Key Password" }),
            React.createElement(Note_1.default, null,
                "You can set an optional password which will be assigned to the private key. If this field is left blank, the default password of ",
                React.createElement("em", null, "changeit"),
                " will be used."),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Java.Certificate.KeystoreAlias"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Java.Certificate.KeystoreAlias"] = x, _a));
                    var _a;
                }, label: "Keystore Alias" }),
            React.createElement(Note_1.default, null,
                "The optional alias to assign the private key to. If left blank, the default alias of ",
                React.createElement("em", null, "Octopus"),
                " will be used"));
    };
    WildflyRelativeLocationComponent.prototype.getBasePaths = function () {
        var commonItems = [
            { text: "none: Keystore Filename is an absolute path", value: "NONE" },
            { text: "jboss.home.dir: Root directory of the application server distribution", value: "jboss.home.dir" },
            { text: "user.home: Application server user's home directory", value: "user.home" },
            { text: "user.dir: Application server user's current working directory", value: "user.dir" },
            { text: "java.home: Java installation directory", value: "java.home" }
        ];
        if (this.props.properties["WildFly.Deploy.ServerType"] === "Domain") {
            commonItems.push({ text: "jboss.domain.base.dir: Base directory for domain content.", value: "jboss.domain.base.dir" }, { text: "jboss.domain.config.dir: Directory that contains the domain configuration.", value: "jboss.domain.config.dir" }, { text: "jboss.domain.data.dir: Directory that the domain will use for persistent data file storage.", value: "jboss.domain.data.dir" }, { text: "jboss.domain.log.dir: Directory that the domain will use for persistent log file storage.", value: "jboss.domain.log.dir" }, { text: "jboss.domain.temp.dir: Directory that the domain will use for temporary file storage.", value: "jboss.domain.temp.dir" }, { text: "jboss.domain.deployment.dir: Directory that the domain will use for storing deployed content.", value: "jboss.domain.deployment.dir" }, {
                text: "jboss.domain.servers.dir: Directory that the domain will use for storing outputs of the managed domain instances.",
                value: "jboss.domain.servers.dir"
            });
        }
        else {
            commonItems.push({ text: "jboss.server.base.dir: Root directory for an individual server instance", value: "jboss.server.base.dir" }, { text: "jboss.server.config.dir: Directory the server will use for configuration file storage", value: "jboss.server.config.dir" }, { text: "jboss.server.data.dir: Directory the server will use for persistent data file storage", value: "jboss.server.data.dir" }, { text: "jboss.server.log.dir: Directory the server will use for log file storage", value: "jboss.server.log.dir" }, { text: "jboss.server.temp.dir: Directory the server will use for temporary file storage", value: "jboss.server.temp.dir" }, { text: "jboss.controller.temp.dir: Directory the server will use for temporary file storage", value: "jboss.controller.temp.dir" });
        }
        return commonItems;
    };
    return WildflyRelativeLocationComponent;
}(BaseComponent_1.BaseComponent));
exports.default = WildflyRelativeLocationComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\wildflyRelativeLocationComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\wildfly\\wildflyRelativeLocationComponent.tsx"); } } })();

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(37);
var FormSectionHeading_1 = __webpack_require__(46);
var feedResource_1 = __webpack_require__(54);
var InternalLink_1 = __webpack_require__(42);
var ExpandableFormSection_1 = __webpack_require__(44);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(58);
var PackageDownloadOptions_1 = __webpack_require__(135);
var routeLinks_1 = __webpack_require__(20);
var getFeedName_1 = __webpack_require__(66);
var Roles_1 = __webpack_require__(35);
var ActionDetails_1 = __webpack_require__(27);
var DeployToTomcatActionSummary = (function (_super) {
    __extends(DeployToTomcatActionSummary, _super);
    function DeployToTomcatActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    DeployToTomcatActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    DeployToTomcatActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy a Java application to Tomcat 7+ using package  ",
            React.createElement("strong", null,
                this.props.properties[specialVariables_1.default.Action.Package.PackageId],
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, this.getFeedId()),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    DeployToTomcatActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return DeployToTomcatActionSummary;
}(BaseComponent_1.BaseComponent));
var DeployToTomcatActionEdit = (function (_super) {
    __extends(DeployToTomcatActionEdit, _super);
    function DeployToTomcatActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feeds: []
        };
        return _this;
    }
    DeployToTomcatActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var feeds, properties;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        feeds = _a.sent();
                        this.setState({ feeds: feeds });
                        properties = {};
                        properties["Octopus.Features.TomcatDeployManager"] = "True";
                        if (!this.props.properties["Octopus.Action.Package.FeedId"]) {
                            properties["Octopus.Action.Package.FeedId"] = feedResource_1.BuiltInFeedId;
                        }
                        this.props.setProperties(properties, true);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DeployToTomcatActionEdit.prototype.render = function () {
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to deploy a package to one or more machines which may be sourced from an external feed or the Octopus built-in feed. You can configure the remote machines to deploy to in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.infrastructure.root, openInSelf: false }, "Infrastructure"),
                " tab.")
            : React.createElement("span", null, "Choose the package you wish to deploy");
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Package Details" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(this.props.properties, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, errors: this.props.errors, localNames: this.props.localNames, feedType: [feedResource_1.FeedType.Nuget, feedResource_1.FeedType.Maven] }),
                React.createElement(PackageDownloadOptions_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, errors: this.props.errors, localNames: this.props.localNames })));
    };
    return DeployToTomcatActionEdit;
}(BaseComponent_1.BaseComponent));
exports.DeployToTomcatActionEdit = DeployToTomcatActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.TomcatDeploy",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DeployToTomcatActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: DeployToTomcatActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.CustomScripts",
            "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.SubstituteInFiles"],
        permanent: ["Octopus.Features.TomcatDeployManager"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\tomcat\\deployToTomcatAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\tomcat\\deployToTomcatAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var actionExecutionLocation_1 = __webpack_require__(37);
var tomcatFeatureTemplate_1 = __webpack_require__(712);
var getFeedName_1 = __webpack_require__(66);
var Roles_1 = __webpack_require__(35);
var ActionDetails_1 = __webpack_require__(27);
var ChangeStateInTomcatActionSummary = (function (_super) {
    __extends(ChangeStateInTomcatActionSummary, _super);
    function ChangeStateInTomcatActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    ChangeStateInTomcatActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    ChangeStateInTomcatActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Change the state of an application in Tomcat 7+ ",
            this.props.targetRolesAsCSV &&
                React.createElement("span", null,
                    " to deployment targets in ",
                    React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                    " "));
    };
    ChangeStateInTomcatActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return ChangeStateInTomcatActionSummary;
}(BaseComponent_1.BaseComponent));
var ChangeStateInTomcatActionEdit = (function (_super) {
    __extends(ChangeStateInTomcatActionEdit, _super);
    function ChangeStateInTomcatActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangeStateInTomcatActionEdit.prototype.render = function () {
        var properties = this.props.properties;
        return React.createElement(tomcatFeatureTemplate_1.default, { properties: this.props.properties, plugin: this.props.plugin, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, errors: this.props.errors });
    };
    return ChangeStateInTomcatActionEdit;
}(BaseComponent_1.BaseComponent));
exports.ChangeStateInTomcatActionEdit = ChangeStateInTomcatActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.TomcatState",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(ChangeStateInTomcatActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: ChangeStateInTomcatActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\tomcat\\changeStateInTomcatAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\tomcat\\changeStateInTomcatAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1969);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".style_nowrap__3WQwQ{white-space:nowrap}", ""]);

// exports
exports.locals = {
	"nowrap": "style_nowrap__3WQwQ"
};

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var tomcatFeatureTemplate_1 = __webpack_require__(712);
var DeployToTomcatFeature = (function (_super) {
    __extends(DeployToTomcatFeature, _super);
    function DeployToTomcatFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeployToTomcatFeature.prototype.render = function () {
        return React.createElement(tomcatFeatureTemplate_1.default, { projectId: this.props.projectId, properties: this.props.properties, plugin: this.props.plugin, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, errors: this.props.errors });
    };
    return DeployToTomcatFeature;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.TomcatDeployManager",
    title: "Tomcat deployment feature",
    description: "Deploys packages to Tomcat via the manager API",
    edit: DeployToTomcatFeature,
    priority: 1
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\tomcat\\deployToTomcatFeature.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\tomcat\\deployToTomcatFeature.tsx"); } } })();

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(14);
var pluginRegistry_1 = __webpack_require__(18);
var ExpandableFormSection_1 = __webpack_require__(44);
var Summary_1 = __webpack_require__(70);
var Text_1 = __webpack_require__(17);
var CertificateVariableSelect_1 = __webpack_require__(165);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(37);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var Note_1 = __webpack_require__(22);
var Sensitive_1 = __webpack_require__(82);
var Roles_1 = __webpack_require__(35);
var ActionDetails_1 = __webpack_require__(27);
var DeployCertificateToTomcatActionSummary = (function (_super) {
    __extends(DeployCertificateToTomcatActionSummary, _super);
    function DeployCertificateToTomcatActionSummary(props) {
        return _super.call(this, props) || this;
    }
    DeployCertificateToTomcatActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy a certificate to Tomcat 7+ to deployment targets in ",
            React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }));
    };
    return DeployCertificateToTomcatActionSummary;
}(BaseComponent_1.BaseComponent));
var DeployCertificateToTomcatActionEdit = (function (_super) {
    __extends(DeployCertificateToTomcatActionEdit, _super);
    function DeployCertificateToTomcatActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null
        };
        return _this;
    }
    DeployCertificateToTomcatActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var properties;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var project;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                            case 1:
                                project = _a.sent();
                                this.setState({ project: project });
                                return [2 /*return*/];
                        }
                    });
                }); });
                properties = this.props.properties;
                if (!properties["Tomcat.Certificate.Service"]) {
                    properties["Tomcat.Certificate.Service"] = "Catalina";
                }
                if (!properties["Tomcat.Certificate.Implementation"]) {
                    properties["Tomcat.Certificate.Implementation"] = "NIO";
                }
                if (!properties["Tomcat.Certificate.Default"]) {
                    properties["Tomcat.Certificate.Default"] = "False";
                }
                this.props.setProperties(properties);
                return [2 /*return*/];
            });
        });
    };
    DeployCertificateToTomcatActionEdit.prototype.tomcatLocationSummary = function () {
        if (this.props.properties["Tomcat.Certificate.CatalinaHome"]) {
            /*
                Guess the path splitter based on the kinds of slashes that exist in
                the base location
             */
            var pathSplit = this.props.properties["Tomcat.Certificate.CatalinaHome"].indexOf("/") !== -1
                ? "/" : "\\";
            return Summary_1.default.summary(React.createElement("span", null,
                "Adding the certificate to the ",
                React.createElement("strong", null,
                    this.props.properties["Tomcat.Certificate.CatalinaBase"] ||
                        this.props.properties["Tomcat.Certificate.CatalinaHome"],
                    pathSplit,
                    "config",
                    pathSplit,
                    "server.xml"),
                " configuration file"));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the CATALINA_BASE directory"));
    };
    DeployCertificateToTomcatActionEdit.prototype.tomcatCertificateSummary = function () {
        if (this.props.properties["Java.Certificate.Variable"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Deploying the ",
                this.props.properties["Java.Certificate.Variable"],
                " certificate",
                this.props.properties["Tomcat.Certificate.Service"] &&
                    React.createElement("span", null,
                        " to the service named ",
                        React.createElement("strong", null, this.props.properties["Tomcat.Certificate.Service"])),
                this.props.properties["Tomcat.Certificate.Port"] &&
                    React.createElement("span", null,
                        " under the connector listening on port ",
                        React.createElement("strong", null, this.props.properties["Tomcat.Certificate.Port"])),
                this.props.properties["Tomcat.Certificate.Hostname"] &&
                    React.createElement("span", null,
                        " configured with the SNI hostname ",
                        React.createElement("strong", null, this.props.properties["Tomcat.Certificate.Hostname"]))));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the certificate to deploy"));
    };
    DeployCertificateToTomcatActionEdit.prototype.tomcatSNISummary = function () {
        if (this.props.properties["Tomcat.Certificate.Hostname"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Mapping certificate to the ",
                this.props.properties["Tomcat.Certificate.Hostname"],
                " host name"));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Map a certificate to a host name (Tomcat 8.5+ only)"));
    };
    DeployCertificateToTomcatActionEdit.prototype.tomcatOptionsSummary = function () {
        if (this.props.properties["Java.Certificate.Password"] ||
            this.props.properties["Tomcat.Certificate.PrivateKeyFilename"] ||
            this.props.properties["Tomcat.Certificate.PublicKeyFilename"] ||
            this.props.properties["Java.Certificate.KeystoreFilename"] ||
            this.props.properties["Java.Certificate.KeystoreAlias"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Deploying the certificate",
                (this.props.properties["Tomcat.Certificate.PrivateKeyFilename"] ||
                    this.props.properties["Tomcat.Certificate.PublicKeyFilename"] ||
                    this.props.properties["Java.Certificate.KeystoreFilename"]) &&
                    React.createElement("span", null, " to a custom location"),
                this.props.properties["Java.Certificate.Password"] &&
                    React.createElement("span", null,
                        " with a custom password",
                        this.props.properties["Java.Certificate.KeystoreAlias"] &&
                            React.createElement("span", null, " and")),
                this.props.properties["Java.Certificate.KeystoreAlias"] &&
                    React.createElement("span", null, " with a custom alias")));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the optional certificate properties"));
    };
    DeployCertificateToTomcatActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var serverDetailsErrorKey = "Tomcat.Certificate.CatalinaHome|" +
            "Tomcat.Certificate.CatalinaBase";
        var certificateDetailsErrorKey = "Java.Certificate.Variable|" +
            "Tomcat.Certificate.Service|" +
            "Tomcat.Certificate.Implementation|" +
            "Tomcat.Certificate.Port";
        return React.createElement("div", null,
            React.createElement(ExpandableFormSection_1.default, { errorKey: serverDetailsErrorKey, title: "Tomcat Location", summary: this.tomcatLocationSummary(), help: "Specify the path to the Tomcat CATALINA_HOME and CATALINA_BASE directories" },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.CatalinaHome"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.CatalinaHome"] = x, _a));
                        var _a;
                    }, label: "Tomcat CATALINA_HOME path", error: this.props.getFieldError("Tomcat.Certificate.CatalinaHome") }),
                React.createElement(Note_1.default, null, "This is the root directory of the \"binary\" distribution of Tomcat."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.CatalinaBase"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.CatalinaBase"] = x, _a));
                        var _a;
                    }, label: "Tomcat CATALINA_BASE path", error: this.props.getFieldError("Java.Certificate.TomcatLocation") }),
                React.createElement(Note_1.default, null, "This is the root directory of the \"active configuration\" of Tomcat. This can be left blank if the Tomcat root directory CATALINA_HOME directory also holds the configuration (i.e. leave this blank if the CATALINA_HOME and CATALINA_BASE directories are the same).")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: certificateDetailsErrorKey, title: "Tomcat Certificate", summary: this.tomcatCertificateSummary(), help: "Specify the details of the certificate to install" },
                this.props.projectId
                    ? React.createElement(CertificateVariableSelect_1.BoundCertificateVariableSelect, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "", doBusyTask: this.props.doBusyTask, projectId: this.props.projectId, value: this.props.properties["Java.Certificate.Variable"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Java.Certificate.Variable"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Java.Certificate.Variable"), allowClear: true })
                    : React.createElement(Text_1.VariableLookupText, { label: "Certificate variable", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Java.Certificate.Variable"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Java.Certificate.Variable"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Java.Certificate.Variable") }),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.Service"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.Service"] = x, _a));
                        var _a;
                    }, label: "Tomcat service name", error: this.props.getFieldError("Tomcat.Certificate.Service") }),
                React.createElement(Note_1.default, null,
                    "This is the name of the Service element in the server.xml file e.g. ",
                    "<",
                    "Service name=\"Catalina\"",
                    ">",
                    "."),
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "NIO", value: properties["Tomcat.Certificate.Implementation"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.Implementation"] = x, _a));
                        var _a;
                    }, label: "SSL implementation" },
                    React.createElement(RadioButton_1.default, { value: "BIO", label: "Blocking IO (BIO - Tomcat 8 and below only)" }),
                    React.createElement(RadioButton_1.default, { value: "NIO", label: "Non-Blocking IO (NIO)" }),
                    React.createElement(RadioButton_1.default, { value: "NIO2", label: "Non-Blocking IO 2 (NIO2 - Tomcat 8 and above only)" }),
                    React.createElement(RadioButton_1.default, { value: "APR", label: "Apache Portable Runtime (APR)" })),
                React.createElement(Note_1.default, null, "These are the standard implementations provided by Tomcat to support HTTPS. Note that not all versions of Tomcat support all implementations."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.Port"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.Port"] = x, _a));
                        var _a;
                    }, label: "HTTPS port", error: this.props.getFieldError("Tomcat.Certificate.Port") }),
                React.createElement(Note_1.default, null, "This is the HTTPS port that this certificate will be bound to.")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "tomcatSNIOptions", title: "Tomcat SNI Options (Tomcat 8.5+ only)", summary: this.tomcatSNISummary(), help: "Specify the SNI details" },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.Hostname"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.Hostname"] = x, _a));
                        var _a;
                    }, label: "Certificate SNI hostname" }),
                React.createElement(Note_1.default, null, "In Tomcat 8.5 and above certificates can be bound to a host name using SNI. This field defines the host name that this certificate is bound to. Leave this field blank when deploying to Tomcat 7 or 8. If you leave this field blank when deploying to Tomcat 8.5 and above, the certificate will be assigned a default host name by Tomcat."),
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Tomcat.Certificate.Default"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.Default"] = x, _a));
                        var _a;
                    }, label: "Default certificate" },
                    React.createElement(RadioButton_1.default, { value: "True", label: "Make this the default certificate" }),
                    React.createElement(RadioButton_1.default, { value: "False", label: "Leave this certificate's default status unchanged" })),
                React.createElement(Note_1.default, null,
                    "In Tomcat 8.5 and above a certificate can be designated as the default one to respond to any request to a host that does not have a specific certificate assigned. Selecting ",
                    React.createElement("em", null, "Make this the default certificate"),
                    " will configure the certificate to be the default one. This field has no effect when deploying to Tomcat 7 or Tomcat 8.")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "tomcatCertificateOptions", title: "Tomcat Certificate Options", summary: this.tomcatOptionsSummary(), help: "Specify the optional certificate details" },
                React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Java.Certificate.Password"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Java.Certificate.Password"] = x, _a));
                        var _a;
                    }, label: "Private key password" }),
                React.createElement(Note_1.default, null, "You can set an optional password which will be assigned to the private key. If this field is left blank, the default password defined by Tomcat will be used where possible, or the private key will remain unencrypted."),
                this.props.properties["Tomcat.Certificate.Implementation"] === "APR" &&
                    React.createElement("div", null,
                        React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.PrivateKeyFilename"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.PrivateKeyFilename"] = x, _a));
                                var _a;
                            }, label: "Private key filename" }),
                        React.createElement(Note_1.default, null,
                            "You can optionally set the path of the private key that will be generated when configuring the APR implementation. If this file exists it will be overwritten. If this field is left blank a new file will be created in the Tomcat ",
                            React.createElement("em", null, "conf"),
                            " directory."),
                        React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.PublicKeyFilename"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.PublicKeyFilename"] = x, _a));
                                var _a;
                            }, label: "Public key filename" }),
                        React.createElement(Note_1.default, null,
                            "You can optionally set the path of the public key that will be generated when configuring the APR implementation. If this file exists it will be overwritten. If this field is left blank a new file will be created in the Tomcat ",
                            React.createElement("em", null, "conf"),
                            " directory.")),
                this.props.properties["Tomcat.Certificate.Implementation"] !== "APR" &&
                    React.createElement("div", null,
                        React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Java.Certificate.KeystoreFilename"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Java.Certificate.KeystoreFilename"] = x, _a));
                                var _a;
                            }, label: "Keystore filename" }),
                        React.createElement(Note_1.default, null,
                            React.createElement("p", null,
                                "You can optionally set the path of the keystore that will be generated when configuring the BIO, NIO and NIO2 implementations. If this file exists it will be overwritten. If this field is left blank a keystore file will be created in the Tomcat ",
                                React.createElement("em", null, "conf"),
                                " directory."),
                            React.createElement("p", null, "If the specified file exists it will be overwritten.")),
                        React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Java.Certificate.KeystoreAlias"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Java.Certificate.KeystoreAlias"] = x, _a));
                                var _a;
                            }, label: "Keystore alias" }),
                        React.createElement(Note_1.default, null,
                            "You can optionally set the alias under which the certificate information will be stored when configuring the BIO, NIO and NIO2 implementations. If this field is left blank the default alias of ",
                            React.createElement("em", null, "octopus"),
                            " will be used."))));
    };
    return DeployCertificateToTomcatActionEdit;
}(BaseComponent_1.BaseComponent));
exports.DeployCertificateToTomcatActionEdit = DeployCertificateToTomcatActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.default.AlwaysOnTarget,
    actionType: "Octopus.TomcatDeployCertificate",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DeployCertificateToTomcatActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: DeployCertificateToTomcatActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return false; },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\tomcat\\deployCertificate.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\tomcat\\deployCertificate.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(37);
var FormSectionHeading_1 = __webpack_require__(46);
var feedResource_1 = __webpack_require__(54);
var InternalLink_1 = __webpack_require__(42);
var ExpandableFormSection_1 = __webpack_require__(44);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(58);
var PackageDownloadOptions_1 = __webpack_require__(135);
var Text_1 = __webpack_require__(17);
var Note_1 = __webpack_require__(22);
var Summary_1 = __webpack_require__(70);
var StringCheckbox_1 = __webpack_require__(38);
var routeLinks_1 = __webpack_require__(20);
var getFeedName_1 = __webpack_require__(66);
var Roles_1 = __webpack_require__(35);
var ActionDetails_1 = __webpack_require__(27);
var DeployJavaPackageActionSummary = (function (_super) {
    __extends(DeployJavaPackageActionSummary, _super);
    function DeployJavaPackageActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    DeployJavaPackageActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    DeployJavaPackageActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy a Java package ",
            React.createElement("strong", null,
                this.props.properties[specialVariables_1.default.Action.Package.PackageId],
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, this.getFeedId()),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    DeployJavaPackageActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return DeployJavaPackageActionSummary;
}(BaseComponent_1.BaseComponent));
var DeployJavaPackageActionEdit = (function (_super) {
    __extends(DeployJavaPackageActionEdit, _super);
    function DeployJavaPackageActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feeds: []
        };
        return _this;
    }
    DeployJavaPackageActionEdit.prototype.deploymentSummary = function () {
        var properties = this.props.properties;
        return Summary_1.default.summary(React.createElement("span", null,
            "Deploying the",
            properties["Octopus.Action.JavaArchive.DeployExploded"] === "True" &&
                React.createElement("span", null, "\u00A0exploded"),
            "\u00A0package",
            properties["Octopus.Action.Package.CustomPackageFileName"] &&
                React.createElement("span", null,
                    "\u00A0named ",
                    React.createElement("strong", null, properties["Octopus.Action.Package.CustomPackageFileName"])),
            properties["Octopus.Action.Package.UseCustomInstallationDirectory"] === "True" &&
                React.createElement("span", null,
                    "\u00A0to ",
                    React.createElement("strong", null, properties["Octopus.Action.Package.CustomInstallationDirectory"])),
            properties["Octopus.Action.Package.UseCustomInstallationDirectory"] === "False" &&
                React.createElement("span", null, "\u00A0to the default location"),
            properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] === "True" &&
                properties["Octopus.Action.Package.UseCustomInstallationDirectory"] === "True" &&
                React.createElement("span", null,
                    "\u00A0purging the destination",
                    properties["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"] &&
                        React.createElement("span", null, "\u00A0with exclusions"))));
    };
    DeployJavaPackageActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var feeds, properties;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        feeds = _a.sent();
                        this.setState({ feeds: feeds });
                        properties = {};
                        if (this.props.properties["Octopus.Action.Package.CustomInstallationDirectory"]) {
                            properties["Octopus.Action.Package.UseCustomInstallationDirectory"] = "True";
                        }
                        else if (this.props.properties["Octopus.Action.Package.UseCustomInstallationDirectory"] !== "True" &&
                            this.props.properties["Octopus.Action.Package.UseCustomInstallationDirectory"] !== "False") {
                            properties["Octopus.Action.Package.UseCustomInstallationDirectory"] = "False";
                        }
                        if (this.props.properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] !== "True" &&
                            this.props.properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] !== "False") {
                            properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] = "False";
                        }
                        if (!this.props.properties["Octopus.Action.JavaArchive.DeployExploded"]) {
                            properties["Octopus.Action.JavaArchive.DeployExploded"] = "False";
                        }
                        if (!this.props.properties["Octopus.Action.Package.FeedId"]) {
                            properties["Octopus.Action.Package.FeedId"] = feedResource_1.BuiltInFeedId;
                        }
                        this.props.setProperties(properties, true);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DeployJavaPackageActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to deploy a Java archive (.jar, .war, .ear) to one or more machines. You can configure the remote machines to deploy to in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.infrastructure.root, openInSelf: false }, "Infrastructure"),
                " tab.")
            : React.createElement("span", null, "Choose the package you wish to deploy");
        var deploymentErrorKey = "Octopus.Action.JavaArchive.DeployExploded|"
            + "Octopus.Action.Package.CustomPackageFileName|"
            + "Octopus.Action.Package.UseCustomInstallationDirectory|"
            + "Octopus.Action.Package.CustomInstallationDirectory|"
            + "Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment|"
            + "Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions";
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Package Details" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(this.props.properties, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors, feedType: [feedResource_1.FeedType.Nuget, feedResource_1.FeedType.Maven] }),
                React.createElement(PackageDownloadOptions_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, localNames: this.props.localNames, errors: this.props.errors })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: deploymentErrorKey, title: "Deployment", summary: this.deploymentSummary(), help: React.createElement("span", null, "Choose how and where the package will be deployed.") },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: properties["Octopus.Action.JavaArchive.DeployExploded"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.JavaArchive.DeployExploded"] = x, _a));
                        var _a;
                    }, label: "Deploy the extracted package", note: React.createElement("span", null, " If selected, the package will be deployed extracted.") }),
                React.createElement(Note_1.default, null,
                    React.createElement("p", null, "Note: The package is always extracted as part of the deployment process, to allow features such as substituting variables in files. By default the package is re-created before deploying to the destination. If the option above is selected it remains extracted.")),
                properties["Octopus.Action.JavaArchive.DeployExploded"] === "False" &&
                    React.createElement("div", null,
                        React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.CustomPackageFileName"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomPackageFileName"] = x, _a));
                                var _a;
                            }, label: "Deployed package file name" }),
                        React.createElement(Note_1.default, null, "The optional filename of the copied package. If left blank, the original filename from the feed will be retained.")),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: properties["Octopus.Action.Package.UseCustomInstallationDirectory"], onChange: function (x) {
                        _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.UseCustomInstallationDirectory"] = x, _a));
                        if (properties["Octopus.Action.Package.UseCustomInstallationDirectory"] !== "True") {
                            _this.props.setProperties((_b = {}, _b["Octopus.Action.Package.CustomInstallationDirectory"] = "", _b));
                        }
                        var _a, _b;
                    }, label: "Use custom deployment directory", note: React.createElement("span", null, "By default the package will be deployed to the target's application directory. This options allows setting a custom deployment directory.") }),
                properties["Octopus.Action.Package.UseCustomInstallationDirectory"] === "True" &&
                    React.createElement("div", null,
                        React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.CustomInstallationDirectory"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomInstallationDirectory"] = x, _a));
                                var _a;
                            }, label: "Deploy Directory" }),
                        React.createElement(Note_1.default, null, "The installed package will be copied to this location on the remote machine."),
                        React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "False", value: properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] = x, _a));
                                var _a;
                            }, label: "Purge" }),
                        React.createElement(Note_1.default, null, "Before the installed package is copied, all files in this location will be removed."),
                        properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] === "True" &&
                            React.createElement("div", null,
                                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"], onChange: function (x) {
                                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"] = x, _a));
                                        var _a;
                                    }, label: "Exclude from purge", multiLine: true, rows: 5 }),
                                React.createElement(Note_1.default, null,
                                    "A newline-separated list of file or directory names, relative to the installation directory, to leave when it is purged. To exclude a whole directory, specify it by name without a wildcard. Extended wildcard syntax is supported. E.g., ",
                                    React.createElement("em", null, "appsettings.config"),
                                    ", ",
                                    React.createElement("em", null, "Config"),
                                    ",",
                                    React.createElement("em", null, "Config\\*.config"),
                                    ", ",
                                    React.createElement("em", null, "**\\*.config"))))));
    };
    return DeployJavaPackageActionEdit;
}(BaseComponent_1.BaseComponent));
exports.DeployJavaPackageActionEdit = DeployJavaPackageActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.JavaArchive",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DeployJavaPackageActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: DeployJavaPackageActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.CustomScripts",
            "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.SubstituteInFiles"],
        initial: ["Octopus.Features.SubstituteInFiles"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\javaPackage\\javaPackageAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\javaPackage\\javaPackageAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(37);
var javaKeystoreComponent_1 = __webpack_require__(711);
var FormSectionHeading_1 = __webpack_require__(46);
var ExpandableFormSection_1 = __webpack_require__(44);
var Summary_1 = __webpack_require__(70);
var Roles_1 = __webpack_require__(35);
var ActionDetails_1 = __webpack_require__(27);
var JavaKeystoreActionSummary = (function (_super) {
    __extends(JavaKeystoreActionSummary, _super);
    function JavaKeystoreActionSummary(props) {
        return _super.call(this, props) || this;
    }
    JavaKeystoreActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy a Java keystore to the target filesystem to deployment targets in ",
            React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }));
    };
    return JavaKeystoreActionSummary;
}(BaseComponent_1.BaseComponent));
var JavaKeystoreActionEdit = (function (_super) {
    __extends(JavaKeystoreActionEdit, _super);
    function JavaKeystoreActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null
        };
        return _this;
    }
    JavaKeystoreActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        project = _a.sent();
                        this.setState({ project: project });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    JavaKeystoreActionEdit.prototype.render = function () {
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Keystore details" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Java.Certificate.Variable|Java.Certificate.KeystoreFilename", title: "Keystore Details", summary: this.keystoreSummary(), help: "Specify the keystore details" },
                React.createElement(javaKeystoreComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, plugin: this.props.plugin, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, errors: this.props.errors, keystoreFilenameMessage: React.createElement("span", null,
                        React.createElement("p", null,
                            "The path of the keystore file to create. This must be an absolute path, the parent directory must exist, and the path must include the keystore filename e.g. ",
                            React.createElement("em", null, "C:\\Keys\\my.keystore"),
                            " or ",
                            React.createElement("em", null, "/opt/server/conf/keys.store"),
                            "."),
                        React.createElement("p", null, "If the file exists, it will be overwritten.")) })));
    };
    JavaKeystoreActionEdit.prototype.keystoreSummary = function () {
        var properties = this.props.properties;
        if (properties["Java.Certificate.Variable"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Deploying certificate referenced by the ",
                React.createElement("strong", null, properties["Java.Certificate.Variable"]),
                " variable",
                properties["Java.Certificate.KeystoreFilename"] &&
                    React.createElement("span", null,
                        "\u00A0to the file ",
                        React.createElement("strong", null, properties["Java.Certificate.KeystoreFilename"])),
                properties["Java.Certificate.Password"] &&
                    React.createElement("span", null, "\u00A0with a custom password"),
                !properties["Java.Certificate.Password"] &&
                    React.createElement("span", null, "\u00A0with the default password"),
                properties["Java.Certificate.KeystoreAlias"] &&
                    React.createElement("span", null,
                        "\u00A0and with the alias ",
                        React.createElement("strong", null, properties["Java.Certificate.KeystoreAlias"])),
                !properties["Java.Certificate.KeystoreAlias"] &&
                    React.createElement("span", null, "\u00A0and with the default alias")));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the keystore details"));
    };
    return JavaKeystoreActionEdit;
}(BaseComponent_1.BaseComponent));
exports.JavaKeystoreActionEdit = JavaKeystoreActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.JavaDeployCertificate",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(JavaKeystoreActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: JavaKeystoreActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\javaKeystore\\javaKeystoreAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\javaKeystore\\javaKeystoreAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var resources_1 = __webpack_require__(26);
var FormSectionHeading_1 = __webpack_require__(46);
var form_1 = __webpack_require__(15);
var awsLoginComponent_1 = __webpack_require__(208);
var CodeEditor_1 = __webpack_require__(119);
var CommonSummaryHelper_1 = __webpack_require__(62);
var ExpandableFormSection_1 = __webpack_require__(44);
var Note_1 = __webpack_require__(22);
var RadioButton_1 = __webpack_require__(36);
var OpenDialogButton_1 = __webpack_require__(74);
var PackageSelector_1 = __webpack_require__(58);
var RadioButtonGroup_1 = __webpack_require__(33);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(35);
var awsTemplateHelper_1 = __webpack_require__(1975);
var ActionDetails_1 = __webpack_require__(27);
var DynamicForm_1 = __webpack_require__(467);
var Text_1 = __webpack_require__(17);
var StringCheckbox_1 = __webpack_require__(38);
var ExternalLink_1 = __webpack_require__(29);
var sourceCodeDialog_1 = __webpack_require__(713);
var AwsCloudFormationActionSummary = (function (_super) {
    __extends(AwsCloudFormationActionSummary, _super);
    function AwsCloudFormationActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AwsCloudFormationActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy an AWS CloudFormation template",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return AwsCloudFormationActionSummary;
}(BaseComponent_1.BaseComponent));
var AwsCloudFormationActionEdit = (function (_super) {
    __extends(AwsCloudFormationActionEdit, _super);
    function AwsCloudFormationActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feeds: [],
            accounts: []
        };
        _this.parameterValues = {};
        _this.parameters = {};
        _this.source = { octopus: "octopus" };
        return _this;
    }
    AwsCloudFormationActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!this.props.properties["Octopus.Action.Aws.WaitForCompletion"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.Aws.WaitForCompletion"] = "True", _c), true);
                        }
                        if (!this.props.properties["Octopus.Action.Aws.AssumeRole"]) {
                            this.props.setProperties((_d = {}, _d["Octopus.Action.Aws.AssumeRole"] = "False", _d), true);
                        }
                        if (!this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"]) {
                            this.props.setProperties((_e = {}, _e["Octopus.Action.AwsAccount.UseInstanceRole"] = "False", _e), true);
                        }
                        if (!this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParameters"]) {
                            this.props.setProperties((_f = {}, _f["Octopus.Action.Aws.CloudFormationTemplateParameters"] = "", _f), true);
                        }
                        // If CloudFormationTemplateParametersRaw isn't set, default it to the value of
                        // CloudFormationTemplateParameters. This accounts for cases where people have
                        // populated CloudFormationTemplateParameters and upgraded to an Octopus version that
                        // expects the UI input to be saved in CloudFormationTemplateParametersRaw.
                        if (!this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"]) {
                            this.props.setProperties((_g = {},
                                _g["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"] = this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParameters"],
                                _g), true);
                        }
                        this.props.setProperties((_h = {}, _h["Octopus.Action.Aws.CloudFormationAction"] = "Deploy", _h), true);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _b.feeds = _j.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 2:
                        _a.apply(this, [(_b.accounts = _j.sent(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AwsCloudFormationActionEdit.prototype.componentWillMount = function () {
        if (this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"] &&
            this.props.properties["Octopus.Action.Aws.TemplateSource"] === "Inline") {
            this.refreshParametersFromTemplate(this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"]);
        }
    };
    AwsCloudFormationActionEdit.prototype.templateSourceSummary = function () {
        var source = this.props.properties["Octopus.Action.Aws.TemplateSource"];
        if (source === "Inline") {
            return form_1.Summary.summary("Source code");
        }
        if (source === "Package") {
            return form_1.Summary.summary("File inside a package");
        }
        return form_1.Summary.placeholder("Template source not specified");
    };
    AwsCloudFormationActionEdit.prototype.pathsSummary = function () {
        var summary = [];
        (this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"])
            ? summary.push(React.createElement("span", null,
                "Using the template in ",
                React.createElement("strong", null, this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"])))
            : summary.push(React.createElement("span", null,
                " ",
                React.createElement("em", null, "no template path specified")));
        (this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"])
            ? summary.push(React.createElement("span", null,
                " with the parameters in ",
                React.createElement("strong", null, this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"])))
            : summary.push(React.createElement("span", null,
                " ",
                React.createElement("em", null, "no parameters path specified")));
        return form_1.Summary.summary(React.Children.toArray(summary));
    };
    AwsCloudFormationActionEdit.prototype.onChangeTemplateSource = function (value) {
        this.props.setProperties((_a = {},
            _a["Octopus.Action.Aws.TemplateSource"] = value,
            _a["Octopus.Action.Aws.CloudFormationTemplate"] = "",
            _a["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"] = "",
            _a["Octopus.Action.Aws.CloudFormationTemplateParameters"] = "",
            _a));
        var _a;
    };
    AwsCloudFormationActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "AWS" }),
            React.createElement(awsLoginComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, plugin: this.props.plugin, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, errors: this.props.errors }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.Region|Octopus.Action.Aws.CloudFormationStackName", title: "CloudFormation", summary: this.cloudFormationSummary(), help: "Specify the details of the CloudFormation stack" },
                React.createElement(Text_1.VariableLookupText, { label: "Region", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.Region"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.Region"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.Region") }),
                React.createElement(Note_1.default, null,
                    "View the ",
                    React.createElement(ExternalLink_1.default, { href: "AWSRegions" }, "AWS Regions and Endpoints"),
                    " documentation for a current list of the available region codes."),
                React.createElement(Text_1.VariableLookupText, { label: "CloudFormation stack name", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.CloudFormationStackName"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.CloudFormationStackName"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.CloudFormationStackName") }),
                React.createElement(form_1.StringRadioButtonGroup, { label: "IAM Capabilities", value: properties["Octopus.Action.Aws.IamCapabilities"] || "NONE", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.IamCapabilities"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "NONE", label: "No additional capabilities", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "CAPABILITY_IAM", label: "The template has IAM resources (CAPABILITY_IAM)" }),
                    React.createElement(RadioButton_1.default, { value: "CAPABILITY_NAMED_IAM", label: "The template has IAM resources with custom names (CAPABILITY_NAMED_IAM)" })),
                React.createElement(Note_1.default, null,
                    "Additional capabilities are required for templates that have IAM resources or named IAM resources. Refer to the ",
                    React.createElement(ExternalLink_1.default, { href: "AwsDocsControllingIAM" }, "AWS documentation"),
                    " for more information."),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { resetValue: "False", value: properties["Octopus.Action.Aws.DisableRollback"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.DisableRollback"] = x, _a));
                        var _a;
                    }, label: "Disable rollback" }),
                React.createElement(Note_1.default, null, "Select this checkbox to disable the automatic rollback of a CloudFormation stack if it failed to be created successfully. This has no effect if the stack exists and is being updated."),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { resetValue: "True", value: properties["Octopus.Action.Aws.WaitForCompletion"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.WaitForCompletion"] = x, _a));
                        var _a;
                    }, label: "Wait for completion" }),
                React.createElement(Note_1.default, null, "Select this checkbox to force the step to wait until the CloudFormation stack has been completed before getting the outputs and finishing the step. Be aware that unselecting this option can mean that no output variables are created, or that output variables may contain outdated values, as the CloudFormation outputs may not have been created or updated before this step completed. Unselecting this option also means the step will not indicate an error if the stack was rolled back during deployment.")),
            React.createElement(FormSectionHeading_1.default, { title: "Template" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.TemplateSource|Octopus.Action.Aws.CloudFormationTemplate", title: "Template Source", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, summary: this.templateSourceSummary(), help: "Select the source of the template." },
                React.createElement(Note_1.default, null, "Templates can be entered as source-code, or contained in a package."),
                React.createElement(RadioButtonGroup_1.default, { value: this.props.properties["Octopus.Action.Aws.TemplateSource"], onChange: function (val) { return _this.onChangeTemplateSource(val); }, error: this.props.getFieldError("Octopus.Action.Aws.TemplateSource") },
                    React.createElement(RadioButton_1.default, { value: "Inline", label: "Source code" }),
                    React.createElement(RadioButton_1.default, { value: "Package", label: "File inside a package" })),
                this.props.properties["Octopus.Action.Aws.TemplateSource"] === "Inline" && React.createElement("div", null,
                    React.createElement("br", null),
                    this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"] &&
                        React.createElement(CodeEditor_1.default, { value: this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"], language: awsTemplateHelper_1.AwsTemplateHelper.tryParseJson(this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"]) ?
                                CodeEditor_1.TextFormat.JSON : CodeEditor_1.TextFormat.YAML, allowFullScreen: false, readOnly: true, onChange: null }),
                    React.createElement("div", null,
                        React.createElement(OpenDialogButton_1.default, { label: this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"] ? "Edit Source Code" : "Add Source Code", wideDialog: true },
                            React.createElement(sourceCodeDialog_1.default, { template: this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"], doBusyTask: this.props.doBusyTask, saveDone: function (template, metadata) {
                                    _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.CloudFormationTemplate"] = template, _a));
                                    _this.refreshParametersFromMetadata(metadata);
                                    var _a;
                                }, textFormat: !this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"] ||
                                    awsTemplateHelper_1.AwsTemplateHelper.tryParseJson(this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"]) ?
                                    CodeEditor_1.TextFormat.JSON : CodeEditor_1.TextFormat.YAML, metadata: "CloudFormation" }))))),
            this.props.properties["Octopus.Action.Aws.TemplateSource"] === "Package" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(this.props.properties, this.state.feeds), help: "Choose the package that contains the template source." },
                    React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors })),
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.CloudFormationTemplate|Octopus.Action.Aws.CloudFormationTemplateParametersRaw", title: "Paths", summary: this.pathsSummary(), help: "Enter relative the paths for the template and parameter files in the package." },
                    React.createElement(Text_1.VariableLookupText, { label: "Template path", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.CloudFormationTemplate"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Aws.CloudFormationTemplate") }),
                    React.createElement(Note_1.default, null, "Relative path to the JSON template file contained in the package"),
                    React.createElement(Text_1.VariableLookupText, { label: "Template parameters path", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Aws.CloudFormationTemplateParametersRaw") }),
                    React.createElement(Note_1.default, null, "Relative path to the JSON parameters file contained in the package"))),
            this.props.properties["Octopus.Action.Aws.TemplateSource"] === "Inline" && this.state.parameterTypes && React.createElement("div", null,
                React.createElement(FormSectionHeading_1.default, { title: "Parameters" }),
                React.createElement(DynamicForm_1.default, { types: this.state.parameterTypes, values: this.state.parameterValues, isBindable: true, onChange: function (data) { return _this.updateParameters(data); } })));
    };
    AwsCloudFormationActionEdit.prototype.cloudFormationSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Aws.CloudFormationStackName"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Creating stack ",
                React.createElement("strong", null, properties["Octopus.Action.Aws.CloudFormationStackName"]),
                properties["Octopus.Action.Aws.Region"] && React.createElement("span", null,
                    " in ",
                    React.createElement("strong", null, properties["Octopus.Action.Aws.Region"])),
                properties["Octopus.Action.Aws.WaitForCompletion"] !== "False" && React.createElement("span", null, " waiting for completion"),
                properties["Octopus.Action.Aws.WaitForCompletion"] === "False" && React.createElement("span", null, " not waiting for completion"),
                properties["Octopus.Action.Aws.DisableRollback"] === "True" && React.createElement("span", null, ", with rollback disabled"),
                properties["Octopus.Action.Aws.IamCapabilities"] && properties["Octopus.Action.Aws.IamCapabilities"] !== "NONE" &&
                    React.createElement("span", null, ", and with IAM capabilities"),
                !properties["Octopus.Action.Aws.IamCapabilities"] || properties["Octopus.Action.Aws.IamCapabilities"] === "NONE" &&
                    React.createElement("span", null, ", and with no IAM capabilities")));
        }
        return form_1.Summary.placeholder("Specify the details of the CloudFormation stack");
    };
    AwsCloudFormationActionEdit.prototype.refreshParametersFromTemplate = function (template) {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.CloudTemplates.getMetadata(template, "CloudFormation")];
                    case 1:
                        response = _a.sent();
                        this.refreshParametersFromMetadata(response);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AwsCloudFormationActionEdit.prototype.refreshParametersFromMetadata = function (metadataResponse) {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var storedParameters, _a;
            return __generator(this, function (_b) {
                storedParameters = this.flattenParameters();
                Object.keys(metadataResponse.Values).forEach(function (key) {
                    if (storedParameters[key]) {
                        metadataResponse.Values[key] = storedParameters[key];
                    }
                });
                this.props.setProperties((_a = {},
                    _a["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"] = JSON.stringify(Object.keys(metadataResponse.Values).map(function (k) { return ({ ParameterKey: k, ParameterValue: metadataResponse.Values[k] }); })),
                    _a));
                this.syncParameters(metadataResponse.Values);
                this.setState({ parameterTypes: metadataResponse.Metadata.Types, parameterValues: metadataResponse.Values });
                return [2 /*return*/];
            });
        }); });
    };
    AwsCloudFormationActionEdit.prototype.flattenParameters = function () {
        var parameters = {};
        if (this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"]) {
            var storedParameters = JSON.parse(this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"]);
            storedParameters.forEach(function (p) {
                parameters[p.ParameterKey] = p.ParameterValue;
            });
        }
        return parameters;
    };
    AwsCloudFormationActionEdit.prototype.updateParameters = function (data) {
        var objectKeys = Object.keys(data);
        this.props.setProperties((_a = {},
            _a["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"] = JSON.stringify(objectKeys.map(function (k) { return ({ ParameterKey: k, ParameterValue: data[k] }); })),
            _a));
        this.syncParameters(data);
        var _a;
    };
    AwsCloudFormationActionEdit.prototype.syncParameters = function (data) {
        var objectKeys = Object.keys(data);
        /*
            Arrays are presented as new line separated strings, but are saved in the properties files
            as comma separated lists. So while Octopus.Action.Aws.CloudFormationTemplateParametersRaw
            retains the data input by the user, Octopus.Action.Aws.CloudFormationTemplateParameters
            is processed to contain the lists that CloudFormation expects.

            See https://github.com/aws/aws-cli/issues/1529 for details.
         */
        this.props.setProperties((_a = {},
            _a["Octopus.Action.Aws.CloudFormationTemplateParameters"] = JSON.stringify(objectKeys.map(function (k) {
                if (Array.isArray(data[k])) {
                    return { ParameterKey: k, ParameterValue: data[k].join(",") };
                }
                else {
                    // We can't have null values, only empty strings
                    return { ParameterKey: k, ParameterValue: data[k] || "" };
                }
            })),
            _a));
        var _a;
    };
    return AwsCloudFormationActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AwsRunCloudFormation",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AwsCloudFormationActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: AwsCloudFormationActionEdit,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\aws\\awsDeployCloudFormationAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\aws\\awsDeployCloudFormationAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AwsTemplateHelper = (function () {
    function AwsTemplateHelper() {
    }
    /**
     * Try to parse the text as JSON
     * @param {string} template The text to parse
     * @returns {boolean} true if the text could be parsed as JSON, and false otherwise
     */
    AwsTemplateHelper.tryParseJson = function (template) {
        try {
            JSON.parse(template);
            return true;
        }
        catch (ex) {
            return false;
        }
    };
    return AwsTemplateHelper;
}());
exports.AwsTemplateHelper = AwsTemplateHelper;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\aws\\awsTemplateHelper.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\aws\\awsTemplateHelper.ts"); } } })();

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var resources_1 = __webpack_require__(26);
var FormSectionHeading_1 = __webpack_require__(46);
var form_1 = __webpack_require__(15);
var awsLoginComponent_1 = __webpack_require__(208);
var Note_1 = __webpack_require__(22);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(35);
var ActionDetails_1 = __webpack_require__(27);
var Text_1 = __webpack_require__(17);
var StringCheckbox_1 = __webpack_require__(38);
var ExternalLink_1 = __webpack_require__(29);
var AwsCloudFormationActionSummary = (function (_super) {
    __extends(AwsCloudFormationActionSummary, _super);
    function AwsCloudFormationActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AwsCloudFormationActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Delete an AWS CloudFormation stack",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return AwsCloudFormationActionSummary;
}(BaseComponent_1.BaseComponent));
var AwsRemoveCloudFormationActionEdit = (function (_super) {
    __extends(AwsRemoveCloudFormationActionEdit, _super);
    function AwsRemoveCloudFormationActionEdit(props) {
        return _super.call(this, props) || this;
    }
    AwsRemoveCloudFormationActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!this.props.properties["Octopus.Action.Aws.WaitForCompletion"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.Aws.WaitForCompletion"] = "True", _c), true);
                        }
                        if (!this.props.properties["Octopus.Action.Aws.AssumeRole"]) {
                            this.props.setProperties((_d = {}, _d["Octopus.Action.Aws.AssumeRole"] = "False", _d), true);
                        }
                        if (!this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"]) {
                            this.props.setProperties((_e = {}, _e["Octopus.Action.AwsAccount.UseInstanceRole"] = "False", _e), true);
                        }
                        this.props.setProperties((_f = {}, _f["Octopus.Action.Aws.CloudFormationAction"] = "Delete", _f), true);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _b.feeds = _g.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 2:
                        _a.apply(this, [(_b.accounts = _g.sent(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AwsRemoveCloudFormationActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "AWS" }),
            React.createElement(awsLoginComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, plugin: this.props.plugin, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, errors: this.props.errors }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.Region|Octopus.Action.Aws.CloudFormationStackName", title: "CloudFormation", summary: this.cloudFormationSummary(), help: "Specify the details of the CloudFormation stack" },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.Region"], label: "Region", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.Region"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.Region") }),
                React.createElement(Note_1.default, null,
                    "View the ",
                    React.createElement(ExternalLink_1.default, { href: "AWSRegions" }, "AWS Regions and Endpoints"),
                    " documentation for a current list of the available region codes."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.CloudFormationStackName"], label: "CloudFormation stack name", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.CloudFormationStackName"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.CloudFormationStackName") }),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { resetValue: "True", value: properties["Octopus.Action.Aws.WaitForCompletion"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.WaitForCompletion"] = x, _a));
                        var _a;
                    }, label: "Wait for completion" }),
                React.createElement(Note_1.default, null, "Select this checkbox to force the step to wait until the CloudFormation stack has been deleted before finishing the step. Be aware that unselecting this option means the step will not indicate an error if the stack was not removed successfully.")));
    };
    AwsRemoveCloudFormationActionEdit.prototype.cloudFormationSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Aws.CloudFormationStackName"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Deleting stack ",
                React.createElement("strong", null, properties["Octopus.Action.Aws.CloudFormationStackName"]),
                properties["Octopus.Action.Aws.Region"] && React.createElement("span", null,
                    " in ",
                    React.createElement("strong", null, properties["Octopus.Action.Aws.Region"])),
                properties["Octopus.Action.Aws.WaitForCompletion"] && React.createElement("span", null, " waiting for completion"),
                !properties["Octopus.Action.Aws.WaitForCompletion"] && React.createElement("span", null, " not waiting for completion")));
        }
        return form_1.Summary.placeholder("Specify the details of the CloudFormation stack");
    };
    return AwsRemoveCloudFormationActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AwsDeleteCloudFormation",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AwsCloudFormationActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: AwsRemoveCloudFormationActionEdit,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\aws\\awsDeleteCloudFormationAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\aws\\awsDeleteCloudFormationAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(37);
var scriptAction_1 = __webpack_require__(273);
var awsLoginComponent_1 = __webpack_require__(208);
var Text_1 = __webpack_require__(17);
var ExpandableFormSection_1 = __webpack_require__(44);
var form_1 = __webpack_require__(15);
var ActionDetails_1 = __webpack_require__(27);
var Note_1 = __webpack_require__(22);
var ExternalLink_1 = __webpack_require__(29);
var AWSRunScriptActionSummary = (function (_super) {
    __extends(AWSRunScriptActionSummary, _super);
    function AWSRunScriptActionSummary(props) {
        return _super.call(this, props) || this;
    }
    AWSRunScriptActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Log into AWS and run a script with the AWS CLI.");
    };
    return AWSRunScriptActionSummary;
}(BaseComponent_1.BaseComponent));
var AWSRunScriptActionEdit = (function (_super) {
    __extends(AWSRunScriptActionEdit, _super);
    function AWSRunScriptActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feeds: [],
            accounts: []
        };
        return _this;
    }
    AWSRunScriptActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _b.feeds = _e.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 2:
                        _a.apply(this, [(_b.accounts = _e.sent(),
                                _b)]);
                        if (!this.props.properties["Octopus.Action.Aws.AssumeRole"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.Aws.AssumeRole"] = "False", _c), true);
                        }
                        if (!this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"]) {
                            this.props.setProperties((_d = {}, _d["Octopus.Action.AwsAccount.UseInstanceRole"] = "False", _d), true);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AWSRunScriptActionEdit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(awsLoginComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, plugin: this.props.plugin, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, errors: this.props.errors }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Aws.Region", title: "Region", summary: this.regionSummary(), help: "Specify the default region" },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.Region"], label: "Region", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.Region"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.Region") }),
                React.createElement(Note_1.default, null,
                    "View the ",
                    React.createElement(ExternalLink_1.default, { href: "AWSRegions" }, "AWS Regions and Endpoints"),
                    " documentation for a current list of the available region codes.")),
            React.createElement(scriptAction_1.ScriptActionEdit, { plugin: this.props.plugin, projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, powerShellOnly: true, errors: this.props.errors }));
    };
    AWSRunScriptActionEdit.prototype.regionSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Aws.Region"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Using ",
                React.createElement("strong", null, properties["Octopus.Action.Aws.Region"]),
                " as the default region"));
        }
        return form_1.Summary.placeholder("Specify the default AWS region");
    };
    return AWSRunScriptActionEdit;
}(BaseComponent_1.BaseComponent));
exports.AWSRunScriptActionEdit = AWSRunScriptActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AwsRunScript",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AWSRunScriptActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: AWSRunScriptActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return false; },
    features: {
        optional: ["Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.SubstituteInFiles"],
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\aws\\awsRunScriptAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\aws\\awsRunScriptAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(37);
var awsLoginComponent_1 = __webpack_require__(208);
var Text_1 = __webpack_require__(17);
var ActionDetails_1 = __webpack_require__(27);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(58);
var lodash_1 = __webpack_require__(16);
var RadioButtonGroup_1 = __webpack_require__(33);
var KeyValueEditList_1 = __webpack_require__(222);
var StringCheckbox_1 = __webpack_require__(38);
var Button_1 = __webpack_require__(51);
var form_1 = __webpack_require__(15);
var ExternalLink_1 = __webpack_require__(29);
var BucketKeyBehaviour;
(function (BucketKeyBehaviour) {
    BucketKeyBehaviour["Filename"] = "Filename";
    BucketKeyBehaviour["Custom"] = "Custom";
})(BucketKeyBehaviour = exports.BucketKeyBehaviour || (exports.BucketKeyBehaviour = {}));
var TargetMode;
(function (TargetMode) {
    TargetMode["EntirePackage"] = "EntirePackage";
    TargetMode["FileSelections"] = "FileSelections";
})(TargetMode || (TargetMode = {}));
var FileSelectionTypes;
(function (FileSelectionTypes) {
    FileSelectionTypes["SingleFile"] = "SingleFile";
    FileSelectionTypes["MultipleFiles"] = "MultipleFiles";
})(FileSelectionTypes || (FileSelectionTypes = {}));
var Fragment = function (props) { return props.children; };
function isMultiFileSelection(selection) {
    return selection && selection.type && selection.type === FileSelectionTypes.MultipleFiles;
}
function isSingleFileSelection(selection) {
    return selection && selection.type && selection.type === FileSelectionTypes.SingleFile;
}
var AwsUploadS3ActionSummary = function (props) { return (React.createElement("div", null, "Upload a package to an AWS S3 bucket.")); };
var simpleSummary = lodash_1.curry(function (property, render, placeholder, properties) {
    return properties[property] ? render(properties[property]) : placeholder();
});
var bucketSummary = simpleSummary("Octopus.Action.Aws.S3.BucketName", function (value) { return form_1.Summary.summary(React.createElement("span", null,
    "Using bucket ",
    React.createElement("strong", null, value))); }, function () { return form_1.Summary.placeholder("Specify the  S3 bucket name"); });
var regionSummary = simpleSummary("Octopus.Action.Aws.Region", function (value) { return form_1.Summary.summary(React.createElement("span", null,
    "Using ",
    React.createElement("strong", null, value),
    " as the default region")); }, function () { return form_1.Summary.placeholder("Specify the default AWS region"); });
var failWith = function (message) {
    throw new Error(message);
};
var targetModeSummary = simpleSummary("Octopus.Action.Aws.S3.TargetMode", function (value) {
    switch (value) {
        case TargetMode.EntirePackage: return form_1.Summary.summary(React.createElement("span", null, "Entire package file (the package will not be extracted)"));
        case TargetMode.FileSelections: return form_1.Summary.summary(React.createElement("span", null, "Specific file(s) within the package"));
        default: failWith("Unknown package type");
    }
}, function () { return form_1.Summary.placeholder("Specify a target type"); });
var renderMetadata = function (onChange, _a) {
    var projectId = _a.projectId, localNames = _a.localNames, detail = __rest(_a, ["projectId", "localNames"]);
    var fieldProps = { projectId: projectId, localNames: localNames, separator: "=", keyLabel: "Key", valueLabel: "Value" };
    return [React.createElement(KeyValueEditList_1.KeyValueEditList, __assign({}, fieldProps, { key: "metadata", name: "metadata", onChange: function (val) { return onChange(__assign({}, detail, { metadata: val })); }, items: function () { return detail.metadata || []; } })),
        React.createElement(KeyValueEditList_1.KeyValueEditList, __assign({}, fieldProps, { key: "tags", name: "tags", onChange: function (val) { return onChange(__assign({}, detail, { tags: val })); }, items: function () { return detail.tags || []; } }))];
};
var CannedAclNote = function () { return (React.createElement(form_1.Note, null,
    "You can read more about available options regarding canned Acls ",
    React.createElement(ExternalLink_1.default, { href: "AwsS3CannedAcl" }, "here"))); };
var StorageClassNote = function () { return (React.createElement(form_1.Note, null,
    "Read more about S3 storage classes ",
    React.createElement(ExternalLink_1.default, { href: "AwsS3StorageClasses" }, "here"))); };
var CannedAclField = function (props) {
    return React.createElement(Text_1.VariableLookupText, __assign({}, props, { label: "Canned Acl" }));
};
var StorageClassField = function (props) {
    return React.createElement(Text_1.VariableLookupText, __assign({}, props, { label: "Storage Class" }));
};
var BucketKeyBehaviourEdit = function (_a) {
    var onChange = _a.onChange, localNames = _a.localNames, projectId = _a.projectId, getFieldError = _a.getFieldError, detail = __rest(_a, ["onChange", "localNames", "projectId", "getFieldError"]);
    var fieldProps = { localNames: localNames, projectId: projectId };
    var behaviour = detail.bucketKeyBehaviour || BucketKeyBehaviour.Custom;
    return React.createElement(Fragment, null,
        React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { resetValue: BucketKeyBehaviour.Custom, value: behaviour, onChange: function (bucketKeyBehaviour) { return onChange({ bucketKeyBehaviour: bucketKeyBehaviour }); }, error: getFieldError("BucketKeyBehaviour") },
            React.createElement(form_1.RadioButton, { value: BucketKeyBehaviour.Filename, label: "Use filename" }),
            React.createElement(form_1.RadioButton, { value: BucketKeyBehaviour.Custom, label: "Use custom key" })),
        behaviour === BucketKeyBehaviour.Custom &&
            React.createElement(Text_1.VariableLookupText, __assign({}, fieldProps, { value: detail.bucketKey, label: "Bucket Key", onChange: function (bucketKey) { return onChange({ bucketKey: bucketKey }); }, error: getFieldError("BucketKey") })),
        behaviour === BucketKeyBehaviour.Filename &&
            React.createElement(Text_1.VariableLookupText, __assign({}, fieldProps, { value: detail.bucketKeyPrefix, label: "Bucket Key Prefix", onChange: function (bucketKeyPrefix) { return onChange({ bucketKeyPrefix: bucketKeyPrefix }); }, error: getFieldError("BucketKeyPrefix") })));
};
var S3PackageDetailEdit = function (_a) {
    var onChange = _a.onChange, getFieldError = _a.getFieldError, children = _a.children, projectId = _a.projectId, localNames = _a.localNames, metadata = _a.metadata, tags = _a.tags, detail = __rest(_a, ["onChange", "getFieldError", "children", "projectId", "localNames", "metadata", "tags"]);
    var fieldProps = { projectId: projectId, localNames: localNames };
    return React.createElement(Fragment, null,
        React.createElement(BucketKeyBehaviourEdit, __assign({}, fieldProps, detail, { onChange: function (val) { return onChange(__assign({}, detail, val)); }, getFieldError: getFieldError })),
        React.createElement(CannedAclField, __assign({}, fieldProps, { value: detail.cannedAcl, onChange: function (val) { return onChange(__assign({}, detail, { cannedAcl: val })); }, error: getFieldError("CannedAcl") })),
        React.createElement(CannedAclNote, null),
        React.createElement(StorageClassField, __assign({}, fieldProps, { value: detail.storageClass, onChange: function (val) { return onChange(__assign({}, detail, { storageClass: val })); }, error: getFieldError("StorageClass") })),
        React.createElement(StorageClassNote, null),
        renderMetadata(onChange, __assign({}, fieldProps, { tags: tags, metadata: metadata })));
};
var S3SingleFileDetailEdit = function (props) {
    var onChange = props.onChange, onChangeType = props.onChangeType, getFieldError = props.getFieldError, children = props.children, metadata = props.metadata, tags = props.tags, localNames = props.localNames, projectId = props.projectId, detail = __rest(props, ["onChange", "onChangeType", "getFieldError", "children", "metadata", "tags", "localNames", "projectId"]);
    var fieldProps = { projectId: projectId, localNames: localNames };
    return React.createElement(Fragment, null,
        React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { resetValue: "SingleFile", value: detail.type, onChange: onChangeType, error: getFieldError("Type") },
            React.createElement(form_1.RadioButton, { value: "SingleFile", label: "Single File" }),
            React.createElement(form_1.RadioButton, { value: "MultipleFiles", label: "Multiple Files" })),
        React.createElement(Text_1.VariableLookupText, __assign({}, fieldProps, { value: detail.path, label: "Path", onChange: function (val) { return onChange(__assign({}, detail, { path: val })); }, error: getFieldError("Path") })),
        React.createElement(StringCheckbox_1.default, { value: detail.performVariableSubstitution, label: "Variable Substitution", onChange: function (val) { return onChange(__assign({}, detail, { performVariableSubstitution: val })); } }),
        React.createElement(BucketKeyBehaviourEdit, __assign({}, fieldProps, detail, { onChange: function (val) { return onChange(__assign({}, detail, val)); }, getFieldError: getFieldError })),
        React.createElement(CannedAclField, __assign({}, fieldProps, { value: detail.cannedAcl, onChange: function (val) { return onChange(__assign({}, detail, { cannedAcl: val })); }, error: getFieldError("CannedAcl") })),
        React.createElement(CannedAclNote, null),
        React.createElement(StorageClassField, __assign({}, fieldProps, { value: detail.storageClass, onChange: function (val) { return onChange(__assign({}, detail, { storageClass: val })); }, error: getFieldError("StorageClass") })),
        React.createElement(StorageClassNote, null),
        renderMetadata(onChange, __assign({}, fieldProps, { tags: tags, metadata: metadata })));
};
var S3MultiFileDetailEdit = function (props) {
    var onChange = props.onChange, onChangeType = props.onChangeType, getFieldError = props.getFieldError, children = props.children, metadata = props.metadata, tags = props.tags, localNames = props.localNames, projectId = props.projectId, detail = __rest(props, ["onChange", "onChangeType", "getFieldError", "children", "metadata", "tags", "localNames", "projectId"]);
    var fieldProps = { projectId: projectId, localNames: localNames };
    return React.createElement(Fragment, null,
        React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { resetValue: "MultipleFiles", value: detail.type, onChange: onChangeType, error: getFieldError("Type") },
            React.createElement(form_1.RadioButton, { value: "SingleFile", label: "Single File" }),
            React.createElement(form_1.RadioButton, { value: "MultipleFiles", label: "Multiple Files" })),
        React.createElement(Text_1.VariableLookupText, __assign({}, fieldProps, { value: detail.pattern, label: "File Pattern", onChange: function (val) { return onChange(__assign({}, detail, { pattern: val })); }, error: getFieldError("Pattern") })),
        React.createElement(Text_1.VariableLookupText, __assign({}, fieldProps, { multiLine: true, value: detail.variableSubstitutionPatterns, label: "Variable Substitution File Patterns", onChange: function (val) { return onChange(__assign({}, detail, { variableSubstitutionPatterns: val })); }, error: getFieldError("VariableSubstitutionPatterns") })),
        React.createElement(form_1.Note, null,
            "A newline-separated list of file names to transform, relative to the package contents. Extended wildcard syntax is supported. E.g., ",
            React.createElement("em", null, "Notes.txt"),
            ", ",
            React.createElement("em", null, "Config\\*.json"),
            ", ",
            React.createElement("em", null, "**\\specific-folder\\*.config."),
            React.createElement("br", null),
            "This field supports extended template syntax. Conditional ",
            React.createElement("code", null, "if"),
            " and ",
            React.createElement("code", null, "unless"),
            ":",
            React.createElement("pre", null, "#{if MyVar}...#{/if}"),
            "Iteration over variable sets or comma-separated values with ",
            React.createElement("code", null, "each"),
            ":",
            React.createElement("pre", null, "#{each mv in MyVar}...#{mv}...#{/each}")),
        React.createElement(Text_1.VariableLookupText, __assign({}, fieldProps, { value: detail.bucketKeyPrefix, label: "Bucket Key Prefix", onChange: function (val) { return onChange(__assign({}, detail, { bucketKeyPrefix: val })); }, error: getFieldError("BucketKeyPrefix") })),
        React.createElement(CannedAclField, __assign({}, fieldProps, { value: detail.cannedAcl, onChange: function (val) { return onChange(__assign({}, detail, { cannedAcl: val })); }, error: getFieldError("CannedAcl") })),
        React.createElement(CannedAclNote, null),
        React.createElement(StorageClassField, __assign({}, fieldProps, { value: detail.storageClass, onChange: function (val) { return onChange(__assign({}, detail, { storageClass: val })); }, error: getFieldError("StorageClass") })),
        React.createElement(StorageClassNote, null),
        renderMetadata(onChange, __assign({}, fieldProps, { tags: tags, metadata: metadata })));
};
var FileSelectionEdit = function (_a) {
    var onChange = _a.onChange, onChangeType = _a.onChangeType, onRemove = _a.onRemove, getFieldError = _a.getFieldError, selection = __rest(_a, ["onChange", "onChangeType", "onRemove", "getFieldError"]);
    var callbacks = { onChange: onChange, onChangeType: onChangeType, getFieldError: getFieldError };
    var removeButton = React.createElement("div", { style: { textAlign: "right" } },
        React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Secondary, onClick: onRemove, label: "Remove File Selection" }));
    return React.createElement(Fragment, null,
        removeButton,
        isSingleFileSelection(selection) && React.createElement(S3SingleFileDetailEdit, __assign({}, selection, callbacks)),
        isMultiFileSelection(selection) && React.createElement(S3MultiFileDetailEdit, __assign({}, selection, callbacks)));
};
var getNewFileSelection = function () {
    return {
        type: FileSelectionTypes.SingleFile,
        tags: [],
        metadata: [],
        cannedAcl: "",
        path: "",
        storageClass: "",
        bucketKey: "",
        bucketKeyPrefix: "",
        bucketKeyBehaviour: BucketKeyBehaviour.Custom,
        performVariableSubstitution: "False"
    };
};
var fileOptionsSummaryText = function (options) {
    return [
        options.storageClass && " on " + options.storageClass + " storage",
        options.cannedAcl && " with " + options.cannedAcl + " permissions"
    ];
};
function targetOptionsSummary(placeholder, summaryCallback) {
    return function (options) {
        if (options === undefined || options === null) {
            return form_1.Summary.placeholder(placeholder);
        }
        var summary = summaryCallback(options);
        if (!summary || summary.length === 0) {
            return form_1.Summary.placeholder(placeholder);
        }
        return form_1.Summary.summary(React.createElement("span", { children: summary }));
    };
}
var singleFileSelectionSummary = targetOptionsSummary("Specify file options", function (options) {
    return (options.path ? ["File ", React.createElement("strong", { key: "summary" }, options.path)] : [React.createElement("strong", { key: "summary" }, "No file path specified")]).concat(fileOptionsSummaryText(options));
});
var packageSummary = targetOptionsSummary("Specify file options", function (options) {
    return [
        options.bucketKey ? React.createElement("strong", { key: "summary" }, options.bucketKey) : React.createElement("strong", { key: "summary" }, "No bucket key provided")
    ].concat(fileOptionsSummaryText(options));
});
var mutliFileSelectionSummary = targetOptionsSummary("Specify file options", function (options) {
    return (options.pattern ? ["Files matching ", React.createElement("strong", { key: "summary" }, options.pattern)] : [React.createElement("strong", { key: "summary" }, "No patterns specified")]).concat(fileOptionsSummaryText(options));
});
var fileSelectionSummary = function (selection) {
    if (isSingleFileSelection(selection)) {
        return singleFileSelectionSummary(selection);
    }
    else if (isMultiFileSelection(selection)) {
        return mutliFileSelectionSummary(selection);
    }
};
var updateFileSelection = function (index, value) {
    return function (previous, properties) {
        var patch = __assign({}, previous, { selections: previous.selections.slice() });
        patch.selections[index] = __assign({}, patch.selections[index], value);
        //We close over the state update and push it onto the queue via setProperties.
        //TODO: Invetisgate alternate way to do this, possibly redux since the same action can be handled by multiple reducers
        properties.setProperties((_a = {}, _a["Octopus.Action.Aws.S3.FileSelections"] = JSON.stringify(patch.selections), _a));
        return patch;
        var _a;
    };
};
var removeFileSelection = function (index) {
    return function (previous, properties) {
        var patch = __assign({}, previous, { selections: previous.selections.slice() });
        patch.selections.splice(index, 1);
        properties.setProperties((_a = {}, _a["Octopus.Action.Aws.S3.FileSelections"] = JSON.stringify(patch.selections), _a));
        return patch;
        var _a;
    };
};
var updatePackageOptions = function (value) {
    return function (previous, properties) {
        var result = __assign({}, previous, { package: __assign({}, previous.package, value) });
        properties.setProperties((_a = {}, _a["Octopus.Action.Aws.S3.PackageOptions"] = JSON.stringify(result.package), _a));
        return result;
        var _a;
    };
};
var addFileSelection = function (value) {
    return function (previous, properties) {
        var patch = { selections: previous.selections.concat([value]) };
        properties.setProperties((_a = {}, _a["Octopus.Action.Aws.S3.FileSelections"] = JSON.stringify(patch.selections), _a));
        return patch;
        var _a;
    };
};
var AwsUploadS3ActionEdit = (function (_super) {
    __extends(AwsUploadS3ActionEdit, _super);
    function AwsUploadS3ActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feeds: [],
            accounts: [],
            package: {
                bucketKey: "",
                bucketKeyBehaviour: BucketKeyBehaviour.Custom,
                bucketKeyPrefix: "",
                storageClass: "",
                cannedAcl: "",
                metadata: [],
                tags: []
            },
            selections: []
        };
        return _this;
    }
    AwsUploadS3ActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var feeds, accounts, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        feeds = _d.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 2:
                        accounts = _d.sent();
                        this.setState(function (prev) { return (__assign({}, prev, { feeds: feeds, accounts: accounts })); });
                        if (!this.props.properties["Octopus.Action.Aws.AssumeRole"]) {
                            this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.AssumeRole"] = "False", _a), true);
                        }
                        if (!this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"]) {
                            this.props.setProperties((_b = {}, _b["Octopus.Action.AwsAccount.UseInstanceRole"] = "False", _b), true);
                        }
                        if (!this.props.properties["Octopus.Action.Aws.S3.TargetMode"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.Aws.S3.TargetMode"] = TargetMode.EntirePackage, _c), true);
                        }
                        this.setState(function (prev, props) {
                            if (props.properties["Octopus.Action.Aws.S3.FileSelections"]) {
                                return { selections: (JSON.parse(props.properties["Octopus.Action.Aws.S3.FileSelections"]) || []) };
                            }
                        });
                        this.setState(function (prev, props) {
                            if (props.properties["Octopus.Action.Aws.S3.PackageOptions"]) {
                                return { package: JSON.parse(props.properties["Octopus.Action.Aws.S3.PackageOptions"]) || {} };
                            }
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AwsUploadS3ActionEdit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(awsLoginComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, plugin: this.props.plugin, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, errors: this.props.errors }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.Region", title: "Region", summary: regionSummary(this.props.properties), help: "Specify the default region" },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.Region"], label: "Region", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.Region"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.Region") }),
                React.createElement(form_1.Note, null,
                    "View the ",
                    React.createElement(ExternalLink_1.default, { href: "AWSRegions" }, "AWS Regions and Endpoints"),
                    " documentation for a current list of the available region codes.")),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.S3.BucketName", title: "Bucket", summary: bucketSummary(this.props.properties), help: "Specify the bucket name" },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.S3.BucketName"], label: "Bucket", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.S3.BucketName"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.S3.BucketName") })),
            React.createElement(form_1.FormSectionHeading, { title: "Package" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(this.props.properties, this.state.feeds), help: "Choose the package or package containing the file(s) to upload." },
                React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.S3.TargetType", title: "Target", summary: targetModeSummary(this.props.properties), help: "Choose how we should treat this package." },
                React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { resetValue: TargetMode.EntirePackage, value: this.props.properties["Octopus.Action.Aws.S3.TargetMode"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.S3.TargetMode"] = x, _a));
                        var _a;
                    }, label: "Execute using the AWS service role for an EC2 instance" },
                    React.createElement(form_1.RadioButton, { value: TargetMode.EntirePackage, label: "Entire package file (the package will not be extracted)" }),
                    React.createElement(form_1.RadioButton, { value: TargetMode.FileSelections, label: "Specific file(s) within the package" }))),
            this.props.properties["Octopus.Action.Aws.S3.TargetMode"] === TargetMode.EntirePackage &&
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.S3.PackageOptions", summary: packageSummary(this.state.package), title: "Package Options", help: "Package options and metadata to use when uploading the entire package to an S3 bucket" },
                    React.createElement(S3PackageDetailEdit, __assign({}, this.state.package, { projectId: this.props.projectId, onChange: function (detail) { return _this.setState(updatePackageOptions(detail)); }, getFieldError: function (field) { return _this.props.getFieldError("Octopus.Action.Aws.S3.PackageOptions." + field); } }))),
            this.props.properties["Octopus.Action.Aws.S3.TargetMode"] === TargetMode.FileSelections && React.createElement(form_1.FormSectionHeading, { title: "Files" }),
            this.props.properties["Octopus.Action.Aws.S3.TargetMode"] === TargetMode.FileSelections && this.state.selections.map(function (selection, index) {
                return React.createElement(form_1.ExpandableFormSection, { key: "IDX_" + index, errorKey: "Octopus.Action.Aws.S3.FileSelections[" + index + "]", summary: fileSelectionSummary(selection), title: "" + (isSingleFileSelection(selection) ? "Single File" : "Multiple Files"), help: "Package options and metadata to use when uploading the entire package to an S3 bucket" },
                    React.createElement(FileSelectionEdit, __assign({}, selection, { onChange: function (value) { return _this.setState(updateFileSelection(index, value)); }, onChangeType: function (type) { return _this.setState(updateFileSelection(index, { type: type })); }, onRemove: function () { return _this.setState(removeFileSelection(index)); }, getFieldError: function (field) { return _this.props.getFieldError("Octopus.Action.Aws.S3.FileSelections[" + index + "]." + field); } })));
            }),
            this.props.properties["Octopus.Action.Aws.S3.TargetMode"] === TargetMode.FileSelections &&
                React.createElement(form_1.UnstructuredFormSection, null,
                    React.createElement("div", { style: { textAlign: "right" } },
                        React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Secondary, label: "" + (this.state.selections.length > 0 ? "Add another file selection" : "Add a file selection"), onClick: function () { return _this.setState(addFileSelection(getNewFileSelection())); } }))));
    };
    return AwsUploadS3ActionEdit;
}(BaseComponent_1.BaseComponent));
exports.AwsUploadS3ActionEdit = AwsUploadS3ActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.TargetOrServer,
    actionType: "Octopus.AwsUploadS3",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AwsUploadS3ActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: AwsUploadS3ActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
    features: {
        optional: [],
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\aws\\awsUploadS3Action.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\aws\\awsUploadS3Action.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var resources_1 = __webpack_require__(26);
var Roles_1 = __webpack_require__(35);
var ActionDetails_1 = __webpack_require__(27);
var terraformAction_1 = __webpack_require__(275);
var TerraformApplyActionSummary = (function (_super) {
    __extends(TerraformApplyActionSummary, _super);
    function TerraformApplyActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformApplyActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Apply a Terraform template",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return TerraformApplyActionSummary;
}(BaseComponent_1.BaseComponent));
var TerraformApplyActionEdit = (function (_super) {
    __extends(TerraformApplyActionEdit, _super);
    function TerraformApplyActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformApplyActionEdit.prototype.render = function () {
        return React.createElement(terraformAction_1.default, { projectId: this.props.projectId, properties: this.props.properties, setProperties: this.props.setProperties, plugin: this.props.plugin, errors: this.props.errors, getFieldError: this.props.getFieldError, doBusyTask: this.props.doBusyTask, actionName: "apply" });
    };
    return TerraformApplyActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.TerraformApply",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(TerraformApplyActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: TerraformApplyActionEdit,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\terraform\\terraformApplyAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\terraform\\terraformApplyAction.tsx"); } } })();

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var resources_1 = __webpack_require__(26);
var Roles_1 = __webpack_require__(35);
var ActionDetails_1 = __webpack_require__(27);
var terraformAction_1 = __webpack_require__(275);
var TerraformDestroyActionSummary = (function (_super) {
    __extends(TerraformDestroyActionSummary, _super);
    function TerraformDestroyActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformDestroyActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Destroy Terraform resources",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return TerraformDestroyActionSummary;
}(BaseComponent_1.BaseComponent));
var TerraformApplyActionEdit = (function (_super) {
    __extends(TerraformApplyActionEdit, _super);
    function TerraformApplyActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformApplyActionEdit.prototype.render = function () {
        return React.createElement(terraformAction_1.default, { projectId: this.props.projectId, properties: this.props.properties, setProperties: this.props.setProperties, plugin: this.props.plugin, errors: this.props.errors, getFieldError: this.props.getFieldError, doBusyTask: this.props.doBusyTask, actionName: "destroy" });
    };
    return TerraformApplyActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.TerraformDestroy",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(TerraformDestroyActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: TerraformApplyActionEdit,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\terraform\\terraformDestroyAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\terraform\\terraformDestroyAction.tsx"); } } })();

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var resources_1 = __webpack_require__(26);
var Roles_1 = __webpack_require__(35);
var ActionDetails_1 = __webpack_require__(27);
var terraformAction_1 = __webpack_require__(275);
var TerraformPlanActionSummary = (function (_super) {
    __extends(TerraformPlanActionSummary, _super);
    function TerraformPlanActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformPlanActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Plan a Terraform template",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return TerraformPlanActionSummary;
}(BaseComponent_1.BaseComponent));
var TerraformApplyActionEdit = (function (_super) {
    __extends(TerraformApplyActionEdit, _super);
    function TerraformApplyActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformApplyActionEdit.prototype.render = function () {
        return React.createElement(terraformAction_1.default, { projectId: this.props.projectId, properties: this.props.properties, setProperties: this.props.setProperties, plugin: this.props.plugin, errors: this.props.errors, getFieldError: this.props.getFieldError, doBusyTask: this.props.doBusyTask, actionName: "plan" });
    };
    return TerraformApplyActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.TerraformPlan",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(TerraformPlanActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: TerraformApplyActionEdit,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\terraform\\terraformPlanAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\terraform\\terraformPlanAction.tsx"); } } })();

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var resources_1 = __webpack_require__(26);
var Roles_1 = __webpack_require__(35);
var ActionDetails_1 = __webpack_require__(27);
var terraformAction_1 = __webpack_require__(275);
var TerraformPlanDestroyActionSummary = (function (_super) {
    __extends(TerraformPlanDestroyActionSummary, _super);
    function TerraformPlanDestroyActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformPlanDestroyActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Plan the destruction of Terraform resources",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return TerraformPlanDestroyActionSummary;
}(BaseComponent_1.BaseComponent));
var TerraformApplyActionEdit = (function (_super) {
    __extends(TerraformApplyActionEdit, _super);
    function TerraformApplyActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformApplyActionEdit.prototype.render = function () {
        return React.createElement(terraformAction_1.default, { projectId: this.props.projectId, properties: this.props.properties, setProperties: this.props.setProperties, plugin: this.props.plugin, errors: this.props.errors, getFieldError: this.props.getFieldError, doBusyTask: this.props.doBusyTask, actionName: "plan -destroy" });
    };
    return TerraformApplyActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.TerraformPlanDestroy",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(TerraformPlanDestroyActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: TerraformApplyActionEdit,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\terraform\\terraformPlanDestroyAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\terraform\\terraformPlanDestroyAction.tsx"); } } })();

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var routeLinks_1 = __webpack_require__(20);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var specialVariables_1 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(35);
var actionExecutionLocation_1 = __webpack_require__(37);
var InternalLink_1 = __webpack_require__(42);
var ExternalLink_1 = __webpack_require__(29);
var form_1 = __webpack_require__(15);
var PackageSelector_1 = __webpack_require__(58);
var PackageDownloadOptions_1 = __webpack_require__(135);
var CommonSummaryHelper_1 = __webpack_require__(62);
var getFeedName_1 = __webpack_require__(66);
var ActionDetails_1 = __webpack_require__(27);
var VhdActionSummary = (function (_super) {
    __extends(VhdActionSummary, _super);
    function VhdActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    VhdActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(this.getFeedId())];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    VhdActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy VHD",
            React.createElement("strong", null,
                " ",
                this.props.properties[specialVariables_1.default.Action.Package.PackageId],
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, this.getFeedId()),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    VhdActionSummary.prototype.getFeedId = function () {
        return this.props.properties[specialVariables_1.default.Action.Package.FeedId];
    };
    return VhdActionSummary;
}(BaseComponent_1.BaseComponent));
var VhdActionEdit = (function (_super) {
    __extends(VhdActionEdit, _super);
    function VhdActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feeds: []
        };
        return _this;
    }
    VhdActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!this.props.properties["Octopus.Action.Package.DownloadOnTentacle"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.Package.DownloadOnTentacle"] = "False", _c), true);
                        }
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _a.apply(this, [(_b.feeds = _d.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    VhdActionEdit.prototype.render = function () {
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to deploy a VHD to one or more machines. The machines require Windows Server 2012 or newer. You can configure the remote machines to deploy to in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.infrastructure.root, openInSelf: false }, "Infrastructure"),
                " tab. The package that you wish to deploy should contain a single VHD or VHDX file in the root of the package.  Learn more about ",
                React.createElement(ExternalLink_1.default, { href: "DocumentationPackaging" }, "what your packages should contain, and how to create them"),
                ".")
            : React.createElement("span", null, "Choose the package you which to deploy");
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(form_1.FormSectionHeading, { title: "Package Details" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "package", title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(properties, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, feeds: this.state.feeds, getFieldError: this.props.getFieldError, localNames: this.props.localNames, errors: this.props.errors }),
                React.createElement(PackageDownloadOptions_1.default, { setProperties: this.props.setProperties, properties: this.props.properties, projectId: this.props.projectId, localNames: this.props.localNames, errors: this.props.errors })));
    };
    return VhdActionEdit;
}(BaseComponent_1.BaseComponent));
exports.VhdActionEdit = VhdActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.Vhd",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(VhdActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: VhdActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: ActionDetails_1.TargetRoles.Optional,
    hasPackages: function (action) { return true; },
    features: {
        permanent: ["Octopus.Features.Vhd"],
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"],
        initial: ["Octopus.Features.SubstituteInFiles"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\vhd\\vhdAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Actions\\vhd\\vhdAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var Text_1 = __webpack_require__(17);
var Note_1 = __webpack_require__(22);
var StringCheckbox_1 = __webpack_require__(38);
var lodash_1 = __webpack_require__(16);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var StringProperties = {
    "Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles": "",
    "Octopus.Action.Package.AdditionalXmlConfigurationTransforms": "",
};
var ConfigurationTransformsEdit = (function (_super) {
    __extends(ConfigurationTransformsEdit, _super);
    function ConfigurationTransformsEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfigurationTransformsEdit.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props) || !lodash_1.isEqual(nextState, this.state);
    };
    ConfigurationTransformsEdit.prototype.summary = function () {
        var auto = this.props.properties["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"] || "";
        var custom = this.props.properties["Octopus.Action.Package.AdditionalXmlConfigurationTransforms"] || "";
        var summary = [];
        if (auto.toLowerCase() !== "false") {
            summary.push(React.createElement("span", null, "Default transforms (*.Release.config and *.EnvironmentName.config)"));
        }
        if (custom && custom.length > 0) {
            if (summary.length === 0) {
                summary.push(React.createElement("span", null, "Custom transforms"));
            }
            else {
                summary.push(React.createElement("span", null, " and custom transforms"));
            }
        }
        if (summary.length === 0) {
            return form_1.Summary.placeholder("No transforms will be run");
        }
        summary.push(React.createElement("span", null, " will be run"));
        return form_1.Summary.summary(React.Children.toArray(summary));
    };
    ConfigurationTransformsEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles|Octopus.Action.Package.AdditionalXmlConfigurationTransforms", title: "Configuration Transforms", summary: this.summary(), help: "Configure XML configuration transforms." },
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", value: properties["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"] = x, _a));
                    var _a;
                }, label: "Run default XML transforms", note: React.createElement("span", null,
                    "Octopus can run configuration transformation files. By default Octopus looks for ",
                    React.createElement("em", null, "*.Release.config"),
                    " and ",
                    React.createElement("em", null, "*.<EnvironmentName>.config"),
                    ".") }),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.AdditionalXmlConfigurationTransforms"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.AdditionalXmlConfigurationTransforms"] = x, _a));
                    var _a;
                }, multiLine: true, error: this.props.getFieldError("Octopus.Action.Package.AdditionalXmlConfigurationTransforms"), label: "Additional transforms" }),
            React.createElement(Note_1.default, { checkboxNote: true },
                React.createElement("p", null, "A comma- or newline-separated list of additional configuration transformation file rules. Example:"),
                React.createElement("pre", null,
                    "Web.Release.config => Web.config",
                    React.createElement("br", null),
                    "*.Foo.config => *.config",
                    React.createElement("br", null),
                    "crossdomainpolicy.#",
                    "{",
                    "Octopus.Environment.Name}.xml => crossdomainpolicy.xml"),
                React.createElement("p", null,
                    "If your configuration file is named ",
                    React.createElement("em", null, "Bar.xml"),
                    ", and your transformation file is named ",
                    React.createElement("em", null, "Foo.xml"),
                    ", you should enter ",
                    React.createElement("em", null, "Foo.xml=>Bar.xml"),
                    ". Wildcards are supported so if you have config files named ",
                    React.createElement("em", null, "xyz.Bar.config"),
                    " and ",
                    React.createElement("em", null, "abc.Bar.config"),
                    ", and you have transform files named ",
                    React.createElement("em", null, "xyz.Foo.config"),
                    " and ",
                    React.createElement("em", null, "abc.Foo.config"),
                    ", you may enter ",
                    React.createElement("em", null, "*.Foo.config=>*.Bar.config"))));
    };
    return ConfigurationTransformsEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.ConfigurationTransforms",
    title: "Configuration transforms",
    description: "Runs configuration file transforms, such as _Web.Release.config_",
    edit: ConfigurationTransformsEdit,
    priority: 21,
    enable: function (properties) {
        properties["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"] = "True";
    },
    disable: function (properties) {
        delete properties["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"];
        delete properties["Octopus.Action.Package.AdditionalXmlConfigurationTransforms"];
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\configurationTransforms\\configurationTransforms.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\configurationTransforms\\configurationTransforms.tsx"); } } })();

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var ExternalLink_1 = __webpack_require__(29);
var StringCheckbox_1 = __webpack_require__(38);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var StringProperties = {
    "Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings": "",
};
var ConfigurationVariablesEdit = (function (_super) {
    __extends(ConfigurationVariablesEdit, _super);
    function ConfigurationVariablesEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfigurationVariablesEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    ConfigurationVariablesEdit.prototype.summary = function () {
        if ((this.props.properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"] || "").toLowerCase() !== "false") {
            return form_1.Summary.summary(React.createElement("span", null,
                "Entries in ",
                React.createElement("em", null, ".config"),
                " files will be updated with variable values"));
        }
        return form_1.Summary.placeholder(React.createElement("span", null,
            "Entries in ",
            React.createElement("em", null, ".config"),
            " files will not be updated with variable values"));
    };
    ConfigurationVariablesEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings", title: "Configuration Variables", summary: this.summary(), help: "If set, replace appSettings and connectionString entries in any .config files." },
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", value: properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"] = x, _a));
                    var _a;
                }, label: "Replace entries in .config files", note: React.createElement("span", null,
                    "Tentacle will look inside your ",
                    React.createElement("em", null, ".config"),
                    " files and attempt to replace any `appSettings`, `applicationSettings` or `connectionStrings` entries that have a `key` or `name` that matches the name of a variable defined in Octopus. For more information, please ",
                    React.createElement(ExternalLink_1.default, { href: "ConfigurationVariables" }, "see the documentation"),
                    ".") }));
    };
    return ConfigurationVariablesEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.ConfigurationVariables",
    title: "Configuration variables",
    description: "Replace settings in any _.config_ files with variables defined in Octopus.",
    edit: ConfigurationVariablesEdit,
    priority: 20,
    enable: function (properties) {
        properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"] = "True";
    },
    disable: function (properties) {
        delete properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"];
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\configurationVariables\\configurationVariables.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\configurationVariables\\configurationVariables.tsx"); } } })();

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var StringCheckbox_1 = __webpack_require__(38);
var Note_1 = __webpack_require__(22);
var Text_1 = __webpack_require__(17);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var StringProperties = {
    "Octopus.Action.Package.CustomInstallationDirectory": "",
    "Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment": "",
    "Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions": "",
    "Octopus.Action.Package.AdditionalXmlConfigurationTransforms": "",
};
var CustomDirectoryEdit = (function (_super) {
    __extends(CustomDirectoryEdit, _super);
    function CustomDirectoryEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomDirectoryEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    CustomDirectoryEdit.prototype.summary = function () {
        if (this.props.properties["Octopus.Action.Package.CustomInstallationDirectory"]) {
            var nodes = [];
            nodes.push(React.createElement("span", null,
                "Package will be installed to ",
                React.createElement("strong", null, this.props.properties["Octopus.Action.Package.CustomInstallationDirectory"])));
            if (this.props.properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] === "True") {
                nodes.push(React.createElement("span", null, ", the directory will be purged before deployment"));
            }
            return form_1.Summary.summary(React.Children.toArray(nodes));
        }
        return form_1.Summary.placeholder(React.createElement("span", null, "Package will be installed to the standard location"));
    };
    CustomDirectoryEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var purge = properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"];
        var showExclude = purge && purge !== "False";
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.CustomInstallationDirectory|Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions", title: "Custom Install Directory", summary: this.summary(), help: "Enter a custom installation directory." },
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.CustomInstallationDirectory"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomInstallationDirectory"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.Package.CustomInstallationDirectory"), label: "Install to" }),
            React.createElement(Note_1.default, null, "After the package is extracted, it will be copied to this location on the remote machine."),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", value: properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] = x, _a));
                    var _a;
                }, label: "Purge this directory before installation" }),
            React.createElement(Note_1.default, null, "Before the contents of the extracted package is copied, all files in this location will be removed."),
            showExclude &&
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"] = x, _a));
                        var _a;
                    }, multiLine: true, error: this.props.getFieldError("Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"), label: "Exclude from purge" }),
            showExclude && React.createElement(Note_1.default, null,
                "A newline-separated list of file or directory names, relative to the installation directory, to leave when it is purged. To exclude a whole directory, specify it by name without a wildcard. Extended wildcard syntax is supported. E.g., ",
                React.createElement("em", null, "appsettings.config"),
                ", ",
                React.createElement("em", null, "Config"),
                ", ",
                React.createElement("em", null, "Config\\*.config"),
                ", ",
                React.createElement("em", null, "**\\*.config")));
    };
    return CustomDirectoryEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.CustomDirectory",
    title: "Custom installation directory",
    description: "Change where Tentacle extracts your package",
    edit: CustomDirectoryEdit,
    priority: 5,
    disable: function (properties) {
        /*
            The java package deployment and this feature share the following properties. We can't
            delete them from the global properties object if UseCustomInstallationDirectory is defined.
         */
        if (properties["Octopus.Action.Package.UseCustomInstallationDirectory"] !== "True") {
            delete properties["Octopus.Action.Package.CustomInstallationDirectory"];
            delete properties["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"];
        }
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\customDirectory\\customDirectory.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\customDirectory\\customDirectory.tsx"); } } })();

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var CodeEditor_1 = __webpack_require__(119);
var Note_1 = __webpack_require__(22);
var scriptingLanguage_1 = __webpack_require__(140);
var ScriptingLanguageSelector_1 = __webpack_require__(450);
var ExpandableFormSection_1 = __webpack_require__(44);
var CustomScriptsEdit = (function (_super) {
    __extends(CustomScriptsEdit, _super);
    function CustomScriptsEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.syntaxExtensions = (_a = {}, _a[scriptingLanguage_1.ScriptingLanguage.PowerShell] = "ps1", _a[scriptingLanguage_1.ScriptingLanguage.CSharp] = "csx", _a[scriptingLanguage_1.ScriptingLanguage.Bash] = "sh", _a[scriptingLanguage_1.ScriptingLanguage.FSharp] = "fsx", _a);
        _this.extensionSyntaxes = { ps1: scriptingLanguage_1.ScriptingLanguage.PowerShell, csx: scriptingLanguage_1.ScriptingLanguage.CSharp, sh: scriptingLanguage_1.ScriptingLanguage.Bash, fsx: scriptingLanguage_1.ScriptingLanguage.FSharp };
        _this.customScriptPrefix = "Octopus.Action.CustomScripts.";
        _this.state = {
            PreDeploy: scriptingLanguage_1.ScriptingLanguage.PowerShell,
            Deploy: scriptingLanguage_1.ScriptingLanguage.PowerShell,
            PostDeploy: scriptingLanguage_1.ScriptingLanguage.PowerShell
        };
        return _this;
        var _a;
    }
    CustomScriptsEdit.prototype.componentDidMount = function () {
        var PreDeploy = this.lookupScriptSyntax("PreDeploy");
        var Deploy = this.lookupScriptSyntax("Deploy");
        var PostDeploy = this.lookupScriptSyntax("PostDeploy");
        this.setState({
            PreDeploy: PreDeploy,
            Deploy: Deploy,
            PostDeploy: PostDeploy
        });
    };
    CustomScriptsEdit.prototype.lookupScriptSyntax = function (scriptType) {
        var _this = this;
        // find the script variable, for Deploy it will look like Octopus.Action.CustomScripts.Deploy.{ps1|sh|csx|fsx}
        var syntax = scriptingLanguage_1.ScriptingLanguage.PowerShell;
        Object.keys(this.extensionSyntaxes).forEach(function (k) {
            var name = _this.customScriptPrefix + scriptType + "." + k;
            if (_this.props.properties.hasOwnProperty(name)) {
                syntax = _this.extensionSyntaxes[k];
            }
        });
        return syntax;
    };
    CustomScriptsEdit.prototype.syntaxChanged = function (scriptType, syntax, scriptBody) {
        var _this = this;
        // if changing from say ps1 to sh we need to delete Octopus.Action.CustomScripts.Deploy.ps1 and add Octopus.Action.CustomScripts.Deploy.sh
        var props = this.props.properties;
        Object.keys(this.extensionSyntaxes).forEach(function (k) {
            var name = _this.customScriptPrefix + scriptType + "." + k;
            if (_this.extensionSyntaxes[k] !== syntax && _this.props.properties.hasOwnProperty(name)) {
                delete props[name];
            }
        });
        props[this.customScriptPrefix + scriptType + "." + this.syntaxExtensions[syntax]] = scriptBody;
        this.props.setProperties(props);
        this.setState((_a = {},
            _a[scriptType] = syntax,
            _a));
        var _a;
    };
    CustomScriptsEdit.prototype.renderScriptSection = function (scriptType) {
        var _this = this;
        var syntax = this.state[scriptType];
        var scriptBody = this.getScriptBody(scriptType);
        return React.createElement("div", null,
            React.createElement(ScriptingLanguageSelector_1.default, { value: syntax, onChange: function (value) { return _this.syntaxChanged(scriptType, value, scriptBody); } }),
            React.createElement(CodeEditor_1.VariableLookupCodeEditor, { localNames: this.props.localNames, projectId: this.props.projectId, syntax: syntax, value: scriptBody, language: syntax, allowFullScreen: true, onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a[_this.customScriptPrefix + scriptType + "." + _this.syntaxExtensions[syntax]] = x, _a));
                    var _a;
                } }));
    };
    CustomScriptsEdit.prototype.getScriptBody = function (scriptType) {
        return this.props.properties[this.customScriptPrefix + scriptType + "." + this.syntaxExtensions[this.state[scriptType]]];
    };
    CustomScriptsEdit.prototype.summary = function () {
        var preDeploy = this.getScriptBody("PreDeploy");
        var deploy = this.getScriptBody("Deploy");
        var postDeploy = this.getScriptBody("PostDeploy");
        var configured = [];
        if (preDeploy) {
            configured.push("Pre-deploy");
        }
        if (deploy) {
            configured.push("Deploy");
        }
        if (postDeploy) {
            configured.push("Post-deploy");
        }
        if (configured.length === 0) {
            return form_1.Summary.placeholder("No scripts have been configured");
        }
        if (configured.length === 1) {
            return form_1.Summary.summary("A script will be run as part of the " + configured[0] + " phase");
        }
        if (configured.length === 2) {
            return form_1.Summary.summary("Scripts will be run as part of the " + configured[0] + " and " + configured[1] + " phases");
        }
        if (configured.length === 3) {
            return form_1.Summary.summary("Scripts will be run as part of the " + configured[0] + ", " + configured[1] + " and " + configured[2] + " phases");
        }
    };
    CustomScriptsEdit.prototype.render = function () {
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "customScripts", title: "Configuration Scripts", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, summary: this.summary(), help: "Configure scripts to run as part of this step." },
            React.createElement("strong", null, "Pre-deployment script"),
            React.createElement(Note_1.default, null, "This script will run after the package is extracted, but before any configuration changes are made."),
            this.renderScriptSection("PreDeploy"),
            React.createElement("br", null),
            React.createElement("strong", null, "Deployment script"),
            React.createElement(Note_1.default, null, "This script will run after XML configuration changes are made, but before any IIS or Windows Service changes are made."),
            this.renderScriptSection("Deploy"),
            React.createElement("br", null),
            React.createElement("strong", null, "Post-deployment script"),
            React.createElement(Note_1.default, null, "This script will run after IIS or Windows Service changes are made."),
            this.renderScriptSection("PostDeploy"));
    };
    return CustomScriptsEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.CustomScripts",
    title: "Custom deployment scripts",
    description: "Execute scripts during the deployment, without embedding them in your package",
    edit: CustomScriptsEdit,
    priority: 10,
    disable: function (properties) {
        Object.keys(properties).filter(function (name) {
            return name.indexOf("Octopus.Action.CustomScripts.") === 0;
        }).forEach(function (name) {
            delete properties[name];
        });
    },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\customScripts\\customScripts.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\customScripts\\customScripts.tsx"); } } })();

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var Text_1 = __webpack_require__(17);
var Note_1 = __webpack_require__(22);
var StringCheckbox_1 = __webpack_require__(38);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var StringProperties = {
    "Octopus.Action.Package.UpdateIisWebsite": "",
    "Octopus.Action.Package.UpdateIisWebsiteName": "",
};
var IISHomeEdit = (function (_super) {
    __extends(IISHomeEdit, _super);
    function IISHomeEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IISHomeEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    IISHomeEdit.prototype.summary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Package.UpdateIisWebsite"] !== "False") {
            if (properties["Octopus.Action.Package.UpdateIisWebsiteName"]) {
                return form_1.Summary.summary("Octopus will update the IIS website " + properties["Octopus.Action.Package.UpdateIisWebsiteName"]);
            }
            else {
                return form_1.Summary.summary("Octopus will find an IIS website based on the package name and attempt to update it");
            }
        }
        else {
            return form_1.Summary.placeholder("The IIS home directory will not be configured");
        }
    };
    IISHomeEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.UpdateIisWebsite|Octopus.Action.Package.UpdateIisWebsite", title: "IIS Home Directory", summary: this.summary(), help: "Configure whether we should automatically update IIS." },
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", value: properties["Octopus.Action.Package.UpdateIisWebsite"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.UpdateIisWebsite"] = x, _a));
                    var _a;
                }, label: "Attempt to automatically update IIS" }),
            React.createElement(Note_1.default, null, "Tentacle will look in IIS for a website with the same name as the current package (or the custom name below) and will attempt to change the home directory to point to the folder that the package was extracted to."),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.UpdateIisWebsiteName"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.UpdateIisWebsiteName"] = x, _a));
                    var _a;
                }, multiLine: true, error: this.props.getFieldError("Octopus.Action.Package.UpdateIisWebsiteName"), label: "Site/virtual directory" }),
            React.createElement(Note_1.default, null,
                "The name of the IIS website, or virtual directory path, to attempt to update. To specify a virtual directory, use the format:",
                React.createElement("pre", null, "WebsiteName/VirtualDirectory1/VirtualDirectory2"),
                "If no name is specified, Tentacle will look for an IIS site named with the same name as the package ID."));
    };
    return IISHomeEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.IisHome",
    title: "IIS6+ home directory",
    description: "Points an existing IIS website or virtual directory's 'Home' directory to the path the package was extracted to" +
        " (**not** compatible with the _IIS web site_ feature)",
    edit: IISHomeEdit,
    priority: 30,
    enable: function (properties) {
        properties["Octopus.Action.Package.UpdateIisWebsite"] = "True";
    },
    disable: function (properties) {
        delete properties["Octopus.Action.Package.UpdateIisWebsite"];
        delete properties["Octopus.Action.Package.UpdateIisWebsiteName"];
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\iisHome\\iisHome.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\iisHome\\iisHome.tsx"); } } })();

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ExternalLink_1 = __webpack_require__(29);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var bindingHelpers_1 = __webpack_require__(1990);
var isBound_1 = __webpack_require__(84);
var Note_1 = __webpack_require__(22);
var RadioButtonGroup_1 = __webpack_require__(33);
var RadioButton_1 = __webpack_require__(36);
var StringCheckbox_1 = __webpack_require__(38);
var Text_1 = __webpack_require__(17);
var Callout_1 = __webpack_require__(81);
var applicationPool_1 = __webpack_require__(1991);
var RemoveItemsList_1 = __webpack_require__(142);
var Button_1 = __webpack_require__(51);
var lodash_1 = __webpack_require__(16);
var bindingDialog_1 = __webpack_require__(1992);
var ThumbprintText_1 = __webpack_require__(449);
var DialogOpener_1 = __webpack_require__(436);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var BindingList = (function (_super) {
    __extends(BindingList, _super);
    function BindingList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BindingList;
}(RemoveItemsList_1.RemoveItemsList));
var StringProperties = {
    "Octopus.Action.IISWebSite.DeploymentType": "",
    "Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate": "",
    "Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName": "",
    "Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath": "",
    "Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath": "",
    "Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate": "",
    "Octopus.Action.IISWebSite.WebApplication.WebSiteName": "",
    "Octopus.Action.IISWebSite.WebApplication.VirtualPath": "",
    "Octopus.Action.IISWebSite.WebApplication.PhysicalPath": "",
    "Octopus.Action.IISWebSite.CreateOrUpdateWebSite": "",
    "Octopus.Action.IISWebSite.StartApplicationPool": "",
    "Octopus.Action.IISWebSite.StartWebSite": "",
    "Octopus.Action.IISWebSite.Bindings": "",
    "Octopus.Action.IISWebSite.WebRootType": "",
    "Octopus.Action.IISWebSite.WebSiteName": "",
    "Octopus.Action.IISWebSite.WebRoot": "",
    "Octopus.Action.IISWebSite.EnableAnonymousAuthentication": "",
    "Octopus.Action.IISWebSite.EnableBasicAuthentication": "",
    "Octopus.Action.IISWebSite.EnableWindowsAuthentication": "",
    "Octopus.Action.IISWebSite.ApplicationPoolName": "",
    "Octopus.Action.IISWebSite.ApplicationPoolFrameworkVersion": "",
    "Octopus.Action.IISWebSite.ApplicationPoolIdentityType": "",
    "Octopus.Action.IISWebSite.ApplicationPoolUsername": "",
    "Octopus.Action.IISWebSite.ApplicationPoolPassword": "",
    "Octopus.Action.IISWebSite.WebApplication.ApplicationPoolName": "",
    "Octopus.Action.IISWebSite.WebApplication.ApplicationPoolFrameworkVersion": "",
    "Octopus.Action.IISWebSite.WebApplication.ApplicationPoolIdentityType": "",
    "Octopus.Action.IISWebSite.WebApplication.ApplicationPoolUsername": "",
    "Octopus.Action.IISWebSite.WebApplication.ApplicationPoolPassword": "",
    "Octopus.Action.WebApplication.WebRootType": ""
};
var IISWebSiteEdit = (function (_super) {
    __extends(IISWebSiteEdit, _super);
    function IISWebSiteEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.projectVariablesUnavailable = function () {
            return (!_this.props.projectId);
        };
        _this.handleWebRootTypeChanged = function (type, property, resetProperty) {
            _this.props.setProperties((_a = {}, _a[property] = type, _a));
            switch (type) {
                case "packageRoot": {
                    _this.resetPhysicalPath(resetProperty);
                }
            }
            var _a;
        };
        _this.handleDeploymentTypeChanged = function (type) {
            switch (type) {
                case "webSite": {
                    _this.selectWebSite();
                    break;
                }
                case "virtualDirectory": {
                    _this.selectVirtualDirectory();
                    break;
                }
                case "webApplication": {
                    _this.selectWebApplication();
                    break;
                }
            }
        };
        _this.selectVirtualDirectory = function () {
            _this.props.setProperties((_a = {},
                _a["Octopus.Action.IISWebSite.DeploymentType"] = "virtualDirectory",
                _a["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = "True",
                _a["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = "False",
                _a["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = "False",
                _a));
            var _a;
        };
        _this.selectWebSite = function () {
            _this.props.setProperties((_a = {},
                _a["Octopus.Action.IISWebSite.DeploymentType"] = "webSite",
                _a["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = "False",
                _a["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = "False",
                _a["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = "True",
                _a));
            var _a;
        };
        _this.selectWebApplication = function () {
            _this.props.setProperties((_a = {},
                _a["Octopus.Action.IISWebSite.DeploymentType"] = "webApplication",
                _a["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = "False",
                _a["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = "True",
                _a["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = "False",
                _a));
            var _a;
        };
        _this.checkWebSiteName = function (name) {
            _this.setState({ looksLikeVDir: name && (name.indexOf("/") !== -1 || name.indexOf("\\") !== -1) });
        };
        _this.checkWebRoot = function (path) {
            _this.setState({ looksLikeFullPath: path && path.indexOf(":") !== -1 });
        };
        _this.resetPhysicalPath = function (variableName) {
            _this.props.setProperties((_a = {}, _a[variableName] = "", _a));
            _this.setState({ looksLikeFullPath: false });
            var _a;
        };
        _this.removeBinding = function (b) {
            var bindings = _this.state.iisBindings.slice();
            bindings.splice(_this.state.iisBindings.indexOf(b), 1);
            _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.Bindings"] = bindingHelpers_1.bindingsToString(bindings), _a));
            var _a;
        };
        _this.editBinding = function (binding) {
            _this.setState({
                editBinding: lodash_1.clone(binding),
                editBindingIndex: _this.state.iisBindings.indexOf(binding)
            });
        };
        _this.addBinding = function () {
            var binding = {
                protocol: "http",
                port: "80",
                ipAddress: "*",
                host: "",
                thumbprint: null,
                enabled: true,
                requireSni: false
            };
            _this.setState({
                editBinding: binding,
                editBindingIndex: null
            });
        };
        _this.resetSelectedBinding = function () {
            _this.setState({
                editBinding: null,
                editBindingIndex: null
            });
        };
        _this.isPropTrue = function (name) {
            if (_this.props.properties[name]) {
                return _this.props.properties[name] === "True";
            }
            return true;
        };
        _this.state = {
            looksLikeVDir: false,
            looksLikeFullPath: false,
            isIISStep: false,
            iisBindings: [],
            editBinding: null,
            editBindingIndex: null,
            certificateMode: { managedByOctopus: false }
        };
        return _this;
    }
    IISWebSiteEdit.prototype.shouldComponentUpdate = function (newProps, newState) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, newProps, this.props) || !lodash_1.isEqual(newState, this.state);
    };
    IISWebSiteEdit.prototype.saveBinding = function (binding) {
        var bindings = this.state.iisBindings.slice();
        if (this.state.editBindingIndex === null) {
            bindings.push(binding);
        }
        else {
            bindings[this.state.editBindingIndex] = binding;
        }
        this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.Bindings"] = bindingHelpers_1.bindingsToString(bindings), _a));
        this.resetSelectedBinding();
        return true;
        var _a;
    };
    IISWebSiteEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var hasPhysicalPath, _a, _b, _c, _d;
                            return __generator(this, function (_e) {
                                if (!this.props.properties["Octopus.Action.IISWebSite.DeploymentType"]) {
                                    this.selectWebSite();
                                }
                                hasPhysicalPath = this.props.properties["Octopus.Action.IISWebSite.WebRoot"] ||
                                    this.props.properties["Octopus.Action.IISWebSite.WebApplication.PhysicalPath"] ||
                                    this.props.properties["Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"];
                                if (!this.props.properties["Octopus.Action.IISWebSite.WebRootType"] && hasPhysicalPath) {
                                    this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebRootType"] = "relativeToPackageRoot", _a));
                                }
                                else if (!this.props.properties["Octopus.Action.IISWebSite.WebRootType"] && !hasPhysicalPath) {
                                    this.props.setProperties((_b = {}, _b["Octopus.Action.IISWebSite.WebRootType"] = "packageRoot", _b));
                                }
                                if (!this.props.properties["Octopus.Action.IISWebSite.StartApplicationPool"]) {
                                    this.props.setProperties((_c = {}, _c["Octopus.Action.IISWebSite.StartApplicationPool"] = "True", _c));
                                }
                                if (!this.props.properties["Octopus.Action.IISWebSite.StartWebSite"]) {
                                    this.props.setProperties((_d = {}, _d["Octopus.Action.IISWebSite.StartWebSite"] = "True", _d));
                                }
                                this.setState({
                                    isIISStep: this.props.plugin.actionType === "Octopus.IIS",
                                    iisBindings: !!this.props.properties["Octopus.Action.IISWebSite.Bindings"] ? bindingHelpers_1.bindingsFromString(this.props.properties["Octopus.Action.IISWebSite.Bindings"]) : []
                                });
                                return [2 /*return*/];
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IISWebSiteEdit.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.properties["Octopus.Action.IISWebSite.Bindings"] !== nextProps.properties["Octopus.Action.IISWebSite.Bindings"]) {
            this.setState({ iisBindings: bindingHelpers_1.bindingsFromString(nextProps.properties["Octopus.Action.IISWebSite.Bindings"]) });
        }
    };
    IISWebSiteEdit.prototype.deploymentTypeSummary = function () {
        var type = this.props.properties["Octopus.Action.IISWebSite.DeploymentType"];
        if (type === "webSite") {
            return form_1.Summary.summary("IIS Web Site");
        }
        else if (type === "virtualDirectory") {
            return form_1.Summary.summary("IIS Virtual Directory");
        }
        else if (type === "webApplication") {
            return form_1.Summary.summary("IIS Web Application");
        }
        return form_1.Summary.placeholder("Deployment type not configured");
    };
    IISWebSiteEdit.prototype.webSiteSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] === "False") {
            return form_1.Summary.placeholder("The web site will not be created or updated");
        }
        if (!properties["Octopus.Action.IISWebSite.WebSiteName"]) {
            return form_1.Summary.placeholder("The web site name has not been configured");
        }
        var nodes = [];
        nodes.push(React.createElement("span", null,
            "Web site ",
            React.createElement("strong", null, properties["Octopus.Action.IISWebSite.WebSiteName"]),
            " will be created or updated"));
        if (properties["Octopus.Action.IISWebSite.WebRootType"] === "packageRoot") {
            nodes.push(React.createElement("span", null, ". Content will be served from the root of the installation directory"));
        }
        else {
            nodes.push(React.createElement("span", null,
                ". Content will be served from ",
                React.createElement("strong", null, properties["Octopus.Action.IISWebSite.WebRoot"] || "/"),
                " relative to the installation directory"));
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    IISWebSiteEdit.prototype.authenticationSummary = function () {
        var modes = [];
        if (this.props.properties["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"] !== "False") {
            modes.push("Anonymous");
        }
        if (this.props.properties["Octopus.Action.IISWebSite.EnableBasicAuthentication"] !== "False") {
            modes.push("Basic");
        }
        if (this.props.properties["Octopus.Action.IISWebSite.EnableWindowsAuthentication"] !== "False") {
            modes.push("Windows");
        }
        if (modes.length === 0) {
            return form_1.Summary.placeholder("No authentication modes are enabled");
        }
        if (modes.length === 1) {
            return form_1.Summary.summary(React.createElement("span", null,
                React.createElement("strong", null, modes[0]),
                " authentication mode will be enabled"));
        }
        if (modes.length === 2) {
            return form_1.Summary.summary(React.createElement("span", null,
                React.createElement("strong", null, modes[0]),
                " and ",
                React.createElement("strong", null, modes[1]),
                " authentication modes will be enabled"));
        }
        if (modes.length === 3) {
            return form_1.Summary.summary(React.createElement("span", null,
                React.createElement("strong", null, modes[0]),
                ", ",
                React.createElement("strong", null, modes[1]),
                " and ",
                React.createElement("strong", null, modes[2]),
                " authentication modes will be enabled"));
        }
    };
    IISWebSiteEdit.prototype.bindingsSummary = function () {
        var length = this.state.iisBindings.length;
        if (length === 0) {
            return form_1.Summary.placeholder("No bindings have been configured");
        }
        var first = this.state.iisBindings[0];
        var address = first.ipAddress || "*";
        var summary = first.protocol + "://" + address + ":" + first.port;
        var nodes = [];
        nodes.push(React.createElement("span", null,
            "The site will listen on ",
            React.createElement("strong", null, summary)));
        if (length === 2) {
            nodes.push(React.createElement("span", null, " and one other binding"));
        }
        if (length > 2) {
            nodes.push(React.createElement("span", null,
                " and ",
                length - 1,
                " other bindings"));
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    IISWebSiteEdit.prototype.virtualDirectorySummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] === "False") {
            return form_1.Summary.placeholder("The virtual directory will not be created or updated");
        }
        if (!properties["Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName"]) {
            return form_1.Summary.summary("The parent web site name has not been configured");
        }
        if (!properties["Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath"]) {
            return form_1.Summary.summary("The virtual path has not been configured");
        }
        var nodes = [];
        nodes.push(React.createElement("span", null,
            "The virtual directory will be created under parent site ",
            React.createElement("strong", null, properties["Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName"])));
        nodes.push(React.createElement("span", null,
            " at virtual path ",
            React.createElement("strong", null, properties["Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath"])));
        if (properties["Octopus.Action.IISWebSite.WebRootType"] === "packageRoot") {
            nodes.push(React.createElement("span", null, ". Content will be served from the root of the installation directory"));
        }
        else {
            nodes.push(React.createElement("span", null,
                ". Content will be served from ",
                React.createElement("strong", null, properties["Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"] || "/"),
                " relative to the installation directory"));
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    IISWebSiteEdit.prototype.webApplicationSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] === "False") {
            return form_1.Summary.placeholder("The web application will not be created or updated");
        }
        if (!properties["Octopus.Action.IISWebSite.WebApplication.WebSiteName"]) {
            return form_1.Summary.summary("The parent web site name has not been configured");
        }
        if (!properties["Octopus.Action.IISWebSite.WebApplication.VirtualPath"]) {
            return form_1.Summary.summary("The virtual path has not been configured");
        }
        var nodes = [];
        nodes.push(React.createElement("span", null,
            "The web application will be created under parent site ",
            React.createElement("strong", null, properties["Octopus.Action.IISWebSite.WebApplication.WebSiteName"])));
        nodes.push(React.createElement("span", null,
            " at virtual path ",
            React.createElement("strong", null, properties["Octopus.Action.IISWebSite.WebApplication.VirtualPath"])));
        if (properties["Octopus.Action.WebApplication.WebRootType"] === "packageRoot") {
            nodes.push(React.createElement("span", null, ". Content will be served from the root of the installation directory"));
        }
        else {
            nodes.push(React.createElement("span", null,
                ". Content will be served from ",
                React.createElement("strong", null, properties["Octopus.Action.IISWebSite.WebApplication.PhysicalPath"] || "/"),
                " relative to the installation directory"));
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    IISWebSiteEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var editBindingDialog = React.createElement(DialogOpener_1.default, { open: !!this.state.editBinding, onClose: this.resetSelectedBinding },
            React.createElement(bindingDialog_1.default, { binding: this.state.editBinding, projectId: this.props.projectId, doBusyTask: this.props.doBusyTask, localNames: this.props.localNames, onAdd: function (binding) { return _this.saveBinding(binding); } }));
        return React.createElement("div", null,
            editBindingDialog,
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.IISWebSite.DeploymentType", title: "IIS Deployment Type", summary: this.deploymentTypeSummary(), help: "Configure the type of deployment." },
                React.createElement(Note_1.default, null,
                    "Learn more about deploying ",
                    React.createElement(ExternalLink_1.default, { href: "IISWebsitesAndApplications" }, "IIS Websites and Applications"),
                    "."),
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: properties["Octopus.Action.IISWebSite.DeploymentType"], error: this.props.getFieldError("Octopus.Action.IISWebSite.DeploymentType"), onChange: function (val) { return _this.handleDeploymentTypeChanged(val); } },
                    React.createElement(RadioButton_1.default, { value: "webSite", label: "IIS Web Site" }),
                    React.createElement(Note_1.default, null, "Create or update an IIS Web Site"),
                    React.createElement(RadioButton_1.default, { value: "virtualDirectory", label: "IIS Virtual Directory" }),
                    React.createElement(Note_1.default, null, "Create or update an IIS Virtual Directory as a child of an existing IIS Web Site"),
                    React.createElement(RadioButton_1.default, { value: "webApplication", label: "IIS Web Application" }),
                    React.createElement(Note_1.default, null, "Create or update an IIS Web Application as a child of an existing IIS Web Site"))),
            properties["Octopus.Action.IISWebSite.DeploymentType"] === "webSite" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.IISWebSite.WebSiteName|Octopus.Action.IISWebSite.WebRoot", title: "Web Site", summary: this.webSiteSummary(), help: "Configure the details of the IIS Web Site." },
                    !this.state.isIISStep && React.createElement("div", null,
                        React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "False", value: properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = x, _a));
                                var _a;
                            }, label: "Create or update an IIS Web Site and Application Pool", note: React.createElement("span", null, "If enabled, Tentacle will use the PowerShell Web Administration module to attempt to create or modify an IIS Web Site and Application Pool using the settings below.") })),
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.WebSiteName"], onChange: function (x) {
                            _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebSiteName"] = x, _a));
                            _this.checkWebSiteName(x);
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.IISWebSite.WebSiteName"), label: "Web site name" }),
                    this.state.looksLikeVDir && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                        "Hey there! It looks like you might be trying to configure a Virtual Directory. ",
                        React.createElement("em", null, "IIS Web Site"),
                        " doesn't support Virtual Directories. You might consider using either the ",
                        React.createElement("em", null, "IIS Virtual Directory"),
                        " or ",
                        React.createElement("em", null, "IIS Web Application"),
                        " deployment type for that, or check ",
                        React.createElement(ExternalLink_1.default, { href: "https://library.octopusdeploy.com" }, "the template library"),
                        " for more options."),
                    React.createElement(Note_1.default, null, "The display name of the IIS Web Site to create or reconfigure."),
                    React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { label: "Physical path", value: properties["Octopus.Action.IISWebSite.WebRootType"], error: this.props.getFieldError("Octopus.Action.IISWebSite.WebRootType"), onChange: function (val) { return _this.handleWebRootTypeChanged(val, "Octopus.Action.IISWebSite.WebRootType", "Octopus.Action.IISWebSite.WebRoot"); } },
                        React.createElement(RadioButton_1.default, { value: "packageRoot", label: "Package installation directory" }),
                        React.createElement(Note_1.default, null,
                            " Configure this IIS Web Site to serve content from the folder that Octopus extracted the package to, or the ",
                            React.createElement("em", null,
                                React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory")),
                            " if specified."),
                        React.createElement(RadioButton_1.default, { value: "relativeToPackageRoot", label: "Relative path under package installation directory" }),
                        properties["Octopus.Action.IISWebSite.WebRootType"] === "relativeToPackageRoot" &&
                            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.WebRoot"], onChange: function (x) {
                                    _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebRoot"] = x, _a));
                                    _this.checkWebRoot(x);
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.IISWebSite.WebRoot"), label: "Package installation directory" }),
                        this.state.looksLikeFullPath && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                            "Hey there! It looks like you might be trying to configure the ",
                            React.createElement("em", null, "Physical Path"),
                            " as an absolute path. This will only work if the ",
                            React.createElement("em", null,
                                React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory")),
                            " feature is enabled or if you are serving content that is not part of your package."),
                        React.createElement(Note_1.default, null,
                            "Configure this IIS Web Site to serve content from a path that is relative to the folder that Octopus extracted the package to, or the ",
                            React.createElement("em", null,
                                React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory")),
                            " if specified.")),
                    React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "False", value: this.props.properties["Octopus.Action.IISWebSite.StartWebSite"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.StartWebSite"] = x, _a));
                            var _a;
                        }, label: "Start IIS Web Site" }),
                    React.createElement(Note_1.default, null, "Whether the deployment step should start the IIS Web Site after a successful deployment or not.")),
                React.createElement(applicationPool_1.default, { properties: this.props.properties, setProperties: this.props.setProperties, projectId: this.props.projectId, localNames: this.props.localNames, pathToRootProperty: "Octopus.Action.IISWebSite", getFieldError: this.props.getFieldError }),
                React.createElement(form_1.ExpandableFormSection, { errorKey: "bindings", title: "Bindings", summary: this.bindingsSummary(), help: "Bindings define what protocols, ports and host names this site will listen on" },
                    React.createElement(BindingList, { listActions: [React.createElement(Button_1.default, { key: "add", label: "Add", onClick: function () { return _this.addBinding(); } })], data: this.state.iisBindings, onRow: function (binding) { return React.createElement("div", null,
                            binding.protocol && React.createElement("p", null,
                                "Protocol: ",
                                React.createElement("strong", null, binding.protocol)),
                            binding.port && React.createElement("p", null,
                                "Port: ",
                                React.createElement("strong", null, binding.port)),
                            binding.ipAddress && React.createElement("p", null,
                                "IP Address: ",
                                React.createElement("strong", null, binding.ipAddress)),
                            binding.host && React.createElement("p", null,
                                "Host: ",
                                React.createElement("strong", null, binding.host)),
                            binding.thumbprint && React.createElement("p", null,
                                "SSL certificate thumbprint: ",
                                React.createElement(ThumbprintText_1.default, { thumbprint: binding.thumbprint })),
                            binding.certificateVariable && React.createElement("p", null,
                                "SSL certificate variable: ",
                                React.createElement("strong", null, binding.certificateVariable)),
                            binding.requireSni && React.createElement("p", null,
                                "Require Server Name Indication (SNI): ",
                                React.createElement("strong", null, binding.requireSni))); }, onRowTouch: function (binding) { return _this.editBinding(binding); }, onRemoveRow: function (binding) { return _this.removeBinding(binding); } })),
                React.createElement(form_1.ExpandableFormSection, { errorKey: "iisauthentication", title: "IIS Authentication", summary: this.authenticationSummary(), help: "Set which authentication modes will be enabled in IIS." },
                    React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "False", value: properties["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"] = x, _a));
                            var _a;
                        }, label: "Enable Anonymous authentication", note: React.createElement("span", null, "Whether IIS should allow anonymous authentication.") }),
                    React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "False", value: properties["Octopus.Action.IISWebSite.EnableBasicAuthentication"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.EnableBasicAuthentication"] = x, _a));
                            var _a;
                        }, label: "Enable Basic authentication", note: React.createElement("span", null, "Whether IIS should allow basic authentication with a 401 challenge.") }),
                    React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "False", value: properties["Octopus.Action.IISWebSite.EnableWindowsAuthentication"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.EnableWindowsAuthentication"] = x, _a));
                            var _a;
                        }, label: "Enable Windows authentication", note: React.createElement("span", null, "Whether IIS should allow integrated Windows authentication with a 401 challenge.") }))),
            properties["Octopus.Action.IISWebSite.DeploymentType"] === "virtualDirectory" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName|Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath", title: "Virtual Directory", summary: this.virtualDirectorySummary(), help: "Configure the details of the IIS Virtual Directory." },
                    !this.state.isIISStep && React.createElement("div", null,
                        React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "False", value: properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = x, _a));
                                var _a;
                            }, label: "Create or update an IIS Virtual Directory", note: React.createElement("span", null, "If enabled, Tentacle will use the PowerShell Web Administration module to attempt to create or modify an IIS Virtual Directory and Application Pool using the settings below.") })),
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName"], onChange: function (x) {
                            _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName"] = x, _a));
                            _this.checkWebSiteName(x);
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName"), label: "Parent web site name" }),
                    this.state.looksLikeVDir && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information }, "Hey there! It looks like you might be trying to enter a Virtual Directory. Enter the parent web site name in this field, and the virtual path details below."),
                    React.createElement(Note_1.default, null, "The name of the parent Web Site for this Virtual Directory in IIS. The Web Site should already exist when this step runs."),
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath"], onChange: function (x) {
                            _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath"] = x, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath"), label: "Virtual path" }),
                    React.createElement(Note_1.default, null,
                        "The virtual path in IIS relative to the parent Web Site. E.g. ",
                        React.createElement("code", null, "/application1/directory2/mydirectory"),
                        ".",
                        React.createElement("br", null),
                        "Note: All parent directories/applications must already exist."),
                    React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { label: "Physical path", value: properties["Octopus.Action.IISWebSite.WebRootType"], error: this.props.getFieldError("Octopus.Action.IISWebSite.WebRootType"), onChange: function (val) { return _this.handleWebRootTypeChanged(val, "Octopus.Action.IISWebSite.WebRootType", "Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"); } },
                        React.createElement(RadioButton_1.default, { value: "packageRoot", label: "Package installation directory" }),
                        React.createElement(Note_1.default, null,
                            " Configure this IIS Web Site to serve content from the folder that Octopus extracted the package to, or the ",
                            React.createElement("em", null,
                                React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory")),
                            " if specified."),
                        React.createElement(RadioButton_1.default, { value: "relativeToPackageRoot", label: "Relative path under package installation directory" }),
                        properties["Octopus.Action.IISWebSite.WebRootType"] === "relativeToPackageRoot" &&
                            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"], onChange: function (x) {
                                    _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"] = x, _a));
                                    _this.checkWebRoot(x);
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"), label: "Package installation directory" }),
                        this.state.looksLikeFullPath && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                            "Hey there! It looks like you might be trying to configure the ",
                            React.createElement("em", null, "Physical Path"),
                            " as an absolute path. This will only work if the ",
                            React.createElement("em", null,
                                React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory")),
                            " feature is enabled or if you are serving content that is not part of your package."),
                        React.createElement(Note_1.default, null,
                            "Configure this Virtual Directory to serve content from a path that is relative to the folder that Octopus extracted the package to, or the ",
                            React.createElement("em", null,
                                React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory")),
                            " if specified.")))),
            properties["Octopus.Action.IISWebSite.DeploymentType"] === "webApplication" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.IISWebSite.WebApplication.WebSiteName|Octopus.Action.IISWebSite.WebApplication.VirtualPath", title: "Web Application", summary: this.webApplicationSummary(), help: "Configure the details of the IIS Web Application" },
                    !this.state.isIISStep && React.createElement("div", null,
                        React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "False", value: properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = x, _a));
                                var _a;
                            }, label: "Create or update an IIS Web Application", note: React.createElement("span", null, "If enabled, Tentacle will use the PowerShell Web Administration module to attempt to create or modify an IIS Web Application and Application Pool using the settings below.") })),
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.WebApplication.WebSiteName"], onChange: function (x) {
                            _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebApplication.WebSiteName"] = x, _a));
                            _this.checkWebSiteName(x);
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.IISWebSite.WebApplication.WebSiteName"), label: "Parent web site name" }),
                    this.state.looksLikeVDir && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information }, "Hey there! It looks like you might be trying to enter a Virtual Directory. Enter the parent web site name in this field, and the virtual path details below."),
                    React.createElement(Note_1.default, null, "The name of the parent Web Site for this Web Application in IIS. The Web Site should already exist when this step runs."),
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.WebApplication.VirtualPath"], onChange: function (x) {
                            _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebApplication.VirtualPath"] = x, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.IISWebSite.WebApplication.VirtualPath"), label: "Virtual path" }),
                    React.createElement(Note_1.default, null,
                        "The virtual path in IIS relative to the parent Web Site. E.g. ",
                        React.createElement("code", null, "/myapplication"),
                        ".",
                        React.createElement("br", null),
                        "Note: All parent directories/applications must already exist."),
                    React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { label: "Physical path", value: properties["Octopus.Action.WebApplication.WebRootType"], error: this.props.getFieldError("Octopus.Action.WebApplication.WebRootType"), onChange: function (val) { return _this.handleWebRootTypeChanged(val, "Octopus.Action.WebApplication.WebRootType", "Octopus.Action.IISWebSite.WebApplication.PhysicalPath"); } },
                        React.createElement(RadioButton_1.default, { value: "packageRoot", label: "Package installation directory" }),
                        React.createElement(Note_1.default, null,
                            " Configure this IIS Web Application to serve content from the folder that Octopus extracted the package to, or the ",
                            React.createElement("em", null,
                                React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory")),
                            " if specified."),
                        React.createElement(RadioButton_1.default, { value: "relativeToPackageRoot", label: "Relative path under package installation directory" }),
                        properties["Octopus.Action.WebApplication.WebRootType"] === "relativeToPackageRoot" &&
                            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.WebApplication.PhysicalPath"], onChange: function (x) {
                                    _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebApplication.PhysicalPath"] = x, _a));
                                    _this.checkWebRoot(x);
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.IISWebSite.WebApplication.PhysicalPath"), label: "Package installation directory" }),
                        this.state.looksLikeFullPath && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                            "Hey there! It looks like you might be trying to configure the ",
                            React.createElement("em", null, "Physical Path"),
                            " as an absolute path. This will only work if the ",
                            React.createElement("em", null,
                                React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory")),
                            " feature is enabled or if you are serving content that is not part of your package."),
                        React.createElement(Note_1.default, null,
                            "Configure this Web Application to serve content from a path that is relative to the folder that Octopus extracted the package to, or the ",
                            React.createElement("em", null,
                                React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory")),
                            " if specified."))),
                React.createElement(applicationPool_1.default, { properties: this.props.properties, setProperties: this.props.setProperties, projectId: this.props.projectId, localNames: this.props.localNames, pathToRootProperty: "Octopus.Action.IISWebSite.WebApplication", getFieldError: this.props.getFieldError })));
    };
    return IISWebSiteEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.IISWebSite",
    title: "IIS web site and application pool",
    description: "Creates or reconfigures an IIS website and application pool (requires IIS7+)",
    edit: IISWebSiteEdit,
    priority: 8,
    enable: function (properties) {
        properties["Octopus.Action.IISWebSite.DeploymentType"] = "webSite";
        properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = "True";
        properties["Octopus.Action.IISWebSite.Bindings"] = bindingHelpers_1.bindingsToString([{ protocol: "http", port: "80", host: "", enabled: true }]);
        setupApplicationPoolDefaults(properties, "Octopus.Action.IISWebSite");
        properties["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"] = "False";
        properties["Octopus.Action.IISWebSite.EnableBasicAuthentication"] = "False";
        properties["Octopus.Action.IISWebSite.EnableWindowsAuthentication"] = "True";
        setupApplicationPoolDefaults(properties, "Octopus.Action.IISWebSite.WebApplication");
        function setupApplicationPoolDefaults(p, pathToRootProperty) {
            p[pathToRootProperty + ".ApplicationPoolFrameworkVersion"] = "v4.0";
            p[pathToRootProperty + ".ApplicationPoolIdentityType"] = "ApplicationPoolIdentity";
        }
    },
    preSave: function (properties) {
        normalizeApplicationPoolData(properties, "Octopus.Action.IISWebSite");
        normalizeApplicationPoolData(properties, "Octopus.Action.IISWebSite.WebApplication");
        function normalizeApplicationPoolData(p, pathToRootProperty) {
            if (p[pathToRootProperty + ".ApplicationPoolIdentityType"] !== "SpecificUser" && !isBound_1.default(p[pathToRootProperty + ".ApplicationPoolIdentityType"])) {
                p[pathToRootProperty + ".ApplicationPoolUsername"] = null;
                p[pathToRootProperty + ".ApplicationPoolPassword"] = null;
            }
        }
    },
    disable: function (properties) {
        Object.keys(properties).filter(function (name) {
            return name.indexOf("Octopus.Action.IISWebSite.") === 0;
        }).forEach(function (name) {
            delete properties[name];
        });
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\iisWebSite\\iisWebSite.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\iisWebSite\\iisWebSite.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var bindingsFromString = function (bindingString) {
    try {
        var result = parseV2Format();
        if (typeof result === "object") {
            return result;
        }
        return parseV1Format();
    }
    catch (ex) {
        return parseV1Format();
    }
    function parseV1Format() {
        var map = function (b) {
            var bindingParts = b.split("/");
            var bindingInfo = bindingParts[1].split(":");
            var enabled = bindingParts.length >= 4 ? (bindingParts[3] === "True") : true;
            var requireSni = bindingParts.length >= 5 ? (bindingParts[4] === "True") : false;
            return {
                protocol: bindingParts[0],
                enabled: enabled,
                thumbprint: bindingParts[2],
                ipAddress: bindingInfo[0],
                port: bindingInfo[1],
                host: bindingInfo[2],
                requireSni: requireSni
            };
        };
        return bindingString.split("|").map(map);
    }
    function parseV2Format() {
        return JSON.parse(bindingString);
    }
};
exports.bindingsFromString = bindingsFromString;
var bindingsToString = function (bindings) {
    var map = function (b) {
        var isHttp = (b.protocol === "http");
        //strip http etc except inside #{...} variable declarations
        b.host = b.host
            .split(/(#{.*?})/g)
            .map(function (h) {
            return /^#{.*}$/.test(h)
                ? h
                : h.replace("//", "").replace("/", "").replace("https:", "").replace("http:", "");
        })
            .join("");
        return {
            protocol: b.protocol,
            ipAddress: b.ipAddress,
            port: b.port,
            host: b.host,
            thumbprint: isHttp ? null : b.thumbprint,
            certificateVariable: isHttp ? null : b.certificateVariable,
            requireSni: isHttp ? false : b.requireSni,
            enabled: b.enabled
        };
    };
    var result = bindings.map(map);
    return JSON.stringify(result);
};
exports.bindingsToString = bindingsToString;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\iisWebSite\\bindingHelpers.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\iisWebSite\\bindingHelpers.ts"); } } })();

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var form_1 = __webpack_require__(15);
var Text_1 = __webpack_require__(17);
var Note_1 = __webpack_require__(22);
var getResetValue_1 = __webpack_require__(397);
var Select_1 = __webpack_require__(41);
var isBound_1 = __webpack_require__(84);
var Sensitive_1 = __webpack_require__(82);
var StringCheckbox_1 = __webpack_require__(38);
var form_2 = __webpack_require__(15);
var applicationPool = function (props) {
    var fullPath = function (propertyName) {
        return props.pathToRootProperty + "." + propertyName;
    };
    var frameworkVersions = [
        { value: "v4.0", text: "v4.0" },
        { value: "v2.0", text: "v2.0" },
        { value: "No Managed Code", text: "No Managed Code" }
    ];
    var appPoolIdentities = [
        { value: "ApplicationPoolIdentity", text: "Application Pool Identity" },
        { value: "LocalService", text: "Local Service" },
        { value: "LocalSystem", text: "Local System" },
        { value: "NetworkService", text: "Network Service" },
        { value: "SpecificUser", text: "Custom user..." },
    ];
    var applicationPoolSummary = function () {
        if (!props.properties[fullPath("ApplicationPoolName")]) {
            return form_1.Summary.placeholder("The Application Pool has not been configured");
        }
        var nodes = [];
        nodes.push(React.createElement("span", null,
            "Application Pool ",
            React.createElement("strong", null, props.properties[fullPath("ApplicationPoolName")]),
            " will be created if required and used."));
        if (props.properties[fullPath("ApplicationPoolFrameworkVersion")] === "No Managed Code") {
            nodes.push(React.createElement("span", null, " It will be configured with no .NET CLR support"));
        }
        else {
            nodes.push(React.createElement("span", null,
                " The .NET framework version will be ",
                React.createElement("strong", null, props.properties[fullPath("ApplicationPoolFrameworkVersion")])));
        }
        var identity = appPoolIdentities.find(function (p) { return props.properties[fullPath("ApplicationPoolIdentityType")] === p.value; });
        if (identity) {
            if (identity.value === "SpecificUser") {
                if (!props.properties[fullPath("ApplicationPoolUsername")]) {
                    nodes.push(React.createElement("span", null, ", and the pool will run as a custom user that has not been configured"));
                }
                else {
                    nodes.push(React.createElement("span", null,
                        ", and the pool will run as ",
                        React.createElement("strong", null, props.properties[fullPath("ApplicationPoolUsername")])));
                }
            }
            else {
                nodes.push(React.createElement("span", null,
                    ", and the pool will run as ",
                    React.createElement("strong", null, identity.text)));
            }
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    return React.createElement(form_1.ExpandableFormSection, { errorKey: fullPath("ApplicationPoolName"), title: "Application Pool", summary: applicationPoolSummary(), help: "Configure the details of the IIS Application Pool that will be created and used." },
        React.createElement(Text_1.VariableLookupText, { localNames: props.localNames, projectId: props.projectId, value: props.properties[fullPath("ApplicationPoolName")], onChange: function (x) {
                return props.setProperties((_a = {}, _a[fullPath("ApplicationPoolName")] = x, _a));
                var _a;
            }, label: "Application Pool name", error: props.getFieldError(fullPath("ApplicationPoolName")), validate: form_2.required("Please enter an Application Pool name") }),
        React.createElement(Note_1.default, null, "Name of the application pool in IIS to create or reconfigure."),
        React.createElement(Select_1.BoundSelect, { variableLookup: {
                localNames: props.localNames,
                projectId: props.projectId
            }, resetValue: "v4.0", value: props.properties[fullPath("ApplicationPoolFrameworkVersion")], onChange: function (x) {
                return props.setProperties((_a = {}, _a[fullPath("ApplicationPoolFrameworkVersion")] = x, _a));
                var _a;
            }, items: frameworkVersions, error: props.getFieldError(fullPath("ApplicationPoolFrameworkVersion")), hintText: ".NET CLR version", label: ".NET CLR version" }),
        React.createElement(Note_1.default, null,
            "The version of the .NET common language runtime that this application pool will use. Choose ",
            React.createElement("strong", null, "v2.0"),
            " for applications built against .NET 2.0, 3.0 or 3.5. Choose ",
            React.createElement("strong", null, "v4.0"),
            " for .NET 4.0 or 4.5"),
        React.createElement(Select_1.BoundSelect, { variableLookup: {
                localNames: props.localNames,
                projectId: props.projectId
            }, resetValue: "ApplicationPoolIdentity", value: props.properties[fullPath("ApplicationPoolIdentityType")], onChange: function (x) {
                return props.setProperties((_a = {}, _a[fullPath("ApplicationPoolIdentityType")] = x, _a));
                var _a;
            }, items: appPoolIdentities, error: props.getFieldError(fullPath("ApplicationPoolIdentityType")), hintText: "Identity", label: "Identity" }),
        React.createElement(Note_1.default, null, "Which built-in account will the application pool run under."),
        (props.properties[fullPath("ApplicationPoolIdentityType")] === "SpecificUser" || isBound_1.default(props.properties[fullPath("ApplicationPoolIdentityType")])) && React.createElement("div", null,
            React.createElement(Text_1.VariableLookupText, { localNames: props.localNames, projectId: props.projectId, value: props.properties[fullPath("ApplicationPoolUsername")], onChange: function (x) {
                    return props.setProperties((_a = {}, _a[fullPath("ApplicationPoolUsername")] = x, _a));
                    var _a;
                }, error: props.getFieldError(fullPath("ApplicationPoolUsername")), label: "Username" }),
            React.createElement(Note_1.default, null,
                "The Windows/domain account of the custom user that the application pool will run under. Example: ",
                React.createElement("code", null, "YOURDOMAIN\\YourAccount"),
                ". You will need to ensure that this user has permissions to run as an application pool."),
            React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                    localNames: props.localNames,
                    projectId: props.projectId
                }, resetValue: getResetValue_1.default(props.properties[fullPath("ApplicationPoolPassword")]), value: props.properties[fullPath("ApplicationPoolPassword")], onChange: function (x) {
                    return props.setProperties((_a = {}, _a[fullPath("ApplicationPoolPassword")] = x, _a));
                    var _a;
                }, label: "Password" }),
            React.createElement(Note_1.default, null, "The password for the custom account given above.")),
        React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                localNames: props.localNames,
                projectId: props.projectId
            }, resetValue: "False", value: props.properties["Octopus.Action.IISWebSite.StartApplicationPool"], onChange: function (x) {
                return props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.StartApplicationPool"] = x, _a));
                var _a;
            }, label: "Start IIS Application Pool" }),
        React.createElement(Note_1.default, null, "Whether the deployment step should start the IIS Application Pool after a successful deployment or not."));
};
exports.default = applicationPool;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\iisWebSite\\applicationPool.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\iisWebSite\\applicationPool.tsx"); } } })();

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Text_1 = __webpack_require__(17);
var OkDialogLayout_1 = __webpack_require__(107);
var DataBaseComponent_1 = __webpack_require__(39);
var Select_1 = __webpack_require__(41);
var Note_1 = __webpack_require__(22);
var StringCheckbox_1 = __webpack_require__(38);
var CertificateVariableSelect_1 = __webpack_require__(165);
var clientInstance_1 = __webpack_require__(10);
var isBound_1 = __webpack_require__(84);
var form_1 = __webpack_require__(15);
var RadioButton_1 = __webpack_require__(36);
var DialogFormSectionHeading_1 = __webpack_require__(1993);
var BindingDialog = (function (_super) {
    __extends(BindingDialog, _super);
    function BindingDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.handleProtocolChanged = function (protocol) {
            _this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.setBindingState({ protocol: protocol });
                    if (protocol === "https") {
                        this.setBindingState({ port: "443" });
                    }
                    return [2 /*return*/];
                });
            }); });
        };
        _this.handleManagedByOctopusChanged = function (managed) {
            _this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (!managed) {
                        this.setState(function (state) { return ({
                            binding: __assign({}, state.binding, { certificateVariable: null }),
                            managedByOctopus: managed
                        }); });
                    }
                    else {
                        this.setState(function (state) { return ({
                            binding: __assign({}, state.binding, { thumbprint: null }),
                            managedByOctopus: managed
                        }); });
                    }
                    return [2 /*return*/];
                });
            }); });
        };
        _this.save = function () {
            var binding = _this.state.binding;
            if (_this.state.binding.protocol === "https" && !_this.state.managedByOctopus) {
                if (!_this.state.binding.thumbprint || _this.state.binding.thumbprint.trim() === "") {
                    _this.setError("An SSL certificate thumbprint must be provided for HTTPS bindings.");
                    return false;
                }
                if (!isBound_1.default(_this.state.binding.thumbprint)) {
                    binding.thumbprint = binding.thumbprint.replace(/[^0-9A-z]/g, "");
                }
            }
            return _this.props.onAdd(binding);
        };
        _this.state = {
            binding: null,
            managedByOctopus: false,
            resetCertificate: null,
            project: null
        };
        return _this;
    }
    BindingDialog.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.projectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        _a = (_b.sent());
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        project = _a;
                        this.setState({
                            binding: this.props.binding,
                            managedByOctopus: !!this.props.binding.certificateVariable,
                            resetCertificate: this.props.binding.certificateVariable,
                            project: project
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    BindingDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { onOkClick: this.save, busy: this.state.busy, errors: this.state.errors, title: "Add Binding" }, this.state.binding && React.createElement("div", null,
            React.createElement(Select_1.BoundSelect, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "http", value: this.state.binding.protocol, onChange: this.handleProtocolChanged, items: [{ value: "http", text: "HTTP" }, { value: "https", text: "HTTPS" }], hintText: "Protocol", label: "Protocol" }),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.port, onChange: function (x) { return _this.setBindingState({ port: x }); }, label: "Port" }),
            React.createElement(Note_1.default, null, "The TCP port number that this binding will listen on."),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.ipAddress, onChange: function (x) { return _this.setBindingState({ ipAddress: x }); }, label: "IP address" }),
            React.createElement(Note_1.default, null,
                "The IP address that the binding will listen on. Use ",
                React.createElement("code", null, "*"),
                " for any address, or specify an address such as ",
                React.createElement("code", null, "10.0.0.1"),
                ". If using a IPv6 address remember to enclose in square brackets such as ",
                React.createElement("code", null, "[::1]"),
                "."),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.host, onChange: function (x) { return _this.setBindingState({ host: x }); }, label: "Host name" }),
            React.createElement(Note_1.default, null,
                "The host header that this binding will listen on. Example:",
                React.createElement("code", null, "www.contoso.com"),
                ". Leave empty to use any host header."),
            this.state.binding.protocol !== "http" && React.createElement("div", null,
                React.createElement(DialogFormSectionHeading_1.default, { title: "Certificate" }),
                React.createElement(form_1.BooleanRadioButtonGroup, { label: "Is the HTTPS certificate managed by Octopus or externally?", value: this.state.managedByOctopus, onChange: this.handleManagedByOctopusChanged },
                    React.createElement(RadioButton_1.default, { value: true, label: "Certificate managed by Octopus", isDefault: true }),
                    React.createElement(Note_1.default, null, "If the certificate is managed by Octopus, it will be automatically imported into the Windows Certificate Store."),
                    React.createElement(RadioButton_1.default, { value: false, label: "Certificate managed externally" }),
                    React.createElement(Note_1.default, null, "If managed externally, the certificate thumbprint is configured. The certificate must have been imported into the Windows Certificate Store.")),
                !this.state.managedByOctopus && React.createElement("div", null,
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.thumbprint, onChange: function (x) { return _this.setBindingState({ thumbprint: x }); }, label: "SSL thumbprint" }),
                    React.createElement(Note_1.default, null, "The X.509 certificate thumbprint to use.")),
                this.state.managedByOctopus && React.createElement("div", null,
                    this.state.project
                        ? React.createElement(CertificateVariableSelect_1.BoundCertificateVariableSelect, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "", projectId: this.props.projectId, doBusyTask: this.doBusyTask, value: this.state.binding.certificateVariable, onChange: function (x) { return _this.setBindingState({ certificateVariable: x }); } })
                        : React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.certificateVariable, onChange: function (x) { return _this.setBindingState({ certificateVariable: x }); }, label: "Certificate variable" }),
                    React.createElement(Note_1.default, null, "A certificate variable.")),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", title: "Server name identification", value: this.state.binding.requireSni.toString(), onChange: function (x) { return _this.setBindingState({ requireSni: x }); }, label: "Required" })),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", title: "Binding status", value: this.state.binding.enabled.toString(), onChange: function (x) { return _this.setBindingState({ enabled: x }); }, label: "Enabled", note: React.createElement("span", null, "Disable this binding to skip it (the binding will not be added).") })));
    };
    BindingDialog.prototype.setBindingState = function (state, callback) {
        this.setChildState1("binding", state);
    };
    return BindingDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = BindingDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\iisWebSite\\bindingDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\iisWebSite\\bindingDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(116);
// use as a section heading in dialogs where we want it to push to the edge despite
// dialogs having margin on the content
var DialogFormSectionHeading = (function (_super) {
    __extends(DialogFormSectionHeading, _super);
    function DialogFormSectionHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogFormSectionHeading.prototype.render = function () {
        return React.createElement("div", { className: styles.dialogSectionHeading },
            React.createElement("div", { className: styles.sectionHeadingTitle }, this.props.title));
    };
    return DialogFormSectionHeading;
}(React.Component));
exports.default = DialogFormSectionHeading;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\DialogFormSectionHeading.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\form\\Sections\\DialogFormSectionHeading.tsx"); } } })();

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(91);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var Note_1 = __webpack_require__(22);
var Text_1 = __webpack_require__(17);
var MoreInfo_1 = __webpack_require__(294);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var StringProperties = {
    "Octopus.Action.Package.JsonConfigurationVariablesEnabled": "",
    "Octopus.Action.Package.JsonConfigurationVariablesTargets": "",
};
var JsonConfigurationVariablesEdit = (function (_super) {
    __extends(JsonConfigurationVariablesEdit, _super);
    function JsonConfigurationVariablesEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JsonConfigurationVariablesEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    JsonConfigurationVariablesEdit.prototype.summary = function () {
        var json = this.props.properties["Octopus.Action.Package.JsonConfigurationVariablesTargets"] || "";
        if (json.length > 0) {
            return form_1.Summary.summary(React.createElement("span", null, "Variable substitution will be performed on configured JSON files"));
        }
        else {
            return form_1.Summary.placeholder("No JSON files configured");
        }
    };
    JsonConfigurationVariablesEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "jsonvariables", title: "JSON Configuration Variables", summary: this.summary(), help: "Configure JSON file variable replacements." },
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.JsonConfigurationVariablesTargets"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.JsonConfigurationVariablesTargets"] = x, _a));
                    var _a;
                }, multiLine: true, error: this.props.getFieldError("Octopus.Action.Package.JsonConfigurationVariablesTargets"), label: "Target files" }),
            React.createElement(Note_1.default, null,
                "A comma- or newline-separated list of file names to replace settings in, relative to the package contents.  Extended wildcard syntax is supported. E.g., ",
                React.createElement("em", null, "appsettings.json"),
                ", ",
                React.createElement("em", null, "Config\\*.json"),
                ", ",
                React.createElement("em", null, "**\\specific-folder\\*.json."),
                ". Configuration values can be replaced using a ",
                React.createElement("code", null, ":"),
                " separated key, starting from the root of the hierarchy."),
            React.createElement(MoreInfo_1.default, { content: React.createElement("div", null,
                    React.createElement("p", null,
                        "Consider the following ",
                        React.createElement("em", null, "appsettings.json"),
                        " file:"),
                    React.createElement("pre", null, "{\n    \"Data\": {\n    \"DefaultConnection\": {\n    \"ConnectionString\": \"Server=(localdb)\\SQLEXPRESS;Database=OctoFX;Trusted_Connection=True\"\n         }\n    }\n}"),
                    React.createElement("p", null,
                        "To replace the value of ",
                        React.createElement("code", null, "ConnectionString"),
                        " you would add a variable name ",
                        React.createElement("code", null, "Data:DefaultConnection:ConnectionString"),
                        " to your project variables / library variable set. The JSON also supports ",
                        React.createElement(index_1.default, { href: "VariableSubstitutionSyntaxExtended" }, "extended template syntax"),
                        "."),
                    React.createElement("p", null,
                        "The 'Target files' field supports ",
                        React.createElement(index_1.default, { href: "VariableSubstitutionSyntaxExtended" }, "extended template syntax"),
                        ". Conditional ",
                        React.createElement("code", null, "if"),
                        " and ",
                        React.createElement("code", null, "unless"),
                        ":"),
                    React.createElement("pre", null, "#{if MyVar}...#{/if}"),
                    React.createElement("p", null,
                        "Iteration over variable sets or comma-separated values with ",
                        React.createElement("code", null, "each"),
                        ":"),
                    React.createElement("pre", null, "#{each mv in MyVar}...#{mv}...#{/each}")) }));
    };
    return JsonConfigurationVariablesEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.JsonConfigurationVariables",
    title: "JSON configuration variables",
    description: "Replace settings in selected JSON files with variables defined in Octopus.",
    edit: JsonConfigurationVariablesEdit,
    priority: 15,
    enable: function (properties) {
        properties["Octopus.Action.Package.JsonConfigurationVariablesEnabled"] = "True";
    },
    disable: function (properties) {
        delete properties["Octopus.Action.Package.JsonConfigurationVariablesEnabled"];
        delete properties["Octopus.Action.Package.JsonConfigurationVariablesTargets"];
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\jsonConfigurationVariables\\jsonConfigurationVariables.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\jsonConfigurationVariables\\jsonConfigurationVariables.tsx"); } } })();

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(91);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var Text_1 = __webpack_require__(17);
var Note_1 = __webpack_require__(22);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var StringProperties = {
    "Octopus.Action.SubstituteInFiles.TargetFiles": "",
    "Octopus.Action.SubstituteInFiles.OutputEncoding": "",
};
var SubstituteInFilesEdit = (function (_super) {
    __extends(SubstituteInFilesEdit, _super);
    function SubstituteInFilesEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubstituteInFilesEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    SubstituteInFilesEdit.prototype.summary = function () {
        var json = this.props.properties["Octopus.Action.SubstituteInFiles.TargetFiles"] || "";
        if (json.length > 0) {
            return form_1.Summary.summary(React.createElement("span", null, "Variable substitution will be performed on configured files"));
        }
        else {
            return form_1.Summary.placeholder("No files configured");
        }
    };
    SubstituteInFilesEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.SubstituteInFiles.TargetFiles|Octopus.Action.SubstituteInFiles.OutputEncoding", title: "Substitute Variables in Files", summary: this.summary(), help: "Configure files to perform variable substitution on." },
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.SubstituteInFiles.TargetFiles"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.SubstituteInFiles.TargetFiles"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.SubstituteInFiles.TargetFiles"), multiLine: true, label: "Target files" }),
            React.createElement(Note_1.default, null,
                "A newline-separated list of file names to transform, relative to the package contents. Extended wildcard syntax is supported. E.g., ",
                React.createElement("em", null, "Notes.txt"),
                ", ",
                React.createElement("em", null, "Config\\*.json"),
                ", ",
                React.createElement("em", null, "**\\specific-folder\\*.config."),
                React.createElement("br", null),
                "This field supports extended template syntax. Conditional ",
                React.createElement("code", null, "if"),
                " and ",
                React.createElement("code", null, "unless"),
                ":",
                React.createElement("pre", null, "#{if MyVar}...#{/if}"),
                "Iteration over variable sets or comma-separated values with ",
                React.createElement("code", null, "each"),
                ":",
                React.createElement("pre", null, "#{each mv in MyVar}...#{mv}...#{/each}")),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.SubstituteInFiles.OutputEncoding"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.SubstituteInFiles.OutputEncoding"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.SubstituteInFiles.OutputEncoding"), multiLine: true, hintText: "Detect from template", label: "Output file encoding" }),
            React.createElement(Note_1.default, null,
                "The name of an encoding to use when writing the transformed file. E.g., ",
                React.createElement("em", null, "utf-8"),
                ".",
                React.createElement("br", null),
                "For a list of supported encoding names, see the Remarks section of the ",
                React.createElement(index_1.default, { href: "EncodingNames" }, "System.Text.Encoding"),
                " class on MSDN."));
    };
    return SubstituteInFilesEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.SubstituteInFiles",
    title: "Substitute Variables in Files",
    description: "Transforms files using the Octopus <code>#{Variable}</code> substitution syntax",
    edit: SubstituteInFilesEdit,
    priority: 22,
    enable: function (properties) {
        properties["Octopus.Action.SubstituteInFiles.Enabled"] = "True";
    },
    disable: function (properties) {
        delete properties["Octopus.Action.SubstituteInFiles.TargetFiles"];
        delete properties["Octopus.Action.SubstituteInFiles.OutputEncoding"];
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\substituteInFiles\\substituteInFiles.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\substituteInFiles\\substituteInFiles.tsx"); } } })();

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ExternalLink_1 = __webpack_require__(29);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var StringCheckbox_1 = __webpack_require__(38);
var Note_1 = __webpack_require__(22);
var Text_1 = __webpack_require__(17);
var Callout_1 = __webpack_require__(81);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var StringProperties = {
    "Octopus.Action.RedGateDatabase.Enabled": "",
    "Octopus.Action.RedGateDatabase.DatabaseName": "",
    "Octopus.Action.RedGateDatabase.ConnectionStrings": "",
    "Octopus.Action.RedGateDatabase.PostDeployValidationEnabled": "",
    "Octopus.Action.RedGateDatabase.SqlCiPath": "",
    "Octopus.Action.RedGateDatabase.SqlComparePath": "",
    "Octopus.Action.RedGateDatabase.CompareOptions": "",
};
var RedgateDatabaseEdit = (function (_super) {
    __extends(RedgateDatabaseEdit, _super);
    function RedgateDatabaseEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RedgateDatabaseEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    RedgateDatabaseEdit.prototype.summary = function () {
        if (this.props.properties["Octopus.Action.RedGateDatabase.Enabled"] !== "False") {
            return form_1.Summary.summary("Database package deployment is enabled");
        }
        else {
            return form_1.Summary.placeholder("Database package deployment is not enabled");
        }
    };
    RedgateDatabaseEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.RedGateDatabase.SqlCiPath|Octopus.Action.RedGateDatabase.SqlComparePathOctopus.Action.RedGateDatabase.ConnectionStrings", title: "Red Gate Database", summary: this.summary(), help: "Configure Red Gate database package deployment." },
            React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning },
                "SQL Release has been replaced by DLM Automation. Don't worry: You can continue to use this feature until you decide to start using DLM Automation. For more information refer to our ",
                React.createElement(ExternalLink_1.default, { href: "RedGateSQLRelease" }, "documentation"),
                "."),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", value: properties["Octopus.Action.RedGateDatabase.Enabled"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.Enabled"] = x, _a));
                    var _a;
                }, label: "Enable Red Gate database package deployment" }),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.RedGateDatabase.DatabaseName"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.DatabaseName"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.RedGateDatabase.DatabaseName"), label: "Database name" }),
            React.createElement(Note_1.default, null, "The name of the SQL database to deploy."),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.RedGateDatabase.ConnectionStrings"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.ConnectionStrings"] = x, _a));
                    var _a;
                }, multiLine: true, error: this.props.getFieldError("Octopus.Action.RedGateDatabase.ConnectionStrings"), label: "SQL Servers" }),
            React.createElement(Note_1.default, null,
                "A list of SQL Server connection strings for the databases to deploy to. Each connection string should be on a new line.",
                React.createElement("br", null),
                "You can use variables to define different connection strings for each environment, and then reference them:",
                React.createElement("pre", null, "#{MyConnectionString}")),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", value: properties["Octopus.Action.RedGateDatabase.PostDeployValidationEnabled"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.PostDeployValidationEnabled"] = x, _a));
                    var _a;
                }, label: "Validate that no other changes to the database have been made outside this deployment" }),
            React.createElement(Note_1.default, null, "Check that the deployment was successful, and that no changes were made outside of Octopus during the deployment. If validation fails, it stops the deployment after the database upgrade."),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.RedGateDatabase.SqlCiPath"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.SqlCiPath"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.RedGateDatabase.SqlCiPath"), label: "SQLCI.exe path" }),
            React.createElement(Note_1.default, null, "The path to Red Gate's SQLCI.exe."),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.RedGateDatabase.SqlComparePath"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.SqlComparePath"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.RedGateDatabase.SqlComparePath"), label: "SQLCompare.exe path" }),
            React.createElement(Note_1.default, null, "The path to the Red Gate's SQLCompare.exe."),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.RedGateDatabase.CompareOptions"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.CompareOptions"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.RedGateDatabase.CompareOptions"), label: "Comparison options" }),
            React.createElement(Note_1.default, null, "The options to pass to the SQL Compare engine. To use multiple options, separate each option with commas or semicolons."));
    };
    return RedgateDatabaseEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.RedGateDatabase",
    title: "Red Gate Database Deployment",
    description: "Deploy a database using SQLCI.exe from Red Gate",
    edit: RedgateDatabaseEdit,
    priority: 100,
    enable: function (properties) {
        properties["Octopus.Action.RedGateDatabase.Enabled"] = "True";
        properties["Octopus.Action.RedGateDatabase.CompareOptions"] = "IgnoreUsers,IgnoreCertificatesAndCryptoKeys,ForceColumnOrder,ThrowOnFileParseFailed";
        properties["Octopus.Action.RedGateDatabase.PostDeployValidationEnabled"] = "True";
        properties["Octopus.Action.RedGateDatabase.SqlCiPath"] = "C:\\Program Files (x86)\\Red Gate\\SQL Automation Pack 1\\sqlCI\\sqlCI.exe";
        properties["Octopus.Action.RedGateDatabase.SqlComparePath"] = "C:\\Program Files (x86)\\Red Gate\\SQL Automation Pack 1\\sqlCI\\SC\\SQLCompare.exe";
    },
    disable: function (properties) {
        Object.keys(properties).filter(function (name) {
            return name.indexOf("Octopus.Action.RedGateDatabase.") === 0;
        }).forEach(function (name) {
            delete properties[name];
        });
    },
    validate: function (properties, errors) {
        if (!properties["Octopus.Action.RedGateDatabase.SqlCiPath"]) {
            errors["Octopus.Action.RedGateDatabase.SqlCiPath"] = "Please specify a path to SQLCI.exe.";
        }
        if (!properties["Octopus.Action.RedGateDatabase.SqlComparePath"]) {
            errors["Octopus.Action.RedGateDatabase.SqlComparePath"] = "Please specify a path to SQLCompare.exe.";
        }
        if (!properties["Octopus.Action.RedGateDatabase.ConnectionStrings"]) {
            errors["Octopus.Action.RedGateDatabase.ConnectionStrings"] = "Please specify the connection strings to the databases that you wish to deploy.";
        }
    },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\redgateDatabase\\redgateDatabase.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\redgateDatabase\\redgateDatabase.tsx"); } } })();

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var Note_1 = __webpack_require__(22);
var StringCheckbox_1 = __webpack_require__(38);
var Text_1 = __webpack_require__(17);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var StringProperties = {
    "Octopus.Action.Vhd.ApplicationPath": "",
    "Octopus.Action.Vhd.DeployVhdToVm": "",
    "Octopus.Action.Vhd.VmName": "",
};
var VhdEdit = (function (_super) {
    __extends(VhdEdit, _super);
    function VhdEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VhdEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    VhdEdit.prototype.summary = function () {
        var properties = this.props.properties;
        var nodes = [];
        if (properties["Octopus.Action.Vhd.ApplicationPath"]) {
            nodes.push(React.createElement("span", null,
                "The application path is ",
                React.createElement("strong", null, properties["Octopus.Action.Vhd.ApplicationPath"]),
                "."));
        }
        else {
            return form_1.Summary.placeholder("No application path has been set");
        }
        if (properties["Octopus.Action.Vhd.DeployVhdToVm"] !== "False") {
            if (properties["Octopus.Action.Vhd.VmName"]) {
                nodes.push(React.createElement("span", null,
                    " The VHD will be attached to Hyper-V VM ",
                    React.createElement("strong", null, properties["Octopus.Action.Vhd.VmName"])));
            }
            else {
                nodes.push(React.createElement("span", null, " The VHD will be attached to a Hyper-V VM, but no VM has been set"));
            }
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    VhdEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Vhd.ApplicationPath|Octopus.Action.Vhd.VmName", title: "VHD Configuration", summary: this.summary(), help: "Configure operations on the VHD as part of the deployment." },
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Vhd.ApplicationPath"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Vhd.ApplicationPath"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.Vhd.ApplicationPath"), label: "VHD application path" }),
            React.createElement(Note_1.default, null,
                "The folder within the VHD that contains your application. For example ",
                React.createElement("em", null, "PublishedApps\\MyApplication"),
                ". Octopus will look in this folder when performing substitutions and transforms."),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "", value: properties["Octopus.Action.Vhd.DeployVhdToVm"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Vhd.DeployVhdToVm"] = x, _a));
                    var _a;
                }, label: "Add VHD to Hyper-V" }),
            React.createElement(Note_1.default, null, "Attach the VHD to a Hyper-V Virtual Machine."),
            React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Vhd.VmName"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Vhd.VmName"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.Vhd.VmName"), label: "Virtual machine name" }),
            React.createElement(Note_1.default, null, "The name of the Hyper-V Virtual Machine to update. The VM will be shut down, the VHD will be added, replacing the current first vitual drive if there is one, then the VHD will be restarted."));
    };
    return VhdEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.Vhd",
    title: "Vhd",
    description: "Allows other features to be performed on the contents of a VHD before optionally attaching it to a Virtual Machine",
    edit: VhdEdit,
    priority: 30,
    validate: function (properties, errors) {
        if (properties["Octopus.Action.Vhd.DeployVhdToVm"] && !properties["Octopus.Action.Vhd.VmName"]) {
            errors["Octopus.Action.Vhd.VmName"] = "Please enter a name for the Virtual Machine.";
        }
        if (!properties["Octopus.Action.Vhd.ApplicationPath"]) {
            errors["Octopus.Action.Vhd.ApplicationPath"] = "Please enter an application path for this VHD.";
        }
    },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\vhd\\vhd.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\vhd\\vhd.tsx"); } } })();

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(14);
var form_1 = __webpack_require__(15);
var getResetValue_1 = __webpack_require__(397);
var isBound_1 = __webpack_require__(84);
var Note_1 = __webpack_require__(22);
var Text_1 = __webpack_require__(17);
var Select_1 = __webpack_require__(41);
var Sensitive_1 = __webpack_require__(82);
var ValueInPropertiesHasChanged_1 = __webpack_require__(65);
var StringCheckbox_1 = __webpack_require__(38);
var StringProperties = {
    "Octopus.Action.WindowsService.CreateOrUpdateService": "",
    "Octopus.Action.WindowsService.ServiceName": "",
    "Octopus.Action.WindowsService.DisplayName": "",
    "Octopus.Action.WindowsService.Description": "",
    "Octopus.Action.WindowsService.ExecutablePath": "",
    "Octopus.Action.WindowsService.Arguments": "",
    "Octopus.Action.WindowsService.ServiceAccount": "",
    "Octopus.Action.WindowsService.CustomAccountName": "",
    "Octopus.Action.WindowsService.CustomAccountPassword": "",
    "Octopus.Action.WindowsService.StartMode": "",
    "Octopus.Action.WindowsService.Dependencies": ""
};
var WindowsServiceEdit = (function (_super) {
    __extends(WindowsServiceEdit, _super);
    function WindowsServiceEdit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.serviceAccounts = [
            { text: "Local System", value: "LocalSystem" },
            { text: "Network Service", value: "NT Authority\\Network Service" },
            { text: "Local Service", value: "NT Authority\\Local Service" },
            { text: "Custom user...", value: "_CUSTOM" }
        ];
        _this.startModes = [
            { text: "Automatic", value: "auto" },
            { text: "Automatic (delayed)", value: "delayed-auto" },
            { text: "Manual", value: "demand" },
            { text: "Unchanged", value: "unchanged" }
        ];
        return _this;
    }
    WindowsServiceEdit.prototype.shouldComponentUpdate = function (newProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, newProps, this.props);
    };
    WindowsServiceEdit.prototype.serviceSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.WindowsService.CreateOrUpdateService"] === "False") {
            return form_1.Summary.placeholder("No windows service will be installed");
        }
        if (properties["Octopus.Action.WindowsService.ServiceName"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Windows service ",
                React.createElement("strong", null, properties["Octopus.Action.WindowsService.ServiceName"]),
                " will be installed"));
        }
        return form_1.Summary.summary("A windows service will be installed but a Service Name has not been configured");
    };
    WindowsServiceEdit.prototype.executableSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.WindowsService.ExecutablePath"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "The executable is ",
                React.createElement("strong", null, properties["Octopus.Action.WindowsService.ExecutablePath"])));
        }
        else {
            return form_1.Summary.placeholder("No executable has been configured for the windows service");
        }
    };
    WindowsServiceEdit.prototype.startupSummary = function () {
        var properties = this.props.properties;
        var user = this.serviceAccounts.find(function (p) { return p.value === properties["Octopus.Action.WindowsService.ServiceAccount"]; });
        var nodes = [];
        if (user && user.value === "_CUSTOM") {
            if (properties["Octopus.Action.WindowsService.CustomAccountName"]) {
                nodes.push(React.createElement("span", null,
                    "The service will run as ",
                    React.createElement("strong", null, properties["Octopus.Action.WindowsService.CustomAccountName"])));
            }
            else {
                nodes.push(React.createElement("span", null,
                    "The service will run as ",
                    React.createElement("strong", null, "Custom User Account")));
            }
        }
        else if (isBound_1.default(properties["Octopus.Action.WindowsService.ServiceAccount"])) {
            nodes.push("The service user account is set by a bound variable");
        }
        else if (user !== undefined) {
            nodes.push(React.createElement("span", null,
                "The service will run as ",
                React.createElement("strong", null, user.text)));
        }
        var startMode = this.startModes.find(function (p) { return p.value === properties["Octopus.Action.WindowsService.StartMode"]; });
        if (isBound_1.default(properties["Octopus.Action.WindowsService.StartMode"])) {
            nodes.push(", the start mode is set by a bound variable");
        }
        else if (startMode !== undefined) {
            nodes.push(React.createElement("span", null,
                ", the start mode is ",
                React.createElement("strong", null, startMode.text)));
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    WindowsServiceEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.WindowsService.ServiceName|Octopus.Action.WindowsService.DisplayName", title: "Windows Service", summary: this.serviceSummary(), help: "Configure a windows service deployment." },
                this.props.plugin.actionType !== "Octopus.WindowsService" && React.createElement("div", null,
                    React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "False", value: properties["Octopus.Action.WindowsService.CreateOrUpdateService"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.CreateOrUpdateService"] = x, _a));
                            var _a;
                        }, label: "Install a Windows Service" }),
                    React.createElement(Note_1.default, null,
                        "If enabled, Tentacle will use ",
                        React.createElement("code", null, "sc.exe"),
                        " to attempt to create a Windows Service using the settings below. If the service already exists, Tentacle will stop the service, reconfigure it, and start it again.")),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.ServiceName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.ServiceName"] = x, _a));
                        var _a;
                    }, label: "Service name", error: this.props.getFieldError("Octopus.Action.WindowsService.ServiceName") }),
                React.createElement(Note_1.default, null, "The name of the Windows Service to create or configure."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.DisplayName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.DisplayName"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.WindowsService.DisplayName"), label: "Display name" }),
                React.createElement(Note_1.default, null, "Optional display name of the Windows Service."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.Description"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.Description"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.WindowsService.Description"), label: "Description" }),
                React.createElement(Note_1.default, null, "User-friendly description of the service.")),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.WindowsService.ExecutablePath|Octopus.Action.WindowsService.Arguments", title: "Windows Service: Executable", summary: this.executableSummary(), help: "Configure the executable of the service." },
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.ExecutablePath"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.ExecutablePath"] = x, _a));
                        var _a;
                    }, label: "Executable path", error: this.props.getFieldError("Octopus.Action.WindowsService.ExecutablePath") }),
                React.createElement(Note_1.default, null,
                    "Path to the executable file for the service. The path should be relative to the package installation directory; for example:",
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement("code", null, "MyService.exe")),
                        React.createElement("li", null,
                            React.createElement("code", null, "bin\\MyService.exe")))),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.Arguments"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.Arguments"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.WindowsService.Arguments"), label: "Arguments" }),
                React.createElement(Note_1.default, null, "Command line arguments that will be passed to the service when it starts each time.")),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.WindowsService.ServiceAccount|Octopus.Action.WindowsService.ServiceAccount|Octopus.Action.WindowsService.Dependencies", title: "Windows Service: Startup", summary: this.startupSummary(), help: "Configure the startup options of the service." },
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "LocalSystem", value: properties["Octopus.Action.WindowsService.ServiceAccount"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.ServiceAccount"] = x, _a));
                        var _a;
                    }, items: this.serviceAccounts, error: this.props.getFieldError("Octopus.Action.WindowsService.ServiceAccount"), hintText: "Service account", label: "Service account" }),
                React.createElement(Note_1.default, null, "Which built-in account will the service run under."),
                (properties["Octopus.Action.WindowsService.ServiceAccount"] === "_CUSTOM" || isBound_1.default(properties["Octopus.Action.WindowsService.ServiceAccount"])) && React.createElement("div", null,
                    React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.CustomAccountName"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.CustomAccountName"] = x, _a));
                            var _a;
                        }, label: "Custom account name" }),
                    React.createElement(Note_1.default, null,
                        "The Windows/domain account of the custom user that the service will run under. Example: ",
                        React.createElement("code", null, "YOURDOMAIN\\YourAccount"),
                        ". You will need to ensure that this user has the 'Log on as a service' right."),
                    React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: getResetValue_1.default(this.props.properties["Octopus.Action.WindowsService.CustomAccountPassword"]), value: properties["Octopus.Action.WindowsService.CustomAccountPassword"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.CustomAccountPassword"] = x, _a));
                            var _a;
                        }, label: "Custom account password" }),
                    React.createElement(Note_1.default, null, "The password for the custom account given above.")),
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "auto", value: properties["Octopus.Action.WindowsService.StartMode"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.StartMode"] = x, _a));
                        var _a;
                    }, items: this.startModes, error: this.props.getFieldError("Octopus.Action.WindowsService.StartMode"), hintText: "Start mode", label: "Start mode" }),
                React.createElement(Note_1.default, null,
                    "When will the service start? Use ",
                    React.createElement("em", null, "Unchanged"),
                    " to use the current status."),
                React.createElement(Text_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.Dependencies"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.Dependencies"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.WindowsService.Dependencies"), label: "Dependencies" }),
                React.createElement(Note_1.default, null,
                    "Any dependencies that the service has. Separate the names using forward slashes (/). For example: ",
                    React.createElement("code", null, "LanmanWorkstation/TCPIP/MSSQL"),
                    ".")));
    };
    return WindowsServiceEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.WindowsService",
    title: "Windows Service",
    description: "Creates or reconfigures a Windows Service using _sc.exe_",
    edit: WindowsServiceEdit,
    priority: 8,
    enable: function (properties) {
        properties["Octopus.Action.WindowsService.CreateOrUpdateService"] = "True";
        properties["Octopus.Action.WindowsService.ServiceAccount"] = "LocalSystem";
        properties["Octopus.Action.WindowsService.StartMode"] = "auto";
    },
    preSave: function (properties) {
        if (properties["Octopus.Action.WindowsService.ServiceAccount"] !== "_CUSTOM"
            && !isBound_1.default(properties["Octopus.Action.WindowsService.ServiceAccount"])) {
            properties["Octopus.Action.WindowsService.CustomAccountName"] = null;
            properties["Octopus.Action.WindowsService.CustomAccountPassword"] = null;
        }
    },
    validate: function (properties, errors) {
        if (!properties["Octopus.Action.WindowsService.ServiceName"]) {
            errors["Octopus.Action.WindowsService.ServiceName"] = "Please enter a service name for the Windows Service.";
        }
        if (!properties["Octopus.Action.WindowsService.ExecutablePath"]) {
            errors["Octopus.Action.WindowsService.ExecutablePath"] = "Please enter an executable path for this Windows Service.";
        }
    },
    disable: function (properties) {
        Object.keys(properties).filter(function (name) {
            return name.indexOf("Octopus.Action.WindowsService.") === 0;
        }).forEach(function (name) {
            delete properties[name];
        });
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\windowsService\\windowsService.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\eec88466c176b607\\newportal\\app\\components\\Features\\windowsService\\windowsService.tsx"); } } })();

/***/ })
],[810]);


// WEBPACK FOOTER //
// main.642033651c765432a8f5.hashedasset.js